
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire45ff"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire45ff"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8j8zV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $60c6c09291648837$export$ffb0004e005737fa; }, function (v) { return $60c6c09291648837$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $60c6c09291648837$export$34b9dba7ce09269b; }, function (v) { return $60c6c09291648837$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $60c6c09291648837$export$25062201e9e25d76; }, function (v) { return $60c6c09291648837$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60c6c09291648837$export$ffb0004e005737fa;
var $60c6c09291648837$export$34b9dba7ce09269b;
var $60c6c09291648837$export$25062201e9e25d76;
'use strict';

var $aivMx = parcelRequire("aivMx");
var $60c6c09291648837$var$k = Symbol.for("react.element"), $60c6c09291648837$var$l = Symbol.for("react.fragment"), $60c6c09291648837$var$m = Object.prototype.hasOwnProperty, $60c6c09291648837$var$n = $aivMx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $60c6c09291648837$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $60c6c09291648837$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$60c6c09291648837$var$m.call(a, b) && !$60c6c09291648837$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $60c6c09291648837$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $60c6c09291648837$var$n.current
    };
}
$60c6c09291648837$export$ffb0004e005737fa = $60c6c09291648837$var$l;
$60c6c09291648837$export$34b9dba7ce09269b = $60c6c09291648837$var$q;
$60c6c09291648837$export$25062201e9e25d76 = $60c6c09291648837$var$q;

});
parcelRegister("aivMx", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jZOM6"));

});
parcelRegister("jZOM6", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $e8eb19a844d02677$export$dca3b0875bd9a954; }, function (v) { return $e8eb19a844d02677$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e8eb19a844d02677$export$16fa2f45be04daa8; }, function (v) { return $e8eb19a844d02677$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e8eb19a844d02677$export$ffb0004e005737fa; }, function (v) { return $e8eb19a844d02677$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e8eb19a844d02677$export$e2c29f18771995cb; }, function (v) { return $e8eb19a844d02677$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e8eb19a844d02677$export$221d75b3f55bb0bd; }, function (v) { return $e8eb19a844d02677$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e8eb19a844d02677$export$5f8d39834fd61797; }, function (v) { return $e8eb19a844d02677$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e8eb19a844d02677$export$74bf444e3cd11ea5; }, function (v) { return $e8eb19a844d02677$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8eb19a844d02677$export$ae55be85d98224ed; }, function (v) { return $e8eb19a844d02677$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $e8eb19a844d02677$export$3ba232387fd5d6dd; }, function (v) { return $e8eb19a844d02677$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e8eb19a844d02677$export$e530037191fcd5d7; }, function (v) { return $e8eb19a844d02677$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e8eb19a844d02677$export$fd42f52fd3ae1109; }, function (v) { return $e8eb19a844d02677$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e8eb19a844d02677$export$c8a8987d4410bf2d; }, function (v) { return $e8eb19a844d02677$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e8eb19a844d02677$export$d38cd72104c1f0e9; }, function (v) { return $e8eb19a844d02677$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e8eb19a844d02677$export$7d1e3a5e95ceca43; }, function (v) { return $e8eb19a844d02677$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e8eb19a844d02677$export$257a8862b851cb5b; }, function (v) { return $e8eb19a844d02677$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e8eb19a844d02677$export$a8257692ac88316c; }, function (v) { return $e8eb19a844d02677$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e8eb19a844d02677$export$488013bae63b21da; }, function (v) { return $e8eb19a844d02677$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e8eb19a844d02677$export$7c73462e0d25e514; }, function (v) { return $e8eb19a844d02677$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e8eb19a844d02677$export$7568632d0d33d16d; }, function (v) { return $e8eb19a844d02677$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e8eb19a844d02677$export$88948ce120ea2619; }, function (v) { return $e8eb19a844d02677$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e8eb19a844d02677$export$35808ee640e87ca7; }, function (v) { return $e8eb19a844d02677$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e8eb19a844d02677$export$fae74005e78b1a27; }, function (v) { return $e8eb19a844d02677$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e8eb19a844d02677$export$dc8fbce3eb94dc1e; }, function (v) { return $e8eb19a844d02677$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e8eb19a844d02677$export$6a7bc4e911dc01cf; }, function (v) { return $e8eb19a844d02677$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e8eb19a844d02677$export$6d9c69b0de29b591; }, function (v) { return $e8eb19a844d02677$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e8eb19a844d02677$export$f680877a34711e37; }, function (v) { return $e8eb19a844d02677$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e8eb19a844d02677$export$d5a552a76deda3c2; }, function (v) { return $e8eb19a844d02677$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e8eb19a844d02677$export$aaabe4eda9ed9969; }, function (v) { return $e8eb19a844d02677$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e8eb19a844d02677$export$e5c5a5f917a5871c; }, function (v) { return $e8eb19a844d02677$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e8eb19a844d02677$export$1538c33de8887b59; }, function (v) { return $e8eb19a844d02677$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e8eb19a844d02677$export$13e3392192263954; }, function (v) { return $e8eb19a844d02677$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e8eb19a844d02677$export$b8f5890fc79d6aca; }, function (v) { return $e8eb19a844d02677$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e8eb19a844d02677$export$60241385465d0a34; }, function (v) { return $e8eb19a844d02677$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e8eb19a844d02677$export$306c0aa65ff9ec16; }, function (v) { return $e8eb19a844d02677$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e8eb19a844d02677$export$7b286972b8d8ccbf; }, function (v) { return $e8eb19a844d02677$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e8eb19a844d02677$export$83d89fbfd8236492; }, function (v) { return $e8eb19a844d02677$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8eb19a844d02677$export$dca3b0875bd9a954;
var $e8eb19a844d02677$export$16fa2f45be04daa8;
var $e8eb19a844d02677$export$ffb0004e005737fa;
var $e8eb19a844d02677$export$e2c29f18771995cb;
var $e8eb19a844d02677$export$221d75b3f55bb0bd;
var $e8eb19a844d02677$export$5f8d39834fd61797;
var $e8eb19a844d02677$export$74bf444e3cd11ea5;
var $e8eb19a844d02677$export$ae55be85d98224ed;
var $e8eb19a844d02677$export$3ba232387fd5d6dd;
var $e8eb19a844d02677$export$e530037191fcd5d7;
var $e8eb19a844d02677$export$fd42f52fd3ae1109;
var $e8eb19a844d02677$export$c8a8987d4410bf2d;
var $e8eb19a844d02677$export$d38cd72104c1f0e9;
var $e8eb19a844d02677$export$7d1e3a5e95ceca43;
var $e8eb19a844d02677$export$257a8862b851cb5b;
var $e8eb19a844d02677$export$a8257692ac88316c;
var $e8eb19a844d02677$export$488013bae63b21da;
var $e8eb19a844d02677$export$7c73462e0d25e514;
var $e8eb19a844d02677$export$7568632d0d33d16d;
var $e8eb19a844d02677$export$88948ce120ea2619;
var $e8eb19a844d02677$export$35808ee640e87ca7;
var $e8eb19a844d02677$export$fae74005e78b1a27;
var $e8eb19a844d02677$export$dc8fbce3eb94dc1e;
var $e8eb19a844d02677$export$6a7bc4e911dc01cf;
var $e8eb19a844d02677$export$6d9c69b0de29b591;
var $e8eb19a844d02677$export$f680877a34711e37;
var $e8eb19a844d02677$export$d5a552a76deda3c2;
var $e8eb19a844d02677$export$aaabe4eda9ed9969;
var $e8eb19a844d02677$export$e5c5a5f917a5871c;
var $e8eb19a844d02677$export$1538c33de8887b59;
var $e8eb19a844d02677$export$13e3392192263954;
var $e8eb19a844d02677$export$b8f5890fc79d6aca;
var $e8eb19a844d02677$export$60241385465d0a34;
var $e8eb19a844d02677$export$306c0aa65ff9ec16;
var $e8eb19a844d02677$export$7b286972b8d8ccbf;
var $e8eb19a844d02677$export$83d89fbfd8236492;
'use strict';
var $e8eb19a844d02677$var$l = Symbol.for("react.element"), $e8eb19a844d02677$var$n = Symbol.for("react.portal"), $e8eb19a844d02677$var$p = Symbol.for("react.fragment"), $e8eb19a844d02677$var$q = Symbol.for("react.strict_mode"), $e8eb19a844d02677$var$r = Symbol.for("react.profiler"), $e8eb19a844d02677$var$t = Symbol.for("react.provider"), $e8eb19a844d02677$var$u = Symbol.for("react.context"), $e8eb19a844d02677$var$v = Symbol.for("react.forward_ref"), $e8eb19a844d02677$var$w = Symbol.for("react.suspense"), $e8eb19a844d02677$var$x = Symbol.for("react.memo"), $e8eb19a844d02677$var$y = Symbol.for("react.lazy"), $e8eb19a844d02677$var$z = Symbol.iterator;
function $e8eb19a844d02677$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8eb19a844d02677$var$z && a[$e8eb19a844d02677$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8eb19a844d02677$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e8eb19a844d02677$var$C = Object.assign, $e8eb19a844d02677$var$D = {};
function $e8eb19a844d02677$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e8eb19a844d02677$var$D;
    this.updater = e || $e8eb19a844d02677$var$B;
}
$e8eb19a844d02677$var$E.prototype.isReactComponent = {};
$e8eb19a844d02677$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e8eb19a844d02677$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e8eb19a844d02677$var$F() {}
$e8eb19a844d02677$var$F.prototype = $e8eb19a844d02677$var$E.prototype;
function $e8eb19a844d02677$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e8eb19a844d02677$var$D;
    this.updater = e || $e8eb19a844d02677$var$B;
}
var $e8eb19a844d02677$var$H = $e8eb19a844d02677$var$G.prototype = new $e8eb19a844d02677$var$F;
$e8eb19a844d02677$var$H.constructor = $e8eb19a844d02677$var$G;
$e8eb19a844d02677$var$C($e8eb19a844d02677$var$H, $e8eb19a844d02677$var$E.prototype);
$e8eb19a844d02677$var$H.isPureReactComponent = !0;
var $e8eb19a844d02677$var$I = Array.isArray, $e8eb19a844d02677$var$J = Object.prototype.hasOwnProperty, $e8eb19a844d02677$var$K = {
    current: null
}, $e8eb19a844d02677$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e8eb19a844d02677$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e8eb19a844d02677$var$J.call(b, d) && !$e8eb19a844d02677$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e8eb19a844d02677$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e8eb19a844d02677$var$K.current
    };
}
function $e8eb19a844d02677$var$N(a, b) {
    return {
        $$typeof: $e8eb19a844d02677$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e8eb19a844d02677$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e8eb19a844d02677$var$l;
}
function $e8eb19a844d02677$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e8eb19a844d02677$var$P = /\/+/g;
function $e8eb19a844d02677$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e8eb19a844d02677$var$escape("" + a.key) : b.toString(36);
}
function $e8eb19a844d02677$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e8eb19a844d02677$var$l:
                case $e8eb19a844d02677$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e8eb19a844d02677$var$Q(h, 0) : d, $e8eb19a844d02677$var$I(c) ? (e = "", null != a && (e = a.replace($e8eb19a844d02677$var$P, "$&/") + "/"), $e8eb19a844d02677$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e8eb19a844d02677$var$O(c) && (c = $e8eb19a844d02677$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e8eb19a844d02677$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e8eb19a844d02677$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e8eb19a844d02677$var$Q(k, g);
        h += $e8eb19a844d02677$var$R(k, b, e, f, c);
    }
    else if (f = $e8eb19a844d02677$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e8eb19a844d02677$var$Q(k, g++), h += $e8eb19a844d02677$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e8eb19a844d02677$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e8eb19a844d02677$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e8eb19a844d02677$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e8eb19a844d02677$var$U = {
    current: null
}, $e8eb19a844d02677$var$V = {
    transition: null
}, $e8eb19a844d02677$var$W = {
    ReactCurrentDispatcher: $e8eb19a844d02677$var$U,
    ReactCurrentBatchConfig: $e8eb19a844d02677$var$V,
    ReactCurrentOwner: $e8eb19a844d02677$var$K
};
function $e8eb19a844d02677$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$e8eb19a844d02677$export$dca3b0875bd9a954 = {
    map: $e8eb19a844d02677$var$S,
    forEach: function(a, b, e) {
        $e8eb19a844d02677$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e8eb19a844d02677$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e8eb19a844d02677$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e8eb19a844d02677$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e8eb19a844d02677$export$16fa2f45be04daa8 = $e8eb19a844d02677$var$E;
$e8eb19a844d02677$export$ffb0004e005737fa = $e8eb19a844d02677$var$p;
$e8eb19a844d02677$export$e2c29f18771995cb = $e8eb19a844d02677$var$r;
$e8eb19a844d02677$export$221d75b3f55bb0bd = $e8eb19a844d02677$var$G;
$e8eb19a844d02677$export$5f8d39834fd61797 = $e8eb19a844d02677$var$q;
$e8eb19a844d02677$export$74bf444e3cd11ea5 = $e8eb19a844d02677$var$w;
$e8eb19a844d02677$export$ae55be85d98224ed = $e8eb19a844d02677$var$W;
$e8eb19a844d02677$export$3ba232387fd5d6dd = $e8eb19a844d02677$var$X;
$e8eb19a844d02677$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e8eb19a844d02677$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e8eb19a844d02677$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e8eb19a844d02677$var$J.call(b, f) && !$e8eb19a844d02677$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e8eb19a844d02677$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e8eb19a844d02677$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e8eb19a844d02677$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e8eb19a844d02677$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e8eb19a844d02677$export$c8a8987d4410bf2d = $e8eb19a844d02677$var$M;
$e8eb19a844d02677$export$d38cd72104c1f0e9 = function(a) {
    var b = $e8eb19a844d02677$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e8eb19a844d02677$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e8eb19a844d02677$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e8eb19a844d02677$var$v,
        render: a
    };
};
$e8eb19a844d02677$export$a8257692ac88316c = $e8eb19a844d02677$var$O;
$e8eb19a844d02677$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e8eb19a844d02677$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e8eb19a844d02677$var$T
    };
};
$e8eb19a844d02677$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e8eb19a844d02677$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e8eb19a844d02677$export$7568632d0d33d16d = function(a) {
    var b = $e8eb19a844d02677$var$V.transition;
    $e8eb19a844d02677$var$V.transition = {};
    try {
        a();
    } finally{
        $e8eb19a844d02677$var$V.transition = b;
    }
};
$e8eb19a844d02677$export$88948ce120ea2619 = $e8eb19a844d02677$var$X;
$e8eb19a844d02677$export$35808ee640e87ca7 = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useCallback(a, b);
};
$e8eb19a844d02677$export$fae74005e78b1a27 = function(a) {
    return $e8eb19a844d02677$var$U.current.useContext(a);
};
$e8eb19a844d02677$export$dc8fbce3eb94dc1e = function() {};
$e8eb19a844d02677$export$6a7bc4e911dc01cf = function(a) {
    return $e8eb19a844d02677$var$U.current.useDeferredValue(a);
};
$e8eb19a844d02677$export$6d9c69b0de29b591 = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useEffect(a, b);
};
$e8eb19a844d02677$export$f680877a34711e37 = function() {
    return $e8eb19a844d02677$var$U.current.useId();
};
$e8eb19a844d02677$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e8eb19a844d02677$var$U.current.useImperativeHandle(a, b, e);
};
$e8eb19a844d02677$export$aaabe4eda9ed9969 = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useInsertionEffect(a, b);
};
$e8eb19a844d02677$export$e5c5a5f917a5871c = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useLayoutEffect(a, b);
};
$e8eb19a844d02677$export$1538c33de8887b59 = function(a, b) {
    return $e8eb19a844d02677$var$U.current.useMemo(a, b);
};
$e8eb19a844d02677$export$13e3392192263954 = function(a, b, e) {
    return $e8eb19a844d02677$var$U.current.useReducer(a, b, e);
};
$e8eb19a844d02677$export$b8f5890fc79d6aca = function(a) {
    return $e8eb19a844d02677$var$U.current.useRef(a);
};
$e8eb19a844d02677$export$60241385465d0a34 = function(a) {
    return $e8eb19a844d02677$var$U.current.useState(a);
};
$e8eb19a844d02677$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e8eb19a844d02677$var$U.current.useSyncExternalStore(a, b, e);
};
$e8eb19a844d02677$export$7b286972b8d8ccbf = function() {
    return $e8eb19a844d02677$var$U.current.useTransition();
};
$e8eb19a844d02677$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("gaHwe", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bc5f567978faddca$export$ae55be85d98224ed; }, function (v) { return $bc5f567978faddca$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $bc5f567978faddca$export$d39a5bbd09211389; }, function (v) { return $bc5f567978faddca$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $bc5f567978faddca$export$882461b6382ed46c; }, function (v) { return $bc5f567978faddca$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $bc5f567978faddca$export$466bfc07425424d5; }, function (v) { return $bc5f567978faddca$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bc5f567978faddca$export$cd75ccfd720a3cd4; }, function (v) { return $bc5f567978faddca$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $bc5f567978faddca$export$fa8d919ba61d84db; }, function (v) { return $bc5f567978faddca$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bc5f567978faddca$export$757ceba2d55c277e; }, function (v) { return $bc5f567978faddca$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $bc5f567978faddca$export$b3890eb0ae9dca99; }, function (v) { return $bc5f567978faddca$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $bc5f567978faddca$export$502457920280e6be; }, function (v) { return $bc5f567978faddca$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bc5f567978faddca$export$c78a37762a8d58e1; }, function (v) { return $bc5f567978faddca$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $bc5f567978faddca$export$dc54d992c10e8a18; }, function (v) { return $bc5f567978faddca$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $bc5f567978faddca$export$83d89fbfd8236492; }, function (v) { return $bc5f567978faddca$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $bc5f567978faddca$export$ae55be85d98224ed;
var $bc5f567978faddca$export$d39a5bbd09211389;
var $bc5f567978faddca$export$882461b6382ed46c;
var $bc5f567978faddca$export$466bfc07425424d5;
var $bc5f567978faddca$export$cd75ccfd720a3cd4;
var $bc5f567978faddca$export$fa8d919ba61d84db;
var $bc5f567978faddca$export$757ceba2d55c277e;
var $bc5f567978faddca$export$b3890eb0ae9dca99;
var $bc5f567978faddca$export$502457920280e6be;
var $bc5f567978faddca$export$c78a37762a8d58e1;
var $bc5f567978faddca$export$dc54d992c10e8a18;
var $bc5f567978faddca$export$83d89fbfd8236492;
'use strict';

var $aivMx = parcelRequire("aivMx");

var $fxLu7 = parcelRequire("fxLu7");
function $bc5f567978faddca$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $bc5f567978faddca$var$da = new Set, $bc5f567978faddca$var$ea = {};
function $bc5f567978faddca$var$fa(a, b) {
    $bc5f567978faddca$var$ha(a, b);
    $bc5f567978faddca$var$ha(a + "Capture", b);
}
function $bc5f567978faddca$var$ha(a, b) {
    $bc5f567978faddca$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$bc5f567978faddca$var$da.add(b[a]);
}
var $bc5f567978faddca$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bc5f567978faddca$var$ja = Object.prototype.hasOwnProperty, $bc5f567978faddca$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $bc5f567978faddca$var$la = {}, $bc5f567978faddca$var$ma = {};
function $bc5f567978faddca$var$oa(a) {
    if ($bc5f567978faddca$var$ja.call($bc5f567978faddca$var$ma, a)) return !0;
    if ($bc5f567978faddca$var$ja.call($bc5f567978faddca$var$la, a)) return !1;
    if ($bc5f567978faddca$var$ka.test(a)) return $bc5f567978faddca$var$ma[a] = !0;
    $bc5f567978faddca$var$la[a] = !0;
    return !1;
}
function $bc5f567978faddca$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $bc5f567978faddca$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $bc5f567978faddca$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $bc5f567978faddca$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $bc5f567978faddca$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $bc5f567978faddca$var$z[b] = new $bc5f567978faddca$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $bc5f567978faddca$var$ra = /[\-:]([a-z])/g;
function $bc5f567978faddca$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($bc5f567978faddca$var$ra, $bc5f567978faddca$var$sa);
    $bc5f567978faddca$var$z[b] = new $bc5f567978faddca$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($bc5f567978faddca$var$ra, $bc5f567978faddca$var$sa);
    $bc5f567978faddca$var$z[b] = new $bc5f567978faddca$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($bc5f567978faddca$var$ra, $bc5f567978faddca$var$sa);
    $bc5f567978faddca$var$z[b] = new $bc5f567978faddca$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$bc5f567978faddca$var$z.xlinkHref = new $bc5f567978faddca$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $bc5f567978faddca$var$z[a] = new $bc5f567978faddca$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $bc5f567978faddca$var$ta(a, b, c, d) {
    var e = $bc5f567978faddca$var$z.hasOwnProperty(b) ? $bc5f567978faddca$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $bc5f567978faddca$var$qa(b, c, e, d) && (c = null), d || null === e ? $bc5f567978faddca$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $bc5f567978faddca$var$ua = $aivMx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $bc5f567978faddca$var$va = Symbol.for("react.element"), $bc5f567978faddca$var$wa = Symbol.for("react.portal"), $bc5f567978faddca$var$ya = Symbol.for("react.fragment"), $bc5f567978faddca$var$za = Symbol.for("react.strict_mode"), $bc5f567978faddca$var$Aa = Symbol.for("react.profiler"), $bc5f567978faddca$var$Ba = Symbol.for("react.provider"), $bc5f567978faddca$var$Ca = Symbol.for("react.context"), $bc5f567978faddca$var$Da = Symbol.for("react.forward_ref"), $bc5f567978faddca$var$Ea = Symbol.for("react.suspense"), $bc5f567978faddca$var$Fa = Symbol.for("react.suspense_list"), $bc5f567978faddca$var$Ga = Symbol.for("react.memo"), $bc5f567978faddca$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $bc5f567978faddca$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $bc5f567978faddca$var$Ja = Symbol.iterator;
function $bc5f567978faddca$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $bc5f567978faddca$var$Ja && a[$bc5f567978faddca$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $bc5f567978faddca$var$A = Object.assign, $bc5f567978faddca$var$La;
function $bc5f567978faddca$var$Ma(a) {
    if (void 0 === $bc5f567978faddca$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $bc5f567978faddca$var$La = b && b[1] || "";
    }
    return "\n" + $bc5f567978faddca$var$La + a;
}
var $bc5f567978faddca$var$Na = !1;
function $bc5f567978faddca$var$Oa(a, b) {
    if (!a || $bc5f567978faddca$var$Na) return "";
    $bc5f567978faddca$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $bc5f567978faddca$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $bc5f567978faddca$var$Ma(a) : "";
}
function $bc5f567978faddca$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $bc5f567978faddca$var$Ma(a.type);
        case 16:
            return $bc5f567978faddca$var$Ma("Lazy");
        case 13:
            return $bc5f567978faddca$var$Ma("Suspense");
        case 19:
            return $bc5f567978faddca$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $bc5f567978faddca$var$Oa(a.type, !1), a;
        case 11:
            return a = $bc5f567978faddca$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $bc5f567978faddca$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $bc5f567978faddca$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $bc5f567978faddca$var$ya:
            return "Fragment";
        case $bc5f567978faddca$var$wa:
            return "Portal";
        case $bc5f567978faddca$var$Aa:
            return "Profiler";
        case $bc5f567978faddca$var$za:
            return "StrictMode";
        case $bc5f567978faddca$var$Ea:
            return "Suspense";
        case $bc5f567978faddca$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $bc5f567978faddca$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $bc5f567978faddca$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $bc5f567978faddca$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $bc5f567978faddca$var$Ga:
            return b = a.displayName || null, null !== b ? b : $bc5f567978faddca$var$Qa(a.type) || "Memo";
        case $bc5f567978faddca$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $bc5f567978faddca$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $bc5f567978faddca$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $bc5f567978faddca$var$Qa(b);
        case 8:
            return b === $bc5f567978faddca$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $bc5f567978faddca$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $bc5f567978faddca$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $bc5f567978faddca$var$Ua(a) {
    var b = $bc5f567978faddca$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $bc5f567978faddca$var$Va(a) {
    a._valueTracker || (a._valueTracker = $bc5f567978faddca$var$Ua(a));
}
function $bc5f567978faddca$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $bc5f567978faddca$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $bc5f567978faddca$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $bc5f567978faddca$var$Ya(a, b) {
    var c = b.checked;
    return $bc5f567978faddca$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $bc5f567978faddca$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $bc5f567978faddca$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $bc5f567978faddca$var$ab(a, b) {
    b = b.checked;
    null != b && $bc5f567978faddca$var$ta(a, "checked", b, !1);
}
function $bc5f567978faddca$var$bb(a, b) {
    $bc5f567978faddca$var$ab(a, b);
    var c = $bc5f567978faddca$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $bc5f567978faddca$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $bc5f567978faddca$var$cb(a, b.type, $bc5f567978faddca$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $bc5f567978faddca$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $bc5f567978faddca$var$cb(a, b, c) {
    if ("number" !== b || $bc5f567978faddca$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $bc5f567978faddca$var$eb = Array.isArray;
function $bc5f567978faddca$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $bc5f567978faddca$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $bc5f567978faddca$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($bc5f567978faddca$var$p(91));
    return $bc5f567978faddca$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $bc5f567978faddca$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($bc5f567978faddca$var$p(92));
            if ($bc5f567978faddca$var$eb(c)) {
                if (1 < c.length) throw Error($bc5f567978faddca$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $bc5f567978faddca$var$Sa(c)
    };
}
function $bc5f567978faddca$var$ib(a, b) {
    var c = $bc5f567978faddca$var$Sa(b.value), d = $bc5f567978faddca$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $bc5f567978faddca$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $bc5f567978faddca$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $bc5f567978faddca$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $bc5f567978faddca$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $bc5f567978faddca$var$mb, $bc5f567978faddca$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $bc5f567978faddca$var$mb = $bc5f567978faddca$var$mb || document.createElement("div");
        $bc5f567978faddca$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $bc5f567978faddca$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $bc5f567978faddca$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $bc5f567978faddca$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $bc5f567978faddca$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($bc5f567978faddca$var$pb).forEach(function(a) {
    $bc5f567978faddca$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $bc5f567978faddca$var$pb[b] = $bc5f567978faddca$var$pb[a];
    });
});
function $bc5f567978faddca$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $bc5f567978faddca$var$pb.hasOwnProperty(a) && $bc5f567978faddca$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $bc5f567978faddca$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $bc5f567978faddca$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $bc5f567978faddca$var$tb = $bc5f567978faddca$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $bc5f567978faddca$var$ub(a, b) {
    if (b) {
        if ($bc5f567978faddca$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($bc5f567978faddca$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($bc5f567978faddca$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($bc5f567978faddca$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($bc5f567978faddca$var$p(62));
    }
}
function $bc5f567978faddca$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bc5f567978faddca$var$wb = null;
function $bc5f567978faddca$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $bc5f567978faddca$var$yb = null, $bc5f567978faddca$var$zb = null, $bc5f567978faddca$var$Ab = null;
function $bc5f567978faddca$var$Bb(a) {
    if (a = $bc5f567978faddca$var$Cb(a)) {
        if ("function" !== typeof $bc5f567978faddca$var$yb) throw Error($bc5f567978faddca$var$p(280));
        var b = a.stateNode;
        b && (b = $bc5f567978faddca$var$Db(b), $bc5f567978faddca$var$yb(a.stateNode, a.type, b));
    }
}
function $bc5f567978faddca$var$Eb(a) {
    $bc5f567978faddca$var$zb ? $bc5f567978faddca$var$Ab ? $bc5f567978faddca$var$Ab.push(a) : $bc5f567978faddca$var$Ab = [
        a
    ] : $bc5f567978faddca$var$zb = a;
}
function $bc5f567978faddca$var$Fb() {
    if ($bc5f567978faddca$var$zb) {
        var a = $bc5f567978faddca$var$zb, b = $bc5f567978faddca$var$Ab;
        $bc5f567978faddca$var$Ab = $bc5f567978faddca$var$zb = null;
        $bc5f567978faddca$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$bc5f567978faddca$var$Bb(b[a]);
    }
}
function $bc5f567978faddca$var$Gb(a, b) {
    return a(b);
}
function $bc5f567978faddca$var$Hb() {}
var $bc5f567978faddca$var$Ib = !1;
function $bc5f567978faddca$var$Jb(a, b, c) {
    if ($bc5f567978faddca$var$Ib) return a(b, c);
    $bc5f567978faddca$var$Ib = !0;
    try {
        return $bc5f567978faddca$var$Gb(a, b, c);
    } finally{
        if ($bc5f567978faddca$var$Ib = !1, null !== $bc5f567978faddca$var$zb || null !== $bc5f567978faddca$var$Ab) $bc5f567978faddca$var$Hb(), $bc5f567978faddca$var$Fb();
    }
}
function $bc5f567978faddca$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $bc5f567978faddca$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($bc5f567978faddca$var$p(231, b, typeof c));
    return c;
}
var $bc5f567978faddca$var$Lb = !1;
if ($bc5f567978faddca$var$ia) try {
    var $bc5f567978faddca$var$Mb = {};
    Object.defineProperty($bc5f567978faddca$var$Mb, "passive", {
        get: function() {
            $bc5f567978faddca$var$Lb = !0;
        }
    });
    window.addEventListener("test", $bc5f567978faddca$var$Mb, $bc5f567978faddca$var$Mb);
    window.removeEventListener("test", $bc5f567978faddca$var$Mb, $bc5f567978faddca$var$Mb);
} catch (a) {
    $bc5f567978faddca$var$Lb = !1;
}
function $bc5f567978faddca$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $bc5f567978faddca$var$Ob = !1, $bc5f567978faddca$var$Pb = null, $bc5f567978faddca$var$Qb = !1, $bc5f567978faddca$var$Rb = null, $bc5f567978faddca$var$Sb = {
    onError: function(a) {
        $bc5f567978faddca$var$Ob = !0;
        $bc5f567978faddca$var$Pb = a;
    }
};
function $bc5f567978faddca$var$Tb(a, b, c, d, e, f, g, h, k) {
    $bc5f567978faddca$var$Ob = !1;
    $bc5f567978faddca$var$Pb = null;
    $bc5f567978faddca$var$Nb.apply($bc5f567978faddca$var$Sb, arguments);
}
function $bc5f567978faddca$var$Ub(a, b, c, d, e, f, g, h, k) {
    $bc5f567978faddca$var$Tb.apply(this, arguments);
    if ($bc5f567978faddca$var$Ob) {
        if ($bc5f567978faddca$var$Ob) {
            var l = $bc5f567978faddca$var$Pb;
            $bc5f567978faddca$var$Ob = !1;
            $bc5f567978faddca$var$Pb = null;
        } else throw Error($bc5f567978faddca$var$p(198));
        $bc5f567978faddca$var$Qb || ($bc5f567978faddca$var$Qb = !0, $bc5f567978faddca$var$Rb = l);
    }
}
function $bc5f567978faddca$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $bc5f567978faddca$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $bc5f567978faddca$var$Xb(a) {
    if ($bc5f567978faddca$var$Vb(a) !== a) throw Error($bc5f567978faddca$var$p(188));
}
function $bc5f567978faddca$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $bc5f567978faddca$var$Vb(a);
        if (null === b) throw Error($bc5f567978faddca$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $bc5f567978faddca$var$Xb(e), a;
                if (f === d) return $bc5f567978faddca$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($bc5f567978faddca$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($bc5f567978faddca$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($bc5f567978faddca$var$p(190));
    }
    if (3 !== c.tag) throw Error($bc5f567978faddca$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $bc5f567978faddca$var$Zb(a) {
    a = $bc5f567978faddca$var$Yb(a);
    return null !== a ? $bc5f567978faddca$var$$b(a) : null;
}
function $bc5f567978faddca$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $bc5f567978faddca$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $bc5f567978faddca$var$ac = $fxLu7.unstable_scheduleCallback, $bc5f567978faddca$var$bc = $fxLu7.unstable_cancelCallback, $bc5f567978faddca$var$cc = $fxLu7.unstable_shouldYield, $bc5f567978faddca$var$dc = $fxLu7.unstable_requestPaint, $bc5f567978faddca$var$B = $fxLu7.unstable_now, $bc5f567978faddca$var$ec = $fxLu7.unstable_getCurrentPriorityLevel, $bc5f567978faddca$var$fc = $fxLu7.unstable_ImmediatePriority, $bc5f567978faddca$var$gc = $fxLu7.unstable_UserBlockingPriority, $bc5f567978faddca$var$hc = $fxLu7.unstable_NormalPriority, $bc5f567978faddca$var$ic = $fxLu7.unstable_LowPriority, $bc5f567978faddca$var$jc = $fxLu7.unstable_IdlePriority, $bc5f567978faddca$var$kc = null, $bc5f567978faddca$var$lc = null;
function $bc5f567978faddca$var$mc(a) {
    if ($bc5f567978faddca$var$lc && "function" === typeof $bc5f567978faddca$var$lc.onCommitFiberRoot) try {
        $bc5f567978faddca$var$lc.onCommitFiberRoot($bc5f567978faddca$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $bc5f567978faddca$var$oc = Math.clz32 ? Math.clz32 : $bc5f567978faddca$var$nc, $bc5f567978faddca$var$pc = Math.log, $bc5f567978faddca$var$qc = Math.LN2;
function $bc5f567978faddca$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($bc5f567978faddca$var$pc(a) / $bc5f567978faddca$var$qc | 0) | 0;
}
var $bc5f567978faddca$var$rc = 64, $bc5f567978faddca$var$sc = 4194304;
function $bc5f567978faddca$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $bc5f567978faddca$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $bc5f567978faddca$var$tc(h) : (f &= g, 0 !== f && (d = $bc5f567978faddca$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $bc5f567978faddca$var$tc(g) : 0 !== f && (d = $bc5f567978faddca$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $bc5f567978faddca$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $bc5f567978faddca$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bc5f567978faddca$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $bc5f567978faddca$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $bc5f567978faddca$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $bc5f567978faddca$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $bc5f567978faddca$var$yc() {
    var a = $bc5f567978faddca$var$rc;
    $bc5f567978faddca$var$rc <<= 1;
    0 === ($bc5f567978faddca$var$rc & 4194240) && ($bc5f567978faddca$var$rc = 64);
    return a;
}
function $bc5f567978faddca$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $bc5f567978faddca$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $bc5f567978faddca$var$oc(b);
    a[b] = c;
}
function $bc5f567978faddca$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $bc5f567978faddca$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $bc5f567978faddca$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $bc5f567978faddca$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $bc5f567978faddca$var$C = 0;
function $bc5f567978faddca$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $bc5f567978faddca$var$Ec, $bc5f567978faddca$var$Fc, $bc5f567978faddca$var$Gc, $bc5f567978faddca$var$Hc, $bc5f567978faddca$var$Ic, $bc5f567978faddca$var$Jc = !1, $bc5f567978faddca$var$Kc = [], $bc5f567978faddca$var$Lc = null, $bc5f567978faddca$var$Mc = null, $bc5f567978faddca$var$Nc = null, $bc5f567978faddca$var$Oc = new Map, $bc5f567978faddca$var$Pc = new Map, $bc5f567978faddca$var$Qc = [], $bc5f567978faddca$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $bc5f567978faddca$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $bc5f567978faddca$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $bc5f567978faddca$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $bc5f567978faddca$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $bc5f567978faddca$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bc5f567978faddca$var$Pc.delete(b.pointerId);
    }
}
function $bc5f567978faddca$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $bc5f567978faddca$var$Cb(b), null !== b && $bc5f567978faddca$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $bc5f567978faddca$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $bc5f567978faddca$var$Lc = $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $bc5f567978faddca$var$Mc = $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $bc5f567978faddca$var$Nc = $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $bc5f567978faddca$var$Oc.set(f, $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $bc5f567978faddca$var$Pc.set(f, $bc5f567978faddca$var$Tc($bc5f567978faddca$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $bc5f567978faddca$var$Vc(a) {
    var b = $bc5f567978faddca$var$Wc(a.target);
    if (null !== b) {
        var c = $bc5f567978faddca$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $bc5f567978faddca$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $bc5f567978faddca$var$Ic(a.priority, function() {
                        $bc5f567978faddca$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $bc5f567978faddca$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $bc5f567978faddca$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $bc5f567978faddca$var$wb = d;
            c.target.dispatchEvent(d);
            $bc5f567978faddca$var$wb = null;
        } else return b = $bc5f567978faddca$var$Cb(c), null !== b && $bc5f567978faddca$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $bc5f567978faddca$var$Zc(a, b, c) {
    $bc5f567978faddca$var$Xc(a) && c.delete(b);
}
function $bc5f567978faddca$var$$c() {
    $bc5f567978faddca$var$Jc = !1;
    null !== $bc5f567978faddca$var$Lc && $bc5f567978faddca$var$Xc($bc5f567978faddca$var$Lc) && ($bc5f567978faddca$var$Lc = null);
    null !== $bc5f567978faddca$var$Mc && $bc5f567978faddca$var$Xc($bc5f567978faddca$var$Mc) && ($bc5f567978faddca$var$Mc = null);
    null !== $bc5f567978faddca$var$Nc && $bc5f567978faddca$var$Xc($bc5f567978faddca$var$Nc) && ($bc5f567978faddca$var$Nc = null);
    $bc5f567978faddca$var$Oc.forEach($bc5f567978faddca$var$Zc);
    $bc5f567978faddca$var$Pc.forEach($bc5f567978faddca$var$Zc);
}
function $bc5f567978faddca$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $bc5f567978faddca$var$Jc || ($bc5f567978faddca$var$Jc = !0, $fxLu7.unstable_scheduleCallback($fxLu7.unstable_NormalPriority, $bc5f567978faddca$var$$c)));
}
function $bc5f567978faddca$var$bd(a) {
    function b(b) {
        return $bc5f567978faddca$var$ad(b, a);
    }
    if (0 < $bc5f567978faddca$var$Kc.length) {
        $bc5f567978faddca$var$ad($bc5f567978faddca$var$Kc[0], a);
        for(var c = 1; c < $bc5f567978faddca$var$Kc.length; c++){
            var d = $bc5f567978faddca$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $bc5f567978faddca$var$Lc && $bc5f567978faddca$var$ad($bc5f567978faddca$var$Lc, a);
    null !== $bc5f567978faddca$var$Mc && $bc5f567978faddca$var$ad($bc5f567978faddca$var$Mc, a);
    null !== $bc5f567978faddca$var$Nc && $bc5f567978faddca$var$ad($bc5f567978faddca$var$Nc, a);
    $bc5f567978faddca$var$Oc.forEach(b);
    $bc5f567978faddca$var$Pc.forEach(b);
    for(c = 0; c < $bc5f567978faddca$var$Qc.length; c++)d = $bc5f567978faddca$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $bc5f567978faddca$var$Qc.length && (c = $bc5f567978faddca$var$Qc[0], null === c.blockedOn);)$bc5f567978faddca$var$Vc(c), null === c.blockedOn && $bc5f567978faddca$var$Qc.shift();
}
var $bc5f567978faddca$var$cd = $bc5f567978faddca$var$ua.ReactCurrentBatchConfig, $bc5f567978faddca$var$dd = !0;
function $bc5f567978faddca$var$ed(a, b, c, d) {
    var e = $bc5f567978faddca$var$C, f = $bc5f567978faddca$var$cd.transition;
    $bc5f567978faddca$var$cd.transition = null;
    try {
        $bc5f567978faddca$var$C = 1, $bc5f567978faddca$var$fd(a, b, c, d);
    } finally{
        $bc5f567978faddca$var$C = e, $bc5f567978faddca$var$cd.transition = f;
    }
}
function $bc5f567978faddca$var$gd(a, b, c, d) {
    var e = $bc5f567978faddca$var$C, f = $bc5f567978faddca$var$cd.transition;
    $bc5f567978faddca$var$cd.transition = null;
    try {
        $bc5f567978faddca$var$C = 4, $bc5f567978faddca$var$fd(a, b, c, d);
    } finally{
        $bc5f567978faddca$var$C = e, $bc5f567978faddca$var$cd.transition = f;
    }
}
function $bc5f567978faddca$var$fd(a, b, c, d) {
    if ($bc5f567978faddca$var$dd) {
        var e = $bc5f567978faddca$var$Yc(a, b, c, d);
        if (null === e) $bc5f567978faddca$var$hd(a, b, d, $bc5f567978faddca$var$id, c), $bc5f567978faddca$var$Sc(a, d);
        else if ($bc5f567978faddca$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($bc5f567978faddca$var$Sc(a, d), b & 4 && -1 < $bc5f567978faddca$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $bc5f567978faddca$var$Cb(e);
                null !== f && $bc5f567978faddca$var$Ec(f);
                f = $bc5f567978faddca$var$Yc(a, b, c, d);
                null === f && $bc5f567978faddca$var$hd(a, b, d, $bc5f567978faddca$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $bc5f567978faddca$var$hd(a, b, d, null, c);
    }
}
var $bc5f567978faddca$var$id = null;
function $bc5f567978faddca$var$Yc(a, b, c, d) {
    $bc5f567978faddca$var$id = null;
    a = $bc5f567978faddca$var$xb(d);
    a = $bc5f567978faddca$var$Wc(a);
    if (null !== a) {
        if (b = $bc5f567978faddca$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $bc5f567978faddca$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $bc5f567978faddca$var$id = a;
    return null;
}
function $bc5f567978faddca$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($bc5f567978faddca$var$ec()){
                case $bc5f567978faddca$var$fc:
                    return 1;
                case $bc5f567978faddca$var$gc:
                    return 4;
                case $bc5f567978faddca$var$hc:
                case $bc5f567978faddca$var$ic:
                    return 16;
                case $bc5f567978faddca$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $bc5f567978faddca$var$kd = null, $bc5f567978faddca$var$ld = null, $bc5f567978faddca$var$md = null;
function $bc5f567978faddca$var$nd() {
    if ($bc5f567978faddca$var$md) return $bc5f567978faddca$var$md;
    var a, b = $bc5f567978faddca$var$ld, c = b.length, d, e = "value" in $bc5f567978faddca$var$kd ? $bc5f567978faddca$var$kd.value : $bc5f567978faddca$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $bc5f567978faddca$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $bc5f567978faddca$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $bc5f567978faddca$var$pd() {
    return !0;
}
function $bc5f567978faddca$var$qd() {
    return !1;
}
function $bc5f567978faddca$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $bc5f567978faddca$var$pd : $bc5f567978faddca$var$qd;
        this.isPropagationStopped = $bc5f567978faddca$var$qd;
        return this;
    }
    $bc5f567978faddca$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $bc5f567978faddca$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $bc5f567978faddca$var$pd);
        },
        persist: function() {},
        isPersistent: $bc5f567978faddca$var$pd
    });
    return b;
}
var $bc5f567978faddca$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bc5f567978faddca$var$td = $bc5f567978faddca$var$rd($bc5f567978faddca$var$sd), $bc5f567978faddca$var$ud = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    view: 0,
    detail: 0
}), $bc5f567978faddca$var$vd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$ud), $bc5f567978faddca$var$wd, $bc5f567978faddca$var$xd, $bc5f567978faddca$var$yd, $bc5f567978faddca$var$Ad = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bc5f567978faddca$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $bc5f567978faddca$var$yd && ($bc5f567978faddca$var$yd && "mousemove" === a.type ? ($bc5f567978faddca$var$wd = a.screenX - $bc5f567978faddca$var$yd.screenX, $bc5f567978faddca$var$xd = a.screenY - $bc5f567978faddca$var$yd.screenY) : $bc5f567978faddca$var$xd = $bc5f567978faddca$var$wd = 0, $bc5f567978faddca$var$yd = a);
        return $bc5f567978faddca$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $bc5f567978faddca$var$xd;
    }
}), $bc5f567978faddca$var$Bd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Ad), $bc5f567978faddca$var$Cd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$Ad, {
    dataTransfer: 0
}), $bc5f567978faddca$var$Dd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Cd), $bc5f567978faddca$var$Ed = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$ud, {
    relatedTarget: 0
}), $bc5f567978faddca$var$Fd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Ed), $bc5f567978faddca$var$Gd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bc5f567978faddca$var$Hd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Gd), $bc5f567978faddca$var$Id = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $bc5f567978faddca$var$Jd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Id), $bc5f567978faddca$var$Kd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    data: 0
}), $bc5f567978faddca$var$Ld = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Kd), $bc5f567978faddca$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bc5f567978faddca$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bc5f567978faddca$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bc5f567978faddca$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $bc5f567978faddca$var$Od[a]) ? !!b[a] : !1;
}
function $bc5f567978faddca$var$zd() {
    return $bc5f567978faddca$var$Pd;
}
var $bc5f567978faddca$var$Qd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $bc5f567978faddca$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $bc5f567978faddca$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $bc5f567978faddca$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bc5f567978faddca$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $bc5f567978faddca$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $bc5f567978faddca$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $bc5f567978faddca$var$Rd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Qd), $bc5f567978faddca$var$Sd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bc5f567978faddca$var$Td = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Sd), $bc5f567978faddca$var$Ud = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bc5f567978faddca$var$zd
}), $bc5f567978faddca$var$Vd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Ud), $bc5f567978faddca$var$Wd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bc5f567978faddca$var$Xd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Wd), $bc5f567978faddca$var$Yd = $bc5f567978faddca$var$A({}, $bc5f567978faddca$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bc5f567978faddca$var$Zd = $bc5f567978faddca$var$rd($bc5f567978faddca$var$Yd), $bc5f567978faddca$var$$d = [
    9,
    13,
    27,
    32
], $bc5f567978faddca$var$ae = $bc5f567978faddca$var$ia && "CompositionEvent" in window, $bc5f567978faddca$var$be = null;
$bc5f567978faddca$var$ia && "documentMode" in document && ($bc5f567978faddca$var$be = document.documentMode);
var $bc5f567978faddca$var$ce = $bc5f567978faddca$var$ia && "TextEvent" in window && !$bc5f567978faddca$var$be, $bc5f567978faddca$var$de = $bc5f567978faddca$var$ia && (!$bc5f567978faddca$var$ae || $bc5f567978faddca$var$be && 8 < $bc5f567978faddca$var$be && 11 >= $bc5f567978faddca$var$be), $bc5f567978faddca$var$ee = String.fromCharCode(32), $bc5f567978faddca$var$fe = !1;
function $bc5f567978faddca$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $bc5f567978faddca$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bc5f567978faddca$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $bc5f567978faddca$var$ie = !1;
function $bc5f567978faddca$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $bc5f567978faddca$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $bc5f567978faddca$var$fe = !0;
            return $bc5f567978faddca$var$ee;
        case "textInput":
            return a = b.data, a === $bc5f567978faddca$var$ee && $bc5f567978faddca$var$fe ? null : a;
        default:
            return null;
    }
}
function $bc5f567978faddca$var$ke(a, b) {
    if ($bc5f567978faddca$var$ie) return "compositionend" === a || !$bc5f567978faddca$var$ae && $bc5f567978faddca$var$ge(a, b) ? (a = $bc5f567978faddca$var$nd(), $bc5f567978faddca$var$md = $bc5f567978faddca$var$ld = $bc5f567978faddca$var$kd = null, $bc5f567978faddca$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $bc5f567978faddca$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $bc5f567978faddca$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bc5f567978faddca$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$bc5f567978faddca$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $bc5f567978faddca$var$ne(a, b, c, d) {
    $bc5f567978faddca$var$Eb(d);
    b = $bc5f567978faddca$var$oe(b, "onChange");
    0 < b.length && (c = new $bc5f567978faddca$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $bc5f567978faddca$var$pe = null, $bc5f567978faddca$var$qe = null;
function $bc5f567978faddca$var$re(a) {
    $bc5f567978faddca$var$se(a, 0);
}
function $bc5f567978faddca$var$te(a) {
    var b = $bc5f567978faddca$var$ue(a);
    if ($bc5f567978faddca$var$Wa(b)) return a;
}
function $bc5f567978faddca$var$ve(a, b) {
    if ("change" === a) return b;
}
var $bc5f567978faddca$var$we = !1;
if ($bc5f567978faddca$var$ia) {
    var $bc5f567978faddca$var$xe;
    if ($bc5f567978faddca$var$ia) {
        var $bc5f567978faddca$var$ye = "oninput" in document;
        if (!$bc5f567978faddca$var$ye) {
            var $bc5f567978faddca$var$ze = document.createElement("div");
            $bc5f567978faddca$var$ze.setAttribute("oninput", "return;");
            $bc5f567978faddca$var$ye = "function" === typeof $bc5f567978faddca$var$ze.oninput;
        }
        $bc5f567978faddca$var$xe = $bc5f567978faddca$var$ye;
    } else $bc5f567978faddca$var$xe = !1;
    $bc5f567978faddca$var$we = $bc5f567978faddca$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $bc5f567978faddca$var$Ae() {
    $bc5f567978faddca$var$pe && ($bc5f567978faddca$var$pe.detachEvent("onpropertychange", $bc5f567978faddca$var$Be), $bc5f567978faddca$var$qe = $bc5f567978faddca$var$pe = null);
}
function $bc5f567978faddca$var$Be(a) {
    if ("value" === a.propertyName && $bc5f567978faddca$var$te($bc5f567978faddca$var$qe)) {
        var b = [];
        $bc5f567978faddca$var$ne(b, $bc5f567978faddca$var$qe, a, $bc5f567978faddca$var$xb(a));
        $bc5f567978faddca$var$Jb($bc5f567978faddca$var$re, b);
    }
}
function $bc5f567978faddca$var$Ce(a, b, c) {
    "focusin" === a ? ($bc5f567978faddca$var$Ae(), $bc5f567978faddca$var$pe = b, $bc5f567978faddca$var$qe = c, $bc5f567978faddca$var$pe.attachEvent("onpropertychange", $bc5f567978faddca$var$Be)) : "focusout" === a && $bc5f567978faddca$var$Ae();
}
function $bc5f567978faddca$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $bc5f567978faddca$var$te($bc5f567978faddca$var$qe);
}
function $bc5f567978faddca$var$Ee(a, b) {
    if ("click" === a) return $bc5f567978faddca$var$te(b);
}
function $bc5f567978faddca$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $bc5f567978faddca$var$te(b);
}
function $bc5f567978faddca$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bc5f567978faddca$var$He = "function" === typeof Object.is ? Object.is : $bc5f567978faddca$var$Ge;
function $bc5f567978faddca$var$Ie(a, b) {
    if ($bc5f567978faddca$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$bc5f567978faddca$var$ja.call(b, e) || !$bc5f567978faddca$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $bc5f567978faddca$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $bc5f567978faddca$var$Ke(a, b) {
    var c = $bc5f567978faddca$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $bc5f567978faddca$var$Je(c);
    }
}
function $bc5f567978faddca$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $bc5f567978faddca$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $bc5f567978faddca$var$Me() {
    for(var a = window, b = $bc5f567978faddca$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $bc5f567978faddca$var$Xa(a.document);
    }
    return b;
}
function $bc5f567978faddca$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $bc5f567978faddca$var$Oe(a) {
    var b = $bc5f567978faddca$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $bc5f567978faddca$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $bc5f567978faddca$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $bc5f567978faddca$var$Ke(c, f);
                var g = $bc5f567978faddca$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $bc5f567978faddca$var$Pe = $bc5f567978faddca$var$ia && "documentMode" in document && 11 >= document.documentMode, $bc5f567978faddca$var$Qe = null, $bc5f567978faddca$var$Re = null, $bc5f567978faddca$var$Se = null, $bc5f567978faddca$var$Te = !1;
function $bc5f567978faddca$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $bc5f567978faddca$var$Te || null == $bc5f567978faddca$var$Qe || $bc5f567978faddca$var$Qe !== $bc5f567978faddca$var$Xa(d) || (d = $bc5f567978faddca$var$Qe, "selectionStart" in d && $bc5f567978faddca$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $bc5f567978faddca$var$Se && $bc5f567978faddca$var$Ie($bc5f567978faddca$var$Se, d) || ($bc5f567978faddca$var$Se = d, d = $bc5f567978faddca$var$oe($bc5f567978faddca$var$Re, "onSelect"), 0 < d.length && (b = new $bc5f567978faddca$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $bc5f567978faddca$var$Qe)));
}
function $bc5f567978faddca$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $bc5f567978faddca$var$We = {
    animationend: $bc5f567978faddca$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $bc5f567978faddca$var$Ve("Animation", "AnimationIteration"),
    animationstart: $bc5f567978faddca$var$Ve("Animation", "AnimationStart"),
    transitionend: $bc5f567978faddca$var$Ve("Transition", "TransitionEnd")
}, $bc5f567978faddca$var$Xe = {}, $bc5f567978faddca$var$Ye = {};
$bc5f567978faddca$var$ia && ($bc5f567978faddca$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $bc5f567978faddca$var$We.animationend.animation, delete $bc5f567978faddca$var$We.animationiteration.animation, delete $bc5f567978faddca$var$We.animationstart.animation), "TransitionEvent" in window || delete $bc5f567978faddca$var$We.transitionend.transition);
function $bc5f567978faddca$var$Ze(a) {
    if ($bc5f567978faddca$var$Xe[a]) return $bc5f567978faddca$var$Xe[a];
    if (!$bc5f567978faddca$var$We[a]) return a;
    var b = $bc5f567978faddca$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $bc5f567978faddca$var$Ye) return $bc5f567978faddca$var$Xe[a] = b[c];
    return a;
}
var $bc5f567978faddca$var$$e = $bc5f567978faddca$var$Ze("animationend"), $bc5f567978faddca$var$af = $bc5f567978faddca$var$Ze("animationiteration"), $bc5f567978faddca$var$bf = $bc5f567978faddca$var$Ze("animationstart"), $bc5f567978faddca$var$cf = $bc5f567978faddca$var$Ze("transitionend"), $bc5f567978faddca$var$df = new Map, $bc5f567978faddca$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $bc5f567978faddca$var$ff(a, b) {
    $bc5f567978faddca$var$df.set(a, b);
    $bc5f567978faddca$var$fa(b, [
        a
    ]);
}
for(var $bc5f567978faddca$var$gf = 0; $bc5f567978faddca$var$gf < $bc5f567978faddca$var$ef.length; $bc5f567978faddca$var$gf++){
    var $bc5f567978faddca$var$hf = $bc5f567978faddca$var$ef[$bc5f567978faddca$var$gf], $bc5f567978faddca$var$jf = $bc5f567978faddca$var$hf.toLowerCase(), $bc5f567978faddca$var$kf = $bc5f567978faddca$var$hf[0].toUpperCase() + $bc5f567978faddca$var$hf.slice(1);
    $bc5f567978faddca$var$ff($bc5f567978faddca$var$jf, "on" + $bc5f567978faddca$var$kf);
}
$bc5f567978faddca$var$ff($bc5f567978faddca$var$$e, "onAnimationEnd");
$bc5f567978faddca$var$ff($bc5f567978faddca$var$af, "onAnimationIteration");
$bc5f567978faddca$var$ff($bc5f567978faddca$var$bf, "onAnimationStart");
$bc5f567978faddca$var$ff("dblclick", "onDoubleClick");
$bc5f567978faddca$var$ff("focusin", "onFocus");
$bc5f567978faddca$var$ff("focusout", "onBlur");
$bc5f567978faddca$var$ff($bc5f567978faddca$var$cf, "onTransitionEnd");
$bc5f567978faddca$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bc5f567978faddca$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bc5f567978faddca$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bc5f567978faddca$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bc5f567978faddca$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bc5f567978faddca$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bc5f567978faddca$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bc5f567978faddca$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bc5f567978faddca$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bc5f567978faddca$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bc5f567978faddca$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bc5f567978faddca$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($bc5f567978faddca$var$lf));
function $bc5f567978faddca$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $bc5f567978faddca$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $bc5f567978faddca$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bc5f567978faddca$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $bc5f567978faddca$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($bc5f567978faddca$var$Qb) throw a = $bc5f567978faddca$var$Rb, $bc5f567978faddca$var$Qb = !1, $bc5f567978faddca$var$Rb = null, a;
}
function $bc5f567978faddca$var$D(a, b) {
    var c = b[$bc5f567978faddca$var$of];
    void 0 === c && (c = b[$bc5f567978faddca$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($bc5f567978faddca$var$pf(b, a, 2, !1), c.add(d));
}
function $bc5f567978faddca$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $bc5f567978faddca$var$pf(c, a, d, b);
}
var $bc5f567978faddca$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $bc5f567978faddca$var$sf(a) {
    if (!a[$bc5f567978faddca$var$rf]) {
        a[$bc5f567978faddca$var$rf] = !0;
        $bc5f567978faddca$var$da.forEach(function(b) {
            "selectionchange" !== b && ($bc5f567978faddca$var$mf.has(b) || $bc5f567978faddca$var$qf(b, !1, a), $bc5f567978faddca$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$bc5f567978faddca$var$rf] || (b[$bc5f567978faddca$var$rf] = !0, $bc5f567978faddca$var$qf("selectionchange", !1, b));
    }
}
function $bc5f567978faddca$var$pf(a, b, c, d) {
    switch($bc5f567978faddca$var$jd(b)){
        case 1:
            var e = $bc5f567978faddca$var$ed;
            break;
        case 4:
            e = $bc5f567978faddca$var$gd;
            break;
        default:
            e = $bc5f567978faddca$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$bc5f567978faddca$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $bc5f567978faddca$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $bc5f567978faddca$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $bc5f567978faddca$var$Jb(function() {
        var d = f, e = $bc5f567978faddca$var$xb(c), g = [];
        a: {
            var h = $bc5f567978faddca$var$df.get(a);
            if (void 0 !== h) {
                var k = $bc5f567978faddca$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $bc5f567978faddca$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $bc5f567978faddca$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $bc5f567978faddca$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $bc5f567978faddca$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $bc5f567978faddca$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $bc5f567978faddca$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $bc5f567978faddca$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $bc5f567978faddca$var$Vd;
                        break;
                    case $bc5f567978faddca$var$$e:
                    case $bc5f567978faddca$var$af:
                    case $bc5f567978faddca$var$bf:
                        k = $bc5f567978faddca$var$Hd;
                        break;
                    case $bc5f567978faddca$var$cf:
                        k = $bc5f567978faddca$var$Xd;
                        break;
                    case "scroll":
                        k = $bc5f567978faddca$var$vd;
                        break;
                    case "wheel":
                        k = $bc5f567978faddca$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $bc5f567978faddca$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $bc5f567978faddca$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $bc5f567978faddca$var$Kb(w, x), null != F && t.push($bc5f567978faddca$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $bc5f567978faddca$var$wb && (n = c.relatedTarget || c.fromElement) && ($bc5f567978faddca$var$Wc(n) || n[$bc5f567978faddca$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $bc5f567978faddca$var$Wc(n) : null, null !== n && (J = $bc5f567978faddca$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $bc5f567978faddca$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $bc5f567978faddca$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $bc5f567978faddca$var$ue(k);
                        u = null == n ? h : $bc5f567978faddca$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $bc5f567978faddca$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $bc5f567978faddca$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $bc5f567978faddca$var$vf(F))u++;
                            for(; 0 < w - u;)t = $bc5f567978faddca$var$vf(t), w--;
                            for(; 0 < u - w;)x = $bc5f567978faddca$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $bc5f567978faddca$var$vf(t);
                                x = $bc5f567978faddca$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $bc5f567978faddca$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $bc5f567978faddca$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $bc5f567978faddca$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $bc5f567978faddca$var$ve;
                else if ($bc5f567978faddca$var$me(h)) {
                    if ($bc5f567978faddca$var$we) na = $bc5f567978faddca$var$Fe;
                    else {
                        na = $bc5f567978faddca$var$De;
                        var xa = $bc5f567978faddca$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $bc5f567978faddca$var$Ee);
                if (na && (na = na(a, d))) {
                    $bc5f567978faddca$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $bc5f567978faddca$var$cb(h, "number", h.value);
            }
            xa = d ? $bc5f567978faddca$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($bc5f567978faddca$var$me(xa) || "true" === xa.contentEditable) $bc5f567978faddca$var$Qe = xa, $bc5f567978faddca$var$Re = d, $bc5f567978faddca$var$Se = null;
                    break;
                case "focusout":
                    $bc5f567978faddca$var$Se = $bc5f567978faddca$var$Re = $bc5f567978faddca$var$Qe = null;
                    break;
                case "mousedown":
                    $bc5f567978faddca$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bc5f567978faddca$var$Te = !1;
                    $bc5f567978faddca$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($bc5f567978faddca$var$Pe) break;
                case "keydown":
                case "keyup":
                    $bc5f567978faddca$var$Ue(g, c, e);
            }
            var $a;
            if ($bc5f567978faddca$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $bc5f567978faddca$var$ie ? $bc5f567978faddca$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($bc5f567978faddca$var$de && "ko" !== c.locale && ($bc5f567978faddca$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $bc5f567978faddca$var$ie && ($a = $bc5f567978faddca$var$nd()) : ($bc5f567978faddca$var$kd = e, $bc5f567978faddca$var$ld = "value" in $bc5f567978faddca$var$kd ? $bc5f567978faddca$var$kd.value : $bc5f567978faddca$var$kd.textContent, $bc5f567978faddca$var$ie = !0)), xa = $bc5f567978faddca$var$oe(d, ba), 0 < xa.length && (ba = new $bc5f567978faddca$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $bc5f567978faddca$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $bc5f567978faddca$var$ce ? $bc5f567978faddca$var$je(a, c) : $bc5f567978faddca$var$ke(a, c)) d = $bc5f567978faddca$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $bc5f567978faddca$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $bc5f567978faddca$var$se(g, b);
    });
}
function $bc5f567978faddca$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $bc5f567978faddca$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $bc5f567978faddca$var$Kb(a, c), null != f && d.unshift($bc5f567978faddca$var$tf(a, f, e)), f = $bc5f567978faddca$var$Kb(a, b), null != f && d.push($bc5f567978faddca$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $bc5f567978faddca$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $bc5f567978faddca$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $bc5f567978faddca$var$Kb(c, f), null != k && g.unshift($bc5f567978faddca$var$tf(c, k, h))) : e || (k = $bc5f567978faddca$var$Kb(c, f), null != k && g.push($bc5f567978faddca$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $bc5f567978faddca$var$xf = /\r\n?/g, $bc5f567978faddca$var$yf = /\u0000|\uFFFD/g;
function $bc5f567978faddca$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($bc5f567978faddca$var$xf, "\n").replace($bc5f567978faddca$var$yf, "");
}
function $bc5f567978faddca$var$Af(a, b, c) {
    b = $bc5f567978faddca$var$zf(b);
    if ($bc5f567978faddca$var$zf(a) !== b && c) throw Error($bc5f567978faddca$var$p(425));
}
function $bc5f567978faddca$var$Bf() {}
var $bc5f567978faddca$var$Cf = null, $bc5f567978faddca$var$Df = null;
function $bc5f567978faddca$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $bc5f567978faddca$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $bc5f567978faddca$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $bc5f567978faddca$var$Hf = "function" === typeof Promise ? Promise : void 0, $bc5f567978faddca$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bc5f567978faddca$var$Hf ? function(a) {
    return $bc5f567978faddca$var$Hf.resolve(null).then(a).catch($bc5f567978faddca$var$If);
} : $bc5f567978faddca$var$Ff;
function $bc5f567978faddca$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $bc5f567978faddca$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $bc5f567978faddca$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $bc5f567978faddca$var$bd(b);
}
function $bc5f567978faddca$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $bc5f567978faddca$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $bc5f567978faddca$var$Nf = Math.random().toString(36).slice(2), $bc5f567978faddca$var$Of = "__reactFiber$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$Pf = "__reactProps$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$uf = "__reactContainer$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$of = "__reactEvents$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$Qf = "__reactListeners$" + $bc5f567978faddca$var$Nf, $bc5f567978faddca$var$Rf = "__reactHandles$" + $bc5f567978faddca$var$Nf;
function $bc5f567978faddca$var$Wc(a) {
    var b = a[$bc5f567978faddca$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$bc5f567978faddca$var$uf] || c[$bc5f567978faddca$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $bc5f567978faddca$var$Mf(a); null !== a;){
                if (c = a[$bc5f567978faddca$var$Of]) return c;
                a = $bc5f567978faddca$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $bc5f567978faddca$var$Cb(a) {
    a = a[$bc5f567978faddca$var$Of] || a[$bc5f567978faddca$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $bc5f567978faddca$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($bc5f567978faddca$var$p(33));
}
function $bc5f567978faddca$var$Db(a) {
    return a[$bc5f567978faddca$var$Pf] || null;
}
var $bc5f567978faddca$var$Sf = [], $bc5f567978faddca$var$Tf = -1;
function $bc5f567978faddca$var$Uf(a) {
    return {
        current: a
    };
}
function $bc5f567978faddca$var$E(a) {
    0 > $bc5f567978faddca$var$Tf || (a.current = $bc5f567978faddca$var$Sf[$bc5f567978faddca$var$Tf], $bc5f567978faddca$var$Sf[$bc5f567978faddca$var$Tf] = null, $bc5f567978faddca$var$Tf--);
}
function $bc5f567978faddca$var$G(a, b) {
    $bc5f567978faddca$var$Tf++;
    $bc5f567978faddca$var$Sf[$bc5f567978faddca$var$Tf] = a.current;
    a.current = b;
}
var $bc5f567978faddca$var$Vf = {}, $bc5f567978faddca$var$H = $bc5f567978faddca$var$Uf($bc5f567978faddca$var$Vf), $bc5f567978faddca$var$Wf = $bc5f567978faddca$var$Uf(!1), $bc5f567978faddca$var$Xf = $bc5f567978faddca$var$Vf;
function $bc5f567978faddca$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $bc5f567978faddca$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $bc5f567978faddca$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $bc5f567978faddca$var$$f() {
    $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf);
    $bc5f567978faddca$var$E($bc5f567978faddca$var$H);
}
function $bc5f567978faddca$var$ag(a, b, c) {
    if ($bc5f567978faddca$var$H.current !== $bc5f567978faddca$var$Vf) throw Error($bc5f567978faddca$var$p(168));
    $bc5f567978faddca$var$G($bc5f567978faddca$var$H, b);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Wf, c);
}
function $bc5f567978faddca$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($bc5f567978faddca$var$p(108, $bc5f567978faddca$var$Ra(a) || "Unknown", e));
    return $bc5f567978faddca$var$A({}, c, d);
}
function $bc5f567978faddca$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $bc5f567978faddca$var$Vf;
    $bc5f567978faddca$var$Xf = $bc5f567978faddca$var$H.current;
    $bc5f567978faddca$var$G($bc5f567978faddca$var$H, a);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Wf, $bc5f567978faddca$var$Wf.current);
    return !0;
}
function $bc5f567978faddca$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($bc5f567978faddca$var$p(169));
    c ? (a = $bc5f567978faddca$var$bg(a, b, $bc5f567978faddca$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf), $bc5f567978faddca$var$E($bc5f567978faddca$var$H), $bc5f567978faddca$var$G($bc5f567978faddca$var$H, a)) : $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$Wf, c);
}
var $bc5f567978faddca$var$eg = null, $bc5f567978faddca$var$fg = !1, $bc5f567978faddca$var$gg = !1;
function $bc5f567978faddca$var$hg(a) {
    null === $bc5f567978faddca$var$eg ? $bc5f567978faddca$var$eg = [
        a
    ] : $bc5f567978faddca$var$eg.push(a);
}
function $bc5f567978faddca$var$ig(a) {
    $bc5f567978faddca$var$fg = !0;
    $bc5f567978faddca$var$hg(a);
}
function $bc5f567978faddca$var$jg() {
    if (!$bc5f567978faddca$var$gg && null !== $bc5f567978faddca$var$eg) {
        $bc5f567978faddca$var$gg = !0;
        var a = 0, b = $bc5f567978faddca$var$C;
        try {
            var c = $bc5f567978faddca$var$eg;
            for($bc5f567978faddca$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $bc5f567978faddca$var$eg = null;
            $bc5f567978faddca$var$fg = !1;
        } catch (e) {
            throw null !== $bc5f567978faddca$var$eg && ($bc5f567978faddca$var$eg = $bc5f567978faddca$var$eg.slice(a + 1)), $bc5f567978faddca$var$ac($bc5f567978faddca$var$fc, $bc5f567978faddca$var$jg), e;
        } finally{
            $bc5f567978faddca$var$C = b, $bc5f567978faddca$var$gg = !1;
        }
    }
    return null;
}
var $bc5f567978faddca$var$kg = [], $bc5f567978faddca$var$lg = 0, $bc5f567978faddca$var$mg = null, $bc5f567978faddca$var$ng = 0, $bc5f567978faddca$var$og = [], $bc5f567978faddca$var$pg = 0, $bc5f567978faddca$var$qg = null, $bc5f567978faddca$var$rg = 1, $bc5f567978faddca$var$sg = "";
function $bc5f567978faddca$var$tg(a, b) {
    $bc5f567978faddca$var$kg[$bc5f567978faddca$var$lg++] = $bc5f567978faddca$var$ng;
    $bc5f567978faddca$var$kg[$bc5f567978faddca$var$lg++] = $bc5f567978faddca$var$mg;
    $bc5f567978faddca$var$mg = a;
    $bc5f567978faddca$var$ng = b;
}
function $bc5f567978faddca$var$ug(a, b, c) {
    $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$rg;
    $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$sg;
    $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$qg;
    $bc5f567978faddca$var$qg = a;
    var d = $bc5f567978faddca$var$rg;
    a = $bc5f567978faddca$var$sg;
    var e = 32 - $bc5f567978faddca$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $bc5f567978faddca$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $bc5f567978faddca$var$rg = 1 << 32 - $bc5f567978faddca$var$oc(b) + e | c << e | d;
        $bc5f567978faddca$var$sg = f + a;
    } else $bc5f567978faddca$var$rg = 1 << f | c << e | d, $bc5f567978faddca$var$sg = a;
}
function $bc5f567978faddca$var$vg(a) {
    null !== a.return && ($bc5f567978faddca$var$tg(a, 1), $bc5f567978faddca$var$ug(a, 1, 0));
}
function $bc5f567978faddca$var$wg(a) {
    for(; a === $bc5f567978faddca$var$mg;)$bc5f567978faddca$var$mg = $bc5f567978faddca$var$kg[--$bc5f567978faddca$var$lg], $bc5f567978faddca$var$kg[$bc5f567978faddca$var$lg] = null, $bc5f567978faddca$var$ng = $bc5f567978faddca$var$kg[--$bc5f567978faddca$var$lg], $bc5f567978faddca$var$kg[$bc5f567978faddca$var$lg] = null;
    for(; a === $bc5f567978faddca$var$qg;)$bc5f567978faddca$var$qg = $bc5f567978faddca$var$og[--$bc5f567978faddca$var$pg], $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg] = null, $bc5f567978faddca$var$sg = $bc5f567978faddca$var$og[--$bc5f567978faddca$var$pg], $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg] = null, $bc5f567978faddca$var$rg = $bc5f567978faddca$var$og[--$bc5f567978faddca$var$pg], $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg] = null;
}
var $bc5f567978faddca$var$xg = null, $bc5f567978faddca$var$yg = null, $bc5f567978faddca$var$I = !1, $bc5f567978faddca$var$zg = null;
function $bc5f567978faddca$var$Ag(a, b) {
    var c = $bc5f567978faddca$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $bc5f567978faddca$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $bc5f567978faddca$var$xg = a, $bc5f567978faddca$var$yg = $bc5f567978faddca$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $bc5f567978faddca$var$xg = a, $bc5f567978faddca$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $bc5f567978faddca$var$qg ? {
                id: $bc5f567978faddca$var$rg,
                overflow: $bc5f567978faddca$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $bc5f567978faddca$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $bc5f567978faddca$var$xg = a, $bc5f567978faddca$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $bc5f567978faddca$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $bc5f567978faddca$var$Eg(a) {
    if ($bc5f567978faddca$var$I) {
        var b = $bc5f567978faddca$var$yg;
        if (b) {
            var c = b;
            if (!$bc5f567978faddca$var$Cg(a, b)) {
                if ($bc5f567978faddca$var$Dg(a)) throw Error($bc5f567978faddca$var$p(418));
                b = $bc5f567978faddca$var$Lf(c.nextSibling);
                var d = $bc5f567978faddca$var$xg;
                b && $bc5f567978faddca$var$Cg(a, b) ? $bc5f567978faddca$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $bc5f567978faddca$var$I = !1, $bc5f567978faddca$var$xg = a);
            }
        } else {
            if ($bc5f567978faddca$var$Dg(a)) throw Error($bc5f567978faddca$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $bc5f567978faddca$var$I = !1;
            $bc5f567978faddca$var$xg = a;
        }
    }
}
function $bc5f567978faddca$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $bc5f567978faddca$var$xg = a;
}
function $bc5f567978faddca$var$Gg(a) {
    if (a !== $bc5f567978faddca$var$xg) return !1;
    if (!$bc5f567978faddca$var$I) return $bc5f567978faddca$var$Fg(a), $bc5f567978faddca$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$bc5f567978faddca$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $bc5f567978faddca$var$yg)) {
        if ($bc5f567978faddca$var$Dg(a)) throw $bc5f567978faddca$var$Hg(), Error($bc5f567978faddca$var$p(418));
        for(; b;)$bc5f567978faddca$var$Ag(a, b), b = $bc5f567978faddca$var$Lf(b.nextSibling);
    }
    $bc5f567978faddca$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($bc5f567978faddca$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $bc5f567978faddca$var$yg = $bc5f567978faddca$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $bc5f567978faddca$var$yg = null;
        }
    } else $bc5f567978faddca$var$yg = $bc5f567978faddca$var$xg ? $bc5f567978faddca$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $bc5f567978faddca$var$Hg() {
    for(var a = $bc5f567978faddca$var$yg; a;)a = $bc5f567978faddca$var$Lf(a.nextSibling);
}
function $bc5f567978faddca$var$Ig() {
    $bc5f567978faddca$var$yg = $bc5f567978faddca$var$xg = null;
    $bc5f567978faddca$var$I = !1;
}
function $bc5f567978faddca$var$Jg(a) {
    null === $bc5f567978faddca$var$zg ? $bc5f567978faddca$var$zg = [
        a
    ] : $bc5f567978faddca$var$zg.push(a);
}
var $bc5f567978faddca$var$Kg = $bc5f567978faddca$var$ua.ReactCurrentBatchConfig;
function $bc5f567978faddca$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($bc5f567978faddca$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($bc5f567978faddca$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($bc5f567978faddca$var$p(284));
        if (!c._owner) throw Error($bc5f567978faddca$var$p(290, a));
    }
    return a;
}
function $bc5f567978faddca$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($bc5f567978faddca$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $bc5f567978faddca$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $bc5f567978faddca$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $bc5f567978faddca$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $bc5f567978faddca$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $bc5f567978faddca$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $bc5f567978faddca$var$Ha && $bc5f567978faddca$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $bc5f567978faddca$var$Lg(a, b, c), d.return = a, d;
        d = $bc5f567978faddca$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $bc5f567978faddca$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $bc5f567978faddca$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $bc5f567978faddca$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $bc5f567978faddca$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $bc5f567978faddca$var$va:
                    return c = $bc5f567978faddca$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $bc5f567978faddca$var$Lg(a, null, b), c.return = a, c;
                case $bc5f567978faddca$var$wa:
                    return b = $bc5f567978faddca$var$Sg(b, a.mode, c), b.return = a, b;
                case $bc5f567978faddca$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($bc5f567978faddca$var$eb(b) || $bc5f567978faddca$var$Ka(b)) return b = $bc5f567978faddca$var$Tg(b, a.mode, c, null), b.return = a, b;
            $bc5f567978faddca$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $bc5f567978faddca$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $bc5f567978faddca$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $bc5f567978faddca$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($bc5f567978faddca$var$eb(c) || $bc5f567978faddca$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $bc5f567978faddca$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $bc5f567978faddca$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $bc5f567978faddca$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $bc5f567978faddca$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($bc5f567978faddca$var$eb(d) || $bc5f567978faddca$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $bc5f567978faddca$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $bc5f567978faddca$var$Ka(h);
        if ("function" !== typeof l) throw Error($bc5f567978faddca$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($bc5f567978faddca$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $bc5f567978faddca$var$I && $bc5f567978faddca$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $bc5f567978faddca$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $bc5f567978faddca$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $bc5f567978faddca$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $bc5f567978faddca$var$Ha && $bc5f567978faddca$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $bc5f567978faddca$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $bc5f567978faddca$var$ya ? (d = $bc5f567978faddca$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $bc5f567978faddca$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $bc5f567978faddca$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $bc5f567978faddca$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $bc5f567978faddca$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $bc5f567978faddca$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($bc5f567978faddca$var$eb(f)) return n(a, d, f, h);
            if ($bc5f567978faddca$var$Ka(f)) return t(a, d, f, h);
            $bc5f567978faddca$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $bc5f567978faddca$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $bc5f567978faddca$var$Ug = $bc5f567978faddca$var$Og(!0), $bc5f567978faddca$var$Vg = $bc5f567978faddca$var$Og(!1), $bc5f567978faddca$var$Wg = $bc5f567978faddca$var$Uf(null), $bc5f567978faddca$var$Xg = null, $bc5f567978faddca$var$Yg = null, $bc5f567978faddca$var$Zg = null;
function $bc5f567978faddca$var$$g() {
    $bc5f567978faddca$var$Zg = $bc5f567978faddca$var$Yg = $bc5f567978faddca$var$Xg = null;
}
function $bc5f567978faddca$var$ah(a) {
    var b = $bc5f567978faddca$var$Wg.current;
    $bc5f567978faddca$var$E($bc5f567978faddca$var$Wg);
    a._currentValue = b;
}
function $bc5f567978faddca$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $bc5f567978faddca$var$ch(a, b) {
    $bc5f567978faddca$var$Xg = a;
    $bc5f567978faddca$var$Zg = $bc5f567978faddca$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($bc5f567978faddca$var$dh = !0), a.firstContext = null);
}
function $bc5f567978faddca$var$eh(a) {
    var b = a._currentValue;
    if ($bc5f567978faddca$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $bc5f567978faddca$var$Yg) {
            if (null === $bc5f567978faddca$var$Xg) throw Error($bc5f567978faddca$var$p(308));
            $bc5f567978faddca$var$Yg = a;
            $bc5f567978faddca$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $bc5f567978faddca$var$Yg = $bc5f567978faddca$var$Yg.next = a;
    }
    return b;
}
var $bc5f567978faddca$var$fh = null;
function $bc5f567978faddca$var$gh(a) {
    null === $bc5f567978faddca$var$fh ? $bc5f567978faddca$var$fh = [
        a
    ] : $bc5f567978faddca$var$fh.push(a);
}
function $bc5f567978faddca$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $bc5f567978faddca$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $bc5f567978faddca$var$ih(a, d);
}
function $bc5f567978faddca$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $bc5f567978faddca$var$jh = !1;
function $bc5f567978faddca$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $bc5f567978faddca$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $bc5f567978faddca$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bc5f567978faddca$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($bc5f567978faddca$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $bc5f567978faddca$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $bc5f567978faddca$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $bc5f567978faddca$var$ih(a, c);
}
function $bc5f567978faddca$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bc5f567978faddca$var$Cc(a, c);
    }
}
function $bc5f567978faddca$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $bc5f567978faddca$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $bc5f567978faddca$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $bc5f567978faddca$var$A({}, q, r);
                            break a;
                        case 2:
                            $bc5f567978faddca$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $bc5f567978faddca$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $bc5f567978faddca$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($bc5f567978faddca$var$p(191, e));
            e.call(d);
        }
    }
}
var $bc5f567978faddca$var$th = {}, $bc5f567978faddca$var$uh = $bc5f567978faddca$var$Uf($bc5f567978faddca$var$th), $bc5f567978faddca$var$vh = $bc5f567978faddca$var$Uf($bc5f567978faddca$var$th), $bc5f567978faddca$var$wh = $bc5f567978faddca$var$Uf($bc5f567978faddca$var$th);
function $bc5f567978faddca$var$xh(a) {
    if (a === $bc5f567978faddca$var$th) throw Error($bc5f567978faddca$var$p(174));
    return a;
}
function $bc5f567978faddca$var$yh(a, b) {
    $bc5f567978faddca$var$G($bc5f567978faddca$var$wh, b);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$vh, a);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$uh, $bc5f567978faddca$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $bc5f567978faddca$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $bc5f567978faddca$var$lb(b, a);
    }
    $bc5f567978faddca$var$E($bc5f567978faddca$var$uh);
    $bc5f567978faddca$var$G($bc5f567978faddca$var$uh, b);
}
function $bc5f567978faddca$var$zh() {
    $bc5f567978faddca$var$E($bc5f567978faddca$var$uh);
    $bc5f567978faddca$var$E($bc5f567978faddca$var$vh);
    $bc5f567978faddca$var$E($bc5f567978faddca$var$wh);
}
function $bc5f567978faddca$var$Ah(a) {
    $bc5f567978faddca$var$xh($bc5f567978faddca$var$wh.current);
    var b = $bc5f567978faddca$var$xh($bc5f567978faddca$var$uh.current);
    var c = $bc5f567978faddca$var$lb(b, a.type);
    b !== c && ($bc5f567978faddca$var$G($bc5f567978faddca$var$vh, a), $bc5f567978faddca$var$G($bc5f567978faddca$var$uh, c));
}
function $bc5f567978faddca$var$Bh(a) {
    $bc5f567978faddca$var$vh.current === a && ($bc5f567978faddca$var$E($bc5f567978faddca$var$uh), $bc5f567978faddca$var$E($bc5f567978faddca$var$vh));
}
var $bc5f567978faddca$var$L = $bc5f567978faddca$var$Uf(0);
function $bc5f567978faddca$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $bc5f567978faddca$var$Dh = [];
function $bc5f567978faddca$var$Eh() {
    for(var a = 0; a < $bc5f567978faddca$var$Dh.length; a++)$bc5f567978faddca$var$Dh[a]._workInProgressVersionPrimary = null;
    $bc5f567978faddca$var$Dh.length = 0;
}
var $bc5f567978faddca$var$Fh = $bc5f567978faddca$var$ua.ReactCurrentDispatcher, $bc5f567978faddca$var$Gh = $bc5f567978faddca$var$ua.ReactCurrentBatchConfig, $bc5f567978faddca$var$Hh = 0, $bc5f567978faddca$var$M = null, $bc5f567978faddca$var$N = null, $bc5f567978faddca$var$O = null, $bc5f567978faddca$var$Ih = !1, $bc5f567978faddca$var$Jh = !1, $bc5f567978faddca$var$Kh = 0, $bc5f567978faddca$var$Lh = 0;
function $bc5f567978faddca$var$P() {
    throw Error($bc5f567978faddca$var$p(321));
}
function $bc5f567978faddca$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$bc5f567978faddca$var$He(a[c], b[c])) return !1;
    return !0;
}
function $bc5f567978faddca$var$Nh(a, b, c, d, e, f) {
    $bc5f567978faddca$var$Hh = f;
    $bc5f567978faddca$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $bc5f567978faddca$var$Fh.current = null === a || null === a.memoizedState ? $bc5f567978faddca$var$Oh : $bc5f567978faddca$var$Ph;
    a = c(d, e);
    if ($bc5f567978faddca$var$Jh) {
        f = 0;
        do {
            $bc5f567978faddca$var$Jh = !1;
            $bc5f567978faddca$var$Kh = 0;
            if (25 <= f) throw Error($bc5f567978faddca$var$p(301));
            f += 1;
            $bc5f567978faddca$var$O = $bc5f567978faddca$var$N = null;
            b.updateQueue = null;
            $bc5f567978faddca$var$Fh.current = $bc5f567978faddca$var$Qh;
            a = c(d, e);
        }while ($bc5f567978faddca$var$Jh);
    }
    $bc5f567978faddca$var$Fh.current = $bc5f567978faddca$var$Rh;
    b = null !== $bc5f567978faddca$var$N && null !== $bc5f567978faddca$var$N.next;
    $bc5f567978faddca$var$Hh = 0;
    $bc5f567978faddca$var$O = $bc5f567978faddca$var$N = $bc5f567978faddca$var$M = null;
    $bc5f567978faddca$var$Ih = !1;
    if (b) throw Error($bc5f567978faddca$var$p(300));
    return a;
}
function $bc5f567978faddca$var$Sh() {
    var a = 0 !== $bc5f567978faddca$var$Kh;
    $bc5f567978faddca$var$Kh = 0;
    return a;
}
function $bc5f567978faddca$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bc5f567978faddca$var$O ? $bc5f567978faddca$var$M.memoizedState = $bc5f567978faddca$var$O = a : $bc5f567978faddca$var$O = $bc5f567978faddca$var$O.next = a;
    return $bc5f567978faddca$var$O;
}
function $bc5f567978faddca$var$Uh() {
    if (null === $bc5f567978faddca$var$N) {
        var a = $bc5f567978faddca$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $bc5f567978faddca$var$N.next;
    var b = null === $bc5f567978faddca$var$O ? $bc5f567978faddca$var$M.memoizedState : $bc5f567978faddca$var$O.next;
    if (null !== b) $bc5f567978faddca$var$O = b, $bc5f567978faddca$var$N = a;
    else {
        if (null === a) throw Error($bc5f567978faddca$var$p(310));
        $bc5f567978faddca$var$N = a;
        a = {
            memoizedState: $bc5f567978faddca$var$N.memoizedState,
            baseState: $bc5f567978faddca$var$N.baseState,
            baseQueue: $bc5f567978faddca$var$N.baseQueue,
            queue: $bc5f567978faddca$var$N.queue,
            next: null
        };
        null === $bc5f567978faddca$var$O ? $bc5f567978faddca$var$M.memoizedState = $bc5f567978faddca$var$O = a : $bc5f567978faddca$var$O = $bc5f567978faddca$var$O.next = a;
    }
    return $bc5f567978faddca$var$O;
}
function $bc5f567978faddca$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $bc5f567978faddca$var$Wh(a) {
    var b = $bc5f567978faddca$var$Uh(), c = b.queue;
    if (null === c) throw Error($bc5f567978faddca$var$p(311));
    c.lastRenderedReducer = a;
    var d = $bc5f567978faddca$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($bc5f567978faddca$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $bc5f567978faddca$var$M.lanes |= m;
                $bc5f567978faddca$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $bc5f567978faddca$var$He(d, b.memoizedState) || ($bc5f567978faddca$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $bc5f567978faddca$var$M.lanes |= f, $bc5f567978faddca$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $bc5f567978faddca$var$Xh(a) {
    var b = $bc5f567978faddca$var$Uh(), c = b.queue;
    if (null === c) throw Error($bc5f567978faddca$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $bc5f567978faddca$var$He(f, b.memoizedState) || ($bc5f567978faddca$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $bc5f567978faddca$var$Yh() {}
function $bc5f567978faddca$var$Zh(a, b) {
    var c = $bc5f567978faddca$var$M, d = $bc5f567978faddca$var$Uh(), e = b(), f = !$bc5f567978faddca$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $bc5f567978faddca$var$dh = !0);
    d = d.queue;
    $bc5f567978faddca$var$$h($bc5f567978faddca$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $bc5f567978faddca$var$O && $bc5f567978faddca$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $bc5f567978faddca$var$bi(9, $bc5f567978faddca$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $bc5f567978faddca$var$Q) throw Error($bc5f567978faddca$var$p(349));
        0 !== ($bc5f567978faddca$var$Hh & 30) || $bc5f567978faddca$var$di(c, b, e);
    }
    return e;
}
function $bc5f567978faddca$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $bc5f567978faddca$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bc5f567978faddca$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $bc5f567978faddca$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $bc5f567978faddca$var$ei(b) && $bc5f567978faddca$var$fi(a);
}
function $bc5f567978faddca$var$ai(a, b, c) {
    return c(function() {
        $bc5f567978faddca$var$ei(b) && $bc5f567978faddca$var$fi(a);
    });
}
function $bc5f567978faddca$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$bc5f567978faddca$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $bc5f567978faddca$var$fi(a) {
    var b = $bc5f567978faddca$var$ih(a, 1);
    null !== b && $bc5f567978faddca$var$gi(b, a, 1, -1);
}
function $bc5f567978faddca$var$hi(a) {
    var b = $bc5f567978faddca$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bc5f567978faddca$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $bc5f567978faddca$var$ii.bind(null, $bc5f567978faddca$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $bc5f567978faddca$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $bc5f567978faddca$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $bc5f567978faddca$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $bc5f567978faddca$var$ji() {
    return $bc5f567978faddca$var$Uh().memoizedState;
}
function $bc5f567978faddca$var$ki(a, b, c, d) {
    var e = $bc5f567978faddca$var$Th();
    $bc5f567978faddca$var$M.flags |= a;
    e.memoizedState = $bc5f567978faddca$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $bc5f567978faddca$var$li(a, b, c, d) {
    var e = $bc5f567978faddca$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $bc5f567978faddca$var$N) {
        var g = $bc5f567978faddca$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $bc5f567978faddca$var$Mh(d, g.deps)) {
            e.memoizedState = $bc5f567978faddca$var$bi(b, c, f, d);
            return;
        }
    }
    $bc5f567978faddca$var$M.flags |= a;
    e.memoizedState = $bc5f567978faddca$var$bi(1 | b, c, f, d);
}
function $bc5f567978faddca$var$mi(a, b) {
    return $bc5f567978faddca$var$ki(8390656, 8, a, b);
}
function $bc5f567978faddca$var$$h(a, b) {
    return $bc5f567978faddca$var$li(2048, 8, a, b);
}
function $bc5f567978faddca$var$ni(a, b) {
    return $bc5f567978faddca$var$li(4, 2, a, b);
}
function $bc5f567978faddca$var$oi(a, b) {
    return $bc5f567978faddca$var$li(4, 4, a, b);
}
function $bc5f567978faddca$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $bc5f567978faddca$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $bc5f567978faddca$var$li(4, 4, $bc5f567978faddca$var$pi.bind(null, b, a), c);
}
function $bc5f567978faddca$var$ri() {}
function $bc5f567978faddca$var$si(a, b) {
    var c = $bc5f567978faddca$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bc5f567978faddca$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bc5f567978faddca$var$ti(a, b) {
    var c = $bc5f567978faddca$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $bc5f567978faddca$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $bc5f567978faddca$var$ui(a, b, c) {
    if (0 === ($bc5f567978faddca$var$Hh & 21)) return a.baseState && (a.baseState = !1, $bc5f567978faddca$var$dh = !0), a.memoizedState = c;
    $bc5f567978faddca$var$He(c, b) || (c = $bc5f567978faddca$var$yc(), $bc5f567978faddca$var$M.lanes |= c, $bc5f567978faddca$var$rh |= c, a.baseState = !0);
    return b;
}
function $bc5f567978faddca$var$vi(a, b) {
    var c = $bc5f567978faddca$var$C;
    $bc5f567978faddca$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $bc5f567978faddca$var$Gh.transition;
    $bc5f567978faddca$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $bc5f567978faddca$var$C = c, $bc5f567978faddca$var$Gh.transition = d;
    }
}
function $bc5f567978faddca$var$wi() {
    return $bc5f567978faddca$var$Uh().memoizedState;
}
function $bc5f567978faddca$var$xi(a, b, c) {
    var d = $bc5f567978faddca$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bc5f567978faddca$var$zi(a)) $bc5f567978faddca$var$Ai(b, c);
    else if (c = $bc5f567978faddca$var$hh(a, b, c, d), null !== c) {
        var e = $bc5f567978faddca$var$R();
        $bc5f567978faddca$var$gi(c, a, d, e);
        $bc5f567978faddca$var$Bi(c, b, d);
    }
}
function $bc5f567978faddca$var$ii(a, b, c) {
    var d = $bc5f567978faddca$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bc5f567978faddca$var$zi(a)) $bc5f567978faddca$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($bc5f567978faddca$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $bc5f567978faddca$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $bc5f567978faddca$var$hh(a, b, e, d);
        null !== c && (e = $bc5f567978faddca$var$R(), $bc5f567978faddca$var$gi(c, a, d, e), $bc5f567978faddca$var$Bi(c, b, d));
    }
}
function $bc5f567978faddca$var$zi(a) {
    var b = a.alternate;
    return a === $bc5f567978faddca$var$M || null !== b && b === $bc5f567978faddca$var$M;
}
function $bc5f567978faddca$var$Ai(a, b) {
    $bc5f567978faddca$var$Jh = $bc5f567978faddca$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $bc5f567978faddca$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $bc5f567978faddca$var$Cc(a, c);
    }
}
var $bc5f567978faddca$var$Rh = {
    readContext: $bc5f567978faddca$var$eh,
    useCallback: $bc5f567978faddca$var$P,
    useContext: $bc5f567978faddca$var$P,
    useEffect: $bc5f567978faddca$var$P,
    useImperativeHandle: $bc5f567978faddca$var$P,
    useInsertionEffect: $bc5f567978faddca$var$P,
    useLayoutEffect: $bc5f567978faddca$var$P,
    useMemo: $bc5f567978faddca$var$P,
    useReducer: $bc5f567978faddca$var$P,
    useRef: $bc5f567978faddca$var$P,
    useState: $bc5f567978faddca$var$P,
    useDebugValue: $bc5f567978faddca$var$P,
    useDeferredValue: $bc5f567978faddca$var$P,
    useTransition: $bc5f567978faddca$var$P,
    useMutableSource: $bc5f567978faddca$var$P,
    useSyncExternalStore: $bc5f567978faddca$var$P,
    useId: $bc5f567978faddca$var$P,
    unstable_isNewReconciler: !1
}, $bc5f567978faddca$var$Oh = {
    readContext: $bc5f567978faddca$var$eh,
    useCallback: function(a, b) {
        $bc5f567978faddca$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $bc5f567978faddca$var$eh,
    useEffect: $bc5f567978faddca$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $bc5f567978faddca$var$ki(4194308, 4, $bc5f567978faddca$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $bc5f567978faddca$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $bc5f567978faddca$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $bc5f567978faddca$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $bc5f567978faddca$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $bc5f567978faddca$var$xi.bind(null, $bc5f567978faddca$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $bc5f567978faddca$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $bc5f567978faddca$var$hi,
    useDebugValue: $bc5f567978faddca$var$ri,
    useDeferredValue: function(a) {
        return $bc5f567978faddca$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $bc5f567978faddca$var$hi(!1), b = a[0];
        a = $bc5f567978faddca$var$vi.bind(null, a[1]);
        $bc5f567978faddca$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $bc5f567978faddca$var$M, e = $bc5f567978faddca$var$Th();
        if ($bc5f567978faddca$var$I) {
            if (void 0 === c) throw Error($bc5f567978faddca$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $bc5f567978faddca$var$Q) throw Error($bc5f567978faddca$var$p(349));
            0 !== ($bc5f567978faddca$var$Hh & 30) || $bc5f567978faddca$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $bc5f567978faddca$var$mi($bc5f567978faddca$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $bc5f567978faddca$var$bi(9, $bc5f567978faddca$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $bc5f567978faddca$var$Th(), b = $bc5f567978faddca$var$Q.identifierPrefix;
        if ($bc5f567978faddca$var$I) {
            var c = $bc5f567978faddca$var$sg;
            var d = $bc5f567978faddca$var$rg;
            c = (d & ~(1 << 32 - $bc5f567978faddca$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $bc5f567978faddca$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $bc5f567978faddca$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $bc5f567978faddca$var$Ph = {
    readContext: $bc5f567978faddca$var$eh,
    useCallback: $bc5f567978faddca$var$si,
    useContext: $bc5f567978faddca$var$eh,
    useEffect: $bc5f567978faddca$var$$h,
    useImperativeHandle: $bc5f567978faddca$var$qi,
    useInsertionEffect: $bc5f567978faddca$var$ni,
    useLayoutEffect: $bc5f567978faddca$var$oi,
    useMemo: $bc5f567978faddca$var$ti,
    useReducer: $bc5f567978faddca$var$Wh,
    useRef: $bc5f567978faddca$var$ji,
    useState: function() {
        return $bc5f567978faddca$var$Wh($bc5f567978faddca$var$Vh);
    },
    useDebugValue: $bc5f567978faddca$var$ri,
    useDeferredValue: function(a) {
        var b = $bc5f567978faddca$var$Uh();
        return $bc5f567978faddca$var$ui(b, $bc5f567978faddca$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $bc5f567978faddca$var$Wh($bc5f567978faddca$var$Vh)[0], b = $bc5f567978faddca$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bc5f567978faddca$var$Yh,
    useSyncExternalStore: $bc5f567978faddca$var$Zh,
    useId: $bc5f567978faddca$var$wi,
    unstable_isNewReconciler: !1
}, $bc5f567978faddca$var$Qh = {
    readContext: $bc5f567978faddca$var$eh,
    useCallback: $bc5f567978faddca$var$si,
    useContext: $bc5f567978faddca$var$eh,
    useEffect: $bc5f567978faddca$var$$h,
    useImperativeHandle: $bc5f567978faddca$var$qi,
    useInsertionEffect: $bc5f567978faddca$var$ni,
    useLayoutEffect: $bc5f567978faddca$var$oi,
    useMemo: $bc5f567978faddca$var$ti,
    useReducer: $bc5f567978faddca$var$Xh,
    useRef: $bc5f567978faddca$var$ji,
    useState: function() {
        return $bc5f567978faddca$var$Xh($bc5f567978faddca$var$Vh);
    },
    useDebugValue: $bc5f567978faddca$var$ri,
    useDeferredValue: function(a) {
        var b = $bc5f567978faddca$var$Uh();
        return null === $bc5f567978faddca$var$N ? b.memoizedState = a : $bc5f567978faddca$var$ui(b, $bc5f567978faddca$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $bc5f567978faddca$var$Xh($bc5f567978faddca$var$Vh)[0], b = $bc5f567978faddca$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $bc5f567978faddca$var$Yh,
    useSyncExternalStore: $bc5f567978faddca$var$Zh,
    useId: $bc5f567978faddca$var$wi,
    unstable_isNewReconciler: !1
};
function $bc5f567978faddca$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $bc5f567978faddca$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $bc5f567978faddca$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $bc5f567978faddca$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $bc5f567978faddca$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $bc5f567978faddca$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $bc5f567978faddca$var$R(), e = $bc5f567978faddca$var$yi(a), f = $bc5f567978faddca$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bc5f567978faddca$var$nh(a, f, e);
        null !== b && ($bc5f567978faddca$var$gi(b, a, e, d), $bc5f567978faddca$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $bc5f567978faddca$var$R(), e = $bc5f567978faddca$var$yi(a), f = $bc5f567978faddca$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $bc5f567978faddca$var$nh(a, f, e);
        null !== b && ($bc5f567978faddca$var$gi(b, a, e, d), $bc5f567978faddca$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $bc5f567978faddca$var$R(), d = $bc5f567978faddca$var$yi(a), e = $bc5f567978faddca$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $bc5f567978faddca$var$nh(a, e, d);
        null !== b && ($bc5f567978faddca$var$gi(b, a, d, c), $bc5f567978faddca$var$oh(b, a, d));
    }
};
function $bc5f567978faddca$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$bc5f567978faddca$var$Ie(c, d) || !$bc5f567978faddca$var$Ie(e, f) : !0;
}
function $bc5f567978faddca$var$Gi(a, b, c) {
    var d = !1, e = $bc5f567978faddca$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $bc5f567978faddca$var$eh(f) : (e = $bc5f567978faddca$var$Zf(b) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $bc5f567978faddca$var$Yf(a, e) : $bc5f567978faddca$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $bc5f567978faddca$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $bc5f567978faddca$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $bc5f567978faddca$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $bc5f567978faddca$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $bc5f567978faddca$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $bc5f567978faddca$var$eh(f) : (f = $bc5f567978faddca$var$Zf(b) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current, e.context = $bc5f567978faddca$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($bc5f567978faddca$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $bc5f567978faddca$var$Ei.enqueueReplaceState(e, e.state, null), $bc5f567978faddca$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $bc5f567978faddca$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $bc5f567978faddca$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $bc5f567978faddca$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $bc5f567978faddca$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $bc5f567978faddca$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $bc5f567978faddca$var$Ni(a, b, c) {
    c = $bc5f567978faddca$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $bc5f567978faddca$var$Oi || ($bc5f567978faddca$var$Oi = !0, $bc5f567978faddca$var$Pi = d);
        $bc5f567978faddca$var$Li(a, b);
    };
    return c;
}
function $bc5f567978faddca$var$Qi(a, b, c) {
    c = $bc5f567978faddca$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $bc5f567978faddca$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $bc5f567978faddca$var$Li(a, b);
        "function" !== typeof d && (null === $bc5f567978faddca$var$Ri ? $bc5f567978faddca$var$Ri = new Set([
            this
        ]) : $bc5f567978faddca$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $bc5f567978faddca$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $bc5f567978faddca$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $bc5f567978faddca$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $bc5f567978faddca$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $bc5f567978faddca$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $bc5f567978faddca$var$mh(-1, 1), b.tag = 2, $bc5f567978faddca$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $bc5f567978faddca$var$Wi = $bc5f567978faddca$var$ua.ReactCurrentOwner, $bc5f567978faddca$var$dh = !1;
function $bc5f567978faddca$var$Xi(a, b, c, d) {
    b.child = null === a ? $bc5f567978faddca$var$Vg(b, null, c, d) : $bc5f567978faddca$var$Ug(b, a.child, c, d);
}
function $bc5f567978faddca$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $bc5f567978faddca$var$ch(b, e);
    d = $bc5f567978faddca$var$Nh(a, b, c, d, f, e);
    c = $bc5f567978faddca$var$Sh();
    if (null !== a && !$bc5f567978faddca$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bc5f567978faddca$var$Zi(a, b, e);
    $bc5f567978faddca$var$I && c && $bc5f567978faddca$var$vg(b);
    b.flags |= 1;
    $bc5f567978faddca$var$Xi(a, b, d, e);
    return b.child;
}
function $bc5f567978faddca$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$bc5f567978faddca$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $bc5f567978faddca$var$bj(a, b, f, d, e);
        a = $bc5f567978faddca$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $bc5f567978faddca$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $bc5f567978faddca$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $bc5f567978faddca$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $bc5f567978faddca$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($bc5f567978faddca$var$Ie(f, d) && a.ref === b.ref) {
            if ($bc5f567978faddca$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($bc5f567978faddca$var$dh = !0);
            else return b.lanes = a.lanes, $bc5f567978faddca$var$Zi(a, b, e);
        }
    }
    return $bc5f567978faddca$var$cj(a, b, c, d, e);
}
function $bc5f567978faddca$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $bc5f567978faddca$var$G($bc5f567978faddca$var$ej, $bc5f567978faddca$var$fj), $bc5f567978faddca$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $bc5f567978faddca$var$G($bc5f567978faddca$var$ej, $bc5f567978faddca$var$fj), $bc5f567978faddca$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $bc5f567978faddca$var$G($bc5f567978faddca$var$ej, $bc5f567978faddca$var$fj);
            $bc5f567978faddca$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $bc5f567978faddca$var$G($bc5f567978faddca$var$ej, $bc5f567978faddca$var$fj), $bc5f567978faddca$var$fj |= d;
    $bc5f567978faddca$var$Xi(a, b, e, c);
    return b.child;
}
function $bc5f567978faddca$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $bc5f567978faddca$var$cj(a, b, c, d, e) {
    var f = $bc5f567978faddca$var$Zf(c) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current;
    f = $bc5f567978faddca$var$Yf(b, f);
    $bc5f567978faddca$var$ch(b, e);
    c = $bc5f567978faddca$var$Nh(a, b, c, d, f, e);
    d = $bc5f567978faddca$var$Sh();
    if (null !== a && !$bc5f567978faddca$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $bc5f567978faddca$var$Zi(a, b, e);
    $bc5f567978faddca$var$I && d && $bc5f567978faddca$var$vg(b);
    b.flags |= 1;
    $bc5f567978faddca$var$Xi(a, b, c, e);
    return b.child;
}
function $bc5f567978faddca$var$hj(a, b, c, d, e) {
    if ($bc5f567978faddca$var$Zf(c)) {
        var f = !0;
        $bc5f567978faddca$var$cg(b);
    } else f = !1;
    $bc5f567978faddca$var$ch(b, e);
    if (null === b.stateNode) $bc5f567978faddca$var$ij(a, b), $bc5f567978faddca$var$Gi(b, c, d), $bc5f567978faddca$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $bc5f567978faddca$var$eh(l) : (l = $bc5f567978faddca$var$Zf(c) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current, l = $bc5f567978faddca$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $bc5f567978faddca$var$Hi(b, g, d, l);
        $bc5f567978faddca$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $bc5f567978faddca$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $bc5f567978faddca$var$Wf.current || $bc5f567978faddca$var$jh ? ("function" === typeof m && ($bc5f567978faddca$var$Di(b, c, m, d), k = b.memoizedState), (h = $bc5f567978faddca$var$jh || $bc5f567978faddca$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $bc5f567978faddca$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $bc5f567978faddca$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $bc5f567978faddca$var$eh(k) : (k = $bc5f567978faddca$var$Zf(c) ? $bc5f567978faddca$var$Xf : $bc5f567978faddca$var$H.current, k = $bc5f567978faddca$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $bc5f567978faddca$var$Hi(b, g, d, k);
        $bc5f567978faddca$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $bc5f567978faddca$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $bc5f567978faddca$var$Wf.current || $bc5f567978faddca$var$jh ? ("function" === typeof y && ($bc5f567978faddca$var$Di(b, c, y, d), n = b.memoizedState), (l = $bc5f567978faddca$var$jh || $bc5f567978faddca$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $bc5f567978faddca$var$jj(a, b, c, d, f, e);
}
function $bc5f567978faddca$var$jj(a, b, c, d, e, f) {
    $bc5f567978faddca$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $bc5f567978faddca$var$dg(b, c, !1), $bc5f567978faddca$var$Zi(a, b, f);
    d = b.stateNode;
    $bc5f567978faddca$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $bc5f567978faddca$var$Ug(b, a.child, null, f), b.child = $bc5f567978faddca$var$Ug(b, null, h, f)) : $bc5f567978faddca$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $bc5f567978faddca$var$dg(b, c, !0);
    return b.child;
}
function $bc5f567978faddca$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $bc5f567978faddca$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $bc5f567978faddca$var$ag(a, b.context, !1);
    $bc5f567978faddca$var$yh(a, b.containerInfo);
}
function $bc5f567978faddca$var$lj(a, b, c, d, e) {
    $bc5f567978faddca$var$Ig();
    $bc5f567978faddca$var$Jg(e);
    b.flags |= 256;
    $bc5f567978faddca$var$Xi(a, b, c, d);
    return b.child;
}
var $bc5f567978faddca$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bc5f567978faddca$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $bc5f567978faddca$var$oj(a, b, c) {
    var d = b.pendingProps, e = $bc5f567978faddca$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $bc5f567978faddca$var$G($bc5f567978faddca$var$L, e & 1);
    if (null === a) {
        $bc5f567978faddca$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $bc5f567978faddca$var$pj(g, d, 0, null), a = $bc5f567978faddca$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $bc5f567978faddca$var$nj(c), b.memoizedState = $bc5f567978faddca$var$mj, a) : $bc5f567978faddca$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $bc5f567978faddca$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $bc5f567978faddca$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $bc5f567978faddca$var$Pg(h, f) : (f = $bc5f567978faddca$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $bc5f567978faddca$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $bc5f567978faddca$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $bc5f567978faddca$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $bc5f567978faddca$var$qj(a, b) {
    b = $bc5f567978faddca$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $bc5f567978faddca$var$sj(a, b, c, d) {
    null !== d && $bc5f567978faddca$var$Jg(d);
    $bc5f567978faddca$var$Ug(b, a.child, null, c);
    a = $bc5f567978faddca$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $bc5f567978faddca$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $bc5f567978faddca$var$Ki(Error($bc5f567978faddca$var$p(422))), $bc5f567978faddca$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $bc5f567978faddca$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $bc5f567978faddca$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $bc5f567978faddca$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $bc5f567978faddca$var$nj(g);
        b.memoizedState = $bc5f567978faddca$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $bc5f567978faddca$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($bc5f567978faddca$var$p(419));
        d = $bc5f567978faddca$var$Ki(f, d, void 0);
        return $bc5f567978faddca$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($bc5f567978faddca$var$dh || h) {
        d = $bc5f567978faddca$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $bc5f567978faddca$var$ih(a, e), $bc5f567978faddca$var$gi(d, a, e, -1));
        }
        $bc5f567978faddca$var$tj();
        d = $bc5f567978faddca$var$Ki(Error($bc5f567978faddca$var$p(421)));
        return $bc5f567978faddca$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $bc5f567978faddca$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $bc5f567978faddca$var$yg = $bc5f567978faddca$var$Lf(e.nextSibling);
    $bc5f567978faddca$var$xg = b;
    $bc5f567978faddca$var$I = !0;
    $bc5f567978faddca$var$zg = null;
    null !== a && ($bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$rg, $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$sg, $bc5f567978faddca$var$og[$bc5f567978faddca$var$pg++] = $bc5f567978faddca$var$qg, $bc5f567978faddca$var$rg = a.id, $bc5f567978faddca$var$sg = a.overflow, $bc5f567978faddca$var$qg = b);
    b = $bc5f567978faddca$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $bc5f567978faddca$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $bc5f567978faddca$var$bh(a.return, b, c);
}
function $bc5f567978faddca$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $bc5f567978faddca$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $bc5f567978faddca$var$Xi(a, b, d.children, c);
    d = $bc5f567978faddca$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $bc5f567978faddca$var$vj(a, c, b);
            else if (19 === a.tag) $bc5f567978faddca$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $bc5f567978faddca$var$G($bc5f567978faddca$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $bc5f567978faddca$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $bc5f567978faddca$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $bc5f567978faddca$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $bc5f567978faddca$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $bc5f567978faddca$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $bc5f567978faddca$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $bc5f567978faddca$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $bc5f567978faddca$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($bc5f567978faddca$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $bc5f567978faddca$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $bc5f567978faddca$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $bc5f567978faddca$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $bc5f567978faddca$var$kj(b);
            $bc5f567978faddca$var$Ig();
            break;
        case 5:
            $bc5f567978faddca$var$Ah(b);
            break;
        case 1:
            $bc5f567978faddca$var$Zf(b.type) && $bc5f567978faddca$var$cg(b);
            break;
        case 4:
            $bc5f567978faddca$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $bc5f567978faddca$var$G($bc5f567978faddca$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $bc5f567978faddca$var$G($bc5f567978faddca$var$L, $bc5f567978faddca$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $bc5f567978faddca$var$oj(a, b, c);
                $bc5f567978faddca$var$G($bc5f567978faddca$var$L, $bc5f567978faddca$var$L.current & 1);
                a = $bc5f567978faddca$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $bc5f567978faddca$var$G($bc5f567978faddca$var$L, $bc5f567978faddca$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $bc5f567978faddca$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $bc5f567978faddca$var$G($bc5f567978faddca$var$L, $bc5f567978faddca$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $bc5f567978faddca$var$dj(a, b, c);
    }
    return $bc5f567978faddca$var$Zi(a, b, c);
}
var $bc5f567978faddca$var$zj, $bc5f567978faddca$var$Aj, $bc5f567978faddca$var$Bj, $bc5f567978faddca$var$Cj;
$bc5f567978faddca$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$bc5f567978faddca$var$Aj = function() {};
$bc5f567978faddca$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $bc5f567978faddca$var$xh($bc5f567978faddca$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $bc5f567978faddca$var$Ya(a, e);
                d = $bc5f567978faddca$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $bc5f567978faddca$var$A({}, e, {
                    value: void 0
                });
                d = $bc5f567978faddca$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $bc5f567978faddca$var$gb(a, e);
                d = $bc5f567978faddca$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $bc5f567978faddca$var$Bf);
        }
        $bc5f567978faddca$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($bc5f567978faddca$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($bc5f567978faddca$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $bc5f567978faddca$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$bc5f567978faddca$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $bc5f567978faddca$var$Dj(a, b) {
    if (!$bc5f567978faddca$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $bc5f567978faddca$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $bc5f567978faddca$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $bc5f567978faddca$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bc5f567978faddca$var$S(b), null;
        case 1:
            return $bc5f567978faddca$var$Zf(b.type) && $bc5f567978faddca$var$$f(), $bc5f567978faddca$var$S(b), null;
        case 3:
            d = b.stateNode;
            $bc5f567978faddca$var$zh();
            $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf);
            $bc5f567978faddca$var$E($bc5f567978faddca$var$H);
            $bc5f567978faddca$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $bc5f567978faddca$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $bc5f567978faddca$var$zg && ($bc5f567978faddca$var$Fj($bc5f567978faddca$var$zg), $bc5f567978faddca$var$zg = null));
            $bc5f567978faddca$var$Aj(a, b);
            $bc5f567978faddca$var$S(b);
            return null;
        case 5:
            $bc5f567978faddca$var$Bh(b);
            var e = $bc5f567978faddca$var$xh($bc5f567978faddca$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $bc5f567978faddca$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($bc5f567978faddca$var$p(166));
                    $bc5f567978faddca$var$S(b);
                    return null;
                }
                a = $bc5f567978faddca$var$xh($bc5f567978faddca$var$uh.current);
                if ($bc5f567978faddca$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$bc5f567978faddca$var$Of] = b;
                    d[$bc5f567978faddca$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $bc5f567978faddca$var$D("cancel", d);
                            $bc5f567978faddca$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $bc5f567978faddca$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $bc5f567978faddca$var$lf.length; e++)$bc5f567978faddca$var$D($bc5f567978faddca$var$lf[e], d);
                            break;
                        case "source":
                            $bc5f567978faddca$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $bc5f567978faddca$var$D("error", d);
                            $bc5f567978faddca$var$D("load", d);
                            break;
                        case "details":
                            $bc5f567978faddca$var$D("toggle", d);
                            break;
                        case "input":
                            $bc5f567978faddca$var$Za(d, f);
                            $bc5f567978faddca$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $bc5f567978faddca$var$D("invalid", d);
                            break;
                        case "textarea":
                            $bc5f567978faddca$var$hb(d, f), $bc5f567978faddca$var$D("invalid", d);
                    }
                    $bc5f567978faddca$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $bc5f567978faddca$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $bc5f567978faddca$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $bc5f567978faddca$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $bc5f567978faddca$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $bc5f567978faddca$var$Va(d);
                            $bc5f567978faddca$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $bc5f567978faddca$var$Va(d);
                            $bc5f567978faddca$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $bc5f567978faddca$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $bc5f567978faddca$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$bc5f567978faddca$var$Of] = b;
                    a[$bc5f567978faddca$var$Pf] = d;
                    $bc5f567978faddca$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $bc5f567978faddca$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $bc5f567978faddca$var$D("cancel", a);
                                $bc5f567978faddca$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $bc5f567978faddca$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $bc5f567978faddca$var$lf.length; e++)$bc5f567978faddca$var$D($bc5f567978faddca$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $bc5f567978faddca$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $bc5f567978faddca$var$D("error", a);
                                $bc5f567978faddca$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $bc5f567978faddca$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $bc5f567978faddca$var$Za(a, d);
                                e = $bc5f567978faddca$var$Ya(a, d);
                                $bc5f567978faddca$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $bc5f567978faddca$var$A({}, d, {
                                    value: void 0
                                });
                                $bc5f567978faddca$var$D("invalid", a);
                                break;
                            case "textarea":
                                $bc5f567978faddca$var$hb(a, d);
                                e = $bc5f567978faddca$var$gb(a, d);
                                $bc5f567978faddca$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $bc5f567978faddca$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $bc5f567978faddca$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $bc5f567978faddca$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $bc5f567978faddca$var$ob(a, k) : "number" === typeof k && $bc5f567978faddca$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($bc5f567978faddca$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $bc5f567978faddca$var$D("scroll", a) : null != k && $bc5f567978faddca$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $bc5f567978faddca$var$Va(a);
                                $bc5f567978faddca$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $bc5f567978faddca$var$Va(a);
                                $bc5f567978faddca$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $bc5f567978faddca$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $bc5f567978faddca$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $bc5f567978faddca$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $bc5f567978faddca$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $bc5f567978faddca$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $bc5f567978faddca$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($bc5f567978faddca$var$p(166));
                c = $bc5f567978faddca$var$xh($bc5f567978faddca$var$wh.current);
                $bc5f567978faddca$var$xh($bc5f567978faddca$var$uh.current);
                if ($bc5f567978faddca$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$bc5f567978faddca$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $bc5f567978faddca$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $bc5f567978faddca$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $bc5f567978faddca$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$bc5f567978faddca$var$Of] = b, b.stateNode = d;
            }
            $bc5f567978faddca$var$S(b);
            return null;
        case 13:
            $bc5f567978faddca$var$E($bc5f567978faddca$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($bc5f567978faddca$var$I && null !== $bc5f567978faddca$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $bc5f567978faddca$var$Hg(), $bc5f567978faddca$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $bc5f567978faddca$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($bc5f567978faddca$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($bc5f567978faddca$var$p(317));
                        f[$bc5f567978faddca$var$Of] = b;
                    } else $bc5f567978faddca$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $bc5f567978faddca$var$S(b);
                    f = !1;
                } else null !== $bc5f567978faddca$var$zg && ($bc5f567978faddca$var$Fj($bc5f567978faddca$var$zg), $bc5f567978faddca$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($bc5f567978faddca$var$L.current & 1) ? 0 === $bc5f567978faddca$var$T && ($bc5f567978faddca$var$T = 3) : $bc5f567978faddca$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $bc5f567978faddca$var$S(b);
            return null;
        case 4:
            return $bc5f567978faddca$var$zh(), $bc5f567978faddca$var$Aj(a, b), null === a && $bc5f567978faddca$var$sf(b.stateNode.containerInfo), $bc5f567978faddca$var$S(b), null;
        case 10:
            return $bc5f567978faddca$var$ah(b.type._context), $bc5f567978faddca$var$S(b), null;
        case 17:
            return $bc5f567978faddca$var$Zf(b.type) && $bc5f567978faddca$var$$f(), $bc5f567978faddca$var$S(b), null;
        case 19:
            $bc5f567978faddca$var$E($bc5f567978faddca$var$L);
            f = b.memoizedState;
            if (null === f) return $bc5f567978faddca$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $bc5f567978faddca$var$Dj(f, !1);
                else {
                    if (0 !== $bc5f567978faddca$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $bc5f567978faddca$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $bc5f567978faddca$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $bc5f567978faddca$var$G($bc5f567978faddca$var$L, $bc5f567978faddca$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $bc5f567978faddca$var$B() > $bc5f567978faddca$var$Gj && (b.flags |= 128, d = !0, $bc5f567978faddca$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $bc5f567978faddca$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $bc5f567978faddca$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$bc5f567978faddca$var$I) return $bc5f567978faddca$var$S(b), null;
                    } else 2 * $bc5f567978faddca$var$B() - f.renderingStartTime > $bc5f567978faddca$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $bc5f567978faddca$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $bc5f567978faddca$var$B(), b.sibling = null, c = $bc5f567978faddca$var$L.current, $bc5f567978faddca$var$G($bc5f567978faddca$var$L, d ? c & 1 | 2 : c & 1), b;
            $bc5f567978faddca$var$S(b);
            return null;
        case 22:
        case 23:
            return $bc5f567978faddca$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($bc5f567978faddca$var$fj & 1073741824) && ($bc5f567978faddca$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $bc5f567978faddca$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($bc5f567978faddca$var$p(156, b.tag));
}
function $bc5f567978faddca$var$Ij(a, b) {
    $bc5f567978faddca$var$wg(b);
    switch(b.tag){
        case 1:
            return $bc5f567978faddca$var$Zf(b.type) && $bc5f567978faddca$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $bc5f567978faddca$var$zh(), $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf), $bc5f567978faddca$var$E($bc5f567978faddca$var$H), $bc5f567978faddca$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $bc5f567978faddca$var$Bh(b), null;
        case 13:
            $bc5f567978faddca$var$E($bc5f567978faddca$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($bc5f567978faddca$var$p(340));
                $bc5f567978faddca$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $bc5f567978faddca$var$E($bc5f567978faddca$var$L), null;
        case 4:
            return $bc5f567978faddca$var$zh(), null;
        case 10:
            return $bc5f567978faddca$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $bc5f567978faddca$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $bc5f567978faddca$var$Jj = !1, $bc5f567978faddca$var$U = !1, $bc5f567978faddca$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $bc5f567978faddca$var$V = null;
function $bc5f567978faddca$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $bc5f567978faddca$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $bc5f567978faddca$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $bc5f567978faddca$var$W(a, b, d);
    }
}
var $bc5f567978faddca$var$Nj = !1;
function $bc5f567978faddca$var$Oj(a, b) {
    $bc5f567978faddca$var$Cf = $bc5f567978faddca$var$dd;
    a = $bc5f567978faddca$var$Me();
    if ($bc5f567978faddca$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $bc5f567978faddca$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $bc5f567978faddca$var$dd = !1;
    for($bc5f567978faddca$var$V = b; null !== $bc5f567978faddca$var$V;)if (b = $bc5f567978faddca$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $bc5f567978faddca$var$V = a;
    else for(; null !== $bc5f567978faddca$var$V;){
        b = $bc5f567978faddca$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $bc5f567978faddca$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($bc5f567978faddca$var$p(163));
            }
        } catch (F) {
            $bc5f567978faddca$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $bc5f567978faddca$var$V = a;
            break;
        }
        $bc5f567978faddca$var$V = b.return;
    }
    n = $bc5f567978faddca$var$Nj;
    $bc5f567978faddca$var$Nj = !1;
    return n;
}
function $bc5f567978faddca$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $bc5f567978faddca$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $bc5f567978faddca$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $bc5f567978faddca$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $bc5f567978faddca$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $bc5f567978faddca$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$bc5f567978faddca$var$Of], delete b[$bc5f567978faddca$var$Pf], delete b[$bc5f567978faddca$var$of], delete b[$bc5f567978faddca$var$Qf], delete b[$bc5f567978faddca$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $bc5f567978faddca$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $bc5f567978faddca$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $bc5f567978faddca$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $bc5f567978faddca$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $bc5f567978faddca$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($bc5f567978faddca$var$Vj(a, b, c), a = a.sibling; null !== a;)$bc5f567978faddca$var$Vj(a, b, c), a = a.sibling;
}
function $bc5f567978faddca$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($bc5f567978faddca$var$Wj(a, b, c), a = a.sibling; null !== a;)$bc5f567978faddca$var$Wj(a, b, c), a = a.sibling;
}
var $bc5f567978faddca$var$X = null, $bc5f567978faddca$var$Xj = !1;
function $bc5f567978faddca$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$bc5f567978faddca$var$Zj(a, b, c), c = c.sibling;
}
function $bc5f567978faddca$var$Zj(a, b, c) {
    if ($bc5f567978faddca$var$lc && "function" === typeof $bc5f567978faddca$var$lc.onCommitFiberUnmount) try {
        $bc5f567978faddca$var$lc.onCommitFiberUnmount($bc5f567978faddca$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $bc5f567978faddca$var$U || $bc5f567978faddca$var$Lj(c, b);
        case 6:
            var d = $bc5f567978faddca$var$X, e = $bc5f567978faddca$var$Xj;
            $bc5f567978faddca$var$X = null;
            $bc5f567978faddca$var$Yj(a, b, c);
            $bc5f567978faddca$var$X = d;
            $bc5f567978faddca$var$Xj = e;
            null !== $bc5f567978faddca$var$X && ($bc5f567978faddca$var$Xj ? (a = $bc5f567978faddca$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $bc5f567978faddca$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $bc5f567978faddca$var$X && ($bc5f567978faddca$var$Xj ? (a = $bc5f567978faddca$var$X, c = c.stateNode, 8 === a.nodeType ? $bc5f567978faddca$var$Kf(a.parentNode, c) : 1 === a.nodeType && $bc5f567978faddca$var$Kf(a, c), $bc5f567978faddca$var$bd(a)) : $bc5f567978faddca$var$Kf($bc5f567978faddca$var$X, c.stateNode));
            break;
        case 4:
            d = $bc5f567978faddca$var$X;
            e = $bc5f567978faddca$var$Xj;
            $bc5f567978faddca$var$X = c.stateNode.containerInfo;
            $bc5f567978faddca$var$Xj = !0;
            $bc5f567978faddca$var$Yj(a, b, c);
            $bc5f567978faddca$var$X = d;
            $bc5f567978faddca$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$bc5f567978faddca$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $bc5f567978faddca$var$Mj(c, b, g) : 0 !== (f & 4) && $bc5f567978faddca$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $bc5f567978faddca$var$Yj(a, b, c);
            break;
        case 1:
            if (!$bc5f567978faddca$var$U && ($bc5f567978faddca$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $bc5f567978faddca$var$W(c, b, h);
            }
            $bc5f567978faddca$var$Yj(a, b, c);
            break;
        case 21:
            $bc5f567978faddca$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($bc5f567978faddca$var$U = (d = $bc5f567978faddca$var$U) || null !== c.memoizedState, $bc5f567978faddca$var$Yj(a, b, c), $bc5f567978faddca$var$U = d) : $bc5f567978faddca$var$Yj(a, b, c);
            break;
        default:
            $bc5f567978faddca$var$Yj(a, b, c);
    }
}
function $bc5f567978faddca$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $bc5f567978faddca$var$Kj);
        b.forEach(function(b) {
            var d = $bc5f567978faddca$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $bc5f567978faddca$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $bc5f567978faddca$var$X = h.stateNode;
                        $bc5f567978faddca$var$Xj = !1;
                        break a;
                    case 3:
                        $bc5f567978faddca$var$X = h.stateNode.containerInfo;
                        $bc5f567978faddca$var$Xj = !0;
                        break a;
                    case 4:
                        $bc5f567978faddca$var$X = h.stateNode.containerInfo;
                        $bc5f567978faddca$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $bc5f567978faddca$var$X) throw Error($bc5f567978faddca$var$p(160));
            $bc5f567978faddca$var$Zj(f, g, e);
            $bc5f567978faddca$var$X = null;
            $bc5f567978faddca$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $bc5f567978faddca$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$bc5f567978faddca$var$dk(b, a), b = b.sibling;
}
function $bc5f567978faddca$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            if (d & 4) {
                try {
                    $bc5f567978faddca$var$Pj(3, a, a.return), $bc5f567978faddca$var$Qj(3, a);
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
                try {
                    $bc5f567978faddca$var$Pj(5, a, a.return);
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            d & 512 && null !== c && $bc5f567978faddca$var$Lj(c, c.return);
            break;
        case 5:
            $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            d & 512 && null !== c && $bc5f567978faddca$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $bc5f567978faddca$var$ob(e, "");
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $bc5f567978faddca$var$ab(e, f);
                    $bc5f567978faddca$var$vb(h, g);
                    var l = $bc5f567978faddca$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $bc5f567978faddca$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $bc5f567978faddca$var$nb(e, q) : "children" === m ? $bc5f567978faddca$var$ob(e, q) : $bc5f567978faddca$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $bc5f567978faddca$var$bb(e, f);
                            break;
                        case "textarea":
                            $bc5f567978faddca$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $bc5f567978faddca$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $bc5f567978faddca$var$fb(e, !!f.multiple, f.defaultValue, !0) : $bc5f567978faddca$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$bc5f567978faddca$var$Pf] = f;
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($bc5f567978faddca$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $bc5f567978faddca$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $bc5f567978faddca$var$bd(b.containerInfo);
            } catch (t) {
                $bc5f567978faddca$var$W(a, a.return, t);
            }
            break;
        case 4:
            $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            break;
        case 13:
            $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($bc5f567978faddca$var$fk = $bc5f567978faddca$var$B()));
            d & 4 && $bc5f567978faddca$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($bc5f567978faddca$var$U = (l = $bc5f567978faddca$var$U) || m, $bc5f567978faddca$var$ck(b, a), $bc5f567978faddca$var$U = l) : $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($bc5f567978faddca$var$V = a, m = a.child; null !== m;){
                    for(q = $bc5f567978faddca$var$V = m; null !== $bc5f567978faddca$var$V;){
                        r = $bc5f567978faddca$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $bc5f567978faddca$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $bc5f567978faddca$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $bc5f567978faddca$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $bc5f567978faddca$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $bc5f567978faddca$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $bc5f567978faddca$var$V = y) : $bc5f567978faddca$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $bc5f567978faddca$var$rb("display", g));
                            } catch (t) {
                                $bc5f567978faddca$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $bc5f567978faddca$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $bc5f567978faddca$var$ck(b, a);
            $bc5f567978faddca$var$ek(a);
            d & 4 && $bc5f567978faddca$var$ak(a);
            break;
        case 21:
            break;
        default:
            $bc5f567978faddca$var$ck(b, a), $bc5f567978faddca$var$ek(a);
    }
}
function $bc5f567978faddca$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($bc5f567978faddca$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($bc5f567978faddca$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($bc5f567978faddca$var$ob(e, ""), d.flags &= -33);
                    var f = $bc5f567978faddca$var$Uj(a);
                    $bc5f567978faddca$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $bc5f567978faddca$var$Uj(a);
                    $bc5f567978faddca$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($bc5f567978faddca$var$p(161));
            }
        } catch (k) {
            $bc5f567978faddca$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $bc5f567978faddca$var$hk(a, b, c) {
    $bc5f567978faddca$var$V = a;
    $bc5f567978faddca$var$ik(a, b, c);
}
function $bc5f567978faddca$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $bc5f567978faddca$var$V;){
        var e = $bc5f567978faddca$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $bc5f567978faddca$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $bc5f567978faddca$var$U;
                h = $bc5f567978faddca$var$Jj;
                var l = $bc5f567978faddca$var$U;
                $bc5f567978faddca$var$Jj = g;
                if (($bc5f567978faddca$var$U = k) && !l) for($bc5f567978faddca$var$V = e; null !== $bc5f567978faddca$var$V;)g = $bc5f567978faddca$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $bc5f567978faddca$var$jk(e) : null !== k ? (k.return = g, $bc5f567978faddca$var$V = k) : $bc5f567978faddca$var$jk(e);
                for(; null !== f;)$bc5f567978faddca$var$V = f, $bc5f567978faddca$var$ik(f, b, c), f = f.sibling;
                $bc5f567978faddca$var$V = e;
                $bc5f567978faddca$var$Jj = h;
                $bc5f567978faddca$var$U = l;
            }
            $bc5f567978faddca$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $bc5f567978faddca$var$V = f) : $bc5f567978faddca$var$kk(a, b, c);
    }
}
function $bc5f567978faddca$var$kk(a) {
    for(; null !== $bc5f567978faddca$var$V;){
        var b = $bc5f567978faddca$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $bc5f567978faddca$var$U || $bc5f567978faddca$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$bc5f567978faddca$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $bc5f567978faddca$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $bc5f567978faddca$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $bc5f567978faddca$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $bc5f567978faddca$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($bc5f567978faddca$var$p(163));
                }
                $bc5f567978faddca$var$U || b.flags & 512 && $bc5f567978faddca$var$Rj(b);
            } catch (r) {
                $bc5f567978faddca$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $bc5f567978faddca$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bc5f567978faddca$var$V = c;
            break;
        }
        $bc5f567978faddca$var$V = b.return;
    }
}
function $bc5f567978faddca$var$gk(a) {
    for(; null !== $bc5f567978faddca$var$V;){
        var b = $bc5f567978faddca$var$V;
        if (b === a) {
            $bc5f567978faddca$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $bc5f567978faddca$var$V = c;
            break;
        }
        $bc5f567978faddca$var$V = b.return;
    }
}
function $bc5f567978faddca$var$jk(a) {
    for(; null !== $bc5f567978faddca$var$V;){
        var b = $bc5f567978faddca$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $bc5f567978faddca$var$Qj(4, b);
                    } catch (k) {
                        $bc5f567978faddca$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $bc5f567978faddca$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $bc5f567978faddca$var$Rj(b);
                    } catch (k) {
                        $bc5f567978faddca$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $bc5f567978faddca$var$Rj(b);
                    } catch (k) {
                        $bc5f567978faddca$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $bc5f567978faddca$var$W(b, b.return, k);
        }
        if (b === a) {
            $bc5f567978faddca$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $bc5f567978faddca$var$V = h;
            break;
        }
        $bc5f567978faddca$var$V = b.return;
    }
}
var $bc5f567978faddca$var$lk = Math.ceil, $bc5f567978faddca$var$mk = $bc5f567978faddca$var$ua.ReactCurrentDispatcher, $bc5f567978faddca$var$nk = $bc5f567978faddca$var$ua.ReactCurrentOwner, $bc5f567978faddca$var$ok = $bc5f567978faddca$var$ua.ReactCurrentBatchConfig, $bc5f567978faddca$var$K = 0, $bc5f567978faddca$var$Q = null, $bc5f567978faddca$var$Y = null, $bc5f567978faddca$var$Z = 0, $bc5f567978faddca$var$fj = 0, $bc5f567978faddca$var$ej = $bc5f567978faddca$var$Uf(0), $bc5f567978faddca$var$T = 0, $bc5f567978faddca$var$pk = null, $bc5f567978faddca$var$rh = 0, $bc5f567978faddca$var$qk = 0, $bc5f567978faddca$var$rk = 0, $bc5f567978faddca$var$sk = null, $bc5f567978faddca$var$tk = null, $bc5f567978faddca$var$fk = 0, $bc5f567978faddca$var$Gj = Infinity, $bc5f567978faddca$var$uk = null, $bc5f567978faddca$var$Oi = !1, $bc5f567978faddca$var$Pi = null, $bc5f567978faddca$var$Ri = null, $bc5f567978faddca$var$vk = !1, $bc5f567978faddca$var$wk = null, $bc5f567978faddca$var$xk = 0, $bc5f567978faddca$var$yk = 0, $bc5f567978faddca$var$zk = null, $bc5f567978faddca$var$Ak = -1, $bc5f567978faddca$var$Bk = 0;
function $bc5f567978faddca$var$R() {
    return 0 !== ($bc5f567978faddca$var$K & 6) ? $bc5f567978faddca$var$B() : -1 !== $bc5f567978faddca$var$Ak ? $bc5f567978faddca$var$Ak : $bc5f567978faddca$var$Ak = $bc5f567978faddca$var$B();
}
function $bc5f567978faddca$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($bc5f567978faddca$var$K & 2) && 0 !== $bc5f567978faddca$var$Z) return $bc5f567978faddca$var$Z & -$bc5f567978faddca$var$Z;
    if (null !== $bc5f567978faddca$var$Kg.transition) return 0 === $bc5f567978faddca$var$Bk && ($bc5f567978faddca$var$Bk = $bc5f567978faddca$var$yc()), $bc5f567978faddca$var$Bk;
    a = $bc5f567978faddca$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $bc5f567978faddca$var$jd(a.type);
    return a;
}
function $bc5f567978faddca$var$gi(a, b, c, d) {
    if (50 < $bc5f567978faddca$var$yk) throw $bc5f567978faddca$var$yk = 0, $bc5f567978faddca$var$zk = null, Error($bc5f567978faddca$var$p(185));
    $bc5f567978faddca$var$Ac(a, c, d);
    if (0 === ($bc5f567978faddca$var$K & 2) || a !== $bc5f567978faddca$var$Q) a === $bc5f567978faddca$var$Q && (0 === ($bc5f567978faddca$var$K & 2) && ($bc5f567978faddca$var$qk |= c), 4 === $bc5f567978faddca$var$T && $bc5f567978faddca$var$Ck(a, $bc5f567978faddca$var$Z)), $bc5f567978faddca$var$Dk(a, d), 1 === c && 0 === $bc5f567978faddca$var$K && 0 === (b.mode & 1) && ($bc5f567978faddca$var$Gj = $bc5f567978faddca$var$B() + 500, $bc5f567978faddca$var$fg && $bc5f567978faddca$var$jg());
}
function $bc5f567978faddca$var$Dk(a, b) {
    var c = a.callbackNode;
    $bc5f567978faddca$var$wc(a, b);
    var d = $bc5f567978faddca$var$uc(a, a === $bc5f567978faddca$var$Q ? $bc5f567978faddca$var$Z : 0);
    if (0 === d) null !== c && $bc5f567978faddca$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $bc5f567978faddca$var$bc(c);
        if (1 === b) 0 === a.tag ? $bc5f567978faddca$var$ig($bc5f567978faddca$var$Ek.bind(null, a)) : $bc5f567978faddca$var$hg($bc5f567978faddca$var$Ek.bind(null, a)), $bc5f567978faddca$var$Jf(function() {
            0 === ($bc5f567978faddca$var$K & 6) && $bc5f567978faddca$var$jg();
        }), c = null;
        else {
            switch($bc5f567978faddca$var$Dc(d)){
                case 1:
                    c = $bc5f567978faddca$var$fc;
                    break;
                case 4:
                    c = $bc5f567978faddca$var$gc;
                    break;
                case 16:
                    c = $bc5f567978faddca$var$hc;
                    break;
                case 536870912:
                    c = $bc5f567978faddca$var$jc;
                    break;
                default:
                    c = $bc5f567978faddca$var$hc;
            }
            c = $bc5f567978faddca$var$Fk(c, $bc5f567978faddca$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $bc5f567978faddca$var$Gk(a, b) {
    $bc5f567978faddca$var$Ak = -1;
    $bc5f567978faddca$var$Bk = 0;
    if (0 !== ($bc5f567978faddca$var$K & 6)) throw Error($bc5f567978faddca$var$p(327));
    var c = a.callbackNode;
    if ($bc5f567978faddca$var$Hk() && a.callbackNode !== c) return null;
    var d = $bc5f567978faddca$var$uc(a, a === $bc5f567978faddca$var$Q ? $bc5f567978faddca$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $bc5f567978faddca$var$Ik(a, d);
    else {
        b = d;
        var e = $bc5f567978faddca$var$K;
        $bc5f567978faddca$var$K |= 2;
        var f = $bc5f567978faddca$var$Jk();
        if ($bc5f567978faddca$var$Q !== a || $bc5f567978faddca$var$Z !== b) $bc5f567978faddca$var$uk = null, $bc5f567978faddca$var$Gj = $bc5f567978faddca$var$B() + 500, $bc5f567978faddca$var$Kk(a, b);
        for(;;)try {
            $bc5f567978faddca$var$Lk();
            break;
        } catch (h) {
            $bc5f567978faddca$var$Mk(a, h);
        }
        $bc5f567978faddca$var$$g();
        $bc5f567978faddca$var$mk.current = f;
        $bc5f567978faddca$var$K = e;
        null !== $bc5f567978faddca$var$Y ? b = 0 : ($bc5f567978faddca$var$Q = null, $bc5f567978faddca$var$Z = 0, b = $bc5f567978faddca$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $bc5f567978faddca$var$xc(a), 0 !== e && (d = e, b = $bc5f567978faddca$var$Nk(a, e)));
        if (1 === b) throw c = $bc5f567978faddca$var$pk, $bc5f567978faddca$var$Kk(a, 0), $bc5f567978faddca$var$Ck(a, d), $bc5f567978faddca$var$Dk(a, $bc5f567978faddca$var$B()), c;
        if (6 === b) $bc5f567978faddca$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$bc5f567978faddca$var$Ok(e) && (b = $bc5f567978faddca$var$Ik(a, d), 2 === b && (f = $bc5f567978faddca$var$xc(a), 0 !== f && (d = f, b = $bc5f567978faddca$var$Nk(a, f))), 1 === b)) throw c = $bc5f567978faddca$var$pk, $bc5f567978faddca$var$Kk(a, 0), $bc5f567978faddca$var$Ck(a, d), $bc5f567978faddca$var$Dk(a, $bc5f567978faddca$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($bc5f567978faddca$var$p(345));
                case 2:
                    $bc5f567978faddca$var$Pk(a, $bc5f567978faddca$var$tk, $bc5f567978faddca$var$uk);
                    break;
                case 3:
                    $bc5f567978faddca$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $bc5f567978faddca$var$fk + 500 - $bc5f567978faddca$var$B(), 10 < b)) {
                        if (0 !== $bc5f567978faddca$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $bc5f567978faddca$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $bc5f567978faddca$var$Ff($bc5f567978faddca$var$Pk.bind(null, a, $bc5f567978faddca$var$tk, $bc5f567978faddca$var$uk), b);
                        break;
                    }
                    $bc5f567978faddca$var$Pk(a, $bc5f567978faddca$var$tk, $bc5f567978faddca$var$uk);
                    break;
                case 4:
                    $bc5f567978faddca$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $bc5f567978faddca$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $bc5f567978faddca$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $bc5f567978faddca$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $bc5f567978faddca$var$Ff($bc5f567978faddca$var$Pk.bind(null, a, $bc5f567978faddca$var$tk, $bc5f567978faddca$var$uk), d);
                        break;
                    }
                    $bc5f567978faddca$var$Pk(a, $bc5f567978faddca$var$tk, $bc5f567978faddca$var$uk);
                    break;
                case 5:
                    $bc5f567978faddca$var$Pk(a, $bc5f567978faddca$var$tk, $bc5f567978faddca$var$uk);
                    break;
                default:
                    throw Error($bc5f567978faddca$var$p(329));
            }
        }
    }
    $bc5f567978faddca$var$Dk(a, $bc5f567978faddca$var$B());
    return a.callbackNode === c ? $bc5f567978faddca$var$Gk.bind(null, a) : null;
}
function $bc5f567978faddca$var$Nk(a, b) {
    var c = $bc5f567978faddca$var$sk;
    a.current.memoizedState.isDehydrated && ($bc5f567978faddca$var$Kk(a, b).flags |= 256);
    a = $bc5f567978faddca$var$Ik(a, b);
    2 !== a && (b = $bc5f567978faddca$var$tk, $bc5f567978faddca$var$tk = c, null !== b && $bc5f567978faddca$var$Fj(b));
    return a;
}
function $bc5f567978faddca$var$Fj(a) {
    null === $bc5f567978faddca$var$tk ? $bc5f567978faddca$var$tk = a : $bc5f567978faddca$var$tk.push.apply($bc5f567978faddca$var$tk, a);
}
function $bc5f567978faddca$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$bc5f567978faddca$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $bc5f567978faddca$var$Ck(a, b) {
    b &= ~$bc5f567978faddca$var$rk;
    b &= ~$bc5f567978faddca$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $bc5f567978faddca$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $bc5f567978faddca$var$Ek(a) {
    if (0 !== ($bc5f567978faddca$var$K & 6)) throw Error($bc5f567978faddca$var$p(327));
    $bc5f567978faddca$var$Hk();
    var b = $bc5f567978faddca$var$uc(a, 0);
    if (0 === (b & 1)) return $bc5f567978faddca$var$Dk(a, $bc5f567978faddca$var$B()), null;
    var c = $bc5f567978faddca$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $bc5f567978faddca$var$xc(a);
        0 !== d && (b = d, c = $bc5f567978faddca$var$Nk(a, d));
    }
    if (1 === c) throw c = $bc5f567978faddca$var$pk, $bc5f567978faddca$var$Kk(a, 0), $bc5f567978faddca$var$Ck(a, b), $bc5f567978faddca$var$Dk(a, $bc5f567978faddca$var$B()), c;
    if (6 === c) throw Error($bc5f567978faddca$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $bc5f567978faddca$var$Pk(a, $bc5f567978faddca$var$tk, $bc5f567978faddca$var$uk);
    $bc5f567978faddca$var$Dk(a, $bc5f567978faddca$var$B());
    return null;
}
function $bc5f567978faddca$var$Qk(a, b) {
    var c = $bc5f567978faddca$var$K;
    $bc5f567978faddca$var$K |= 1;
    try {
        return a(b);
    } finally{
        $bc5f567978faddca$var$K = c, 0 === $bc5f567978faddca$var$K && ($bc5f567978faddca$var$Gj = $bc5f567978faddca$var$B() + 500, $bc5f567978faddca$var$fg && $bc5f567978faddca$var$jg());
    }
}
function $bc5f567978faddca$var$Rk(a) {
    null !== $bc5f567978faddca$var$wk && 0 === $bc5f567978faddca$var$wk.tag && 0 === ($bc5f567978faddca$var$K & 6) && $bc5f567978faddca$var$Hk();
    var b = $bc5f567978faddca$var$K;
    $bc5f567978faddca$var$K |= 1;
    var c = $bc5f567978faddca$var$ok.transition, d = $bc5f567978faddca$var$C;
    try {
        if ($bc5f567978faddca$var$ok.transition = null, $bc5f567978faddca$var$C = 1, a) return a();
    } finally{
        $bc5f567978faddca$var$C = d, $bc5f567978faddca$var$ok.transition = c, $bc5f567978faddca$var$K = b, 0 === ($bc5f567978faddca$var$K & 6) && $bc5f567978faddca$var$jg();
    }
}
function $bc5f567978faddca$var$Hj() {
    $bc5f567978faddca$var$fj = $bc5f567978faddca$var$ej.current;
    $bc5f567978faddca$var$E($bc5f567978faddca$var$ej);
}
function $bc5f567978faddca$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $bc5f567978faddca$var$Gf(c));
    if (null !== $bc5f567978faddca$var$Y) for(c = $bc5f567978faddca$var$Y.return; null !== c;){
        var d = c;
        $bc5f567978faddca$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $bc5f567978faddca$var$$f();
                break;
            case 3:
                $bc5f567978faddca$var$zh();
                $bc5f567978faddca$var$E($bc5f567978faddca$var$Wf);
                $bc5f567978faddca$var$E($bc5f567978faddca$var$H);
                $bc5f567978faddca$var$Eh();
                break;
            case 5:
                $bc5f567978faddca$var$Bh(d);
                break;
            case 4:
                $bc5f567978faddca$var$zh();
                break;
            case 13:
                $bc5f567978faddca$var$E($bc5f567978faddca$var$L);
                break;
            case 19:
                $bc5f567978faddca$var$E($bc5f567978faddca$var$L);
                break;
            case 10:
                $bc5f567978faddca$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $bc5f567978faddca$var$Hj();
        }
        c = c.return;
    }
    $bc5f567978faddca$var$Q = a;
    $bc5f567978faddca$var$Y = a = $bc5f567978faddca$var$Pg(a.current, null);
    $bc5f567978faddca$var$Z = $bc5f567978faddca$var$fj = b;
    $bc5f567978faddca$var$T = 0;
    $bc5f567978faddca$var$pk = null;
    $bc5f567978faddca$var$rk = $bc5f567978faddca$var$qk = $bc5f567978faddca$var$rh = 0;
    $bc5f567978faddca$var$tk = $bc5f567978faddca$var$sk = null;
    if (null !== $bc5f567978faddca$var$fh) {
        for(b = 0; b < $bc5f567978faddca$var$fh.length; b++)if (c = $bc5f567978faddca$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $bc5f567978faddca$var$fh = null;
    }
    return a;
}
function $bc5f567978faddca$var$Mk(a, b) {
    do {
        var c = $bc5f567978faddca$var$Y;
        try {
            $bc5f567978faddca$var$$g();
            $bc5f567978faddca$var$Fh.current = $bc5f567978faddca$var$Rh;
            if ($bc5f567978faddca$var$Ih) {
                for(var d = $bc5f567978faddca$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $bc5f567978faddca$var$Ih = !1;
            }
            $bc5f567978faddca$var$Hh = 0;
            $bc5f567978faddca$var$O = $bc5f567978faddca$var$N = $bc5f567978faddca$var$M = null;
            $bc5f567978faddca$var$Jh = !1;
            $bc5f567978faddca$var$Kh = 0;
            $bc5f567978faddca$var$nk.current = null;
            if (null === c || null === c.return) {
                $bc5f567978faddca$var$T = 1;
                $bc5f567978faddca$var$pk = b;
                $bc5f567978faddca$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $bc5f567978faddca$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $bc5f567978faddca$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $bc5f567978faddca$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $bc5f567978faddca$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $bc5f567978faddca$var$Si(f, l, b);
                            $bc5f567978faddca$var$tj();
                            break a;
                        }
                        k = Error($bc5f567978faddca$var$p(426));
                    }
                } else if ($bc5f567978faddca$var$I && h.mode & 1) {
                    var J = $bc5f567978faddca$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $bc5f567978faddca$var$Vi(J, g, h, f, b);
                        $bc5f567978faddca$var$Jg($bc5f567978faddca$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $bc5f567978faddca$var$Ji(k, h);
                4 !== $bc5f567978faddca$var$T && ($bc5f567978faddca$var$T = 2);
                null === $bc5f567978faddca$var$sk ? $bc5f567978faddca$var$sk = [
                    f
                ] : $bc5f567978faddca$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $bc5f567978faddca$var$Ni(f, k, b);
                            $bc5f567978faddca$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $bc5f567978faddca$var$Ri || !$bc5f567978faddca$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $bc5f567978faddca$var$Qi(f, h, b);
                                $bc5f567978faddca$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $bc5f567978faddca$var$Sk(c);
        } catch (na) {
            b = na;
            $bc5f567978faddca$var$Y === c && null !== c && ($bc5f567978faddca$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $bc5f567978faddca$var$Jk() {
    var a = $bc5f567978faddca$var$mk.current;
    $bc5f567978faddca$var$mk.current = $bc5f567978faddca$var$Rh;
    return null === a ? $bc5f567978faddca$var$Rh : a;
}
function $bc5f567978faddca$var$tj() {
    if (0 === $bc5f567978faddca$var$T || 3 === $bc5f567978faddca$var$T || 2 === $bc5f567978faddca$var$T) $bc5f567978faddca$var$T = 4;
    null === $bc5f567978faddca$var$Q || 0 === ($bc5f567978faddca$var$rh & 268435455) && 0 === ($bc5f567978faddca$var$qk & 268435455) || $bc5f567978faddca$var$Ck($bc5f567978faddca$var$Q, $bc5f567978faddca$var$Z);
}
function $bc5f567978faddca$var$Ik(a, b) {
    var c = $bc5f567978faddca$var$K;
    $bc5f567978faddca$var$K |= 2;
    var d = $bc5f567978faddca$var$Jk();
    if ($bc5f567978faddca$var$Q !== a || $bc5f567978faddca$var$Z !== b) $bc5f567978faddca$var$uk = null, $bc5f567978faddca$var$Kk(a, b);
    for(;;)try {
        $bc5f567978faddca$var$Tk();
        break;
    } catch (e) {
        $bc5f567978faddca$var$Mk(a, e);
    }
    $bc5f567978faddca$var$$g();
    $bc5f567978faddca$var$K = c;
    $bc5f567978faddca$var$mk.current = d;
    if (null !== $bc5f567978faddca$var$Y) throw Error($bc5f567978faddca$var$p(261));
    $bc5f567978faddca$var$Q = null;
    $bc5f567978faddca$var$Z = 0;
    return $bc5f567978faddca$var$T;
}
function $bc5f567978faddca$var$Tk() {
    for(; null !== $bc5f567978faddca$var$Y;)$bc5f567978faddca$var$Uk($bc5f567978faddca$var$Y);
}
function $bc5f567978faddca$var$Lk() {
    for(; null !== $bc5f567978faddca$var$Y && !$bc5f567978faddca$var$cc();)$bc5f567978faddca$var$Uk($bc5f567978faddca$var$Y);
}
function $bc5f567978faddca$var$Uk(a) {
    var b = $bc5f567978faddca$var$Vk(a.alternate, a, $bc5f567978faddca$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $bc5f567978faddca$var$Sk(a) : $bc5f567978faddca$var$Y = b;
    $bc5f567978faddca$var$nk.current = null;
}
function $bc5f567978faddca$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $bc5f567978faddca$var$Ej(c, b, $bc5f567978faddca$var$fj), null !== c) {
                $bc5f567978faddca$var$Y = c;
                return;
            }
        } else {
            c = $bc5f567978faddca$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $bc5f567978faddca$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $bc5f567978faddca$var$T = 6;
                $bc5f567978faddca$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $bc5f567978faddca$var$Y = b;
            return;
        }
        $bc5f567978faddca$var$Y = b = a;
    }while (null !== b);
    0 === $bc5f567978faddca$var$T && ($bc5f567978faddca$var$T = 5);
}
function $bc5f567978faddca$var$Pk(a, b, c) {
    var d = $bc5f567978faddca$var$C, e = $bc5f567978faddca$var$ok.transition;
    try {
        $bc5f567978faddca$var$ok.transition = null, $bc5f567978faddca$var$C = 1, $bc5f567978faddca$var$Wk(a, b, c, d);
    } finally{
        $bc5f567978faddca$var$ok.transition = e, $bc5f567978faddca$var$C = d;
    }
    return null;
}
function $bc5f567978faddca$var$Wk(a, b, c, d) {
    do $bc5f567978faddca$var$Hk();
    while (null !== $bc5f567978faddca$var$wk);
    if (0 !== ($bc5f567978faddca$var$K & 6)) throw Error($bc5f567978faddca$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($bc5f567978faddca$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $bc5f567978faddca$var$Bc(a, f);
    a === $bc5f567978faddca$var$Q && ($bc5f567978faddca$var$Y = $bc5f567978faddca$var$Q = null, $bc5f567978faddca$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $bc5f567978faddca$var$vk || ($bc5f567978faddca$var$vk = !0, $bc5f567978faddca$var$Fk($bc5f567978faddca$var$hc, function() {
        $bc5f567978faddca$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $bc5f567978faddca$var$ok.transition;
        $bc5f567978faddca$var$ok.transition = null;
        var g = $bc5f567978faddca$var$C;
        $bc5f567978faddca$var$C = 1;
        var h = $bc5f567978faddca$var$K;
        $bc5f567978faddca$var$K |= 4;
        $bc5f567978faddca$var$nk.current = null;
        $bc5f567978faddca$var$Oj(a, c);
        $bc5f567978faddca$var$dk(c, a);
        $bc5f567978faddca$var$Oe($bc5f567978faddca$var$Df);
        $bc5f567978faddca$var$dd = !!$bc5f567978faddca$var$Cf;
        $bc5f567978faddca$var$Df = $bc5f567978faddca$var$Cf = null;
        a.current = c;
        $bc5f567978faddca$var$hk(c, a, e);
        $bc5f567978faddca$var$dc();
        $bc5f567978faddca$var$K = h;
        $bc5f567978faddca$var$C = g;
        $bc5f567978faddca$var$ok.transition = f;
    } else a.current = c;
    $bc5f567978faddca$var$vk && ($bc5f567978faddca$var$vk = !1, $bc5f567978faddca$var$wk = a, $bc5f567978faddca$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($bc5f567978faddca$var$Ri = null);
    $bc5f567978faddca$var$mc(c.stateNode, d);
    $bc5f567978faddca$var$Dk(a, $bc5f567978faddca$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($bc5f567978faddca$var$Oi) throw $bc5f567978faddca$var$Oi = !1, a = $bc5f567978faddca$var$Pi, $bc5f567978faddca$var$Pi = null, a;
    0 !== ($bc5f567978faddca$var$xk & 1) && 0 !== a.tag && $bc5f567978faddca$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $bc5f567978faddca$var$zk ? $bc5f567978faddca$var$yk++ : ($bc5f567978faddca$var$yk = 0, $bc5f567978faddca$var$zk = a) : $bc5f567978faddca$var$yk = 0;
    $bc5f567978faddca$var$jg();
    return null;
}
function $bc5f567978faddca$var$Hk() {
    if (null !== $bc5f567978faddca$var$wk) {
        var a = $bc5f567978faddca$var$Dc($bc5f567978faddca$var$xk), b = $bc5f567978faddca$var$ok.transition, c = $bc5f567978faddca$var$C;
        try {
            $bc5f567978faddca$var$ok.transition = null;
            $bc5f567978faddca$var$C = 16 > a ? 16 : a;
            if (null === $bc5f567978faddca$var$wk) var d = !1;
            else {
                a = $bc5f567978faddca$var$wk;
                $bc5f567978faddca$var$wk = null;
                $bc5f567978faddca$var$xk = 0;
                if (0 !== ($bc5f567978faddca$var$K & 6)) throw Error($bc5f567978faddca$var$p(331));
                var e = $bc5f567978faddca$var$K;
                $bc5f567978faddca$var$K |= 4;
                for($bc5f567978faddca$var$V = a.current; null !== $bc5f567978faddca$var$V;){
                    var f = $bc5f567978faddca$var$V, g = f.child;
                    if (0 !== ($bc5f567978faddca$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($bc5f567978faddca$var$V = l; null !== $bc5f567978faddca$var$V;){
                                    var m = $bc5f567978faddca$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $bc5f567978faddca$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $bc5f567978faddca$var$V = q;
                                    else for(; null !== $bc5f567978faddca$var$V;){
                                        m = $bc5f567978faddca$var$V;
                                        var r = m.sibling, y = m.return;
                                        $bc5f567978faddca$var$Sj(m);
                                        if (m === l) {
                                            $bc5f567978faddca$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $bc5f567978faddca$var$V = r;
                                            break;
                                        }
                                        $bc5f567978faddca$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $bc5f567978faddca$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $bc5f567978faddca$var$V = g;
                    else b: for(; null !== $bc5f567978faddca$var$V;){
                        f = $bc5f567978faddca$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $bc5f567978faddca$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $bc5f567978faddca$var$V = x;
                            break b;
                        }
                        $bc5f567978faddca$var$V = f.return;
                    }
                }
                var w = a.current;
                for($bc5f567978faddca$var$V = w; null !== $bc5f567978faddca$var$V;){
                    g = $bc5f567978faddca$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $bc5f567978faddca$var$V = u;
                    else b: for(g = w; null !== $bc5f567978faddca$var$V;){
                        h = $bc5f567978faddca$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $bc5f567978faddca$var$Qj(9, h);
                            }
                        } catch (na) {
                            $bc5f567978faddca$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $bc5f567978faddca$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $bc5f567978faddca$var$V = F;
                            break b;
                        }
                        $bc5f567978faddca$var$V = h.return;
                    }
                }
                $bc5f567978faddca$var$K = e;
                $bc5f567978faddca$var$jg();
                if ($bc5f567978faddca$var$lc && "function" === typeof $bc5f567978faddca$var$lc.onPostCommitFiberRoot) try {
                    $bc5f567978faddca$var$lc.onPostCommitFiberRoot($bc5f567978faddca$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $bc5f567978faddca$var$C = c, $bc5f567978faddca$var$ok.transition = b;
        }
    }
    return !1;
}
function $bc5f567978faddca$var$Xk(a, b, c) {
    b = $bc5f567978faddca$var$Ji(c, b);
    b = $bc5f567978faddca$var$Ni(a, b, 1);
    a = $bc5f567978faddca$var$nh(a, b, 1);
    b = $bc5f567978faddca$var$R();
    null !== a && ($bc5f567978faddca$var$Ac(a, 1, b), $bc5f567978faddca$var$Dk(a, b));
}
function $bc5f567978faddca$var$W(a, b, c) {
    if (3 === a.tag) $bc5f567978faddca$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $bc5f567978faddca$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $bc5f567978faddca$var$Ri || !$bc5f567978faddca$var$Ri.has(d))) {
                a = $bc5f567978faddca$var$Ji(c, a);
                a = $bc5f567978faddca$var$Qi(b, a, 1);
                b = $bc5f567978faddca$var$nh(b, a, 1);
                a = $bc5f567978faddca$var$R();
                null !== b && ($bc5f567978faddca$var$Ac(b, 1, a), $bc5f567978faddca$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $bc5f567978faddca$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $bc5f567978faddca$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $bc5f567978faddca$var$Q === a && ($bc5f567978faddca$var$Z & c) === c && (4 === $bc5f567978faddca$var$T || 3 === $bc5f567978faddca$var$T && ($bc5f567978faddca$var$Z & 130023424) === $bc5f567978faddca$var$Z && 500 > $bc5f567978faddca$var$B() - $bc5f567978faddca$var$fk ? $bc5f567978faddca$var$Kk(a, 0) : $bc5f567978faddca$var$rk |= c);
    $bc5f567978faddca$var$Dk(a, b);
}
function $bc5f567978faddca$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $bc5f567978faddca$var$sc, $bc5f567978faddca$var$sc <<= 1, 0 === ($bc5f567978faddca$var$sc & 130023424) && ($bc5f567978faddca$var$sc = 4194304)));
    var c = $bc5f567978faddca$var$R();
    a = $bc5f567978faddca$var$ih(a, b);
    null !== a && ($bc5f567978faddca$var$Ac(a, b, c), $bc5f567978faddca$var$Dk(a, c));
}
function $bc5f567978faddca$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $bc5f567978faddca$var$Yk(a, c);
}
function $bc5f567978faddca$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($bc5f567978faddca$var$p(314));
    }
    null !== d && d.delete(b);
    $bc5f567978faddca$var$Yk(a, c);
}
var $bc5f567978faddca$var$Vk;
$bc5f567978faddca$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $bc5f567978faddca$var$Wf.current) $bc5f567978faddca$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $bc5f567978faddca$var$dh = !1, $bc5f567978faddca$var$yj(a, b, c);
            $bc5f567978faddca$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $bc5f567978faddca$var$dh = !1, $bc5f567978faddca$var$I && 0 !== (b.flags & 1048576) && $bc5f567978faddca$var$ug(b, $bc5f567978faddca$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $bc5f567978faddca$var$ij(a, b);
            a = b.pendingProps;
            var e = $bc5f567978faddca$var$Yf(b, $bc5f567978faddca$var$H.current);
            $bc5f567978faddca$var$ch(b, c);
            e = $bc5f567978faddca$var$Nh(null, b, d, a, e, c);
            var f = $bc5f567978faddca$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $bc5f567978faddca$var$Zf(d) ? (f = !0, $bc5f567978faddca$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $bc5f567978faddca$var$kh(b), e.updater = $bc5f567978faddca$var$Ei, b.stateNode = e, e._reactInternals = b, $bc5f567978faddca$var$Ii(b, d, a, c), b = $bc5f567978faddca$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $bc5f567978faddca$var$I && f && $bc5f567978faddca$var$vg(b), $bc5f567978faddca$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $bc5f567978faddca$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $bc5f567978faddca$var$Zk(d);
                a = $bc5f567978faddca$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $bc5f567978faddca$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $bc5f567978faddca$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $bc5f567978faddca$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $bc5f567978faddca$var$$i(null, b, d, $bc5f567978faddca$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($bc5f567978faddca$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bc5f567978faddca$var$Ci(d, e), $bc5f567978faddca$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bc5f567978faddca$var$Ci(d, e), $bc5f567978faddca$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $bc5f567978faddca$var$kj(b);
                if (null === a) throw Error($bc5f567978faddca$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $bc5f567978faddca$var$lh(a, b);
                $bc5f567978faddca$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $bc5f567978faddca$var$Ji(Error($bc5f567978faddca$var$p(423)), b);
                        b = $bc5f567978faddca$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $bc5f567978faddca$var$Ji(Error($bc5f567978faddca$var$p(424)), b);
                        b = $bc5f567978faddca$var$lj(a, b, d, c, e);
                        break a;
                    } else for($bc5f567978faddca$var$yg = $bc5f567978faddca$var$Lf(b.stateNode.containerInfo.firstChild), $bc5f567978faddca$var$xg = b, $bc5f567978faddca$var$I = !0, $bc5f567978faddca$var$zg = null, c = $bc5f567978faddca$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $bc5f567978faddca$var$Ig();
                    if (d === e) {
                        b = $bc5f567978faddca$var$Zi(a, b, c);
                        break a;
                    }
                    $bc5f567978faddca$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $bc5f567978faddca$var$Ah(b), null === a && $bc5f567978faddca$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $bc5f567978faddca$var$Ef(d, e) ? g = null : null !== f && $bc5f567978faddca$var$Ef(d, f) && (b.flags |= 32), $bc5f567978faddca$var$gj(a, b), $bc5f567978faddca$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $bc5f567978faddca$var$Eg(b), null;
        case 13:
            return $bc5f567978faddca$var$oj(a, b, c);
        case 4:
            return $bc5f567978faddca$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $bc5f567978faddca$var$Ug(b, null, d, c) : $bc5f567978faddca$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bc5f567978faddca$var$Ci(d, e), $bc5f567978faddca$var$Yi(a, b, d, e, c);
        case 7:
            return $bc5f567978faddca$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $bc5f567978faddca$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $bc5f567978faddca$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $bc5f567978faddca$var$G($bc5f567978faddca$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($bc5f567978faddca$var$He(f.value, g)) {
                        if (f.children === e.children && !$bc5f567978faddca$var$Wf.current) {
                            b = $bc5f567978faddca$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $bc5f567978faddca$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $bc5f567978faddca$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($bc5f567978faddca$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $bc5f567978faddca$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $bc5f567978faddca$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $bc5f567978faddca$var$ch(b, c), e = $bc5f567978faddca$var$eh(e), d = d(e), b.flags |= 1, $bc5f567978faddca$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $bc5f567978faddca$var$Ci(d, b.pendingProps), e = $bc5f567978faddca$var$Ci(d.type, e), $bc5f567978faddca$var$$i(a, b, d, e, c);
        case 15:
            return $bc5f567978faddca$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $bc5f567978faddca$var$Ci(d, e), $bc5f567978faddca$var$ij(a, b), b.tag = 1, $bc5f567978faddca$var$Zf(d) ? (a = !0, $bc5f567978faddca$var$cg(b)) : a = !1, $bc5f567978faddca$var$ch(b, c), $bc5f567978faddca$var$Gi(b, d, e), $bc5f567978faddca$var$Ii(b, d, e, c), $bc5f567978faddca$var$jj(null, b, d, !0, a, c);
        case 19:
            return $bc5f567978faddca$var$xj(a, b, c);
        case 22:
            return $bc5f567978faddca$var$dj(a, b, c);
    }
    throw Error($bc5f567978faddca$var$p(156, b.tag));
};
function $bc5f567978faddca$var$Fk(a, b) {
    return $bc5f567978faddca$var$ac(a, b);
}
function $bc5f567978faddca$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bc5f567978faddca$var$Bg(a, b, c, d) {
    return new $bc5f567978faddca$var$$k(a, b, c, d);
}
function $bc5f567978faddca$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $bc5f567978faddca$var$Zk(a) {
    if ("function" === typeof a) return $bc5f567978faddca$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $bc5f567978faddca$var$Da) return 11;
        if (a === $bc5f567978faddca$var$Ga) return 14;
    }
    return 2;
}
function $bc5f567978faddca$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $bc5f567978faddca$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $bc5f567978faddca$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $bc5f567978faddca$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $bc5f567978faddca$var$ya:
            return $bc5f567978faddca$var$Tg(c.children, e, f, b);
        case $bc5f567978faddca$var$za:
            g = 8;
            e |= 8;
            break;
        case $bc5f567978faddca$var$Aa:
            return a = $bc5f567978faddca$var$Bg(12, c, b, e | 2), a.elementType = $bc5f567978faddca$var$Aa, a.lanes = f, a;
        case $bc5f567978faddca$var$Ea:
            return a = $bc5f567978faddca$var$Bg(13, c, b, e), a.elementType = $bc5f567978faddca$var$Ea, a.lanes = f, a;
        case $bc5f567978faddca$var$Fa:
            return a = $bc5f567978faddca$var$Bg(19, c, b, e), a.elementType = $bc5f567978faddca$var$Fa, a.lanes = f, a;
        case $bc5f567978faddca$var$Ia:
            return $bc5f567978faddca$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $bc5f567978faddca$var$Ba:
                    g = 10;
                    break a;
                case $bc5f567978faddca$var$Ca:
                    g = 9;
                    break a;
                case $bc5f567978faddca$var$Da:
                    g = 11;
                    break a;
                case $bc5f567978faddca$var$Ga:
                    g = 14;
                    break a;
                case $bc5f567978faddca$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($bc5f567978faddca$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $bc5f567978faddca$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $bc5f567978faddca$var$Tg(a, b, c, d) {
    a = $bc5f567978faddca$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $bc5f567978faddca$var$pj(a, b, c, d) {
    a = $bc5f567978faddca$var$Bg(22, a, d, b);
    a.elementType = $bc5f567978faddca$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $bc5f567978faddca$var$Qg(a, b, c) {
    a = $bc5f567978faddca$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $bc5f567978faddca$var$Sg(a, b, c) {
    b = $bc5f567978faddca$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $bc5f567978faddca$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $bc5f567978faddca$var$zc(0);
    this.expirationTimes = $bc5f567978faddca$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bc5f567978faddca$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $bc5f567978faddca$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $bc5f567978faddca$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $bc5f567978faddca$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $bc5f567978faddca$var$kh(f);
    return a;
}
function $bc5f567978faddca$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bc5f567978faddca$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $bc5f567978faddca$var$dl(a) {
    if (!a) return $bc5f567978faddca$var$Vf;
    a = a._reactInternals;
    a: {
        if ($bc5f567978faddca$var$Vb(a) !== a || 1 !== a.tag) throw Error($bc5f567978faddca$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($bc5f567978faddca$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($bc5f567978faddca$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($bc5f567978faddca$var$Zf(c)) return $bc5f567978faddca$var$bg(a, c, b);
    }
    return b;
}
function $bc5f567978faddca$var$el(a, b, c, d, e, f, g, h, k) {
    a = $bc5f567978faddca$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $bc5f567978faddca$var$dl(null);
    c = a.current;
    d = $bc5f567978faddca$var$R();
    e = $bc5f567978faddca$var$yi(c);
    f = $bc5f567978faddca$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $bc5f567978faddca$var$nh(c, f, e);
    a.current.lanes = e;
    $bc5f567978faddca$var$Ac(a, e, d);
    $bc5f567978faddca$var$Dk(a, d);
    return a;
}
function $bc5f567978faddca$var$fl(a, b, c, d) {
    var e = b.current, f = $bc5f567978faddca$var$R(), g = $bc5f567978faddca$var$yi(e);
    c = $bc5f567978faddca$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $bc5f567978faddca$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $bc5f567978faddca$var$nh(e, b, g);
    null !== a && ($bc5f567978faddca$var$gi(a, e, g, f), $bc5f567978faddca$var$oh(a, e, g));
    return g;
}
function $bc5f567978faddca$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $bc5f567978faddca$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $bc5f567978faddca$var$il(a, b) {
    $bc5f567978faddca$var$hl(a, b);
    (a = a.alternate) && $bc5f567978faddca$var$hl(a, b);
}
function $bc5f567978faddca$var$jl() {
    return null;
}
var $bc5f567978faddca$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $bc5f567978faddca$var$ll(a) {
    this._internalRoot = a;
}
$bc5f567978faddca$var$ml.prototype.render = $bc5f567978faddca$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($bc5f567978faddca$var$p(409));
    $bc5f567978faddca$var$fl(a, b, null, null);
};
$bc5f567978faddca$var$ml.prototype.unmount = $bc5f567978faddca$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $bc5f567978faddca$var$Rk(function() {
            $bc5f567978faddca$var$fl(null, a, null, null);
        });
        b[$bc5f567978faddca$var$uf] = null;
    }
};
function $bc5f567978faddca$var$ml(a) {
    this._internalRoot = a;
}
$bc5f567978faddca$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $bc5f567978faddca$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $bc5f567978faddca$var$Qc.length && 0 !== b && b < $bc5f567978faddca$var$Qc[c].priority; c++);
        $bc5f567978faddca$var$Qc.splice(c, 0, a);
        0 === c && $bc5f567978faddca$var$Vc(a);
    }
};
function $bc5f567978faddca$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $bc5f567978faddca$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $bc5f567978faddca$var$pl() {}
function $bc5f567978faddca$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $bc5f567978faddca$var$gl(g);
                f.call(a);
            };
        }
        var g = $bc5f567978faddca$var$el(b, d, a, 0, null, !1, !1, "", $bc5f567978faddca$var$pl);
        a._reactRootContainer = g;
        a[$bc5f567978faddca$var$uf] = g.current;
        $bc5f567978faddca$var$sf(8 === a.nodeType ? a.parentNode : a);
        $bc5f567978faddca$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $bc5f567978faddca$var$gl(k);
            h.call(a);
        };
    }
    var k = $bc5f567978faddca$var$bl(a, 0, !1, null, null, !1, !1, "", $bc5f567978faddca$var$pl);
    a._reactRootContainer = k;
    a[$bc5f567978faddca$var$uf] = k.current;
    $bc5f567978faddca$var$sf(8 === a.nodeType ? a.parentNode : a);
    $bc5f567978faddca$var$Rk(function() {
        $bc5f567978faddca$var$fl(b, k, c, d);
    });
    return k;
}
function $bc5f567978faddca$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $bc5f567978faddca$var$gl(g);
                h.call(a);
            };
        }
        $bc5f567978faddca$var$fl(b, g, a, e);
    } else g = $bc5f567978faddca$var$ql(c, b, a, e, d);
    return $bc5f567978faddca$var$gl(g);
}
$bc5f567978faddca$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $bc5f567978faddca$var$tc(b.pendingLanes);
                0 !== c && ($bc5f567978faddca$var$Cc(b, c | 1), $bc5f567978faddca$var$Dk(b, $bc5f567978faddca$var$B()), 0 === ($bc5f567978faddca$var$K & 6) && ($bc5f567978faddca$var$Gj = $bc5f567978faddca$var$B() + 500, $bc5f567978faddca$var$jg()));
            }
            break;
        case 13:
            $bc5f567978faddca$var$Rk(function() {
                var b = $bc5f567978faddca$var$ih(a, 1);
                if (null !== b) {
                    var c = $bc5f567978faddca$var$R();
                    $bc5f567978faddca$var$gi(b, a, 1, c);
                }
            }), $bc5f567978faddca$var$il(a, 1);
    }
};
$bc5f567978faddca$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $bc5f567978faddca$var$ih(a, 134217728);
        if (null !== b) {
            var c = $bc5f567978faddca$var$R();
            $bc5f567978faddca$var$gi(b, a, 134217728, c);
        }
        $bc5f567978faddca$var$il(a, 134217728);
    }
};
$bc5f567978faddca$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $bc5f567978faddca$var$yi(a), c = $bc5f567978faddca$var$ih(a, b);
        if (null !== c) {
            var d = $bc5f567978faddca$var$R();
            $bc5f567978faddca$var$gi(c, a, b, d);
        }
        $bc5f567978faddca$var$il(a, b);
    }
};
$bc5f567978faddca$var$Hc = function() {
    return $bc5f567978faddca$var$C;
};
$bc5f567978faddca$var$Ic = function(a, b) {
    var c = $bc5f567978faddca$var$C;
    try {
        return $bc5f567978faddca$var$C = a, b();
    } finally{
        $bc5f567978faddca$var$C = c;
    }
};
$bc5f567978faddca$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $bc5f567978faddca$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $bc5f567978faddca$var$Db(d);
                        if (!e) throw Error($bc5f567978faddca$var$p(90));
                        $bc5f567978faddca$var$Wa(d);
                        $bc5f567978faddca$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $bc5f567978faddca$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $bc5f567978faddca$var$fb(a, !!c.multiple, b, !1);
    }
};
$bc5f567978faddca$var$Gb = $bc5f567978faddca$var$Qk;
$bc5f567978faddca$var$Hb = $bc5f567978faddca$var$Rk;
var $bc5f567978faddca$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $bc5f567978faddca$var$Cb,
        $bc5f567978faddca$var$ue,
        $bc5f567978faddca$var$Db,
        $bc5f567978faddca$var$Eb,
        $bc5f567978faddca$var$Fb,
        $bc5f567978faddca$var$Qk
    ]
}, $bc5f567978faddca$var$tl = {
    findFiberByHostInstance: $bc5f567978faddca$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $bc5f567978faddca$var$ul = {
    bundleType: $bc5f567978faddca$var$tl.bundleType,
    version: $bc5f567978faddca$var$tl.version,
    rendererPackageName: $bc5f567978faddca$var$tl.rendererPackageName,
    rendererConfig: $bc5f567978faddca$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $bc5f567978faddca$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $bc5f567978faddca$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $bc5f567978faddca$var$tl.findFiberByHostInstance || $bc5f567978faddca$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bc5f567978faddca$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bc5f567978faddca$var$vl.isDisabled && $bc5f567978faddca$var$vl.supportsFiber) try {
        $bc5f567978faddca$var$kc = $bc5f567978faddca$var$vl.inject($bc5f567978faddca$var$ul), $bc5f567978faddca$var$lc = $bc5f567978faddca$var$vl;
    } catch (a) {}
}
$bc5f567978faddca$export$ae55be85d98224ed = $bc5f567978faddca$var$sl;
$bc5f567978faddca$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$bc5f567978faddca$var$nl(b)) throw Error($bc5f567978faddca$var$p(200));
    return $bc5f567978faddca$var$cl(a, b, null, c);
};
$bc5f567978faddca$export$882461b6382ed46c = function(a, b) {
    if (!$bc5f567978faddca$var$nl(a)) throw Error($bc5f567978faddca$var$p(299));
    var c = !1, d = "", e = $bc5f567978faddca$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $bc5f567978faddca$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$bc5f567978faddca$var$uf] = b.current;
    $bc5f567978faddca$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $bc5f567978faddca$var$ll(b);
};
$bc5f567978faddca$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($bc5f567978faddca$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($bc5f567978faddca$var$p(268, a));
    }
    a = $bc5f567978faddca$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$bc5f567978faddca$export$cd75ccfd720a3cd4 = function(a) {
    return $bc5f567978faddca$var$Rk(a);
};
$bc5f567978faddca$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$bc5f567978faddca$var$ol(b)) throw Error($bc5f567978faddca$var$p(200));
    return $bc5f567978faddca$var$rl(null, a, b, !0, c);
};
$bc5f567978faddca$export$757ceba2d55c277e = function(a, b, c) {
    if (!$bc5f567978faddca$var$nl(a)) throw Error($bc5f567978faddca$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $bc5f567978faddca$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $bc5f567978faddca$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$bc5f567978faddca$var$uf] = b.current;
    $bc5f567978faddca$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $bc5f567978faddca$var$ml(b);
};
$bc5f567978faddca$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$bc5f567978faddca$var$ol(b)) throw Error($bc5f567978faddca$var$p(200));
    return $bc5f567978faddca$var$rl(null, a, b, !1, c);
};
$bc5f567978faddca$export$502457920280e6be = function(a) {
    if (!$bc5f567978faddca$var$ol(a)) throw Error($bc5f567978faddca$var$p(40));
    return a._reactRootContainer ? ($bc5f567978faddca$var$Rk(function() {
        $bc5f567978faddca$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$bc5f567978faddca$var$uf] = null;
        });
    }), !0) : !1;
};
$bc5f567978faddca$export$c78a37762a8d58e1 = $bc5f567978faddca$var$Qk;
$bc5f567978faddca$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$bc5f567978faddca$var$ol(c)) throw Error($bc5f567978faddca$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($bc5f567978faddca$var$p(38));
    return $bc5f567978faddca$var$rl(a, b, c, !1, d);
};
$bc5f567978faddca$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fxLu7", function(module, exports) {
'use strict';

module.exports = (parcelRequire("k5KFB"));

});
parcelRegister("k5KFB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ea0879f9e82260fb$export$c4744153514ff05d; }, function (v) { return $ea0879f9e82260fb$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ea0879f9e82260fb$export$3e506c1ccc9cc1a7; }, function (v) { return $ea0879f9e82260fb$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ea0879f9e82260fb$export$e26fe2ed2fa76875; }, function (v) { return $ea0879f9e82260fb$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ea0879f9e82260fb$export$502329bbf4b505b1; }, function (v) { return $ea0879f9e82260fb$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ea0879f9e82260fb$export$6e3807111c4874c4; }, function (v) { return $ea0879f9e82260fb$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ea0879f9e82260fb$export$c27134553091fb3a; }, function (v) { return $ea0879f9e82260fb$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ea0879f9e82260fb$export$33ee1acdc04fd2a2; }, function (v) { return $ea0879f9e82260fb$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ea0879f9e82260fb$export$b00a404bbd5edef2; }, function (v) { return $ea0879f9e82260fb$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ea0879f9e82260fb$export$8352ce38b91d0c62; }, function (v) { return $ea0879f9e82260fb$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ea0879f9e82260fb$export$d66a1c1c77bd778b; }, function (v) { return $ea0879f9e82260fb$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ea0879f9e82260fb$export$d3dfb8e4810cb555; }, function (v) { return $ea0879f9e82260fb$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ea0879f9e82260fb$export$839f9183b0465a69; }, function (v) { return $ea0879f9e82260fb$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ea0879f9e82260fb$export$72fdf0e06517287b; }, function (v) { return $ea0879f9e82260fb$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ea0879f9e82260fb$export$4b844e58a3e414b4; }, function (v) { return $ea0879f9e82260fb$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ea0879f9e82260fb$export$816d2913ae6b83b1; }, function (v) { return $ea0879f9e82260fb$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ea0879f9e82260fb$export$61bcfe829111a1d0; }, function (v) { return $ea0879f9e82260fb$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ea0879f9e82260fb$export$7ee8c9beb337bc3f; }, function (v) { return $ea0879f9e82260fb$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ea0879f9e82260fb$export$b5836b71941fa3ed; }, function (v) { return $ea0879f9e82260fb$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ea0879f9e82260fb$export$cf845f2c119da08a; }, function (v) { return $ea0879f9e82260fb$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea0879f9e82260fb$export$c4744153514ff05d;
var $ea0879f9e82260fb$export$3e506c1ccc9cc1a7;
var $ea0879f9e82260fb$export$e26fe2ed2fa76875;
var $ea0879f9e82260fb$export$502329bbf4b505b1;
var $ea0879f9e82260fb$export$6e3807111c4874c4;
var $ea0879f9e82260fb$export$c27134553091fb3a;
var $ea0879f9e82260fb$export$33ee1acdc04fd2a2;
var $ea0879f9e82260fb$export$b00a404bbd5edef2;
var $ea0879f9e82260fb$export$8352ce38b91d0c62;
var $ea0879f9e82260fb$export$d66a1c1c77bd778b;
var $ea0879f9e82260fb$export$d3dfb8e4810cb555;
var $ea0879f9e82260fb$export$839f9183b0465a69;
var $ea0879f9e82260fb$export$72fdf0e06517287b;
var $ea0879f9e82260fb$export$4b844e58a3e414b4;
var $ea0879f9e82260fb$export$816d2913ae6b83b1;
var $ea0879f9e82260fb$export$61bcfe829111a1d0;
var $ea0879f9e82260fb$export$7ee8c9beb337bc3f;
var $ea0879f9e82260fb$export$b5836b71941fa3ed;
var $ea0879f9e82260fb$export$cf845f2c119da08a;
'use strict';
function $ea0879f9e82260fb$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ea0879f9e82260fb$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ea0879f9e82260fb$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ea0879f9e82260fb$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ea0879f9e82260fb$var$g(C, c)) n < e && 0 > $ea0879f9e82260fb$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ea0879f9e82260fb$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ea0879f9e82260fb$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ea0879f9e82260fb$var$l = performance;
    $ea0879f9e82260fb$export$c4744153514ff05d = function() {
        return $ea0879f9e82260fb$var$l.now();
    };
} else {
    var $ea0879f9e82260fb$var$p = Date, $ea0879f9e82260fb$var$q = $ea0879f9e82260fb$var$p.now();
    $ea0879f9e82260fb$export$c4744153514ff05d = function() {
        return $ea0879f9e82260fb$var$p.now() - $ea0879f9e82260fb$var$q;
    };
}
var $ea0879f9e82260fb$var$r = [], $ea0879f9e82260fb$var$t = [], $ea0879f9e82260fb$var$u = 1, $ea0879f9e82260fb$var$v = null, $ea0879f9e82260fb$var$y = 3, $ea0879f9e82260fb$var$z = !1, $ea0879f9e82260fb$var$A = !1, $ea0879f9e82260fb$var$B = !1, $ea0879f9e82260fb$var$D = "function" === typeof setTimeout ? setTimeout : null, $ea0879f9e82260fb$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ea0879f9e82260fb$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ea0879f9e82260fb$var$G(a) {
    for(var b = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t); null !== b;){
        if (null === b.callback) $ea0879f9e82260fb$var$k($ea0879f9e82260fb$var$t);
        else if (b.startTime <= a) $ea0879f9e82260fb$var$k($ea0879f9e82260fb$var$t), b.sortIndex = b.expirationTime, $ea0879f9e82260fb$var$f($ea0879f9e82260fb$var$r, b);
        else break;
        b = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t);
    }
}
function $ea0879f9e82260fb$var$H(a) {
    $ea0879f9e82260fb$var$B = !1;
    $ea0879f9e82260fb$var$G(a);
    if (!$ea0879f9e82260fb$var$A) {
        if (null !== $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r)) $ea0879f9e82260fb$var$A = !0, $ea0879f9e82260fb$var$I($ea0879f9e82260fb$var$J);
        else {
            var b = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t);
            null !== b && $ea0879f9e82260fb$var$K($ea0879f9e82260fb$var$H, b.startTime - a);
        }
    }
}
function $ea0879f9e82260fb$var$J(a, b) {
    $ea0879f9e82260fb$var$A = !1;
    $ea0879f9e82260fb$var$B && ($ea0879f9e82260fb$var$B = !1, $ea0879f9e82260fb$var$E($ea0879f9e82260fb$var$L), $ea0879f9e82260fb$var$L = -1);
    $ea0879f9e82260fb$var$z = !0;
    var c = $ea0879f9e82260fb$var$y;
    try {
        $ea0879f9e82260fb$var$G(b);
        for($ea0879f9e82260fb$var$v = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r); null !== $ea0879f9e82260fb$var$v && (!($ea0879f9e82260fb$var$v.expirationTime > b) || a && !$ea0879f9e82260fb$var$M());){
            var d = $ea0879f9e82260fb$var$v.callback;
            if ("function" === typeof d) {
                $ea0879f9e82260fb$var$v.callback = null;
                $ea0879f9e82260fb$var$y = $ea0879f9e82260fb$var$v.priorityLevel;
                var e = d($ea0879f9e82260fb$var$v.expirationTime <= b);
                b = $ea0879f9e82260fb$export$c4744153514ff05d();
                "function" === typeof e ? $ea0879f9e82260fb$var$v.callback = e : $ea0879f9e82260fb$var$v === $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r) && $ea0879f9e82260fb$var$k($ea0879f9e82260fb$var$r);
                $ea0879f9e82260fb$var$G(b);
            } else $ea0879f9e82260fb$var$k($ea0879f9e82260fb$var$r);
            $ea0879f9e82260fb$var$v = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r);
        }
        if (null !== $ea0879f9e82260fb$var$v) var w = !0;
        else {
            var m = $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t);
            null !== m && $ea0879f9e82260fb$var$K($ea0879f9e82260fb$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ea0879f9e82260fb$var$v = null, $ea0879f9e82260fb$var$y = c, $ea0879f9e82260fb$var$z = !1;
    }
}
var $ea0879f9e82260fb$var$N = !1, $ea0879f9e82260fb$var$O = null, $ea0879f9e82260fb$var$L = -1, $ea0879f9e82260fb$var$P = 5, $ea0879f9e82260fb$var$Q = -1;
function $ea0879f9e82260fb$var$M() {
    return $ea0879f9e82260fb$export$c4744153514ff05d() - $ea0879f9e82260fb$var$Q < $ea0879f9e82260fb$var$P ? !1 : !0;
}
function $ea0879f9e82260fb$var$R() {
    if (null !== $ea0879f9e82260fb$var$O) {
        var a = $ea0879f9e82260fb$export$c4744153514ff05d();
        $ea0879f9e82260fb$var$Q = a;
        var b = !0;
        try {
            b = $ea0879f9e82260fb$var$O(!0, a);
        } finally{
            b ? $ea0879f9e82260fb$var$S() : ($ea0879f9e82260fb$var$N = !1, $ea0879f9e82260fb$var$O = null);
        }
    } else $ea0879f9e82260fb$var$N = !1;
}
var $ea0879f9e82260fb$var$S;
if ("function" === typeof $ea0879f9e82260fb$var$F) $ea0879f9e82260fb$var$S = function() {
    $ea0879f9e82260fb$var$F($ea0879f9e82260fb$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ea0879f9e82260fb$var$T = new MessageChannel, $ea0879f9e82260fb$var$U = $ea0879f9e82260fb$var$T.port2;
    $ea0879f9e82260fb$var$T.port1.onmessage = $ea0879f9e82260fb$var$R;
    $ea0879f9e82260fb$var$S = function() {
        $ea0879f9e82260fb$var$U.postMessage(null);
    };
} else $ea0879f9e82260fb$var$S = function() {
    $ea0879f9e82260fb$var$D($ea0879f9e82260fb$var$R, 0);
};
function $ea0879f9e82260fb$var$I(a) {
    $ea0879f9e82260fb$var$O = a;
    $ea0879f9e82260fb$var$N || ($ea0879f9e82260fb$var$N = !0, $ea0879f9e82260fb$var$S());
}
function $ea0879f9e82260fb$var$K(a, b) {
    $ea0879f9e82260fb$var$L = $ea0879f9e82260fb$var$D(function() {
        a($ea0879f9e82260fb$export$c4744153514ff05d());
    }, b);
}
$ea0879f9e82260fb$export$3e506c1ccc9cc1a7 = 5;
$ea0879f9e82260fb$export$e26fe2ed2fa76875 = 1;
$ea0879f9e82260fb$export$502329bbf4b505b1 = 4;
$ea0879f9e82260fb$export$6e3807111c4874c4 = 3;
$ea0879f9e82260fb$export$c27134553091fb3a = null;
$ea0879f9e82260fb$export$33ee1acdc04fd2a2 = 2;
$ea0879f9e82260fb$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ea0879f9e82260fb$export$8352ce38b91d0c62 = function() {
    $ea0879f9e82260fb$var$A || $ea0879f9e82260fb$var$z || ($ea0879f9e82260fb$var$A = !0, $ea0879f9e82260fb$var$I($ea0879f9e82260fb$var$J));
};
$ea0879f9e82260fb$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ea0879f9e82260fb$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ea0879f9e82260fb$export$d3dfb8e4810cb555 = function() {
    return $ea0879f9e82260fb$var$y;
};
$ea0879f9e82260fb$export$839f9183b0465a69 = function() {
    return $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r);
};
$ea0879f9e82260fb$export$72fdf0e06517287b = function(a) {
    switch($ea0879f9e82260fb$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ea0879f9e82260fb$var$y;
    }
    var c = $ea0879f9e82260fb$var$y;
    $ea0879f9e82260fb$var$y = b;
    try {
        return a();
    } finally{
        $ea0879f9e82260fb$var$y = c;
    }
};
$ea0879f9e82260fb$export$4b844e58a3e414b4 = function() {};
$ea0879f9e82260fb$export$816d2913ae6b83b1 = function() {};
$ea0879f9e82260fb$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ea0879f9e82260fb$var$y;
    $ea0879f9e82260fb$var$y = a;
    try {
        return b();
    } finally{
        $ea0879f9e82260fb$var$y = c;
    }
};
$ea0879f9e82260fb$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ea0879f9e82260fb$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ea0879f9e82260fb$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ea0879f9e82260fb$var$f($ea0879f9e82260fb$var$t, a), null === $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$r) && a === $ea0879f9e82260fb$var$h($ea0879f9e82260fb$var$t) && ($ea0879f9e82260fb$var$B ? ($ea0879f9e82260fb$var$E($ea0879f9e82260fb$var$L), $ea0879f9e82260fb$var$L = -1) : $ea0879f9e82260fb$var$B = !0, $ea0879f9e82260fb$var$K($ea0879f9e82260fb$var$H, c - d))) : (a.sortIndex = e, $ea0879f9e82260fb$var$f($ea0879f9e82260fb$var$r, a), $ea0879f9e82260fb$var$A || $ea0879f9e82260fb$var$z || ($ea0879f9e82260fb$var$A = !0, $ea0879f9e82260fb$var$I($ea0879f9e82260fb$var$J)));
    return a;
};
$ea0879f9e82260fb$export$b5836b71941fa3ed = $ea0879f9e82260fb$var$M;
$ea0879f9e82260fb$export$cf845f2c119da08a = function(a) {
    var b = $ea0879f9e82260fb$var$y;
    return function() {
        var c = $ea0879f9e82260fb$var$y;
        $ea0879f9e82260fb$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ea0879f9e82260fb$var$y = c;
        }
    };
};

});



parcelRegister("94WEq", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map'), nativeCreate = getNative(Object, 'create');
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("4vp6j", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.40
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.40', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HUAWEI = 'Huawei', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', OPERA = 'Opera', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /(?:honor)([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Honor'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Lenovo'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    'Nokia'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OnePlus'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("g1KQj", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("bbNXs", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map'), nativeCreate = getNative(Object, 'create');
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRegister("gkDLY", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $be3d5da9d58b920c$export$306c0aa65ff9ec16; }, function (v) { return $be3d5da9d58b920c$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $be3d5da9d58b920c$export$306c0aa65ff9ec16;
"use strict";

var $aivMx = parcelRequire("aivMx");
function $be3d5da9d58b920c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $be3d5da9d58b920c$var$objectIs = "function" === typeof Object.is ? Object.is : $be3d5da9d58b920c$var$is, $be3d5da9d58b920c$var$useState = $aivMx.useState, $be3d5da9d58b920c$var$useEffect = $aivMx.useEffect, $be3d5da9d58b920c$var$useLayoutEffect = $aivMx.useLayoutEffect, $be3d5da9d58b920c$var$useDebugValue = $aivMx.useDebugValue;
function $be3d5da9d58b920c$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $be3d5da9d58b920c$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $be3d5da9d58b920c$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $be3d5da9d58b920c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $be3d5da9d58b920c$var$useEffect(function() {
        $be3d5da9d58b920c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $be3d5da9d58b920c$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $be3d5da9d58b920c$var$useDebugValue(value);
    return value;
}
function $be3d5da9d58b920c$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$be3d5da9d58b920c$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $be3d5da9d58b920c$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $be3d5da9d58b920c$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $be3d5da9d58b920c$var$useSyncExternalStore$1 : $be3d5da9d58b920c$var$useSyncExternalStore$2;
$be3d5da9d58b920c$export$306c0aa65ff9ec16 = void 0 !== $aivMx.useSyncExternalStore ? $aivMx.useSyncExternalStore : $be3d5da9d58b920c$var$shim;

});

parcelRegister("cr0L2", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $90d8981af7d172e9$export$bf730a2d8bf68b42; }, function (v) { return $90d8981af7d172e9$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $90d8981af7d172e9$export$bf730a2d8bf68b42;
"use strict";

var $aivMx = parcelRequire("aivMx");

var $5MEMe = parcelRequire("5MEMe");
function $90d8981af7d172e9$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $90d8981af7d172e9$var$objectIs = "function" === typeof Object.is ? Object.is : $90d8981af7d172e9$var$is, $90d8981af7d172e9$var$useSyncExternalStore = $5MEMe.useSyncExternalStore, $90d8981af7d172e9$var$useRef = $aivMx.useRef, $90d8981af7d172e9$var$useEffect = $aivMx.useEffect, $90d8981af7d172e9$var$useMemo = $aivMx.useMemo, $90d8981af7d172e9$var$useDebugValue = $aivMx.useDebugValue;
$90d8981af7d172e9$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $90d8981af7d172e9$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $90d8981af7d172e9$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($90d8981af7d172e9$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $90d8981af7d172e9$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $90d8981af7d172e9$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $90d8981af7d172e9$var$useDebugValue(value);
    return value;
};

});
parcelRegister("5MEMe", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gkDLY"));

});


parcelRegister("A9JWB", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $06caeb137d83ef6a$export$2b8d127b894957b9; }, function (v) { return $06caeb137d83ef6a$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $06caeb137d83ef6a$export$cea3a54a6425200c; }, function (v) { return $06caeb137d83ef6a$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $06caeb137d83ef6a$export$a7c73072b1a182ae; }, function (v) { return $06caeb137d83ef6a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $06caeb137d83ef6a$export$9f27bc3417b4524d; }, function (v) { return $06caeb137d83ef6a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $06caeb137d83ef6a$export$db77ccec0bb4ccac; }, function (v) { return $06caeb137d83ef6a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $06caeb137d83ef6a$export$8392c0c9d3dcbd35; }, function (v) { return $06caeb137d83ef6a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $06caeb137d83ef6a$export$ffb0004e005737fa; }, function (v) { return $06caeb137d83ef6a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $06caeb137d83ef6a$export$b624eff549462981; }, function (v) { return $06caeb137d83ef6a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $06caeb137d83ef6a$export$7897aa7841a5380c; }, function (v) { return $06caeb137d83ef6a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $06caeb137d83ef6a$export$602eac185826482c; }, function (v) { return $06caeb137d83ef6a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $06caeb137d83ef6a$export$e2c29f18771995cb; }, function (v) { return $06caeb137d83ef6a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $06caeb137d83ef6a$export$5f8d39834fd61797; }, function (v) { return $06caeb137d83ef6a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $06caeb137d83ef6a$export$74bf444e3cd11ea5; }, function (v) { return $06caeb137d83ef6a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $06caeb137d83ef6a$export$92387174baf9b227; }, function (v) { return $06caeb137d83ef6a$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $06caeb137d83ef6a$export$ec112efeb987d9c6; }, function (v) { return $06caeb137d83ef6a$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $06caeb137d83ef6a$export$b706b080d889d2c9; }, function (v) { return $06caeb137d83ef6a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $06caeb137d83ef6a$export$5be5a87408f70ddc; }, function (v) { return $06caeb137d83ef6a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $06caeb137d83ef6a$export$45a5e7f76e0caa8d; }, function (v) { return $06caeb137d83ef6a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $06caeb137d83ef6a$export$455c2e768291efa6; }, function (v) { return $06caeb137d83ef6a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $06caeb137d83ef6a$export$9522e17588c12572; }, function (v) { return $06caeb137d83ef6a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $06caeb137d83ef6a$export$2110ac352bb060b9; }, function (v) { return $06caeb137d83ef6a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $06caeb137d83ef6a$export$56885ab8b9c456ab; }, function (v) { return $06caeb137d83ef6a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $06caeb137d83ef6a$export$d927fcb6adf8f9de; }, function (v) { return $06caeb137d83ef6a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $06caeb137d83ef6a$export$b82d16f27459e05a; }, function (v) { return $06caeb137d83ef6a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $06caeb137d83ef6a$export$522c17b4f5e123e8; }, function (v) { return $06caeb137d83ef6a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $06caeb137d83ef6a$export$1aabd8a0274ecfd6; }, function (v) { return $06caeb137d83ef6a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $06caeb137d83ef6a$export$9b621391a187a31a; }, function (v) { return $06caeb137d83ef6a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $06caeb137d83ef6a$export$f5bbd400c2f4426f; }, function (v) { return $06caeb137d83ef6a$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $06caeb137d83ef6a$export$2b8d127b894957b9;
var $06caeb137d83ef6a$export$cea3a54a6425200c;
var $06caeb137d83ef6a$export$a7c73072b1a182ae;
var $06caeb137d83ef6a$export$9f27bc3417b4524d;
var $06caeb137d83ef6a$export$db77ccec0bb4ccac;
var $06caeb137d83ef6a$export$8392c0c9d3dcbd35;
var $06caeb137d83ef6a$export$ffb0004e005737fa;
var $06caeb137d83ef6a$export$b624eff549462981;
var $06caeb137d83ef6a$export$7897aa7841a5380c;
var $06caeb137d83ef6a$export$602eac185826482c;
var $06caeb137d83ef6a$export$e2c29f18771995cb;
var $06caeb137d83ef6a$export$5f8d39834fd61797;
var $06caeb137d83ef6a$export$74bf444e3cd11ea5;
var $06caeb137d83ef6a$export$92387174baf9b227;
var $06caeb137d83ef6a$export$ec112efeb987d9c6;
var $06caeb137d83ef6a$export$b706b080d889d2c9;
var $06caeb137d83ef6a$export$5be5a87408f70ddc;
var $06caeb137d83ef6a$export$45a5e7f76e0caa8d;
var $06caeb137d83ef6a$export$455c2e768291efa6;
var $06caeb137d83ef6a$export$9522e17588c12572;
var $06caeb137d83ef6a$export$2110ac352bb060b9;
var $06caeb137d83ef6a$export$56885ab8b9c456ab;
var $06caeb137d83ef6a$export$d927fcb6adf8f9de;
var $06caeb137d83ef6a$export$b82d16f27459e05a;
var $06caeb137d83ef6a$export$522c17b4f5e123e8;
var $06caeb137d83ef6a$export$1aabd8a0274ecfd6;
var $06caeb137d83ef6a$export$9b621391a187a31a;
var $06caeb137d83ef6a$export$f5bbd400c2f4426f;
'use strict';
var $06caeb137d83ef6a$var$b = "function" === typeof Symbol && Symbol.for, $06caeb137d83ef6a$var$c = $06caeb137d83ef6a$var$b ? Symbol.for("react.element") : 60103, $06caeb137d83ef6a$var$d = $06caeb137d83ef6a$var$b ? Symbol.for("react.portal") : 60106, $06caeb137d83ef6a$var$e = $06caeb137d83ef6a$var$b ? Symbol.for("react.fragment") : 60107, $06caeb137d83ef6a$var$f = $06caeb137d83ef6a$var$b ? Symbol.for("react.strict_mode") : 60108, $06caeb137d83ef6a$var$g = $06caeb137d83ef6a$var$b ? Symbol.for("react.profiler") : 60114, $06caeb137d83ef6a$var$h = $06caeb137d83ef6a$var$b ? Symbol.for("react.provider") : 60109, $06caeb137d83ef6a$var$k = $06caeb137d83ef6a$var$b ? Symbol.for("react.context") : 60110, $06caeb137d83ef6a$var$l = $06caeb137d83ef6a$var$b ? Symbol.for("react.async_mode") : 60111, $06caeb137d83ef6a$var$m = $06caeb137d83ef6a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $06caeb137d83ef6a$var$n = $06caeb137d83ef6a$var$b ? Symbol.for("react.forward_ref") : 60112, $06caeb137d83ef6a$var$p = $06caeb137d83ef6a$var$b ? Symbol.for("react.suspense") : 60113, $06caeb137d83ef6a$var$q = $06caeb137d83ef6a$var$b ? Symbol.for("react.suspense_list") : 60120, $06caeb137d83ef6a$var$r = $06caeb137d83ef6a$var$b ? Symbol.for("react.memo") : 60115, $06caeb137d83ef6a$var$t = $06caeb137d83ef6a$var$b ? Symbol.for("react.lazy") : 60116, $06caeb137d83ef6a$var$v = $06caeb137d83ef6a$var$b ? Symbol.for("react.block") : 60121, $06caeb137d83ef6a$var$w = $06caeb137d83ef6a$var$b ? Symbol.for("react.fundamental") : 60117, $06caeb137d83ef6a$var$x = $06caeb137d83ef6a$var$b ? Symbol.for("react.responder") : 60118, $06caeb137d83ef6a$var$y = $06caeb137d83ef6a$var$b ? Symbol.for("react.scope") : 60119;
function $06caeb137d83ef6a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $06caeb137d83ef6a$var$c:
                switch(a = a.type, a){
                    case $06caeb137d83ef6a$var$l:
                    case $06caeb137d83ef6a$var$m:
                    case $06caeb137d83ef6a$var$e:
                    case $06caeb137d83ef6a$var$g:
                    case $06caeb137d83ef6a$var$f:
                    case $06caeb137d83ef6a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $06caeb137d83ef6a$var$k:
                            case $06caeb137d83ef6a$var$n:
                            case $06caeb137d83ef6a$var$t:
                            case $06caeb137d83ef6a$var$r:
                            case $06caeb137d83ef6a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $06caeb137d83ef6a$var$d:
                return u;
        }
    }
}
function $06caeb137d83ef6a$var$A(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$m;
}
$06caeb137d83ef6a$export$2b8d127b894957b9 = $06caeb137d83ef6a$var$l;
$06caeb137d83ef6a$export$cea3a54a6425200c = $06caeb137d83ef6a$var$m;
$06caeb137d83ef6a$export$a7c73072b1a182ae = $06caeb137d83ef6a$var$k;
$06caeb137d83ef6a$export$9f27bc3417b4524d = $06caeb137d83ef6a$var$h;
$06caeb137d83ef6a$export$db77ccec0bb4ccac = $06caeb137d83ef6a$var$c;
$06caeb137d83ef6a$export$8392c0c9d3dcbd35 = $06caeb137d83ef6a$var$n;
$06caeb137d83ef6a$export$ffb0004e005737fa = $06caeb137d83ef6a$var$e;
$06caeb137d83ef6a$export$b624eff549462981 = $06caeb137d83ef6a$var$t;
$06caeb137d83ef6a$export$7897aa7841a5380c = $06caeb137d83ef6a$var$r;
$06caeb137d83ef6a$export$602eac185826482c = $06caeb137d83ef6a$var$d;
$06caeb137d83ef6a$export$e2c29f18771995cb = $06caeb137d83ef6a$var$g;
$06caeb137d83ef6a$export$5f8d39834fd61797 = $06caeb137d83ef6a$var$f;
$06caeb137d83ef6a$export$74bf444e3cd11ea5 = $06caeb137d83ef6a$var$p;
$06caeb137d83ef6a$export$92387174baf9b227 = function(a) {
    return $06caeb137d83ef6a$var$A(a) || $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$l;
};
$06caeb137d83ef6a$export$ec112efeb987d9c6 = $06caeb137d83ef6a$var$A;
$06caeb137d83ef6a$export$b706b080d889d2c9 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$k;
};
$06caeb137d83ef6a$export$5be5a87408f70ddc = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$h;
};
$06caeb137d83ef6a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $06caeb137d83ef6a$var$c;
};
$06caeb137d83ef6a$export$455c2e768291efa6 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$n;
};
$06caeb137d83ef6a$export$9522e17588c12572 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$e;
};
$06caeb137d83ef6a$export$2110ac352bb060b9 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$t;
};
$06caeb137d83ef6a$export$56885ab8b9c456ab = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$r;
};
$06caeb137d83ef6a$export$d927fcb6adf8f9de = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$d;
};
$06caeb137d83ef6a$export$b82d16f27459e05a = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$g;
};
$06caeb137d83ef6a$export$522c17b4f5e123e8 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$f;
};
$06caeb137d83ef6a$export$1aabd8a0274ecfd6 = function(a) {
    return $06caeb137d83ef6a$var$z(a) === $06caeb137d83ef6a$var$p;
};
$06caeb137d83ef6a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $06caeb137d83ef6a$var$e || a === $06caeb137d83ef6a$var$m || a === $06caeb137d83ef6a$var$g || a === $06caeb137d83ef6a$var$f || a === $06caeb137d83ef6a$var$p || a === $06caeb137d83ef6a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $06caeb137d83ef6a$var$t || a.$$typeof === $06caeb137d83ef6a$var$r || a.$$typeof === $06caeb137d83ef6a$var$h || a.$$typeof === $06caeb137d83ef6a$var$k || a.$$typeof === $06caeb137d83ef6a$var$n || a.$$typeof === $06caeb137d83ef6a$var$w || a.$$typeof === $06caeb137d83ef6a$var$x || a.$$typeof === $06caeb137d83ef6a$var$y || a.$$typeof === $06caeb137d83ef6a$var$v);
};
$06caeb137d83ef6a$export$f5bbd400c2f4426f = $06caeb137d83ef6a$var$z;

});

parcelRegister("hSPEQ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d04f8cf7e9864647$export$a7c73072b1a182ae; }, function (v) { return $d04f8cf7e9864647$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d04f8cf7e9864647$export$9f27bc3417b4524d; }, function (v) { return $d04f8cf7e9864647$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d04f8cf7e9864647$export$db77ccec0bb4ccac; }, function (v) { return $d04f8cf7e9864647$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d04f8cf7e9864647$export$8392c0c9d3dcbd35; }, function (v) { return $d04f8cf7e9864647$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d04f8cf7e9864647$export$ffb0004e005737fa; }, function (v) { return $d04f8cf7e9864647$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d04f8cf7e9864647$export$b624eff549462981; }, function (v) { return $d04f8cf7e9864647$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d04f8cf7e9864647$export$7897aa7841a5380c; }, function (v) { return $d04f8cf7e9864647$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d04f8cf7e9864647$export$602eac185826482c; }, function (v) { return $d04f8cf7e9864647$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d04f8cf7e9864647$export$e2c29f18771995cb; }, function (v) { return $d04f8cf7e9864647$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d04f8cf7e9864647$export$5f8d39834fd61797; }, function (v) { return $d04f8cf7e9864647$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d04f8cf7e9864647$export$74bf444e3cd11ea5; }, function (v) { return $d04f8cf7e9864647$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $d04f8cf7e9864647$export$998bcd577473dd93; }, function (v) { return $d04f8cf7e9864647$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $d04f8cf7e9864647$export$92387174baf9b227; }, function (v) { return $d04f8cf7e9864647$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $d04f8cf7e9864647$export$ec112efeb987d9c6; }, function (v) { return $d04f8cf7e9864647$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d04f8cf7e9864647$export$b706b080d889d2c9; }, function (v) { return $d04f8cf7e9864647$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d04f8cf7e9864647$export$5be5a87408f70ddc; }, function (v) { return $d04f8cf7e9864647$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d04f8cf7e9864647$export$45a5e7f76e0caa8d; }, function (v) { return $d04f8cf7e9864647$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d04f8cf7e9864647$export$455c2e768291efa6; }, function (v) { return $d04f8cf7e9864647$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d04f8cf7e9864647$export$9522e17588c12572; }, function (v) { return $d04f8cf7e9864647$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d04f8cf7e9864647$export$2110ac352bb060b9; }, function (v) { return $d04f8cf7e9864647$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d04f8cf7e9864647$export$56885ab8b9c456ab; }, function (v) { return $d04f8cf7e9864647$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d04f8cf7e9864647$export$d927fcb6adf8f9de; }, function (v) { return $d04f8cf7e9864647$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d04f8cf7e9864647$export$b82d16f27459e05a; }, function (v) { return $d04f8cf7e9864647$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d04f8cf7e9864647$export$522c17b4f5e123e8; }, function (v) { return $d04f8cf7e9864647$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d04f8cf7e9864647$export$1aabd8a0274ecfd6; }, function (v) { return $d04f8cf7e9864647$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $d04f8cf7e9864647$export$3d6c20d97e46b957; }, function (v) { return $d04f8cf7e9864647$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d04f8cf7e9864647$export$9b621391a187a31a; }, function (v) { return $d04f8cf7e9864647$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d04f8cf7e9864647$export$f5bbd400c2f4426f; }, function (v) { return $d04f8cf7e9864647$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d04f8cf7e9864647$export$a7c73072b1a182ae;
var $d04f8cf7e9864647$export$9f27bc3417b4524d;
var $d04f8cf7e9864647$export$db77ccec0bb4ccac;
var $d04f8cf7e9864647$export$8392c0c9d3dcbd35;
var $d04f8cf7e9864647$export$ffb0004e005737fa;
var $d04f8cf7e9864647$export$b624eff549462981;
var $d04f8cf7e9864647$export$7897aa7841a5380c;
var $d04f8cf7e9864647$export$602eac185826482c;
var $d04f8cf7e9864647$export$e2c29f18771995cb;
var $d04f8cf7e9864647$export$5f8d39834fd61797;
var $d04f8cf7e9864647$export$74bf444e3cd11ea5;
var $d04f8cf7e9864647$export$998bcd577473dd93;
var $d04f8cf7e9864647$export$92387174baf9b227;
var $d04f8cf7e9864647$export$ec112efeb987d9c6;
var $d04f8cf7e9864647$export$b706b080d889d2c9;
var $d04f8cf7e9864647$export$5be5a87408f70ddc;
var $d04f8cf7e9864647$export$45a5e7f76e0caa8d;
var $d04f8cf7e9864647$export$455c2e768291efa6;
var $d04f8cf7e9864647$export$9522e17588c12572;
var $d04f8cf7e9864647$export$2110ac352bb060b9;
var $d04f8cf7e9864647$export$56885ab8b9c456ab;
var $d04f8cf7e9864647$export$d927fcb6adf8f9de;
var $d04f8cf7e9864647$export$b82d16f27459e05a;
var $d04f8cf7e9864647$export$522c17b4f5e123e8;
var $d04f8cf7e9864647$export$1aabd8a0274ecfd6;
var $d04f8cf7e9864647$export$3d6c20d97e46b957;
var $d04f8cf7e9864647$export$9b621391a187a31a;
var $d04f8cf7e9864647$export$f5bbd400c2f4426f;
'use strict';
var $d04f8cf7e9864647$var$b = Symbol.for("react.element"), $d04f8cf7e9864647$var$c = Symbol.for("react.portal"), $d04f8cf7e9864647$var$d = Symbol.for("react.fragment"), $d04f8cf7e9864647$var$e = Symbol.for("react.strict_mode"), $d04f8cf7e9864647$var$f = Symbol.for("react.profiler"), $d04f8cf7e9864647$var$g = Symbol.for("react.provider"), $d04f8cf7e9864647$var$h = Symbol.for("react.context"), $d04f8cf7e9864647$var$k = Symbol.for("react.server_context"), $d04f8cf7e9864647$var$l = Symbol.for("react.forward_ref"), $d04f8cf7e9864647$var$m = Symbol.for("react.suspense"), $d04f8cf7e9864647$var$n = Symbol.for("react.suspense_list"), $d04f8cf7e9864647$var$p = Symbol.for("react.memo"), $d04f8cf7e9864647$var$q = Symbol.for("react.lazy"), $d04f8cf7e9864647$var$t = Symbol.for("react.offscreen"), $d04f8cf7e9864647$var$u;
$d04f8cf7e9864647$var$u = Symbol.for("react.module.reference");
function $d04f8cf7e9864647$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $d04f8cf7e9864647$var$b:
                switch(a = a.type, a){
                    case $d04f8cf7e9864647$var$d:
                    case $d04f8cf7e9864647$var$f:
                    case $d04f8cf7e9864647$var$e:
                    case $d04f8cf7e9864647$var$m:
                    case $d04f8cf7e9864647$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $d04f8cf7e9864647$var$k:
                            case $d04f8cf7e9864647$var$h:
                            case $d04f8cf7e9864647$var$l:
                            case $d04f8cf7e9864647$var$q:
                            case $d04f8cf7e9864647$var$p:
                            case $d04f8cf7e9864647$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $d04f8cf7e9864647$var$c:
                return r;
        }
    }
}
$d04f8cf7e9864647$export$a7c73072b1a182ae = $d04f8cf7e9864647$var$h;
$d04f8cf7e9864647$export$9f27bc3417b4524d = $d04f8cf7e9864647$var$g;
$d04f8cf7e9864647$export$db77ccec0bb4ccac = $d04f8cf7e9864647$var$b;
$d04f8cf7e9864647$export$8392c0c9d3dcbd35 = $d04f8cf7e9864647$var$l;
$d04f8cf7e9864647$export$ffb0004e005737fa = $d04f8cf7e9864647$var$d;
$d04f8cf7e9864647$export$b624eff549462981 = $d04f8cf7e9864647$var$q;
$d04f8cf7e9864647$export$7897aa7841a5380c = $d04f8cf7e9864647$var$p;
$d04f8cf7e9864647$export$602eac185826482c = $d04f8cf7e9864647$var$c;
$d04f8cf7e9864647$export$e2c29f18771995cb = $d04f8cf7e9864647$var$f;
$d04f8cf7e9864647$export$5f8d39834fd61797 = $d04f8cf7e9864647$var$e;
$d04f8cf7e9864647$export$74bf444e3cd11ea5 = $d04f8cf7e9864647$var$m;
$d04f8cf7e9864647$export$998bcd577473dd93 = $d04f8cf7e9864647$var$n;
$d04f8cf7e9864647$export$92387174baf9b227 = function() {
    return !1;
};
$d04f8cf7e9864647$export$ec112efeb987d9c6 = function() {
    return !1;
};
$d04f8cf7e9864647$export$b706b080d889d2c9 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$h;
};
$d04f8cf7e9864647$export$5be5a87408f70ddc = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$g;
};
$d04f8cf7e9864647$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $d04f8cf7e9864647$var$b;
};
$d04f8cf7e9864647$export$455c2e768291efa6 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$l;
};
$d04f8cf7e9864647$export$9522e17588c12572 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$d;
};
$d04f8cf7e9864647$export$2110ac352bb060b9 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$q;
};
$d04f8cf7e9864647$export$56885ab8b9c456ab = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$p;
};
$d04f8cf7e9864647$export$d927fcb6adf8f9de = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$c;
};
$d04f8cf7e9864647$export$b82d16f27459e05a = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$f;
};
$d04f8cf7e9864647$export$522c17b4f5e123e8 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$e;
};
$d04f8cf7e9864647$export$1aabd8a0274ecfd6 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$m;
};
$d04f8cf7e9864647$export$3d6c20d97e46b957 = function(a) {
    return $d04f8cf7e9864647$var$v(a) === $d04f8cf7e9864647$var$n;
};
$d04f8cf7e9864647$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $d04f8cf7e9864647$var$d || a === $d04f8cf7e9864647$var$f || a === $d04f8cf7e9864647$var$e || a === $d04f8cf7e9864647$var$m || a === $d04f8cf7e9864647$var$n || a === $d04f8cf7e9864647$var$t || "object" === typeof a && null !== a && (a.$$typeof === $d04f8cf7e9864647$var$q || a.$$typeof === $d04f8cf7e9864647$var$p || a.$$typeof === $d04f8cf7e9864647$var$g || a.$$typeof === $d04f8cf7e9864647$var$h || a.$$typeof === $d04f8cf7e9864647$var$l || a.$$typeof === $d04f8cf7e9864647$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$d04f8cf7e9864647$export$f5bbd400c2f4426f = $d04f8cf7e9864647$var$v;

});

parcelRegister("lJpQh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $vtwyg = parcelRequire("vtwyg");
function $fd21d8a7aca9ca69$var$emptyFunction() {}
function $fd21d8a7aca9ca69$var$emptyFunctionWithReset() {}
$fd21d8a7aca9ca69$var$emptyFunctionWithReset.resetWarningCache = $fd21d8a7aca9ca69$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $vtwyg) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $fd21d8a7aca9ca69$var$emptyFunctionWithReset,
        resetWarningCache: $fd21d8a7aca9ca69$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("vtwyg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $05e9cc38adc5be63$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $05e9cc38adc5be63$var$ReactPropTypesSecret;

});


parcelRegister("i4YVD", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("kkDZD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $37Dan = parcelRequire("37Dan");

var $1zv5y = parcelRequire("1zv5y");

var $l7ybS = parcelRequire("l7ybS");
function $ecd4b2b3f869d573$var$last(array) {
    if (!$l7ybS.isArrayLike(array)) return undefined;
    return $37Dan.last($1zv5y.toArray(array));
}
module.exports.last = $ecd4b2b3f869d573$var$last;

});
parcelRegister("37Dan", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $2460682d43e0a382$var$last(arr) {
    return arr[arr.length - 1];
}
module.exports.last = $2460682d43e0a382$var$last;

});

parcelRegister("1zv5y", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $12512cda11a6686a$var$toArray(value) {
    return Array.isArray(value) ? value : Array.from(value);
}
module.exports.toArray = $12512cda11a6686a$var$toArray;

});

parcelRegister("l7ybS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lFC75 = parcelRequire("lFC75");
function $f604c5edb331c0a6$var$isArrayLike(value) {
    return value != null && typeof value !== 'function' && $lFC75.isLength(value.length);
}
module.exports.isArrayLike = $f604c5edb331c0a6$var$isArrayLike;

});
parcelRegister("lFC75", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $fc6afdcc53db30c8$var$isLength(value) {
    return Number.isSafeInteger(value) && value >= 0;
}
module.exports.isLength = $fc6afdcc53db30c8$var$isLength;

});



parcelRegister("gAKvK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9gqiT = parcelRequire("9gqiT");

var $kXM1U = parcelRequire("kXM1U");

var $cthHH = parcelRequire("cthHH");

var $k1SBU = parcelRequire("k1SBU");
function $c1441648fc0affd8$var$get(object, path, defaultValue) {
    if (object == null) return defaultValue;
    switch(typeof path){
        case 'string':
            {
                if ($9gqiT.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) {
                    if ($kXM1U.isDeepKey(path)) return $c1441648fc0affd8$var$get(object, $k1SBU.toPath(path), defaultValue);
                    else return defaultValue;
                }
                return result;
            }
        case 'number':
        case 'symbol':
            {
                if (typeof path === 'number') path = $cthHH.toKey(path);
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
        default:
            {
                if (Array.isArray(path)) return $c1441648fc0affd8$var$getWithPath(object, path, defaultValue);
                if (Object.is(path?.valueOf(), -0)) path = '-0';
                else path = String(path);
                if ($9gqiT.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
    }
}
function $c1441648fc0affd8$var$getWithPath(object, path, defaultValue) {
    if (path.length === 0) return defaultValue;
    let current = object;
    for(let index = 0; index < path.length; index++){
        if (current == null) return defaultValue;
        if ($9gqiT.isUnsafeProperty(path[index])) return defaultValue;
        current = current[path[index]];
    }
    if (current === undefined) return defaultValue;
    return current;
}
module.exports.get = $c1441648fc0affd8$var$get;

});
parcelRegister("9gqiT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $6bea030864a52c96$var$isUnsafeProperty(key) {
    return key === '__proto__';
}
module.exports.isUnsafeProperty = $6bea030864a52c96$var$isUnsafeProperty;

});

parcelRegister("kXM1U", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f42e930d2b5bc275$var$isDeepKey(key) {
    switch(typeof key){
        case 'number':
        case 'symbol':
            return false;
        case 'string':
            return key.includes('.') || key.includes('[') || key.includes(']');
    }
}
module.exports.isDeepKey = $f42e930d2b5bc275$var$isDeepKey;

});

parcelRegister("cthHH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9145ed0fe9bf065d$var$toKey(value) {
    if (typeof value === 'string' || typeof value === 'symbol') return value;
    if (Object.is(value?.valueOf?.(), -0)) return '-0';
    return String(value);
}
module.exports.toKey = $9145ed0fe9bf065d$var$toKey;

});

parcelRegister("k1SBU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hjRI9 = parcelRequire("hjRI9");

var $cthHH = parcelRequire("cthHH");
function $e94e43213f4b6b91$var$toPath(deepKey) {
    if (Array.isArray(deepKey)) return deepKey.map($cthHH.toKey);
    if (typeof deepKey === 'symbol') return [
        deepKey
    ];
    deepKey = $hjRI9.toString(deepKey);
    const result = [];
    const length = deepKey.length;
    if (length === 0) return result;
    let index = 0;
    let key = '';
    let quoteChar = '';
    let bracket = false;
    if (deepKey.charCodeAt(0) === 46) {
        result.push('');
        index++;
    }
    while(index < length){
        const char = deepKey[index];
        if (quoteChar) {
            if (char === '\\' && index + 1 < length) {
                index++;
                key += deepKey[index];
            } else if (char === quoteChar) quoteChar = '';
            else key += char;
        } else if (bracket) {
            if (char === '"' || char === "'") quoteChar = char;
            else if (char === ']') {
                bracket = false;
                result.push(key);
                key = '';
            } else key += char;
        } else {
            if (char === '[') {
                bracket = true;
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else if (char === '.') {
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else key += char;
        }
        index++;
    }
    if (key) result.push(key);
    return result;
}
module.exports.toPath = $e94e43213f4b6b91$var$toPath;

});
parcelRegister("hjRI9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c9bddff0b5ed9d42$var$toString(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map($c9bddff0b5ed9d42$var$toString).join(',');
    const result = String(value);
    if (result === '0' && Object.is(Number(value), -0)) return '-0';
    return result;
}
module.exports.toString = $c9bddff0b5ed9d42$var$toString;

});



parcelRegister("56Xh3", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $3b8b7de0f7247d71$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $3b8b7de0f7247d71$export$2e2bcd8739ae039 = fn;

});

parcelRegister("h9EiF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8S7UC = parcelRequire("8S7UC");

var $1tqtD = parcelRequire("1tqtD");

var $aJT8p = parcelRequire("aJT8p");
function $c7d289ae0077f6a4$var$sortBy(collection, ...criteria) {
    const length = criteria.length;
    if (length > 1 && $aJT8p.isIterateeCall(collection, criteria[0], criteria[1])) criteria = [];
    else if (length > 2 && $aJT8p.isIterateeCall(criteria[0], criteria[1], criteria[2])) criteria = [
        criteria[0]
    ];
    return $8S7UC.orderBy(collection, $1tqtD.flatten(criteria), [
        'asc'
    ]);
}
module.exports.sortBy = $c7d289ae0077f6a4$var$sortBy;

});
parcelRegister("8S7UC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $h3jkW = parcelRequire("h3jkW");

var $30DCZ = parcelRequire("30DCZ");

var $k1SBU = parcelRequire("k1SBU");
function $675981193b948707$var$orderBy(collection, criteria, orders, guard) {
    if (collection == null) return [];
    orders = guard ? undefined : orders;
    if (!Array.isArray(collection)) collection = Object.values(collection);
    if (!Array.isArray(criteria)) criteria = criteria == null ? [
        null
    ] : [
        criteria
    ];
    if (criteria.length === 0) criteria = [
        null
    ];
    if (!Array.isArray(orders)) orders = orders == null ? [] : [
        orders
    ];
    orders = orders.map((order)=>String(order));
    const getValueByNestedPath = (object, path)=>{
        let target = object;
        for(let i = 0; i < path.length && target != null; ++i)target = target[path[i]];
        return target;
    };
    const getValueByCriterion = (criterion, object)=>{
        if (object == null || criterion == null) return object;
        if (typeof criterion === 'object' && 'key' in criterion) {
            if (Object.hasOwn(object, criterion.key)) return object[criterion.key];
            return getValueByNestedPath(object, criterion.path);
        }
        if (typeof criterion === 'function') return criterion(object);
        if (Array.isArray(criterion)) return getValueByNestedPath(object, criterion);
        if (typeof object === 'object') return object[criterion];
        return object;
    };
    const preparedCriteria = criteria.map((criterion)=>{
        if (Array.isArray(criterion) && criterion.length === 1) criterion = criterion[0];
        if (criterion == null || typeof criterion === 'function' || Array.isArray(criterion) || $30DCZ.isKey(criterion)) return criterion;
        return {
            key: criterion,
            path: $k1SBU.toPath(criterion)
        };
    });
    const preparedCollection = collection.map((item)=>({
            original: item,
            criteria: preparedCriteria.map((criterion)=>getValueByCriterion(criterion, item))
        }));
    return preparedCollection.slice().sort((a, b)=>{
        for(let i = 0; i < preparedCriteria.length; i++){
            const comparedResult = $h3jkW.compareValues(a.criteria[i], b.criteria[i], orders[i]);
            if (comparedResult !== 0) return comparedResult;
        }
        return 0;
    }).map((item)=>item.original);
}
module.exports.orderBy = $675981193b948707$var$orderBy;

});
parcelRegister("h3jkW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $c6a1b75f433963b9$var$getPriority(a) {
    if (typeof a === 'symbol') return 1;
    if (a === null) return 2;
    if (a === undefined) return 3;
    if (a !== a) return 4;
    return 0;
}
const $c6a1b75f433963b9$var$compareValues = (a, b, order)=>{
    if (a !== b) {
        const aPriority = $c6a1b75f433963b9$var$getPriority(a);
        const bPriority = $c6a1b75f433963b9$var$getPriority(b);
        if (aPriority === bPriority && aPriority === 0) {
            if (a < b) return order === 'desc' ? 1 : -1;
            if (a > b) return order === 'desc' ? -1 : 1;
        }
        return order === 'desc' ? bPriority - aPriority : aPriority - bPriority;
    }
    return 0;
};
module.exports.compareValues = $c6a1b75f433963b9$var$compareValues;

});

parcelRegister("30DCZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bkjph = parcelRequire("bkjph");
const $23101c7743d613c3$var$regexIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const $23101c7743d613c3$var$regexIsPlainProp = /^\w*$/;
function $23101c7743d613c3$var$isKey(value, object) {
    if (Array.isArray(value)) return false;
    if (typeof value === 'number' || typeof value === 'boolean' || value == null || $bkjph.isSymbol(value)) return true;
    return typeof value === 'string' && ($23101c7743d613c3$var$regexIsPlainProp.test(value) || !$23101c7743d613c3$var$regexIsDeepProp.test(value)) || object != null && Object.hasOwn(object, value);
}
module.exports.isKey = $23101c7743d613c3$var$isKey;

});
parcelRegister("bkjph", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $83f09dc0f26392a3$var$isSymbol(value) {
    return typeof value === 'symbol' || value instanceof Symbol;
}
module.exports.isSymbol = $83f09dc0f26392a3$var$isSymbol;

});



parcelRegister("1tqtD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $112d09ad01fb24b2$var$flatten(arr, depth = 1) {
    const result = [];
    const flooredDepth = Math.floor(depth);
    const recursive = (arr, currentDepth)=>{
        for(let i = 0; i < arr.length; i++){
            const item = arr[i];
            if (Array.isArray(item) && currentDepth < flooredDepth) recursive(item, currentDepth + 1);
            else result.push(item);
        }
    };
    recursive(arr, 0);
    return result;
}
module.exports.flatten = $112d09ad01fb24b2$var$flatten;

});

parcelRegister("aJT8p", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eZdwf = parcelRequire("eZdwf");

var $l7ybS = parcelRequire("l7ybS");

var $4j1N7 = parcelRequire("4j1N7");

var $2rOTb = parcelRequire("2rOTb");
function $7d18dff56c3d320e$var$isIterateeCall(value, index, object) {
    if (!$4j1N7.isObject(object)) return false;
    if (typeof index === 'number' && $l7ybS.isArrayLike(object) && $eZdwf.isIndex(index) && index < object.length || typeof index === 'string' && index in object) return $2rOTb.eq(object[index], value);
    return false;
}
module.exports.isIterateeCall = $7d18dff56c3d320e$var$isIterateeCall;

});
parcelRegister("eZdwf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ae913fcefed64ac4$var$IS_UNSIGNED_INTEGER = /^(?:0|[1-9]\d*)$/;
function $ae913fcefed64ac4$var$isIndex(value, length = Number.MAX_SAFE_INTEGER) {
    switch(typeof value){
        case 'number':
            return Number.isInteger(value) && value >= 0 && value < length;
        case 'symbol':
            return false;
        case 'string':
            return $ae913fcefed64ac4$var$IS_UNSIGNED_INTEGER.test(value);
    }
}
module.exports.isIndex = $ae913fcefed64ac4$var$isIndex;

});

parcelRegister("4j1N7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $322a537648cd198c$var$isObject(value) {
    return value !== null && (typeof value === 'object' || typeof value === 'function');
}
module.exports.isObject = $322a537648cd198c$var$isObject;

});

parcelRegister("2rOTb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $1c8593e3c838a8a0$var$eq(value, other) {
    return value === other || Number.isNaN(value) && Number.isNaN(other);
}
module.exports.eq = $1c8593e3c838a8a0$var$eq;

});



parcelRegister("cNk52", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("1snDC"));

});
parcelRegister("1snDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $gMSGT.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $gMSGT.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $9UgmA.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $9UgmA.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $dmQkO.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $dmQkO.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $dmQkO.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $dmQkO.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $10fabe020ce2b25d$var$_symbol.symbolsStroke;
    }
});

var $10fabe020ce2b25d$var$_arc = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("gJzyj")));

var $10fabe020ce2b25d$var$_area = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("2xVuJ")));

var $10fabe020ce2b25d$var$_line = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("bq1IQ")));

var $10fabe020ce2b25d$var$_pie = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("46e4y")));

var $10fabe020ce2b25d$var$_areaRadial = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("52L56")));

var $10fabe020ce2b25d$var$_lineRadial = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("4Avzq")));

var $10fabe020ce2b25d$var$_pointRadial = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("1BxcD")));

var $dmQkO = parcelRequire("dmQkO");

var $10fabe020ce2b25d$var$_symbol = $10fabe020ce2b25d$var$_interopRequireWildcard((parcelRequire("70e5h")));

var $10fabe020ce2b25d$var$_asterisk = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("95T0h")));

var $10fabe020ce2b25d$var$_circle = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("47vhw")));

var $10fabe020ce2b25d$var$_cross = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("4c6v5")));

var $10fabe020ce2b25d$var$_diamond = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("iVj0x")));

var $10fabe020ce2b25d$var$_diamond2 = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("dnP3p")));

var $10fabe020ce2b25d$var$_plus = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("bM2SP")));

var $10fabe020ce2b25d$var$_square = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("c9Xna")));

var $10fabe020ce2b25d$var$_square2 = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("bfnwo")));

var $10fabe020ce2b25d$var$_star = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("kXsR3")));

var $10fabe020ce2b25d$var$_triangle = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("jeSdt")));

var $10fabe020ce2b25d$var$_triangle2 = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("9ISv6")));

var $10fabe020ce2b25d$var$_wye = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("l6Jpb")));

var $10fabe020ce2b25d$var$_x = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("91rty")));

var $10fabe020ce2b25d$var$_basisClosed = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("9Duo3")));

var $10fabe020ce2b25d$var$_basisOpen = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("aV3mI")));

var $10fabe020ce2b25d$var$_basis = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("huH7c")));

var $gMSGT = parcelRequire("gMSGT");

var $10fabe020ce2b25d$var$_bundle = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("iyKia")));

var $10fabe020ce2b25d$var$_cardinalClosed = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("4nomH")));

var $10fabe020ce2b25d$var$_cardinalOpen = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("V0bgH")));

var $10fabe020ce2b25d$var$_cardinal = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("9h9W4")));

var $10fabe020ce2b25d$var$_catmullRomClosed = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("ctkLG")));

var $10fabe020ce2b25d$var$_catmullRomOpen = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("5wXMf")));

var $10fabe020ce2b25d$var$_catmullRom = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("dCI6C")));

var $10fabe020ce2b25d$var$_linearClosed = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("idyuF")));

var $10fabe020ce2b25d$var$_linear = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("8RPbs")));

var $9UgmA = parcelRequire("9UgmA");

var $10fabe020ce2b25d$var$_natural = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("84HG8")));

var $10fabe020ce2b25d$var$_step = $10fabe020ce2b25d$var$_interopRequireWildcard((parcelRequire("aTRiZ")));

var $10fabe020ce2b25d$var$_stack = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("7Jr1f")));

var $10fabe020ce2b25d$var$_expand = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("8bPpA")));

var $10fabe020ce2b25d$var$_diverging = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("fffED")));

var $10fabe020ce2b25d$var$_none = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("j55mY")));

var $10fabe020ce2b25d$var$_silhouette = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("jvC2R")));

var $10fabe020ce2b25d$var$_wiggle = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("fQcdn")));

var $10fabe020ce2b25d$var$_appearance = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("cM4Z9")));

var $10fabe020ce2b25d$var$_ascending = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("btqAc")));

var $10fabe020ce2b25d$var$_descending = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("j3PsI")));

var $10fabe020ce2b25d$var$_insideOut = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("5Atyf")));

var $10fabe020ce2b25d$var$_none2 = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("jMETz")));

var $10fabe020ce2b25d$var$_reverse = $10fabe020ce2b25d$var$_interopRequireDefault((parcelRequire("asaPI")));
function $10fabe020ce2b25d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($10fabe020ce2b25d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $10fabe020ce2b25d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $10fabe020ce2b25d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $10fabe020ce2b25d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("gJzyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2ec6d48a3e5944d$var$_default;

var $ebeGp = parcelRequire("ebeGp");

var $c2ec6d48a3e5944d$var$_constant = $c2ec6d48a3e5944d$var$_interopRequireDefault((parcelRequire("8xZW2")));

var $hKzgR = parcelRequire("hKzgR");
function $c2ec6d48a3e5944d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c2ec6d48a3e5944d$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $c2ec6d48a3e5944d$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $c2ec6d48a3e5944d$var$arcStartAngle(d) {
    return d.startAngle;
}
function $c2ec6d48a3e5944d$var$arcEndAngle(d) {
    return d.endAngle;
}
function $c2ec6d48a3e5944d$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $c2ec6d48a3e5944d$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $hKzgR.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $c2ec6d48a3e5944d$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $hKzgR.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $hKzgR.sqrt)((0, $hKzgR.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $c2ec6d48a3e5944d$var$_default() {
    var innerRadius = $c2ec6d48a3e5944d$var$arcInnerRadius, outerRadius = $c2ec6d48a3e5944d$var$arcOuterRadius, cornerRadius = (0, $c2ec6d48a3e5944d$var$_constant.default)(0), padRadius = null, startAngle = $c2ec6d48a3e5944d$var$arcStartAngle, endAngle = $c2ec6d48a3e5944d$var$arcEndAngle, padAngle = $c2ec6d48a3e5944d$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $hKzgR.halfPi, a1 = endAngle.apply(this, arguments) - $hKzgR.halfPi, da = (0, $hKzgR.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $ebeGp.path)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > $hKzgR.epsilon)) context.moveTo(0, 0);
        else if (da > $hKzgR.tau - $hKzgR.epsilon) {
            context.moveTo(r1 * (0, $hKzgR.cos)(a0), r1 * (0, $hKzgR.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $hKzgR.epsilon) {
                context.moveTo(r0 * (0, $hKzgR.cos)(a1), r0 * (0, $hKzgR.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $hKzgR.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $hKzgR.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $hKzgR.min)((0, $hKzgR.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $hKzgR.epsilon) {
                var p0 = (0, $hKzgR.asin)(rp / r0 * (0, $hKzgR.sin)(ap)), p1 = (0, $hKzgR.asin)(rp / r1 * (0, $hKzgR.sin)(ap));
                if ((da0 -= p0 * 2) > $hKzgR.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $hKzgR.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $hKzgR.cos)(a01), y01 = r1 * (0, $hKzgR.sin)(a01), x10 = r0 * (0, $hKzgR.cos)(a10), y10 = r0 * (0, $hKzgR.sin)(a10);
            // Apply rounded corners?
            if (rc > $hKzgR.epsilon) {
                var x11 = r1 * (0, $hKzgR.cos)(a11), y11 = r1 * (0, $hKzgR.sin)(a11), x00 = r0 * (0, $hKzgR.cos)(a00), y00 = r0 * (0, $hKzgR.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < $hKzgR.pi && (oc = $c2ec6d48a3e5944d$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $hKzgR.sin)((0, $hKzgR.acos)((ax * bx + ay * by) / ((0, $hKzgR.sqrt)(ax * ax + ay * ay) * (0, $hKzgR.sqrt)(bx * bx + by * by))) / 2), lc = (0, $hKzgR.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $hKzgR.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $hKzgR.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > $hKzgR.epsilon)) context.moveTo(x01, y01);
            else if (rc1 > $hKzgR.epsilon) {
                t0 = $c2ec6d48a3e5944d$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $c2ec6d48a3e5944d$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $hKzgR.atan2)(t0.y01, t0.x01), (0, $hKzgR.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $hKzgR.atan2)(t0.y01, t0.x01), (0, $hKzgR.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $hKzgR.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $hKzgR.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $hKzgR.atan2)(t1.y11, t1.x11), (0, $hKzgR.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $hKzgR.epsilon) || !(da0 > $hKzgR.epsilon)) context.lineTo(x10, y10);
            else if (rc0 > $hKzgR.epsilon) {
                t0 = $c2ec6d48a3e5944d$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $c2ec6d48a3e5944d$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $hKzgR.atan2)(t0.y01, t0.x01), (0, $hKzgR.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $hKzgR.atan2)(t0.y01, t0.x01), (0, $hKzgR.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $hKzgR.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $hKzgR.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $hKzgR.atan2)(t1.y11, t1.x11), (0, $hKzgR.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $hKzgR.pi / 2;
        return [
            (0, $hKzgR.cos)(a) * r,
            (0, $hKzgR.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $c2ec6d48a3e5944d$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $c2ec6d48a3e5944d$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $c2ec6d48a3e5944d$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $c2ec6d48a3e5944d$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $c2ec6d48a3e5944d$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $c2ec6d48a3e5944d$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $c2ec6d48a3e5944d$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("ebeGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $a52d7b7f1550fc0a$var$_path.default;
    }
});

var $a52d7b7f1550fc0a$var$_path = $a52d7b7f1550fc0a$var$_interopRequireDefault((parcelRequire("3nTBe")));
function $a52d7b7f1550fc0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("3nTBe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $276ea5f6572c2935$var$pi = Math.PI, $276ea5f6572c2935$var$tau = 2 * $276ea5f6572c2935$var$pi, $276ea5f6572c2935$var$epsilon = 1e-6, $276ea5f6572c2935$var$tauEpsilon = $276ea5f6572c2935$var$tau - $276ea5f6572c2935$var$epsilon;
function $276ea5f6572c2935$var$Path() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $276ea5f6572c2935$var$path() {
    return new $276ea5f6572c2935$var$Path();
}
$276ea5f6572c2935$var$Path.prototype = $276ea5f6572c2935$var$path.prototype = {
    constructor: $276ea5f6572c2935$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $276ea5f6572c2935$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $276ea5f6572c2935$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($276ea5f6572c2935$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $276ea5f6572c2935$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $276ea5f6572c2935$var$epsilon || Math.abs(this._y1 - y0) > $276ea5f6572c2935$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $276ea5f6572c2935$var$tau + $276ea5f6572c2935$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $276ea5f6572c2935$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $276ea5f6572c2935$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $276ea5f6572c2935$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $276ea5f6572c2935$var$_default = module.exports.default = $276ea5f6572c2935$var$path;

});


parcelRegister("8xZW2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $639172d7c24d3389$var$_default;
function $639172d7c24d3389$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("hKzgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $cec2179ed20d661a$var$acos;
module.exports.asin = $cec2179ed20d661a$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $cec2179ed20d661a$var$abs = module.exports.abs = Math.abs;
const $cec2179ed20d661a$var$atan2 = module.exports.atan2 = Math.atan2;
const $cec2179ed20d661a$var$cos = module.exports.cos = Math.cos;
const $cec2179ed20d661a$var$max = module.exports.max = Math.max;
const $cec2179ed20d661a$var$min = module.exports.min = Math.min;
const $cec2179ed20d661a$var$sin = module.exports.sin = Math.sin;
const $cec2179ed20d661a$var$sqrt = module.exports.sqrt = Math.sqrt;
const $cec2179ed20d661a$var$epsilon = module.exports.epsilon = 1e-12;
const $cec2179ed20d661a$var$pi = module.exports.pi = Math.PI;
const $cec2179ed20d661a$var$halfPi = module.exports.halfPi = $cec2179ed20d661a$var$pi / 2;
const $cec2179ed20d661a$var$tau = module.exports.tau = 2 * $cec2179ed20d661a$var$pi;
function $cec2179ed20d661a$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $cec2179ed20d661a$var$pi : Math.acos(x);
}
function $cec2179ed20d661a$var$asin(x) {
    return x >= 1 ? $cec2179ed20d661a$var$halfPi : x <= -1 ? -$cec2179ed20d661a$var$halfPi : Math.asin(x);
}

});


parcelRegister("2xVuJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1dab43116609d587$var$_default;

var $ebeGp = parcelRequire("ebeGp");

var $1dab43116609d587$var$_array = $1dab43116609d587$var$_interopRequireDefault((parcelRequire("jlhyu")));

var $1dab43116609d587$var$_constant = $1dab43116609d587$var$_interopRequireDefault((parcelRequire("8xZW2")));

var $1dab43116609d587$var$_linear = $1dab43116609d587$var$_interopRequireDefault((parcelRequire("8RPbs")));

var $1dab43116609d587$var$_line = $1dab43116609d587$var$_interopRequireDefault((parcelRequire("bq1IQ")));

var $biZwz = parcelRequire("biZwz");
function $1dab43116609d587$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1dab43116609d587$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $1dab43116609d587$var$_constant.default)(true), context = null, curve = $1dab43116609d587$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $biZwz.x : (0, $1dab43116609d587$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $1dab43116609d587$var$_constant.default)(0) : (0, $1dab43116609d587$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $biZwz.y : (0, $1dab43116609d587$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $1dab43116609d587$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $ebeGp.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $1dab43116609d587$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $1dab43116609d587$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $1dab43116609d587$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $1dab43116609d587$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $1dab43116609d587$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $1dab43116609d587$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $1dab43116609d587$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $1dab43116609d587$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("jlhyu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e14d9894a074d928$var$_default;
module.exports.slice = void 0;
var $e14d9894a074d928$var$slice = module.exports.slice = Array.prototype.slice;
function $e14d9894a074d928$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("8RPbs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $674af9fefd24ccb8$var$_default;
function $674af9fefd24ccb8$var$Linear(context) {
    this._context = context;
}
$674af9fefd24ccb8$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $674af9fefd24ccb8$var$_default(context) {
    return new $674af9fefd24ccb8$var$Linear(context);
}

});

parcelRegister("bq1IQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8503756c02c274bc$var$_default;

var $ebeGp = parcelRequire("ebeGp");

var $8503756c02c274bc$var$_array = $8503756c02c274bc$var$_interopRequireDefault((parcelRequire("jlhyu")));

var $8503756c02c274bc$var$_constant = $8503756c02c274bc$var$_interopRequireDefault((parcelRequire("8xZW2")));

var $8503756c02c274bc$var$_linear = $8503756c02c274bc$var$_interopRequireDefault((parcelRequire("8RPbs")));

var $biZwz = parcelRequire("biZwz");
function $8503756c02c274bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8503756c02c274bc$var$_default(x, y) {
    var defined = (0, $8503756c02c274bc$var$_constant.default)(true), context = null, curve = $8503756c02c274bc$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $biZwz.x : (0, $8503756c02c274bc$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $biZwz.y : (0, $8503756c02c274bc$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $8503756c02c274bc$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $ebeGp.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $8503756c02c274bc$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $8503756c02c274bc$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $8503756c02c274bc$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("biZwz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $83b1199d076b9ff9$var$x;
module.exports.y = $83b1199d076b9ff9$var$y;
function $83b1199d076b9ff9$var$x(p) {
    return p[0];
}
function $83b1199d076b9ff9$var$y(p) {
    return p[1];
}

});



parcelRegister("46e4y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fc2a371b5573a3d$var$_default;

var $2fc2a371b5573a3d$var$_array = $2fc2a371b5573a3d$var$_interopRequireDefault((parcelRequire("jlhyu")));

var $2fc2a371b5573a3d$var$_constant = $2fc2a371b5573a3d$var$_interopRequireDefault((parcelRequire("8xZW2")));

var $2fc2a371b5573a3d$var$_descending = $2fc2a371b5573a3d$var$_interopRequireDefault((parcelRequire("lUnlK")));

var $2fc2a371b5573a3d$var$_identity = $2fc2a371b5573a3d$var$_interopRequireDefault((parcelRequire("ktubF")));

var $hKzgR = parcelRequire("hKzgR");
function $2fc2a371b5573a3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2fc2a371b5573a3d$var$_default() {
    var value = $2fc2a371b5573a3d$var$_identity.default, sortValues = $2fc2a371b5573a3d$var$_descending.default, sort = null, startAngle = (0, $2fc2a371b5573a3d$var$_constant.default)(0), endAngle = (0, $2fc2a371b5573a3d$var$_constant.default)($hKzgR.tau), padAngle = (0, $2fc2a371b5573a3d$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $2fc2a371b5573a3d$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($hKzgR.tau, Math.max(-$hKzgR.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $2fc2a371b5573a3d$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $2fc2a371b5573a3d$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $2fc2a371b5573a3d$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $2fc2a371b5573a3d$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("lUnlK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ff30f0b8f44769ef$var$_default;
function $ff30f0b8f44769ef$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("ktubF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee7deea21bee3ef5$var$_default;
function $ee7deea21bee3ef5$var$_default(d) {
    return d;
}

});


parcelRegister("52L56", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ac1a8ff7c131953$var$_default;

var $3ac1a8ff7c131953$var$_radial = $3ac1a8ff7c131953$var$_interopRequireWildcard((parcelRequire("eF3PK")));

var $3ac1a8ff7c131953$var$_area = $3ac1a8ff7c131953$var$_interopRequireDefault((parcelRequire("2xVuJ")));

var $4Avzq = parcelRequire("4Avzq");
function $3ac1a8ff7c131953$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3ac1a8ff7c131953$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3ac1a8ff7c131953$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $3ac1a8ff7c131953$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $3ac1a8ff7c131953$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $3ac1a8ff7c131953$var$_default() {
    var a = (0, $3ac1a8ff7c131953$var$_area.default)().curve($3ac1a8ff7c131953$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $4Avzq.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $4Avzq.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $4Avzq.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $4Avzq.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $3ac1a8ff7c131953$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("eF3PK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $aac7de4adbeeb42f$var$curveRadial;

var $aac7de4adbeeb42f$var$_linear = $aac7de4adbeeb42f$var$_interopRequireDefault((parcelRequire("8RPbs")));
function $aac7de4adbeeb42f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $aac7de4adbeeb42f$var$curveRadialLinear = module.exports.curveRadialLinear = $aac7de4adbeeb42f$var$curveRadial($aac7de4adbeeb42f$var$_linear.default);
function $aac7de4adbeeb42f$var$Radial(curve) {
    this._curve = curve;
}
$aac7de4adbeeb42f$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $aac7de4adbeeb42f$var$curveRadial(curve) {
    function radial(context) {
        return new $aac7de4adbeeb42f$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("4Avzq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $357303726be1b927$var$_default;
module.exports.lineRadial = $357303726be1b927$var$lineRadial;

var $357303726be1b927$var$_radial = $357303726be1b927$var$_interopRequireWildcard((parcelRequire("eF3PK")));

var $357303726be1b927$var$_line = $357303726be1b927$var$_interopRequireDefault((parcelRequire("bq1IQ")));
function $357303726be1b927$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $357303726be1b927$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($357303726be1b927$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $357303726be1b927$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $357303726be1b927$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $357303726be1b927$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $357303726be1b927$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $357303726be1b927$var$_default() {
    return $357303726be1b927$var$lineRadial((0, $357303726be1b927$var$_line.default)().curve($357303726be1b927$var$_radial.curveRadialLinear));
}

});


parcelRegister("1BxcD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $12b300849aa2d88a$var$_default;
function $12b300849aa2d88a$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("dmQkO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $9bb5ed048cc42341$var$link;
module.exports.linkHorizontal = $9bb5ed048cc42341$var$linkHorizontal;
module.exports.linkRadial = $9bb5ed048cc42341$var$linkRadial;
module.exports.linkVertical = $9bb5ed048cc42341$var$linkVertical;

var $ebeGp = parcelRequire("ebeGp");

var $jlhyu = parcelRequire("jlhyu");

var $9bb5ed048cc42341$var$_constant = $9bb5ed048cc42341$var$_interopRequireDefault((parcelRequire("8xZW2")));

var $gMSGT = parcelRequire("gMSGT");

var $biZwz = parcelRequire("biZwz");
function $9bb5ed048cc42341$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9bb5ed048cc42341$var$linkSource(d) {
    return d.source;
}
function $9bb5ed048cc42341$var$linkTarget(d) {
    return d.target;
}
function $9bb5ed048cc42341$var$link(curve) {
    let source = $9bb5ed048cc42341$var$linkSource;
    let target = $9bb5ed048cc42341$var$linkTarget;
    let x = $biZwz.x;
    let y = $biZwz.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $jlhyu.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $ebeGp.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $9bb5ed048cc42341$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $9bb5ed048cc42341$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $9bb5ed048cc42341$var$linkHorizontal() {
    return $9bb5ed048cc42341$var$link($gMSGT.bumpX);
}
function $9bb5ed048cc42341$var$linkVertical() {
    return $9bb5ed048cc42341$var$link($gMSGT.bumpY);
}
function $9bb5ed048cc42341$var$linkRadial() {
    const l = $9bb5ed048cc42341$var$link($gMSGT.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("gMSGT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $c38b8d7e0bcdbba7$var$bumpRadial;
module.exports.bumpX = $c38b8d7e0bcdbba7$var$bumpX;
module.exports.bumpY = $c38b8d7e0bcdbba7$var$bumpY;

var $c38b8d7e0bcdbba7$var$_pointRadial = $c38b8d7e0bcdbba7$var$_interopRequireDefault((parcelRequire("1BxcD")));
function $c38b8d7e0bcdbba7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $c38b8d7e0bcdbba7$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $c38b8d7e0bcdbba7$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $c38b8d7e0bcdbba7$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $c38b8d7e0bcdbba7$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $c38b8d7e0bcdbba7$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $c38b8d7e0bcdbba7$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $c38b8d7e0bcdbba7$var$bumpX(context) {
    return new $c38b8d7e0bcdbba7$var$Bump(context, true);
}
function $c38b8d7e0bcdbba7$var$bumpY(context) {
    return new $c38b8d7e0bcdbba7$var$Bump(context, false);
}
function $c38b8d7e0bcdbba7$var$bumpRadial(context) {
    return new $c38b8d7e0bcdbba7$var$BumpRadial(context);
}

});


parcelRegister("70e5h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5193754b4e85b8a4$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $ebeGp = parcelRequire("ebeGp");

var $5193754b4e85b8a4$var$_constant = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("8xZW2")));

var $5193754b4e85b8a4$var$_asterisk = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("95T0h")));

var $5193754b4e85b8a4$var$_circle = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("47vhw")));

var $5193754b4e85b8a4$var$_cross = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("4c6v5")));

var $5193754b4e85b8a4$var$_diamond = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("iVj0x")));

var $5193754b4e85b8a4$var$_diamond2 = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("dnP3p")));

var $5193754b4e85b8a4$var$_plus = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("bM2SP")));

var $5193754b4e85b8a4$var$_square = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("c9Xna")));

var $5193754b4e85b8a4$var$_square2 = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("bfnwo")));

var $5193754b4e85b8a4$var$_star = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("kXsR3")));

var $5193754b4e85b8a4$var$_triangle = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("jeSdt")));

var $5193754b4e85b8a4$var$_triangle2 = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("9ISv6")));

var $5193754b4e85b8a4$var$_wye = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("l6Jpb")));

var $5193754b4e85b8a4$var$_x = $5193754b4e85b8a4$var$_interopRequireDefault((parcelRequire("91rty")));
function $5193754b4e85b8a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $5193754b4e85b8a4$var$symbolsFill = module.exports.symbolsFill = [
    $5193754b4e85b8a4$var$_circle.default,
    $5193754b4e85b8a4$var$_cross.default,
    $5193754b4e85b8a4$var$_diamond.default,
    $5193754b4e85b8a4$var$_square.default,
    $5193754b4e85b8a4$var$_star.default,
    $5193754b4e85b8a4$var$_triangle.default,
    $5193754b4e85b8a4$var$_wye.default
];
// These symbols are designed to be stroked (with a width of 1.5px and round caps).
const $5193754b4e85b8a4$var$symbolsStroke = module.exports.symbolsStroke = [
    $5193754b4e85b8a4$var$_circle.default,
    $5193754b4e85b8a4$var$_plus.default,
    $5193754b4e85b8a4$var$_x.default,
    $5193754b4e85b8a4$var$_triangle2.default,
    $5193754b4e85b8a4$var$_asterisk.default,
    $5193754b4e85b8a4$var$_square2.default,
    $5193754b4e85b8a4$var$_diamond2.default
];
function $5193754b4e85b8a4$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $5193754b4e85b8a4$var$_constant.default)(type || $5193754b4e85b8a4$var$_circle.default);
    size = typeof size === "function" ? size : (0, $5193754b4e85b8a4$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $ebeGp.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $5193754b4e85b8a4$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $5193754b4e85b8a4$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("95T0h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
const $69ef3f3d40d887f7$var$sqrt3 = (0, $hKzgR.sqrt)(3);
var $69ef3f3d40d887f7$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size + (0, $hKzgR.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $69ef3f3d40d887f7$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

});

parcelRegister("47vhw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
var $300014c158df5660$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size / $hKzgR.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $hKzgR.tau);
    }
};

});

parcelRegister("4c6v5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
var $30dd53411d1cca09$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("iVj0x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
const $dc6c4b68f04bce82$var$tan30 = (0, $hKzgR.sqrt)(1 / 3);
const $dc6c4b68f04bce82$var$tan30_2 = $dc6c4b68f04bce82$var$tan30 * 2;
var $dc6c4b68f04bce82$var$_default = module.exports.default = {
    draw (context, size) {
        const y = (0, $hKzgR.sqrt)(size / $dc6c4b68f04bce82$var$tan30_2);
        const x = y * $dc6c4b68f04bce82$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("dnP3p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
var $9be50697afdf0856$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

});

parcelRegister("bM2SP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
var $892669f2d86a95e4$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size - (0, $hKzgR.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

});

parcelRegister("c9Xna", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
var $8da4617f0f897f89$var$_default = module.exports.default = {
    draw (context, size) {
        const w = (0, $hKzgR.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("bfnwo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
var $8303574acaf4020a$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

});

parcelRegister("kXsR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
const $f41fb349be6ae0de$var$ka = 0.89081309152928522810;
const $f41fb349be6ae0de$var$kr = (0, $hKzgR.sin)($hKzgR.pi / 10) / (0, $hKzgR.sin)(7 * $hKzgR.pi / 10);
const $f41fb349be6ae0de$var$kx = (0, $hKzgR.sin)($hKzgR.tau / 10) * $f41fb349be6ae0de$var$kr;
const $f41fb349be6ae0de$var$ky = -(0, $hKzgR.cos)($hKzgR.tau / 10) * $f41fb349be6ae0de$var$kr;
var $f41fb349be6ae0de$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size * $f41fb349be6ae0de$var$ka);
        const x = $f41fb349be6ae0de$var$kx * r;
        const y = $f41fb349be6ae0de$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $hKzgR.tau * i / 5;
            const c = (0, $hKzgR.cos)(a);
            const s = (0, $hKzgR.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("jeSdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
const $e019615f4daf7473$var$sqrt3 = (0, $hKzgR.sqrt)(3);
var $e019615f4daf7473$var$_default = module.exports.default = {
    draw (context, size) {
        const y = -(0, $hKzgR.sqrt)(size / ($e019615f4daf7473$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$e019615f4daf7473$var$sqrt3 * y, -y);
        context.lineTo($e019615f4daf7473$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("9ISv6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
const $71427fcd8246175b$var$sqrt3 = (0, $hKzgR.sqrt)(3);
var $71427fcd8246175b$var$_default = module.exports.default = {
    draw (context, size) {
        const s = (0, $hKzgR.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $71427fcd8246175b$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

});

parcelRegister("l6Jpb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
const $f5dd6107591bc880$var$c = -0.5;
const $f5dd6107591bc880$var$s = (0, $hKzgR.sqrt)(3) / 2;
const $f5dd6107591bc880$var$k = 1 / (0, $hKzgR.sqrt)(12);
const $f5dd6107591bc880$var$a = ($f5dd6107591bc880$var$k / 2 + 1) * 3;
var $f5dd6107591bc880$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size / $f5dd6107591bc880$var$a);
        const x0 = r / 2, y0 = r * $f5dd6107591bc880$var$k;
        const x1 = x0, y1 = r * $f5dd6107591bc880$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($f5dd6107591bc880$var$c * x0 - $f5dd6107591bc880$var$s * y0, $f5dd6107591bc880$var$s * x0 + $f5dd6107591bc880$var$c * y0);
        context.lineTo($f5dd6107591bc880$var$c * x1 - $f5dd6107591bc880$var$s * y1, $f5dd6107591bc880$var$s * x1 + $f5dd6107591bc880$var$c * y1);
        context.lineTo($f5dd6107591bc880$var$c * x2 - $f5dd6107591bc880$var$s * y2, $f5dd6107591bc880$var$s * x2 + $f5dd6107591bc880$var$c * y2);
        context.lineTo($f5dd6107591bc880$var$c * x0 + $f5dd6107591bc880$var$s * y0, $f5dd6107591bc880$var$c * y0 - $f5dd6107591bc880$var$s * x0);
        context.lineTo($f5dd6107591bc880$var$c * x1 + $f5dd6107591bc880$var$s * y1, $f5dd6107591bc880$var$c * y1 - $f5dd6107591bc880$var$s * x1);
        context.lineTo($f5dd6107591bc880$var$c * x2 + $f5dd6107591bc880$var$s * y2, $f5dd6107591bc880$var$c * y2 - $f5dd6107591bc880$var$s * x2);
        context.closePath();
    }
};

});

parcelRegister("91rty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKzgR = parcelRequire("hKzgR");
var $69198526fa9639e8$var$_default = module.exports.default = {
    draw (context, size) {
        const r = (0, $hKzgR.sqrt)(size - (0, $hKzgR.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

});


parcelRegister("9Duo3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $703f53c822af8e4a$var$_default;

var $703f53c822af8e4a$var$_noop = $703f53c822af8e4a$var$_interopRequireDefault((parcelRequire("llObO")));

var $huH7c = parcelRequire("huH7c");
function $703f53c822af8e4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $703f53c822af8e4a$var$BasisClosed(context) {
    this._context = context;
}
$703f53c822af8e4a$var$BasisClosed.prototype = {
    areaStart: $703f53c822af8e4a$var$_noop.default,
    areaEnd: $703f53c822af8e4a$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $huH7c.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $703f53c822af8e4a$var$_default(context) {
    return new $703f53c822af8e4a$var$BasisClosed(context);
}

});
parcelRegister("llObO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8b27db9b59a7c7c$var$_default;
function $f8b27db9b59a7c7c$var$_default() {}

});

parcelRegister("huH7c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $cbc6aec63484c481$var$Basis;
module.exports.default = $cbc6aec63484c481$var$_default;
module.exports.point = $cbc6aec63484c481$var$point;
function $cbc6aec63484c481$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $cbc6aec63484c481$var$Basis(context) {
    this._context = context;
}
$cbc6aec63484c481$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $cbc6aec63484c481$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $cbc6aec63484c481$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $cbc6aec63484c481$var$_default(context) {
    return new $cbc6aec63484c481$var$Basis(context);
}

});


parcelRegister("aV3mI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f31d687a49e6340$var$_default;

var $huH7c = parcelRequire("huH7c");
function $7f31d687a49e6340$var$BasisOpen(context) {
    this._context = context;
}
$7f31d687a49e6340$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $huH7c.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7f31d687a49e6340$var$_default(context) {
    return new $7f31d687a49e6340$var$BasisOpen(context);
}

});

parcelRegister("iyKia", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $huH7c = parcelRequire("huH7c");
function $d82f4f952d95b806$var$Bundle(context, beta) {
    this._basis = new $huH7c.Basis(context);
    this._beta = beta;
}
$d82f4f952d95b806$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $d82f4f952d95b806$var$_default = module.exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $huH7c.Basis(context) : new $d82f4f952d95b806$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("4nomH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $32fc35ceedd9b401$var$CardinalClosed;
module.exports.default = void 0;

var $32fc35ceedd9b401$var$_noop = $32fc35ceedd9b401$var$_interopRequireDefault((parcelRequire("llObO")));

var $9h9W4 = parcelRequire("9h9W4");
function $32fc35ceedd9b401$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $32fc35ceedd9b401$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$32fc35ceedd9b401$var$CardinalClosed.prototype = {
    areaStart: $32fc35ceedd9b401$var$_noop.default,
    areaEnd: $32fc35ceedd9b401$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $9h9W4.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $32fc35ceedd9b401$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $32fc35ceedd9b401$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("9h9W4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $6c0d68956a0b9805$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $6c0d68956a0b9805$var$point;
function $6c0d68956a0b9805$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $6c0d68956a0b9805$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$6c0d68956a0b9805$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $6c0d68956a0b9805$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $6c0d68956a0b9805$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $6c0d68956a0b9805$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $6c0d68956a0b9805$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("V0bgH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $0ab576e0d74fab1c$var$CardinalOpen;
module.exports.default = void 0;

var $9h9W4 = parcelRequire("9h9W4");
function $0ab576e0d74fab1c$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$0ab576e0d74fab1c$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $9h9W4.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $0ab576e0d74fab1c$var$_default = module.exports.default = function custom(tension) {
    function cardinal(context) {
        return new $0ab576e0d74fab1c$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("ctkLG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4nomH = parcelRequire("4nomH");

var $91484d91bd580b99$var$_noop = $91484d91bd580b99$var$_interopRequireDefault((parcelRequire("llObO")));

var $dCI6C = parcelRequire("dCI6C");
function $91484d91bd580b99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $91484d91bd580b99$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$91484d91bd580b99$var$CatmullRomClosed.prototype = {
    areaStart: $91484d91bd580b99$var$_noop.default,
    areaEnd: $91484d91bd580b99$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $dCI6C.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $91484d91bd580b99$var$_default = module.exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $91484d91bd580b99$var$CatmullRomClosed(context, alpha) : new $4nomH.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("dCI6C", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $hKzgR = parcelRequire("hKzgR");

var $9h9W4 = parcelRequire("9h9W4");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $hKzgR.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $hKzgR.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $9h9W4.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("5wXMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $V0bgH = parcelRequire("V0bgH");

var $dCI6C = parcelRequire("dCI6C");
function $406e4f6d328a7956$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$406e4f6d328a7956$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $dCI6C.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $406e4f6d328a7956$var$_default = module.exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $406e4f6d328a7956$var$CatmullRomOpen(context, alpha) : new $V0bgH.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("idyuF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d434329daa989e07$var$_default;

var $d434329daa989e07$var$_noop = $d434329daa989e07$var$_interopRequireDefault((parcelRequire("llObO")));
function $d434329daa989e07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d434329daa989e07$var$LinearClosed(context) {
    this._context = context;
}
$d434329daa989e07$var$LinearClosed.prototype = {
    areaStart: $d434329daa989e07$var$_noop.default,
    areaEnd: $d434329daa989e07$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $d434329daa989e07$var$_default(context) {
    return new $d434329daa989e07$var$LinearClosed(context);
}

});

parcelRegister("9UgmA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $73660971c33cbd52$var$monotoneX;
module.exports.monotoneY = $73660971c33cbd52$var$monotoneY;
function $73660971c33cbd52$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $73660971c33cbd52$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($73660971c33cbd52$var$sign(s0) + $73660971c33cbd52$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $73660971c33cbd52$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $73660971c33cbd52$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $73660971c33cbd52$var$MonotoneX(context) {
    this._context = context;
}
$73660971c33cbd52$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $73660971c33cbd52$var$point(this, this._t0, $73660971c33cbd52$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $73660971c33cbd52$var$point(this, $73660971c33cbd52$var$slope2(this, t1 = $73660971c33cbd52$var$slope3(this, x, y)), t1);
                break;
            default:
                $73660971c33cbd52$var$point(this, this._t0, t1 = $73660971c33cbd52$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $73660971c33cbd52$var$MonotoneY(context) {
    this._context = new $73660971c33cbd52$var$ReflectContext(context);
}
($73660971c33cbd52$var$MonotoneY.prototype = Object.create($73660971c33cbd52$var$MonotoneX.prototype)).point = function(x, y) {
    $73660971c33cbd52$var$MonotoneX.prototype.point.call(this, y, x);
};
function $73660971c33cbd52$var$ReflectContext(context) {
    this._context = context;
}
$73660971c33cbd52$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $73660971c33cbd52$var$monotoneX(context) {
    return new $73660971c33cbd52$var$MonotoneX(context);
}
function $73660971c33cbd52$var$monotoneY(context) {
    return new $73660971c33cbd52$var$MonotoneY(context);
}

});

parcelRegister("84HG8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e10941ae5c4492e$var$_default;
function $5e10941ae5c4492e$var$Natural(context) {
    this._context = context;
}
$5e10941ae5c4492e$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $5e10941ae5c4492e$var$controlPoints(x), py = $5e10941ae5c4492e$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $5e10941ae5c4492e$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $5e10941ae5c4492e$var$_default(context) {
    return new $5e10941ae5c4492e$var$Natural(context);
}

});

parcelRegister("aTRiZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ef863c568692ee1$var$_default;
module.exports.stepAfter = $7ef863c568692ee1$var$stepAfter;
module.exports.stepBefore = $7ef863c568692ee1$var$stepBefore;
function $7ef863c568692ee1$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$7ef863c568692ee1$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $7ef863c568692ee1$var$_default(context) {
    return new $7ef863c568692ee1$var$Step(context, 0.5);
}
function $7ef863c568692ee1$var$stepBefore(context) {
    return new $7ef863c568692ee1$var$Step(context, 0);
}
function $7ef863c568692ee1$var$stepAfter(context) {
    return new $7ef863c568692ee1$var$Step(context, 1);
}

});

parcelRegister("7Jr1f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a11b1d4673d8755$var$_default;

var $5a11b1d4673d8755$var$_array = $5a11b1d4673d8755$var$_interopRequireDefault((parcelRequire("jlhyu")));

var $5a11b1d4673d8755$var$_constant = $5a11b1d4673d8755$var$_interopRequireDefault((parcelRequire("8xZW2")));

var $5a11b1d4673d8755$var$_none = $5a11b1d4673d8755$var$_interopRequireDefault((parcelRequire("j55mY")));

var $5a11b1d4673d8755$var$_none2 = $5a11b1d4673d8755$var$_interopRequireDefault((parcelRequire("jMETz")));
function $5a11b1d4673d8755$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5a11b1d4673d8755$var$stackValue(d, key) {
    return d[key];
}
function $5a11b1d4673d8755$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $5a11b1d4673d8755$var$_default() {
    var keys = (0, $5a11b1d4673d8755$var$_constant.default)([]), order = $5a11b1d4673d8755$var$_none2.default, offset = $5a11b1d4673d8755$var$_none.default, value = $5a11b1d4673d8755$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $5a11b1d4673d8755$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $5a11b1d4673d8755$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $5a11b1d4673d8755$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $5a11b1d4673d8755$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $5a11b1d4673d8755$var$_none2.default : typeof _ === "function" ? _ : (0, $5a11b1d4673d8755$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $5a11b1d4673d8755$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("j55mY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de42a639a5f1e3e4$var$_default;
function $de42a639a5f1e3e4$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("jMETz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e67238f28e7bbd8f$var$_default;
function $e67238f28e7bbd8f$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("8bPpA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f673b181c08d904$var$_default;

var $5f673b181c08d904$var$_none = $5f673b181c08d904$var$_interopRequireDefault((parcelRequire("j55mY")));
function $5f673b181c08d904$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f673b181c08d904$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $5f673b181c08d904$var$_none.default)(series, order);
}

});

parcelRegister("fffED", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1946658d8c67e68$var$_default;
function $b1946658d8c67e68$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("jvC2R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e33e6c8685ff1d22$var$_default;

var $e33e6c8685ff1d22$var$_none = $e33e6c8685ff1d22$var$_interopRequireDefault((parcelRequire("j55mY")));
function $e33e6c8685ff1d22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e33e6c8685ff1d22$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $e33e6c8685ff1d22$var$_none.default)(series, order);
}

});

parcelRegister("fQcdn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b8852ff393c6f4ff$var$_default;

var $b8852ff393c6f4ff$var$_none = $b8852ff393c6f4ff$var$_interopRequireDefault((parcelRequire("j55mY")));
function $b8852ff393c6f4ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b8852ff393c6f4ff$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $b8852ff393c6f4ff$var$_none.default)(series, order);
}

});

parcelRegister("cM4Z9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94cdd5b1338645e9$var$_default;

var $94cdd5b1338645e9$var$_none = $94cdd5b1338645e9$var$_interopRequireDefault((parcelRequire("jMETz")));
function $94cdd5b1338645e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94cdd5b1338645e9$var$_default(series) {
    var peaks = series.map($94cdd5b1338645e9$var$peak);
    return (0, $94cdd5b1338645e9$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $94cdd5b1338645e9$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("btqAc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $85a705f235ddff2b$var$_default;
module.exports.sum = $85a705f235ddff2b$var$sum;

var $85a705f235ddff2b$var$_none = $85a705f235ddff2b$var$_interopRequireDefault((parcelRequire("jMETz")));
function $85a705f235ddff2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $85a705f235ddff2b$var$_default(series) {
    var sums = series.map($85a705f235ddff2b$var$sum);
    return (0, $85a705f235ddff2b$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $85a705f235ddff2b$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("j3PsI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de06376f2e432839$var$_default;

var $de06376f2e432839$var$_ascending = $de06376f2e432839$var$_interopRequireDefault((parcelRequire("btqAc")));
function $de06376f2e432839$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $de06376f2e432839$var$_default(series) {
    return (0, $de06376f2e432839$var$_ascending.default)(series).reverse();
}

});

parcelRegister("5Atyf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41173cd407609941$var$_default;

var $41173cd407609941$var$_appearance = $41173cd407609941$var$_interopRequireDefault((parcelRequire("cM4Z9")));

var $btqAc = parcelRequire("btqAc");
function $41173cd407609941$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $41173cd407609941$var$_default(series) {
    var n = series.length, i, j, sums = series.map($btqAc.sum), order = (0, $41173cd407609941$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("asaPI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79c4ec2884046661$var$_default;

var $79c4ec2884046661$var$_none = $79c4ec2884046661$var$_interopRequireDefault((parcelRequire("jMETz")));
function $79c4ec2884046661$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79c4ec2884046661$var$_default(series) {
    return (0, $79c4ec2884046661$var$_none.default)(series).reverse();
}

});



parcelRegister("1u5Rd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $j74jC = parcelRequire("j74jC");
function $114d22efb6da3128$var$throttle(func, throttleMs = 0, options = {}) {
    const { leading: leading = true, trailing: trailing = true } = options;
    return $j74jC.debounce(func, throttleMs, {
        leading: leading,
        maxWait: throttleMs,
        trailing: trailing
    });
}
module.exports.throttle = $114d22efb6da3128$var$throttle;

});
parcelRegister("j74jC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ef37w = parcelRequire("ef37w");
function $dea204bba0ce948f$var$debounce(func, debounceMs = 0, options = {}) {
    if (typeof options !== 'object') options = {};
    const { leading: leading = false, trailing: trailing = true, maxWait: maxWait } = options;
    const edges = Array(2);
    if (leading) edges[0] = 'leading';
    if (trailing) edges[1] = 'trailing';
    let result = undefined;
    let pendingAt = null;
    const _debounced = $ef37w.debounce(function(...args) {
        result = func.apply(this, args);
        pendingAt = null;
    }, debounceMs, {
        edges: edges
    });
    const debounced = function(...args) {
        if (maxWait != null) {
            if (pendingAt === null) pendingAt = Date.now();
            if (Date.now() - pendingAt >= maxWait) {
                result = func.apply(this, args);
                pendingAt = Date.now();
                _debounced.cancel();
                _debounced.schedule();
                return result;
            }
        }
        _debounced.apply(this, args);
        return result;
    };
    const flush = ()=>{
        _debounced.flush();
        return result;
    };
    debounced.cancel = _debounced.cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $dea204bba0ce948f$var$debounce;

});
parcelRegister("ef37w", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $a5e4e305cbfffc54$var$debounce(func, debounceMs, { signal: signal, edges: edges } = {}) {
    let pendingThis = undefined;
    let pendingArgs = null;
    const leading = edges != null && edges.includes('leading');
    const trailing = edges == null || edges.includes('trailing');
    const invoke = ()=>{
        if (pendingArgs !== null) {
            func.apply(pendingThis, pendingArgs);
            pendingThis = undefined;
            pendingArgs = null;
        }
    };
    const onTimerEnd = ()=>{
        if (trailing) invoke();
        cancel();
    };
    let timeoutId = null;
    const schedule = ()=>{
        if (timeoutId != null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            onTimerEnd();
        }, debounceMs);
    };
    const cancelTimer = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    const cancel = ()=>{
        cancelTimer();
        pendingThis = undefined;
        pendingArgs = null;
    };
    const flush = ()=>{
        invoke();
    };
    const debounced = function(...args) {
        if (signal?.aborted) return;
        pendingThis = this;
        pendingArgs = args;
        const isFirstCall = timeoutId == null;
        schedule();
        if (leading && isFirstCall) invoke();
    };
    debounced.schedule = schedule;
    debounced.cancel = cancel;
    debounced.flush = flush;
    signal?.addEventListener('abort', cancel, {
        once: true
    });
    return debounced;
}
module.exports.debounce = $a5e4e305cbfffc54$var$debounce;

});



parcelRegister("4DHlV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $360c6ee56c0f5147$var$isPlainObject(object) {
    if (typeof object !== 'object') return false;
    if (object == null) return false;
    if (Object.getPrototypeOf(object) === null) return true;
    if (Object.prototype.toString.call(object) !== '[object Object]') {
        const tag = object[Symbol.toStringTag];
        if (tag == null) return false;
        const isTagReadonly = !Object.getOwnPropertyDescriptor(object, Symbol.toStringTag)?.writable;
        if (isTagReadonly) return false;
        return object.toString() === `[object ${tag}]`;
    }
    let proto = object;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(object) === proto;
}
module.exports.isPlainObject = $360c6ee56c0f5147$var$isPlainObject;

});

parcelRegister("ifW0z", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aJT8p = parcelRequire("aJT8p");

var $aGiDc = parcelRequire("aGiDc");
function $d4a69fec0f4ef4e4$var$range(start, end, step) {
    if (step && typeof step !== 'number' && $aJT8p.isIterateeCall(start, end, step)) end = step = undefined;
    start = $aGiDc.toFinite(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = $aGiDc.toFinite(end);
    step = step === undefined ? start < end ? 1 : -1 : $aGiDc.toFinite(step);
    const length = Math.max(Math.ceil((end - start) / (step || 1)), 0);
    const result = new Array(length);
    for(let index = 0; index < length; index++){
        result[index] = start;
        start += step;
    }
    return result;
}
module.exports.range = $d4a69fec0f4ef4e4$var$range;

});
parcelRegister("aGiDc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4oWEQ = parcelRequire("4oWEQ");
function $0201bf165634c3dd$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $4oWEQ.toNumber(value);
    if (value === Infinity || value === -Infinity) {
        const sign = value < 0 ? -1 : 1;
        return sign * Number.MAX_VALUE;
    }
    return value === value ? value : 0;
}
module.exports.toFinite = $0201bf165634c3dd$var$toFinite;

});
parcelRegister("4oWEQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bkjph = parcelRequire("bkjph");
function $3346e786fc888273$var$toNumber(value) {
    if ($bkjph.isSymbol(value)) return NaN;
    return Number(value);
}
module.exports.toNumber = $3346e786fc888273$var$toNumber;

});



parcelRegister("b1EZC", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("8m4c0"));

});
parcelRegister("8m4c0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $6153a160aa6007ff$var$_tickFormat.default;
    }
});

var $6153a160aa6007ff$var$_band = $6153a160aa6007ff$var$_interopRequireWildcard((parcelRequire("jplOL")));

var $6153a160aa6007ff$var$_identity = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("h4aZB")));

var $6153a160aa6007ff$var$_linear = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("hkuVA")));

var $6153a160aa6007ff$var$_log = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("7w1Ey")));

var $6153a160aa6007ff$var$_symlog = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("dH0Sc")));

var $6153a160aa6007ff$var$_ordinal = $6153a160aa6007ff$var$_interopRequireWildcard((parcelRequire("dd3Un")));

var $6153a160aa6007ff$var$_pow = $6153a160aa6007ff$var$_interopRequireWildcard((parcelRequire("7BKZn")));

var $6153a160aa6007ff$var$_radial = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("a8ngM")));

var $6153a160aa6007ff$var$_quantile = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("46r1H")));

var $6153a160aa6007ff$var$_quantize = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("9BRZ4")));

var $6153a160aa6007ff$var$_threshold = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("c8vHW")));

var $6153a160aa6007ff$var$_time = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("62kva")));

var $6153a160aa6007ff$var$_utcTime = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("3BYig")));

var $6153a160aa6007ff$var$_sequential = $6153a160aa6007ff$var$_interopRequireWildcard((parcelRequire("gzBfA")));

var $6153a160aa6007ff$var$_sequentialQuantile = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("k6LaN")));

var $6153a160aa6007ff$var$_diverging = $6153a160aa6007ff$var$_interopRequireWildcard((parcelRequire("3G8kb")));

var $6153a160aa6007ff$var$_tickFormat = $6153a160aa6007ff$var$_interopRequireDefault((parcelRequire("gSfL7")));
function $6153a160aa6007ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6153a160aa6007ff$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6153a160aa6007ff$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6153a160aa6007ff$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6153a160aa6007ff$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("jplOL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e21146a933ef8368$var$band;
module.exports.point = $e21146a933ef8368$var$point;

var $vxwOH = parcelRequire("vxwOH");

var $aPZBO = parcelRequire("aPZBO");

var $e21146a933ef8368$var$_ordinal = $e21146a933ef8368$var$_interopRequireDefault((parcelRequire("dd3Un")));
function $e21146a933ef8368$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e21146a933ef8368$var$band() {
    var scale = (0, $e21146a933ef8368$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $vxwOH.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $e21146a933ef8368$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $aPZBO.initRange.apply(rescale(), arguments);
}
function $e21146a933ef8368$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $e21146a933ef8368$var$pointish(copy());
    };
    return scale;
}
function $e21146a933ef8368$var$point() {
    return $e21146a933ef8368$var$pointish($e21146a933ef8368$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("vxwOH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $ejIvL.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $knLmT.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $knLmT.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $ejIvL.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $ejIvL.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $05ece76327f9e0ec$var$_zip.default;
    }
});

var $05ece76327f9e0ec$var$_bisect = $05ece76327f9e0ec$var$_interopRequireWildcard((parcelRequire("4lUU4")));

var $05ece76327f9e0ec$var$_ascending = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("fmMml")));

var $05ece76327f9e0ec$var$_bisector = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("ikxXS")));

var $05ece76327f9e0ec$var$_count = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("b5KLI")));

var $05ece76327f9e0ec$var$_cross = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("bovCI")));

var $05ece76327f9e0ec$var$_cumsum = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("2aFY8")));

var $05ece76327f9e0ec$var$_descending = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("annF2")));

var $05ece76327f9e0ec$var$_deviation = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("9fPGa")));

var $05ece76327f9e0ec$var$_extent = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("bsTWE")));

var $ejIvL = parcelRequire("ejIvL");

var $05ece76327f9e0ec$var$_group = $05ece76327f9e0ec$var$_interopRequireWildcard((parcelRequire("ir7f8")));

var $05ece76327f9e0ec$var$_groupSort = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("c25TU")));

var $05ece76327f9e0ec$var$_bin = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("bIkm0")));

var $05ece76327f9e0ec$var$_freedmanDiaconis = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("bgbnt")));

var $05ece76327f9e0ec$var$_scott = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("hzWsu")));

var $05ece76327f9e0ec$var$_sturges = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("dmlJt")));

var $05ece76327f9e0ec$var$_max = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("lGtFd")));

var $05ece76327f9e0ec$var$_maxIndex = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("68pvo")));

var $05ece76327f9e0ec$var$_mean = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("eFXY2")));

var $05ece76327f9e0ec$var$_median = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("12FRg")));

var $05ece76327f9e0ec$var$_merge = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("gicRv")));

var $05ece76327f9e0ec$var$_min = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("ag5vz")));

var $05ece76327f9e0ec$var$_minIndex = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("ip4JR")));

var $05ece76327f9e0ec$var$_mode = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("aTMfN")));

var $05ece76327f9e0ec$var$_nice = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("kgpXX")));

var $05ece76327f9e0ec$var$_pairs = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("3ZI89")));

var $05ece76327f9e0ec$var$_permute = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("couLM")));

var $05ece76327f9e0ec$var$_quantile = $05ece76327f9e0ec$var$_interopRequireWildcard((parcelRequire("hYsH8")));

var $05ece76327f9e0ec$var$_quickselect = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("12ZYd")));

var $05ece76327f9e0ec$var$_range = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("6mtHM")));

var $05ece76327f9e0ec$var$_rank = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("kE6rA")));

var $05ece76327f9e0ec$var$_least = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("j0Yqx")));

var $05ece76327f9e0ec$var$_leastIndex = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("59jMd")));

var $05ece76327f9e0ec$var$_greatest = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("4wL4U")));

var $05ece76327f9e0ec$var$_greatestIndex = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("6U87z")));

var $05ece76327f9e0ec$var$_scan = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("2RAD8")));

var $05ece76327f9e0ec$var$_shuffle = $05ece76327f9e0ec$var$_interopRequireWildcard((parcelRequire("bPQHc")));

var $05ece76327f9e0ec$var$_sum = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("7Ke5o")));

var $05ece76327f9e0ec$var$_ticks = $05ece76327f9e0ec$var$_interopRequireWildcard((parcelRequire("gA6Ah")));

var $05ece76327f9e0ec$var$_transpose = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("8kS3K")));

var $05ece76327f9e0ec$var$_variance = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("hrWf1")));

var $05ece76327f9e0ec$var$_zip = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("9LAhn")));

var $05ece76327f9e0ec$var$_every = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("92VNq")));

var $05ece76327f9e0ec$var$_some = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("5YwCv")));

var $05ece76327f9e0ec$var$_filter = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("feRDr")));

var $05ece76327f9e0ec$var$_map = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("km1zb")));

var $05ece76327f9e0ec$var$_reduce = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("d8sqb")));

var $05ece76327f9e0ec$var$_reverse = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("kDvdN")));

var $05ece76327f9e0ec$var$_sort = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("fGd6i")));

var $05ece76327f9e0ec$var$_difference = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("9CsPA")));

var $05ece76327f9e0ec$var$_disjoint = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("ilstI")));

var $05ece76327f9e0ec$var$_intersection = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("jjDyq")));

var $05ece76327f9e0ec$var$_subset = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("XZ3cv")));

var $05ece76327f9e0ec$var$_superset = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("4sa22")));

var $05ece76327f9e0ec$var$_union = $05ece76327f9e0ec$var$_interopRequireDefault((parcelRequire("2zTOR")));

var $knLmT = parcelRequire("knLmT");
function $05ece76327f9e0ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $05ece76327f9e0ec$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($05ece76327f9e0ec$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $05ece76327f9e0ec$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $05ece76327f9e0ec$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("4lUU4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $32b543661518b60a$var$_ascending = $32b543661518b60a$var$_interopRequireDefault((parcelRequire("fmMml")));

var $32b543661518b60a$var$_bisector = $32b543661518b60a$var$_interopRequireDefault((parcelRequire("ikxXS")));

var $32b543661518b60a$var$_number = $32b543661518b60a$var$_interopRequireDefault((parcelRequire("5GtN1")));
function $32b543661518b60a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32b543661518b60a$var$ascendingBisect = (0, $32b543661518b60a$var$_bisector.default)($32b543661518b60a$var$_ascending.default);
const $32b543661518b60a$var$bisectRight = module.exports.bisectRight = $32b543661518b60a$var$ascendingBisect.right;
const $32b543661518b60a$var$bisectLeft = module.exports.bisectLeft = $32b543661518b60a$var$ascendingBisect.left;
const $32b543661518b60a$var$bisectCenter = module.exports.bisectCenter = (0, $32b543661518b60a$var$_bisector.default)($32b543661518b60a$var$_number.default).center;
var $32b543661518b60a$var$_default = module.exports.default = $32b543661518b60a$var$bisectRight;

});
parcelRegister("fmMml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2fe6c3ca7a30fb1$var$ascending;
function $b2fe6c3ca7a30fb1$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("ikxXS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d58470f654c8ca9a$var$bisector;

var $d58470f654c8ca9a$var$_ascending = $d58470f654c8ca9a$var$_interopRequireDefault((parcelRequire("fmMml")));

var $d58470f654c8ca9a$var$_descending = $d58470f654c8ca9a$var$_interopRequireDefault((parcelRequire("annF2")));
function $d58470f654c8ca9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d58470f654c8ca9a$var$bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $d58470f654c8ca9a$var$_ascending.default;
        compare2 = (d, x)=>(0, $d58470f654c8ca9a$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $d58470f654c8ca9a$var$_ascending.default || f === $d58470f654c8ca9a$var$_descending.default ? f : $d58470f654c8ca9a$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $d58470f654c8ca9a$var$zero() {
    return 0;
}

});
parcelRegister("annF2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78de67ee2eac20f9$var$descending;
function $78de67ee2eac20f9$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("5GtN1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4237fb986f22d9ec$var$number;
module.exports.numbers = $4237fb986f22d9ec$var$numbers;
function $4237fb986f22d9ec$var$number(x) {
    return x === null ? NaN : +x;
}
function* $4237fb986f22d9ec$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("b5KLI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8134709a655575fe$var$count;
function $8134709a655575fe$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("bovCI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84ba7755925451c6$var$cross;
function $84ba7755925451c6$var$length(array) {
    return array.length | 0;
}
function $84ba7755925451c6$var$empty(length) {
    return !(length > 0);
}
function $84ba7755925451c6$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $84ba7755925451c6$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $84ba7755925451c6$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $84ba7755925451c6$var$reducer(values.pop());
    values = values.map($84ba7755925451c6$var$arrayify);
    const lengths = values.map($84ba7755925451c6$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($84ba7755925451c6$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("2aFY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $194d1218961beaa2$var$cumsum;
function $194d1218961beaa2$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("9fPGa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6bcd9a2ee1ea70f4$var$deviation;

var $6bcd9a2ee1ea70f4$var$_variance = $6bcd9a2ee1ea70f4$var$_interopRequireDefault((parcelRequire("hrWf1")));
function $6bcd9a2ee1ea70f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6bcd9a2ee1ea70f4$var$deviation(values, valueof) {
    const v = (0, $6bcd9a2ee1ea70f4$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("hrWf1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cb4222c54fbfd826$var$variance;
function $cb4222c54fbfd826$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("bsTWE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $858db4b9d62ee5fd$var$extent;
function $858db4b9d62ee5fd$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("ejIvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $a6c55e138cbf6565$var$fcumsum;
module.exports.fsum = $a6c55e138cbf6565$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $a6c55e138cbf6565$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $a6c55e138cbf6565$var$Adder;
function $a6c55e138cbf6565$var$fsum(values, valueof) {
    const adder = new $a6c55e138cbf6565$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $a6c55e138cbf6565$var$fcumsum(values, valueof) {
    const adder = new $a6c55e138cbf6565$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("ir7f8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6c05df2523f8a7d$var$group;
module.exports.flatGroup = $d6c05df2523f8a7d$var$flatGroup;
module.exports.flatRollup = $d6c05df2523f8a7d$var$flatRollup;
module.exports.groups = $d6c05df2523f8a7d$var$groups;
module.exports.index = $d6c05df2523f8a7d$var$index;
module.exports.indexes = $d6c05df2523f8a7d$var$indexes;
module.exports.rollup = $d6c05df2523f8a7d$var$rollup;
module.exports.rollups = $d6c05df2523f8a7d$var$rollups;

var $knLmT = parcelRequire("knLmT");

var $d6c05df2523f8a7d$var$_identity = $d6c05df2523f8a7d$var$_interopRequireDefault((parcelRequire("eDKjX")));
function $d6c05df2523f8a7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d6c05df2523f8a7d$var$group(values, ...keys) {
    return $d6c05df2523f8a7d$var$nest(values, $d6c05df2523f8a7d$var$_identity.default, $d6c05df2523f8a7d$var$_identity.default, keys);
}
function $d6c05df2523f8a7d$var$groups(values, ...keys) {
    return $d6c05df2523f8a7d$var$nest(values, Array.from, $d6c05df2523f8a7d$var$_identity.default, keys);
}
function $d6c05df2523f8a7d$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $d6c05df2523f8a7d$var$flatGroup(values, ...keys) {
    return $d6c05df2523f8a7d$var$flatten($d6c05df2523f8a7d$var$groups(values, ...keys), keys);
}
function $d6c05df2523f8a7d$var$flatRollup(values, reduce, ...keys) {
    return $d6c05df2523f8a7d$var$flatten($d6c05df2523f8a7d$var$rollups(values, reduce, ...keys), keys);
}
function $d6c05df2523f8a7d$var$rollup(values, reduce, ...keys) {
    return $d6c05df2523f8a7d$var$nest(values, $d6c05df2523f8a7d$var$_identity.default, reduce, keys);
}
function $d6c05df2523f8a7d$var$rollups(values, reduce, ...keys) {
    return $d6c05df2523f8a7d$var$nest(values, Array.from, reduce, keys);
}
function $d6c05df2523f8a7d$var$index(values, ...keys) {
    return $d6c05df2523f8a7d$var$nest(values, $d6c05df2523f8a7d$var$_identity.default, $d6c05df2523f8a7d$var$unique, keys);
}
function $d6c05df2523f8a7d$var$indexes(values, ...keys) {
    return $d6c05df2523f8a7d$var$nest(values, Array.from, $d6c05df2523f8a7d$var$unique, keys);
}
function $d6c05df2523f8a7d$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $d6c05df2523f8a7d$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $knLmT.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("knLmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $ed6ab2fc85c3ce0c$var$InternMap extends Map {
    constructor(entries, key = $ed6ab2fc85c3ce0c$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($ed6ab2fc85c3ce0c$var$intern_get(this, key));
    }
    has(key) {
        return super.has($ed6ab2fc85c3ce0c$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($ed6ab2fc85c3ce0c$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($ed6ab2fc85c3ce0c$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $ed6ab2fc85c3ce0c$var$InternMap;
class $ed6ab2fc85c3ce0c$var$InternSet extends Set {
    constructor(values, key = $ed6ab2fc85c3ce0c$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($ed6ab2fc85c3ce0c$var$intern_get(this, value));
    }
    add(value) {
        return super.add($ed6ab2fc85c3ce0c$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($ed6ab2fc85c3ce0c$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $ed6ab2fc85c3ce0c$var$InternSet;
function $ed6ab2fc85c3ce0c$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $ed6ab2fc85c3ce0c$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $ed6ab2fc85c3ce0c$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $ed6ab2fc85c3ce0c$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("eDKjX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $02c023ab9e5df937$var$identity;
function $02c023ab9e5df937$var$identity(x) {
    return x;
}

});


parcelRegister("c25TU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c2a3fb990bc5df1$var$groupSort;

var $8c2a3fb990bc5df1$var$_ascending = $8c2a3fb990bc5df1$var$_interopRequireDefault((parcelRequire("fmMml")));

var $8c2a3fb990bc5df1$var$_group = $8c2a3fb990bc5df1$var$_interopRequireWildcard((parcelRequire("ir7f8")));

var $8c2a3fb990bc5df1$var$_sort = $8c2a3fb990bc5df1$var$_interopRequireDefault((parcelRequire("fGd6i")));
function $8c2a3fb990bc5df1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8c2a3fb990bc5df1$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $8c2a3fb990bc5df1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $8c2a3fb990bc5df1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $8c2a3fb990bc5df1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c2a3fb990bc5df1$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $8c2a3fb990bc5df1$var$_sort.default)((0, $8c2a3fb990bc5df1$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $8c2a3fb990bc5df1$var$_ascending.default)(av, bv) || (0, $8c2a3fb990bc5df1$var$_ascending.default)(ak, bk)) : (0, $8c2a3fb990bc5df1$var$_sort.default)((0, $8c2a3fb990bc5df1$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $8c2a3fb990bc5df1$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("fGd6i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $b6a4f0c314066caf$var$ascendingDefined;
module.exports.compareDefined = $b6a4f0c314066caf$var$compareDefined;
module.exports.default = $b6a4f0c314066caf$var$sort;

var $b6a4f0c314066caf$var$_ascending = $b6a4f0c314066caf$var$_interopRequireDefault((parcelRequire("fmMml")));

var $b6a4f0c314066caf$var$_permute = $b6a4f0c314066caf$var$_interopRequireDefault((parcelRequire("couLM")));
function $b6a4f0c314066caf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b6a4f0c314066caf$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $b6a4f0c314066caf$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$b6a4f0c314066caf$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $b6a4f0c314066caf$var$_permute.default)(values, index);
    }
    return values.sort($b6a4f0c314066caf$var$compareDefined(f));
}
function $b6a4f0c314066caf$var$compareDefined(compare = $b6a4f0c314066caf$var$_ascending.default) {
    if (compare === $b6a4f0c314066caf$var$_ascending.default) return $b6a4f0c314066caf$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $b6a4f0c314066caf$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("couLM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $905f98225a0bebb8$var$permute;
function $905f98225a0bebb8$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("bIkm0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $887397a7b6968c34$var$bin;

var $hVvKS = parcelRequire("hVvKS");

var $887397a7b6968c34$var$_bisect = $887397a7b6968c34$var$_interopRequireDefault((parcelRequire("4lUU4")));

var $887397a7b6968c34$var$_constant = $887397a7b6968c34$var$_interopRequireDefault((parcelRequire("9v0hp")));

var $887397a7b6968c34$var$_extent = $887397a7b6968c34$var$_interopRequireDefault((parcelRequire("bsTWE")));

var $887397a7b6968c34$var$_identity = $887397a7b6968c34$var$_interopRequireDefault((parcelRequire("eDKjX")));

var $887397a7b6968c34$var$_nice = $887397a7b6968c34$var$_interopRequireDefault((parcelRequire("kgpXX")));

var $887397a7b6968c34$var$_ticks = $887397a7b6968c34$var$_interopRequireWildcard((parcelRequire("gA6Ah")));

var $887397a7b6968c34$var$_sturges = $887397a7b6968c34$var$_interopRequireDefault((parcelRequire("dmlJt")));
function $887397a7b6968c34$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($887397a7b6968c34$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $887397a7b6968c34$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $887397a7b6968c34$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $887397a7b6968c34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $887397a7b6968c34$var$bin() {
    var value = $887397a7b6968c34$var$_identity.default, domain = $887397a7b6968c34$var$_extent.default, threshold = $887397a7b6968c34$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $887397a7b6968c34$var$_extent.default) [x0, x1] = (0, $887397a7b6968c34$var$_nice.default)(x0, x1, tn);
            tz = (0, $887397a7b6968c34$var$_ticks.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $887397a7b6968c34$var$_ticks.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $887397a7b6968c34$var$_extent.default) {
                    const step = (0, $887397a7b6968c34$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $887397a7b6968c34$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $887397a7b6968c34$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $887397a7b6968c34$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $887397a7b6968c34$var$_constant.default)($hVvKS.slice.call(_)) : (0, $887397a7b6968c34$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("hVvKS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $d0d064724c5fb20c$var$array = Array.prototype;
var $d0d064724c5fb20c$var$slice = module.exports.slice = $d0d064724c5fb20c$var$array.slice;
var $d0d064724c5fb20c$var$map = module.exports.map = $d0d064724c5fb20c$var$array.map;

});

parcelRegister("9v0hp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ea739dbc992048a$var$constant;
function $6ea739dbc992048a$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("kgpXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec0971903a19b060$var$nice;

var $gA6Ah = parcelRequire("gA6Ah");
function $ec0971903a19b060$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $gA6Ah.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("gA6Ah", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1251d9f37f978a5$var$ticks;
module.exports.tickIncrement = $c1251d9f37f978a5$var$tickIncrement;
module.exports.tickStep = $c1251d9f37f978a5$var$tickStep;
var $c1251d9f37f978a5$var$e10 = Math.sqrt(50), $c1251d9f37f978a5$var$e5 = Math.sqrt(10), $c1251d9f37f978a5$var$e2 = Math.sqrt(2);
function $c1251d9f37f978a5$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $c1251d9f37f978a5$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $c1251d9f37f978a5$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $c1251d9f37f978a5$var$e10 ? 10 : error >= $c1251d9f37f978a5$var$e5 ? 5 : error >= $c1251d9f37f978a5$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $c1251d9f37f978a5$var$e10 ? 10 : error >= $c1251d9f37f978a5$var$e5 ? 5 : error >= $c1251d9f37f978a5$var$e2 ? 2 : 1);
}
function $c1251d9f37f978a5$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $c1251d9f37f978a5$var$e10) step1 *= 10;
    else if (error >= $c1251d9f37f978a5$var$e5) step1 *= 5;
    else if (error >= $c1251d9f37f978a5$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("dmlJt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b9e301038552747$var$thresholdSturges;

var $9b9e301038552747$var$_count = $9b9e301038552747$var$_interopRequireDefault((parcelRequire("b5KLI")));
function $9b9e301038552747$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b9e301038552747$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $9b9e301038552747$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("bgbnt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $832a03b6389b63cd$var$thresholdFreedmanDiaconis;

var $832a03b6389b63cd$var$_count = $832a03b6389b63cd$var$_interopRequireDefault((parcelRequire("b5KLI")));

var $832a03b6389b63cd$var$_quantile = $832a03b6389b63cd$var$_interopRequireDefault((parcelRequire("hYsH8")));
function $832a03b6389b63cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $832a03b6389b63cd$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $832a03b6389b63cd$var$_quantile.default)(values, 0.75) - (0, $832a03b6389b63cd$var$_quantile.default)(values, 0.25)) * Math.pow((0, $832a03b6389b63cd$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("hYsH8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d15e4c6a69be6065$var$quantile;
module.exports.quantileSorted = $d15e4c6a69be6065$var$quantileSorted;

var $d15e4c6a69be6065$var$_max = $d15e4c6a69be6065$var$_interopRequireDefault((parcelRequire("lGtFd")));

var $d15e4c6a69be6065$var$_min = $d15e4c6a69be6065$var$_interopRequireDefault((parcelRequire("ag5vz")));

var $d15e4c6a69be6065$var$_quickselect = $d15e4c6a69be6065$var$_interopRequireDefault((parcelRequire("12ZYd")));

var $d15e4c6a69be6065$var$_number = $d15e4c6a69be6065$var$_interopRequireWildcard((parcelRequire("5GtN1")));
function $d15e4c6a69be6065$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d15e4c6a69be6065$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $d15e4c6a69be6065$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $d15e4c6a69be6065$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $d15e4c6a69be6065$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d15e4c6a69be6065$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $d15e4c6a69be6065$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $d15e4c6a69be6065$var$_min.default)(values);
    if (p >= 1) return (0, $d15e4c6a69be6065$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $d15e4c6a69be6065$var$_max.default)((0, $d15e4c6a69be6065$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $d15e4c6a69be6065$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $d15e4c6a69be6065$var$quantileSorted(values, p, valueof = $d15e4c6a69be6065$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("lGtFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fc9487cc8f28a05f$var$max;
function $fc9487cc8f28a05f$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("ag5vz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $777fabd42d4bd16a$var$min;
function $777fabd42d4bd16a$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("12ZYd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c360c56459f8917$var$quickselect;

var $fGd6i = parcelRequire("fGd6i");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $0c360c56459f8917$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $fGd6i.ascendingDefined : (0, $fGd6i.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $0c360c56459f8917$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $0c360c56459f8917$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $0c360c56459f8917$var$swap(array, left, right);
        while(i < j){
            $0c360c56459f8917$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $0c360c56459f8917$var$swap(array, left, j);
        else ++j, $0c360c56459f8917$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $0c360c56459f8917$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("hzWsu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccc30d37dd5fd551$var$thresholdScott;

var $ccc30d37dd5fd551$var$_count = $ccc30d37dd5fd551$var$_interopRequireDefault((parcelRequire("b5KLI")));

var $ccc30d37dd5fd551$var$_deviation = $ccc30d37dd5fd551$var$_interopRequireDefault((parcelRequire("9fPGa")));
function $ccc30d37dd5fd551$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ccc30d37dd5fd551$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $ccc30d37dd5fd551$var$_count.default)(values)) / (3.49 * (0, $ccc30d37dd5fd551$var$_deviation.default)(values)));
}

});

parcelRegister("68pvo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $477746428334df39$var$maxIndex;
function $477746428334df39$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("eFXY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aaf369514ba8684d$var$mean;
function $aaf369514ba8684d$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("12FRg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c26727f83f53940$var$median;

var $0c26727f83f53940$var$_quantile = $0c26727f83f53940$var$_interopRequireDefault((parcelRequire("hYsH8")));
function $0c26727f83f53940$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0c26727f83f53940$var$median(values, valueof) {
    return (0, $0c26727f83f53940$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("gicRv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bdc84dec1d70959a$var$merge;
function* $bdc84dec1d70959a$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $bdc84dec1d70959a$var$merge(arrays) {
    return Array.from($bdc84dec1d70959a$var$flatten(arrays));
}

});

parcelRegister("ip4JR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d65e3cccab10f418$var$minIndex;
function $d65e3cccab10f418$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("aTMfN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ef4789be108e86c$var$mode;

var $knLmT = parcelRequire("knLmT");
function $7ef4789be108e86c$var$mode(values, valueof) {
    const counts = new $knLmT.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("3ZI89", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e894cfbd8105b95$var$pairs;
module.exports.pair = $2e894cfbd8105b95$var$pair;
function $2e894cfbd8105b95$var$pairs(values, pairof = $2e894cfbd8105b95$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $2e894cfbd8105b95$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("6mtHM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a1bd6f35957a74b$var$range;
function $4a1bd6f35957a74b$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("kE6rA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f07c8ab8bc2b4728$var$rank;

var $f07c8ab8bc2b4728$var$_ascending = $f07c8ab8bc2b4728$var$_interopRequireDefault((parcelRequire("fmMml")));

var $fGd6i = parcelRequire("fGd6i");
function $f07c8ab8bc2b4728$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f07c8ab8bc2b4728$var$rank(values, valueof = $f07c8ab8bc2b4728$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $f07c8ab8bc2b4728$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $f07c8ab8bc2b4728$var$_ascending.default ? (i, j)=>(0, $fGd6i.ascendingDefined)(V[i], V[j]) : (0, $fGd6i.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("j0Yqx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd7ce3fa3af836c2$var$least;

var $dd7ce3fa3af836c2$var$_ascending = $dd7ce3fa3af836c2$var$_interopRequireDefault((parcelRequire("fmMml")));
function $dd7ce3fa3af836c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dd7ce3fa3af836c2$var$least(values, compare = $dd7ce3fa3af836c2$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $dd7ce3fa3af836c2$var$_ascending.default)(value, minValue) < 0 : (0, $dd7ce3fa3af836c2$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("59jMd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3bfd223d9877c8e0$var$leastIndex;

var $3bfd223d9877c8e0$var$_ascending = $3bfd223d9877c8e0$var$_interopRequireDefault((parcelRequire("fmMml")));

var $3bfd223d9877c8e0$var$_minIndex = $3bfd223d9877c8e0$var$_interopRequireDefault((parcelRequire("ip4JR")));
function $3bfd223d9877c8e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3bfd223d9877c8e0$var$leastIndex(values, compare = $3bfd223d9877c8e0$var$_ascending.default) {
    if (compare.length === 1) return (0, $3bfd223d9877c8e0$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("4wL4U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34beab55566c0b6d$var$greatest;

var $34beab55566c0b6d$var$_ascending = $34beab55566c0b6d$var$_interopRequireDefault((parcelRequire("fmMml")));
function $34beab55566c0b6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34beab55566c0b6d$var$greatest(values, compare = $34beab55566c0b6d$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $34beab55566c0b6d$var$_ascending.default)(value, maxValue) > 0 : (0, $34beab55566c0b6d$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("6U87z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $014c19e5fb7ab05b$var$greatestIndex;

var $014c19e5fb7ab05b$var$_ascending = $014c19e5fb7ab05b$var$_interopRequireDefault((parcelRequire("fmMml")));

var $014c19e5fb7ab05b$var$_maxIndex = $014c19e5fb7ab05b$var$_interopRequireDefault((parcelRequire("68pvo")));
function $014c19e5fb7ab05b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $014c19e5fb7ab05b$var$greatestIndex(values, compare = $014c19e5fb7ab05b$var$_ascending.default) {
    if (compare.length === 1) return (0, $014c19e5fb7ab05b$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("2RAD8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $215cf1feee0125ad$var$scan;

var $215cf1feee0125ad$var$_leastIndex = $215cf1feee0125ad$var$_interopRequireDefault((parcelRequire("59jMd")));
function $215cf1feee0125ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $215cf1feee0125ad$var$scan(values, compare) {
    const index = (0, $215cf1feee0125ad$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("bPQHc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $89dd556596cda96b$var$shuffler;
var $89dd556596cda96b$var$_default = module.exports.default = $89dd556596cda96b$var$shuffler(Math.random);
function $89dd556596cda96b$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("7Ke5o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a37c175f4eba496$var$sum;
function $5a37c175f4eba496$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("8kS3K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $611a2017d3628a37$var$transpose;

var $611a2017d3628a37$var$_min = $611a2017d3628a37$var$_interopRequireDefault((parcelRequire("ag5vz")));
function $611a2017d3628a37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $611a2017d3628a37$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $611a2017d3628a37$var$_min.default)(matrix, $611a2017d3628a37$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $611a2017d3628a37$var$length(d) {
    return d.length;
}

});

parcelRegister("9LAhn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71c4a52c28498add$var$zip;

var $71c4a52c28498add$var$_transpose = $71c4a52c28498add$var$_interopRequireDefault((parcelRequire("8kS3K")));
function $71c4a52c28498add$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $71c4a52c28498add$var$zip() {
    return (0, $71c4a52c28498add$var$_transpose.default)(arguments);
}

});

parcelRegister("92VNq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6961221551650a3b$var$every;
function $6961221551650a3b$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("5YwCv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $459bdc0323010327$var$some;
function $459bdc0323010327$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("feRDr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b181c49eb8dd78a8$var$filter;
function $b181c49eb8dd78a8$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("km1zb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed1713c784a81108$var$map;
function $ed1713c784a81108$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("d8sqb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99021195f73571a8$var$reduce;
function $99021195f73571a8$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("kDvdN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f05fab166d3d280d$var$reverse;
function $f05fab166d3d280d$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("9CsPA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $700e06e85fcfb841$var$difference;

var $knLmT = parcelRequire("knLmT");
function $700e06e85fcfb841$var$difference(values, ...others) {
    values = new $knLmT.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("ilstI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5b04755305eee40$var$disjoint;

var $knLmT = parcelRequire("knLmT");
function $d5b04755305eee40$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $knLmT.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("jjDyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0fe795828e36e80$var$intersection;

var $knLmT = parcelRequire("knLmT");
function $e0fe795828e36e80$var$intersection(values, ...others) {
    values = new $knLmT.InternSet(values);
    others = others.map($e0fe795828e36e80$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $e0fe795828e36e80$var$set(values) {
    return values instanceof $knLmT.InternSet ? values : new $knLmT.InternSet(values);
}

});

parcelRegister("XZ3cv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b44de2f5a5be5c5$var$subset;

var $0b44de2f5a5be5c5$var$_superset = $0b44de2f5a5be5c5$var$_interopRequireDefault((parcelRequire("4sa22")));
function $0b44de2f5a5be5c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0b44de2f5a5be5c5$var$subset(values, other) {
    return (0, $0b44de2f5a5be5c5$var$_superset.default)(other, values);
}

});
parcelRegister("4sa22", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33e18f150530fe85$var$superset;
function $33e18f150530fe85$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $33e18f150530fe85$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $33e18f150530fe85$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $33e18f150530fe85$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("2zTOR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e0a263694c8fe5c$var$union;

var $knLmT = parcelRequire("knLmT");
function $1e0a263694c8fe5c$var$union(...others) {
    const set = new $knLmT.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("aPZBO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $7e3e750837cea323$var$initInterpolator;
module.exports.initRange = $7e3e750837cea323$var$initRange;
function $7e3e750837cea323$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $7e3e750837cea323$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("dd3Un", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99df8560e8fe2c43$var$ordinal;
module.exports.implicit = void 0;

var $vxwOH = parcelRequire("vxwOH");

var $aPZBO = parcelRequire("aPZBO");
const $99df8560e8fe2c43$var$implicit = module.exports.implicit = Symbol("implicit");
function $99df8560e8fe2c43$var$ordinal() {
    var index = new $vxwOH.InternMap(), domain = [], range = [], unknown = $99df8560e8fe2c43$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $99df8560e8fe2c43$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $vxwOH.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $99df8560e8fe2c43$var$ordinal(domain, range).unknown(unknown);
    };
    $aPZBO.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("h4aZB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c6cb5648cbf416a6$var$identity;

var $hkuVA = parcelRequire("hkuVA");

var $c6cb5648cbf416a6$var$_number = $c6cb5648cbf416a6$var$_interopRequireDefault((parcelRequire("9ss5Q")));
function $c6cb5648cbf416a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c6cb5648cbf416a6$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $c6cb5648cbf416a6$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c6cb5648cbf416a6$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $c6cb5648cbf416a6$var$_number.default) : [
        0,
        1
    ];
    return (0, $hkuVA.linearish)(scale);
}

});
parcelRegister("hkuVA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9dc4b9209cba49e$var$linear;
module.exports.linearish = $c9dc4b9209cba49e$var$linearish;

var $vxwOH = parcelRequire("vxwOH");

var $c9dc4b9209cba49e$var$_continuous = $c9dc4b9209cba49e$var$_interopRequireWildcard((parcelRequire("dfCSv")));

var $aPZBO = parcelRequire("aPZBO");

var $c9dc4b9209cba49e$var$_tickFormat = $c9dc4b9209cba49e$var$_interopRequireDefault((parcelRequire("gSfL7")));
function $c9dc4b9209cba49e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c9dc4b9209cba49e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c9dc4b9209cba49e$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $c9dc4b9209cba49e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $c9dc4b9209cba49e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $c9dc4b9209cba49e$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $vxwOH.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $c9dc4b9209cba49e$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $vxwOH.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $c9dc4b9209cba49e$var$linear() {
    var scale = (0, $c9dc4b9209cba49e$var$_continuous.default)();
    scale.copy = function() {
        return (0, $c9dc4b9209cba49e$var$_continuous.copy)(scale, $c9dc4b9209cba49e$var$linear());
    };
    $aPZBO.initRange.apply(scale, arguments);
    return $c9dc4b9209cba49e$var$linearish(scale);
}

});
parcelRegister("dfCSv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $9a5ad571b9c68547$var$copy;
module.exports.default = $9a5ad571b9c68547$var$continuous;
module.exports.identity = $9a5ad571b9c68547$var$identity;
module.exports.transformer = $9a5ad571b9c68547$var$transformer;

var $vxwOH = parcelRequire("vxwOH");

var $ctdoE = parcelRequire("ctdoE");

var $9a5ad571b9c68547$var$_constant = $9a5ad571b9c68547$var$_interopRequireDefault((parcelRequire("CqUcz")));

var $9a5ad571b9c68547$var$_number = $9a5ad571b9c68547$var$_interopRequireDefault((parcelRequire("9ss5Q")));
function $9a5ad571b9c68547$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9a5ad571b9c68547$var$unit = [
    0,
    1
];
function $9a5ad571b9c68547$var$identity(x) {
    return x;
}
function $9a5ad571b9c68547$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $9a5ad571b9c68547$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $9a5ad571b9c68547$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $9a5ad571b9c68547$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $9a5ad571b9c68547$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $9a5ad571b9c68547$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $9a5ad571b9c68547$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $9a5ad571b9c68547$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $vxwOH.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $9a5ad571b9c68547$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $9a5ad571b9c68547$var$transformer() {
    var domain = $9a5ad571b9c68547$var$unit, range = $9a5ad571b9c68547$var$unit, interpolate = $ctdoE.interpolate, transform, untransform, unknown, clamp = $9a5ad571b9c68547$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $9a5ad571b9c68547$var$identity) clamp = $9a5ad571b9c68547$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $9a5ad571b9c68547$var$polymap : $9a5ad571b9c68547$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $ctdoE.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $9a5ad571b9c68547$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $ctdoE.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $9a5ad571b9c68547$var$identity, rescale()) : clamp !== $9a5ad571b9c68547$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $9a5ad571b9c68547$var$continuous() {
    return $9a5ad571b9c68547$var$transformer()($9a5ad571b9c68547$var$identity, $9a5ad571b9c68547$var$identity);
}

});
parcelRegister("ctdoE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $eGeJl.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $eGeJl.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $914295bc7fbd6c98$var$_quantize.default;
    }
});

var $914295bc7fbd6c98$var$_value = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("kD0l9")));

var $914295bc7fbd6c98$var$_array = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("luXq6")));

var $914295bc7fbd6c98$var$_basis = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("1bmGG")));

var $914295bc7fbd6c98$var$_basisClosed = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("6X6wf")));

var $914295bc7fbd6c98$var$_date = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("2OheY")));

var $914295bc7fbd6c98$var$_discrete = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("4YOqM")));

var $914295bc7fbd6c98$var$_hue = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("8Oh4j")));

var $914295bc7fbd6c98$var$_number = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("6RFEN")));

var $914295bc7fbd6c98$var$_numberArray = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("6o5Sg")));

var $914295bc7fbd6c98$var$_object = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("l0tng")));

var $914295bc7fbd6c98$var$_round = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("9VdKc")));

var $914295bc7fbd6c98$var$_string = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("jjGrm")));

var $eGeJl = parcelRequire("eGeJl");

var $914295bc7fbd6c98$var$_zoom = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("eBekX")));

var $914295bc7fbd6c98$var$_rgb = $914295bc7fbd6c98$var$_interopRequireWildcard((parcelRequire("8Yzef")));

var $914295bc7fbd6c98$var$_hsl = $914295bc7fbd6c98$var$_interopRequireWildcard((parcelRequire("iSI1a")));

var $914295bc7fbd6c98$var$_lab = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("gy5fu")));

var $914295bc7fbd6c98$var$_hcl = $914295bc7fbd6c98$var$_interopRequireWildcard((parcelRequire("j1kha")));

var $914295bc7fbd6c98$var$_cubehelix = $914295bc7fbd6c98$var$_interopRequireWildcard((parcelRequire("8mDa3")));

var $914295bc7fbd6c98$var$_piecewise = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("dXY1l")));

var $914295bc7fbd6c98$var$_quantize = $914295bc7fbd6c98$var$_interopRequireDefault((parcelRequire("3d65a")));
function $914295bc7fbd6c98$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($914295bc7fbd6c98$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $914295bc7fbd6c98$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $914295bc7fbd6c98$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $914295bc7fbd6c98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("kD0l9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f047b6babc0efc1c$var$_default;

var $4AoQl = parcelRequire("4AoQl");

var $f047b6babc0efc1c$var$_rgb = $f047b6babc0efc1c$var$_interopRequireDefault((parcelRequire("8Yzef")));

var $luXq6 = parcelRequire("luXq6");

var $f047b6babc0efc1c$var$_date = $f047b6babc0efc1c$var$_interopRequireDefault((parcelRequire("2OheY")));

var $f047b6babc0efc1c$var$_number = $f047b6babc0efc1c$var$_interopRequireDefault((parcelRequire("6RFEN")));

var $f047b6babc0efc1c$var$_object = $f047b6babc0efc1c$var$_interopRequireDefault((parcelRequire("l0tng")));

var $f047b6babc0efc1c$var$_string = $f047b6babc0efc1c$var$_interopRequireDefault((parcelRequire("jjGrm")));

var $f047b6babc0efc1c$var$_constant = $f047b6babc0efc1c$var$_interopRequireDefault((parcelRequire("5I4kQ")));

var $f047b6babc0efc1c$var$_numberArray = $f047b6babc0efc1c$var$_interopRequireWildcard((parcelRequire("6o5Sg")));
function $f047b6babc0efc1c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f047b6babc0efc1c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $f047b6babc0efc1c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $f047b6babc0efc1c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $f047b6babc0efc1c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f047b6babc0efc1c$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $f047b6babc0efc1c$var$_constant.default)(b) : (t === "number" ? $f047b6babc0efc1c$var$_number.default : t === "string" ? (c = (0, $4AoQl.color)(b)) ? (b = c, $f047b6babc0efc1c$var$_rgb.default) : $f047b6babc0efc1c$var$_string.default : b instanceof $4AoQl.color ? $f047b6babc0efc1c$var$_rgb.default : b instanceof Date ? $f047b6babc0efc1c$var$_date.default : (0, $f047b6babc0efc1c$var$_numberArray.isNumberArray)(b) ? $f047b6babc0efc1c$var$_numberArray.default : Array.isArray(b) ? $luXq6.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $f047b6babc0efc1c$var$_object.default : $f047b6babc0efc1c$var$_number.default)(a, b);
}

});
parcelRegister("4AoQl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $356dcb923aa8d989$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $356dcb923aa8d989$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $356dcb923aa8d989$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $356dcb923aa8d989$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $356dcb923aa8d989$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $356dcb923aa8d989$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $356dcb923aa8d989$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $356dcb923aa8d989$var$_color.rgb;
    }
});

var $356dcb923aa8d989$var$_color = $356dcb923aa8d989$var$_interopRequireWildcard((parcelRequire("exD4H")));

var $356dcb923aa8d989$var$_lab = $356dcb923aa8d989$var$_interopRequireWildcard((parcelRequire("kvvmo")));

var $356dcb923aa8d989$var$_cubehelix = $356dcb923aa8d989$var$_interopRequireDefault((parcelRequire("a7qBG")));
function $356dcb923aa8d989$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $356dcb923aa8d989$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($356dcb923aa8d989$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $356dcb923aa8d989$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $356dcb923aa8d989$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("exD4H", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("9lRfB")));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function Color() {}
var darker = exports.darker = 0.7;
var brighter = exports.brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("9lRfB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6cef61b6f20a5dce$var$_default;
module.exports.extend = $6cef61b6f20a5dce$var$extend;
function $6cef61b6f20a5dce$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $6cef61b6f20a5dce$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("kvvmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $eedf07655fefc33d$var$Hcl;
module.exports.Lab = $eedf07655fefc33d$var$Lab;
module.exports.default = $eedf07655fefc33d$var$lab;
module.exports.gray = $eedf07655fefc33d$var$gray;
module.exports.hcl = $eedf07655fefc33d$var$hcl;
module.exports.lch = $eedf07655fefc33d$var$lch;

var $eedf07655fefc33d$var$_define = $eedf07655fefc33d$var$_interopRequireWildcard((parcelRequire("9lRfB")));

var $exD4H = parcelRequire("exD4H");

var $dIvTu = parcelRequire("dIvTu");
function $eedf07655fefc33d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($eedf07655fefc33d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $eedf07655fefc33d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $eedf07655fefc33d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $eedf07655fefc33d$var$K = 18, $eedf07655fefc33d$var$Xn = 0.96422, $eedf07655fefc33d$var$Yn = 1, $eedf07655fefc33d$var$Zn = 0.82521, $eedf07655fefc33d$var$t0 = 4 / 29, $eedf07655fefc33d$var$t1 = 6 / 29, $eedf07655fefc33d$var$t2 = 3 * $eedf07655fefc33d$var$t1 * $eedf07655fefc33d$var$t1, $eedf07655fefc33d$var$t3 = $eedf07655fefc33d$var$t1 * $eedf07655fefc33d$var$t1 * $eedf07655fefc33d$var$t1;
function $eedf07655fefc33d$var$labConvert(o) {
    if (o instanceof $eedf07655fefc33d$var$Lab) return new $eedf07655fefc33d$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $eedf07655fefc33d$var$Hcl) return $eedf07655fefc33d$var$hcl2lab(o);
    if (!(o instanceof $exD4H.Rgb)) o = (0, $exD4H.rgbConvert)(o);
    var r = $eedf07655fefc33d$var$rgb2lrgb(o.r), g = $eedf07655fefc33d$var$rgb2lrgb(o.g), b = $eedf07655fefc33d$var$rgb2lrgb(o.b), y = $eedf07655fefc33d$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $eedf07655fefc33d$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $eedf07655fefc33d$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $eedf07655fefc33d$var$Xn);
        z = $eedf07655fefc33d$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $eedf07655fefc33d$var$Zn);
    }
    return new $eedf07655fefc33d$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $eedf07655fefc33d$var$gray(l, opacity) {
    return new $eedf07655fefc33d$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $eedf07655fefc33d$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $eedf07655fefc33d$var$labConvert(l) : new $eedf07655fefc33d$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $eedf07655fefc33d$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $eedf07655fefc33d$var$_define.default)($eedf07655fefc33d$var$Lab, $eedf07655fefc33d$var$lab, (0, $eedf07655fefc33d$var$_define.extend)($exD4H.Color, {
    brighter (k) {
        return new $eedf07655fefc33d$var$Lab(this.l + $eedf07655fefc33d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $eedf07655fefc33d$var$Lab(this.l - $eedf07655fefc33d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $eedf07655fefc33d$var$Xn * $eedf07655fefc33d$var$lab2xyz(x);
        y = $eedf07655fefc33d$var$Yn * $eedf07655fefc33d$var$lab2xyz(y);
        z = $eedf07655fefc33d$var$Zn * $eedf07655fefc33d$var$lab2xyz(z);
        return new $exD4H.Rgb($eedf07655fefc33d$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $eedf07655fefc33d$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $eedf07655fefc33d$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $eedf07655fefc33d$var$xyz2lab(t) {
    return t > $eedf07655fefc33d$var$t3 ? Math.pow(t, 1 / 3) : t / $eedf07655fefc33d$var$t2 + $eedf07655fefc33d$var$t0;
}
function $eedf07655fefc33d$var$lab2xyz(t) {
    return t > $eedf07655fefc33d$var$t1 ? t * t * t : $eedf07655fefc33d$var$t2 * (t - $eedf07655fefc33d$var$t0);
}
function $eedf07655fefc33d$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $eedf07655fefc33d$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $eedf07655fefc33d$var$hclConvert(o) {
    if (o instanceof $eedf07655fefc33d$var$Hcl) return new $eedf07655fefc33d$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $eedf07655fefc33d$var$Lab)) o = $eedf07655fefc33d$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $eedf07655fefc33d$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $dIvTu.degrees;
    return new $eedf07655fefc33d$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $eedf07655fefc33d$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $eedf07655fefc33d$var$hclConvert(l) : new $eedf07655fefc33d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $eedf07655fefc33d$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $eedf07655fefc33d$var$hclConvert(h) : new $eedf07655fefc33d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $eedf07655fefc33d$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $eedf07655fefc33d$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $eedf07655fefc33d$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $dIvTu.radians;
    return new $eedf07655fefc33d$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $eedf07655fefc33d$var$_define.default)($eedf07655fefc33d$var$Hcl, $eedf07655fefc33d$var$hcl, (0, $eedf07655fefc33d$var$_define.extend)($exD4H.Color, {
    brighter (k) {
        return new $eedf07655fefc33d$var$Hcl(this.h, this.c, this.l + $eedf07655fefc33d$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $eedf07655fefc33d$var$Hcl(this.h, this.c, this.l - $eedf07655fefc33d$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $eedf07655fefc33d$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("dIvTu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $9fc81fe62ac11e10$var$radians = module.exports.radians = Math.PI / 180;
const $9fc81fe62ac11e10$var$degrees = module.exports.degrees = 180 / Math.PI;

});


parcelRegister("a7qBG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $75df326892c8172d$var$Cubehelix;
module.exports.default = $75df326892c8172d$var$cubehelix;

var $75df326892c8172d$var$_define = $75df326892c8172d$var$_interopRequireWildcard((parcelRequire("9lRfB")));

var $exD4H = parcelRequire("exD4H");

var $dIvTu = parcelRequire("dIvTu");
function $75df326892c8172d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($75df326892c8172d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $75df326892c8172d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $75df326892c8172d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $75df326892c8172d$var$A = -0.14861, $75df326892c8172d$var$B = 1.78277, $75df326892c8172d$var$C = -0.29227, $75df326892c8172d$var$D = -0.90649, $75df326892c8172d$var$E = 1.97294, $75df326892c8172d$var$ED = $75df326892c8172d$var$E * $75df326892c8172d$var$D, $75df326892c8172d$var$EB = $75df326892c8172d$var$E * $75df326892c8172d$var$B, $75df326892c8172d$var$BC_DA = $75df326892c8172d$var$B * $75df326892c8172d$var$C - $75df326892c8172d$var$D * $75df326892c8172d$var$A;
function $75df326892c8172d$var$cubehelixConvert(o) {
    if (o instanceof $75df326892c8172d$var$Cubehelix) return new $75df326892c8172d$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $exD4H.Rgb)) o = (0, $exD4H.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($75df326892c8172d$var$BC_DA * b + $75df326892c8172d$var$ED * r - $75df326892c8172d$var$EB * g) / ($75df326892c8172d$var$BC_DA + $75df326892c8172d$var$ED - $75df326892c8172d$var$EB), bl = b - l, k = ($75df326892c8172d$var$E * (g - l) - $75df326892c8172d$var$C * bl) / $75df326892c8172d$var$D, s = Math.sqrt(k * k + bl * bl) / ($75df326892c8172d$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $dIvTu.degrees - 120 : NaN;
    return new $75df326892c8172d$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $75df326892c8172d$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $75df326892c8172d$var$cubehelixConvert(h) : new $75df326892c8172d$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $75df326892c8172d$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $75df326892c8172d$var$_define.default)($75df326892c8172d$var$Cubehelix, $75df326892c8172d$var$cubehelix, (0, $75df326892c8172d$var$_define.extend)($exD4H.Color, {
    brighter (k) {
        k = k == null ? $exD4H.brighter : Math.pow($exD4H.brighter, k);
        return new $75df326892c8172d$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $exD4H.darker : Math.pow($exD4H.darker, k);
        return new $75df326892c8172d$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $dIvTu.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $exD4H.Rgb(255 * (l + a * ($75df326892c8172d$var$A * cosh + $75df326892c8172d$var$B * sinh)), 255 * (l + a * ($75df326892c8172d$var$C * cosh + $75df326892c8172d$var$D * sinh)), 255 * (l + a * ($75df326892c8172d$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("8Yzef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $4AoQl = parcelRequire("4AoQl");

var $688f410b2ddb0350$var$_basis = $688f410b2ddb0350$var$_interopRequireDefault((parcelRequire("1bmGG")));

var $688f410b2ddb0350$var$_basisClosed = $688f410b2ddb0350$var$_interopRequireDefault((parcelRequire("6X6wf")));

var $688f410b2ddb0350$var$_color = $688f410b2ddb0350$var$_interopRequireWildcard((parcelRequire("i4A3e")));
function $688f410b2ddb0350$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($688f410b2ddb0350$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $688f410b2ddb0350$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $688f410b2ddb0350$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $688f410b2ddb0350$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $688f410b2ddb0350$var$_default = module.exports.default = function rgbGamma(y) {
    var color = (0, $688f410b2ddb0350$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $4AoQl.rgb)(start)).r, (end = (0, $4AoQl.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $688f410b2ddb0350$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $688f410b2ddb0350$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $4AoQl.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $688f410b2ddb0350$var$rgbBasis = module.exports.rgbBasis = $688f410b2ddb0350$var$rgbSpline($688f410b2ddb0350$var$_basis.default);
var $688f410b2ddb0350$var$rgbBasisClosed = module.exports.rgbBasisClosed = $688f410b2ddb0350$var$rgbSpline($688f410b2ddb0350$var$_basisClosed.default);

});
parcelRegister("1bmGG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $0dc86ac761e6bd9a$var$basis;
module.exports.default = $0dc86ac761e6bd9a$var$_default;
function $0dc86ac761e6bd9a$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $0dc86ac761e6bd9a$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $0dc86ac761e6bd9a$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("6X6wf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50fd4f526909b826$var$_default;

var $1bmGG = parcelRequire("1bmGG");
function $50fd4f526909b826$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $1bmGG.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("i4A3e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d28490bd2f0d61a4$var$nogamma;
module.exports.gamma = $d28490bd2f0d61a4$var$gamma;
module.exports.hue = $d28490bd2f0d61a4$var$hue;

var $d28490bd2f0d61a4$var$_constant = $d28490bd2f0d61a4$var$_interopRequireDefault((parcelRequire("5I4kQ")));
function $d28490bd2f0d61a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d28490bd2f0d61a4$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $d28490bd2f0d61a4$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $d28490bd2f0d61a4$var$hue(a, b) {
    var d = b - a;
    return d ? $d28490bd2f0d61a4$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $d28490bd2f0d61a4$var$_constant.default)(isNaN(a) ? b : a);
}
function $d28490bd2f0d61a4$var$gamma(y) {
    return (y = +y) === 1 ? $d28490bd2f0d61a4$var$nogamma : function(a, b) {
        return b - a ? $d28490bd2f0d61a4$var$exponential(a, b, y) : (0, $d28490bd2f0d61a4$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $d28490bd2f0d61a4$var$nogamma(a, b) {
    var d = b - a;
    return d ? $d28490bd2f0d61a4$var$linear(a, d) : (0, $d28490bd2f0d61a4$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("5I4kQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $42846cab87877820$var$_default = (x)=>()=>x;
module.exports.default = $42846cab87877820$var$_default;

});



parcelRegister("luXq6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fa6a7ddf3f96817e$var$_default;
module.exports.genericArray = $fa6a7ddf3f96817e$var$genericArray;

var $fa6a7ddf3f96817e$var$_value = $fa6a7ddf3f96817e$var$_interopRequireDefault((parcelRequire("kD0l9")));

var $fa6a7ddf3f96817e$var$_numberArray = $fa6a7ddf3f96817e$var$_interopRequireWildcard((parcelRequire("6o5Sg")));
function $fa6a7ddf3f96817e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fa6a7ddf3f96817e$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $fa6a7ddf3f96817e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $fa6a7ddf3f96817e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $fa6a7ddf3f96817e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fa6a7ddf3f96817e$var$_default(a, b) {
    return ((0, $fa6a7ddf3f96817e$var$_numberArray.isNumberArray)(b) ? $fa6a7ddf3f96817e$var$_numberArray.default : $fa6a7ddf3f96817e$var$genericArray)(a, b);
}
function $fa6a7ddf3f96817e$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $fa6a7ddf3f96817e$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("6o5Sg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a698a71847f18af$var$_default;
module.exports.isNumberArray = $4a698a71847f18af$var$isNumberArray;
function $4a698a71847f18af$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $4a698a71847f18af$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("2OheY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20bd9fe1603b01a5$var$_default;
function $20bd9fe1603b01a5$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("6RFEN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ff8018621af210d$var$_default;
function $4ff8018621af210d$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("l0tng", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4b062263cfd9516$var$_default;

var $f4b062263cfd9516$var$_value = $f4b062263cfd9516$var$_interopRequireDefault((parcelRequire("kD0l9")));
function $f4b062263cfd9516$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f4b062263cfd9516$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $f4b062263cfd9516$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("jjGrm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e100b67425243101$var$_default;

var $e100b67425243101$var$_number = $e100b67425243101$var$_interopRequireDefault((parcelRequire("6RFEN")));
function $e100b67425243101$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e100b67425243101$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $e100b67425243101$var$reB = new RegExp($e100b67425243101$var$reA.source, "g");
function $e100b67425243101$var$zero(b) {
    return function() {
        return b;
    };
}
function $e100b67425243101$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $e100b67425243101$var$_default(a, b) {
    var bi = $e100b67425243101$var$reA.lastIndex = $e100b67425243101$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $e100b67425243101$var$reA.exec(a)) && (bm = $e100b67425243101$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $e100b67425243101$var$_number.default)(am, bm)
            });
        }
        bi = $e100b67425243101$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $e100b67425243101$var$one(q[0].x) : $e100b67425243101$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("4YOqM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a03e28db9b25e5c$var$_default;
function $3a03e28db9b25e5c$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("8Oh4j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66a03bb1658bd314$var$_default;

var $i4A3e = parcelRequire("i4A3e");
function $66a03bb1658bd314$var$_default(a, b) {
    var i = (0, $i4A3e.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("9VdKc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7394193e083e7663$var$_default;
function $7394193e083e7663$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("eGeJl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $ab006a0ef53f594f$var$_number = $ab006a0ef53f594f$var$_interopRequireDefault((parcelRequire("6RFEN")));

var $cFJOC = parcelRequire("cFJOC");
function $ab006a0ef53f594f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ab006a0ef53f594f$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $ab006a0ef53f594f$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $ab006a0ef53f594f$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $ab006a0ef53f594f$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $ab006a0ef53f594f$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $ab006a0ef53f594f$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $ab006a0ef53f594f$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $ab006a0ef53f594f$var$interpolateTransformCss = module.exports.interpolateTransformCss = $ab006a0ef53f594f$var$interpolateTransform($cFJOC.parseCss, "px, ", "px)", "deg)");
var $ab006a0ef53f594f$var$interpolateTransformSvg = module.exports.interpolateTransformSvg = $ab006a0ef53f594f$var$interpolateTransform($cFJOC.parseSvg, ", ", ")", ")");

});
parcelRegister("cFJOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $939cda5c78f39b63$var$parseCss;
module.exports.parseSvg = $939cda5c78f39b63$var$parseSvg;

var $939cda5c78f39b63$var$_decompose = $939cda5c78f39b63$var$_interopRequireWildcard((parcelRequire("jvEYB")));
function $939cda5c78f39b63$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($939cda5c78f39b63$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $939cda5c78f39b63$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $939cda5c78f39b63$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var $939cda5c78f39b63$var$svgNode;
/* eslint-disable no-undef */ function $939cda5c78f39b63$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $939cda5c78f39b63$var$_decompose.identity : (0, $939cda5c78f39b63$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $939cda5c78f39b63$var$parseSvg(value) {
    if (value == null) return $939cda5c78f39b63$var$_decompose.identity;
    if (!$939cda5c78f39b63$var$svgNode) $939cda5c78f39b63$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $939cda5c78f39b63$var$svgNode.setAttribute("transform", value);
    if (!(value = $939cda5c78f39b63$var$svgNode.transform.baseVal.consolidate())) return $939cda5c78f39b63$var$_decompose.identity;
    value = value.matrix;
    return (0, $939cda5c78f39b63$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("jvEYB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e340b2a8bb9f6f88$var$_default;
module.exports.identity = void 0;
var $e340b2a8bb9f6f88$var$degrees = 180 / Math.PI;
var $e340b2a8bb9f6f88$var$identity = module.exports.identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $e340b2a8bb9f6f88$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $e340b2a8bb9f6f88$var$degrees,
        skewX: Math.atan(skewX) * $e340b2a8bb9f6f88$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("eBekX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $aa0fa468c6675ee0$var$epsilon2 = 1e-12;
function $aa0fa468c6675ee0$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $aa0fa468c6675ee0$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $aa0fa468c6675ee0$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $aa0fa468c6675ee0$var$_default = module.exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $aa0fa468c6675ee0$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $aa0fa468c6675ee0$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $aa0fa468c6675ee0$var$tanh(rho * s + r0) - $aa0fa468c6675ee0$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $aa0fa468c6675ee0$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("iSI1a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $4AoQl = parcelRequire("4AoQl");

var $dbef6a2c9c5507b6$var$_color = $dbef6a2c9c5507b6$var$_interopRequireWildcard((parcelRequire("i4A3e")));
function $dbef6a2c9c5507b6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($dbef6a2c9c5507b6$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $dbef6a2c9c5507b6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $dbef6a2c9c5507b6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $dbef6a2c9c5507b6$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4AoQl.hsl)(start)).h, (end = (0, $4AoQl.hsl)(end)).h), s = (0, $dbef6a2c9c5507b6$var$_color.default)(start.s, end.s), l = (0, $dbef6a2c9c5507b6$var$_color.default)(start.l, end.l), opacity = (0, $dbef6a2c9c5507b6$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $dbef6a2c9c5507b6$var$_default = module.exports.default = $dbef6a2c9c5507b6$var$hsl($dbef6a2c9c5507b6$var$_color.hue);
var $dbef6a2c9c5507b6$var$hslLong = module.exports.hslLong = $dbef6a2c9c5507b6$var$hsl($dbef6a2c9c5507b6$var$_color.default);

});

parcelRegister("gy5fu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0c3e49f0fd35cdc$var$lab;

var $4AoQl = parcelRequire("4AoQl");

var $c0c3e49f0fd35cdc$var$_color = $c0c3e49f0fd35cdc$var$_interopRequireDefault((parcelRequire("i4A3e")));
function $c0c3e49f0fd35cdc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c0c3e49f0fd35cdc$var$lab(start, end) {
    var l = (0, $c0c3e49f0fd35cdc$var$_color.default)((start = (0, $4AoQl.lab)(start)).l, (end = (0, $4AoQl.lab)(end)).l), a = (0, $c0c3e49f0fd35cdc$var$_color.default)(start.a, end.a), b = (0, $c0c3e49f0fd35cdc$var$_color.default)(start.b, end.b), opacity = (0, $c0c3e49f0fd35cdc$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("j1kha", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $4AoQl = parcelRequire("4AoQl");

var $dd8dd6b2a3c8bf54$var$_color = $dd8dd6b2a3c8bf54$var$_interopRequireWildcard((parcelRequire("i4A3e")));
function $dd8dd6b2a3c8bf54$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($dd8dd6b2a3c8bf54$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $dd8dd6b2a3c8bf54$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $dd8dd6b2a3c8bf54$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $dd8dd6b2a3c8bf54$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4AoQl.hcl)(start)).h, (end = (0, $4AoQl.hcl)(end)).h), c = (0, $dd8dd6b2a3c8bf54$var$_color.default)(start.c, end.c), l = (0, $dd8dd6b2a3c8bf54$var$_color.default)(start.l, end.l), opacity = (0, $dd8dd6b2a3c8bf54$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $dd8dd6b2a3c8bf54$var$_default = module.exports.default = $dd8dd6b2a3c8bf54$var$hcl($dd8dd6b2a3c8bf54$var$_color.hue);
var $dd8dd6b2a3c8bf54$var$hclLong = module.exports.hclLong = $dd8dd6b2a3c8bf54$var$hcl($dd8dd6b2a3c8bf54$var$_color.default);

});

parcelRegister("8mDa3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $4AoQl = parcelRequire("4AoQl");

var $616ec15fdec3c8eb$var$_color = $616ec15fdec3c8eb$var$_interopRequireWildcard((parcelRequire("i4A3e")));
function $616ec15fdec3c8eb$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($616ec15fdec3c8eb$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $616ec15fdec3c8eb$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $616ec15fdec3c8eb$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $616ec15fdec3c8eb$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $4AoQl.cubehelix)(start)).h, (end = (0, $4AoQl.cubehelix)(end)).h), s = (0, $616ec15fdec3c8eb$var$_color.default)(start.s, end.s), l = (0, $616ec15fdec3c8eb$var$_color.default)(start.l, end.l), opacity = (0, $616ec15fdec3c8eb$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $616ec15fdec3c8eb$var$_default = module.exports.default = $616ec15fdec3c8eb$var$cubehelix($616ec15fdec3c8eb$var$_color.hue);
var $616ec15fdec3c8eb$var$cubehelixLong = module.exports.cubehelixLong = $616ec15fdec3c8eb$var$cubehelix($616ec15fdec3c8eb$var$_color.default);

});

parcelRegister("dXY1l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2af57ee07fb8fbe$var$piecewise;

var $a2af57ee07fb8fbe$var$_value = $a2af57ee07fb8fbe$var$_interopRequireDefault((parcelRequire("kD0l9")));
function $a2af57ee07fb8fbe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a2af57ee07fb8fbe$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $a2af57ee07fb8fbe$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("3d65a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25674dd291d3b631$var$_default;
function $25674dd291d3b631$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("CqUcz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07386b97a0405e02$var$constants;
function $07386b97a0405e02$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("9ss5Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e2c854d9199e057$var$number;
function $6e2c854d9199e057$var$number(x) {
    return +x;
}

});


parcelRegister("gSfL7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c48de9ea3c736dce$var$tickFormat;

var $vxwOH = parcelRequire("vxwOH");

var $kqUyO = parcelRequire("kqUyO");
function $c48de9ea3c736dce$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $vxwOH.tickStep)(start, stop, count), precision;
    specifier = (0, $kqUyO.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $kqUyO.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $kqUyO.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $kqUyO.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $kqUyO.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $kqUyO.format)(specifier);
}

});
parcelRegister("kqUyO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $ee021c1a83bf19cf$var$_precisionRound.default;
    }
});

var $ee021c1a83bf19cf$var$_defaultLocale = $ee021c1a83bf19cf$var$_interopRequireWildcard((parcelRequire("bHli4")));

var $ee021c1a83bf19cf$var$_locale = $ee021c1a83bf19cf$var$_interopRequireDefault((parcelRequire("5voMM")));

var $ee021c1a83bf19cf$var$_formatSpecifier = $ee021c1a83bf19cf$var$_interopRequireWildcard((parcelRequire("k9Okv")));

var $ee021c1a83bf19cf$var$_precisionFixed = $ee021c1a83bf19cf$var$_interopRequireDefault((parcelRequire("efUns")));

var $ee021c1a83bf19cf$var$_precisionPrefix = $ee021c1a83bf19cf$var$_interopRequireDefault((parcelRequire("3Yzje")));

var $ee021c1a83bf19cf$var$_precisionRound = $ee021c1a83bf19cf$var$_interopRequireDefault((parcelRequire("3ZO3P")));
function $ee021c1a83bf19cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ee021c1a83bf19cf$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ee021c1a83bf19cf$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $ee021c1a83bf19cf$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $ee021c1a83bf19cf$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("bHli4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $884439ba7dae635a$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $884439ba7dae635a$var$_locale = $884439ba7dae635a$var$_interopRequireDefault((parcelRequire("5voMM")));
function $884439ba7dae635a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $884439ba7dae635a$var$locale;
var $884439ba7dae635a$var$format;
var $884439ba7dae635a$var$formatPrefix;
$884439ba7dae635a$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $884439ba7dae635a$var$defaultLocale(definition) {
    $884439ba7dae635a$var$locale = (0, $884439ba7dae635a$var$_locale.default)(definition);
    module.exports.format = $884439ba7dae635a$var$format = $884439ba7dae635a$var$locale.format;
    module.exports.formatPrefix = $884439ba7dae635a$var$formatPrefix = $884439ba7dae635a$var$locale.formatPrefix;
    return $884439ba7dae635a$var$locale;
}

});
parcelRegister("5voMM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $402312ee0966dd28$var$_default;

var $402312ee0966dd28$var$_exponent = $402312ee0966dd28$var$_interopRequireDefault((parcelRequire("dxPVX")));

var $402312ee0966dd28$var$_formatGroup = $402312ee0966dd28$var$_interopRequireDefault((parcelRequire("4Bzad")));

var $402312ee0966dd28$var$_formatNumerals = $402312ee0966dd28$var$_interopRequireDefault((parcelRequire("jc6ay")));

var $402312ee0966dd28$var$_formatSpecifier = $402312ee0966dd28$var$_interopRequireDefault((parcelRequire("k9Okv")));

var $402312ee0966dd28$var$_formatTrim = $402312ee0966dd28$var$_interopRequireDefault((parcelRequire("kwJdZ")));

var $402312ee0966dd28$var$_formatTypes = $402312ee0966dd28$var$_interopRequireDefault((parcelRequire("1rOY1")));

var $5Xud5 = parcelRequire("5Xud5");

var $402312ee0966dd28$var$_identity = $402312ee0966dd28$var$_interopRequireDefault((parcelRequire("eYfv2")));
function $402312ee0966dd28$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $402312ee0966dd28$var$map = Array.prototype.map, $402312ee0966dd28$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $402312ee0966dd28$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $402312ee0966dd28$var$_identity.default : (0, $402312ee0966dd28$var$_formatGroup.default)($402312ee0966dd28$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $402312ee0966dd28$var$_identity.default : (0, $402312ee0966dd28$var$_formatNumerals.default)($402312ee0966dd28$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $402312ee0966dd28$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!$402312ee0966dd28$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $402312ee0966dd28$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $402312ee0966dd28$var$_formatTrim.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $402312ee0966dd28$var$prefixes[8 + $5Xud5.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $402312ee0966dd28$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $402312ee0966dd28$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $402312ee0966dd28$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("dxPVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9dc6a460f92de328$var$_default;

var $6nNo4 = parcelRequire("6nNo4");
function $9dc6a460f92de328$var$_default(x) {
    return x = (0, $6nNo4.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("6nNo4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a5b33586248a312$var$_default;
module.exports.formatDecimalParts = $4a5b33586248a312$var$formatDecimalParts;
function $4a5b33586248a312$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $4a5b33586248a312$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("4Bzad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35a5e4e9f33dfac2$var$_default;
function $35a5e4e9f33dfac2$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("jc6ay", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $df93ec67aa6cd42a$var$_default;
function $df93ec67aa6cd42a$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("k9Okv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $eacbb05957483c83$var$FormatSpecifier;
module.exports.default = $eacbb05957483c83$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $eacbb05957483c83$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $eacbb05957483c83$var$formatSpecifier(specifier) {
    if (!(match = $eacbb05957483c83$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $eacbb05957483c83$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$eacbb05957483c83$var$formatSpecifier.prototype = $eacbb05957483c83$var$FormatSpecifier.prototype; // instanceof
function $eacbb05957483c83$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$eacbb05957483c83$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("kwJdZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef19e07cb0b43488$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $ef19e07cb0b43488$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("1rOY1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10dfd90bb595f258$var$_formatDecimal = $10dfd90bb595f258$var$_interopRequireDefault((parcelRequire("6nNo4")));

var $10dfd90bb595f258$var$_formatPrefixAuto = $10dfd90bb595f258$var$_interopRequireDefault((parcelRequire("5Xud5")));

var $10dfd90bb595f258$var$_formatRounded = $10dfd90bb595f258$var$_interopRequireDefault((parcelRequire("iisFu")));
function $10dfd90bb595f258$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $10dfd90bb595f258$var$_default = module.exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $10dfd90bb595f258$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $10dfd90bb595f258$var$_formatRounded.default)(x * 100, p),
    "r": $10dfd90bb595f258$var$_formatRounded.default,
    "s": $10dfd90bb595f258$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("5Xud5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $011e9c79ef14fce7$var$_default;
module.exports.prefixExponent = void 0;

var $6nNo4 = parcelRequire("6nNo4");
var $011e9c79ef14fce7$var$prefixExponent;
function $011e9c79ef14fce7$var$_default(x, p) {
    var d = (0, $6nNo4.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $011e9c79ef14fce7$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $6nNo4.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("iisFu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5202550b8418cc2$var$_default;

var $6nNo4 = parcelRequire("6nNo4");
function $d5202550b8418cc2$var$_default(x, p) {
    var d = (0, $6nNo4.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("eYfv2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae62b12ca4620977$var$_default;
function $ae62b12ca4620977$var$_default(x) {
    return x;
}

});



parcelRegister("efUns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a60e32c3ca923344$var$_default;

var $a60e32c3ca923344$var$_exponent = $a60e32c3ca923344$var$_interopRequireDefault((parcelRequire("dxPVX")));
function $a60e32c3ca923344$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a60e32c3ca923344$var$_default(step) {
    return Math.max(0, -(0, $a60e32c3ca923344$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("3Yzje", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e525d591eb1e214$var$_default;

var $2e525d591eb1e214$var$_exponent = $2e525d591eb1e214$var$_interopRequireDefault((parcelRequire("dxPVX")));
function $2e525d591eb1e214$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2e525d591eb1e214$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $2e525d591eb1e214$var$_exponent.default)(value) / 3))) * 3 - (0, $2e525d591eb1e214$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("3ZO3P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e8de6a5be25dc3b$var$_default;

var $2e8de6a5be25dc3b$var$_exponent = $2e8de6a5be25dc3b$var$_interopRequireDefault((parcelRequire("dxPVX")));
function $2e8de6a5be25dc3b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2e8de6a5be25dc3b$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $2e8de6a5be25dc3b$var$_exponent.default)(max) - (0, $2e8de6a5be25dc3b$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("7w1Ey", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $578ccdd3f90e065b$var$log;
module.exports.loggish = $578ccdd3f90e065b$var$loggish;

var $vxwOH = parcelRequire("vxwOH");

var $kqUyO = parcelRequire("kqUyO");

var $578ccdd3f90e065b$var$_nice = $578ccdd3f90e065b$var$_interopRequireDefault((parcelRequire("5yjGp")));

var $dfCSv = parcelRequire("dfCSv");

var $aPZBO = parcelRequire("aPZBO");
function $578ccdd3f90e065b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $578ccdd3f90e065b$var$transformLog(x) {
    return Math.log(x);
}
function $578ccdd3f90e065b$var$transformExp(x) {
    return Math.exp(x);
}
function $578ccdd3f90e065b$var$transformLogn(x) {
    return -Math.log(-x);
}
function $578ccdd3f90e065b$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $578ccdd3f90e065b$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $578ccdd3f90e065b$var$powp(base) {
    return base === 10 ? $578ccdd3f90e065b$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $578ccdd3f90e065b$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $578ccdd3f90e065b$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $578ccdd3f90e065b$var$loggish(transform) {
    const scale = transform($578ccdd3f90e065b$var$transformLog, $578ccdd3f90e065b$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $578ccdd3f90e065b$var$logp(base), pows = $578ccdd3f90e065b$var$powp(base);
        if (domain()[0] < 0) {
            logs = $578ccdd3f90e065b$var$reflect(logs), pows = $578ccdd3f90e065b$var$reflect(pows);
            transform($578ccdd3f90e065b$var$transformLogn, $578ccdd3f90e065b$var$transformExpn);
        } else transform($578ccdd3f90e065b$var$transformLog, $578ccdd3f90e065b$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $vxwOH.ticks)(u, v, n);
        } else z = (0, $vxwOH.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $kqUyO.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $kqUyO.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $578ccdd3f90e065b$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $578ccdd3f90e065b$var$log() {
    const scale = $578ccdd3f90e065b$var$loggish((0, $dfCSv.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $dfCSv.copy)(scale, $578ccdd3f90e065b$var$log()).base(scale.base());
    $aPZBO.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("5yjGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $40af655a8b957c64$var$nice;
function $40af655a8b957c64$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("dH0Sc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9f7ff7ecc96732f6$var$symlog;
module.exports.symlogish = $9f7ff7ecc96732f6$var$symlogish;

var $hkuVA = parcelRequire("hkuVA");

var $dfCSv = parcelRequire("dfCSv");

var $aPZBO = parcelRequire("aPZBO");
function $9f7ff7ecc96732f6$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $9f7ff7ecc96732f6$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $9f7ff7ecc96732f6$var$symlogish(transform) {
    var c = 1, scale = transform($9f7ff7ecc96732f6$var$transformSymlog(c), $9f7ff7ecc96732f6$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($9f7ff7ecc96732f6$var$transformSymlog(c = +_), $9f7ff7ecc96732f6$var$transformSymexp(c)) : c;
    };
    return (0, $hkuVA.linearish)(scale);
}
function $9f7ff7ecc96732f6$var$symlog() {
    var scale = $9f7ff7ecc96732f6$var$symlogish((0, $dfCSv.transformer)());
    scale.copy = function() {
        return (0, $dfCSv.copy)(scale, $9f7ff7ecc96732f6$var$symlog()).constant(scale.constant());
    };
    return $aPZBO.initRange.apply(scale, arguments);
}

});

parcelRegister("7BKZn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58a07022e61d6132$var$pow;
module.exports.powish = $58a07022e61d6132$var$powish;
module.exports.sqrt = $58a07022e61d6132$var$sqrt;

var $hkuVA = parcelRequire("hkuVA");

var $dfCSv = parcelRequire("dfCSv");

var $aPZBO = parcelRequire("aPZBO");
function $58a07022e61d6132$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $58a07022e61d6132$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $58a07022e61d6132$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $58a07022e61d6132$var$powish(transform) {
    var scale = transform($dfCSv.identity, $dfCSv.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($dfCSv.identity, $dfCSv.identity) : exponent === 0.5 ? transform($58a07022e61d6132$var$transformSqrt, $58a07022e61d6132$var$transformSquare) : transform($58a07022e61d6132$var$transformPow(exponent), $58a07022e61d6132$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $hkuVA.linearish)(scale);
}
function $58a07022e61d6132$var$pow() {
    var scale = $58a07022e61d6132$var$powish((0, $dfCSv.transformer)());
    scale.copy = function() {
        return (0, $dfCSv.copy)(scale, $58a07022e61d6132$var$pow()).exponent(scale.exponent());
    };
    $aPZBO.initRange.apply(scale, arguments);
    return scale;
}
function $58a07022e61d6132$var$sqrt() {
    return $58a07022e61d6132$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("a8ngM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $760cb39a5eda60db$var$radial;

var $760cb39a5eda60db$var$_continuous = $760cb39a5eda60db$var$_interopRequireDefault((parcelRequire("dfCSv")));

var $aPZBO = parcelRequire("aPZBO");

var $hkuVA = parcelRequire("hkuVA");

var $760cb39a5eda60db$var$_number = $760cb39a5eda60db$var$_interopRequireDefault((parcelRequire("9ss5Q")));
function $760cb39a5eda60db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $760cb39a5eda60db$var$square(x) {
    return Math.sign(x) * x * x;
}
function $760cb39a5eda60db$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $760cb39a5eda60db$var$radial() {
    var squared = (0, $760cb39a5eda60db$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $760cb39a5eda60db$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($760cb39a5eda60db$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $760cb39a5eda60db$var$_number.default)).map($760cb39a5eda60db$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $760cb39a5eda60db$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $aPZBO.initRange.apply(scale, arguments);
    return (0, $hkuVA.linearish)(scale);
}

});

parcelRegister("46r1H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fccafd74e29b1f4$var$quantile;

var $vxwOH = parcelRequire("vxwOH");

var $aPZBO = parcelRequire("aPZBO");
function $2fccafd74e29b1f4$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $vxwOH.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $vxwOH.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($vxwOH.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $2fccafd74e29b1f4$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $aPZBO.initRange.apply(scale, arguments);
}

});

parcelRegister("9BRZ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ff171d7b91554de$var$quantize;

var $vxwOH = parcelRequire("vxwOH");

var $hkuVA = parcelRequire("hkuVA");

var $aPZBO = parcelRequire("aPZBO");
function $6ff171d7b91554de$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $vxwOH.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $6ff171d7b91554de$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $aPZBO.initRange.apply((0, $hkuVA.linearish)(scale), arguments);
}

});

parcelRegister("c8vHW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d5ed3e798cf272d$var$threshold;

var $vxwOH = parcelRequire("vxwOH");

var $aPZBO = parcelRequire("aPZBO");
function $8d5ed3e798cf272d$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $vxwOH.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8d5ed3e798cf272d$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $aPZBO.initRange.apply(scale, arguments);
}

});

parcelRegister("62kva", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $4652d5359effc210$var$calendar;
module.exports.default = $4652d5359effc210$var$time;

var $kSA7E = parcelRequire("kSA7E");

var $4TeLy = parcelRequire("4TeLy");

var $4652d5359effc210$var$_continuous = $4652d5359effc210$var$_interopRequireWildcard((parcelRequire("dfCSv")));

var $aPZBO = parcelRequire("aPZBO");

var $4652d5359effc210$var$_nice = $4652d5359effc210$var$_interopRequireDefault((parcelRequire("5yjGp")));
function $4652d5359effc210$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4652d5359effc210$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4652d5359effc210$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $4652d5359effc210$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $4652d5359effc210$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $4652d5359effc210$var$date(t) {
    return new Date(t);
}
function $4652d5359effc210$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $4652d5359effc210$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $4652d5359effc210$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $4652d5359effc210$var$number)) : domain().map($4652d5359effc210$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $4652d5359effc210$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $4652d5359effc210$var$_continuous.copy)(scale, $4652d5359effc210$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $4652d5359effc210$var$time() {
    return $aPZBO.initRange.apply($4652d5359effc210$var$calendar($kSA7E.timeTicks, $kSA7E.timeTickInterval, $kSA7E.timeYear, $kSA7E.timeMonth, $kSA7E.timeWeek, $kSA7E.timeDay, $kSA7E.timeHour, $kSA7E.timeMinute, $kSA7E.timeSecond, $4TeLy.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("kSA7E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $bzBqy.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $bzBqy.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $bzBqy.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $bzBqy.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $bzBqy.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $bzBqy.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $bzBqy.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $bzBqy.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $bzBqy.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $bzBqy.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $lCaH6.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $lCaH6.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $bzBqy.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $bzBqy.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $bzBqy.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $bzBqy.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $bzBqy.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $bzBqy.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $hSokR.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $hSokR.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $hSokR.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $hSokR.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $hSokR.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $hSokR.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $hSokR.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $hSokR.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $hSokR.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $hSokR.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $lCaH6.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $lCaH6.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $hSokR.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $hSokR.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $hSokR.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $hSokR.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $hSokR.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $hSokR.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $f334deed773dd903$var$_utcYear.utcYears;
    }
});

var $f334deed773dd903$var$_interval = $f334deed773dd903$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $f334deed773dd903$var$_millisecond = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("dD0qu")));

var $f334deed773dd903$var$_second = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("kMjkw")));

var $f334deed773dd903$var$_minute = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("c78Vh")));

var $f334deed773dd903$var$_hour = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("gprxh")));

var $f334deed773dd903$var$_day = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("1oJfp")));

var $bzBqy = parcelRequire("bzBqy");

var $f334deed773dd903$var$_month = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("6RUJc")));

var $f334deed773dd903$var$_year = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("5eHOg")));

var $f334deed773dd903$var$_utcMinute = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("eJwM1")));

var $f334deed773dd903$var$_utcHour = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("gSeoo")));

var $f334deed773dd903$var$_utcDay = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("lQADx")));

var $hSokR = parcelRequire("hSokR");

var $f334deed773dd903$var$_utcMonth = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("cdUw0")));

var $f334deed773dd903$var$_utcYear = $f334deed773dd903$var$_interopRequireWildcard((parcelRequire("hGiMf")));

var $lCaH6 = parcelRequire("lCaH6");
function $f334deed773dd903$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f334deed773dd903$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $f334deed773dd903$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $f334deed773dd903$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $f334deed773dd903$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("6ZIcJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $517abaa5e2c2d9d5$var$newInterval;
var $517abaa5e2c2d9d5$var$t0 = new Date(), $517abaa5e2c2d9d5$var$t1 = new Date();
function $517abaa5e2c2d9d5$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $517abaa5e2c2d9d5$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $517abaa5e2c2d9d5$var$t0.setTime(+start), $517abaa5e2c2d9d5$var$t1.setTime(+end);
            floori($517abaa5e2c2d9d5$var$t0), floori($517abaa5e2c2d9d5$var$t1);
            return Math.floor(count($517abaa5e2c2d9d5$var$t0, $517abaa5e2c2d9d5$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("dD0qu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $9ebf3f8579abfa35$var$_interval = $9ebf3f8579abfa35$var$_interopRequireDefault((parcelRequire("6ZIcJ")));
function $9ebf3f8579abfa35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9ebf3f8579abfa35$var$millisecond = (0, $9ebf3f8579abfa35$var$_interval.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$9ebf3f8579abfa35$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $9ebf3f8579abfa35$var$millisecond;
    return (0, $9ebf3f8579abfa35$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $9ebf3f8579abfa35$var$_default = module.exports.default = $9ebf3f8579abfa35$var$millisecond;
var $9ebf3f8579abfa35$var$milliseconds = module.exports.milliseconds = $9ebf3f8579abfa35$var$millisecond.range;

});

parcelRegister("kMjkw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $f20748e45ff427c5$var$_interval = $f20748e45ff427c5$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $f20748e45ff427c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f20748e45ff427c5$var$second = (0, $f20748e45ff427c5$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $a1xWJ.durationSecond);
}, function(start, end) {
    return (end - start) / $a1xWJ.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $f20748e45ff427c5$var$_default = module.exports.default = $f20748e45ff427c5$var$second;
var $f20748e45ff427c5$var$seconds = module.exports.seconds = $f20748e45ff427c5$var$second.range;

});
parcelRegister("a1xWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $74c45464ac197a2d$var$durationSecond = module.exports.durationSecond = 1000;
const $74c45464ac197a2d$var$durationMinute = module.exports.durationMinute = $74c45464ac197a2d$var$durationSecond * 60;
const $74c45464ac197a2d$var$durationHour = module.exports.durationHour = $74c45464ac197a2d$var$durationMinute * 60;
const $74c45464ac197a2d$var$durationDay = module.exports.durationDay = $74c45464ac197a2d$var$durationHour * 24;
const $74c45464ac197a2d$var$durationWeek = module.exports.durationWeek = $74c45464ac197a2d$var$durationDay * 7;
const $74c45464ac197a2d$var$durationMonth = module.exports.durationMonth = $74c45464ac197a2d$var$durationDay * 30;
const $74c45464ac197a2d$var$durationYear = module.exports.durationYear = $74c45464ac197a2d$var$durationDay * 365;

});


parcelRegister("c78Vh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $8d1d0f630fc8d420$var$_interval = $8d1d0f630fc8d420$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $8d1d0f630fc8d420$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8d1d0f630fc8d420$var$minute = (0, $8d1d0f630fc8d420$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $a1xWJ.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $a1xWJ.durationMinute);
}, function(start, end) {
    return (end - start) / $a1xWJ.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $8d1d0f630fc8d420$var$_default = module.exports.default = $8d1d0f630fc8d420$var$minute;
var $8d1d0f630fc8d420$var$minutes = module.exports.minutes = $8d1d0f630fc8d420$var$minute.range;

});

parcelRegister("gprxh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $bf24572fc60d5688$var$_interval = $bf24572fc60d5688$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $bf24572fc60d5688$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bf24572fc60d5688$var$hour = (0, $bf24572fc60d5688$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $a1xWJ.durationSecond - date.getMinutes() * $a1xWJ.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $a1xWJ.durationHour);
}, function(start, end) {
    return (end - start) / $a1xWJ.durationHour;
}, function(date) {
    return date.getHours();
});
var $bf24572fc60d5688$var$_default = module.exports.default = $bf24572fc60d5688$var$hour;
var $bf24572fc60d5688$var$hours = module.exports.hours = $bf24572fc60d5688$var$hour.range;

});

parcelRegister("1oJfp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $104b218b41227c42$var$_interval = $104b218b41227c42$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $104b218b41227c42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $104b218b41227c42$var$day = (0, $104b218b41227c42$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $a1xWJ.durationMinute) / $a1xWJ.durationDay, (date)=>date.getDate() - 1);
var $104b218b41227c42$var$_default = module.exports.default = $104b218b41227c42$var$day;
var $104b218b41227c42$var$days = module.exports.days = $104b218b41227c42$var$day.range;

});

parcelRegister("bzBqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $86cffee0056adef9$var$_interval = $86cffee0056adef9$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $86cffee0056adef9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86cffee0056adef9$var$weekday(i) {
    return (0, $86cffee0056adef9$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $a1xWJ.durationMinute) / $a1xWJ.durationWeek;
    });
}
var $86cffee0056adef9$var$sunday = module.exports.sunday = $86cffee0056adef9$var$weekday(0);
var $86cffee0056adef9$var$monday = module.exports.monday = $86cffee0056adef9$var$weekday(1);
var $86cffee0056adef9$var$tuesday = module.exports.tuesday = $86cffee0056adef9$var$weekday(2);
var $86cffee0056adef9$var$wednesday = module.exports.wednesday = $86cffee0056adef9$var$weekday(3);
var $86cffee0056adef9$var$thursday = module.exports.thursday = $86cffee0056adef9$var$weekday(4);
var $86cffee0056adef9$var$friday = module.exports.friday = $86cffee0056adef9$var$weekday(5);
var $86cffee0056adef9$var$saturday = module.exports.saturday = $86cffee0056adef9$var$weekday(6);
var $86cffee0056adef9$var$sundays = module.exports.sundays = $86cffee0056adef9$var$sunday.range;
var $86cffee0056adef9$var$mondays = module.exports.mondays = $86cffee0056adef9$var$monday.range;
var $86cffee0056adef9$var$tuesdays = module.exports.tuesdays = $86cffee0056adef9$var$tuesday.range;
var $86cffee0056adef9$var$wednesdays = module.exports.wednesdays = $86cffee0056adef9$var$wednesday.range;
var $86cffee0056adef9$var$thursdays = module.exports.thursdays = $86cffee0056adef9$var$thursday.range;
var $86cffee0056adef9$var$fridays = module.exports.fridays = $86cffee0056adef9$var$friday.range;
var $86cffee0056adef9$var$saturdays = module.exports.saturdays = $86cffee0056adef9$var$saturday.range;

});

parcelRegister("6RUJc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $5003b252074952d0$var$_interval = $5003b252074952d0$var$_interopRequireDefault((parcelRequire("6ZIcJ")));
function $5003b252074952d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5003b252074952d0$var$month = (0, $5003b252074952d0$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $5003b252074952d0$var$_default = module.exports.default = $5003b252074952d0$var$month;
var $5003b252074952d0$var$months = module.exports.months = $5003b252074952d0$var$month.range;

});

parcelRegister("5eHOg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $3d003e41fad531e7$var$_interval = $3d003e41fad531e7$var$_interopRequireDefault((parcelRequire("6ZIcJ")));
function $3d003e41fad531e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3d003e41fad531e7$var$year = (0, $3d003e41fad531e7$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$3d003e41fad531e7$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $3d003e41fad531e7$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $3d003e41fad531e7$var$_default = module.exports.default = $3d003e41fad531e7$var$year;
var $3d003e41fad531e7$var$years = module.exports.years = $3d003e41fad531e7$var$year.range;

});

parcelRegister("eJwM1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $ab9eb0cecd2aaa22$var$_interval = $ab9eb0cecd2aaa22$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $ab9eb0cecd2aaa22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ab9eb0cecd2aaa22$var$utcMinute = (0, $ab9eb0cecd2aaa22$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $a1xWJ.durationMinute);
}, function(start, end) {
    return (end - start) / $a1xWJ.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $ab9eb0cecd2aaa22$var$_default = module.exports.default = $ab9eb0cecd2aaa22$var$utcMinute;
var $ab9eb0cecd2aaa22$var$utcMinutes = module.exports.utcMinutes = $ab9eb0cecd2aaa22$var$utcMinute.range;

});

parcelRegister("gSeoo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $c48cda8402ec63d7$var$_interval = $c48cda8402ec63d7$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $c48cda8402ec63d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c48cda8402ec63d7$var$utcHour = (0, $c48cda8402ec63d7$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $a1xWJ.durationHour);
}, function(start, end) {
    return (end - start) / $a1xWJ.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $c48cda8402ec63d7$var$_default = module.exports.default = $c48cda8402ec63d7$var$utcHour;
var $c48cda8402ec63d7$var$utcHours = module.exports.utcHours = $c48cda8402ec63d7$var$utcHour.range;

});

parcelRegister("lQADx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $fe7adf9bc02a9e21$var$_interval = $fe7adf9bc02a9e21$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $fe7adf9bc02a9e21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fe7adf9bc02a9e21$var$utcDay = (0, $fe7adf9bc02a9e21$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $a1xWJ.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $fe7adf9bc02a9e21$var$_default = module.exports.default = $fe7adf9bc02a9e21$var$utcDay;
var $fe7adf9bc02a9e21$var$utcDays = module.exports.utcDays = $fe7adf9bc02a9e21$var$utcDay.range;

});

parcelRegister("hSokR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $d03a5b4feb6b2f75$var$_interval = $d03a5b4feb6b2f75$var$_interopRequireDefault((parcelRequire("6ZIcJ")));

var $a1xWJ = parcelRequire("a1xWJ");
function $d03a5b4feb6b2f75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d03a5b4feb6b2f75$var$utcWeekday(i) {
    return (0, $d03a5b4feb6b2f75$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $a1xWJ.durationWeek;
    });
}
var $d03a5b4feb6b2f75$var$utcSunday = module.exports.utcSunday = $d03a5b4feb6b2f75$var$utcWeekday(0);
var $d03a5b4feb6b2f75$var$utcMonday = module.exports.utcMonday = $d03a5b4feb6b2f75$var$utcWeekday(1);
var $d03a5b4feb6b2f75$var$utcTuesday = module.exports.utcTuesday = $d03a5b4feb6b2f75$var$utcWeekday(2);
var $d03a5b4feb6b2f75$var$utcWednesday = module.exports.utcWednesday = $d03a5b4feb6b2f75$var$utcWeekday(3);
var $d03a5b4feb6b2f75$var$utcThursday = module.exports.utcThursday = $d03a5b4feb6b2f75$var$utcWeekday(4);
var $d03a5b4feb6b2f75$var$utcFriday = module.exports.utcFriday = $d03a5b4feb6b2f75$var$utcWeekday(5);
var $d03a5b4feb6b2f75$var$utcSaturday = module.exports.utcSaturday = $d03a5b4feb6b2f75$var$utcWeekday(6);
var $d03a5b4feb6b2f75$var$utcSundays = module.exports.utcSundays = $d03a5b4feb6b2f75$var$utcSunday.range;
var $d03a5b4feb6b2f75$var$utcMondays = module.exports.utcMondays = $d03a5b4feb6b2f75$var$utcMonday.range;
var $d03a5b4feb6b2f75$var$utcTuesdays = module.exports.utcTuesdays = $d03a5b4feb6b2f75$var$utcTuesday.range;
var $d03a5b4feb6b2f75$var$utcWednesdays = module.exports.utcWednesdays = $d03a5b4feb6b2f75$var$utcWednesday.range;
var $d03a5b4feb6b2f75$var$utcThursdays = module.exports.utcThursdays = $d03a5b4feb6b2f75$var$utcThursday.range;
var $d03a5b4feb6b2f75$var$utcFridays = module.exports.utcFridays = $d03a5b4feb6b2f75$var$utcFriday.range;
var $d03a5b4feb6b2f75$var$utcSaturdays = module.exports.utcSaturdays = $d03a5b4feb6b2f75$var$utcSaturday.range;

});

parcelRegister("cdUw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $8e6289adfbf34991$var$_interval = $8e6289adfbf34991$var$_interopRequireDefault((parcelRequire("6ZIcJ")));
function $8e6289adfbf34991$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8e6289adfbf34991$var$utcMonth = (0, $8e6289adfbf34991$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $8e6289adfbf34991$var$_default = module.exports.default = $8e6289adfbf34991$var$utcMonth;
var $8e6289adfbf34991$var$utcMonths = module.exports.utcMonths = $8e6289adfbf34991$var$utcMonth.range;

});

parcelRegister("hGiMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $cdf4ecb1c03b7f71$var$_interval = $cdf4ecb1c03b7f71$var$_interopRequireDefault((parcelRequire("6ZIcJ")));
function $cdf4ecb1c03b7f71$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cdf4ecb1c03b7f71$var$utcYear = (0, $cdf4ecb1c03b7f71$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$cdf4ecb1c03b7f71$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $cdf4ecb1c03b7f71$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $cdf4ecb1c03b7f71$var$_default = module.exports.default = $cdf4ecb1c03b7f71$var$utcYear;
var $cdf4ecb1c03b7f71$var$utcYears = module.exports.utcYears = $cdf4ecb1c03b7f71$var$utcYear.range;

});

parcelRegister("lCaH6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $vxwOH = parcelRequire("vxwOH");

var $a1xWJ = parcelRequire("a1xWJ");

var $fbc571396e72e4a2$var$_millisecond = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("dD0qu")));

var $fbc571396e72e4a2$var$_second = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("kMjkw")));

var $fbc571396e72e4a2$var$_minute = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("c78Vh")));

var $fbc571396e72e4a2$var$_hour = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("gprxh")));

var $fbc571396e72e4a2$var$_day = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("1oJfp")));

var $bzBqy = parcelRequire("bzBqy");

var $fbc571396e72e4a2$var$_month = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("6RUJc")));

var $fbc571396e72e4a2$var$_year = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("5eHOg")));

var $fbc571396e72e4a2$var$_utcMinute = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("eJwM1")));

var $fbc571396e72e4a2$var$_utcHour = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("gSeoo")));

var $fbc571396e72e4a2$var$_utcDay = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("lQADx")));

var $hSokR = parcelRequire("hSokR");

var $fbc571396e72e4a2$var$_utcMonth = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("cdUw0")));

var $fbc571396e72e4a2$var$_utcYear = $fbc571396e72e4a2$var$_interopRequireDefault((parcelRequire("hGiMf")));
function $fbc571396e72e4a2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fbc571396e72e4a2$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $fbc571396e72e4a2$var$_second.default,
            1,
            $a1xWJ.durationSecond
        ],
        [
            $fbc571396e72e4a2$var$_second.default,
            5,
            5 * $a1xWJ.durationSecond
        ],
        [
            $fbc571396e72e4a2$var$_second.default,
            15,
            15 * $a1xWJ.durationSecond
        ],
        [
            $fbc571396e72e4a2$var$_second.default,
            30,
            30 * $a1xWJ.durationSecond
        ],
        [
            minute,
            1,
            $a1xWJ.durationMinute
        ],
        [
            minute,
            5,
            5 * $a1xWJ.durationMinute
        ],
        [
            minute,
            15,
            15 * $a1xWJ.durationMinute
        ],
        [
            minute,
            30,
            30 * $a1xWJ.durationMinute
        ],
        [
            hour,
            1,
            $a1xWJ.durationHour
        ],
        [
            hour,
            3,
            3 * $a1xWJ.durationHour
        ],
        [
            hour,
            6,
            6 * $a1xWJ.durationHour
        ],
        [
            hour,
            12,
            12 * $a1xWJ.durationHour
        ],
        [
            day,
            1,
            $a1xWJ.durationDay
        ],
        [
            day,
            2,
            2 * $a1xWJ.durationDay
        ],
        [
            week,
            1,
            $a1xWJ.durationWeek
        ],
        [
            month,
            1,
            $a1xWJ.durationMonth
        ],
        [
            month,
            3,
            3 * $a1xWJ.durationMonth
        ],
        [
            year,
            1,
            $a1xWJ.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $vxwOH.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $vxwOH.tickStep)(start / $a1xWJ.durationYear, stop / $a1xWJ.durationYear, count));
        if (i === 0) return $fbc571396e72e4a2$var$_millisecond.default.every(Math.max((0, $vxwOH.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$fbc571396e72e4a2$var$utcTicks, $fbc571396e72e4a2$var$utcTickInterval] = $fbc571396e72e4a2$var$ticker($fbc571396e72e4a2$var$_utcYear.default, $fbc571396e72e4a2$var$_utcMonth.default, $hSokR.utcSunday, $fbc571396e72e4a2$var$_utcDay.default, $fbc571396e72e4a2$var$_utcHour.default, $fbc571396e72e4a2$var$_utcMinute.default);
module.exports.utcTickInterval = $fbc571396e72e4a2$var$utcTickInterval;
module.exports.utcTicks = $fbc571396e72e4a2$var$utcTicks;
const [$fbc571396e72e4a2$var$timeTicks, $fbc571396e72e4a2$var$timeTickInterval] = $fbc571396e72e4a2$var$ticker($fbc571396e72e4a2$var$_year.default, $fbc571396e72e4a2$var$_month.default, $bzBqy.sunday, $fbc571396e72e4a2$var$_day.default, $fbc571396e72e4a2$var$_hour.default, $fbc571396e72e4a2$var$_minute.default);
module.exports.timeTickInterval = $fbc571396e72e4a2$var$timeTickInterval;
module.exports.timeTicks = $fbc571396e72e4a2$var$timeTicks;

});


parcelRegister("4TeLy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $38f7c0b037234b19$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $38f7c0b037234b19$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $38f7c0b037234b19$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $38f7c0b037234b19$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $38f7c0b037234b19$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $38f7c0b037234b19$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $38f7c0b037234b19$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $38f7c0b037234b19$var$_defaultLocale.utcParse;
    }
});

var $38f7c0b037234b19$var$_defaultLocale = $38f7c0b037234b19$var$_interopRequireWildcard((parcelRequire("avJ3O")));

var $38f7c0b037234b19$var$_locale = $38f7c0b037234b19$var$_interopRequireDefault((parcelRequire("fw1O1")));

var $38f7c0b037234b19$var$_isoFormat = $38f7c0b037234b19$var$_interopRequireDefault((parcelRequire("iw6jH")));

var $38f7c0b037234b19$var$_isoParse = $38f7c0b037234b19$var$_interopRequireDefault((parcelRequire("lxnBp")));
function $38f7c0b037234b19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $38f7c0b037234b19$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($38f7c0b037234b19$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $38f7c0b037234b19$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $38f7c0b037234b19$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

});
parcelRegister("avJ3O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a6fc0b011c48d49$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $7a6fc0b011c48d49$var$_locale = $7a6fc0b011c48d49$var$_interopRequireDefault((parcelRequire("fw1O1")));
function $7a6fc0b011c48d49$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7a6fc0b011c48d49$var$locale;
var $7a6fc0b011c48d49$var$timeFormat;
var $7a6fc0b011c48d49$var$timeParse;
var $7a6fc0b011c48d49$var$utcFormat;
var $7a6fc0b011c48d49$var$utcParse;
$7a6fc0b011c48d49$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $7a6fc0b011c48d49$var$defaultLocale(definition) {
    $7a6fc0b011c48d49$var$locale = (0, $7a6fc0b011c48d49$var$_locale.default)(definition);
    module.exports.timeFormat = $7a6fc0b011c48d49$var$timeFormat = $7a6fc0b011c48d49$var$locale.format;
    module.exports.timeParse = $7a6fc0b011c48d49$var$timeParse = $7a6fc0b011c48d49$var$locale.parse;
    module.exports.utcFormat = $7a6fc0b011c48d49$var$utcFormat = $7a6fc0b011c48d49$var$locale.utcFormat;
    module.exports.utcParse = $7a6fc0b011c48d49$var$utcParse = $7a6fc0b011c48d49$var$locale.utcParse;
    return $7a6fc0b011c48d49$var$locale;
}

});
parcelRegister("fw1O1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4bb3ebee334c39d$var$formatLocale;

var $kSA7E = parcelRequire("kSA7E");
function $b4bb3ebee334c39d$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $b4bb3ebee334c39d$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $b4bb3ebee334c39d$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $b4bb3ebee334c39d$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $b4bb3ebee334c39d$var$formatRe(locale_periods), periodLookup = $b4bb3ebee334c39d$var$formatLookup(locale_periods), weekdayRe = $b4bb3ebee334c39d$var$formatRe(locale_weekdays), weekdayLookup = $b4bb3ebee334c39d$var$formatLookup(locale_weekdays), shortWeekdayRe = $b4bb3ebee334c39d$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $b4bb3ebee334c39d$var$formatLookup(locale_shortWeekdays), monthRe = $b4bb3ebee334c39d$var$formatRe(locale_months), monthLookup = $b4bb3ebee334c39d$var$formatLookup(locale_months), shortMonthRe = $b4bb3ebee334c39d$var$formatRe(locale_shortMonths), shortMonthLookup = $b4bb3ebee334c39d$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $b4bb3ebee334c39d$var$formatDayOfMonth,
        "e": $b4bb3ebee334c39d$var$formatDayOfMonth,
        "f": $b4bb3ebee334c39d$var$formatMicroseconds,
        "g": $b4bb3ebee334c39d$var$formatYearISO,
        "G": $b4bb3ebee334c39d$var$formatFullYearISO,
        "H": $b4bb3ebee334c39d$var$formatHour24,
        "I": $b4bb3ebee334c39d$var$formatHour12,
        "j": $b4bb3ebee334c39d$var$formatDayOfYear,
        "L": $b4bb3ebee334c39d$var$formatMilliseconds,
        "m": $b4bb3ebee334c39d$var$formatMonthNumber,
        "M": $b4bb3ebee334c39d$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $b4bb3ebee334c39d$var$formatUnixTimestamp,
        "s": $b4bb3ebee334c39d$var$formatUnixTimestampSeconds,
        "S": $b4bb3ebee334c39d$var$formatSeconds,
        "u": $b4bb3ebee334c39d$var$formatWeekdayNumberMonday,
        "U": $b4bb3ebee334c39d$var$formatWeekNumberSunday,
        "V": $b4bb3ebee334c39d$var$formatWeekNumberISO,
        "w": $b4bb3ebee334c39d$var$formatWeekdayNumberSunday,
        "W": $b4bb3ebee334c39d$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b4bb3ebee334c39d$var$formatYear,
        "Y": $b4bb3ebee334c39d$var$formatFullYear,
        "Z": $b4bb3ebee334c39d$var$formatZone,
        "%": $b4bb3ebee334c39d$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $b4bb3ebee334c39d$var$formatUTCDayOfMonth,
        "e": $b4bb3ebee334c39d$var$formatUTCDayOfMonth,
        "f": $b4bb3ebee334c39d$var$formatUTCMicroseconds,
        "g": $b4bb3ebee334c39d$var$formatUTCYearISO,
        "G": $b4bb3ebee334c39d$var$formatUTCFullYearISO,
        "H": $b4bb3ebee334c39d$var$formatUTCHour24,
        "I": $b4bb3ebee334c39d$var$formatUTCHour12,
        "j": $b4bb3ebee334c39d$var$formatUTCDayOfYear,
        "L": $b4bb3ebee334c39d$var$formatUTCMilliseconds,
        "m": $b4bb3ebee334c39d$var$formatUTCMonthNumber,
        "M": $b4bb3ebee334c39d$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $b4bb3ebee334c39d$var$formatUnixTimestamp,
        "s": $b4bb3ebee334c39d$var$formatUnixTimestampSeconds,
        "S": $b4bb3ebee334c39d$var$formatUTCSeconds,
        "u": $b4bb3ebee334c39d$var$formatUTCWeekdayNumberMonday,
        "U": $b4bb3ebee334c39d$var$formatUTCWeekNumberSunday,
        "V": $b4bb3ebee334c39d$var$formatUTCWeekNumberISO,
        "w": $b4bb3ebee334c39d$var$formatUTCWeekdayNumberSunday,
        "W": $b4bb3ebee334c39d$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $b4bb3ebee334c39d$var$formatUTCYear,
        "Y": $b4bb3ebee334c39d$var$formatUTCFullYear,
        "Z": $b4bb3ebee334c39d$var$formatUTCZone,
        "%": $b4bb3ebee334c39d$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $b4bb3ebee334c39d$var$parseDayOfMonth,
        "e": $b4bb3ebee334c39d$var$parseDayOfMonth,
        "f": $b4bb3ebee334c39d$var$parseMicroseconds,
        "g": $b4bb3ebee334c39d$var$parseYear,
        "G": $b4bb3ebee334c39d$var$parseFullYear,
        "H": $b4bb3ebee334c39d$var$parseHour24,
        "I": $b4bb3ebee334c39d$var$parseHour24,
        "j": $b4bb3ebee334c39d$var$parseDayOfYear,
        "L": $b4bb3ebee334c39d$var$parseMilliseconds,
        "m": $b4bb3ebee334c39d$var$parseMonthNumber,
        "M": $b4bb3ebee334c39d$var$parseMinutes,
        "p": parsePeriod,
        "q": $b4bb3ebee334c39d$var$parseQuarter,
        "Q": $b4bb3ebee334c39d$var$parseUnixTimestamp,
        "s": $b4bb3ebee334c39d$var$parseUnixTimestampSeconds,
        "S": $b4bb3ebee334c39d$var$parseSeconds,
        "u": $b4bb3ebee334c39d$var$parseWeekdayNumberMonday,
        "U": $b4bb3ebee334c39d$var$parseWeekNumberSunday,
        "V": $b4bb3ebee334c39d$var$parseWeekNumberISO,
        "w": $b4bb3ebee334c39d$var$parseWeekdayNumberSunday,
        "W": $b4bb3ebee334c39d$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $b4bb3ebee334c39d$var$parseYear,
        "Y": $b4bb3ebee334c39d$var$parseFullYear,
        "Z": $b4bb3ebee334c39d$var$parseZone,
        "%": $b4bb3ebee334c39d$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $b4bb3ebee334c39d$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $b4bb3ebee334c39d$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $b4bb3ebee334c39d$var$utcDate($b4bb3ebee334c39d$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $kSA7E.utcMonday.ceil(week) : (0, $kSA7E.utcMonday)(week);
                    week = $kSA7E.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $b4bb3ebee334c39d$var$localDate($b4bb3ebee334c39d$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $kSA7E.timeMonday.ceil(week) : (0, $kSA7E.timeMonday)(week);
                    week = $kSA7E.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $b4bb3ebee334c39d$var$utcDate($b4bb3ebee334c39d$var$newDate(d.y, 0, 1)).getUTCDay() : $b4bb3ebee334c39d$var$localDate($b4bb3ebee334c39d$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $b4bb3ebee334c39d$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $b4bb3ebee334c39d$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $b4bb3ebee334c39d$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $b4bb3ebee334c39d$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $b4bb3ebee334c39d$var$numberRe = /^\s*\d+/, // note: ignores next directive
$b4bb3ebee334c39d$var$percentRe = /^%/, $b4bb3ebee334c39d$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $b4bb3ebee334c39d$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $b4bb3ebee334c39d$var$requote(s) {
    return s.replace($b4bb3ebee334c39d$var$requoteRe, "\\$&");
}
function $b4bb3ebee334c39d$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($b4bb3ebee334c39d$var$requote).join("|") + ")", "i");
}
function $b4bb3ebee334c39d$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $b4bb3ebee334c39d$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseWeekNumberSunday(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseWeekNumberISO(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseWeekNumberMonday(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseFullYear(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseYear(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseQuarter(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseMonthNumber(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseDayOfMonth(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseDayOfYear(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseHour24(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseMinutes(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseSeconds(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseMilliseconds(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseMicroseconds(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseLiteralPercent(d, string, i) {
    var n = $b4bb3ebee334c39d$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $b4bb3ebee334c39d$var$parseUnixTimestamp(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $b4bb3ebee334c39d$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $b4bb3ebee334c39d$var$formatDayOfMonth(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getDate(), p, 2);
}
function $b4bb3ebee334c39d$var$formatHour24(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getHours(), p, 2);
}
function $b4bb3ebee334c39d$var$formatHour12(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $b4bb3ebee334c39d$var$formatDayOfYear(d, p) {
    return $b4bb3ebee334c39d$var$pad(1 + $kSA7E.timeDay.count((0, $kSA7E.timeYear)(d), d), p, 3);
}
function $b4bb3ebee334c39d$var$formatMilliseconds(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getMilliseconds(), p, 3);
}
function $b4bb3ebee334c39d$var$formatMicroseconds(d, p) {
    return $b4bb3ebee334c39d$var$formatMilliseconds(d, p) + "000";
}
function $b4bb3ebee334c39d$var$formatMonthNumber(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getMonth() + 1, p, 2);
}
function $b4bb3ebee334c39d$var$formatMinutes(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getMinutes(), p, 2);
}
function $b4bb3ebee334c39d$var$formatSeconds(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getSeconds(), p, 2);
}
function $b4bb3ebee334c39d$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $b4bb3ebee334c39d$var$formatWeekNumberSunday(d, p) {
    return $b4bb3ebee334c39d$var$pad($kSA7E.timeSunday.count((0, $kSA7E.timeYear)(d) - 1, d), p, 2);
}
function $b4bb3ebee334c39d$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $kSA7E.timeThursday)(d) : $kSA7E.timeThursday.ceil(d);
}
function $b4bb3ebee334c39d$var$formatWeekNumberISO(d, p) {
    d = $b4bb3ebee334c39d$var$dISO(d);
    return $b4bb3ebee334c39d$var$pad($kSA7E.timeThursday.count((0, $kSA7E.timeYear)(d), d) + ((0, $kSA7E.timeYear)(d).getDay() === 4), p, 2);
}
function $b4bb3ebee334c39d$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $b4bb3ebee334c39d$var$formatWeekNumberMonday(d, p) {
    return $b4bb3ebee334c39d$var$pad($kSA7E.timeMonday.count((0, $kSA7E.timeYear)(d) - 1, d), p, 2);
}
function $b4bb3ebee334c39d$var$formatYear(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getFullYear() % 100, p, 2);
}
function $b4bb3ebee334c39d$var$formatYearISO(d, p) {
    d = $b4bb3ebee334c39d$var$dISO(d);
    return $b4bb3ebee334c39d$var$pad(d.getFullYear() % 100, p, 2);
}
function $b4bb3ebee334c39d$var$formatFullYear(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b4bb3ebee334c39d$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $kSA7E.timeThursday)(d) : $kSA7E.timeThursday.ceil(d);
    return $b4bb3ebee334c39d$var$pad(d.getFullYear() % 10000, p, 4);
}
function $b4bb3ebee334c39d$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $b4bb3ebee334c39d$var$pad(z / 60 | 0, "0", 2) + $b4bb3ebee334c39d$var$pad(z % 60, "0", 2);
}
function $b4bb3ebee334c39d$var$formatUTCDayOfMonth(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCDate(), p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCHour24(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCHours(), p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCHour12(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCDayOfYear(d, p) {
    return $b4bb3ebee334c39d$var$pad(1 + $kSA7E.utcDay.count((0, $kSA7E.utcYear)(d), d), p, 3);
}
function $b4bb3ebee334c39d$var$formatUTCMilliseconds(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $b4bb3ebee334c39d$var$formatUTCMicroseconds(d, p) {
    return $b4bb3ebee334c39d$var$formatUTCMilliseconds(d, p) + "000";
}
function $b4bb3ebee334c39d$var$formatUTCMonthNumber(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCMinutes(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCMinutes(), p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCSeconds(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCSeconds(), p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $b4bb3ebee334c39d$var$formatUTCWeekNumberSunday(d, p) {
    return $b4bb3ebee334c39d$var$pad($kSA7E.utcSunday.count((0, $kSA7E.utcYear)(d) - 1, d), p, 2);
}
function $b4bb3ebee334c39d$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $kSA7E.utcThursday)(d) : $kSA7E.utcThursday.ceil(d);
}
function $b4bb3ebee334c39d$var$formatUTCWeekNumberISO(d, p) {
    d = $b4bb3ebee334c39d$var$UTCdISO(d);
    return $b4bb3ebee334c39d$var$pad($kSA7E.utcThursday.count((0, $kSA7E.utcYear)(d), d) + ((0, $kSA7E.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $b4bb3ebee334c39d$var$formatUTCWeekNumberMonday(d, p) {
    return $b4bb3ebee334c39d$var$pad($kSA7E.utcMonday.count((0, $kSA7E.utcYear)(d) - 1, d), p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCYear(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCYearISO(d, p) {
    d = $b4bb3ebee334c39d$var$UTCdISO(d);
    return $b4bb3ebee334c39d$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $b4bb3ebee334c39d$var$formatUTCFullYear(d, p) {
    return $b4bb3ebee334c39d$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b4bb3ebee334c39d$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $kSA7E.utcThursday)(d) : $kSA7E.utcThursday.ceil(d);
    return $b4bb3ebee334c39d$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $b4bb3ebee334c39d$var$formatUTCZone() {
    return "+0000";
}
function $b4bb3ebee334c39d$var$formatLiteralPercent() {
    return "%";
}
function $b4bb3ebee334c39d$var$formatUnixTimestamp(d) {
    return +d;
}
function $b4bb3ebee334c39d$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("iw6jH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $avJ3O = parcelRequire("avJ3O");
var $d7b01d80e830ff15$var$isoSpecifier = module.exports.isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function $d7b01d80e830ff15$var$formatIsoNative(date) {
    return date.toISOString();
}
var $d7b01d80e830ff15$var$formatIso = Date.prototype.toISOString ? $d7b01d80e830ff15$var$formatIsoNative : (0, $avJ3O.utcFormat)($d7b01d80e830ff15$var$isoSpecifier);
var $d7b01d80e830ff15$var$_default = module.exports.default = $d7b01d80e830ff15$var$formatIso;

});

parcelRegister("lxnBp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $iw6jH = parcelRequire("iw6jH");

var $avJ3O = parcelRequire("avJ3O");
function $fadefcfe9da28cd1$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $fadefcfe9da28cd1$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $fadefcfe9da28cd1$var$parseIsoNative : (0, $avJ3O.utcParse)($iw6jH.isoSpecifier);
var $fadefcfe9da28cd1$var$_default = module.exports.default = $fadefcfe9da28cd1$var$parseIso;

});



parcelRegister("3BYig", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a1398dbd12a9f49$var$utcTime;

var $kSA7E = parcelRequire("kSA7E");

var $4TeLy = parcelRequire("4TeLy");

var $62kva = parcelRequire("62kva");

var $aPZBO = parcelRequire("aPZBO");
function $2a1398dbd12a9f49$var$utcTime() {
    return $aPZBO.initRange.apply((0, $62kva.calendar)($kSA7E.utcTicks, $kSA7E.utcTickInterval, $kSA7E.utcYear, $kSA7E.utcMonth, $kSA7E.utcWeek, $kSA7E.utcDay, $kSA7E.utcHour, $kSA7E.utcMinute, $kSA7E.utcSecond, $4TeLy.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("gzBfA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $c10ccf6478e4623d$var$copy;
module.exports.default = $c10ccf6478e4623d$var$sequential;
module.exports.sequentialLog = $c10ccf6478e4623d$var$sequentialLog;
module.exports.sequentialPow = $c10ccf6478e4623d$var$sequentialPow;
module.exports.sequentialSqrt = $c10ccf6478e4623d$var$sequentialSqrt;
module.exports.sequentialSymlog = $c10ccf6478e4623d$var$sequentialSymlog;

var $ctdoE = parcelRequire("ctdoE");

var $dfCSv = parcelRequire("dfCSv");

var $aPZBO = parcelRequire("aPZBO");

var $hkuVA = parcelRequire("hkuVA");

var $7w1Ey = parcelRequire("7w1Ey");

var $dH0Sc = parcelRequire("dH0Sc");

var $7BKZn = parcelRequire("7BKZn");
function $c10ccf6478e4623d$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $dfCSv.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($ctdoE.interpolate);
    scale.rangeRound = range($ctdoE.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $c10ccf6478e4623d$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $c10ccf6478e4623d$var$sequential() {
    var scale = (0, $hkuVA.linearish)($c10ccf6478e4623d$var$transformer()($dfCSv.identity));
    scale.copy = function() {
        return $c10ccf6478e4623d$var$copy(scale, $c10ccf6478e4623d$var$sequential());
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}
function $c10ccf6478e4623d$var$sequentialLog() {
    var scale = (0, $7w1Ey.loggish)($c10ccf6478e4623d$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $c10ccf6478e4623d$var$copy(scale, $c10ccf6478e4623d$var$sequentialLog()).base(scale.base());
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}
function $c10ccf6478e4623d$var$sequentialSymlog() {
    var scale = (0, $dH0Sc.symlogish)($c10ccf6478e4623d$var$transformer());
    scale.copy = function() {
        return $c10ccf6478e4623d$var$copy(scale, $c10ccf6478e4623d$var$sequentialSymlog()).constant(scale.constant());
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}
function $c10ccf6478e4623d$var$sequentialPow() {
    var scale = (0, $7BKZn.powish)($c10ccf6478e4623d$var$transformer());
    scale.copy = function() {
        return $c10ccf6478e4623d$var$copy(scale, $c10ccf6478e4623d$var$sequentialPow()).exponent(scale.exponent());
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}
function $c10ccf6478e4623d$var$sequentialSqrt() {
    return $c10ccf6478e4623d$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("k6LaN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ea38f5cbea7afdde$var$sequentialQuantile;

var $vxwOH = parcelRequire("vxwOH");

var $dfCSv = parcelRequire("dfCSv");

var $aPZBO = parcelRequire("aPZBO");
function $ea38f5cbea7afdde$var$sequentialQuantile() {
    var domain = [], interpolator = $dfCSv.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $vxwOH.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($vxwOH.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $vxwOH.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $ea38f5cbea7afdde$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("3G8kb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2adbc0691fd92927$var$diverging;
module.exports.divergingLog = $2adbc0691fd92927$var$divergingLog;
module.exports.divergingPow = $2adbc0691fd92927$var$divergingPow;
module.exports.divergingSqrt = $2adbc0691fd92927$var$divergingSqrt;
module.exports.divergingSymlog = $2adbc0691fd92927$var$divergingSymlog;

var $ctdoE = parcelRequire("ctdoE");

var $dfCSv = parcelRequire("dfCSv");

var $aPZBO = parcelRequire("aPZBO");

var $hkuVA = parcelRequire("hkuVA");

var $7w1Ey = parcelRequire("7w1Ey");

var $gzBfA = parcelRequire("gzBfA");

var $dH0Sc = parcelRequire("dH0Sc");

var $7BKZn = parcelRequire("7BKZn");
function $2adbc0691fd92927$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $dfCSv.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $ctdoE.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($ctdoE.interpolate);
    scale.rangeRound = range($ctdoE.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $2adbc0691fd92927$var$diverging() {
    var scale = (0, $hkuVA.linearish)($2adbc0691fd92927$var$transformer()($dfCSv.identity));
    scale.copy = function() {
        return (0, $gzBfA.copy)(scale, $2adbc0691fd92927$var$diverging());
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}
function $2adbc0691fd92927$var$divergingLog() {
    var scale = (0, $7w1Ey.loggish)($2adbc0691fd92927$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $gzBfA.copy)(scale, $2adbc0691fd92927$var$divergingLog()).base(scale.base());
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}
function $2adbc0691fd92927$var$divergingSymlog() {
    var scale = (0, $dH0Sc.symlogish)($2adbc0691fd92927$var$transformer());
    scale.copy = function() {
        return (0, $gzBfA.copy)(scale, $2adbc0691fd92927$var$divergingSymlog()).constant(scale.constant());
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}
function $2adbc0691fd92927$var$divergingPow() {
    var scale = (0, $7BKZn.powish)($2adbc0691fd92927$var$transformer());
    scale.copy = function() {
        return (0, $gzBfA.copy)(scale, $2adbc0691fd92927$var$divergingPow()).exponent(scale.exponent());
    };
    return $aPZBO.initInterpolator.apply(scale, arguments);
}
function $2adbc0691fd92927$var$divergingSqrt() {
    return $2adbc0691fd92927$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("b40KW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g4dSz = parcelRequire("g4dSz");

var $if4Jc = parcelRequire("if4Jc");

var $1d8VS = parcelRequire("1d8VS");

var $8giRX = parcelRequire("8giRX");

var $kXM1U = parcelRequire("kXM1U");

var $dm0tj = parcelRequire("dm0tj");

var $4DHlV = parcelRequire("4DHlV");
function $80e0a798ad4aa34f$var$omit(obj, ...keysArr) {
    if (obj == null) return {};
    keysArr = $dm0tj.flatten(keysArr);
    const result = $80e0a798ad4aa34f$var$cloneInOmit(obj, keysArr);
    for(let i = 0; i < keysArr.length; i++){
        let keys = keysArr[i];
        switch(typeof keys){
            case 'object':
                if (!Array.isArray(keys)) keys = Array.from(keys);
                for(let j = 0; j < keys.length; j++){
                    const key = keys[j];
                    $1d8VS.unset(result, key);
                }
                break;
            case 'string':
            case 'symbol':
            case 'number':
                $1d8VS.unset(result, keys);
                break;
        }
    }
    return result;
}
function $80e0a798ad4aa34f$var$cloneInOmit(obj, keys) {
    const hasDeepKey = keys.some((key)=>Array.isArray(key) || $kXM1U.isDeepKey(key));
    if (hasDeepKey) return $80e0a798ad4aa34f$var$deepCloneInOmit(obj);
    return $80e0a798ad4aa34f$var$shallowCloneInOmit(obj);
}
function $80e0a798ad4aa34f$var$shallowCloneInOmit(obj) {
    const result = {};
    const keysToCopy = [
        ...$if4Jc.keysIn(obj),
        ...$8giRX.getSymbolsIn(obj)
    ];
    for(let i = 0; i < keysToCopy.length; i++){
        const key = keysToCopy[i];
        result[key] = obj[key];
    }
    return result;
}
function $80e0a798ad4aa34f$var$deepCloneInOmit(obj) {
    const result = {};
    const keysToCopy = [
        ...$if4Jc.keysIn(obj),
        ...$8giRX.getSymbolsIn(obj)
    ];
    for(let i = 0; i < keysToCopy.length; i++){
        const key = keysToCopy[i];
        result[key] = $g4dSz.cloneDeepWith(obj[key], (valueToClone)=>{
            if ($4DHlV.isPlainObject(valueToClone)) return undefined;
            return valueToClone;
        });
    }
    return result;
}
module.exports.omit = $80e0a798ad4aa34f$var$omit;

});
parcelRegister("g4dSz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dVp2N = parcelRequire("dVp2N");

var $kSX0N = parcelRequire("kSX0N");
function $bb27c928189a7be3$var$cloneDeepWith(obj, customizer) {
    return $dVp2N.cloneDeepWith(obj, (value, key, object, stack)=>{
        const cloned = customizer?.(value, key, object, stack);
        if (cloned !== undefined) return cloned;
        if (typeof obj !== 'object') return undefined;
        switch(Object.prototype.toString.call(obj)){
            case $kSX0N.numberTag:
            case $kSX0N.stringTag:
            case $kSX0N.booleanTag:
                {
                    const result = new obj.constructor(obj?.valueOf());
                    $dVp2N.copyProperties(result, obj);
                    return result;
                }
            case $kSX0N.argumentsTag:
                {
                    const result = {};
                    $dVp2N.copyProperties(result, obj);
                    result.length = obj.length;
                    result[Symbol.iterator] = obj[Symbol.iterator];
                    return result;
                }
            default:
                return undefined;
        }
    });
}
module.exports.cloneDeepWith = $bb27c928189a7be3$var$cloneDeepWith;

});
parcelRegister("dVp2N", function(module, exports) {

var $e6hkG = parcelRequire("e6hkG");
var $a2340676c5d61b33$require$Buffer = $e6hkG.Buffer;
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jKqpv = parcelRequire("jKqpv");

var $lUKgF = parcelRequire("lUKgF");

var $kSX0N = parcelRequire("kSX0N");

var $drWlg = parcelRequire("drWlg");

var $b81uI = parcelRequire("b81uI");
function $a2340676c5d61b33$var$cloneDeepWith(obj, cloneValue) {
    return $a2340676c5d61b33$var$cloneDeepWithImpl(obj, undefined, obj, new Map(), cloneValue);
}
function $a2340676c5d61b33$var$cloneDeepWithImpl(valueToClone, keyToClone, objectToClone, stack = new Map(), cloneValue) {
    const cloned = cloneValue?.(valueToClone, keyToClone, objectToClone, stack);
    if (cloned !== undefined) return cloned;
    if ($drWlg.isPrimitive(valueToClone)) return valueToClone;
    if (stack.has(valueToClone)) return stack.get(valueToClone);
    if (Array.isArray(valueToClone)) {
        const result = new Array(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $a2340676c5d61b33$var$cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        if (Object.hasOwn(valueToClone, 'index')) result.index = valueToClone.index;
        if (Object.hasOwn(valueToClone, 'input')) result.input = valueToClone.input;
        return result;
    }
    if (valueToClone instanceof Date) return new Date(valueToClone.getTime());
    if (valueToClone instanceof RegExp) {
        const result = new RegExp(valueToClone.source, valueToClone.flags);
        result.lastIndex = valueToClone.lastIndex;
        return result;
    }
    if (valueToClone instanceof Map) {
        const result = new Map();
        stack.set(valueToClone, result);
        for (const [key, value] of valueToClone)result.set(key, $a2340676c5d61b33$var$cloneDeepWithImpl(value, key, objectToClone, stack, cloneValue));
        return result;
    }
    if (valueToClone instanceof Set) {
        const result = new Set();
        stack.set(valueToClone, result);
        for (const value of valueToClone)result.add($a2340676c5d61b33$var$cloneDeepWithImpl(value, undefined, objectToClone, stack, cloneValue));
        return result;
    }
    if (typeof $a2340676c5d61b33$require$Buffer !== 'undefined' && $a2340676c5d61b33$require$Buffer.isBuffer(valueToClone)) return valueToClone.subarray();
    if ($b81uI.isTypedArray(valueToClone)) {
        const result = new (Object.getPrototypeOf(valueToClone)).constructor(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $a2340676c5d61b33$var$cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof ArrayBuffer || typeof SharedArrayBuffer !== 'undefined' && valueToClone instanceof SharedArrayBuffer) return valueToClone.slice(0);
    if (valueToClone instanceof DataView) {
        const result = new DataView(valueToClone.buffer.slice(0), valueToClone.byteOffset, valueToClone.byteLength);
        stack.set(valueToClone, result);
        $a2340676c5d61b33$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof File !== 'undefined' && valueToClone instanceof File) {
        const result = new File([
            valueToClone
        ], valueToClone.name, {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $a2340676c5d61b33$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof Blob !== 'undefined' && valueToClone instanceof Blob) {
        const result = new Blob([
            valueToClone
        ], {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $a2340676c5d61b33$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Error) {
        const result = new valueToClone.constructor();
        stack.set(valueToClone, result);
        result.message = valueToClone.message;
        result.name = valueToClone.name;
        result.stack = valueToClone.stack;
        result.cause = valueToClone.cause;
        $a2340676c5d61b33$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Boolean) {
        const result = new Boolean(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $a2340676c5d61b33$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Number) {
        const result = new Number(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $a2340676c5d61b33$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof String) {
        const result = new String(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $a2340676c5d61b33$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof valueToClone === 'object' && $a2340676c5d61b33$var$isCloneableObject(valueToClone)) {
        const result = Object.create(Object.getPrototypeOf(valueToClone));
        stack.set(valueToClone, result);
        $a2340676c5d61b33$var$copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    return valueToClone;
}
function $a2340676c5d61b33$var$copyProperties(target, source, objectToClone = target, stack, cloneValue) {
    const keys = [
        ...Object.keys(source),
        ...$jKqpv.getSymbols(source)
    ];
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor == null || descriptor.writable) target[key] = $a2340676c5d61b33$var$cloneDeepWithImpl(source[key], key, objectToClone, stack, cloneValue);
    }
}
function $a2340676c5d61b33$var$isCloneableObject(object) {
    switch($lUKgF.getTag(object)){
        case $kSX0N.argumentsTag:
        case $kSX0N.arrayTag:
        case $kSX0N.arrayBufferTag:
        case $kSX0N.dataViewTag:
        case $kSX0N.booleanTag:
        case $kSX0N.dateTag:
        case $kSX0N.float32ArrayTag:
        case $kSX0N.float64ArrayTag:
        case $kSX0N.int8ArrayTag:
        case $kSX0N.int16ArrayTag:
        case $kSX0N.int32ArrayTag:
        case $kSX0N.mapTag:
        case $kSX0N.numberTag:
        case $kSX0N.objectTag:
        case $kSX0N.regexpTag:
        case $kSX0N.setTag:
        case $kSX0N.stringTag:
        case $kSX0N.symbolTag:
        case $kSX0N.uint8ArrayTag:
        case $kSX0N.uint8ClampedArrayTag:
        case $kSX0N.uint16ArrayTag:
        case $kSX0N.uint32ArrayTag:
            return true;
        default:
            return false;
    }
}
module.exports.cloneDeepWith = $a2340676c5d61b33$var$cloneDeepWith;
module.exports.cloneDeepWithImpl = $a2340676c5d61b33$var$cloneDeepWithImpl;
module.exports.copyProperties = $a2340676c5d61b33$var$copyProperties;

});
parcelRegister("e6hkG", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $a43f1221574a89cf$export$a143d493d941bafc; }, function (v) { return $a43f1221574a89cf$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $a43f1221574a89cf$export$f99ded8fe4b79145; }, function (v) { return $a43f1221574a89cf$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a43f1221574a89cf$export$a143d493d941bafc;
var $a43f1221574a89cf$export$e4cf37d7f6fb9e0a;
var $a43f1221574a89cf$export$f99ded8fe4b79145;
var $a43f1221574a89cf$export$599f31c3813fae4d;
'use strict';

var $lENzZ = parcelRequire("lENzZ");

var $86gGF = parcelRequire("86gGF");
const $a43f1221574a89cf$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$a43f1221574a89cf$export$a143d493d941bafc = $a43f1221574a89cf$var$Buffer;
$a43f1221574a89cf$export$e4cf37d7f6fb9e0a = $a43f1221574a89cf$var$SlowBuffer;
$a43f1221574a89cf$export$f99ded8fe4b79145 = 50;
const $a43f1221574a89cf$var$K_MAX_LENGTH = 0x7fffffff;
$a43f1221574a89cf$export$599f31c3813fae4d = $a43f1221574a89cf$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a43f1221574a89cf$var$Buffer.TYPED_ARRAY_SUPPORT = $a43f1221574a89cf$var$typedArraySupport();
if (!$a43f1221574a89cf$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a43f1221574a89cf$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a43f1221574a89cf$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$a43f1221574a89cf$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a43f1221574a89cf$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$a43f1221574a89cf$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a43f1221574a89cf$var$createBuffer(length) {
    if (length > $a43f1221574a89cf$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a43f1221574a89cf$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a43f1221574a89cf$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a43f1221574a89cf$var$allocUnsafe(arg);
    }
    return $a43f1221574a89cf$var$from(arg, encodingOrOffset, length);
}
$a43f1221574a89cf$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a43f1221574a89cf$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $a43f1221574a89cf$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a43f1221574a89cf$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a43f1221574a89cf$var$isInstance(value, ArrayBuffer) || value && $a43f1221574a89cf$var$isInstance(value.buffer, ArrayBuffer)) return $a43f1221574a89cf$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($a43f1221574a89cf$var$isInstance(value, SharedArrayBuffer) || value && $a43f1221574a89cf$var$isInstance(value.buffer, SharedArrayBuffer))) return $a43f1221574a89cf$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a43f1221574a89cf$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $a43f1221574a89cf$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $a43f1221574a89cf$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a43f1221574a89cf$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a43f1221574a89cf$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a43f1221574a89cf$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a43f1221574a89cf$var$Buffer, Uint8Array);
function $a43f1221574a89cf$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a43f1221574a89cf$var$alloc(size, fill, encoding) {
    $a43f1221574a89cf$var$assertSize(size);
    if (size <= 0) return $a43f1221574a89cf$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $a43f1221574a89cf$var$createBuffer(size).fill(fill, encoding) : $a43f1221574a89cf$var$createBuffer(size).fill(fill);
    return $a43f1221574a89cf$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a43f1221574a89cf$var$Buffer.alloc = function(size, fill, encoding) {
    return $a43f1221574a89cf$var$alloc(size, fill, encoding);
};
function $a43f1221574a89cf$var$allocUnsafe(size) {
    $a43f1221574a89cf$var$assertSize(size);
    return $a43f1221574a89cf$var$createBuffer(size < 0 ? 0 : $a43f1221574a89cf$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a43f1221574a89cf$var$Buffer.allocUnsafe = function(size) {
    return $a43f1221574a89cf$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a43f1221574a89cf$var$Buffer.allocUnsafeSlow = function(size) {
    return $a43f1221574a89cf$var$allocUnsafe(size);
};
function $a43f1221574a89cf$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$a43f1221574a89cf$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $a43f1221574a89cf$var$byteLength(string, encoding) | 0;
    let buf = $a43f1221574a89cf$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a43f1221574a89cf$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $a43f1221574a89cf$var$checked(array.length) | 0;
    const buf = $a43f1221574a89cf$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a43f1221574a89cf$var$fromArrayView(arrayView) {
    if ($a43f1221574a89cf$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $a43f1221574a89cf$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a43f1221574a89cf$var$fromArrayLike(arrayView);
}
function $a43f1221574a89cf$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a43f1221574a89cf$var$Buffer.prototype);
    return buf;
}
function $a43f1221574a89cf$var$fromObject(obj) {
    if ($a43f1221574a89cf$var$Buffer.isBuffer(obj)) {
        const len = $a43f1221574a89cf$var$checked(obj.length) | 0;
        const buf = $a43f1221574a89cf$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $a43f1221574a89cf$var$numberIsNaN(obj.length)) return $a43f1221574a89cf$var$createBuffer(0);
        return $a43f1221574a89cf$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $a43f1221574a89cf$var$fromArrayLike(obj.data);
}
function $a43f1221574a89cf$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a43f1221574a89cf$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a43f1221574a89cf$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $a43f1221574a89cf$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a43f1221574a89cf$var$Buffer.alloc(+length);
}
$a43f1221574a89cf$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a43f1221574a89cf$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a43f1221574a89cf$var$Buffer.compare = function compare(a, b) {
    if ($a43f1221574a89cf$var$isInstance(a, Uint8Array)) a = $a43f1221574a89cf$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a43f1221574a89cf$var$isInstance(b, Uint8Array)) b = $a43f1221574a89cf$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a43f1221574a89cf$var$Buffer.isBuffer(a) || !$a43f1221574a89cf$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a43f1221574a89cf$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$a43f1221574a89cf$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a43f1221574a89cf$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $a43f1221574a89cf$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($a43f1221574a89cf$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a43f1221574a89cf$var$Buffer.isBuffer(buf)) buf = $a43f1221574a89cf$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a43f1221574a89cf$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a43f1221574a89cf$var$byteLength(string, encoding) {
    if ($a43f1221574a89cf$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a43f1221574a89cf$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $a43f1221574a89cf$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $a43f1221574a89cf$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a43f1221574a89cf$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a43f1221574a89cf$var$Buffer.byteLength = $a43f1221574a89cf$var$byteLength;
function $a43f1221574a89cf$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $a43f1221574a89cf$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $a43f1221574a89cf$var$utf8Slice(this, start, end);
        case 'ascii':
            return $a43f1221574a89cf$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $a43f1221574a89cf$var$latin1Slice(this, start, end);
        case 'base64':
            return $a43f1221574a89cf$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a43f1221574a89cf$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a43f1221574a89cf$var$Buffer.prototype._isBuffer = true;
function $a43f1221574a89cf$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a43f1221574a89cf$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$a43f1221574a89cf$var$swap(this, i, i + 1);
    return this;
};
$a43f1221574a89cf$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $a43f1221574a89cf$var$swap(this, i, i + 3);
        $a43f1221574a89cf$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a43f1221574a89cf$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $a43f1221574a89cf$var$swap(this, i, i + 7);
        $a43f1221574a89cf$var$swap(this, i + 1, i + 6);
        $a43f1221574a89cf$var$swap(this, i + 2, i + 5);
        $a43f1221574a89cf$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a43f1221574a89cf$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $a43f1221574a89cf$var$utf8Slice(this, 0, length);
    return $a43f1221574a89cf$var$slowToString.apply(this, arguments);
};
$a43f1221574a89cf$var$Buffer.prototype.toLocaleString = $a43f1221574a89cf$var$Buffer.prototype.toString;
$a43f1221574a89cf$var$Buffer.prototype.equals = function equals(b) {
    if (!$a43f1221574a89cf$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $a43f1221574a89cf$var$Buffer.compare(this, b) === 0;
};
$a43f1221574a89cf$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $a43f1221574a89cf$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($a43f1221574a89cf$var$customInspectSymbol) $a43f1221574a89cf$var$Buffer.prototype[$a43f1221574a89cf$var$customInspectSymbol] = $a43f1221574a89cf$var$Buffer.prototype.inspect;
$a43f1221574a89cf$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a43f1221574a89cf$var$isInstance(target, Uint8Array)) target = $a43f1221574a89cf$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a43f1221574a89cf$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a43f1221574a89cf$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a43f1221574a89cf$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $a43f1221574a89cf$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a43f1221574a89cf$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a43f1221574a89cf$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a43f1221574a89cf$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $a43f1221574a89cf$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a43f1221574a89cf$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a43f1221574a89cf$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a43f1221574a89cf$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a43f1221574a89cf$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a43f1221574a89cf$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a43f1221574a89cf$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a43f1221574a89cf$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a43f1221574a89cf$var$utf8Write(buf, string, offset, length) {
    return $a43f1221574a89cf$var$blitBuffer($a43f1221574a89cf$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a43f1221574a89cf$var$asciiWrite(buf, string, offset, length) {
    return $a43f1221574a89cf$var$blitBuffer($a43f1221574a89cf$var$asciiToBytes(string), buf, offset, length);
}
function $a43f1221574a89cf$var$base64Write(buf, string, offset, length) {
    return $a43f1221574a89cf$var$blitBuffer($a43f1221574a89cf$var$base64ToBytes(string), buf, offset, length);
}
function $a43f1221574a89cf$var$ucs2Write(buf, string, offset, length) {
    return $a43f1221574a89cf$var$blitBuffer($a43f1221574a89cf$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a43f1221574a89cf$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $a43f1221574a89cf$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $a43f1221574a89cf$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $a43f1221574a89cf$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $a43f1221574a89cf$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a43f1221574a89cf$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a43f1221574a89cf$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a43f1221574a89cf$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $lENzZ.fromByteArray(buf);
    else return $lENzZ.fromByteArray(buf.slice(start, end));
}
function $a43f1221574a89cf$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a43f1221574a89cf$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $a43f1221574a89cf$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a43f1221574a89cf$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $a43f1221574a89cf$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a43f1221574a89cf$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a43f1221574a89cf$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a43f1221574a89cf$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a43f1221574a89cf$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $a43f1221574a89cf$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a43f1221574a89cf$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a43f1221574a89cf$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a43f1221574a89cf$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a43f1221574a89cf$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$a43f1221574a89cf$var$Buffer.prototype.readUintLE = $a43f1221574a89cf$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a43f1221574a89cf$var$Buffer.prototype.readUintBE = $a43f1221574a89cf$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a43f1221574a89cf$var$Buffer.prototype.readUint8 = $a43f1221574a89cf$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a43f1221574a89cf$var$Buffer.prototype.readUint16LE = $a43f1221574a89cf$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a43f1221574a89cf$var$Buffer.prototype.readUint16BE = $a43f1221574a89cf$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a43f1221574a89cf$var$Buffer.prototype.readUint32LE = $a43f1221574a89cf$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a43f1221574a89cf$var$Buffer.prototype.readUint32BE = $a43f1221574a89cf$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a43f1221574a89cf$var$Buffer.prototype.readBigUInt64LE = $a43f1221574a89cf$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a43f1221574a89cf$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a43f1221574a89cf$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a43f1221574a89cf$var$Buffer.prototype.readBigUInt64BE = $a43f1221574a89cf$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a43f1221574a89cf$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a43f1221574a89cf$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a43f1221574a89cf$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a43f1221574a89cf$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a43f1221574a89cf$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a43f1221574a89cf$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a43f1221574a89cf$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a43f1221574a89cf$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a43f1221574a89cf$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a43f1221574a89cf$var$Buffer.prototype.readBigInt64LE = $a43f1221574a89cf$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a43f1221574a89cf$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a43f1221574a89cf$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$a43f1221574a89cf$var$Buffer.prototype.readBigInt64BE = $a43f1221574a89cf$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a43f1221574a89cf$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a43f1221574a89cf$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$a43f1221574a89cf$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 4, this.length);
    return $86gGF.read(this, offset, true, 23, 4);
};
$a43f1221574a89cf$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 4, this.length);
    return $86gGF.read(this, offset, false, 23, 4);
};
$a43f1221574a89cf$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 8, this.length);
    return $86gGF.read(this, offset, true, 52, 8);
};
$a43f1221574a89cf$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkOffset(offset, 8, this.length);
    return $86gGF.read(this, offset, false, 52, 8);
};
function $a43f1221574a89cf$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a43f1221574a89cf$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$a43f1221574a89cf$var$Buffer.prototype.writeUintLE = $a43f1221574a89cf$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a43f1221574a89cf$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a43f1221574a89cf$var$Buffer.prototype.writeUintBE = $a43f1221574a89cf$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a43f1221574a89cf$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a43f1221574a89cf$var$Buffer.prototype.writeUint8 = $a43f1221574a89cf$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a43f1221574a89cf$var$Buffer.prototype.writeUint16LE = $a43f1221574a89cf$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a43f1221574a89cf$var$Buffer.prototype.writeUint16BE = $a43f1221574a89cf$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a43f1221574a89cf$var$Buffer.prototype.writeUint32LE = $a43f1221574a89cf$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a43f1221574a89cf$var$Buffer.prototype.writeUint32BE = $a43f1221574a89cf$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a43f1221574a89cf$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a43f1221574a89cf$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a43f1221574a89cf$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a43f1221574a89cf$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a43f1221574a89cf$var$Buffer.prototype.writeBigUInt64LE = $a43f1221574a89cf$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $a43f1221574a89cf$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a43f1221574a89cf$var$Buffer.prototype.writeBigUInt64BE = $a43f1221574a89cf$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $a43f1221574a89cf$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a43f1221574a89cf$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a43f1221574a89cf$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a43f1221574a89cf$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a43f1221574a89cf$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a43f1221574a89cf$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a43f1221574a89cf$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a43f1221574a89cf$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a43f1221574a89cf$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a43f1221574a89cf$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a43f1221574a89cf$var$Buffer.prototype.writeBigInt64LE = $a43f1221574a89cf$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $a43f1221574a89cf$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$a43f1221574a89cf$var$Buffer.prototype.writeBigInt64BE = $a43f1221574a89cf$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $a43f1221574a89cf$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $a43f1221574a89cf$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $a43f1221574a89cf$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $86gGF.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a43f1221574a89cf$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a43f1221574a89cf$var$writeFloat(this, value, offset, true, noAssert);
};
$a43f1221574a89cf$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a43f1221574a89cf$var$writeFloat(this, value, offset, false, noAssert);
};
function $a43f1221574a89cf$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a43f1221574a89cf$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $86gGF.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a43f1221574a89cf$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a43f1221574a89cf$var$writeDouble(this, value, offset, true, noAssert);
};
$a43f1221574a89cf$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a43f1221574a89cf$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a43f1221574a89cf$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a43f1221574a89cf$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a43f1221574a89cf$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$a43f1221574a89cf$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $a43f1221574a89cf$var$Buffer.isBuffer(val) ? val : $a43f1221574a89cf$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $a43f1221574a89cf$var$errors = {};
function $a43f1221574a89cf$var$E(sym, getMessage, Base) {
    $a43f1221574a89cf$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$a43f1221574a89cf$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$a43f1221574a89cf$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$a43f1221574a89cf$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $a43f1221574a89cf$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $a43f1221574a89cf$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $a43f1221574a89cf$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $a43f1221574a89cf$var$checkBounds(buf, offset, byteLength) {
    $a43f1221574a89cf$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a43f1221574a89cf$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a43f1221574a89cf$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $a43f1221574a89cf$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $a43f1221574a89cf$var$checkBounds(buf, offset, byteLength);
}
function $a43f1221574a89cf$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $a43f1221574a89cf$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $a43f1221574a89cf$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a43f1221574a89cf$var$validateNumber(value, type);
        throw new $a43f1221574a89cf$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $a43f1221574a89cf$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a43f1221574a89cf$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $a43f1221574a89cf$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a43f1221574a89cf$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a43f1221574a89cf$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $a43f1221574a89cf$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $a43f1221574a89cf$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a43f1221574a89cf$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a43f1221574a89cf$var$base64ToBytes(str) {
    return $lENzZ.toByteArray($a43f1221574a89cf$var$base64clean(str));
}
function $a43f1221574a89cf$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a43f1221574a89cf$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a43f1221574a89cf$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $a43f1221574a89cf$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a43f1221574a89cf$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $a43f1221574a89cf$var$BufferBigIntNotDefined : fn;
}
function $a43f1221574a89cf$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("lENzZ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $fc43cad4d59905bc$export$d622b2ad8d90c771; }, function (v) { return $fc43cad4d59905bc$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $fc43cad4d59905bc$export$6100ba28696e12de; }, function (v) { return $fc43cad4d59905bc$export$6100ba28696e12de = v; });
var $fc43cad4d59905bc$export$a48f0734ac7c2329;
var $fc43cad4d59905bc$export$d622b2ad8d90c771;
var $fc43cad4d59905bc$export$6100ba28696e12de;
'use strict';
$fc43cad4d59905bc$export$a48f0734ac7c2329 = $fc43cad4d59905bc$var$byteLength;
$fc43cad4d59905bc$export$d622b2ad8d90c771 = $fc43cad4d59905bc$var$toByteArray;
$fc43cad4d59905bc$export$6100ba28696e12de = $fc43cad4d59905bc$var$fromByteArray;
var $fc43cad4d59905bc$var$lookup = [];
var $fc43cad4d59905bc$var$revLookup = [];
var $fc43cad4d59905bc$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $fc43cad4d59905bc$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $fc43cad4d59905bc$var$i = 0, $fc43cad4d59905bc$var$len = $fc43cad4d59905bc$var$code.length; $fc43cad4d59905bc$var$i < $fc43cad4d59905bc$var$len; ++$fc43cad4d59905bc$var$i){
    $fc43cad4d59905bc$var$lookup[$fc43cad4d59905bc$var$i] = $fc43cad4d59905bc$var$code[$fc43cad4d59905bc$var$i];
    $fc43cad4d59905bc$var$revLookup[$fc43cad4d59905bc$var$code.charCodeAt($fc43cad4d59905bc$var$i)] = $fc43cad4d59905bc$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$fc43cad4d59905bc$var$revLookup['-'.charCodeAt(0)] = 62;
$fc43cad4d59905bc$var$revLookup['_'.charCodeAt(0)] = 63;
function $fc43cad4d59905bc$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $fc43cad4d59905bc$var$byteLength(b64) {
    var lens = $fc43cad4d59905bc$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $fc43cad4d59905bc$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $fc43cad4d59905bc$var$toByteArray(b64) {
    var tmp;
    var lens = $fc43cad4d59905bc$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $fc43cad4d59905bc$var$Arr($fc43cad4d59905bc$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i)] << 18 | $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i)] << 2 | $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i)] << 10 | $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $fc43cad4d59905bc$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $fc43cad4d59905bc$var$tripletToBase64(num) {
    return $fc43cad4d59905bc$var$lookup[num >> 18 & 0x3F] + $fc43cad4d59905bc$var$lookup[num >> 12 & 0x3F] + $fc43cad4d59905bc$var$lookup[num >> 6 & 0x3F] + $fc43cad4d59905bc$var$lookup[num & 0x3F];
}
function $fc43cad4d59905bc$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($fc43cad4d59905bc$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $fc43cad4d59905bc$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($fc43cad4d59905bc$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($fc43cad4d59905bc$var$lookup[tmp >> 2] + $fc43cad4d59905bc$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($fc43cad4d59905bc$var$lookup[tmp >> 10] + $fc43cad4d59905bc$var$lookup[tmp >> 4 & 0x3F] + $fc43cad4d59905bc$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("86gGF", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $5e5bd4028f5b3b6a$export$aafa59e2e03f2942; }, function (v) { return $5e5bd4028f5b3b6a$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $5e5bd4028f5b3b6a$export$68d8715fc104d294; }, function (v) { return $5e5bd4028f5b3b6a$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5e5bd4028f5b3b6a$export$aafa59e2e03f2942;
var $5e5bd4028f5b3b6a$export$68d8715fc104d294;
$5e5bd4028f5b3b6a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5e5bd4028f5b3b6a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("jKqpv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $e606ccc356643d45$var$getSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter((symbol)=>Object.prototype.propertyIsEnumerable.call(object, symbol));
}
module.exports.getSymbols = $e606ccc356643d45$var$getSymbols;

});

parcelRegister("lUKgF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $ff42b7c394fae385$var$getTag(value) {
    if (value == null) return value === undefined ? '[object Undefined]' : '[object Null]';
    return Object.prototype.toString.call(value);
}
module.exports.getTag = $ff42b7c394fae385$var$getTag;

});

parcelRegister("kSX0N", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f346a0516e091133$var$regexpTag = '[object RegExp]';
const $f346a0516e091133$var$stringTag = '[object String]';
const $f346a0516e091133$var$numberTag = '[object Number]';
const $f346a0516e091133$var$booleanTag = '[object Boolean]';
const $f346a0516e091133$var$argumentsTag = '[object Arguments]';
const $f346a0516e091133$var$symbolTag = '[object Symbol]';
const $f346a0516e091133$var$dateTag = '[object Date]';
const $f346a0516e091133$var$mapTag = '[object Map]';
const $f346a0516e091133$var$setTag = '[object Set]';
const $f346a0516e091133$var$arrayTag = '[object Array]';
const $f346a0516e091133$var$functionTag = '[object Function]';
const $f346a0516e091133$var$arrayBufferTag = '[object ArrayBuffer]';
const $f346a0516e091133$var$objectTag = '[object Object]';
const $f346a0516e091133$var$errorTag = '[object Error]';
const $f346a0516e091133$var$dataViewTag = '[object DataView]';
const $f346a0516e091133$var$uint8ArrayTag = '[object Uint8Array]';
const $f346a0516e091133$var$uint8ClampedArrayTag = '[object Uint8ClampedArray]';
const $f346a0516e091133$var$uint16ArrayTag = '[object Uint16Array]';
const $f346a0516e091133$var$uint32ArrayTag = '[object Uint32Array]';
const $f346a0516e091133$var$bigUint64ArrayTag = '[object BigUint64Array]';
const $f346a0516e091133$var$int8ArrayTag = '[object Int8Array]';
const $f346a0516e091133$var$int16ArrayTag = '[object Int16Array]';
const $f346a0516e091133$var$int32ArrayTag = '[object Int32Array]';
const $f346a0516e091133$var$bigInt64ArrayTag = '[object BigInt64Array]';
const $f346a0516e091133$var$float32ArrayTag = '[object Float32Array]';
const $f346a0516e091133$var$float64ArrayTag = '[object Float64Array]';
module.exports.argumentsTag = $f346a0516e091133$var$argumentsTag;
module.exports.arrayBufferTag = $f346a0516e091133$var$arrayBufferTag;
module.exports.arrayTag = $f346a0516e091133$var$arrayTag;
module.exports.bigInt64ArrayTag = $f346a0516e091133$var$bigInt64ArrayTag;
module.exports.bigUint64ArrayTag = $f346a0516e091133$var$bigUint64ArrayTag;
module.exports.booleanTag = $f346a0516e091133$var$booleanTag;
module.exports.dataViewTag = $f346a0516e091133$var$dataViewTag;
module.exports.dateTag = $f346a0516e091133$var$dateTag;
module.exports.errorTag = $f346a0516e091133$var$errorTag;
module.exports.float32ArrayTag = $f346a0516e091133$var$float32ArrayTag;
module.exports.float64ArrayTag = $f346a0516e091133$var$float64ArrayTag;
module.exports.functionTag = $f346a0516e091133$var$functionTag;
module.exports.int16ArrayTag = $f346a0516e091133$var$int16ArrayTag;
module.exports.int32ArrayTag = $f346a0516e091133$var$int32ArrayTag;
module.exports.int8ArrayTag = $f346a0516e091133$var$int8ArrayTag;
module.exports.mapTag = $f346a0516e091133$var$mapTag;
module.exports.numberTag = $f346a0516e091133$var$numberTag;
module.exports.objectTag = $f346a0516e091133$var$objectTag;
module.exports.regexpTag = $f346a0516e091133$var$regexpTag;
module.exports.setTag = $f346a0516e091133$var$setTag;
module.exports.stringTag = $f346a0516e091133$var$stringTag;
module.exports.symbolTag = $f346a0516e091133$var$symbolTag;
module.exports.uint16ArrayTag = $f346a0516e091133$var$uint16ArrayTag;
module.exports.uint32ArrayTag = $f346a0516e091133$var$uint32ArrayTag;
module.exports.uint8ArrayTag = $f346a0516e091133$var$uint8ArrayTag;
module.exports.uint8ClampedArrayTag = $f346a0516e091133$var$uint8ClampedArrayTag;

});

parcelRegister("drWlg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9cab0d740903eede$var$isPrimitive(value) {
    return value == null || typeof value !== 'object' && typeof value !== 'function';
}
module.exports.isPrimitive = $9cab0d740903eede$var$isPrimitive;

});

parcelRegister("b81uI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $81a199d28c954885$var$isTypedArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
module.exports.isTypedArray = $81a199d28c954885$var$isTypedArray;

});



parcelRegister("if4Jc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $OtE1R = parcelRequire("OtE1R");

var $kV5MM = parcelRequire("kV5MM");

var $l7ybS = parcelRequire("l7ybS");

var $iH4AG = parcelRequire("iH4AG");

var $8TDLl = parcelRequire("8TDLl");
function $036d602fdaa2a298$var$keysIn(object) {
    if (object == null) return [];
    switch(typeof object){
        case 'object':
        case 'function':
            if ($l7ybS.isArrayLike(object)) return $036d602fdaa2a298$var$arrayLikeKeysIn(object);
            if ($kV5MM.isPrototype(object)) return $036d602fdaa2a298$var$prototypeKeysIn(object);
            return $036d602fdaa2a298$var$keysInImpl(object);
        default:
            return $036d602fdaa2a298$var$keysInImpl(Object(object));
    }
}
function $036d602fdaa2a298$var$keysInImpl(object) {
    const result = [];
    for(const key in object)result.push(key);
    return result;
}
function $036d602fdaa2a298$var$prototypeKeysIn(object) {
    const keys = $036d602fdaa2a298$var$keysInImpl(object);
    return keys.filter((key)=>key !== 'constructor');
}
function $036d602fdaa2a298$var$arrayLikeKeysIn(object) {
    const indices = $8TDLl.times(object.length, (index)=>`${index}`);
    const filteredKeys = new Set(indices);
    if ($OtE1R.isBuffer(object)) {
        filteredKeys.add('offset');
        filteredKeys.add('parent');
    }
    if ($iH4AG.isTypedArray(object)) {
        filteredKeys.add('buffer');
        filteredKeys.add('byteLength');
        filteredKeys.add('byteOffset');
    }
    const inheritedKeys = $036d602fdaa2a298$var$keysInImpl(object).filter((key)=>!filteredKeys.has(key));
    if (Array.isArray(object)) return [
        ...indices,
        ...inheritedKeys
    ];
    return [
        ...indices.filter((index)=>Object.hasOwn(object, index)),
        ...inheritedKeys
    ];
}
module.exports.keysIn = $036d602fdaa2a298$var$keysIn;

});
parcelRegister("OtE1R", function(module, exports) {

var $e6hkG = parcelRequire("e6hkG");
var $097baa6ec181fbc6$require$Buffer = $e6hkG.Buffer;
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $097baa6ec181fbc6$var$isBuffer(x) {
    return typeof $097baa6ec181fbc6$require$Buffer !== 'undefined' && $097baa6ec181fbc6$require$Buffer.isBuffer(x);
}
module.exports.isBuffer = $097baa6ec181fbc6$var$isBuffer;

});

parcelRegister("kV5MM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $f3ad9e708cf84e10$var$isPrototype(value) {
    const constructor = value?.constructor;
    const prototype = typeof constructor === 'function' ? constructor.prototype : Object.prototype;
    return value === prototype;
}
module.exports.isPrototype = $f3ad9e708cf84e10$var$isPrototype;

});

parcelRegister("iH4AG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $b81uI = parcelRequire("b81uI");
function $d9bfcdbfd3f9cde1$var$isTypedArray(x) {
    return $b81uI.isTypedArray(x);
}
module.exports.isTypedArray = $d9bfcdbfd3f9cde1$var$isTypedArray;

});

parcelRegister("8TDLl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1N098 = parcelRequire("1N098");
function $67a24dd6ac06acb0$var$times(n, getValue) {
    n = $1N098.toInteger(n);
    if (n < 1 || !Number.isSafeInteger(n)) return [];
    const result = new Array(n);
    for(let i = 0; i < n; i++)result[i] = typeof getValue === 'function' ? getValue(i) : i;
    return result;
}
module.exports.times = $67a24dd6ac06acb0$var$times;

});
parcelRegister("1N098", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $aGiDc = parcelRequire("aGiDc");
function $14da7b161285d7a7$var$toInteger(value) {
    const finite = $aGiDc.toFinite(value);
    const remainder = finite % 1;
    return remainder ? finite - remainder : finite;
}
module.exports.toInteger = $14da7b161285d7a7$var$toInteger;

});



parcelRegister("1d8VS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gAKvK = parcelRequire("gAKvK");

var $9gqiT = parcelRequire("9gqiT");

var $kXM1U = parcelRequire("kXM1U");

var $cthHH = parcelRequire("cthHH");

var $k1SBU = parcelRequire("k1SBU");
function $0e1def26537a8460$var$unset(obj, path) {
    if (obj == null) return true;
    switch(typeof path){
        case 'symbol':
        case 'number':
        case 'object':
            if (Array.isArray(path)) return $0e1def26537a8460$var$unsetWithPath(obj, path);
            if (typeof path === 'number') path = $cthHH.toKey(path);
            else if (typeof path === 'object') {
                if (Object.is(path?.valueOf(), -0)) path = '-0';
                else path = String(path);
            }
            if ($9gqiT.isUnsafeProperty(path)) return false;
            if (obj?.[path] === undefined) return true;
            try {
                delete obj[path];
                return true;
            } catch  {
                return false;
            }
        case 'string':
            if (obj?.[path] === undefined && $kXM1U.isDeepKey(path)) return $0e1def26537a8460$var$unsetWithPath(obj, $k1SBU.toPath(path));
            if ($9gqiT.isUnsafeProperty(path)) return false;
            try {
                delete obj[path];
                return true;
            } catch  {
                return false;
            }
    }
}
function $0e1def26537a8460$var$unsetWithPath(obj, path) {
    const parent = path.length === 1 ? obj : $gAKvK.get(obj, path.slice(0, -1));
    const lastKey = path[path.length - 1];
    if (parent?.[lastKey] === undefined) return true;
    if ($9gqiT.isUnsafeProperty(lastKey)) return false;
    try {
        delete parent[lastKey];
        return true;
    } catch  {
        return false;
    }
}
module.exports.unset = $0e1def26537a8460$var$unset;

});

parcelRegister("8giRX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jKqpv = parcelRequire("jKqpv");
function $603e746b8ab08621$var$getSymbolsIn(object) {
    const result = [];
    while(object){
        result.push(...$jKqpv.getSymbols(object));
        object = Object.getPrototypeOf(object);
    }
    return result;
}
module.exports.getSymbolsIn = $603e746b8ab08621$var$getSymbolsIn;

});

parcelRegister("dm0tj", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $l7ybS = parcelRequire("l7ybS");
function $9b8db21ca91e7c2b$var$flatten(value, depth = 1) {
    const result = [];
    const flooredDepth = Math.floor(depth);
    if (!$l7ybS.isArrayLike(value)) return result;
    const recursive = (arr, currentDepth)=>{
        for(let i = 0; i < arr.length; i++){
            const item = arr[i];
            if (currentDepth < flooredDepth && (Array.isArray(item) || Boolean(item?.[Symbol.isConcatSpreadable]) || item !== null && typeof item === 'object' && Object.prototype.toString.call(item) === '[object Arguments]')) {
                if (Array.isArray(item)) recursive(item, currentDepth + 1);
                else recursive(Array.from(item), currentDepth + 1);
            } else result.push(item);
        }
    };
    recursive(Array.from(value), 0);
    return result;
}
module.exports.flatten = $9b8db21ca91e7c2b$var$flatten;

});


parcelRegister("lwPuX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2gp2K = parcelRequire("2gp2K");

var $crZHd = parcelRequire("crZHd");

var $5XrUM = parcelRequire("5XrUM");

var $lj6PM = parcelRequire("lj6PM");
function $fac4889b2c7d6af4$var$uniqBy(array, iteratee$1 = $crZHd.identity) {
    if (!$5XrUM.isArrayLikeObject(array)) return [];
    return $2gp2K.uniqBy(Array.from(array), $lj6PM.iteratee(iteratee$1));
}
module.exports.uniqBy = $fac4889b2c7d6af4$var$uniqBy;

});
parcelRegister("2gp2K", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $1a60807abc38fca6$var$uniqBy(arr, mapper) {
    const map = new Map();
    for(let i = 0; i < arr.length; i++){
        const item = arr[i];
        const key = mapper(item);
        if (!map.has(key)) map.set(key, item);
    }
    return Array.from(map.values());
}
module.exports.uniqBy = $1a60807abc38fca6$var$uniqBy;

});

parcelRegister("crZHd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $9107dd2de057296e$var$identity(x) {
    return x;
}
module.exports.identity = $9107dd2de057296e$var$identity;

});

parcelRegister("5XrUM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $l7ybS = parcelRequire("l7ybS");

var $iYT1Q = parcelRequire("iYT1Q");
function $45681db77573a55c$var$isArrayLikeObject(value) {
    return $iYT1Q.isObjectLike(value) && $l7ybS.isArrayLike(value);
}
module.exports.isArrayLikeObject = $45681db77573a55c$var$isArrayLikeObject;

});
parcelRegister("iYT1Q", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
function $dd188426dff21a86$var$isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
module.exports.isObjectLike = $dd188426dff21a86$var$isObjectLike;

});


parcelRegister("lj6PM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $crZHd = parcelRequire("crZHd");

var $dDcSX = parcelRequire("dDcSX");

var $3SaXY = parcelRequire("3SaXY");

var $fjYaa = parcelRequire("fjYaa");
function $f830ac70d22292db$var$iteratee(value) {
    if (value == null) return $crZHd.identity;
    switch(typeof value){
        case 'function':
            return value;
        case 'object':
            if (Array.isArray(value) && value.length === 2) return $fjYaa.matchesProperty(value[0], value[1]);
            return $3SaXY.matches(value);
        case 'string':
        case 'symbol':
        case 'number':
            return $dDcSX.property(value);
    }
}
module.exports.iteratee = $f830ac70d22292db$var$iteratee;

});
parcelRegister("dDcSX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gAKvK = parcelRequire("gAKvK");
function $9ec8e9a8c8722f07$var$property(path) {
    return function(object) {
        return $gAKvK.get(object, path);
    };
}
module.exports.property = $9ec8e9a8c8722f07$var$property;

});

parcelRegister("3SaXY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6yMte = parcelRequire("6yMte");

var $1WLLc = parcelRequire("1WLLc");
function $2d1eebf039ec33e5$var$matches(source) {
    source = $1WLLc.cloneDeep(source);
    return (target)=>{
        return $6yMte.isMatch(target, source);
    };
}
module.exports.matches = $2d1eebf039ec33e5$var$matches;

});
parcelRegister("6yMte", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $ho3So = parcelRequire("ho3So");
function $4c6b84463a9d5444$var$isMatch(target, source) {
    return $ho3So.isMatchWith(target, source, ()=>undefined);
}
module.exports.isMatch = $4c6b84463a9d5444$var$isMatch;

});
parcelRegister("ho3So", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4j1N7 = parcelRequire("4j1N7");

var $drWlg = parcelRequire("drWlg");

var $2rOTb = parcelRequire("2rOTb");
function $ca87af508211485f$var$isMatchWith(target, source, compare) {
    if (typeof compare !== 'function') return $ca87af508211485f$var$isMatchWith(target, source, ()=>undefined);
    return $ca87af508211485f$var$isMatchWithInternal(target, source, function doesMatch(objValue, srcValue, key, object, source, stack) {
        const isEqual = compare(objValue, srcValue, key, object, source, stack);
        if (isEqual !== undefined) return Boolean(isEqual);
        return $ca87af508211485f$var$isMatchWithInternal(objValue, srcValue, doesMatch, stack);
    }, new Map());
}
function $ca87af508211485f$var$isMatchWithInternal(target, source, compare, stack) {
    if (source === target) return true;
    switch(typeof source){
        case 'object':
            return $ca87af508211485f$var$isObjectMatch(target, source, compare, stack);
        case 'function':
            {
                const sourceKeys = Object.keys(source);
                if (sourceKeys.length > 0) return $ca87af508211485f$var$isMatchWithInternal(target, {
                    ...source
                }, compare, stack);
                return $2rOTb.eq(target, source);
            }
        default:
            if (!$4j1N7.isObject(target)) return $2rOTb.eq(target, source);
            if (typeof source === 'string') return source === '';
            return true;
    }
}
function $ca87af508211485f$var$isObjectMatch(target, source, compare, stack) {
    if (source == null) return true;
    if (Array.isArray(source)) return $ca87af508211485f$var$isArrayMatch(target, source, compare, stack);
    if (source instanceof Map) return $ca87af508211485f$var$isMapMatch(target, source, compare, stack);
    if (source instanceof Set) return $ca87af508211485f$var$isSetMatch(target, source, compare, stack);
    const keys = Object.keys(source);
    if (target == null) return keys.length === 0;
    if (keys.length === 0) return true;
    if (stack?.has(source)) return stack.get(source) === target;
    stack?.set(source, target);
    try {
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (!$drWlg.isPrimitive(target) && !(key in target)) return false;
            if (source[key] === undefined && target[key] !== undefined) return false;
            if (source[key] === null && target[key] !== null) return false;
            const isEqual = compare(target[key], source[key], key, target, source, stack);
            if (!isEqual) return false;
        }
        return true;
    } finally{
        stack?.delete(source);
    }
}
function $ca87af508211485f$var$isMapMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Map)) return false;
    for (const [key, sourceValue] of source.entries()){
        const targetValue = target.get(key);
        const isEqual = compare(targetValue, sourceValue, key, target, source, stack);
        if (isEqual === false) return false;
    }
    return true;
}
function $ca87af508211485f$var$isArrayMatch(target, source, compare, stack) {
    if (source.length === 0) return true;
    if (!Array.isArray(target)) return false;
    const countedIndex = new Set();
    for(let i = 0; i < source.length; i++){
        const sourceItem = source[i];
        let found = false;
        for(let j = 0; j < target.length; j++){
            if (countedIndex.has(j)) continue;
            const targetItem = target[j];
            let matches = false;
            const isEqual = compare(targetItem, sourceItem, i, target, source, stack);
            if (isEqual) matches = true;
            if (matches) {
                countedIndex.add(j);
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    return true;
}
function $ca87af508211485f$var$isSetMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Set)) return false;
    return $ca87af508211485f$var$isArrayMatch([
        ...target
    ], [
        ...source
    ], compare, stack);
}
module.exports.isMatchWith = $ca87af508211485f$var$isMatchWith;
module.exports.isSetMatch = $ca87af508211485f$var$isSetMatch;

});


parcelRegister("1WLLc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dVp2N = parcelRequire("dVp2N");
function $16b0416dc307e116$var$cloneDeep(obj) {
    return $dVp2N.cloneDeepWithImpl(obj, undefined, obj, new Map(), undefined);
}
module.exports.cloneDeep = $16b0416dc307e116$var$cloneDeep;

});


parcelRegister("fjYaa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6yMte = parcelRequire("6yMte");

var $cthHH = parcelRequire("cthHH");

var $huev4 = parcelRequire("huev4");

var $gAKvK = parcelRequire("gAKvK");

var $6vb92 = parcelRequire("6vb92");
function $b2774c79e63bc511$var$matchesProperty(property, source) {
    switch(typeof property){
        case 'object':
            if (Object.is(property?.valueOf(), -0)) property = '-0';
            break;
        case 'number':
            property = $cthHH.toKey(property);
            break;
    }
    source = $huev4.cloneDeep(source);
    return function(target) {
        const result = $gAKvK.get(target, property);
        if (result === undefined) return $6vb92.has(target, property);
        if (source === undefined) return result === undefined;
        return $6yMte.isMatch(result, source);
    };
}
module.exports.matchesProperty = $b2774c79e63bc511$var$matchesProperty;

});
parcelRegister("huev4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g4dSz = parcelRequire("g4dSz");
function $cbb07c734987e79d$var$cloneDeep(obj) {
    return $g4dSz.cloneDeepWith(obj);
}
module.exports.cloneDeep = $cbb07c734987e79d$var$cloneDeep;

});

parcelRegister("6vb92", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kXM1U = parcelRequire("kXM1U");

var $eZdwf = parcelRequire("eZdwf");

var $DGoWz = parcelRequire("DGoWz");

var $k1SBU = parcelRequire("k1SBU");
function $4bbe486c352c9391$var$has(object, path) {
    let resolvedPath;
    if (Array.isArray(path)) resolvedPath = path;
    else if (typeof path === 'string' && $kXM1U.isDeepKey(path) && object?.[path] == null) resolvedPath = $k1SBU.toPath(path);
    else resolvedPath = [
        path
    ];
    if (resolvedPath.length === 0) return false;
    let current = object;
    for(let i = 0; i < resolvedPath.length; i++){
        const key = resolvedPath[i];
        if (current == null || !Object.hasOwn(current, key)) {
            const isSparseIndex = (Array.isArray(current) || $DGoWz.isArguments(current)) && $eZdwf.isIndex(key) && key < current.length;
            if (!isSparseIndex) return false;
        }
        current = current[key];
    }
    return true;
}
module.exports.has = $4bbe486c352c9391$var$has;

});
parcelRegister("DGoWz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lUKgF = parcelRequire("lUKgF");
function $077488a6af11249c$var$isArguments(value) {
    return value !== null && typeof value === 'object' && $lUKgF.getTag(value) === '[object Arguments]';
}
module.exports.isArguments = $077488a6af11249c$var$isArguments;

});





parcelRegister("anY5p", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", function () { return $78faa942f71965c2$export$307591e98609eddd; }, function (v) { return $78faa942f71965c2$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $78faa942f71965c2$export$eb3a06aef9e6ee51; }, function (v) { return $78faa942f71965c2$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $78faa942f71965c2$export$b23711c915539651; }, function (v) { return $78faa942f71965c2$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToString", function () { return $78faa942f71965c2$export$80e7718417253a51; }, function (v) { return $78faa942f71965c2$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "version", function () { return $78faa942f71965c2$export$83d89fbfd8236492; }, function (v) { return $78faa942f71965c2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $78faa942f71965c2$export$307591e98609eddd;
var $78faa942f71965c2$export$eb3a06aef9e6ee51;
var $78faa942f71965c2$export$b23711c915539651;
var $78faa942f71965c2$export$80e7718417253a51;
var $78faa942f71965c2$export$83d89fbfd8236492;
'use strict';

var $aivMx = parcelRequire("aivMx");
function $78faa942f71965c2$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $78faa942f71965c2$var$p = Object.prototype.hasOwnProperty, $78faa942f71965c2$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $78faa942f71965c2$var$ha = {}, $78faa942f71965c2$var$ia = {};
function $78faa942f71965c2$var$ja(a) {
    if ($78faa942f71965c2$var$p.call($78faa942f71965c2$var$ia, a)) return !0;
    if ($78faa942f71965c2$var$p.call($78faa942f71965c2$var$ha, a)) return !1;
    if ($78faa942f71965c2$var$fa.test(a)) return $78faa942f71965c2$var$ia[a] = !0;
    $78faa942f71965c2$var$ha[a] = !0;
    return !1;
}
function $78faa942f71965c2$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $78faa942f71965c2$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $78faa942f71965c2$var$t[b] = new $78faa942f71965c2$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $78faa942f71965c2$var$ka = /[\-:]([a-z])/g;
function $78faa942f71965c2$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($78faa942f71965c2$var$ka, $78faa942f71965c2$var$la);
    $78faa942f71965c2$var$t[b] = new $78faa942f71965c2$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($78faa942f71965c2$var$ka, $78faa942f71965c2$var$la);
    $78faa942f71965c2$var$t[b] = new $78faa942f71965c2$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($78faa942f71965c2$var$ka, $78faa942f71965c2$var$la);
    $78faa942f71965c2$var$t[b] = new $78faa942f71965c2$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$78faa942f71965c2$var$t.xlinkHref = new $78faa942f71965c2$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $78faa942f71965c2$var$t[a] = new $78faa942f71965c2$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $78faa942f71965c2$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $78faa942f71965c2$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($78faa942f71965c2$var$u).forEach(function(a) {
    $78faa942f71965c2$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $78faa942f71965c2$var$u[b] = $78faa942f71965c2$var$u[a];
    });
});
var $78faa942f71965c2$var$na = /["'&<>]/;
function $78faa942f71965c2$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $78faa942f71965c2$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $78faa942f71965c2$var$oa = /([A-Z])/g, $78faa942f71965c2$var$pa = /^ms-/, $78faa942f71965c2$var$qa = Array.isArray;
function $78faa942f71965c2$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $78faa942f71965c2$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $78faa942f71965c2$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $78faa942f71965c2$var$w(2, null);
        case "math":
            return $78faa942f71965c2$var$w(3, null);
        case "foreignObject":
            return $78faa942f71965c2$var$w(1, null);
        case "table":
            return $78faa942f71965c2$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $78faa942f71965c2$var$w(5, null);
        case "colgroup":
            return $78faa942f71965c2$var$w(7, null);
        case "tr":
            return $78faa942f71965c2$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $78faa942f71965c2$var$w(1, null) : a;
}
var $78faa942f71965c2$var$sa = new Map;
function $78faa942f71965c2$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($78faa942f71965c2$var$l(62));
    b = !0;
    for(var d in c)if ($78faa942f71965c2$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $78faa942f71965c2$var$v(d);
                f = $78faa942f71965c2$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $78faa942f71965c2$var$sa.get(e);
                void 0 !== g ? e = g : (g = $78faa942f71965c2$var$v(e.replace($78faa942f71965c2$var$oa, "-$1").toLowerCase().replace($78faa942f71965c2$var$pa, "-ms-")), $78faa942f71965c2$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $78faa942f71965c2$var$p.call($78faa942f71965c2$var$u, d) ? "" + f : f + "px" : $78faa942f71965c2$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $78faa942f71965c2$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $78faa942f71965c2$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $78faa942f71965c2$var$t.hasOwnProperty(c) ? $78faa942f71965c2$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
            }
        } else if ($78faa942f71965c2$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $78faa942f71965c2$var$v(d), '"');
        }
    }
}
function $78faa942f71965c2$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($78faa942f71965c2$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($78faa942f71965c2$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $78faa942f71965c2$var$ua(a) {
    var b = "";
    $aivMx.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $78faa942f71965c2$var$va(a, b, c, d) {
    a.push($78faa942f71965c2$var$A(c));
    var f = c = null, e;
    for(e in b)if ($78faa942f71965c2$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $78faa942f71965c2$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $78faa942f71965c2$var$y(a, f, c);
    return "string" === typeof c ? (a.push($78faa942f71965c2$var$v(c)), null) : c;
}
var $78faa942f71965c2$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $78faa942f71965c2$var$xa = new Map;
function $78faa942f71965c2$var$A(a) {
    var b = $78faa942f71965c2$var$xa.get(a);
    if (void 0 === b) {
        if (!$78faa942f71965c2$var$wa.test(a)) throw Error($78faa942f71965c2$var$l(65, a));
        b = "<" + a;
        $78faa942f71965c2$var$xa.set(a, b);
    }
    return b;
}
function $78faa942f71965c2$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($78faa942f71965c2$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($78faa942f71965c2$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $78faa942f71965c2$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $78faa942f71965c2$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($78faa942f71965c2$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($78faa942f71965c2$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $78faa942f71965c2$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $78faa942f71965c2$var$ua(h), $78faa942f71965c2$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $78faa942f71965c2$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($78faa942f71965c2$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($78faa942f71965c2$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(91));
                default:
                    $78faa942f71965c2$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($78faa942f71965c2$var$l(92));
                if ($78faa942f71965c2$var$qa(n) && 1 < n.length) throw Error($78faa942f71965c2$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($78faa942f71965c2$var$v("" + e));
            return null;
        case "input":
            a.push($78faa942f71965c2$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($78faa942f71965c2$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $78faa942f71965c2$var$x(a, d, g, m);
            }
            null !== n ? $78faa942f71965c2$var$x(a, d, "checked", n) : null !== k && $78faa942f71965c2$var$x(a, d, "checked", k);
            null !== e ? $78faa942f71965c2$var$x(a, d, "value", e) : null !== h && $78faa942f71965c2$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($78faa942f71965c2$var$A("menuitem"));
            for(var C in c)if ($78faa942f71965c2$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(400));
                default:
                    $78faa942f71965c2$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($78faa942f71965c2$var$A("title"));
            e = null;
            for(q in c)if ($78faa942f71965c2$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(434));
                default:
                    $78faa942f71965c2$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($78faa942f71965c2$var$A(b));
            g = e = null;
            for(k in c)if ($78faa942f71965c2$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $78faa942f71965c2$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($78faa942f71965c2$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($78faa942f71965c2$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($78faa942f71965c2$var$A(b));
            for(var D in c)if ($78faa942f71965c2$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($78faa942f71965c2$var$l(399, b));
                default:
                    $78faa942f71965c2$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $78faa942f71965c2$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $78faa942f71965c2$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $78faa942f71965c2$var$va(a, c, b, d);
            a.push($78faa942f71965c2$var$A(b));
            g = e = null;
            for(m in c)if ($78faa942f71965c2$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $78faa942f71965c2$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $78faa942f71965c2$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $78faa942f71965c2$var$v(h), '"');
            }
            a.push(">");
            $78faa942f71965c2$var$y(a, g, e);
            return e;
    }
}
function $78faa942f71965c2$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($78faa942f71965c2$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $78faa942f71965c2$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($78faa942f71965c2$var$l(397));
    }
}
function $78faa942f71965c2$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($78faa942f71965c2$var$l(397));
    }
}
var $78faa942f71965c2$var$Ca = /[<\u2028\u2029]/g;
function $78faa942f71965c2$var$Da(a) {
    return JSON.stringify(a).replace($78faa942f71965c2$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $78faa942f71965c2$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $78faa942f71965c2$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($78faa942f71965c2$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($78faa942f71965c2$var$v(b)), a = !0);
    return a;
}
var $78faa942f71965c2$var$B = Object.assign, $78faa942f71965c2$var$Ga = Symbol.for("react.element"), $78faa942f71965c2$var$Ha = Symbol.for("react.portal"), $78faa942f71965c2$var$Ia = Symbol.for("react.fragment"), $78faa942f71965c2$var$Ja = Symbol.for("react.strict_mode"), $78faa942f71965c2$var$Ka = Symbol.for("react.profiler"), $78faa942f71965c2$var$La = Symbol.for("react.provider"), $78faa942f71965c2$var$Ma = Symbol.for("react.context"), $78faa942f71965c2$var$Na = Symbol.for("react.forward_ref"), $78faa942f71965c2$var$Oa = Symbol.for("react.suspense"), $78faa942f71965c2$var$Pa = Symbol.for("react.suspense_list"), $78faa942f71965c2$var$Qa = Symbol.for("react.memo"), $78faa942f71965c2$var$Ra = Symbol.for("react.lazy"), $78faa942f71965c2$var$Sa = Symbol.for("react.scope"), $78faa942f71965c2$var$Ta = Symbol.for("react.debug_trace_mode"), $78faa942f71965c2$var$Ua = Symbol.for("react.legacy_hidden"), $78faa942f71965c2$var$Va = Symbol.for("react.default_value"), $78faa942f71965c2$var$Wa = Symbol.iterator;
function $78faa942f71965c2$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $78faa942f71965c2$var$Ia:
            return "Fragment";
        case $78faa942f71965c2$var$Ha:
            return "Portal";
        case $78faa942f71965c2$var$Ka:
            return "Profiler";
        case $78faa942f71965c2$var$Ja:
            return "StrictMode";
        case $78faa942f71965c2$var$Oa:
            return "Suspense";
        case $78faa942f71965c2$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $78faa942f71965c2$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $78faa942f71965c2$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $78faa942f71965c2$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $78faa942f71965c2$var$Qa:
            return b = a.displayName || null, null !== b ? b : $78faa942f71965c2$var$Xa(a.type) || "Memo";
        case $78faa942f71965c2$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $78faa942f71965c2$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $78faa942f71965c2$var$Ya = {};
function $78faa942f71965c2$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $78faa942f71965c2$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $78faa942f71965c2$var$E = null;
function $78faa942f71965c2$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($78faa942f71965c2$var$l(401));
        } else {
            if (null === c) throw Error($78faa942f71965c2$var$l(401));
            $78faa942f71965c2$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $78faa942f71965c2$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $78faa942f71965c2$var$$a(a);
}
function $78faa942f71965c2$var$ab(a) {
    var b = a.parent;
    null !== b && $78faa942f71965c2$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $78faa942f71965c2$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($78faa942f71965c2$var$l(402));
    a.depth === b.depth ? $78faa942f71965c2$var$F(a, b) : $78faa942f71965c2$var$bb(a, b);
}
function $78faa942f71965c2$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($78faa942f71965c2$var$l(402));
    a.depth === c.depth ? $78faa942f71965c2$var$F(a, c) : $78faa942f71965c2$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $78faa942f71965c2$var$G(a) {
    var b = $78faa942f71965c2$var$E;
    b !== a && (null === b ? $78faa942f71965c2$var$ab(a) : null === a ? $78faa942f71965c2$var$$a(b) : b.depth === a.depth ? $78faa942f71965c2$var$F(b, a) : b.depth > a.depth ? $78faa942f71965c2$var$bb(b, a) : $78faa942f71965c2$var$cb(b, a), $78faa942f71965c2$var$E = a);
}
var $78faa942f71965c2$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $78faa942f71965c2$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $78faa942f71965c2$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $78faa942f71965c2$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $78faa942f71965c2$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $78faa942f71965c2$var$B({}, e, h)) : $78faa942f71965c2$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $78faa942f71965c2$var$fb = {
    id: 1,
    overflow: ""
};
function $78faa942f71965c2$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $78faa942f71965c2$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $78faa942f71965c2$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $78faa942f71965c2$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $78faa942f71965c2$var$H = Math.clz32 ? Math.clz32 : $78faa942f71965c2$var$hb, $78faa942f71965c2$var$ib = Math.log, $78faa942f71965c2$var$jb = Math.LN2;
function $78faa942f71965c2$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($78faa942f71965c2$var$ib(a) / $78faa942f71965c2$var$jb | 0) | 0;
}
function $78faa942f71965c2$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $78faa942f71965c2$var$lb = "function" === typeof Object.is ? Object.is : $78faa942f71965c2$var$kb, $78faa942f71965c2$var$I = null, $78faa942f71965c2$var$ob = null, $78faa942f71965c2$var$J = null, $78faa942f71965c2$var$K = null, $78faa942f71965c2$var$L = !1, $78faa942f71965c2$var$M = !1, $78faa942f71965c2$var$N = 0, $78faa942f71965c2$var$O = null, $78faa942f71965c2$var$P = 0;
function $78faa942f71965c2$var$Q() {
    if (null === $78faa942f71965c2$var$I) throw Error($78faa942f71965c2$var$l(321));
    return $78faa942f71965c2$var$I;
}
function $78faa942f71965c2$var$pb() {
    if (0 < $78faa942f71965c2$var$P) throw Error($78faa942f71965c2$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $78faa942f71965c2$var$qb() {
    null === $78faa942f71965c2$var$K ? null === $78faa942f71965c2$var$J ? ($78faa942f71965c2$var$L = !1, $78faa942f71965c2$var$J = $78faa942f71965c2$var$K = $78faa942f71965c2$var$pb()) : ($78faa942f71965c2$var$L = !0, $78faa942f71965c2$var$K = $78faa942f71965c2$var$J) : null === $78faa942f71965c2$var$K.next ? ($78faa942f71965c2$var$L = !1, $78faa942f71965c2$var$K = $78faa942f71965c2$var$K.next = $78faa942f71965c2$var$pb()) : ($78faa942f71965c2$var$L = !0, $78faa942f71965c2$var$K = $78faa942f71965c2$var$K.next);
    return $78faa942f71965c2$var$K;
}
function $78faa942f71965c2$var$rb() {
    $78faa942f71965c2$var$ob = $78faa942f71965c2$var$I = null;
    $78faa942f71965c2$var$M = !1;
    $78faa942f71965c2$var$J = null;
    $78faa942f71965c2$var$P = 0;
    $78faa942f71965c2$var$K = $78faa942f71965c2$var$O = null;
}
function $78faa942f71965c2$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $78faa942f71965c2$var$tb(a, b, c) {
    $78faa942f71965c2$var$I = $78faa942f71965c2$var$Q();
    $78faa942f71965c2$var$K = $78faa942f71965c2$var$qb();
    if ($78faa942f71965c2$var$L) {
        var d = $78faa942f71965c2$var$K.queue;
        b = d.dispatch;
        if (null !== $78faa942f71965c2$var$O && (c = $78faa942f71965c2$var$O.get(d), void 0 !== c)) {
            $78faa942f71965c2$var$O.delete(d);
            d = $78faa942f71965c2$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $78faa942f71965c2$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $78faa942f71965c2$var$K.memoizedState,
            b
        ];
    }
    a = a === $78faa942f71965c2$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $78faa942f71965c2$var$K.memoizedState = a;
    a = $78faa942f71965c2$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $78faa942f71965c2$var$ub.bind(null, $78faa942f71965c2$var$I, a);
    return [
        $78faa942f71965c2$var$K.memoizedState,
        a
    ];
}
function $78faa942f71965c2$var$vb(a, b) {
    $78faa942f71965c2$var$I = $78faa942f71965c2$var$Q();
    $78faa942f71965c2$var$K = $78faa942f71965c2$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $78faa942f71965c2$var$K) {
        var c = $78faa942f71965c2$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$78faa942f71965c2$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $78faa942f71965c2$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $78faa942f71965c2$var$ub(a, b, c) {
    if (25 <= $78faa942f71965c2$var$P) throw Error($78faa942f71965c2$var$l(301));
    if (a === $78faa942f71965c2$var$I) {
        if ($78faa942f71965c2$var$M = !0, a = {
            action: c,
            next: null
        }, null === $78faa942f71965c2$var$O && ($78faa942f71965c2$var$O = new Map), c = $78faa942f71965c2$var$O.get(b), void 0 === c) $78faa942f71965c2$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $78faa942f71965c2$var$wb() {
    throw Error($78faa942f71965c2$var$l(394));
}
function $78faa942f71965c2$var$R() {}
var $78faa942f71965c2$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $78faa942f71965c2$var$Q();
        return a._currentValue2;
    },
    useMemo: $78faa942f71965c2$var$vb,
    useReducer: $78faa942f71965c2$var$tb,
    useRef: function(a) {
        $78faa942f71965c2$var$I = $78faa942f71965c2$var$Q();
        $78faa942f71965c2$var$K = $78faa942f71965c2$var$qb();
        var b = $78faa942f71965c2$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $78faa942f71965c2$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $78faa942f71965c2$var$tb($78faa942f71965c2$var$sb, a);
    },
    useInsertionEffect: $78faa942f71965c2$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $78faa942f71965c2$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $78faa942f71965c2$var$R,
    useEffect: $78faa942f71965c2$var$R,
    useDebugValue: $78faa942f71965c2$var$R,
    useDeferredValue: function(a) {
        $78faa942f71965c2$var$Q();
        return a;
    },
    useTransition: function() {
        $78faa942f71965c2$var$Q();
        return [
            !1,
            $78faa942f71965c2$var$wb
        ];
    },
    useId: function() {
        var a = $78faa942f71965c2$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $78faa942f71965c2$var$H(a) - 1)).toString(32) + b;
        var c = $78faa942f71965c2$var$S;
        if (null === c) throw Error($78faa942f71965c2$var$l(404));
        b = $78faa942f71965c2$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $78faa942f71965c2$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($78faa942f71965c2$var$l(407));
        return c();
    }
}, $78faa942f71965c2$var$S = null, $78faa942f71965c2$var$yb = $aivMx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $78faa942f71965c2$var$zb(a) {
    console.error(a);
    return null;
}
function $78faa942f71965c2$var$T() {}
function $78faa942f71965c2$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $78faa942f71965c2$var$zb : f,
        onAllReady: void 0 === e ? $78faa942f71965c2$var$T : e,
        onShellReady: void 0 === g ? $78faa942f71965c2$var$T : g,
        onShellError: void 0 === h ? $78faa942f71965c2$var$T : h,
        onFatalError: void 0 === k ? $78faa942f71965c2$var$T : k
    };
    c = $78faa942f71965c2$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $78faa942f71965c2$var$Bb(b, a, null, c, n, $78faa942f71965c2$var$Ya, null, $78faa942f71965c2$var$fb);
    m.push(a);
    return b;
}
function $78faa942f71965c2$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $78faa942f71965c2$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $78faa942f71965c2$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $78faa942f71965c2$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $78faa942f71965c2$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $78faa942f71965c2$var$Db(a, b, c, d, f) {
    $78faa942f71965c2$var$I = {};
    $78faa942f71965c2$var$ob = b;
    $78faa942f71965c2$var$N = 0;
    for(a = c(d, f); $78faa942f71965c2$var$M;)$78faa942f71965c2$var$M = !1, $78faa942f71965c2$var$N = 0, $78faa942f71965c2$var$P += 1, $78faa942f71965c2$var$K = null, a = c(d, f);
    $78faa942f71965c2$var$rb();
    return a;
}
function $78faa942f71965c2$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($78faa942f71965c2$var$l(108, $78faa942f71965c2$var$Xa(d) || "Unknown", h));
            d = $78faa942f71965c2$var$B({}, g, c);
        }
        b.legacyContext = d;
        $78faa942f71965c2$var$X(a, b, f);
        b.legacyContext = g;
    } else $78faa942f71965c2$var$X(a, b, f);
}
function $78faa942f71965c2$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $78faa942f71965c2$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $78faa942f71965c2$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $78faa942f71965c2$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $78faa942f71965c2$var$eb(e, c, d, f);
            $78faa942f71965c2$var$Eb(a, b, e, c);
        } else {
            e = $78faa942f71965c2$var$Za(c, b.legacyContext);
            f = $78faa942f71965c2$var$Db(a, b, c, d, e);
            var g = 0 !== $78faa942f71965c2$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $78faa942f71965c2$var$eb(f, c, d, e), $78faa942f71965c2$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $78faa942f71965c2$var$gb(d, 1, 0);
                try {
                    $78faa942f71965c2$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $78faa942f71965c2$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $78faa942f71965c2$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $78faa942f71965c2$var$ra(g, c, d);
        $78faa942f71965c2$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $78faa942f71965c2$var$Ua:
            case $78faa942f71965c2$var$Ta:
            case $78faa942f71965c2$var$Ja:
            case $78faa942f71965c2$var$Ka:
            case $78faa942f71965c2$var$Ia:
                $78faa942f71965c2$var$X(a, b, d.children);
                return;
            case $78faa942f71965c2$var$Pa:
                $78faa942f71965c2$var$X(a, b, d.children);
                return;
            case $78faa942f71965c2$var$Sa:
                throw Error($78faa942f71965c2$var$l(343));
            case $78faa942f71965c2$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $78faa942f71965c2$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $78faa942f71965c2$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($78faa942f71965c2$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $78faa942f71965c2$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $78faa942f71965c2$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $78faa942f71965c2$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $78faa942f71965c2$var$Na:
                d = $78faa942f71965c2$var$Db(a, b, c.render, d, f);
                if (0 !== $78faa942f71965c2$var$N) {
                    c = b.treeContext;
                    b.treeContext = $78faa942f71965c2$var$gb(c, 1, 0);
                    try {
                        $78faa942f71965c2$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $78faa942f71965c2$var$X(a, b, d);
                return;
            case $78faa942f71965c2$var$Qa:
                c = c.type;
                d = $78faa942f71965c2$var$Fb(c, d);
                $78faa942f71965c2$var$Gb(a, b, c, d, f);
                return;
            case $78faa942f71965c2$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $78faa942f71965c2$var$E;
                $78faa942f71965c2$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $78faa942f71965c2$var$X(a, b, f);
                a = $78faa942f71965c2$var$E;
                if (null === a) throw Error($78faa942f71965c2$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $78faa942f71965c2$var$Va ? a.context._defaultValue : d;
                a = $78faa942f71965c2$var$E = a.parent;
                b.context = a;
                return;
            case $78faa942f71965c2$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $78faa942f71965c2$var$X(a, b, d);
                return;
            case $78faa942f71965c2$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $78faa942f71965c2$var$Fb(c, d);
                $78faa942f71965c2$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($78faa942f71965c2$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $78faa942f71965c2$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $78faa942f71965c2$var$Ga:
                $78faa942f71965c2$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $78faa942f71965c2$var$Ha:
                throw Error($78faa942f71965c2$var$l(257));
            case $78faa942f71965c2$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $78faa942f71965c2$var$X(a, b, c);
                return;
        }
        if ($78faa942f71965c2$var$qa(c)) {
            $78faa942f71965c2$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $78faa942f71965c2$var$Wa && c[$78faa942f71965c2$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $78faa942f71965c2$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($78faa942f71965c2$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $78faa942f71965c2$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $78faa942f71965c2$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $78faa942f71965c2$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $78faa942f71965c2$var$gb(e, d, f);
        try {
            $78faa942f71965c2$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $78faa942f71965c2$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $78faa942f71965c2$var$X(a, b, c);
    } catch (k) {
        if ($78faa942f71965c2$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $78faa942f71965c2$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $78faa942f71965c2$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $78faa942f71965c2$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $78faa942f71965c2$var$G(e), k;
    }
}
function $78faa942f71965c2$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $78faa942f71965c2$var$Kb(this, b, a);
}
function $78faa942f71965c2$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($78faa942f71965c2$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $78faa942f71965c2$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $78faa942f71965c2$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $78faa942f71965c2$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $78faa942f71965c2$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($78faa942f71965c2$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $78faa942f71965c2$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $78faa942f71965c2$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($78faa942f71965c2$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($78faa942f71965c2$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $78faa942f71965c2$var$Cb(a) {
    if (2 !== a.status) {
        var b = $78faa942f71965c2$var$E, c = $78faa942f71965c2$var$yb.current;
        $78faa942f71965c2$var$yb.current = $78faa942f71965c2$var$xb;
        var d = $78faa942f71965c2$var$S;
        $78faa942f71965c2$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $78faa942f71965c2$var$G(g.context);
                    try {
                        $78faa942f71965c2$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $78faa942f71965c2$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($78faa942f71965c2$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $78faa942f71965c2$var$V(h, q);
                            null === n ? $78faa942f71965c2$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $78faa942f71965c2$var$Mb(a, a.destination);
        } catch (z) {
            $78faa942f71965c2$var$V(a, z), $78faa942f71965c2$var$W(a, z);
        } finally{
            $78faa942f71965c2$var$S = d, $78faa942f71965c2$var$yb.current = c, c === $78faa942f71965c2$var$xb && $78faa942f71965c2$var$G(b);
        }
    }
}
function $78faa942f71965c2$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $78faa942f71965c2$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($78faa942f71965c2$var$l(390));
    }
}
function $78faa942f71965c2$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $78faa942f71965c2$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $78faa942f71965c2$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $78faa942f71965c2$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $78faa942f71965c2$var$za(b, a.responseState, d);
        $78faa942f71965c2$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $78faa942f71965c2$var$za(b, a.responseState, d.id), $78faa942f71965c2$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($78faa942f71965c2$var$l(391));
    $78faa942f71965c2$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $78faa942f71965c2$var$Ob(a, b, c) {
    $78faa942f71965c2$var$Aa(b, a.responseState, c.formatContext, c.id);
    $78faa942f71965c2$var$Nb(a, b, c);
    return $78faa942f71965c2$var$Ba(b, c.formatContext);
}
function $78faa942f71965c2$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$78faa942f71965c2$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($78faa942f71965c2$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $78faa942f71965c2$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($78faa942f71965c2$var$l(392));
        return $78faa942f71965c2$var$Ob(a, b, d);
    }
    $78faa942f71965c2$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $78faa942f71965c2$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $78faa942f71965c2$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($78faa942f71965c2$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $78faa942f71965c2$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $78faa942f71965c2$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $78faa942f71965c2$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$78faa942f71965c2$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$78faa942f71965c2$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$78faa942f71965c2$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $78faa942f71965c2$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $78faa942f71965c2$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $78faa942f71965c2$var$Mb(a, a.destination);
    } catch (d) {
        $78faa942f71965c2$var$V(a, d), $78faa942f71965c2$var$W(a, d);
    }
}
function $78faa942f71965c2$var$Sb() {}
function $78faa942f71965c2$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $78faa942f71965c2$var$Ab(a, $78faa942f71965c2$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $78faa942f71965c2$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $78faa942f71965c2$var$Cb(a);
    $78faa942f71965c2$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $78faa942f71965c2$var$Mb(a, h);
        } catch (m) {
            $78faa942f71965c2$var$V(a, m), $78faa942f71965c2$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($78faa942f71965c2$var$l(426));
    return g;
}
$78faa942f71965c2$export$307591e98609eddd = function() {
    throw Error($78faa942f71965c2$var$l(207));
};
$78faa942f71965c2$export$eb3a06aef9e6ee51 = function(a, b) {
    return $78faa942f71965c2$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$78faa942f71965c2$export$b23711c915539651 = function() {
    throw Error($78faa942f71965c2$var$l(208));
};
$78faa942f71965c2$export$80e7718417253a51 = function(a, b) {
    return $78faa942f71965c2$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$78faa942f71965c2$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("3c06z", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", function () { return $253292e9913a6593$export$7020a3240b287705; }, function (v) { return $253292e9913a6593$export$7020a3240b287705 = v; });
$parcel$export(module.exports, "version", function () { return $253292e9913a6593$export$83d89fbfd8236492; }, function (v) { return $253292e9913a6593$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $253292e9913a6593$export$7020a3240b287705;
var $253292e9913a6593$export$83d89fbfd8236492;
'use strict';

var $aivMx = parcelRequire("aivMx");
function $253292e9913a6593$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $253292e9913a6593$var$l = null, $253292e9913a6593$var$n = 0;
function $253292e9913a6593$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $253292e9913a6593$var$n && (a.enqueue(new Uint8Array($253292e9913a6593$var$l.buffer, 0, $253292e9913a6593$var$n)), $253292e9913a6593$var$l = new Uint8Array(512), $253292e9913a6593$var$n = 0), a.enqueue(b);
        else {
            var c = $253292e9913a6593$var$l.length - $253292e9913a6593$var$n;
            c < b.length && (0 === c ? a.enqueue($253292e9913a6593$var$l) : ($253292e9913a6593$var$l.set(b.subarray(0, c), $253292e9913a6593$var$n), a.enqueue($253292e9913a6593$var$l), b = b.subarray(c)), $253292e9913a6593$var$l = new Uint8Array(512), $253292e9913a6593$var$n = 0);
            $253292e9913a6593$var$l.set(b, $253292e9913a6593$var$n);
            $253292e9913a6593$var$n += b.length;
        }
    }
}
function $253292e9913a6593$var$t(a, b) {
    $253292e9913a6593$var$p(a, b);
    return !0;
}
function $253292e9913a6593$var$ba(a) {
    $253292e9913a6593$var$l && 0 < $253292e9913a6593$var$n && (a.enqueue(new Uint8Array($253292e9913a6593$var$l.buffer, 0, $253292e9913a6593$var$n)), $253292e9913a6593$var$l = null, $253292e9913a6593$var$n = 0);
}
var $253292e9913a6593$var$ca = new TextEncoder;
function $253292e9913a6593$var$u(a) {
    return $253292e9913a6593$var$ca.encode(a);
}
function $253292e9913a6593$var$w(a) {
    return $253292e9913a6593$var$ca.encode(a);
}
function $253292e9913a6593$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $253292e9913a6593$var$x = Object.prototype.hasOwnProperty, $253292e9913a6593$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $253292e9913a6593$var$fa = {}, $253292e9913a6593$var$ha = {};
function $253292e9913a6593$var$ia(a) {
    if ($253292e9913a6593$var$x.call($253292e9913a6593$var$ha, a)) return !0;
    if ($253292e9913a6593$var$x.call($253292e9913a6593$var$fa, a)) return !1;
    if ($253292e9913a6593$var$ea.test(a)) return $253292e9913a6593$var$ha[a] = !0;
    $253292e9913a6593$var$fa[a] = !0;
    return !1;
}
function $253292e9913a6593$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $253292e9913a6593$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $253292e9913a6593$var$z[b] = new $253292e9913a6593$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $253292e9913a6593$var$ja = /[\-:]([a-z])/g;
function $253292e9913a6593$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($253292e9913a6593$var$ja, $253292e9913a6593$var$ka);
    $253292e9913a6593$var$z[b] = new $253292e9913a6593$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($253292e9913a6593$var$ja, $253292e9913a6593$var$ka);
    $253292e9913a6593$var$z[b] = new $253292e9913a6593$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($253292e9913a6593$var$ja, $253292e9913a6593$var$ka);
    $253292e9913a6593$var$z[b] = new $253292e9913a6593$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$253292e9913a6593$var$z.xlinkHref = new $253292e9913a6593$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $253292e9913a6593$var$z[a] = new $253292e9913a6593$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $253292e9913a6593$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $253292e9913a6593$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($253292e9913a6593$var$B).forEach(function(a) {
    $253292e9913a6593$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $253292e9913a6593$var$B[b] = $253292e9913a6593$var$B[a];
    });
});
var $253292e9913a6593$var$oa = /["'&<>]/;
function $253292e9913a6593$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $253292e9913a6593$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $253292e9913a6593$var$pa = /([A-Z])/g, $253292e9913a6593$var$qa = /^ms-/, $253292e9913a6593$var$ra = Array.isArray, $253292e9913a6593$var$sa = $253292e9913a6593$var$w("<script>"), $253292e9913a6593$var$ta = $253292e9913a6593$var$w("\x3c/script>"), $253292e9913a6593$var$ua = $253292e9913a6593$var$w('<script src="'), $253292e9913a6593$var$va = $253292e9913a6593$var$w('<script type="module" src="'), $253292e9913a6593$var$wa = $253292e9913a6593$var$w('" async="">\x3c/script>'), $253292e9913a6593$var$xa = /(<\/|<)(s)(cript)/gi;
function $253292e9913a6593$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $253292e9913a6593$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $253292e9913a6593$var$sa : $253292e9913a6593$var$w('<script nonce="' + $253292e9913a6593$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $253292e9913a6593$var$u(("" + c).replace($253292e9913a6593$var$xa, $253292e9913a6593$var$ya)), $253292e9913a6593$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($253292e9913a6593$var$ua, $253292e9913a6593$var$u($253292e9913a6593$var$C(d[c])), $253292e9913a6593$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($253292e9913a6593$var$va, $253292e9913a6593$var$u($253292e9913a6593$var$C(f[d])), $253292e9913a6593$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $253292e9913a6593$var$w(a + "P:"),
        segmentPrefix: $253292e9913a6593$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $253292e9913a6593$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $253292e9913a6593$var$Aa(a) {
    return $253292e9913a6593$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $253292e9913a6593$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $253292e9913a6593$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $253292e9913a6593$var$D(2, null);
        case "math":
            return $253292e9913a6593$var$D(3, null);
        case "foreignObject":
            return $253292e9913a6593$var$D(1, null);
        case "table":
            return $253292e9913a6593$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $253292e9913a6593$var$D(5, null);
        case "colgroup":
            return $253292e9913a6593$var$D(7, null);
        case "tr":
            return $253292e9913a6593$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $253292e9913a6593$var$D(1, null) : a;
}
var $253292e9913a6593$var$Ca = $253292e9913a6593$var$w("\x3c!-- --\x3e");
function $253292e9913a6593$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($253292e9913a6593$var$Ca);
    a.push($253292e9913a6593$var$u($253292e9913a6593$var$C(b)));
    return !0;
}
var $253292e9913a6593$var$Ea = new Map, $253292e9913a6593$var$Fa = $253292e9913a6593$var$w(' style="'), $253292e9913a6593$var$Ga = $253292e9913a6593$var$w(":"), $253292e9913a6593$var$Ha = $253292e9913a6593$var$w(";");
function $253292e9913a6593$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($253292e9913a6593$var$k(62));
    b = !0;
    for(var d in c)if ($253292e9913a6593$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $253292e9913a6593$var$u($253292e9913a6593$var$C(d));
                f = $253292e9913a6593$var$u($253292e9913a6593$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $253292e9913a6593$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $253292e9913a6593$var$w($253292e9913a6593$var$C(e.replace($253292e9913a6593$var$pa, "-$1").toLowerCase().replace($253292e9913a6593$var$qa, "-ms-"))), $253292e9913a6593$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $253292e9913a6593$var$x.call($253292e9913a6593$var$B, d) ? $253292e9913a6593$var$u("" + f) : $253292e9913a6593$var$u(f + "px") : $253292e9913a6593$var$u($253292e9913a6593$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($253292e9913a6593$var$Fa, e, $253292e9913a6593$var$Ga, f)) : a.push($253292e9913a6593$var$Ha, e, $253292e9913a6593$var$Ga, f);
        }
    }
    b || a.push($253292e9913a6593$var$E);
}
var $253292e9913a6593$var$H = $253292e9913a6593$var$w(" "), $253292e9913a6593$var$I = $253292e9913a6593$var$w('="'), $253292e9913a6593$var$E = $253292e9913a6593$var$w('"'), $253292e9913a6593$var$Ja = $253292e9913a6593$var$w('=""');
function $253292e9913a6593$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $253292e9913a6593$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $253292e9913a6593$var$z.hasOwnProperty(c) ? $253292e9913a6593$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $253292e9913a6593$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$Ja) : !1 !== d && a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($253292e9913a6593$var$H, c, $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
            }
        } else if ($253292e9913a6593$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($253292e9913a6593$var$H, $253292e9913a6593$var$u(c), $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(d)), $253292e9913a6593$var$E);
        }
    }
}
var $253292e9913a6593$var$K = $253292e9913a6593$var$w(">"), $253292e9913a6593$var$Ka = $253292e9913a6593$var$w("/>");
function $253292e9913a6593$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($253292e9913a6593$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($253292e9913a6593$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($253292e9913a6593$var$u("" + b));
    }
}
function $253292e9913a6593$var$La(a) {
    var b = "";
    $aivMx.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $253292e9913a6593$var$Ma = $253292e9913a6593$var$w(' selected=""');
function $253292e9913a6593$var$Na(a, b, c, d) {
    a.push($253292e9913a6593$var$M(c));
    var f = c = null, e;
    for(e in b)if ($253292e9913a6593$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $253292e9913a6593$var$J(a, d, e, g);
        }
    }
    a.push($253292e9913a6593$var$K);
    $253292e9913a6593$var$L(a, f, c);
    return "string" === typeof c ? (a.push($253292e9913a6593$var$u($253292e9913a6593$var$C(c))), null) : c;
}
var $253292e9913a6593$var$Oa = $253292e9913a6593$var$w("\n"), $253292e9913a6593$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $253292e9913a6593$var$Qa = new Map;
function $253292e9913a6593$var$M(a) {
    var b = $253292e9913a6593$var$Qa.get(a);
    if (void 0 === b) {
        if (!$253292e9913a6593$var$Pa.test(a)) throw Error($253292e9913a6593$var$k(65, a));
        b = $253292e9913a6593$var$w("<" + a);
        $253292e9913a6593$var$Qa.set(a, b);
    }
    return b;
}
var $253292e9913a6593$var$Ra = $253292e9913a6593$var$w("<!DOCTYPE html>");
function $253292e9913a6593$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($253292e9913a6593$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($253292e9913a6593$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $253292e9913a6593$var$J(a, d, r, h);
                }
            }
            a.push($253292e9913a6593$var$K);
            $253292e9913a6593$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($253292e9913a6593$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($253292e9913a6593$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $253292e9913a6593$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $253292e9913a6593$var$La(h), $253292e9913a6593$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($253292e9913a6593$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($253292e9913a6593$var$Ma);
            } else q && a.push($253292e9913a6593$var$Ma);
            a.push($253292e9913a6593$var$K);
            $253292e9913a6593$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($253292e9913a6593$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($253292e9913a6593$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(91));
                default:
                    $253292e9913a6593$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($253292e9913a6593$var$K);
            if (null != r) {
                if (null != e) throw Error($253292e9913a6593$var$k(92));
                if ($253292e9913a6593$var$ra(r) && 1 < r.length) throw Error($253292e9913a6593$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($253292e9913a6593$var$Oa);
            null !== e && a.push($253292e9913a6593$var$u($253292e9913a6593$var$C("" + e)));
            return null;
        case "input":
            a.push($253292e9913a6593$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($253292e9913a6593$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $253292e9913a6593$var$J(a, d, g, q);
            }
            null !== r ? $253292e9913a6593$var$J(a, d, "checked", r) : null !== m && $253292e9913a6593$var$J(a, d, "checked", m);
            null !== e ? $253292e9913a6593$var$J(a, d, "value", e) : null !== h && $253292e9913a6593$var$J(a, d, "value", h);
            a.push($253292e9913a6593$var$Ka);
            return null;
        case "menuitem":
            a.push($253292e9913a6593$var$M("menuitem"));
            for(var A in c)if ($253292e9913a6593$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(400));
                default:
                    $253292e9913a6593$var$J(a, d, A, e);
            }
            a.push($253292e9913a6593$var$K);
            return null;
        case "title":
            a.push($253292e9913a6593$var$M("title"));
            e = null;
            for(v in c)if ($253292e9913a6593$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(434));
                default:
                    $253292e9913a6593$var$J(a, d, v, g);
            }
            a.push($253292e9913a6593$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($253292e9913a6593$var$M(b));
            g = e = null;
            for(m in c)if ($253292e9913a6593$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $253292e9913a6593$var$J(a, d, m, h);
            }
            a.push($253292e9913a6593$var$K);
            if (null != g) {
                if (null != e) throw Error($253292e9913a6593$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($253292e9913a6593$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($253292e9913a6593$var$Oa, $253292e9913a6593$var$u(c)) : a.push($253292e9913a6593$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($253292e9913a6593$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($253292e9913a6593$var$M(b));
            for(var F in c)if ($253292e9913a6593$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($253292e9913a6593$var$k(399, b));
                default:
                    $253292e9913a6593$var$J(a, d, F, e);
            }
            a.push($253292e9913a6593$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $253292e9913a6593$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($253292e9913a6593$var$Ra), $253292e9913a6593$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $253292e9913a6593$var$Na(a, c, b, d);
            a.push($253292e9913a6593$var$M(b));
            g = e = null;
            for(q in c)if ($253292e9913a6593$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $253292e9913a6593$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $253292e9913a6593$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($253292e9913a6593$var$H, $253292e9913a6593$var$u(q), $253292e9913a6593$var$I, $253292e9913a6593$var$u($253292e9913a6593$var$C(h)), $253292e9913a6593$var$E);
            }
            a.push($253292e9913a6593$var$K);
            $253292e9913a6593$var$L(a, g, e);
            return e;
    }
}
var $253292e9913a6593$var$Ta = $253292e9913a6593$var$w("</"), $253292e9913a6593$var$Ua = $253292e9913a6593$var$w(">"), $253292e9913a6593$var$Va = $253292e9913a6593$var$w('<template id="'), $253292e9913a6593$var$Wa = $253292e9913a6593$var$w('"></template>'), $253292e9913a6593$var$Xa = $253292e9913a6593$var$w("\x3c!--$--\x3e"), $253292e9913a6593$var$Ya = $253292e9913a6593$var$w('\x3c!--$?--\x3e<template id="'), $253292e9913a6593$var$Za = $253292e9913a6593$var$w('"></template>'), $253292e9913a6593$var$$a = $253292e9913a6593$var$w("\x3c!--$!--\x3e"), $253292e9913a6593$var$ab = $253292e9913a6593$var$w("\x3c!--/$--\x3e"), $253292e9913a6593$var$bb = $253292e9913a6593$var$w("<template"), $253292e9913a6593$var$cb = $253292e9913a6593$var$w('"'), $253292e9913a6593$var$db = $253292e9913a6593$var$w(' data-dgst="');
$253292e9913a6593$var$w(' data-msg="');
$253292e9913a6593$var$w(' data-stck="');
var $253292e9913a6593$var$eb = $253292e9913a6593$var$w("></template>");
function $253292e9913a6593$var$fb(a, b, c) {
    $253292e9913a6593$var$p(a, $253292e9913a6593$var$Ya);
    if (null === c) throw Error($253292e9913a6593$var$k(395));
    $253292e9913a6593$var$p(a, c);
    return $253292e9913a6593$var$t(a, $253292e9913a6593$var$Za);
}
var $253292e9913a6593$var$gb = $253292e9913a6593$var$w('<div hidden id="'), $253292e9913a6593$var$hb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$ib = $253292e9913a6593$var$w("</div>"), $253292e9913a6593$var$jb = $253292e9913a6593$var$w('<svg aria-hidden="true" style="display:none" id="'), $253292e9913a6593$var$kb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$lb = $253292e9913a6593$var$w("</svg>"), $253292e9913a6593$var$mb = $253292e9913a6593$var$w('<math aria-hidden="true" style="display:none" id="'), $253292e9913a6593$var$nb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$ob = $253292e9913a6593$var$w("</math>"), $253292e9913a6593$var$pb = $253292e9913a6593$var$w('<table hidden id="'), $253292e9913a6593$var$qb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$rb = $253292e9913a6593$var$w("</table>"), $253292e9913a6593$var$sb = $253292e9913a6593$var$w('<table hidden><tbody id="'), $253292e9913a6593$var$tb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$ub = $253292e9913a6593$var$w("</tbody></table>"), $253292e9913a6593$var$vb = $253292e9913a6593$var$w('<table hidden><tr id="'), $253292e9913a6593$var$wb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$xb = $253292e9913a6593$var$w("</tr></table>"), $253292e9913a6593$var$yb = $253292e9913a6593$var$w('<table hidden><colgroup id="'), $253292e9913a6593$var$zb = $253292e9913a6593$var$w('">'), $253292e9913a6593$var$Ab = $253292e9913a6593$var$w("</colgroup></table>");
function $253292e9913a6593$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$gb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$hb);
        case 2:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$jb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$kb);
        case 3:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$mb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$nb);
        case 4:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$pb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$qb);
        case 5:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$sb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$tb);
        case 6:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$vb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$wb);
        case 7:
            return $253292e9913a6593$var$p(a, $253292e9913a6593$var$yb), $253292e9913a6593$var$p(a, b.segmentPrefix), $253292e9913a6593$var$p(a, $253292e9913a6593$var$u(d.toString(16))), $253292e9913a6593$var$t(a, $253292e9913a6593$var$zb);
        default:
            throw Error($253292e9913a6593$var$k(397));
    }
}
function $253292e9913a6593$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$ib);
        case 2:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$lb);
        case 3:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$ob);
        case 4:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$rb);
        case 5:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$ub);
        case 6:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$xb);
        case 7:
            return $253292e9913a6593$var$t(a, $253292e9913a6593$var$Ab);
        default:
            throw Error($253292e9913a6593$var$k(397));
    }
}
var $253292e9913a6593$var$Db = $253292e9913a6593$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $253292e9913a6593$var$Eb = $253292e9913a6593$var$w('$RS("'), $253292e9913a6593$var$Gb = $253292e9913a6593$var$w('","'), $253292e9913a6593$var$Hb = $253292e9913a6593$var$w('")\x3c/script>'), $253292e9913a6593$var$Ib = $253292e9913a6593$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $253292e9913a6593$var$Jb = $253292e9913a6593$var$w('$RC("'), $253292e9913a6593$var$Kb = $253292e9913a6593$var$w('","'), $253292e9913a6593$var$Lb = $253292e9913a6593$var$w('")\x3c/script>'), $253292e9913a6593$var$Mb = $253292e9913a6593$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $253292e9913a6593$var$Nb = $253292e9913a6593$var$w('$RX("'), $253292e9913a6593$var$Ob = $253292e9913a6593$var$w('"'), $253292e9913a6593$var$Pb = $253292e9913a6593$var$w(")\x3c/script>"), $253292e9913a6593$var$Qb = $253292e9913a6593$var$w(","), $253292e9913a6593$var$Rb = /[<\u2028\u2029]/g;
function $253292e9913a6593$var$Sb(a) {
    return JSON.stringify(a).replace($253292e9913a6593$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $253292e9913a6593$var$N = Object.assign, $253292e9913a6593$var$Tb = Symbol.for("react.element"), $253292e9913a6593$var$Ub = Symbol.for("react.portal"), $253292e9913a6593$var$Vb = Symbol.for("react.fragment"), $253292e9913a6593$var$Wb = Symbol.for("react.strict_mode"), $253292e9913a6593$var$Xb = Symbol.for("react.profiler"), $253292e9913a6593$var$Yb = Symbol.for("react.provider"), $253292e9913a6593$var$Zb = Symbol.for("react.context"), $253292e9913a6593$var$$b = Symbol.for("react.forward_ref"), $253292e9913a6593$var$ac = Symbol.for("react.suspense"), $253292e9913a6593$var$bc = Symbol.for("react.suspense_list"), $253292e9913a6593$var$cc = Symbol.for("react.memo"), $253292e9913a6593$var$dc = Symbol.for("react.lazy"), $253292e9913a6593$var$ec = Symbol.for("react.scope"), $253292e9913a6593$var$fc = Symbol.for("react.debug_trace_mode"), $253292e9913a6593$var$gc = Symbol.for("react.legacy_hidden"), $253292e9913a6593$var$hc = Symbol.for("react.default_value"), $253292e9913a6593$var$ic = Symbol.iterator;
function $253292e9913a6593$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $253292e9913a6593$var$Vb:
            return "Fragment";
        case $253292e9913a6593$var$Ub:
            return "Portal";
        case $253292e9913a6593$var$Xb:
            return "Profiler";
        case $253292e9913a6593$var$Wb:
            return "StrictMode";
        case $253292e9913a6593$var$ac:
            return "Suspense";
        case $253292e9913a6593$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $253292e9913a6593$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $253292e9913a6593$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $253292e9913a6593$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $253292e9913a6593$var$cc:
            return b = a.displayName || null, null !== b ? b : $253292e9913a6593$var$jc(a.type) || "Memo";
        case $253292e9913a6593$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $253292e9913a6593$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $253292e9913a6593$var$kc = {};
function $253292e9913a6593$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $253292e9913a6593$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $253292e9913a6593$var$O = null;
function $253292e9913a6593$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($253292e9913a6593$var$k(401));
        } else {
            if (null === c) throw Error($253292e9913a6593$var$k(401));
            $253292e9913a6593$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $253292e9913a6593$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $253292e9913a6593$var$mc(a);
}
function $253292e9913a6593$var$nc(a) {
    var b = a.parent;
    null !== b && $253292e9913a6593$var$nc(b);
    a.context._currentValue = a.value;
}
function $253292e9913a6593$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($253292e9913a6593$var$k(402));
    a.depth === b.depth ? $253292e9913a6593$var$P(a, b) : $253292e9913a6593$var$oc(a, b);
}
function $253292e9913a6593$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($253292e9913a6593$var$k(402));
    a.depth === c.depth ? $253292e9913a6593$var$P(a, c) : $253292e9913a6593$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $253292e9913a6593$var$Q(a) {
    var b = $253292e9913a6593$var$O;
    b !== a && (null === b ? $253292e9913a6593$var$nc(a) : null === a ? $253292e9913a6593$var$mc(b) : b.depth === a.depth ? $253292e9913a6593$var$P(b, a) : b.depth > a.depth ? $253292e9913a6593$var$oc(b, a) : $253292e9913a6593$var$pc(b, a), $253292e9913a6593$var$O = a);
}
var $253292e9913a6593$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $253292e9913a6593$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $253292e9913a6593$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $253292e9913a6593$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $253292e9913a6593$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $253292e9913a6593$var$N({}, e, h)) : $253292e9913a6593$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $253292e9913a6593$var$sc = {
    id: 1,
    overflow: ""
};
function $253292e9913a6593$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $253292e9913a6593$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $253292e9913a6593$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $253292e9913a6593$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $253292e9913a6593$var$uc = Math.clz32 ? Math.clz32 : $253292e9913a6593$var$vc, $253292e9913a6593$var$wc = Math.log, $253292e9913a6593$var$xc = Math.LN2;
function $253292e9913a6593$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($253292e9913a6593$var$wc(a) / $253292e9913a6593$var$xc | 0) | 0;
}
function $253292e9913a6593$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $253292e9913a6593$var$zc = "function" === typeof Object.is ? Object.is : $253292e9913a6593$var$yc, $253292e9913a6593$var$R = null, $253292e9913a6593$var$Ac = null, $253292e9913a6593$var$Bc = null, $253292e9913a6593$var$S = null, $253292e9913a6593$var$T = !1, $253292e9913a6593$var$Cc = !1, $253292e9913a6593$var$U = 0, $253292e9913a6593$var$V = null, $253292e9913a6593$var$Dc = 0;
function $253292e9913a6593$var$W() {
    if (null === $253292e9913a6593$var$R) throw Error($253292e9913a6593$var$k(321));
    return $253292e9913a6593$var$R;
}
function $253292e9913a6593$var$Ec() {
    if (0 < $253292e9913a6593$var$Dc) throw Error($253292e9913a6593$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $253292e9913a6593$var$Fc() {
    null === $253292e9913a6593$var$S ? null === $253292e9913a6593$var$Bc ? ($253292e9913a6593$var$T = !1, $253292e9913a6593$var$Bc = $253292e9913a6593$var$S = $253292e9913a6593$var$Ec()) : ($253292e9913a6593$var$T = !0, $253292e9913a6593$var$S = $253292e9913a6593$var$Bc) : null === $253292e9913a6593$var$S.next ? ($253292e9913a6593$var$T = !1, $253292e9913a6593$var$S = $253292e9913a6593$var$S.next = $253292e9913a6593$var$Ec()) : ($253292e9913a6593$var$T = !0, $253292e9913a6593$var$S = $253292e9913a6593$var$S.next);
    return $253292e9913a6593$var$S;
}
function $253292e9913a6593$var$Gc() {
    $253292e9913a6593$var$Ac = $253292e9913a6593$var$R = null;
    $253292e9913a6593$var$Cc = !1;
    $253292e9913a6593$var$Bc = null;
    $253292e9913a6593$var$Dc = 0;
    $253292e9913a6593$var$S = $253292e9913a6593$var$V = null;
}
function $253292e9913a6593$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $253292e9913a6593$var$Ic(a, b, c) {
    $253292e9913a6593$var$R = $253292e9913a6593$var$W();
    $253292e9913a6593$var$S = $253292e9913a6593$var$Fc();
    if ($253292e9913a6593$var$T) {
        var d = $253292e9913a6593$var$S.queue;
        b = d.dispatch;
        if (null !== $253292e9913a6593$var$V && (c = $253292e9913a6593$var$V.get(d), void 0 !== c)) {
            $253292e9913a6593$var$V.delete(d);
            d = $253292e9913a6593$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $253292e9913a6593$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $253292e9913a6593$var$S.memoizedState,
            b
        ];
    }
    a = a === $253292e9913a6593$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $253292e9913a6593$var$S.memoizedState = a;
    a = $253292e9913a6593$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $253292e9913a6593$var$Jc.bind(null, $253292e9913a6593$var$R, a);
    return [
        $253292e9913a6593$var$S.memoizedState,
        a
    ];
}
function $253292e9913a6593$var$Kc(a, b) {
    $253292e9913a6593$var$R = $253292e9913a6593$var$W();
    $253292e9913a6593$var$S = $253292e9913a6593$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $253292e9913a6593$var$S) {
        var c = $253292e9913a6593$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$253292e9913a6593$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $253292e9913a6593$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $253292e9913a6593$var$Jc(a, b, c) {
    if (25 <= $253292e9913a6593$var$Dc) throw Error($253292e9913a6593$var$k(301));
    if (a === $253292e9913a6593$var$R) {
        if ($253292e9913a6593$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $253292e9913a6593$var$V && ($253292e9913a6593$var$V = new Map), c = $253292e9913a6593$var$V.get(b), void 0 === c) $253292e9913a6593$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $253292e9913a6593$var$Lc() {
    throw Error($253292e9913a6593$var$k(394));
}
function $253292e9913a6593$var$Mc() {}
var $253292e9913a6593$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $253292e9913a6593$var$W();
        return a._currentValue;
    },
    useMemo: $253292e9913a6593$var$Kc,
    useReducer: $253292e9913a6593$var$Ic,
    useRef: function(a) {
        $253292e9913a6593$var$R = $253292e9913a6593$var$W();
        $253292e9913a6593$var$S = $253292e9913a6593$var$Fc();
        var b = $253292e9913a6593$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $253292e9913a6593$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $253292e9913a6593$var$Ic($253292e9913a6593$var$Hc, a);
    },
    useInsertionEffect: $253292e9913a6593$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $253292e9913a6593$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $253292e9913a6593$var$Mc,
    useEffect: $253292e9913a6593$var$Mc,
    useDebugValue: $253292e9913a6593$var$Mc,
    useDeferredValue: function(a) {
        $253292e9913a6593$var$W();
        return a;
    },
    useTransition: function() {
        $253292e9913a6593$var$W();
        return [
            !1,
            $253292e9913a6593$var$Lc
        ];
    },
    useId: function() {
        var a = $253292e9913a6593$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $253292e9913a6593$var$uc(a) - 1)).toString(32) + b;
        var c = $253292e9913a6593$var$Nc;
        if (null === c) throw Error($253292e9913a6593$var$k(404));
        b = $253292e9913a6593$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $253292e9913a6593$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($253292e9913a6593$var$k(407));
        return c();
    }
}, $253292e9913a6593$var$Nc = null, $253292e9913a6593$var$Pc = $aivMx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $253292e9913a6593$var$Qc(a) {
    console.error(a);
    return null;
}
function $253292e9913a6593$var$X() {}
function $253292e9913a6593$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $253292e9913a6593$var$Qc : f,
        onAllReady: void 0 === e ? $253292e9913a6593$var$X : e,
        onShellReady: void 0 === g ? $253292e9913a6593$var$X : g,
        onShellError: void 0 === h ? $253292e9913a6593$var$X : h,
        onFatalError: void 0 === m ? $253292e9913a6593$var$X : m
    };
    c = $253292e9913a6593$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $253292e9913a6593$var$Tc(b, a, null, c, r, $253292e9913a6593$var$kc, null, $253292e9913a6593$var$sc);
    q.push(a);
    return b;
}
function $253292e9913a6593$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $253292e9913a6593$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $253292e9913a6593$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $253292e9913a6593$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $253292e9913a6593$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $253292e9913a6593$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $253292e9913a6593$var$Wc(a, b, c, d, f) {
    $253292e9913a6593$var$R = {};
    $253292e9913a6593$var$Ac = b;
    $253292e9913a6593$var$U = 0;
    for(a = c(d, f); $253292e9913a6593$var$Cc;)$253292e9913a6593$var$Cc = !1, $253292e9913a6593$var$U = 0, $253292e9913a6593$var$Dc += 1, $253292e9913a6593$var$S = null, a = c(d, f);
    $253292e9913a6593$var$Gc();
    return a;
}
function $253292e9913a6593$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($253292e9913a6593$var$k(108, $253292e9913a6593$var$jc(d) || "Unknown", h));
            d = $253292e9913a6593$var$N({}, g, c);
        }
        b.legacyContext = d;
        $253292e9913a6593$var$Z(a, b, f);
        b.legacyContext = g;
    } else $253292e9913a6593$var$Z(a, b, f);
}
function $253292e9913a6593$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $253292e9913a6593$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $253292e9913a6593$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $253292e9913a6593$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $253292e9913a6593$var$rc(e, c, d, f);
            $253292e9913a6593$var$Xc(a, b, e, c);
        } else {
            e = $253292e9913a6593$var$lc(c, b.legacyContext);
            f = $253292e9913a6593$var$Wc(a, b, c, d, e);
            var g = 0 !== $253292e9913a6593$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $253292e9913a6593$var$rc(f, c, d, e), $253292e9913a6593$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $253292e9913a6593$var$tc(d, 1, 0);
                try {
                    $253292e9913a6593$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $253292e9913a6593$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $253292e9913a6593$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $253292e9913a6593$var$Ba(g, c, d);
        $253292e9913a6593$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($253292e9913a6593$var$Ta, $253292e9913a6593$var$u(c), $253292e9913a6593$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $253292e9913a6593$var$gc:
            case $253292e9913a6593$var$fc:
            case $253292e9913a6593$var$Wb:
            case $253292e9913a6593$var$Xb:
            case $253292e9913a6593$var$Vb:
                $253292e9913a6593$var$Z(a, b, d.children);
                return;
            case $253292e9913a6593$var$bc:
                $253292e9913a6593$var$Z(a, b, d.children);
                return;
            case $253292e9913a6593$var$ec:
                throw Error($253292e9913a6593$var$k(343));
            case $253292e9913a6593$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $253292e9913a6593$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $253292e9913a6593$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($253292e9913a6593$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($253292e9913a6593$var$Ca), q.status = 1, $253292e9913a6593$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $253292e9913a6593$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $253292e9913a6593$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $253292e9913a6593$var$$b:
                d = $253292e9913a6593$var$Wc(a, b, c.render, d, f);
                if (0 !== $253292e9913a6593$var$U) {
                    c = b.treeContext;
                    b.treeContext = $253292e9913a6593$var$tc(c, 1, 0);
                    try {
                        $253292e9913a6593$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $253292e9913a6593$var$Z(a, b, d);
                return;
            case $253292e9913a6593$var$cc:
                c = c.type;
                d = $253292e9913a6593$var$Yc(c, d);
                $253292e9913a6593$var$Zc(a, b, c, d, f);
                return;
            case $253292e9913a6593$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $253292e9913a6593$var$O;
                $253292e9913a6593$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $253292e9913a6593$var$Z(a, b, f);
                a = $253292e9913a6593$var$O;
                if (null === a) throw Error($253292e9913a6593$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $253292e9913a6593$var$hc ? a.context._defaultValue : d;
                a = $253292e9913a6593$var$O = a.parent;
                b.context = a;
                return;
            case $253292e9913a6593$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $253292e9913a6593$var$Z(a, b, d);
                return;
            case $253292e9913a6593$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $253292e9913a6593$var$Yc(c, d);
                $253292e9913a6593$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($253292e9913a6593$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $253292e9913a6593$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $253292e9913a6593$var$Tb:
                $253292e9913a6593$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $253292e9913a6593$var$Ub:
                throw Error($253292e9913a6593$var$k(257));
            case $253292e9913a6593$var$dc:
                var d = c._init;
                c = d(c._payload);
                $253292e9913a6593$var$Z(a, b, c);
                return;
        }
        if ($253292e9913a6593$var$ra(c)) {
            $253292e9913a6593$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $253292e9913a6593$var$ic && c[$253292e9913a6593$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $253292e9913a6593$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($253292e9913a6593$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $253292e9913a6593$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $253292e9913a6593$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $253292e9913a6593$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $253292e9913a6593$var$tc(e, d, f);
        try {
            $253292e9913a6593$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $253292e9913a6593$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $253292e9913a6593$var$Z(a, b, c);
    } catch (m) {
        if ($253292e9913a6593$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $253292e9913a6593$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $253292e9913a6593$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $253292e9913a6593$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $253292e9913a6593$var$Q(e), m;
    }
}
function $253292e9913a6593$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $253292e9913a6593$var$dd(this, b, a);
}
function $253292e9913a6593$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($253292e9913a6593$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $253292e9913a6593$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $253292e9913a6593$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $253292e9913a6593$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $253292e9913a6593$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($253292e9913a6593$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $253292e9913a6593$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $253292e9913a6593$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($253292e9913a6593$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($253292e9913a6593$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $253292e9913a6593$var$Uc(a) {
    if (2 !== a.status) {
        var b = $253292e9913a6593$var$O, c = $253292e9913a6593$var$Pc.current;
        $253292e9913a6593$var$Pc.current = $253292e9913a6593$var$Oc;
        var d = $253292e9913a6593$var$Nc;
        $253292e9913a6593$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $253292e9913a6593$var$Q(g.context);
                    try {
                        $253292e9913a6593$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($253292e9913a6593$var$Ca), g.abortSet.delete(g), m.status = 1, $253292e9913a6593$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($253292e9913a6593$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $253292e9913a6593$var$Y(h, v);
                            null === r ? $253292e9913a6593$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $253292e9913a6593$var$fd(a, a.destination);
        } catch (G) {
            $253292e9913a6593$var$Y(a, G), $253292e9913a6593$var$Vc(a, G);
        } finally{
            $253292e9913a6593$var$Nc = d, $253292e9913a6593$var$Pc.current = c, c === $253292e9913a6593$var$Oc && $253292e9913a6593$var$Q(b);
        }
    }
}
function $253292e9913a6593$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $253292e9913a6593$var$p(b, $253292e9913a6593$var$Va);
            $253292e9913a6593$var$p(b, a.placeholderPrefix);
            a = $253292e9913a6593$var$u(d.toString(16));
            $253292e9913a6593$var$p(b, a);
            return $253292e9913a6593$var$t(b, $253292e9913a6593$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$253292e9913a6593$var$p(b, d[e]);
                f = $253292e9913a6593$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$253292e9913a6593$var$p(b, d[e]);
            e < d.length && (f = $253292e9913a6593$var$t(b, d[e]));
            return f;
        default:
            throw Error($253292e9913a6593$var$k(390));
    }
}
function $253292e9913a6593$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $253292e9913a6593$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $253292e9913a6593$var$t(b, $253292e9913a6593$var$$a), $253292e9913a6593$var$p(b, $253292e9913a6593$var$bb), d && ($253292e9913a6593$var$p(b, $253292e9913a6593$var$db), $253292e9913a6593$var$p(b, $253292e9913a6593$var$u($253292e9913a6593$var$C(d))), $253292e9913a6593$var$p(b, $253292e9913a6593$var$cb)), $253292e9913a6593$var$t(b, $253292e9913a6593$var$eb), $253292e9913a6593$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $253292e9913a6593$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $253292e9913a6593$var$fb(b, a.responseState, d);
        $253292e9913a6593$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $253292e9913a6593$var$fb(b, a.responseState, d.id), $253292e9913a6593$var$gd(a, b, c);
    else {
        $253292e9913a6593$var$t(b, $253292e9913a6593$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($253292e9913a6593$var$k(391));
        $253292e9913a6593$var$hd(a, b, c[0]);
    }
    return $253292e9913a6593$var$t(b, $253292e9913a6593$var$ab);
}
function $253292e9913a6593$var$id(a, b, c) {
    $253292e9913a6593$var$Bb(b, a.responseState, c.formatContext, c.id);
    $253292e9913a6593$var$hd(a, b, c);
    return $253292e9913a6593$var$Cb(b, c.formatContext);
}
function $253292e9913a6593$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$253292e9913a6593$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $253292e9913a6593$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $253292e9913a6593$var$p(b, $253292e9913a6593$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $253292e9913a6593$var$p(b, $253292e9913a6593$var$Ib));
    if (null === d) throw Error($253292e9913a6593$var$k(395));
    c = $253292e9913a6593$var$u(c.toString(16));
    $253292e9913a6593$var$p(b, d);
    $253292e9913a6593$var$p(b, $253292e9913a6593$var$Kb);
    $253292e9913a6593$var$p(b, a.segmentPrefix);
    $253292e9913a6593$var$p(b, c);
    return $253292e9913a6593$var$t(b, $253292e9913a6593$var$Lb);
}
function $253292e9913a6593$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($253292e9913a6593$var$k(392));
        return $253292e9913a6593$var$id(a, b, d);
    }
    $253292e9913a6593$var$id(a, b, d);
    a = a.responseState;
    $253292e9913a6593$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $253292e9913a6593$var$p(b, $253292e9913a6593$var$Eb) : (a.sentCompleteSegmentFunction = !0, $253292e9913a6593$var$p(b, $253292e9913a6593$var$Db));
    $253292e9913a6593$var$p(b, a.segmentPrefix);
    f = $253292e9913a6593$var$u(f.toString(16));
    $253292e9913a6593$var$p(b, f);
    $253292e9913a6593$var$p(b, $253292e9913a6593$var$Gb);
    $253292e9913a6593$var$p(b, a.placeholderPrefix);
    $253292e9913a6593$var$p(b, f);
    return $253292e9913a6593$var$t(b, $253292e9913a6593$var$Hb);
}
function $253292e9913a6593$var$fd(a, b) {
    $253292e9913a6593$var$l = new Uint8Array(512);
    $253292e9913a6593$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $253292e9913a6593$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$253292e9913a6593$var$p(b, d[c]);
            c < d.length && $253292e9913a6593$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $253292e9913a6593$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $253292e9913a6593$var$p(d, $253292e9913a6593$var$Nb) : (h.sentClientRenderFunction = !0, $253292e9913a6593$var$p(d, $253292e9913a6593$var$Mb));
            if (null === m) throw Error($253292e9913a6593$var$k(395));
            $253292e9913a6593$var$p(d, m);
            $253292e9913a6593$var$p(d, $253292e9913a6593$var$Ob);
            if (q || r || v) $253292e9913a6593$var$p(d, $253292e9913a6593$var$Qb), $253292e9913a6593$var$p(d, $253292e9913a6593$var$u($253292e9913a6593$var$Sb(q || "")));
            if (r || v) $253292e9913a6593$var$p(d, $253292e9913a6593$var$Qb), $253292e9913a6593$var$p(d, $253292e9913a6593$var$u($253292e9913a6593$var$Sb(r || "")));
            v && ($253292e9913a6593$var$p(d, $253292e9913a6593$var$Qb), $253292e9913a6593$var$p(d, $253292e9913a6593$var$u($253292e9913a6593$var$Sb(v))));
            if (!$253292e9913a6593$var$t(d, $253292e9913a6593$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$253292e9913a6593$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $253292e9913a6593$var$ba(b);
        $253292e9913a6593$var$l = new Uint8Array(512);
        $253292e9913a6593$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$253292e9913a6593$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$253292e9913a6593$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $253292e9913a6593$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $253292e9913a6593$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $253292e9913a6593$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $253292e9913a6593$var$fd(a, a.destination);
    } catch (d) {
        $253292e9913a6593$var$Y(a, d), $253292e9913a6593$var$Vc(a, d);
    }
}
$253292e9913a6593$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $253292e9913a6593$var$Rc(a, $253292e9913a6593$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $253292e9913a6593$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $253292e9913a6593$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $253292e9913a6593$var$fd(h, a);
                        } catch (A) {
                            $253292e9913a6593$var$Y(h, A), $253292e9913a6593$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $253292e9913a6593$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $253292e9913a6593$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $253292e9913a6593$var$Uc(h);
    });
};
$253292e9913a6593$export$83d89fbfd8236492 = "18.3.1";

});

var $02de83db299f7983$exports = {};
'use strict';

$02de83db299f7983$exports = (parcelRequire("8j8zV"));


parcelRequire("aivMx");
var $86dae81a7d15f03f$export$882461b6382ed46c;
var $86dae81a7d15f03f$export$757ceba2d55c277e;
'use strict';
var $9f97ad3b314012cb$exports = {};
'use strict';
function $9f97ad3b314012cb$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9f97ad3b314012cb$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9f97ad3b314012cb$var$checkDCE();

$9f97ad3b314012cb$exports = (parcelRequire("gaHwe"));


var $86dae81a7d15f03f$var$i;
$86dae81a7d15f03f$export$882461b6382ed46c = $9f97ad3b314012cb$exports.createRoot;
$86dae81a7d15f03f$export$757ceba2d55c277e = $9f97ad3b314012cb$exports.hydrateRoot;



var $94WEq = parcelRequire("94WEq");
function $fa575a8859835fb5$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $fa575a8859835fb5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fa575a8859835fb5$export$2e2bcd8739ae039(o);
}



function $87d318f6d8110916$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fa575a8859835fb5$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fa575a8859835fb5$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $870a62074cbae60b$export$2e2bcd8739ae039(t) {
    var i = (0, $87d318f6d8110916$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $fa575a8859835fb5$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $17254d86ba126058$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $870a62074cbae60b$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $3400877ec9987019$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3400877ec9987019$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3400877ec9987019$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $17254d86ba126058$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3400877ec9987019$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $b4bc487a38c3f200$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $b4bc487a38c3f200$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $b4bc487a38c3f200$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $b4bc487a38c3f200$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $b4bc487a38c3f200$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $b4bc487a38c3f200$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $b4bc487a38c3f200$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $b4bc487a38c3f200$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $b4bc487a38c3f200$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($b4bc487a38c3f200$var$isDate(val)) return 'date';
    if ($b4bc487a38c3f200$var$isError(val)) return 'error';
    var constructorName = $b4bc487a38c3f200$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $b4bc487a38c3f200$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $b4bc487a38c3f200$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $b4bc487a38c3f200$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $b4bc487a38c3f200$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $b4bc487a38c3f200$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(1));
        return enhancer($b4bc487a38c3f200$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$b4bc487a38c3f200$var$isPlainObject(action)) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $b4bc487a38c3f200$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$b4bc487a38c3f200$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $b4bc487a38c3f200$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$b4bc487a38c3f200$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $b4bc487a38c3f200$export$8928921ea2d3b126 = $b4bc487a38c3f200$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $b4bc487a38c3f200$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $b4bc487a38c3f200$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $b4bc487a38c3f200$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$b4bc487a38c3f200$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $b4bc487a38c3f200$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $b4bc487a38c3f200$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $b4bc487a38c3f200$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $b4bc487a38c3f200$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $b4bc487a38c3f200$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $b4bc487a38c3f200$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $b4bc487a38c3f200$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $b4bc487a38c3f200$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $b4bc487a38c3f200$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $b4bc487a38c3f200$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $b4bc487a38c3f200$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $b4bc487a38c3f200$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $b4bc487a38c3f200$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($b4bc487a38c3f200$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $b4bc487a38c3f200$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $3400877ec9987019$export$2e2bcd8739ae039)((0, $3400877ec9987019$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


var $05d10e651fe8cb91$var$createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var $05d10e651fe8cb91$export$2b10f4b30fb65583 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('CANCEL_PROMISE');
var $05d10e651fe8cb91$export$3281fbb3edc9dee3 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('CHANNEL_END');
var $05d10e651fe8cb91$export$8f8422ac5947a789 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('IO');
var $05d10e651fe8cb91$export$5a1a83be8f503735 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('MATCH');
var $05d10e651fe8cb91$export$9074c4e62c4e51bb = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('MULTICAST');
var $05d10e651fe8cb91$export$7d963e45ecdffba1 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('SAGA_ACTION');
var $05d10e651fe8cb91$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('SELF_CANCELLATION');
var $05d10e651fe8cb91$export$9355e489ad16f98e = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('TASK');
var $05d10e651fe8cb91$export$a47f788ef0b36709 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('TASK_CANCEL');
var $05d10e651fe8cb91$export$d966e43d90bf4c05 = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('TERMINATE');
var $05d10e651fe8cb91$export$bdae2c4f4f03305d = /*#__PURE__*/ $05d10e651fe8cb91$var$createSymbol('LOCATION');


function $6767be368738adce$export$2e2bcd8739ae039() {
    return $6767be368738adce$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6767be368738adce$export$2e2bcd8739ae039.apply(null, arguments);
}


function $612ace97f19660e2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $8208d7224f148797$export$c7b6444af1f098df = function undef(v) {
    return v === null || v === undefined;
};
var $8208d7224f148797$export$1352885233577768 = function notUndef(v) {
    return v !== null && v !== undefined;
};
var $8208d7224f148797$export$86951950244e2001 = function func(f) {
    return typeof f === 'function';
};
var $8208d7224f148797$export$98e628dec113755e = function number(n) {
    return typeof n === 'number';
};
var $8208d7224f148797$export$22b082955e083ec3 = function string(s) {
    return typeof s === 'string';
};
var $8208d7224f148797$export$2f23118c22fb2630 = Array.isArray;
var $8208d7224f148797$export$be5493f9613cbbe = function object(obj) {
    return obj && !$8208d7224f148797$export$2f23118c22fb2630(obj) && typeof obj === 'object';
};
var $8208d7224f148797$export$c957ef27a0ebfd4 = function promise(p) {
    return p && $8208d7224f148797$export$86951950244e2001(p.then);
};
var $8208d7224f148797$export$6f58e2338da23f4d = function iterator(it) {
    return it && $8208d7224f148797$export$86951950244e2001(it.next) && $8208d7224f148797$export$86951950244e2001(it.throw);
};
var $8208d7224f148797$export$8e2ddbe84aff549 = function iterable(it) {
    return it && $8208d7224f148797$export$86951950244e2001(Symbol) ? $8208d7224f148797$export$86951950244e2001(it[Symbol.iterator]) : $8208d7224f148797$export$2f23118c22fb2630(it);
};
var $8208d7224f148797$export$94e939b87ca64fb4 = function task(t) {
    return t && t[0, $05d10e651fe8cb91$export$9355e489ad16f98e];
};
var $8208d7224f148797$export$2ce8c19c8dfba715 = function sagaAction(a) {
    return Boolean(a && a[0, $05d10e651fe8cb91$export$7d963e45ecdffba1]);
};
var $8208d7224f148797$export$5ab46cbf6120b33a = function observable(ob) {
    return ob && $8208d7224f148797$export$86951950244e2001(ob.subscribe);
};
var $8208d7224f148797$export$ab1029bcae9ddb4a = function buffer(buf) {
    return buf && $8208d7224f148797$export$86951950244e2001(buf.isEmpty) && $8208d7224f148797$export$86951950244e2001(buf.take) && $8208d7224f148797$export$86951950244e2001(buf.put);
};
var $8208d7224f148797$export$24f82734ea047e6f = function pattern(pat) {
    return pat && ($8208d7224f148797$export$22b082955e083ec3(pat) || $8208d7224f148797$export$8f701197936bc2a6(pat) || $8208d7224f148797$export$86951950244e2001(pat) || $8208d7224f148797$export$2f23118c22fb2630(pat) && pat.every(pattern));
};
var $8208d7224f148797$export$1f95fbd68d964d36 = function channel(ch) {
    return ch && $8208d7224f148797$export$86951950244e2001(ch.take) && $8208d7224f148797$export$86951950244e2001(ch.close);
};
var $8208d7224f148797$export$32b5e46230afa379 = function stringableFunc(f) {
    return $8208d7224f148797$export$86951950244e2001(f) && f.hasOwnProperty('toString');
};
var $8208d7224f148797$export$8f701197936bc2a6 = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var $8208d7224f148797$export$1364843af8d5a963 = function multicast(ch) {
    return $8208d7224f148797$export$1f95fbd68d964d36(ch) && ch[0, $05d10e651fe8cb91$export$9074c4e62c4e51bb];
};
var $8208d7224f148797$export$dc573d8a6576cdb3 = function effect(eff) {
    return eff && eff[0, $05d10e651fe8cb91$export$8f8422ac5947a789];
};






var $1c08c370c926c31e$var$MAX_SIGNED_INT = 2147483647;
function $1c08c370c926c31e$var$delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, Math.min($1c08c370c926c31e$var$MAX_SIGNED_INT, ms), val);
    });
    promise[0, $05d10e651fe8cb91$export$2b10f4b30fb65583] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
var $1c08c370c926c31e$export$2e2bcd8739ae039 = $1c08c370c926c31e$var$delayP;


var $45d5d5ff9e5b412e$var$konst = function konst(v) {
    return function() {
        return v;
    };
};
var $45d5d5ff9e5b412e$export$342063e11d6c3cad = /*#__PURE__*/ $45d5d5ff9e5b412e$var$konst(true);
var $45d5d5ff9e5b412e$export$625550452a3fa3ec = function noop() {};
var $45d5d5ff9e5b412e$export$7f8ddf7c7c20b3cd = function identity(v) {
    return v;
};
var $45d5d5ff9e5b412e$var$hasSymbol = typeof Symbol === 'function';
var $45d5d5ff9e5b412e$export$d141bba7fdc215a3 = $45d5d5ff9e5b412e$var$hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function $45d5d5ff9e5b412e$export$db3b6bfb95261072(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var $45d5d5ff9e5b412e$export$ffb5f4729a158638 = function assignWithSymbols(target, source) {
    (0, $6767be368738adce$export$2e2bcd8739ae039)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var $45d5d5ff9e5b412e$export$3b14a55fb2447963 = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function $45d5d5ff9e5b412e$export$43caf9889c228507(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $45d5d5ff9e5b412e$export$ae1af26003f05816(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var $45d5d5ff9e5b412e$var$kThrow = function kThrow(err) {
    throw err;
};
var $45d5d5ff9e5b412e$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $45d5d5ff9e5b412e$export$9e5f44173e64f162(next, thro, name) {
    if (thro === void 0) thro = $45d5d5ff9e5b412e$var$kThrow;
    if (name === void 0) name = 'iterator';
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: $45d5d5ff9e5b412e$var$kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== 'undefined') iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $45d5d5ff9e5b412e$export$96f57966bedc81b4(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var $45d5d5ff9e5b412e$export$23f2a1d2818174ef = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var $45d5d5ff9e5b412e$export$efccba1c4a2ef57b = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var $45d5d5ff9e5b412e$var$FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var $45d5d5ff9e5b412e$export$953cecd6e717a553 = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var $45d5d5ff9e5b412e$export$a9c23c6ac3fc3eca = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, $05d10e651fe8cb91$export$7d963e45ecdffba1), {
            value: true
        }));
    };
};
var $45d5d5ff9e5b412e$export$df995fae86a55f06 = function shouldTerminate(res) {
    return res === (0, $05d10e651fe8cb91$export$d966e43d90bf4c05);
};
var $45d5d5ff9e5b412e$export$4a5767248b18ef41 = function shouldCancel(res) {
    return res === (0, $05d10e651fe8cb91$export$a47f788ef0b36709);
};
var $45d5d5ff9e5b412e$export$2408f22a0fab9ae5 = function shouldComplete(res) {
    return $45d5d5ff9e5b412e$export$df995fae86a55f06(res) || $45d5d5ff9e5b412e$export$4a5767248b18ef41(res);
};
function $45d5d5ff9e5b412e$export$882b5998b3b9117c(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, $8208d7224f148797$export$2f23118c22fb2630)(shape) ? $45d5d5ff9e5b412e$export$953cecd6e717a553(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || $45d5d5ff9e5b412e$export$2408f22a0fab9ae5(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = $45d5d5ff9e5b412e$export$625550452a3fa3ec;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function $45d5d5ff9e5b412e$export$35e795649ee09318(fn) {
    return {
        name: fn.name || 'anonymous',
        location: $45d5d5ff9e5b412e$export$90a7f3efeed30595(fn)
    };
}
function $45d5d5ff9e5b412e$export$90a7f3efeed30595(instrumented) {
    return instrumented[0, $05d10e651fe8cb91$export$bdae2c4f4f03305d];
}
function $45d5d5ff9e5b412e$export$ef35774e6d314e91() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
var $45d5d5ff9e5b412e$var$BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var $45d5d5ff9e5b412e$var$ON_OVERFLOW_THROW = 1;
var $45d5d5ff9e5b412e$var$ON_OVERFLOW_DROP = 2;
var $45d5d5ff9e5b412e$var$ON_OVERFLOW_SLIDE = 3;
var $45d5d5ff9e5b412e$var$ON_OVERFLOW_EXPAND = 4;
var $45d5d5ff9e5b412e$var$zeroBuffer = {
    isEmpty: $45d5d5ff9e5b412e$export$342063e11d6c3cad,
    put: $45d5d5ff9e5b412e$export$625550452a3fa3ec,
    take: $45d5d5ff9e5b412e$export$625550452a3fa3ec
};
function $45d5d5ff9e5b412e$var$ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case $45d5d5ff9e5b412e$var$ON_OVERFLOW_THROW:
                        throw new Error($45d5d5ff9e5b412e$var$BUFFER_OVERFLOW);
                    case $45d5d5ff9e5b412e$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $45d5d5ff9e5b412e$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $45d5d5ff9e5b412e$export$7ccc53e8f1e7dfc5 = function none() {
    return $45d5d5ff9e5b412e$var$zeroBuffer;
};
var $45d5d5ff9e5b412e$var$fixed = function fixed(limit) {
    return $45d5d5ff9e5b412e$var$ringBuffer(limit, $45d5d5ff9e5b412e$var$ON_OVERFLOW_THROW);
};
var $45d5d5ff9e5b412e$var$dropping = function dropping(limit) {
    return $45d5d5ff9e5b412e$var$ringBuffer(limit, $45d5d5ff9e5b412e$var$ON_OVERFLOW_DROP);
};
var $45d5d5ff9e5b412e$export$e7c866399fa523f5 = function sliding(limit) {
    return $45d5d5ff9e5b412e$var$ringBuffer(limit, $45d5d5ff9e5b412e$var$ON_OVERFLOW_SLIDE);
};
var $45d5d5ff9e5b412e$export$f1e1789686576879 = function expanding(initialSize) {
    return $45d5d5ff9e5b412e$var$ringBuffer(initialSize, $45d5d5ff9e5b412e$var$ON_OVERFLOW_EXPAND);
};
var $45d5d5ff9e5b412e$export$9bb611d729802a56 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: $45d5d5ff9e5b412e$export$7ccc53e8f1e7dfc5,
    fixed: $45d5d5ff9e5b412e$var$fixed,
    dropping: $45d5d5ff9e5b412e$var$dropping,
    sliding: $45d5d5ff9e5b412e$export$e7c866399fa523f5,
    expanding: $45d5d5ff9e5b412e$export$f1e1789686576879
});
var $45d5d5ff9e5b412e$export$971d5caa766a69d7 = 'TAKE';
var $45d5d5ff9e5b412e$export$56c0d5a1e737357d = 'PUT';
var $45d5d5ff9e5b412e$export$ebd11618f299a286 = 'ALL';
var $45d5d5ff9e5b412e$export$db202ddc8be9136 = 'RACE';
var $45d5d5ff9e5b412e$export$e7094788287c5e9b = 'CALL';
var $45d5d5ff9e5b412e$export$407448d2b89b1813 = 'CPS';
var $45d5d5ff9e5b412e$export$d66501df72047452 = 'FORK';
var $45d5d5ff9e5b412e$export$b4171a6734a65d42 = 'JOIN';
var $45d5d5ff9e5b412e$export$8b22cf2602fb60ce = 'CANCEL';
var $45d5d5ff9e5b412e$export$25ce5a424b770e84 = 'SELECT';
var $45d5d5ff9e5b412e$export$4368d992c4eafac0 = 'ACTION_CHANNEL';
var $45d5d5ff9e5b412e$export$2d1720544b23b823 = 'CANCELLED';
var $45d5d5ff9e5b412e$export$39b482c5e57630a8 = 'FLUSH';
var $45d5d5ff9e5b412e$export$2329c99376c9d0a4 = 'GET_CONTEXT';
var $45d5d5ff9e5b412e$export$dda1d9f60106f0e9 = 'SET_CONTEXT';
var $45d5d5ff9e5b412e$export$78acf4525d8a74c4 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TAKE: $45d5d5ff9e5b412e$export$971d5caa766a69d7,
    PUT: $45d5d5ff9e5b412e$export$56c0d5a1e737357d,
    ALL: $45d5d5ff9e5b412e$export$ebd11618f299a286,
    RACE: $45d5d5ff9e5b412e$export$db202ddc8be9136,
    CALL: $45d5d5ff9e5b412e$export$e7094788287c5e9b,
    CPS: $45d5d5ff9e5b412e$export$407448d2b89b1813,
    FORK: $45d5d5ff9e5b412e$export$d66501df72047452,
    JOIN: $45d5d5ff9e5b412e$export$b4171a6734a65d42,
    CANCEL: $45d5d5ff9e5b412e$export$8b22cf2602fb60ce,
    SELECT: $45d5d5ff9e5b412e$export$25ce5a424b770e84,
    ACTION_CHANNEL: $45d5d5ff9e5b412e$export$4368d992c4eafac0,
    CANCELLED: $45d5d5ff9e5b412e$export$2d1720544b23b823,
    FLUSH: $45d5d5ff9e5b412e$export$39b482c5e57630a8,
    GET_CONTEXT: $45d5d5ff9e5b412e$export$2329c99376c9d0a4,
    SET_CONTEXT: $45d5d5ff9e5b412e$export$dda1d9f60106f0e9
});
var $45d5d5ff9e5b412e$var$TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';
var $45d5d5ff9e5b412e$var$makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, $05d10e651fe8cb91$export$8f8422ac5947a789] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var $45d5d5ff9e5b412e$var$isForkEffect = function isForkEffect(eff) {
    return (0, $8208d7224f148797$export$dc573d8a6576cdb3)(eff) && eff.type === $45d5d5ff9e5b412e$export$d66501df72047452;
};
var $45d5d5ff9e5b412e$export$3466f893ebf79586 = function detach(eff) {
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$d66501df72047452, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, eff.payload, {
        detached: true
    }));
};
function $45d5d5ff9e5b412e$export$61196ced6d74a310(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = '*';
    if ((0, $8208d7224f148797$export$24f82734ea047e6f)(patternOrChannel)) {
        if ((0, $8208d7224f148797$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
        return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$971d5caa766a69d7, {
            pattern: patternOrChannel
        });
    }
    if ((0, $8208d7224f148797$export$1364843af8d5a963)(patternOrChannel) && (0, $8208d7224f148797$export$1352885233577768)(multicastPattern) && (0, $8208d7224f148797$export$24f82734ea047e6f)(multicastPattern)) return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$971d5caa766a69d7, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, $8208d7224f148797$export$1f95fbd68d964d36)(patternOrChannel)) {
        if ((0, $8208d7224f148797$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
        return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$971d5caa766a69d7, {
            channel: patternOrChannel
        });
    }
}
var $45d5d5ff9e5b412e$export$8743009a87fcb00f = function takeMaybe() {
    var eff = $45d5d5ff9e5b412e$export$61196ced6d74a310.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function $45d5d5ff9e5b412e$export$dc98b0b04f4c7758(channel$1, action) {
    if ((0, $8208d7224f148797$export$c7b6444af1f098df)(action)) {
        action = channel$1; // `undefined` instead of `null` to make default parameter work
        channel$1 = undefined;
    }
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$56c0d5a1e737357d, {
        channel: channel$1,
        action: action
    });
}
var $45d5d5ff9e5b412e$export$71511d61b312f219 = function putResolve() {
    var eff = $45d5d5ff9e5b412e$export$dc98b0b04f4c7758.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function $45d5d5ff9e5b412e$export$3d8c2f653ac9d0b9(effects) {
    var eff = $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$ebd11618f299a286, effects);
    eff.combinator = true;
    return eff;
}
function $45d5d5ff9e5b412e$export$71cec2538cb2c617(effects) {
    var eff = $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$db202ddc8be9136, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var $45d5d5ff9e5b412e$var$validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    $45d5d5ff9e5b412e$export$db3b6bfb95261072(fnDescriptor, (0, $8208d7224f148797$export$1352885233577768), effectName + ": argument fn is undefined or null");
    if ((0, $8208d7224f148797$export$86951950244e2001)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, $8208d7224f148797$export$2f23118c22fb2630)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        $45d5d5ff9e5b412e$export$db3b6bfb95261072(fn, (0, $8208d7224f148797$export$1352885233577768), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, $8208d7224f148797$export$be5493f9613cbbe)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        $45d5d5ff9e5b412e$export$db3b6bfb95261072(fn, (0, $8208d7224f148797$export$1352885233577768), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        $45d5d5ff9e5b412e$export$db3b6bfb95261072(fnDescriptor, (0, $8208d7224f148797$export$86951950244e2001), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, $8208d7224f148797$export$22b082955e083ec3)(fn)) {
        $45d5d5ff9e5b412e$export$db3b6bfb95261072(context[fn], (0, $8208d7224f148797$export$86951950244e2001), effectName + ": context arguments has no such method - \"" + fn + "\"");
        return;
    }
    $45d5d5ff9e5b412e$export$db3b6bfb95261072(fn, (0, $8208d7224f148797$export$86951950244e2001), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function $45d5d5ff9e5b412e$var$getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, $8208d7224f148797$export$86951950244e2001)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, $8208d7224f148797$export$2f23118c22fb2630)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, $8208d7224f148797$export$22b082955e083ec3)(fn) && (0, $8208d7224f148797$export$86951950244e2001)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var $45d5d5ff9e5b412e$var$isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== $45d5d5ff9e5b412e$export$3722cfe417b6ed86;
};
function $45d5d5ff9e5b412e$export$c4ce752e73470fba(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var arg0;
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$e7094788287c5e9b, $45d5d5ff9e5b412e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $45d5d5ff9e5b412e$export$34aec0b863436764(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$e7094788287c5e9b, $45d5d5ff9e5b412e$var$getFnCallDescriptor([
        context,
        fn
    ], args));
}
function $45d5d5ff9e5b412e$export$3c2fa207a37baaea(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$407448d2b89b1813, $45d5d5ff9e5b412e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$d66501df72047452, $45d5d5ff9e5b412e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $45d5d5ff9e5b412e$export$ce26c07117d59d6a(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $45d5d5ff9e5b412e$export$3466f893ebf79586($45d5d5ff9e5b412e$export$3a1a48c8f6ef640e.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function $45d5d5ff9e5b412e$export$6559d589eb85fbb6(taskOrTasks) {
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$b4171a6734a65d42, taskOrTasks);
}
function $45d5d5ff9e5b412e$export$a07804094c3ecf2d(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, $05d10e651fe8cb91$export$3f4d38f8b89bfda7);
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$8b22cf2602fb60ce, taskOrTasks);
}
function $45d5d5ff9e5b412e$export$efca4cbe5dd06740(selector) {
    if (selector === void 0) selector = $45d5d5ff9e5b412e$export$7f8ddf7c7c20b3cd;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$25ce5a424b770e84, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function $45d5d5ff9e5b412e$export$3a6d5c9ae78a2c08(pattern$1, buffer$1) {
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$4368d992c4eafac0, {
        pattern: pattern$1,
        buffer: buffer$1
    });
}
function $45d5d5ff9e5b412e$export$a8550f7dbe79f93a() {
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$2d1720544b23b823, {});
}
function $45d5d5ff9e5b412e$export$2e2af4578d910ddf(channel$1) {
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$39b482c5e57630a8, channel$1);
}
function $45d5d5ff9e5b412e$export$a93c5207d687da10(prop) {
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$2329c99376c9d0a4, prop);
}
function $45d5d5ff9e5b412e$export$c3950d9923825c02(props) {
    return $45d5d5ff9e5b412e$var$makeEffect($45d5d5ff9e5b412e$export$dda1d9f60106f0e9, props);
}
var $45d5d5ff9e5b412e$export$3722cfe417b6ed86 = /*#__PURE__*/ $45d5d5ff9e5b412e$export$c4ce752e73470fba.bind(null, (0, $1c08c370c926c31e$export$2e2bcd8739ae039));


function $973b2c0da971f80e$var$deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function $973b2c0da971f80e$export$368f32fb8739d33c(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($973b2c0da971f80e$var$deferred());
    return arr;
}
var $973b2c0da971f80e$export$2e2bcd8739ae039 = $973b2c0da971f80e$var$deferred;



var $c2bb61c8a2f6b79d$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $c2bb61c8a2f6b79d$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $c2bb61c8a2f6b79d$var$exec(task) {
    try {
        $c2bb61c8a2f6b79d$var$suspend();
        task();
    } finally{
        $c2bb61c8a2f6b79d$var$release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function $c2bb61c8a2f6b79d$var$asap(task) {
    $c2bb61c8a2f6b79d$var$queue.push(task);
    if (!$c2bb61c8a2f6b79d$var$semaphore) {
        $c2bb61c8a2f6b79d$var$suspend();
        $c2bb61c8a2f6b79d$var$flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function $c2bb61c8a2f6b79d$var$immediately(task) {
    try {
        $c2bb61c8a2f6b79d$var$suspend();
        return task();
    } finally{
        $c2bb61c8a2f6b79d$var$flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function $c2bb61c8a2f6b79d$var$suspend() {
    $c2bb61c8a2f6b79d$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $c2bb61c8a2f6b79d$var$release() {
    $c2bb61c8a2f6b79d$var$semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function $c2bb61c8a2f6b79d$var$flush() {
    $c2bb61c8a2f6b79d$var$release();
    var task;
    while(!$c2bb61c8a2f6b79d$var$semaphore && (task = $c2bb61c8a2f6b79d$var$queue.shift()) !== undefined)$c2bb61c8a2f6b79d$var$exec(task);
}
var $c2bb61c8a2f6b79d$var$array = function array(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return $c2bb61c8a2f6b79d$var$matcher(p)(input);
        });
    };
};
var $c2bb61c8a2f6b79d$var$predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var $c2bb61c8a2f6b79d$var$string = function string(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var $c2bb61c8a2f6b79d$var$symbol = function symbol(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var $c2bb61c8a2f6b79d$var$wildcard = function wildcard() {
    return 0, $45d5d5ff9e5b412e$export$342063e11d6c3cad;
};
function $c2bb61c8a2f6b79d$var$matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === '*' ? $c2bb61c8a2f6b79d$var$wildcard : (0, $8208d7224f148797$export$22b082955e083ec3)(pattern) ? $c2bb61c8a2f6b79d$var$string : (0, $8208d7224f148797$export$2f23118c22fb2630)(pattern) ? $c2bb61c8a2f6b79d$var$array : (0, $8208d7224f148797$export$32b5e46230afa379)(pattern) ? $c2bb61c8a2f6b79d$var$string : (0, $8208d7224f148797$export$86951950244e2001)(pattern) ? $c2bb61c8a2f6b79d$var$predicate : (0, $8208d7224f148797$export$8f701197936bc2a6)(pattern) ? $c2bb61c8a2f6b79d$var$symbol : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var $c2bb61c8a2f6b79d$export$32239d68d9c6cb49 = {
    type: (0, $05d10e651fe8cb91$export$3281fbb3edc9dee3)
};
var $c2bb61c8a2f6b79d$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === (0, $05d10e651fe8cb91$export$3281fbb3edc9dee3);
};
var $c2bb61c8a2f6b79d$var$CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var $c2bb61c8a2f6b79d$var$INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var $c2bb61c8a2f6b79d$var$UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function $c2bb61c8a2f6b79d$export$1f95fbd68d964d36(buffer$1) {
    if (buffer$1 === void 0) buffer$1 = (0, $45d5d5ff9e5b412e$export$f1e1789686576879)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $45d5d5ff9e5b412e$export$23f2a1d2818174ef)($c2bb61c8a2f6b79d$var$CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$1.isEmpty()) throw (0, $45d5d5ff9e5b412e$export$23f2a1d2818174ef)('Cannot have pending takers with non empty buffer');
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$1.isEmpty()) cb($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
        else if (!buffer$1.isEmpty()) cb(buffer$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, $45d5d5ff9e5b412e$export$43caf9889c228507)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$1.isEmpty()) {
            cb($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function $c2bb61c8a2f6b79d$export$dfc3101b3180c292(subscribe, buffer) {
    if (buffer === void 0) buffer = (0, $45d5d5ff9e5b412e$export$7ccc53e8f1e7dfc5)();
    var closed = false;
    var unsubscribe;
    var chan = $c2bb61c8a2f6b79d$export$1f95fbd68d964d36(buffer);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, $8208d7224f148797$export$86951950244e2001)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if ($c2bb61c8a2f6b79d$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, $45d5d5ff9e5b412e$export$ae1af26003f05816)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $c2bb61c8a2f6b79d$export$438eddf2fd884f37() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, $45d5d5ff9e5b412e$export$23f2a1d2818174ef)($c2bb61c8a2f6b79d$var$CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
        });
    };
    return _ref = {}, _ref[0, $05d10e651fe8cb91$export$9074c4e62c4e51bb] = true, _ref.put = function put(input) {
        if (closed) return;
        if ($c2bb61c8a2f6b79d$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, $05d10e651fe8cb91$export$5a1a83be8f503735](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher) {
        if (matcher === void 0) matcher = $c2bb61c8a2f6b79d$var$wildcard;
        if (closed) {
            cb($c2bb61c8a2f6b79d$export$32239d68d9c6cb49);
            return;
        }
        cb[0, $05d10e651fe8cb91$export$5a1a83be8f503735] = matcher;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, $45d5d5ff9e5b412e$export$ae1af26003f05816)(function() {
            ensureCanMutateNextTakers();
            (0, $45d5d5ff9e5b412e$export$43caf9889c228507)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function $c2bb61c8a2f6b79d$export$e987d166a3a4f3ec() {
    var chan = $c2bb61c8a2f6b79d$export$438eddf2fd884f37();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, $05d10e651fe8cb91$export$7d963e45ecdffba1]) {
            put(input);
            return;
        }
        $c2bb61c8a2f6b79d$var$asap(function() {
            put(input);
        });
    };
    return chan;
}
var $c2bb61c8a2f6b79d$var$RUNNING = 0;
var $c2bb61c8a2f6b79d$var$CANCELLED = 1;
var $c2bb61c8a2f6b79d$var$ABORTED = 2;
var $c2bb61c8a2f6b79d$var$DONE = 3;
function $c2bb61c8a2f6b79d$var$resolvePromise(promise, cb) {
    var cancelPromise = promise[0, $05d10e651fe8cb91$export$2b10f4b30fb65583];
    if ((0, $8208d7224f148797$export$86951950244e2001)(cancelPromise)) cb.cancel = cancelPromise;
    promise.then(cb, function(error) {
        cb(error, true);
    });
}
var $c2bb61c8a2f6b79d$var$current = 0;
var $c2bb61c8a2f6b79d$var$nextSagaId = function() {
    return ++$c2bb61c8a2f6b79d$var$current;
};
var $c2bb61c8a2f6b79d$var$_effectRunnerMap;
function $c2bb61c8a2f6b79d$var$getIteratorMetaInfo(iterator, fn) {
    if (iterator.isSagaIterator) return {
        name: iterator.meta.name
    };
    return (0, $45d5d5ff9e5b412e$export$35e795649ee09318)(fn);
}
function $c2bb61c8a2f6b79d$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, $8208d7224f148797$export$6f58e2338da23f4d)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, $8208d7224f148797$export$c957ef27a0ebfd4)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, $45d5d5ff9e5b412e$export$9e5f44173e64f162)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, $45d5d5ff9e5b412e$export$9e5f44173e64f162)(function() {
            throw err;
        });
    }
}
function $c2bb61c8a2f6b79d$var$runPutEffect(env, _ref2, cb) {
    var channel = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ $c2bb61c8a2f6b79d$var$asap(function() {
        var result;
        try {
            result = (channel ? channel.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, $8208d7224f148797$export$c957ef27a0ebfd4)(result)) $c2bb61c8a2f6b79d$var$resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function $c2bb61c8a2f6b79d$var$runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if ($c2bb61c8a2f6b79d$export$42af6f45c6e0d09f(input) && !maybe) {
            cb((0, $05d10e651fe8cb91$export$d966e43d90bf4c05));
            return;
        }
        cb(input);
    };
    try {
        channel.take(takeCb, (0, $8208d7224f148797$export$1352885233577768)(pattern) ? $c2bb61c8a2f6b79d$var$matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function $c2bb61c8a2f6b79d$var$runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, $8208d7224f148797$export$c957ef27a0ebfd4)(result)) {
            $c2bb61c8a2f6b79d$var$resolvePromise(result, cb);
            return;
        }
        if ((0, $8208d7224f148797$export$6f58e2338da23f4d)(result)) {
            // resolve iterator
            $c2bb61c8a2f6b79d$var$proc(env, result, task.context, $c2bb61c8a2f6b79d$var$current, (0, $45d5d5ff9e5b412e$export$35e795649ee09318)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function $c2bb61c8a2f6b79d$var$runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, $8208d7224f148797$export$c7b6444af1f098df)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function $c2bb61c8a2f6b79d$var$runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = $c2bb61c8a2f6b79d$var$createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = $c2bb61c8a2f6b79d$var$getIteratorMetaInfo(taskIterator, fn);
    $c2bb61c8a2f6b79d$var$immediately(function() {
        var child = $c2bb61c8a2f6b79d$var$proc(env, taskIterator, parent.context, $c2bb61c8a2f6b79d$var$current, meta, detached, undefined);
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function $c2bb61c8a2f6b79d$var$runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                if (taskToJoin.isRunning()) (0, $45d5d5ff9e5b412e$export$43caf9889c228507)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, $8208d7224f148797$export$2f23118c22fb2630)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, $45d5d5ff9e5b412e$export$882b5998b3b9117c)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function $c2bb61c8a2f6b79d$var$cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function $c2bb61c8a2f6b79d$var$runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, $05d10e651fe8cb91$export$3f4d38f8b89bfda7)) $c2bb61c8a2f6b79d$var$cancelSingleTask(task);
    else if ((0, $8208d7224f148797$export$2f23118c22fb2630)(taskOrTasks)) taskOrTasks.forEach($c2bb61c8a2f6b79d$var$cancelSingleTask);
    else $c2bb61c8a2f6b79d$var$cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function $c2bb61c8a2f6b79d$var$runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = $c2bb61c8a2f6b79d$var$current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, $8208d7224f148797$export$2f23118c22fb2630)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, $45d5d5ff9e5b412e$export$882b5998b3b9117c)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function $c2bb61c8a2f6b79d$var$runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = $c2bb61c8a2f6b79d$var$current;
    var keys = Object.keys(effects);
    var response = (0, $8208d7224f148797$export$2f23118c22fb2630)(effects) ? (0, $45d5d5ff9e5b412e$export$953cecd6e717a553)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, $45d5d5ff9e5b412e$export$2408f22a0fab9ae5)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function $c2bb61c8a2f6b79d$var$runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function $c2bb61c8a2f6b79d$var$runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer = _ref14.buffer;
    var chan = $c2bb61c8a2f6b79d$export$1f95fbd68d964d36(buffer);
    var match = $c2bb61c8a2f6b79d$var$matcher(pattern);
    var taker = function taker(action) {
        if (!$c2bb61c8a2f6b79d$export$42af6f45c6e0d09f(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function $c2bb61c8a2f6b79d$var$runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function $c2bb61c8a2f6b79d$var$runFlushEffect(env, channel, cb) {
    channel.flush(cb);
}
function $c2bb61c8a2f6b79d$var$runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function $c2bb61c8a2f6b79d$var$runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, $45d5d5ff9e5b412e$export$ffb5f4729a158638)(task.context, props);
    cb();
}
var $c2bb61c8a2f6b79d$var$effectRunnerMap = ($c2bb61c8a2f6b79d$var$_effectRunnerMap = {}, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$971d5caa766a69d7] = $c2bb61c8a2f6b79d$var$runTakeEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$56c0d5a1e737357d] = $c2bb61c8a2f6b79d$var$runPutEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$ebd11618f299a286] = $c2bb61c8a2f6b79d$var$runAllEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$db202ddc8be9136] = $c2bb61c8a2f6b79d$var$runRaceEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$e7094788287c5e9b] = $c2bb61c8a2f6b79d$var$runCallEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$407448d2b89b1813] = $c2bb61c8a2f6b79d$var$runCPSEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$d66501df72047452] = $c2bb61c8a2f6b79d$var$runForkEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$b4171a6734a65d42] = $c2bb61c8a2f6b79d$var$runJoinEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$8b22cf2602fb60ce] = $c2bb61c8a2f6b79d$var$runCancelEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$25ce5a424b770e84] = $c2bb61c8a2f6b79d$var$runSelectEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$4368d992c4eafac0] = $c2bb61c8a2f6b79d$var$runChannelEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$2d1720544b23b823] = $c2bb61c8a2f6b79d$var$runCancelledEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$39b482c5e57630a8] = $c2bb61c8a2f6b79d$var$runFlushEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$2329c99376c9d0a4] = $c2bb61c8a2f6b79d$var$runGetContextEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap[0, $45d5d5ff9e5b412e$export$dda1d9f60106f0e9] = $c2bb61c8a2f6b79d$var$runSetContextEffect, $c2bb61c8a2f6b79d$var$_effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function $c2bb61c8a2f6b79d$var$forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $45d5d5ff9e5b412e$export$43caf9889c228507)(tasks, task);
            task.cont = (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function $c2bb61c8a2f6b79d$var$formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function $c2bb61c8a2f6b79d$var$effectLocationAsString(effect) {
    var location = (0, $45d5d5ff9e5b412e$export$90a7f3efeed30595)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + $c2bb61c8a2f6b79d$var$formatLocation(fileName, lineNumber);
        return source;
    }
    return '';
}
function $c2bb61c8a2f6b79d$var$sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + $c2bb61c8a2f6b79d$var$formatLocation(location.fileName, location.lineNumber);
    return name;
}
function $c2bb61c8a2f6b79d$var$cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, $45d5d5ff9e5b412e$export$3b14a55fb2447963)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return '';
    return [
        'Tasks cancelled due to error:'
    ].concat(cancelledTasks).join('\n');
}
var $c2bb61c8a2f6b79d$var$crashedEffect = null;
var $c2bb61c8a2f6b79d$var$sagaStack = [];
var $c2bb61c8a2f6b79d$var$addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = $c2bb61c8a2f6b79d$var$crashedEffect;
    $c2bb61c8a2f6b79d$var$sagaStack.push(frame);
};
var $c2bb61c8a2f6b79d$var$clear = function clear() {
    $c2bb61c8a2f6b79d$var$crashedEffect = null;
    $c2bb61c8a2f6b79d$var$sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var $c2bb61c8a2f6b79d$var$setCrashedEffect = function setCrashedEffect(effect) {
    $c2bb61c8a2f6b79d$var$crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var $c2bb61c8a2f6b79d$var$toString = function toString() {
    var firstSaga = $c2bb61c8a2f6b79d$var$sagaStack[0], otherSagas = $c2bb61c8a2f6b79d$var$sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? $c2bb61c8a2f6b79d$var$effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + $c2bb61c8a2f6b79d$var$sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + $c2bb61c8a2f6b79d$var$sagaLocationAsString(s.meta);
    }), [
        $c2bb61c8a2f6b79d$var$cancelledTasksAsString($c2bb61c8a2f6b79d$var$sagaStack)
    ]).join('\n');
};
function $c2bb61c8a2f6b79d$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    if (cont === void 0) cont = (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
    var status = $c2bb61c8a2f6b79d$var$RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = $c2bb61c8a2f6b79d$var$forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === $c2bb61c8a2f6b79d$var$RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = $c2bb61c8a2f6b79d$var$CANCELLED;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, $05d10e651fe8cb91$export$a47f788ef0b36709), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, $05d10e651fe8cb91$export$a47f788ef0b36709)) status = $c2bb61c8a2f6b79d$var$CANCELLED;
            else if (status !== $c2bb61c8a2f6b79d$var$CANCELLED) status = $c2bb61c8a2f6b79d$var$DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = $c2bb61c8a2f6b79d$var$ABORTED;
            $c2bb61c8a2f6b79d$var$addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = $c2bb61c8a2f6b79d$var$toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                $c2bb61c8a2f6b79d$var$clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, $45d5d5ff9e5b412e$export$ffb5f4729a158638)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, $973b2c0da971f80e$export$2e2bcd8739ae039)();
        if (status === $c2bb61c8a2f6b79d$var$ABORTED) deferredEnd.reject(taskError);
        else if (status !== $c2bb61c8a2f6b79d$var$RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, $05d10e651fe8cb91$export$9355e489ad16f98e] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === $c2bb61c8a2f6b79d$var$RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === $c2bb61c8a2f6b79d$var$CANCELLED || status === $c2bb61c8a2f6b79d$var$RUNNING && mainTask.status === $c2bb61c8a2f6b79d$var$CANCELLED;
    }, _task.isAborted = function isAborted() {
        return status === $c2bb61c8a2f6b79d$var$ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function $c2bb61c8a2f6b79d$var$proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: $c2bb61c8a2f6b79d$var$RUNNING
    };
    /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/ var task = $c2bb61c8a2f6b79d$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/ function cancelMain() {
        if (mainTask.status === $c2bb61c8a2f6b79d$var$RUNNING) {
            mainTask.status = $c2bb61c8a2f6b79d$var$CANCELLED;
            next((0, $05d10e651fe8cb91$export$a47f788ef0b36709));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ if (cont) cont.cancel = task.cancel;
     // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values
                $c2bb61c8a2f6b79d$var$clear();
            } else if ((0, $45d5d5ff9e5b412e$export$4a5767248b18ef41)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = $c2bb61c8a2f6b79d$var$CANCELLED;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $8208d7224f148797$export$86951950244e2001)(iterator$1.return) ? iterator$1.return((0, $05d10e651fe8cb91$export$a47f788ef0b36709)) : {
                    done: true,
                    value: (0, $05d10e651fe8cb91$export$a47f788ef0b36709)
                };
            } else if ((0, $45d5d5ff9e5b412e$export$df995fae86a55f06)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $8208d7224f148797$export$86951950244e2001)(iterator$1.return) ? iterator$1.return() : {
                done: true
            };
            else result = iterator$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== $c2bb61c8a2f6b79d$var$CANCELLED) mainTask.status = $c2bb61c8a2f6b79d$var$DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === $c2bb61c8a2f6b79d$var$CANCELLED) throw error;
            mainTask.status = $c2bb61c8a2f6b79d$var$ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, $8208d7224f148797$export$c957ef27a0ebfd4)(effect)) $c2bb61c8a2f6b79d$var$resolvePromise(effect, currCb);
        else if ((0, $8208d7224f148797$export$6f58e2338da23f4d)(effect)) // resolve iterator
        $c2bb61c8a2f6b79d$var$proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, $05d10e651fe8cb91$export$8f8422ac5947a789]) {
            var effectRunner = $c2bb61c8a2f6b79d$var$effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = '';
        var effectId = $c2bb61c8a2f6b79d$var$nextSagaId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) $c2bb61c8a2f6b79d$var$setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var $c2bb61c8a2f6b79d$var$RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var $c2bb61c8a2f6b79d$var$NON_GENERATOR_ERR = $c2bb61c8a2f6b79d$var$RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function $c2bb61c8a2f6b79d$export$3d8d44bf0c43bb61(_ref, saga) {
    var _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $c2bb61c8a2f6b79d$export$e987d166a3a4f3ec() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, $45d5d5ff9e5b412e$export$96f57966bedc81b4) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$1 = saga.apply(void 0, args);
    var effectId = $c2bb61c8a2f6b79d$var$nextSagaId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $45d5d5ff9e5b412e$export$625550452a3fa3ec);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, $45d5d5ff9e5b412e$export$ef35774e6d314e91).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, $45d5d5ff9e5b412e$export$7f8ddf7c7c20b3cd);
    var env = {
        channel: channel,
        dispatch: (0, $45d5d5ff9e5b412e$export$a9c23c6ac3fc3eca)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return $c2bb61c8a2f6b79d$var$immediately(function() {
        var task = $c2bb61c8a2f6b79d$var$proc(env, iterator$1, context, effectId, (0, $45d5d5ff9e5b412e$export$35e795649ee09318)(saga), /* isRoot */ true, undefined);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function $c2bb61c8a2f6b79d$var$sagaMiddlewareFactory(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $c2bb61c8a2f6b79d$export$e987d166a3a4f3ec() : _ref$channel, sagaMonitor = _ref.sagaMonitor, options = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_ref, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        boundRunSaga = $c2bb61c8a2f6b79d$export$3d8d44bf0c43bb61.bind(null, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, options, {
            context: context,
            channel: channel,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, $45d5d5ff9e5b412e$export$ffb5f4729a158638)(context, props);
    };
    return sagaMiddleware;
}
var $c2bb61c8a2f6b79d$export$2e2bcd8739ae039 = $c2bb61c8a2f6b79d$var$sagaMiddlewareFactory;


var $e77394150e9d59e6$export$2e2bcd8739ae039 = (0, $c2bb61c8a2f6b79d$export$2e2bcd8739ae039);


var $60658be5529a36bf$export$1e511d4a378977f5;
var $60658be5529a36bf$export$d32324a03b6bde1b;
var $60658be5529a36bf$export$321b1ffcca858b2b;
'use strict';

var $60658be5529a36bf$require$compose = $b4bc487a38c3f200$export$f672e0b6f7222cd7;
$60658be5529a36bf$export$1e511d4a378977f5 = true;
$60658be5529a36bf$export$d32324a03b6bde1b = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === 'object') return $60658be5529a36bf$require$compose;
    return $60658be5529a36bf$require$compose.apply(null, arguments);
};
$60658be5529a36bf$export$321b1ffcca858b2b = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};



function $4d71ee434250a1d3$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $4d71ee434250a1d3$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $4d71ee434250a1d3$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $4d71ee434250a1d3$var$isAbsolute(to);
    var isFromAbs = from && $4d71ee434250a1d3$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $4d71ee434250a1d3$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $4d71ee434250a1d3$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $4d71ee434250a1d3$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $4d71ee434250a1d3$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$4d71ee434250a1d3$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $4d71ee434250a1d3$export$2e2bcd8739ae039 = $4d71ee434250a1d3$var$resolvePathname;


function $02e2bfdd0166f2f6$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $02e2bfdd0166f2f6$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $02e2bfdd0166f2f6$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $02e2bfdd0166f2f6$var$valueOf(a);
        var bValue = $02e2bfdd0166f2f6$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $02e2bfdd0166f2f6$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $02e2bfdd0166f2f6$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $02e2bfdd0166f2f6$export$2e2bcd8739ae039 = $02e2bfdd0166f2f6$var$valueEqual;



var $d23b6a4945e6cbc3$var$isProduction = true;
var $d23b6a4945e6cbc3$var$prefix = 'Invariant failed';
function $d23b6a4945e6cbc3$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($d23b6a4945e6cbc3$var$isProduction) throw new Error($d23b6a4945e6cbc3$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($d23b6a4945e6cbc3$var$prefix, ": ").concat(provided) : $d23b6a4945e6cbc3$var$prefix;
    throw new Error(value);
}


function $0e3a6b1020765bd1$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $0e3a6b1020765bd1$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $0e3a6b1020765bd1$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $0e3a6b1020765bd1$var$stripBasename(path, prefix) {
    return $0e3a6b1020765bd1$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $0e3a6b1020765bd1$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $0e3a6b1020765bd1$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $0e3a6b1020765bd1$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $0e3a6b1020765bd1$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $6767be368738adce$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $4d71ee434250a1d3$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $0e3a6b1020765bd1$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $02e2bfdd0166f2f6$export$2e2bcd8739ae039)(a.state, b.state);
}
function $0e3a6b1020765bd1$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $0e3a6b1020765bd1$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $0e3a6b1020765bd1$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $0e3a6b1020765bd1$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $0e3a6b1020765bd1$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $0e3a6b1020765bd1$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $0e3a6b1020765bd1$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $0e3a6b1020765bd1$var$PopStateEvent = 'popstate';
var $0e3a6b1020765bd1$var$HashChangeEvent = 'hashchange';
function $0e3a6b1020765bd1$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $0e3a6b1020765bd1$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$0e3a6b1020765bd1$var$canUseDOM && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $0e3a6b1020765bd1$var$supportsHistory();
    var needsHashChangeListener = !$0e3a6b1020765bd1$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $0e3a6b1020765bd1$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $0e3a6b1020765bd1$var$stripTrailingSlash($0e3a6b1020765bd1$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $0e3a6b1020765bd1$var$stripBasename(path, basename);
        return $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $0e3a6b1020765bd1$var$createTransitionManager();
    function setState(nextState) {
        (0, $6767be368738adce$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($0e3a6b1020765bd1$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($0e3a6b1020765bd1$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($0e3a6b1020765bd1$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $0e3a6b1020765bd1$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($0e3a6b1020765bd1$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($0e3a6b1020765bd1$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($0e3a6b1020765bd1$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($0e3a6b1020765bd1$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $0e3a6b1020765bd1$var$HashChangeEvent$1 = 'hashchange';
var $0e3a6b1020765bd1$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $0e3a6b1020765bd1$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $0e3a6b1020765bd1$var$stripLeadingSlash,
        decodePath: $0e3a6b1020765bd1$var$addLeadingSlash
    },
    slash: {
        encodePath: $0e3a6b1020765bd1$var$addLeadingSlash,
        decodePath: $0e3a6b1020765bd1$var$addLeadingSlash
    }
};
function $0e3a6b1020765bd1$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $0e3a6b1020765bd1$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $0e3a6b1020765bd1$var$pushHashPath(path) {
    window.location.hash = path;
}
function $0e3a6b1020765bd1$var$replaceHashPath(path) {
    window.location.replace($0e3a6b1020765bd1$var$stripHash(window.location.href) + '#' + path);
}
function $0e3a6b1020765bd1$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$0e3a6b1020765bd1$var$canUseDOM && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $0e3a6b1020765bd1$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $0e3a6b1020765bd1$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $0e3a6b1020765bd1$var$stripTrailingSlash($0e3a6b1020765bd1$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $0e3a6b1020765bd1$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($0e3a6b1020765bd1$var$getHashPath());
        if (basename) path = $0e3a6b1020765bd1$var$stripBasename(path, basename);
        return $0e3a6b1020765bd1$export$90c043f1c57770b8(path);
    }
    var transitionManager = $0e3a6b1020765bd1$var$createTransitionManager();
    function setState(nextState) {
        (0, $6767be368738adce$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $0e3a6b1020765bd1$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $0e3a6b1020765bd1$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $0e3a6b1020765bd1$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($0e3a6b1020765bd1$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($0e3a6b1020765bd1$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $0e3a6b1020765bd1$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $0e3a6b1020765bd1$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $0e3a6b1020765bd1$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $0e3a6b1020765bd1$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $0e3a6b1020765bd1$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $0e3a6b1020765bd1$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $0e3a6b1020765bd1$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $0e3a6b1020765bd1$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($0e3a6b1020765bd1$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $0e3a6b1020765bd1$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $0e3a6b1020765bd1$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $0e3a6b1020765bd1$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($0e3a6b1020765bd1$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($0e3a6b1020765bd1$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($0e3a6b1020765bd1$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $0e3a6b1020765bd1$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $0e3a6b1020765bd1$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $0e3a6b1020765bd1$var$createTransitionManager();
    function setState(nextState) {
        (0, $6767be368738adce$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $0e3a6b1020765bd1$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $0e3a6b1020765bd1$export$90c043f1c57770b8(entry, undefined, createKey()) : $0e3a6b1020765bd1$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $0e3a6b1020765bd1$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $0e3a6b1020765bd1$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $0e3a6b1020765bd1$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}


const $3b7d72a70d6ed09c$export$be84bd1ba815d4c2 = '@@router/LOCATION_CHANGE';
const $3b7d72a70d6ed09c$export$d035cdafa5d37a89 = '@@router/CALL_HISTORY_METHOD';
var $3b7d72a70d6ed09c$export$cb91a8c42229ee94 = /*#__PURE__*/ function(RouterActionType) {
    RouterActionType["PUSH"] = "PUSH";
    RouterActionType["REPLACE"] = "REPLACE";
    RouterActionType["GO"] = "GO";
    RouterActionType["GO_BACK"] = "GO_BACK";
    RouterActionType["GO_FORWARD"] = "GO_FORWARD";
    return RouterActionType;
}({});
const $3b7d72a70d6ed09c$export$4cbf152802aa238 = (path, state)=>({
        type: $3b7d72a70d6ed09c$export$d035cdafa5d37a89,
        payload: {
            method: "PUSH",
            args: [
                path,
                state
            ]
        }
    });
const $3b7d72a70d6ed09c$export$77ad94ebf1c2b9ed = (path, state)=>({
        type: $3b7d72a70d6ed09c$export$d035cdafa5d37a89,
        payload: {
            method: "REPLACE",
            args: [
                path,
                state
            ]
        }
    });
const $3b7d72a70d6ed09c$export$93bb224d05b3906d = (index)=>({
        type: $3b7d72a70d6ed09c$export$d035cdafa5d37a89,
        payload: {
            method: "GO",
            args: [
                index
            ]
        }
    });
const $3b7d72a70d6ed09c$export$28fca2ccfd38b8f = ()=>({
        type: $3b7d72a70d6ed09c$export$d035cdafa5d37a89,
        payload: {
            method: "GO_BACK",
            args: []
        }
    });
const $3b7d72a70d6ed09c$export$994d0e87e52ba8e3 = ()=>({
        type: $3b7d72a70d6ed09c$export$d035cdafa5d37a89,
        payload: {
            method: "GO_FORWARD",
            args: []
        }
    });
const $3b7d72a70d6ed09c$export$1fe5128387816284 = (history)=>(store)=>(next)=>(action)=>{
                if (action.type !== $3b7d72a70d6ed09c$export$d035cdafa5d37a89) return next(action);
                const { method: method, args: args } = action.payload;
                switch(method){
                    case "PUSH":
                        history.push(...args);
                        break;
                    case "REPLACE":
                        history.replace(...args);
                        break;
                    case "GO":
                        history.go(...args);
                        break;
                    case "GO_BACK":
                        history.goBack();
                        break;
                    case "GO_FORWARD":
                        history.goForward();
                        break;
                    default:
                        break;
                }
                return next(action);
            };
const $3b7d72a70d6ed09c$export$4360105d0eb5a11c = (history)=>{
    const initialState = {
        location: history.location,
        action: history.action
    };
    return (state = initialState, action)=>{
        if (action.type === $3b7d72a70d6ed09c$export$be84bd1ba815d4c2) return {
            ...state,
            location: action.payload.location,
            action: action.payload.action
        };
        return state;
    };
};
const $3b7d72a70d6ed09c$export$5a3c9ae1fa6d7e61 = (history, store)=>{
    const handleLocationChange = (location, action)=>{
        store.dispatch({
            type: $3b7d72a70d6ed09c$export$be84bd1ba815d4c2,
            payload: {
                location: location,
                action: action,
                isFirstRendering: false,
                state: window.history.state
            }
        });
    };
    // Listen for location changes and dispatch them to the store
    const unlisten = history.listen(handleLocationChange);
    // Dispatch initial location
    store.dispatch({
        type: $3b7d72a70d6ed09c$export$be84bd1ba815d4c2,
        payload: {
            location: history.location,
            action: history.action,
            isFirstRendering: true,
            state: window.history.state
        }
    });
    return unlisten;
};








var $17b5b1be37557756$var$done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var $17b5b1be37557756$var$qEnd = {};
function $17b5b1be37557756$var$safeName(patternOrChannel) {
    if ((0, $8208d7224f148797$export$1f95fbd68d964d36)(patternOrChannel)) return 'channel';
    if ((0, $8208d7224f148797$export$32b5e46230afa379)(patternOrChannel)) return String(patternOrChannel);
    if ((0, $8208d7224f148797$export$86951950244e2001)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function $17b5b1be37557756$var$fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === $17b5b1be37557756$var$qEnd) return $17b5b1be37557756$var$done(arg);
        if (error && !errorState) {
            nextState = $17b5b1be37557756$var$qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === $17b5b1be37557756$var$qEnd ? $17b5b1be37557756$var$done(arg) : effect;
        }
    }
    return (0, $45d5d5ff9e5b412e$export$9e5f44173e64f162)(next, function(error) {
        return next(null, error);
    }, name);
}
function $17b5b1be37557756$var$takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $45d5d5ff9e5b412e$export$61196ced6d74a310)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q1',
                effect: yFork(action)
            };
        }
    }, 'q1', "takeEvery(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $17b5b1be37557756$var$takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $45d5d5ff9e5b412e$export$61196ced6d74a310)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $45d5d5ff9e5b412e$export$a07804094c3ecf2d)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: 'q3',
                effect: yCancel(task)
            } : {
                nextState: 'q1',
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: 'q1',
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, 'q1', "takeLatest(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $17b5b1be37557756$var$takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $45d5d5ff9e5b412e$export$61196ced6d74a310)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q1',
                effect: yCall(action)
            };
        }
    }, 'q1', "takeLeading(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $17b5b1be37557756$var$throttle(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$1;
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $45d5d5ff9e5b412e$export$61196ced6d74a310)(channel$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $45d5d5ff9e5b412e$export$3722cfe417b6ed86)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$1 = ch;
    };
    var needsChannel = !(0, $8208d7224f148797$export$1f95fbd68d964d36)(patternOrChannel);
    if (!needsChannel) setChannel(patternOrChannel);
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            var yActionChannel = {
                done: false,
                value: (0, $45d5d5ff9e5b412e$export$3a6d5c9ae78a2c08)(patternOrChannel, (0, $45d5d5ff9e5b412e$export$e7c866399fa523f5)(1))
            };
            return {
                nextState: 'q2',
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: 'q3',
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: 'q4',
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: 'q2',
                effect: yDelay
            };
        }
    }, needsChannel ? 'q1' : 'q2', "throttle(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $17b5b1be37557756$var$retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, $45d5d5ff9e5b412e$export$3722cfe417b6ed86)(delayLength)
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yCall,
                errorState: 'q10'
            };
        },
        q2: function q2() {
            return {
                nextState: $17b5b1be37557756$var$qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: 'q1',
                effect: yDelay
            };
        }
    }, 'q1', "retry(" + fn.name + ")");
}
function $17b5b1be37557756$var$debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, $45d5d5ff9e5b412e$export$61196ced6d74a310)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, $45d5d5ff9e5b412e$export$71cec2538cb2c617)({
            action: (0, $45d5d5ff9e5b412e$export$61196ced6d74a310)(patternOrChannel),
            debounce: (0, $45d5d5ff9e5b412e$export$3722cfe417b6ed86)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return $17b5b1be37557756$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q3',
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: 'q1',
                effect: yFork(action)
            } : {
                nextState: 'q2',
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, 'q1', "debounce(" + $17b5b1be37557756$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
var $17b5b1be37557756$var$validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, $45d5d5ff9e5b412e$export$db3b6bfb95261072)(patternOrChannel, (0, $8208d7224f148797$export$1352885233577768), fn.name + " requires a pattern or channel");
    (0, $45d5d5ff9e5b412e$export$db3b6bfb95261072)(worker, (0, $8208d7224f148797$export$1352885233577768), fn.name + " requires a saga parameter");
};
function $17b5b1be37557756$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
        $17b5b1be37557756$var$takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
        $17b5b1be37557756$var$takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$ab18f80dcccecca4(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
        $17b5b1be37557756$var$takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$de363e709c412c8a(ms, patternOrChannel, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
        $17b5b1be37557756$var$throttle,
        ms,
        patternOrChannel,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$9369b12211e1fce4(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba).apply(void 0, [
        $17b5b1be37557756$var$retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function $17b5b1be37557756$export$61fc7d43ac8f84b0(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e).apply(void 0, [
        $17b5b1be37557756$var$debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}







var $94WEq = parcelRequire("94WEq");
var $649c168665c7425f$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $649c168665c7425f$export$2e2bcd8739ae039 = {
    randomUUID: $649c168665c7425f$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $c2c280843ba50cbb$var$getRandomValues;
var $c2c280843ba50cbb$var$rnds8 = new Uint8Array(16);
function $c2c280843ba50cbb$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$c2c280843ba50cbb$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $c2c280843ba50cbb$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$c2c280843ba50cbb$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $c2c280843ba50cbb$var$getRandomValues($c2c280843ba50cbb$var$rnds8);
}


var $4e4d94e12bdb53af$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $7418090bafe93e4a$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4e4d94e12bdb53af$export$2e2bcd8739ae039).test(uuid);
}
var $7418090bafe93e4a$export$2e2bcd8739ae039 = $7418090bafe93e4a$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $9b0cf9279d5d0a2e$var$byteToHex = [];
for(var $9b0cf9279d5d0a2e$var$i = 0; $9b0cf9279d5d0a2e$var$i < 256; ++$9b0cf9279d5d0a2e$var$i)$9b0cf9279d5d0a2e$var$byteToHex.push(($9b0cf9279d5d0a2e$var$i + 0x100).toString(16).slice(1));
function $9b0cf9279d5d0a2e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 0]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 1]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 2]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 3]] + '-' + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 4]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 5]] + '-' + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 6]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 7]] + '-' + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 8]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 9]] + '-' + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 10]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 11]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 12]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 13]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 14]] + $9b0cf9279d5d0a2e$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $9b0cf9279d5d0a2e$var$stringify(arr, offset = 0) {
    var uuid = $9b0cf9279d5d0a2e$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $7418090bafe93e4a$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $9b0cf9279d5d0a2e$export$2e2bcd8739ae039 = $9b0cf9279d5d0a2e$var$stringify;


function $70c7bcd05bb92b18$var$v4(options, buf, offset) {
    if ((0, $649c168665c7425f$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $649c168665c7425f$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $c2c280843ba50cbb$export$2e2bcd8739ae039))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $9b0cf9279d5d0a2e$export$8fb373d660548968)(rnds);
}
var $70c7bcd05bb92b18$export$2e2bcd8739ae039 = $70c7bcd05bb92b18$var$v4;


var $bd80e90ec7f1f3b2$export$f1bd415280efb039 = /*#__PURE__*/ function(PageActionTypes) {
    PageActionTypes["LOCATION_CHANGE"] = "@@router/LOCATION_CHANGE";
    PageActionTypes["PAGE_REQUEST"] = "@@router/PAGE_REQUEST";
    PageActionTypes["PAGE_SUCCESS"] = "@@page/PAGE_SUCCESS";
    PageActionTypes["CLEAR_FORMS"] = "@@page/CLEAR_FORMS";
    PageActionTypes["SUBMIT_FORM_REQUEST"] = "@@page/SUBMIT_FORM_REQUEST";
    PageActionTypes["ACTIVATE_LOCAL_SHIMMER_SUCCESS"] = "@@page/ACTIVATE_LOCAL_SHIMMER_SUCCESS";
    PageActionTypes["SET_FORM_VALUES_REQUEST"] = "@@page/SET_FORM_VALUES_REQUEST";
    PageActionTypes["SET_FORM_VALUES_SUCCESS"] = "@@page/SET_FORM_VALUES_SUCCESS";
    PageActionTypes["RESET_FORM_VALUES_SUCCESS"] = "@@page/RESET_FORM_VALUES_SUCCESS";
    PageActionTypes["MERGE_STYLE_REQUEST"] = "@@page/MERGE_STYLE_REQUEST";
    PageActionTypes["MERGE_STYLE_SUCCESS"] = "@@page/MERGE_STYLE_SUCCESS";
    PageActionTypes["UPDATE_VARIABLE_REQUEST"] = "@@page/UPDATE_VARIABLE_REQUEST";
    PageActionTypes["UPDATE_VARIABLE_SUCCESS"] = "@@page/UPDATE_VARIABLE_SUCCESS";
    PageActionTypes["UNCHECK_DEPENDENT_RADIO_REQUEST"] = "@@page/UNCHECK_DEPENDENT_RADIO_REQUEST";
    PageActionTypes["UNCHECK_DEPENDENT_RADIO_SUCCESS"] = "@@page/UNCHECK_DEPENDENT_RADIO_SUCCESS";
    PageActionTypes["ACTION_REQUEST"] = "@@page/ACTION_REQUEST";
    PageActionTypes["ACTION_SUCCESS"] = "@@page/ACTION_SUCCESS";
    return PageActionTypes;
}({});




class $2857511e8f5d961e$export$2e2bcd8739ae039 {
    static sessionKey = 'sessionId';
    static sessionId = null;
    // Method to get the sessionId, first from memory then from sessionStorage
    static getSessionId() {
        if (this.sessionId) return this.sessionId;
        try {
            const storedId = sessionStorage.getItem(this.sessionKey);
            if (storedId) {
                this.sessionId = storedId;
                return storedId;
            }
        } catch (error) {
            console.warn('Failed to access sessionStorage:', error);
        }
        return null;
    }
    // Method to set the sessionId in memory and sessionStorage
    static setSessionId(sessionId) {
        this.sessionId = sessionId;
        try {
            sessionStorage.setItem(this.sessionKey, sessionId);
        } catch (error) {
            console.warn('Failed to save to sessionStorage:', error);
        }
    }
    // Method to generate a new sessionId and store it
    static generateSessionId() {
        const sessionId = (0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)();
        this.setSessionId(sessionId);
        return sessionId;
    }
    // Method to clear the sessionId from memory and sessionStorage
    static clearSessionId() {
        this.sessionId = null;
        try {
            sessionStorage.removeItem(this.sessionKey);
        } catch (error) {
            console.warn('Failed to remove from sessionStorage:', error);
        }
    }
    // Method to get or create a sessionId
    static getOrCreateSessionId() {
        let sessionId = this.getSessionId();
        if (!sessionId) sessionId = this.generateSessionId();
        return sessionId;
    }
}



class $7cdaba13c8ba20d3$export$2e2bcd8739ae039 {
    static deviceKey = 'deviceId';
    static deviceId = null;
    // Method to get the deviceId, first from memory then from localStorage
    static getDeviceId() {
        if (this.deviceId) return this.deviceId;
        try {
            const storedId = localStorage.getItem(this.deviceKey);
            if (storedId) {
                this.deviceId = storedId;
                return storedId;
            }
        } catch (error) {
            console.warn('Failed to access localStorage:', error);
        }
        return null;
    }
    // Method to set the deviceId in memory and localStorage
    static setDeviceId(deviceId) {
        this.deviceId = deviceId;
        try {
            localStorage.setItem(this.deviceKey, deviceId);
        } catch (error) {
            console.warn('Failed to save to localStorage:', error);
        }
    }
    // Method to generate a new deviceId and store it
    static generateDeviceId() {
        const deviceId = (0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)();
        this.setDeviceId(deviceId);
        return deviceId;
    }
    // Method to clear the deviceId from memory and localStorage
    static clearDeviceId() {
        this.deviceId = null;
        try {
            localStorage.removeItem(this.deviceKey);
        } catch (error) {
            console.warn('Failed to remove from localStorage:', error);
        }
    }
    // Method to get or create a deviceId
    static getOrCreateDeviceId() {
        let deviceId = this.getDeviceId();
        if (!deviceId) deviceId = this.generateDeviceId();
        return deviceId;
    }
}


/* eslint-disable max-len */ var $9f90670b1354254b$exports = {};
!function(n, t) {
    t($9f90670b1354254b$exports);
}($9f90670b1354254b$exports, function(n) {
    "use strict";
    function t(n) {
        return null == n;
    }
    function r(n) {
        throw new Error("Argument " + n + " is empty.");
    }
    function e(n) {
        return "function" == typeof n && "getType" in n;
    }
    function i(n) {
        throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions"');
    }
    function o(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if (null == n.getType) throw new Error("Argument contains array with invalid element at index " + t + ', it should be an action-creator instance from "typesafe-actions"');
    }
    function u(n) {
        return "string" == typeof n || "symbol" == typeof n;
    }
    function a(n) {
        return !u(n);
    }
    function c(n) {
        throw new Error("Argument " + n + " is invalid, it should be an action type of type: string | symbol");
    }
    function f(n, t) {
        if (null == n) throw new Error("Argument contains array with empty element at index " + t);
        if ("string" != typeof n && "symbol" != typeof n) throw new Error("Argument contains array with invalid element at index " + t + ", it should be of type: string | symbol");
    }
    function s(n, e, o, u) {
        return t(n) && r(1), a(n) && i(1), {
            type: n,
            payload: e,
            meta: o,
            error: u
        };
    }
    function y(n, e) {
        t(n) && r(1), a(n) && c(1);
        return Object.assign(function() {
            var t = null != e ? e.apply(void 0, arguments) : void 0;
            return Object.assign({
                type: n
            }, t);
        }, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    function l(n, e, i) {
        return t(n) && r(1), a(n) && c(1), function() {
            return y(n, function() {
                var n = arguments.length <= 0 ? void 0 : arguments[0], t = arguments.length <= 1 ? void 0 : arguments[1];
                return null == e && null == i || (n = null != e ? e.apply(void 0, arguments) : void 0, t = null != i ? i.apply(void 0, arguments) : void 0), Object.assign({}, void 0 !== n && {
                    payload: n
                }, {}, void 0 !== t && {
                    meta: t
                });
            });
        };
    }
    function p(n) {
        return t(n) && r(1), e(n) || i(1), n.getType();
    }
    function d(n, e) {
        t(n) && r(1), a(n) && c(1);
        var i = null != e ? e(n) : function() {
            return {
                type: n
            };
        };
        return Object.assign(i, {
            getType: function() {
                return n;
            },
            toString: function() {
                return n;
            }
        });
    }
    var g = {
        createAction: function(n, t) {
            var r = null == t ? function() {
                return s(n);
            } : t(s.bind(null, n));
            return Object.assign(r, {
                getType: function() {
                    return n;
                },
                toString: function() {
                    return n;
                }
            });
        },
        createCustomAction: d,
        createStandardAction: function(n) {
            return t(n) && r(1), a(n) && c(1), Object.assign(function() {
                return d(n, function(n) {
                    return function(t, r) {
                        return {
                            type: n,
                            payload: t,
                            meta: r
                        };
                    };
                });
            }, {
                map: function(t) {
                    return d(n, function(n) {
                        return function(r, e) {
                            return Object.assign(t(r, e), {
                                type: n
                            });
                        };
                    });
                }
            });
        }
    };
    n.action = s, n.createAction = l, n.createAsyncAction = function(n, t, r, e) {
        return function() {
            var i = [
                n,
                t,
                r,
                e
            ].map(function(n, t) {
                return Array.isArray(n) ? l(n[0], n[1], n[2])() : "string" == typeof n || "symbol" == typeof n ? l(n)() : void (t < 3 && function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action type of "string | symbol" or a tuple of "[string | symbol, Function, Function?]"');
                }(t));
            });
            return {
                request: i[0],
                success: i[1],
                failure: i[2],
                cancel: i[3]
            };
        };
    }, n.createCustomAction = y, n.createReducer = function n(t, r) {
        void 0 === r && (r = {});
        var i = Object.assign({}, r), o = function(r, o) {
            var a = Array.isArray(r) ? r : [
                r
            ], c = {};
            return a.map(function(n, t) {
                return e(n) ? p(n) : u(n) ? n : function(n) {
                    throw new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions" or action type of type: string | symbol');
                }(t + 1);
            }).forEach(function(n) {
                return c[n] = o;
            }), n(t, Object.assign({}, i, {}, c));
        };
        return Object.assign(function(n, r) {
            if (void 0 === n && (n = t), i.hasOwnProperty(r.type)) {
                var e = i[r.type];
                if ("function" != typeof e) throw Error('Reducer under "' + r.type + '" key is not a valid reducer');
                return e(n, r);
            }
            return n;
        }, {
            handlers: Object.assign({}, i),
            handleAction: o,
            handleType: o
        });
    }, n.deprecated = g, n.getType = p, n.isActionOf = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(o);
        var u = function(n) {
            return i.some(function(t) {
                return n.type === t.getType();
            });
        };
        return void 0 === e ? u : u(e);
    }, n.isOfType = function(n, e) {
        t(n) && r(1);
        var i = Array.isArray(n) ? n : [
            n
        ];
        i.forEach(f);
        var o = function(n) {
            return i.includes(n.type);
        };
        return void 0 === e ? o : o(e);
    };
});



const $8eba69c5466928d3$export$6e19b0a4e4c542c1 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).RESET_FORM_VALUES_SUCCESS, data);
const $8eba69c5466928d3$export$528cdcbbafe26779 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SET_FORM_VALUES_REQUEST, data);
const $8eba69c5466928d3$export$4452cb953514838a = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SET_FORM_VALUES_SUCCESS, data);
const $8eba69c5466928d3$export$c75cc2fedb4914bf = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UNCHECK_DEPENDENT_RADIO_REQUEST, data);
const $8eba69c5466928d3$export$22aa4fb508251850 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UNCHECK_DEPENDENT_RADIO_SUCCESS, data);
const $8eba69c5466928d3$export$fe25ce1cfff10000 = (data, indexTrigger, context)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).MERGE_STYLE_REQUEST, data, {
        context: context,
        index: indexTrigger
    });
const $8eba69c5466928d3$export$eecf287d0d9bbcd2 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).MERGE_STYLE_SUCCESS, data);
const $8eba69c5466928d3$export$ea176eb1668c7b4b = (data, localShimmer)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_REQUEST, data, localShimmer);
const $8eba69c5466928d3$export$98eb18032ef4d6ea = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_SUCCESS, data);
const $8eba69c5466928d3$export$3653d7e5cadcf5e3 = ()=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).CLEAR_FORMS);
const $8eba69c5466928d3$export$decff28e578bd5f9 = (data, localShimmer)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SUBMIT_FORM_REQUEST, data, localShimmer);
const $8eba69c5466928d3$export$36f0c40eded97f9d = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_VARIABLE_REQUEST, data);
const $8eba69c5466928d3$export$7b322c1959eae1de = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_VARIABLE_SUCCESS, data);
const $8eba69c5466928d3$export$2c41626496d118d = (data, localShimmer)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).ACTION_REQUEST, data, localShimmer);
const $8eba69c5466928d3$export$b8bdf8945930e196 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).ACTION_SUCCESS, data);
const $8eba69c5466928d3$export$1f3acb761da593d8 = ()=>(0, $9f90670b1354254b$exports.action)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).ACTIVATE_LOCAL_SHIMMER_SUCCESS);



/* eslint-disable max-len */ 
// Response object for POST /get
var $9c904b43c5ef6eaf$export$e378b6cc3d050bd4 = /*#__PURE__*/ function(ConfigActionTypes) {
    ConfigActionTypes["CONFIG_REQUEST"] = "@@config/CONFIG_REQUEST";
    ConfigActionTypes["CONFIG_EMPTY_REQUEST"] = "@@config/CONFIG_EMPTY_REQUEST";
    ConfigActionTypes["CONFIG_SUCCESS"] = "@@config/CONFIG_SUCCESS";
    ConfigActionTypes["CONFIG_ERROR"] = "@@config/CONFIG_ERROR";
    ConfigActionTypes["CONFIG_UPDATE_ENDPOINT_PARAMS"] = "@@config/CONFIG_UPDATE_ENDPOINT_PARAMS";
    return ConfigActionTypes;
}({});


const $2907166a90fe0a09$export$cf229b36ba13aa52 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_REQUEST, data);
const $2907166a90fe0a09$export$ba933bc7f0f71012 = (data)=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_EMPTY_REQUEST, data);
const $2907166a90fe0a09$export$ff747514dac36e4c = (data)=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_SUCCESS, data);
const $2907166a90fe0a09$export$3dbcfb3539facac2 = ()=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_ERROR);
const $2907166a90fe0a09$export$1899915054cedfe4 = (params)=>(0, $9f90670b1354254b$exports.action)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_UPDATE_ENDPOINT_PARAMS, params);






/**
 * FE-4577 — client-side design-system store and `Fds` delivery negotiation.
 *
 * The backend (FE-4576) keeps a per-device record of what it has delivered and
 * answers with only what this client is missing or holds stale. After the first
 * visit most responses carry no class or template bodies at all, so the renderer
 * resolves them out of this store instead of out of the response.
 */ /**
 * FE-4577 — the `Fds` delivery-negotiation codec.
 *
 * Pure: no browser state, no I/O, no imports from the app. That is deliberate —
 * the hash has published self-check vectors (below) and this file can be pasted
 * into a devtools console to check them against a live backend.
 *
 * One format travels in both directions, so one parser serves both:
 *
 *   request    Fds: h=9f2c8b…; t=1756742400123; th=dark,light
 *   response   Fds: t=1756750100789
 *   response   Fds: t=1756750100789; r=1
 *
 * `h` is the fingerprint of what the client holds; the backend NEVER sends it
 * back. The client computes it itself — two independent computations disagreeing
 * is precisely how a half-lost store is detected.
 *
 * The same string also travels in the body as `session_data.fds`, because no
 * `F*` header appears in any `Access-Control-Expose-Headers` list, so a
 * cross-origin response has its header stripped while the body field survives.
 */ /** What an empty or unusable store sends. Also the fallback when SHA-256 is unavailable. */ const $eb0c8dfc30574995$export$667905b9ff594359 = 'none';
/**
 * Orders by Unicode code point, which is also UTF-8 byte order — what Go's
 * `sort.Strings` produces on the other side.
 *
 * A bare `.sort()` compares UTF-16 code units, which disagrees for
 * supplementary-plane characters (a surrogate pair sorts below U+E000 there,
 * above it here). External ids are almost certainly ASCII, where the two agree,
 * so this is insurance: getting it wrong yields a permanent hash mismatch, i.e.
 * a permanent full delivery — degraded, never incorrect.
 */ const $eb0c8dfc30574995$var$compareByCodePoint = (a, b)=>{
    const left = Array.from(a).map((ch)=>ch.codePointAt(0) ?? 0);
    const right = Array.from(b).map((ch)=>ch.codePointAt(0) ?? 0);
    const diffAt = left.findIndex((cp, i)=>cp !== right[i]);
    if (diffAt === -1) return left.length - right.length;
    if (diffAt >= right.length) return 1;
    return left[diffAt] - right[diffAt];
};
const $eb0c8dfc30574995$var$joinSorted = (ids)=>[
        ...ids
    ].sort($eb0c8dfc30574995$var$compareByCodePoint).join(',');
const $eb0c8dfc30574995$export$6fbfa9a224da57ed = ({ classIds: classIds, templateIds: templateIds, themeNames: themeNames, hasConfig: hasConfig })=>`c:${$eb0c8dfc30574995$var$joinSorted(classIds)}\n` + `t:${$eb0c8dfc30574995$var$joinSorted(templateIds)}\n` + `s:${$eb0c8dfc30574995$var$joinSorted(themeNames)}\n` + `g:${hasConfig ? '1' : '0'}`;
const $eb0c8dfc30574995$export$4eacf6229f17c532 = async (input)=>{
    try {
        const subtle = globalThis.crypto?.subtle;
        if (!subtle) return null;
        const digest = await subtle.digest('SHA-256', new TextEncoder().encode(input));
        return Array.from(new Uint8Array(digest)).map((byte)=>byte.toString(16).padStart(2, '0')).join('');
    } catch (error) {
        return null;
    }
};
const $eb0c8dfc30574995$export$cb615aec2f7a2a40 = async (input)=>await $eb0c8dfc30574995$export$4eacf6229f17c532($eb0c8dfc30574995$export$6fbfa9a224da57ed(input)) ?? $eb0c8dfc30574995$export$667905b9ff594359;
const $eb0c8dfc30574995$export$a2c0955a6c5c053c = (value)=>{
    if (typeof value !== 'string') return null;
    const parts = value.split(';').map((part)=>part.trim()).filter(Boolean);
    return Object.fromEntries(parts.map((part)=>{
        const eq = part.indexOf('=');
        return eq === -1 ? [
            part,
            ''
        ] : [
            part.slice(0, eq).trim(),
            part.slice(eq + 1).trim()
        ];
    }));
};
const $eb0c8dfc30574995$export$f7a140ecf1b662c8 = (value)=>{
    const parsed = $eb0c8dfc30574995$export$a2c0955a6c5c053c(value);
    if (!parsed) return null;
    return {
        mark: parsed.t || null,
        reset: parsed.r === '1'
    };
};
const $eb0c8dfc30574995$export$ba8b6f33181002cf = ({ hash: hash, mark: mark, themes: themes })=>{
    const parts = [
        `h=${hash || $eb0c8dfc30574995$export$667905b9ff594359}`
    ];
    if (mark) parts.push(`t=${mark}`);
    if (themes.length > 0) parts.push(`th=${$eb0c8dfc30574995$var$joinSorted(themes)}`);
    return parts.join('; ');
};
const $eb0c8dfc30574995$export$d607b5325cb2b217 = (payload, headerValue)=>{
    const fromRoot = payload?.session_data?.fds;
    if (typeof fromRoot === 'string') return fromRoot;
    const fromData = payload?.data?.session_data?.fds;
    if (typeof fromData === 'string') return fromData;
    return typeof headerValue === 'string' ? headerValue : null;
};


/**
 * FE-4577 — the client's mirror of the branch's design system.
 *
 * THE INVARIANT THAT MAKES THIS SAFE:
 *
 *   `h` is non-`none` only when the mirror is authoritative.
 *
 * A response can omit a block only if we sent a hash claiming to hold it, and we
 * can only send such a hash once hydration has settled. So a payload normalized
 * against an unhydrated mirror necessarily carried all its blocks. Correctness
 * therefore does NOT depend on boot ordering — awaiting hydration at boot is
 * purely an optimisation that avoids one wasted full delivery per session.
 *
 * BODIES ARE STORED RAW. `resolveDesignTokens` substitutes `{{_s.*}}`/`{{_c.*}}`
 * INTO class and template bodies; persisting those would bake one theme's values
 * into the store, and the backend will never re-send a class it believes we
 * hold, so a theme switch would render stale for ever. Substitution happens
 * after the merge — see `resolve.ts`.
 *
 * Nothing exported here throws or rejects.
 */ 
/**
 * FE-4577 — persistence for the design-system mirror.
 *
 * WHY THIS IS NOT `utils/indexedDbHelper.ts`. That module is hardcoded to the
 * `main` database and its single `cacheScreens` store, and its `getItem`
 * returns a `[id, value]` tuple; generalising it would mean touching the hot
 * navigation path at every existing call site. More importantly the ticket's
 * suggestion — a second store inside `main`, behind a version bump — carries a
 * real hazard: a tab still running the previous bundle holds `main` at v1, the
 * v2 upgrade fires `onblocked`, and the open never settles. Every screen-cache
 * read is `yield call(...)`ed from a saga, so that is a navigation that hangs.
 * A separate database has no upgrade to block, keeps the (large) design record
 * out of `getItemRegexp`'s `getAll()` on every navigation, and isolates
 * design-system failures from the screen cache entirely.
 *
 * Nothing here throws or rejects: a failure is reported as "storage unusable",
 * which the store turns into a memory-only session.
 */ const $3c698436e1cae2af$var$DB_NAME = 'fractalDesignSystem';
const $3c698436e1cae2af$var$DB_VERSION = 1;
const $3c698436e1cae2af$var$STORE_NAME = 'designSystem';
const $3c698436e1cae2af$var$OPEN_TIMEOUT_MS = 3000;
let $3c698436e1cae2af$var$dbPromise = null;
const $3c698436e1cae2af$var$warn = (operation, error)=>{
    const err = error;
    console.warn(`[design-system] IndexedDB ${operation} failed:`, err?.message || error);
};
function $3c698436e1cae2af$var$openDatabase() {
    if ($3c698436e1cae2af$var$dbPromise) return $3c698436e1cae2af$var$dbPromise;
    $3c698436e1cae2af$var$dbPromise = new Promise((resolve, reject)=>{
        if (typeof indexedDB === 'undefined' || indexedDB === null) {
            reject(new Error('IndexedDB is unavailable in this context'));
            return;
        }
        let request;
        try {
            request = indexedDB.open($3c698436e1cae2af$var$DB_NAME, $3c698436e1cae2af$var$DB_VERSION);
        } catch (error) {
            reject(error);
            return;
        }
        let settled = false;
        let timer;
        const finish = (fn, arg)=>{
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            fn(arg);
        };
        timer = setTimeout(()=>finish(reject, new Error('IndexedDB open timed out')), $3c698436e1cae2af$var$OPEN_TIMEOUT_MS);
        request.onupgradeneeded = ()=>{
            const db = request.result;
            if (!db.objectStoreNames.contains($3c698436e1cae2af$var$STORE_NAME)) db.createObjectStore($3c698436e1cae2af$var$STORE_NAME, {
                keyPath: 'id'
            });
        };
        request.onblocked = ()=>finish(reject, new Error('IndexedDB upgrade blocked by another tab'));
        request.onsuccess = ()=>{
            const db = request.result;
            db.onversionchange = ()=>{
                db.close();
                $3c698436e1cae2af$var$dbPromise = null;
            };
            db.onclose = ()=>{
                $3c698436e1cae2af$var$dbPromise = null;
            };
            finish(resolve, db);
        };
        request.onerror = ()=>finish(reject, request.error);
    }).catch((error)=>{
        $3c698436e1cae2af$var$warn('open', error);
        $3c698436e1cae2af$var$dbPromise = null;
        throw error;
    });
    return $3c698436e1cae2af$var$dbPromise;
}
async function $3c698436e1cae2af$export$b400c64e22f7eb4c(key) {
    try {
        const db = await $3c698436e1cae2af$var$openDatabase();
        return await new Promise((resolve, reject)=>{
            const transaction = db.transaction([
                $3c698436e1cae2af$var$STORE_NAME
            ], 'readonly');
            transaction.onabort = ()=>reject(transaction.error);
            const request = transaction.objectStore($3c698436e1cae2af$var$STORE_NAME).get(key);
            request.onsuccess = ()=>resolve(request.result ? request.result.value : null);
            request.onerror = ()=>reject(request.error);
        });
    } catch (error) {
        $3c698436e1cae2af$var$warn('read', error);
        $3c698436e1cae2af$var$dbPromise = null;
        return undefined;
    }
}
async function $3c698436e1cae2af$export$63bd2e4de2312d4f(key, value) {
    try {
        const db = await $3c698436e1cae2af$var$openDatabase();
        return await new Promise((resolve, reject)=>{
            const transaction = db.transaction([
                $3c698436e1cae2af$var$STORE_NAME
            ], 'readwrite');
            transaction.onabort = ()=>reject(transaction.error);
            const request = transaction.objectStore($3c698436e1cae2af$var$STORE_NAME).put({
                id: key,
                value: value
            });
            request.onsuccess = ()=>resolve(true);
            request.onerror = ()=>reject(request.error);
        });
    } catch (error) {
        $3c698436e1cae2af$var$warn('write', error);
        $3c698436e1cae2af$var$dbPromise = null;
        return false;
    }
}


const $e916c0573570ec65$var$SCHEMA = 1;
const $e916c0573570ec65$var$PERSIST_DEBOUNCE_MS = 50;
/** How long a request will wait for hydration before giving up and sending `h=none`. */ const $e916c0573570ec65$var$HYDRATE_BUDGET_MS = 1500;
/** Beyond this the record is not worth a quota error; the session goes memory-only. */ const $e916c0573570ec65$var$MAX_PERSISTED_BYTES = 4194304;
const $e916c0573570ec65$var$emptyState = ()=>({
        classes: {},
        templates: {},
        themes: {},
        unnamedTheme: null,
        configTokens: null,
        activeTheme: null,
        mark: null,
        contentRevision: 0
    });
const $e916c0573570ec65$var$isPlainObject = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
let $e916c0573570ec65$var$state = $e916c0573570ec65$var$emptyState();
let $e916c0573570ec65$var$status = 'idle';
/** False when storage is unusable — the session still works, in memory only. */ let $e916c0573570ec65$var$persistable = false;
let $e916c0573570ec65$var$hydrationPromise = null;
let $e916c0573570ec65$var$persistTimer = null;
let $e916c0573570ec65$var$hashCache = null;
let $e916c0573570ec65$var$themeChangeListener = null;
const $e916c0573570ec65$export$f55c2c7b57013ae0 = (listener)=>{
    $e916c0573570ec65$var$themeChangeListener = listener;
};
const $e916c0573570ec65$var$noteThemeChange = (previous, next)=>{
    if (!previous || previous === next) return;
    try {
        $e916c0573570ec65$var$themeChangeListener?.();
    } catch (error) {
        console.warn('[design-system] theme-change listener failed:', error);
    }
};
/**
 * The kill switch. `?nofds` or `window.__FDS_DISABLED__` forces `h=none` and
 * disables every write, reverting to the pre-FE-4577 behaviour without a
 * rollback — and the degraded path is one we need to be correct anyway.
 */ const $e916c0573570ec65$var$isDisabled = ()=>{
    try {
        if (typeof window === 'undefined') return true;
        // eslint-disable-next-line no-underscore-dangle
        if (window.__FDS_DISABLED__) return true;
        return new URLSearchParams(window.location.search).has('nofds');
    } catch (error) {
        return true;
    }
};
/**
 * Keyed by the public address. The branch is encoded in the HOST
 * (`{project}--{branch}.fractal.cc`), and `config.data.public_url` has not
 * arrived yet at boot, whereas the host is available synchronously.
 */ const $e916c0573570ec65$var$storageKey = ()=>`ds:v${$e916c0573570ec65$var$SCHEMA}:${window.location.host}`;
const $e916c0573570ec65$var$persistNow = async ()=>{
    if (!$e916c0573570ec65$var$persistable) return;
    const record = {
        schema: $e916c0573570ec65$var$SCHEMA,
        host: window.location.host,
        savedAt: Date.now(),
        state: $e916c0573570ec65$var$state
    };
    let serializedSize = 0;
    try {
        serializedSize = JSON.stringify(record).length;
    } catch (error) {
        $e916c0573570ec65$var$persistable = false;
        return;
    }
    if (serializedSize > $e916c0573570ec65$var$MAX_PERSISTED_BYTES) {
        console.warn('[design-system] record too large to persist; continuing in memory only');
        $e916c0573570ec65$var$persistable = false;
        return;
    }
    const ok = await (0, $3c698436e1cae2af$export$63bd2e4de2312d4f)($e916c0573570ec65$var$storageKey(), record);
    if (!ok) $e916c0573570ec65$var$persistable = false;
};
/**
 * Single-flight, trailing-debounced. We always write the COMPLETE current state,
 * so last-write-wins is correct and no queue or ordering logic is needed.
 */ const $e916c0573570ec65$var$schedulePersist = ()=>{
    if (!$e916c0573570ec65$var$persistable) return;
    if ($e916c0573570ec65$var$persistTimer) clearTimeout($e916c0573570ec65$var$persistTimer);
    $e916c0573570ec65$var$persistTimer = setTimeout(()=>{
        $e916c0573570ec65$var$persistTimer = null;
        // Never rejects; nothing to await.
        $e916c0573570ec65$var$persistNow();
    }, $e916c0573570ec65$var$PERSIST_DEBOUNCE_MS);
};
const $e916c0573570ec65$var$adopt = (stored)=>{
    $e916c0573570ec65$var$state = {
        ...$e916c0573570ec65$var$emptyState(),
        classes: $e916c0573570ec65$var$isPlainObject(stored.classes) ? stored.classes : {},
        templates: $e916c0573570ec65$var$isPlainObject(stored.templates) ? stored.templates : {},
        themes: $e916c0573570ec65$var$isPlainObject(stored.themes) ? stored.themes : {},
        unnamedTheme: $e916c0573570ec65$var$isPlainObject(stored.unnamedTheme) ? stored.unnamedTheme : null,
        configTokens: $e916c0573570ec65$var$isPlainObject(stored.configTokens) ? stored.configTokens : null,
        activeTheme: typeof stored.activeTheme === 'string' ? stored.activeTheme : null,
        mark: typeof stored.mark === 'string' ? stored.mark : null,
        contentRevision: 1
    };
};
const $e916c0573570ec65$export$9279e804159fafce = (options)=>{
    if ($e916c0573570ec65$var$hydrationPromise) return $e916c0573570ec65$var$hydrationPromise;
    $e916c0573570ec65$var$hydrationPromise = (async ()=>{
        if (options?.enabled === false || $e916c0573570ec65$var$isDisabled()) {
            $e916c0573570ec65$var$status = 'degraded';
            return $e916c0573570ec65$var$status;
        }
        const stored = await (0, $3c698436e1cae2af$export$b400c64e22f7eb4c)($e916c0573570ec65$var$storageKey());
        if (stored === undefined) {
            // Storage unusable (private window, blocked). The mirror still works for
            // this session; it simply starts empty and is not written back.
            $e916c0573570ec65$var$persistable = false;
            $e916c0573570ec65$var$status = 'ready';
            return $e916c0573570ec65$var$status;
        }
        $e916c0573570ec65$var$persistable = true;
        if (stored && stored.schema === $e916c0573570ec65$var$SCHEMA && stored.host === window.location.host && $e916c0573570ec65$var$isPlainObject(stored.state)) $e916c0573570ec65$var$adopt(stored.state);
        $e916c0573570ec65$var$status = 'ready';
        return $e916c0573570ec65$var$status;
    })().catch((error)=>{
        console.warn('[design-system] hydration failed; continuing without a store:', error);
        $e916c0573570ec65$var$status = 'degraded';
        return $e916c0573570ec65$var$status;
    });
    return $e916c0573570ec65$var$hydrationPromise;
};
const $e916c0573570ec65$export$cd01cfbf2621a76f = ()=>$e916c0573570ec65$var$state;
const $e916c0573570ec65$export$706d74652ca42d0c = ()=>$e916c0573570ec65$var$status === 'ready';
const $e916c0573570ec65$var$holdsNothing = ()=>Object.keys($e916c0573570ec65$var$state.classes).length === 0 && Object.keys($e916c0573570ec65$var$state.templates).length === 0 && Object.keys($e916c0573570ec65$var$state.themes).length === 0 && $e916c0573570ec65$var$state.configTokens === null;
const $e916c0573570ec65$export$2403d95536079032 = ()=>$e916c0573570ec65$var$status === 'ready' && ($e916c0573570ec65$var$state.mark !== null || !$e916c0573570ec65$var$holdsNothing());
const $e916c0573570ec65$export$4e6858a00e721a90 = ()=>{
    const { mark: mark } = $e916c0573570ec65$var$state;
    $e916c0573570ec65$var$state = $e916c0573570ec65$var$emptyState();
    $e916c0573570ec65$var$state.mark = mark;
    $e916c0573570ec65$var$state.contentRevision += 1;
    $e916c0573570ec65$var$hashCache = null;
};
const $e916c0573570ec65$export$48b6abc6928e842a = (input)=>{
    if ($e916c0573570ec65$var$status !== 'ready') return;
    const parsed = (0, $eb0c8dfc30574995$export$f7a140ecf1b662c8)(input.fds);
    if (!parsed) return; // rules 2 and 8
    if (parsed.reset) $e916c0573570ec65$export$4e6858a00e721a90(); // rule 3
    let contentChanged = false;
    if ($e916c0573570ec65$var$isPlainObject(input.classes) && Object.keys(input.classes).length > 0) {
        Object.assign($e916c0573570ec65$var$state.classes, input.classes); // rules 5 and 7
        contentChanged = true;
    }
    if ($e916c0573570ec65$var$isPlainObject(input.templates) && Object.keys(input.templates).length > 0) {
        Object.assign($e916c0573570ec65$var$state.templates, input.templates);
        contentChanged = true;
    }
    const themeName = typeof input.themeName === 'string' && input.themeName.trim() ? input.themeName.trim() : null;
    if (themeName) {
        const previousTheme = $e916c0573570ec65$var$state.activeTheme;
        $e916c0573570ec65$var$state.activeTheme = themeName;
        $e916c0573570ec65$var$noteThemeChange(previousTheme, themeName);
    }
    if ($e916c0573570ec65$var$isPlainObject(input.styles) && Object.keys(input.styles).length > 0) {
        if (themeName) {
            $e916c0573570ec65$var$state.themes[themeName] = input.styles;
            contentChanged = true;
        } else {
            // Renderable but unadvertised — see `unnamedTheme` above.
            $e916c0573570ec65$var$state.unnamedTheme = input.styles;
            contentChanged = true;
        }
    }
    if ($e916c0573570ec65$var$isPlainObject(input.configTokens) && Object.keys(input.configTokens).length > 0) {
        $e916c0573570ec65$var$state.configTokens = input.configTokens;
        contentChanged = true;
    }
    $e916c0573570ec65$var$state.mark = parsed.mark; // rule 1 — always, even when nothing was delivered
    if (contentChanged) {
        $e916c0573570ec65$var$state.contentRevision += 1;
        $e916c0573570ec65$var$hashCache = null;
    }
    $e916c0573570ec65$var$schedulePersist();
};
const $e916c0573570ec65$export$1aac46682655bea0 = (name)=>{
    const next = typeof name === 'string' && name.trim() ? name.trim() : null;
    if ($e916c0573570ec65$var$state.activeTheme === next) return;
    const previousTheme = $e916c0573570ec65$var$state.activeTheme;
    $e916c0573570ec65$var$state.activeTheme = next;
    $e916c0573570ec65$var$noteThemeChange(previousTheme, next);
    $e916c0573570ec65$var$schedulePersist();
};
const $e916c0573570ec65$var$hashOfMirror = ()=>{
    if ($e916c0573570ec65$var$hashCache && $e916c0573570ec65$var$hashCache.revision === $e916c0573570ec65$var$state.contentRevision) return $e916c0573570ec65$var$hashCache.promise;
    const promise = (0, $eb0c8dfc30574995$export$cb615aec2f7a2a40)({
        classIds: Object.keys($e916c0573570ec65$var$state.classes),
        templateIds: Object.keys($e916c0573570ec65$var$state.templates),
        themeNames: Object.keys($e916c0573570ec65$var$state.themes),
        hasConfig: $e916c0573570ec65$var$state.configTokens !== null
    });
    $e916c0573570ec65$var$hashCache = {
        revision: $e916c0573570ec65$var$state.contentRevision,
        promise: promise
    };
    return promise;
};
const $e916c0573570ec65$var$NONE_HEADER = (0, $eb0c8dfc30574995$export$ba8b6f33181002cf)({
    hash: (0, $eb0c8dfc30574995$export$667905b9ff594359),
    mark: null,
    themes: []
});
const $e916c0573570ec65$export$ac2a76745b8c23c3 = async ()=>{
    try {
        if ($e916c0573570ec65$var$isDisabled()) return $e916c0573570ec65$var$NONE_HEADER;
        if ($e916c0573570ec65$var$status === 'idle') await Promise.race([
            $e916c0573570ec65$export$9279e804159fafce(),
            new Promise((resolve)=>{
                setTimeout(resolve, $e916c0573570ec65$var$HYDRATE_BUDGET_MS);
            })
        ]);
        if ($e916c0573570ec65$var$status !== 'ready') return $e916c0573570ec65$var$NONE_HEADER;
        // An empty-but-usable store may send either `h=none` or the empty-store
        // hash; the backend handles both, and `none` is the clearer signal.
        if ($e916c0573570ec65$var$holdsNothing()) return $e916c0573570ec65$var$NONE_HEADER;
        const hash = await $e916c0573570ec65$var$hashOfMirror();
        if (hash === (0, $eb0c8dfc30574995$export$667905b9ff594359)) return $e916c0573570ec65$var$NONE_HEADER;
        return (0, $eb0c8dfc30574995$export$ba8b6f33181002cf)({
            hash: hash,
            mark: $e916c0573570ec65$var$state.mark,
            themes: Object.keys($e916c0573570ec65$var$state.themes)
        });
    } catch (error) {
        return $e916c0573570ec65$var$NONE_HEADER;
    }
};


/**
 * FE-4577 — merge the store into a payload, then substitute tokens.
 *
 * ORDER IS THE WHOLE POINT. Before this ticket `normalizeAppData` substituted
 * `{{_s.*}}`/`{{_c.*}}` into class and template bodies as they arrived, and the
 * substituted copies were all that survived. That cannot be persisted: the
 * backend never re-sends a class it believes the client holds, so a body with
 * one theme's values baked in would render stale for ever after a theme switch.
 * The store therefore holds RAW bodies and substitution happens HERE, against
 * whatever theme is current, every time a payload is normalized.
 *
 * That would be ruinously expensive done naively — after warm-up the merged map
 * is the branch's ENTIRE class set on every single response — so it is memoised
 * on two levels:
 *
 *   level 2  source map  -> resolved map   (identity in, identity out)
 *   level 1  source body -> resolved body  (a delivery of 3 classes into a map
 *                                           of 400 substitutes 3)
 *
 * Both hang off a single-entry scope cache: the scope changes only when the
 * store's content revision or the active theme changes, NOT when the delivery
 * mark moves — and the mark moves on every response.
 */ /**
 * FE-4533 — design-system token substitution.
 *
 * Two namespaces, both written as `{{...}}` inside any style value:
 *
 *   {{_s.<name>}}  a variable of the ANSWERING THEME  (envelope `styles`)
 *   {{_c.<name>}}  a project config token             (envelope `config`)
 *
 * MIRROR OF THE EDITOR, NOT SHARED CODE. `fractal-fe` resolves the same two
 * namespaces while painting its canvas (`features/themes/lib/designTokens.ts`);
 * the repos ship separately, so this is a deliberate duplicate in the manner of
 * `styleClasses` and ROOT_FLEX_DEFAULTS. If the unresolved-token rule below
 * changes, BOTH move together or the editor shows something production will not.
 *
 * UNRESOLVED TOKENS STAY AS AUTHORED. `{{_s.nope}}` renders as that very text
 * rather than as an empty string: a typo that silently removes a style leaves
 * the author nothing to see, while visible token text is a bad outcome they can
 * at least act on. FE-4533 states this outright.
 *
 * WHY THE CLIENT DOES THIS AT ALL: the backend delivers `styles` with its `_c`
 * references INTACT — verified against a live payload, where the answering
 * theme arrived as `{accent: "{{_c.brand_color}}"}`. It selects the theme, but
 * it does not resolve the tokens inside it.
 */ /** `{{ _s.name }}` / `{{_c.name}}` — tolerant of inner whitespace. */ const $c4e93b74a0912850$var$TOKEN_PATTERN = /\{\{\s*_(s|c)\.([^}\s]+?)\s*\}\}/g;
const $c4e93b74a0912850$var$lookup = (scope, ns, name)=>ns === 's' ? scope.styles?.[name] : scope.config?.[name];
const $c4e93b74a0912850$export$f00f57895e4f4945 = (value, scope)=>value.replace($c4e93b74a0912850$var$TOKEN_PATTERN, (whole, ns, name)=>{
        const resolved = $c4e93b74a0912850$var$lookup(scope, ns, name);
        return resolved === undefined || resolved === null ? whole : String(resolved);
    });
const $c4e93b74a0912850$export$a45762bb3fea3c3e = (value, scope)=>{
    if (typeof value === 'string') {
        const next = $c4e93b74a0912850$export$f00f57895e4f4945(value, scope);
        return next === value ? value : next;
    }
    if (Array.isArray(value)) {
        let changed = false;
        const out = value.map((entry)=>{
            const next = $c4e93b74a0912850$export$a45762bb3fea3c3e(entry, scope);
            if (next !== entry) changed = true;
            return next;
        });
        return changed ? out : value;
    }
    if (value && typeof value === 'object') {
        let changed = false;
        const out = {};
        Object.entries(value).forEach(([key, entry])=>{
            const next = $c4e93b74a0912850$export$a45762bb3fea3c3e(entry, scope);
            if (next !== entry) changed = true;
            out[key] = next;
        });
        return changed ? out : value;
    }
    return value;
};
const $c4e93b74a0912850$export$5ef0b1ae431a2a84 = (styles, config)=>{
    if (!styles || typeof styles !== 'object') return {};
    return $c4e93b74a0912850$export$a45762bb3fea3c3e(styles, {
        config: config
    });
};



const $0338670cd4d1a0d1$var$isPlainObject = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
const $0338670cd4d1a0d1$var$isEmpty = (value)=>!value || Object.keys(value).length === 0;
let $0338670cd4d1a0d1$var$scopeCache = null;
/**
 * Store wins over what the payload carried.
 *
 * For a NETWORK payload the two agree — ingestion ran first, so everything
 * delivered is already in the store. For a CACHE read they do not: the entry may
 * embed blocks written by an older build, and the store is fresher.
 *
 * When nothing was delivered — the common case once warm — the store's own map
 * object is returned by identity, which is what lets the memo below hit.
 */ const $0338670cd4d1a0d1$var$mergeMaps = (delivered, stored)=>{
    if ($0338670cd4d1a0d1$var$isEmpty(delivered)) return stored;
    if ($0338670cd4d1a0d1$var$isEmpty(stored)) return delivered;
    return {
        ...delivered,
        ...stored
    };
};
const $0338670cd4d1a0d1$var$substituteMap = (source, cache)=>{
    const hit = cache.maps.get(source);
    if (hit) return hit;
    let changed = false;
    const out = {};
    Object.entries(source).forEach(([id, body])=>{
        let resolved;
        if (body && typeof body === 'object') {
            const bodyHit = cache.bodies.get(body);
            if (bodyHit !== undefined) resolved = bodyHit;
            else {
                resolved = (0, $c4e93b74a0912850$export$a45762bb3fea3c3e)(body, cache.scope);
                cache.bodies.set(body, resolved);
            }
        } else resolved = (0, $c4e93b74a0912850$export$a45762bb3fea3c3e)(body, cache.scope);
        if (resolved !== body) changed = true;
        out[id] = resolved;
    });
    // Unchanged ⇒ hand back the source itself, so identity survives the pass.
    const result = changed ? out : source;
    cache.maps.set(source, result);
    return result;
};
const $0338670cd4d1a0d1$export$7b00eca51c80f986 = (delivered)=>{
    const state = (0, $e916c0573570ec65$export$cd01cfbf2621a76f)();
    // The theme block this payload should paint with. A response that carries its
    // own `styles` wins; otherwise the named theme the store holds; otherwise the
    // unnamed one (styles that arrived with no `screen.settings.theme` to key on).
    const storedTheme = state.activeTheme && state.themes[state.activeTheme] || state.unnamedTheme || undefined;
    const effectiveStyles = $0338670cd4d1a0d1$var$isPlainObject(delivered.styles) ? delivered.styles : storedTheme;
    const effectiveConfig = $0338670cd4d1a0d1$var$isPlainObject(delivered.configTokens) ? delivered.configTokens : state.configTokens ?? undefined;
    // Keyed on what actually determines the scope. The delivery mark is
    // deliberately absent: it changes on every response and would defeat the memo.
    const key = [
        state.contentRevision,
        state.activeTheme ?? '',
        $0338670cd4d1a0d1$var$isPlainObject(delivered.styles) ? 'ds' : '',
        $0338670cd4d1a0d1$var$isPlainObject(delivered.configTokens) ? 'dc' : ''
    ].join('|');
    if (!$0338670cd4d1a0d1$var$scopeCache || $0338670cd4d1a0d1$var$scopeCache.key !== key) {
        const themeVariables = (0, $c4e93b74a0912850$export$5ef0b1ae431a2a84)(effectiveStyles, effectiveConfig);
        $0338670cd4d1a0d1$var$scopeCache = {
            key: key,
            themeVariables: themeVariables,
            scope: {
                styles: themeVariables,
                config: effectiveConfig
            },
            // FE-4577 finding B: computed from the EFFECTIVE scope, not the payload.
            // Once the backend stops sending `styles`/`config` every payload declares
            // no tokens of its own, and the old payload-only test would leave every
            // `{{_s.accent}}` rendering as literal text.
            hasTokens: Object.keys(themeVariables).length > 0 || !!effectiveConfig,
            maps: new WeakMap(),
            bodies: new WeakMap()
        };
    }
    const cache = $0338670cd4d1a0d1$var$scopeCache;
    const finish = (merged)=>{
        if ($0338670cd4d1a0d1$var$isEmpty(merged)) return undefined;
        return cache.hasTokens ? $0338670cd4d1a0d1$var$substituteMap(merged, cache) : merged;
    };
    return {
        hasTokens: cache.hasTokens,
        themeVariables: cache.themeVariables,
        scope: cache.scope,
        classes: finish($0338670cd4d1a0d1$var$mergeMaps(delivered.classes, state.classes)),
        templates: finish($0338670cd4d1a0d1$var$mergeMaps(delivered.templates, state.templates))
    };
};
const $0338670cd4d1a0d1$export$ece869686ee08478 = ()=>{
    $0338670cd4d1a0d1$var$scopeCache = null;
};
const $0338670cd4d1a0d1$export$fc94ef871805e581 = (body)=>{
    if (!$0338670cd4d1a0d1$var$isPlainObject(body)) return body;
    // Only discard what the store can hand back. Against a backend that does not
    // speak FE-4576 the store stays permanently empty, so stripping here would
    // cache screens whose classes and templates nothing can restore and they would
    // replay unstyled. Confirmed by test, and it is the exact failure a renderer
    // deployed ahead of the engine would ship.
    //
    // Entries written before the protocol goes live stay whole and keep working:
    // the read-side merge is `{ ...embedded, ...store }`, so the store wins where
    // it has an id and the embedded copy fills the rest.
    if (!(0, $e916c0573570ec65$export$2403d95536079032)()) return body;
    const { classes: classes, templates: templates, styles: styles, ...rest } = body;
    if ($0338670cd4d1a0d1$var$isPlainObject(rest.config)) {
        const { classes: cfgClasses, templates: cfgTemplates, ...restConfig } = rest.config;
        rest.config = restConfig;
    }
    if ($0338670cd4d1a0d1$var$isPlainObject(rest.session_data) && 'fds' in rest.session_data) {
        const { fds: fds, ...restSession } = rest.session_data;
        rest.session_data = restSession;
    }
    return rest;
};




// Fractal Headers
const $3668382e27becba6$var$HeaderFractalClient = "Fc"; // Fractal-Client
const $3668382e27becba6$var$HeaderFractalInterfaceEngine = "Fie"; // Fractal-Interface-Engine
const $3668382e27becba6$var$HeaderFractalSessionID = "Fsi"; // Fractal-Session-ID
const $3668382e27becba6$var$HeaderFractalDeviceID = "Fdi"; // Fractal-Device-ID
const $3668382e27becba6$var$HeaderFractalDesignSystem = "Fds"; // Fractal-Design-System (FE-4577)
const $3668382e27becba6$var$BASE_API_PATH = '/api/v1';
let $3668382e27becba6$var$frameApiContext = {};
function $3668382e27becba6$export$99153244860c0d0e(ctx) {
    $3668382e27becba6$var$frameApiContext = {
        ...$3668382e27becba6$var$frameApiContext,
        ...ctx
    };
}
const $3668382e27becba6$export$3fa83f310820eeee = ()=>typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('frame');
const $3668382e27becba6$var$buildUrl = (path)=>{
    const { companyShortname: companyShortname, projectShortname: projectShortname } = $3668382e27becba6$var$frameApiContext;
    if ($3668382e27becba6$export$3fa83f310820eeee() && companyShortname && projectShortname) return `${window.location.origin}/${companyShortname}/${projectShortname}${$3668382e27becba6$var$BASE_API_PATH}${path}`;
    return `${$3668382e27becba6$var$BASE_API_PATH}${path}`;
};
async function $3668382e27becba6$export$2e2bcd8739ae039({ method: method, path: path, data: data }) {
    const url = $3668382e27becba6$var$buildUrl(path);
    const body = JSON.stringify(data);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        [$3668382e27becba6$var$HeaderFractalClient]: 'web',
        [$3668382e27becba6$var$HeaderFractalInterfaceEngine]: 'true',
        [$3668382e27becba6$var$HeaderFractalSessionID]: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId(),
        [$3668382e27becba6$var$HeaderFractalDeviceID]: (0, $7cdaba13c8ba20d3$export$2e2bcd8739ae039).getOrCreateDeviceId(),
        // FE-4577 — what this client already holds of the design system. Never
        // throws; degrades to `h=none`, which is simply a full delivery.
        // `buildUrl` makes every request from this helper same-origin by
        // construction, so there is no third party to leak the inventory hash to.
        [$3668382e27becba6$var$HeaderFractalDesignSystem]: await (0, $e916c0573570ec65$export$ac2a76745b8c23c3)()
    };
    const response = await fetch(url, {
        method: method,
        headers: headers,
        body: body
    });
    if (response.status !== 200) {
        let message = await response.text();
        if (message.startsWith('{')) message = JSON.parse(message).data;
        throw new Error(`${response.status} ${response.statusText}. ${message}`);
    }
    return response.json();
}


function* $44edbfa3e77e92f9$var$open(nextPage) {
    if (nextPage.startsWith('http')) window.open(nextPage);
    else yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $3b7d72a70d6ed09c$export$4cbf152802aa238)(nextPage));
}
function* $44edbfa3e77e92f9$var$api(method, path, data) {
    let response = {};
    response = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $3668382e27becba6$export$2e2bcd8739ae039), {
        method: method,
        path: path,
        data: data
    });
    switch(response.code){
        // page not found
        case 404:
            yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $3b7d72a70d6ed09c$export$4cbf152802aa238)('/not_found'));
            break;
        // redirect
        case 302:
            if (response.data && response.data.nextPage) {
                if (response.data.close) {
                    window.close();
                    yield (0, $45d5d5ff9e5b412e$export$3722cfe417b6ed86)(500);
                    yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($44edbfa3e77e92f9$var$open, response.data.nextPage);
                } else yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($44edbfa3e77e92f9$var$open, response.data.nextPage);
            }
            break;
        default:
            break;
    }
    return response;
}
var $44edbfa3e77e92f9$export$2e2bcd8739ae039 = $44edbfa3e77e92f9$var$api;


/**
 * Envelope normalizer for every backend payload that carries a screen.
 *
 * The renderer was written against ONE envelope — the init script, the `/get`
 * response and the local cache all used to look like this:
 *
 *   { code, status, screen: <id>,
 *     data: { config: { public_url, endpoint_id, endpoint_type, features, ... },
 *             screen: { id, sections, settings },
 *             parameters, variable_data, mode, live_updates, localization } }
 *
 * tnbe-web-be 0.22.x serves a FLAT one:
 *
 *   { code, status,
 *     screen: { id, sections, settings: { ..., mode, live_updates, localization }, cache },
 *     parameters, session_data: { public_url, endpoint_id, endpoint_type },
 *     templates }
 *
 * Five things moved: the `data` wrapper is gone, `screen` holds the screen
 * OBJECT instead of its id, `config` is now `session_data`, `templates` is new,
 * `mode` / `live_updates` /
 * `localization` sank into `screen.settings`, and `cache` climbed from
 * `screen.settings` up onto `screen`. An update (`mode: update`) carries
 * `screen: { id, updates, settings }`: its operations moved from `data.updates`
 * onto `screen`.
 *
 * Every read site in this app (parseNewFormat, the /get sagas, the init-script
 * bootstrap, the config saga) expects the FIRST shape, so normalize INTO it at
 * the trust boundary rather than teaching each read site about both. All three
 * exports are idempotent: an already-canonical payload — including one restored
 * from the local cache, or the legacy `sections`-at-top format — passes through
 * unchanged.
 */ 



const $7d394fadd9d1d259$var$isPlainObject = (value)=>!!value && typeof value === 'object' && !Array.isArray(value);
/**
 * Keys the 0.22.x `session_data` block carries that USED to live on
 * `data.config` — the endpoint context the app reads for its `Fs*` headers and
 * for `publicUrl`. `session_id` / `device_id` are deliberately NOT in this list:
 * they belong to the page's own session_data, not to config.
 */ const $7d394fadd9d1d259$var$CONFIG_KEYS_FROM_SESSION_DATA = [
    'public_url',
    'endpoint_id',
    'endpoint_type',
    'process_id',
    'task_ref',
    'features',
    'basic',
    'variables',
    'urls',
    'style'
];
/**
 * The flat envelope dropped `features` entirely, and `features.processes !== true`
 * makes the legacy `request` sagas run alongside the action chunks a 0.22.x
 * deployment serves (double-fired requests), and picks the socket.io websocket
 * provider over the native one. So a payload with NO `features` block defaults to
 * actions-mode.
 *
 * The default is applied per-KEY, not per-block: a payload that sends
 * `features.processes` keeps its own value — an explicit `processes: false` is a
 * deliberate legacy-mode deployment, not an omission — while a `features` block
 * that omits `processes` still gets the default, and keeps its other keys.
 * Flip this constant to opt out of the defaulting entirely.
 */ const $7d394fadd9d1d259$var$DEFAULT_PROCESSES_FEATURE = true;
/**
 * Rebuild `data.config` from whichever place this payload keeps the endpoint
 * context. Returns `undefined` when the payload carries no config context at
 * all, so a plain screen response can't accidentally seed a non-empty config
 * state (which would make the config saga skip its `/config` fetch).
 */ const $7d394fadd9d1d259$var$buildConfig = (raw, body)=>{
    const sessionData = $7d394fadd9d1d259$var$isPlainObject(raw.session_data) ? raw.session_data : undefined;
    // `config` means two different things depending on the envelope. In the LEGACY
    // shape `data.config` is this endpoint context. In the FLAT shape the
    // top-level `config` is the DESIGN CONFIG (`{{_c.*}}` token values) — a
    // different resource that merely shares the name, and `body` is a copy of
    // `raw`, so reading it here folded design tokens into the endpoint config.
    // Worse, it made this function return non-undefined for a payload with no
    // endpoint context at all, which per the note above makes the config saga skip
    // its `/config` fetch. Only a payload that HAD a `data` wrapper can supply it.
    const isLegacyEnvelope = $7d394fadd9d1d259$var$isPlainObject(raw.data);
    const existingConfig = isLegacyEnvelope && $7d394fadd9d1d259$var$isPlainObject(body.config) ? body.config : undefined;
    if (!sessionData && !existingConfig) return undefined;
    const config = {};
    if (sessionData) $7d394fadd9d1d259$var$CONFIG_KEYS_FROM_SESSION_DATA.forEach((key)=>{
        if (sessionData[key] !== undefined) config[key] = sessionData[key];
    });
    // `templates` is a top-level sibling in the flat shape; the app reads it off
    // `config.templates`, so fold it back in.
    if ($7d394fadd9d1d259$var$isPlainObject(raw.templates)) config.templates = raw.templates;
    // FE-4517 — `classes` rides along on the same terms: the style-class bodies
    // this screen's nodes name in `style.class`, keyed by external_id. The old
    // envelope carried a global class blob under this name; this is the
    // branch-scoped per-screen map that replaced it, and it IS read now.
    if ($7d394fadd9d1d259$var$isPlainObject(raw.classes)) config.classes = raw.classes;
    // A `session_data` that carries only the page's own session/device ids is NOT
    // config context. Inventing a config from it would seed a non-empty config
    // state at boot, which makes handleConfigRequest skip its `/config` fetch.
    if (!existingConfig && Object.keys(config).length === 0) return undefined;
    // An explicit `data.config` is the canonical shape — it always wins.
    Object.assign(config, existingConfig);
    const features = $7d394fadd9d1d259$var$isPlainObject(config.features) ? config.features : undefined;
    if ($7d394fadd9d1d259$var$DEFAULT_PROCESSES_FEATURE && features?.processes === undefined) config.features = {
        ...features,
        processes: true
    };
    return config;
};
/**
 * FE-4533 — resolve `{{_s.*}}` / `{{_c.*}}` across everything this payload paints.
 * FE-4577 — and merge in whatever the design-system store already holds.
 *
 * Done HERE, at the trust boundary, for the same reason the envelope is
 * normalized here: the alternative is teaching every read site — the screen
 * renderer, the class applier, the template expander — about two namespaces and
 * hoping none is missed. It is also what lets the render seam in `base.ts` stay
 * exactly as it was: by the time `applyStyleClasses(expandTemplateRefs(...))`
 * reads `data.classes` / `data.templates`, those maps are already complete,
 * whether the bodies arrived in this response, in an earlier one, or in a
 * previous session.
 *
 * ORDER IS LOAD-BEARING. Config resolves INSIDE the theme first
 * (`resolveThemeVariables`, now inside `resolveDeliveredDesignSystem`), so
 * `{{_s.accent}}` yields a finished value rather than one that still contains
 * `{{_c.brand_color}}`. See `designTokens.ts`.
 *
 * The three places a token can sit, all verified present in a live payload:
 *   screen.sections   the nodes' own styles
 *   classes           style-class bodies named by `style.class`
 *   templates         template bodies
 *
 * `classes` / `templates` are substituted at the TOP of the body, because that is
 * where every consumer reads them (`base.ts` → `applyStyleClasses(…, data?.classes)`,
 * `index.tsx` → `appData.data.templates`). `buildConfig` also folds the same
 * objects onto `config` for its own readers, so the resolved value is assigned to
 * BOTH — substituting only the `config` copy left the one the renderer actually
 * paints from untouched.
 *
 * NOTE the "no tokens ⇒ return untouched" shortcut this function used to open
 * with is GONE, and deliberately. It tested the PAYLOAD for tokens; once the
 * backend stops re-sending `styles` and `config` to a client that already holds
 * them, every payload declares none and every `{{_s.*}}` would render as literal
 * text. The test now lives in `resolveDeliveredDesignSystem` and is made against
 * the effective scope — payload merged over store.
 */ const $7d394fadd9d1d259$var$resolveDesignTokens = (raw, body)=>{
    // What THIS payload carried. `buildConfig` has already folded the same two
    // blocks onto `body.config`, so check there too.
    const deliveredBlock = (key)=>{
        if ($7d394fadd9d1d259$var$isPlainObject(body[key])) return body[key];
        if ($7d394fadd9d1d259$var$isPlainObject(body.config)) {
            const fromConfig = body.config[key];
            if ($7d394fadd9d1d259$var$isPlainObject(fromConfig)) return fromConfig;
        }
        return undefined;
    };
    const resolved = (0, $0338670cd4d1a0d1$export$7b00eca51c80f986)({
        classes: deliveredBlock('classes'),
        templates: deliveredBlock('templates'),
        styles: $7d394fadd9d1d259$var$isPlainObject(raw.styles) ? raw.styles : undefined,
        configTokens: $7d394fadd9d1d259$var$isPlainObject(raw.config) ? raw.config : undefined
    });
    const substituteScreen = resolved.hasTokens && $7d394fadd9d1d259$var$isPlainObject(body.screen);
    const replaceStyles = $7d394fadd9d1d259$var$isPlainObject(body.styles);
    if (!substituteScreen && !replaceStyles && !resolved.classes && !resolved.templates) return body;
    const next = {
        ...body
    };
    if (substituteScreen) next.screen = (0, $c4e93b74a0912850$export$a45762bb3fea3c3e)(next.screen, resolved.scope);
    // Replace the delivered theme block with the RESOLVED one. Nothing reads it
    // today, but leaving `{{_c.*}}` sitting in the body invites a future consumer
    // to read a token where every sibling holds a value.
    if (replaceStyles) next.styles = resolved.themeVariables;
    if (resolved.classes) next.classes = resolved.classes;
    if (resolved.templates) next.templates = resolved.templates;
    // Keep `config`'s copies pointing at the SAME resolved objects, so the two
    // views of one resource can never disagree.
    if ($7d394fadd9d1d259$var$isPlainObject(next.config) && (resolved.classes || resolved.templates)) {
        const nextConfig = {
            ...next.config
        };
        if (resolved.classes) nextConfig.classes = resolved.classes;
        if (resolved.templates) nextConfig.templates = resolved.templates;
        next.config = nextConfig;
    }
    return next;
};
/**
 * FE-4577 — record what this delivery carried.
 *
 * Called BEFORE `buildConfig` and `resolveDesignTokens`, for two reasons: the
 * store must hold RAW bodies (substituting first would bake one theme's values
 * into them permanently), and `buildConfig` overwrites `body.config` with the
 * ENDPOINT config, which is a different thing from the `{{_c.*}}` design tokens
 * under `raw.config`.
 *
 * A payload carrying no `Fds` at all leaves the store untouched — that is an
 * older backend, or the SSR shell, and is handled inside `ingestDelivery`.
 */ const $7d394fadd9d1d259$var$ingestDesignSystemDelivery = (raw, body, fdsHeader)=>{
    const blockOf = (key)=>{
        if ($7d394fadd9d1d259$var$isPlainObject(body[key])) return body[key];
        return $7d394fadd9d1d259$var$isPlainObject(raw[key]) ? raw[key] : undefined;
    };
    const screen = $7d394fadd9d1d259$var$isPlainObject(body.screen) ? body.screen : undefined;
    const settings = $7d394fadd9d1d259$var$isPlainObject(screen?.settings) ? screen.settings : undefined;
    const themeName = typeof settings?.theme === 'string' ? settings.theme : null;
    (0, $e916c0573570ec65$export$48b6abc6928e842a)({
        fds: (0, $eb0c8dfc30574995$export$d607b5325cb2b217)(raw, fdsHeader),
        classes: blockOf('classes'),
        templates: blockOf('templates'),
        // `styles` and `config` are read off `raw` exactly as `resolveDesignTokens`
        // reads them, so the store holds precisely what the resolver would have used.
        styles: $7d394fadd9d1d259$var$isPlainObject(raw.styles) ? raw.styles : undefined,
        configTokens: $7d394fadd9d1d259$var$isPlainObject(raw.config) ? raw.config : undefined,
        themeName: themeName
    });
};
const $7d394fadd9d1d259$export$ef119f2182a928e = (raw, opts)=>{
    if (!$7d394fadd9d1d259$var$isPlainObject(raw)) return raw;
    // A `data` that is NOT an object is the body itself — an action can answer
    // with `{ code, data: [...] }` or `{ code, data: "text" }`, and those flow
    // into `$response` verbatim. Same semantics as the `'data' in json ? …` probe
    // this replaced; there is nothing to normalize on a non-object body.
    if ('data' in raw && !$7d394fadd9d1d259$var$isPlainObject(raw.data)) return raw.data;
    // Legacy envelope: the body already sits under `data`. Flat envelope: the
    // body IS the response.
    //
    // `code` / `status` are deliberately NOT stripped in the flat branch: a
    // process/action response with no `data` key was previously passed through
    // whole and lands in the `$response` context, so `{{$response.status}}` and
    // `{{$response.code}}` must keep resolving. No parser reads them off a body.
    const body = $7d394fadd9d1d259$var$isPlainObject(raw.data) ? {
        ...raw.data
    } : {
        ...raw
    };
    let screen;
    if ($7d394fadd9d1d259$var$isPlainObject(body.screen)) screen = body.screen;
    else if ($7d394fadd9d1d259$var$isPlainObject(raw.screen)) screen = raw.screen;
    if (screen) {
        const settings = $7d394fadd9d1d259$var$isPlainObject(screen.settings) ? screen.settings : undefined;
        // 0.22.x sank these three from the body into `screen.settings`. Hoist them
        // back: `mode` drives the update-vs-show branch in the sagas, `live_updates`
        // gates the websocket, `localization` sets <html lang>.
        if (body.mode === undefined && settings?.mode !== undefined) body.mode = settings.mode;
        if (body.live_updates === undefined && settings?.live_updates !== undefined) body.live_updates = settings.live_updates;
        if (body.localization === undefined) {
            const localization = settings?.localization ?? screen.localization;
            if (localization !== undefined) body.localization = localization;
        }
        // ...and `cache` climbed the other way, out of `settings` onto `screen`,
        // while every read site is `settings?.cache` (the local-cache write gate).
        body.screen = screen.cache !== undefined && settings && settings.cache === undefined ? {
            ...screen,
            settings: {
                ...settings,
                cache: screen.cache
            }
        } : screen;
    }
    if (opts?.ingest) $7d394fadd9d1d259$var$ingestDesignSystemDelivery(raw, body, opts.fdsHeader);
    const config = $7d394fadd9d1d259$var$buildConfig(raw, body);
    if (config) body.config = config;
    else delete body.config;
    const resolved = $7d394fadd9d1d259$var$resolveDesignTokens(raw, body);
    // FE-4892 — an update's `insert` / `remove` / `replace` moved off the body onto
    // `screen.updates`, while `updateDataWithModeUpdate` reads `updates` off the
    // body: without this hoist a `mode: update` merged only its `parameters`.
    // Hoisted AFTER token resolution, from the resolved `screen`, so a node the
    // update brings in gets its `{{_s.*}}` / `{{_c.*}}` substituted like every
    // other node on the screen.
    const resolvedScreen = $7d394fadd9d1d259$var$isPlainObject(resolved.screen) ? resolved.screen : undefined;
    if (resolved.updates === undefined && resolvedScreen?.updates !== undefined) resolved.updates = resolvedScreen.updates;
    return resolved;
};
const $7d394fadd9d1d259$export$f803345c14bbbc14 = (sessionData)=>({
        device_id: (0, $7cdaba13c8ba20d3$export$2e2bcd8739ae039).getOrCreateDeviceId(),
        session_id: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId(),
        ...$7d394fadd9d1d259$var$isPlainObject(sessionData) ? sessionData : {}
    });
const $7d394fadd9d1d259$export$935adcd9e006ac5d = (raw, opts)=>{
    if (!$7d394fadd9d1d259$var$isPlainObject(raw)) return {
        code: undefined,
        status: undefined,
        data: raw,
        session_data: $7d394fadd9d1d259$export$f803345c14bbbc14(undefined)
    };
    let rawSessionData;
    if ($7d394fadd9d1d259$var$isPlainObject(raw.session_data)) rawSessionData = raw.session_data;
    else if ($7d394fadd9d1d259$var$isPlainObject(raw.data) && $7d394fadd9d1d259$var$isPlainObject(raw.data.session_data)) rawSessionData = raw.data.session_data;
    return {
        code: raw.code,
        status: raw.status,
        data: $7d394fadd9d1d259$export$ef119f2182a928e(raw, {
            ingest: true,
            ...opts
        }),
        session_data: $7d394fadd9d1d259$export$f803345c14bbbc14(rawSessionData)
    };
};
const $7d394fadd9d1d259$export$b9a006cb2241c14 = (raw, opts)=>{
    if (!$7d394fadd9d1d259$var$isPlainObject(raw)) return null;
    // The SSR shell carries no `Fds`, so ingesting it is a no-op (rule 8); the
    // retry that `retryWithHeaders` performs DOES carry one and must be ingested.
    const data = $7d394fadd9d1d259$export$ef119f2182a928e(raw, {
        ingest: true,
        ...opts
    });
    // `screen` is polymorphic across the two shapes: an id in the legacy
    // envelope, the screen object in the flat one.
    const screenId = $7d394fadd9d1d259$var$isPlainObject(raw.screen) ? raw.screen.id : raw.screen ?? data?.screen?.id ?? data?.screen_id;
    return {
        ...raw.apiUrl !== undefined ? {
            apiUrl: raw.apiUrl
        } : {},
        ...raw.code !== undefined ? {
            code: raw.code
        } : {},
        ...raw.status !== undefined ? {
            status: raw.status
        } : {},
        screen: screenId,
        data: data
    };
};




const $c9e12427d7d919f3$var$DB_NAME = 'main';
const $c9e12427d7d919f3$var$DB_VERSION = 1;
const $c9e12427d7d919f3$var$STORE_NAME = 'cacheScreens';
// `indexedDB.open` can hang indefinitely: another tab holding an older version
// open fires `onblocked` and the request simply never settles. Every read below
// is `yield call(...)`ed from a saga, so an open that never settles is a
// navigation that never completes. Bound it and treat the timeout as a miss.
const $c9e12427d7d919f3$var$OPEN_TIMEOUT_MS = 3000;
// One connection for the page, not one per operation. The old code opened a
// fresh connection on every call and never closed any of them, which widens the
// window in which a future version bump is blocked by our own stale handles.
let $c9e12427d7d919f3$var$dbPromise = null;
const $c9e12427d7d919f3$var$logFailure = (operation, details, error)=>{
    const err = error;
    console.error(`IndexedDB ${operation} failed:`, {
        ...details,
        error: err?.message || error,
        errorName: err?.name,
        timestamp: new Date().toISOString()
    });
};
function $c9e12427d7d919f3$var$openDatabase() {
    if ($c9e12427d7d919f3$var$dbPromise) return $c9e12427d7d919f3$var$dbPromise;
    $c9e12427d7d919f3$var$dbPromise = new Promise((resolve, reject)=>{
        if (typeof indexedDB === 'undefined' || indexedDB === null) {
            reject(new Error('IndexedDB is unavailable in this context'));
            return;
        }
        // A private window can throw synchronously from `open` itself.
        let request;
        try {
            request = indexedDB.open($c9e12427d7d919f3$var$DB_NAME, $c9e12427d7d919f3$var$DB_VERSION);
        } catch (error) {
            reject(error);
            return;
        }
        let settled = false;
        let timer;
        const finish = (fn, arg)=>{
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            fn(arg);
        };
        timer = setTimeout(()=>finish(reject, new Error('IndexedDB open timed out')), $c9e12427d7d919f3$var$OPEN_TIMEOUT_MS);
        request.onupgradeneeded = (event)=>{
            const db = event.target.result;
            if (!db.objectStoreNames.contains($c9e12427d7d919f3$var$STORE_NAME)) db.createObjectStore($c9e12427d7d919f3$var$STORE_NAME, {
                keyPath: 'id',
                autoIncrement: true
            });
        };
        // Another tab is holding an older version open. Fail fast rather than wait:
        // the caller degrades to a cache miss and goes to the network, which is a
        // far better outcome than a navigation that hangs until the other tab closes.
        request.onblocked = ()=>finish(reject, new Error('IndexedDB upgrade blocked by another tab'));
        request.onsuccess = ()=>{
            const db = request.result;
            // Never be the tab that blocks someone else's upgrade.
            db.onversionchange = ()=>{
                db.close();
                $c9e12427d7d919f3$var$dbPromise = null;
            };
            db.onclose = ()=>{
                $c9e12427d7d919f3$var$dbPromise = null;
            };
            finish(resolve, db);
        };
        request.onerror = ()=>finish(reject, request.error);
    }).catch((error)=>{
        $c9e12427d7d919f3$var$logFailure('openDatabase', {
            dbName: $c9e12427d7d919f3$var$DB_NAME,
            dbVersion: $c9e12427d7d919f3$var$DB_VERSION
        }, error);
        $c9e12427d7d919f3$var$dbPromise = null;
        throw error;
    });
    return $c9e12427d7d919f3$var$dbPromise;
}
/**
 * Runs one transaction and NEVER rejects.
 *
 * Callers here are not equipped to handle a rejection. `setItem` is invoked
 * fire-and-forget from a dozen saga sites, so a rejection surfaces as an
 * unhandled promise rejection; and the `getItem` at `sagas.ts:476` sits OUTSIDE
 * the try that opens at `:500`, so a rejection there aborts the whole form
 * submission — which is exactly what happens today in a private window.
 * Every failure degrades to `fallback`, i.e. a cache miss.
 */ async function $c9e12427d7d919f3$var$withStore(operation, mode, details, fallback, run) {
    try {
        const db = await $c9e12427d7d919f3$var$openDatabase();
        return await new Promise((resolve, reject)=>{
            const transaction = db.transaction([
                $c9e12427d7d919f3$var$STORE_NAME
            ], mode);
            transaction.onabort = ()=>reject(transaction.error);
            run(transaction.objectStore($c9e12427d7d919f3$var$STORE_NAME), resolve, reject);
        });
    } catch (error) {
        $c9e12427d7d919f3$var$logFailure(operation, details, error);
        // The handle may be the thing that went bad (closed connection, evicted
        // database). Drop it so the next call re-opens rather than failing forever.
        $c9e12427d7d919f3$var$dbPromise = null;
        return fallback;
    }
}
async function $c9e12427d7d919f3$export$8a8216c44337cd5(key, value) {
    return $c9e12427d7d919f3$var$withStore('setItem', 'readwrite', {
        key: key
    }, undefined, (store, resolve, reject)=>{
        const request = store.put({
            id: key,
            value: value
        });
        request.onsuccess = ()=>resolve();
        request.onerror = ()=>reject(request.error);
    });
}
async function $c9e12427d7d919f3$export$fe2d9b4e03920b4c(key) {
    return $c9e12427d7d919f3$var$withStore('removeItem', 'readwrite', {
        key: key
    }, undefined, (store, resolve, reject)=>{
        const request = store.delete(key);
        request.onsuccess = ()=>resolve();
        request.onerror = ()=>reject(request.error);
    });
}
async function $c9e12427d7d919f3$export$f92dfeb71e9bb569(key) {
    return $c9e12427d7d919f3$var$withStore('getItem', 'readonly', {
        key: key
    }, [
        null,
        null
    ], (store, resolve, reject)=>{
        const request = store.get(key);
        request.onsuccess = ()=>{
            const result = request.result;
            resolve([
                result?.id,
                result?.value
            ]);
        };
        request.onerror = ()=>reject(request.error);
    });
}
async function $c9e12427d7d919f3$export$42ffd38884aecdac() {
    return $c9e12427d7d919f3$var$withStore('clear', 'readwrite', {}, undefined, (store, resolve, reject)=>{
        const request = store.clear();
        request.onsuccess = ()=>resolve();
        request.onerror = ()=>reject(request.error);
    });
}
async function $c9e12427d7d919f3$export$a9d1467bbcbfc43(command) {
    return $c9e12427d7d919f3$var$withStore('getItemRegexp', 'readonly', {
        command: command
    }, [
        null,
        null
    ], (store, resolve, reject)=>{
        const request = store.getAll(); // Fetch all entries to apply regex matching
        request.onsuccess = ()=>{
            const entries = request.result;
            const matches = [];
            for (const entry of entries){
                const key = entry.id;
                const value = entry.value;
                if (!key) continue;
                // Check for exact match first
                if (key === command) {
                    matches.push({
                        key: key,
                        value: value,
                        specificity: -1
                    }); // Highest priority for exact matches
                    continue;
                }
                // Check if the command is a prefix match for the key (before any placeholders)
                const placeholderIndex = key.indexOf('{{');
                if (placeholderIndex !== -1) {
                    const keyPrefix = key.substring(0, placeholderIndex);
                    if (command === keyPrefix) {
                        // The command matches the key up to the first placeholder
                        const specificity = (key.match(/{{\w+}}/g) || []).length;
                        matches.push({
                            key: key,
                            value: value,
                            specificity: specificity
                        });
                        continue;
                    }
                }
                // Escape special regex characters in the key
                const escapedKey = key.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                // Replace {{...}} placeholders with regex patterns
                const pattern = escapedKey.replace(/{{\w+}}/g, '[\\w\\-\\.~\\?&=]*'); // Make placeholders optional
                const regex = new RegExp(`^${pattern}$`);
                // Check if the command matches the regex
                if (regex.test(command)) {
                    // Calculate specificity: fewer wildcards = higher specificity
                    const specificity = (key.match(/{{\w+}}/g) || []).length;
                    matches.push({
                        key: key,
                        value: value,
                        specificity: specificity
                    });
                }
            }
            if (matches.length > 0) {
                // Sort matches by specificity (ascending: fewer wildcards = higher priority)
                matches.sort((a, b)=>a.specificity - b.specificity);
                // Resolve with the best match
                resolve([
                    matches[0].key,
                    matches[0].value
                ]);
            } else // If no match is found, resolve with null
            resolve([
                null,
                null
            ]);
        };
        request.onerror = ()=>reject(request.error);
    });
}


var $4aeabe14c1618d30$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $4aeabe14c1618d30$exports) {
        classNames.default = classNames;
        $4aeabe14c1618d30$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $94WEq = parcelRequire("94WEq");

var $4vp6j = parcelRequire("4vp6j");

const $7d814282d5d3c114$var$GLOBAL_VARIABLES_KEY = 'tnbe_global_variables';
const $7d814282d5d3c114$export$1c9005e29d943d56 = ()=>{
    try {
        const stored = localStorage.getItem($7d814282d5d3c114$var$GLOBAL_VARIABLES_KEY);
        return stored ? JSON.parse(stored) : {};
    } catch (error) {
        console.error('Error reading global variables from localStorage:', error);
        return {};
    }
};
const $7d814282d5d3c114$export$cdbc98475cde4e80 = (variables)=>{
    try {
        localStorage.setItem($7d814282d5d3c114$var$GLOBAL_VARIABLES_KEY, JSON.stringify(variables));
    } catch (error) {
        console.error('Error saving global variables to localStorage:', error);
    }
};
const $7d814282d5d3c114$export$d40b0ae730754ac0 = (path)=>{
    const globalVars = $7d814282d5d3c114$export$1c9005e29d943d56();
    return (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(globalVars, path);
};
const $7d814282d5d3c114$export$b06e1c08d229ad64 = (path, value)=>{
    const globalVars = $7d814282d5d3c114$export$1c9005e29d943d56();
    (0, $7b0e169a5380005e$export$c52c7e952af52ee2)(globalVars, path, value);
    $7d814282d5d3c114$export$cdbc98475cde4e80(globalVars);
};
const $7d814282d5d3c114$export$226358b83530f879 = (path)=>{
    return path === 'c' || path.startsWith('c.');
};
const $7d814282d5d3c114$export$289398774300c991 = (path, localVariables = {}, localVariableData = {})=>{
    if ($7d814282d5d3c114$export$226358b83530f879(path)) return $7d814282d5d3c114$export$d40b0ae730754ac0(path);
    // Try local variables first, then localVariableData. PRESENCE check (not `||`) so a stored
    // falsy value (`''`, `0`, `false`) wins over the declared default instead of being discarded —
    // critical for the v2 data.* model (e.g. `config.search_query = ''` must read back as `''`, not
    // fall through to `undefined`, which the scope proxy would then wrap in a truthy child proxy).
    const localValue = (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariables, path);
    return localValue !== undefined ? localValue : (0, $7b0e169a5380005e$export$2516322ffbb7f3fb)(localVariableData, path);
};
const $7d814282d5d3c114$export$2d11ccb133d345 = (path, value, updateLocalVariable)=>{
    if ($7d814282d5d3c114$export$226358b83530f879(path)) $7d814282d5d3c114$export$b06e1c08d229ad64(path, value);
    else if (updateLocalVariable) updateLocalVariable(path, value);
};


/**
 * FE-4451 — assemble screen templates at render time.
 *
 * A component that carries a `template` field is a REFERENCE: its body lives in
 * the `templates` map delivered with the screen, keyed by external_id, and its
 * `overrides` hold whatever the screen's author changed. This turns that pair
 * back into an ordinary component tree before anything else looks at the page.
 *
 * MIRROR OF THE EDITOR, NOT SHARED CODE. `fractal-fe`'s
 * `features/screenTemplates/lib/expandTemplateRefs.ts` performs the same
 * assembly with the same id formula and the same merge rules; the two repos ship
 * separately, so this is a deliberate duplicate in the manner of
 * ROOT_FLEX_DEFAULTS. If the merge contract changes, BOTH move together or a
 * screen renders differently in the editor than it does in production.
 *
 * The one deliberate divergence is failure handling. The editor SHOWS an
 * unresolved reference so its author can fix it; this is a public screen, where
 * an unresolved reference is the renderer's normal silence — the component is
 * dropped, the rest of the page assembles, and diagnostics go to the console
 * and never into the markup.
 */ /**
 * FE-4733 — a template's local variables: qualification by placement, and the
 * template layer of the variable merge.
 *
 * A template body is SHARED by every placement, so it cannot name one. The
 * author writes local references — `{{state}}`, a Variables-chunk
 * `key: "state"`, `data.state` in a script — and every reference is qualified to
 * the placement PATH when the instance is assembled. The path is the chain of
 * placement names from the screen down: the screen-level placement's own id,
 * then the template node id of each nested placement below it —
 * `card-text-row-gap20-20-16-i81zHgSXo.action.state`. The template node id, not
 * the assembled `<placement>~<node>` id, because every level stores its path
 * relative to itself: the card declares `action.state`, not `…~action.state`.
 *
 * The values come from the same walk, bottom-up (`effectiveLocalsOf`): at each
 * level wrap what the nested placements declare into their placement names, then
 * lay the level's own declaration over it. At the screen that yields one object
 * per placement, and it goes UNDERNEATH `screen.settings.variables`
 * (`withTemplateVariables`), so the final order, right wins, is: templates →
 * `settings.variables` → backend parameters and event writes → global `c.*`.
 *
 * MIRROR OF THE EDITOR, NOT SHARED CODE — `fractal-fe`'s
 * `features/screenTemplates/lib/templateLocalVariables.ts`, same anchors. Two
 * deliberate differences: the editor qualifies with the assembled placement id,
 * one level deep, where this qualifies with the full path; and there is no
 * regex lookbehind here, because this runs on public pages in whatever browser
 * the visitor has.
 */ const $35b49f009a3f327f$var$isPlainObject = (value)=>!!value && typeof value === 'object' && !Array.isArray(value);
/**
 * Heads owned by other passes, never a template's to claim: `this` is row
 * scope, `c` the global store, `_c` / `_s` / `_config` the design-token and
 * config passes, `_l` localisation. A template that declares one gets neither
 * the qualification nor the merge for it — otherwise `{{_c.brand}}` inside the
 * body would be redirected into the placement and never reach its own pass.
 */ const $35b49f009a3f327f$var$RESERVED_HEADS = new Set([
    'this',
    'c',
    '_c',
    '_s',
    '_config',
    '_l'
]);
const $35b49f009a3f327f$var$cloneValue = (value)=>value && typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value;
const $35b49f009a3f327f$export$5600be0f3a865577 = (root)=>{
    const declared = $35b49f009a3f327f$var$isPlainObject(root) ? root.variables : undefined;
    if (!$35b49f009a3f327f$var$isPlainObject(declared)) return {};
    return Object.keys(declared).reduce((acc, key)=>{
        if (!$35b49f009a3f327f$var$RESERVED_HEADS.has(key)) acc[key] = declared[key];
        return acc;
    }, {});
};
const $35b49f009a3f327f$var$isUnresolvedPlaceholder = (value)=>typeof value === 'string' && /^\{\{.*\}\}$/.test(value);
/**
 * Lay `upper` over `lower`, right wins, without touching either.
 *
 * Plain objects merge key by key; anything else from `upper` REPLACES — an array
 * default is one value, and index-merging `['x']` over `['a', 'b']` into
 * `['x', 'b']` is the corruption lodash's merge would produce here. An upper
 * `"{{…}}"` that never resolved does not clobber a real lower value, the same
 * guard `mergeVariableBags` keeps between the layers above this one.
 */ const $35b49f009a3f327f$var$layerOver = (lower, upper)=>{
    if ($35b49f009a3f327f$var$isPlainObject(lower) && $35b49f009a3f327f$var$isPlainObject(upper)) {
        const out = {
            ...lower
        };
        Object.keys(upper).forEach((key)=>{
            out[key] = key in out ? $35b49f009a3f327f$var$layerOver(out[key], upper[key]) : $35b49f009a3f327f$var$cloneValue(upper[key]);
        });
        return out;
    }
    if (upper === undefined) return lower;
    if ($35b49f009a3f327f$var$isUnresolvedPlaceholder(upper) && lower !== undefined && !$35b49f009a3f327f$var$isUnresolvedPlaceholder(lower)) return lower;
    return $35b49f009a3f327f$var$cloneValue(upper);
};
/** Placement names within a body: each reference below the root, not descended into. */ const $35b49f009a3f327f$var$nestedPlacementsOf = (root)=>{
    const out = [];
    const visit = (nodes)=>{
        (Array.isArray(nodes) ? nodes : []).forEach((node)=>{
            if (!$35b49f009a3f327f$var$isPlainObject(node)) return;
            const externalId = typeof node.template === 'string' ? node.template.trim() : '';
            if (externalId && node.id !== undefined && node.id !== null) {
                out.push({
                    local: String(node.id),
                    externalId: externalId
                });
                return;
            }
            visit(node.items);
        });
    };
    visit(root.items);
    return out;
};
const $35b49f009a3f327f$export$3fd6718c0bb9b38a = (externalId, templates, rootOf, ancestry = [])=>{
    if (ancestry.indexOf(externalId) !== -1) return {};
    const root = rootOf(templates?.[externalId]);
    if (!root) return {};
    const chain = ancestry.concat(externalId);
    const nested = $35b49f009a3f327f$var$nestedPlacementsOf(root).reduce((acc, { local: local, externalId: ref })=>{
        const locals = $35b49f009a3f327f$export$3fd6718c0bb9b38a(ref, templates, rootOf, chain);
        if (Object.keys(locals).length && !$35b49f009a3f327f$var$RESERVED_HEADS.has(local)) acc[local] = locals;
        return acc;
    }, {});
    return $35b49f009a3f327f$var$layerOver(nested, $35b49f009a3f327f$export$5600be0f3a865577(root));
};
const $35b49f009a3f327f$export$5fd3ff355298e599 = (templateLayer, variables)=>{
    if (!$35b49f009a3f327f$var$isPlainObject(templateLayer) || !Object.keys(templateLayer).length) return variables;
    let own = variables;
    if (typeof own === 'string') try {
        own = JSON.parse(own);
    } catch  {
        own = undefined;
    }
    return $35b49f009a3f327f$var$layerOver(templateLayer, $35b49f009a3f327f$var$isPlainObject(own) ? own : {});
};
const $35b49f009a3f327f$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/**
 * The two anchors a local reference can sit behind, as in the editor:
 *   `{{state}}` / `{{state.x}}` — first segment of a binding; a plain string
 *      `"state"` is untouched because the next character is a quote;
 *   `data.state` — the script anchor. In serialized JSON a newline or tab
 *      before it is the two characters `\n` / `\t`, hence the escape branch.
 * `{{this…}}` is never a declared local, so row scope is never rewritten.
 */ const $35b49f009a3f327f$var$localRefRegexFor = (name)=>new RegExp(`(\\{\\{\\s*)${$35b49f009a3f327f$var$escapeRegExp(name)}(?=[\\s.}])` + `|((?:^|[^A-Za-z0-9_.$]|\\\\[nt])data\\.)${$35b49f009a3f327f$var$escapeRegExp(name)}(?![A-Za-z0-9_])`, 'g');
const $35b49f009a3f327f$var$headOf = (path)=>path.split('.')[0];
/**
 * Qualify the Variables-chunk WRITE keys. A key is a bare dotted path with no
 * `{{` and no `data.`, so the regex cannot see it; it is walked structurally.
 */ const $35b49f009a3f327f$var$qualifyVariableChunkKeys = (node, path, heads)=>{
    if (Array.isArray(node)) return node.map((child)=>$35b49f009a3f327f$var$qualifyVariableChunkKeys(child, path, heads));
    if (!$35b49f009a3f327f$var$isPlainObject(node)) return node;
    const out = {};
    Object.keys(node).forEach((key)=>{
        out[key] = $35b49f009a3f327f$var$qualifyVariableChunkKeys(node[key], path, heads);
    });
    if (Array.isArray(out.variables)) out.variables = out.variables.map((row)=>{
        if (!$35b49f009a3f327f$var$isPlainObject(row) || typeof row.key !== 'string') return row;
        const key = row.key.trim();
        if (!heads.has($35b49f009a3f327f$var$headOf(key))) return row;
        return {
            ...row,
            key: `${path}.${key}`
        };
    });
    return out;
};
const $35b49f009a3f327f$export$28ecb2a293df7413 = (subtree, path, heads)=>{
    const names = heads.filter((name)=>!!name && !$35b49f009a3f327f$var$RESERVED_HEADS.has(name));
    if (!path || !names.length) return subtree;
    const withKeys = $35b49f009a3f327f$var$qualifyVariableChunkKeys(subtree, path, new Set(names));
    const json = JSON.stringify(withKeys);
    if (typeof json !== 'string') return subtree;
    const qualified = names.reduce((acc, name)=>acc.replace($35b49f009a3f327f$var$localRefRegexFor(name), (_whole, binding, script)=>`${binding ?? script ?? ''}${path}.${name}`), json);
    return qualified === json ? withKeys : JSON.parse(qualified);
};


const $16d445f6645d8a76$export$3e8308555a6b6232 = '~';
const $16d445f6645d8a76$var$isPlainObject = (value)=>!!value && typeof value === 'object' && !Array.isArray(value);
/**
 * The body root of a map entry.
 *
 * Two envelopes, because both occur on the wire:
 *  - the entry is the RECORD (`{ id, name, status, data }`) — what
 *    `GET /screens/{key}?include=templates` returns;
 *  - the entry IS the body (`{ template: … }`) — what the public render
 *    envelope carries, where the metadata would be useless to a renderer.
 *
 * Reading only the record form is how the first version silently dropped every
 * reference on a real page: the key was present, the body was present, and the
 * lookup still answered "unresolved".
 *
 * The body is ALWAYS `data.template` — ONE root component (FE-4448), the only
 * form the backend reads (`data.template.style`). The `components` array this
 * used to also accept is gone: every consumer took `components[0]`, so a second
 * root was silently dropped at placement. The editor now refuses to save one.
 * Keep this in step with `fractal-fe`'s `templateRootOf`.
 */ const $16d445f6645d8a76$var$templateRootOf = (record)=>{
    if (!$16d445f6645d8a76$var$isPlainObject(record)) return null;
    const source = $16d445f6645d8a76$var$isPlainObject(record.data) ? record.data : record;
    return $16d445f6645d8a76$var$isPlainObject(source.template) ? source.template : null;
};
/**
 * Drop `null`-valued entries at any depth.
 *
 * `null` means "fall back to the template value" — an erasure of an override,
 * not a value to write. Merging it verbatim would blank the template's own value.
 */ const $16d445f6645d8a76$var$withoutNulls = (value)=>{
    if (Array.isArray(value) || !$16d445f6645d8a76$var$isPlainObject(value)) return value;
    return Object.keys(value).reduce((acc, key)=>{
        if (value[key] === null) return acc;
        acc[key] = $16d445f6645d8a76$var$withoutNulls(value[key]);
        return acc;
    }, {});
};
/**
 * Deep-merge an override onto a template node.
 *
 * Same contract as `updates.replace`: `{style:{width}}` overrides `width` only.
 * Arrays are REPLACED, never index-merged — `background` and `options` are
 * collections whose element 0 bears no relation to the template's element 0.
 */ const $16d445f6645d8a76$var$mergeOverride = (node, override)=>{
    const clean = $16d445f6645d8a76$var$withoutNulls(override);
    if (!$16d445f6645d8a76$var$isPlainObject(clean)) return node;
    const out = {
        ...node
    };
    Object.keys(clean).forEach((key)=>{
        const value = clean[key];
        const current = out[key];
        out[key] = $16d445f6645d8a76$var$isPlainObject(value) && $16d445f6645d8a76$var$isPlainObject(current) ? $16d445f6645d8a76$var$mergeOverride(current, value) : value;
    });
    return out;
};
/** Rewrite event `object_id` cross-references through an old-id → new-id map. */ const $16d445f6645d8a76$var$remapEventTargets = (node, idMap)=>{
    const out = {
        ...node
    };
    if ($16d445f6645d8a76$var$isPlainObject(out.events)) out.events = Object.keys(out.events).reduce((acc, eventType)=>{
        const chunks = out.events[eventType];
        acc[eventType] = Array.isArray(chunks) ? chunks.map((chunk)=>$16d445f6645d8a76$var$isPlainObject(chunk) && typeof chunk.object_id === 'string' && idMap.has(chunk.object_id) ? {
                ...chunk,
                object_id: idMap.get(chunk.object_id)
            } : chunk) : chunks;
        return acc;
    }, {});
    if (Array.isArray(out.items)) out.items = out.items.map((child)=>$16d445f6645d8a76$var$remapEventTargets(child, idMap));
    return out;
};
/**
 * One node of a template body, re-keyed and merged with its override.
 *
 * The ROOT keeps the PLACED component's id — that is the id the screen and its
 * events already address — while descendants are namespaced by it, so the same
 * template placed twice produces two disjoint subtrees.
 */ const $16d445f6645d8a76$var$buildInstance = (body, instanceId, overrides, idMap, isRoot = true)=>{
    const templateNodeId = body.id;
    const id = isRoot ? instanceId : `${instanceId}${$16d445f6645d8a76$export$3e8308555a6b6232}${templateNodeId}`;
    idMap.set(templateNodeId, id);
    const children = Array.isArray(body.items) ? body.items : [];
    const items = children.map((child)=>$16d445f6645d8a76$var$buildInstance(child, instanceId, overrides, idMap, false));
    const merged = $16d445f6645d8a76$var$mergeOverride({
        ...body
    }, overrides?.[templateNodeId]);
    return {
        ...merged,
        id: id,
        ...items.length ? {
            items: items
        } : {}
    };
};
/**
 * Expand every template reference in a section list.
 *
 * Returns a NEW array; nodes without a `template` field are passed through with
 * their children expanded, so a reference nested inside an ordinary container is
 * still assembled.
 *
 * `ancestry` guards against a template that references itself, directly or
 * through a chain, which would otherwise recurse until the stack blows.
 */ const $16d445f6645d8a76$var$containsTemplateRef = (nodes)=>nodes.some((node)=>$16d445f6645d8a76$var$isPlainObject(node) && (typeof node.template === 'string' && !!node.template.trim() || Array.isArray(node.items) && $16d445f6645d8a76$var$containsTemplateRef(node.items)));
const $16d445f6645d8a76$var$screenPlacementPath = (node)=>String(node.id);
const $16d445f6645d8a76$var$expandList = (sections, templates, ancestry, placementPathOf)=>{
    const list = Array.isArray(sections) ? sections : [];
    // A screen with no references must come out BYTE-IDENTICAL — the same array,
    // the same node objects. The assembly below rebuilds every container it walks
    // through, and this runs on the bootstrap path for every screen ever served,
    // so without this scan a page that has nothing to do with templates would pay
    // a full tree rebuild and lose object identity on first paint.
    if (!$16d445f6645d8a76$var$containsTemplateRef(list)) return list;
    return list.reduce((acc, node)=>{
        if (!$16d445f6645d8a76$var$isPlainObject(node)) {
            acc.push(node);
            return acc;
        }
        const externalId = typeof node.template === 'string' ? node.template.trim() : '';
        if (!externalId) {
            acc.push(Array.isArray(node.items) ? {
                ...node,
                items: $16d445f6645d8a76$var$expandList(node.items, templates, ancestry, placementPathOf)
            } : node);
            return acc;
        }
        if (ancestry.indexOf(externalId) !== -1) {
            // eslint-disable-next-line no-console
            console.warn(`[templates] circular reference to ${externalId}; component "${node.id}" skipped`);
            return acc;
        }
        const body = $16d445f6645d8a76$var$templateRootOf(templates[externalId]);
        if (!body) {
            // UNRESOLVED — deleted permanently, or living in another branch. This is a
            // public screen: drop the component, assemble the rest, and say nothing in
            // the markup. The editor is the surface that shows failure states.
            // eslint-disable-next-line no-console
            console.warn(`[templates] unresolved template ${externalId} for component "${node.id}"`);
            return acc;
        }
        const idMap = new Map();
        const instance = $16d445f6645d8a76$var$buildInstance(body, String(node.id), $16d445f6645d8a76$var$isPlainObject(node.overrides) ? node.overrides : {}, idMap);
        const remapped = $16d445f6645d8a76$var$remapEventTargets(instance, idMap);
        // FE-4733 — qualify this body's local references to the placement path, so
        // two placements of one template cannot share a value. It runs BEFORE the
        // nested expansion below: a nested reference is still an unexpanded
        // `{ template, overrides }` node here, so only names THIS level owns are
        // rewritten — its own declaration plus the names of its nested placements —
        // and a name the nested body uses without declaring it is left for the
        // screen (UC-7). Each nested body is then qualified with the longer path.
        const path = placementPathOf(node);
        const heads = Object.keys((0, $35b49f009a3f327f$export$3fd6718c0bb9b38a)(externalId, templates, $16d445f6645d8a76$var$templateRootOf, ancestry));
        const qualified = (0, $35b49f009a3f327f$export$28ecb2a293df7413)(remapped, path, heads);
        const localIdOf = new Map();
        idMap.forEach((assembledId, templateNodeId)=>localIdOf.set(assembledId, templateNodeId));
        const nestedPathOf = (nested)=>`${path}.${localIdOf.get(String(nested.id)) ?? String(nested.id)}`;
        acc.push({
            ...qualified,
            items: $16d445f6645d8a76$var$expandList(qualified.items, templates, ancestry.concat(externalId), nestedPathOf)
        });
        return acc;
    }, []);
};
const $16d445f6645d8a76$export$f75350e774e076c0 = (sections, templates)=>{
    const list = Array.isArray(sections) ? sections : [];
    if (!$16d445f6645d8a76$var$isPlainObject(templates)) return list;
    return $16d445f6645d8a76$var$expandList(list, templates, [], $16d445f6645d8a76$var$screenPlacementPath);
};
const $16d445f6645d8a76$export$41bf54004b173df6 = (sections, templates)=>{
    const layer = {};
    if (!$16d445f6645d8a76$var$isPlainObject(templates)) return layer;
    const visit = (nodes)=>{
        (Array.isArray(nodes) ? nodes : []).forEach((node)=>{
            if (!$16d445f6645d8a76$var$isPlainObject(node)) return;
            const externalId = typeof node.template === 'string' ? node.template.trim() : '';
            if (!externalId) {
                visit(node.items);
                return;
            }
            const locals = (0, $35b49f009a3f327f$export$3fd6718c0bb9b38a)(externalId, templates, $16d445f6645d8a76$var$templateRootOf);
            if (Object.keys(locals).length) layer[String(node.id)] = locals;
        });
    };
    visit(sections);
    return layer;
};
const $16d445f6645d8a76$export$e7a25978043fb98a = (settings, sections, templates)=>{
    const layer = $16d445f6645d8a76$export$41bf54004b173df6(sections, templates);
    if (!Object.keys(layer).length) return settings;
    const base = $16d445f6645d8a76$var$isPlainObject(settings) ? settings : {};
    return {
        ...base,
        variables: (0, $35b49f009a3f327f$export$5fd3ff355298e599)(layer, base.variables)
    };
};



/**
 * FE-4517 — resolve style classes at render time.
 *
 * A node names its classes in `style.class`, and since FE-4517 those entries are
 * each class's **external_id**, not its CSS name. The bodies arrive with the
 * screen in a `classes` map keyed by that id — exactly as template bodies arrive
 * in `templates` — because the renderer has no classes API and can only render
 * what it is delivered.
 *
 * MIRROR OF THE EDITOR, NOT SHARED CODE. `fractal-fe` resolves the same map in
 * `useClassStyleMap` and merges it in each panel's `mergedStyles`; the two repos
 * ship separately, so this is a deliberate duplicate in the manner of
 * `screenTemplates.ts` and ROOT_FLEX_DEFAULTS. If the precedence changes, BOTH
 * move together or a screen renders differently in the editor than in production.
 *
 * PRECEDENCE: the class is the BASE layer and the node's own value wins. That is
 * what makes a class a default a component may override, and it matches the
 * editor, where `mergedStyles` merges `mergedClasses` first and the node's own
 * style on top.
 */ const $45287d3e48b5815e$var$isPlainObject = (value)=>!!value && typeof value === 'object' && !Array.isArray(value);
/** The ids in one `style.class` value. Tolerates the string and array shapes. */ const $45287d3e48b5815e$var$idsOf = (value)=>{
    if (typeof value === 'string') return value.split(' ').map((part)=>part.trim()).filter(Boolean);
    if (Array.isArray(value)) return value.filter((part)=>typeof part === 'string' && !!part.trim()).map((part)=>part.trim());
    return [];
};
/**
 * Deep-merge, with `upper` winning.
 *
 * Arrays are REPLACED, never index-merged — `background` is an ordered layer
 * stack and `options` a collection, so element 0 of one bears no relation to
 * element 0 of the other. Same rule the template override merge follows.
 */ const $45287d3e48b5815e$var$mergeUnder = (base, upper)=>{
    const out = {
        ...base
    };
    Object.keys(upper).forEach((key)=>{
        const value = upper[key];
        const current = out[key];
        out[key] = $45287d3e48b5815e$var$isPlainObject(value) && $45287d3e48b5815e$var$isPlainObject(current) ? $45287d3e48b5815e$var$mergeUnder(current, value) : value;
    });
    return out;
};
/**
 * Apply the classes named at ONE style scope, and recurse into nested scopes.
 *
 * `class` is legal at every level — `states.hover.class` and
 * `breakpoints.mobile.class` are as valid as the base — because a state override
 * is itself a partial style. Resolving only the base would leave a
 * hover-only class unstyled, which reads as a component that loses its styling
 * the moment you point at it.
 *
 * The `class` key is KEPT after resolution, not stripped: it is still emitted as
 * the DOM `className`, which is what page-level CSS and any author stylesheet
 * hook onto.
 */ const $45287d3e48b5815e$var$resolveScope = (style, classStyles)=>{
    if (!$45287d3e48b5815e$var$isPlainObject(style)) return style;
    // Nested scopes first, so a state's own class is resolved before that state is
    // merged over the base below.
    const withScopes = {
        ...style
    };
    Object.keys(withScopes).forEach((key)=>{
        if (key === 'class') return;
        if ($45287d3e48b5815e$var$isPlainObject(withScopes[key])) withScopes[key] = $45287d3e48b5815e$var$resolveScope(withScopes[key], classStyles);
    });
    const ids = $45287d3e48b5815e$var$idsOf(withScopes.class);
    if (!ids.length) return withScopes;
    // Left to right, so a later class wins over an earlier one — the cascade order
    // an author writing `"a b"` expects.
    let beneath = {};
    ids.forEach((id)=>{
        const classStyle = classStyles[id];
        if ($45287d3e48b5815e$var$isPlainObject(classStyle)) beneath = $45287d3e48b5815e$var$mergeUnder(beneath, classStyle);
    });
    // A class must never carry structure into the node it styles.
    delete beneath.class;
    delete beneath.states;
    delete beneath.breakpoints;
    return $45287d3e48b5815e$var$mergeUnder(beneath, withScopes);
};
/**
 * The delivered map, flattened to id → style.
 *
 * Two envelopes, because both occur on the wire — the same pair
 * `templateRootOf` handles: the entry is the RECORD (`{ id, name, data }`), or
 * the entry IS the style. Reading only the record form is how the template
 * expansion once silently dropped every reference on a real page.
 */ const $45287d3e48b5815e$var$classMapCache = new WeakMap();
const $45287d3e48b5815e$export$bd663e08074c0fbe = (classes)=>{
    if (!$45287d3e48b5815e$var$isPlainObject(classes)) return {};
    // FE-4577 — memoised on the source map's identity. This used to be handed the
    // handful of classes one screen delivered; it is now handed the branch's
    // ENTIRE accumulated set, on every parse, every cache read and every socket
    // frame. The design-system resolver keeps that map's identity stable while
    // nothing is delivered, so after warm-up this is a single lookup.
    const cached = $45287d3e48b5815e$var$classMapCache.get(classes);
    if (cached) return cached;
    const flattened = Object.keys(classes).reduce((acc, key)=>{
        const entry = classes[key];
        if (!$45287d3e48b5815e$var$isPlainObject(entry)) return acc;
        const data = $45287d3e48b5815e$var$isPlainObject(entry.data) ? entry.data : entry;
        if ($45287d3e48b5815e$var$isPlainObject(data)) acc[key] = data;
        return acc;
    }, {});
    $45287d3e48b5815e$var$classMapCache.set(classes, flattened);
    return flattened;
};
/** Does this style scope, or any nested one, actually name a class? */ const $45287d3e48b5815e$var$scopeNamesClass = (style)=>{
    if (!$45287d3e48b5815e$var$isPlainObject(style)) return false;
    if ($45287d3e48b5815e$var$idsOf(style.class).length > 0) return true;
    return Object.keys(style).some((key)=>key !== 'class' && $45287d3e48b5815e$var$isPlainObject(style[key]) && $45287d3e48b5815e$var$scopeNamesClass(style[key]));
};
/**
 * FE-4577 — the same pre-scan `expandTemplateRefs` carries, and now needed for
 * the same reason.
 *
 * `applyStyleClasses` used to escape early whenever the DELIVERED class map was
 * empty, which was the common case. Fed the whole branch's set from the store,
 * that map is never empty, so without this a screen naming no class at all would
 * pay a full tree rebuild and lose object identity on every single parse.
 */ const $45287d3e48b5815e$var$containsClassRef = (nodes)=>nodes.some((node)=>{
        if (!$45287d3e48b5815e$var$isPlainObject(node)) return false;
        if ($45287d3e48b5815e$var$scopeNamesClass(node.style)) return true;
        return Array.isArray(node.items) && $45287d3e48b5815e$var$containsClassRef(node.items);
    });
const $45287d3e48b5815e$export$8a8430000842166d = (sections, classes)=>{
    const list = Array.isArray(sections) ? sections : [];
    const classStyles = $45287d3e48b5815e$export$bd663e08074c0fbe(classes);
    if (!Object.keys(classStyles).length) return sections;
    if (!$45287d3e48b5815e$var$containsClassRef(list)) return sections;
    const step = (node)=>{
        if (!$45287d3e48b5815e$var$isPlainObject(node)) return node;
        const resolvedStyle = $45287d3e48b5815e$var$resolveScope(node.style, classStyles);
        const items = Array.isArray(node.items) ? node.items.map(step) : node.items;
        if (resolvedStyle === node.style && items === node.items) return node;
        return {
            ...node,
            ...node.style !== undefined ? {
                style: resolvedStyle
            } : {},
            ...node.items !== undefined ? {
                items: items
            } : {}
        };
    };
    return list.map(step);
};


function $7b0e169a5380005e$export$8c51936ffbb22bee(input) {
    try {
        const parsedJSON = JSON.parse(input);
        return parsedJSON;
    } catch (error) {
        // Parsing failed, return the original input
        return input;
    }
}
function $7b0e169a5380005e$export$678f3c59bb79515(input, pretty) {
    if (typeof input === 'object' && input !== null) try {
        // Add the second and third parameters to JSON.stringify for indentation
        const jsonString = JSON.stringify(input, null, pretty ? 2 : 0);
        return jsonString;
    } catch (error) {
        // Stringification failed, return the original input
        return '';
    }
    else // Input is not an object, return it as is
    return '';
}
// TNBEWEB-1992: recursive Proxy that turns property access into dotted-path get/set.
// `data.a.b = 1` writes path 'a.b'; `data.a.b` reads it. Nested objects/arrays return a
// child proxy so writes flow through at any depth; scalars return the raw (native-typed)
// value. Symbols (Symbol.iterator, Symbol.toPrimitive, …) delegate to the raw node so a
// nested array/object can still be iterated or spread.
const $7b0e169a5380005e$var$makeVarProxy = (basePath, readFn, writeFn)=>new Proxy(Object.create(null), {
        get (_t, prop) {
            if (typeof prop === 'symbol') {
                const node = readFn(basePath);
                if (node === null || node === undefined) {
                    // A missing node coerces like `undefined` (NaN in arithmetic, "undefined" as a
                    // string) rather than "[object Object]", so a leaf read of an unset var stays sane.
                    if (prop === Symbol.toPrimitive) return ()=>undefined;
                    return undefined;
                }
                const sv = node[prop];
                return typeof sv === 'function' ? sv.bind(node) : sv;
            }
            const full = basePath ? `${basePath}.${String(prop)}` : String(prop);
            const val = readFn(full);
            if (val === null) return null;
            // TNBEWEB-1992 (v2 data.* model): arrays read RAW so `.filter/.map/.find`, `Array.isArray`
            // and `|| []` behave natively — a child proxy breaks them and, once stored, corrupts the
            // array. Reassign the whole array rather than mutating an element in place.
            if (Array.isArray(val)) return val;
            // Plain objects AND not-yet-existing (undefined) paths return a child proxy, so a nested
            // write to a missing path — `data.form.address.city = 1` — creates it (the set trap gets
            // the full dotted path). Existing scalars return raw, matching $get. (Caveat: reading a
            // never-set key yields a truthy proxy, not undefined — screen vars are normally declared.)
            if (val === undefined || typeof val === 'object') return $7b0e169a5380005e$var$makeVarProxy(full, readFn, writeFn);
            return val;
        },
        set (_t, prop, value) {
            if (typeof prop === 'symbol') return false;
            writeFn(basePath ? `${basePath}.${String(prop)}` : String(prop), value);
            return true;
        },
        has (_t, prop) {
            if (typeof prop === 'symbol') return false;
            const full = basePath ? `${basePath}.${String(prop)}` : String(prop);
            return readFn(full) !== undefined;
        },
        ownKeys () {
            const node = readFn(basePath);
            return node !== null && typeof node === 'object' ? Reflect.ownKeys(node) : [];
        },
        getOwnPropertyDescriptor (_t, prop) {
            if (typeof prop === 'symbol') return undefined;
            const full = basePath ? `${basePath}.${String(prop)}` : String(prop);
            const val = readFn(full);
            if (val === undefined) return undefined;
            return {
                value: val,
                enumerable: true,
                configurable: true,
                writable: true
            };
        }
    });
const $7b0e169a5380005e$export$d46cc9e985b98ed3 = (fns)=>{
    const read = (p)=>fns.$getVariable(p);
    const write = (p, v)=>fns.writeVar?.(p, v);
    const data = $7b0e169a5380005e$var$makeVarProxy('', read, write);
    // Global variables are addressed by the string-form 'c.' prefix; _c.x ≡ $get('c.x').
    const globalScope = $7b0e169a5380005e$var$makeVarProxy('', (p)=>read(`c.${p}`), (p, v)=>write(`c.${p}`, v));
    const hasRow = fns.thisRow !== null && fns.thisRow !== undefined && typeof fns.rowPath === 'string';
    const thisArg = hasRow ? $7b0e169a5380005e$var$makeVarProxy('', // eslint-disable-next-line @typescript-eslint/no-use-before-define
    (p)=>$7b0e169a5380005e$export$2516322ffbb7f3fb(fns.thisRow, p), (p, v)=>write(`${fns.rowPath}.${p}`, v)) : undefined;
    // `global` is the single proxy behind both _c and _config (see executeFunction).
    return {
        data: data,
        global: globalScope,
        thisArg: thisArg
    };
};
const $7b0e169a5380005e$export$1ed0175478ddd28b = (functionString, $event, internalFns, // When true, errors propagate to the caller instead of being swallowed. Used by
// `pre`-timing functions: a thrown / rejected `pre` function must abort the event's
// requests. Default false keeps legacy `during` callers fire-and-forget.
rethrowErrors = false)=>{
    try {
        // Check for state function calls. The short names also match the long names
        // (e.g. "$setVariable".includes("$set")), so a single substring check covers both.
        const hasSetState = functionString.includes('$set');
        const hasGetState = functionString.includes('$get');
        // TNBEWEB-1992: data / _c / _config / this. Built only when the caller supplied the new
        // write path (writeVar); otherwise `scope` is undefined and behaviour is 100% legacy.
        const scope = internalFns?.writeVar ? $7b0e169a5380005e$export$d46cc9e985b98ed3(internalFns) : undefined;
        // Inject a scope object only when the handler references it as a WHOLE WORD and does not
        // declare its own binding of that name (a strict-mode `let/const/function/class <id>`
        // clashing with a same-named parameter is a SyntaxError). `data`/`_c`/`_config` were never
        // valid bare identifiers before (no closure provided them), so injecting can only fix a
        // ReferenceError, never change a working handler.
        const wants = (id)=>new RegExp(`\\b${id}\\b`).test(functionString) && !new RegExp(`\\b(?:let|const|function|class)\\s+${id}\\b`).test(functionString);
        // Create context with allowed internal functions.
        // $set / $get are short aliases of $setVariable / $getVariable (TNBEWEB-1987);
        // the long names remain as deprecated aliases for backward compatibility.
        const context = {
            $event: $event,
            $response: internalFns?.$response,
            ...hasSetState && {
                $setVariable: internalFns?.$setVariable,
                $set: internalFns?.$setVariable
            },
            ...hasGetState && {
                $getVariable: internalFns?.$getVariable,
                $get: internalFns?.$getVariable
            },
            ...scope && wants('data') && {
                data: scope.data
            },
            ...scope && wants('_c') && {
                _c: scope.global
            },
            ...scope && wants('_config') && {
                _config: scope.global
            }
        };
        // Create function with controlled scope
        const func = new Function(...Object.keys(context), `
      "use strict";
      ${functionString}
    `);
        // Execute with provided context. `this` is the current repeatable row (a Proxy) when one
        // exists; otherwise undefined — identical to the previous plain call under strict mode.
        // Return the result so callers can await a returned Promise (`pre` timing).
        return func.apply(scope?.thisArg, Object.values(context));
    } catch (error) {
        // A `pre` caller reports the failure itself (reportPreCancelled); logging here as well
        // printed every cancelled event twice.
        if (rethrowErrors) throw error;
        console.error('Error executing function:', error);
    }
};
// A function result is async only when it is a thenable. Reading `then` can itself throw
// (a hostile getter) — callers invoke this inside their try, so that counts as a failure.
const $7b0e169a5380005e$var$isThenable = (value)=>value !== null && (typeof value === 'object' || typeof value === 'function') && typeof value.then === 'function';
const $7b0e169a5380005e$export$6c3d028e3b451352 = (functionUpdates = [])=>({
        pre: functionUpdates.filter((u)=>u?.function && u.timing === 'pre'),
        during: functionUpdates.filter((u)=>u?.function && u.timing !== 'pre')
    });
const $7b0e169a5380005e$export$54132b3e2309dd2c = (preFns, internalFns, $event)=>{
    const runFrom = (start)=>{
        for(let i = start; i < preFns.length; i += 1){
            const result = $7b0e169a5380005e$export$1ed0175478ddd28b(preFns[i].function, $event, internalFns, true);
            if ($7b0e169a5380005e$var$isThenable(result)) {
                const next = i + 1;
                // Adopt the thenable ONCE: a hand-rolled `then` that calls back twice must not re-run
                // the pre functions after it.
                return Promise.resolve(result).then(()=>runFrom(next));
            }
        }
        return undefined;
    };
    return runFrom(0);
};
const $7b0e169a5380005e$export$abfe38bb9d3b70f4 = (internalFns, reason)=>{
    console.warn('Event cancelled by its "pre" function; its styles, actions and requests were skipped:', reason);
    internalFns?.onPreCancelled?.(reason);
};
const $7b0e169a5380005e$export$4526859d798b35 = (functionUpdates, internalFns, runEffects, $event)=>{
    const { pre: pre, during: during } = $7b0e169a5380005e$export$6c3d028e3b451352(functionUpdates);
    // during: fire-and-forget, before/parallel with the effects
    during.forEach((update)=>{
        $7b0e169a5380005e$export$1ed0175478ddd28b(update.function, $event, internalFns);
    });
    if (!pre.length) {
        runEffects();
        return;
    }
    let pending;
    try {
        pending = $7b0e169a5380005e$export$54132b3e2309dd2c(pre, internalFns, $event);
    } catch (err) {
        $7b0e169a5380005e$export$abfe38bb9d3b70f4(internalFns, err);
        return;
    }
    if (!pending) {
        internalFns.onPrePassed?.();
        runEffects();
        return;
    }
    pending.then(()=>{
        internalFns.onPrePassed?.();
        runEffects();
    }, (err)=>$7b0e169a5380005e$export$abfe38bb9d3b70f4(internalFns, err))// A throw inside the effects is not a cancelled pre function — report it as what it is.
    .catch((err)=>console.error('Event effects failed after its "pre" functions:', err));
};
const $7b0e169a5380005e$export$2516322ffbb7f3fb = (obj, path)=>{
    // Handle empty/invalid paths
    if (!path) return undefined;
    // Split path into parts (e.g. "user.address.street" -> ["user", "address", "street"])
    const parts = path.split('.');
    let result = obj;
    // Traverse the object following the path
    for (const part of parts){
        if (result === null || result === undefined) return undefined;
        result = result[part];
    }
    return result;
};
const $7b0e169a5380005e$export$c52c7e952af52ee2 = (obj, path, value)=>{
    // Handle empty/invalid paths
    if (!path) return;
    // Split path into parts (e.g. "user.address.street" -> ["user", "address", "street"])
    const parts = path.split('.');
    let current = obj;
    // Navigate to the parent of the target property
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i];
        if (current[part] === null || typeof current[part] !== 'object') current[part] = {};
        current = current[part];
    }
    // Set the final value
    current[parts[parts.length - 1]] = value;
};
const $7b0e169a5380005e$export$59feb59f25215061 = (node)=>{
    while(node){
        if (node instanceof HTMLElement && node.getAttribute('data-portal') === 'true') return true;
        node = node.parentNode;
    }
    return false;
};
const $7b0e169a5380005e$export$61fc7d43ac8f84b0 = (func, delay)=>{
    let timeoutId;
    return function deb(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>func.apply(this, args), delay);
    };
};
const $7b0e169a5380005e$export$78e968efcca6b7ef = (pattern, nodeId)=>{
    const regex = new RegExp(`^${pattern.replace('*', '.*')}$`);
    return regex.test(nodeId);
};
function $7b0e169a5380005e$export$2083ef81b7b5b44(obj) {
    const { command: command, action: action, component_id: component_id, screen_id: screen_id } = obj || {};
    let cacheKey = command;
    if (component_id && screen_id) {
        if (action) cacheKey = `${screen_id}/${component_id}/${action}`;
        else if (command) cacheKey = `${screen_id}/${component_id}/${command}`;
    }
    return cacheKey;
}
function $7b0e169a5380005e$export$b40f43cc69224c6e(scheme) {
    let hasCache = false;
    const pattern = /{{.*}}/;
    function analyzeObject(obj) {
        // Create copy of object to avoid mutations
        const result = {
            ...obj
        };
        // Remove any existing events
        // if (result.events) {
        //   delete result.events;
        // }
        // Check if current object has cache:true or value matches the pattern
        if (obj.cache === true || typeof obj.value === 'string' && pattern.test(obj.value) && obj.cache !== false) {
            hasCache = true;
            result.skeleton = true;
            return result;
        }
        // Only process if items array exists
        if (Array.isArray(obj.items)) result.items = obj.items.map((item)=>analyzeObject(item));
        return result;
    }
    const transformed = scheme.map((obj)=>analyzeObject(obj));
    return {
        status: hasCache,
        transformed: transformed
    };
}
function $7b0e169a5380005e$export$9cb59c0e57b11a(scheme) {
    function clearObject(obj) {
        // Create copy of object to avoid mutations
        const result = {
            ...obj
        };
        // Remove skeleton property if it exists
        if (result.skeleton !== undefined) delete result.skeleton;
        // Recursively process items array if it exists
        if (Array.isArray(obj.items)) result.items = obj.items.map((item)=>clearObject(item));
        return result;
    }
    return scheme.map((obj)=>clearObject(obj));
}
function $7b0e169a5380005e$export$8f49bf34d2145408(items, idsObject, updateFunc, insideTable = false) {
    return items.map((item)=>{
        const isTable = item.component === "table";
        const newInsideTable = insideTable || isTable;
        // Check if item.id matches any pattern in ids or if item.id is directly in ids
        const idMatches = Object.keys(idsObject).some((id)=>id === item.id || $7b0e169a5380005e$export$78e968efcca6b7ef(id, item.id) && idsObject[id]?.object_type === item.component);
        if (idMatches) item = updateFunc({
            ...item
        }, newInsideTable);
        if (item.items && item.items.length > 0) return {
            ...item,
            items: $7b0e169a5380005e$export$8f49bf34d2145408(item.items, idsObject, updateFunc, newInsideTable)
        };
        return item;
    });
}
// A value that is ENTIRELY an unresolved `{{...}}` template — e.g. the literal
// `"{{parameters.repayment_schedule_details}}"` the backend leaves behind when a
// dynamic value reference fails to resolve (see `variable_data._errors` /
// `parameters.*`). It carries no data.
const $7b0e169a5380005e$var$isUnresolvedVariablePlaceholder = (v)=>typeof v === 'string' && /^\{\{.*\}\}$/.test(v);
function $7b0e169a5380005e$export$fdb973e72befebb1(...sources) {
    const result = {};
    sources.forEach((src)=>{
        if (!src || typeof src !== 'object') return;
        const safe = {};
        Object.keys(src).forEach((key)=>{
            const incoming = src[key];
            const existing = result[key];
            if ($7b0e169a5380005e$var$isUnresolvedVariablePlaceholder(incoming) && existing !== undefined && !$7b0e169a5380005e$var$isUnresolvedVariablePlaceholder(existing)) return; // keep the resolved value; drop the clobbering placeholder
            safe[key] = incoming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))(result, safe); // lodash deep-merge handles nested objects + cloning
    });
    return result;
}
function $7b0e169a5380005e$export$8c1182ab03da08ba(globalVariables, localVariables) {
    return $7b0e169a5380005e$export$fdb973e72befebb1(localVariables || {}, globalVariables || {});
}
function $7b0e169a5380005e$export$5356827378a1e669(items, name, excludeId) {
    const changedIds = [];
    const updatedItems = items.map((item)=>{
        if (item.component === 'radio' && item.name === name && item.id !== excludeId) {
            item.value = false;
            changedIds.push(item.id);
        } else if (item.component === 'radio' && item.name === name && item.id === excludeId) item.value = true;
        if (item.items && item.items.length > 0) {
            const nestedResult = $7b0e169a5380005e$export$5356827378a1e669(item.items, name, excludeId);
            changedIds.push(...nestedResult.changedIds);
            return {
                ...item,
                items: nestedResult.items
            };
        }
        return item;
    });
    return {
        items: updatedItems,
        changedIds: changedIds
    };
}
function $7b0e169a5380005e$export$ff76c51b0f744e0a(style) {
    const tag = document.createElement('style');
    tag.innerHTML = style;
    document.head.appendChild(tag);
}
function $7b0e169a5380005e$export$fce6876652108ab(value) {
    return typeof value === 'undefined' || value === null || value.length === 0;
}
function $7b0e169a5380005e$export$4385e60b38654f68() {
    return Math.floor(Math.random() * 0xffff);
}
function $7b0e169a5380005e$export$aeecb75b7111fef7(inputString) {
    if (!inputString || !inputString.length) return inputString;
    return inputString.replace(/\$[a-zA-Z0-9_-]+/g, (match)=>`var(--${match.slice(1)})`);
}
const $7b0e169a5380005e$export$189053d41e721fcb = (...classes)=>{
    const processedClasses = classes.reduce((acc, className)=>{
        if (typeof className === 'string') acc.push(...className.split(' '));
        else if (Array.isArray(className)) acc.push(...className);
        else if (className && typeof className === 'object') Object.keys(className).forEach((key)=>{
            if (className[key]) acc.push(key);
        });
        return acc;
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4aeabe14c1618d30$exports)))(...processedClasses);
};
const $7b0e169a5380005e$export$f86e83e7d412cd5e = (spacing)=>{
    if (!spacing) return {};
    const parseValue = (val)=>{
        if (typeof val === 'number') return `${val}px`;
        if (typeof val === 'string' && val.trim() !== '') return val.includes('px') || val.includes('%') ? val : `${parseFloat(val)}px`;
        return '';
    };
    if (Array.isArray(spacing)) {
        const [top, right, bottom, left] = spacing.map(parseValue);
        const result = {};
        if (top) result.marginTop = top;
        if (right) result.marginRight = right;
        if (bottom) result.marginBottom = bottom;
        if (left) result.marginLeft = left;
        return result;
    }
    if (typeof spacing === 'number' || typeof spacing === 'string' && spacing.trim() !== '') {
        const value = parseValue(spacing);
        return {
            marginTop: value,
            marginRight: value,
            marginBottom: value,
            marginLeft: value
        };
    }
    return {};
};
const $7b0e169a5380005e$export$d7647e01dea1340 = (spacing)=>{
    if (!spacing) return {};
    const parseValue = (val)=>{
        if (typeof val === 'number') return `${val}px`;
        if (typeof val === 'string' && val.trim() !== '') return val.includes('px') || val.includes('%') ? val : `${parseFloat(val)}px`;
        return '';
    };
    if (Array.isArray(spacing)) {
        const [top, right, bottom, left] = spacing.map(parseValue);
        const result = {};
        if (top) result.paddingTop = top;
        if (right) result.paddingRight = right;
        if (bottom) result.paddingBottom = bottom;
        if (left) result.paddingLeft = left;
        return result;
    }
    if (typeof spacing === 'number' || typeof spacing === 'string' && spacing.trim() !== '') {
        const value = parseValue(spacing);
        return {
            paddingTop: value,
            paddingRight: value,
            paddingBottom: value,
            paddingLeft: value
        };
    }
    return {};
};
function $7b0e169a5380005e$export$d673a9445babfbef(svg_string) {
    if (typeof svg_string !== 'string') return false;
    if (!svg_string.trim().match(/^<svg[^>]*>[\s\S]*<\/svg>$/i)) return false;
    const parser = new DOMParser();
    const doc = parser.parseFromString(svg_string, 'image/svg+xml');
    return doc.documentElement.nodeName === 'svg';
}
function $7b0e169a5380005e$export$a5202107d3e3cdb0() {
    const parser = new (0, (/*@__PURE__*/$parcel$interopDefault($4vp6j)))();
    const browserInfo = parser.getResult();
    const geodata = null;
    navigator.permissions;
    return {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
        offset: -new Date().getTimezoneOffset(),
        localization: navigator.language || null,
        device_id: null,
        device_os: browserInfo.os.name || null,
        browser_version: browserInfo.browser.version || null,
        browser_provider: browserInfo.browser.name || null,
        front_version: "0.1",
        back_version: "0.1",
        screen_resolution: {
            w: window.screen.width || null,
            h: window.screen.height || null
        },
        device_type: browserInfo.device.type || 'desktop',
        external_ip: null,
        internal_ip: null,
        geodata: geodata ? {
            latitude: geodata.latitude,
            longitude: geodata.longitude,
            altitude: geodata.altitude,
            accuracy: geodata.accuracy,
            altitude_accuracy: geodata.altitudeAccuracy,
            heading: geodata.heading,
            speed: geodata.speed
        } : null
    };
}
function $7b0e169a5380005e$export$a8c212b8aefc29ec(section) {
    const formValues = {};
    const parseItems = (items)=>{
        items.forEach((item)=>{
            if (item.id && item.value !== undefined && (item.component === 'input' || item.component === 'checkbox' || item.component === 'radio' || item.component === 'select' || item.component === 'switcher')) formValues[item.id] = item.value;
            if (item.items && item.items.length > 0) parseItems(item.items);
        });
    };
    if (Array.isArray(section)) section.forEach((sec)=>{
        if (sec.items) parseItems(sec.items);
    });
    if (section && section.items) parseItems(section.items);
    return formValues;
}
const $7b0e169a5380005e$export$9b89bb1262f2987f = (value)=>{
    const regex = /^\{\{.*\}\}$/;
    return regex.test(value);
};
const $7b0e169a5380005e$export$3175f779c869dc51 = (value)=>{
    if (typeof value !== 'string') return [
        $7b0e169a5380005e$export$678f3c59bb79515(value, false)
    ];
    const matches = [
        ...value.matchAll(/\{\{(.*?)\}\}/g)
    ];
    return matches.map((match)=>match[1]);
};
const $7b0e169a5380005e$export$19c69f429b13dbe1 = (value)=>{
    if (!value) return '';
    const match = value.match(/\{\{(.*?)\}\}/);
    return match ? match[1] : value;
};
const $7b0e169a5380005e$export$a87687c5ea189578 = (obj, path)=>{
    // Handle the case where the path is exactly 'this'
    if (path === 'this') return typeof obj === 'string' ? obj : JSON.stringify(obj);
    if (Array.isArray(path)) {
        const normalizedPaths = path.map((p)=>p.startsWith('this.') ? p.slice(5) : p);
        const values = normalizedPaths.map((p)=>p.split('.').reduce((acc, part)=>acc && acc[part], obj));
        return values.map((value)=>typeof value === 'string' ? value : JSON.stringify(value)).join('');
    }
    // Remove 'this.' prefix if it exists
    const normalizedPath = path.startsWith('this.') ? path.slice(5) : path;
    const value = normalizedPath.split('.').reduce((acc, part)=>acc && acc[part], obj);
    return typeof value === 'string' ? value : JSON.stringify(value);
};
const $7b0e169a5380005e$export$ebda49d0e9aa0c89 = (obj, path)=>path.split('.').reduce((acc, part)=>{
        const value = acc !== undefined && acc !== null && typeof acc === 'object' && !Array.isArray(acc) ? acc[part] : acc;
        if (typeof value === 'number' || typeof value === 'boolean') return value.toString();
        return value;
    }, obj);
// Keys whose pre-substitution template is preserved as `<key>Original` when page
// init resolves the scheme. `value` is long-standing; `to` is FE-4677.
// Blast radius for `to` is nil: it is never a constructed object key in this repo,
// it only ever arrives from scheme JSON as `ActionChunk.to`.
const $7b0e169a5380005e$var$TEMPLATE_ORIGIN_KEYS = new Set([
    'value',
    'to'
]);
const $7b0e169a5380005e$export$9a7eef5d73136d1e = (style, variables)=>{
    const parsedVars = typeof variables === 'string' ? $7b0e169a5380005e$export$8c51936ffbb22bee(variables) : variables;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const replacePlaceholders = (obj)=>{
        if (typeof obj === 'string') {
            const regex = /{{(.*?)}}/g;
            let match;
            let result = obj;
            const matches = [];
            // eslint-disable-next-line no-cond-assign
            while((match = regex.exec(obj)) !== null)matches.push(match);
            // eslint-disable-next-line @typescript-eslint/no-shadow
            matches.forEach((match)=>{
                if (match[0].startsWith('{{this') || match[0].startsWith('{{_l.')) return;
                const variablePath = match[1].trim();
                const variableValue = $7b0e169a5380005e$export$ebda49d0e9aa0c89(parsedVars, variablePath);
                // eslint-disable-next-line no-nested-ternary
                const replacement = variableValue !== undefined ? typeof variableValue === 'object' ? JSON.stringify(variableValue) : variableValue : '';
                result = result.replace(match[0], replacement);
            });
            return result;
        }
        if (Array.isArray(obj)) return obj.map((item)=>replacePlaceholders(item));
        if (typeof obj === 'object' && obj !== null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newObj = {};
            Object.keys(obj).forEach((key)=>{
                const processed = replacePlaceholders(obj[key]);
                newObj[key] = processed;
                // If this key carries a template that must survive page init, stash the
                // pre-substitution string in a sibling `<key>Original`.
                // FE-4677: `to` joined `value` here. Page init runs this resolver over the
                // WHOLE scheme (routes/page/index.tsx), including `events.*.action.to`, so an
                // endpoint path like `/admin/loan/{{loan_ref}}` was baked to `/admin/loan/`
                // before any click could happen — the template was gone by event time.
                if ($7b0e169a5380005e$var$TEMPLATE_ORIGIN_KEYS.has(key) && typeof obj[key] === 'string' && typeof processed === 'string' && obj[key] !== processed) newObj[`${key}Original`] = obj[key];
            });
            return newObj;
        }
        return obj;
    };
    return replacePlaceholders(style);
};
const $7b0e169a5380005e$export$485c71a5d8ecbaad = (style, variables)=>{
    const parsedVars = typeof variables === 'string' ? $7b0e169a5380005e$export$8c51936ffbb22bee(variables) : variables;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const replacePlaceholders = (obj)=>{
        if (typeof obj === 'string') {
            const regex = /{{(this(?:\..*?)?)}}/g;
            let match;
            let result = obj;
            const matches = [];
            // eslint-disable-next-line no-cond-assign
            while((match = regex.exec(obj)) !== null)matches.push(match);
            matches.forEach((match)=>{
                const variablePath = match[1].trim();
                let replacement;
                if (variablePath === 'this') replacement = JSON.stringify(parsedVars);
                else {
                    const variableValue = $7b0e169a5380005e$export$ebda49d0e9aa0c89(parsedVars, variablePath.slice(5)); // Remove 'this.' from the path
                    replacement = variableValue !== undefined ? typeof variableValue === 'object' ? JSON.stringify(variableValue) : variableValue : '';
                }
                result = result.replace(match[0], replacement);
            });
            return result;
        }
        if (Array.isArray(obj)) return obj.map((item)=>replacePlaceholders(item));
        if (typeof obj === 'object' && obj !== null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newObj = {};
            Object.keys(obj).forEach((key)=>{
                if (key === 'object_id') newObj[key] = obj[key]; // Ignore/skip placeholder replacement for 'object_id'
                else newObj[key] = replacePlaceholders(obj[key]);
            });
            return newObj;
        }
        return obj;
    };
    return replacePlaceholders(style);
};
function $7b0e169a5380005e$export$1ab2cd8b58d4bd64(scriptUrls) {
    const scriptTagRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
    const srcAttrRegex = /\bsrc\s*=\s*(?:"([^"]*)"|'([^']*)')/i;
    let match;
    while((match = scriptTagRegex.exec(scriptUrls)) !== null){
        const [fullTag, attrs, inner] = match;
        const srcMatch = attrs.match(srcAttrRegex);
        const src = srcMatch && (srcMatch[1] ?? srcMatch[2]);
        if (src) $7b0e169a5380005e$var$attachScriptIfMissing(src, false);
        else if (inner.trim()) $7b0e169a5380005e$var$attachScriptIfMissing(fullTag, true);
    }
}
async function $7b0e169a5380005e$export$dda81216098e0f9d(fonts) {
    const appendLink = (href)=>{
        if (!href) return;
        if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) return;
        const linkElement = document.createElement('link');
        linkElement.rel = 'stylesheet';
        linkElement.href = href;
        document.head.appendChild(linkElement);
    };
    // Editor serializes `fonts` as `JSON.stringify([{name, src}, ...])` — the
    // string branch must JSON.parse first. Legacy `<link href="...">` HTML
    // payloads still flow through the regex fallback below.
    let parsed = null;
    if (typeof fonts === 'string' && fonts) try {
        const maybe = JSON.parse(fonts);
        if (Array.isArray(maybe)) parsed = maybe;
    } catch  {
        parsed = null;
    }
    const source = parsed ?? fonts;
    if (typeof source === 'string') {
        const fontRegex = /<link.*?href="([^"]+)"[^>]*>/gs;
        let match;
        while((match = fontRegex.exec(source)) !== null)appendLink(match[1]);
    } else if (Array.isArray(source)) source.forEach((font)=>{
        if (typeof font === 'string') appendLink(font);
        else if (font && font.name && font.src) appendLink(font.src);
    });
}
function $7b0e169a5380005e$var$attachScriptIfMissing(scriptContent, isInline) {
    const existingScripts = document.querySelectorAll('script');
    if (!isInline) {
        // Check if the URL script is already present
        for(let i = 0; i < existingScripts.length; i++){
            if (existingScripts[i].src === scriptContent) return; // Script already exists
        }
        // Attach the URL script
        const script = document.createElement('script');
        script.src = scriptContent;
        document.head?.appendChild(script);
    } else {
        // Extract the inner content of the inline script
        const inlineScriptContent = $7b0e169a5380005e$var$extractScriptContent(scriptContent);
        // Check if the inline script is already present
        for(let i = 0; i < existingScripts.length; i++){
            if (existingScripts[i].innerHTML.trim() === inlineScriptContent) return; // Script already exists
        }
        // Attach the inline script
        const script = document.createElement('script');
        script.innerHTML = inlineScriptContent;
        document.head?.appendChild(script);
    }
}
function $7b0e169a5380005e$var$extractScriptContent(content) {
    const scriptRegex = /<script.*?>([\s\S]*?)<\/script>/s;
    const match = scriptRegex.exec(content);
    return match ? match[1].trim() : '';
}
const $7b0e169a5380005e$export$b5ac3c35b6e379b6 = (value, delay, isOpenNewTab, hist)=>{
    const openUrl = ()=>{
        const url = value.startsWith('/') ? `${window.location.origin}${value}` : value;
        const isDownloadable = url.match(/\.(pdf|docx?|xlsx?|zip|rar|tar\.gz|jpg|jpeg|png|gif)$/i);
        if (isDownloadable) {
            const link = document.createElement('a');
            link.href = url;
            link.rel = 'noopener noreferrer';
            link.target = '_blank';
            link.download = '';
            link.click();
        } else if (isOpenNewTab) window.open(url, '_blank', 'noopener,noreferrer');
        else if (value.startsWith('/')) {
            if (hist) hist.push(value);
            else if (!hist) window.location.href = value;
        } else window.location.href = url;
    };
    if (delay && delay > 0) setTimeout(openUrl, delay * 1000);
    else openUrl();
};
const $7b0e169a5380005e$export$2c457c0314f4f781 = (source)=>/^\{\{(.*)\}\}$/.test(source || '');
function $7b0e169a5380005e$export$e9c29559b77b0f7b(data, parentData, dataLake, i, variables, parentI = 0) {
    if (data?.type === 'table-header-row' || data?.type === 'table-body-row') {
        // eslint-disable-next-line max-len
        const replacedVariables = $7b0e169a5380005e$export$2c457c0314f4f781(parentData?.settings?.source) ? $7b0e169a5380005e$export$9a7eef5d73136d1e(parentData?.settings?.source, variables) : parentData?.settings?.source;
        const parseSourceIfExist = $7b0e169a5380005e$export$8c51936ffbb22bee(replacedVariables);
        // TNBEWEB-1992: capture the bound variable name from the raw `{{var}}` template (before it
        // is resolved to the array) so a `this.*` write inside a row targets variableData.<var>.<i>.
        // Stashed on settings too, because the row's cells only see the already-resolved source.
        // FE-4733: `-` admitted — a template local qualifies to `<placement-id>.<name>`, and a
        // placement id is hyphenated; without it the row loses its write-back path.
        const srcMatch = String(parentData?.settings?.source ?? '').match(/^\s*\{\{\s*([\w.-]+)\s*\}\}\s*$/);
        const srcVar = srcMatch ? srcMatch[1] : undefined;
        return {
            settings: {
                ...parentData?.settings,
                source: replacedVariables,
                ...srcVar && {
                    __sourceVar: srcVar
                }
            },
            cols: parentData?.cols,
            data: Array.isArray(parseSourceIfExist) ? parseSourceIfExist[i] : undefined,
            rowPath: srcVar ? `${srcVar}.${i}` : undefined
        };
    }
    if (data?.type === 'table-header-row-cell') {
        // eslint-disable-next-line max-len
        const replacedVariables = $7b0e169a5380005e$export$2c457c0314f4f781(dataLake?.settings?.source) ? $7b0e169a5380005e$export$9a7eef5d73136d1e(dataLake?.settings?.source, variables) : dataLake?.settings?.source;
        return {
            settings: {
                ...dataLake?.settings,
                source: replacedVariables
            },
            cols: dataLake?.cols,
            data: dataLake?.cols?.items?.[i]
        };
    }
    if (data?.type === 'table-body-row-cell') {
        const parseSourceIfExist = $7b0e169a5380005e$export$8c51936ffbb22bee(dataLake?.settings?.source);
        // TNBEWEB-1992: the row index for a cell is parentI; recover the bound variable name the
        // row stashed on settings so `this.*` writes inside the cell reach variableData.<var>.<parentI>.
        // eslint-disable-next-line no-underscore-dangle
        const srcVar = dataLake?.settings?.__sourceVar;
        return {
            settings: dataLake?.settings,
            cols: dataLake?.cols,
            data: Array.isArray(parseSourceIfExist) ? parseSourceIfExist[parentI] : undefined,
            rowPath: srcVar ? `${srcVar}.${parentI}` : undefined
        };
    }
    if (dataLake) return dataLake;
    return undefined;
}
// Custom resolutions are keyed by an arbitrary id (not a preset name); their
// pixel widths live in screen.settings.custom_resolutions. The editor keys
// component `breakpoints` by that same id, so the runtime must be able to map
// a custom id -> width to emit the correct @media rule. We register them at
// parse time so getSizesBasedOnScreen (called deep in styleHelper without
// access to settings) can resolve them.
const $7b0e169a5380005e$var$customResolutionWidths = {};
const $7b0e169a5380005e$export$ed72da891243b781 = (list)=>{
    if (!Array.isArray(list)) return;
    list.forEach((res)=>{
        if (res && typeof res.id === 'string' && typeof res.width === 'number') $7b0e169a5380005e$var$customResolutionWidths[res.id] = res.width;
    });
};
const $7b0e169a5380005e$export$e58d7eefdadeb732 = (screen)=>{
    switch(screen){
        case '4k':
            return 2560;
        case '2k':
            return 1920;
        case 'laptopL':
            return 1440;
        case 'laptop':
            return 1024;
        case 'tablet':
            return 768;
        case 'mobileL':
            return 425;
        case 'mobileM':
            return 375;
        case 'mobileS':
            return 320;
        default:
            // Custom resolution id -> its persisted pixel width; 1440 if unknown.
            return screen && $7b0e169a5380005e$var$customResolutionWidths[screen] || 1440;
    }
};
function $7b0e169a5380005e$export$3832c1507dd48f1d(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    const out = {
        ...obj
    };
    if ('activeState' in out) {
        out.active_state = out.activeState;
        delete out.activeState;
    }
    if ('svgString' in out) {
        out.svg_string = out.svgString;
        delete out.svgString;
    }
    if ('scriptUrl' in out) {
        out.script_url = out.scriptUrl;
        delete out.scriptUrl;
    }
    if (out.settings && typeof out.settings === 'object' && 'afterSymbols' in out.settings) {
        out.settings = {
            ...out.settings,
            after_symbols: out.settings.afterSymbols
        };
        delete out.settings.afterSymbols;
    }
    return out;
}
function $7b0e169a5380005e$var$eventChunksHaveLegacy(events) {
    if (!events || typeof events !== 'object') return false;
    for (const key of Object.keys(events)){
        const chunks = events[key];
        if (!Array.isArray(chunks)) continue;
        for (const chunk of chunks){
            if (chunk && typeof chunk === 'object' && $7b0e169a5380005e$var$nodeHasLegacy(chunk)) return true;
        }
    }
    return false;
}
function $7b0e169a5380005e$var$nodeHasLegacy(node) {
    if (!node || typeof node !== 'object') return false;
    if ('activeState' in node || 'svgString' in node || 'scriptUrl' in node) return true;
    if (node.settings && typeof node.settings === 'object' && 'afterSymbols' in node.settings) return true;
    if (node.events && $7b0e169a5380005e$var$eventChunksHaveLegacy(node.events)) return true;
    if (Array.isArray(node.items)) for (const item of node.items){
        if ($7b0e169a5380005e$var$nodeHasLegacy(item)) return true;
    }
    return false;
}
function $7b0e169a5380005e$var$migrateEventChunks(events) {
    if (!events || typeof events !== 'object') return events;
    const out = {};
    Object.keys(events).forEach((key)=>{
        const chunks = events[key];
        out[key] = Array.isArray(chunks) ? chunks.map((chunk)=>$7b0e169a5380005e$export$3832c1507dd48f1d(chunk)) : chunks;
    });
    return out;
}
function $7b0e169a5380005e$export$2fd5a075072ce09d(node) {
    if (!node || typeof node !== 'object') return node;
    if (Array.isArray(node)) return node.map($7b0e169a5380005e$export$2fd5a075072ce09d);
    if (!$7b0e169a5380005e$var$nodeHasLegacy(node)) return node;
    const migrated = $7b0e169a5380005e$export$3832c1507dd48f1d(node);
    if (migrated.events) migrated.events = $7b0e169a5380005e$var$migrateEventChunks(migrated.events);
    if (Array.isArray(migrated.items)) migrated.items = migrated.items.map($7b0e169a5380005e$export$2fd5a075072ce09d);
    return migrated;
}
const $7b0e169a5380005e$export$ab76a6159e74f74b = (localization)=>{
    if (typeof localization !== 'string') return;
    const lang = localization.trim();
    if (!lang) return;
    if (typeof document !== 'undefined' && document.documentElement) document.documentElement.lang = lang;
};
const $7b0e169a5380005e$export$969b2a989f0d9d7f = (settings)=>{
    if (!settings || typeof settings !== 'object') return settings;
    const rawVariables = settings.variables;
    const parsedVariables = typeof rawVariables === 'string' ? $7b0e169a5380005e$export$8c51936ffbb22bee(rawVariables) : rawVariables;
    const customResolutions = settings?.custom_resolutions ?? settings?.customResolutions;
    $7b0e169a5380005e$export$ed72da891243b781(customResolutions);
    return {
        ...settings,
        variables: parsedVariables && typeof parsedVariables === 'object' ? parsedVariables : {},
        baseScreenResolution: settings?.base_screen_resolution ?? settings?.baseScreenResolution,
        customResolutions: customResolutions
    };
};
const $7b0e169a5380005e$export$d214ae9ea462ad72 = (data)=>{
    const { sections: sections, settings: settings, localization: localization } = data || {};
    const [first] = sections || [];
    // Old format keeps sections/settings at the top level; localization is a
    // top-level sibling (same level as `config`) with a `settings` fallback.
    // Refine <html lang> the same way parseNewFormat does so the legacy
    // (sections-at-top) path isn't silently skipped. No-op when absent.
    $7b0e169a5380005e$export$ab76a6159e74f74b(localization ?? settings?.localization);
    // Previously this hardcoded `settings: {}`, which discarded the screen's
    // resolution config (base_screen_resolution, custom_resolutions) on every
    // legacy (sections-at-top) response. That left pageSettings.baseScreenResolution
    // undefined, which collapses the per-breakpoint @media math in
    // generateComponentStyles (a breakpoint whose styles never emit → the element
    // renders class-less/invisible). Normalize the same way parseNewFormat does so
    // the base resolution and custom widths survive. No-op when settings is absent.
    const customResolutions = settings?.custom_resolutions ?? settings?.customResolutions;
    $7b0e169a5380005e$export$ed72da891243b781(customResolutions);
    const enhancedSettings = settings ? {
        ...settings,
        baseScreenResolution: settings?.base_screen_resolution ?? settings?.baseScreenResolution,
        customResolutions: customResolutions
    } : {};
    // FE-4733 — the template layer goes underneath the screen's own variables.
    const settingsWithTemplates = (0, $16d445f6645d8a76$export$e7a25978043fb98a)(enhancedSettings, [
        first
    ], data?.templates);
    // The legacy shape predates templates, but a cached/legacy payload that does
    // carry the map must assemble the same way rather than rendering a bare
    // reference. Falls back to the original node when the reference is
    // unresolved, so this can never turn a legacy screen into nothing.
    const [assembledFirst] = (0, $45287d3e48b5815e$export$8a8430000842166d)((0, $16d445f6645d8a76$export$f75350e774e076c0)([
        first
    ], data?.templates), data?.classes);
    return {
        page: $7b0e169a5380005e$export$2fd5a075072ce09d(assembledFirst ?? first),
        settings: settingsWithTemplates,
        variableData: {},
        screenId: undefined,
        liveUpdates: false
    };
};
function $7b0e169a5380005e$export$7e97e2c09f211669(sessionData) {
    if (!sessionData || typeof sessionData !== 'object') return sessionData;
    const transformed = {
        ...sessionData
    };
    if ('session_id' in transformed) {
        transformed.sessionId = transformed.session_id;
        delete transformed.session_id;
    }
    if ('device_id' in transformed) {
        transformed.deviceId = transformed.device_id;
        delete transformed.device_id;
    }
    return transformed;
}
const $7b0e169a5380005e$export$305e871e4887c1d = (data)=>{
    const { screen: screen, variable_data: variableData, parameters: parameters, live_updates: liveUpdates, screen_id: screen_id, localization: localization } = data || {};
    const { sections: rawSections, settings: settings, id: id } = screen || {};
    // Backend may attach `localization` at the response top level or nested on
    // the screen/settings — read defensively and refine <html lang>.
    const screenLocalization = localization ?? screen?.localization ?? settings?.localization;
    $7b0e169a5380005e$export$ab76a6159e74f74b(screenLocalization);
    // FE-4451 — assemble template references BEFORE the protocol migration, so a
    // template BODY (which arrives straight from the map, never having passed
    // through a screen parse) gets the same legacy-field migration every other
    // node does. Expanding afterwards would leave template content on the old
    // protocol while the screen around it moved on.
    // FE-4517 — classes resolve AFTER template assembly, so a class named inside a
    // template body is resolved too: the body arrives straight from the templates
    // map and has never passed through a screen parse. Same ordering reason as the
    // migration below.
    const assembledSections = Array.isArray(rawSections) ? (0, $45287d3e48b5815e$export$8a8430000842166d)((0, $16d445f6645d8a76$export$f75350e774e076c0)(rawSections, data?.templates), data?.classes) : rawSections;
    const sections = Array.isArray(assembledSections) ? assembledSections.map($7b0e169a5380005e$export$2fd5a075072ce09d) : assembledSections;
    // Merge parameters into variableData at the top level
    const mergedVariableData = {
        ...variableData,
        ...parameters
    };
    // Unescape the script content if present (it's escaped during save as <\\/script>)
    const unescapedScript = settings?.script ? settings.script.replace(/<\\\/script>/gi, '</script>') : settings?.script;
    // Normalize resolution fields: backend sends snake_case
    // (base_screen_resolution, custom_resolutions) but components read camelCase.
    // Register custom resolution widths so breakpoints keyed by custom ids resolve.
    const customResolutions = settings?.custom_resolutions ?? settings?.customResolutions;
    $7b0e169a5380005e$export$ed72da891243b781(customResolutions);
    // Add live_updates to settings and unescape script.
    // FE-4733 — and lay the template layer underneath the screen's own variables:
    // every placement's declared locals, keyed by its path, so a qualified
    // `{{<placement>.action.state}}` has its default before any event writes it.
    const enhancedSettings = {
        ...(0, $16d445f6645d8a76$export$e7a25978043fb98a)(settings, rawSections, data?.templates),
        script: unescapedScript,
        live_updates: liveUpdates,
        localization: screenLocalization,
        baseScreenResolution: settings?.base_screen_resolution ?? settings?.baseScreenResolution,
        customResolutions: customResolutions
    };
    if (mergedVariableData && Object.keys(mergedVariableData).length > 0) {
        const remainingVariableData = {
            ...mergedVariableData
        };
        Object.keys(mergedVariableData).forEach((key)=>{
            if (key === 'c' || key.startsWith('c.')) {
                (0, $7d814282d5d3c114$export$b06e1c08d229ad64)(key, mergedVariableData[key]);
                delete remainingVariableData[key];
            }
        });
        return {
            page: sections,
            settings: enhancedSettings,
            variableData: remainingVariableData,
            screenId: id || screen_id
        };
    }
    return {
        page: sections,
        settings: enhancedSettings,
        variableData: mergedVariableData,
        screenId: id || screen_id
    };
};
function $7b0e169a5380005e$export$2a59332213f35798(items, idsToRemove) {
    return items.filter((item)=>!idsToRemove.includes(item.id)).map((item)=>({
            ...item,
            items: item.items ? $7b0e169a5380005e$export$2a59332213f35798(item.items, idsToRemove) : item.items
        }));
}
function $7b0e169a5380005e$export$262ab96e0b01295c(items, replaceOperations) {
    // Separate operations into moves (with parent_id) and regular updates
    const moveOperations = replaceOperations.filter((op)=>op.parent_id !== undefined);
    const updateOperations = replaceOperations.filter((op)=>op.parent_id === undefined);
    // First pass: collect nodes to be moved (with their complete subtrees)
    const nodesToMove = new Map();
    const collectNodesToMove = (itemList)=>{
        itemList.forEach((item)=>{
            const moveOp = moveOperations.find((op)=>op.id === item.id);
            if (moveOp) // Store the complete node with all its children
            nodesToMove.set(item.id, item);
            if (item.items && Array.isArray(item.items)) collectNodesToMove(item.items);
        });
    };
    collectNodesToMove(items);
    // Second pass: remove nodes that are being moved and apply regular updates
    const processItems = (itemList)=>itemList.filter((item)=>!nodesToMove.has(item.id)) // Remove nodes that will be moved
        .map((item)=>{
            // Find if there's a regular update operation for this item
            const updateOp = updateOperations.find((op)=>op.id === item.id);
            if (updateOp) {
                // Extract the properties to merge - support both formats:
                // 1. { id, component: {...} } - wrapped in component property
                // 2. { id, value, ... } - direct properties
                const { id: id, component: component, position: position, ...directProps } = updateOp;
                const propsToMerge = component || directProps;
                // Deep merge the properties from update operation with existing item
                const mergedItem = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, item, propsToMerge, {
                    id: item.id
                });
                // If item has nested items, recursively process them
                if (mergedItem.items && Array.isArray(mergedItem.items)) mergedItem.items = processItems(mergedItem.items);
                return mergedItem;
            }
            // No update operation for this item, but check nested items
            if (item.items && Array.isArray(item.items)) return {
                ...item,
                items: processItems(item.items)
            };
            return item;
        });
    let processedItems = processItems(items);
    // Third pass: insert moved nodes at their new parent locations
    if (moveOperations.length > 0) {
        const insertMovedNodes = (itemList)=>itemList.map((item)=>{
                // Find move operations that target this item as the new parent
                const movesToThisParent = moveOperations.filter((op)=>op.parent_id === item.id);
                if (movesToThisParent.length > 0) {
                    // Ensure items array exists
                    const currentItems = item.items || [];
                    // Sort moves by position to ensure correct order of insertion
                    const sortedMoves = [
                        ...movesToThisParent
                    ].sort((a, b)=>{
                        const posA = a.position !== undefined ? parseInt(String(a.position), 10) : Number.MAX_SAFE_INTEGER;
                        const posB = b.position !== undefined ? parseInt(String(b.position), 10) : Number.MAX_SAFE_INTEGER;
                        return posA - posB;
                    });
                    // Insert each moved node with its complete subtree
                    sortedMoves.forEach((moveOp)=>{
                        const nodeToMove = nodesToMove.get(moveOp.id);
                        if (nodeToMove) {
                            // Apply any property updates from the move operation (excluding parent_id)
                            const { id: id, parent_id: parentId, component: component, position: position, ...propsToUpdate } = moveOp;
                            const updatedNode = Object.keys(propsToUpdate).length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, nodeToMove, propsToUpdate) : nodeToMove;
                            const targetPos = parseInt(String(position), 10);
                            if (!Number.isNaN(targetPos) && targetPos >= 0 && targetPos <= currentItems.length) currentItems.splice(targetPos, 0, updatedNode);
                            else currentItems.push(updatedNode);
                        }
                    });
                    return {
                        ...item,
                        items: currentItems.length > 0 ? insertMovedNodes(currentItems) : currentItems
                    };
                }
                // No moves to this parent, but check nested items
                if (item.items && Array.isArray(item.items)) return {
                    ...item,
                    items: insertMovedNodes(item.items)
                };
                return item;
            });
        // Handle moves to root level (parent_id is empty string or root identifier)
        const movesToRoot = moveOperations.filter((op)=>op.parent_id === '');
        if (movesToRoot.length > 0) {
            const sortedMoves = [
                ...movesToRoot
            ].sort((a, b)=>{
                const posA = a.position !== undefined ? parseInt(String(a.position), 10) : Number.MAX_SAFE_INTEGER;
                const posB = b.position !== undefined ? parseInt(String(b.position), 10) : Number.MAX_SAFE_INTEGER;
                return posA - posB;
            });
            sortedMoves.forEach((moveOp)=>{
                const nodeToMove = nodesToMove.get(moveOp.id);
                if (nodeToMove) {
                    // Apply any property updates from the move operation (excluding parent_id)
                    const { id: id, parent_id: parentId, component: component, position: position, ...propsToUpdate } = moveOp;
                    const updatedNode = Object.keys(propsToUpdate).length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, nodeToMove, propsToUpdate) : nodeToMove;
                    const targetPos = parseInt(String(position), 10);
                    if (!Number.isNaN(targetPos) && targetPos >= 0 && targetPos <= processedItems.length) processedItems.splice(targetPos, 0, updatedNode);
                    else processedItems.push(updatedNode);
                }
            });
        }
        processedItems = insertMovedNodes(processedItems);
    }
    // Fourth pass: reposition items if position property is specified
    const repositionOperations = replaceOperations.filter((op)=>op.position !== undefined);
    if (repositionOperations.length > 0) {
        const repositionItems = (itemList)=>itemList.map((item)=>{
                // Check if any children need repositioning
                if (item.items && Array.isArray(item.items) && item.items.length > 0) {
                    const currentItems = [
                        ...item.items
                    ];
                    let hasChanges = false;
                    // Find operations that target children of this parent
                    repositionOperations.forEach((op)=>{
                        const targetIndex = currentItems.findIndex((child)=>child.id === op.id);
                        if (targetIndex !== -1) {
                            const targetPosition = parseInt(String(op.position), 10);
                            // Only reposition if the target position is valid and different from current
                            if (!Number.isNaN(targetPosition) && targetPosition >= 0 && targetPosition !== targetIndex) {
                                const [movedItem] = currentItems.splice(targetIndex, 1);
                                const insertPosition = Math.min(targetPosition, currentItems.length);
                                currentItems.splice(insertPosition, 0, movedItem);
                                hasChanges = true;
                            }
                        }
                    });
                    // Recursively process nested items
                    const processedChildren = repositionItems(currentItems);
                    return {
                        ...item,
                        items: processedChildren
                    };
                }
                return item;
            });
        // Handle root-level repositioning
        const rootReposOperations = repositionOperations.filter((op)=>// Check if the item exists at root level
            processedItems.findIndex((item)=>item.id === op.id) !== -1);
        if (rootReposOperations.length > 0) rootReposOperations.forEach((op)=>{
            const currentIndex = processedItems.findIndex((item)=>item.id === op.id);
            if (currentIndex !== -1) {
                const targetPosition = parseInt(String(op.position), 10);
                if (!Number.isNaN(targetPosition) && targetPosition >= 0 && targetPosition !== currentIndex) {
                    const [movedItem] = processedItems.splice(currentIndex, 1);
                    const insertPosition = Math.min(targetPosition, processedItems.length);
                    processedItems.splice(insertPosition, 0, movedItem);
                }
            }
        });
        processedItems = repositionItems(processedItems);
    }
    return processedItems;
}
function $7b0e169a5380005e$export$5731eff3cc800245(items, insertOperations) {
    return items.map((item)=>{
        // Check if this item is a parent for any insert operation
        const insertOps = insertOperations.filter((op)=>op.parent_id === item.id);
        if (insertOps.length > 0) {
            // Process all insert operations for this parent
            const newItems = [
                ...item.items || []
            ];
            insertOps.forEach((insertOp)=>{
                // Old format: { parent_id, components: [...] }
                if (insertOp.components && Array.isArray(insertOp.components)) // Append all components to the end (old behavior)
                newItems.push(...insertOp.components);
                else if (insertOp.component) {
                    const { component: component } = insertOp;
                    const { position: position } = insertOp;
                    // If position is specified and valid, insert at that position
                    if (typeof position === 'number' && position >= 0) {
                        // Clamp position to valid range
                        const insertIndex = Math.min(position, newItems.length);
                        newItems.splice(insertIndex, 0, component);
                    } else // If no position specified, append to end
                    newItems.push(component);
                }
            });
            return {
                ...item,
                items: newItems
            };
        }
        // Recursively process child items
        if (item.items && item.items.length > 0) return {
            ...item,
            items: $7b0e169a5380005e$export$5731eff3cc800245(item.items, insertOperations)
        };
        return item;
    });
}
function $7b0e169a5380005e$export$7fb9c25935e012b(currentData, updateData, currentVariableData = {}) {
    const { mode: mode, parameters: parameters, updates: updates, update_cache: update_cache } = updateData || {};
    // If not update mode, return original data
    if (mode !== 'update') return {
        page: currentData,
        variableData: currentVariableData,
        shouldUpdateCache: false
    };
    let updatedPage = $7b0e169a5380005e$export$9cb59c0e57b11a(currentData);
    // FE-4577 — resolve templates and style classes on the nodes this patch brings
    // IN, before they are merged into the tree.
    //
    // A full screen response gets this from `parseNewFormat`, but an `updates`
    // frame never passed through it, so a patched-in node naming a template or a
    // `style.class` rendered as a bare unresolved reference. The protocol
    // explicitly delivers the classes an update needs, and by this point the trust
    // boundary has already merged the store in, so `updateData.classes` /
    // `.templates` hold the complete maps whether the bodies arrived in this frame
    // or in an earlier one.
    //
    // Both helpers are identity-preserving when there is nothing to resolve
    // (`containsTemplateRef` / the empty-class-map guard), so a patch that uses
    // neither is untouched and pays no rebuild.
    const resolveIncoming = (nodes)=>(0, $45287d3e48b5815e$export$8a8430000842166d)((0, $16d445f6645d8a76$export$f75350e774e076c0)(nodes, updateData?.templates), updateData?.classes);
    const resolvedReplace = Array.isArray(updates?.replace) ? resolveIncoming(updates.replace) : updates?.replace;
    const resolvedInsert = Array.isArray(updates?.insert) ? updates.insert.map((op)=>{
        if (Array.isArray(op?.components)) return {
            ...op,
            components: resolveIncoming(op.components)
        };
        if (op?.component) {
            const [resolvedComponent] = resolveIncoming([
                op.component
            ]);
            return {
                ...op,
                component: resolvedComponent
            };
        }
        return op;
    }) : updates?.insert;
    // Apply remove operations
    if (updates?.remove && Array.isArray(updates.remove)) updatedPage = $7b0e169a5380005e$export$2a59332213f35798(updatedPage, updates.remove);
    // Apply replace operations (merge styles with existing items)
    if (Array.isArray(resolvedReplace)) updatedPage = $7b0e169a5380005e$export$262ab96e0b01295c(updatedPage, resolvedReplace);
    // Apply insert operations
    if (Array.isArray(resolvedInsert)) {
        // Separate root-level inserts from nested inserts
        const rootInserts = resolvedInsert.filter((op)=>op.parent_id === null || op.parent_id === '');
        const nestedInserts = resolvedInsert.filter((op)=>op.parent_id !== null && op.parent_id !== '');
        // First, recursively apply nested inserts
        if (nestedInserts.length > 0) updatedPage = $7b0e169a5380005e$export$5731eff3cc800245(updatedPage, nestedInserts);
        // Then, handle root-level inserts
        if (rootInserts.length > 0) // Process each root insert operation
        rootInserts.forEach((insertOp)=>{
            // Old format: { parent_id, components: [...] }
            if (insertOp.components && Array.isArray(insertOp.components)) updatedPage.push(...insertOp.components);
            else if (insertOp.component) {
                const { component: component, position: position } = insertOp;
                const pos = parseInt(String(position), 10) || 0;
                // Insert component at specified position in root array
                if (pos >= 0 && pos <= updatedPage.length) updatedPage.splice(pos, 0, component);
                else // If position is out of bounds, append to end
                updatedPage.push(component);
            }
        });
    }
    // FE-4733 — placements this patch brings in own template locals too. Their
    // defaults go UNDERNEATH the current bag, so a value an event already wrote
    // under the same placement path survives a repeated response (UC-6).
    const incomingNodes = [
        ...Array.isArray(updates?.replace) ? updates.replace : [],
        ...Array.isArray(updates?.insert) ? updates.insert.flatMap((op)=>Array.isArray(op?.components) ? op.components : op?.component ? [
                op.component
            ] : []) : []
    ];
    const variablesWithTemplates = (0, $35b49f009a3f327f$export$5fd3ff355298e599)((0, $16d445f6645d8a76$export$41bf54004b173df6)(incomingNodes, updateData?.templates), currentVariableData);
    // Merge parameters into variableData
    const updatedVariableData = parameters ? (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, variablesWithTemplates, parameters) : variablesWithTemplates;
    return {
        page: updatedPage,
        variableData: updatedVariableData,
        shouldUpdateCache: !!update_cache
    };
}
const $7b0e169a5380005e$export$c11473a4d340015a = (template, // eslint-disable-next-line @typescript-eslint/no-explicit-any
params, // eslint-disable-next-line @typescript-eslint/no-explicit-any
variables)=>{
    if (typeof template !== 'string' || !template) return {
        path: template,
        used: [],
        missing: []
    };
    // Keep the query/fragment aside — a token there is not a path parameter.
    const splitAt = (()=>{
        const q = template.indexOf('?');
        const h = template.indexOf('#');
        if (q === -1) return h;
        if (h === -1) return q;
        return Math.min(q, h);
    })();
    const pathPart = splitAt === -1 ? template : template.slice(0, splitAt);
    const rest = splitAt === -1 ? '' : template.slice(splitAt);
    const used = new Set();
    const missing = new Set();
    const isBlank = (v)=>v === undefined || v === null || typeof v === 'string' && v.trim() === '';
    const resolvedPath = pathPart.replace(/\{\{([^{}]+)\}\}/g, (whole, rawKey)=>{
        const key = String(rawKey).trim();
        if (!key) return whole;
        // `{{this.*}}` (repeatable row scope) and `{{_l.*}}` (localisation) are owned by
        // other passes — replacePlaceholdersWithVariables skips them for exactly this
        // reason. Leave them untouched and do NOT report them as missing, so this helper
        // stays strictly additive: a token those passes left behind reaches the URL
        // literally, just as it did before FE-4677.
        if (key === 'this' || key.startsWith('this.') || key.startsWith('_l.')) return whole;
        const fromParams = params ? params[key] : undefined;
        if (!isBlank(fromParams)) {
            used.add(key);
            return encodeURIComponent(typeof fromParams === 'object' ? JSON.stringify(fromParams) : String(fromParams));
        }
        const fromVars = $7b0e169a5380005e$export$ebda49d0e9aa0c89(variables, key);
        if (!isBlank(fromVars)) return encodeURIComponent(typeof fromVars === 'object' ? JSON.stringify(fromVars) : String(fromVars));
        missing.add(key);
        return whole;
    });
    return {
        path: resolvedPath + rest,
        used: [
            ...used
        ],
        missing: [
            ...missing
        ]
    };
};



var $g1KQj = parcelRequire("g1KQj");


// Components the renderer itself put into `error` because a `pre` function cancelled their
// event. Only these are cleared on the next pass — an `error` the author set is never touched.
const $c6acd105f1cc0a20$var$cancelledByPre = new Set();
const $c6acd105f1cc0a20$var$setOwnerState = (store, owner, activeState)=>{
    // Exactly the chunk an author would write, so bound (`{{v.*}}`) states and row scoping behave
    // as they do for author style chunks. `object_type` only disambiguates templated object_ids
    // (matchesPattern); an exact node id matches on its own.
    store.dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)([
        {
            object_id: owner.id,
            object_type: '',
            active_state: activeState,
            style: {}
        }
    ], owner.parentIndex, owner.row));
};
const $c6acd105f1cc0a20$var$buildOwnerHooks = (store, owner)=>({
        onPreCancelled: ()=>{
            $c6acd105f1cc0a20$var$cancelledByPre.add(owner.id);
            $c6acd105f1cc0a20$var$setOwnerState(store, owner, 'error');
        },
        onPrePassed: ()=>{
            if (!$c6acd105f1cc0a20$var$cancelledByPre.delete(owner.id)) return;
            // Something else replaced our `error` since (e.g. `disabled`): leave it.
            if (owner.activeState === undefined || owner.activeState === 'error') $c6acd105f1cc0a20$var$setOwnerState(store, owner, 'base');
        }
    });
// Nest a dotted path into an object: nest('a.b.c', v) => { a: { b: { c: v } } }.
// Mirrors the updateVariableRequest saga (sagas.ts) and the saga response path so the
// reducer receives the same deep-write shape.
const $c6acd105f1cc0a20$var$nest = (dotted, value)=>dotted.split('.').reduceRight((acc, k)=>({
            [k]: acc
        }), value);
const $c6acd105f1cc0a20$export$48102551e27885f5 = ({ store: store, thisRow: thisRow, rowPath: rowPath, response: response, directWrites: directWrites, owner: owner })=>{
    // Write path for data.* / this.* (local) and _c.*/_config.* (global). Matches the ticket:
    // dispatch UPDATE_VARIABLE_SUCCESS for local variables, write localStorage for globals. The
    // direct SUCCESS dispatch (the same pattern the saga response path and applyVariablesFirst
    // already use) commits synchronously — so read-after-write in the same handler works — and
    // cannot be dropped by the `takeLatest` guard on UPDATE_VARIABLE_REQUEST that $set rides.
    const writeVar = (path, value)=>{
        if ((0, $7d814282d5d3c114$export$226358b83530f879)(path)) (0, $7d814282d5d3c114$export$b06e1c08d229ad64)(path, value);
        else store.dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: $c6acd105f1cc0a20$var$nest(path, value),
            replaceArrays: true
        }));
    };
    return {
        // --- legacy scope: byte-for-byte with the previous inline objects for each context ---
        $setVariable: directWrites ? (key, value)=>(0, $7d814282d5d3c114$export$2d11ccb133d345)(key, value, (k, v)=>writeVar(k, v)) : (key, value)=>(0, $7d814282d5d3c114$export$2d11ccb133d345)(key, value, (k, v)=>{
                store.dispatch((0, $8eba69c5466928d3$export$36f0c40eded97f9d)({
                    variable: k,
                    value: v
                }));
            }),
        $getVariable: (key)=>{
            // state.page.variableData / settings.variables are the selectVariableData /
            // selectLocalVariableData selectors inlined (avoids a page/selectors -> store -> sagas
            // -> handlerScope import cycle); identical read to the previous inline internalFns.
            const state = store.getState();
            return (0, $7d814282d5d3c114$export$289398774300c991)(key, state.page?.variableData, state.page?.settings?.variables);
        },
        $moment: (...args)=>(0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(...args),
        ...response !== undefined && {
            $response: response
        },
        writeVar: // --- NEW write path behind data.* / _c.* / _config.* / this.* ---
        writeVar,
        thisRow: // --- NEW row context for `this` (both undefined outside a repeatable row) ---
        thisRow,
        rowPath: rowPath,
        // --- TNBEWEB-2022: a cancelled `pre` puts the owner into `error`; the next pass clears it ---
        ...owner?.id ? $c6acd105f1cc0a20$var$buildOwnerHooks(store, owner) : {}
    };
};



// Runtime resolution for the Events "Variables" block (editor: VariablesChunk).
//
// A variables chunk assigns key -> typed value pairs into the variable store.
// It is applied BEFORE every other chunk in the same event (first in the
// stack). Keys may be nested/templated paths (`test.test[0]`,
// `test.test[{{this.id}}]`); values support {{template}} references including
// `{{this.param}}` and recursive `{{a[{{b}}]}}`.


const $7674591fd5554b85$export$a7714fd308578054 = (chunk)=>!!chunk && 'variables' in chunk && Array.isArray(chunk.variables);
const $7674591fd5554b85$export$8ccf933b0513f8d0 = (pathStr)=>{
    const keys = [];
    let current = '';
    let inBrackets = false;
    let bracketDepth = 0;
    for(let i = 0; i < pathStr.length; i++){
        const char = pathStr[i];
        if (char === '[') {
            if (inBrackets) {
                bracketDepth++;
                current += char;
            } else {
                if (current) {
                    keys.push(current);
                    current = '';
                }
                inBrackets = true;
            }
        } else if (char === ']') {
            if (bracketDepth > 0) {
                bracketDepth--;
                current += char;
            } else {
                inBrackets = false;
                if (current) {
                    let key = current;
                    if (key.startsWith('"') && key.endsWith('"') || key.startsWith("'") && key.endsWith("'")) key = key.slice(1, -1);
                    keys.push(key);
                    current = '';
                }
            }
        } else if (char === '.' && !inBrackets) {
            if (current) {
                keys.push(current);
                current = '';
            }
        } else current += char;
    }
    if (current) keys.push(current);
    return keys;
};
const $7674591fd5554b85$var$getByPath = (obj, path)=>{
    if (!path || obj === null || obj === undefined) return undefined;
    return $7674591fd5554b85$export$8ccf933b0513f8d0(path).reduce((acc, key)=>{
        if (acc === null || acc === undefined) return undefined;
        if (!isNaN(Number(key))) {
            const numKey = Number(key);
            return Array.isArray(acc) ? acc[numKey] : acc[key];
        }
        return acc[key];
    }, obj);
};
const $7674591fd5554b85$export$f65a19d15516795e = (target, path, value)=>{
    const keys = $7674591fd5554b85$export$8ccf933b0513f8d0(path);
    if (!keys.length) return;
    let current = target;
    for(let i = 0; i < keys.length - 1; i++){
        const key = keys[i];
        const nextIsIndex = !isNaN(Number(keys[i + 1]));
        if (current[key] === null || typeof current[key] !== 'object') current[key] = nextIsIndex ? [] : {};
        current = current[key];
    }
    current[keys[keys.length - 1]] = value;
};
// Resolve a single path token to its value from the available contexts.
const $7674591fd5554b85$var$resolveToken = (rawPath, varsCtx, thisCtx)=>{
    const path = rawPath.trim();
    if (path === 'this') return thisCtx;
    if (path.startsWith('this.')) return $7674591fd5554b85$var$getByPath(thisCtx, path.slice(5));
    if ((0, $7d814282d5d3c114$export$226358b83530f879)(path)) return (0, $7d814282d5d3c114$export$d40b0ae730754ac0)(path);
    return $7674591fd5554b85$var$getByPath(varsCtx, path);
};
const $7674591fd5554b85$export$f04a893ac5c95cdd = (input, varsCtx, thisCtx)=>{
    if (typeof input !== 'string') return input;
    let str = input;
    let guard = 0;
    const innermost = /\{\{([^{}]*)\}\}/;
    while(innermost.test(str) && guard < 25){
        str = str.replace(/\{\{([^{}]*)\}\}/g, (_whole, expr)=>{
            const val = $7674591fd5554b85$var$resolveToken(expr, varsCtx, thisCtx);
            if (val === undefined || val === null) return '';
            return typeof val === 'object' ? JSON.stringify(val) : String(val);
        });
        guard++;
    }
    return str;
};
const $7674591fd5554b85$export$ea0330bb743bb1f5 = (value, type)=>{
    if (!type || value === null || value === undefined) return value;
    switch(type.toLowerCase()){
        case 'string':
            return String(value);
        case 'number':
            {
                const num = Number(value);
                return isNaN(num) ? String(value) : num;
            }
        case 'boolean':
            if (typeof value === 'boolean') return value;
            if (typeof value === 'string') {
                const lower = value.toLowerCase();
                if (lower === 'true') return true;
                if (lower === 'false') return false;
            }
            return Boolean(value);
        case 'array':
            if (Array.isArray(value)) return value;
            if (typeof value === 'string') try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : [
                    value
                ];
            } catch  {
                return [
                    value
                ];
            }
            return [
                value
            ];
        case 'object':
            if (typeof value === 'object') return value;
            if (typeof value === 'string') try {
                const parsed = JSON.parse(value);
                return typeof parsed === 'object' && parsed !== null ? parsed : {
                    value: value
                };
            } catch  {
                return {
                    value: value
                };
            }
            return {
                value: value
            };
        default:
            return String(value);
    }
};
const $7674591fd5554b85$export$4c40aaaedfbf949d = (chunks, ctx)=>{
    const parsedLocal = typeof ctx.localVariables === 'string' ? (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(ctx.localVariables) : ctx.localVariables || {};
    // Form input values are exposed as bare `{{fieldId}}` tokens, where fieldId is
    // the input's id. Lowest precedence: local + design-time variables override a
    // form field on a name clash (variables are the authoritative source).
    const varsCtx = {
        ...ctx.formValues || {},
        ...parsedLocal || {},
        ...ctx.variables || {}
    };
    const thisCtx = ctx.thisContext;
    const result = {};
    chunks.forEach((chunk)=>{
        (chunk.variables || []).forEach((row)=>{
            const rawKey = (row.key || '').trim();
            if (!rawKey) return;
            // Unwrap a fully-wrapped key (`{{a.b[0]}}`) — the key is a destination
            // path, not a variable reference — then resolve any inner templates.
            let keyExpr = rawKey;
            if (keyExpr.startsWith('{{') && keyExpr.endsWith('}}')) keyExpr = keyExpr.slice(2, -2).trim();
            const resolvedKey = $7674591fd5554b85$export$f04a893ac5c95cdd(keyExpr, varsCtx, thisCtx);
            if (!resolvedKey) return;
            // Page init (routes/page/index.tsx) runs the WHOLE screen — including these
            // event-variable rows — through replacePlaceholdersWithVariables, which
            // resolves every `{{...}}` in a `value` field against the variable bag that
            // exists AT LOAD. Form values are empty then, so a `{{field}}` reference is
            // baked into '' and the source template is preserved in `valueOriginal`.
            // Recover from valueOriginal so the token survives until the event actually
            // fires. Guard with the same {{...}} test the action saga uses (sagas.ts):
            // only treat valueOriginal as the source when it genuinely carries a
            // template — otherwise honour the (possibly intentionally literal) value.
            const hasTemplateOriginal = typeof row.valueOriginal === 'string' && /\{\{[^}]+\}\}/.test(row.valueOriginal);
            const rawValue = hasTemplateOriginal ? row.valueOriginal : row.value ?? '';
            const resolvedValue = $7674591fd5554b85$export$f04a893ac5c95cdd(rawValue, varsCtx, thisCtx);
            const typedValue = $7674591fd5554b85$export$ea0330bb743bb1f5(resolvedValue, row.type);
            $7674591fd5554b85$export$f65a19d15516795e(result, resolvedKey, typedValue);
        });
    });
    return result;
};


// Replayable snapshot of a navigation request. Saved in window.history.state
// under the __fractal key so back/forward can reproduce the original request
// verbatim — same URL, same headers, same body — independent of any state
// drift that happened in between. See TNBEWEB-1905.
const $9c0f2890202f6fcd$var$FRACTAL_KEY = '__fractal';
const $9c0f2890202f6fcd$export$44f5514ba2c862c1 = (state)=>{
    if (!state || typeof state !== 'object') return undefined;
    const maybe = state[$9c0f2890202f6fcd$var$FRACTAL_KEY];
    return maybe && maybe.kind === 'action' ? maybe : undefined;
};
const $9c0f2890202f6fcd$export$6e124b896d76bfaa = (path, ctx)=>{
    window.history.pushState({
        [$9c0f2890202f6fcd$var$FRACTAL_KEY]: ctx
    }, '', path);
};
const $9c0f2890202f6fcd$export$d287140c80e4b48d = (ctx)=>{
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.history.replaceState({
        [$9c0f2890202f6fcd$var$FRACTAL_KEY]: ctx
    }, '', currentUrl);
};


/**
 * FE-4577 — every screen-cache write goes through here so the design system is
 * stripped first. Wrapped at the import rather than at each of the nine call
 * sites below: the bodies are now merged with the whole branch's classes and
 * templates, and one missed site would embed a full duplicate copy.
 */ const $6ace1c53c6a18897$var$setLocalCache = (key, body)=>(0, $c9e12427d7d919f3$export$8a8216c44337cd5)(key, (0, $0338670cd4d1a0d1$export$fc94ef871805e581)(body));
// A runtime style-merge chunk (e.g. an on_click writing active_state: "success"
// onto a node) must NEVER clobber a variable BINDING such as
// "{{v.decision_select_state}}" with a concrete literal. The page tree is
// re-resolved from this same store slice on every render, so once the binding
// string is overwritten the node is permanently unlinked from its variable and
// code-driven states (e.g. `disabled`) stop applying. See TNBEWEB-2001.
const $6ace1c53c6a18897$var$ACTIVE_STATE_BINDING_RE = /\{\{.*?\}\}/;
const $6ace1c53c6a18897$var$isBindingString = (value)=>typeof value === 'string' && $6ace1c53c6a18897$var$ACTIVE_STATE_BINDING_RE.test(value);
// Preserve a variable-bound active_state; otherwise take the incoming literal,
// falling back to the existing value (original `incoming || existing` behavior).
const $6ace1c53c6a18897$var$mergeActiveState = (incoming, existing)=>$6ace1c53c6a18897$var$isBindingString(existing) ? existing : incoming || existing;
// If `binding` is exactly "{{ v.<path> }}" (a single writable LOCAL variable
// reference — no surrounding text), return the dotted path, else null. This is
// the case we can safely redirect a literal into: instead of overwriting the
// binding we write the literal to the bound variable and KEEP the binding, so
// the node — and every other node bound to the same variable — stays reactive.
// Composite strings ("x-{{v.a}}"), row scope ({{this.*}}) and global/bare refs
// are excluded; callers fall back to preserving the binding without a redirect.
const $6ace1c53c6a18897$var$extractRedirectableVarPath = (binding)=>{
    if (typeof binding !== 'string') return null;
    const match = binding.match(/^\s*\{\{\s*(v\.[^{}]+?)\s*\}\}\s*$/);
    return match ? match[1] : null;
};
function $6ace1c53c6a18897$var$styleMerger(page, updates) {
    const inArr = Array.isArray(page) ? page : [
        page
    ];
    const updatesMap = updates.reduce((map, update)=>{
        map[update.object_id] = update;
        return map;
    }, {});
    const updatedComponents = (0, $7b0e169a5380005e$export$8f49bf34d2145408)(inArr, updatesMap, (item)=>{
        const update = Object.keys(updatesMap).find((objId)=>objId === item.id || (0, $7b0e169a5380005e$export$78e968efcca6b7ef)(objId, item.id) && updatesMap[objId]?.object_type === item.component);
        if (update) return {
            ...item,
            active_state: $6ace1c53c6a18897$var$mergeActiveState(updatesMap[update]?.active_state, item.active_state),
            style: (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, item.style, updatesMap[update]?.style)
        };
        return item;
    });
    return updatedComponents;
}
// Opens a hidden <input type="file"> and resolves with the user's selection.
// Resolves with an empty array when the picker is dismissed without a choice.
const $6ace1c53c6a18897$var$pickFiles = ({ accept: accept, multiple: multiple })=>new Promise((resolve)=>{
        const input = document.createElement('input');
        input.type = 'file';
        if (multiple) input.multiple = true;
        if (accept && accept.length) input.accept = accept.join(',');
        input.style.display = 'none';
        let settled = false;
        const finish = (files)=>{
            if (settled) return;
            settled = true;
            resolve(files);
            if (input.parentNode) input.parentNode.removeChild(input);
            window.removeEventListener('focus', onFocus);
        };
        input.addEventListener('change', ()=>{
            const files = input.files ? Array.from(input.files) : [];
            finish(files);
        });
        // Detect cancel: browsers don't fire a cancel event reliably, but focus
        // returns to the window when the dialog closes. Check the input shortly
        // after — if it still has no files, treat it as a cancel.
        const onFocus = ()=>{
            setTimeout(()=>{
                if (!settled && (!input.files || input.files.length === 0)) finish([]);
            }, 300);
        };
        window.addEventListener('focus', onFocus, {
            once: true
        });
        document.body.appendChild(input);
        input.click();
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $6ace1c53c6a18897$var$handlePageRequest(action) {
    // When `features.processes` is on, the deployment runs in actions-mode
    // and the legacy `request` flow is replaced by `action` chunks — skip
    // entirely so migrated schemes don't double-fire legacy requests.
    const processes = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.config?.data?.features?.processes);
    if (processes === true) return;
    const screenId = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.screenId);
    const { payload: payload, meta: localShimmer } = action || {};
    const { location: location, silent: silent, componentId: componentId, onSuccess: onSuccess, onError: onError } = payload || {};
    const { pathname: pathnameDraft, search: search } = location || {};
    const pathname = pathnameDraft === '/' ? '/' : pathnameDraft.replace(/\/$/, '');
    // Correct the route if it ends with a trailing slash without triggering a location change
    if (pathnameDraft.length > 1 && pathnameDraft.endsWith('/')) {
        const correctedPathname = pathnameDraft.slice(0, -1);
        const newUrl = search ? `${correctedPathname}${search}` : correctedPathname;
        window.history.replaceState(null, '', newUrl);
    }
    try {
        const isFrameMode = search ? new URLSearchParams(search).has('frame') : false;
        const breakLoadPages = [
            '/not_found',
            '/frame/internal'
        ];
        if (pathname && !isFrameMode && !breakLoadPages.includes(pathname)) {
            const page = pathname === '/' || pathname === '' ? '/' : pathname.replace('/', '');
            yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$3653d7e5cadcf5e3)());
            const cacheKey = (0, $7b0e169a5380005e$export$2083ef81b7b5b44)({
                command: `${page}${search?.length ? search : ''}`,
                action: undefined,
                component_id: componentId,
                screen_id: screenId
            });
            const [key, value] = cacheKey ? yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $c9e12427d7d919f3$export$a9d1467bbcbfc43), cacheKey) : [
                null,
                null
            ];
            if (!/\{\{[^}]+\}\}/.test(key) && !silent) try {
                const currentPath = window.location.pathname === '/' ? '/' : window.location.pathname.replace(/\/$/, '');
                const currentSearch = window.location.search;
                const navigateTo = search ? `${pathname}${search}` : pathname;
                if (currentPath !== pathname || search && currentSearch !== search) {
                    if (window.location.pathname + window.location.search !== navigateTo) yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $3b7d72a70d6ed09c$export$4cbf152802aa238)(navigateTo));
                }
            } catch (navError) {
                console.error('Navigation failed:', navError);
            // Continue execution even if navigation fails
            }
            if (value && !silent) {
                // Cache entries are written from a normalized body, but an entry from an
                // older build (or a future envelope change) may not be — normalizing is
                // idempotent, so it is free insurance.
                const cached = (0, $7d394fadd9d1d259$export$ef119f2182a928e)(value);
                const { page: pp, settings: settings, variableData: variableData, screenId: screenIdParsed } = cached.sections ? (0, $7b0e169a5380005e$export$d214ae9ea462ad72)(cached) : (0, $7b0e169a5380005e$export$305e871e4887c1d)(cached);
                let mergedData;
                if (localShimmer?.length) mergedData = $6ace1c53c6a18897$var$styleMerger(pp, localShimmer);
                yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                    data: mergedData || pp,
                    settings: settings,
                    session_data: {
                        type: 'indexedDb',
                        localShimmer: !!localShimmer?.length,
                        hash: (0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)()
                    },
                    variableData: (0, $7b0e169a5380005e$export$8c1182ab03da08ba)(variableData, settings?.variables),
                    screenId: screenIdParsed
                }));
            } else if (localShimmer?.length) yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$1f3acb761da593d8)());
            const rawGetResponse = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $44edbfa3e77e92f9$export$2e2bcd8739ae039), 'post', '/get', {
                command: `${page}${search?.length ? search : ''}`,
                skip_cache: silent ? true : !!value,
                screen_id: screenId,
                active_route: `${window.location.pathname}${window.location.search || ''}`,
                component_id: componentId,
                device_info: (0, $7b0e169a5380005e$export$a5202107d3e3cdb0)(),
                session_id: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId()
            });
            // 0.22.x drops the `data` wrapper and sinks mode/live_updates/localization
            // into `screen.settings` — normalize so everything below (mode branch,
            // parseNewFormat, the cache writes) keeps reading one shape.
            const { code: code, data: data, session_data: session_data } = (0, $7d394fadd9d1d259$export$935adcd9e006ac5d)(rawGetResponse);
            if (code !== 200 || !data) {
                if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, {
                    success: false,
                    error: 'Invalid response',
                    code: code,
                    data: data
                }, componentId);
                return;
            }
            const { page: pp, settings: settings, variableData: variableData, screenId: screenIdParsed } = data.sections ? (0, $7b0e169a5380005e$export$d214ae9ea462ad72)(data) : (0, $7b0e169a5380005e$export$305e871e4887c1d)(data);
            // Handle new update mode scheme
            let finalPageData = pp;
            let finalVariableData = variableData;
            let shouldUpdateCache = false;
            if (data.mode === 'update') {
                const currentPageData = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.data.page);
                const currentVariableData = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.variableData);
                const { page: updatedPage, variableData: updatedVariableData, shouldUpdateCache: cacheFlag } = (0, $7b0e169a5380005e$export$7fb9c25935e012b)(currentPageData, data, currentVariableData);
                finalPageData = updatedPage;
                finalVariableData = updatedVariableData;
                shouldUpdateCache = cacheFlag;
            }
            yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                data: finalPageData,
                settings: settings,
                session_data: {
                    ...(0, $7b0e169a5380005e$export$7e97e2c09f211669)(session_data),
                    localShimmer: false,
                    // `skip-` after a cached render (it already reset, TNBEWEB-1484) and on a silent
                    // refresh — FE-4866: that reset now reaches `.pageWrap`, the whole page.
                    hash: value || silent ? `skip-${(0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)()}` : (0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)()
                },
                variableData: (0, $7b0e169a5380005e$export$8c1182ab03da08ba)(finalVariableData, settings?.variables),
                screenId: screenIdParsed
            }));
            const { status: status, transformed: transformed } = (0, $7b0e169a5380005e$export$b40f43cc69224c6e)(data?.screen?.sections || []);
            // Handle caching based on mode and settings
            if (data.mode === 'update') // For update mode, save the final transformed data
            {
                if (shouldUpdateCache) $6ace1c53c6a18897$var$setLocalCache(cacheKey, {
                    ...data,
                    screen: {
                        ...data.screen,
                        sections: finalPageData
                    },
                    variable_data: finalVariableData
                });
            } else if (settings?.command && settings?.cache) {
                $6ace1c53c6a18897$var$setLocalCache(settings.command, {
                    ...data,
                    screen: {
                        ...data.screen,
                        sections: transformed
                    },
                    variable_data: variableData
                });
                $6ace1c53c6a18897$var$setLocalCache(cacheKey, {
                    ...data,
                    screen: {
                        ...data.screen,
                        sections: transformed
                    },
                    variable_data: variableData
                });
            } else if (status && transformed && !silent && settings?.cache) // Update response with transformed sections
            // Save
            $6ace1c53c6a18897$var$setLocalCache(cacheKey, {
                ...data,
                screen: {
                    ...data.screen,
                    sections: transformed
                },
                variable_data: variableData
            });
            else if (!componentId && !screenId && !silent && settings?.cache) $6ace1c53c6a18897$var$setLocalCache(cacheKey, {
                ...data,
                screen: {
                    ...data.screen,
                    sections: data?.screen?.sections
                },
                variable_data: variableData
            });
            // else if (!silent) {
            //   removeFromLocalCache(cacheKey);
            // }
            // Handle settings.command URL update
            if (settings?.command) {
                const newCommand = settings.command.replace(/^\//, '').replace(/\/$/, '');
                const currentPath = window.location.pathname.replace(/^\//, '').replace(/\/$/, '') + window.location.search;
                if (!/\{\{[^}]+\}\}/.test(newCommand) && newCommand !== currentPath) // yield put(push(`/${newCommand}`));
                {
                    if (window.location.pathname + window.location.search !== `/${newCommand}`) window.history.pushState(null, '', `/${newCommand}`);
                }
            }
            // Parse form values
            const formValues = (0, $7b0e169a5380005e$export$a8c212b8aefc29ec)(finalPageData);
            yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$6e19b0a4e4c542c1)({
                data: formValues
            }));
            if (onSuccess?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onSuccess, {
                success: true,
                data: data,
                code: code
            }, componentId);
        }
    } catch (error) {
        if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, {
            success: false,
            error: error instanceof Error ? error.message : String(error)
        }, componentId);
    }
}
function* $6ace1c53c6a18897$var$handleSetFormValuesRequest(action) {
    const { payload: payload } = action || {};
    const { field: field } = payload || {};
    const { id: id, value: value } = field || {};
    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$4452cb953514838a)({
        data: {
            [id]: value
        }
    }));
}
// Resolve a {{$response.key.nested}} placeholder against a response context.
// Returns undefined when the variable name is not a $response.* reference or
// when the path cannot be found — the caller then falls back to form values.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6ace1c53c6a18897$var$resolveResponseContextValue = (variableName, responseContext)=>{
    if (!responseContext || typeof variableName !== 'string') return undefined;
    const trimmed = variableName.trim();
    if (!trimmed.startsWith('$response')) return undefined;
    if (trimmed === '$response') return responseContext;
    const path = trimmed.slice(10);
    if (!path) return responseContext;
    return path.split('.').reduce((acc, segment)=>{
        if (acc === null || acc === undefined) return undefined;
        return acc[segment];
    }, responseContext);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
// Helper function to convert value to specified type
const $6ace1c53c6a18897$var$convertToType = (value, type)=>{
    if (!type || value === null || value === undefined) return value;
    switch(type.toLowerCase()){
        case 'string':
            return String(value);
        case 'number':
            const num = Number(value);
            return isNaN(num) ? String(value) : num;
        case 'boolean':
            if (typeof value === 'boolean') return value;
            if (typeof value === 'string') {
                const lower = value.toLowerCase();
                if (lower === 'true') return true;
                if (lower === 'false') return false;
            }
            return Boolean(value);
        case 'array':
            if (Array.isArray(value)) return value;
            if (typeof value === 'string') try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : [
                    value
                ];
            } catch  {
                return [
                    value
                ];
            }
            return [
                value
            ];
        case 'object':
            if (typeof value === 'object') return value;
            if (typeof value === 'string') try {
                const parsed = JSON.parse(value);
                return typeof parsed === 'object' && parsed !== null ? parsed : {
                    value: value
                };
            } catch  {
                return {
                    value: value
                };
            }
            return {
                value: value
            };
        case 'file':
            // Marker type for FormData assembly — value is passed through as-is
            // (File | File[] | undefined). Actual file selection happens in the
            // upload action handler; this branch simply preserves the value.
            return value;
        default:
            return String(value);
    }
};
function* $6ace1c53c6a18897$var$sendAllFormValues(action) {
    // When `features.processes` is on, the deployment runs in actions-mode
    // and the legacy `request` flow is replaced by `action` chunks — skip
    // entirely so migrated schemes don't double-fire legacy requests.
    const processes = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.config?.data?.features?.processes);
    if (processes === true) return;
    const screenId = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.screenId);
    const { payload: payload, meta: localShimmer } = action || {};
    const { value: value, delay: del, componentId: componentId, block: block, silent: silent, onSuccess: onSuccess, onError: onError } = payload || {};
    // Stop processing if block is true
    if (block) return;
    const page = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page);
    const { settings: settings, variableData: variableData, formValues: formValues } = page || {};
    const mergedVariables = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, settings?.variables || {}, variableData || {});
    const replacedFormValue = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(formValues, mergedVariables);
    yield (0, $45d5d5ff9e5b412e$export$3722cfe417b6ed86)(del || 0);
    const cacheKey = (0, $7b0e169a5380005e$export$2083ef81b7b5b44)({
        command: undefined,
        action: value,
        component_id: componentId,
        screen_id: screenId
    });
    const [key2, value2] = cacheKey ? yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $c9e12427d7d919f3$export$f92dfeb71e9bb569), cacheKey) : [
        null,
        null
    ];
    if (value2 && !silent) {
        const cached2 = (0, $7d394fadd9d1d259$export$ef119f2182a928e)(value2);
        const { page: pp, settings: settings, variableData: variableData, screenId: screenIdParsed } = cached2.sections ? (0, $7b0e169a5380005e$export$d214ae9ea462ad72)(cached2) : (0, $7b0e169a5380005e$export$305e871e4887c1d)(cached2);
        let mergedData;
        if (localShimmer?.length) mergedData = $6ace1c53c6a18897$var$styleMerger(pp, localShimmer);
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
            data: mergedData || pp,
            settings: settings,
            session_data: {
                localShimmer: !!localShimmer?.length,
                type: 'indexedDb',
                hash: `skip-${(0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)()}`
            },
            variableData: (0, $7b0e169a5380005e$export$8c1182ab03da08ba)(variableData, settings?.variables),
            screenId: screenIdParsed
        }));
    } else if (localShimmer?.length) yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$1f3acb761da593d8)());
    try {
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$3653d7e5cadcf5e3)());
        const rawGetResponse = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $44edbfa3e77e92f9$export$2e2bcd8739ae039), 'post', '/get', {
            action: value,
            screen_id: screenId,
            skip_cache: silent ? true : !!value,
            active_route: `${window.location.pathname}${window.location.search || ''}`,
            component_id: componentId,
            device_info: (0, $7b0e169a5380005e$export$a5202107d3e3cdb0)(),
            session_id: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId(),
            ...replacedFormValue
        });
        const { code: code, data: data, session_data: session_data } = (0, $7d394fadd9d1d259$export$935adcd9e006ac5d)(rawGetResponse);
        if (code !== 200 || !data) return;
        const { page: pp, settings: settings, variableData: variableData, screenId: screenIdParsed } = data.sections ? (0, $7b0e169a5380005e$export$d214ae9ea462ad72)(data) : (0, $7b0e169a5380005e$export$305e871e4887c1d)(data);
        // Handle new update mode scheme
        let finalPageData = pp;
        let finalVariableData = variableData;
        let shouldUpdateCache = false;
        if (data.mode === 'update') {
            const currentPageData = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.data.page);
            const currentVariableData = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.variableData);
            const { page: updatedPage, variableData: updatedVariableData, shouldUpdateCache: cacheFlag } = (0, $7b0e169a5380005e$export$7fb9c25935e012b)(currentPageData, data, currentVariableData);
            finalPageData = updatedPage;
            finalVariableData = updatedVariableData;
            shouldUpdateCache = cacheFlag;
        }
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
            data: finalPageData,
            settings: settings,
            session_data: {
                ...(0, $7b0e169a5380005e$export$7e97e2c09f211669)(session_data),
                localShimmer: false,
                hash: `skip-${(0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)()}`
            },
            variableData: (0, $7b0e169a5380005e$export$8c1182ab03da08ba)(finalVariableData, settings?.variables),
            screenId: screenIdParsed
        }));
        const { status: status, transformed: transformed } = (0, $7b0e169a5380005e$export$b40f43cc69224c6e)(data?.screen?.sections || []);
        // Handle caching based on mode and settings
        if (data.mode === 'update') // For update mode, save the final transformed data
        {
            if (shouldUpdateCache) $6ace1c53c6a18897$var$setLocalCache(cacheKey, {
                ...data,
                screen: {
                    ...data.screen,
                    sections: finalPageData
                },
                variable_data: finalVariableData
            });
        } else if (status && transformed && !silent && settings?.cache) $6ace1c53c6a18897$var$setLocalCache(cacheKey, {
            ...data,
            screen: {
                ...data.screen,
                sections: transformed
            },
            variable_data: variableData
        });
        else if (!silent) {
            if (cacheKey) (0, $c9e12427d7d919f3$export$fe2d9b4e03920b4c)(cacheKey);
        }
        // Handle settings.command URL update
        if (settings?.command) {
            const newCommand = settings.command.replace(/^\//, '').replace(/\/$/, '');
            const currentPath = window.location.pathname.replace(/^\//, '').replace(/\/$/, '') + window.location.search;
            if (!/\{\{[^}]+\}\}/.test(newCommand) && newCommand !== currentPath) // yield put(push(`/${newCommand}`));
            {
                if (window.location.pathname + window.location.search !== `/${newCommand}`) window.history.pushState(null, '', `/${newCommand}`);
            }
        }
        // Parse form values
        const formValues = (0, $7b0e169a5380005e$export$a8c212b8aefc29ec)(finalPageData);
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$6e19b0a4e4c542c1)({
            data: formValues
        }));
        if (onSuccess?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onSuccess, {
            success: true,
            data: data,
            code: code
        }, componentId);
    } catch (error) {
        if (error instanceof Error) console.error('Error in sendAllFormValues:', error.message);
        if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, {
            success: false,
            error: error instanceof Error ? error.message : String(error)
        }, componentId);
    }
}
function* $6ace1c53c6a18897$var$updateVariableRequest(action) {
    const { payload: payload } = action || {};
    const { variable: variable, value: value } = payload || {};
    const keys = variable.split('.');
    const result = keys.reduceRight((acc, key)=>({
            [key]: acc
        }), value);
    // $setVariable semantics: arrays REPLACE the stored value (no index-merge stale tail).
    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
        data: result,
        replaceArrays: true
    }));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $6ace1c53c6a18897$var$handleLocationChange(action) {
    const { location: location, isFirstRendering: isFirstRendering, state: state, action: navAction } = action.payload;
    if (isFirstRendering === true) {
        // Check if config is already initialized from init script
        const configState = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.config);
        const isConfigFromInitScript = configState?.initializedFromInitScript === true;
        if (isConfigFromInitScript) ;
        else if ((0, $3668382e27becba6$export$3fa83f310820eeee)()) // View mode: the editor is the source of truth for the schema — it posts its
        // (possibly unsaved) working copy over the iframe handshake. `configRequest`
        // chains a `pageRequest` for the PERSISTED screen, whose PAGE_SUCCESS lands a
        // few hundred ms later and overwrites the posted schema — and, because the
        // reducer resets `variableData` wholesale, it also wipes everything the screen's
        // `on_launch` handlers wrote. Those handlers don't re-run (Container latches
        // `launchExecutedRef`), so the preview renders correctly for a moment and then
        // permanently breaks. Fetch the config WITHOUT the page fetch here; navigation
        // after the handshake still goes through the normal saga/API flow.
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $2907166a90fe0a09$export$ba933bc7f0f71012)(location));
        else yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $2907166a90fe0a09$export$cf229b36ba13aa52)(location));
        return;
    }
    // Back/forward — replay the exact request that put us on this URL. On
    // pushState(null) entries (state === null) we intentionally make no
    // backend request, per TNBEWEB-1905 acceptance criteria.
    if (navAction === 'POP') {
        const ctx = (0, $9c0f2890202f6fcd$export$44f5514ba2c862c1)(state);
        if (ctx) try {
            yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$executeNavigationRequest, ctx, {
                silent: false,
                updateHistory: false
            });
        } catch (error) {
            console.error('Navigation replay failed:', error);
        }
        return;
    }
    // Legacy PUSH/REPLACE: keep the old command-based path alive for components
    // that still dispatch pageRequest directly. processes:true navigation goes
    // through handleActionRequest and does not land here.
    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
        ...action.payload
    }));
}
function* $6ace1c53c6a18897$var$handleMergeStyle(action) {
    const { payload: payload, meta: meta } = action || {};
    const { context: context, index: index } = meta || {};
    const updates = Array.isArray(payload) ? payload : [
        payload
    ];
    const { page: page } = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.data);
    const styleChunks = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.styleChunks);
    const { indexes: indexes, refs: refs } = styleChunks || {};
    // Helper function to extract context values and generate ref keys
    const generateRefKey = (objectId, context)=>{
        if (!context || !objectId.includes('{{')) return null;
        let refKey = objectId;
        // Match patterns like {{this.id}}, {{demo}}, {{demo.key}}
        const matches = objectId.match(/\{\{([^}]+)\}\}/g);
        if (matches) matches.forEach((match)=>{
            const path = match.slice(2, -2); // Remove {{ and }}
            let value;
            // Handle {{this.}} patterns - extract from current context
            if (path.startsWith('this.')) {
                const contextPath = path.substring(5); // Remove 'this.'
                value = getNestedValue(context, contextPath);
            } else if (path.startsWith('this[')) {
                const contextPath = path.substring(4); // Remove 'this'
                value = getNestedValue(context, contextPath);
            } else // Handle other patterns like {{demo}}, {{demo.key}}
            value = getNestedValue(context, path);
            if (value !== undefined) refKey = refKey.replace(match, value);
        });
        return refKey !== objectId ? refKey : null;
    };
    // Helper function to get nested value from object
    const getNestedValue = (obj, path)=>{
        if (!path || obj === null || obj === undefined) return undefined;
        // Parse the path to handle both dot notation and bracket notation
        const parsePath = (pathStr)=>{
            const keys = [];
            let current = '';
            let inBrackets = false;
            let bracketDepth = 0;
            for(let i = 0; i < pathStr.length; i++){
                const char = pathStr[i];
                if (char === '[') {
                    if (inBrackets) {
                        bracketDepth++;
                        current += char;
                    } else {
                        if (current) {
                            keys.push(current);
                            current = '';
                        }
                        inBrackets = true;
                    }
                } else if (char === ']') {
                    if (bracketDepth > 0) {
                        bracketDepth--;
                        current += char;
                    } else {
                        inBrackets = false;
                        if (current) {
                            // Handle nested brackets and evaluate the content
                            let key = current;
                            // If the key contains quotes, remove them
                            if (key.startsWith('"') && key.endsWith('"') || key.startsWith("'") && key.endsWith("'")) key = key.slice(1, -1);
                            // If the key is a number, keep it as is
                            // If it contains nested brackets or dots, it might be a complex expression
                            keys.push(key);
                            current = '';
                        }
                    }
                } else if (char === '.' && !inBrackets) {
                    if (current) {
                        keys.push(current);
                        current = '';
                    }
                } else current += char;
            }
            if (current) keys.push(current);
            return keys;
        };
        const keys = parsePath(path);
        return keys.reduce((current, key)=>{
            if (current === null || current === undefined) return undefined;
            // Handle numeric keys for arrays
            if (!isNaN(Number(key))) {
                const numKey = Number(key);
                return Array.isArray(current) ? current[numKey] : current[key];
            }
            // Handle regular object keys
            return current[key];
        }, obj);
    };
    // Generate all ref updates at top level FIRST
    updates.forEach((update)=>{
        const refKey = generateRefKey(update.object_id, context);
        if (refKey && update.style) {
            if (!refs[refKey]) refs[refKey] = {};
            // Save refs with type and update structure
            refs[refKey] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, refs[refKey], {
                type: update.object_type,
                update: update?.style || {}
            });
        }
    });
    const updatesMap = updates.reduce((map, update)=>{
        map[update.object_id] = update;
        return map;
    }, {});
    const inArr = Array.isArray(page) ? page : [
        page
    ];
    // TNBEWEB-2001: when a style chunk carries a literal active_state for a node
    // whose active_state is bound to a single writable variable ({{v.*}}), we do
    // NOT bake the literal onto the node (that would unlink it from the variable
    // and break code-driven states like `disabled`). Instead we keep the binding
    // and redirect the literal into the bound variable — collected here (keyed by
    // path so the last write wins), dispatched after the tree merge below.
    const variableRedirects = new Map();
    const updatedComponents = (0, $7b0e169a5380005e$export$8f49bf34d2145408)(inArr, updatesMap, (item, insideTable)=>{
        const update = Object.keys(updatesMap).find((objId)=>objId === item.id || (0, $7b0e169a5380005e$export$78e968efcca6b7ef)(objId, item.id) && updatesMap[objId]?.object_type === item.component);
        if (update) {
            const updateData = updatesMap[update];
            if (insideTable && typeof index === 'number') {
                if (!indexes[item.id]) indexes[item.id] = {};
                indexes[item.id][index] = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, indexes[item.id][index], updateData?.style);
                return item;
            }
            const incomingActiveState = updateData?.active_state;
            const boundVarPath = $6ace1c53c6a18897$var$extractRedirectableVarPath(item.active_state);
            if (incomingActiveState != null && incomingActiveState !== '' && !$6ace1c53c6a18897$var$isBindingString(incomingActiveState) && boundVarPath) // Redirect the literal into the bound variable; keep item.active_state
            // as the "{{v.*}}" binding (mergeActiveState preserves it below).
            variableRedirects.set(boundVarPath, incomingActiveState);
            return {
                ...item,
                active_state: $6ace1c53c6a18897$var$mergeActiveState(incomingActiveState, item.active_state),
                style: (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, item.style, updateData?.style)
            };
        }
        return item;
    });
    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$eecf287d0d9bbcd2)({
        data: updatedComponents,
        styleChunks: {
            indexes: indexes,
            refs: refs
        } // Include updated refs
    }));
    // Apply the collected active_state → variable redirects. Reuses the variable
    // write saga so every node bound to each variable re-resolves on next render.
    if (variableRedirects.size) yield (0, $45d5d5ff9e5b412e$export$3d8c2f653ac9d0b9)(Array.from(variableRedirects, ([variable, value])=>(0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$updateVariableRequest, {
            payload: {
                variable: variable,
                value: value
            }
        })));
}
function* $6ace1c53c6a18897$var$handleUncheck(action) {
    const { payload: payload } = action || {};
    const { name: name, excludeId: excludeId, originalName: originalName } = payload || {};
    const { page: page } = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.data);
    const hasVariables = /\{\{.*?\}\}/.test(originalName);
    if (hasVariables) ;
    else {
        const { items: items, changedIds: changedIds } = (0, $7b0e169a5380005e$export$5356827378a1e669)(page, name, excludeId);
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$22aa4fb508251850)({
            data: items
        }));
        for (const item of changedIds)yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: item,
                value: false
            }
        }));
    }
}
function* $6ace1c53c6a18897$var$watchLocationChange() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).LOCATION_CHANGE, $6ace1c53c6a18897$var$handleLocationChange);
}
// Helper function to merge payloads by object_id while preserving context/index
const $6ace1c53c6a18897$var$mergePayloadsByContext = (batches, newPayload, newMeta)=>{
    const contextKey = `${newMeta?.context ? JSON.stringify(newMeta.context) : 'null'}_${newMeta?.index ?? 'null'}`;
    if (!batches[contextKey]) batches[contextKey] = {
        meta: newMeta,
        payloads: []
    };
    const currentBatch = batches[contextKey];
    const payloadArray = Array.isArray(newPayload) ? newPayload : [
        newPayload
    ];
    payloadArray.forEach((payload)=>{
        const existingIndex = currentBatch.payloads.findIndex((item)=>item.object_id === payload.object_id);
        if (existingIndex !== -1) // Merge styles for existing object_id
        currentBatch.payloads[existingIndex] = {
            ...currentBatch.payloads[existingIndex],
            ...payload,
            style: (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, currentBatch.payloads[existingIndex].style, payload.style)
        };
        else currentBatch.payloads.push(payload);
    });
};
// Batch MERGE_STYLE_REQUEST actions within 45ms, preserving context and index
function* $6ace1c53c6a18897$var$mergeStyleBatcher() {
    let batches = {}; // Group by context + index
    while(true){
        // Wait for the first MERGE_STYLE_REQUEST
        const firstAction = yield (0, $45d5d5ff9e5b412e$export$61196ced6d74a310)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).MERGE_STYLE_REQUEST);
        $6ace1c53c6a18897$var$mergePayloadsByContext(batches, firstAction.payload, firstAction.meta);
        // Now, for 45ms, collect any more MERGE_STYLE_REQUESTs
        while(true){
            const { nextAction: nextAction, timeout: timeout } = yield (0, $45d5d5ff9e5b412e$export$71cec2538cb2c617)({
                nextAction: (0, $45d5d5ff9e5b412e$export$61196ced6d74a310)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).MERGE_STYLE_REQUEST),
                timeout: (0, $45d5d5ff9e5b412e$export$3722cfe417b6ed86)(50)
            });
            if (nextAction) $6ace1c53c6a18897$var$mergePayloadsByContext(batches, nextAction.payload, nextAction.meta);
            else {
                for (const [contextKey, batch] of Object.entries(batches))yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$handleMergeStyle, {
                    payload: batch.payloads,
                    meta: batch.meta
                });
                batches = {};
                break;
            }
        }
    }
}
// FE-4677: page init runs the whole scheme through replacePlaceholdersWithVariables, which bakes
// every `{{…}}` of an event chunk long before the click; the pre-substitution template survives
// as `<key>Original` (`toOriginal`, `valueOriginal`). `{{this.*}}` is already resolved inside it:
// the component runs its whole `events` subtree through replacePlaceholdersWithVariablesV2.
const $6ace1c53c6a18897$var$eventTemplate = (original, baked)=>typeof original === 'string' && /\{\{[^}]+\}\}/.test(original) ? original : baked;
// FE-4677: page init resolved templates against a bag that ALSO held the globals
// (`getGlobalVariables()`, exposed as `{{c.*}}`), but an event-time bag has none. Re-resolving a
// recovered template without them would turn a `{{c.*}}` that used to bake correctly into an
// unresolved token. Globals live under the `c` key, so they cannot collide with page variables.
const $6ace1c53c6a18897$var$withGlobalVariables = (variables)=>(0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, variables, (0, $7d814282d5d3c114$export$1c9005e29d943d56)() || {});
// Event-time bag for URL templates: page variables (+ `$response` when chained) + globals.
function* $6ace1c53c6a18897$var$selectUrlVariables(responseContext) {
    const variableData = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.variableData);
    const settings = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.settings);
    const mergedVariables = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, settings?.variables || {}, variableData || {});
    return $6ace1c53c6a18897$var$withGlobalVariables(responseContext ? (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedVariables, {
        $response: responseContext
    }) : mergedVariables);
}
// TNBEWEB-2022: a legacy "Open url" request chained from on_success / on_error navigates exactly
// like a component's own one (handleOpenUrl: new-tab flag, delay, SPA push), with its URL
// resolved at event time — after the level's pre functions wrote their variables.
function* $6ace1c53c6a18897$var$openChainedUrl(template, delaySeconds, openInNewTab, responseContext) {
    const variables = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$selectUrlVariables, responseContext);
    const url = typeof template === 'string' ? (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(template, variables) : template;
    // '' would reload the page (location.href = '').
    if (typeof url !== 'string' || !url) return;
    // An explicit flag wins; only a scheme that never stored one keeps this path's old
    // default (an http URL opened a new tab).
    const newTab = openInNewTab ?? url.startsWith('http');
    // In processes mode `history.push` only changes the URL — the page request it triggers is
    // skipped (handlePageRequest) — so a relative path keeps its full reload there.
    const processes = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.config?.data?.features?.processes);
    (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(url, delaySeconds, newTab, processes === true ? undefined : (0, $4931f7746d84676b$export$55abd4691b317664));
}
// The same chunk order as a component's own event (runFunctionsWithTiming → runEffects):
// variables → `during` functions → `pre` functions (a throw / rejection skips everything after
// them and raises no on_error) → styles → actions → requests.
function* $6ace1c53c6a18897$var$runEventChunks(chunks, responseContext, ownerId) {
    // Variables are assigned before every other chunk in the event (first in the
    // stack), so subsequent style/action/function chunks see the new values.
    const variableUpdates = chunks.filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
    if (variableUpdates.length) {
        const state = (0, $4931f7746d84676b$export$6f57813fe9f31bf9).getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: state.page?.variableData,
            localVariables: state.page?.settings?.variables,
            thisContext: responseContext,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    }
    const styleUpdates = chunks.filter((u)=>u && 'style' in u);
    const actionUpdates = chunks.filter((u)=>u && 'action' in u);
    const requestUpdates = chunks.filter((u)=>u && 'request' in u);
    const { pre: pre, during: during } = (0, $7b0e169a5380005e$export$6c3d028e3b451352)(chunks.filter((u)=>u && 'function' in u));
    // TNBEWEB-1992: shared handler scope. `directWrites` keeps this path's synchronous $set
    // (so a later function-chunk in the same on_success can $get an earlier chunk's write).
    // No repeatable row in the response context → `this` stays undefined here.
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: $4931f7746d84676b$export$6f57813fe9f31bf9,
        response: responseContext,
        directWrites: true,
        owner: ownerId ? {
            id: ownerId
        } : undefined
    });
    during.forEach((update)=>{
        (0, $7b0e169a5380005e$export$1ed0175478ddd28b)(update.function, undefined, internalFns);
    });
    if (pre.length) {
        try {
            const pending = (0, $7b0e169a5380005e$export$54132b3e2309dd2c)(pre, internalFns);
            // Only a real Promise is yielded: even an already-resolved one would cost a microtask.
            if (pending) yield pending;
        } catch (err) {
            (0, $7b0e169a5380005e$export$abfe38bb9d3b70f4)(internalFns, err);
            return;
        }
        internalFns.onPrePassed?.();
    }
    if (styleUpdates.length) yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates));
    for (const update of actionUpdates)yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$2c41626496d118d)({
        actionUpdate: update,
        responseContext: responseContext
    }));
    for (const update of requestUpdates){
        const { method: method, value: value, valueOriginal: valueOriginal, silent: silent, config: config } = update?.request || {};
        const { delay: reqDelay } = config || {};
        if (method === 'command') yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
            location: {
                pathname: value
            },
            silent: silent
        }));
        else if (method === 'action') yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: value,
            delay: reqDelay,
            silent: silent
        }));
        else if (method === 'open-url') yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$openChainedUrl, $6ace1c53c6a18897$var$eventTemplate(valueOriginal, value), reqDelay, silent, responseContext);
    }
}
// TNBEWEB-2022: on_success / on_error run DETACHED from the worker that raised them. That worker
// is a takeLatest task (ACTION_REQUEST / PAGE_REQUEST / SUBMIT_FORM_REQUEST), and a chained
// action / command / submit dispatches the very pattern it was started by: takeLatest cancelled
// the running worker, and with it every chunk still queued after that dispatch — the function in
// "on_success: [Open url, function]" never ran. Detached, an exception inside the chain also can
// no longer kill the root saga. Every caller invokes this as its final step.
function* $6ace1c53c6a18897$var$processEventChunks(chunks, responseContext, ownerId) {
    if (!chunks?.length) return;
    yield (0, $45d5d5ff9e5b412e$export$ce26c07117d59d6a)($6ace1c53c6a18897$var$runEventChunks, chunks, responseContext, ownerId);
}
// FE-4866 — the address a response asks the browser to show: its `settings.command`
// resolved, without the leading/trailing slash. null when there is no command or a
// placeholder is left unresolved — such a response never changes the URL.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6ace1c53c6a18897$var$resolveCommandAddress = (command, variables)=>{
    if (typeof command !== 'string' || !command) return null;
    const resolved = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(command, variables);
    const address = resolved.replace(/^\//, '').replace(/\/$/, '');
    return /\{\{[^}]+\}\}/.test(address) ? null : address;
};
// The address the browser shows now, in the shape resolveCommandAddress returns.
const $6ace1c53c6a18897$var$currentAddress = ()=>window.location.pathname.replace(/^\//, '').replace(/\/$/, '') + window.location.search;
// Runs a NavContext snapshot — same logic whether this is an initial action
// request or a back/forward replay from window.history.state. Callers pass
// `updateHistory: true` to save the new entry via push/replaceState; replays
// pass `false` because popstate already placed us on the right URL.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* $6ace1c53c6a18897$var$executeNavigationRequest(snapshot, opts) {
    const { url: url, method: method, headers: snapshotHeaders, body: body, componentId: componentId, cacheActionUrl: cacheActionUrl, screenId: snapshotScreenId } = snapshot;
    const { silent: silent, onSuccess: onSuccess, onError: onError, responseContext: responseContext, localShimmer: localShimmer, variablesForCommand: variablesForCommand, updateHistory: updateHistory } = opts;
    // FE-4866 — the page scroller (`.pageWrap`) and scrollable containers go back to the top
    // when a PAGE_SUCCESS carries a fresh hash; a `skip-` hash leaves them where they are. A
    // navigation gets exactly ONE fresh hash, on the first render of the new screen: the cached
    // copy when there is one, otherwise the server's. The server render that follows a cached
    // one (TNBEWEB-1484), `mode: update`, `silent` requests and a response for the screen and
    // address already shown all keep `skip-`. A back/forward replay (`updateHistory: false`)
    // always counts — popstate has already moved the URL, so the address test can't see it.
    const shownScreenId = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.screenId);
    const isNavigationTo = (address, nextScreenId)=>!updateHistory || nextScreenId != null && String(nextScreenId) !== String(shownScreenId) || address !== null && address !== $6ace1c53c6a18897$var$currentAddress();
    let scrollResetDone = false;
    const cacheKey = (0, $7b0e169a5380005e$export$2083ef81b7b5b44)({
        command: undefined,
        action: cacheActionUrl || url,
        component_id: componentId,
        screen_id: snapshotScreenId
    });
    const [, value2] = cacheKey ? yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $c9e12427d7d919f3$export$f92dfeb71e9bb569), cacheKey) : [
        null,
        null
    ];
    if (value2 && !silent) {
        const cachedNav = (0, $7d394fadd9d1d259$export$ef119f2182a928e)(value2);
        const { page: pp, settings: cachedSettings, variableData: cachedVariableData, screenId: screenIdParsed } = cachedNav.sections ? (0, $7b0e169a5380005e$export$d214ae9ea462ad72)(cachedNav) : (0, $7b0e169a5380005e$export$305e871e4887c1d)(cachedNav);
        let mergedData;
        if (localShimmer?.length) mergedData = $6ace1c53c6a18897$var$styleMerger(pp, localShimmer);
        const cachedAddress = $6ace1c53c6a18897$var$resolveCommandAddress(cachedSettings?.command, (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, variablesForCommand || {}, cachedVariableData || {}, cachedSettings?.variables || {}));
        scrollResetDone = cachedNav.mode !== 'update' && isNavigationTo(cachedAddress, screenIdParsed);
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
            data: mergedData || pp,
            settings: cachedSettings,
            session_data: {
                localShimmer: !!localShimmer?.length,
                type: 'indexedDb',
                hash: scrollResetDone ? (0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)() : `skip-${(0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)()}`
            },
            variableData: (0, $7b0e169a5380005e$export$8c1182ab03da08ba)(cachedVariableData, cachedSettings?.variables),
            screenId: screenIdParsed
        }));
    } else if (localShimmer?.length) yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$1f3acb761da593d8)());
    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$3653d7e5cadcf5e3)());
    // Fsc is derived from the live cache state at call time, not from the snapshot —
    // a replay might hit cache even if the original call did not, or vice versa.
    //
    // FE-4577 — Fds is derived here for the same reason, and it matters more: the
    // snapshot in `history.state` can be minutes old, so a back/forward replay
    // would claim an inventory we have long since moved past. The backend
    // self-heals from a stale hash (it answers `r=1` and re-delivers), so this is
    // not a correctness problem — but it would throw away the entire benefit on
    // exactly the navigation that should be cheapest.
    //
    // Gated on same-origin: unlike Fsc, this header describes the branch's class
    // and template inventory and must not travel to a third-party action URL.
    const isSameOriginTarget = url.startsWith('/') || url.includes(window.location.host);
    const fdsHeaderValue = isSameOriginTarget ? yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $e916c0573570ec65$export$ac2a76745b8c23c3)) : null;
    const requestHeaders = {
        ...snapshotHeaders,
        Fsc: value2 ? 'false' : silent ? 'false' : 'true',
        ...fdsHeaderValue ? {
            Fds: fdsHeaderValue
        } : {}
    };
    const response = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)(fetch, url, {
        method: (method || 'POST').toUpperCase(),
        headers: requestHeaders,
        ...body !== undefined && {
            body: body
        }
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const responseJson = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)([
        response,
        'json'
    ]);
    const code = response.status;
    if (!responseJson || typeof responseJson !== 'object') {
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
            success: false,
            error: 'Invalid JSON response'
        }));
        if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, {
            success: false,
            error: 'Invalid JSON response',
            code: code
        }, componentId);
        return;
    }
    // FE-4577 — read the design-system delivery mark BEFORE normalizing, so the
    // boundary can ingest it. `session_data.fds` in the body takes precedence and
    // is the reliable source (no `F*` header is in any `Access-Control-Expose-
    // Headers` list, so the header is stripped cross-origin); this is the fallback.
    const responseFds = response.headers.get('Fds');
    // Replaces the old `'data' in responseJson ? …` probe: same envelope-vs-flat
    // question, but it also hoists mode/live_updates/localization out of
    // `screen.settings` and rebuilds `config` from `session_data`.
    const responseData = (0, $7d394fadd9d1d259$export$ef119f2182a928e)(responseJson, {
        ingest: true,
        fdsHeader: responseFds
    });
    const session_data = (0, $7b0e169a5380005e$export$7e97e2c09f211669)((0, $7d394fadd9d1d259$export$f803345c14bbbc14)(responseJson.session_data));
    const responseEndpointId = response.headers.get('Fseid');
    const responseEndpointType = response.headers.get('Fset');
    const responseTaskRef = response.headers.get('Fref');
    const responseProcessId = response.headers.get('Fspid');
    if (responseEndpointId || responseEndpointType || responseTaskRef || responseProcessId) {
        const updatedParams = {};
        if (responseEndpointId) updatedParams.endpoint_id = responseEndpointId;
        if (responseEndpointType) updatedParams.endpoint_type = responseEndpointType;
        if (responseTaskRef) updatedParams.task_ref = responseTaskRef;
        if (responseProcessId) updatedParams.process_id = responseProcessId;
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $2907166a90fe0a09$export$1899915054cedfe4)(updatedParams));
    }
    if (code !== 200 || !responseData) {
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
            success: false,
            error: 'Invalid response'
        }));
        if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, {
            success: false,
            error: 'Invalid response',
            code: code,
            data: responseData
        }, componentId);
        return;
    }
    // Refine <html lang> from `localization` on any successful response — a
    // process/actions response (screen: null) still carries the language even
    // though it has no screen to render, and would otherwise early-return below
    // before any parser (and its applyDocumentLanguage) runs.
    (0, $7b0e169a5380005e$export$ab76a6159e74f74b)(responseData.localization);
    const hasScreenData = responseData && typeof responseData === 'object' && (responseData.sections || responseData.screen || responseData.updates);
    if (!hasScreenData) {
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
            success: true,
            data: responseData
        }));
        if (onSuccess?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onSuccess, {
            success: true,
            data: responseData,
            code: code
        }, componentId);
        return;
    }
    const { page: pp, settings: responseSettingsDraft, variableData: responseVariableData, screenId: screenIdParsed } = responseData.sections ? (0, $7b0e169a5380005e$export$d214ae9ea462ad72)(responseData) : (0, $7b0e169a5380005e$export$305e871e4887c1d)(responseData);
    let finalPageData = pp;
    let finalVariableData = responseVariableData;
    let responseSettings = responseSettingsDraft;
    let shouldUpdateCache = false;
    if (responseData.mode === 'update') {
        const currentPageData = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.data.page);
        const currentVariableData = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.variableData);
        const currentSettings = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.settings);
        const { page: updatedPage, variableData: updatedVariableData, shouldUpdateCache: cacheFlag } = (0, $7b0e169a5380005e$export$7fb9c25935e012b)(currentPageData, responseData, currentVariableData);
        responseSettings = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, currentSettings, responseSettingsDraft);
        finalPageData = updatedPage;
        finalVariableData = updatedVariableData;
        shouldUpdateCache = cacheFlag;
    }
    // Resolved once, before the render: the same address decides the scroll reset here and
    // push-vs-replace of the history entry below.
    const responseAddress = $6ace1c53c6a18897$var$resolveCommandAddress(responseSettings?.command, (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, variablesForCommand || {}, finalVariableData || {}, responseSettings?.variables || {}));
    const resetScroll = !silent && !scrollResetDone && responseData.mode !== 'update' && isNavigationTo(responseAddress, screenIdParsed);
    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
        data: finalPageData,
        settings: responseSettings,
        session_data: {
            ...session_data,
            localShimmer: false,
            hash: resetScroll ? (0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)() : `skip-${(0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)()}`
        },
        variableData: (0, $7b0e169a5380005e$export$8c1182ab03da08ba)(finalVariableData, responseSettings?.variables),
        screenId: screenIdParsed
    }));
    const { status: status, transformed: transformed } = (0, $7b0e169a5380005e$export$b40f43cc69224c6e)(responseData?.screen?.sections || []);
    if (responseData.mode === 'update') {
        if (shouldUpdateCache) $6ace1c53c6a18897$var$setLocalCache(cacheKey, {
            ...responseData,
            screen: {
                ...responseData.screen,
                sections: finalPageData
            },
            variable_data: finalVariableData
        });
    } else if (status && transformed && !silent && responseSettings?.cache) $6ace1c53c6a18897$var$setLocalCache(cacheKey, {
        ...responseData,
        screen: {
            ...responseData.screen,
            sections: transformed
        },
        variable_data: responseVariableData
    });
    else if (!silent) {
        if (cacheKey) (0, $c9e12427d7d919f3$export$fe2d9b4e03920b4c)(cacheKey);
    }
    if (updateHistory) {
        if (responseAddress !== null && responseAddress !== $6ace1c53c6a18897$var$currentAddress()) (0, $9c0f2890202f6fcd$export$6e124b896d76bfaa)(`/${responseAddress}`, snapshot);
        else // No command from server, an unresolved one, or the address we are already on —
        // keep URL as-is but stamp the current entry with the new context so
        // refresh/back/forward replays this exact request.
        (0, $9c0f2890202f6fcd$export$d287140c80e4b48d)(snapshot);
    }
    const formValues = (0, $7b0e169a5380005e$export$a8c212b8aefc29ec)(finalPageData);
    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$6e19b0a4e4c542c1)({
        data: formValues
    }));
    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
        success: true,
        data: responseData
    }));
    if (onSuccess?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onSuccess, {
        success: true,
        data: responseData,
        code: code
    }, componentId);
}
function* $6ace1c53c6a18897$var$handleActionRequest(action) {
    const screenId = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page.screenId);
    const { payload: payload, meta: localShimmer } = action || {};
    const { actionUpdate: actionUpdate, componentId: componentId, onSuccess: onSuccess, onError: onError, responseContext: responseContext } = payload || {};
    const { type: type, method: method, to: to, toOriginal: toOriginal, format: format, data: data, data_TEMPORARY: dataTemporary, target: target, silent: legacySilent, delay: legacyDelay, settings: settings, request_type: request_type, process_id: process_id, upload: upload } = actionUpdate?.action || {};
    const { send_all_parameters: sendAll } = settings || {};
    // FE-4121: an action's settings all live in `action.settings` now. Old
    // definitions (not re-saved by the editor) still carry `silent`/`delay` at the
    // top level of `action` — keep honouring them, `settings` wins.
    // Resolved HERE, before `settings` is shadowed by the page settings below.
    const silent = settings?.silent ?? legacySilent;
    const actionDelay = settings?.delay ?? legacyDelay;
    // Apply delay if specified
    if (actionDelay && actionDelay > 0) yield (0, $45d5d5ff9e5b412e$export$3722cfe417b6ed86)(actionDelay);
    try {
        if (type === 'request') {
            const page = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page);
            const config = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.config);
            const { settings: settings, variableData: variableData, formValues: currentFormValues } = page || {};
            const { publicUrl: publicUrl, data: configData } = config || {};
            const { endpoint_id: endpoint_id, process_id: config_process_id, endpoint_type: endpoint_type, task_ref: task_ref } = configData || {};
            const mergedVariables = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, settings?.variables || {}, variableData || {});
            // When this action is dispatched as a chained step from an upload's
            // (or any other action's) on_success/on_error, expose `$response` in
            // the placeholder bag so `{{$response.*}}` resolves inside the URL
            // and any multi-token field values that fall back to the generic
            // resolver. Field-level single-token paths still go through
            // resolveResponseContextValue first, which is unchanged.
            const variablesWithResponse = responseContext ? (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedVariables, {
                $response: responseContext
            }) : mergedVariables;
            const replacedFormValue = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(currentFormValues, mergedVariables);
            // FE-4677: parameters are resolved BEFORE the URL is built, because an
            // endpoint path may contain `{{token}}` segments that these very parameters
            // fill. Pure motion — this block reads only `data`, `replacedFormValue`,
            // `responseContext` and `variablesWithResponse`, never the URL.
            // Transform data: extract actual values from form storage based on data keys
            let additionalData = {};
            if (data && typeof data === 'object') additionalData = Object.keys(data).reduce((acc, key)=>{
                const fieldConfig = data[key];
                let extractedValue;
                let targetType;
                // Check if there's a direct value in replacedFormValue
                if (replacedFormValue.hasOwnProperty(key)) {
                    extractedValue = replacedFormValue[key];
                    // If fieldConfig is an object, it might have a type
                    if (typeof fieldConfig === 'object' && fieldConfig !== null && 'type' in fieldConfig) targetType = fieldConfig.type;
                } else if (typeof fieldConfig === 'string') {
                    const variableMatch = fieldConfig.match(/\{\{([^}]+)\}\}/);
                    if (variableMatch) {
                        const variableName = variableMatch[1].trim();
                        extractedValue = $6ace1c53c6a18897$var$resolveResponseContextValue(variableName, responseContext);
                        if (extractedValue === undefined) extractedValue = replacedFormValue[variableName] ?? (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(fieldConfig, variablesWithResponse);
                    }
                } else if (typeof fieldConfig === 'object' && fieldConfig !== null && 'value' in fieldConfig) {
                    const { value: value } = fieldConfig;
                    const { valueOriginal: valueOriginal } = fieldConfig;
                    targetType = fieldConfig.type;
                    if (typeof valueOriginal === 'string' && /\{\{[^}]+\}\}/.test(valueOriginal)) {
                        const variableMatch = valueOriginal.match(/\{\{([^}]+)\}\}/);
                        if (variableMatch) {
                            const variableName = variableMatch[1].trim();
                            extractedValue = $6ace1c53c6a18897$var$resolveResponseContextValue(variableName, responseContext);
                            if (extractedValue === undefined) extractedValue = replacedFormValue[variableName] ?? (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(valueOriginal, variablesWithResponse);
                        }
                    } else if (typeof value === 'string' && /\{\{[^}]+\}\}/.test(value)) {
                        const variableMatch = value.match(/\{\{([^}]+)\}\}/);
                        if (variableMatch) {
                            const variableName = variableMatch[1].trim();
                            extractedValue = $6ace1c53c6a18897$var$resolveResponseContextValue(variableName, responseContext);
                            if (extractedValue === undefined) extractedValue = replacedFormValue[variableName] ?? (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(value, variablesWithResponse);
                        } else extractedValue = value;
                    } else extractedValue = value;
                }
                // Convert to target type if specified
                if (extractedValue !== undefined) acc[key] = $6ace1c53c6a18897$var$convertToType(extractedValue, targetType);
                return acc;
            }, {});
            // Normalize publicUrl - remove leading and trailing slashes
            const normalizedPublicUrl = publicUrl && request_type !== 'process' ? `/${publicUrl.replace(/^\/|\/$/g, '')}` : '';
            // Replace placeholders in URL
            let urlWithVariables;
            // FE-4677: path-parameter keys consumed by the URL, so they are not ALSO
            // repeated in the body / query string.
            let usedPathParamKeys = [];
            if (request_type === 'process' && process_id) // For process requests, use process_external_id to construct URL
            // const processId = replacePlaceholdersWithVariables(process_external_id, mergedVariables);
            urlWithVariables = `/_processes/${process_id}`;
            else {
                // FE-4677: an endpoint path like `/admin/loan/{{loan_ref}}` was baked to
                // `/admin/loan/` at page init — resolve from the stashed template (eventTemplate).
                const toTemplate = $6ace1c53c6a18897$var$eventTemplate(toOriginal, to);
                // Fill `{{token}}` path segments from the action's own parameters first,
                // falling back to page variables. Tokens in the query part are left to the
                // generic resolver below, exactly as before.
                const urlVariables = $6ace1c53c6a18897$var$withGlobalVariables(variablesWithResponse);
                const pathResult = (0, $7b0e169a5380005e$export$c11473a4d340015a)(toTemplate, additionalData, urlVariables);
                if (pathResult.missing.length) // Never ship `/admin/loan/` — an empty segment can route to a DIFFERENT
                // endpoint (FE-4670). Throwing reuses the existing catch, which reports the
                // failure and runs the action's on_error chain.
                throw new Error(`Missing path parameter(s): ${pathResult.missing.join(', ')}`);
                usedPathParamKeys = pathResult.used;
                urlWithVariables = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(pathResult.path, urlVariables);
            }
            // Prepend publicUrl to relative URLs (not absolute URLs with protocol)
            if (normalizedPublicUrl && !urlWithVariables.match(/^https?:\/\//)) {
                if (urlWithVariables.startsWith('/')) // Relative URL with leading slash: /api/endpoint
                urlWithVariables = `${normalizedPublicUrl}${urlWithVariables}`;
                else if (urlWithVariables.length > 0) // Relative URL without leading slash: api/endpoint
                urlWithVariables = `${normalizedPublicUrl}/${urlWithVariables}`;
            }
            // Build cache action URL with all relevant request params as query params for a unique, stable cache key
            const cacheActionUrlObj = new URL(urlWithVariables, window.location.origin);
            const cacheDataParams = sendAll ? {
                ...replacedFormValue,
                ...additionalData
            } : {
                ...additionalData
            };
            // FE-4677: a key consumed by the path is already in the URL — drop it here so
            // the cache key matches the request we actually send. Still unique per row,
            // because the value now lives in the path itself.
            usedPathParamKeys.forEach((k)=>{
                delete cacheDataParams[k];
            });
            Object.entries(cacheDataParams).forEach(([key, value])=>{
                if (value !== null && value !== undefined) cacheActionUrlObj.searchParams.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
            });
            const cacheActionUrl = cacheActionUrlObj.pathname + (cacheActionUrlObj.search || '');
            // Assemble the request exactly once here; the same URL/headers/body are
            // snapshotted into history.state so back/forward can replay verbatim.
            const requestData = sendAll ? {
                screen_id: screenId,
                active_route: `${window.location.pathname}${window.location.search || ''}`,
                component_id: componentId,
                device_info: (0, $7b0e169a5380005e$export$a5202107d3e3cdb0)(),
                session_id: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId(),
                ...replacedFormValue,
                ...additionalData
            } : {
                ...additionalData
            };
            // FE-4677: path parameters are consumed by the URL, so they are NOT repeated
            // in the body / query string — the value appears exactly once. Done after
            // assembly so it covers the `sendAll` form-value spread too.
            // (Revert point: if the gateway does not bind path segments into the called
            // process's start input, delete this loop to send them in both places.)
            usedPathParamKeys.forEach((k)=>{
                delete requestData[k];
            });
            const requestHeaders = {
                Accept: 'application/json'
            };
            const isSameOrigin = urlWithVariables.startsWith('/') || urlWithVariables.includes(window.location.host);
            if (isSameOrigin) {
                // NOTE: Fds is deliberately NOT stamped here. These headers are frozen
                // into the `history.state` snapshot and replayed on back/forward, and a
                // design-system claim goes stale the moment anything is delivered.
                // `executeNavigationRequest` derives it at fire time instead, next to Fsc.
                requestHeaders.Fc = 'web';
                requestHeaders.Fie = 'true';
                requestHeaders.Fsi = (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId();
                requestHeaders.Fdi = (0, $7cdaba13c8ba20d3$export$2e2bcd8739ae039).getOrCreateDeviceId();
                if (endpoint_id) requestHeaders.Fseid = String(endpoint_id);
                if (endpoint_type) requestHeaders.Fset = String(endpoint_type);
                if (task_ref) requestHeaders.Fref = String(task_ref);
                if (screenId) requestHeaders.Fssid = String(screenId);
                if (config_process_id) requestHeaders.Fspid = String(config_process_id);
                if (componentId) requestHeaders.Fcid = String(componentId);
            }
            let finalUrl = urlWithVariables;
            let requestBody;
            if (method?.toUpperCase() === 'GET') {
                const urlObj = new URL(urlWithVariables, window.location.origin);
                Object.entries(requestData).forEach(([key, value])=>{
                    if (value !== null && value !== undefined) urlObj.searchParams.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
                });
                // Keep URL relative if the original was relative, so it's portable in history.state.
                finalUrl = urlWithVariables.match(/^https?:\/\//) ? urlObj.toString() : urlObj.pathname + (urlObj.search || '');
            } else {
                const isFormFormat = format === 'form';
                if (isFormFormat) {
                    requestHeaders['Content-Type'] = 'application/x-www-form-urlencoded';
                    const formBody = new URLSearchParams();
                    Object.entries(requestData).forEach(([key, value])=>{
                        if (value !== null && value !== undefined) formBody.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
                    });
                    requestBody = formBody.toString();
                } else {
                    requestHeaders['Content-Type'] = 'application/json';
                    requestBody = JSON.stringify(requestData);
                }
            }
            const snapshot = {
                kind: 'action',
                url: finalUrl,
                method: (method || 'POST').toUpperCase(),
                headers: requestHeaders,
                body: requestBody,
                componentId: componentId,
                screenId: screenId,
                cacheActionUrl: cacheActionUrl,
                sendAll: !!sendAll
            };
            yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$executeNavigationRequest, snapshot, {
                silent: silent,
                onSuccess: onSuccess,
                onError: onError,
                responseContext: responseContext,
                localShimmer: localShimmer,
                variablesForCommand: mergedVariables,
                updateHistory: true
            });
        } else if (type === 'url') {
            // TNBEWEB-2022: resolved from the stashed template at event time, so variables written by
            // the event's pre functions (e.g. a token) reach the URL — `to` itself was baked at init.
            const variables = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$selectUrlVariables, responseContext);
            const urlWithVariables = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)($6ace1c53c6a18897$var$eventTemplate(toOriginal, to), variables);
            if (typeof urlWithVariables !== 'string' || !urlWithVariables) // location.href = '' would reload the page; fail into on_error instead.
            throw new Error('Open url action resolved to an empty address');
            if (target === '_blank') {
                // No `noopener` feature: with it window.open always returns null and hides a popup block.
                const openedWindow = window.open(urlWithVariables, '_blank');
                if (!openedWindow) {
                    const errorCtx = {
                        success: false,
                        type: 'url',
                        error: 'popup_blocked',
                        url: urlWithVariables,
                        target: target
                    };
                    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
                        success: false,
                        error: errorCtx.error
                    }));
                    if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, errorCtx, componentId);
                    return;
                }
                // The opened page must not be able to navigate this one (reverse tabnabbing).
                try {
                    openedWindow.opener = null;
                } catch  {
                // Already cross-origin: the relationship cannot be used from there anyway.
                }
            } else window.location.href = urlWithVariables;
            const successCtx = {
                success: true,
                type: 'url',
                url: urlWithVariables,
                target: target
            };
            yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)(successCtx));
            if (onSuccess?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onSuccess, successCtx, componentId);
        } else if (type === 'upload') {
            const page = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.page);
            const { settings: pageSettings, variableData: variableData, formValues: currentFormValues } = page || {};
            const mergedVariables = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, pageSettings?.variables || {}, variableData || {});
            // When this upload is itself chained from another action's
            // on_success/on_error, the upstream `responseContext` is exposed as
            // `$response` so the URL, headers, and field values can reference it.
            const variablesWithResponse = responseContext ? (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedVariables, {
                $response: responseContext
            }) : mergedVariables;
            const replacedFormValue = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(currentFormValues, mergedVariables);
            const uploadKind = upload?.type || 'api';
            const fileSettings = upload?.file || {};
            const acceptTypes = Array.isArray(fileSettings.types) ? fileSettings.types : [];
            const multiple = !!fileSettings.multiple;
            const maxSize = typeof fileSettings.max_size === 'number' ? fileSettings.max_size : undefined;
            // Locate the single `file`-typed field in data — its key is the
            // multipart field name. Other entries in data are regular fields.
            // The editor writes both `data` (Record, canonical) and
            // `data_TEMPORARY` (raw rows). Prefer the array when present so a
            // user-added empty row round-trips, then fall back to the Record.
            let fileFieldKey;
            let dataEntries = [];
            if (Array.isArray(dataTemporary) && dataTemporary.length) dataEntries = dataTemporary.map((row)=>{
                if (!row || typeof row !== 'object') return null;
                const k = typeof row.key === 'string' ? row.key : '';
                if (!k) return null;
                const { key: _k, ...rest } = row;
                return [
                    k,
                    rest
                ];
            }).filter((e)=>!!e);
            else if (data && typeof data === 'object') dataEntries = Object.entries(data);
            for (const [key, cfg] of dataEntries)if (cfg && typeof cfg === 'object' && cfg.type === 'file') {
                fileFieldKey = key;
                break;
            }
            if (!fileFieldKey) {
                const errorCtx = {
                    error: 'Upload action requires exactly one data field with type "file"'
                };
                yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
                    success: false,
                    error: errorCtx.error
                }));
                if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, errorCtx, componentId);
                return;
            }
            // Open native file picker and wait for the user's selection.
            const selectedFiles = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$pickFiles, {
                accept: acceptTypes,
                multiple: multiple
            });
            if (!selectedFiles.length) // User cancelled — silent no-op, matches how native pickers behave.
            return;
            // Validate file size (client-side; server is still source of truth).
            if (maxSize !== undefined) {
                const oversized = selectedFiles.find((f)=>f.size > maxSize);
                if (oversized) {
                    const errCtx = {
                        error: 'File size exceeds limit',
                        filename: oversized.name,
                        size_bytes: oversized.size,
                        max_size: maxSize
                    };
                    yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
                        success: false,
                        error: errCtx.error
                    }));
                    if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, errCtx, componentId);
                    return;
                }
            }
            if (uploadKind !== 'api') {
                const errCtx = {
                    error: `Unsupported upload type: ${uploadKind}`
                };
                yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
                    success: false,
                    error: errCtx.error
                }));
                if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, errCtx, componentId);
                return;
            }
            const apiCfg = upload?.api || {};
            const rawUrl = apiCfg.url || to || '';
            const uploadUrl = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(rawUrl, variablesWithResponse);
            const finalUploadUrl = uploadUrl;
            const uploadMethod = (apiCfg.method || 'POST').toUpperCase();
            // Build user-managed headers, with placeholders resolved (e.g. so
            // `Authorization: Bearer {{token}}` works). Editor writes both
            // `headers` (Record) and `headers_TEMPORARY` (raw rows); prefer the
            // array form so partially-filled rows round-trip without dropping.
            const resolvedHeaders = {};
            const headerRows = apiCfg.headers_TEMPORARY;
            if (Array.isArray(headerRows) && headerRows.length) for (const row of headerRows){
                if (!row || typeof row !== 'object') continue;
                const hKey = typeof row.key === 'string' ? row.key.trim() : '';
                if (!hKey) continue;
                const hVal = row.value;
                resolvedHeaders[hKey] = typeof hVal === 'string' ? (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(hVal, variablesWithResponse) : hVal == null ? '' : String(hVal);
            }
            else if (apiCfg.headers && typeof apiCfg.headers === 'object') for (const [hKey, hVal] of Object.entries(apiCfg.headers)){
                if (!hKey || !hKey.trim()) continue;
                resolvedHeaders[hKey] = typeof hVal === 'string' ? (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(hVal, variablesWithResponse) : hVal == null ? '' : String(hVal);
            }
            // Build multipart/form-data: the `file` field gets the binary(s);
            // every other data entry is stringified as a regular form field.
            const formData = new FormData();
            if (multiple) for (const f of selectedFiles)formData.append(fileFieldKey, f, f.name);
            else formData.append(fileFieldKey, selectedFiles[0], selectedFiles[0].name);
            for (const [key, cfg] of dataEntries){
                if (key === fileFieldKey) continue;
                let extractedValue;
                let targetType;
                if (typeof cfg === 'string') extractedValue = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(cfg, variablesWithResponse);
                else if (cfg && typeof cfg === 'object') {
                    targetType = cfg.type;
                    const cfgValue = cfg.value;
                    const cfgValueOriginal = cfg.valueOriginal;
                    const placeholderSource = typeof cfgValueOriginal === 'string' ? cfgValueOriginal : cfgValue;
                    if (typeof placeholderSource === 'string' && /\{\{[^}]+\}\}/.test(placeholderSource)) {
                        const m = placeholderSource.match(/\{\{([^}]+)\}\}/);
                        if (m) {
                            const variableName = m[1].trim();
                            extractedValue = $6ace1c53c6a18897$var$resolveResponseContextValue(variableName, responseContext);
                            if (extractedValue === undefined) extractedValue = replacedFormValue[variableName] ?? (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(placeholderSource, variablesWithResponse);
                        }
                    } else extractedValue = cfgValue;
                }
                if (extractedValue === undefined || extractedValue === null) continue;
                const converted = $6ace1c53c6a18897$var$convertToType(extractedValue, targetType);
                if (typeof converted === 'object') formData.append(key, JSON.stringify(converted));
                else formData.append(key, String(converted));
            }
            // Do not set Content-Type manually — the browser fills in the
            // multipart boundary automatically when a FormData body is used.
            const response = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)(fetch, finalUploadUrl, {
                method: uploadMethod,
                headers: resolvedHeaders,
                body: formData
            });
            const firstFile = selectedFiles[0];
            const fileMeta = multiple ? selectedFiles.map((f)=>({
                    filename: f.name,
                    content_type: f.type,
                    size_bytes: f.size
                })) : {
                filename: firstFile.name,
                content_type: firstFile.type,
                size_bytes: firstFile.size
            };
            let responseBody = null;
            try {
                const contentType = response.headers.get('Content-Type') || '';
                responseBody = contentType.includes('application/json') ? yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)([
                    response,
                    'json'
                ]) : yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)([
                    response,
                    'text'
                ]);
            } catch (_parseErr) {
                responseBody = null;
            }
            // Flatten the JSON body into the response context so chained chunks
            // can write `{{$response.imageUrl}}` instead of `{{$response.response.imageUrl}}`.
            // Plain-text bodies / arrays / null stay accessible via `.response`.
            const flatBody = responseBody && typeof responseBody === 'object' && !Array.isArray(responseBody) ? responseBody : {};
            if (!response.ok) {
                const errCtx = {
                    ...multiple ? {
                        files: fileMeta
                    } : fileMeta,
                    code: response.status,
                    ...flatBody,
                    response: responseBody,
                    error: `Upload failed with status ${response.status}`
                };
                yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
                    success: false,
                    error: errCtx.error
                }));
                if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, errCtx, componentId);
                return;
            }
            const successCtx = multiple ? {
                files: fileMeta,
                code: response.status,
                ...flatBody,
                response: responseBody
            } : {
                ...fileMeta,
                code: response.status,
                ...flatBody,
                response: responseBody
            };
            // Persist upload metadata to formValues[componentId] so subsequent
            // chunks (or re-renders) can read {{componentId}} if needed.
            if (componentId) yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$4452cb953514838a)({
                data: {
                    [componentId]: successCtx
                }
            }));
            yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
                success: true,
                type: 'upload',
                data: successCtx
            }));
            if (onSuccess?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onSuccess, successCtx, componentId);
        }
    } catch (error) {
        if (!silent) console.error('Action request failed:', error);
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$b8bdf8945930e196)({
            success: false,
            error: error.message
        }));
        if (onError?.length) yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)($6ace1c53c6a18897$var$processEventChunks, onError, {
            success: false,
            error: error instanceof Error ? error.message : String(error)
        }, componentId);
    }
}
function* $6ace1c53c6a18897$var$watchFetchRequest() {
    yield (0, $17b5b1be37557756$export$ca010cea618a298a)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_REQUEST, $6ace1c53c6a18897$var$handlePageRequest);
    yield (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($6ace1c53c6a18897$var$mergeStyleBatcher);
}
function* $6ace1c53c6a18897$var$watchHandleInputRequest() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SET_FORM_VALUES_REQUEST, $6ace1c53c6a18897$var$handleSetFormValuesRequest);
}
function* $6ace1c53c6a18897$var$watchSubmitFormRequest() {
    yield (0, $17b5b1be37557756$export$ca010cea618a298a)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SUBMIT_FORM_REQUEST, $6ace1c53c6a18897$var$sendAllFormValues);
}
function* $6ace1c53c6a18897$var$watchUpdateVariableRequest() {
    yield (0, $17b5b1be37557756$export$ca010cea618a298a)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_VARIABLE_REQUEST, $6ace1c53c6a18897$var$updateVariableRequest);
}
function* $6ace1c53c6a18897$var$watchActionRequest() {
    yield (0, $17b5b1be37557756$export$ca010cea618a298a)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).ACTION_REQUEST, $6ace1c53c6a18897$var$handleActionRequest);
}
function* $6ace1c53c6a18897$var$watchUncheckDependent() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UNCHECK_DEPENDENT_RADIO_REQUEST, $6ace1c53c6a18897$var$handleUncheck);
}
function* $6ace1c53c6a18897$var$pageSaga() {
    yield (0, $45d5d5ff9e5b412e$export$3d8c2f653ac9d0b9)([
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($6ace1c53c6a18897$var$watchHandleInputRequest),
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($6ace1c53c6a18897$var$watchFetchRequest),
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($6ace1c53c6a18897$var$watchSubmitFormRequest),
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($6ace1c53c6a18897$var$watchLocationChange),
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($6ace1c53c6a18897$var$watchUpdateVariableRequest),
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($6ace1c53c6a18897$var$watchActionRequest),
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($6ace1c53c6a18897$var$watchUncheckDependent)
    ]);
}
var $6ace1c53c6a18897$export$2e2bcd8739ae039 = $6ace1c53c6a18897$var$pageSaga;


/* eslint-disable @typescript-eslint/default-param-last */ 

var $94WEq = parcelRequire("94WEq");

var $bbNXs = parcelRequire("bbNXs");
const $471be8cf4b44b657$export$d4c72bab9d6cc13a = {
    data: {
        page: {}
    },
    screenId: undefined,
    styleChunks: {
        refs: {},
        indexes: {}
    },
    session_data: {},
    settings: {},
    variableData: {},
    formValues: {},
    loading: true
};
const $471be8cf4b44b657$export$df5f0d913620ea1b = (state = $471be8cf4b44b657$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_REQUEST:
            return {
                ...state,
                loading: true,
                notifications: []
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).SET_FORM_VALUES_SUCCESS:
            return {
                ...state,
                formValues: {
                    ...state.formValues,
                    ...action.payload.data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).RESET_FORM_VALUES_SUCCESS:
            return {
                ...state,
                formValues: {
                    ...action.payload.data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).ACTIVATE_LOCAL_SHIMMER_SUCCESS:
            return {
                ...state,
                session_data: {
                    ...state.session_data,
                    localShimmer: true
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).PAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                previewFile: undefined,
                screenId: action.payload.screenId,
                data: {
                    page: action.payload.data
                },
                settings: action.payload.settings ? {
                    ...action.payload.settings
                } : state.settings,
                variableData: {
                    ...action.payload.variableData
                },
                session_data: {
                    ...action.payload.session_data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).MERGE_STYLE_SUCCESS:
            return {
                ...state,
                data: {
                    page: action.payload.data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UNCHECK_DEPENDENT_RADIO_SUCCESS:
            return {
                ...state,
                data: {
                    page: action.payload.data
                }
            };
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).UPDATE_VARIABLE_SUCCESS:
            {
                // replaceArrays: $setVariable writes replace arrays wholesale ([x] over [a,b,c] → [x]).
                // Default (Variables-chunk path) keeps lodash index-merge — sparse partial arrays
                // like products[2].edit_icon_state depend on it.
                const { data: data, replaceArrays: replaceArrays } = action.payload;
                return {
                    ...state,
                    variableData: replaceArrays ? (0, (/*@__PURE__*/$parcel$interopDefault($bbNXs)))({}, state.variableData, data, (_dst, src)=>Array.isArray(src) ? src : undefined) : (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, state.variableData, data)
                };
            }
        case (0, $bd80e90ec7f1f3b2$export$f1bd415280efb039).CLEAR_FORMS:
            return {
                ...state,
                data: {
                    ...state.data,
                    forms: []
                }
            };
        default:
            return state;
    }
};









function* $7888bad15d99924f$var$handleConfigRequest(action) {
    // Check if config is already initialized from server-side data
    const currentConfig = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.config?.data);
    const hasConfig = currentConfig && Object.keys(currentConfig).length > 0;
    if (hasConfig) {
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
            location: {
                ...action.payload
            }
        }));
        return;
    }
    const configResponse = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $44edbfa3e77e92f9$export$2e2bcd8739ae039), 'get', '/config');
    const { code: code, data: data } = (0, $7d394fadd9d1d259$export$935adcd9e006ac5d)(configResponse);
    if (code === 200) {
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $2907166a90fe0a09$export$ff747514dac36e4c)({
            data: {
                ...data
            }
        }));
        if (data.style) (0, $7b0e169a5380005e$export$ff76c51b0f744e0a)(data.style);
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
            location: {
                ...action.payload
            }
        }));
    } else yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $2907166a90fe0a09$export$3dbcfb3539facac2)());
}
function* $7888bad15d99924f$var$handleConfigEmptyRequest() {
    // Check if config is already initialized from server-side data
    const currentConfig = yield (0, $45d5d5ff9e5b412e$export$efca4cbe5dd06740)((state)=>state.config?.data);
    const hasConfig = currentConfig && Object.keys(currentConfig).length > 0;
    if (hasConfig) return;
    const configResponse = yield (0, $45d5d5ff9e5b412e$export$c4ce752e73470fba)((0, $44edbfa3e77e92f9$export$2e2bcd8739ae039), 'get', '/config');
    const { code: code, data: data } = (0, $7d394fadd9d1d259$export$935adcd9e006ac5d)(configResponse);
    if (code === 200) {
        if (data.style) (0, $7b0e169a5380005e$export$ff76c51b0f744e0a)(data.style);
        yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $2907166a90fe0a09$export$ff747514dac36e4c)({
            data: {
                ...data
            }
        }));
    } else yield (0, $45d5d5ff9e5b412e$export$dc98b0b04f4c7758)((0, $2907166a90fe0a09$export$3dbcfb3539facac2)());
}
function* $7888bad15d99924f$var$watchFetchRequest() {
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_REQUEST, $7888bad15d99924f$var$handleConfigRequest);
    yield (0, $17b5b1be37557756$export$4e24be1e1c9d5c69)((0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_EMPTY_REQUEST, $7888bad15d99924f$var$handleConfigEmptyRequest);
}
function* $7888bad15d99924f$var$configSaga() {
    yield (0, $45d5d5ff9e5b412e$export$3d8c2f653ac9d0b9)([
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)($7888bad15d99924f$var$watchFetchRequest)
    ]);
}
var $7888bad15d99924f$export$2e2bcd8739ae039 = $7888bad15d99924f$var$configSaga;


/* eslint-disable @typescript-eslint/default-param-last */ 
const $7cc89248c7209f44$export$d4c72bab9d6cc13a = {
    data: {},
    initializedFromInitScript: false,
    publicUrl: undefined
};
const $7cc89248c7209f44$export$21f3d8f1fe4f2d8 = (state = $7cc89248c7209f44$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case (0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_SUCCESS:
            return {
                ...state,
                data: {
                    ...action.payload.data
                },
                initializedFromInitScript: action.payload.initializedFromInitScript || false,
                publicUrl: action.payload.publicUrl
            };
        case (0, $9c904b43c5ef6eaf$export$e378b6cc3d050bd4).CONFIG_UPDATE_ENDPOINT_PARAMS:
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};


const $0f4aec746757b732$export$3be10229d3544b83 = (history)=>(0, $b4bc487a38c3f200$export$66e4520cdb265d18)({
        router: (0, $3b7d72a70d6ed09c$export$4360105d0eb5a11c)(history),
        page: (0, $471be8cf4b44b657$export$df5f0d913620ea1b),
        config: (0, $7cc89248c7209f44$export$21f3d8f1fe4f2d8)
    });
function* $0f4aec746757b732$export$6a6f973fb1abcfdc() {
    yield (0, $45d5d5ff9e5b412e$export$3d8c2f653ac9d0b9)([
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)((0, $7888bad15d99924f$export$2e2bcd8739ae039)),
        (0, $45d5d5ff9e5b412e$export$3a1a48c8f6ef640e)((0, $6ace1c53c6a18897$export$2e2bcd8739ae039))
    ]);
}


const $4931f7746d84676b$export$55abd4691b317664 = (0, $0e3a6b1020765bd1$export$719fc203c4e16dee)();
let $4931f7746d84676b$export$6f57813fe9f31bf9;
function $4931f7746d84676b$export$2e2bcd8739ae039(initialState) {
    const composeEnhancers = (0, $60658be5529a36bf$export$d32324a03b6bde1b)({});
    const sagaMiddleware = (0, $e77394150e9d59e6$export$2e2bcd8739ae039)();
    $4931f7746d84676b$export$6f57813fe9f31bf9 = (0, $b4bc487a38c3f200$export$f51a9068ac82ea43)((0, $0f4aec746757b732$export$3be10229d3544b83)($4931f7746d84676b$export$55abd4691b317664), initialState, composeEnhancers((0, $b4bc487a38c3f200$export$9ff26e0402cc7b7)((0, $3b7d72a70d6ed09c$export$1fe5128387816284)($4931f7746d84676b$export$55abd4691b317664), sagaMiddleware)));
    sagaMiddleware.run((0, $0f4aec746757b732$export$6a6f973fb1abcfdc));
    return $4931f7746d84676b$export$6f57813fe9f31bf9;
}



parcelRequire("aivMx");
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $5MEMe = parcelRequire("5MEMe");
var $e5d28596ff67251c$exports = {};
'use strict';

$e5d28596ff67251c$exports = (parcelRequire("cr0L2"));





// Default to a dummy "batch" implementation that just runs the callback
function $4c61203c9cf36eaa$var$defaultNoopBatch(callback) {
    callback();
}
let $4c61203c9cf36eaa$var$batch = $4c61203c9cf36eaa$var$defaultNoopBatch; // Allow injecting another batching function later
const $4c61203c9cf36eaa$export$4b9874722d0da7bc = (newBatch)=>$4c61203c9cf36eaa$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $4c61203c9cf36eaa$export$fc47d4c0ba3bd2c6 = ()=>$4c61203c9cf36eaa$var$batch;



var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");
const $361aa446d88712bf$var$ContextKey = Symbol.for(`react-redux-context`);
const $361aa446d88712bf$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $361aa446d88712bf$var$getContext() {
    var _gT$ContextKey;
    if (!$aivMx.createContext) return {};
    const contextMap = (_gT$ContextKey = $361aa446d88712bf$var$gT[$361aa446d88712bf$var$ContextKey]) != null ? _gT$ContextKey : $361aa446d88712bf$var$gT[$361aa446d88712bf$var$ContextKey] = new Map();
    let realContext = contextMap.get($aivMx.createContext);
    if (!realContext) {
        realContext = $aivMx.createContext(null);
        contextMap.set($aivMx.createContext, realContext);
    }
    return realContext;
}
const $361aa446d88712bf$export$cc80c08dc91f1c00 = /*#__PURE__*/ $361aa446d88712bf$var$getContext();
var $361aa446d88712bf$export$2e2bcd8739ae039 = $361aa446d88712bf$export$cc80c08dc91f1c00;


function $4127e7c544b4c057$export$d4d6226d5fc61558(context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $aivMx.useContext)(context);
        return contextValue;
    };
}
const $4127e7c544b4c057$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $4127e7c544b4c057$export$d4d6226d5fc61558();



const $abfd7c056df8e569$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};


let $f40d1f3d995cccef$var$useSyncExternalStoreWithSelector = (0, $abfd7c056df8e569$export$20656a4825650bd0);
const $f40d1f3d995cccef$export$e2e6e3f3f3b782e3 = (fn)=>{
    $f40d1f3d995cccef$var$useSyncExternalStoreWithSelector = fn;
};
const $f40d1f3d995cccef$var$refEquality = (a, b)=>a === b;
function $f40d1f3d995cccef$export$2b53f90d2bd1cbfb(context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $361aa446d88712bf$export$cc80c08dc91f1c00) ? (0, $4127e7c544b4c057$export$c1275ca9a6fd3ec5) : (0, $4127e7c544b4c057$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $f40d1f3d995cccef$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $aivMx.useRef)(true);
        const wrappedSelector = (0, $aivMx.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $f40d1f3d995cccef$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $aivMx.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $f40d1f3d995cccef$export$2105062e25df4afe = /*#__PURE__*/ $f40d1f3d995cccef$export$2b53f90d2bd1cbfb();




var $a32b854b69af5a94$exports = {};
'use strict';
var $c96e60eb6cff7e49$exports = {};
'use strict';

$c96e60eb6cff7e49$exports = (parcelRequire("A9JWB"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $a32b854b69af5a94$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $a32b854b69af5a94$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $a32b854b69af5a94$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $a32b854b69af5a94$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $a32b854b69af5a94$var$TYPE_STATICS = {};
$a32b854b69af5a94$var$TYPE_STATICS[$c96e60eb6cff7e49$exports.ForwardRef] = $a32b854b69af5a94$var$FORWARD_REF_STATICS;
$a32b854b69af5a94$var$TYPE_STATICS[$c96e60eb6cff7e49$exports.Memo] = $a32b854b69af5a94$var$MEMO_STATICS;
function $a32b854b69af5a94$var$getStatics(component) {
    // React v16.11 and below
    if ($c96e60eb6cff7e49$exports.isMemo(component)) return $a32b854b69af5a94$var$MEMO_STATICS;
     // React v16.12 and above
    return $a32b854b69af5a94$var$TYPE_STATICS[component['$$typeof']] || $a32b854b69af5a94$var$REACT_STATICS;
}
var $a32b854b69af5a94$var$defineProperty = Object.defineProperty;
var $a32b854b69af5a94$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $a32b854b69af5a94$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $a32b854b69af5a94$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $a32b854b69af5a94$var$getPrototypeOf = Object.getPrototypeOf;
var $a32b854b69af5a94$var$objectPrototype = Object.prototype;
function $a32b854b69af5a94$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($a32b854b69af5a94$var$objectPrototype) {
            var inheritedComponent = $a32b854b69af5a94$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $a32b854b69af5a94$var$objectPrototype) $a32b854b69af5a94$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $a32b854b69af5a94$var$getOwnPropertyNames(sourceComponent);
        if ($a32b854b69af5a94$var$getOwnPropertySymbols) keys = keys.concat($a32b854b69af5a94$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $a32b854b69af5a94$var$getStatics(targetComponent);
        var sourceStatics = $a32b854b69af5a94$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$a32b854b69af5a94$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $a32b854b69af5a94$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $a32b854b69af5a94$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$a32b854b69af5a94$exports = $a32b854b69af5a94$var$hoistNonReactStatics;



var $aivMx = parcelRequire("aivMx");
var $5280ebdf6a2fee14$exports = {};
'use strict';

$5280ebdf6a2fee14$exports = (parcelRequire("hSPEQ"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $c8dcf2f11e553f3d$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $2d55f4e5d3122779$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $c8dcf2f11e553f3d$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $2d55f4e5d3122779$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $2d55f4e5d3122779$var$verify(mapStateToProps, 'mapStateToProps');
    $2d55f4e5d3122779$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $2d55f4e5d3122779$var$verify(mergeProps, 'mergeProps');
}


const $d994fed38fdd2c9c$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $d994fed38fdd2c9c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d994fed38fdd2c9c$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_ref, $d994fed38fdd2c9c$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $d994fed38fdd2c9c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $5ff7f2480956b8ce$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e7102004ed25fa60$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $2faf2ca8db4437d4$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $e7102004ed25fa60$export$2e2bcd8739ae039)(value)) (0, $c8dcf2f11e553f3d$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $70699fd7311458e3$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $70699fd7311458e3$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $70699fd7311458e3$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $70699fd7311458e3$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $70699fd7311458e3$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $053a6eaee2a635f2$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $fca739655e9c9f6b$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $70699fd7311458e3$export$710f7c60f68acd3e)((dispatch)=>(0, $5ff7f2480956b8ce$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $70699fd7311458e3$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $70699fd7311458e3$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : (0, $053a6eaee2a635f2$export$19ef7b929f7e2559)(mapDispatchToProps, 'mapDispatchToProps');
}




function $07a90a3d2d029fc5$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $70699fd7311458e3$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $70699fd7311458e3$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : (0, $053a6eaee2a635f2$export$19ef7b929f7e2559)(mapStateToProps, 'mapStateToProps');
}





function $4d90bd7c26246bf4$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $6767be368738adce$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $4d90bd7c26246bf4$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $4d90bd7c26246bf4$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$4d90bd7c26246bf4$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $4d90bd7c26246bf4$export$5b105939c84b5234(mergeProps) : (0, $053a6eaee2a635f2$export$19ef7b929f7e2559)(mergeProps, 'mergeProps');
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $39e2d9229ed3e385$var$createListenerCollection() {
    const batch = (0, $4c61203c9cf36eaa$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $39e2d9229ed3e385$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $39e2d9229ed3e385$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $39e2d9229ed3e385$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $39e2d9229ed3e385$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $39e2d9229ed3e385$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $aivMx = parcelRequire("aivMx");
const $d6662a22e770eb21$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $d6662a22e770eb21$export$700979bc83e7db82 = $d6662a22e770eb21$export$71594e8a50f746f4 ? $aivMx.useLayoutEffect : $aivMx.useEffect;


function $b1dd956634aa1b08$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $b1dd956634aa1b08$export$2e2bcd8739ae039(objA, objB) {
    if ($b1dd956634aa1b08$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$b1dd956634aa1b08$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $0e647a1d90b9cc81$var$_excluded = [
    "reactReduxForwardedRef"
];
let $0e647a1d90b9cc81$var$useSyncExternalStore = (0, $abfd7c056df8e569$export$20656a4825650bd0);
const $0e647a1d90b9cc81$export$36d45daa6a4925b8 = (fn)=>{
    $0e647a1d90b9cc81$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $0e647a1d90b9cc81$var$EMPTY_ARRAY = [
    null,
    0
];
const $0e647a1d90b9cc81$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $0e647a1d90b9cc81$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $0e647a1d90b9cc81$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $d6662a22e770eb21$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $0e647a1d90b9cc81$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $0e647a1d90b9cc81$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $0e647a1d90b9cc81$var$initStateUpdates = ()=>$0e647a1d90b9cc81$var$EMPTY_ARRAY;
function $0e647a1d90b9cc81$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $0e647a1d90b9cc81$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $0e647a1d90b9cc81$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $0e647a1d90b9cc81$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $b1dd956634aa1b08$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $b1dd956634aa1b08$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $b1dd956634aa1b08$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $07a90a3d2d029fc5$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $fca739655e9c9f6b$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $4d90bd7c26246bf4$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $aivMx.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(props, $0e647a1d90b9cc81$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $aivMx.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $5280ebdf6a2fee14$exports.isContextConsumer)(/*#__PURE__*/ $aivMx.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $aivMx.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $aivMx.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $d994fed38fdd2c9c$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $aivMx.useMemo(()=>{
                if (!shouldHandleStateChanges) return $0e647a1d90b9cc81$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $39e2d9229ed3e385$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $aivMx.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $6767be368738adce$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $aivMx.useRef();
            const lastWrapperProps = $aivMx.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $aivMx.useRef();
            const renderIsScheduled = $aivMx.useRef(false);
            const isProcessingDispatch = $aivMx.useRef(false);
            const isMounted = $aivMx.useRef(false);
            const latestSubscriptionCallbackError = $aivMx.useRef();
            (0, $d6662a22e770eb21$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $aivMx.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $aivMx.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $0e647a1d90b9cc81$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $0e647a1d90b9cc81$var$useIsomorphicLayoutEffectWithArgs($0e647a1d90b9cc81$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $0e647a1d90b9cc81$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $d6662a22e770eb21$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $aivMx.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $aivMx.createElement(WrappedComponent, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $aivMx.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $aivMx.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $aivMx.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $aivMx.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $aivMx.createElement(Connect, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($a32b854b69af5a94$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($a32b854b69af5a94$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $0e647a1d90b9cc81$export$2e2bcd8739ae039 = $0e647a1d90b9cc81$var$connect;



var $aivMx = parcelRequire("aivMx");



function $7a57c545a1f92740$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $aivMx.useMemo(()=>{
        const subscription = (0, $39e2d9229ed3e385$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $aivMx.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $d6662a22e770eb21$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $361aa446d88712bf$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $aivMx.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $7a57c545a1f92740$export$2e2bcd8739ae039 = $7a57c545a1f92740$var$Provider;







function $864b0261b61c7c4a$export$671dba69185d0304(context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $361aa446d88712bf$export$cc80c08dc91f1c00) ? (0, $4127e7c544b4c057$export$c1275ca9a6fd3ec5) : (0, $4127e7c544b4c057$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $864b0261b61c7c4a$export$6ccbb43953eebf8 = /*#__PURE__*/ $864b0261b61c7c4a$export$671dba69185d0304();


function $d023060d48542f4c$export$bc9b55530897c558(context = (0, $361aa446d88712bf$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $361aa446d88712bf$export$cc80c08dc91f1c00) ? (0, $864b0261b61c7c4a$export$6ccbb43953eebf8) : (0, $864b0261b61c7c4a$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $d023060d48542f4c$export$8ad76b76a4c905f8 = /*#__PURE__*/ $d023060d48542f4c$export$bc9b55530897c558();









(0, $f40d1f3d995cccef$export$e2e6e3f3f3b782e3)((0, $e5d28596ff67251c$exports.useSyncExternalStoreWithSelector));
(0, $0e647a1d90b9cc81$export$36d45daa6a4925b8)((0, $5MEMe.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $4c61203c9cf36eaa$export$4b9874722d0da7bc)((0, $9f97ad3b314012cb$exports.unstable_batchedUpdates));




var $aivMx = parcelRequire("aivMx");
function $cce73e5d1d37055b$export$2e2bcd8739ae039(t, e) {
    return $cce73e5d1d37055b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $cce73e5d1d37055b$export$2e2bcd8739ae039(t, e);
}


function $0d767dd10c1fa0a3$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $cce73e5d1d37055b$export$2e2bcd8739ae039)(t, o);
}



var $aivMx = parcelRequire("aivMx");
var $e58e8d2b21900e4d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e58e8d2b21900e4d$var$ReactIs, $e58e8d2b21900e4d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$e58e8d2b21900e4d$exports = (parcelRequire("lJpQh"))();






var $f37523df22180869$exports = {};
var $6e0a6410913e21a0$exports = {};
$6e0a6410913e21a0$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $f37523df22180869$exports = $f37523df22180869$var$pathToRegexp;
$f37523df22180869$exports.parse = $f37523df22180869$var$parse;
$f37523df22180869$exports.compile = $f37523df22180869$var$compile;
$f37523df22180869$exports.tokensToFunction = $f37523df22180869$var$tokensToFunction;
$f37523df22180869$exports.tokensToRegExp = $f37523df22180869$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $f37523df22180869$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $f37523df22180869$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $f37523df22180869$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $f37523df22180869$var$escapeGroup(pattern) : asterisk ? '.*' : $f37523df22180869$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $f37523df22180869$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $f37523df22180869$var$escapeString(delimiter) + ']+?';
    return $f37523df22180869$var$escapeString(prevText) + '|(?:(?!' + $f37523df22180869$var$escapeString(prevText) + ')[^' + $f37523df22180869$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $f37523df22180869$var$compile(str, options) {
    return $f37523df22180869$var$tokensToFunction($f37523df22180869$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $f37523df22180869$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $f37523df22180869$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $f37523df22180869$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $f37523df22180869$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $f37523df22180869$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($6e0a6410913e21a0$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $f37523df22180869$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $f37523df22180869$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $f37523df22180869$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $f37523df22180869$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $f37523df22180869$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $f37523df22180869$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $f37523df22180869$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $f37523df22180869$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($f37523df22180869$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $f37523df22180869$var$flags(options));
    return $f37523df22180869$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $f37523df22180869$var$stringToRegexp(path, keys, options) {
    return $f37523df22180869$var$tokensToRegExp($f37523df22180869$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $f37523df22180869$var$tokensToRegExp(tokens, keys, options) {
    if (!$6e0a6410913e21a0$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $f37523df22180869$var$escapeString(token);
        else {
            var prefix = $f37523df22180869$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $f37523df22180869$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $f37523df22180869$var$attachKeys(new RegExp('^' + route, $f37523df22180869$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $f37523df22180869$var$pathToRegexp(path, keys, options) {
    if (!$6e0a6410913e21a0$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $f37523df22180869$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($6e0a6410913e21a0$exports(path)) return $f37523df22180869$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $f37523df22180869$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}





var $8e7337eeed3043b3$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $8e7337eeed3043b3$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $8e7337eeed3043b3$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $8e7337eeed3043b3$var$commonjsGlobal[key] = ($8e7337eeed3043b3$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $8e7337eeed3043b3$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $8e7337eeed3043b3$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $8e7337eeed3043b3$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $8e7337eeed3043b3$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $8e7337eeed3043b3$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $8e7337eeed3043b3$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($8e7337eeed3043b3$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $8e7337eeed3043b3$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $8e7337eeed3043b3$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $8e7337eeed3043b3$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $8e7337eeed3043b3$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $8e7337eeed3043b3$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createContext || $8e7337eeed3043b3$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $8e7337eeed3043b3$var$createNamedContext = function createNamedContext(name) {
    var context = $8e7337eeed3043b3$var$createContext();
    context.displayName = name;
    return context;
};
var $8e7337eeed3043b3$export$c213558b66925821 = /*#__PURE__*/ $8e7337eeed3043b3$var$createNamedContext("Router-History");
var $8e7337eeed3043b3$export$63baa8ccbe60bb07 = /*#__PURE__*/ $8e7337eeed3043b3$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $8e7337eeed3043b3$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $8e7337eeed3043b3$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $0e3a6b1020765bd1$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
var $8e7337eeed3043b3$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $8e7337eeed3043b3$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $8e7337eeed3043b3$var$messageType;
var $8e7337eeed3043b3$var$cache = {};
var $8e7337eeed3043b3$var$cacheLimit = 10000;
var $8e7337eeed3043b3$var$cacheCount = 0;
function $8e7337eeed3043b3$var$compilePath(path) {
    if ($8e7337eeed3043b3$var$cache[path]) return $8e7337eeed3043b3$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($f37523df22180869$exports))).compile(path);
    if ($8e7337eeed3043b3$var$cacheCount < $8e7337eeed3043b3$var$cacheLimit) {
        $8e7337eeed3043b3$var$cache[path] = generator;
        $8e7337eeed3043b3$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $8e7337eeed3043b3$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $8e7337eeed3043b3$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $8e7337eeed3043b3$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $8e7337eeed3043b3$export$82476f982757e71e(to, computedMatch.params) : (0, $6767be368738adce$export$2e2bcd8739ae039)({}, to, {
            pathname: $8e7337eeed3043b3$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $0e3a6b1020765bd1$export$c3e8bb440bd55b18)(prevLocation, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $8e7337eeed3043b3$var$cache$1 = {};
var $8e7337eeed3043b3$var$cacheLimit$1 = 10000;
var $8e7337eeed3043b3$var$cacheCount$1 = 0;
function $8e7337eeed3043b3$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $8e7337eeed3043b3$var$cache$1[cacheKey] || ($8e7337eeed3043b3$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($f37523df22180869$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($8e7337eeed3043b3$var$cacheCount$1 < $8e7337eeed3043b3$var$cacheLimit$1) {
        pathCache[path] = result;
        $8e7337eeed3043b3$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $8e7337eeed3043b3$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $8e7337eeed3043b3$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $8e7337eeed3043b3$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Children.count(children) === 0;
}
function $8e7337eeed3043b3$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $8e7337eeed3043b3$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $8e7337eeed3043b3$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $6767be368738adce$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $8e7337eeed3043b3$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
function $8e7337eeed3043b3$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $8e7337eeed3043b3$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $6767be368738adce$export$2e2bcd8739ae039)({}, location, {
        pathname: $8e7337eeed3043b3$var$addLeadingSlash(basename) + location.pathname
    });
}
function $8e7337eeed3043b3$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $8e7337eeed3043b3$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $6767be368738adce$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $8e7337eeed3043b3$var$createURL(location) {
    return typeof location === "string" ? location : (0, $0e3a6b1020765bd1$export$fe53371bee54353d)(location);
}
function $8e7337eeed3043b3$var$staticHandler(methodName) {
    return function() {
        (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
    };
}
function $8e7337eeed3043b3$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $8e7337eeed3043b3$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $8e7337eeed3043b3$var$noop;
        };
        _this.handleBlock = function() {
            return $8e7337eeed3043b3$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $8e7337eeed3043b3$var$addBasename(basename, (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(location));
        context.url = $8e7337eeed3043b3$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $8e7337eeed3043b3$var$addLeadingSlash(basename + $8e7337eeed3043b3$var$createURL(path));
            },
            action: "POP",
            location: $8e7337eeed3043b3$var$stripBasename(basename, (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $8e7337eeed3043b3$var$staticHandler("go"),
            goBack: $8e7337eeed3043b3$var$staticHandler("goBack"),
            goForward: $8e7337eeed3043b3$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$55185c17a0fcbe46, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $8e7337eeed3043b3$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $8e7337eeed3043b3$export$81336c211d5ff295(location.pathname, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $8e7337eeed3043b3$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($8e7337eeed3043b3$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(Component, (0, $6767be368738adce$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a32b854b69af5a94$exports)))(C, Component);
}
var $8e7337eeed3043b3$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext;
function $8e7337eeed3043b3$export$3420e1dc2c4a518c() {
    return $8e7337eeed3043b3$var$useContext($8e7337eeed3043b3$export$c213558b66925821);
}
function $8e7337eeed3043b3$export$45d76561a5302f2b() {
    return $8e7337eeed3043b3$var$useContext($8e7337eeed3043b3$export$63baa8ccbe60bb07).location;
}
function $8e7337eeed3043b3$export$99eaa27ddbbb95ef() {
    var match = $8e7337eeed3043b3$var$useContext($8e7337eeed3043b3$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $8e7337eeed3043b3$export$632be4bb944c1bc7(path) {
    var location = $8e7337eeed3043b3$export$45d76561a5302f2b();
    var match = $8e7337eeed3043b3$var$useContext($8e7337eeed3043b3$export$63baa8ccbe60bb07).match;
    return path ? $8e7337eeed3043b3$export$81336c211d5ff295(location.pathname, path) : match;
}
var $8e7337eeed3043b3$var$global$1, $8e7337eeed3043b3$var$key, $8e7337eeed3043b3$var$buildNames, $8e7337eeed3043b3$var$initialBuildName, $8e7337eeed3043b3$var$secondaryBuildName;




var $aivMx = parcelRequire("aivMx");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $4eb000c8d349d54f$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $0e3a6b1020765bd1$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement((0, $8e7337eeed3043b3$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $4eb000c8d349d54f$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $0d767dd10c1fa0a3$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $0e3a6b1020765bd1$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement((0, $8e7337eeed3043b3$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component);
var $4eb000c8d349d54f$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $4eb000c8d349d54f$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $0e3a6b1020765bd1$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $4eb000c8d349d54f$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $4eb000c8d349d54f$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef;
if (typeof $4eb000c8d349d54f$var$forwardRef === "undefined") $4eb000c8d349d54f$var$forwardRef = $4eb000c8d349d54f$var$forwardRefShim;
function $4eb000c8d349d54f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $4eb000c8d349d54f$var$LinkAnchor = $4eb000c8d349d54f$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $6767be368738adce$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$4eb000c8d349d54f$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($4eb000c8d349d54f$var$forwardRefShim !== $4eb000c8d349d54f$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $4eb000c8d349d54f$export$a6c7ac8248d6e38a = $4eb000c8d349d54f$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $4eb000c8d349d54f$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement((0, $8e7337eeed3043b3$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $4eb000c8d349d54f$var$normalizeToLocation($4eb000c8d349d54f$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $6767be368738adce$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $4eb000c8d349d54f$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $0e3a6b1020765bd1$export$fe53371bee54353d)(context.location) === (0, $0e3a6b1020765bd1$export$fe53371bee54353d)($4eb000c8d349d54f$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($4eb000c8d349d54f$var$forwardRefShim !== $4eb000c8d349d54f$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(component, props);
    });
});
var $4eb000c8d349d54f$var$toType, $4eb000c8d349d54f$var$refType;
var $4eb000c8d349d54f$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $4eb000c8d349d54f$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef;
if (typeof $4eb000c8d349d54f$var$forwardRef$1 === "undefined") $4eb000c8d349d54f$var$forwardRef$1 = $4eb000c8d349d54f$var$forwardRefShim$1;
function $4eb000c8d349d54f$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $4eb000c8d349d54f$export$b0d92dbee9b5b60d = $4eb000c8d349d54f$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $612ace97f19660e2$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement((0, $8e7337eeed3043b3$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $4eb000c8d349d54f$var$normalizeToLocation($4eb000c8d349d54f$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $8e7337eeed3043b3$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $4eb000c8d349d54f$var$joinClassnames(className, activeClassName);
            style = (0, $6767be368738adce$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $6767be368738adce$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($4eb000c8d349d54f$var$forwardRefShim$1 !== $4eb000c8d349d54f$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($4eb000c8d349d54f$export$a6c7ac8248d6e38a, props);
    });
});
var $4eb000c8d349d54f$var$ariaCurrentType;




const $2a1fdbb8d383931f$var$CustomRouter = ({ history: history, children: children })=>{
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    (0, $aivMx.useEffect)(()=>{
        // Start listening to history changes and dispatch to store
        const unlisten = (0, $3b7d72a70d6ed09c$export$5a3c9ae1fa6d7e61)(history, store);
        // Clean up when component unmounts
        return unlisten;
    }, [
        history,
        store
    ]);
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e7337eeed3043b3$export$55185c17a0fcbe46), {
        history: history,
        children: children
    });
};
var $2a1fdbb8d383931f$export$2e2bcd8739ae039 = $2a1fdbb8d383931f$var$CustomRouter;



parcelRequire("aivMx");



var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");

parcelRequire("aivMx");

/* eslint-disable react/jsx-props-no-spreading */ 

var $aivMx = parcelRequire("aivMx");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $d7167ae03e108b0e$var$extendStatics = function(d, b) {
    $d7167ae03e108b0e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d7167ae03e108b0e$var$extendStatics(d, b);
};
function $d7167ae03e108b0e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d7167ae03e108b0e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d7167ae03e108b0e$export$18ce0697a983be9b = function() {
    $d7167ae03e108b0e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d7167ae03e108b0e$export$18ce0697a983be9b.apply(this, arguments);
};
function $d7167ae03e108b0e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d7167ae03e108b0e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d7167ae03e108b0e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d7167ae03e108b0e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d7167ae03e108b0e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d7167ae03e108b0e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $d7167ae03e108b0e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d7167ae03e108b0e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d7167ae03e108b0e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d7167ae03e108b0e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d7167ae03e108b0e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d7167ae03e108b0e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d7167ae03e108b0e$export$45d3717a4c69092e(o, m, p);
}
function $d7167ae03e108b0e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d7167ae03e108b0e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d7167ae03e108b0e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d7167ae03e108b0e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d7167ae03e108b0e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d7167ae03e108b0e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d7167ae03e108b0e$export$10c90e4f7922046c(v) {
    return this instanceof $d7167ae03e108b0e$export$10c90e4f7922046c ? (this.v = v, this) : new $d7167ae03e108b0e$export$10c90e4f7922046c(v);
}
function $d7167ae03e108b0e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d7167ae03e108b0e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d7167ae03e108b0e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d7167ae03e108b0e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d7167ae03e108b0e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d7167ae03e108b0e$export$19a8beecd37a4c45 === "function" ? $d7167ae03e108b0e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d7167ae03e108b0e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d7167ae03e108b0e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $d7167ae03e108b0e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d7167ae03e108b0e$export$45d3717a4c69092e(result, mod, k);
    }
    $d7167ae03e108b0e$var$__setModuleDefault(result, mod);
    return result;
}
function $d7167ae03e108b0e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d7167ae03e108b0e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d7167ae03e108b0e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d7167ae03e108b0e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d7167ae03e108b0e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d7167ae03e108b0e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d7167ae03e108b0e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d7167ae03e108b0e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $d7167ae03e108b0e$export$2e2bcd8739ae039 = {
    __extends: $d7167ae03e108b0e$export$a8ba968b8961cb8a,
    __assign: $d7167ae03e108b0e$export$18ce0697a983be9b,
    __rest: $d7167ae03e108b0e$export$3c9a16f847548506,
    __decorate: $d7167ae03e108b0e$export$29e00dfd3077644b,
    __param: $d7167ae03e108b0e$export$d5ad3fd78186038f,
    __metadata: $d7167ae03e108b0e$export$f1db080c865becb9,
    __awaiter: $d7167ae03e108b0e$export$1050f835b63b671e,
    __generator: $d7167ae03e108b0e$export$67ebef60e6f28a6,
    __createBinding: $d7167ae03e108b0e$export$45d3717a4c69092e,
    __exportStar: $d7167ae03e108b0e$export$f33643c0debef087,
    __values: $d7167ae03e108b0e$export$19a8beecd37a4c45,
    __read: $d7167ae03e108b0e$export$8d051b38c9118094,
    __spread: $d7167ae03e108b0e$export$afc72e2116322959,
    __spreadArrays: $d7167ae03e108b0e$export$6388937ca91ccae8,
    __spreadArray: $d7167ae03e108b0e$export$1216008129fb82ed,
    __await: $d7167ae03e108b0e$export$10c90e4f7922046c,
    __asyncGenerator: $d7167ae03e108b0e$export$e427f37a30a4de9b,
    __asyncDelegator: $d7167ae03e108b0e$export$bbd80228419bb833,
    __asyncValues: $d7167ae03e108b0e$export$e3b29a3d6162315f,
    __makeTemplateObject: $d7167ae03e108b0e$export$4fb47efe1390b86f,
    __importStar: $d7167ae03e108b0e$export$c21735bcef00d192,
    __importDefault: $d7167ae03e108b0e$export$da59b14a69baef04,
    __classPrivateFieldGet: $d7167ae03e108b0e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d7167ae03e108b0e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d7167ae03e108b0e$export$81fdc39f203e4e04,
    __addDisposableResource: $d7167ae03e108b0e$export$88ac25d8e944e405,
    __disposeResources: $d7167ae03e108b0e$export$8f076105dc360e92
};


function $685fb41f75d10f60$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $021663a6134a8be0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $021663a6134a8be0$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $685fb41f75d10f60$export$2e2bcd8739ae039)(function(prop) {
    return $021663a6134a8be0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $aivMx = parcelRequire("aivMx");
var $a69eca18a69a3816$exports = {};
//
$a69eca18a69a3816$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $9839ee8e660104a4$export$71ad59f2e432cfe8 = "-ms-";
var $9839ee8e660104a4$export$2c0f367103c8d01c = "-moz-";
var $9839ee8e660104a4$export$39dfd62a25e0fe93 = "-webkit-";
var $9839ee8e660104a4$export$a29989082612d0d9 = "comm";
var $9839ee8e660104a4$export$aa3a2e812ca8570d = "rule";
var $9839ee8e660104a4$export$527d108ccf083c2b = "decl";
var $9839ee8e660104a4$export$d3d35020fa5b54f0 = "@page";
var $9839ee8e660104a4$export$500415a86c544f73 = "@media";
var $9839ee8e660104a4$export$a763edbf796b780a = "@import";
var $9839ee8e660104a4$export$2790aeb8b4e5c826 = "@charset";
var $9839ee8e660104a4$export$1cc683e23b84b133 = "@viewport";
var $9839ee8e660104a4$export$9447a5efea57e862 = "@supports";
var $9839ee8e660104a4$export$ef011b4e114b1fba = "@document";
var $9839ee8e660104a4$export$6aad947bda0f3f46 = "@namespace";
var $9839ee8e660104a4$export$b44a8529a35fcb60 = "@keyframes";
var $9839ee8e660104a4$export$2c16de31893252e6 = "@font-face";
var $9839ee8e660104a4$export$3d846dd52e150c6f = "@counter-style";
var $9839ee8e660104a4$export$22314bfbb57653fe = "@font-feature-values";
var $9839ee8e660104a4$export$d773506282b3cfe6 = "@layer";
var $9839ee8e660104a4$export$1c5a554c78c0cd12 = "@scope";
var $9839ee8e660104a4$export$2335f513bbd82c6d = Math.abs;
var $9839ee8e660104a4$export$6788812c4e6611e6 = String.fromCharCode;
var $9839ee8e660104a4$export$e6e34fd1f2686227 = Object.assign;
function $9839ee8e660104a4$export$d6af199866bfb566(e, r) {
    return $9839ee8e660104a4$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $9839ee8e660104a4$export$a9db5e087081082d(e, 0)) << 2 ^ $9839ee8e660104a4$export$a9db5e087081082d(e, 1)) << 2 ^ $9839ee8e660104a4$export$a9db5e087081082d(e, 2)) << 2 ^ $9839ee8e660104a4$export$a9db5e087081082d(e, 3) : 0;
}
function $9839ee8e660104a4$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $9839ee8e660104a4$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $9839ee8e660104a4$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $9839ee8e660104a4$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $9839ee8e660104a4$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $9839ee8e660104a4$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $9839ee8e660104a4$export$36776f635604f274(e) {
    return e.length;
}
function $9839ee8e660104a4$export$f9084667e487ed46(e) {
    return e.length;
}
function $9839ee8e660104a4$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $9839ee8e660104a4$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $9839ee8e660104a4$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$9839ee8e660104a4$export$4659b591c19bdf3d(e, r);
    });
}
var $9839ee8e660104a4$export$53f1d5ea8de3d7c = 1;
var $9839ee8e660104a4$export$4e0c71f277ca26b3 = 1;
var $9839ee8e660104a4$export$f24224f1c91d8156 = 0;
var $9839ee8e660104a4$export$5880b8b5730aff45 = 0;
var $9839ee8e660104a4$export$c0306caf338ac095 = 0;
var $9839ee8e660104a4$export$30a86d91af8ff6e6 = "";
function $9839ee8e660104a4$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $9839ee8e660104a4$export$53f1d5ea8de3d7c,
        column: $9839ee8e660104a4$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $9839ee8e660104a4$export$784d13d8ee351f07(e, r) {
    return $9839ee8e660104a4$export$e6e34fd1f2686227($9839ee8e660104a4$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $9839ee8e660104a4$export$590e8b2c435046d9(e) {
    while(e.root)e = $9839ee8e660104a4$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $9839ee8e660104a4$export$10d8903dec122b9d(e, e.siblings);
}
function $9839ee8e660104a4$export$eba6f6f03b0a92e7() {
    return $9839ee8e660104a4$export$c0306caf338ac095;
}
function $9839ee8e660104a4$export$232faf9add678146() {
    $9839ee8e660104a4$export$c0306caf338ac095 = $9839ee8e660104a4$export$5880b8b5730aff45 > 0 ? $9839ee8e660104a4$export$a9db5e087081082d($9839ee8e660104a4$export$30a86d91af8ff6e6, --$9839ee8e660104a4$export$5880b8b5730aff45) : 0;
    if ($9839ee8e660104a4$export$4e0c71f277ca26b3--, $9839ee8e660104a4$export$c0306caf338ac095 === 10) $9839ee8e660104a4$export$4e0c71f277ca26b3 = 1, $9839ee8e660104a4$export$53f1d5ea8de3d7c--;
    return $9839ee8e660104a4$export$c0306caf338ac095;
}
function $9839ee8e660104a4$export$48cfd1e771a65c4f() {
    $9839ee8e660104a4$export$c0306caf338ac095 = $9839ee8e660104a4$export$5880b8b5730aff45 < $9839ee8e660104a4$export$f24224f1c91d8156 ? $9839ee8e660104a4$export$a9db5e087081082d($9839ee8e660104a4$export$30a86d91af8ff6e6, $9839ee8e660104a4$export$5880b8b5730aff45++) : 0;
    if ($9839ee8e660104a4$export$4e0c71f277ca26b3++, $9839ee8e660104a4$export$c0306caf338ac095 === 10) $9839ee8e660104a4$export$4e0c71f277ca26b3 = 1, $9839ee8e660104a4$export$53f1d5ea8de3d7c++;
    return $9839ee8e660104a4$export$c0306caf338ac095;
}
function $9839ee8e660104a4$export$4d3fb11e950abb9e() {
    return $9839ee8e660104a4$export$a9db5e087081082d($9839ee8e660104a4$export$30a86d91af8ff6e6, $9839ee8e660104a4$export$5880b8b5730aff45);
}
function $9839ee8e660104a4$export$e88cb2efb12ae807() {
    return $9839ee8e660104a4$export$5880b8b5730aff45;
}
function $9839ee8e660104a4$export$58adb3bec8346d0f(e, r) {
    return $9839ee8e660104a4$export$2f35ab04d2335697($9839ee8e660104a4$export$30a86d91af8ff6e6, e, r);
}
function $9839ee8e660104a4$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $9839ee8e660104a4$export$2de70f21292aac9e(e) {
    return $9839ee8e660104a4$export$53f1d5ea8de3d7c = $9839ee8e660104a4$export$4e0c71f277ca26b3 = 1, $9839ee8e660104a4$export$f24224f1c91d8156 = $9839ee8e660104a4$export$36776f635604f274($9839ee8e660104a4$export$30a86d91af8ff6e6 = e), $9839ee8e660104a4$export$5880b8b5730aff45 = 0, [];
}
function $9839ee8e660104a4$export$45918ac1574455b1(e) {
    return $9839ee8e660104a4$export$30a86d91af8ff6e6 = "", e;
}
function $9839ee8e660104a4$export$410ac95b9ec204b8(e) {
    return $9839ee8e660104a4$export$87c2784dc9fc4ab($9839ee8e660104a4$export$58adb3bec8346d0f($9839ee8e660104a4$export$5880b8b5730aff45 - 1, $9839ee8e660104a4$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $9839ee8e660104a4$export$660b2ee2d4fb4eff(e) {
    return $9839ee8e660104a4$export$45918ac1574455b1($9839ee8e660104a4$export$5f8c09e3ae6f64e1($9839ee8e660104a4$export$2de70f21292aac9e(e)));
}
function $9839ee8e660104a4$export$7af1228ff777d175(e) {
    while($9839ee8e660104a4$export$c0306caf338ac095 = $9839ee8e660104a4$export$4d3fb11e950abb9e())if ($9839ee8e660104a4$export$c0306caf338ac095 < 33) $9839ee8e660104a4$export$48cfd1e771a65c4f();
    else break;
    return $9839ee8e660104a4$export$9e1725a4cfeada27(e) > 2 || $9839ee8e660104a4$export$9e1725a4cfeada27($9839ee8e660104a4$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $9839ee8e660104a4$export$5f8c09e3ae6f64e1(e) {
    while($9839ee8e660104a4$export$48cfd1e771a65c4f())switch($9839ee8e660104a4$export$9e1725a4cfeada27($9839ee8e660104a4$export$c0306caf338ac095)){
        case 0:
            $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$c2ab62c7bf24634($9839ee8e660104a4$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$410ac95b9ec204b8($9839ee8e660104a4$export$c0306caf338ac095), e);
            break;
        default:
            $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$6788812c4e6611e6($9839ee8e660104a4$export$c0306caf338ac095), e);
    }
    return e;
}
function $9839ee8e660104a4$export$955ba06d119e085e(e, r) {
    while(--r && $9839ee8e660104a4$export$48cfd1e771a65c4f())if ($9839ee8e660104a4$export$c0306caf338ac095 < 48 || $9839ee8e660104a4$export$c0306caf338ac095 > 102 || $9839ee8e660104a4$export$c0306caf338ac095 > 57 && $9839ee8e660104a4$export$c0306caf338ac095 < 65 || $9839ee8e660104a4$export$c0306caf338ac095 > 70 && $9839ee8e660104a4$export$c0306caf338ac095 < 97) break;
    return $9839ee8e660104a4$export$58adb3bec8346d0f(e, $9839ee8e660104a4$export$e88cb2efb12ae807() + (r < 6 && $9839ee8e660104a4$export$4d3fb11e950abb9e() == 32 && $9839ee8e660104a4$export$48cfd1e771a65c4f() == 32));
}
function $9839ee8e660104a4$export$c889f2fcc19dbf12(e) {
    while($9839ee8e660104a4$export$48cfd1e771a65c4f())switch($9839ee8e660104a4$export$c0306caf338ac095){
        case e:
            return $9839ee8e660104a4$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $9839ee8e660104a4$export$c889f2fcc19dbf12($9839ee8e660104a4$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $9839ee8e660104a4$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $9839ee8e660104a4$export$48cfd1e771a65c4f();
            break;
    }
    return $9839ee8e660104a4$export$5880b8b5730aff45;
}
function $9839ee8e660104a4$export$4254d4e2b3745c4c(e, r) {
    while($9839ee8e660104a4$export$48cfd1e771a65c4f())if (e + $9839ee8e660104a4$export$c0306caf338ac095 === 57) break;
    else if (e + $9839ee8e660104a4$export$c0306caf338ac095 === 84 && $9839ee8e660104a4$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $9839ee8e660104a4$export$58adb3bec8346d0f(r, $9839ee8e660104a4$export$5880b8b5730aff45 - 1) + "*" + $9839ee8e660104a4$export$6788812c4e6611e6(e === 47 ? e : $9839ee8e660104a4$export$48cfd1e771a65c4f());
}
function $9839ee8e660104a4$export$c2ab62c7bf24634(e) {
    while(!$9839ee8e660104a4$export$9e1725a4cfeada27($9839ee8e660104a4$export$4d3fb11e950abb9e()))$9839ee8e660104a4$export$48cfd1e771a65c4f();
    return $9839ee8e660104a4$export$58adb3bec8346d0f(e, $9839ee8e660104a4$export$5880b8b5730aff45);
}
function $9839ee8e660104a4$export$ef7acd7185315e22(e) {
    return $9839ee8e660104a4$export$45918ac1574455b1($9839ee8e660104a4$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $9839ee8e660104a4$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $9839ee8e660104a4$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $9839ee8e660104a4$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $9839ee8e660104a4$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($9839ee8e660104a4$export$f8e21b1e77979a08(z += $9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $9839ee8e660104a4$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $9839ee8e660104a4$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $9839ee8e660104a4$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $9839ee8e660104a4$export$955ba06d119e085e($9839ee8e660104a4$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($9839ee8e660104a4$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$4a34f930e789283c($9839ee8e660104a4$export$4254d4e2b3745c4c($9839ee8e660104a4$export$48cfd1e771a65c4f(), $9839ee8e660104a4$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $9839ee8e660104a4$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $9839ee8e660104a4$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $9839ee8e660104a4$export$36776f635604f274(z) - l) $9839ee8e660104a4$export$10d8903dec122b9d(p > 32 ? $9839ee8e660104a4$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $9839ee8e660104a4$export$f8483753829ec8f3($9839ee8e660104a4$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $9839ee8e660104a4$export$10d8903dec122b9d(j = $9839ee8e660104a4$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $9839ee8e660104a4$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $9839ee8e660104a4$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $9839ee8e660104a4$export$98e6a39c04603d36(e, j, j, n && $9839ee8e660104a4$export$10d8903dec122b9d($9839ee8e660104a4$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $9839ee8e660104a4$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $9839ee8e660104a4$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $9839ee8e660104a4$export$232faf9add678146() == 125) continue;
            }
            switch(z += $9839ee8e660104a4$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($9839ee8e660104a4$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($9839ee8e660104a4$export$4d3fb11e950abb9e() === 45) z += $9839ee8e660104a4$export$410ac95b9ec204b8($9839ee8e660104a4$export$48cfd1e771a65c4f());
                    v = $9839ee8e660104a4$export$4d3fb11e950abb9e(), o = l = $9839ee8e660104a4$export$36776f635604f274(k = z += $9839ee8e660104a4$export$c2ab62c7bf24634($9839ee8e660104a4$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $9839ee8e660104a4$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $9839ee8e660104a4$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $9839ee8e660104a4$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $9839ee8e660104a4$export$2f35ab04d2335697(e, p + 1, p = $9839ee8e660104a4$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $9839ee8e660104a4$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $9839ee8e660104a4$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $9839ee8e660104a4$export$35059013cd4a06db(e, r, a, s === 0 ? $9839ee8e660104a4$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $9839ee8e660104a4$export$4a34f930e789283c(e, r, a, c) {
    return $9839ee8e660104a4$export$35059013cd4a06db(e, r, a, $9839ee8e660104a4$export$a29989082612d0d9, $9839ee8e660104a4$export$6788812c4e6611e6($9839ee8e660104a4$export$eba6f6f03b0a92e7()), $9839ee8e660104a4$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $9839ee8e660104a4$export$f8483753829ec8f3(e, r, a, n, c) {
    return $9839ee8e660104a4$export$35059013cd4a06db(e, r, a, $9839ee8e660104a4$export$527d108ccf083c2b, $9839ee8e660104a4$export$2f35ab04d2335697(e, 0, n), $9839ee8e660104a4$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $9839ee8e660104a4$export$82e9f45cca5ba907(n, c, s) {
    switch($9839ee8e660104a4$export$d6af199866bfb566(n, c)){
        case 5103:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $9839ee8e660104a4$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$2c0f367103c8d01c + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($9839ee8e660104a4$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "box-$1$2" + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-item-" + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$9839ee8e660104a4$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $9839ee8e660104a4$export$71ad59f2e432cfe8 + "grid-row-" + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-line-pack" + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + "box-" + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "-grow", "") + $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $9839ee8e660104a4$export$39dfd62a25e0fe93 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "box-pack:$3" + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $9839ee8e660104a4$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$9839ee8e660104a4$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $9839ee8e660104a4$export$71ad59f2e432cfe8 + "grid-column-align" + $9839ee8e660104a4$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $9839ee8e660104a4$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$9839ee8e660104a4$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$9839ee8e660104a4$export$f8e21b1e77979a08(s, "span", 0) ? $9839ee8e660104a4$export$4659b591c19bdf3d(s, /\d+/) : +$9839ee8e660104a4$export$4659b591c19bdf3d(s, /\d+/) - +$9839ee8e660104a4$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $9839ee8e660104a4$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $9839ee8e660104a4$export$71ad59f2e432cfe8 + $9839ee8e660104a4$export$77ad94ebf1c2b9ed($9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($9839ee8e660104a4$export$36776f635604f274(n) - 1 - c > 6) switch($9839ee8e660104a4$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($9839ee8e660104a4$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $9839ee8e660104a4$export$2c0f367103c8d01c + ($9839ee8e660104a4$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$9839ee8e660104a4$export$f8e21b1e77979a08(n, "stretch", 0) ? $9839ee8e660104a4$export$82e9f45cca5ba907($9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $9839ee8e660104a4$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $9839ee8e660104a4$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($9839ee8e660104a4$export$a9db5e087081082d(n, c + 6) === 121) return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, ":", ":" + $9839ee8e660104a4$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($9839ee8e660104a4$export$a9db5e087081082d(n, $9839ee8e660104a4$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + ($9839ee8e660104a4$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $9839ee8e660104a4$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, ":", ":" + $9839ee8e660104a4$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $9839ee8e660104a4$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $9839ee8e660104a4$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $9839ee8e660104a4$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $9839ee8e660104a4$export$a763edbf796b780a:
        case $9839ee8e660104a4$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $9839ee8e660104a4$export$a29989082612d0d9:
            return "";
        case $9839ee8e660104a4$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $9839ee8e660104a4$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $9839ee8e660104a4$export$aa3a2e812ca8570d:
            if (!$9839ee8e660104a4$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $9839ee8e660104a4$export$36776f635604f274(a = $9839ee8e660104a4$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $9839ee8e660104a4$export$5a7767152ae0305f(e) {
    var r = $9839ee8e660104a4$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $9839ee8e660104a4$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $9839ee8e660104a4$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $9839ee8e660104a4$export$527d108ccf083c2b:
                n.return = $9839ee8e660104a4$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $9839ee8e660104a4$export$b44a8529a35fcb60:
                return $9839ee8e660104a4$export$dfdc1655ccc5b9cb([
                    $9839ee8e660104a4$export$784d13d8ee351f07(n, {
                        value: $9839ee8e660104a4$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $9839ee8e660104a4$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $9839ee8e660104a4$export$aa3a2e812ca8570d:
                if (n.length) return $9839ee8e660104a4$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($9839ee8e660104a4$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    $9839ee8e660104a4$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $9839ee8e660104a4$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $9839ee8e660104a4$export$e6e34fd1f2686227(n, {
                                props: $9839ee8e660104a4$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    $9839ee8e660104a4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $9839ee8e660104a4$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    $9839ee8e660104a4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $9839ee8e660104a4$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    $9839ee8e660104a4$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $9839ee8e660104a4$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $9839ee8e660104a4$export$590e8b2c435046d9($9839ee8e660104a4$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $9839ee8e660104a4$export$e6e34fd1f2686227(n, {
                                props: $9839ee8e660104a4$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $9839ee8e660104a4$export$76a88f7de6507443(e) {
    switch(e.type){
        case $9839ee8e660104a4$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $9839ee8e660104a4$export$1be1fc439b849fdf($9839ee8e660104a4$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($9839ee8e660104a4$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $9839ee8e660104a4$export$2f35ab04d2335697(r, 1, $9839ee8e660104a4$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $9839ee8e660104a4$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $9839ee8e660104a4$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $9839ee8e660104a4$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $4b34b39cb95ff80d$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $6e03950c2a9b6039$var$f = "data-styled", $6e03950c2a9b6039$var$m = "active", $6e03950c2a9b6039$var$y = "data-styled-version", $6e03950c2a9b6039$export$83d89fbfd8236492 = "6.1.17", $6e03950c2a9b6039$var$g = "/*!sc*/\n", $6e03950c2a9b6039$var$S = "undefined" != typeof window && "HTMLElement" in window, $6e03950c2a9b6039$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $6e03950c2a9b6039$var$b = {}, $6e03950c2a9b6039$var$E = /invalid hook call/i, $6e03950c2a9b6039$var$N = new Set, $6e03950c2a9b6039$var$P = function(t, n) {
    var o, s, i, a, e;
}, $6e03950c2a9b6039$var$_ = Object.freeze([]), $6e03950c2a9b6039$var$C = Object.freeze({});
function $6e03950c2a9b6039$var$I(e, t, n) {
    return void 0 === n && (n = $6e03950c2a9b6039$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $6e03950c2a9b6039$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $6e03950c2a9b6039$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $6e03950c2a9b6039$var$D = /(^-|-$)/g;
function $6e03950c2a9b6039$var$R(e) {
    return e.replace($6e03950c2a9b6039$var$O, "-").replace($6e03950c2a9b6039$var$D, "");
}
var $6e03950c2a9b6039$var$T = /(a)(d)/gi, $6e03950c2a9b6039$var$k = 52, $6e03950c2a9b6039$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $6e03950c2a9b6039$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $6e03950c2a9b6039$var$k; t = t / $6e03950c2a9b6039$var$k | 0)n = $6e03950c2a9b6039$var$j(t % $6e03950c2a9b6039$var$k) + n;
    return ($6e03950c2a9b6039$var$j(t % $6e03950c2a9b6039$var$k) + n).replace($6e03950c2a9b6039$var$T, "$1-$2");
}
var $6e03950c2a9b6039$var$V, $6e03950c2a9b6039$var$F = 5381, $6e03950c2a9b6039$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $6e03950c2a9b6039$var$z = function(e) {
    return $6e03950c2a9b6039$var$M($6e03950c2a9b6039$var$F, e);
};
function $6e03950c2a9b6039$var$$(e) {
    return $6e03950c2a9b6039$var$x($6e03950c2a9b6039$var$z(e) >>> 0);
}
function $6e03950c2a9b6039$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $6e03950c2a9b6039$var$L(e) {
    return "string" == typeof e && true;
}
var $6e03950c2a9b6039$var$G = "function" == typeof Symbol && Symbol.for, $6e03950c2a9b6039$var$Y = $6e03950c2a9b6039$var$G ? Symbol.for("react.memo") : 60115, $6e03950c2a9b6039$var$W = $6e03950c2a9b6039$var$G ? Symbol.for("react.forward_ref") : 60112, $6e03950c2a9b6039$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $6e03950c2a9b6039$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $6e03950c2a9b6039$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $6e03950c2a9b6039$var$J = (($6e03950c2a9b6039$var$V = {})[$6e03950c2a9b6039$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $6e03950c2a9b6039$var$V[$6e03950c2a9b6039$var$Y] = $6e03950c2a9b6039$var$U, $6e03950c2a9b6039$var$V);
function $6e03950c2a9b6039$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $6e03950c2a9b6039$var$Y ? $6e03950c2a9b6039$var$U : "$$typeof" in e ? $6e03950c2a9b6039$var$J[e.$$typeof] : $6e03950c2a9b6039$var$q;
}
var $6e03950c2a9b6039$var$Z = Object.defineProperty, $6e03950c2a9b6039$var$K = Object.getOwnPropertyNames, $6e03950c2a9b6039$var$Q = Object.getOwnPropertySymbols, $6e03950c2a9b6039$var$ee = Object.getOwnPropertyDescriptor, $6e03950c2a9b6039$var$te = Object.getPrototypeOf, $6e03950c2a9b6039$var$ne = Object.prototype;
function $6e03950c2a9b6039$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($6e03950c2a9b6039$var$ne) {
            var o = $6e03950c2a9b6039$var$te(t);
            o && o !== $6e03950c2a9b6039$var$ne && $6e03950c2a9b6039$var$oe(e, o, n);
        }
        var r = $6e03950c2a9b6039$var$K(t);
        $6e03950c2a9b6039$var$Q && (r = r.concat($6e03950c2a9b6039$var$Q(t)));
        for(var s = $6e03950c2a9b6039$var$X(e), i = $6e03950c2a9b6039$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $6e03950c2a9b6039$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $6e03950c2a9b6039$var$ee(t, c);
                try {
                    $6e03950c2a9b6039$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $6e03950c2a9b6039$var$re(e) {
    return "function" == typeof e;
}
function $6e03950c2a9b6039$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $6e03950c2a9b6039$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $6e03950c2a9b6039$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $6e03950c2a9b6039$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $6e03950c2a9b6039$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$6e03950c2a9b6039$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $6e03950c2a9b6039$var$le(e[o], t[o]);
    else if ($6e03950c2a9b6039$var$ce(t)) for(var o in t)e[o] = $6e03950c2a9b6039$var$le(e[o], t[o]);
    return e;
}
function $6e03950c2a9b6039$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $6e03950c2a9b6039$var$pe = {};
function $6e03950c2a9b6039$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $6e03950c2a9b6039$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $6e03950c2a9b6039$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $6e03950c2a9b6039$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($6e03950c2a9b6039$var$g);
        return t;
    }, e;
}(), $6e03950c2a9b6039$var$me = 1073741824, $6e03950c2a9b6039$var$ye = new Map, $6e03950c2a9b6039$var$ve = new Map, $6e03950c2a9b6039$var$ge = 1, $6e03950c2a9b6039$var$Se = function(e) {
    if ($6e03950c2a9b6039$var$ye.has(e)) return $6e03950c2a9b6039$var$ye.get(e);
    for(; $6e03950c2a9b6039$var$ve.has($6e03950c2a9b6039$var$ge);)$6e03950c2a9b6039$var$ge++;
    var t = $6e03950c2a9b6039$var$ge++;
    return $6e03950c2a9b6039$var$ye.set(e, t), $6e03950c2a9b6039$var$ve.set(t, e), t;
}, $6e03950c2a9b6039$var$we = function(e, t) {
    $6e03950c2a9b6039$var$ge = t + 1, $6e03950c2a9b6039$var$ye.set(e, t), $6e03950c2a9b6039$var$ve.set(t, e);
}, $6e03950c2a9b6039$var$be = "style[".concat($6e03950c2a9b6039$var$f, "][").concat($6e03950c2a9b6039$var$y, '="').concat($6e03950c2a9b6039$export$83d89fbfd8236492, '"]'), $6e03950c2a9b6039$var$Ee = new RegExp("^".concat($6e03950c2a9b6039$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $6e03950c2a9b6039$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $6e03950c2a9b6039$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($6e03950c2a9b6039$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($6e03950c2a9b6039$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($6e03950c2a9b6039$var$we(u, l), $6e03950c2a9b6039$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $6e03950c2a9b6039$var$_e = function(e) {
    for(var t = document.querySelectorAll($6e03950c2a9b6039$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($6e03950c2a9b6039$var$f) !== $6e03950c2a9b6039$var$m && ($6e03950c2a9b6039$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $6e03950c2a9b6039$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $6e03950c2a9b6039$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($6e03950c2a9b6039$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($6e03950c2a9b6039$var$f, $6e03950c2a9b6039$var$m), o.setAttribute($6e03950c2a9b6039$var$y, $6e03950c2a9b6039$export$83d89fbfd8236492);
    var i = $6e03950c2a9b6039$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $6e03950c2a9b6039$var$Ae = function() {
    function e(e) {
        this.element = $6e03950c2a9b6039$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $6e03950c2a9b6039$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $6e03950c2a9b6039$var$Oe = function() {
    function e(e) {
        this.element = $6e03950c2a9b6039$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $6e03950c2a9b6039$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $6e03950c2a9b6039$var$Re = $6e03950c2a9b6039$var$S, $6e03950c2a9b6039$var$Te = {
    isServer: !$6e03950c2a9b6039$var$S,
    useCSSOMInjection: !$6e03950c2a9b6039$var$w
}, $6e03950c2a9b6039$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $6e03950c2a9b6039$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $d7167ae03e108b0e$export$18ce0697a983be9b)((0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, $6e03950c2a9b6039$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $6e03950c2a9b6039$var$S && $6e03950c2a9b6039$var$Re && ($6e03950c2a9b6039$var$Re = !1, $6e03950c2a9b6039$var$_e(this)), $6e03950c2a9b6039$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $6e03950c2a9b6039$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($6e03950c2a9b6039$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($6e03950c2a9b6039$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $6e03950c2a9b6039$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $6e03950c2a9b6039$var$S && $6e03950c2a9b6039$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $d7167ae03e108b0e$export$18ce0697a983be9b)((0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $6e03950c2a9b6039$var$De(n) : t ? new $6e03950c2a9b6039$var$Ae(n) : new $6e03950c2a9b6039$var$Oe(n);
        }(this.options), new $6e03950c2a9b6039$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($6e03950c2a9b6039$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($6e03950c2a9b6039$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($6e03950c2a9b6039$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $6e03950c2a9b6039$var$je = /&/g, $6e03950c2a9b6039$var$xe = /^\s*\/\/.*$/gm;
function $6e03950c2a9b6039$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $6e03950c2a9b6039$var$Ve(e.children, t)), e;
    });
}
function $6e03950c2a9b6039$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $6e03950c2a9b6039$var$C : e, s = r.options, i = void 0 === s ? $6e03950c2a9b6039$var$C : s, a = r.plugins, c = void 0 === a ? $6e03950c2a9b6039$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $9839ee8e660104a4$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($6e03950c2a9b6039$var$je, n).replace(o, l));
    }), i.prefix && u.push($9839ee8e660104a4$export$e08c7d021b829b7a), u.push($9839ee8e660104a4$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($6e03950c2a9b6039$var$xe, ""), l = $9839ee8e660104a4$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $6e03950c2a9b6039$var$Ve(l, i.namespace));
        var p = [];
        return $9839ee8e660104a4$export$dfdc1655ccc5b9cb(l, $9839ee8e660104a4$export$5a7767152ae0305f(u.concat($9839ee8e660104a4$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $6e03950c2a9b6039$var$he(15), $6e03950c2a9b6039$var$M(e, t.name);
    }, $6e03950c2a9b6039$var$F).toString() : "", p;
}
var $6e03950c2a9b6039$var$Me = new $6e03950c2a9b6039$var$ke, $6e03950c2a9b6039$var$ze = $6e03950c2a9b6039$var$Fe(), $6e03950c2a9b6039$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $6e03950c2a9b6039$var$Me,
    stylis: $6e03950c2a9b6039$var$ze
}), $6e03950c2a9b6039$export$91317688fc694efa = $6e03950c2a9b6039$export$8c190ef828af4c86.Consumer, $6e03950c2a9b6039$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createContext(void 0);
function $6e03950c2a9b6039$var$Ge() {
    return (0, $aivMx.useContext)($6e03950c2a9b6039$export$8c190ef828af4c86);
}
function $6e03950c2a9b6039$export$a473771da2f0ff7c(e) {
    var t = (0, $aivMx.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $6e03950c2a9b6039$var$Ge().styleSheet, l = (0, $aivMx.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $aivMx.useMemo)(function() {
        return $6e03950c2a9b6039$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $aivMx.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($a69eca18a69a3816$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $aivMx.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($6e03950c2a9b6039$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($6e03950c2a9b6039$var$Le.Provider, {
        value: u
    }, e.children));
}
var $6e03950c2a9b6039$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $6e03950c2a9b6039$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $6e03950c2a9b6039$var$ue(this, function() {
            throw $6e03950c2a9b6039$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $6e03950c2a9b6039$var$ze), this.name + e.hash;
    }, e;
}(), $6e03950c2a9b6039$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $6e03950c2a9b6039$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $6e03950c2a9b6039$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $6e03950c2a9b6039$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $6e03950c2a9b6039$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$6e03950c2a9b6039$var$Ue(i) && (Array.isArray(i) && i.isCss || $6e03950c2a9b6039$var$re(i) ? r.push("".concat($6e03950c2a9b6039$var$He(s), ":"), i, ";") : $6e03950c2a9b6039$var$ce(i) ? r.push.apply(r, (0, $d7167ae03e108b0e$export$1216008129fb82ed)((0, $d7167ae03e108b0e$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $6e03950c2a9b6039$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($6e03950c2a9b6039$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $4b34b39cb95ff80d$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $6e03950c2a9b6039$var$Xe(e, t, n, o) {
    if ($6e03950c2a9b6039$var$Ue(e)) return [];
    if ($6e03950c2a9b6039$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($6e03950c2a9b6039$var$re(e)) {
        if (!$6e03950c2a9b6039$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $6e03950c2a9b6039$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $6e03950c2a9b6039$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $6e03950c2a9b6039$var$ce(e) ? $6e03950c2a9b6039$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($6e03950c2a9b6039$var$_, e.map(function(e) {
        return $6e03950c2a9b6039$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $6e03950c2a9b6039$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($6e03950c2a9b6039$var$re(n) && !$6e03950c2a9b6039$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $6e03950c2a9b6039$var$Ke = $6e03950c2a9b6039$var$z($6e03950c2a9b6039$export$83d89fbfd8236492), $6e03950c2a9b6039$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $6e03950c2a9b6039$var$Ze(e), this.componentId = t, this.baseHash = $6e03950c2a9b6039$var$M($6e03950c2a9b6039$var$Ke, t), this.baseStyle = n, $6e03950c2a9b6039$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $6e03950c2a9b6039$var$ie(o, this.staticRulesId);
            else {
                var r = $6e03950c2a9b6039$var$ae($6e03950c2a9b6039$var$Xe(this.rules, e, t, n)), s = $6e03950c2a9b6039$var$x($6e03950c2a9b6039$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $6e03950c2a9b6039$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $6e03950c2a9b6039$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $6e03950c2a9b6039$var$ae($6e03950c2a9b6039$var$Xe(u, e, t, n));
                    a = $6e03950c2a9b6039$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $6e03950c2a9b6039$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $6e03950c2a9b6039$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $6e03950c2a9b6039$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createContext(void 0), $6e03950c2a9b6039$export$b631efc24e9d5e2f = $6e03950c2a9b6039$export$2c657da244d00bd6.Consumer;
function $6e03950c2a9b6039$export$93d4e7f90805808f() {
    var e = (0, $aivMx.useContext)($6e03950c2a9b6039$export$2c657da244d00bd6);
    if (!e) throw $6e03950c2a9b6039$var$he(18);
    return e;
}
function $6e03950c2a9b6039$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext($6e03950c2a9b6039$export$2c657da244d00bd6), r = (0, $aivMx.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $6e03950c2a9b6039$var$he(14);
            if ($6e03950c2a9b6039$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $6e03950c2a9b6039$var$he(8);
            return n ? (0, $d7167ae03e108b0e$export$18ce0697a983be9b)((0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($6e03950c2a9b6039$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $6e03950c2a9b6039$var$rt = {}, $6e03950c2a9b6039$var$st = new Set;
function $6e03950c2a9b6039$var$it(e, r, s) {
    var i = $6e03950c2a9b6039$export$7ba318d8d2f06c76(e), a = e, c = !$6e03950c2a9b6039$var$L(e), p = r.attrs, d = void 0 === p ? $6e03950c2a9b6039$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $6e03950c2a9b6039$var$R(e);
        $6e03950c2a9b6039$var$rt[n] = ($6e03950c2a9b6039$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($6e03950c2a9b6039$var$$($6e03950c2a9b6039$export$83d89fbfd8236492 + n + $6e03950c2a9b6039$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $6e03950c2a9b6039$var$L(e) ? "styled.".concat(e) : "Styled(".concat($6e03950c2a9b6039$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($6e03950c2a9b6039$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $6e03950c2a9b6039$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext($6e03950c2a9b6039$export$2c657da244d00bd6), m = $6e03950c2a9b6039$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $6e03950c2a9b6039$var$I(r, f, c) || $6e03950c2a9b6039$var$C, g = function(e, n, o) {
                for(var r, s = (0, $d7167ae03e108b0e$export$18ce0697a983be9b)((0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $6e03950c2a9b6039$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $6e03950c2a9b6039$var$ie(s[c], a[c]) : "style" === c ? (0, $d7167ae03e108b0e$export$18ce0697a983be9b)((0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $6e03950c2a9b6039$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $6e03950c2a9b6039$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $6e03950c2a9b6039$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$6e03950c2a9b6039$var$L(S) && !$6e03950c2a9b6039$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $aivMx.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $6e03950c2a9b6039$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$6e03950c2a9b6039$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $6e03950c2a9b6039$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $6e03950c2a9b6039$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $6e03950c2a9b6039$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $6e03950c2a9b6039$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $6e03950c2a9b6039$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($6e03950c2a9b6039$var$re(t) || $6e03950c2a9b6039$var$ce(t)) return $6e03950c2a9b6039$var$ct($6e03950c2a9b6039$var$Xe($6e03950c2a9b6039$var$at($6e03950c2a9b6039$var$_, (0, $d7167ae03e108b0e$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $6e03950c2a9b6039$var$Xe(r) : $6e03950c2a9b6039$var$ct($6e03950c2a9b6039$var$Xe($6e03950c2a9b6039$var$at(r, n)));
}
function $6e03950c2a9b6039$var$ut(n, o, r) {
    if (void 0 === r && (r = $6e03950c2a9b6039$var$C), !o) throw $6e03950c2a9b6039$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $6e03950c2a9b6039$export$dbf350e5966cf602.apply(void 0, (0, $d7167ae03e108b0e$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $6e03950c2a9b6039$var$ut(n, o, (0, $d7167ae03e108b0e$export$18ce0697a983be9b)((0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $6e03950c2a9b6039$var$ut(n, o, (0, $d7167ae03e108b0e$export$18ce0697a983be9b)((0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $6e03950c2a9b6039$var$pt = function(e) {
    return $6e03950c2a9b6039$var$ut($6e03950c2a9b6039$var$it, e);
}, $6e03950c2a9b6039$export$2e2bcd8739ae039 = $6e03950c2a9b6039$var$pt;
$6e03950c2a9b6039$var$A.forEach(function(e) {
    $6e03950c2a9b6039$export$2e2bcd8739ae039[e] = $6e03950c2a9b6039$var$pt(e);
});
var $6e03950c2a9b6039$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $6e03950c2a9b6039$var$Ze(e), $6e03950c2a9b6039$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($6e03950c2a9b6039$var$ae($6e03950c2a9b6039$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $6e03950c2a9b6039$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $6e03950c2a9b6039$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $6e03950c2a9b6039$export$dbf350e5966cf602.apply(void 0, (0, $d7167ae03e108b0e$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($6e03950c2a9b6039$var$$(JSON.stringify(i))), c = new $6e03950c2a9b6039$var$ht(i, a);
    var l = function(e) {
        var t = $6e03950c2a9b6039$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext($6e03950c2a9b6039$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $6e03950c2a9b6039$var$b, o, s);
        else {
            var i = (0, $d7167ae03e108b0e$export$18ce0697a983be9b)((0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, n), {
                theme: $6e03950c2a9b6039$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).memo(l);
}
function $6e03950c2a9b6039$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $6e03950c2a9b6039$var$ae($6e03950c2a9b6039$export$dbf350e5966cf602.apply(void 0, (0, $d7167ae03e108b0e$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $6e03950c2a9b6039$var$$(r);
    return new $6e03950c2a9b6039$var$We(s, r);
}
function $6e03950c2a9b6039$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef(function(n, r) {
        var s = $6e03950c2a9b6039$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).useContext($6e03950c2a9b6039$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(e, (0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($6e03950c2a9b6039$var$B(e), ")"), $6e03950c2a9b6039$var$oe(n, e);
}
var $6e03950c2a9b6039$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $6e03950c2a9b6039$var$Ce(), o = $6e03950c2a9b6039$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($6e03950c2a9b6039$var$f, '="true"'),
                "".concat($6e03950c2a9b6039$var$y, '="').concat($6e03950c2a9b6039$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $6e03950c2a9b6039$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $6e03950c2a9b6039$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$6e03950c2a9b6039$var$f] = "", n[$6e03950c2a9b6039$var$y] = $6e03950c2a9b6039$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $6e03950c2a9b6039$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement("style", (0, $d7167ae03e108b0e$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $6e03950c2a9b6039$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $6e03950c2a9b6039$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($6e03950c2a9b6039$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $6e03950c2a9b6039$var$he(3);
    }, e;
}(), $6e03950c2a9b6039$export$5c87cfe6c475f500 = {
    StyleSheet: $6e03950c2a9b6039$var$ke,
    mainSheet: $6e03950c2a9b6039$var$Me
};
var $6e03950c2a9b6039$var$St = "__sc-".concat($6e03950c2a9b6039$var$f, "__");




var $94WEq = parcelRequire("94WEq");

var $bbNXs = parcelRequire("bbNXs");
/**
 * `background` is an ORDERED LAYER STACK, so a narrower scope must replace it
 * WHOLESALE rather than merge it slot-by-slot.
 *
 * lodash merges arrays index-by-index and never truncates, so a state that
 * defines FEWER layers than its base leaks the base's tail: base
 * `[image, colour]` + state `[red]` resolves to `[red, colour]`. It also merges
 * the layer OBJECTS key-by-key, so an image's `size`/`opacity` survive into a
 * colour that replaced it — and a stale `opacity: 0` then makes the replacement
 * invisible via the hide filter in `getBackgroundProperties`.
 *
 * This only bites where a state is applied by MERGING rather than by its own CSS
 * rule — i.e. the `active_state` path for `loading / success / error / disabled /
 * init`, which `blockList` in `styleHelper.ts` excludes from CSS emission.
 * `hover` / `click` / `focus` each get their own rule and are unaffected.
 *
 * Same hazard and same fix as the `replaceArrays` customizer in
 * `store/page/reducer.ts`; kept as a named helper so the nine components that
 * need it cannot drift apart.
 */ const $e284844083433a8c$var$replaceBackgroundArray = (_dstValue, srcValue, key)=>Array.isArray(srcValue) && key === 'background' ? [
        ...srcValue
    ] : undefined;
const $e284844083433a8c$export$3186d74a8b5f5ee8 = (object, ...sources)=>(0, (/*@__PURE__*/$parcel$interopDefault($bbNXs)))(object, ...sources, $e284844083433a8c$var$replaceBackgroundArray);
var $e284844083433a8c$export$2e2bcd8739ae039 = $e284844083433a8c$export$3186d74a8b5f5ee8;



parcelRequire("aivMx");


/* eslint-disable @typescript-eslint/naming-convention */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-restricted-syntax */ 

// Animation protocol — runtime side. Matches the fractal-fe editor's
// src/utils/animation.ts shape so the saved AnimationSettings produced by
// the AnimationPicker round-trip into framer-motion's `transition` object
// without translation at the renderer.
const $ae86b1db8cf5bdf9$export$d5d042b82187c4c4 = (a)=>{
    if (!a) return true;
    // TNBEWEB-1969 — a viewport-triggered entrance must never be treated as
    // identity (which would disable `hasEntrance` in useInitEntrance), even if
    // its duration is 0. Keep in lockstep with fractal-fe.
    if (a.viewport?.enabled) return false;
    if (!a.duration || a.duration <= 0) return true;
    return false;
};
const $ae86b1db8cf5bdf9$export$3e1473d01213a4a7 = (e)=>{
    if (typeof e === 'string') switch(e){
        case 'linear':
            return 'linear';
        case 'ease':
            return 'ease';
        case 'ease_in':
            return 'ease-in';
        case 'ease_out':
            return 'ease-out';
        case 'ease_in_out':
            return 'ease-in-out';
        // Both treated as bouncy cubic-beziers until the v2 spring runtime lands.
        case 'spring':
            return 'cubic-bezier(0.5, 1.8, 0.5, 0.85)';
        case 'bounce':
            return 'cubic-bezier(0.68, -0.55, 0.27, 1.55)';
        default:
            return 'ease-out';
    }
    if (e.type === 'cubic_bezier') {
        const [a, b] = e.points;
        // cubic-bezier requires the X control coords ∈ [0,1]; an out-of-range X
        // produces an illegal easing string that throws a synchronous TypeError
        // when applied as CSS / handed to Element.animate(). Defend here so a bad
        // persisted value can never crash the renderer. Y may overshoot, so only X
        // is clamped. NaN falls back to 0. (Mirrors the editor's TNBEWEB-1957 fix.)
        const clampX = (n)=>Number.isFinite(n) ? Math.max(0, Math.min(1, n)) : 0;
        const safeY = (n)=>Number.isFinite(n) ? n : 0;
        return `cubic-bezier(${clampX(a.x)}, ${safeY(a.y)}, ${clampX(b.x)}, ${safeY(b.y)})`;
    }
    if (e.type === 'spring') {
        // Fit spring(stiffness, damping, mass) to a cubic-bezier. Approximate
        // mapping: high stiffness + low damping → snappier, more overshoot.
        const stiffness = Math.max(1, e.stiffness);
        const damping = Math.max(0, e.damping);
        const ratio = damping / Math.sqrt(stiffness * (e.mass || 1) * 4);
        if (ratio >= 1) return 'cubic-bezier(0.4, 0, 0.2, 1)';
        if (ratio >= 0.7) return 'cubic-bezier(0.34, 1.2, 0.64, 1)';
        if (ratio >= 0.4) return 'cubic-bezier(0.34, 1.56, 0.64, 1)';
        return 'cubic-bezier(0.68, -0.55, 0.27, 1.55)';
    }
    return 'ease-out';
};
const $ae86b1db8cf5bdf9$export$61ea3fc207ed00a0 = (a)=>{
    const durationSec = (a.duration || 0) / 1000;
    const delaySec = (a.delay || 0) / 1000;
    if (typeof a.easing === 'string') switch(a.easing){
        case 'linear':
            return {
                duration: durationSec,
                delay: delaySec,
                ease: 'linear'
            };
        case 'ease':
            return {
                duration: durationSec,
                delay: delaySec,
                ease: [
                    0.25,
                    0.1,
                    0.25,
                    1
                ]
            };
        case 'ease_in':
            return {
                duration: durationSec,
                delay: delaySec,
                ease: 'easeIn'
            };
        case 'ease_out':
            return {
                duration: durationSec,
                delay: delaySec,
                ease: 'easeOut'
            };
        case 'ease_in_out':
            return {
                duration: durationSec,
                delay: delaySec,
                ease: 'easeInOut'
            };
        case 'spring':
            return {
                type: 'spring',
                stiffness: 300,
                damping: 24,
                mass: 1,
                delay: delaySec
            };
        case 'bounce':
            return {
                duration: durationSec,
                delay: delaySec,
                ease: [
                    0.68,
                    -0.55,
                    0.27,
                    1.55
                ]
            };
        default:
            return {
                duration: durationSec,
                delay: delaySec,
                ease: 'easeOut'
            };
    }
    if (a.easing.type === 'cubic_bezier') {
        const [p0, p1] = a.easing.points;
        return {
            duration: durationSec,
            delay: delaySec,
            ease: [
                p0.x,
                p0.y,
                p1.x,
                p1.y
            ]
        };
    }
    if (a.easing.type === 'spring') return {
        type: 'spring',
        stiffness: a.easing.stiffness,
        damping: a.easing.damping,
        mass: a.easing.mass || 1,
        delay: delaySec
    };
    return {
        duration: durationSec,
        delay: delaySec,
        ease: 'easeOut'
    };
};


// 'init' (TNBEWEB-1960) is the on-load entrance state — applied via the
// active_state merge during the first-mount entrance phase, NOT as a `&:init`
// pseudo-class (which would never match). Block it like the runtime states.
const $e0d24bf85c947bed$var$blockList = [
    'loading',
    'success',
    'error',
    'disabled',
    'init'
];
const $e0d24bf85c947bed$var$breakpointsOrder = [
    '2k',
    '4k',
    'laptopL',
    'laptop',
    'tablet',
    'mobileL',
    'mobileM',
    'mobileS'
];
const $e0d24bf85c947bed$var$getScrollbarWidth = (scroll)=>{
    switch(scroll?.type){
        case 'hidden':
        case 'visible':
        case 'auto':
        case 'scroll':
            return 'auto';
        case 'none':
        case 'transparent':
            return 'none';
        default:
            return undefined;
    }
};
function $e0d24bf85c947bed$var$getOverflow(scroll, font, display, flex) {
    const scrollType = scroll?.type === 'transparent' ? 'none' : scroll?.type;
    if (font?.text_overflow === 'ellipsis' && !scrollType) return {
        overflow: 'hidden'
    };
    else if (!scrollType) return {};
    const overflow = scroll?.direction === 'both' ? scrollType === 'none' ? 'auto' : scrollType || 'auto' : font?.text_overflow === 'ellipsis' ? 'hidden' : undefined;
    const overflowX = scroll?.direction === 'x' || scroll?.direction === 'both' ? scrollType || 'auto' : display === 'grid' ? 'hidden' : flex?.direction === 'row' ? scrollType === 'none' ? 'auto' : scrollType || 'hidden' : 'hidden';
    const overflowY = scroll?.direction === 'y' || scroll?.direction === 'both' ? scrollType || 'auto' : display === 'grid' ? scrollType === 'none' ? 'auto' : scrollType || 'hidden' : flex?.direction === 'column' ? scrollType === 'none' ? 'auto' : scrollType || 'hidden' : 'hidden';
    return {
        overflow: overflow,
        overflowX: overflowX,
        overflowY: overflowY,
        overscrollBehavior: 'contain'
    };
}
function $e0d24bf85c947bed$var$getBackgroundImage(input) {
    if ((0, $7b0e169a5380005e$export$d673a9445babfbef)(input)) // If the input is a valid SVG, use it as a data URL
    return `url("data:image/svg+xml,${encodeURIComponent(input)}")`;
    else // If the input is not a valid SVG, assume it's a URL to an image
    return `url("${input}")`;
}
// Helper type guards
const $e0d24bf85c947bed$var$isBorderDirectional = (width)=>{
    return width?.type && [
        'top',
        'right',
        'bottom',
        'left'
    ].includes(width.type);
};
const $e0d24bf85c947bed$var$isBorderCustom = (width)=>{
    return width?.type === 'custom' && Array.isArray(width.value);
};
const $e0d24bf85c947bed$var$normalizeStyleValue = (value)=>{
    if (value === null || value === undefined || value === '') return value;
    if (typeof value === 'number') return `${value}px`;
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (/^-?\d*\.?\d+$/.test(trimmed)) return `${trimmed}px`;
    }
    return value;
};
const $e0d24bf85c947bed$var$generateGapStyles = (flex)=>{
    if (!flex?.gap) return {};
    // Handle single number or string value
    if (typeof flex.gap === 'number') return {
        gap: `${flex.gap}px`
    };
    if (typeof flex.gap === 'string') {
        // Split by space or comma and trim whitespace
        const values = flex.gap.split(/[\s,]+/).filter(Boolean).map((val)=>val.trim());
        // Process each value to ensure proper format
        const processedValues = values.map((val)=>{
            // If it's a pure number
            if (/^\d+$/.test(val)) return `${val}px`;
            // If it already has units (px, em, rem, etc.)
            if (/^\d+(?:px|em|rem|vh|vw|%)$/.test(val)) return val;
            // Invalid format
            return val;
        });
        // Return formatted gap value based on number of values
        if (processedValues.length === 1) return {
            gap: processedValues[0]
        };
        if (processedValues.length === 2) return {
            gap: processedValues.join(' ')
        };
        // If more than 2 values, only use the first two
        return {
            gap: `${processedValues[0]} ${processedValues[1]}`
        };
    }
    return {};
};
// Modified border width generation
const $e0d24bf85c947bed$var$generateBorderWidth = (border)=>{
    if (!border?.width) return {};
    if (typeof border.width === 'string' || typeof border.width === 'number') return {
        borderWidth: $e0d24bf85c947bed$var$normalizeStyleValue(border.width)
    };
    if (border.width === null) return {
        borderWidth: 0
    };
    if ($e0d24bf85c947bed$var$isBorderDirectional(border.width)) {
        const { type: type, value: value } = border.width;
        return {
            borderWidth: 0,
            [`border${type?.charAt(0).toUpperCase()}${type?.slice(1)}Width`]: $e0d24bf85c947bed$var$normalizeStyleValue(value)
        };
    }
    if ($e0d24bf85c947bed$var$isBorderCustom(border.width)) return {
        borderTopWidth: $e0d24bf85c947bed$var$normalizeStyleValue(border.width.value[0]),
        borderRightWidth: $e0d24bf85c947bed$var$normalizeStyleValue(border.width.value[1]),
        borderBottomWidth: $e0d24bf85c947bed$var$normalizeStyleValue(border.width.value[2]),
        borderLeftWidth: $e0d24bf85c947bed$var$normalizeStyleValue(border.width.value[3])
    };
    return {};
};
const $e0d24bf85c947bed$var$generateBorderRadius = (border)=>{
    if (!border?.radius) return {};
    if (typeof border.radius === 'string' || typeof border.radius === 'number') return {
        borderRadius: $e0d24bf85c947bed$var$normalizeStyleValue(border.radius)
    };
    if (border.radius === null) return {
        borderRadius: 0
    };
    if ($e0d24bf85c947bed$var$isBorderCustom(border.radius)) return {
        borderTopLeftRadius: $e0d24bf85c947bed$var$normalizeStyleValue(border.radius.value[0]),
        borderTopRightRadius: $e0d24bf85c947bed$var$normalizeStyleValue(border.radius.value[1]),
        borderBottomRightRadius: $e0d24bf85c947bed$var$normalizeStyleValue(border.radius.value[2]),
        borderBottomLeftRadius: $e0d24bf85c947bed$var$normalizeStyleValue(border.radius.value[3])
    };
    return {};
};
const $e0d24bf85c947bed$var$parseBackgroundSize = (url)=>{
    try {
        const baseUrl = window.location.origin; // Base URL for relative URLs
        const urlObj = new URL(url, baseUrl);
        const backgroundSize = urlObj.searchParams.get('backgroundSize');
        const rotateRaw = urlObj.searchParams.get('rotate');
        if (backgroundSize !== null) urlObj.searchParams.delete('backgroundSize');
        if (rotateRaw !== null) urlObj.searchParams.delete('rotate');
        const resultUrl = url.startsWith('http') ? urlObj.toString() : urlObj.pathname + urlObj.search;
        const rotate = rotateRaw !== null && !Number.isNaN(Number(rotateRaw)) ? Number(rotateRaw) : null;
        return {
            url: resultUrl,
            backgroundSize: backgroundSize,
            rotate: rotate
        };
    } catch (e) {
        return {
            url: url,
            backgroundSize: null,
            rotate: null
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e0d24bf85c947bed$var$filterUndefinedProperties = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredObj = {}; // Add index signature
    const validNumberRegex = /^-?\d+(\.\d+)?$/; // Regular expression to match valid numbers
    for(const key in obj)if (obj[key] !== undefined) {
        let value = obj[key];
        if (typeof value === 'string' && validNumberRegex.test(value)) value = parseFloat(value);
        filteredObj[key] = (0, $7b0e169a5380005e$export$aeecb75b7111fef7)(value);
    }
    return filteredObj;
};
// Multiply a gradient layer's global opacity into every stop's alpha (non-destructive to the
// stored stops; CSS `background-image` has no per-layer opacity slot). Picker-emitted stops are
// always rgba; rgb stops are treated as alpha 1; non-rgb tokens (rare) are left untouched.
const $e0d24bf85c947bed$var$applyGradientOpacity = (gradient, opacity)=>{
    if (opacity == null || opacity >= 1) return gradient;
    const k = Math.max(0, Math.min(1, opacity));
    return gradient.replace(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+)\s*)?\)/gi, (_m, r, g, b, a)=>`rgba(${r}, ${g}, ${b}, ${+((a === undefined ? 1 : parseFloat(a)) * k).toFixed(3)})`);
};
/**
 * TNBEWEB-1869 — every exit path must emit the SAME key set.
 *
 * States are emitted as their own CSS rules (`&:hover`, …), so a property this
 * function omits is simply not declared and the BASE rule keeps applying. When
 * a state overrode an image with a single colour it used to emit only
 * `background-color`, never clearing `background-image` — and `background-image`
 * paints ABOVE `background-color`, so the base image stayed visible on top of
 * the new colour. The reverse swap left the old colour bleeding through a
 * transparent PNG.
 *
 * `undefined` cannot fix that: `filterUndefinedProperties` DELETES those keys.
 * The cleared value has to be a real CSS one — `none` / `transparent`.
 */ const $e0d24bf85c947bed$var$CLEARED_BACKGROUND = {
    backgroundColor: 'transparent',
    backgroundImage: 'none',
    backgroundPosition: undefined,
    backgroundSize: undefined,
    backgroundRepeat: undefined
};
function $e0d24bf85c947bed$var$getBackgroundProperties(shapes) {
    // ABSENT `background` means "inherit" — emit nothing at all so the broader
    // scope's rule survives. This is what makes Fill inheritance work, and it is
    // deliberately NOT the same as an empty array below.
    if (shapes == null || !Array.isArray(shapes)) return {};
    // An EMPTY array is an explicit "this scope has no fill", so it must clear.
    if (shapes.length === 0) return {
        ...$e0d24bf85c947bed$var$CLEARED_BACKGROUND
    };
    const backgroundImages = [];
    const backgroundPositions = [];
    const backgroundSizes = [];
    const backgroundRepeats = [];
    const isSingleColor = shapes.length === 1 && shapes[0].type === 'color';
    if (isSingleColor) return {
        ...$e0d24bf85c947bed$var$CLEARED_BACKGROUND,
        backgroundColor: shapes[0].value
    };
    shapes.filter((el)=>!((el.type === 'image' || el.type === 'gradient') && el.opacity === 0)).forEach((shape)=>{
        if (shape.value?.startsWith('linear-gradient') || shape.value?.startsWith('radial-gradient')) {
            backgroundImages.push($e0d24bf85c947bed$var$applyGradientOpacity(shape.value, shape.opacity));
            backgroundPositions.push('center');
            backgroundSizes.push('cover');
            backgroundRepeats.push('no-repeat');
        } else if (shape.value?.startsWith('http') || shape.value?.startsWith('/')) {
            backgroundImages.push(`url(${$e0d24bf85c947bed$var$parseBackgroundSize(shape.value).url})`);
            backgroundPositions.push('center');
            backgroundSizes.push($e0d24bf85c947bed$var$parseBackgroundSize(shape.value).backgroundSize || 'contain');
            backgroundRepeats.push('no-repeat');
        } else {
            const gradientValue = `linear-gradient(${shape.value}, ${shape.value})`;
            backgroundImages.push(gradientValue);
            backgroundPositions.push('center');
            backgroundSizes.push('cover');
            backgroundRepeats.push('no-repeat');
        }
    });
    const hasImages = backgroundImages.length > 0;
    // Still spread the cleared defaults: a multi-layer stack composes everything
    // into `background-image`, so it must explicitly reset the `background-color`
    // a broader scope's single-colour rule may have set.
    return {
        ...$e0d24bf85c947bed$var$CLEARED_BACKGROUND,
        backgroundImage: hasImages ? backgroundImages.reverse().join(', ') : 'none',
        backgroundPosition: hasImages ? backgroundPositions.reverse().join(', ') : undefined,
        backgroundSize: hasImages ? backgroundSizes.reverse().join(', ') : undefined,
        backgroundRepeat: hasImages ? backgroundRepeats.reverse().join(', ') : undefined
    };
}
const $e0d24bf85c947bed$var$generateComponentStyles = (style, baseWidth, skipStates, parent_display, parentVisibility, parent_flex_direction)=>{
    if (!style) return null;
    const { font: font, align: align, height: height, width: width, max_width: max_width, min_width: min_width, max_height: max_height, min_height: min_height, margin: margin, padding: padding, grid: grid, border: border, position: position, z_index: z_index, user_select: user_select, scroll: scroll, cursor: cursor, breakpoints: breakpoints, states: states, display: display, flex: flex, box: box, background: background, aspect_ratio: aspect_ratio, left: left, bottom: bottom, top: top, right: right, object: object, transform: transform, transform_origin: transform_origin, backface_visibility: backface_visibility, transform_style: transform_style, placeholder: placeholder, opacity: opacity, visibility: visibilityParam, animation: animation } = style;
    const isFlexObject = flex && typeof flex !== 'string';
    const isBorderObject = border && typeof border !== 'string';
    // const backgroundShape = background?.[background.length - 1];
    const isFillWidth = width === 'fill';
    const isFillHeight = height === 'fill';
    const parentIsFlex = parent_display === 'flex';
    const parentDirIsColumn = parent_flex_direction === 'column' || parent_flex_direction === 'column-reverse';
    const widthIsMainAxisFill = isFillWidth && parentIsFlex && !parentDirIsColumn;
    const heightIsMainAxisFill = isFillHeight && parentIsFlex && parentDirIsColumn;
    const widthIsCrossAxisFill = isFillWidth && parentIsFlex && parentDirIsColumn;
    const heightIsCrossAxisFill = isFillHeight && parentIsFlex && !parentDirIsColumn;
    // Flex main axis -> flex-grow; cross axis -> 100%; grid/block/unknown -> no-op (already fills naturally)
    const resolvedWidth = isFillWidth ? widthIsCrossAxisFill ? '100%' : undefined : width;
    const resolvedHeight = isFillHeight ? heightIsCrossAxisFill ? '100%' : undefined : height;
    const fillNeedsFlexGrow = widthIsMainAxisFill || heightIsMainAxisFill;
    const explicitFlexGrow = isFlexObject ? flex?.grow : undefined;
    const effectiveFlexGrow = explicitFlexGrow !== undefined ? explicitFlexGrow : fillNeedsFlexGrow ? 1 : undefined;
    const placeholderStyles = $e0d24bf85c947bed$var$filterUndefinedProperties({
        fontWeight: placeholder?.weight,
        fontStyle: placeholder?.style,
        fontSize: $e0d24bf85c947bed$var$normalizeStyleValue(placeholder?.size),
        color: placeholder?.color,
        fontFamily: placeholder?.family,
        lineHeight: $e0d24bf85c947bed$var$normalizeStyleValue(placeholder?.height),
        letterSpacing: $e0d24bf85c947bed$var$normalizeStyleValue(placeholder?.letter_spacing),
        textDecoration: placeholder?.decoration,
        textTransform: placeholder?.transform
    });
    const componentStyles = $e0d24bf85c947bed$var$filterUndefinedProperties({
        textOverflow: font?.text_overflow,
        textTransform: font?.transform,
        whiteSpace: font?.text_overflow === 'ellipsis' ? 'nowrap' : font?.text_wrap === 'wrap' ? 'normal' : 'nowrap',
        fontSize: $e0d24bf85c947bed$var$normalizeStyleValue(font?.size),
        fontWeight: font?.weight,
        lineHeight: $e0d24bf85c947bed$var$normalizeStyleValue(font?.height),
        letterSpacing: $e0d24bf85c947bed$var$normalizeStyleValue(font?.letter_spacing),
        color: font?.color,
        fontFamily: font?.family,
        fontStyle: font?.style,
        textDecoration: font?.decoration,
        textAlign: align?.horizontal,
        verticalAlign: align?.vertical,
        gridAutoFlow: grid?.auto?.flow,
        gridAutoColumns: grid?.auto?.columns,
        gridAutoRows: grid?.auto?.rows,
        // A `display: grid` text element has a single implicit `auto` column, which
        // sizes to the text's one-line max-content and overflows the box instead of
        // wrapping. When wrap is enabled, cap the column at the container so
        // `white-space: normal` has a finite width to wrap into. Gated on text_wrap
        // so default (overflow) and ellipsis behavior are untouched.
        gridTemplateColumns: font?.text_wrap === 'wrap' && display === 'grid' ? 'minmax(0, 1fr)' : undefined,
        height: $e0d24bf85c947bed$var$normalizeStyleValue(resolvedHeight),
        width: $e0d24bf85c947bed$var$normalizeStyleValue(resolvedWidth),
        aspectRatio: aspect_ratio,
        maxWidth: $e0d24bf85c947bed$var$normalizeStyleValue(max_width || (typeof flex?.basis === 'number' && resolvedWidth ? resolvedWidth : undefined)),
        minWidth: $e0d24bf85c947bed$var$normalizeStyleValue(min_width || (typeof flex?.basis === 'number' && resolvedWidth ? resolvedWidth : undefined)),
        maxHeight: $e0d24bf85c947bed$var$normalizeStyleValue(max_height),
        minHeight: $e0d24bf85c947bed$var$normalizeStyleValue(min_height),
        ...(0, $7b0e169a5380005e$export$f86e83e7d412cd5e)(margin),
        ...(0, $7b0e169a5380005e$export$d7647e01dea1340)(padding),
        display: (visibilityParam || parentVisibility) && (visibilityParam === 'hidden' || parentVisibility === 'hidden') ? 'none' : parentVisibility && parentVisibility === 'visible' ? parent_display : visibilityParam && visibilityParam === 'visible' ? display : display,
        alignItems: grid?.align_items || (isFlexObject ? flex.align_items : undefined),
        alignContent: isFlexObject ? flex.align_items : undefined,
        cursor: cursor,
        gridColumnStart: grid?.x ? `${grid.x}` : undefined,
        gridColumnEnd: grid?.cols ? `span ${grid?.cols}` : undefined,
        gridRowStart: grid?.y ? `${grid.y}` : undefined,
        gridRowEnd: grid?.rows ? `span ${grid?.rows}` : undefined,
        justifyItems: grid?.justify_items,
        justifyContent: grid?.justify_content || (isFlexObject ? flex.justify_content : undefined),
        ...$e0d24bf85c947bed$var$getBackgroundProperties(background),
        flexDirection: isFlexObject ? flex?.direction : undefined,
        flexShrink: isFlexObject ? flex?.shrink : undefined,
        flexGrow: effectiveFlexGrow,
        flexBasis: effectiveFlexGrow && effectiveFlexGrow !== '0' && effectiveFlexGrow !== 0 ? 0 : 'auto',
        flexWrap: isFlexObject ? flex?.wrap : undefined,
        ...$e0d24bf85c947bed$var$generateGapStyles(flex),
        // Modified
        ...isBorderObject ? $e0d24bf85c947bed$var$generateBorderWidth(border) : {},
        ...isBorderObject ? $e0d24bf85c947bed$var$generateBorderRadius(border) : {},
        borderStyle: isBorderObject ? border?.style : undefined,
        borderColor: isBorderObject ? border?.color : undefined,
        border: !isBorderObject ? border : undefined,
        position: position ? `${position} !important` : undefined,
        zIndex: z_index,
        ...$e0d24bf85c947bed$var$getOverflow(scroll, font, display, flex),
        scrollSnapType: scroll?.snap ? 'both mandatory' : undefined,
        boxShadow: box?.shadow ? box?.shadow : undefined,
        boxSizing: box?.sizing ? box?.sizing : 'border-box',
        objectFit: object?.fit,
        objectPosition: object?.position,
        userSelect: user_select,
        left: $e0d24bf85c947bed$var$normalizeStyleValue(left),
        bottom: $e0d24bf85c947bed$var$normalizeStyleValue(bottom),
        top: $e0d24bf85c947bed$var$normalizeStyleValue(top),
        right: $e0d24bf85c947bed$var$normalizeStyleValue(right),
        transform: transform,
        transformOrigin: transform_origin,
        backfaceVisibility: backface_visibility,
        transformStyle: transform_style,
        opacity: opacity,
        scrollbarWidth: $e0d24bf85c947bed$var$getScrollbarWidth(scroll)
    });
    // Express the protocol `animation` block as a CSS `transition` on the base
    // rule so state changes (:hover/:active emitted below as pseudo-classes)
    // animate over the protocol's duration/easing instead of snapping. A base-rule
    // transition drives BOTH enter and leave of a pseudo-state, and does not fire
    // on first paint. Because this function recurses for `states` and
    // `breakpoints`, a per-state/per-breakpoint `animation` override emits its own
    // transition inside that nested rule.
    if (animation && !(0, $ae86b1db8cf5bdf9$export$d5d042b82187c4c4)(animation)) componentStyles.transition = `all ${animation.duration}ms ${(0, $ae86b1db8cf5bdf9$export$3e1473d01213a4a7)(animation.easing)} ${animation.delay}ms`;
    if (breakpoints) {
        const visibilityMap = {};
        const displayMap = {};
        Object.entries(breakpoints).forEach(([breakpoint, styles])=>{
            const visibility = styles.visibility;
            const display = styles.display;
            if (visibility) visibilityMap[breakpoint] = visibility;
            if (display) displayMap[breakpoint] = display;
        });
        // Order breakpoints by their resolved pixel width (widest first). Custom
        // resolution ids resolve to their persisted width via getSizesBasedOnScreen,
        // so they participate in this order; the old hardcoded `breakpointsOrder`
        // (preset names only) gave custom ids indexOf === -1 and excluded them from
        // the visibility/display inheritance cascade. The preset order is kept only
        // as a deterministic tiebreaker when two keys resolve to the same width.
        const widthOf = (key)=>(0, $7b0e169a5380005e$export$e58d7eefdadeb732)(key);
        const orderedKeys = Object.keys(breakpoints).sort((a, b)=>{
            const byWidth = widthOf(b) - widthOf(a);
            if (byWidth !== 0) return byWidth;
            return $e0d24bf85c947bed$var$breakpointsOrder.indexOf(a) - $e0d24bf85c947bed$var$breakpointsOrder.indexOf(b);
        });
        orderedKeys.forEach((breakpoint)=>{
            const styles = breakpoints[breakpoint];
            const baseWidthForBreakpoint = widthOf(breakpoint);
            const bpIndex = orderedKeys.indexOf(breakpoint);
            // Inherit visibility/display from the nearest explicitly-set breakpoint,
            // walking from this breakpoint toward the base resolution width. The base
            // width is the pivot (was hardcoded to laptopL, which broke any screen
            // whose base resolution wasn't laptopL).
            let inheritedVisibility = visibilityParam;
            let inheritedDisplay = parent_display;
            const pivot = baseWidth ?? baseWidthForBreakpoint;
            if (baseWidthForBreakpoint >= pivot) // Wider than (or equal to) base: walk down toward the base width.
            for(let i = bpIndex; i < orderedKeys.length; i++){
                if (widthOf(orderedKeys[i]) < pivot) break;
                if (visibilityMap[orderedKeys[i]]) {
                    inheritedVisibility = visibilityMap[orderedKeys[i]];
                    inheritedDisplay = displayMap[orderedKeys[i]] || inheritedDisplay;
                    break;
                }
            }
            else // Narrower than base: walk up toward the base width.
            for(let i = bpIndex; i >= 0; i--){
                if (widthOf(orderedKeys[i]) > pivot) break;
                if (visibilityMap[orderedKeys[i]]) {
                    inheritedVisibility = visibilityMap[orderedKeys[i]];
                    inheritedDisplay = displayMap[orderedKeys[i]] || inheritedDisplay;
                    break;
                }
            }
            const generatedStyles = $e0d24bf85c947bed$var$generateComponentStyles(styles, undefined, skipStates, inheritedDisplay, inheritedVisibility, parent_flex_direction); // Call only once per valid breakpoint
            // Resolve the base width. When the screen has no `base_screen_resolution`
            // set, `baseWidth` arrives undefined; every comparison below would then be
            // false (`1440 > undefined` etc.) and the ENTIRE breakpoint would be
            // dropped — silently discarding whatever was configured on that view
            // (geometry AND visibility). With no explicit base, treat the top-level
            // style as the widest/default layer and every breakpoint as a max-width
            // override that applies AT-AND-BELOW its own width. Defaulting the base to
            // +Infinity makes e.g. laptopL(1440) emit as `@media (max-width: 1440px)`:
            // it applies at ≤1440 (the device viewport) while the base style still
            // governs wider viewports. Defaulting to 1440 instead made the breakpoint
            // unwrapped (always-on) and leaked it ABOVE 1440, overriding the base's
            // hidden/large-screen styling.
            const effectiveBaseWidth = baseWidth ?? Number.POSITIVE_INFINITY;
            if (baseWidthForBreakpoint === effectiveBaseWidth) // Breakpoint width equals an EXPLICIT base width: these ARE the base
            // styles, so emit them unwrapped (no @media). Previously this case matched
            // neither `>` nor `<` and produced NO CSS — the element rendered
            // class-less/invisible at the device viewport. (Unreachable when base is
            // the +Infinity default, by design — those go to the max-width branch.)
            Object.assign(componentStyles, generatedStyles);
            else if (baseWidthForBreakpoint > effectiveBaseWidth) componentStyles[`@media (min-width: ${baseWidthForBreakpoint}px)`] = generatedStyles;
            else if (baseWidthForBreakpoint < effectiveBaseWidth) componentStyles[`@media (max-width: ${baseWidthForBreakpoint}px)`] = generatedStyles;
        });
    }
    if (states && !skipStates) Object.keys(states).filter((st)=>!$e0d24bf85c947bed$var$blockList.includes(st)).forEach((state)=>{
        const modifiedState = state === 'focus-within' ? 'focusWithin' : state === 'click' ? 'active' : state;
        // `click`→`:active` is emitted with a doubled `&&` parent selector so its
        // specificity (`.cls.cls:active`) strictly exceeds `&:hover`/`&:focus`
        // (`.cls:hover`). This gives `click` an EXPLICIT priority over `hover`
        // that does NOT depend on the order `states` keys are emitted / the
        // browser cascade: while the pointer is held down over a hovered
        // component, the click style wins over hover (TNBEWEB-1970, UC-1).
        // Releasing the pointer drops `:active` and the component falls back to
        // `:hover`; with no `click` state nothing changes (UC-4, no regression).
        const ampersand = state === 'click' ? '&&' : '&';
        const stateStyles = {
            ...$e0d24bf85c947bed$var$generateComponentStyles(states[state], undefined, true, display, undefined, parent_flex_direction)
        };
        // TNBEWEB-1980: a bare CSS `:hover` rule fires on a finger tap (and sticks
        // until the next outclick) on touch devices. Gate the `hover` state behind
        // `@media (hover: hover)` so it only applies where a hover-capable pointer
        // exists. Other states (focus/active/click) are unaffected — `click`→`:active`
        // keeps its doubled-`&&` specificity priority over hover (TNBEWEB-1970).
        if (state === 'hover') componentStyles['@media (hover: hover)'] = {
            ...componentStyles['@media (hover: hover)'] || {},
            [`${ampersand}:${modifiedState}`]: stateStyles
        };
        else componentStyles[`${ampersand}:${modifiedState}`] = stateStyles;
    });
    if (placeholder) componentStyles['&::placeholder'] = placeholderStyles;
    return componentStyles;
};
var $e0d24bf85c947bed$export$2e2bcd8739ae039 = $e0d24bf85c947bed$var$generateComponentStyles;


var $ceebea49d17ac2e7$export$34e0f9847d4c02dd;
$ceebea49d17ac2e7$export$34e0f9847d4c02dd = `bd8sfG_container`;


const $823fa51ea581843c$var$StyledContainer = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
    position: relative;
    visibility: visible;
    pointer-events: none;
  ${(props)=>props.$nested && `
    position: absolute;
    z-index: 99999999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  `}
`;
const $823fa51ea581843c$var$ContainerSkeleton = ({ style: style, skipStates: skipStates, baseScreenResolution: baseScreenResolution, nested: nested, parentStyle: parentStyle })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($823fa51ea581843c$var$StyledContainer, {
        $shape: {
            display: style.display,
            grid: style.grid,
            flex: style.flex,
            width: nested ? undefined : style.width,
            height: nested ? undefined : style.height,
            min_height: !style.height ? '16px' : undefined,
            border: {
                radius: style?.border?.radius
            }
        },
        $baseScreenResolution: baseScreenResolution,
        $skipStates: skipStates,
        $nested: nested,
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4aeabe14c1618d30$exports)))('shimmer-container', $ceebea49d17ac2e7$export$34e0f9847d4c02dd)
    });
var $823fa51ea581843c$export$2e2bcd8739ae039 = $823fa51ea581843c$var$ContainerSkeleton;


var $71fb680e8403c8dd$export$2e2bcd8739ae039 = (0, $823fa51ea581843c$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");



// selectors.ts
const $79fc67ed759ae65b$export$8054c67068b60a33 = (state)=>state.page;
const $79fc67ed759ae65b$export$e3ab06c283dfbb87 = (state)=>$79fc67ed759ae65b$export$8054c67068b60a33(state).variableData;
const $79fc67ed759ae65b$export$78b26e3ba532c6ce = (state)=>$79fc67ed759ae65b$export$8054c67068b60a33(state).settings?.variables;








var $aivMx = parcelRequire("aivMx");

const $a2763a0b9b623ad0$export$a46b8a0c83328bf7 = (styleDraft, activeState, targetRef)=>{
    const initState = styleDraft?.states?.init;
    const entranceAnimation = initState?.animation || styleDraft?.animation;
    const hasEntrance = !!initState && !(0, $ae86b1db8cf5bdf9$export$d5d042b82187c4c4)(entranceAnimation);
    const viewport = initState?.animation?.viewport;
    const viewportEnabled = hasEntrance && viewport?.enabled === true;
    const [inOrigin, setInOrigin] = (0, $aivMx.useState)(hasEntrance);
    const playedRef = (0, $aivMx.useRef)(false);
    // Legacy mount-time entrance (double rAF). Skipped when the viewport trigger
    // owns the flip, so the two paths never both fire.
    (0, $aivMx.useEffect)(()=>{
        if (!hasEntrance || viewportEnabled || playedRef.current) return undefined;
        playedRef.current = true;
        // retain:'start' → object stays at the origin; don't settle to Base.
        if (initState?.animation?.retain === 'start') return undefined;
        let raf2 = 0;
        const raf1 = requestAnimationFrame(()=>{
            raf2 = requestAnimationFrame(()=>setInOrigin(false));
        });
        return ()=>{
            cancelAnimationFrame(raf1);
            if (raf2) cancelAnimationFrame(raf2);
        };
    // Entrance plays once per mount; intentionally only re-evaluates on hasEntrance.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasEntrance,
        viewportEnabled
    ]);
    // Viewport-entry trigger (TNBEWEB-1969). Flips into Base on first/each entry.
    (0, $aivMx.useEffect)(()=>{
        if (!viewportEnabled) return undefined;
        const retainStart = initState?.animation?.retain === 'start';
        // No ref passed AT ALL → we can never observe a node, so don't strand the
        // entrance at the (hidden) origin; play it immediately. Distinct from
        // "ref passed but node not mounted yet" (handled by the rAF retry below).
        if (!targetRef) {
            if (!retainStart) setInOrigin(false);
            return undefined;
        }
        const repeat = viewport?.repeat === true;
        let observer = null;
        let rafId = 0;
        let attempts = 0;
        // ~5s at 60fps. A node behind a skeleton/loading placeholder mounts well
        // within this; the bound just prevents an unbounded rAF spin.
        const MAX_ATTEMPTS = 300;
        const attach = ()=>{
            const el = targetRef.current;
            if (!el) {
                // Ref passed but the node isn't in the DOM yet (a skeleton/loading
                // placeholder renders first). React won't re-run this effect when the
                // ref's .current later mutates, so STAY at the origin and retry next
                // frame rather than flipping to Base off-screen.
                attempts += 1;
                if (attempts > MAX_ATTEMPTS) {
                    if (!retainStart) setInOrigin(false); // last resort: reveal, don't stay invisible
                    return;
                }
                rafId = requestAnimationFrame(attach);
                return;
            }
            const obs = new IntersectionObserver((entries)=>{
                const entry = entries[0];
                if (!entry) return;
                if (entry.isIntersecting) {
                    // Play the entrance (settle to Base) unless the origin is retained.
                    if (!retainStart) setInOrigin(false);
                    if (!repeat) obs.disconnect();
                } else if (repeat && !retainStart) // Reset to the origin while off-screen so the next entry replays.
                setInOrigin(true);
            }, {
                threshold: viewport?.threshold ?? 0.2,
                rootMargin: viewport?.rootMargin ?? '0px'
            });
            observer = obs;
            obs.observe(el);
        };
        attach();
        return ()=>{
            if (rafId) cancelAnimationFrame(rafId);
            if (observer) observer.disconnect();
        };
    // Re-arm only when the trigger config or the node changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        viewportEnabled,
        viewport?.repeat,
        viewport?.threshold,
        viewport?.rootMargin,
        targetRef
    ]);
    return {
        effectiveState: inOrigin ? 'init' : activeState,
        entranceAnimation: hasEntrance ? entranceAnimation : undefined
    };
};


const $43a41cb6de4b5efd$var$StyledCheckboxLabel = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).label`
    cursor: pointer;
    display: flex;
    align-items: center;
    jsutify-content: center;
    position: relative;
    z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $43a41cb6de4b5efd$var$StyledCheckbox = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
  cursor: pointer;
  margin: 0;
  pading: 0;
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
const $43a41cb6de4b5efd$var$Checkbox = ({ id: id, style: stDraft, value: val, events: eventsDraft, soc: soc, pageSettings: pageSettings, dataLake: dataLake, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, settings: settings, skeleton: renderSkeleton2, active_state: activeStateDraft, parentLoading: parentLoading, parentStyle: parentStyle, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache })=>{
    const { ref: ref } = settings || {};
    const extractedValue = (0, $7b0e169a5380005e$export$3175f779c869dc51)(val || '');
    const value = dataLake?.data && typeof val === 'string' && val?.match(/{{this\..*}}/) ? (0, $7b0e169a5380005e$export$a87687c5ea189578)(dataLake.data, extractedValue) : val;
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const containerRef = (0, $aivMx.useRef)(null);
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    const { style: styleDraft, events: events, active_state: active_state, ref: realRef } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        ref: ref,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        ref: undefined,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'checkbox') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading
    ]);
    // First useMemo to merge active state styles with base style
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, containerRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const [isChecked, setIsChecked] = (0, $aivMx.useState)(value === 'true' || value === true);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const debouncedSubmitForm = (0, $aivMx.useCallback)((0, $7b0e169a5380005e$export$61fc7d43ac8f84b0)(()=>{
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: 'soc',
            componentId: id
        }));
    }, 500), []);
    (0, $aivMx.useEffect)(()=>{
        setIsChecked(value === 'true' || value === true);
    }, [
        value
    ]);
    const handleCheckboxChange = ()=>{
        setIsChecked(!isChecked);
        const fieldId = `${id}${nestedTable && typeof parentIndex === 'number' ? `::${parentIndex}` : ''}`;
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: realRef || fieldId,
                value: !isChecked
            }
        }));
        if (soc) debouncedSubmitForm();
    };
    const { on_change: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const handleClick = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        e.preventDefault();
        handleCheckboxChange();
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = clickUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = clickUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = clickUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(clickUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(hoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const styleUpdates = launchUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') ;
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && containerRef.current && !containerRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Handle action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: active_state === 'disabled' || active_state === 'loading'
    });
    // Mouse handlers are typed for the div/input event the shared executeFunction
    // expects; the label element they're bound to differs, so keep the element
    // alias untyped (matches the previously-spread motionAnimProps: any).
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const LabelEl = $43a41cb6de4b5efd$var$StyledCheckboxLabel;
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)(LabelEl, {
        ref: containerRef,
        htmlFor: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": "checkbox",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        onClick: handleClick,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($43a41cb6de4b5efd$var$StyledCheckbox, {
                "data-id": realRef || id,
                id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
                type: "checkbox"
            }),
            isChecked ? settings?.icons?.active ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
                style: {
                    maxWidth: '100%',
                    maxHeight: '100%'
                },
                src: settings.icons.active
            }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                style: {
                    transform: 'scale(0.9)',
                    overflow: 'visible'
                },
                children: [
                    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                        d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z",
                        stroke: style?.font?.color || 'white'
                    }),
                    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                        d: "M12 5L6.5 10.5L4 8",
                        stroke: style?.font?.color || 'white',
                        strokeWidth: "1.6666",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }) : settings?.icons?.inactive ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
                style: {
                    maxWidth: '100%',
                    maxHeight: '100%'
                },
                src: settings.icons.inactive
            }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                style: {
                    transform: 'scale(0.9)',
                    overflow: 'visible'
                },
                children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z",
                    stroke: style?.font?.color || 'white'
                })
            })
        ]
    });
};
var $43a41cb6de4b5efd$export$2e2bcd8739ae039 = $43a41cb6de4b5efd$var$Checkbox;


var $2c90db8687e433b8$export$2e2bcd8739ae039 = (0, $43a41cb6de4b5efd$export$2e2bcd8739ae039);



parcelRequire("aivMx");


parcelRequire("aivMx");
const $e8d6e02fe13adc9b$var$SvgRenderer = ({ svg_string: svg_string })=>{
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
        src: `data:image/svg+xml;utf8,${encodeURIComponent(svg_string)}`
    });
};
var $e8d6e02fe13adc9b$export$2e2bcd8739ae039 = $e8d6e02fe13adc9b$var$SvgRenderer;


var $319d67322a675734$export$2e2bcd8739ae039 = (0, $e8d6e02fe13adc9b$export$2e2bcd8739ae039);




const $cd789220c822bcdc$var$StyledImage = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).img`
 z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, undefined, undefined, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $cd789220c822bcdc$var$StyledDiv = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, undefined, undefined, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $cd789220c822bcdc$var$Image = ({ id: id, image: image, style: style, svg_string: svg_string, parentStyle: parentStyle })=>{
    // if (image && image.startsWith('$')) {
    //   const iconName = image.substring(1);
    //   const SvgComponent = result[iconName];
    //   if (SvgComponent) {
    //     return <SvgComponent />;
    //   } else {
    //     // Handle the case where the SVG component is not found
    //     console.error(`SVG component "${iconName}" not found in result2.`);
    //     return null;
    //   }
    // }
    // If svg_string is provided, render SVGRenderer
    if (svg_string) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $319d67322a675734$export$2e2bcd8739ae039), {
        svg_string: svg_string
    });
    // Otherwise, render the StyledImage component
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($cd789220c822bcdc$var$StyledImage, {
        id: id,
        src: image,
        alt: id,
        $shape: style,
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": "image",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
};
var $cd789220c822bcdc$export$2e2bcd8739ae039 = $cd789220c822bcdc$var$Image;


var $aa8f0f735a0f79aa$export$2e2bcd8739ae039 = (0, $cd789220c822bcdc$export$2e2bcd8739ae039);


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable max-len */ 

var $aivMx = parcelRequire("aivMx");

/** Checks if value is string */ function $b4195841d15b2d87$export$844ec244b1367d54(str) {
    return typeof str === 'string' || str instanceof String;
}
/** Checks if value is object */ function $b4195841d15b2d87$export$a6cdc56e425d0d0a(obj) {
    var _obj$constructor;
    return typeof obj === 'object' && obj != null && (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === 'Object';
}
function $b4195841d15b2d87$export$357523c63a2253b9(obj, keys) {
    if (Array.isArray(keys)) return $b4195841d15b2d87$export$357523c63a2253b9(obj, (_, k)=>keys.includes(k));
    return Object.entries(obj).reduce((acc, _ref)=>{
        let [k, v] = _ref;
        if (keys(v, k)) acc[k] = v;
        return acc;
    }, {});
}
/** Direction */ const $b4195841d15b2d87$export$9106728c49045482 = {
    NONE: 'NONE',
    LEFT: 'LEFT',
    FORCE_LEFT: 'FORCE_LEFT',
    RIGHT: 'RIGHT',
    FORCE_RIGHT: 'FORCE_RIGHT'
};
/** Direction */ function $b4195841d15b2d87$export$32af4dafed14c8ce(direction) {
    switch(direction){
        case $b4195841d15b2d87$export$9106728c49045482.LEFT:
            return $b4195841d15b2d87$export$9106728c49045482.FORCE_LEFT;
        case $b4195841d15b2d87$export$9106728c49045482.RIGHT:
            return $b4195841d15b2d87$export$9106728c49045482.FORCE_RIGHT;
        default:
            return direction;
    }
}
/** Escapes regular expression control chars */ function $b4195841d15b2d87$export$7c57da42ce8e346f(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}
// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function $b4195841d15b2d87$export$7aeb68f71172641d(b, a) {
    if (a === b) return true;
    const arrA = Array.isArray(a), arrB = Array.isArray(b);
    let i;
    if (arrA && arrB) {
        if (a.length != b.length) return false;
        for(i = 0; i < a.length; i++)if (!$b4195841d15b2d87$export$7aeb68f71172641d(a[i], b[i])) return false;
        return true;
    }
    if (arrA != arrB) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        const dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA && dateB) return a.getTime() == b.getTime();
        if (dateA != dateB) return false;
        const regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA && regexpB) return a.toString() == b.toString();
        if (regexpA != regexpB) return false;
        const keys = Object.keys(a);
        // if (keys.length !== Object.keys(b).length) return false;
        for(i = 0; i < keys.length; i++)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = 0; i < keys.length; i++)if (!$b4195841d15b2d87$export$7aeb68f71172641d(b[keys[i]], a[keys[i]])) return false;
        return true;
    } else if (a && b && typeof a === 'function' && typeof b === 'function') return a.toString() === b.toString();
    return false;
}



/** Provides details of changing input */ class $5bfe4737c33ba518$export$2e2bcd8739ae039 {
    /** Current input value */ /** Current cursor position */ /** Old input value */ /** Old selection */ constructor(opts){
        Object.assign(this, opts);
        // double check if left part was changed (autofilling, other non-standard input triggers)
        while(this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos))--this.oldSelection.start;
        if (this.insertedCount) {
            // double check right part
            while(this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end))if (this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end) ++this.oldSelection.end;
            else ++this.cursorPos;
        }
    }
    /** Start changing position */ get startChangePos() {
        return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /** Inserted symbols count */ get insertedCount() {
        return this.cursorPos - this.startChangePos;
    }
    /** Inserted symbols */ get inserted() {
        return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /** Removed symbols count */ get removedCount() {
        // Math.max for opposite operation
        return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
        this.oldValue.length - this.value.length, 0);
    }
    /** Removed symbols */ get removed() {
        return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /** Unchanged head symbols */ get head() {
        return this.value.substring(0, this.startChangePos);
    }
    /** Unchanged tail symbols */ get tail() {
        return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /** Remove direction */ get removeDirection() {
        if (!this.removedCount || this.insertedCount) return (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        // align right if delete at right
        return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
        this.oldSelection.end === this.oldSelection.start ? (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT : (0, $b4195841d15b2d87$export$9106728c49045482).LEFT;
    }
}



/** Applies mask on element */ function $7dec8b23e7031bbf$export$2e2bcd8739ae039(el, opts) {
    // currently available only for input-like elements
    return new $7dec8b23e7031bbf$export$2e2bcd8739ae039.InputMask(el, opts);
}


// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// export function maskedClass(mask: string): typeof MaskedPattern;
// export function maskedClass(mask: DateConstructor): typeof MaskedDate;
// export function maskedClass(mask: NumberConstructor): typeof MaskedNumber;
// export function maskedClass(mask: Array<any> | ArrayConstructor): typeof MaskedDynamic;
// export function maskedClass(mask: MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass(mask: Masked): typeof Masked;
// export function maskedClass(mask: typeof Masked): typeof Masked;
// export function maskedClass(mask: typeof MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: typeof MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: typeof MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: typeof MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: typeof MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: typeof MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: typeof MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: typeof MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass<Mask extends typeof Masked> (mask: Mask): Mask;
// export function maskedClass(mask: RegExp): typeof MaskedRegExp;
// export function maskedClass(mask: (value: string, ...args: any[]) => boolean): typeof MaskedFunction;
/** Get Masked class by mask type */ function $d30869383ae23901$export$81ad4b1539a22420(mask) /* TODO */ {
    if (mask == null) throw new Error('mask property should be defined');
    if (mask instanceof RegExp) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedRegExp;
    if ((0, $b4195841d15b2d87$export$844ec244b1367d54)(mask)) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedPattern;
    if (mask === Date) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedDate;
    if (mask === Number) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedNumber;
    if (Array.isArray(mask) || mask === Array) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedDynamic;
    if ((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked && mask.prototype instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) return mask;
    if ((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked && mask instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) return mask.constructor;
    if (mask instanceof Function) return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedFunction;
    console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
    return (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked;
}
function $d30869383ae23901$export$a213ae1c699d7230(opts) {
    if (!opts) throw new Error('Options in not defined');
    if ((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) {
        if (opts.prototype instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) return {
            mask: opts
        };
        /*
      handle cases like:
      1) opts = Masked
      2) opts = { mask: Masked, ...instanceOpts }
    */ const { mask: mask, ...instanceOpts } = opts instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked ? {
            mask: opts
        } : (0, $b4195841d15b2d87$export$a6cdc56e425d0d0a)(opts) && opts.mask instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked ? opts : {};
        if (mask) {
            const _mask = mask.mask;
            return {
                ...(0, $b4195841d15b2d87$export$357523c63a2253b9)(mask, (_, k)=>!k.startsWith('_')),
                mask: mask.constructor,
                _mask: _mask,
                ...instanceOpts
            };
        }
    }
    if (!(0, $b4195841d15b2d87$export$a6cdc56e425d0d0a)(opts)) return {
        mask: opts
    };
    return {
        ...opts
    };
}
// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// From masked
// export default function createMask<Opts extends Masked, ReturnMasked=Opts> (opts: Opts): ReturnMasked;
// // From masked class
// export default function createMask<Opts extends MaskedOptions<typeof Masked>, ReturnMasked extends Masked=InstanceType<Opts['mask']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDate>, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedNumber>, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedEnum>, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRange>, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedFunction>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedPattern>, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDynamic>, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// // From mask opts
// export default function createMask<Opts extends MaskedOptions<Masked>, ReturnMasked=Opts extends MaskedOptions<infer M> ? M : never> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedNumberOptions, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDateFactoryOptions, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedEnumOptions, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedRangeOptions, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedPatternOptions, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDynamicOptions, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<RegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<Function>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
/** Creates new {@link Masked} depending on mask type */ function $d30869383ae23901$export$2e2bcd8739ae039(opts) {
    if ((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked && opts instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) return opts;
    const nOpts = $d30869383ae23901$export$a213ae1c699d7230(opts);
    const MaskedClass = $d30869383ae23901$export$81ad4b1539a22420(nOpts.mask);
    if (!MaskedClass) throw new Error("Masked class is not found for provided mask " + nOpts.mask + ", appropriate module needs to be imported manually before creating mask.");
    if (nOpts.mask === MaskedClass) delete nOpts.mask;
    if (nOpts._mask) {
        nOpts.mask = nOpts._mask;
        delete nOpts._mask;
    }
    return new MaskedClass(nOpts);
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).createMask = $d30869383ae23901$export$2e2bcd8739ae039;



/**  Generic element API to use with mask */ class $ae7da51f8113dc85$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** Safely returns selection start */ get selectionStart() {
        let start;
        try {
            start = this._unsafeSelectionStart;
        } catch  {}
        return start != null ? start : this.value.length;
    }
    /** Safely returns selection end */ get selectionEnd() {
        let end;
        try {
            end = this._unsafeSelectionEnd;
        } catch  {}
        return end != null ? end : this.value.length;
    }
    /** Safely sets element selection */ select(start, end) {
        if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
        try {
            this._unsafeSelect(start, end);
        } catch  {}
    }
    /** */ get isActive() {
        return false;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskElement = $ae7da51f8113dc85$export$2e2bcd8739ae039;




const $ecbac16a2bea0b4a$var$KEY_Z = 90;
const $ecbac16a2bea0b4a$var$KEY_Y = 89;
/** Bridge between HTMLElement and {@link Masked} */ class $ecbac16a2bea0b4a$export$2e2bcd8739ae039 extends (0, $ae7da51f8113dc85$export$2e2bcd8739ae039) {
    /** HTMLElement to use mask on */ constructor(input){
        super();
        this.input = input;
        this._onKeydown = this._onKeydown.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onBeforeinput = this._onBeforeinput.bind(this);
        this._onCompositionEnd = this._onCompositionEnd.bind(this);
    }
    get rootElement() {
        var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
        return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
    }
    /** Is element in focus */ get isActive() {
        return this.input === this.rootElement.activeElement;
    }
    /** Binds HTMLElement events to mask internal events */ bindEvents(handlers) {
        this.input.addEventListener('keydown', this._onKeydown);
        this.input.addEventListener('input', this._onInput);
        this.input.addEventListener('beforeinput', this._onBeforeinput);
        this.input.addEventListener('compositionend', this._onCompositionEnd);
        this.input.addEventListener('drop', handlers.drop);
        this.input.addEventListener('click', handlers.click);
        this.input.addEventListener('focus', handlers.focus);
        this.input.addEventListener('blur', handlers.commit);
        this._handlers = handlers;
    }
    _onKeydown(e) {
        if (this._handlers.redo && (e.keyCode === $ecbac16a2bea0b4a$var$KEY_Z && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === $ecbac16a2bea0b4a$var$KEY_Y && e.ctrlKey)) {
            e.preventDefault();
            return this._handlers.redo(e);
        }
        if (this._handlers.undo && e.keyCode === $ecbac16a2bea0b4a$var$KEY_Z && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            return this._handlers.undo(e);
        }
        if (!e.isComposing) this._handlers.selectionChange(e);
    }
    _onBeforeinput(e) {
        if (e.inputType === 'historyUndo' && this._handlers.undo) {
            e.preventDefault();
            return this._handlers.undo(e);
        }
        if (e.inputType === 'historyRedo' && this._handlers.redo) {
            e.preventDefault();
            return this._handlers.redo(e);
        }
    }
    _onCompositionEnd(e) {
        this._handlers.input(e);
    }
    _onInput(e) {
        if (!e.isComposing) this._handlers.input(e);
    }
    /** Unbinds HTMLElement events to mask internal events */ unbindEvents() {
        this.input.removeEventListener('keydown', this._onKeydown);
        this.input.removeEventListener('input', this._onInput);
        this.input.removeEventListener('beforeinput', this._onBeforeinput);
        this.input.removeEventListener('compositionend', this._onCompositionEnd);
        this.input.removeEventListener('drop', this._handlers.drop);
        this.input.removeEventListener('click', this._handlers.click);
        this.input.removeEventListener('focus', this._handlers.focus);
        this.input.removeEventListener('blur', this._handlers.commit);
        this._handlers = {};
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).HTMLMaskElement = $ecbac16a2bea0b4a$export$2e2bcd8739ae039;




/** Bridge between InputElement and {@link Masked} */ class $ebab80655d6a9181$export$2e2bcd8739ae039 extends (0, $ecbac16a2bea0b4a$export$2e2bcd8739ae039) {
    /** InputElement to use mask on */ constructor(input){
        super(input);
        this.input = input;
    }
    /** Returns InputElement selection start */ get _unsafeSelectionStart() {
        return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }
    /** Returns InputElement selection end */ get _unsafeSelectionEnd() {
        return this.input.selectionEnd;
    }
    /** Sets InputElement selection */ _unsafeSelect(start, end) {
        this.input.setSelectionRange(start, end);
    }
    get value() {
        return this.input.value;
    }
    set value(value) {
        this.input.value = value;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).HTMLMaskElement = (0, $ecbac16a2bea0b4a$export$2e2bcd8739ae039);





class $6deed0002d645a3f$export$2e2bcd8739ae039 extends (0, $ecbac16a2bea0b4a$export$2e2bcd8739ae039) {
    /** Returns HTMLElement selection start */ get _unsafeSelectionStart() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Returns HTMLElement selection end */ get _unsafeSelectionEnd() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Sets HTMLElement selection */ _unsafeSelect(start, end) {
        if (!this.rootElement.createRange) return;
        const range = this.rootElement.createRange();
        range.setStart(this.input.firstChild || this.input, start);
        range.setEnd(this.input.lastChild || this.input, end);
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    /** HTMLElement value */ get value() {
        return this.input.textContent || '';
    }
    set value(value) {
        this.input.textContent = value;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).HTMLContenteditableMaskElement = $6deed0002d645a3f$export$2e2bcd8739ae039;



class $8d4d359c9723b699$export$2e2bcd8739ae039 {
    constructor(){
        this.states = [];
        this.currentIndex = 0;
    }
    get currentState() {
        return this.states[this.currentIndex];
    }
    get isEmpty() {
        return this.states.length === 0;
    }
    push(state) {
        // if current index points before the last element then remove the future
        if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
        this.states.push(state);
        if (this.states.length > $8d4d359c9723b699$export$2e2bcd8739ae039.MAX_LENGTH) this.states.shift();
        this.currentIndex = this.states.length - 1;
    }
    go(steps) {
        this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
        return this.currentState;
    }
    undo() {
        return this.go(-1);
    }
    redo() {
        return this.go(1);
    }
    clear() {
        this.states.length = 0;
        this.currentIndex = 0;
    }
}
$8d4d359c9723b699$export$2e2bcd8739ae039.MAX_LENGTH = 100;



/** Listens to element events and controls changes between element and {@link Masked} */ class $3895576b00a3d126$export$2e2bcd8739ae039 {
    /**
    View element
  */ /** Internal {@link Masked} model */ constructor(el, opts){
        this.el = el instanceof (0, $ae7da51f8113dc85$export$2e2bcd8739ae039) ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new (0, $6deed0002d645a3f$export$2e2bcd8739ae039)(el) : new (0, $ebab80655d6a9181$export$2e2bcd8739ae039)(el);
        this.masked = (0, $d30869383ae23901$export$2e2bcd8739ae039)(opts);
        this._listeners = {};
        this._value = '';
        this._unmaskedValue = '';
        this._rawInputValue = '';
        this.history = new (0, $8d4d359c9723b699$export$2e2bcd8739ae039)();
        this._saveSelection = this._saveSelection.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onUndo = this._onUndo.bind(this);
        this._onRedo = this._onRedo.bind(this);
        this.alignCursor = this.alignCursor.bind(this);
        this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
        this._bindEvents();
        // refresh
        this.updateValue();
        this._onChange();
    }
    maskEquals(mask) {
        var _this$masked;
        return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
    }
    /** Masked */ get mask() {
        return this.masked.mask;
    }
    set mask(mask) {
        if (this.maskEquals(mask)) return;
        if (!(mask instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked) && this.masked.constructor === (0, $d30869383ae23901$export$81ad4b1539a22420)(mask)) {
            // TODO "any" no idea
            this.masked.updateOptions({
                mask: mask
            });
            return;
        }
        const masked = mask instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked ? mask : (0, $d30869383ae23901$export$2e2bcd8739ae039)({
            mask: mask
        });
        masked.unmaskedValue = this.masked.unmaskedValue;
        this.masked = masked;
    }
    /** Raw value */ get value() {
        return this._value;
    }
    set value(str) {
        if (this.value === str) return;
        this.masked.value = str;
        this.updateControl('auto');
    }
    /** Unmasked value */ get unmaskedValue() {
        return this._unmaskedValue;
    }
    set unmaskedValue(str) {
        if (this.unmaskedValue === str) return;
        this.masked.unmaskedValue = str;
        this.updateControl('auto');
    }
    /** Raw input value */ get rawInputValue() {
        return this._rawInputValue;
    }
    set rawInputValue(str) {
        if (this.rawInputValue === str) return;
        this.masked.rawInputValue = str;
        this.updateControl();
        this.alignCursor();
    }
    /** Typed unmasked value */ get typedValue() {
        return this.masked.typedValue;
    }
    set typedValue(val) {
        if (this.masked.typedValueEquals(val)) return;
        this.masked.typedValue = val;
        this.updateControl('auto');
    }
    /** Display value */ get displayValue() {
        return this.masked.displayValue;
    }
    /** Starts listening to element events */ _bindEvents() {
        this.el.bindEvents({
            selectionChange: this._saveSelection,
            input: this._onInput,
            drop: this._onDrop,
            click: this._onClick,
            focus: this._onFocus,
            commit: this._onChange,
            undo: this._onUndo,
            redo: this._onRedo
        });
    }
    /** Stops listening to element events */ _unbindEvents() {
        if (this.el) this.el.unbindEvents();
    }
    /** Fires custom event */ _fireEvent(ev, e) {
        const listeners = this._listeners[ev];
        if (!listeners) return;
        listeners.forEach((l)=>l(e));
    }
    /** Current selection start */ get selectionStart() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */ get cursorPos() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    }
    set cursorPos(pos) {
        if (!this.el || !this.el.isActive) return;
        this.el.select(pos, pos);
        this._saveSelection();
    }
    /** Stores current selection */ _saveSelection() {
        if (this.displayValue !== this.el.value) console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
        this._selection = {
            start: this.selectionStart,
            end: this.cursorPos
        };
    }
    /** Syncronizes model value from view */ updateValue() {
        this.masked.value = this.el.value;
        this._value = this.masked.value;
        this._unmaskedValue = this.masked.unmaskedValue;
        this._rawInputValue = this.masked.rawInputValue;
    }
    /** Syncronizes view from model value, fires change events */ updateControl(cursorPos) {
        const newUnmaskedValue = this.masked.unmaskedValue;
        const newValue = this.masked.value;
        const newRawInputValue = this.masked.rawInputValue;
        const newDisplayValue = this.displayValue;
        const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue || this._rawInputValue !== newRawInputValue;
        this._unmaskedValue = newUnmaskedValue;
        this._value = newValue;
        this._rawInputValue = newRawInputValue;
        if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
        if (cursorPos === 'auto') this.alignCursor();
        else if (cursorPos != null) this.cursorPos = cursorPos;
        if (isChanged) this._fireChangeEvents();
        if (!this._historyChanging && (isChanged || this.history.isEmpty)) this.history.push({
            unmaskedValue: newUnmaskedValue,
            selection: {
                start: this.selectionStart,
                end: this.cursorPos
            }
        });
    }
    /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */ updateOptions(opts) {
        const { mask: mask, ...restOpts } = opts; // TODO types, yes, mask is optional
        const updateMask = !this.maskEquals(mask);
        const updateOpts = this.masked.optionsIsChanged(restOpts);
        if (updateMask) this.mask = mask;
        if (updateOpts) this.masked.updateOptions(restOpts); // TODO
        if (updateMask || updateOpts) this.updateControl();
    }
    /** Updates cursor */ updateCursor(cursorPos) {
        if (cursorPos == null) return;
        this.cursorPos = cursorPos;
        // also queue change cursor for mobile browsers
        this._delayUpdateCursor(cursorPos);
    }
    /** Delays cursor update to support mobile browsers */ _delayUpdateCursor(cursorPos) {
        this._abortUpdateCursor();
        this._changingCursorPos = cursorPos;
        this._cursorChanging = setTimeout(()=>{
            if (!this.el) return; // if was destroyed
            this.cursorPos = this._changingCursorPos;
            this._abortUpdateCursor();
        }, 10);
    }
    /** Fires custom events */ _fireChangeEvents() {
        this._fireEvent('accept', this._inputEvent);
        if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
    }
    /** Aborts delayed cursor update */ _abortUpdateCursor() {
        if (this._cursorChanging) {
            clearTimeout(this._cursorChanging);
            delete this._cursorChanging;
        }
    }
    /** Aligns cursor to nearest available position */ alignCursor() {
        this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, (0, $b4195841d15b2d87$export$9106728c49045482).LEFT));
    }
    /** Aligns cursor only if selection is empty */ alignCursorFriendly() {
        if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
        this.alignCursor();
    }
    /** Adds listener on custom event */ on(ev, handler) {
        if (!this._listeners[ev]) this._listeners[ev] = [];
        this._listeners[ev].push(handler);
        return this;
    }
    /** Removes custom event listener */ off(ev, handler) {
        if (!this._listeners[ev]) return this;
        if (!handler) {
            delete this._listeners[ev];
            return this;
        }
        const hIndex = this._listeners[ev].indexOf(handler);
        if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
        return this;
    }
    /** Handles view input event */ _onInput(e) {
        this._inputEvent = e;
        this._abortUpdateCursor();
        const details = new (0, $5bfe4737c33ba518$export$2e2bcd8739ae039)({
            // new state
            value: this.el.value,
            cursorPos: this.cursorPos,
            // old state
            oldValue: this.displayValue,
            oldSelection: this._selection
        });
        const oldRawValue = this.masked.rawInputValue;
        const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
            input: true,
            raw: true
        }).offset;
        // force align in remove direction only if no input chars were removed
        // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
        const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
        if (removeDirection !== (0, $b4195841d15b2d87$export$9106728c49045482).NONE) cursorPos = this.masked.nearestInputPos(cursorPos, (0, $b4195841d15b2d87$export$9106728c49045482).NONE);
        this.updateControl(cursorPos);
        delete this._inputEvent;
    }
    /** Handles view change event and commits model value */ _onChange() {
        if (this.displayValue !== this.el.value) this.updateValue();
        this.masked.doCommit();
        this.updateControl();
        this._saveSelection();
    }
    /** Handles view drop event, prevents by default */ _onDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }
    /** Restore last selection on focus */ _onFocus(ev) {
        this.alignCursorFriendly();
    }
    /** Restore last selection on focus */ _onClick(ev) {
        this.alignCursorFriendly();
    }
    _onUndo() {
        this._applyHistoryState(this.history.undo());
    }
    _onRedo() {
        this._applyHistoryState(this.history.redo());
    }
    _applyHistoryState(state) {
        if (!state) return;
        this._historyChanging = true;
        this.unmaskedValue = state.unmaskedValue;
        this.el.select(state.selection.start, state.selection.end);
        this._saveSelection();
        this._historyChanging = false;
    }
    /** Unbind view events and removes element reference */ destroy() {
        this._unbindEvents();
        this._listeners.length = 0;
        delete this.el;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).InputMask = $3895576b00a3d126$export$2e2bcd8739ae039;








/** Provides details of changing model value */ class $b285a78e7d6163d8$export$2e2bcd8739ae039 {
    /** Inserted symbols */ /** Additional offset if any changes occurred before tail */ /** Raw inserted is used by dynamic mask */ /** Can skip chars */ static normalize(prep) {
        return Array.isArray(prep) ? prep : [
            prep,
            new $b285a78e7d6163d8$export$2e2bcd8739ae039()
        ];
    }
    constructor(details){
        Object.assign(this, {
            inserted: '',
            rawInserted: '',
            tailShift: 0,
            skip: false
        }, details);
    }
    /** Aggregate changes */ aggregate(details) {
        this.inserted += details.inserted;
        this.rawInserted += details.rawInserted;
        this.tailShift += details.tailShift;
        this.skip = this.skip || details.skip;
        return this;
    }
    /** Total offset considering all changes */ get offset() {
        return this.tailShift + this.inserted.length;
    }
    get consumed() {
        return Boolean(this.rawInserted) || this.skip;
    }
    equals(details) {
        return this.inserted === details.inserted && this.tailShift === details.tailShift && this.rawInserted === details.rawInserted && this.skip === details.skip;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).ChangeDetails = $b285a78e7d6163d8$export$2e2bcd8739ae039;




/** Provides details of continuous extracted tail */ class $8648f741d9791934$export$2e2bcd8739ae039 {
    /** Tail value as string */ /** Tail start position */ /** Start position */ constructor(value, from, stop){
        if (value === void 0) value = '';
        if (from === void 0) from = 0;
        this.value = value;
        this.from = from;
        this.stop = stop;
    }
    toString() {
        return this.value;
    }
    extend(tail) {
        this.value += String(tail);
    }
    appendTo(masked) {
        return masked.append(this.toString(), {
            tail: true
        }).aggregate(masked._appendPlaceholder());
    }
    get state() {
        return {
            value: this.value,
            from: this.from,
            stop: this.stop
        };
    }
    set state(state) {
        Object.assign(this, state);
    }
    unshift(beforePos) {
        if (!this.value.length || beforePos != null && this.from >= beforePos) return '';
        const shiftChar = this.value[0];
        this.value = this.value.slice(1);
        return shiftChar;
    }
    shift() {
        if (!this.value.length) return '';
        const shiftChar = this.value[this.value.length - 1];
        this.value = this.value.slice(0, -1);
        return shiftChar;
    }
}




/** Append flags */ /** Extract flags */ // see https://github.com/microsoft/TypeScript/issues/6223
/** Provides common masking stuff */ class $9b02b15c72a43b68$export$2e2bcd8739ae039 {
    /** */ /** */ /** Transforms value before mask processing */ /** Transforms each char before mask processing */ /** Validates if value is acceptable */ /** Does additional processing at the end of editing */ /** Format typed value to string */ /** Parse string to get typed value */ /** Enable characters overwriting */ /** */ /** */ /** */ /** */ constructor(opts){
        this._value = '';
        this._update({
            ...$9b02b15c72a43b68$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this._initialized = true;
    }
    /** Sets and applies new options */ updateOptions(opts) {
        if (!this.optionsIsChanged(opts)) return;
        this.withValueRefresh(this._update.bind(this, opts));
    }
    /** Sets new options */ _update(opts) {
        Object.assign(this, opts);
    }
    /** Mask state */ get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
    }
    /** Resets value */ reset() {
        this._value = '';
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this.resolve(value, {
            input: true
        });
    }
    /** Resolve new value */ resolve(value, flags) {
        if (flags === void 0) flags = {
            input: true
        };
        this.reset();
        this.append(value, flags, '');
        this.doCommit();
    }
    get unmaskedValue() {
        return this.value;
    }
    set unmaskedValue(value) {
        this.resolve(value, {});
    }
    get typedValue() {
        return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
    }
    set typedValue(value) {
        if (this.format) this.value = this.format(value, this);
        else this.unmaskedValue = String(value);
    }
    /** Value that includes raw user input */ get rawInputValue() {
        return this.extractInput(0, this.displayValue.length, {
            raw: true
        });
    }
    set rawInputValue(value) {
        this.resolve(value, {
            raw: true
        });
    }
    get displayValue() {
        return this.value;
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return this.isComplete;
    }
    /** Finds nearest input position in direction */ nearestInputPos(cursorPos, direction) {
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return Math.min(this.displayValue.length, toPos - fromPos);
    }
    /** Extracts value in range considering flags */ extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return this.displayValue.slice(fromPos, toPos);
    }
    /** Extracts tail in range */ extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return new (0, $8648f741d9791934$export$2e2bcd8739ae039)(this.extractInput(fromPos, toPos), fromPos);
    }
    /** Appends tail */ appendTail(tail) {
        if ((0, $b4195841d15b2d87$export$844ec244b1367d54)(tail)) tail = new (0, $8648f741d9791934$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    /** Appends char */ _appendCharRaw(ch, flags) {
        if (!ch) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        this._value += ch;
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            inserted: ch,
            rawInserted: ch
        });
    }
    /** Appends char */ _appendChar(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const consistentState = this.state;
        let details;
        [ch, details] = this.doPrepareChar(ch, flags);
        if (ch) {
            details = details.aggregate(this._appendCharRaw(ch, flags));
            // TODO handle `skip`?
            // try `autofix` lookahead
            if (!details.rawInserted && this.autofix === 'pad') {
                const noFixState = this.state;
                this.state = consistentState;
                let fixDetails = this.pad(flags);
                const chDetails = this._appendCharRaw(ch, flags);
                fixDetails = fixDetails.aggregate(chDetails);
                // if fix was applied or
                // if details are equal use skip restoring state optimization
                if (chDetails.rawInserted || fixDetails.equals(details)) details = fixDetails;
                else this.state = noFixState;
            }
        }
        if (details.inserted) {
            let consistentTail;
            let appended = this.doValidate(flags) !== false;
            if (appended && checkTail != null) {
                // validation ok, check tail
                const beforeTailState = this.state;
                if (this.overwrite === true) {
                    consistentTail = checkTail.state;
                    for(let i = 0; i < details.rawInserted.length; ++i)checkTail.unshift(this.displayValue.length - details.tailShift);
                }
                let tailDetails = this.appendTail(checkTail);
                appended = tailDetails.rawInserted.length === checkTail.toString().length;
                // not ok, try shift
                if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
                    this.state = beforeTailState;
                    consistentTail = checkTail.state;
                    for(let i = 0; i < details.rawInserted.length; ++i)checkTail.shift();
                    tailDetails = this.appendTail(checkTail);
                    appended = tailDetails.rawInserted.length === checkTail.toString().length;
                }
                // if ok, rollback state after tail
                if (appended && tailDetails.inserted) this.state = beforeTailState;
            }
            // revert all if something went wrong
            if (!appended) {
                details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
                this.state = consistentState;
                if (checkTail && consistentTail) checkTail.state = consistentTail;
            }
        }
        return details;
    }
    /** Appends optional placeholder at the end */ _appendPlaceholder() {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    /** Appends optional eager placeholder at the end */ _appendEager() {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    /** Appends symbols considering flags */ append(str, flags, tail) {
        if (!(0, $b4195841d15b2d87$export$844ec244b1367d54)(str)) throw new Error('value should be string');
        const checkTail = (0, $b4195841d15b2d87$export$844ec244b1367d54)(tail) ? new (0, $8648f741d9791934$export$2e2bcd8739ae039)(String(tail)) : tail;
        if (flags != null && flags.tail) flags._beforeTailState = this.state;
        let details;
        [str, details] = this.doPrepare(str, flags);
        for(let ci = 0; ci < str.length; ++ci){
            const d = this._appendChar(str[ci], flags, checkTail);
            if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
            details.aggregate(d);
        }
        if ((this.eager === true || this.eager === 'append') && flags != null && flags.input && str) details.aggregate(this._appendEager());
        // append tail but aggregate only tailShift
        if (checkTail != null) details.tailShift += this.appendTail(checkTail).tailShift;
        return details;
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    /** Calls function and reapplies current value */ withValueRefresh(fn) {
        if (this._refreshing || !this._initialized) return fn();
        this._refreshing = true;
        const rawInput = this.rawInputValue;
        const value = this.value;
        const ret = fn();
        this.rawInputValue = rawInput;
        // append lost trailing chars at the end
        if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
            this.append(value.slice(this.displayValue.length), {}, '');
            this.doCommit();
        }
        delete this._refreshing;
        return ret;
    }
    runIsolated(fn) {
        if (this._isolated || !this._initialized) return fn(this);
        this._isolated = true;
        const state = this.state;
        const ret = fn(this);
        this.state = state;
        delete this._isolated;
        return ret;
    }
    doSkipInvalid(ch, flags, checkTail) {
        return Boolean(this.skipInvalid);
    }
    /** Prepares string before mask processing */ doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $b285a78e7d6163d8$export$2e2bcd8739ae039).normalize(this.prepare ? this.prepare(str, this, flags) : str);
    }
    /** Prepares each char before mask processing */ doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $b285a78e7d6163d8$export$2e2bcd8739ae039).normalize(this.prepareChar ? this.prepareChar(str, this, flags) : str);
    }
    /** Validates if value is acceptable */ doValidate(flags) {
        return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
    /** Does additional processing at the end of editing */ doCommit() {
        if (this.commit) this.commit(this.value, this);
    }
    splice(start, deleteCount, inserted, removeDirection, flags) {
        if (inserted === void 0) inserted = '';
        if (removeDirection === void 0) removeDirection = (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        if (flags === void 0) flags = {
            input: true
        };
        const tailPos = start + deleteCount;
        const tail = this.extractTail(tailPos);
        const eagerRemove = this.eager === true || this.eager === 'remove';
        let oldRawValue;
        if (eagerRemove) {
            removeDirection = (0, $b4195841d15b2d87$export$32af4dafed14c8ce)(removeDirection);
            oldRawValue = this.extractInput(0, tailPos, {
                raw: true
            });
        }
        let startChangePos = start;
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        // if it is just deletion without insertion
        if (removeDirection !== (0, $b4195841d15b2d87$export$9106728c49045482).NONE) {
            startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? (0, $b4195841d15b2d87$export$9106728c49045482).NONE : removeDirection);
            // adjust tailShift if start was aligned
            details.tailShift = startChangePos - start;
        }
        details.aggregate(this.remove(startChangePos));
        if (eagerRemove && removeDirection !== (0, $b4195841d15b2d87$export$9106728c49045482).NONE && oldRawValue === this.rawInputValue) {
            if (removeDirection === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT) {
                let valLength;
                while(oldRawValue === this.rawInputValue && (valLength = this.displayValue.length))details.aggregate(new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
                    tailShift: -1
                })).aggregate(this.remove(valLength - 1));
            } else if (removeDirection === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT) tail.unshift();
        }
        return details.aggregate(this.append(inserted, flags, tail));
    }
    maskEquals(mask) {
        return this.mask === mask;
    }
    optionsIsChanged(opts) {
        return !(0, $b4195841d15b2d87$export$7aeb68f71172641d)(this, opts);
    }
    typedValueEquals(value) {
        const tval = this.typedValue;
        return value === tval || $9b02b15c72a43b68$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $9b02b15c72a43b68$export$2e2bcd8739ae039.EMPTY_VALUES.includes(tval) || (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false);
    }
    pad(flags) {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
}
$9b02b15c72a43b68$export$2e2bcd8739ae039.DEFAULTS = {
    skipInvalid: true
};
$9b02b15c72a43b68$export$2e2bcd8739ae039.EMPTY_VALUES = [
    undefined,
    null,
    ''
];
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked = $9b02b15c72a43b68$export$2e2bcd8739ae039;











class $6a2e65700e83fd33$export$2e2bcd8739ae039 {
    /** */ constructor(chunks, from){
        if (chunks === void 0) chunks = [];
        if (from === void 0) from = 0;
        this.chunks = chunks;
        this.from = from;
    }
    toString() {
        return this.chunks.map(String).join('');
    }
    extend(tailChunk) {
        if (!String(tailChunk)) return;
        tailChunk = (0, $b4195841d15b2d87$export$844ec244b1367d54)(tailChunk) ? new (0, $8648f741d9791934$export$2e2bcd8739ae039)(String(tailChunk)) : tailChunk;
        const lastChunk = this.chunks[this.chunks.length - 1];
        const extendLast = lastChunk && // if stops are same or tail has no stop
        (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
        tailChunk.from === lastChunk.from + lastChunk.toString().length;
        if (tailChunk instanceof (0, $8648f741d9791934$export$2e2bcd8739ae039)) {
            // check the ability to extend previous chunk
            if (extendLast) // extend previous chunk
            lastChunk.extend(tailChunk.toString());
            else // append new chunk
            this.chunks.push(tailChunk);
        } else if (tailChunk instanceof $6a2e65700e83fd33$export$2e2bcd8739ae039) {
            if (tailChunk.stop == null) {
                // unwrap floating chunks to parent, keeping `from` pos
                let firstTailChunk;
                while(tailChunk.chunks.length && tailChunk.chunks[0].stop == null){
                    firstTailChunk = tailChunk.chunks.shift(); // not possible to be `undefined` because length was checked above
                    firstTailChunk.from += tailChunk.from;
                    this.extend(firstTailChunk);
                }
            }
            // if tail chunk still has value
            if (tailChunk.toString()) {
                // if chunks contains stops, then popup stop to container
                tailChunk.stop = tailChunk.blockIndex;
                this.chunks.push(tailChunk);
            }
        }
    }
    appendTo(masked) {
        if (!(masked instanceof (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedPattern)) {
            const tail = new (0, $8648f741d9791934$export$2e2bcd8739ae039)(this.toString());
            return tail.appendTo(masked);
        }
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        for(let ci = 0; ci < this.chunks.length; ++ci){
            const chunk = this.chunks[ci];
            const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
            const stop = chunk.stop;
            let chunkBlock;
            if (stop != null && // if block not found or stop is behind lastBlock
            (!lastBlockIter || lastBlockIter.index <= stop)) {
                if (chunk instanceof $6a2e65700e83fd33$export$2e2bcd8739ae039 || // for continuous block also check if stop is exist
                masked._stops.indexOf(stop) >= 0) details.aggregate(masked._appendPlaceholder(stop));
                chunkBlock = chunk instanceof $6a2e65700e83fd33$export$2e2bcd8739ae039 && masked._blocks[stop];
            }
            if (chunkBlock) {
                const tailDetails = chunkBlock.appendTail(chunk);
                details.aggregate(tailDetails);
                // get not inserted chars
                const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
                if (remainChars) details.aggregate(masked.append(remainChars, {
                    tail: true
                }));
            } else details.aggregate(masked.append(chunk.toString(), {
                tail: true
            }));
        }
        return details;
    }
    get state() {
        return {
            chunks: this.chunks.map((c)=>c.state),
            from: this.from,
            stop: this.stop,
            blockIndex: this.blockIndex
        };
    }
    set state(state) {
        const { chunks: chunks, ...props } = state;
        Object.assign(this, props);
        this.chunks = chunks.map((cstate)=>{
            const chunk = "chunks" in cstate ? new $6a2e65700e83fd33$export$2e2bcd8739ae039() : new (0, $8648f741d9791934$export$2e2bcd8739ae039)();
            chunk.state = cstate;
            return chunk;
        });
    }
    unshift(beforePos) {
        if (!this.chunks.length || beforePos != null && this.from >= beforePos) return '';
        const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
        let ci = 0;
        while(ci < this.chunks.length){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.unshift(chunkShiftPos);
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                ++ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return '';
    }
    shift() {
        if (!this.chunks.length) return '';
        let ci = this.chunks.length - 1;
        while(0 <= ci){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.shift();
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                --ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return '';
    }
}



class $f69f0b66e48a7ef0$export$2e2bcd8739ae039 {
    constructor(masked, pos){
        this.masked = masked;
        this._log = [];
        const { offset: offset, index: index } = masked._mapPosToBlock(pos) || (pos < 0 ? // first
        {
            index: 0,
            offset: 0
        } : // last
        {
            index: this.masked._blocks.length,
            offset: 0
        });
        this.offset = offset;
        this.index = index;
        this.ok = false;
    }
    get block() {
        return this.masked._blocks[this.index];
    }
    get pos() {
        return this.masked._blockStartPos(this.index) + this.offset;
    }
    get state() {
        return {
            index: this.index,
            offset: this.offset,
            ok: this.ok
        };
    }
    set state(s) {
        Object.assign(this, s);
    }
    pushState() {
        this._log.push(this.state);
    }
    popState() {
        const s = this._log.pop();
        if (s) this.state = s;
        return s;
    }
    bindBlock() {
        if (this.block) return;
        if (this.index < 0) {
            this.index = 0;
            this.offset = 0;
        }
        if (this.index >= this.masked._blocks.length) {
            this.index = this.masked._blocks.length - 1;
            this.offset = this.block.displayValue.length; // TODO this is stupid type error, `block` depends on index that was changed above
        }
    }
    _pushLeft(fn) {
        this.pushState();
        for(this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0){
            var _this$block;
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    _pushRight(fn) {
        this.pushState();
        for(this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0){
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    pushLeftBeforeFilled() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT);
            if (this.offset !== 0) return true;
        });
    }
    pushLeftBeforeInput() {
        // cases:
        // filled input: 00|
        // optional empty input: 00[]|
        // nested block: XX<[]>|
        return this._pushLeft(()=>{
            if (this.block.isFixed) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushLeftBeforeRequired() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushRightBeforeFilled() {
        return this._pushRight(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT);
            if (this.offset !== this.block.value.length) return true;
        });
    }
    pushRightBeforeInput() {
        return this._pushRight(()=>{
            if (this.block.isFixed) return;
            // const o = this.offset;
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).NONE);
            // HACK cases like (STILL DOES NOT WORK FOR NESTED)
            // aa|X
            // aa<X|[]>X_    - this will not work
            // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
            return true;
        });
    }
    pushRightBeforeRequired() {
        return this._pushRight(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            // TODO check |[*]XX_
            this.offset = this.block.nearestInputPos(this.offset, (0, $b4195841d15b2d87$export$9106728c49045482).NONE);
            return true;
        });
    }
}






class $f65e3184e2233cc5$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        Object.assign(this, opts);
        this._value = '';
        this.isFixed = true;
    }
    get value() {
        return this._value;
    }
    get unmaskedValue() {
        return this.isUnmasking ? this.value : '';
    }
    get rawInputValue() {
        return this._isRawInput ? this.value : '';
    }
    get displayValue() {
        return this.value;
    }
    reset() {
        this._isRawInput = false;
        this._value = '';
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
        if (!this._value) this._isRawInput = false;
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this._value.length;
        switch(direction){
            case (0, $b4195841d15b2d87$export$9106728c49045482).LEFT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT:
                return minPos;
            case (0, $b4195841d15b2d87$export$9106728c49045482).NONE:
            case (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT:
            default:
                return maxPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        return this._isRawInput ? toPos - fromPos : 0;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        if (flags === void 0) flags = {};
        return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return Boolean(this._value);
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        const appendEager = this.eager === true || this.eager === 'append';
        const appended = this.char === ch;
        const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            inserted: this.char,
            rawInserted: isResolved ? this.char : ''
        });
        this._value = this.char;
        this._isRawInput = isResolved && (flags.raw || flags.input);
        return details;
    }
    _appendEager() {
        return this._appendChar(this.char, {
            tail: true
        });
    }
    _appendPlaceholder() {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (this.isFilled) return details;
        this._value = details.inserted = this.char;
        return details;
    }
    extractTail() {
        return new (0, $8648f741d9791934$export$2e2bcd8739ae039)('');
    }
    appendTail(tail) {
        if ((0, $b4195841d15b2d87$export$844ec244b1367d54)(tail)) tail = new (0, $8648f741d9791934$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    append(str, flags, tail) {
        const details = this._appendChar(str[0], flags);
        if (tail != null) details.tailShift += this.appendTail(tail).tailShift;
        return details;
    }
    doCommit() {}
    get state() {
        return {
            _value: this._value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
        this._isRawInput = Boolean(state._rawInputValue);
    }
    pad(flags) {
        return this._appendPlaceholder();
    }
}






class $8bc8830b315da14a$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        const { parent: parent, isOptional: isOptional, placeholderChar: placeholderChar, displayChar: displayChar, lazy: lazy, eager: eager, ...maskOpts } = opts;
        this.masked = (0, $d30869383ae23901$export$2e2bcd8739ae039)(maskOpts);
        Object.assign(this, {
            parent: parent,
            isOptional: isOptional,
            placeholderChar: placeholderChar,
            displayChar: displayChar,
            lazy: lazy,
            eager: eager
        });
    }
    reset() {
        this.isFilled = false;
        this.masked.reset();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        if (fromPos === 0 && toPos >= 1) {
            this.isFilled = false;
            return this.masked.remove(fromPos, toPos);
        }
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    get value() {
        return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
    }
    get unmaskedValue() {
        return this.masked.unmaskedValue;
    }
    get rawInputValue() {
        return this.masked.rawInputValue;
    }
    get displayValue() {
        return this.masked.value && this.displayChar || this.value;
    }
    get isComplete() {
        return Boolean(this.masked.value) || this.isOptional;
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        const state = this.masked.state;
        // simulate input
        let details = this.masked._appendChar(ch, this.currentMaskFlags(flags));
        if (details.inserted && this.doValidate(flags) === false) {
            details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
            this.masked.state = state;
        }
        if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) details.inserted = this.placeholderChar;
        details.skip = !details.inserted && !this.isOptional;
        this.isFilled = Boolean(details.inserted);
        return details;
    }
    append(str, flags, tail) {
        // TODO probably should be done via _appendChar
        return this.masked.append(str, this.currentMaskFlags(flags), tail);
    }
    _appendPlaceholder() {
        if (this.isFilled || this.isOptional) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        this.isFilled = true;
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            inserted: this.placeholderChar
        });
    }
    _appendEager() {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
    extractTail(fromPos, toPos) {
        return this.masked.extractTail(fromPos, toPos);
    }
    appendTail(tail) {
        return this.masked.appendTail(tail);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.masked.extractInput(fromPos, toPos, flags);
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this.value.length;
        const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
        switch(direction){
            case (0, $b4195841d15b2d87$export$9106728c49045482).LEFT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT:
                return this.isComplete ? boundPos : minPos;
            case (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT:
                return this.isComplete ? boundPos : maxPos;
            case (0, $b4195841d15b2d87$export$9106728c49045482).NONE:
            default:
                return boundPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.value.slice(fromPos, toPos).length;
    }
    doValidate(flags) {
        return this.masked.doValidate(this.currentMaskFlags(flags)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags)));
    }
    doCommit() {
        this.masked.doCommit();
    }
    get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue,
            masked: this.masked.state,
            isFilled: this.isFilled
        };
    }
    set state(state) {
        this.masked.state = state.masked;
        this.isFilled = state.isFilled;
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta;
        return {
            ...flags,
            _beforeTailState: (flags == null || (_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.masked) || (flags == null ? void 0 : flags._beforeTailState)
        };
    }
    pad(flags) {
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
    }
}
$8bc8830b315da14a$export$2e2bcd8739ae039.DEFAULT_DEFINITIONS = {
    '0': /\d/,
    'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // http://stackoverflow.com/a/22075070
    '*': /./
};







/** Masking by RegExp */ class $3514f0c5efff08c9$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const mask = opts.mask;
        if (mask) opts.validate = (value)=>value.search(mask) >= 0;
        super._update(opts);
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedRegExp = $3514f0c5efff08c9$export$2e2bcd8739ae039;



/** Pattern mask */ class $855f132dbdeea111$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    /** */ /** */ /** Single char for empty input */ /** Single char for filled input */ /** Show placeholder only when needed */ /** Enable characters overwriting */ /** */ /** */ /** */ constructor(opts){
        super({
            ...$855f132dbdeea111$export$2e2bcd8739ae039.DEFAULTS,
            ...opts,
            definitions: Object.assign({}, (0, $8bc8830b315da14a$export$2e2bcd8739ae039).DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        opts.definitions = Object.assign({}, this.definitions, opts.definitions);
        super._update(opts);
        this._rebuildMask();
    }
    _rebuildMask() {
        const defs = this.definitions;
        this._blocks = [];
        this.exposeBlock = undefined;
        this._stops = [];
        this._maskedBlocks = {};
        const pattern = this.mask;
        if (!pattern || !defs) return;
        let unmaskingBlock = false;
        let optionalBlock = false;
        for(let i = 0; i < pattern.length; ++i){
            if (this.blocks) {
                const p = pattern.slice(i);
                const bNames = Object.keys(this.blocks).filter((bName)=>p.indexOf(bName) === 0);
                // order by key length
                bNames.sort((a, b)=>b.length - a.length);
                // use block name with max length
                const bName = bNames[0];
                if (bName) {
                    const { expose: expose, repeat: repeat, ...bOpts } = (0, $d30869383ae23901$export$a213ae1c699d7230)(this.blocks[bName]); // TODO type Opts<Arg & Extra>
                    const blockOpts = {
                        lazy: this.lazy,
                        eager: this.eager,
                        placeholderChar: this.placeholderChar,
                        displayChar: this.displayChar,
                        overwrite: this.overwrite,
                        autofix: this.autofix,
                        ...bOpts,
                        repeat: repeat,
                        parent: this
                    };
                    const maskedBlock = repeat != null ? new (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).RepeatBlock(blockOpts /* TODO */ ) : (0, $d30869383ae23901$export$2e2bcd8739ae039)(blockOpts);
                    if (maskedBlock) {
                        this._blocks.push(maskedBlock);
                        if (expose) this.exposeBlock = maskedBlock;
                        // store block index
                        if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
                        this._maskedBlocks[bName].push(this._blocks.length - 1);
                    }
                    i += bName.length - 1;
                    continue;
                }
            }
            let char = pattern[i];
            let isInput = char in defs;
            if (char === $855f132dbdeea111$export$2e2bcd8739ae039.STOP_CHAR) {
                this._stops.push(this._blocks.length);
                continue;
            }
            if (char === '{' || char === '}') {
                unmaskingBlock = !unmaskingBlock;
                continue;
            }
            if (char === '[' || char === ']') {
                optionalBlock = !optionalBlock;
                continue;
            }
            if (char === $855f132dbdeea111$export$2e2bcd8739ae039.ESCAPE_CHAR) {
                ++i;
                char = pattern[i];
                if (!char) break;
                isInput = false;
            }
            const def = isInput ? new (0, $8bc8830b315da14a$export$2e2bcd8739ae039)({
                isOptional: optionalBlock,
                lazy: this.lazy,
                eager: this.eager,
                placeholderChar: this.placeholderChar,
                displayChar: this.displayChar,
                ...(0, $d30869383ae23901$export$a213ae1c699d7230)(defs[char]),
                parent: this
            }) : new (0, $f65e3184e2233cc5$export$2e2bcd8739ae039)({
                char: char,
                eager: this.eager,
                isUnmasking: unmaskingBlock
            });
            this._blocks.push(def);
        }
    }
    get state() {
        return {
            ...super.state,
            _blocks: this._blocks.map((b)=>b.state)
        };
    }
    set state(state) {
        if (!state) {
            this.reset();
            return;
        }
        const { _blocks: _blocks, ...maskedState } = state;
        this._blocks.forEach((b, bi)=>b.state = _blocks[bi]);
        super.state = maskedState;
    }
    reset() {
        super.reset();
        this._blocks.forEach((b)=>b.reset());
    }
    get isComplete() {
        return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((b)=>b.isComplete);
    }
    get isFilled() {
        return this._blocks.every((b)=>b.isFilled);
    }
    get isFixed() {
        return this._blocks.every((b)=>b.isFixed);
    }
    get isOptional() {
        return this._blocks.every((b)=>b.isOptional);
    }
    doCommit() {
        this._blocks.forEach((b)=>b.doCommit());
        super.doCommit();
    }
    get unmaskedValue() {
        return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((str, b)=>str += b.unmaskedValue, '');
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.unmaskedValue = unmaskedValue;
            this.appendTail(tail);
            this.doCommit();
        } else super.unmaskedValue = unmaskedValue;
    }
    get value() {
        return this.exposeBlock ? this.exposeBlock.value : // TODO return _value when not in change?
        this._blocks.reduce((str, b)=>str += b.value, '');
    }
    set value(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.value = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.value = value;
    }
    get typedValue() {
        return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
    }
    set typedValue(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.typedValue = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.typedValue = value;
    }
    get displayValue() {
        return this._blocks.reduce((str, b)=>str += b.displayValue, '');
    }
    appendTail(tail) {
        return super.appendTail(tail).aggregate(this._appendPlaceholder());
    }
    _appendEager() {
        var _this$_mapPosToBlock;
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
        if (startBlockIndex == null) return details;
        // TODO test if it works for nested pattern masks
        if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
        for(let bi = startBlockIndex; bi < this._blocks.length; ++bi){
            const d = this._blocks[bi]._appendEager();
            if (!d.inserted) break;
            details.aggregate(d);
        }
        return details;
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const blockIter = this._mapPosToBlock(this.displayValue.length);
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (!blockIter) return details;
        for(let bi = blockIter.index, block; block = this._blocks[bi]; ++bi){
            var _flags$_beforeTailSta;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            details.aggregate(blockDetails);
            if (blockDetails.consumed) break; // go next char
        }
        return details;
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const chunkTail = new (0, $6a2e65700e83fd33$export$2e2bcd8739ae039)();
        if (fromPos === toPos) return chunkTail;
        this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos)=>{
            const blockChunk = b.extractTail(bFromPos, bToPos);
            blockChunk.stop = this._findStopBefore(bi);
            blockChunk.from = this._blockStartPos(bi);
            if (blockChunk instanceof (0, $6a2e65700e83fd33$export$2e2bcd8739ae039)) blockChunk.blockIndex = bi;
            chunkTail.extend(blockChunk);
        });
        return chunkTail;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (flags === void 0) flags = {};
        if (fromPos === toPos) return '';
        let input = '';
        this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos)=>{
            input += b.extractInput(fromPos, toPos, flags);
        });
        return input;
    }
    _findStopBefore(blockIndex) {
        let stopBefore;
        for(let si = 0; si < this._stops.length; ++si){
            const stop = this._stops[si];
            if (stop <= blockIndex) stopBefore = stop;
            else break;
        }
        return stopBefore;
    }
    /** Appends placeholder depending on laziness */ _appendPlaceholder(toBlockIndex) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (this.lazy && toBlockIndex == null) return details;
        const startBlockIter = this._mapPosToBlock(this.displayValue.length);
        if (!startBlockIter) return details;
        const startBlockIndex = startBlockIter.index;
        const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
        this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b)=>{
            if (!b.lazy || toBlockIndex != null) {
                var _blocks2;
                details.aggregate(b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length));
            }
        });
        return details;
    }
    /** Finds block in pos */ _mapPosToBlock(pos) {
        let accVal = '';
        for(let bi = 0; bi < this._blocks.length; ++bi){
            const block = this._blocks[bi];
            const blockStartPos = accVal.length;
            accVal += block.displayValue;
            if (pos <= accVal.length) return {
                index: bi,
                offset: pos - blockStartPos
            };
        }
    }
    _blockStartPos(blockIndex) {
        return this._blocks.slice(0, blockIndex).reduce((pos, b)=>pos += b.displayValue.length, 0);
    }
    _forEachBlocksInRange(fromPos, toPos, fn) {
        if (toPos === void 0) toPos = this.displayValue.length;
        const fromBlockIter = this._mapPosToBlock(fromPos);
        if (fromBlockIter) {
            const toBlockIter = this._mapPosToBlock(toPos);
            // process first block
            const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
            const fromBlockStartPos = fromBlockIter.offset;
            const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
            fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
            if (toBlockIter && !isSameBlock) {
                // process intermediate blocks
                for(let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi)fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
                // process last block
                fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
            }
        }
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            removeDetails.aggregate(b.remove(bFromPos, bToPos));
        });
        return removeDetails;
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $b4195841d15b2d87$export$9106728c49045482).NONE;
        if (!this._blocks.length) return 0;
        const cursor = new (0, $f69f0b66e48a7ef0$export$2e2bcd8739ae039)(this, cursorPos);
        if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).NONE) {
            // -------------------------------------------------
            // NONE should only go out from fixed to the right!
            // -------------------------------------------------
            if (cursor.pushRightBeforeInput()) return cursor.pos;
            cursor.popState();
            if (cursor.pushLeftBeforeInput()) return cursor.pos;
            return this.displayValue.length;
        }
        // FORCE is only about a|* otherwise is 0
        if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).LEFT || direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT) {
            // try to break fast when *|a
            if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeFilled();
                if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
                cursor.popState();
            }
            // forward flow
            cursor.pushLeftBeforeInput();
            cursor.pushLeftBeforeRequired();
            cursor.pushLeftBeforeFilled();
            // backward flow
            if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeInput();
                cursor.pushRightBeforeRequired();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
            }
            if (cursor.ok) return cursor.pos;
            if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT) return 0;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return 0;
        }
        if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT || direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT) {
            // forward flow
            cursor.pushRightBeforeInput();
            cursor.pushRightBeforeRequired();
            if (cursor.pushRightBeforeFilled()) return cursor.pos;
            if (direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT) return this.displayValue.length;
            // backward flow
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return this.nearestInputPos(cursorPos, (0, $b4195841d15b2d87$export$9106728c49045482).LEFT);
        }
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        let total = 0;
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            total += b.totalInputPositions(bFromPos, bToPos);
        });
        return total;
    }
    /** Get block by name */ maskedBlock(name) {
        return this.maskedBlocks(name)[0];
    }
    /** Get all blocks by name */ maskedBlocks(name) {
        const indices = this._maskedBlocks[name];
        if (!indices) return [];
        return indices.map((gi)=>this._blocks[gi]);
    }
    pad(flags) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        this._forEachBlocksInRange(0, this.displayValue.length, (b)=>details.aggregate(b.pad(flags)));
        return details;
    }
}
$855f132dbdeea111$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $9b02b15c72a43b68$export$2e2bcd8739ae039).DEFAULTS,
    lazy: true,
    placeholderChar: '_'
};
$855f132dbdeea111$export$2e2bcd8739ae039.STOP_CHAR = '`';
$855f132dbdeea111$export$2e2bcd8739ae039.ESCAPE_CHAR = '\\';
$855f132dbdeea111$export$2e2bcd8739ae039.InputDefinition = (0, $8bc8830b315da14a$export$2e2bcd8739ae039);
$855f132dbdeea111$export$2e2bcd8739ae039.FixedDefinition = (0, $f65e3184e2233cc5$export$2e2bcd8739ae039);
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedPattern = $855f132dbdeea111$export$2e2bcd8739ae039;














/** Pattern which accepts ranges */ class $cffc19e600b54687$export$2e2bcd8739ae039 extends (0, $855f132dbdeea111$export$2e2bcd8739ae039) {
    /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */ /** Min bound */ /** Max bound */ get _matchFrom() {
        return this.maxLength - String(this.from).length;
    }
    constructor(opts){
        super(opts); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { to: to = this.to || 0, from: from = this.from || 0, maxLength: maxLength = this.maxLength || 0, autofix: autofix = this.autofix, ...patternOpts } = opts;
        this.to = to;
        this.from = from;
        this.maxLength = Math.max(String(to).length, maxLength);
        this.autofix = autofix;
        const fromStr = String(this.from).padStart(this.maxLength, '0');
        const toStr = String(this.to).padStart(this.maxLength, '0');
        let sameCharsCount = 0;
        while(sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount])++sameCharsCount;
        patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);
        super._update(patternOpts);
    }
    get isComplete() {
        return super.isComplete && Boolean(this.value);
    }
    boundaries(str) {
        let minstr = '';
        let maxstr = '';
        const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
        if (num) {
            minstr = '0'.repeat(placeholder.length) + num;
            maxstr = '9'.repeat(placeholder.length) + num;
        }
        minstr = minstr.padEnd(this.maxLength, '0');
        maxstr = maxstr.padEnd(this.maxLength, '9');
        return [
            minstr,
            maxstr
        ];
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        let details;
        [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ''), flags);
        if (!ch) details.skip = !this.isComplete;
        return [
            ch,
            details
        ];
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        if (!this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(ch, flags);
        const fromStr = String(this.from).padStart(this.maxLength, '0');
        const toStr = String(this.to).padStart(this.maxLength, '0');
        const [minstr, maxstr] = this.boundaries(this.value + ch);
        if (Number(maxstr) < this.from) return super._appendCharRaw(fromStr[this.value.length], flags);
        if (Number(minstr) > this.to) {
            if (!flags.tail && this.autofix === 'pad' && this.value.length + 1 < this.maxLength) return super._appendCharRaw(fromStr[this.value.length], flags).aggregate(this._appendCharRaw(ch, flags));
            return super._appendCharRaw(toStr[this.value.length], flags);
        }
        return super._appendCharRaw(ch, flags);
    }
    doValidate(flags) {
        const str = this.value;
        const firstNonZero = str.search(/[^0]/);
        if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
        const [minstr, maxstr] = this.boundaries(str);
        return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags);
    }
    pad(flags) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (this.value.length === this.maxLength) return details;
        const value = this.value;
        const padLength = this.maxLength - this.value.length;
        if (padLength) {
            this.reset();
            for(let i = 0; i < padLength; ++i)details.aggregate(super._appendCharRaw('0', flags));
            // append tail
            value.split('').forEach((ch)=>this._appendCharRaw(ch));
        }
        return details;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedRange = $cffc19e600b54687$export$2e2bcd8739ae039;













const $88a08c76ce88c37c$var$DefaultPattern = 'd{.}`m{.}`Y';
// Make format and parse required when pattern is provided
/** Date mask */ class $88a08c76ce88c37c$export$2e2bcd8739ae039 extends (0, $855f132dbdeea111$export$2e2bcd8739ae039) {
    static extractPatternOptions(opts) {
        const { mask: mask, pattern: pattern, ...patternOpts } = opts;
        return {
            ...patternOpts,
            mask: (0, $b4195841d15b2d87$export$844ec244b1367d54)(mask) ? mask : pattern
        };
    }
    /** Pattern mask for date according to {@link MaskedDate#format} */ /** Start date */ /** End date */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super($88a08c76ce88c37c$export$2e2bcd8739ae039.extractPatternOptions({
            ...$88a08c76ce88c37c$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        }));
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { mask: mask, pattern: pattern, blocks: blocks, ...patternOpts } = {
            ...$88a08c76ce88c37c$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        };
        const patternBlocks = Object.assign({}, $88a08c76ce88c37c$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS());
        // adjust year block
        if (opts.min) patternBlocks.Y.from = opts.min.getFullYear();
        if (opts.max) patternBlocks.Y.to = opts.max.getFullYear();
        if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
            patternBlocks.m.from = opts.min.getMonth() + 1;
            patternBlocks.m.to = opts.max.getMonth() + 1;
            if (patternBlocks.m.from === patternBlocks.m.to) {
                patternBlocks.d.from = opts.min.getDate();
                patternBlocks.d.to = opts.max.getDate();
            }
        }
        Object.assign(patternBlocks, this.blocks, blocks);
        super._update({
            ...patternOpts,
            mask: (0, $b4195841d15b2d87$export$844ec244b1367d54)(mask) ? mask : pattern,
            blocks: patternBlocks
        });
    }
    doValidate(flags) {
        const date = this.date;
        return super.doValidate(flags) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
    /** Checks if date is exists */ isDateExist(str) {
        return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
    /** Parsed Date */ get date() {
        return this.typedValue;
    }
    set date(date) {
        this.typedValue = date;
    }
    get typedValue() {
        return this.isComplete ? super.typedValue : null;
    }
    set typedValue(value) {
        super.typedValue = value;
    }
    maskEquals(mask) {
        return mask === Date || super.maskEquals(mask);
    }
    optionsIsChanged(opts) {
        return super.optionsIsChanged($88a08c76ce88c37c$export$2e2bcd8739ae039.extractPatternOptions(opts));
    }
}
$88a08c76ce88c37c$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS = ()=>({
        d: {
            mask: (0, $cffc19e600b54687$export$2e2bcd8739ae039),
            from: 1,
            to: 31,
            maxLength: 2
        },
        m: {
            mask: (0, $cffc19e600b54687$export$2e2bcd8739ae039),
            from: 1,
            to: 12,
            maxLength: 2
        },
        Y: {
            mask: (0, $cffc19e600b54687$export$2e2bcd8739ae039),
            from: 1900,
            to: 9999
        }
    });
$88a08c76ce88c37c$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $855f132dbdeea111$export$2e2bcd8739ae039).DEFAULTS,
    mask: Date,
    pattern: $88a08c76ce88c37c$var$DefaultPattern,
    format: (date, masked)=>{
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return [
            day,
            month,
            year
        ].join('.');
    },
    parse: (str, masked)=>{
        const [day, month, year] = str.split('.').map(Number);
        return new Date(year, month - 1, day);
    }
};
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedDate = $88a08c76ce88c37c$export$2e2bcd8739ae039;








/** Dynamic mask for choosing appropriate mask in run-time */ class $7708daf759dfe080$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    constructor(opts){
        super({
            ...$7708daf759dfe080$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this.currentMask = undefined;
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        if ('mask' in opts) {
            this.exposeMask = undefined;
            // mask could be totally dynamic with only `dispatch` option
            this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m)=>{
                const { expose: expose, ...maskOpts } = (0, $d30869383ae23901$export$a213ae1c699d7230)(m);
                const masked = (0, $d30869383ae23901$export$2e2bcd8739ae039)({
                    overwrite: this._overwrite,
                    eager: this._eager,
                    skipInvalid: this._skipInvalid,
                    ...maskOpts
                });
                if (expose) this.exposeMask = masked;
                return masked;
            }) : [];
        // this.currentMask = this.doDispatch(''); // probably not needed but lets see
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = this._applyDispatch(ch, flags);
        if (this.currentMask) details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
        return details;
    }
    _applyDispatch(appended, flags, tail) {
        if (appended === void 0) appended = '';
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = '';
        const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
        const inputValue = this.rawInputValue;
        const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
        const tailValue = inputValue.slice(insertValue.length);
        const prevMask = this.currentMask;
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        const prevMaskState = prevMask == null ? void 0 : prevMask.state;
        // clone flags to prevent overwriting `_beforeTailState`
        this.currentMask = this.doDispatch(appended, {
            ...flags
        }, tail);
        // restore state after dispatch
        if (this.currentMask) {
            if (this.currentMask !== prevMask) {
                // if mask changed reapply input
                this.currentMask.reset();
                if (insertValue) {
                    this.currentMask.append(insertValue, {
                        raw: true
                    });
                    details.tailShift = this.currentMask.value.length - prevValueBeforeTail.length;
                }
                if (tailValue) details.tailShift += this.currentMask.append(tailValue, {
                    raw: true,
                    tail: true
                }).tailShift;
            } else if (prevMaskState) // Dispatch can do something bad with state, so
            // restore prev mask state
            this.currentMask.state = prevMaskState;
        }
        return details;
    }
    _appendPlaceholder() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendPlaceholder());
        return details;
    }
    _appendEager() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendEager());
        return details;
    }
    appendTail(tail) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (tail) details.aggregate(this._applyDispatch('', {}, tail));
        return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta, _flags$_beforeTailSta2;
        return {
            ...flags,
            _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
        };
    }
    doDispatch(appended, flags, tail) {
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = '';
        return this.dispatch(appended, this, flags, tail);
    }
    doValidate(flags) {
        return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
    doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepare(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepare(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepareChar(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepareChar(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    reset() {
        var _this$currentMask;
        (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
        this.compiledMasks.forEach((m)=>m.reset());
    }
    get value() {
        return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : '';
    }
    set value(value) {
        if (this.exposeMask) {
            this.exposeMask.value = value;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.value = value;
    }
    get unmaskedValue() {
        return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : '';
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeMask) {
            this.exposeMask.unmaskedValue = unmaskedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : '';
    }
    set typedValue(typedValue) {
        if (this.exposeMask) {
            this.exposeMask.typedValue = typedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
            return;
        }
        let unmaskedValue = String(typedValue);
        // double check it
        if (this.currentMask) {
            this.currentMask.typedValue = typedValue;
            unmaskedValue = this.currentMask.unmaskedValue;
        }
        this.unmaskedValue = unmaskedValue;
    }
    get displayValue() {
        return this.currentMask ? this.currentMask.displayValue : '';
    }
    get isComplete() {
        var _this$currentMask2;
        return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
    }
    get isFilled() {
        var _this$currentMask3;
        return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
    }
    remove(fromPos, toPos) {
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        if (this.currentMask) details.aggregate(this.currentMask.remove(fromPos, toPos))// update with dispatch
        .aggregate(this._applyDispatch());
        return details;
    }
    get state() {
        var _this$currentMask4;
        return {
            ...super.state,
            _rawInputValue: this.rawInputValue,
            compiledMasks: this.compiledMasks.map((m)=>m.state),
            currentMaskRef: this.currentMask,
            currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
        };
    }
    set state(state) {
        const { compiledMasks: compiledMasks, currentMaskRef: currentMaskRef, currentMask: currentMask, ...maskedState } = state;
        if (compiledMasks) this.compiledMasks.forEach((m, mi)=>m.state = compiledMasks[mi]);
        if (currentMaskRef != null) {
            this.currentMask = currentMaskRef;
            this.currentMask.state = currentMask;
        }
        super.state = maskedState;
    }
    extractInput(fromPos, toPos, flags) {
        return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : '';
    }
    extractTail(fromPos, toPos) {
        return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
    }
    doCommit() {
        if (this.currentMask) this.currentMask.doCommit();
        super.doCommit();
    }
    nearestInputPos(cursorPos, direction) {
        return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : super.nearestInputPos(cursorPos, direction);
    }
    get overwrite() {
        return this.currentMask ? this.currentMask.overwrite : this._overwrite;
    }
    set overwrite(overwrite) {
        this._overwrite = overwrite;
    }
    get eager() {
        return this.currentMask ? this.currentMask.eager : this._eager;
    }
    set eager(eager) {
        this._eager = eager;
    }
    get skipInvalid() {
        return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
    }
    set skipInvalid(skipInvalid) {
        this._skipInvalid = skipInvalid;
    }
    get autofix() {
        return this.currentMask ? this.currentMask.autofix : this._autofix;
    }
    set autofix(autofix) {
        this._autofix = autofix;
    }
    maskEquals(mask) {
        return Array.isArray(mask) ? this.compiledMasks.every((m, mi)=>{
            if (!mask[mi]) return;
            const { mask: oldMask, ...restOpts } = mask[mi];
            return (0, $b4195841d15b2d87$export$7aeb68f71172641d)(m, restOpts) && m.maskEquals(oldMask);
        }) : super.maskEquals(mask);
    }
    typedValueEquals(value) {
        var _this$currentMask5;
        return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
    }
}
/** Currently chosen mask */ /** Currently chosen mask */ /** Compliled {@link Masked} options */ /** Chooses {@link Masked} depending on input value */ $7708daf759dfe080$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $9b02b15c72a43b68$export$2e2bcd8739ae039).DEFAULTS,
    dispatch: (appended, masked, flags, tail)=>{
        if (!masked.compiledMasks.length) return;
        const inputValue = masked.rawInputValue;
        // simulate input
        const inputs = masked.compiledMasks.map((m, index)=>{
            const isCurrent = masked.currentMask === m;
            const startInputPos = isCurrent ? m.displayValue.length : m.nearestInputPos(m.displayValue.length, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT);
            if (m.rawInputValue !== inputValue) {
                m.reset();
                m.append(inputValue, {
                    raw: true
                });
            } else if (!isCurrent) m.remove(startInputPos);
            m.append(appended, masked.currentMaskFlags(flags));
            m.appendTail(tail);
            return {
                index: index,
                weight: m.rawInputValue.length,
                totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.displayValue.length, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT)))
            };
        });
        // pop masks with longer values first
        inputs.sort((i1, i2)=>i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
        return masked.compiledMasks[inputs[0].index];
    }
};
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedDynamic = $7708daf759dfe080$export$2e2bcd8739ae039;














/** Pattern which validates enum values */ class $d05fe604ad915261$export$2e2bcd8739ae039 extends (0, $855f132dbdeea111$export$2e2bcd8739ae039) {
    constructor(opts){
        super({
            ...$d05fe604ad915261$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        }); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { enum: enum_, ...eopts } = opts;
        if (enum_) {
            const lengths = enum_.map((e)=>e.length);
            const requiredLength = Math.min(...lengths);
            const optionalLength = Math.max(...lengths) - requiredLength;
            eopts.mask = '*'.repeat(requiredLength);
            if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
            this.enum = enum_;
        }
        super._update(eopts);
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const matchFrom = Math.min(this.nearestInputPos(0, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT), this.value.length);
        const matches = this.enum.filter((e)=>this.matchValue(e, this.unmaskedValue + ch, matchFrom));
        if (matches.length) {
            if (matches.length === 1) this._forEachBlocksInRange(0, this.value.length, (b, bi)=>{
                const mch = matches[0][bi];
                if (bi >= this.value.length || mch === b.value) return;
                b.reset();
                b._appendChar(mch, flags);
            });
            const d = super._appendCharRaw(matches[0][this.value.length], flags);
            if (matches.length === 1) matches[0].slice(this.unmaskedValue.length).split('').forEach((mch)=>d.aggregate(super._appendCharRaw(mch)));
            return d;
        }
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            skip: !this.isComplete
        });
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        // just drop tail
        return new (0, $8648f741d9791934$export$2e2bcd8739ae039)('', fromPos);
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (fromPos === toPos) return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        const matchFrom = Math.min(super.nearestInputPos(0, (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT), this.value.length);
        let pos;
        for(pos = fromPos; pos >= 0; --pos){
            const matches = this.enum.filter((e)=>this.matchValue(e, this.value.slice(matchFrom, pos), matchFrom));
            if (matches.length > 1) break;
        }
        const details = super.remove(pos, toPos);
        details.tailShift += pos - fromPos;
        return details;
    }
    get isComplete() {
        return this.enum.indexOf(this.value) >= 0;
    }
}
/** Match enum value */ $d05fe604ad915261$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $855f132dbdeea111$export$2e2bcd8739ae039).DEFAULTS,
    matchValue: (estr, istr, matchFrom)=>estr.indexOf(istr, matchFrom) === matchFrom
};
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedEnum = $d05fe604ad915261$export$2e2bcd8739ae039;








/** Masking by custom Function */ class $b4d52afcbabd034f$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update({
            ...opts,
            validate: opts.mask
        });
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedFunction = $b4d52afcbabd034f$export$2e2bcd8739ae039;







var $b7b274a57cc86b76$var$_MaskedNumber;
/** Number mask */ class $b7b274a57cc86b76$export$2e2bcd8739ae039 extends (0, $9b02b15c72a43b68$export$2e2bcd8739ae039) {
    /** Single char */ /** Single char */ /** Array of single chars */ /** */ /** */ /** Digits after point */ /** Flag to remove leading and trailing zeros in the end of editing */ /** Flag to pad trailing zeros after point in the end of editing */ /** Enable characters overwriting */ /** */ /** */ /** */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super({
            ...$b7b274a57cc86b76$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        this._updateRegExps();
    }
    _updateRegExps() {
        const start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
        const mid = '\\d*';
        const end = (this.scale ? "(" + (0, $b4195841d15b2d87$export$7c57da42ce8e346f)(this.radix) + "\\d{0," + this.scale + "})?" : '') + '$';
        this._numberRegExp = new RegExp(start + mid + end);
        this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map((0, $b4195841d15b2d87$export$7c57da42ce8e346f)).join('') + "]", 'g');
        this._thousandsSeparatorRegExp = new RegExp((0, $b4195841d15b2d87$export$7c57da42ce8e346f)(this.thousandsSeparator), 'g');
    }
    _removeThousandsSeparators(value) {
        return value.replace(this._thousandsSeparatorRegExp, '');
    }
    _insertThousandsSeparators(value) {
        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        const parts = value.split(this.radix);
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
        return parts.join(this.radix);
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        const [prepCh, details] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */ (flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch), flags);
        if (ch && !prepCh) details.skip = true;
        if (prepCh && !this.allowPositive && !this.value && prepCh !== '-') details.aggregate(this._appendChar('-'));
        return [
            prepCh,
            details
        ];
    }
    _separatorsCount(to, extendOnSeparators) {
        if (extendOnSeparators === void 0) extendOnSeparators = false;
        let count = 0;
        for(let pos = 0; pos < to; ++pos)if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
            ++count;
            if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
        return count;
    }
    _separatorsCountFromSlice(slice) {
        if (slice === void 0) slice = this._value;
        return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
        this._value = this._removeThousandsSeparators(this.value);
        const oldValue = this._value;
        this._value += ch;
        const num = this.number;
        let accepted = !isNaN(num);
        let skip = false;
        if (accepted) {
            let fixedNum;
            if (this.min != null && this.min < 0 && this.number < this.min) fixedNum = this.min;
            if (this.max != null && this.max > 0 && this.number > this.max) fixedNum = this.max;
            if (fixedNum != null) {
                if (this.autofix) {
                    this._value = this.format(fixedNum, this).replace($b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
                    skip || (skip = oldValue === this._value && !flags.tail); // if not changed on tail it's still ok to proceed
                } else accepted = false;
            }
            accepted && (accepted = Boolean(this._value.match(this._numberRegExp)));
        }
        let appendDetails;
        if (!accepted) {
            this._value = oldValue;
            appendDetails = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        } else appendDetails = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            inserted: this._value.slice(oldValue.length),
            rawInserted: skip ? '' : ch,
            skip: skip
        });
        this._value = this._insertThousandsSeparators(this._value);
        const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
        appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
        return appendDetails;
    }
    _findSeparatorAround(pos) {
        if (this.thousandsSeparator) {
            const searchFrom = pos - this.thousandsSeparator.length + 1;
            const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
            if (separatorPos <= pos) return separatorPos;
        }
        return -1;
    }
    _adjustRangeWithSeparators(from, to) {
        const separatorAroundFromPos = this._findSeparatorAround(from);
        if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
        const separatorAroundToPos = this._findSeparatorAround(to);
        if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
        return [
            from,
            to
        ];
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        const valueBeforePos = this.value.slice(0, fromPos);
        const valueAfterPos = this.value.slice(toPos);
        const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
        this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
        return new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)({
            tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
        });
    }
    nearestInputPos(cursorPos, direction) {
        if (!this.thousandsSeparator) return cursorPos;
        switch(direction){
            case (0, $b4195841d15b2d87$export$9106728c49045482).NONE:
            case (0, $b4195841d15b2d87$export$9106728c49045482).LEFT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT:
                {
                    const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
                    if (separatorAtLeftPos >= 0) {
                        const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
                        if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_LEFT) return separatorAtLeftPos;
                    }
                    break;
                }
            case (0, $b4195841d15b2d87$export$9106728c49045482).RIGHT:
            case (0, $b4195841d15b2d87$export$9106728c49045482).FORCE_RIGHT:
                {
                    const separatorAtRightPos = this._findSeparatorAround(cursorPos);
                    if (separatorAtRightPos >= 0) return separatorAtRightPos + this.thousandsSeparator.length;
                }
        }
        return cursorPos;
    }
    doCommit() {
        if (this.value) {
            const number = this.number;
            let validnum = number;
            // check bounds
            if (this.min != null) validnum = Math.max(validnum, this.min);
            if (this.max != null) validnum = Math.min(validnum, this.max);
            if (validnum !== number) this.unmaskedValue = this.format(validnum, this);
            let formatted = this.value;
            if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
            if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
            this._value = formatted;
        }
        super.doCommit();
    }
    _normalizeZeros(value) {
        const parts = this._removeThousandsSeparators(value).split(this.radix);
        // remove leading zeros
        parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num)=>sign + num);
        // add leading zero
        if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';
        if (parts.length > 1) {
            parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros
            if (!parts[1].length) parts.length = 1; // remove fractional
        }
        return this._insertThousandsSeparators(parts.join(this.radix));
    }
    _padFractionalZeros(value) {
        if (!value) return value;
        const parts = value.split(this.radix);
        if (parts.length < 2) parts.push('');
        parts[1] = parts[1].padEnd(this.scale, '0');
        return parts.join(this.radix);
    }
    doSkipInvalid(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === $b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX || this.mapToRadix.includes(ch));
        return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
    }
    get unmaskedValue() {
        return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, $b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX);
    }
    set unmaskedValue(unmaskedValue) {
        super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.parse(this.unmaskedValue, this);
    }
    set typedValue(n) {
        this.rawInputValue = this.format(n, this).replace($b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
    }
    /** Parsed Number */ get number() {
        return this.typedValue;
    }
    set number(number) {
        this.typedValue = number;
    }
    get allowNegative() {
        return this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    get allowPositive() {
        return this.min != null && this.min > 0 || this.max != null && this.max > 0;
    }
    typedValueEquals(value) {
        // handle  0 -> '' case (typed = 0 even if value = '')
        // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
        return (super.typedValueEquals(value) || $b7b274a57cc86b76$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $b7b274a57cc86b76$export$2e2bcd8739ae039.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === '');
    }
}
$b7b274a57cc86b76$var$_MaskedNumber = $b7b274a57cc86b76$export$2e2bcd8739ae039;
$b7b274a57cc86b76$export$2e2bcd8739ae039.UNMASKED_RADIX = '.';
$b7b274a57cc86b76$export$2e2bcd8739ae039.EMPTY_VALUES = [
    ...(0, $9b02b15c72a43b68$export$2e2bcd8739ae039).EMPTY_VALUES,
    0
];
$b7b274a57cc86b76$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $9b02b15c72a43b68$export$2e2bcd8739ae039).DEFAULTS,
    mask: Number,
    radix: ',',
    thousandsSeparator: '',
    mapToRadix: [
        $b7b274a57cc86b76$var$_MaskedNumber.UNMASKED_RADIX
    ],
    min: Number.MIN_SAFE_INTEGER,
    max: Number.MAX_SAFE_INTEGER,
    scale: 2,
    normalizeZeros: true,
    padFractionalZeros: false,
    parse: Number,
    format: (n)=>n.toLocaleString('en-US', {
            useGrouping: false,
            maximumFractionDigits: 20
        })
};
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).MaskedNumber = $b7b274a57cc86b76$export$2e2bcd8739ae039;









/** Mask pipe source and destination types */ const $ace06d054ccb72d8$export$90dab59c3d4b6e03 = {
    MASKED: 'value',
    UNMASKED: 'unmaskedValue',
    TYPED: 'typedValue'
};
/** Creates new pipe function depending on mask type, source and destination options */ function $ace06d054ccb72d8$export$a504d53a5b99e1b9(arg, from, to) {
    if (from === void 0) from = $ace06d054ccb72d8$export$90dab59c3d4b6e03.MASKED;
    if (to === void 0) to = $ace06d054ccb72d8$export$90dab59c3d4b6e03.MASKED;
    const masked = (0, $d30869383ae23901$export$2e2bcd8739ae039)(arg);
    return (value)=>masked.runIsolated((m)=>{
            m[from] = value;
            return m[to];
        });
}
/** Pipes value through mask depending on mask type, source and destination options */ function $ace06d054ccb72d8$export$a4627e546088548d(value, mask, from, to) {
    return $ace06d054ccb72d8$export$a504d53a5b99e1b9(mask, from, to)(value);
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).PIPE_TYPE = $ace06d054ccb72d8$export$90dab59c3d4b6e03;
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).createPipe = $ace06d054ccb72d8$export$a504d53a5b99e1b9;
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).pipe = $ace06d054ccb72d8$export$a4627e546088548d;
















/** Pattern mask */ class $8bb8b34d96ef61f6$export$2e2bcd8739ae039 extends (0, $855f132dbdeea111$export$2e2bcd8739ae039) {
    get repeatFrom() {
        var _ref;
        return (_ref = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null ? _ref : 0;
    }
    get repeatTo() {
        var _ref2;
        return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
    }
    constructor(opts){
        super(opts);
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        var _ref3, _ref4, _this$_blocks;
        const { repeat: repeat, ...blockOpts } = (0, $d30869383ae23901$export$a213ae1c699d7230)(opts); // TODO type
        this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
        const block = (0, $d30869383ae23901$export$2e2bcd8739ae039)(this._blockOpts);
        this.repeat = (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null ? _ref3 : Infinity; // TODO type
        super._update({
            mask: 'm'.repeat(Math.max(this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length) || 0, this.repeatFrom)),
            blocks: {
                m: block
            },
            eager: block.eager,
            overwrite: block.overwrite,
            skipInvalid: block.skipInvalid,
            lazy: block.lazy,
            placeholderChar: block.placeholderChar,
            displayChar: block.displayChar
        });
    }
    _allocateBlock(bi) {
        if (bi < this._blocks.length) return this._blocks[bi];
        if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
            this._blocks.push((0, $d30869383ae23901$export$2e2bcd8739ae039)(this._blockOpts));
            this.mask += 'm';
            return this._blocks[this._blocks.length - 1];
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = new (0, $b285a78e7d6163d8$export$2e2bcd8739ae039)();
        for(let bi = (_this$_mapPosToBlock$ = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index) != null ? _this$_mapPosToBlock$ : Math.max(this._blocks.length - 1, 0), block, allocated; // try to get a block or
        // try to allocate a new block if not allocated already
        block = (_this$_blocks$bi = this._blocks[bi]) != null ? _this$_blocks$bi : allocated = !allocated && this._allocateBlock(bi); ++bi){
            var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            if (blockDetails.skip && allocated) {
                // remove the last allocated block and break
                this._blocks.pop();
                this.mask = this.mask.slice(1);
                break;
            }
            details.aggregate(blockDetails);
            if (blockDetails.consumed) break; // go next char
        }
        return details;
    }
    _trimEmptyTail(fromPos, toPos) {
        var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
        if (fromPos === void 0) fromPos = 0;
        const firstBlockIndex = Math.max(((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0, this.repeatFrom, 0);
        let lastBlockIndex;
        if (toPos != null) lastBlockIndex = (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
        if (lastBlockIndex == null) lastBlockIndex = this._blocks.length - 1;
        let removeCount = 0;
        for(let blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount){
            if (this._blocks[blockIndex].unmaskedValue) break;
        }
        if (removeCount) {
            this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
            this.mask = this.mask.slice(removeCount);
        }
    }
    reset() {
        super.reset();
        this._trimEmptyTail();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._trimEmptyTail(fromPos, toPos);
        return removeDetails;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos == null && this.repeatTo === Infinity) return Infinity;
        return super.totalInputPositions(fromPos, toPos);
    }
    get state() {
        return super.state;
    }
    set state(state) {
        this._blocks.length = state._blocks.length;
        this.mask = this.mask.slice(0, this._blocks.length);
        super.state = state;
    }
}
(0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).RepeatBlock = $8bb8b34d96ef61f6$export$2e2bcd8739ae039;






try {
    globalThis.IMask = (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039);
} catch  {}















var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");


const $15fa0f632c3d3783$var$MASK_PROPS = {
    // common
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).instanceOf(RegExp),
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            Date,
            Number,
            (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).instanceOf((0, $7dec8b23e7031bbf$export$2e2bcd8739ae039).Masked)
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).any,
    unmask: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            'typed'
        ])
    ]),
    prepare: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    prepareChar: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    validate: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    commit: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    overwrite: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            'shift'
        ])
    ]),
    eager: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            'append',
            'remove'
        ])
    ]),
    skipInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
    // events
    onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    // pattern
    placeholderChar: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    displayChar: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    lazy: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
    definitions: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object,
    blocks: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object,
    // enum
    enum: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string),
    // range
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
    // date
    pattern: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    format: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    autofix: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOf([
            'pad'
        ])
    ]),
    // number
    radix: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    thousandsSeparator: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string,
    mapToRadix: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).string),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
    normalizeZeros: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
    padFractionalZeros: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).bool,
    min: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).instanceOf(Date)
    ]),
    max: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).instanceOf(Date)
    ]),
    // dynamic
    dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
    // ref
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($e58e8d2b21900e4d$exports))).object
        })
    ])
};
const $15fa0f632c3d3783$var$MASK_PROPS_NAMES = Object.keys($15fa0f632c3d3783$var$MASK_PROPS).filter((p)=>p !== 'value');
const $15fa0f632c3d3783$var$NON_MASK_OPTIONS_NAMES = [
    'value',
    'unmask',
    'onAccept',
    'onComplete',
    'inputRef'
];
const $15fa0f632c3d3783$var$MASK_OPTIONS_NAMES = $15fa0f632c3d3783$var$MASK_PROPS_NAMES.filter((pName)=>$15fa0f632c3d3783$var$NON_MASK_OPTIONS_NAMES.indexOf(pName) < 0);
function $15fa0f632c3d3783$export$2e2bcd8739ae039(ComposedComponent) {
    var _Class;
    const MaskedComponent = (_Class = class MaskedComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Component {
        constructor(props){
            super(props);
            this._inputRef = this._inputRef.bind(this);
        }
        componentDidMount() {
            if (!this.props.mask) return;
            this.initMask();
        }
        componentDidUpdate() {
            const props = this.props;
            const maskOptions = this._extractMaskOptionsFromProps(props);
            if (maskOptions.mask) {
                if (this.maskRef) {
                    this.maskRef.updateOptions(maskOptions); // TODO fix
                    if ('value' in props && props.value !== undefined) this.maskValue = props.value;
                } else this.initMask(maskOptions);
            } else {
                this.destroyMask();
                if ('value' in props && props.value !== undefined) {
                    var _this$element;
                    if ((_this$element = this.element) != null && _this$element.isContentEditable && this.element.tagName !== 'INPUT' && this.element.tagName !== 'TEXTAREA') this.element.textContent = props.value;
                    else this.element.value = props.value;
                }
            }
        }
        componentWillUnmount() {
            this.destroyMask();
        }
        _inputRef(el) {
            this.element = el;
            if (this.props.inputRef) {
                if (Object.prototype.hasOwnProperty.call(this.props.inputRef, 'current')) this.props.inputRef.current = el;
                else this.props.inputRef(el);
            }
        }
        initMask(maskOptions) {
            if (maskOptions === void 0) maskOptions = this._extractMaskOptionsFromProps(this.props);
            this.maskRef = (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039)(this.element, maskOptions).on('accept', this._onAccept.bind(this)).on('complete', this._onComplete.bind(this));
            if ('value' in this.props && this.props.value !== undefined) this.maskValue = this.props.value;
        }
        destroyMask() {
            if (this.maskRef) {
                this.maskRef.destroy();
                delete this.maskRef;
            }
        }
        _extractMaskOptionsFromProps(props) {
            const { ...cloneProps } = props;
            // keep only mask options
            Object.keys(cloneProps).filter((prop)=>$15fa0f632c3d3783$var$MASK_OPTIONS_NAMES.indexOf(prop) < 0).forEach((nonMaskProp)=>{
                delete cloneProps[nonMaskProp];
            });
            return cloneProps;
        }
        _extractNonMaskProps(props) {
            const { ...cloneProps } = props;
            $15fa0f632c3d3783$var$MASK_PROPS_NAMES.forEach((maskProp)=>{
                if (maskProp !== 'maxLength') delete cloneProps[maskProp];
            });
            if (!('defaultValue' in cloneProps)) cloneProps.defaultValue = props.mask ? '' : cloneProps.value;
            delete cloneProps.value;
            return cloneProps;
        }
        get maskValue() {
            if (!this.maskRef) return '';
            if (this.props.unmask === 'typed') return this.maskRef.typedValue;
            if (this.props.unmask) return this.maskRef.unmaskedValue;
            return this.maskRef.value;
        }
        set maskValue(value) {
            if (!this.maskRef) return;
            value = value == null && this.props.unmask !== 'typed' ? '' : value;
            if (this.props.unmask === 'typed') this.maskRef.typedValue = value;
            else if (this.props.unmask) this.maskRef.unmaskedValue = value;
            else this.maskRef.value = value;
        }
        _onAccept(e) {
            if (this.props.onAccept && this.maskRef) this.props.onAccept(this.maskValue, this.maskRef, e);
        }
        _onComplete(e) {
            if (this.props.onComplete && this.maskRef) this.props.onComplete(this.maskValue, this.maskRef, e);
        }
        render() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(ComposedComponent, {
                ...this._extractNonMaskProps(this.props),
                inputRef: this._inputRef
            });
        }
    }, _Class.displayName = void 0, _Class.propTypes = void 0, _Class);
    const nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
    MaskedComponent.displayName = "IMask(" + nestedComponentName + ")";
    MaskedComponent.propTypes = $15fa0f632c3d3783$var$MASK_PROPS;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef((props, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement(MaskedComponent, {
            ...props,
            ref: ref
        }));
}




const $416d9e5f2c67c58b$var$IMaskInputClass = (0, $15fa0f632c3d3783$export$2e2bcd8739ae039)((_ref)=>{
    let { inputRef: inputRef, ...props } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement('input', {
        ...props,
        ref: inputRef
    });
});
const $416d9e5f2c67c58b$var$IMaskInputFn = (props, ref)=>(0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createElement($416d9e5f2c67c58b$var$IMaskInputClass, {
        ...props,
        ref: ref
    }) // TODO fix no idea
;
const $416d9e5f2c67c58b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).forwardRef($416d9e5f2c67c58b$var$IMaskInputFn);




var $aivMx = parcelRequire("aivMx");
function $175ba8d7564d9b4b$export$2e2bcd8739ae039(opts, _temp) {
    let { onAccept: onAccept, onComplete: onComplete, ref: ref = (0, $aivMx.useRef)(null), defaultValue: defaultValue, defaultUnmaskedValue: defaultUnmaskedValue, defaultTypedValue: defaultTypedValue } = _temp === void 0 ? {} : _temp;
    const maskRef = (0, $aivMx.useRef)(null);
    const [lastAcceptState, setLastAcceptState] = (0, $aivMx.useState)({});
    const [value, setValue] = (0, $aivMx.useState)('');
    const [unmaskedValue, setUnmaskedValue] = (0, $aivMx.useState)('');
    const [typedValue, setTypedValue] = (0, $aivMx.useState)();
    const _destroyMask = (0, $aivMx.useCallback)(()=>{
        var _maskRef$current;
        (_maskRef$current = maskRef.current) == null || _maskRef$current.destroy();
        maskRef.current = null;
    }, []);
    const storeLastAcceptedValues = (0, $aivMx.useCallback)(()=>{
        const m = maskRef.current;
        if (!m) return;
        setLastAcceptState({
            value: m.value,
            unmaskedValue: m.unmaskedValue,
            typedValue: m.typedValue
        });
        setTypedValue(m.typedValue);
        setUnmaskedValue(m.unmaskedValue);
        setValue(m.value);
    }, []);
    const _onAccept = (0, $aivMx.useCallback)((event)=>{
        const m = maskRef.current;
        if (!m) return;
        storeLastAcceptedValues();
        onAccept == null || onAccept(m.value, m, event);
    }, [
        onAccept
    ]);
    const _onComplete = (0, $aivMx.useCallback)((event)=>maskRef.current && (onComplete == null ? void 0 : onComplete(maskRef.current.value, maskRef.current, event)), [
        onComplete
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { value: lastAcceptValue, ...state } = lastAcceptState;
        const mask = maskRef.current;
        if (!mask || value === undefined) return;
        if (lastAcceptValue !== value) {
            mask.value = value;
            if (mask.value !== value) _onAccept();
        }
        setLastAcceptState(state);
    }, [
        value
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { unmaskedValue: lastAcceptUnmaskedValue, ...state } = lastAcceptState;
        const mask = maskRef.current;
        if (!mask || unmaskedValue === undefined) return;
        if (lastAcceptUnmaskedValue !== unmaskedValue) {
            mask.unmaskedValue = unmaskedValue;
            if (mask.unmaskedValue !== unmaskedValue) _onAccept();
        }
        setLastAcceptState(state);
    }, [
        unmaskedValue
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { typedValue: lastAcceptTypedValue, ...state } = lastAcceptState;
        const mask = maskRef.current;
        if (!mask || typedValue === undefined) return;
        if (lastAcceptTypedValue !== typedValue) {
            mask.typedValue = typedValue;
            if (!mask.masked.typedValueEquals(typedValue)) _onAccept();
        }
        setLastAcceptState(state);
    }, [
        typedValue
    ]);
    (0, $aivMx.useEffect)(()=>{
        const el = ref.current;
        if (!el || !(opts != null && opts.mask)) return _destroyMask();
        const mask = maskRef.current;
        if (!mask) {
            if (el && opts != null && opts.mask) {
                maskRef.current = (0, $7dec8b23e7031bbf$export$2e2bcd8739ae039)(el, opts);
                storeLastAcceptedValues();
                if (defaultValue !== undefined) setValue(defaultValue);
                if (defaultUnmaskedValue !== undefined) setUnmaskedValue(defaultUnmaskedValue);
                if (defaultTypedValue !== undefined) setTypedValue(defaultTypedValue);
            }
        } else mask == null || mask.updateOptions(opts); // TODO fix no idea
    }, [
        opts,
        _destroyMask,
        _onAccept
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!maskRef.current) return;
        const mask = maskRef.current;
        mask.on('accept', _onAccept);
        mask.on('complete', _onComplete);
        return ()=>{
            mask.off('accept', _onAccept);
            mask.off('complete', _onComplete);
        };
    }, [
        _onAccept,
        _onComplete
    ]);
    (0, $aivMx.useEffect)(()=>_destroyMask, [
        _destroyMask
    ]);
    return {
        ref: ref,
        maskRef: maskRef,
        value: value,
        setValue: setValue,
        unmaskedValue: unmaskedValue,
        setUnmaskedValue: setUnmaskedValue,
        typedValue: typedValue,
        setTypedValue: setTypedValue
    };
}



parcelRequire("aivMx");





var $94WEq = parcelRequire("94WEq");










var $aivMx = parcelRequire("aivMx");


var $i4YVD = parcelRequire("i4YVD");
var $cdef6bd59ed00ff5$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $cdef6bd59ed00ff5$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $cdef6bd59ed00ff5$var$symbolTag = '[object Symbol]';
/** Used to match words composed of alphanumeric characters. */ var $cdef6bd59ed00ff5$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $cdef6bd59ed00ff5$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $cdef6bd59ed00ff5$var$rsAstralRange = '\\ud800-\\udfff', $cdef6bd59ed00ff5$var$rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', $cdef6bd59ed00ff5$var$rsComboSymbolsRange = '\\u20d0-\\u20f0', $cdef6bd59ed00ff5$var$rsDingbatRange = '\\u2700-\\u27bf', $cdef6bd59ed00ff5$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $cdef6bd59ed00ff5$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $cdef6bd59ed00ff5$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $cdef6bd59ed00ff5$var$rsPunctuationRange = '\\u2000-\\u206f', $cdef6bd59ed00ff5$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $cdef6bd59ed00ff5$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $cdef6bd59ed00ff5$var$rsVarRange = '\\ufe0e\\ufe0f', $cdef6bd59ed00ff5$var$rsBreakRange = $cdef6bd59ed00ff5$var$rsMathOpRange + $cdef6bd59ed00ff5$var$rsNonCharRange + $cdef6bd59ed00ff5$var$rsPunctuationRange + $cdef6bd59ed00ff5$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $cdef6bd59ed00ff5$var$rsApos = "['\u2019]", $cdef6bd59ed00ff5$var$rsAstral = '[' + $cdef6bd59ed00ff5$var$rsAstralRange + ']', $cdef6bd59ed00ff5$var$rsBreak = '[' + $cdef6bd59ed00ff5$var$rsBreakRange + ']', $cdef6bd59ed00ff5$var$rsCombo = '[' + $cdef6bd59ed00ff5$var$rsComboMarksRange + $cdef6bd59ed00ff5$var$rsComboSymbolsRange + ']', $cdef6bd59ed00ff5$var$rsDigits = '\\d+', $cdef6bd59ed00ff5$var$rsDingbat = '[' + $cdef6bd59ed00ff5$var$rsDingbatRange + ']', $cdef6bd59ed00ff5$var$rsLower = '[' + $cdef6bd59ed00ff5$var$rsLowerRange + ']', $cdef6bd59ed00ff5$var$rsMisc = '[^' + $cdef6bd59ed00ff5$var$rsAstralRange + $cdef6bd59ed00ff5$var$rsBreakRange + $cdef6bd59ed00ff5$var$rsDigits + $cdef6bd59ed00ff5$var$rsDingbatRange + $cdef6bd59ed00ff5$var$rsLowerRange + $cdef6bd59ed00ff5$var$rsUpperRange + ']', $cdef6bd59ed00ff5$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $cdef6bd59ed00ff5$var$rsModifier = '(?:' + $cdef6bd59ed00ff5$var$rsCombo + '|' + $cdef6bd59ed00ff5$var$rsFitz + ')', $cdef6bd59ed00ff5$var$rsNonAstral = '[^' + $cdef6bd59ed00ff5$var$rsAstralRange + ']', $cdef6bd59ed00ff5$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $cdef6bd59ed00ff5$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $cdef6bd59ed00ff5$var$rsUpper = '[' + $cdef6bd59ed00ff5$var$rsUpperRange + ']', $cdef6bd59ed00ff5$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $cdef6bd59ed00ff5$var$rsLowerMisc = '(?:' + $cdef6bd59ed00ff5$var$rsLower + '|' + $cdef6bd59ed00ff5$var$rsMisc + ')', $cdef6bd59ed00ff5$var$rsUpperMisc = '(?:' + $cdef6bd59ed00ff5$var$rsUpper + '|' + $cdef6bd59ed00ff5$var$rsMisc + ')', $cdef6bd59ed00ff5$var$rsOptLowerContr = '(?:' + $cdef6bd59ed00ff5$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $cdef6bd59ed00ff5$var$rsOptUpperContr = '(?:' + $cdef6bd59ed00ff5$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $cdef6bd59ed00ff5$var$reOptMod = $cdef6bd59ed00ff5$var$rsModifier + '?', $cdef6bd59ed00ff5$var$rsOptVar = '[' + $cdef6bd59ed00ff5$var$rsVarRange + ']?', $cdef6bd59ed00ff5$var$rsOptJoin = '(?:' + $cdef6bd59ed00ff5$var$rsZWJ + '(?:' + [
    $cdef6bd59ed00ff5$var$rsNonAstral,
    $cdef6bd59ed00ff5$var$rsRegional,
    $cdef6bd59ed00ff5$var$rsSurrPair
].join('|') + ')' + $cdef6bd59ed00ff5$var$rsOptVar + $cdef6bd59ed00ff5$var$reOptMod + ')*', $cdef6bd59ed00ff5$var$rsSeq = $cdef6bd59ed00ff5$var$rsOptVar + $cdef6bd59ed00ff5$var$reOptMod + $cdef6bd59ed00ff5$var$rsOptJoin, $cdef6bd59ed00ff5$var$rsEmoji = '(?:' + [
    $cdef6bd59ed00ff5$var$rsDingbat,
    $cdef6bd59ed00ff5$var$rsRegional,
    $cdef6bd59ed00ff5$var$rsSurrPair
].join('|') + ')' + $cdef6bd59ed00ff5$var$rsSeq, $cdef6bd59ed00ff5$var$rsSymbol = '(?:' + [
    $cdef6bd59ed00ff5$var$rsNonAstral + $cdef6bd59ed00ff5$var$rsCombo + '?',
    $cdef6bd59ed00ff5$var$rsCombo,
    $cdef6bd59ed00ff5$var$rsRegional,
    $cdef6bd59ed00ff5$var$rsSurrPair,
    $cdef6bd59ed00ff5$var$rsAstral
].join('|') + ')';
/** Used to match apostrophes. */ var $cdef6bd59ed00ff5$var$reApos = RegExp($cdef6bd59ed00ff5$var$rsApos, 'g');
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $cdef6bd59ed00ff5$var$reComboMark = RegExp($cdef6bd59ed00ff5$var$rsCombo, 'g');
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $cdef6bd59ed00ff5$var$reUnicode = RegExp($cdef6bd59ed00ff5$var$rsFitz + '(?=' + $cdef6bd59ed00ff5$var$rsFitz + ')|' + $cdef6bd59ed00ff5$var$rsSymbol + $cdef6bd59ed00ff5$var$rsSeq, 'g');
/** Used to match complex or compound words. */ var $cdef6bd59ed00ff5$var$reUnicodeWord = RegExp([
    $cdef6bd59ed00ff5$var$rsUpper + '?' + $cdef6bd59ed00ff5$var$rsLower + '+' + $cdef6bd59ed00ff5$var$rsOptLowerContr + '(?=' + [
        $cdef6bd59ed00ff5$var$rsBreak,
        $cdef6bd59ed00ff5$var$rsUpper,
        '$'
    ].join('|') + ')',
    $cdef6bd59ed00ff5$var$rsUpperMisc + '+' + $cdef6bd59ed00ff5$var$rsOptUpperContr + '(?=' + [
        $cdef6bd59ed00ff5$var$rsBreak,
        $cdef6bd59ed00ff5$var$rsUpper + $cdef6bd59ed00ff5$var$rsLowerMisc,
        '$'
    ].join('|') + ')',
    $cdef6bd59ed00ff5$var$rsUpper + '?' + $cdef6bd59ed00ff5$var$rsLowerMisc + '+' + $cdef6bd59ed00ff5$var$rsOptLowerContr,
    $cdef6bd59ed00ff5$var$rsUpper + '+' + $cdef6bd59ed00ff5$var$rsOptUpperContr,
    $cdef6bd59ed00ff5$var$rsDigits,
    $cdef6bd59ed00ff5$var$rsEmoji
].join('|'), 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $cdef6bd59ed00ff5$var$reHasUnicode = RegExp('[' + $cdef6bd59ed00ff5$var$rsZWJ + $cdef6bd59ed00ff5$var$rsAstralRange + $cdef6bd59ed00ff5$var$rsComboMarksRange + $cdef6bd59ed00ff5$var$rsComboSymbolsRange + $cdef6bd59ed00ff5$var$rsVarRange + ']');
/** Used to detect strings that need a more robust regexp to match words. */ var $cdef6bd59ed00ff5$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */ var $cdef6bd59ed00ff5$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 'ss'
};
/** Detect free variable `global` from Node.js. */ var $cdef6bd59ed00ff5$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $cdef6bd59ed00ff5$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $cdef6bd59ed00ff5$var$root = $cdef6bd59ed00ff5$var$freeGlobal || $cdef6bd59ed00ff5$var$freeSelf || Function('return this')();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $cdef6bd59ed00ff5$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $cdef6bd59ed00ff5$var$asciiToArray(string) {
    return string.split('');
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $cdef6bd59ed00ff5$var$asciiWords(string) {
    return string.match($cdef6bd59ed00ff5$var$reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $cdef6bd59ed00ff5$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $cdef6bd59ed00ff5$var$deburrLetter = $cdef6bd59ed00ff5$var$basePropertyOf($cdef6bd59ed00ff5$var$deburredLetters);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $cdef6bd59ed00ff5$var$hasUnicode(string) {
    return $cdef6bd59ed00ff5$var$reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $cdef6bd59ed00ff5$var$hasUnicodeWord(string) {
    return $cdef6bd59ed00ff5$var$reHasUnicodeWord.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $cdef6bd59ed00ff5$var$stringToArray(string) {
    return $cdef6bd59ed00ff5$var$hasUnicode(string) ? $cdef6bd59ed00ff5$var$unicodeToArray(string) : $cdef6bd59ed00ff5$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $cdef6bd59ed00ff5$var$unicodeToArray(string) {
    return string.match($cdef6bd59ed00ff5$var$reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $cdef6bd59ed00ff5$var$unicodeWords(string) {
    return string.match($cdef6bd59ed00ff5$var$reUnicodeWord) || [];
}
/** Used for built-in method references. */ var $cdef6bd59ed00ff5$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cdef6bd59ed00ff5$var$objectToString = $cdef6bd59ed00ff5$var$objectProto.toString;
/** Built-in value references. */ var $cdef6bd59ed00ff5$var$Symbol = $cdef6bd59ed00ff5$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $cdef6bd59ed00ff5$var$symbolProto = $cdef6bd59ed00ff5$var$Symbol ? $cdef6bd59ed00ff5$var$Symbol.prototype : undefined, $cdef6bd59ed00ff5$var$symbolToString = $cdef6bd59ed00ff5$var$symbolProto ? $cdef6bd59ed00ff5$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $cdef6bd59ed00ff5$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $cdef6bd59ed00ff5$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($cdef6bd59ed00ff5$var$isSymbol(value)) return $cdef6bd59ed00ff5$var$symbolToString ? $cdef6bd59ed00ff5$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$cdef6bd59ed00ff5$var$INFINITY ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cdef6bd59ed00ff5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $cdef6bd59ed00ff5$var$baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $cdef6bd59ed00ff5$var$createCaseFirst(methodName) {
    return function(string) {
        string = $cdef6bd59ed00ff5$var$toString(string);
        var strSymbols = $cdef6bd59ed00ff5$var$hasUnicode(string) ? $cdef6bd59ed00ff5$var$stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cdef6bd59ed00ff5$var$castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $cdef6bd59ed00ff5$var$createCompounder(callback) {
    return function(string) {
        return $cdef6bd59ed00ff5$var$arrayReduce($cdef6bd59ed00ff5$var$words($cdef6bd59ed00ff5$var$deburr(string).replace($cdef6bd59ed00ff5$var$reApos, '')), callback, '');
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cdef6bd59ed00ff5$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $cdef6bd59ed00ff5$var$isSymbol(value) {
    return typeof value == 'symbol' || $cdef6bd59ed00ff5$var$isObjectLike(value) && $cdef6bd59ed00ff5$var$objectToString.call(value) == $cdef6bd59ed00ff5$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $cdef6bd59ed00ff5$var$toString(value) {
    return value == null ? '' : $cdef6bd59ed00ff5$var$baseToString(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $cdef6bd59ed00ff5$var$camelCase = $cdef6bd59ed00ff5$var$createCompounder(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $cdef6bd59ed00ff5$var$capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $cdef6bd59ed00ff5$var$capitalize(string) {
    return $cdef6bd59ed00ff5$var$upperFirst($cdef6bd59ed00ff5$var$toString(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $cdef6bd59ed00ff5$var$deburr(string) {
    string = $cdef6bd59ed00ff5$var$toString(string);
    return string && string.replace($cdef6bd59ed00ff5$var$reLatin, $cdef6bd59ed00ff5$var$deburrLetter).replace($cdef6bd59ed00ff5$var$reComboMark, '');
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $cdef6bd59ed00ff5$var$upperFirst = $cdef6bd59ed00ff5$var$createCaseFirst('toUpperCase');
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $cdef6bd59ed00ff5$var$words(string, pattern, guard) {
    string = $cdef6bd59ed00ff5$var$toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $cdef6bd59ed00ff5$var$hasUnicodeWord(string) ? $cdef6bd59ed00ff5$var$unicodeWords(string) : $cdef6bd59ed00ff5$var$asciiWords(string);
    return string.match(pattern) || [];
}
$cdef6bd59ed00ff5$exports = $cdef6bd59ed00ff5$var$camelCase;



var $94WEq = parcelRequire("94WEq");


var $g1KQj = parcelRequire("g1KQj");








var $4ccf8135492ead97$exports = {};


/**
* @version: 3.1
* @author: Dan Grossman http://www.dangrossman.info/
* @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
* @website: http://www.daterangepicker.com/
*/ // Following the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Make globaly available as well
    define([
        'moment',
        'jquery'
    ], function(moment, jquery) {
        if (!jquery.fn) jquery.fn = {}; // webpack server rendering
        if (typeof moment !== 'function' && moment.hasOwnProperty('default')) moment = moment['default'];
        return factory(moment, jquery);
    });
    else if (0, $4ccf8135492ead97$exports) {
        // Node / Browserify
        //isomorphic issue
        var jQuery = typeof window != 'undefined' ? window.jQuery : undefined;
        if (!jQuery) {
            jQuery = (parcelRequire("i4YVD"));
            if (!jQuery.fn) jQuery.fn = {};
        }
        var moment = typeof window != 'undefined' && typeof window.moment != 'undefined' ? window.moment : (parcelRequire("g1KQj"));
        $4ccf8135492ead97$exports = factory(moment, jQuery);
    } else // Browser globals
    root.daterangepicker = factory(root.moment, root.jQuery);
})($4ccf8135492ead97$exports, function(moment, $) {
    var DateRangePicker = function(element, options, cb) {
        //default settings for options
        this.parentEl = 'body';
        this.element = $(element);
        this.startDate = moment().startOf('day');
        this.endDate = moment().endOf('day');
        this.minDate = false;
        this.maxDate = false;
        this.maxSpan = false;
        this.autoApply = false;
        this.singleDatePicker = false;
        this.showDropdowns = false;
        this.minYear = moment().subtract(100, 'year').format('YYYY');
        this.maxYear = moment().add(100, 'year').format('YYYY');
        this.showWeekNumbers = false;
        this.showISOWeekNumbers = false;
        this.showCustomRangeLabel = true;
        this.timePicker = false;
        this.timePicker24Hour = false;
        this.timePickerIncrement = 1;
        this.timePickerSeconds = false;
        this.linkedCalendars = true;
        this.autoUpdateInput = true;
        this.alwaysShowCalendars = false;
        this.ranges = {};
        this.opens = 'right';
        if (this.element.hasClass('pull-right')) this.opens = 'left';
        this.drops = 'down';
        if (this.element.hasClass('dropup')) this.drops = 'up';
        this.buttonClasses = 'btn btn-sm';
        this.applyButtonClasses = 'btn-primary';
        this.cancelButtonClasses = 'btn-default';
        this.locale = {
            direction: 'ltr',
            format: moment.localeData().longDateFormat('L'),
            separator: ' - ',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: moment.weekdaysMin(),
            monthNames: moment.monthsShort(),
            firstDay: moment.localeData().firstDayOfWeek()
        };
        this.callback = function() {};
        //some state information
        this.isShowing = false;
        this.leftCalendar = {};
        this.rightCalendar = {};
        //custom options from user
        if (typeof options !== 'object' || options === null) options = {};
        //allow setting options with data attributes
        //data-api options will be overwritten with custom javascript options
        options = $.extend(this.element.data(), options);
        //html template for the picker UI
        if (typeof options.template !== 'string' && !(options.template instanceof $)) options.template = '<div class="daterangepicker"><div class="ranges"></div><div class="drp-calendar left"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-calendar right"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-buttons"><span class="drp-selected"></span><button class="cancelBtn" type="button"></button><button class="applyBtn" disabled="disabled" type="button"></button> </div></div>';
        this.parentEl = options.parentEl && $(options.parentEl).length ? $(options.parentEl) : $(this.parentEl);
        this.container = $(options.template).appendTo(this.parentEl);
        //
        // handle all the possible options overriding defaults
        //
        if (typeof options.locale === 'object') {
            if (typeof options.locale.direction === 'string') this.locale.direction = options.locale.direction;
            if (typeof options.locale.format === 'string') this.locale.format = options.locale.format;
            if (typeof options.locale.separator === 'string') this.locale.separator = options.locale.separator;
            if (typeof options.locale.daysOfWeek === 'object') this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
            if (typeof options.locale.monthNames === 'object') this.locale.monthNames = options.locale.monthNames.slice();
            if (typeof options.locale.firstDay === 'number') this.locale.firstDay = options.locale.firstDay;
            if (typeof options.locale.applyLabel === 'string') this.locale.applyLabel = options.locale.applyLabel;
            if (typeof options.locale.cancelLabel === 'string') this.locale.cancelLabel = options.locale.cancelLabel;
            if (typeof options.locale.weekLabel === 'string') this.locale.weekLabel = options.locale.weekLabel;
            if (typeof options.locale.customRangeLabel === 'string') {
                //Support unicode chars in the custom range name.
                var elem = document.createElement('textarea');
                elem.innerHTML = options.locale.customRangeLabel;
                var rangeHtml = elem.value;
                this.locale.customRangeLabel = rangeHtml;
            }
        }
        this.container.addClass(this.locale.direction);
        if (typeof options.startDate === 'string') this.startDate = moment(options.startDate, this.locale.format);
        if (typeof options.endDate === 'string') this.endDate = moment(options.endDate, this.locale.format);
        if (typeof options.minDate === 'string') this.minDate = moment(options.minDate, this.locale.format);
        if (typeof options.maxDate === 'string') this.maxDate = moment(options.maxDate, this.locale.format);
        if (typeof options.startDate === 'object') this.startDate = moment(options.startDate);
        if (typeof options.endDate === 'object') this.endDate = moment(options.endDate);
        if (typeof options.minDate === 'object') this.minDate = moment(options.minDate);
        if (typeof options.maxDate === 'object') this.maxDate = moment(options.maxDate);
        // sanity check for bad options
        if (this.minDate && this.startDate.isBefore(this.minDate)) this.startDate = this.minDate.clone();
        // sanity check for bad options
        if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
        if (typeof options.applyButtonClasses === 'string') this.applyButtonClasses = options.applyButtonClasses;
        if (typeof options.applyClass === 'string') this.applyButtonClasses = options.applyClass;
        if (typeof options.cancelButtonClasses === 'string') this.cancelButtonClasses = options.cancelButtonClasses;
        if (typeof options.cancelClass === 'string') this.cancelButtonClasses = options.cancelClass;
        if (typeof options.maxSpan === 'object') this.maxSpan = options.maxSpan;
        if (typeof options.dateLimit === 'object') this.maxSpan = options.dateLimit;
        if (typeof options.opens === 'string') this.opens = options.opens;
        if (typeof options.drops === 'string') this.drops = options.drops;
        if (typeof options.showWeekNumbers === 'boolean') this.showWeekNumbers = options.showWeekNumbers;
        if (typeof options.showISOWeekNumbers === 'boolean') this.showISOWeekNumbers = options.showISOWeekNumbers;
        if (typeof options.buttonClasses === 'string') this.buttonClasses = options.buttonClasses;
        if (typeof options.buttonClasses === 'object') this.buttonClasses = options.buttonClasses.join(' ');
        if (typeof options.showDropdowns === 'boolean') this.showDropdowns = options.showDropdowns;
        if (typeof options.minYear === 'number') this.minYear = options.minYear;
        if (typeof options.maxYear === 'number') this.maxYear = options.maxYear;
        if (typeof options.showCustomRangeLabel === 'boolean') this.showCustomRangeLabel = options.showCustomRangeLabel;
        if (typeof options.singleDatePicker === 'boolean') {
            this.singleDatePicker = options.singleDatePicker;
            if (this.singleDatePicker) this.endDate = this.startDate.clone();
        }
        if (typeof options.timePicker === 'boolean') this.timePicker = options.timePicker;
        if (typeof options.timePickerSeconds === 'boolean') this.timePickerSeconds = options.timePickerSeconds;
        if (typeof options.timePickerIncrement === 'number') this.timePickerIncrement = options.timePickerIncrement;
        if (typeof options.timePicker24Hour === 'boolean') this.timePicker24Hour = options.timePicker24Hour;
        if (typeof options.autoApply === 'boolean') this.autoApply = options.autoApply;
        if (typeof options.autoUpdateInput === 'boolean') this.autoUpdateInput = options.autoUpdateInput;
        if (typeof options.linkedCalendars === 'boolean') this.linkedCalendars = options.linkedCalendars;
        if (typeof options.isInvalidDate === 'function') this.isInvalidDate = options.isInvalidDate;
        if (typeof options.isCustomDate === 'function') this.isCustomDate = options.isCustomDate;
        if (typeof options.alwaysShowCalendars === 'boolean') this.alwaysShowCalendars = options.alwaysShowCalendars;
        // update day names order to firstDay
        if (this.locale.firstDay != 0) {
            var iterator = this.locale.firstDay;
            while(iterator > 0){
                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
                iterator--;
            }
        }
        var start, end, range;
        //if no start/end dates set, check if an input element contains initial values
        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
            if ($(this.element).is(':text')) {
                var val = $(this.element).val(), split = val.split(this.locale.separator);
                start = end = null;
                if (split.length == 2) {
                    start = moment(split[0], this.locale.format);
                    end = moment(split[1], this.locale.format);
                } else if (this.singleDatePicker && val !== "") {
                    start = moment(val, this.locale.format);
                    end = moment(val, this.locale.format);
                }
                if (start !== null && end !== null) {
                    this.setStartDate(start);
                    this.setEndDate(end);
                }
            }
        }
        if (typeof options.ranges === 'object') {
            for(range in options.ranges){
                if (typeof options.ranges[range][0] === 'string') start = moment(options.ranges[range][0], this.locale.format);
                else start = moment(options.ranges[range][0]);
                if (typeof options.ranges[range][1] === 'string') end = moment(options.ranges[range][1], this.locale.format);
                else end = moment(options.ranges[range][1]);
                // If the start or end date exceed those allowed by the minDate or maxSpan
                // options, shorten the range to the allowable period.
                if (this.minDate && start.isBefore(this.minDate)) start = this.minDate.clone();
                var maxDate = this.maxDate;
                if (this.maxSpan && maxDate && start.clone().add(this.maxSpan).isAfter(maxDate)) maxDate = start.clone().add(this.maxSpan);
                if (maxDate && end.isAfter(maxDate)) end = maxDate.clone();
                // If the end of the range is before the minimum or the start of the range is
                // after the maximum, don't display this range option at all.
                if (this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day') || maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')) continue;
                //Support unicode chars in the range names.
                var elem = document.createElement('textarea');
                elem.innerHTML = range;
                var rangeHtml = elem.value;
                this.ranges[rangeHtml] = [
                    start,
                    end
                ];
            }
            var list = '<ul>';
            for(range in this.ranges)list += '<li data-range-key="' + range + '">' + range + '</li>';
            if (this.showCustomRangeLabel) list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
            list += '</ul>';
            this.container.find('.ranges').prepend(list);
        }
        if (typeof cb === 'function') this.callback = cb;
        if (!this.timePicker) {
            this.startDate = this.startDate.startOf('day');
            this.endDate = this.endDate.endOf('day');
            this.container.find('.calendar-time').hide();
        }
        //can't be used together for now
        if (this.timePicker && this.autoApply) this.autoApply = false;
        if (this.autoApply) this.container.addClass('auto-apply');
        if (typeof options.ranges === 'object') this.container.addClass('show-ranges');
        if (this.singleDatePicker) {
            this.container.addClass('single');
            this.container.find('.drp-calendar.left').addClass('single');
            this.container.find('.drp-calendar.left').show();
            this.container.find('.drp-calendar.right').hide();
            if (!this.timePicker && this.autoApply) this.container.addClass('auto-apply');
        }
        if (typeof options.ranges === 'undefined' && !this.singleDatePicker || this.alwaysShowCalendars) this.container.addClass('show-calendar');
        this.container.addClass('opens' + this.opens);
        //apply CSS classes and labels to buttons
        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
        if (this.applyButtonClasses.length) this.container.find('.applyBtn').addClass(this.applyButtonClasses);
        if (this.cancelButtonClasses.length) this.container.find('.cancelBtn').addClass(this.cancelButtonClasses);
        this.container.find('.applyBtn').html(this.locale.applyLabel);
        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
        //
        // event listeners
        //
        this.container.find('.drp-calendar').on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this)).on('click.daterangepicker', '.next', $.proxy(this.clickNext, this)).on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this)).on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this)).on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this)).on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this)).on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this));
        this.container.find('.ranges').on('click.daterangepicker', 'li', $.proxy(this.clickRange, this));
        this.container.find('.drp-buttons').on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this)).on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this));
        if (this.element.is('input') || this.element.is('button')) this.element.on({
            'click.daterangepicker': $.proxy(this.show, this),
            'focus.daterangepicker': $.proxy(this.show, this),
            'keyup.daterangepicker': $.proxy(this.elementChanged, this),
            'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
        });
        else {
            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
        }
        //
        // if attached to a text input, set the initial value
        //
        this.updateElement();
    };
    DateRangePicker.prototype = {
        constructor: DateRangePicker,
        setStartDate: function(startDate) {
            if (typeof startDate === 'string') this.startDate = moment(startDate, this.locale.format);
            if (typeof startDate === 'object') this.startDate = moment(startDate);
            if (!this.timePicker) this.startDate = this.startDate.startOf('day');
            if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            if (this.minDate && this.startDate.isBefore(this.minDate)) {
                this.startDate = this.minDate.clone();
                if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
                this.startDate = this.maxDate.clone();
                if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            }
            if (!this.isShowing) this.updateElement();
            this.updateMonthsInView();
        },
        setEndDate: function(endDate) {
            if (typeof endDate === 'string') this.endDate = moment(endDate, this.locale.format);
            if (typeof endDate === 'object') this.endDate = moment(endDate);
            if (!this.timePicker) this.endDate = this.endDate.endOf('day');
            if (this.timePicker && this.timePickerIncrement) this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
            if (this.endDate.isBefore(this.startDate)) this.endDate = this.startDate.clone();
            if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();
            if (this.maxSpan && this.startDate.clone().add(this.maxSpan).isBefore(this.endDate)) this.endDate = this.startDate.clone().add(this.maxSpan);
            this.previousRightTime = this.endDate.clone();
            this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            if (!this.isShowing) this.updateElement();
            this.updateMonthsInView();
        },
        isInvalidDate: function() {
            return false;
        },
        isCustomDate: function() {
            return false;
        },
        updateView: function() {
            if (this.timePicker) {
                this.renderTimePicker('left');
                this.renderTimePicker('right');
                if (!this.endDate) this.container.find('.right .calendar-time select').prop('disabled', true).addClass('disabled');
                else this.container.find('.right .calendar-time select').prop('disabled', false).removeClass('disabled');
            }
            if (this.endDate) this.container.find('.drp-selected').html(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
            this.updateMonthsInView();
            this.updateCalendars();
            this.updateFormInputs();
        },
        updateMonthsInView: function() {
            if (this.endDate) {
                //if both dates are visible already, do nothing
                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM')) && (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))) return;
                this.leftCalendar.month = this.startDate.clone().date(2);
                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) this.rightCalendar.month = this.endDate.clone().date(2);
                else this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
            } else if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
                this.leftCalendar.month = this.startDate.clone().date(2);
                this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
            }
            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
                this.rightCalendar.month = this.maxDate.clone().date(2);
                this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
            }
        },
        updateCalendars: function() {
            if (this.timePicker) {
                var hour, minute, second;
                if (this.endDate) {
                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;
                    }
                } else {
                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;
                    }
                }
                this.leftCalendar.month.hour(hour).minute(minute).second(second);
                this.rightCalendar.month.hour(hour).minute(minute).second(second);
            }
            this.renderCalendar('left');
            this.renderCalendar('right');
            //highlight any predefined range matching the current start and end dates
            this.container.find('.ranges li').removeClass('active');
            if (this.endDate == null) return;
            this.calculateChosenLabel();
        },
        renderCalendar: function(side) {
            //
            // Build the matrix of dates that will populate the calendar
            //
            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
            var month = calendar.month.month();
            var year = calendar.month.year();
            var hour = calendar.month.hour();
            var minute = calendar.month.minute();
            var second = calendar.month.second();
            var daysInMonth = moment([
                year,
                month
            ]).daysInMonth();
            var firstDay = moment([
                year,
                month,
                1
            ]);
            var lastDay = moment([
                year,
                month,
                daysInMonth
            ]);
            var lastMonth = moment(firstDay).subtract(1, 'month').month();
            var lastYear = moment(firstDay).subtract(1, 'month').year();
            var daysInLastMonth = moment([
                lastYear,
                lastMonth
            ]).daysInMonth();
            var dayOfWeek = firstDay.day();
            //initialize a 6 rows x 7 columns array for the calendar
            var calendar = [];
            calendar.firstDay = firstDay;
            calendar.lastDay = lastDay;
            for(var i = 0; i < 6; i++)calendar[i] = [];
            //populate the calendar with date objects
            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
            if (startDay > daysInLastMonth) startDay -= 7;
            if (dayOfWeek == this.locale.firstDay) startDay = daysInLastMonth - 6;
            var curDate = moment([
                lastYear,
                lastMonth,
                startDay,
                12,
                minute,
                second
            ]);
            var col, row;
            for(var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')){
                if (i > 0 && col % 7 === 0) {
                    col = 0;
                    row++;
                }
                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
                curDate.hour(12);
                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') calendar[row][col] = this.minDate.clone();
                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') calendar[row][col] = this.maxDate.clone();
            }
            //make the calendar object available to hoverDate/clickDate
            if (side == 'left') this.leftCalendar.calendar = calendar;
            else this.rightCalendar.calendar = calendar;
            //
            // Display the calendar
            //
            var minDate = side == 'left' ? this.minDate : this.startDate;
            var maxDate = this.maxDate;
            var selected = side == 'left' ? this.startDate : this.endDate;
            var arrow = this.locale.direction == 'ltr' ? {
                left: 'chevron-left',
                right: 'chevron-right'
            } : {
                left: 'chevron-right',
                right: 'chevron-left'
            };
            var html = '<table class="table-condensed">';
            html += '<thead>';
            html += '<tr>';
            // add empty cell for week number
            if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th></th>';
            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) html += '<th class="prev available"><span></span></th>';
            else html += '<th></th>';
            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
            if (this.showDropdowns) {
                var currentMonth = calendar[1][1].month();
                var currentYear = calendar[1][1].year();
                var maxYear = maxDate && maxDate.year() || this.maxYear;
                var minYear = minDate && minDate.year() || this.minYear;
                var inMinYear = currentYear == minYear;
                var inMaxYear = currentYear == maxYear;
                var monthHtml = '<select class="monthselect">';
                for(var m = 0; m < 12; m++)if ((!inMinYear || minDate && m >= minDate.month()) && (!inMaxYear || maxDate && m <= maxDate.month())) monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + ">" + this.locale.monthNames[m] + "</option>";
                else monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
                monthHtml += "</select>";
                var yearHtml = '<select class="yearselect">';
                for(var y = minYear; y <= maxYear; y++)yearHtml += '<option value="' + y + '"' + (y === currentYear ? ' selected="selected"' : '') + '>' + y + '</option>';
                yearHtml += '</select>';
                dateHtml = monthHtml + yearHtml;
            }
            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) html += '<th class="next available"><span></span></th>';
            else html += '<th></th>';
            html += '</tr>';
            html += '<tr>';
            // add week number label
            if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th class="week">' + this.locale.weekLabel + '</th>';
            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
                html += '<th>' + dayOfWeek + '</th>';
            });
            html += '</tr>';
            html += '</thead>';
            html += '<tbody>';
            //adjust maxDate to reflect the maxSpan setting in order to
            //grey out end dates beyond the maxSpan
            if (this.endDate == null && this.maxSpan) {
                var maxLimit = this.startDate.clone().add(this.maxSpan).endOf('day');
                if (!maxDate || maxLimit.isBefore(maxDate)) maxDate = maxLimit;
            }
            for(var row = 0; row < 6; row++){
                html += '<tr>';
                // add week number
                if (this.showWeekNumbers) html += '<td class="week">' + calendar[row][0].week() + '</td>';
                else if (this.showISOWeekNumbers) html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
                for(var col = 0; col < 7; col++){
                    var classes = [];
                    //highlight today's date
                    if (calendar[row][col].isSame(new Date(), "day")) classes.push('today');
                    //highlight weekends
                    if (calendar[row][col].isoWeekday() > 5) classes.push('weekend');
                    //grey out the dates in other months displayed at beginning and end of this calendar
                    if (calendar[row][col].month() != calendar[1][1].month()) classes.push('off', 'ends');
                    //don't allow selection of dates before the minimum date
                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day')) classes.push('off', 'disabled');
                    //don't allow selection of dates after the maximum date
                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day')) classes.push('off', 'disabled');
                    //don't allow selection of date if a custom function decides it's invalid
                    if (this.isInvalidDate(calendar[row][col])) classes.push('off', 'disabled');
                    //highlight the currently selected start date
                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD')) classes.push('active', 'start-date');
                    //highlight the currently selected end date
                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD')) classes.push('active', 'end-date');
                    //highlight dates in-between the selected dates
                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate) classes.push('in-range');
                    //apply custom classes for this date
                    var isCustom = this.isCustomDate(calendar[row][col]);
                    if (isCustom !== false) {
                        if (typeof isCustom === 'string') classes.push(isCustom);
                        else Array.prototype.push.apply(classes, isCustom);
                    }
                    var cname = '', disabled = false;
                    for(var i = 0; i < classes.length; i++){
                        cname += classes[i] + ' ';
                        if (classes[i] == 'disabled') disabled = true;
                    }
                    if (!disabled) cname += 'available';
                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
                }
                html += '</tr>';
            }
            html += '</tbody>';
            html += '</table>';
            this.container.find('.drp-calendar.' + side + ' .calendar-table').html(html);
        },
        renderTimePicker: function(side) {
            // Don't bother updating the time picker if it's currently disabled
            // because an end date hasn't been clicked yet
            if (side == 'right' && !this.endDate) return;
            var html, selected, minDate, maxDate = this.maxDate;
            if (this.maxSpan && (!this.maxDate || this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate))) maxDate = this.startDate.clone().add(this.maxSpan);
            if (side == 'left') {
                selected = this.startDate.clone();
                minDate = this.minDate;
            } else if (side == 'right') {
                selected = this.endDate.clone();
                minDate = this.startDate;
                //Preserve the time already selected
                var timeSelector = this.container.find('.drp-calendar.right .calendar-time');
                if (timeSelector.html() != '') {
                    selected.hour(!isNaN(selected.hour()) ? selected.hour() : timeSelector.find('.hourselect option:selected').val());
                    selected.minute(!isNaN(selected.minute()) ? selected.minute() : timeSelector.find('.minuteselect option:selected').val());
                    selected.second(!isNaN(selected.second()) ? selected.second() : timeSelector.find('.secondselect option:selected').val());
                    if (!this.timePicker24Hour) {
                        var ampm = timeSelector.find('.ampmselect option:selected').val();
                        if (ampm === 'PM' && selected.hour() < 12) selected.hour(selected.hour() + 12);
                        if (ampm === 'AM' && selected.hour() === 12) selected.hour(0);
                    }
                }
                if (selected.isBefore(this.startDate)) selected = this.startDate.clone();
                if (maxDate && selected.isAfter(maxDate)) selected = maxDate.clone();
            }
            //
            // hours
            //
            html = '<select class="hourselect">';
            var start = this.timePicker24Hour ? 0 : 1;
            var end = this.timePicker24Hour ? 23 : 12;
            for(var i = start; i <= end; i++){
                var i_in_24 = i;
                if (!this.timePicker24Hour) i_in_24 = selected.hour() >= 12 ? i == 12 ? 12 : i + 12 : i == 12 ? 0 : i;
                var time = selected.clone().hour(i_in_24);
                var disabled = false;
                if (minDate && time.minute(59).isBefore(minDate)) disabled = true;
                if (maxDate && time.minute(0).isAfter(maxDate)) disabled = true;
                if (i_in_24 == selected.hour() && !disabled) html += '<option value="' + i + '" selected="selected">' + i + '</option>';
                else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
                else html += '<option value="' + i + '">' + i + '</option>';
            }
            html += '</select> ';
            //
            // minutes
            //
            html += ': <select class="minuteselect">';
            for(var i = 0; i < 60; i += this.timePickerIncrement){
                var padded = i < 10 ? '0' + i : i;
                var time = selected.clone().minute(i);
                var disabled = false;
                if (minDate && time.second(59).isBefore(minDate)) disabled = true;
                if (maxDate && time.second(0).isAfter(maxDate)) disabled = true;
                if (selected.minute() == i && !disabled) html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                else html += '<option value="' + i + '">' + padded + '</option>';
            }
            html += '</select> ';
            //
            // seconds
            //
            if (this.timePickerSeconds) {
                html += ': <select class="secondselect">';
                for(var i = 0; i < 60; i++){
                    var padded = i < 10 ? '0' + i : i;
                    var time = selected.clone().second(i);
                    var disabled = false;
                    if (minDate && time.isBefore(minDate)) disabled = true;
                    if (maxDate && time.isAfter(maxDate)) disabled = true;
                    if (selected.second() == i && !disabled) html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
                    else if (disabled) html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
                    else html += '<option value="' + i + '">' + padded + '</option>';
                }
                html += '</select> ';
            }
            //
            // AM/PM
            //
            if (!this.timePicker24Hour) {
                html += '<select class="ampmselect">';
                var am_html = '';
                var pm_html = '';
                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) am_html = ' disabled="disabled" class="disabled"';
                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) pm_html = ' disabled="disabled" class="disabled"';
                if (selected.hour() >= 12) html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
                else html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
                html += '</select>';
            }
            this.container.find('.drp-calendar.' + side + ' .calendar-time').html(html);
        },
        updateFormInputs: function() {
            if (this.singleDatePicker || this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate))) this.container.find('button.applyBtn').prop('disabled', false);
            else this.container.find('button.applyBtn').prop('disabled', true);
        },
        move: function() {
            var parentOffset = {
                top: 0,
                left: 0
            }, containerTop, drops = this.drops;
            var parentRightEdge = $(window).width();
            if (!this.parentEl.is('body')) {
                parentOffset = {
                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
                };
                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
            }
            switch(drops){
                case 'auto':
                    containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                    if (containerTop + this.container.outerHeight() >= this.parentEl[0].scrollHeight) {
                        containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                        drops = 'up';
                    }
                    break;
                case 'up':
                    containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
                    break;
                default:
                    containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
                    break;
            }
            // Force the container to it's actual width
            this.container.css({
                top: 0,
                left: 0,
                right: 'auto'
            });
            var containerWidth = this.container.outerWidth();
            this.container.toggleClass('drop-up', drops == 'up');
            if (this.opens == 'left') {
                var containerRight = parentRightEdge - this.element.offset().left - this.element.outerWidth();
                if (containerWidth + containerRight > $(window).width()) this.container.css({
                    top: containerTop,
                    right: 'auto',
                    left: 9
                });
                else this.container.css({
                    top: containerTop,
                    right: containerRight,
                    left: 'auto'
                });
            } else if (this.opens == 'center') {
                var containerLeft = this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2 - containerWidth / 2;
                if (containerLeft < 0) this.container.css({
                    top: containerTop,
                    right: 'auto',
                    left: 9
                });
                else if (containerLeft + containerWidth > $(window).width()) this.container.css({
                    top: containerTop,
                    left: 'auto',
                    right: 0
                });
                else this.container.css({
                    top: containerTop,
                    left: containerLeft,
                    right: 'auto'
                });
            } else {
                var containerLeft = this.element.offset().left - parentOffset.left;
                if (containerLeft + containerWidth > $(window).width()) this.container.css({
                    top: containerTop,
                    left: 'auto',
                    right: 0
                });
                else this.container.css({
                    top: containerTop,
                    left: containerLeft,
                    right: 'auto'
                });
            }
        },
        show: function(e) {
            if (this.isShowing) return;
            // Create a click proxy that is private to this instance of datepicker, for unbinding
            this._outsideClickProxy = $.proxy(function(e) {
                this.outsideClick(e);
            }, this);
            // Bind global datepicker mousedown for hiding and
            $(document).on('mousedown.daterangepicker', this._outsideClickProxy)// also support mobile devices
            .on('touchend.daterangepicker', this._outsideClickProxy)// also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
            .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)// and also close when focus changes to outside the picker (eg. tabbing between controls)
            .on('focusin.daterangepicker', this._outsideClickProxy);
            // Reposition the picker if the window is resized while it's open
            $(window).on('resize.daterangepicker', $.proxy(function(e) {
                this.move(e);
            }, this));
            this.oldStartDate = this.startDate.clone();
            this.oldEndDate = this.endDate.clone();
            this.previousRightTime = this.endDate.clone();
            this.updateView();
            this.container.show();
            this.move();
            this.element.trigger('show.daterangepicker', this);
            this.isShowing = true;
        },
        hide: function(e) {
            if (!this.isShowing) return;
            //incomplete date selection, revert to last values
            if (!this.endDate) {
                this.startDate = this.oldStartDate.clone();
                this.endDate = this.oldEndDate.clone();
            }
            //if a new date range was selected, invoke the user callback function
            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate)) this.callback(this.startDate.clone(), this.endDate.clone(), this.chosenLabel);
            //if picker is attached to a text input, update it
            this.updateElement();
            $(document).off('.daterangepicker');
            $(window).off('.daterangepicker');
            this.container.hide();
            this.element.trigger('hide.daterangepicker', this);
            this.isShowing = false;
        },
        toggle: function(e) {
            if (this.isShowing) this.hide();
            else this.show();
        },
        outsideClick: function(e) {
            var target = $(e.target);
            // if the page is clicked anywhere except within the daterangerpicker/button
            // itself then call this.hide()
            if (// ie modal dialog fix
            e.type == "focusin" || target.closest(this.element).length || target.closest(this.container).length || target.closest('.calendar-table').length) return;
            this.hide();
            this.element.trigger('outsideClick.daterangepicker', this);
        },
        showCalendars: function() {
            this.container.addClass('show-calendar');
            this.move();
            this.element.trigger('showCalendar.daterangepicker', this);
        },
        hideCalendars: function() {
            this.container.removeClass('show-calendar');
            this.element.trigger('hideCalendar.daterangepicker', this);
        },
        clickRange: function(e) {
            var label = e.target.getAttribute('data-range-key');
            this.chosenLabel = label;
            if (label == this.locale.customRangeLabel) this.showCalendars();
            else {
                var dates = this.ranges[label];
                this.startDate = dates[0];
                this.endDate = dates[1];
                if (!this.timePicker) {
                    this.startDate.startOf('day');
                    this.endDate.endOf('day');
                }
                if (!this.alwaysShowCalendars) this.hideCalendars();
                this.clickApply();
            }
        },
        clickPrev: function(e) {
            var cal = $(e.target).parents('.drp-calendar');
            if (cal.hasClass('left')) {
                this.leftCalendar.month.subtract(1, 'month');
                if (this.linkedCalendars) this.rightCalendar.month.subtract(1, 'month');
            } else this.rightCalendar.month.subtract(1, 'month');
            this.updateCalendars();
        },
        clickNext: function(e) {
            var cal = $(e.target).parents('.drp-calendar');
            if (cal.hasClass('left')) this.leftCalendar.month.add(1, 'month');
            else {
                this.rightCalendar.month.add(1, 'month');
                if (this.linkedCalendars) this.leftCalendar.month.add(1, 'month');
            }
            this.updateCalendars();
        },
        hoverDate: function(e) {
            //ignore dates that can't be selected
            if (!$(e.target).hasClass('available')) return;
            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
            //highlight the dates between the start date and the date being hovered as a potential end date
            var leftCalendar = this.leftCalendar;
            var rightCalendar = this.rightCalendar;
            var startDate = this.startDate;
            if (!this.endDate) this.container.find('.drp-calendar tbody td').each(function(index, el) {
                //skip week numbers, only look at dates
                if ($(el).hasClass('week')) return;
                var title = $(el).attr('data-title');
                var row = title.substr(1, 1);
                var col = title.substr(3, 1);
                var cal = $(el).parents('.drp-calendar');
                var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
                if (dt.isAfter(startDate) && dt.isBefore(date) || dt.isSame(date, 'day')) $(el).addClass('in-range');
                else $(el).removeClass('in-range');
            });
        },
        clickDate: function(e) {
            if (!$(e.target).hasClass('available')) return;
            var title = $(e.target).attr('data-title');
            var row = title.substr(1, 1);
            var col = title.substr(3, 1);
            var cal = $(e.target).parents('.drp-calendar');
            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
            //
            // this function needs to do a few things:
            // * alternate between selecting a start and end date for the range,
            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
            // * if autoapply is enabled, and an end date was chosen, apply the selection
            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
            // * if one of the inputs above the calendars was focused, cancel that manual input
            //
            if (this.endDate || date.isBefore(this.startDate, 'day')) {
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.left .ampmselect').val();
                        if (ampm === 'PM' && hour < 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;
                    }
                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find('.left .minuteselect option:last').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.endDate = null;
                this.setStartDate(date.clone());
            } else if (!this.endDate && date.isBefore(this.startDate)) //special case: clicking the same date for start/end,
            //but the time of the end date is before the start date
            this.setEndDate(this.startDate.clone());
            else {
                if (this.timePicker) {
                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
                    if (!this.timePicker24Hour) {
                        var ampm = this.container.find('.right .ampmselect').val();
                        if (ampm === 'PM' && hour < 12) hour += 12;
                        if (ampm === 'AM' && hour === 12) hour = 0;
                    }
                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
                    if (isNaN(minute)) minute = parseInt(this.container.find('.right .minuteselect option:last').val(), 10);
                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
                    date = date.clone().hour(hour).minute(minute).second(second);
                }
                this.setEndDate(date.clone());
                if (this.autoApply) {
                    this.calculateChosenLabel();
                    this.clickApply();
                }
            }
            if (this.singleDatePicker) {
                this.setEndDate(this.startDate);
                if (!this.timePicker && this.autoApply) this.clickApply();
            }
            this.updateView();
            //This is to cancel the blur event handler if the mouse was in one of the inputs
            e.stopPropagation();
        },
        calculateChosenLabel: function() {
            var customRange = true;
            var i = 0;
            for(var range in this.ranges){
                if (this.timePicker) {
                    var format = this.timePickerSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
                    //ignore times when comparing dates if time picker seconds is not enabled
                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
                        customRange = false;
                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                        break;
                    }
                } else //ignore times when comparing dates if time picker is not enabled
                if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
                    customRange = false;
                    this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').attr('data-range-key');
                    break;
                }
                i++;
            }
            if (customRange) {
                if (this.showCustomRangeLabel) this.chosenLabel = this.container.find('.ranges li:last').addClass('active').attr('data-range-key');
                else this.chosenLabel = null;
                this.showCalendars();
            }
        },
        clickApply: function(e) {
            this.hide();
            this.element.trigger('apply.daterangepicker', this);
        },
        clickCancel: function(e) {
            this.startDate = this.oldStartDate;
            this.endDate = this.oldEndDate;
            this.hide();
            this.element.trigger('cancel.daterangepicker', this);
        },
        monthOrYearChanged: function(e) {
            var isLeft = $(e.target).closest('.drp-calendar').hasClass('left'), leftOrRight = isLeft ? 'left' : 'right', cal = this.container.find('.drp-calendar.' + leftOrRight);
            // Month must be Number for new moment versions
            var month = parseInt(cal.find('.monthselect').val(), 10);
            var year = cal.find('.yearselect').val();
            if (!isLeft) {
                if (year < this.startDate.year() || year == this.startDate.year() && month < this.startDate.month()) {
                    month = this.startDate.month();
                    year = this.startDate.year();
                }
            }
            if (this.minDate) {
                if (year < this.minDate.year() || year == this.minDate.year() && month < this.minDate.month()) {
                    month = this.minDate.month();
                    year = this.minDate.year();
                }
            }
            if (this.maxDate) {
                if (year > this.maxDate.year() || year == this.maxDate.year() && month > this.maxDate.month()) {
                    month = this.maxDate.month();
                    year = this.maxDate.year();
                }
            }
            if (isLeft) {
                this.leftCalendar.month.month(month).year(year);
                if (this.linkedCalendars) this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
            } else {
                this.rightCalendar.month.month(month).year(year);
                if (this.linkedCalendars) this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
            }
            this.updateCalendars();
        },
        timeChanged: function(e) {
            var cal = $(e.target).closest('.drp-calendar'), isLeft = cal.hasClass('left');
            var hour = parseInt(cal.find('.hourselect').val(), 10);
            var minute = parseInt(cal.find('.minuteselect').val(), 10);
            if (isNaN(minute)) minute = parseInt(cal.find('.minuteselect option:last').val(), 10);
            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
            if (!this.timePicker24Hour) {
                var ampm = cal.find('.ampmselect').val();
                if (ampm === 'PM' && hour < 12) hour += 12;
                if (ampm === 'AM' && hour === 12) hour = 0;
            }
            if (isLeft) {
                var start = this.startDate.clone();
                start.hour(hour);
                start.minute(minute);
                start.second(second);
                this.setStartDate(start);
                if (this.singleDatePicker) this.endDate = this.startDate.clone();
                else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) this.setEndDate(start.clone());
            } else if (this.endDate) {
                var end = this.endDate.clone();
                end.hour(hour);
                end.minute(minute);
                end.second(second);
                this.setEndDate(end);
            }
            //update the calendars so all clickable dates reflect the new time component
            this.updateCalendars();
            //update the form inputs above the calendars with the new time
            this.updateFormInputs();
            //re-render the time pickers because changing one selection can affect what's enabled in another
            this.renderTimePicker('left');
            this.renderTimePicker('right');
        },
        elementChanged: function() {
            if (!this.element.is('input')) return;
            if (!this.element.val().length) return;
            var dateString = this.element.val().split(this.locale.separator), start = null, end = null;
            if (dateString.length === 2) {
                start = moment(dateString[0], this.locale.format);
                end = moment(dateString[1], this.locale.format);
            }
            if (this.singleDatePicker || start === null || end === null) {
                start = moment(this.element.val(), this.locale.format);
                end = start;
            }
            if (!start.isValid() || !end.isValid()) return;
            this.setStartDate(start);
            this.setEndDate(end);
            this.updateView();
        },
        keydown: function(e) {
            //hide on tab or enter
            if (e.keyCode === 9 || e.keyCode === 13) this.hide();
            //hide on esc and prevent propagation
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();
                this.hide();
            }
        },
        updateElement: function() {
            if (this.element.is('input') && this.autoUpdateInput) {
                var newValue = this.startDate.format(this.locale.format);
                if (!this.singleDatePicker) newValue += this.locale.separator + this.endDate.format(this.locale.format);
                if (newValue !== this.element.val()) this.element.val(newValue).trigger('change');
            }
        },
        remove: function() {
            this.container.remove();
            this.element.off('.daterangepicker');
            this.element.removeData();
        }
    };
    $.fn.daterangepicker = function(options, callback) {
        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
        this.each(function() {
            var el = $(this);
            if (el.data('daterangepicker')) el.data('daterangepicker').remove();
            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
        });
        return this;
    };
    return DateRangePicker;
});





var $b1c1f0d19c8481bd$export$79b718b15081b231;
var $b1c1f0d19c8481bd$export$3c83a39499c722d6;
var $b1c1f0d19c8481bd$export$683472f6198a076e;
$b1c1f0d19c8481bd$export$79b718b15081b231 = `TEjdDq_applyBtn`;
$b1c1f0d19c8481bd$export$3c83a39499c722d6 = `TEjdDq_cancelBtn`;
$b1c1f0d19c8481bd$export$683472f6198a076e = `TEjdDq_disabled`;



const $3fb5be8cad0655cb$var$ranges = (filterMinDate, filterMaxDate, maxSpan)=>{
    const minDate = filterMinDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(filterMinDate) : null;
    const maxDate = filterMaxDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(filterMaxDate) : null;
    const maxSpanDays = maxSpan?.days ? parseInt(maxSpan.days, 10) : null;
    const applyMaxSpan = (start, end)=>{
        if (maxSpanDays) {
            const maxStartDate = end.clone().subtract(maxSpanDays, 'days');
            start = start.isBefore(maxStartDate) ? maxStartDate : start;
        }
        if (maxDate && end.isAfter(maxDate)) end = maxDate;
        return [
            start,
            end
        ];
    };
    return {
        "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('day').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('day'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf('day')),
        "\u0412\u0447\u043E\u0440\u0430": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'day').startOf('day').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'day').startOf('day'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'day').endOf('day')),
        "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('isoWeek').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('isoWeek'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf('isoWeek')),
        "\u041C\u0438\u043D\u0443\u043B\u0438\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'week').startOf('isoWeek').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'week').startOf('isoWeek'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'week').endOf('isoWeek')),
        "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('month').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('month'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf('month')),
        "\u041C\u0438\u043D\u0443\u043B\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'month').startOf('month').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'month').startOf('month'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'month').endOf('month')),
        "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0440\u0456\u043A": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('year').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('year'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf('year')),
        "\u041C\u0438\u043D\u0443\u043B\u0438\u0439 \u0440\u0456\u043A": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'year').startOf('year').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'year').startOf('year'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().subtract(1, 'year').endOf('year')),
        "\u0412\u0435\u0441\u044C \u0447\u0430\u0441": applyMaxSpan(minDate && (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('year').isBefore(minDate) ? minDate : (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().startOf('year'), (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf('year'))
    };
};
const $3fb5be8cad0655cb$var$preprocess = (obj)=>{
    obj = typeof obj === 'string' ? (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(obj) : obj;
    if (obj && typeof obj === 'object') {
        if (typeof obj.locale === 'string') obj.locale = (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(obj.locale);
        if (obj.locale && typeof obj.locale.days_of_week === 'string') obj.locale.days_of_week = (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(obj.locale.days_of_week);
        if (obj.locale && typeof obj.locale.month_names === 'string') obj.locale.month_names = (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(obj.locale.month_names);
    }
    return obj;
};
const $3fb5be8cad0655cb$var$transformKeysDeep = (obj)=>{
    obj = $3fb5be8cad0655cb$var$preprocess(obj);
    if (Array.isArray(obj)) return obj.map((item)=>$3fb5be8cad0655cb$var$transformKeysDeep(item));
    if (obj && typeof obj === 'object') return Object.keys(obj).reduce((acc, key)=>{
        const value = obj[key];
        const newKey = (0, (/*@__PURE__*/$parcel$interopDefault($cdef6bd59ed00ff5$exports)))(key);
        acc[newKey] = $3fb5be8cad0655cb$var$transformKeysDeep(value);
        return acc;
    }, {});
    return obj;
};
const $3fb5be8cad0655cb$var$colorVarMap = {
    applyButtonBg: '--drp-apply-bg',
    applyButtonBorder: '--drp-apply-border',
    applyButtonText: '--drp-apply-text',
    applyButtonBgDisabled: '--drp-apply-bg-disabled',
    applyButtonBorderDisabled: '--drp-apply-border-disabled',
    applyButtonTextDisabled: '--drp-apply-text-disabled',
    cancelButtonBg: '--drp-cancel-bg',
    cancelButtonBorder: '--drp-cancel-border',
    cancelButtonText: '--drp-cancel-text',
    rangeActiveBg: '--drp-range-active-bg',
    rangeActiveText: '--drp-range-active-text',
    rangeHoverBg: '--drp-range-hover-bg'
};
const $3fb5be8cad0655cb$var$applyDrpColors = (container, colors)=>{
    if (!container || !colors || typeof colors !== 'object') return;
    Object.keys(colors).forEach((key)=>{
        const cssVar = $3fb5be8cad0655cb$var$colorVarMap[key];
        const value = colors[key];
        if (cssVar && typeof value === 'string' && value) container.style.setProperty(cssVar, value);
    });
};
const $3fb5be8cad0655cb$var$StyledInput = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
    z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $3fb5be8cad0655cb$var$validateInputPattern = (value, pattern)=>{
    if (!pattern) return true;
    try {
        const regex = new RegExp(pattern);
        return regex.test(value);
    } catch (e) {
        console.error('Invalid regex pattern:', e);
        return true; // Return true if pattern is invalid to avoid blocking input
    }
};
const $3fb5be8cad0655cb$var$getTimeRanges = (inputValue, ranges, separator = ' : ', format = 'HH:mm DD/MM/YY')=>{
    let start;
    let end;
    if (!inputValue) return {
        start: start,
        end: end
    };
    const separatorRegex = new RegExp(`\\s*${separator.trim()}\\s*`);
    if (separatorRegex.test(inputValue)) {
        // Custom range with formatted string
        const [startStr, endStr] = inputValue.split(separatorRegex);
        start = (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(startStr, format);
        end = (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(endStr, format);
    } else if (inputValue.length === 10) {
        if (Number.isNaN(Number(inputValue))) {
            start = (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(inputValue, format);
            end = start;
        } else {
            const startUnix = Number(inputValue);
            start = (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj))).unix(startUnix);
            end = start;
        }
    } else // Predefined ranges
    switch(inputValue){
        case '1d':
            [start, end] = ranges['1 Day'];
            break;
        case '1w':
            [start, end] = ranges['1 Week'];
            break;
        case '2w':
            [start, end] = ranges['2 Weeks'];
            break;
        case '1M':
            [start, end] = ranges['1 Month'];
            break;
        default:
            break; // Invalid input, do nothing
    }
    return {
        start: start,
        end: end
    };
};
const $3fb5be8cad0655cb$var$labelMatcher = {
    '1d': '1 Day',
    '1w': '1 Week',
    '2w': '2 Weeks',
    '1M': '1 Month'
};
const $3fb5be8cad0655cb$var$DateTimePicker = ({ id: id, style: stDraft, placeholder: placeholder, value: valueDraft, tooltip: tooltip, events: eventsDraft, soc: soc, pageSettings: pageSettings, dataLake: dataLake, active_state: activeStateDraft, regexp: regexp, settings: settings, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, parentRef: parentRef, skeleton: renderSkeleton2, parentLoading: parentLoading, parentStyle: parentStyle, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache })=>{
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const [isFocused, setIsFocused] = (0, $aivMx.useState)(false);
    const inputRef = (0, $aivMx.useMemo)(()=>{
        if (parentRef?.current) return parentRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).createRef();
    }, [
        parentRef?.current
    ]);
    const { delay: delay = 500, json: json, ref: ref } = settings || {};
    const transformedJSON = json ? $3fb5be8cad0655cb$var$transformKeysDeep(json) : {};
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    const { style: styleDraft, events: events, active_state: active_state, ref: realRef, value: value } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        value: valueDraft,
        ref: ref,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        value: valueDraft,
        ref: undefined,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'input') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading
    ]);
    // First useMemo to merge active state styles with base style
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, inputRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const { autofocus: autofocus } = style || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const { on_focus: focusStyles, on_change: changeStyles, on_blur: blurStyles, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_regexp_success: regexpSuccessUpdates, on_regexp_error: regexpErorUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    const handleInput = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        const newValue = e.target.value;
        // Check max length
        if (regexp?.max_length && newValue.length > regexp.max_length) return;
        setInternalInputValue(newValue);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: realRef || id,
                value: newValue
            }
        }));
        // Check pattern validation
        if (regexp?.pattern && typeof regexp.pattern === 'string') {
            const result = !$3fb5be8cad0655cb$var$validateInputPattern(newValue, regexp.pattern);
            if (regexpSuccessUpdates && result) {
                const styleUpdates = regexpSuccessUpdates.filter((update)=>update && 'style' in update);
                const requestUpdates = regexpSuccessUpdates.filter((update)=>update && 'request' in update);
                const functionUpdates = regexpSuccessUpdates.filter((update)=>update && 'function' in update);
                const actionUpdates = regexpSuccessUpdates.filter((update)=>update && 'action' in update);
                applyVariablesFirst(regexpSuccessUpdates);
                const runEffects = ()=>{
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                    if (actionUpdates.length) {
                        const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                        handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                    }
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                            location: {
                                pathname: value
                            },
                            silent: silent,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }, filterLoadingState));
                        else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }, filterLoadingState));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
            } else if (regexpErorUpdates && !result) {
                const styleUpdates = regexpErorUpdates.filter((update)=>update && 'style' in update);
                const requestUpdates = regexpErorUpdates.filter((update)=>update && 'request' in update);
                const functionUpdates = regexpErorUpdates.filter((update)=>update && 'function' in update);
                const actionUpdates = regexpErorUpdates.filter((update)=>update && 'action' in update);
                applyVariablesFirst(regexpErorUpdates);
                const runEffects = ()=>{
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                    if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                            location: {
                                pathname: value
                            },
                            silent: silent,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
            }
        }
        if (changeStyles) {
            const styleUpdates = changeStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = changeStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = changeStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = changeStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(changeStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
        if (soc) dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: 'soc',
            delay: delay,
            componentId: id
        }));
    };
    const handleFocus = (e)=>{
        setIsFocused(true);
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (focusStyles) {
            const styleUpdates = focusStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = focusStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = focusStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = focusStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(focusStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleBlur = (e)=>{
        setIsFocused(false);
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (blurStyles) {
            const styleUpdates = blurStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = blurStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = blurStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = blurStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(blurStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(hoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') {
                        const newTimeout = setTimeout(()=>{
                            dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                                value: value,
                                silent: silent,
                                delay: delay,
                                componentId: id,
                                onSuccess: onSuccessUpdates,
                                onError: onErrorUpdates
                            }));
                        }, config?.delay * 1000 || 0);
                        timeoutsRef.current.push(newTimeout);
                    } else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && inputRef.current && !inputRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Handle action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    const prevSelectionRef = (0, $aivMx.useRef)({});
    const [internalInputValue, setInternalInputValue] = (0, $aivMx.useState)('');
    const [isCalendarOpen, setIsCalendarOpen] = (0, $aivMx.useState)(false);
    (0, $aivMx.useEffect)(()=>{
        if (value) {
            const locale = transformedJSON?.locale || {};
            const { separator: separator = ' : ', format: format = 'HH:mm DD/MM/YY' } = locale || {};
            const { start: start, end: end } = $3fb5be8cad0655cb$var$getTimeRanges(value, {}, separator, format);
            const separatorRegex = new RegExp(`\\s*${separator.trim()}\\s*`);
            // Always update internal value when external value changes
            if (separatorRegex.test(value)) setInternalInputValue(`${start?.format(format)} - ${end?.format(format)}`);
            else if (value.length === 10) setInternalInputValue(start?.format(format) || '');
            else setInternalInputValue($3fb5be8cad0655cb$var$labelMatcher[value]);
        } else {
            // Clear internal value when external value is cleared
            setInternalInputValue('');
            if (inputRef.current) {
                inputRef.current.value = '';
                inputRef.current.dates = [];
            }
        }
    }, [
        value
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!isFocused) return;
        const dateRangePickerContainer = document.createElement('div');
        dateRangePickerContainer.id = `dateRangePickerContainer-${id}`;
        document.body.appendChild(dateRangePickerContainer);
        const { start: startUnix, end: endUnix } = $3fb5be8cad0655cb$var$getTimeRanges(value, {}, transformedJSON?.locale?.separator, transformedJSON?.locale?.format);
        // Use refs to store the previous selection for comparison
        prevSelectionRef.current = {
            startStr: startUnix ? startUnix.format(transformedJSON?.locale?.format || 'DD/MM/YYYY') : '',
            endStr: endUnix ? endUnix.format(transformedJSON?.locale?.format || 'DD/MM/YYYY') : ''
        };
        // No value yet: the plugin would default the calendar to TODAY and only clamps
        // that default against minDate (not maxDate), so for a past maxDate the year
        // dropdown shows its first option (minDate's year, e.g. 1930). Open at maxDate
        // instead (clamped up to minDate) so the initial year is inside the range.
        // Parse the bounds with the locale format ("05.06.2008" = 5 June in DD.MM.YYYY).
        const localeFormat = transformedJSON?.locale?.format || 'DD/MM/YYYY';
        const parsedMin = transformedJSON?.minDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(transformedJSON.minDate, localeFormat) : undefined;
        const parsedMax = transformedJSON?.maxDate ? (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))(transformedJSON.maxDate, localeFormat) : undefined;
        let initialStart = startUnix?.isValid() ? startUnix : undefined;
        if (!initialStart && parsedMax?.isValid()) {
            initialStart = parsedMax.clone();
            if (parsedMin?.isValid() && initialStart.isBefore(parsedMin)) initialStart = parsedMin.clone();
        }
        const $dateRangePicker = (0, (/*@__PURE__*/$parcel$interopDefault($i4YVD)))(inputRef.current).daterangepicker({
            startDate: initialStart,
            endDate: endUnix?.isValid() ? endUnix : initialStart,
            ranges: typeof transformedJSON?.ranges === "undefined" ? $3fb5be8cad0655cb$var$ranges(transformedJSON?.minDate, transformedJSON?.maxDate, transformedJSON?.maxSpan) : transformedJSON.ranges,
            cancelButtonClasses: $b1c1f0d19c8481bd$export$3c83a39499c722d6,
            showCustomRangeLabel: false,
            applyButtonClasses: $b1c1f0d19c8481bd$export$79b718b15081b231,
            timePicker: true,
            timePicker24Hour: true,
            timePickerSeconds: false,
            alwaysShowCalendars: true,
            opens: 'left',
            autoUpdateInput: false,
            maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($g1KQj)))().endOf('day'),
            locale: {
                format: 'DD/MM/YYYY',
                separator: ' : ',
                applyLabel: 'Save',
                cancelLabel: 'Cancel',
                fromLabel: 'From',
                toLabel: 'To',
                customRangeLabel: 'Custom',
                weekLabel: 'W',
                daysOfWeek: [
                    'Sub',
                    'Mo',
                    'Tu',
                    'We',
                    'Th',
                    'Fr',
                    'Sa'
                ],
                monthNames: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ],
                firstDay: 1
            },
            ...transformedJSON || {}
        }, (start, end, label)=>{
            if (label === '1 Day' || label === '1 Week' || label === '2 Weeks' || label === '1 Month') setInternalInputValue(label);
            else if (transformedJSON?.singleDatePicker) setInternalInputValue(start.format(transformedJSON.locale?.format));
            else setInternalInputValue(`${start.format(transformedJSON.locale?.format)} - ${end.format(transformedJSON.locale?.format)}`);
            // Create and dispatch a synthetic input event
            const syntheticEvent = {
                target: {
                    value: label === '1 Day' || label === '1 Week' || label === '2 Weeks' || label === '1 Month' ? label : transformedJSON?.singleDatePicker ? start.format(transformedJSON.locale?.format) : `${start.format(transformedJSON.locale?.format)} - ${end.format(transformedJSON.locale?.format)}`
                },
                preventDefault: ()=>{},
                stopPropagation: ()=>{}
            };
            // Call handleInput with the synthetic event
            handleInput(syntheticEvent);
        });
        // // Add an event listener for the "apply.daterangepicker" event
        $dateRangePicker.on('apply.daterangepicker', (ev, picker)=>{
            // Get the current selection
            const currentStartStr = picker.startDate.format(transformedJSON?.locale?.format || 'DD/MM/YYYY');
            const currentEndStr = picker.endDate.format(transformedJSON?.locale?.format || 'DD/MM/YYYY');
            if (picker.chosenLabel === '1 Day' || picker.chosenLabel === '1 Week' || picker.chosenLabel === '2 Weeks' || picker.chosenLabel === '1 Month') setInternalInputValue(picker.chosenLabel);
            else if (transformedJSON?.singleDatePicker) setInternalInputValue(picker.startDate.format(transformedJSON.locale?.format));
            else setInternalInputValue(`${picker.startDate.format(transformedJSON.locale?.format)} - ${picker.endDate.format(transformedJSON.locale?.format)}`);
            // Create and dispatch a synthetic input event
            const syntheticEvent = {
                target: {
                    value: picker.chosenLabel === '1 Day' || picker.chosenLabel === '1 Week' || picker.chosenLabel === '2 Weeks' || picker.chosenLabel === '1 Month' ? picker.chosenLabel : transformedJSON?.singleDatePicker ? picker.startDate.format(transformedJSON.locale?.format) : `${picker.startDate.format(transformedJSON.locale?.format)} - ${picker.endDate.format(transformedJSON.locale?.format)}`
                },
                preventDefault: ()=>{},
                stopPropagation: ()=>{}
            };
            // Call handleInput with the synthetic event
            handleInput(syntheticEvent);
            // Update the previous selection reference
            prevSelectionRef.current = {
                startStr: currentStartStr,
                endStr: currentEndStr
            };
        });
        $dateRangePicker.on('show.daterangepicker', ()=>{
            setIsCalendarOpen(true);
            const $containers = (0, (/*@__PURE__*/$parcel$interopDefault($i4YVD)))('.daterangepicker');
            const $visibleContainer = $containers.filter(function() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($i4YVD)))(this).css('display') !== 'none';
            }).first();
            if ($visibleContainer?.length) {
                $3fb5be8cad0655cb$var$applyDrpColors($visibleContainer[0], transformedJSON?.colors);
                // Apply zoom based on the coefficient
                const zoom = transformedJSON?.style?.zoom || 1;
                $visibleContainer.children().css('zoom', zoom);
                // Calculate total width based on all .drp-calendar elements
                const $calendars = $visibleContainer.find('.drp-calendar');
                const $ranges = $visibleContainer.find('.ranges');
                let totalWidth = 0;
                $calendars.each(function() {
                    // Only include elements that are not hidden
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($i4YVD)))(this).css('display') !== 'none') totalWidth += (0, (/*@__PURE__*/$parcel$interopDefault($i4YVD)))(this).outerWidth(true) || 0;
                });
                $ranges.each(function() {
                    // Only include elements that are not hidden
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($i4YVD)))(this).css('display') !== 'none') totalWidth += (0, (/*@__PURE__*/$parcel$interopDefault($i4YVD)))(this).outerWidth(true) || 0;
                });
                // Apply zoom factor to the width calculation
                if (zoom && zoom !== 1) totalWidth *= zoom;
                // Add padding/margin to ensure everything fits
                if (totalWidth > 0) {
                    // Add some extra space for padding, borders, etc.
                    totalWidth += 10;
                    $visibleContainer.css('width', `${totalWidth}px`);
                }
                const offset = $visibleContainer.offset();
                if (offset) {
                    // Only adjust position if it's outside the viewport
                    const rect = $visibleContainer[0].getBoundingClientRect();
                    // Check if calendar extends beyond viewport edges
                    const windowHeight = window.innerHeight;
                    const hasTopOverflow = rect.top < 0;
                    const hasLeftOverflow = rect.left < 0;
                    const hasBottomOverflow = rect.bottom > windowHeight;
                    if (rect && (hasTopOverflow || hasLeftOverflow || hasBottomOverflow)) {
                        let newTop = offset.top;
                        if (hasTopOverflow) newTop = 0;
                        else if (hasBottomOverflow) {
                            // If overflow at bottom, move the calendar up just enough to fit in viewport
                            const bottomOverflow = rect.bottom - windowHeight;
                            newTop = offset.top - bottomOverflow;
                            // Ensure we don't create a new top overflow
                            newTop = Math.max(0, newTop);
                        }
                        const newLeft = hasLeftOverflow ? 0 : offset.left;
                        // Generate a dynamic class with important styles
                        const dynamicClassName = 'daterangepicker-adjusted-position';
                        const styleElementId = 'daterangepicker-dynamic-styles';
                        // Check if the style element already exists
                        let styleElement = document.getElementById(styleElementId);
                        if (!styleElement) {
                            styleElement = document.createElement('style');
                            styleElement.id = styleElementId;
                            document.head.appendChild(styleElement);
                        }
                        // Add the dynamic styles
                        styleElement.innerHTML = `
            .${dynamicClassName} {
              top: ${newTop}px !important;
              left: ${newLeft}px !important;
              position: absolute !important;
              width: ${totalWidth}px !important;
            }
          `;
                        // Apply the class to the visible container
                        $visibleContainer.addClass(dynamicClassName);
                    }
                }
            }
            const drpSelectedNode = document.querySelector('.drp-selected');
            if (drpSelectedNode && transformedJSON?.singleDatePicker) drpSelectedNode.style.display = 'none';
            else if (drpSelectedNode && typeof transformedJSON?.ranges !== 'undefined') {
                drpSelectedNode.style.left = '34px';
                drpSelectedNode.style.display = 'inline';
            } else if (drpSelectedNode) {
                drpSelectedNode.style.left = '226px';
                drpSelectedNode.style.display = 'inline';
            }
        });
        $dateRangePicker.on('hide.daterangepicker', ()=>{
            setIsCalendarOpen(false);
        });
        $dateRangePicker.data('daterangepicker').show();
        // Cleanup event listeners on component unmount
        return ()=>{
            $dateRangePicker.off('show.daterangepicker');
            $dateRangePicker.off('hide.daterangepicker');
            document.body.removeChild(dateRangePickerContainer);
        };
    }, [
        value,
        id,
        isFocused
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: active_state === 'disabled' || active_state === 'loading'
    });
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($3fb5be8cad0655cb$var$StyledInput, {
        ref: inputRef,
        style: {
            display: style?.visibility === 'hidden' ? 'none' : undefined
        },
        placeholder: placeholder,
        "data-id": realRef || id,
        id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        type: "text",
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        disabled: active_state === 'disabled' || active_state === 'loading',
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        value: internalInputValue,
        title: tooltip,
        autoComplete: "off",
        autoFocus: autofocus,
        onInput: handleInput,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        maxLength: regexp?.max_length
    });
};
var $3fb5be8cad0655cb$export$2e2bcd8739ae039 = $3fb5be8cad0655cb$var$DateTimePicker;


var $896243df65db0cdd$export$2e2bcd8739ae039 = (0, $3fb5be8cad0655cb$export$2e2bcd8739ae039);




const $62d6cd46aaf31470$var$validateInputPattern = (value, pattern, patternFlag)=>{
    if (!value || typeof value !== 'string') return false;
    if (!pattern) return true;
    try {
        const regex = patternFlag ? new RegExp(pattern, patternFlag) : new RegExp(pattern);
        return regex.test(value);
    } catch (e) {
        console.error('Invalid regex pattern or flag:', {
            pattern: pattern,
            patternFlag: patternFlag,
            error: e
        });
        return false; // Fail closed for invalid patterns
    }
};
const $62d6cd46aaf31470$var$StyledInput = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
    z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
// trigger
const $62d6cd46aaf31470$var$StyledTextarea = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).textarea`
  resize: none;
  z-index: 1;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $62d6cd46aaf31470$var$Input = ({ id: id, style: stDraft, placeholder: placeholder, value: valueDraft, tooltip: tooltip, events: eventsDraft, soc: soc, pageSettings: pageSettings, dataLake: dataLake, active_state: activeStateDraft, regexp: regexp, settings: settings, type: type, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, skeleton: renderSkeleton2, parentLoading: parentLoading, parentStyle: parentStyle, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache })=>{
    const { ref: ref } = settings || {};
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const inputRef = (0, $aivMx.useRef)(null);
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    const { delay: delay = 500, autocomplete: autocomplete } = settings || {};
    const { style: styleDraft, events: events, active_state: active_state, ref: realRef, value: value } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        value: valueDraft,
        ref: ref,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        value: valueDraft,
        ref: undefined,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'input') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading
    ]);
    // First useMemo to merge active state styles with base style
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, inputRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const [internalValue, setInternalValue] = (0, $aivMx.useState)(value);
    const { autofocus: autofocus } = style || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const { on_focus: focusStyles, on_change: changeStyles, on_blur: blurStyles, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_regexp_success: regexpSuccessUpdates, on_regexp_error: regexpErrorUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    // Repeatable rows are reconciled by index, so this instance can be reused for a
    // DIFFERENT entity (page change, sort, filter). Re-sync on the row identity too --
    // otherwise a swap between two rows whose stored value is identical (e.g. both empty)
    // leaves the previous row's typed text in place.
    const rowIdentity = realRef || id;
    (0, $aivMx.useEffect)(()=>{
        if (type === 'number' && typeof value === 'string') setInternalValue(value.replace(/,/g, '.'));
        else setInternalValue(value);
    }, [
        type,
        value,
        rowIdentity
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (type === 'number' && typeof value === 'string') {
            if (value !== internalValue) setInternalValue(value.replace(/,/g, '.'));
        } else if (value !== internalValue) setInternalValue(value);
    }, [
        type,
        value,
        rowIdentity
    ]);
    // const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    //   // Если input в фокусе — снимаем фокус, чтобы не менялось значение
    //   if (type === 'number' && document.activeElement === inputRef.current) {
    //     inputRef.current?.blur();
    //     setTimeout(() => {
    //       inputRef.current?.focus();
    //     }, 0);
    //   }
    // };
    const handleInput = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            block: true
        }));
        let newValue = e.target.value;
        // If type is number, allow only digits and one decimal separator
        if (type === 'number') {
            // Replace comma with dot
            newValue = newValue.replace(/,/g, '.');
            // Remove invalid characters (allow digits and one dot)
            newValue = newValue.replace(/[^0-9.]/g, '');
            // Only one dot allowed
            const parts = newValue.split('.');
            if (parts.length > 2) newValue = `${parts[0]}.${parts.slice(1).join('')}`;
        }
        // Check max length
        if (regexp?.max_length && newValue.length > regexp.max_length) return;
        setInternalValue(newValue);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: realRef || id,
                value: newValue
            }
        }));
        // Check pattern validation
        if (changeStyles) {
            const styleUpdates = changeStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = changeStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = changeStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = changeStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(changeStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
        if (regexp?.pattern && typeof regexp.pattern === 'string') {
            const result = $62d6cd46aaf31470$var$validateInputPattern(newValue, regexp.pattern);
            if (regexpErrorUpdates && !result) {
                const styleUpdates = regexpErrorUpdates.filter((update)=>update && 'style' in update);
                const requestUpdates = regexpErrorUpdates.filter((update)=>update && 'request' in update);
                const functionUpdates = regexpErrorUpdates.filter((update)=>update && 'function' in update);
                const actionUpdates = regexpErrorUpdates.filter((update)=>update && 'action' in update);
                applyVariablesFirst(regexpErrorUpdates);
                const runEffects = ()=>{
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                    if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                            location: {
                                pathname: value
                            },
                            silent: silent,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
            } else if (regexpSuccessUpdates && result) {
                const styleUpdates = regexpSuccessUpdates.filter((update)=>update && 'style' in update);
                const requestUpdates = regexpSuccessUpdates.filter((update)=>update && 'request' in update);
                const functionUpdates = regexpSuccessUpdates.filter((update)=>update && 'function' in update);
                const actionUpdates = regexpSuccessUpdates.filter((update)=>update && 'action' in update);
                applyVariablesFirst(regexpSuccessUpdates);
                const runEffects = ()=>{
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                    if (actionUpdates.length) {
                        const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                        handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                    }
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                            location: {
                                pathname: value
                            },
                            silent: silent,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }, filterLoadingState));
                        else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }, filterLoadingState));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
            }
        }
        if (soc) dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: 'soc',
            delay: delay,
            componentId: id
        }));
    };
    const handleKeyDown = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        // TNBEWEB-1989: inputs aren't wrapped in a <form>, so the on-screen keyboard's
        // action button ("Go"/"Next"/"Done") has no submit target — the browser either
        // does nothing or heuristically tabs to an arbitrary field. Define the action
        // explicitly: the action key closes the keyboard by blurring the field. blur()
        // persists the value via handleBlur; preventDefault stops the heuristic tab.
        // Only applies to single-line inputs — <textarea> keeps Enter as newline
        // (TextArea has no handleKeyDown handler).
        if (e.key === 'Enter') {
            e.preventDefault();
            inputRef.current?.blur();
        }
    };
    const handleFocus = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (focusStyles) {
            const styleUpdates = focusStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = focusStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = focusStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = focusStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(focusStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleBlur = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            block: true
        }));
        const newValue = e.target.value;
        setInternalValue(newValue);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: realRef || id,
                value: newValue
            }
        }));
        if (blurStyles) {
            const styleUpdates = blurStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = blurStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = blurStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = blurStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(blurStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(hoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') ;
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && inputRef.current && !inputRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Process action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: active_state === 'disabled' || active_state === 'loading'
    });
    const InputEl = $62d6cd46aaf31470$var$StyledInput;
    return regexp?.mask_pattern ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(InputEl, {
        as: (0, $416d9e5f2c67c58b$export$2e2bcd8739ae039),
        mask: regexp.mask_pattern,
        value: internalValue,
        // onWheel={handleWheel}
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        disabled: active_state === 'disabled',
        inputRef: inputRef,
        placeholder: placeholder,
        "data-id": realRef || id,
        id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        type: type === 'number' ? 'text' : type || 'text',
        style: {
            display: style?.visibility === 'hidden' ? 'none' : undefined
        },
        autoFocus: autofocus,
        maxLength: regexp?.max_length,
        onClick: (e)=>{
            e.stopPropagation();
        },
        $shape: style,
        autoComplete: autocomplete === false ? 'off' : 'on',
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        title: tooltip,
        onInput: handleInput,
        // TNBEWEB-1989: static hint — the action button reads "Done", matching the
        // "close the keyboard" behavior in handleKeyDown (dynamic/configurable label is out of scope).
        enterKeyHint: "done",
        lang: "en"
    }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(InputEl, {
        ref: inputRef,
        style: {
            display: style?.visibility === 'hidden' ? 'none' : undefined
        },
        placeholder: placeholder,
        "data-id": realRef || id,
        id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        type: type === 'number' ? 'text' : type || 'text',
        // onWheel={handleWheel}
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        disabled: active_state === 'disabled',
        "data-component": "input",
        autoComplete: autocomplete === false ? 'off' : 'on',
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        value: internalValue,
        title: tooltip,
        autoFocus: autofocus,
        onInput: handleInput,
        onKeyDown: handleKeyDown,
        onClick: (e)=>e.stopPropagation(),
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        maxLength: regexp?.max_length,
        // TNBEWEB-1989: static hint — the action button reads "Done", matching the
        // "close the keyboard" behavior in handleKeyDown (dynamic/configurable label is out of scope).
        enterKeyHint: "done",
        lang: "en"
    });
};
const $62d6cd46aaf31470$var$TextArea = ({ id: id, style: stDraft, placeholder: placeholder, value: valueDraft, tooltip: tooltip, events: eventsDraft, soc: soc, pageSettings: pageSettings, dataLake: dataLake, active_state: activeStateDraft, regexp: regexp, settings: settings, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, skeleton: renderSkeleton2, parentLoading: parentLoading, parentStyle: parentStyle, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache })=>{
    const { ref: ref } = settings || {};
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const inputRef = (0, $aivMx.useRef)(null);
    const { delay: delay = 500 } = settings || {};
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    const { style: styleDraft, events: events, active_state: active_state, ref: realRef, value: value } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        value: valueDraft,
        ref: ref,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        value: valueDraft,
        ref: undefined,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'input') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading
    ]);
    // First useMemo to merge active state styles with base style
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, inputRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const [internalValue, setInternalValue] = (0, $aivMx.useState)(value);
    const { autofocus: autofocus } = style || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const { on_focus: focusStyles, on_change: changeStyles, on_blur: blurStyles, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_regexp_success: regexpSuccessUpdates, on_regexp_error: regexpErrorUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    // See the note in Input: re-sync on row identity so a reused instance cannot keep
    // the previous entity's typed text when both rows share the same stored value.
    const rowIdentity = realRef || id;
    (0, $aivMx.useEffect)(()=>{
        setInternalValue(value);
    }, [
        value,
        rowIdentity
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (value !== internalValue) setInternalValue(value);
    }, [
        value,
        rowIdentity
    ]);
    const handleInput = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            block: true
        }));
        const newValue = e.target.value;
        // Check max length
        if (regexp?.max_length && newValue.length > regexp.max_length) return;
        setInternalValue(newValue);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: realRef || id,
                value: newValue
            }
        }));
        // Check pattern validation
        if (changeStyles) {
            const styleUpdates = changeStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = changeStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = changeStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = changeStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(changeStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
        if (regexp?.pattern && typeof regexp.pattern === 'string') {
            const result = $62d6cd46aaf31470$var$validateInputPattern(newValue, regexp.pattern, 'gs');
            if (regexpErrorUpdates && !result) {
                const styleUpdates = regexpErrorUpdates.filter((update)=>update && 'style' in update);
                const requestUpdates = regexpErrorUpdates.filter((update)=>update && 'request' in update);
                const functionUpdates = regexpErrorUpdates.filter((update)=>update && 'function' in update);
                const actionUpdates = regexpErrorUpdates.filter((update)=>update && 'action' in update);
                applyVariablesFirst(regexpErrorUpdates);
                const runEffects = ()=>{
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                    if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                            location: {
                                pathname: value
                            },
                            silent: silent,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
            } else if (regexpSuccessUpdates && result) {
                const styleUpdates = regexpSuccessUpdates.filter((update)=>update && 'style' in update);
                const requestUpdates = regexpSuccessUpdates.filter((update)=>update && 'request' in update);
                const functionUpdates = regexpSuccessUpdates.filter((update)=>update && 'function' in update);
                const actionUpdates = regexpSuccessUpdates.filter((update)=>update && 'action' in update);
                applyVariablesFirst(regexpSuccessUpdates);
                const runEffects = ()=>{
                    if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                    if (actionUpdates.length) {
                        const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                        handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                    }
                    if (requestUpdates.length) requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                            location: {
                                pathname: value
                            },
                            silent: silent,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }, filterLoadingState));
                        else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }, filterLoadingState));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
            }
        }
        if (soc) dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: 'soc',
            delay: delay,
            componentId: id
        }));
    };
    const handleFocus = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (focusStyles) {
            const styleUpdates = focusStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = focusStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = focusStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = focusStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(focusStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleBlur = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            block: true
        }));
        const newValue = e.target.value;
        setInternalValue(newValue);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: realRef || id,
                value: newValue
            }
        }));
        if (blurStyles) {
            const styleUpdates = blurStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = blurStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = blurStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = blurStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(blurStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(hoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') {
                        const newTimeout = setTimeout(()=>{
                            dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                                value: value,
                                silent: silent,
                                delay: delay,
                                componentId: id,
                                onSuccess: onSuccessUpdates,
                                onError: onErrorUpdates
                            }));
                        }, config?.delay * 1000 || 0);
                        timeoutsRef.current.push(newTimeout);
                    } else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && inputRef.current && !inputRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Handle action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: active_state === 'disabled' || active_state === 'loading'
    });
    const TextareaEl = $62d6cd46aaf31470$var$StyledTextarea;
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(TextareaEl, {
        ref: inputRef,
        placeholder: placeholder,
        "data-id": realRef || id,
        id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        value: internalValue,
        title: tooltip,
        autoFocus: autofocus,
        disabled: active_state === 'disabled',
        onInput: handleInput,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        maxLength: regexp?.max_length
    });
};
const $62d6cd46aaf31470$var$Email = ({ id: id, style: style, placeholder: placeholder })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        placeholder: placeholder,
        id: id,
        type: "email",
        $shape: style,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
const $62d6cd46aaf31470$var$Number = ({ id: id, style: style, placeholder: placeholder })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        placeholder: placeholder,
        id: id,
        type: "number",
        $shape: style,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
const $62d6cd46aaf31470$var$File = ({ id: id, style: style, placeholder: placeholder })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        placeholder: placeholder,
        id: id,
        type: "file",
        $shape: style,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
const $62d6cd46aaf31470$var$Phone = ({ id: id, style: style, placeholder: placeholder })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$StyledInput, {
        placeholder: placeholder,
        id: id,
        type: "tel",
        $shape: style,
        "data-component": "input",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class)
    });
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $62d6cd46aaf31470$var$Global = (props)=>{
    const { type: type } = props;
    switch(type){
        case 'text':
        case 'password':
        case 'number':
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Input, {
                ...props
            });
        case 'textarea':
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$TextArea, {
                ...props
            });
        // case 'password':
        //   return <Password {...props} />;
        case 'email':
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Email, {
                ...props
            });
        case 'number':
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Number, {
                ...props
            });
        case 'file':
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$File, {
                ...props
            });
        case 'phone':
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Phone, {
                ...props
            });
        case 'daterangepicker':
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $896243df65db0cdd$export$2e2bcd8739ae039), {
                ...props
            });
        default:
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($62d6cd46aaf31470$var$Input, {
                ...props
            });
    }
};
var $62d6cd46aaf31470$export$2e2bcd8739ae039 = $62d6cd46aaf31470$var$Global;


var $7ea0c43ec9b05f7e$export$2e2bcd8739ae039 = (0, $62d6cd46aaf31470$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");







parcelRequire("aivMx");
const $b4c89c9d73897b7f$var$SvgRadioChecked = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                fill: "#7F56D9",
                d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8"
            }),
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                fill: "#fff",
                d: "M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
            })
        ]
    });
var $b4c89c9d73897b7f$export$2e2bcd8739ae039 = $b4c89c9d73897b7f$var$SvgRadioChecked;



parcelRequire("aivMx");
const $e7abda7e005876c0$var$SvgRadioUnchecked = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
            stroke: "#D0D5DD",
            d: "M.5 8a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z"
        })
    });
var $e7abda7e005876c0$export$2e2bcd8739ae039 = $e7abda7e005876c0$var$SvgRadioUnchecked;






const $6858d9d764342496$var$StyledRadioLabel = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).label`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 0;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $6858d9d764342496$var$StyledRadio = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
  z-index: 1;
  cursor: pointer;
  margin: 0;
  padding: 0;
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
`;
const $6858d9d764342496$var$Radio = ({ id: id, style: stDraft, name: name, events: eventsDraft, soc: soc, value: valueDraft, pageSettings: pageSettings, dataLake: dataLake, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, settings: settings, skeleton: renderSkeleton2, parentLoading: parentLoading, parentStyle: parentStyle, active_state: activeStateDraft, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache })=>{
    const { ref: ref } = settings || {};
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const containerRef = (0, $aivMx.useRef)(null);
    const { style: styleDraft, events: events, active_state: active_state, value: value, ref: realRef, name: parsedName } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        ref: ref,
        value: valueDraft,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft,
        name: name
    }, dataLake.data) : {
        ref: undefined,
        value: valueDraft,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft,
        name: name
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'radio') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading
    ]);
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    // First useMemo to merge active state styles with base style
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, containerRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const [checkedInternal, setCheckedInternal] = (0, $aivMx.useState)(value === 'true' ? true : value === 'false' ? false : value);
    const debouncedSubmitForm = (0, $aivMx.useCallback)((0, $7b0e169a5380005e$export$61fc7d43ac8f84b0)(()=>{
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: 'soc',
            componentId: id
        }));
    }, 500), []);
    (0, $aivMx.useEffect)(()=>{
        setCheckedInternal(value === 'true' ? true : value === 'false' ? false : value);
    }, [
        value
    ]);
    const { on_change: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const handleCheckboxChange = ()=>{
        if (checkedInternal && checkedInternal !== 'false') return;
        setCheckedInternal(!checkedInternal);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: realRef || id,
                value: !checkedInternal
            }
        }));
        dispatch((0, $8eba69c5466928d3$export$c75cc2fedb4914bf)({
            excludeId: realRef || id,
            name: parsedName,
            originalName: name
        }));
        if (soc) debouncedSubmitForm(!checkedInternal);
    };
    const handleClick = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        handleCheckboxChange();
        e.preventDefault();
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = clickUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = clickUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = clickUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(clickUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(hoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const styleUpdates = launchUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') ;
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && containerRef.current && !containerRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Handle action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: active_state === 'disabled' || active_state === 'loading'
    });
    // Mouse handlers are typed for the div/input event the shared executeFunction
    // expects; the label element they're bound to differs, so keep the element
    // alias untyped (matches the previously-spread motionAnimProps: any).
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const LabelEl = $6858d9d764342496$var$StyledRadioLabel;
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)(LabelEl, {
        ref: containerRef,
        htmlFor: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": "radio",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        onClick: handleClick,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($6858d9d764342496$var$StyledRadio, {
                "data-id": realRef || id,
                id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
                name: parsedName,
                value: id,
                type: "radio",
                checked: checkedInternal
            }),
            checkedInternal ? settings?.icons?.active ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
                style: {
                    maxWidth: '100%',
                    maxHeight: '100%'
                },
                src: settings.icons.active
            }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $b4c89c9d73897b7f$export$2e2bcd8739ae039), {}) : settings?.icons?.inactive ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("img", {
                style: {
                    maxWidth: '100%',
                    maxHeight: '100%'
                },
                src: settings.icons.inactive
            }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $e7abda7e005876c0$export$2e2bcd8739ae039), {})
        ]
    });
};
var $6858d9d764342496$export$2e2bcd8739ae039 = $6858d9d764342496$var$Radio;


var $b35bf230db392315$export$2e2bcd8739ae039 = (0, $6858d9d764342496$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");








parcelRequire("aivMx");
const $b08c9de2ff5f2c28$var$SvgXClose = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
            stroke: "#000",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M18 6 6 18M6 6l12 12"
        })
    });
var $b08c9de2ff5f2c28$export$2e2bcd8739ae039 = $b08c9de2ff5f2c28$var$SvgXClose;







parcelRequire("aivMx");
const $c07e36697bce3a79$var$SvgChevronDown = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
            stroke: "#667085",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.667,
            d: "m5 7.5 5 5 5-5"
        })
    });
var $c07e36697bce3a79$export$2e2bcd8739ae039 = $c07e36697bce3a79$var$SvgChevronDown;


var $cd0af89cb2a229cd$export$5cfb6affd60879e9;
var $cd0af89cb2a229cd$export$a1499cbfa2755cde;
var $cd0af89cb2a229cd$export$f26c97331adc89d5;
var $cd0af89cb2a229cd$export$ff8e94cb38bad9e7;
$cd0af89cb2a229cd$export$5cfb6affd60879e9 = `BDHbBq_chipIcon`;
$cd0af89cb2a229cd$export$a1499cbfa2755cde = `BDHbBq_chipItem`;
$cd0af89cb2a229cd$export$f26c97331adc89d5 = `BDHbBq_selectItem`;
$cd0af89cb2a229cd$export$ff8e94cb38bad9e7 = `BDHbBq_selectItemsContainer`;


const $c98b0135d71b9ff2$var$SelectWrapper = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  z-index: 1;
  position: relative;
  display: grid;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, undefined, undefined, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $c98b0135d71b9ff2$var$SelectButton = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).button`
  display: grid;
  cursor: pointer;
  width: 100%;
  overflow: hidden;
  z-index: 0;
  padding: 0;
  background-color: transparent;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates)}
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  &:focus, &:focus-within {
    outline: none;
    box-shadow: ${(props)=>props.isOpen ? 'none' : 'none'};
  }
`;
const $c98b0135d71b9ff2$var$SelectInput = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).input`
    border: 0;
    margin: 0;
    padding: 0;
    outline: none;
    width: 100%;
    min-width: 80px;
    background: transparent;
    ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape)}
`;
const $c98b0135d71b9ff2$var$SelectOptions = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  position: fixed;
  top: ${(props)=>`${props.top + props.height + 4 || 0}px`};
  left: ${(props)=>`${props.left || 0}px`};
  width: ${(props)=>`${props.width || 0}px`};
  z-index: ${(props)=>`${props.zIndex || 999999999999}`};
  max-height: 245px;
  background: #fff;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape)}

    overflow-y: auto !important;

  /* Custom Scrollbar for Webkit browsers */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--Colors-Background-bg-quaternary, #EAECF0);
    border-radius: var(--radius-full, 9999px);
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Custom Scrollbar for Firefox */
  scrollbar-width: thin;
  scrollbar-color: var(--Colors-Background-bg-quaternary, #EAECF0) transparent;
`;
const $c98b0135d71b9ff2$var$SelectOption = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  padding: 10px;
  cursor: pointer;
  background: ${(props)=>props.isSelected ? '#F9FAFB' : undefined};
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;

  &:hover {
    background: #F9FAFB;
  }
`;
const $c98b0135d71b9ff2$var$CombinedSelect = ({ id: id, type: type, options: optionsDraft, style: stDraft, value: valueDraft, events: eventsDraft, soc: soc, placeholder: placeholder, settings: settings, pageSettings: pageSettings, dataLake: dataLake, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, parentRef: parentRef, parentStyle: parentStyle, skeleton: renderSkeleton2, active_state: activeStateDraft, parentLoading: parentLoading, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache })=>{
    const { ref: ref } = settings || {};
    const itemRef = (0, $aivMx.useRef)(null);
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const { delay: delay = 500 } = settings || {};
    const { style: styleDraft, events: events, options: optionsTransformed, value: value, active_state: active_state, ref: realRef } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        ref: ref,
        style: stDraft,
        events: eventsDraft,
        value: valueDraft,
        options: optionsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        ref: undefined,
        style: stDraft,
        events: eventsDraft,
        value: valueDraft,
        options: optionsDraft,
        active_state: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'select') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading
    ]);
    const filteredOptionsPrevLengthRef = (0, $aivMx.useRef)(null);
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    const selectRef = (0, $aivMx.useRef)(null);
    // First useMemo to merge active state styles with base styles
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, selectRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const { grid: gridStyle, border: border, font: font, placeholder: placeholderStyle, ...otherStyle } = style || {};
    const { width: width, height: height, flex: flexStyle } = style || {};
    const { grow: grow, shrink: shrink, basis: basis } = flexStyle || {};
    const dropdownRef = (0, $aivMx.useRef)(null);
    const options = (0, $aivMx.useMemo)(()=>{
        // If it's a string, try to parse it as JSON, otherwise use as is
        const parsed = typeof optionsTransformed === 'string' ? (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(optionsTransformed) : optionsTransformed;
        // Always return an array
        return Array.isArray(parsed) ? parsed : [];
    }, [
        optionsTransformed
    ]);
    const [position, setPosition] = (0, $aivMx.useState)({
        top: 0,
        left: 0,
        width: 0,
        height: 0
    });
    const isSearchEnabled = settings?.search;
    const isMultiple = type === 'multiple';
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const [isOpen, setIsOpen] = (0, $aivMx.useState)(false);
    const [showOptions, setShowOptions] = (0, $aivMx.useState)(false);
    const [searchTerm, setSearchTerm] = (0, $aivMx.useState)();
    const [internalValue, setInternalValue] = (0, $aivMx.useState)(Array.isArray(value) ? value : value ? [
        value
    ] : []);
    const { on_change: changeStyles, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_focus: focusUpdates, on_blur: blurUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    (0, $aivMx.useEffect)(()=>{
        if (Array.isArray(value) && value.length || value && typeof value === 'string') {
            if (typeof value === 'string' && value.startsWith('[') && value.endsWith(']')) setInternalValue((0, $7b0e169a5380005e$export$8c51936ffbb22bee)(value));
            else setInternalValue(Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }, [
        value
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (Array.isArray(value) && value.length && value.join(' ') !== internalValue?.join(' ')) setInternalValue(value);
        else if (!Array.isArray(value) && value !== internalValue[0]) setInternalValue(value ? [
            value
        ] : []);
    }, [
        value
    ]);
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(hoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        let clickInsidePortal = false;
        const handleMouseDown = (event)=>{
            if (dropdownRef.current && dropdownRef.current.contains(event.target)) clickInsidePortal = true;
        };
        const handleClickOutside = (event)=>{
            if (!clickInsidePortal && selectRef.current && !selectRef.current.contains(event.target)) setIsOpen(false);
            clickInsidePortal = false; // Reset the flag
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleMouseDown);
            document.addEventListener('mouseup', handleClickOutside);
            return ()=>{
                document.removeEventListener('mousedown', handleMouseDown);
                document.removeEventListener('mouseup', handleClickOutside);
            };
        }
    }, [
        isOpen
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (isOpen && focusUpdates) {
            const styleUpdates = focusUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = focusUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = focusUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = focusUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(focusUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        } else if (!isOpen && blurUpdates) {
            const styleUpdates = blurUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = blurUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = blurUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = blurUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(blurUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
    }, [
        isOpen
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const styleUpdates = launchUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') ;
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    const handleChange = (e, selected)=>{
        if (type === 'multiple') {
            const newValuesBuffer = [
                ...internalValue,
                selected
            ];
            const uniqueValues = newValuesBuffer.filter((value, index)=>newValuesBuffer.indexOf(value) === index);
            setInternalValue(uniqueValues);
            setSearchTerm('');
            dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
                field: {
                    id: realRef || id,
                    value: uniqueValues
                }
            }));
        } else {
            setInternalValue([
                selected
            ]);
            setSearchTerm('');
            dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
                field: {
                    id: realRef || id,
                    value: selected
                }
            }));
        }
        if (changeStyles) {
            const styleUpdates = changeStyles.filter((update)=>update && 'style' in update);
            const requestUpdates = changeStyles.filter((update)=>update && 'request' in update);
            const functionUpdates = changeStyles.filter((update)=>update && 'function' in update);
            const actionUpdates = changeStyles.filter((update)=>update && 'action' in update);
            applyVariablesFirst(changeStyles);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
        if (soc) dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: 'soc',
            delay: delay,
            componentId: id
        }));
    };
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && selectRef.current && !selectRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Handle action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    const handleSelect = (e, id)=>{
        handleChange(e, id);
        setIsOpen(false);
    };
    const handleDeleteChip = (chip, e)=>{
        e.stopPropagation();
        e.preventDefault();
        setInternalValue((prevValues)=>prevValues.filter((value)=>value !== chip));
    };
    // `options` is normalised to an array by the useMemo above (it already runs
    // parseIfJSON for the legacy string form), so no re-parsing is needed here.
    const filteredOptions = (()=>{
        return options.filter((option)=>{
            if (!isSearchEnabled || !searchTerm) return true;
            if (Array.isArray(option.value)) return option.value.some((val)=>val.toLowerCase().includes(searchTerm.toLowerCase()));
            if (typeof option.value === 'string') return option.value.toLowerCase().includes(searchTerm.toLowerCase());
            return false;
        });
    })();
    const filteredOptionsRef = (0, $aivMx.useRef)(filteredOptions);
    (0, $aivMx.useEffect)(()=>{
        filteredOptionsPrevLengthRef.current = filteredOptionsRef.current?.length;
        filteredOptionsRef.current = filteredOptions;
    }, [
        filteredOptions
    ]);
    const updatePosition = (0, $aivMx.useCallback)((e)=>{
        if (!itemRef.current) return false;
        const itemHeight = itemRef.current ? itemRef.current.offsetHeight : 38;
        const itemCount = filteredOptionsRef.current?.length;
        const maxDropdownHeight = window.visualViewport.height / 3;
        const dropdownHeight = Math.min(itemHeight * itemCount, 245, maxDropdownHeight);
        const viewportHeight = window.visualViewport.height;
        const { scrollY: scrollY } = window;
        let rect;
        if (parentRef && parentRef.current) rect = parentRef.current.getBoundingClientRect();
        else if (selectRef.current) rect = selectRef.current.getBoundingClientRect();
        if (!rect) return false;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        const { left: left } = rect;
        let top = rect.top + scrollY;
        if (dropdownHeight > spaceBelow && spaceAbove > spaceBelow) top = rect.top + scrollY - dropdownHeight - itemHeight - 8;
        setPosition({
            top: top,
            height: rect.height,
            left: left,
            width: rect.width
        });
        return true;
    }, [
        parentRef,
        filteredOptionsRef
    ]);
    const updateMaxHeight = ()=>{
        if (dropdownRef.current) {
            const maxDropdownHeight = Math.min(window.visualViewport.height / 3, 245);
            dropdownRef.current.style.maxHeight = `${maxDropdownHeight}px`;
        }
    };
    const handleFunction = ()=>{
        updateMaxHeight();
        updatePosition();
    };
    (0, $aivMx.useEffect)(()=>{
        if (isOpen) {
            handleFunction();
            // If showOptions is not yet true, set it after position calculation
            if (!showOptions) setShowOptions(true);
        } else setShowOptions(false);
    }, [
        isOpen,
        showOptions
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (filteredOptionsPrevLengthRef.current !== filteredOptions.length) updatePosition();
    }, [
        filteredOptions
    ]);
    (0, $aivMx.useEffect)(()=>{
        window.addEventListener('resize', handleFunction);
        window.addEventListener('scroll', handleFunction, true); // true to capture event in the capturing phase
        // Initial position update
        updatePosition();
        return ()=>{
            window.removeEventListener('resize', handleFunction);
            window.removeEventListener('scroll', handleFunction, true);
        };
    }, [
        parentRef
    ]);
    const SelectInputComponent = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($c98b0135d71b9ff2$var$SelectInput, {
            $shape: {
                font: font
            },
            value: searchTerm,
            onChange: (e)=>setSearchTerm(e.target.value),
            autoFocus: true
        });
    const getTitleFromSelectOptions = (value)=>{
        const parsedVaue = Array.isArray(value) ? value[0] : value;
        const selectedOption = options?.find((option)=>option.id === parsedVaue);
        return selectedOption?.value;
    };
    const PlaceholderSpan = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
            style: (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)({
                font: {
                    ...placeholderStyle
                }
            }),
            children: placeholder
        });
    const handleClick = (0, $aivMx.useCallback)((e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (!isOpen) {
            setIsOpen(true);
            // Measure position first, then show options when ready
            requestAnimationFrame(()=>{
                if (updatePosition()) setShowOptions(true);
            });
        } else {
            setIsOpen(false);
            setShowOptions(false);
        }
    }, [
        active_state,
        isOpen,
        updatePosition
    ]);
    const ChevronDownComponent = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 20,
                minWidth: 20
            },
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $c07e36697bce3a79$export$2e2bcd8739ae039), {})
        });
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: active_state === 'disabled' || active_state === 'loading'
    });
    const WrapperEl = $c98b0135d71b9ff2$var$SelectWrapper;
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)(WrapperEl, {
        "data-id": realRef || id,
        id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        $shape: {
            grid: gridStyle,
            width: width,
            height: height,
            flex: {
                grow: grow,
                shrink: shrink,
                basis: basis
            }
        },
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        "data-component": "select",
        ref: selectRef,
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-expanded": isOpen,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)($c98b0135d71b9ff2$var$SelectButton, {
                $shape: {
                    ...otherStyle,
                    border: border,
                    font: font
                },
                $baseScreenResolution: baseScreenResolution,
                $skipStates: active_state === 'disabled' || active_state === 'loading',
                onClick: handleClick,
                "aria-haspopup": "true",
                isOpen: isOpen,
                children: [
                    isOpen && isSearchEnabled && !isMultiple && SelectInputComponent(),
                    isMultiple && isSearchEnabled && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
                        className: $cd0af89cb2a229cd$export$ff8e94cb38bad9e7,
                        children: [
                            Array.isArray(internalValue) && internalValue?.length ? internalValue?.map((val)=>{
                                const selectedOption = options?.find((option)=>option.id === val);
                                return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
                                    className: $cd0af89cb2a229cd$export$f26c97331adc89d5,
                                    children: [
                                        /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                                            className: $cd0af89cb2a229cd$export$a1499cbfa2755cde,
                                            children: selectedOption?.value
                                        }),
                                        /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                                            className: $cd0af89cb2a229cd$export$5cfb6affd60879e9,
                                            role: "button",
                                            onClick: (e)=>handleDeleteChip(val, e),
                                            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $b08c9de2ff5f2c28$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                }, val);
                            }) : null,
                            isOpen ? SelectInputComponent() : null,
                            !isOpen && !internalValue?.length ? PlaceholderSpan() : null
                        ]
                    }),
                    isMultiple && !isSearchEnabled && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                        className: $cd0af89cb2a229cd$export$ff8e94cb38bad9e7,
                        children: Array.isArray(internalValue) && internalValue?.length ? internalValue?.map((val)=>{
                            const selectedOption = Array.isArray(options) ? options?.find((option)=>option.id === val) : [];
                            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
                                className: $cd0af89cb2a229cd$export$f26c97331adc89d5,
                                children: [
                                    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                                        className: $cd0af89cb2a229cd$export$a1499cbfa2755cde,
                                        children: selectedOption?.value
                                    }),
                                    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                                        className: $cd0af89cb2a229cd$export$5cfb6affd60879e9,
                                        role: "button",
                                        onClick: (e)=>handleDeleteChip(val, e),
                                        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $b08c9de2ff5f2c28$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }, val);
                        }) : PlaceholderSpan()
                    }),
                    (!isOpen && !isMultiple || isOpen && !isSearchEnabled && !isMultiple) && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                        style: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis'
                        },
                        children: internalValue?.length ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                            children: getTitleFromSelectOptions(internalValue)
                        }) : PlaceholderSpan()
                    }),
                    !isMultiple && (!isSearchEnabled || !isOpen) ? ChevronDownComponent() : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {})
                ]
            }),
            isOpen && showOptions && /*#__PURE__*/ (0, $9f97ad3b314012cb$exports.createPortal)(/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($c98b0135d71b9ff2$var$SelectOptions, {
                $shape: {
                    border: parentStyle?.border || {},
                    background: style?.background || parentStyle?.background || [
                        {
                            type: 'color',
                            value: '#ffffff',
                            opacity: 1
                        }
                    ],
                    font: style?.font || {},
                    zIndex: style?.zIndex || parentStyle?.zIndex || 999999999999
                },
                ref: dropdownRef,
                "data-portal": "true",
                role: "listbox",
                height: position.height,
                top: position.top,
                left: position.left,
                width: position.width,
                children: filteredOptions.map((option, index)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)($c98b0135d71b9ff2$var$SelectOption, {
                        ref: index === 0 ? itemRef : null,
                        $shape: {
                            ...otherStyle
                        },
                        onClick: (e)=>handleSelect(e, option.id),
                        "aria-selected": internalValue.includes(option.id),
                        isSelected: internalValue.includes(option.id),
                        role: "option",
                        children: [
                            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                                style: {
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                },
                                children: option.value
                            }),
                            internalValue.includes(option.id) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: 20,
                                    minWidth: 20
                                },
                                children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("g", {
                                        id: "check",
                                        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
                                            id: "Icon",
                                            d: "M16.6668 5L7.50016 14.1667L3.3335 10",
                                            stroke: border?.color || "#7F56D9",
                                            strokeWidth: "1.66667",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            }) : null
                        ]
                    }, option.id))
            }), document.body)
        ]
    });
};
var $c98b0135d71b9ff2$export$2e2bcd8739ae039 = $c98b0135d71b9ff2$var$CombinedSelect;


var $bb9696960a8827ef$export$2e2bcd8739ae039 = (0, $c98b0135d71b9ff2$export$2e2bcd8739ae039);




parcelRequire("aivMx");



const $bc344fbf3bab5269$var$StyledSeparator = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, undefined, undefined, props.$parentDisplay, undefined, props.$parentFlexDirection)}
  /* Add specific styling for the separator */
  z-index: 1;
  border: ${(props)=>props.type === 'line' ? '1px solid black' : 'none'};
`;
const $bc344fbf3bab5269$var$Separator = ({ id: id, type: type, title: title, style: style, parentStyle: parentStyle })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($bc344fbf3bab5269$var$StyledSeparator, {
        id: id,
        type: type,
        $shape: style,
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        children: title
    });
var $bc344fbf3bab5269$export$2e2bcd8739ae039 = $bc344fbf3bab5269$var$Separator;


var $3492f55331d0a86f$export$2e2bcd8739ae039 = (0, $bc344fbf3bab5269$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");










var $9d2cfd122ae19143$export$b38bf4f33e9e4c25;
var $9d2cfd122ae19143$export$b2e11d516d0a2c5b;
$9d2cfd122ae19143$export$b38bf4f33e9e4c25 = `d2QKNq_slider`;
$9d2cfd122ae19143$export$b2e11d516d0a2c5b = `d2QKNq_toggleSlider`;


const $0a078e346477fb8c$var$StyledToggleContainer = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  z-index: 1;
  cursor: pointer;
  position: relative;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $0a078e346477fb8c$var$ToggleSlider = ({ id: id, style: stDraft, checked: checked, events: eventsDraft, soc: soc, value: valueDraft, pageSettings: pageSettings, dataLake: dataLake, active_state: activeStateDraft, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, skeleton: renderSkeleton2, parentLoading: parentLoading, parentStyle: parentStyle, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache, settings: settings })=>{
    const { ref: ref } = settings || {};
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const containerRef = (0, $aivMx.useRef)(null);
    const { style: styleDraft, events: events, active_state: active_state, value: value, ref: realRef } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        ref: ref,
        value: valueDraft,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        ref: undefined,
        value: valueDraft,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'switcher') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading
    ]);
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    // First useMemo to merge active state styles with base style
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, containerRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const { on_change: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    const [active, setActive] = (0, $aivMx.useState)(value === 'true');
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const debouncedSubmitForm = (0, $aivMx.useCallback)((0, $7b0e169a5380005e$export$61fc7d43ac8f84b0)(()=>{
        dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
            value: 'soc',
            componentId: id
        }));
    }, 500), []);
    const handleToggle = ()=>{
        setActive(!active);
        dispatch((0, $8eba69c5466928d3$export$528cdcbbafe26779)({
            field: {
                id: realRef || id,
                value: !active
            }
        }));
        if (soc) debouncedSubmitForm(!active);
    };
    (0, $aivMx.useEffect)(()=>{
        setActive(value === 'true');
    }, [
        value
    ]);
    const handleClick = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        handleToggle();
        e.preventDefault();
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = clickUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = clickUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = clickUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(clickUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(hoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const styleUpdates = launchUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') ;
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && containerRef.current && !containerRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Handle action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: active_state === 'disabled' || active_state === 'loading'
    });
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($0a078e346477fb8c$var$StyledToggleContainer, {
        ref: containerRef,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": "switcher",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style.class),
        onClick: handleClick,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
            className: $9d2cfd122ae19143$export$b2e11d516d0a2c5b,
            children: [
                /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("input", {
                    type: "checkbox",
                    "data-id": realRef || id,
                    id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
                    checked: active
                }),
                /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("label", {
                    htmlFor: id,
                    className: $9d2cfd122ae19143$export$b38bf4f33e9e4c25
                })
            ]
        })
    });
};
var $0a078e346477fb8c$export$2e2bcd8739ae039 = $0a078e346477fb8c$var$ToggleSlider;


var $f7a8d8148b95e31e$export$2e2bcd8739ae039 = (0, $0a078e346477fb8c$export$2e2bcd8739ae039);




var $aivMx = parcelRequire("aivMx");



var $94WEq = parcelRequire("94WEq");










/* eslint-disable @typescript-eslint/no-explicit-any */ 

var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");
function $d545b40f7ad07d5d$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $d545b40f7ad07d5d$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $d545b40f7ad07d5d$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $d545b40f7ad07d5d$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $d545b40f7ad07d5d$export$2e2bcd8739ae039 = $d545b40f7ad07d5d$export$4f5d2d50c9deca37;



var $aivMx = parcelRequire("aivMx");


var $aivMx = parcelRequire("aivMx");
var $3714d61fa454e414$var$EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
function $3714d61fa454e414$export$7d045284457d8577(key) {
    if (typeof key !== 'string') return false;
    var allowedEventKeys = $3714d61fa454e414$var$EventKeys;
    return allowedEventKeys.includes(key);
}



var $aivMx = parcelRequire("aivMx");
var $bf74bd062767a6f3$var$SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it, and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $bf74bd062767a6f3$var$SVGElementPropKeySet = new Set($bf74bd062767a6f3$var$SVGElementPropKeys);
function $bf74bd062767a6f3$export$b73d29c2a6d3ff97(key) {
    if (typeof key !== 'string') return false;
    return $bf74bd062767a6f3$var$SVGElementPropKeySet.has(key);
}
function $bf74bd062767a6f3$export$904e03d0a8b085df(key) {
    return typeof key === 'string' && key.startsWith('data-');
}
function $bf74bd062767a6f3$export$8b56257912140094(obj) {
    if (typeof obj !== 'object' || obj === null) return {};
    var result = {};
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ($bf74bd062767a6f3$export$b73d29c2a6d3ff97(key) || $bf74bd062767a6f3$export$904e03d0a8b085df(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $bf74bd062767a6f3$export$6d5921c09aa671a9(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(input) && typeof input.props === 'object' && input.props !== null) {
        var p = input.props;
        return $bf74bd062767a6f3$export$8b56257912140094(p);
    }
    if (typeof input === 'object' && !Array.isArray(input)) return $bf74bd062767a6f3$export$8b56257912140094(input);
    return null;
}


function $61a9c4d36b40070f$export$67f8fc03e57e2747(obj) {
    var result = {};
    // for ... in loop is 10x faster than Object.entries + filter + Object.fromEntries in Chrome
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ((0, $bf74bd062767a6f3$export$b73d29c2a6d3ff97)(key) || (0, $bf74bd062767a6f3$export$904e03d0a8b085df)(key) || (0, $3714d61fa454e414$export$7d045284457d8577)(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $61a9c4d36b40070f$export$87ef3d7bc7cd0706(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(input)) // @ts-expect-error we can't type this better because input can be any React element
    return $61a9c4d36b40070f$export$67f8fc03e57e2747(input.props);
    if (typeof input === 'object' && !Array.isArray(input)) return $61a9c4d36b40070f$export$67f8fc03e57e2747(input);
    return null;
}


var $d3f671dc6f3ee601$var$_excluded = [
    "children",
    "className"
];
function $d3f671dc6f3ee601$var$_extends() {
    return $d3f671dc6f3ee601$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d3f671dc6f3ee601$var$_extends.apply(null, arguments);
}
function $d3f671dc6f3ee601$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $d3f671dc6f3ee601$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $d3f671dc6f3ee601$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d3f671dc6f3ee601$export$936d0764594b6eb3 = /*#__PURE__*/ $aivMx.forwardRef((props, ref)=>{
    var { children: children, className: className } = props, others = $d3f671dc6f3ee601$var$_objectWithoutProperties(props, $d3f671dc6f3ee601$var$_excluded);
    var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-layer', className);
    return /*#__PURE__*/ $aivMx.createElement("g", $d3f671dc6f3ee601$var$_extends({
        className: layerClass
    }, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(others), {
        ref: ref
    }), children);
});


/**
 * @fileOverview Cross
 */ var $66258e37252e74df$export$f6f0c3fe4ec306ea = (_props)=>null;
$66258e37252e74df$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $aivMx = parcelRequire("aivMx");
var $559f1311a8e0dc33$exports = {};

$559f1311a8e0dc33$exports = (parcelRequire("kkDZD")).last;



var $aivMx = parcelRequire("aivMx");


var $aivMx = parcelRequire("aivMx");

var $a7b626aae7e6649e$exports = {};

$a7b626aae7e6649e$exports = (parcelRequire("gAKvK")).get;


var $9d9ad0197f7e4c2b$export$9d334328eb75e624 = (value)=>{
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $9d9ad0197f7e4c2b$export$e426a261f3212d7d = (value)=>{
    // eslint-disable-next-line eqeqeq
    return typeof value == 'number' && value != +value;
};
var $9d9ad0197f7e4c2b$export$e50269385c77c348 = (value)=>typeof value === 'string' && value.indexOf('%') === value.length - 1;
var $9d9ad0197f7e4c2b$export$7e4aa119212bc614 = (value)=>(typeof value === 'number' || value instanceof Number) && !$9d9ad0197f7e4c2b$export$e426a261f3212d7d(value);
var $9d9ad0197f7e4c2b$export$402a499e1ea44294 = (value)=>$9d9ad0197f7e4c2b$export$7e4aa119212bc614(value) || typeof value === 'string';
var $9d9ad0197f7e4c2b$var$idCounter = 0;
var $9d9ad0197f7e4c2b$export$8b15d37bc3f197d4 = (prefix)=>{
    var id = ++$9d9ad0197f7e4c2b$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $9d9ad0197f7e4c2b$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$9d9ad0197f7e4c2b$export$7e4aa119212bc614(percent) && typeof percent !== 'string') return defaultValue;
    var value;
    if ($9d9ad0197f7e4c2b$export$e50269385c77c348(percent)) {
        if (totalValue == null) return defaultValue;
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ($9d9ad0197f7e4c2b$export$e426a261f3212d7d(value)) value = defaultValue;
    if (validate && totalValue != null && value > totalValue) value = totalValue;
    return value;
};
var $9d9ad0197f7e4c2b$export$732baf6a98f122 = (ary)=>{
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
function $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9(start, end, t) {
    if ($9d9ad0197f7e4c2b$export$7e4aa119212bc614(start) && $9d9ad0197f7e4c2b$export$7e4aa119212bc614(end)) return start + t * (end - start);
    return end;
}
function $9d9ad0197f7e4c2b$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return undefined;
    return ary.find((entry)=>entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($a7b626aae7e6649e$exports)))(entry, specifiedKey)) === specifiedValue);
}
var $9d9ad0197f7e4c2b$export$484982720961754e = (data)=>{
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $9d9ad0197f7e4c2b$export$b931b78cbb3caf86 = (value)=>{
    return value === null || typeof value === 'undefined';
};
var $9d9ad0197f7e4c2b$export$3061f22cd819074d = (value)=>{
    if ($9d9ad0197f7e4c2b$export$b931b78cbb3caf86(value)) return value;
    return "".concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
};
function $9d9ad0197f7e4c2b$export$7e515ab5fbd92bef(value) {
    return value != null;
}
function $9d9ad0197f7e4c2b$export$8793edee2d425525() {}


var $a898dc03dc17f75a$var$parseIsSsrByDefault = ()=>!(typeof window !== 'undefined' && window.document && Boolean(window.document.createElement) && window.setTimeout);
var $a898dc03dc17f75a$export$98f03c5d19621d70 = {
    devToolsEnabled: false,
    isSsr: $a898dc03dc17f75a$var$parseIsSsrByDefault()
};



function $78c37db13d89687b$var$_defineProperty(e, r, t) {
    return (r = $78c37db13d89687b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $78c37db13d89687b$var$_toPropertyKey(t) {
    var i = $78c37db13d89687b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $78c37db13d89687b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $78c37db13d89687b$export$182500e6725aad9a {
    constructor(maxSize){
        $78c37db13d89687b$var$_defineProperty(this, "cache", new Map());
        this.maxSize = maxSize;
    }
    get(key) {
        var value = this.cache.get(key);
        if (value !== undefined) {
            this.cache.delete(key);
            this.cache.set(key, value);
        }
        return value;
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize) {
            var firstKey = this.cache.keys().next().value;
            if (firstKey != null) this.cache.delete(firstKey);
        }
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
    size() {
        return this.cache.size;
    }
}


function $3cfe37fe7cebaf4e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cfe37fe7cebaf4e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cfe37fe7cebaf4e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3cfe37fe7cebaf4e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cfe37fe7cebaf4e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3cfe37fe7cebaf4e$var$_defineProperty(e, r, t) {
    return (r = $3cfe37fe7cebaf4e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3cfe37fe7cebaf4e$var$_toPropertyKey(t) {
    var i = $3cfe37fe7cebaf4e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3cfe37fe7cebaf4e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3cfe37fe7cebaf4e$var$defaultConfig = {
    cacheSize: 2000,
    enableCache: true
};
var $3cfe37fe7cebaf4e$var$currentConfig = $3cfe37fe7cebaf4e$var$_objectSpread({}, $3cfe37fe7cebaf4e$var$defaultConfig);
var $3cfe37fe7cebaf4e$var$stringCache = new (0, $78c37db13d89687b$export$182500e6725aad9a)($3cfe37fe7cebaf4e$var$currentConfig.cacheSize);
var $3cfe37fe7cebaf4e$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $3cfe37fe7cebaf4e$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $3cfe37fe7cebaf4e$var$createCacheKey(text, style) {
    // Simple string concatenation for better performance than JSON.stringify
    var fontSize = style.fontSize || '';
    var fontFamily = style.fontFamily || '';
    var fontWeight = style.fontWeight || '';
    var fontStyle = style.fontStyle || '';
    var letterSpacing = style.letterSpacing || '';
    var textTransform = style.textTransform || '';
    return "".concat(text, "|").concat(fontSize, "|").concat(fontFamily, "|").concat(fontWeight, "|").concat(fontStyle, "|").concat(letterSpacing, "|").concat(textTransform);
}
/**
 * Measure text using DOM (accurate but slower)
 * @param text - The text to measure
 * @param style - CSS style properties to apply
 * @returns The size of the text
 */ var $3cfe37fe7cebaf4e$var$measureTextWithDOM = (text, style)=>{
    try {
        var measurementSpan = document.getElementById($3cfe37fe7cebaf4e$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $3cfe37fe7cebaf4e$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Apply styles directly without unnecessary object creation
        Object.assign(measurementSpan.style, $3cfe37fe7cebaf4e$var$SPAN_STYLE, style);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height
        };
    } catch (_unused) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $3cfe37fe7cebaf4e$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $a898dc03dc17f75a$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    // If caching is disabled, measure directly
    if (!$3cfe37fe7cebaf4e$var$currentConfig.enableCache) return $3cfe37fe7cebaf4e$var$measureTextWithDOM(text, style);
    var cacheKey = $3cfe37fe7cebaf4e$var$createCacheKey(text, style);
    var cachedResult = $3cfe37fe7cebaf4e$var$stringCache.get(cacheKey);
    if (cachedResult) return cachedResult;
    // Measure using DOM
    var result = $3cfe37fe7cebaf4e$var$measureTextWithDOM(text, style);
    // Store in LRU cache
    $3cfe37fe7cebaf4e$var$stringCache.set(cacheKey, result);
    return result;
};
var $3cfe37fe7cebaf4e$export$24830ea431eb8e34 = (config)=>{
    var newConfig = $3cfe37fe7cebaf4e$var$_objectSpread($3cfe37fe7cebaf4e$var$_objectSpread({}, $3cfe37fe7cebaf4e$var$currentConfig), config);
    if (newConfig.cacheSize !== $3cfe37fe7cebaf4e$var$currentConfig.cacheSize) $3cfe37fe7cebaf4e$var$stringCache = new (0, $78c37db13d89687b$export$182500e6725aad9a)(newConfig.cacheSize);
    $3cfe37fe7cebaf4e$var$currentConfig = newConfig;
};
var $3cfe37fe7cebaf4e$export$1340d8ffb2cb9b2 = ()=>$3cfe37fe7cebaf4e$var$_objectSpread({}, $3cfe37fe7cebaf4e$var$currentConfig);
var $3cfe37fe7cebaf4e$export$dbfda59986504510 = ()=>{
    $3cfe37fe7cebaf4e$var$stringCache.clear();
};
var $3cfe37fe7cebaf4e$export$5941b2b80425c12f = ()=>({
        size: $3cfe37fe7cebaf4e$var$stringCache.size(),
        maxSize: $3cfe37fe7cebaf4e$var$currentConfig.cacheSize
    });



var $f016aa6565305eb6$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $f016aa6565305eb6$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $f016aa6565305eb6$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $f016aa6565305eb6$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $f016aa6565305eb6$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    in: 96,
    Q: 96 / 101.6,
    px: 1
};
var $f016aa6565305eb6$var$FIXED_CSS_LENGTH_UNITS = Object.keys($f016aa6565305eb6$var$CONVERSION_RATES);
var $f016aa6565305eb6$var$STR_NAN = 'NaN';
function $f016aa6565305eb6$var$convertToPx(value, unit) {
    return value * $f016aa6565305eb6$var$CONVERSION_RATES[unit];
}
class $f016aa6565305eb6$var$DecimalCSS {
    static parse(str) {
        var _NUM_SPLIT_REGEX$exec;
        var [, numStr, unit] = (_NUM_SPLIT_REGEX$exec = $f016aa6565305eb6$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [];
        return new $f016aa6565305eb6$var$DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
    }
    constructor(num, unit){
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if ((0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(num)) this.unit = '';
        if (unit !== '' && !$f016aa6565305eb6$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($f016aa6565305eb6$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $f016aa6565305eb6$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    add(other) {
        if (this.unit !== other.unit) return new $f016aa6565305eb6$var$DecimalCSS(NaN, '');
        return new $f016aa6565305eb6$var$DecimalCSS(this.num + other.num, this.unit);
    }
    subtract(other) {
        if (this.unit !== other.unit) return new $f016aa6565305eb6$var$DecimalCSS(NaN, '');
        return new $f016aa6565305eb6$var$DecimalCSS(this.num - other.num, this.unit);
    }
    multiply(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $f016aa6565305eb6$var$DecimalCSS(NaN, '');
        return new $f016aa6565305eb6$var$DecimalCSS(this.num * other.num, this.unit || other.unit);
    }
    divide(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $f016aa6565305eb6$var$DecimalCSS(NaN, '');
        return new $f016aa6565305eb6$var$DecimalCSS(this.num / other.num, this.unit || other.unit);
    }
    toString() {
        return "".concat(this.num).concat(this.unit);
    }
    isNaN() {
        return (0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(this.num);
    }
}
function $f016aa6565305eb6$var$calculateArithmetic(expr) {
    if (expr.includes($f016aa6565305eb6$var$STR_NAN)) return $f016aa6565305eb6$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var [, leftOperand, operator, rightOperand] = (_MULTIPLY_OR_DIVIDE_R = $f016aa6565305eb6$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [];
        var lTs = $f016aa6565305eb6$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $f016aa6565305eb6$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $f016aa6565305eb6$var$STR_NAN;
        newExpr = newExpr.replace($f016aa6565305eb6$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var [, _leftOperand, _operator, _rightOperand] = (_ADD_OR_SUBTRACT_REGE = $f016aa6565305eb6$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [];
        var _lTs = $f016aa6565305eb6$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $f016aa6565305eb6$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $f016aa6565305eb6$var$STR_NAN;
        newExpr = newExpr.replace($f016aa6565305eb6$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $f016aa6565305eb6$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $f016aa6565305eb6$var$calculateParentheses(expr) {
    var newExpr = expr;
    var match;
    // eslint-disable-next-line no-cond-assign
    while((match = $f016aa6565305eb6$var$PARENTHESES_REGEX.exec(newExpr)) != null){
        var [, parentheticalExpression] = match;
        newExpr = newExpr.replace($f016aa6565305eb6$var$PARENTHESES_REGEX, $f016aa6565305eb6$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $f016aa6565305eb6$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $f016aa6565305eb6$var$calculateParentheses(newExpr);
    newExpr = $f016aa6565305eb6$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $f016aa6565305eb6$export$c891f73c9c6d00c9(expression) {
    try {
        return $f016aa6565305eb6$var$evaluateExpression(expression);
    } catch (_unused) {
        return $f016aa6565305eb6$var$STR_NAN;
    }
}
function $f016aa6565305eb6$export$254eac204f89fd7d(expression) {
    var result = $f016aa6565305eb6$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $f016aa6565305eb6$var$STR_NAN) return '';
    return result;
}



function $2f9fe6ad083d623b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f9fe6ad083d623b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f9fe6ad083d623b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2f9fe6ad083d623b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f9fe6ad083d623b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2f9fe6ad083d623b$var$_defineProperty(e, r, t) {
    return (r = $2f9fe6ad083d623b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2f9fe6ad083d623b$var$_toPropertyKey(t) {
    var i = $2f9fe6ad083d623b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2f9fe6ad083d623b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2f9fe6ad083d623b$export$45004cc70a390ee8(realProps, defaultProps) {
    /*
   * To avoid mutating the original `realProps` object passed to the function, create a shallow copy of it.
   * `resolvedProps` will be modified directly with the defaults.
   */ var resolvedProps = $2f9fe6ad083d623b$var$_objectSpread({}, realProps);
    /*
   * Since the function guarantees `D extends Partial<T>`, this assignment is safe.
   * It allows TypeScript to work with the well-defined `Partial<T>` type inside the loop,
   * making subsequent type inference (especially for `dp[key]`) much more straightforward for the compiler.
   * This is a key step to improve type safety *without* value assertions later.
   */ var dp = defaultProps;
    /*
   * `Object.keys` doesn't preserve strong key types - it always returns Array<string>.
   * However, due to the `D extends Partial<T>` constraint,
   * we know these keys *must* also be valid keys of `T`.
   * This assertion informs TypeScript of this relationship, avoiding type errors when using `key` to index `acc` (type T).
   *
   * Type assertions are not sound but in this case it's necessary
   * as `Object.keys` does not do what we want it to do.
   */ var keys = Object.keys(defaultProps);
    var withDefaults = keys.reduce((acc, key)=>{
        if (acc[key] === undefined && dp[key] !== undefined) acc[key] = dp[key];
        return acc;
    }, resolvedProps);
    /*
   * And again type assertions are not safe but here we have done the runtime work
   * so let's bypass the lack of static type safety and tell the compiler what happened.
   */ return withDefaults;
} /**
 * Helper type to extract the keys of T that are required.
 * It iterates through each key K in T. If Pick<T, K> cannot be assigned an empty object {},
 * it means K is required, so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to extract the keys of T that are optional.
 * It iterates through each key K in T. If Pick<T, K> can be assigned an empty object {},
 * it means K is optional (or potentially missing), so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to ensure keys of D exist in T.
 * For each key K in D, if K is also a key of T, keep the type D[K].
 * If K is NOT a key of T, map it to type `never`.
 * An object cannot have a property of type `never`, effectively disallowing extra keys.
 */  /**
 * This type will take a source type `Props` and a default type `Defaults` and will return a new type
 * where all properties that are optional in `Props` but required in `Defaults` are made required in the result.
 * Properties that are required in `Props` and optional in `Defaults` will remain required.
 * Properties that are optional in both `Props` and `Defaults` will remain optional.
 *
 * This is useful for creating a type that represents the resolved props of a component with default props.
 */ 


function $c7c0820fc649c04a$export$f8a8fc612ced9bb0(n) {
    return Number.isFinite(n);
}
function $c7c0820fc649c04a$export$5374bb854d0e41c8(n) {
    return typeof n === 'number' && n > 0 && Number.isFinite(n);
}


var $79fae2d735abd531$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "fill",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor"
], $79fae2d735abd531$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $79fae2d735abd531$var$_extends() {
    return $79fae2d735abd531$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $79fae2d735abd531$var$_extends.apply(null, arguments);
}
function $79fae2d735abd531$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $79fae2d735abd531$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $79fae2d735abd531$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $79fae2d735abd531$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $79fae2d735abd531$var$calculateWordWidths = (_ref)=>{
    var { children: children, breakAll: breakAll, style: style } = _ref;
    try {
        var words = [];
        if (!(0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($79fae2d735abd531$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map((word)=>({
                word: word,
                width: (0, $3cfe37fe7cebaf4e$export$e5560531f057ad5d)(word, style).width
            }));
        var spaceWidth = breakAll ? 0 : (0, $3cfe37fe7cebaf4e$export$e5560531f057ad5d)('\u00A0', style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (_unused) {
        return null;
    }
};
function $79fae2d735abd531$export$ae5e6c08954aa63c(value) {
    return value === 'start' || value === 'middle' || value === 'end' || value === 'inherit';
}
var $79fae2d735abd531$var$calculate = (words, lineWidth, spaceWidth, scaleToFit)=>words.reduce((result, _ref2)=>{
        var { word: word, width: width } = _ref2;
        var currentLine = result[result.length - 1];
        if (currentLine && width != null && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
            // Word can be added to an existing line
            currentLine.words.push(word);
            currentLine.width += width + spaceWidth;
        } else {
            // Add first word to line or word is too long to scaleToFit on existing line
            var newLine = {
                words: [
                    word
                ],
                width: width
            };
            result.push(newLine);
        }
        return result;
    }, []);
var $79fae2d735abd531$var$findLongestLine = (words)=>words.reduce((a, b)=>a.width > b.width ? a : b);
var $79fae2d735abd531$var$suffix = "\u2026";
var $79fae2d735abd531$var$checkOverflow = (text, index, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit)=>{
    var tempText = text.slice(0, index);
    var words = $79fae2d735abd531$var$calculateWordWidths({
        breakAll: breakAll,
        style: style,
        children: tempText + $79fae2d735abd531$var$suffix
    });
    if (!words) return [
        false,
        []
    ];
    var result = $79fae2d735abd531$var$calculate(words.wordsWithComputedWidth, lineWidth, spaceWidth, scaleToFit);
    var doesOverflow = result.length > maxLines || $79fae2d735abd531$var$findLongestLine(result).width > Number(lineWidth);
    return [
        doesOverflow,
        result
    ];
};
var $79fae2d735abd531$var$calculateWordsByLines = (_ref3, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit)=>{
    var { maxLines: maxLines, children: children, style: style, breakAll: breakAll } = _ref3;
    var shouldLimitLines = (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(maxLines);
    var text = String(children);
    var originalResult = $79fae2d735abd531$var$calculate(initialWordsWithComputedWith, lineWidth, spaceWidth, scaleToFit);
    if (!shouldLimitLines || scaleToFit) return originalResult;
    var overflows = originalResult.length > maxLines || $79fae2d735abd531$var$findLongestLine(originalResult).width > Number(lineWidth);
    if (!overflows) return originalResult;
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var [doesPrevOverflow, result] = $79fae2d735abd531$var$checkOverflow(text, prev, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        var [doesMiddleOverflow] = $79fae2d735abd531$var$checkOverflow(text, middle, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $79fae2d735abd531$var$getWordsWithoutCalculate = (children)=>{
    var words = !(0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(children) ? children.toString().split($79fae2d735abd531$var$BREAKING_SPACES) : [];
    return [
        {
            words: words,
            width: undefined
        }
    ];
};
var $79fae2d735abd531$export$86ba3bfd091ebe4f = (_ref4)=>{
    var { width: width, scaleToFit: scaleToFit, children: children, style: style, breakAll: breakAll, maxLines: maxLines } = _ref4;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $a898dc03dc17f75a$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $79fae2d735abd531$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var { wordsWithComputedWidth: wcw, spaceWidth: sw } = wordWidths;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $79fae2d735abd531$var$getWordsWithoutCalculate(children);
        return $79fae2d735abd531$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, Boolean(scaleToFit));
    }
    return $79fae2d735abd531$var$getWordsWithoutCalculate(children);
};
var $79fae2d735abd531$var$DEFAULT_FILL = '#808080';
var $79fae2d735abd531$export$beb103ac5cf1498b = {
    angle: 0,
    breakAll: false,
    // Magic number from d3
    capHeight: '0.71em',
    fill: $79fae2d735abd531$var$DEFAULT_FILL,
    lineHeight: '1em',
    scaleToFit: false,
    textAnchor: 'start',
    // Maintain compat with existing charts / default SVG behavior
    verticalAnchor: 'end',
    x: 0,
    y: 0
};
var $79fae2d735abd531$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $aivMx.forwardRef)((outsideProps, ref)=>{
    var _resolveDefaultProps = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $79fae2d735abd531$export$beb103ac5cf1498b), { x: propsX, y: propsY, lineHeight: lineHeight, capHeight: capHeight, fill: fill, scaleToFit: scaleToFit, textAnchor: textAnchor, verticalAnchor: verticalAnchor } = _resolveDefaultProps, props = $79fae2d735abd531$var$_objectWithoutProperties(_resolveDefaultProps, $79fae2d735abd531$var$_excluded);
    var wordsByLines = (0, $aivMx.useMemo)(()=>{
        return $79fae2d735abd531$export$86ba3bfd091ebe4f({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var { dx: dx, dy: dy, angle: angle, className: className, breakAll: breakAll } = props, textProps = $79fae2d735abd531$var$_objectWithoutProperties(props, $79fae2d735abd531$var$_excluded2);
    if (!(0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(propsX) || !(0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(propsY) || wordsByLines.length === 0) return null;
    var x = Number(propsX) + ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = Number(propsY) + ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(dy) ? dy : 0);
    if (!(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(x) || !(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(y)) return null;
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $f016aa6565305eb6$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $f016aa6565305eb6$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $f016aa6565305eb6$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var { width: width } = props;
        transforms.push("scale(".concat((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(width) && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(lineWidth) ? width / lineWidth : 1, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ $aivMx.createElement("text", $79fae2d735abd531$var$_extends({}, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(textProps), {
        ref: ref,
        x: x,
        y: y,
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $79fae2d735abd531$var$DEFAULT_FILL : fill
    }), wordsByLines.map((line, index)=>{
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys which is why we add the array index here
        $aivMx.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
});
$79fae2d735abd531$export$5f1af8db9871e1d6.displayName = 'Text';




var $aivMx = parcelRequire("aivMx");
function $e8905a15bef036aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e8905a15bef036aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e8905a15bef036aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e8905a15bef036aa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e8905a15bef036aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e8905a15bef036aa$var$_defineProperty(e, r, t) {
    return (r = $e8905a15bef036aa$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e8905a15bef036aa$var$_toPropertyKey(t) {
    var i = $e8905a15bef036aa$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e8905a15bef036aa$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e8905a15bef036aa$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $e8905a15bef036aa$export$4f2c4f194778dcbb = (angle)=>angle * Math.PI / 180;
var $e8905a15bef036aa$export$1c20e104e3e29a0a = (angleInRadian)=>angleInRadian * 180 / Math.PI;
var $e8905a15bef036aa$export$5c9a959bb3fc7749 = (cx, cy, radius, angle)=>({
        x: cx + Math.cos(-$e8905a15bef036aa$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$e8905a15bef036aa$export$d74e8f7e9cc3fed3 * angle) * radius
    });
var $e8905a15bef036aa$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        brushBottom: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $e8905a15bef036aa$var$distanceBetweenPoints = (point, anotherPoint)=>{
    var { x: x1, y: y1 } = point;
    var { x: x2, y: y2 } = anotherPoint;
    return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
};
var $e8905a15bef036aa$var$getAngleOfPoint = (_ref, _ref2)=>{
    var { x: x, y: y } = _ref;
    var { cx: cx, cy: cy } = _ref2;
    var radius = $e8905a15bef036aa$var$distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius,
        angle: 0
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $e8905a15bef036aa$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $e8905a15bef036aa$var$formatAngleOfSector = (_ref3)=>{
    var { startAngle: startAngle, endAngle: endAngle } = _ref3;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $e8905a15bef036aa$var$reverseFormatAngleOfSector = (angle, _ref4)=>{
    var { startAngle: startAngle, endAngle: endAngle } = _ref4;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $e8905a15bef036aa$export$e85a2bf8cd31c504 = (_ref5, viewBox)=>{
    var { chartX: x, chartY: y } = _ref5;
    var { radius: radius, angle: angle } = $e8905a15bef036aa$var$getAngleOfPoint({
        x: x,
        y: y
    }, viewBox);
    var { innerRadius: innerRadius, outerRadius: outerRadius } = viewBox;
    if (radius < innerRadius || radius > outerRadius) return null;
    if (radius === 0) return null;
    var { startAngle: startAngle, endAngle: endAngle } = $e8905a15bef036aa$var$formatAngleOfSector(viewBox);
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $e8905a15bef036aa$var$_objectSpread($e8905a15bef036aa$var$_objectSpread({}, viewBox), {}, {
        radius: radius,
        angle: $e8905a15bef036aa$var$reverseFormatAngleOfSector(formatAngle, viewBox)
    });
    return null;
};
var $e8905a15bef036aa$export$88d525dabc04abcd = (tick)=>!/*#__PURE__*/ (0, $aivMx.isValidElement)(tick) && typeof tick !== 'function' && typeof tick !== 'boolean' && tick != null ? tick.className : '';



var $aivMx = parcelRequire("aivMx");


var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");
var $748f70810790c017$export$876ef70bc88b13cb = /*#__PURE__*/ (0, $aivMx.createContext)(null);


var $7729c221c7142965$var$noopDispatch = (a)=>a;
var $7729c221c7142965$export$f51d452c10d5b956 = ()=>{
    var context = (0, $aivMx.useContext)((0, $748f70810790c017$export$876ef70bc88b13cb));
    if (context) return context.store.dispatch;
    return $7729c221c7142965$var$noopDispatch;
};
var $7729c221c7142965$var$noop = ()=>{};
var $7729c221c7142965$var$addNestedSubNoop = ()=>$7729c221c7142965$var$noop;
var $7729c221c7142965$var$refEquality = (a, b)=>a === b;
function $7729c221c7142965$export$a7347740d65f620b(selector) {
    var context = (0, $aivMx.useContext)((0, $748f70810790c017$export$876ef70bc88b13cb));
    return (0, $e5d28596ff67251c$exports.useSyncExternalStoreWithSelector)(context ? context.subscription.addNestedSub : $7729c221c7142965$var$addNestedSubNoop, context ? context.store.getState : $7729c221c7142965$var$noop, context ? context.store.getState : $7729c221c7142965$var$noop, context ? selector : $7729c221c7142965$var$noop, $7729c221c7142965$var$refEquality);
}



var $56Xh3 = parcelRequire("56Xh3");

// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $fc60b43328c237ec$var$NOT_FOUND = 'NOT_FOUND';
function $fc60b43328c237ec$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $fc60b43328c237ec$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $fc60b43328c237ec$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $fc60b43328c237ec$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $fc60b43328c237ec$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $fc60b43328c237ec$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $fc60b43328c237ec$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $fc60b43328c237ec$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $fc60b43328c237ec$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $fc60b43328c237ec$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $fc60b43328c237ec$var$createSingletonCache(comparator) : $fc60b43328c237ec$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $fc60b43328c237ec$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $f9eec652ce42beb0$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $f9eec652ce42beb0$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $f9eec652ce42beb0$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $f9eec652ce42beb0$export$595d22ed68ca2841 = /* #__PURE__ */ $f9eec652ce42beb0$export$5943f4447f6ef248((0, $fc60b43328c237ec$export$281bff7f05488aa2));
var $f9eec652ce42beb0$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $f9eec652ce42beb0$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $a65a962df7391a7a$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $a65a962df7391a7a$var$thunk = $a65a962df7391a7a$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$a65a962df7391a7a$var$thunk.withExtraArgument = $a65a962df7391a7a$var$createThunkMiddleware;
var $a65a962df7391a7a$export$2e2bcd8739ae039 = $a65a962df7391a7a$var$thunk;


var $d60c7aefffed8a78$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d60c7aefffed8a78$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d60c7aefffed8a78$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $d60c7aefffed8a78$var$__defProp = Object.defineProperty;
var $d60c7aefffed8a78$var$__defProps = Object.defineProperties;
var $d60c7aefffed8a78$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d60c7aefffed8a78$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d60c7aefffed8a78$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d60c7aefffed8a78$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d60c7aefffed8a78$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d60c7aefffed8a78$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d60c7aefffed8a78$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d60c7aefffed8a78$var$__hasOwnProp.call(b, prop)) $d60c7aefffed8a78$var$__defNormalProp(a, prop, b[prop]);
    if ($d60c7aefffed8a78$var$__getOwnPropSymbols) for(var _i = 0, _c = $d60c7aefffed8a78$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($d60c7aefffed8a78$var$__propIsEnum.call(b, prop)) $d60c7aefffed8a78$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d60c7aefffed8a78$var$__spreadProps = function(a, b) {
    return $d60c7aefffed8a78$var$__defProps(a, $d60c7aefffed8a78$var$__getOwnPropDescs(b));
};
var $d60c7aefffed8a78$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $d60c7aefffed8a78$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $f9eec652ce42beb0$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $d60c7aefffed8a78$var$__spreadArray([
            (0, $56Xh3.isDraft)(value) ? (0, $56Xh3.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $d60c7aefffed8a78$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $b4bc487a38c3f200$export$f672e0b6f7222cd7;
    return (0, $b4bc487a38c3f200$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d60c7aefffed8a78$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $d60c7aefffed8a78$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $d60c7aefffed8a78$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d60c7aefffed8a78$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $d60c7aefffed8a78$var$__spreadValues($d60c7aefffed8a78$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $d60c7aefffed8a78$export$b956e38827fca970(action) {
    return $d60c7aefffed8a78$export$53b83ca8eaab0383(action) && "type" in action;
}
function $d60c7aefffed8a78$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $d60c7aefffed8a78$var$hasMatchFunction(action);
}
function $d60c7aefffed8a78$export$ebd532f9034651f3(action) {
    return $d60c7aefffed8a78$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($d60c7aefffed8a78$var$isValidKey);
}
function $d60c7aefffed8a78$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $d60c7aefffed8a78$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $d60c7aefffed8a78$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $d60c7aefffed8a78$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $d60c7aefffed8a78$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $d60c7aefffed8a78$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $d60c7aefffed8a78$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $d60c7aefffed8a78$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $d60c7aefffed8a78$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $d60c7aefffed8a78$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $d60c7aefffed8a78$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $d60c7aefffed8a78$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $d60c7aefffed8a78$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $d60c7aefffed8a78$var$freezeDraftable(val) {
    return (0, $56Xh3.isDraftable)(val) ? (0, $56Xh3.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $d60c7aefffed8a78$var$isProduction = true;
var $d60c7aefffed8a78$var$prefix = "Invariant failed";
function $d60c7aefffed8a78$var$invariant(condition, message) {
    if (condition) return;
    if ($d60c7aefffed8a78$var$isProduction) throw new Error($d60c7aefffed8a78$var$prefix);
    throw new Error($d60c7aefffed8a78$var$prefix + ": " + (message || ""));
}
function $d60c7aefffed8a78$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $d60c7aefffed8a78$var$getSerialize(serializer, decycler), indent);
}
function $d60c7aefffed8a78$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $d60c7aefffed8a78$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d60c7aefffed8a78$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $d60c7aefffed8a78$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $d60c7aefffed8a78$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $d60c7aefffed8a78$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $d60c7aefffed8a78$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $d60c7aefffed8a78$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $d60c7aefffed8a78$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $d60c7aefffed8a78$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $d60c7aefffed8a78$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $d60c7aefffed8a78$export$53b83ca8eaab0383(val);
}
function $d60c7aefffed8a78$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $d60c7aefffed8a78$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d60c7aefffed8a78$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $d60c7aefffed8a78$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d60c7aefffed8a78$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d60c7aefffed8a78$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d60c7aefffed8a78$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $d60c7aefffed8a78$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $d60c7aefffed8a78$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $d60c7aefffed8a78$export$36c1185aeee5b0a6(options);
    };
}
function $d60c7aefffed8a78$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $d60c7aefffed8a78$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($d60c7aefffed8a78$var$isBoolean(thunk)) middlewareArray.push((0, $a65a962df7391a7a$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $a65a962df7391a7a$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $d60c7aefffed8a78$var$IS_PRODUCTION = true;
function $d60c7aefffed8a78$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $d60c7aefffed8a78$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($d60c7aefffed8a78$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $b4bc487a38c3f200$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$d60c7aefffed8a78$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$d60c7aefffed8a78$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $b4bc487a38c3f200$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $b4bc487a38c3f200$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d60c7aefffed8a78$var$composeWithDevTools($d60c7aefffed8a78$var$__spreadValues({
        trace: !$d60c7aefffed8a78$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $d60c7aefffed8a78$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $d60c7aefffed8a78$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $b4bc487a38c3f200$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d60c7aefffed8a78$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d60c7aefffed8a78$var$isStateFunction(x) {
    return typeof x === "function";
}
var $d60c7aefffed8a78$var$hasWarnedAboutObjectNotation = false;
function $d60c7aefffed8a78$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $d60c7aefffed8a78$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($d60c7aefffed8a78$var$isStateFunction(initialState)) getInitialState = function() {
        return $d60c7aefffed8a78$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $d60c7aefffed8a78$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $d60c7aefffed8a78$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $56Xh3.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $56Xh3.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $56Xh3.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $d60c7aefffed8a78$var$hasWarnedAboutObjectNotation2 = false;
function $d60c7aefffed8a78$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $d60c7aefffed8a78$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : $d60c7aefffed8a78$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $d60c7aefffed8a78$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $d60c7aefffed8a78$export$309c7a02b0b0bc62(type, prepareCallback) : $d60c7aefffed8a78$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $d60c7aefffed8a78$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $d60c7aefffed8a78$var$__spreadValues($d60c7aefffed8a78$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $d60c7aefffed8a78$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $d60c7aefffed8a78$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d60c7aefffed8a78$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($d60c7aefffed8a78$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d60c7aefffed8a78$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $d60c7aefffed8a78$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $d60c7aefffed8a78$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $d60c7aefffed8a78$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $d60c7aefffed8a78$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $d60c7aefffed8a78$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $d60c7aefffed8a78$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $d60c7aefffed8a78$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $d60c7aefffed8a78$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $d60c7aefffed8a78$var$createSingleArgumentStateOperator(mutator) {
    var operator = $d60c7aefffed8a78$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d60c7aefffed8a78$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d60c7aefffed8a78$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $56Xh3.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $56Xh3.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $d60c7aefffed8a78$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $d60c7aefffed8a78$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d60c7aefffed8a78$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d60c7aefffed8a78$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $d60c7aefffed8a78$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d60c7aefffed8a78$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $d60c7aefffed8a78$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d60c7aefffed8a78$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $d60c7aefffed8a78$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d60c7aefffed8a78$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d60c7aefffed8a78$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $d60c7aefffed8a78$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $d60c7aefffed8a78$var$__spreadValues($d60c7aefffed8a78$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $d60c7aefffed8a78$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $d60c7aefffed8a78$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d60c7aefffed8a78$var$createStateOperator(addOneMutably),
        addMany: $d60c7aefffed8a78$var$createStateOperator(addManyMutably),
        setOne: $d60c7aefffed8a78$var$createStateOperator(setOneMutably),
        setMany: $d60c7aefffed8a78$var$createStateOperator(setManyMutably),
        setAll: $d60c7aefffed8a78$var$createStateOperator(setAllMutably),
        updateOne: $d60c7aefffed8a78$var$createStateOperator(updateOneMutably),
        updateMany: $d60c7aefffed8a78$var$createStateOperator(updateManyMutably),
        upsertOne: $d60c7aefffed8a78$var$createStateOperator(upsertOneMutably),
        upsertMany: $d60c7aefffed8a78$var$createStateOperator(upsertManyMutably),
        removeOne: $d60c7aefffed8a78$var$createStateOperator(removeOneMutably),
        removeMany: $d60c7aefffed8a78$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d60c7aefffed8a78$var$createSortedStateAdapter(selectId, sort) {
    var _c = $d60c7aefffed8a78$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d60c7aefffed8a78$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($d60c7aefffed8a78$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d60c7aefffed8a78$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d60c7aefffed8a78$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $d60c7aefffed8a78$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d60c7aefffed8a78$var$createStateOperator(addOneMutably),
        updateOne: $d60c7aefffed8a78$var$createStateOperator(updateOneMutably),
        upsertOne: $d60c7aefffed8a78$var$createStateOperator(upsertOneMutably),
        setOne: $d60c7aefffed8a78$var$createStateOperator(setOneMutably),
        setMany: $d60c7aefffed8a78$var$createStateOperator(setManyMutably),
        setAll: $d60c7aefffed8a78$var$createStateOperator(setAllMutably),
        addMany: $d60c7aefffed8a78$var$createStateOperator(addManyMutably),
        updateMany: $d60c7aefffed8a78$var$createStateOperator(updateManyMutably),
        upsertMany: $d60c7aefffed8a78$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d60c7aefffed8a78$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $d60c7aefffed8a78$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $d60c7aefffed8a78$var$createInitialStateFactory();
    var selectorsFactory = $d60c7aefffed8a78$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $d60c7aefffed8a78$var$createSortedStateAdapter(selectId, sortComparer) : $d60c7aefffed8a78$var$createUnsortedStateAdapter(selectId);
    return $d60c7aefffed8a78$var$__spreadValues($d60c7aefffed8a78$var$__spreadValues($d60c7aefffed8a78$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $d60c7aefffed8a78$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d60c7aefffed8a78$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $d60c7aefffed8a78$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d60c7aefffed8a78$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d60c7aefffed8a78$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $d60c7aefffed8a78$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $d60c7aefffed8a78$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $d60c7aefffed8a78$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d60c7aefffed8a78$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $d60c7aefffed8a78$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $d60c7aefffed8a78$var$__spreadProps($d60c7aefffed8a78$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $d60c7aefffed8a78$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $d60c7aefffed8a78$var$__spreadProps($d60c7aefffed8a78$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $d60c7aefffed8a78$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $d60c7aefffed8a78$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d60c7aefffed8a78$var$__spreadProps($d60c7aefffed8a78$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d60c7aefffed8a78$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $d60c7aefffed8a78$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $d60c7aefffed8a78$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$d60c7aefffed8a78$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $d60c7aefffed8a78$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $d60c7aefffed8a78$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $d60c7aefffed8a78$var$RejectWithValue) throw result;
                                                if (result instanceof $d60c7aefffed8a78$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $d60c7aefffed8a78$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($d60c7aefffed8a78$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $d60c7aefffed8a78$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d60c7aefffed8a78$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $d60c7aefffed8a78$var$matches = function(matcher, action) {
    if ($d60c7aefffed8a78$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d60c7aefffed8a78$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $d60c7aefffed8a78$var$matches(matcher, action);
        });
    };
}
function $d60c7aefffed8a78$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $d60c7aefffed8a78$var$matches(matcher, action);
        });
    };
}
function $d60c7aefffed8a78$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d60c7aefffed8a78$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d60c7aefffed8a78$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d60c7aefffed8a78$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$d60c7aefffed8a78$var$isAsyncThunkArray(asyncThunks)) return $d60c7aefffed8a78$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $d60c7aefffed8a78$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d60c7aefffed8a78$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d60c7aefffed8a78$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$d60c7aefffed8a78$var$isAsyncThunkArray(asyncThunks)) return $d60c7aefffed8a78$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $d60c7aefffed8a78$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d60c7aefffed8a78$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $d60c7aefffed8a78$export$9dd1fb32974da385($d60c7aefffed8a78$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$d60c7aefffed8a78$var$isAsyncThunkArray(asyncThunks)) return $d60c7aefffed8a78$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $d60c7aefffed8a78$export$9dd1fb32974da385($d60c7aefffed8a78$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $d60c7aefffed8a78$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d60c7aefffed8a78$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$d60c7aefffed8a78$var$isAsyncThunkArray(asyncThunks)) return $d60c7aefffed8a78$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $d60c7aefffed8a78$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $d60c7aefffed8a78$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $d60c7aefffed8a78$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$d60c7aefffed8a78$var$isAsyncThunkArray(asyncThunks)) return $d60c7aefffed8a78$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $d60c7aefffed8a78$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $d60c7aefffed8a78$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $d60c7aefffed8a78$var$noop = function() {};
var $d60c7aefffed8a78$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $d60c7aefffed8a78$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $d60c7aefffed8a78$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $d60c7aefffed8a78$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $d60c7aefffed8a78$var$task = "task";
var $d60c7aefffed8a78$var$listener = "listener";
var $d60c7aefffed8a78$var$completed = "completed";
var $d60c7aefffed8a78$var$cancelled = "cancelled";
var $d60c7aefffed8a78$var$taskCancelled = "task-" + $d60c7aefffed8a78$var$cancelled;
var $d60c7aefffed8a78$var$taskCompleted = "task-" + $d60c7aefffed8a78$var$completed;
var $d60c7aefffed8a78$var$listenerCancelled = $d60c7aefffed8a78$var$listener + "-" + $d60c7aefffed8a78$var$cancelled;
var $d60c7aefffed8a78$var$listenerCompleted = $d60c7aefffed8a78$var$listener + "-" + $d60c7aefffed8a78$var$completed;
var $d60c7aefffed8a78$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $d60c7aefffed8a78$var$task + " " + $d60c7aefffed8a78$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $d60c7aefffed8a78$var$validateActive = function(signal) {
    if (signal.aborted) throw new $d60c7aefffed8a78$export$cb1bdac908fed7f(signal.reason);
};
function $d60c7aefffed8a78$var$raceWithSignal(signal, promise2) {
    var cleanup = $d60c7aefffed8a78$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $d60c7aefffed8a78$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d60c7aefffed8a78$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $d60c7aefffed8a78$var$noop;
    });
}
var $d60c7aefffed8a78$var$runTask = function(task2, cleanUp) {
    return $d60c7aefffed8a78$var$__async(void 0, null, function() {
        var value, error_1;
        return $d60c7aefffed8a78$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $d60c7aefffed8a78$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $d60c7aefffed8a78$var$createPause = function(signal) {
    return function(promise2) {
        return $d60c7aefffed8a78$var$catchRejection($d60c7aefffed8a78$var$raceWithSignal(signal, promise2).then(function(output) {
            $d60c7aefffed8a78$var$validateActive(signal);
            return output;
        }));
    };
};
var $d60c7aefffed8a78$var$createDelay = function(signal) {
    var pause = $d60c7aefffed8a78$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $d60c7aefffed8a78$var$assign = Object.assign;
var $d60c7aefffed8a78$var$INTERNAL_NIL_TOKEN = {};
var $d60c7aefffed8a78$var$alm = "listenerMiddleware";
var $d60c7aefffed8a78$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $d60c7aefffed8a78$var$addAbortSignalListener(parentAbortSignal, function() {
            return $d60c7aefffed8a78$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $d60c7aefffed8a78$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $d60c7aefffed8a78$var$runTask(function() {
            return $d60c7aefffed8a78$var$__async(void 0, null, function() {
                var result2;
                return $d60c7aefffed8a78$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $d60c7aefffed8a78$var$validateActive(parentAbortSignal);
                            $d60c7aefffed8a78$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $d60c7aefffed8a78$var$createPause(childAbortController.signal),
                                    delay: $d60c7aefffed8a78$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $d60c7aefffed8a78$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $d60c7aefffed8a78$var$abortControllerWithReason(childAbortController, $d60c7aefffed8a78$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $d60c7aefffed8a78$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $d60c7aefffed8a78$var$abortControllerWithReason(childAbortController, $d60c7aefffed8a78$var$taskCancelled);
            }
        };
    };
};
var $d60c7aefffed8a78$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $d60c7aefffed8a78$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $d60c7aefffed8a78$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $d60c7aefffed8a78$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $d60c7aefffed8a78$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $d60c7aefffed8a78$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $d60c7aefffed8a78$var$catchRejection(take(predicate, timeout));
    };
};
var $d60c7aefffed8a78$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $d60c7aefffed8a78$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $d60c7aefffed8a78$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d60c7aefffed8a78$var$createListenerEntry = function(options) {
    var _c = $d60c7aefffed8a78$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $d60c7aefffed8a78$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $d60c7aefffed8a78$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $d60c7aefffed8a78$var$abortControllerWithReason(controller, $d60c7aefffed8a78$var$listenerCancelled);
    });
};
var $d60c7aefffed8a78$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($d60c7aefffed8a78$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $d60c7aefffed8a78$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $d60c7aefffed8a78$export$f03a6b845d3fb58b = $d60c7aefffed8a78$export$309c7a02b0b0bc62($d60c7aefffed8a78$var$alm + "/add");
var $d60c7aefffed8a78$export$b1b8022855fb2b71 = $d60c7aefffed8a78$export$309c7a02b0b0bc62($d60c7aefffed8a78$var$alm + "/removeAll");
var $d60c7aefffed8a78$export$b03e9483f936dccb = $d60c7aefffed8a78$export$309c7a02b0b0bc62($d60c7aefffed8a78$var$alm + "/remove");
var $d60c7aefffed8a78$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $d60c7aefffed8a78$var$__spreadArray([
        $d60c7aefffed8a78$var$alm + "/error"
    ], args));
};
function $d60c7aefffed8a78$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $d60c7aefffed8a78$var$defaultErrorHandler : _c;
    $d60c7aefffed8a78$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d60c7aefffed8a78$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $d60c7aefffed8a78$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $d60c7aefffed8a78$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d60c7aefffed8a78$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $d60c7aefffed8a78$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $d60c7aefffed8a78$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $d60c7aefffed8a78$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $d60c7aefffed8a78$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $d60c7aefffed8a78$var$createDelay(internalTaskController.signal),
                                pause: $d60c7aefffed8a78$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $d60c7aefffed8a78$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $d60c7aefffed8a78$var$abortControllerWithReason(controller, $d60c7aefffed8a78$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $d60c7aefffed8a78$export$cb1bdac908fed7f)) $d60c7aefffed8a78$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $d60c7aefffed8a78$var$abortControllerWithReason(internalTaskController, $d60c7aefffed8a78$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $d60c7aefffed8a78$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$d60c7aefffed8a78$export$b956e38827fca970(action)) return next(action);
                if ($d60c7aefffed8a78$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d60c7aefffed8a78$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d60c7aefffed8a78$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $d60c7aefffed8a78$var$INTERNAL_NIL_TOKEN) throw new Error($d60c7aefffed8a78$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d60c7aefffed8a78$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d60c7aefffed8a78$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $d60c7aefffed8a78$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d60c7aefffed8a78$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$d60c7aefffed8a78$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $d60c7aefffed8a78$var$promise;
var $d60c7aefffed8a78$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($d60c7aefffed8a78$var$promise || ($d60c7aefffed8a78$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $d60c7aefffed8a78$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $d60c7aefffed8a78$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d60c7aefffed8a78$var$createQueueWithTimer(10);
var $d60c7aefffed8a78$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $d60c7aefffed8a78$var$queueMicrotaskShim : options.type === "raf" ? $d60c7aefffed8a78$var$rAF : options.type === "callback" ? options.queueNotification : $d60c7aefffed8a78$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d60c7aefffed8a78$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $56Xh3.enableES5)();


var $909e1e5d36056665$var$initialState = {
    layoutType: 'horizontal',
    width: 0,
    height: 0,
    margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    scale: 1
};
var $909e1e5d36056665$var$chartLayoutSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'chartLayout',
    initialState: $909e1e5d36056665$var$initialState,
    reducers: {
        setLayout (state, action) {
            state.layoutType = action.payload;
        },
        setChartSize (state, action) {
            state.width = action.payload.width;
            state.height = action.payload.height;
        },
        setMargin (state, action) {
            var _action$payload$top, _action$payload$right, _action$payload$botto, _action$payload$left;
            state.margin.top = (_action$payload$top = action.payload.top) !== null && _action$payload$top !== void 0 ? _action$payload$top : 0;
            state.margin.right = (_action$payload$right = action.payload.right) !== null && _action$payload$right !== void 0 ? _action$payload$right : 0;
            state.margin.bottom = (_action$payload$botto = action.payload.bottom) !== null && _action$payload$botto !== void 0 ? _action$payload$botto : 0;
            state.margin.left = (_action$payload$left = action.payload.left) !== null && _action$payload$left !== void 0 ? _action$payload$left : 0;
        },
        setScale (state, action) {
            state.scale = action.payload;
        }
    }
});
var { setMargin: $909e1e5d36056665$export$3f8f25b83912855f, setLayout: $909e1e5d36056665$export$e8437af1f2483b8e, setChartSize: $909e1e5d36056665$export$136b7feefeae481a, setScale: $909e1e5d36056665$export$4dc523f7f9b3edd6 } = $909e1e5d36056665$var$chartLayoutSlice.actions;
var $909e1e5d36056665$export$701395c4acfabc85 = $909e1e5d36056665$var$chartLayoutSlice.reducer;


var $ff7643c45c712aa2$var$__defProp = Object.defineProperty;
var $ff7643c45c712aa2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ff7643c45c712aa2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ff7643c45c712aa2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ff7643c45c712aa2$var$__defNormalProp = (obj, key, value)=>key in obj ? $ff7643c45c712aa2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ff7643c45c712aa2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ff7643c45c712aa2$var$__hasOwnProp.call(b, prop)) $ff7643c45c712aa2$var$__defNormalProp(a, prop, b[prop]);
    if ($ff7643c45c712aa2$var$__getOwnPropSymbols) {
        for (var prop of $ff7643c45c712aa2$var$__getOwnPropSymbols(b))if ($ff7643c45c712aa2$var$__propIsEnum.call(b, prop)) $ff7643c45c712aa2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ff7643c45c712aa2$var$__publicField = (obj, key, value)=>{
    $ff7643c45c712aa2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $ff7643c45c712aa2$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $ff7643c45c712aa2$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $ff7643c45c712aa2$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $ff7643c45c712aa2$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($ff7643c45c712aa2$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $ff7643c45c712aa2$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $ff7643c45c712aa2$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $ff7643c45c712aa2$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $ff7643c45c712aa2$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $ff7643c45c712aa2$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $ff7643c45c712aa2$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $ff7643c45c712aa2$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $ff7643c45c712aa2$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $ff7643c45c712aa2$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $ff7643c45c712aa2$var$__spreadValues($ff7643c45c712aa2$var$__spreadValues({}, $ff7643c45c712aa2$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $ff7643c45c712aa2$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $ff7643c45c712aa2$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $ff7643c45c712aa2$var$$REVISION = 0;
var $ff7643c45c712aa2$var$CURRENT_TRACKER = null;
var $ff7643c45c712aa2$var$Cell = class {
    constructor(initialValue, isEqual = $ff7643c45c712aa2$var$tripleEq){
        $ff7643c45c712aa2$var$__publicField(this, "revision", $ff7643c45c712aa2$var$$REVISION);
        $ff7643c45c712aa2$var$__publicField(this, "_value");
        $ff7643c45c712aa2$var$__publicField(this, "_lastValue");
        $ff7643c45c712aa2$var$__publicField(this, "_isEqual", $ff7643c45c712aa2$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $ff7643c45c712aa2$var$CURRENT_TRACKER == null || $ff7643c45c712aa2$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$ff7643c45c712aa2$var$$REVISION;
    }
};
function $ff7643c45c712aa2$var$tripleEq(a, b) {
    return a === b;
}
var $ff7643c45c712aa2$var$TrackingCache = class {
    constructor(fn){
        $ff7643c45c712aa2$var$__publicField(this, "_cachedValue");
        $ff7643c45c712aa2$var$__publicField(this, "_cachedRevision", -1);
        $ff7643c45c712aa2$var$__publicField(this, "_deps", []);
        $ff7643c45c712aa2$var$__publicField(this, "hits", 0);
        $ff7643c45c712aa2$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $ff7643c45c712aa2$var$CURRENT_TRACKER;
            $ff7643c45c712aa2$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $ff7643c45c712aa2$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $ff7643c45c712aa2$var$CURRENT_TRACKER == null || $ff7643c45c712aa2$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $ff7643c45c712aa2$var$getValue(cell) {
    if (!(cell instanceof $ff7643c45c712aa2$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $ff7643c45c712aa2$var$setValue(storage, value) {
    if (!(storage instanceof $ff7643c45c712aa2$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $ff7643c45c712aa2$var$createCell(initialValue, isEqual = $ff7643c45c712aa2$var$tripleEq) {
    return new $ff7643c45c712aa2$var$Cell(initialValue, isEqual);
}
function $ff7643c45c712aa2$var$createCache(fn) {
    $ff7643c45c712aa2$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $ff7643c45c712aa2$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $ff7643c45c712aa2$var$neverEq = (a, b)=>false;
function $ff7643c45c712aa2$var$createTag() {
    return $ff7643c45c712aa2$var$createCell(null, $ff7643c45c712aa2$var$neverEq);
}
function $ff7643c45c712aa2$var$dirtyTag(tag, value) {
    $ff7643c45c712aa2$var$setValue(tag, value);
}
var $ff7643c45c712aa2$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $ff7643c45c712aa2$var$createTag();
    $ff7643c45c712aa2$var$getValue(tag);
};
var $ff7643c45c712aa2$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $ff7643c45c712aa2$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $ff7643c45c712aa2$var$REDUX_PROXY_LABEL = Symbol();
var $ff7643c45c712aa2$var$nextId = 0;
var $ff7643c45c712aa2$var$proto = Object.getPrototypeOf({});
var $ff7643c45c712aa2$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $ff7643c45c712aa2$var$__publicField(this, "proxy", new Proxy(this, $ff7643c45c712aa2$var$objectProxyHandler));
        $ff7643c45c712aa2$var$__publicField(this, "tag", $ff7643c45c712aa2$var$createTag());
        $ff7643c45c712aa2$var$__publicField(this, "tags", {});
        $ff7643c45c712aa2$var$__publicField(this, "children", {});
        $ff7643c45c712aa2$var$__publicField(this, "collectionTag", null);
        $ff7643c45c712aa2$var$__publicField(this, "id", $ff7643c45c712aa2$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $ff7643c45c712aa2$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $ff7643c45c712aa2$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $ff7643c45c712aa2$var$createNode(childValue);
                if (childNode.tag) $ff7643c45c712aa2$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $ff7643c45c712aa2$var$createTag();
                    tag.value = childValue;
                }
                $ff7643c45c712aa2$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $ff7643c45c712aa2$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $ff7643c45c712aa2$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $ff7643c45c712aa2$var$__publicField(this, "proxy", new Proxy([
            this
        ], $ff7643c45c712aa2$var$arrayProxyHandler));
        $ff7643c45c712aa2$var$__publicField(this, "tag", $ff7643c45c712aa2$var$createTag());
        $ff7643c45c712aa2$var$__publicField(this, "tags", {});
        $ff7643c45c712aa2$var$__publicField(this, "children", {});
        $ff7643c45c712aa2$var$__publicField(this, "collectionTag", null);
        $ff7643c45c712aa2$var$__publicField(this, "id", $ff7643c45c712aa2$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $ff7643c45c712aa2$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $ff7643c45c712aa2$var$consumeCollection(node);
        return $ff7643c45c712aa2$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $ff7643c45c712aa2$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $ff7643c45c712aa2$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $ff7643c45c712aa2$var$objectProxyHandler.has(node, prop);
    }
};
function $ff7643c45c712aa2$var$createNode(value) {
    if (Array.isArray(value)) return new $ff7643c45c712aa2$var$ArrayTreeNode(value);
    return new $ff7643c45c712aa2$var$ObjectTreeNode(value);
}
function $ff7643c45c712aa2$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $ff7643c45c712aa2$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $ff7643c45c712aa2$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $ff7643c45c712aa2$var$dirtyCollection(node);
            $ff7643c45c712aa2$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $ff7643c45c712aa2$var$updateNode(childNode, newChildValue);
        else {
            $ff7643c45c712aa2$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $ff7643c45c712aa2$var$deleteNode(node) {
    if (node.tag) $ff7643c45c712aa2$var$dirtyTag(node.tag, null);
    $ff7643c45c712aa2$var$dirtyCollection(node);
    for(const key in node.tags)$ff7643c45c712aa2$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$ff7643c45c712aa2$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $ff7643c45c712aa2$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $ff7643c45c712aa2$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $ff7643c45c712aa2$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $ff7643c45c712aa2$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $ff7643c45c712aa2$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $ff7643c45c712aa2$export$3f025202a230c6dd = (a, b)=>a === b;
function $ff7643c45c712aa2$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $ff7643c45c712aa2$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $ff7643c45c712aa2$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $ff7643c45c712aa2$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $ff7643c45c712aa2$var$createSingletonCache(comparator) : $ff7643c45c712aa2$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $ff7643c45c712aa2$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $ff7643c45c712aa2$export$c8f9cf88d9fdee55(func) {
    const node = $ff7643c45c712aa2$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $ff7643c45c712aa2$var$createCacheKeyComparator($ff7643c45c712aa2$export$3f025202a230c6dd);
    const cache = $ff7643c45c712aa2$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $ff7643c45c712aa2$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $ff7643c45c712aa2$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $ff7643c45c712aa2$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $ff7643c45c712aa2$var$StrongRef;
var $ff7643c45c712aa2$var$UNTERMINATED = 0;
var $ff7643c45c712aa2$var$TERMINATED = 1;
function $ff7643c45c712aa2$var$createCacheNode() {
    return {
        s: $ff7643c45c712aa2$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $ff7643c45c712aa2$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $ff7643c45c712aa2$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $ff7643c45c712aa2$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $ff7643c45c712aa2$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $ff7643c45c712aa2$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $ff7643c45c712aa2$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $ff7643c45c712aa2$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $ff7643c45c712aa2$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $ff7643c45c712aa2$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $ff7643c45c712aa2$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $ff7643c45c712aa2$var$__spreadValues($ff7643c45c712aa2$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $ff7643c45c712aa2$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $ff7643c45c712aa2$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $ff7643c45c712aa2$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $ff7643c45c712aa2$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $ff7643c45c712aa2$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $ff7643c45c712aa2$export$595d22ed68ca2841 = /* @__PURE__ */ $ff7643c45c712aa2$export$5943f4447f6ef248($ff7643c45c712aa2$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $ff7643c45c712aa2$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $ff7643c45c712aa2$export$595d22ed68ca2841)=>{
    $ff7643c45c712aa2$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$ff7643c45c712aa2$export$75979cfcd91bf38f
});



var $63d55c965c0eca64$exports = {};

$63d55c965c0eca64$exports = (parcelRequire("h9EiF")).sortBy;


var $94d84d1c93d9fa29$export$1d27a9e667f67593 = (state)=>state.legend.settings;
var $94d84d1c93d9fa29$export$c9c2b00a34f852e5 = (state)=>state.legend.size;
var $94d84d1c93d9fa29$var$selectAllLegendPayload2DArray = (state)=>state.legend.payload;
var $94d84d1c93d9fa29$export$9a6de64b691a7304 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $94d84d1c93d9fa29$var$selectAllLegendPayload2DArray,
    $94d84d1c93d9fa29$export$1d27a9e667f67593
], (payloads, _ref)=>{
    var { itemSorter: itemSorter } = _ref;
    var flat = payloads.flat(1);
    return itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($63d55c965c0eca64$exports)))(flat, itemSorter) : flat;
});




var $37e225aae6e0868f$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$37e225aae6e0868f$exports = (parcelRequire("cNk52"));



function $bd2b31f7ff5e821d$export$238176e5211cdc1a(arr, startIndex, endIndex) {
    if (!Array.isArray(arr)) return arr;
    if (arr && startIndex + endIndex !== 0) return arr.slice(startIndex, endIndex + 1);
    return arr;
}


function $09206e1485e62bdb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $09206e1485e62bdb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $09206e1485e62bdb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $09206e1485e62bdb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $09206e1485e62bdb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $09206e1485e62bdb$var$_defineProperty(e, r, t) {
    return (r = $09206e1485e62bdb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $09206e1485e62bdb$var$_toPropertyKey(t) {
    var i = $09206e1485e62bdb$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $09206e1485e62bdb$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $09206e1485e62bdb$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(obj) || (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(dataKey)) return defaultValue;
    if ((0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($a7b626aae7e6649e$exports)))(obj, dataKey, defaultValue);
    if (typeof dataKey === 'function') return dataKey(obj);
    return defaultValue;
}
var $09206e1485e62bdb$export$3a657a8c9f789617 = (offset, legendSettings, legendSize)=>{
    if (legendSettings && legendSize) {
        var { width: boxWidth, height: boxHeight } = legendSize;
        var { align: align, verticalAlign: verticalAlign, layout: layout } = legendSettings;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(offset[align])) return $09206e1485e62bdb$var$_objectSpread($09206e1485e62bdb$var$_objectSpread({}, offset), {}, {
            [align]: offset[align] + (boxWidth || 0)
        });
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(offset[verticalAlign])) return $09206e1485e62bdb$var$_objectSpread($09206e1485e62bdb$var$_objectSpread({}, offset), {}, {
            [verticalAlign]: offset[verticalAlign] + (boxHeight || 0)
        });
    }
    return offset;
};
var $09206e1485e62bdb$export$9fc1baaa6c6368b = (layout, axisType)=>layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
var $09206e1485e62bdb$export$846dc5ac5fecff74 = (ticks, minValue, maxValue, syncWithTicks)=>{
    if (syncWithTicks) return ticks.map((entry)=>entry.coordinate);
    var hasMin, hasMax;
    var values = ticks.map((entry)=>{
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $09206e1485e62bdb$export$c829ee42daf7f66d = (axis, isGrid, isAll)=>{
    if (!axis) return null;
    var { duplicateDomain: duplicateDomain, type: type, range: range, scale: scale, realScaleType: realScaleType, isCategorical: isCategorical, categoricalDomain: categoricalDomain, tickCount: tickCount, ticks: ticks, niceTicks: niceTicks, axisType: axisType } = axis;
    if (!scale) return null;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range && range.length >= 2 ? (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (ticks || niceTicks)) {
        var result = (ticks || niceTicks || []).map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset,
                index: index
            };
        });
        return result.filter((row)=>!(0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(row.coordinate));
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        }));
    if (scale.ticks && !isAll && tickCount != null) return scale.ticks(tickCount).map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset,
            index: index
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        }));
};
var $09206e1485e62bdb$var$EPS = 1e-4;
var $09206e1485e62bdb$export$9d80152e23bae434 = (scale)=>{
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $09206e1485e62bdb$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $09206e1485e62bdb$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $09206e1485e62bdb$export$c7ec0fa96d0c462e = (value, domain)=>{
    if (!domain || domain.length !== 2 || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(domain[0]) || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $09206e1485e62bdb$export$3104c513558164c1 = (series)=>{
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $09206e1485e62bdb$export$9f2c6ead70935022 = (series)=>{
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $09206e1485e62bdb$var$STACK_OFFSET_MAP = {
    sign: $09206e1485e62bdb$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $37e225aae6e0868f$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $37e225aae6e0868f$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $37e225aae6e0868f$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $37e225aae6e0868f$exports.stackOffsetWiggle),
    positive: $09206e1485e62bdb$export$9f2c6ead70935022
};
var $09206e1485e62bdb$export$c2170542cfc0177c = (data, dataKeys, offsetType)=>{
    var offsetAccessor = $09206e1485e62bdb$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $37e225aae6e0868f$exports.stack)().keys(dataKeys).value((d, key)=>Number($09206e1485e62bdb$export$f97fc4a450f29a(d, key, 0))).order((0, $37e225aae6e0868f$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
function $09206e1485e62bdb$export$f0871da41ca7fc82(publicStackId) {
    return publicStackId == null ? undefined : String(publicStackId);
}
function $09206e1485e62bdb$export$6e87f3defb83c3f(_ref) {
    var { axis: axis, ticks: ticks, bandSize: bandSize, entry: entry, index: index, dataKey: dataKey } = _ref;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $9d9ad0197f7e4c2b$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $09206e1485e62bdb$export$f97fc4a450f29a(entry, !(0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(dataKey) ? dataKey : axis.dataKey);
    // @ts-expect-error getValueByDataKey does not validate the output type
    return !(0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(value) ? axis.scale(value) : null;
}
var $09206e1485e62bdb$export$8abb9e87422f3a0c = (_ref2)=>{
    var { axis: axis, ticks: ticks, offset: offset, bandSize: bandSize, entry: entry, index: index } = _ref2;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $09206e1485e62bdb$export$f97fc4a450f29a(entry, axis.dataKey, axis.scale.domain()[index]);
    return !(0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $09206e1485e62bdb$export$54f3200dd4a8a235 = (_ref3)=>{
    var { numericAxis: numericAxis } = _ref3;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var minValue = Math.min(domain[0], domain[1]);
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $09206e1485e62bdb$var$getDomainOfSingle = (data)=>{
    var flat = data.flat(2).filter((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614));
    return [
        Math.min(...flat),
        Math.max(...flat)
    ];
};
var $09206e1485e62bdb$var$makeDomainFinite = (domain)=>{
    return [
        domain[0] === Infinity ? 0 : domain[0],
        domain[1] === -Infinity ? 0 : domain[1]
    ];
};
var $09206e1485e62bdb$export$26522b779eb5497c = (stackGroups, startIndex, endIndex)=>{
    if (stackGroups == null) return undefined;
    return $09206e1485e62bdb$var$makeDomainFinite(Object.keys(stackGroups).reduce((result, stackId)=>{
        var group = stackGroups[stackId];
        var { stackedData: stackedData } = group;
        var domain = stackedData.reduce((res, entry)=>{
            var sliced = (0, $bd2b31f7ff5e821d$export$238176e5211cdc1a)(entry, startIndex, endIndex);
            var s = $09206e1485e62bdb$var$getDomainOfSingle(sliced);
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]));
};
var $09206e1485e62bdb$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $09206e1485e62bdb$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $09206e1485e62bdb$export$212ec45c42fe68a7 = (axis, ticks, isBar)=>{
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($63d55c965c0eca64$exports)))(ticks, (o)=>o.coordinate);
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
function $09206e1485e62bdb$export$3c1b390368bb3561(_ref4) {
    var { tooltipEntrySettings: tooltipEntrySettings, dataKey: dataKey, payload: payload, value: value, name: name } = _ref4;
    return $09206e1485e62bdb$var$_objectSpread($09206e1485e62bdb$var$_objectSpread({}, tooltipEntrySettings), {}, {
        dataKey: dataKey,
        payload: payload,
        value: value,
        name: name
    });
}
function $09206e1485e62bdb$export$d3207de44081d2b3(nameFromItem, dataKey) {
    if (nameFromItem) return String(nameFromItem);
    if (typeof dataKey === 'string') return dataKey;
    return undefined;
}
var $09206e1485e62bdb$export$f29fac779ccd75bc = (coordinate, layout)=>{
    if (layout === 'horizontal') return coordinate.chartX;
    if (layout === 'vertical') return coordinate.chartY;
    return undefined;
};
var $09206e1485e62bdb$export$fb2b0f76aa25d837 = (rangeObj, layout)=>{
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};


var $122c64eee523dc50$export$771ef0ac044f724d = (state)=>state.layout.width;
var $122c64eee523dc50$export$5856a7d94c109505 = (state)=>state.layout.height;
var $122c64eee523dc50$export$317b55dda5fb5617 = (state)=>state.layout.scale;
var $122c64eee523dc50$export$aa3aa1fbf76377f0 = (state)=>state.layout.margin;



var $ca40ce91d5de9c53$export$bd320344232f30af = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((state)=>state.cartesianAxis.xAxis, (xAxisMap)=>{
    return Object.values(xAxisMap);
});
var $ca40ce91d5de9c53$export$e22adabb0128cf25 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((state)=>state.cartesianAxis.yAxis, (yAxisMap)=>{
    return Object.values(yAxisMap);
});


var $61c6522d82a73e91$export$db34c3e22d611955 = [
    '#1890FF',
    '#66B5FF',
    '#41D9C7',
    '#2FC25B',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#223273',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#13C2C2',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9'
];
var $61c6522d82a73e91$export$c0f3d78d63b3e065 = 'data-recharts-item-index';
var $61c6522d82a73e91$export$38427ae88f231d57 = 'data-recharts-item-data-key';
var $61c6522d82a73e91$export$fb6ee82c8ee2faf8 = 60;


function $680da228e16ed19c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $680da228e16ed19c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $680da228e16ed19c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $680da228e16ed19c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $680da228e16ed19c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $680da228e16ed19c$var$_defineProperty(e, r, t) {
    return (r = $680da228e16ed19c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $680da228e16ed19c$var$_toPropertyKey(t) {
    var i = $680da228e16ed19c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $680da228e16ed19c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $680da228e16ed19c$export$2d0a7adecb2afc9c = (state)=>state.brush.height;
function $680da228e16ed19c$var$selectLeftAxesOffset(state) {
    var yAxes = (0, $ca40ce91d5de9c53$export$e22adabb0128cf25)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'left' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $61c6522d82a73e91$export$fb6ee82c8ee2faf8);
            return result + width;
        }
        return result;
    }, 0);
}
function $680da228e16ed19c$var$selectRightAxesOffset(state) {
    var yAxes = (0, $ca40ce91d5de9c53$export$e22adabb0128cf25)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'right' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $61c6522d82a73e91$export$fb6ee82c8ee2faf8);
            return result + width;
        }
        return result;
    }, 0);
}
function $680da228e16ed19c$var$selectTopAxesOffset(state) {
    var xAxes = (0, $ca40ce91d5de9c53$export$bd320344232f30af)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'top' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
function $680da228e16ed19c$var$selectBottomAxesOffset(state) {
    var xAxes = (0, $ca40ce91d5de9c53$export$bd320344232f30af)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'bottom' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
var $680da228e16ed19c$export$1e34c8efb0bc9b3b = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $122c64eee523dc50$export$771ef0ac044f724d),
    (0, $122c64eee523dc50$export$5856a7d94c109505),
    (0, $122c64eee523dc50$export$aa3aa1fbf76377f0),
    $680da228e16ed19c$export$2d0a7adecb2afc9c,
    $680da228e16ed19c$var$selectLeftAxesOffset,
    $680da228e16ed19c$var$selectRightAxesOffset,
    $680da228e16ed19c$var$selectTopAxesOffset,
    $680da228e16ed19c$var$selectBottomAxesOffset,
    (0, $94d84d1c93d9fa29$export$1d27a9e667f67593),
    (0, $94d84d1c93d9fa29$export$c9c2b00a34f852e5)
], (chartWidth, chartHeight, margin, brushHeight, leftAxesOffset, rightAxesOffset, topAxesOffset, bottomAxesOffset, legendSettings, legendSize)=>{
    var offsetH = {
        left: (margin.left || 0) + leftAxesOffset,
        right: (margin.right || 0) + rightAxesOffset
    };
    var offsetV = {
        top: (margin.top || 0) + topAxesOffset,
        bottom: (margin.bottom || 0) + bottomAxesOffset
    };
    var offset = $680da228e16ed19c$var$_objectSpread($680da228e16ed19c$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    offset.bottom += brushHeight;
    offset = (0, $09206e1485e62bdb$export$3a657a8c9f789617)(offset, legendSettings, legendSize);
    var offsetWidth = chartWidth - offset.left - offset.right;
    var offsetHeight = chartHeight - offset.top - offset.bottom;
    return $680da228e16ed19c$var$_objectSpread($680da228e16ed19c$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
});
var $680da228e16ed19c$export$fb5e3eb7f8167ce7 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)($680da228e16ed19c$export$1e34c8efb0bc9b3b, (offset)=>({
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    }));
var $680da228e16ed19c$export$32c8e778bac69ce4 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((0, $122c64eee523dc50$export$771ef0ac044f724d), (0, $122c64eee523dc50$export$5856a7d94c109505), (width, height)=>({
        x: 0,
        y: 0,
        width: width,
        height: height
    }));




var $aivMx = parcelRequire("aivMx");
var $1c9217aa5a5c378b$var$PanoramaContext = /*#__PURE__*/ (0, $aivMx.createContext)(null);
var $1c9217aa5a5c378b$export$4b0c59f8845ba920 = ()=>(0, $aivMx.useContext)($1c9217aa5a5c378b$var$PanoramaContext) != null;
var $1c9217aa5a5c378b$export$415fcedf1e191db0 = (_ref)=>{
    var { children: children } = _ref;
    return /*#__PURE__*/ $aivMx.createElement($1c9217aa5a5c378b$var$PanoramaContext.Provider, {
        value: true
    }, children);
};






var $157aebf66ae7c2b8$export$5ba94b496f8dc52e = (state)=>state.brush;
var $157aebf66ae7c2b8$export$3b81e97eae001823 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $157aebf66ae7c2b8$export$5ba94b496f8dc52e,
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    (0, $122c64eee523dc50$export$aa3aa1fbf76377f0)
], (brushSettings, offset, margin)=>({
        height: brushSettings.height,
        x: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(brushSettings.x) ? brushSettings.x : offset.left,
        y: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(brushSettings.y) ? brushSettings.y : offset.top + offset.height + offset.brushBottom - ((margin === null || margin === void 0 ? void 0 : margin.bottom) || 0),
        width: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(brushSettings.width) ? brushSettings.width : offset.width
    }));




var $aivMx = parcelRequire("aivMx");
var $2fd6e4c333b96ec3$exports = {};

$2fd6e4c333b96ec3$exports = (parcelRequire("1u5Rd")).throttle;



/* eslint no-console: 0 */ var $0b9d7895420683f6$var$isDev = true;
var $0b9d7895420683f6$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($0b9d7895420683f6$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, ()=>args[argIndex++]));
            }
        }
    }
};



var $04f67645b2a397ab$export$83d33ab1950e2a9 = (containerWidth, containerHeight, props)=>{
    var { width: width = '100%', height: height = '100%', aspect: aspect, maxHeight: maxHeight } = props;
    /*
   * The containerWidth and containerHeight are already percentage based because it's set as that percentage in CSS.
   * Means we don't have to calculate percentages here.
   */ var calculatedWidth = (0, $9d9ad0197f7e4c2b$export$e50269385c77c348)(width) ? containerWidth : Number(width);
    var calculatedHeight = (0, $9d9ad0197f7e4c2b$export$e50269385c77c348)(height) ? containerHeight : Number(height);
    if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) // Will default to using width for aspect ratio
        calculatedHeight = calculatedWidth / aspect;
        else if (calculatedHeight) // But we should also take height into consideration
        calculatedWidth = calculatedHeight * aspect;
        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight != null && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
    }
    return {
        calculatedWidth: calculatedWidth,
        calculatedHeight: calculatedHeight
    };
};
var $04f67645b2a397ab$var$bothOverflow = {
    width: 0,
    height: 0,
    overflow: 'visible'
};
var $04f67645b2a397ab$var$overflowX = {
    width: 0,
    overflowX: 'visible'
};
var $04f67645b2a397ab$var$overflowY = {
    height: 0,
    overflowY: 'visible'
};
var $04f67645b2a397ab$var$noStyle = {};
var $04f67645b2a397ab$export$d36bc8432d8d3f9d = (props)=>{
    var { width: width, height: height } = props;
    var isWidthPercent = (0, $9d9ad0197f7e4c2b$export$e50269385c77c348)(width);
    var isHeightPercent = (0, $9d9ad0197f7e4c2b$export$e50269385c77c348)(height);
    if (isWidthPercent && isHeightPercent) return $04f67645b2a397ab$var$bothOverflow;
    if (isWidthPercent) return $04f67645b2a397ab$var$overflowX;
    if (isHeightPercent) return $04f67645b2a397ab$var$overflowY;
    return $04f67645b2a397ab$var$noStyle;
};
function $04f67645b2a397ab$export$f717eb32fd8d3af5(_ref) {
    var { width: width, height: height, aspect: aspect } = _ref;
    var calculatedWidth = width;
    var calculatedHeight = height;
    if (calculatedWidth === undefined && calculatedHeight === undefined) {
        calculatedWidth = '100%';
        calculatedHeight = '100%';
    } else if (calculatedWidth === undefined) calculatedWidth = aspect && aspect > 0 ? undefined : '100%';
    else if (calculatedHeight === undefined) calculatedHeight = aspect && aspect > 0 ? undefined : '100%';
    return {
        width: calculatedWidth,
        height: calculatedHeight
    };
}



function $9acfa7cb966ff3a4$var$_extends() {
    return $9acfa7cb966ff3a4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9acfa7cb966ff3a4$var$_extends.apply(null, arguments);
}
function $9acfa7cb966ff3a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9acfa7cb966ff3a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9acfa7cb966ff3a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9acfa7cb966ff3a4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9acfa7cb966ff3a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9acfa7cb966ff3a4$var$_defineProperty(e, r, t) {
    return (r = $9acfa7cb966ff3a4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9acfa7cb966ff3a4$var$_toPropertyKey(t) {
    var i = $9acfa7cb966ff3a4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9acfa7cb966ff3a4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9acfa7cb966ff3a4$var$ResponsiveContainerContext = /*#__PURE__*/ (0, $aivMx.createContext)({
    width: -1,
    height: -1
});
function $9acfa7cb966ff3a4$var$isAcceptableSize(size) {
    return (0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(size.width) && (0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(size.height);
}
function $9acfa7cb966ff3a4$var$ResponsiveContainerContextProvider(_ref) {
    var { children: children, width: width, height: height } = _ref;
    var size = (0, $aivMx.useMemo)(()=>({
            width: width,
            height: height
        }), [
        width,
        height
    ]);
    if (!$9acfa7cb966ff3a4$var$isAcceptableSize(size)) /*
     * Don't render the container if width or height is non-positive because
     * in that case the chart will not be rendered properly anyway.
     * We will instead wait for the next resize event to provide the correct dimensions.
     */ return null;
    return /*#__PURE__*/ $aivMx.createElement($9acfa7cb966ff3a4$var$ResponsiveContainerContext.Provider, {
        value: size
    }, children);
}
var $9acfa7cb966ff3a4$export$4ec9972d4f677af6 = ()=>(0, $aivMx.useContext)($9acfa7cb966ff3a4$var$ResponsiveContainerContext);
var $9acfa7cb966ff3a4$var$SizeDetectorContainer = /*#__PURE__*/ (0, $aivMx.forwardRef)((_ref2, ref)=>{
    var { aspect: aspect, initialDimension: initialDimension = {
        width: -1,
        height: -1
    }, width: width, height: height, minWidth: /*
     * default min-width to 0 if not specified - 'auto' causes issues with flexbox
     * https://github.com/recharts/recharts/issues/172
     */ minWidth = 0, minHeight: minHeight, maxHeight: maxHeight, children: children, debounce: debounce = 0, id: id, className: className, onResize: onResize, style: style = {} } = _ref2;
    var containerRef = (0, $aivMx.useRef)(null);
    /*
   * We are using a ref to avoid re-creating the ResizeObserver when the onResize function changes.
   * The ref is updated on every render, so the latest onResize function is always available in the effect.
   */ var onResizeRef = (0, $aivMx.useRef)();
    onResizeRef.current = onResize;
    (0, $aivMx.useImperativeHandle)(ref, ()=>containerRef.current);
    var [sizes, setSizes] = (0, $aivMx.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    });
    var setContainerSize = (0, $aivMx.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $aivMx.useEffect)(()=>{
        if (containerRef.current == null || typeof ResizeObserver === 'undefined') return 0, $9d9ad0197f7e4c2b$export$8793edee2d425525;
        var callback = (entries)=>{
            var _onResizeRef$current;
            var { width: containerWidth, height: containerHeight } = entries[0].contentRect;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($2fd6e4c333b96ec3$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var { width: containerWidth, height: containerHeight } = containerRef.current.getBoundingClientRect();
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var { containerWidth: containerWidth, containerHeight: containerHeight } = sizes;
    (0, $0b9d7895420683f6$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
    var { calculatedWidth: calculatedWidth, calculatedHeight: calculatedHeight } = (0, $04f67645b2a397ab$export$83d33ab1950e2a9)(containerWidth, containerHeight, {
        width: width,
        height: height,
        aspect: aspect,
        maxHeight: maxHeight
    });
    (0, $0b9d7895420683f6$export$c106dd0671a0fc2d)(calculatedWidth != null && calculatedWidth > 0 || calculatedHeight != null && calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    return /*#__PURE__*/ $aivMx.createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-responsive-container', className),
        style: $9acfa7cb966ff3a4$var$_objectSpread($9acfa7cb966ff3a4$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, /*#__PURE__*/ $aivMx.createElement("div", {
        style: (0, $04f67645b2a397ab$export$d36bc8432d8d3f9d)({
            width: width,
            height: height
        })
    }, /*#__PURE__*/ $aivMx.createElement($9acfa7cb966ff3a4$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, children)));
});
var $9acfa7cb966ff3a4$export$e60a4704009a0009 = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var responsiveContainerContext = $9acfa7cb966ff3a4$export$4ec9972d4f677af6();
    if ((0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(responsiveContainerContext.width) && (0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(responsiveContainerContext.height)) /*
     * If we detect that we are already inside another ResponsiveContainer,
     * we do not attempt to add another layer of responsiveness.
     */ return props.children;
    var { width: width, height: height } = (0, $04f67645b2a397ab$export$f717eb32fd8d3af5)({
        width: props.width,
        height: props.height,
        aspect: props.aspect
    });
    /*
   * Let's try to get the calculated dimensions without having the div container set up.
   * Sometimes this does produce fixed, positive dimensions. If so, we can skip rendering the div and monitoring its size.
   */ var { calculatedWidth: calculatedWidth, calculatedHeight: calculatedHeight } = (0, $04f67645b2a397ab$export$83d33ab1950e2a9)(undefined, undefined, {
        width: width,
        height: height,
        aspect: props.aspect,
        maxHeight: props.maxHeight
    });
    if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(calculatedWidth) && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(calculatedHeight)) /*
     * If it just so happens that the combination of width, height, and aspect ratio
     * results in fixed dimensions, then we don't need to monitor the container's size.
     * We can just provide these fixed dimensions to the context.
     *
     * Note that here we are not checking for positive numbers;
     * if the user provides a zero or negative width/height, we will just pass that along
     * as whatever size we detect won't be helping anyway.
     */ return /*#__PURE__*/ $aivMx.createElement($9acfa7cb966ff3a4$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, props.children);
    /*
   * Static analysis did not produce fixed dimensions,
   * so we need to render a special div and monitor its size.
   */ return /*#__PURE__*/ $aivMx.createElement($9acfa7cb966ff3a4$var$SizeDetectorContainer, $9acfa7cb966ff3a4$var$_extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
});



function $2d4a23e6670568d2$export$94a03fc5d61f2504(box) {
    if (!box) return undefined;
    return {
        x: box.x,
        y: box.y,
        upperWidth: 'upperWidth' in box ? box.upperWidth : box.width,
        lowerWidth: 'lowerWidth' in box ? box.lowerWidth : box.width,
        width: box.width,
        height: box.height
    };
}
var $2d4a23e6670568d2$export$76b29bb074e0c45a = ()=>{
    var _useAppSelector;
    var panorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var rootViewBox = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $680da228e16ed19c$export$fb5e3eb7f8167ce7));
    var brushDimensions = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $157aebf66ae7c2b8$export$3b81e97eae001823));
    var brushPadding = (_useAppSelector = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $157aebf66ae7c2b8$export$5ba94b496f8dc52e))) === null || _useAppSelector === void 0 ? void 0 : _useAppSelector.padding;
    if (!panorama || !brushDimensions || !brushPadding) return rootViewBox;
    return {
        width: brushDimensions.width - brushPadding.left - brushPadding.right,
        height: brushDimensions.height - brushPadding.top - brushPadding.bottom,
        x: brushPadding.left,
        y: brushPadding.top
    };
};
var $2d4a23e6670568d2$var$manyComponentsThrowErrorsIfOffsetIsUndefined = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
    brushBottom: 0
};
var $2d4a23e6670568d2$export$10605f61bef2858a = ()=>{
    var _useAppSelector2;
    return (_useAppSelector2 = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $680da228e16ed19c$export$1e34c8efb0bc9b3b))) !== null && _useAppSelector2 !== void 0 ? _useAppSelector2 : $2d4a23e6670568d2$var$manyComponentsThrowErrorsIfOffsetIsUndefined;
};
var $2d4a23e6670568d2$export$8854f7ece606854b = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)((0, $122c64eee523dc50$export$771ef0ac044f724d));
};
var $2d4a23e6670568d2$export$369ae257969c6f9f = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)((0, $122c64eee523dc50$export$5856a7d94c109505));
};
var $2d4a23e6670568d2$export$58ac794108fd8ca = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>state.layout.margin);
};
var $2d4a23e6670568d2$export$8426b6d9af801dee = (state)=>state.layout.layoutType;
var $2d4a23e6670568d2$export$970c79ecc7081cc = ()=>(0, $7729c221c7142965$export$a7347740d65f620b)($2d4a23e6670568d2$export$8426b6d9af801dee);
var $2d4a23e6670568d2$export$c9942bdfc7f2781c = ()=>{
    var layout = $2d4a23e6670568d2$export$970c79ecc7081cc();
    if (layout === 'horizontal' || layout === 'vertical') return layout;
    return undefined;
};
var $2d4a23e6670568d2$export$a3faf3c7b8f19073 = ()=>{
    /*
   * All charts provide a layout type in the chart context.
   * If we have a layout type, we are in a chart context.
   */ var layout = $2d4a23e6670568d2$export$970c79ecc7081cc();
    return layout !== undefined;
};
var $2d4a23e6670568d2$export$80ea82e77fb424e1 = (props)=>{
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var { width: widthFromProps, height: heightFromProps } = props;
    var responsiveContainerCalculations = (0, $9acfa7cb966ff3a4$export$4ec9972d4f677af6)();
    var width = widthFromProps;
    var height = heightFromProps;
    if (responsiveContainerCalculations) {
        /*
     * In case we receive width and height from ResponsiveContainer,
     * we will always prefer those.
     * Only in case ResponsiveContainer does not provide width or height,
     * we will fall back to the explicitly provided width and height.
     *
     * This to me feels backwards - we should allow override by the more specific props on individual charts, right?
     * But this is 3.x behaviour, so let's keep it for backwards compatibility.
     *
     * We can change this in 4.x if we want to.
     */ width = responsiveContainerCalculations.width > 0 ? responsiveContainerCalculations.width : widthFromProps;
        height = responsiveContainerCalculations.height > 0 ? responsiveContainerCalculations.height : heightFromProps;
    }
    (0, $aivMx.useEffect)(()=>{
        if (!isPanorama && (0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(width) && (0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(height)) dispatch((0, $909e1e5d36056665$export$136b7feefeae481a)({
            width: width,
            height: height
        }));
    }, [
        dispatch,
        isPanorama,
        width,
        height
    ]);
    return null;
};
var $2d4a23e6670568d2$export$19a41f515e2a12ff = (_ref)=>{
    var { margin: margin } = _ref;
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useEffect)(()=>{
        dispatch((0, $909e1e5d36056665$export$3f8f25b83912855f)(margin));
    }, [
        dispatch,
        margin
    ]);
    return null;
};








/**
 * A collection of all default zIndex values used throughout the library.
 */ var $5ad557dd967fc64c$export$96df16b28aa32702 = {
    /**
   * CartesianGrid and PolarGrid
   */ grid: -100,
    /**
   * Background of Bar and RadialBar.
   * This is not visible by default but can be enabled by setting background={true} on Bar or RadialBar.
   */ barBackground: -50,
    /*
   * other chart elements or custom elements without specific zIndex
   * render in here, at zIndex 0
   */ /**
   * Area, Pie, Radar, and ReferenceArea
   */ area: 100,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area. CursorRectangle is a rectangle box.
   * It renders below bar so that in a stacked bar chart the cursor rectangle does not hide the other bars.
   */ cursorRectangle: 200,
    /**
   * Bar and RadialBar
   */ bar: 300,
    /**
   * Line and ReferenceLine, and ErrorBor
   */ line: 400,
    /**
   * XAxis and YAxis and PolarAngleAxis and PolarRadiusAxis ticks and lines and children
   */ axis: 500,
    /**
   * Scatter and ReferenceDot,
   * and Dots of Line and Area and Radar if they have dot=true
   */ scatter: 600,
    /**
   * Hovering over a Bar or RadialBar renders a highlight rectangle
   */ activeBar: 1000,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area, usually a cross or a box.
   * CursorLine is a line cursor rendered in Line, Area, Scatter, Radar charts.
   * It renders above the Line and Scatter so that it is always visible.
   * It renders below active dot so that the dot is always visible and shows the current point.
   * We're also assuming that the active dot is small enough that it does not fully cover the cursor line.
   *
   * This also applies to the radial cursor in RadialBarChart.
   */ cursorLine: 1100,
    /**
   * Hovering over a Point in Line, Area, Scatter, Radar renders a highlight dot
   */ activeDot: 1200,
    /**
   * LabelList and Label, including Axis labels
   */ label: 2000
};


var $2d7a8ff8eee7b82c$export$969183d9e860c26e = {
    allowDecimals: false,
    allowDuplicatedCategory: true,
    // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
    angleAxisId: 0,
    axisLine: true,
    cx: 0,
    cy: 0,
    orientation: 'outer',
    reversed: false,
    scale: 'auto',
    tick: true,
    tickLine: true,
    tickSize: 8,
    type: 'category',
    zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).axis
};



var $d9d297da33f1ac90$export$1a08e61551a7e57d = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: true,
    angle: 0,
    axisLine: true,
    cx: 0,
    cy: 0,
    includeHidden: false,
    orientation: 'right',
    radiusAxisId: 0,
    reversed: false,
    scale: 'auto',
    stroke: '#ccc',
    tick: true,
    tickCount: 5,
    type: 'number',
    zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).axis
};


var $d20f3aee8b703dd2$export$3f7e30291950e694 = (axisSettings, axisRange)=>{
    if (!axisSettings || !axisRange) return undefined;
    if (axisSettings !== null && axisSettings !== void 0 && axisSettings.reversed) return [
        axisRange[1],
        axisRange[0]
    ];
    return axisRange;
};



var $84d209255304466f$export$7489bacc62c76b42 = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: false,
    // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
    dataKey: undefined,
    domain: undefined,
    id: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).reversed,
    scale: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).scale,
    tick: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).tick,
    tickCount: undefined,
    ticks: undefined,
    type: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).type,
    unit: undefined
};
var $84d209255304466f$export$31037ebc9a4d24a3 = {
    allowDataOverflow: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).allowDataOverflow,
    allowDecimals: false,
    allowDuplicatedCategory: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).radiusAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).scale,
    tick: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).tick,
    tickCount: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).tickCount,
    ticks: undefined,
    type: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).type,
    unit: undefined
};
var $84d209255304466f$export$12cefc54c06c7ceb = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).scale,
    tick: (0, $2d7a8ff8eee7b82c$export$969183d9e860c26e).tick,
    tickCount: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined
};
var $84d209255304466f$export$829f399331f9ec1b = {
    allowDataOverflow: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).allowDataOverflow,
    allowDecimals: false,
    allowDuplicatedCategory: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).radiusAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).scale,
    tick: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).tick,
    tickCount: (0, $d9d297da33f1ac90$export$1a08e61551a7e57d).tickCount,
    ticks: undefined,
    type: 'category',
    unit: undefined
};
var $84d209255304466f$export$2d9ff7eb66def0da = (state, angleAxisId)=>{
    if (state.polarAxis.angleAxis[angleAxisId] != null) return state.polarAxis.angleAxis[angleAxisId];
    if (state.layout.layoutType === 'radial') return $84d209255304466f$export$12cefc54c06c7ceb;
    return $84d209255304466f$export$7489bacc62c76b42;
};
var $84d209255304466f$export$74b0499accddabe1 = (state, radiusAxisId)=>{
    if (state.polarAxis.radiusAxis[radiusAxisId] != null) return state.polarAxis.radiusAxis[radiusAxisId];
    if (state.layout.layoutType === 'radial') return $84d209255304466f$export$829f399331f9ec1b;
    return $84d209255304466f$export$31037ebc9a4d24a3;
};
var $84d209255304466f$export$a743f010244424e8 = (state)=>state.polarOptions;
var $84d209255304466f$export$53b653c1c5d6829b = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $122c64eee523dc50$export$771ef0ac044f724d),
    (0, $122c64eee523dc50$export$5856a7d94c109505),
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b)
], (0, $e8905a15bef036aa$export$ad5c48602371adfa));
var $84d209255304466f$var$selectInnerRadius = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $84d209255304466f$export$a743f010244424e8,
    $84d209255304466f$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(polarChartOptions.innerRadius, maxRadius, 0);
});
var $84d209255304466f$export$32a1ec2f6eaad494 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $84d209255304466f$export$a743f010244424e8,
    $84d209255304466f$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(polarChartOptions.outerRadius, maxRadius, maxRadius * 0.8);
});
var $84d209255304466f$var$combineAngleAxisRange = (polarOptions)=>{
    if (polarOptions == null) return [
        0,
        0
    ];
    var { startAngle: startAngle, endAngle: endAngle } = polarOptions;
    return [
        startAngle,
        endAngle
    ];
};
var $84d209255304466f$export$d00c8e94622c940 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $84d209255304466f$export$a743f010244424e8
], $84d209255304466f$var$combineAngleAxisRange);
var $84d209255304466f$export$15ccd32b0dd865d2 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $84d209255304466f$export$2d9ff7eb66def0da,
    $84d209255304466f$export$d00c8e94622c940
], (0, $d20f3aee8b703dd2$export$3f7e30291950e694));
var $84d209255304466f$export$e13d847e4d4f833f = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $84d209255304466f$export$53b653c1c5d6829b,
    $84d209255304466f$var$selectInnerRadius,
    $84d209255304466f$export$32a1ec2f6eaad494
], (maxRadius, innerRadius, outerRadius)=>{
    if (maxRadius == null || innerRadius == null || outerRadius == null) return undefined;
    return [
        innerRadius,
        outerRadius
    ];
});
var $84d209255304466f$export$2b324c38f06972bb = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $84d209255304466f$export$74b0499accddabe1,
    $84d209255304466f$export$e13d847e4d4f833f
], (0, $d20f3aee8b703dd2$export$3f7e30291950e694));
var $84d209255304466f$export$57f4101c1e20bd95 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $84d209255304466f$export$a743f010244424e8,
    $84d209255304466f$var$selectInnerRadius,
    $84d209255304466f$export$32a1ec2f6eaad494,
    (0, $122c64eee523dc50$export$771ef0ac044f724d),
    (0, $122c64eee523dc50$export$5856a7d94c109505)
], (layout, polarOptions, innerRadius, outerRadius, width, height)=>{
    if (layout !== 'centric' && layout !== 'radial' || polarOptions == null || innerRadius == null || outerRadius == null) return undefined;
    var { cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle } = polarOptions;
    return {
        cx: (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(cx, width, width / 2),
        cy: (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(cy, height, height / 2),
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        clockWise: false // this property look useful, why not use it?
    };
});





var $aivMx = parcelRequire("aivMx");




/**
 * Checks if two arrays are equal, treating empty arrays as equal regardless of reference.
 * If both arrays are non-empty, it checks for reference equality.
 * @param a
 * @param b
 */ function $d44733464ce55990$export$dcc34c4213e7f4c(a, b) {
    if (Array.isArray(a) && Array.isArray(b) && a.length === 0 && b.length === 0) // empty arrays are always equal, regardless of reference
    return true;
    return a === b;
}
function $d44733464ce55990$export$4f42c64323a69d96(a, b) {
    if (a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}



var $f32f74c67887f2ee$export$2ed4ad840fb53d45 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((state)=>state.zIndex.zIndexMap, (_, zIndex)=>zIndex, (_, _zIndex, isPanorama)=>isPanorama, (zIndexMap, zIndex, isPanorama)=>{
    if (zIndex == null) return undefined;
    var entry = zIndexMap[zIndex];
    if (entry == null) return undefined;
    if (isPanorama) return entry.panoramaElementId;
    return entry.elementId;
});
var $f32f74c67887f2ee$export$7967bffce127e19c = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((state)=>state.zIndex.zIndexMap, (zIndexMap)=>{
    var allNumbers = Object.keys(zIndexMap).map((zIndexStr)=>parseInt(zIndexStr, 10)).concat(Object.values((0, $5ad557dd967fc64c$export$96df16b28aa32702)));
    var uniqueNumbers = Array.from(new Set(allNumbers));
    return uniqueNumbers.sort((a, b)=>a - b);
}, {
    memoizeOptions: {
        resultEqualityCheck: (0, $d44733464ce55990$export$4f42c64323a69d96)
    }
});




function $f208877c1770a0d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f208877c1770a0d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f208877c1770a0d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f208877c1770a0d1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f208877c1770a0d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f208877c1770a0d1$var$_defineProperty(e, r, t) {
    return (r = $f208877c1770a0d1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f208877c1770a0d1$var$_toPropertyKey(t) {
    var i = $f208877c1770a0d1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f208877c1770a0d1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f208877c1770a0d1$var$seed = {};
var $f208877c1770a0d1$var$initialState = {
    zIndexMap: Object.values((0, $5ad557dd967fc64c$export$96df16b28aa32702)).reduce((acc, current)=>$f208877c1770a0d1$var$_objectSpread($f208877c1770a0d1$var$_objectSpread({}, acc), {}, {
            [current]: {
                elementId: undefined,
                panoramaElementId: undefined,
                consumers: 0
            }
        }), $f208877c1770a0d1$var$seed)
};
var $f208877c1770a0d1$var$defaultZIndexSet = new Set(Object.values((0, $5ad557dd967fc64c$export$96df16b28aa32702)));
function $f208877c1770a0d1$var$isDefaultZIndex(zIndex) {
    return $f208877c1770a0d1$var$defaultZIndexSet.has(zIndex);
}
var $f208877c1770a0d1$var$zIndexSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'zIndex',
    initialState: $f208877c1770a0d1$var$initialState,
    reducers: {
        registerZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) state.zIndexMap[zIndex].consumers += 1;
                else state.zIndexMap[zIndex] = {
                    consumers: 1,
                    elementId: undefined,
                    panoramaElementId: undefined
                };
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        unregisterZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    state.zIndexMap[zIndex].consumers -= 1;
                    /*
           * Garbage collect unused z-index entries, except for default z-indexes.
           * Default z-indexes are always rendered, regardless of whether there are consumers or not.
           * And because of that, even if we delete this entry, the ZIndexPortal provider will still be rendered
           * and React is not going to re-create it, and it won't re-register the element ID.
           * So let's not delete default z-index entries.
           */ if (state.zIndexMap[zIndex].consumers <= 0 && !$f208877c1770a0d1$var$isDefaultZIndex(zIndex)) delete state.zIndexMap[zIndex];
                }
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        registerZIndexPortalId: {
            reducer: (state, action)=>{
                var { zIndex: zIndex, elementId: elementId, isPanorama: isPanorama } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (isPanorama) state.zIndexMap[zIndex].panoramaElementId = elementId;
                    else state.zIndexMap[zIndex].elementId = elementId;
                } else state.zIndexMap[zIndex] = {
                    consumers: 0,
                    elementId: isPanorama ? undefined : elementId,
                    panoramaElementId: isPanorama ? elementId : undefined
                };
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        unregisterZIndexPortalId: {
            reducer: (state, action)=>{
                var { zIndex: zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (action.payload.isPanorama) state.zIndexMap[zIndex].panoramaElementId = undefined;
                    else state.zIndexMap[zIndex].elementId = undefined;
                }
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        }
    }
});
var { registerZIndexPortal: $f208877c1770a0d1$export$8fe155db96cddace, unregisterZIndexPortal: $f208877c1770a0d1$export$230718bd38635ccb, registerZIndexPortalId: $f208877c1770a0d1$export$7243b907ccc71fa6, unregisterZIndexPortalId: $f208877c1770a0d1$export$c3d01e849b2b6f99 } = $f208877c1770a0d1$var$zIndexSlice.actions;
var $f208877c1770a0d1$export$a34096cdea3a022a = $f208877c1770a0d1$var$zIndexSlice.reducer;




function $e548635fa476b495$export$b37befaf92aba9f1(_ref) {
    var { zIndex: zIndex, children: children } = _ref;
    /*
   * If we are outside of chart, then we can't rely on the zIndex portal state,
   * so we just render normally.
   */ var isInChartContext = (0, $2d4a23e6670568d2$export$a3faf3c7b8f19073)();
    /*
   * If zIndex is undefined then we render normally without portals.
   * Also, if zIndex is 0, we render normally without portals,
   * because 0 is the default layer that does not need a portal.
   */ var shouldRenderInPortal = isInChartContext && zIndex !== undefined && zIndex !== 0;
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useLayoutEffect)(()=>{
        if (!shouldRenderInPortal) // Nothing to do. We have to call the hook because of the rules of hooks.
        return 0, $9d9ad0197f7e4c2b$export$8793edee2d425525;
        /*
     * Because zIndexes are dynamic (meaning, we're not working with a predefined set of layers,
     * but we allow users to define any zIndex at any time), we need to register
     * the requested zIndex in the global store. This way, the ZIndexPortals component
     * can render the corresponding portals and only the requested ones.
     */ dispatch((0, $f208877c1770a0d1$export$8fe155db96cddace)({
            zIndex: zIndex
        }));
        return ()=>{
            dispatch((0, $f208877c1770a0d1$export$230718bd38635ccb)({
                zIndex: zIndex
            }));
        };
    }, [
        dispatch,
        zIndex,
        shouldRenderInPortal
    ]);
    var portalId = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $f32f74c67887f2ee$export$2ed4ad840fb53d45)(state, zIndex, isPanorama));
    if (!shouldRenderInPortal) // If no zIndex is provided or zIndex is 0, render normally without portals
    return children;
    if (!portalId) /*
     * If we don't have a portalId yet, this means that the registration
     * has not been processed yet by the ZIndexPortals component.
     * So here we render null and wait for the next render cycle.
     */ return null;
    var zIndexPortal = document.getElementById(portalId);
    if (zIndexPortal) return /*#__PURE__*/ (0, $9f97ad3b314012cb$exports.createPortal)(children, zIndexPortal);
    /*
   * If the portal is not found, this means it has not been rendered yet.
   * So here we render null and wait for the next render cycle.
   */ return null;
}



var $23f34369f47c7824$var$_excluded = [
    "labelRef"
];
function $23f34369f47c7824$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $23f34369f47c7824$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $23f34369f47c7824$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $23f34369f47c7824$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $23f34369f47c7824$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $23f34369f47c7824$var$ownKeys(Object(t), !0).forEach(function(r) {
            $23f34369f47c7824$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $23f34369f47c7824$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $23f34369f47c7824$var$_defineProperty(e, r, t) {
    return (r = $23f34369f47c7824$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $23f34369f47c7824$var$_toPropertyKey(t) {
    var i = $23f34369f47c7824$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $23f34369f47c7824$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $23f34369f47c7824$var$_extends() {
    return $23f34369f47c7824$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $23f34369f47c7824$var$_extends.apply(null, arguments);
}
var $23f34369f47c7824$var$CartesianLabelContext = /*#__PURE__*/ (0, $aivMx.createContext)(null);
var $23f34369f47c7824$export$3b4df77eaec10b03 = (_ref)=>{
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, width: width, height: height, children: children } = _ref;
    var viewBox = (0, $aivMx.useMemo)(()=>({
            x: x,
            y: y,
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            width: width,
            height: height
        }), [
        x,
        y,
        upperWidth,
        lowerWidth,
        width,
        height
    ]);
    return /*#__PURE__*/ $aivMx.createElement($23f34369f47c7824$var$CartesianLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $23f34369f47c7824$var$useCartesianLabelContext = ()=>{
    var labelChildContext = (0, $aivMx.useContext)($23f34369f47c7824$var$CartesianLabelContext);
    var chartContext = (0, $2d4a23e6670568d2$export$76b29bb074e0c45a)();
    return labelChildContext || (0, $2d4a23e6670568d2$export$94a03fc5d61f2504)(chartContext);
};
var $23f34369f47c7824$var$PolarLabelContext = /*#__PURE__*/ (0, $aivMx.createContext)(null);
var $23f34369f47c7824$export$cd0d7ffccbd95e6d = (_ref2)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, clockWise: clockWise, children: children } = _ref2;
    var viewBox = (0, $aivMx.useMemo)(()=>({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            clockWise: clockWise
        }), [
        cx,
        cy,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        clockWise
    ]);
    return /*#__PURE__*/ $aivMx.createElement($23f34369f47c7824$var$PolarLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $23f34369f47c7824$export$6f334acae8be4776 = ()=>{
    var labelChildContext = (0, $aivMx.useContext)($23f34369f47c7824$var$PolarLabelContext);
    var chartContext = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $84d209255304466f$export$57f4101c1e20bd95));
    return labelChildContext || chartContext;
};
var $23f34369f47c7824$var$getLabel = (props)=>{
    var { value: value, formatter: formatter } = props;
    var label = (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(props.children) ? value : props.children;
    if (typeof formatter === 'function') return formatter(label);
    return label;
};
var $23f34369f47c7824$export$96a48941c06f377f = (content)=>{
    return content != null && typeof content === 'function';
};
var $23f34369f47c7824$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $23f34369f47c7824$var$renderRadialLabel = (labelProps, position, label, attrs, viewBox)=>{
    var { offset: offset, className: className } = labelProps;
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, clockWise: clockWise } = viewBox;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $23f34369f47c7824$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    switch(position){
        case 'insideStart':
            labelAngle = startAngle + sign * offset;
            direction = clockWise;
            break;
        case 'insideEnd':
            labelAngle = endAngle - sign * offset;
            direction = !clockWise;
            break;
        case 'end':
            labelAngle = endAngle + sign * offset;
            direction = clockWise;
            break;
        default:
            throw new Error("Unsupported position ".concat(position));
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(labelProps.id) ? (0, $9d9ad0197f7e4c2b$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ $aivMx.createElement("text", $23f34369f47c7824$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ $aivMx.createElement("defs", null, /*#__PURE__*/ $aivMx.createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ $aivMx.createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $23f34369f47c7824$var$getAttrsOfPolarLabel = (viewBox, offset, position)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = viewBox;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var { x: _x, y: _y } = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle);
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var { x: x, y: y } = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, r, midAngle);
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $23f34369f47c7824$var$isPolar = (viewBox)=>'cx' in viewBox && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(viewBox.cx);
var $23f34369f47c7824$export$41428aa60b2f4ad6 = (props, viewBox)=>{
    var { parentViewBox: parentViewBoxFromProps, offset: offset, position: position } = props;
    var parentViewBox;
    if (parentViewBoxFromProps != null && !$23f34369f47c7824$var$isPolar(parentViewBoxFromProps)) // Check that nobody is trying to pass a polar viewBox to a cartesian label
    parentViewBox = parentViewBoxFromProps;
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, height: height } = viewBox;
    // Funnel.tsx provides a viewBox where `x` is the top-left of the trapezoid shape.
    var upperX = x;
    // The trapezoid is centered, so we can calculate the other corners from the top-left.
    var lowerX = x + (upperWidth - lowerWidth) / 2;
    // middleX is the x-coordinate of the left edge at the vertical midpoint of the trapezoid.
    var middleX = (upperX + lowerX) / 2;
    // The width of the trapezoid at its vertical midpoint.
    var midHeightWidth = (upperWidth + lowerWidth) / 2;
    // The center x-coordinate is constant for the entire height of the trapezoid.
    var centerX = upperX + upperWidth / 2;
    // Define vertical offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative height.
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative width.
    var horizontalSign = upperWidth >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: upperX + upperWidth / 2,
            y: y - verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $23f34369f47c7824$var$_objectSpread($23f34369f47c7824$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: upperWidth
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: lowerX + lowerWidth / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $23f34369f47c7824$var$_objectSpread($23f34369f47c7824$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: lowerWidth
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: middleX - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $23f34369f47c7824$var$_objectSpread($23f34369f47c7824$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: middleX + midHeightWidth + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $23f34369f47c7824$var$_objectSpread($23f34369f47c7824$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: midHeightWidth,
        height: height
    } : {};
    if (position === 'insideLeft') return $23f34369f47c7824$var$_objectSpread({
        x: middleX + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $23f34369f47c7824$var$_objectSpread({
        x: middleX + midHeightWidth - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $23f34369f47c7824$var$_objectSpread({
        x: upperX + upperWidth / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $23f34369f47c7824$var$_objectSpread({
        x: lowerX + lowerWidth / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $23f34369f47c7824$var$_objectSpread({
        x: upperX + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $23f34369f47c7824$var$_objectSpread({
        x: upperX + upperWidth - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $23f34369f47c7824$var$_objectSpread({
        x: lowerX + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $23f34369f47c7824$var$_objectSpread({
        x: lowerX + lowerWidth - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (!!position && typeof position === 'object' && ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(position.x) || (0, $9d9ad0197f7e4c2b$export$e50269385c77c348)(position.x)) && ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(position.y) || (0, $9d9ad0197f7e4c2b$export$e50269385c77c348)(position.y))) // TODO: This is not quite right. The width of the trapezoid changes with y.
    // A percentage-based x should be relative to the width at that y.
    // For now, we use the mid-height width as a reasonable approximation.
    return $23f34369f47c7824$var$_objectSpread({
        x: x + (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(position.x, midHeightWidth),
        y: y + (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $23f34369f47c7824$var$_objectSpread({
        x: centerX,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $23f34369f47c7824$export$b1c389a57ef19225 = {
    angle: 0,
    offset: 5,
    zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).label,
    position: 'middle',
    textBreakAll: false
};
function $23f34369f47c7824$export$b04be29aa201d4f5(outerProps) {
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outerProps, $23f34369f47c7824$export$b1c389a57ef19225);
    var { viewBox: viewBoxFromProps, position: position, value: value, children: children, content: content, className: className = '', textBreakAll: textBreakAll, labelRef: labelRef } = props;
    var polarViewBox = $23f34369f47c7824$export$6f334acae8be4776();
    var cartesianViewBox = $23f34369f47c7824$var$useCartesianLabelContext();
    /*
   * I am not proud about this solution, but it's a quick fix for https://github.com/recharts/recharts/issues/6030#issuecomment-3155352460.
   * What we should really do is split Label into two components: CartesianLabel and PolarLabel and then handle their respective viewBoxes separately.
   * Also other components should set its own viewBox in a context so that we can fix https://github.com/recharts/recharts/issues/6156
   */ var resolvedViewBox = position === 'center' ? cartesianViewBox : polarViewBox !== null && polarViewBox !== void 0 ? polarViewBox : cartesianViewBox;
    var viewBox, label, positionAttrs;
    if (viewBoxFromProps == null) viewBox = resolvedViewBox;
    else if ($23f34369f47c7824$var$isPolar(viewBoxFromProps)) viewBox = viewBoxFromProps;
    else viewBox = (0, $2d4a23e6670568d2$export$94a03fc5d61f2504)(viewBoxFromProps);
    if (!viewBox || (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(value) && (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(children) && !/*#__PURE__*/ (0, $aivMx.isValidElement)(content) && typeof content !== 'function') return null;
    var propsWithViewBox = $23f34369f47c7824$var$_objectSpread($23f34369f47c7824$var$_objectSpread({}, props), {}, {
        viewBox: viewBox
    });
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(content)) {
        var { labelRef: _ } = propsWithViewBox, propsWithoutLabelRef = $23f34369f47c7824$var$_objectWithoutProperties(propsWithViewBox, $23f34369f47c7824$var$_excluded);
        return /*#__PURE__*/ (0, $aivMx.cloneElement)(content, propsWithoutLabelRef);
    }
    if (typeof content === 'function') {
        // @ts-expect-error we're not checking if the content component returns something that Text is able to render
        label = /*#__PURE__*/ (0, $aivMx.createElement)(content, propsWithViewBox);
        if (/*#__PURE__*/ (0, $aivMx.isValidElement)(label)) return label;
    } else label = $23f34369f47c7824$var$getLabel(props);
    var attrs = (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(props);
    if ($23f34369f47c7824$var$isPolar(viewBox)) {
        if (position === 'insideStart' || position === 'insideEnd' || position === 'end') return $23f34369f47c7824$var$renderRadialLabel(props, position, label, attrs, viewBox);
        positionAttrs = $23f34369f47c7824$var$getAttrsOfPolarLabel(viewBox, props.offset, props.position);
    } else positionAttrs = $23f34369f47c7824$export$41428aa60b2f4ad6(props, viewBox);
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $aivMx.createElement((0, $79fae2d735abd531$export$5f1af8db9871e1d6), $23f34369f47c7824$var$_extends({
        ref: labelRef,
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-label', className)
    }, attrs, positionAttrs, {
        /*
     * textAnchor is decided by default based on the `position`
     * but we allow overriding via props for precise control.
     */ textAnchor: (0, $79fae2d735abd531$export$ae5e6c08954aa63c)(attrs.textAnchor) ? attrs.textAnchor : positionAttrs.textAnchor,
        breakAll: textBreakAll
    }), label));
}
$23f34369f47c7824$export$b04be29aa201d4f5.displayName = 'Label';
var $23f34369f47c7824$var$parseLabel = (label, viewBox, labelRef)=>{
    if (!label) return null;
    var commonProps = {
        viewBox: viewBox,
        labelRef: labelRef
    };
    if (label === true) return /*#__PURE__*/ $aivMx.createElement($23f34369f47c7824$export$b04be29aa201d4f5, $23f34369f47c7824$var$_extends({
        key: "label-implicit"
    }, commonProps));
    if ((0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(label)) return /*#__PURE__*/ $aivMx.createElement($23f34369f47c7824$export$b04be29aa201d4f5, $23f34369f47c7824$var$_extends({
        key: "label-implicit",
        value: label
    }, commonProps));
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(label)) {
        if (label.type === $23f34369f47c7824$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $aivMx.cloneElement)(label, $23f34369f47c7824$var$_objectSpread({
            key: 'label-implicit'
        }, commonProps));
        return /*#__PURE__*/ $aivMx.createElement($23f34369f47c7824$export$b04be29aa201d4f5, $23f34369f47c7824$var$_extends({
            key: "label-implicit",
            content: label
        }, commonProps));
    }
    if ($23f34369f47c7824$export$96a48941c06f377f(label)) return /*#__PURE__*/ $aivMx.createElement($23f34369f47c7824$export$b04be29aa201d4f5, $23f34369f47c7824$var$_extends({
        key: "label-implicit",
        content: label
    }, commonProps));
    if (label && typeof label === 'object') return /*#__PURE__*/ $aivMx.createElement($23f34369f47c7824$export$b04be29aa201d4f5, $23f34369f47c7824$var$_extends({}, label, {
        key: "label-implicit"
    }, commonProps));
    return null;
};
function $23f34369f47c7824$export$3c82c3a3704539d8(_ref3) {
    var { label: label, labelRef: labelRef } = _ref3;
    var viewBox = $23f34369f47c7824$var$useCartesianLabelContext();
    return $23f34369f47c7824$var$parseLabel(label, viewBox, labelRef) || null;
}
function $23f34369f47c7824$export$24b42d9a68417c83(_ref4) {
    var { label: label } = _ref4;
    var viewBox = $23f34369f47c7824$export$6f334acae8be4776();
    return $23f34369f47c7824$var$parseLabel(label, viewBox) || null;
}








var $bdc309bb5887af46$var$_excluded = [
    "valueAccessor"
], $bdc309bb5887af46$var$_excluded2 = [
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll",
    "zIndex"
];
function $bdc309bb5887af46$var$_extends() {
    return $bdc309bb5887af46$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bdc309bb5887af46$var$_extends.apply(null, arguments);
}
function $bdc309bb5887af46$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bdc309bb5887af46$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bdc309bb5887af46$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * This is public API because we expose it as the valueAccessor parameter.
 *
 * The properties of "viewBox" are repeated as the root props of the entry object.
 * So it doesn't matter if you read entry.x or entry.viewBox.x, they are the same.
 *
 * It's not necessary to pass redundant data, but we keep it for backward compatibility.
 */ /**
 * LabelList props do not allow refs because the same props are reused in multiple elements so we don't have a good single place to ref to.
 */ /**
 * This is the type accepted for the `label` prop on various graphical items.
 * It accepts:
 *
 * boolean:
 *    true = labels show,
 *    false = labels don't show
 * React element:
 *    will be cloned with extra props
 * function:
 *    is used as <Label content={function} />, so this will be called once for each individual label (so typically once for each data point)
 * object:
 *    the props to be passed to a LabelList component
 */ var $bdc309bb5887af46$var$defaultAccessor = (entry)=>Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($559f1311a8e0dc33$exports)))(entry.value) : entry.value;
var $bdc309bb5887af46$var$CartesianLabelListContext = /*#__PURE__*/ (0, $aivMx.createContext)(undefined);
var $bdc309bb5887af46$export$64e384eac5db53f7 = $bdc309bb5887af46$var$CartesianLabelListContext.Provider;
var $bdc309bb5887af46$var$PolarLabelListContext = /*#__PURE__*/ (0, $aivMx.createContext)(undefined);
var $bdc309bb5887af46$export$38a852d7976af0fe = $bdc309bb5887af46$var$PolarLabelListContext.Provider;
function $bdc309bb5887af46$var$useCartesianLabelListContext() {
    return (0, $aivMx.useContext)($bdc309bb5887af46$var$CartesianLabelListContext);
}
function $bdc309bb5887af46$var$usePolarLabelListContext() {
    return (0, $aivMx.useContext)($bdc309bb5887af46$var$PolarLabelListContext);
}
function $bdc309bb5887af46$export$835fcf23ab7bf88(_ref) {
    var { valueAccessor: valueAccessor = $bdc309bb5887af46$var$defaultAccessor } = _ref, restProps = $bdc309bb5887af46$var$_objectWithoutProperties(_ref, $bdc309bb5887af46$var$_excluded);
    var { dataKey: dataKey, clockWise: clockWise, id: id, textBreakAll: textBreakAll, zIndex: zIndex } = restProps, others = $bdc309bb5887af46$var$_objectWithoutProperties(restProps, $bdc309bb5887af46$var$_excluded2);
    var cartesianData = $bdc309bb5887af46$var$useCartesianLabelListContext();
    var polarData = $bdc309bb5887af46$var$usePolarLabelListContext();
    var data = cartesianData || polarData;
    if (!data || !data.length) return null;
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : (0, $5ad557dd967fc64c$export$96df16b28aa32702).label
    }, /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map((entry, index)=>{
        var _restProps$fill;
        var value = (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(dataKey) ? valueAccessor(entry, index) : (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ $aivMx.createElement((0, $23f34369f47c7824$export$b04be29aa201d4f5), $bdc309bb5887af46$var$_extends({
            key: "label-".concat(index)
        }, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(entry), others, idProps, {
            /*
       * Prefer to use the explicit fill from LabelList props.
       * Only in an absence of that, fall back to the fill of the entry.
       * The entry fill can be quite difficult to see especially in Bar, Pie, RadialBar in inside positions.
       * On the other hand it's quite convenient in Scatter, Line, or when the position is outside the Bar, Pie filled shapes.
       */ fill: (_restProps$fill = restProps.fill) !== null && _restProps$fill !== void 0 ? _restProps$fill : entry.fill,
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: entry.viewBox,
            index: index,
            zIndex: 0
        }));
    })));
}
$bdc309bb5887af46$export$835fcf23ab7bf88.displayName = 'LabelList';
function $bdc309bb5887af46$export$9a402bc8de2b410e(_ref2) {
    var { label: label } = _ref2;
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ $aivMx.createElement($bdc309bb5887af46$export$835fcf23ab7bf88, {
        key: "labelList-implicit"
    });
    if (/*#__PURE__*/ $aivMx.isValidElement(label) || (0, $23f34369f47c7824$export$96a48941c06f377f)(label)) return /*#__PURE__*/ $aivMx.createElement($bdc309bb5887af46$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        content: label
    });
    if (typeof label === 'object') return /*#__PURE__*/ $aivMx.createElement($bdc309bb5887af46$export$835fcf23ab7bf88, $bdc309bb5887af46$var$_extends({
        key: "labelList-implicit"
    }, label, {
        type: String(label.type)
    }));
    return null;
}





var $aivMx = parcelRequire("aivMx");


var $a703e7e67d5286d1$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $a703e7e67d5286d1$export$be63e0664592e141 = (Comp)=>{
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $a703e7e67d5286d1$var$lastChildren = null;
var $a703e7e67d5286d1$var$lastResult = null;
var $a703e7e67d5286d1$export$45b10814cc054894 = (children)=>{
    if (children === $a703e7e67d5286d1$var$lastChildren && Array.isArray($a703e7e67d5286d1$var$lastResult)) return $a703e7e67d5286d1$var$lastResult;
    var result = [];
    (0, $aivMx.Children).forEach(children, (child)=>{
        if ((0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(child)) return;
        if ((0, $c96e60eb6cff7e49$exports.isFragment)(child)) result = result.concat($a703e7e67d5286d1$export$45b10814cc054894(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $a703e7e67d5286d1$var$lastResult = result;
    $a703e7e67d5286d1$var$lastChildren = children;
    return result;
};
function $a703e7e67d5286d1$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map((t)=>$a703e7e67d5286d1$export$be63e0664592e141(t));
    else types = [
        $a703e7e67d5286d1$export$be63e0664592e141(type)
    ];
    $a703e7e67d5286d1$export$45b10814cc054894(children).forEach((child)=>{
        // @ts-expect-error toArray and lodash.get are not compatible. Let's get rid of the whole findAllByType function
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($a7b626aae7e6649e$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($a7b626aae7e6649e$exports)))(child, 'type.name');
        if (childType && types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
var $a703e7e67d5286d1$export$28c0c718114c1a2e = (dot)=>{
    if (dot && typeof dot === 'object' && 'clipDot' in dot) return Boolean(dot.clipDot);
    return true;
};




var $aivMx = parcelRequire("aivMx");

var $1ea0ac8e1739d80a$export$b8cdb4ab1d25db49 = (c)=>{
    return 'radius' in c && 'startAngle' in c && 'endAngle' in c;
};
var $1ea0ac8e1739d80a$export$7c4c290a4a9c1b1e = (props, newHandler)=>{
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(props)) inputProps = props.props;
    if (typeof inputProps !== 'object' && typeof inputProps !== 'function') return null;
    var out = {};
    Object.keys(inputProps).forEach((key)=>{
        if ((0, $3714d61fa454e414$export$7d045284457d8577)(key)) out[key] = newHandler || ((e)=>inputProps[key](inputProps, e));
    });
    return out;
};
var $1ea0ac8e1739d80a$var$getEventHandlerOfChild = (originalHandler, data, index)=>(e)=>{
        originalHandler(data, index, e);
        return null;
    };
var $1ea0ac8e1739d80a$export$ca62be0d67a3158c = (props, data, index)=>{
    if (props === null || typeof props !== 'object' && typeof props !== 'function') return null;
    var out = null;
    Object.keys(props).forEach((key)=>{
        var item = props[key];
        if ((0, $3714d61fa454e414$export$7d045284457d8577)(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $1ea0ac8e1739d80a$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};
var $1ea0ac8e1739d80a$export$d307f5934e447d0e = (arr)=>{
    return Array.isArray(arr) && arr.length > 0;
};



var $aivMx = parcelRequire("aivMx");


var $aivMx = parcelRequire("aivMx");
var $5b8df110085d1594$exports = {};

$5b8df110085d1594$exports = (parcelRequire("4DHlV")).isPlainObject;



var $aivMx = parcelRequire("aivMx");



var $aivMx = parcelRequire("aivMx");


function $35360cba28ad52dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35360cba28ad52dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35360cba28ad52dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $35360cba28ad52dc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35360cba28ad52dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $35360cba28ad52dc$var$_defineProperty(e, r, t) {
    return (r = $35360cba28ad52dc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $35360cba28ad52dc$var$_toPropertyKey(t) {
    var i = $35360cba28ad52dc$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $35360cba28ad52dc$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $35360cba28ad52dc$export$51610fddbf64bc9d = (name)=>name.replace(/([A-Z])/g, (v)=>"-".concat(v.toLowerCase()));
var $35360cba28ad52dc$export$1594c78389ee3429 = (props, duration, easing)=>props.map((prop)=>"".concat($35360cba28ad52dc$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing)).join(',');
var $35360cba28ad52dc$export$59e29973723da0b3 = (preObj, nextObj)=>[
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce((a, b)=>a.filter((c)=>b.includes(c)));
var $35360cba28ad52dc$export$d6051a0f7a227332 = (fn, obj)=>Object.keys(obj).reduce((res, key)=>$35360cba28ad52dc$var$_objectSpread($35360cba28ad52dc$var$_objectSpread({}, res), {}, {
            [key]: fn(key, obj[key])
        }), {});


function $08e31cfc0c1b1356$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $08e31cfc0c1b1356$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $08e31cfc0c1b1356$var$ownKeys(Object(t), !0).forEach(function(r) {
            $08e31cfc0c1b1356$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $08e31cfc0c1b1356$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $08e31cfc0c1b1356$var$_defineProperty(e, r, t) {
    return (r = $08e31cfc0c1b1356$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $08e31cfc0c1b1356$var$_toPropertyKey(t) {
    var i = $08e31cfc0c1b1356$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $08e31cfc0c1b1356$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $08e31cfc0c1b1356$export$58f0f39f63f3cf42 = (begin, end, k)=>begin + (end - begin) * k;
var $08e31cfc0c1b1356$var$needContinue = (_ref)=>{
    var { from: from, to: to } = _ref;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $08e31cfc0c1b1356$var$calStepperVals = (easing, preVals, steps)=>{
    var nextStepVals = (0, $35360cba28ad52dc$export$d6051a0f7a227332)((key, val)=>{
        if ($08e31cfc0c1b1356$var$needContinue(val)) {
            var [newX, newV] = easing(val.from, val.to, val.velocity);
            return $08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $35360cba28ad52dc$export$d6051a0f7a227332)((key, val)=>{
        if ($08e31cfc0c1b1356$var$needContinue(val)) return $08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread({}, val), {}, {
            velocity: $08e31cfc0c1b1356$export$58f0f39f63f3cf42(val.velocity, nextStepVals[key].velocity, steps),
            from: $08e31cfc0c1b1356$export$58f0f39f63f3cf42(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return $08e31cfc0c1b1356$var$calStepperVals(easing, nextStepVals, steps - 1);
};
function $08e31cfc0c1b1356$var$createStepperUpdate(from, to, easing, interKeys, render, timeoutController) {
    var preTime;
    var stepperStyle = interKeys.reduce((res, key)=>$08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread({}, res), {}, {
            [key]: {
                from: from[key],
                velocity: 0,
                to: to[key]
            }
        }), {});
    var getCurrStyle = ()=>(0, $35360cba28ad52dc$export$d6051a0f7a227332)((key, val)=>val.from, stepperStyle);
    var shouldStopAnimation = ()=>!Object.values(stepperStyle).filter($08e31cfc0c1b1356$var$needContinue).length;
    var stopAnimation = null;
    var stepperUpdate = (now)=>{
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $08e31cfc0c1b1356$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread({}, from), to), getCurrStyle()));
        preTime = now;
        if (!shouldStopAnimation()) stopAnimation = timeoutController.setTimeout(stepperUpdate);
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(stepperUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation;
            (_stopAnimation = stopAnimation) === null || _stopAnimation === void 0 || _stopAnimation();
        };
    };
}
function $08e31cfc0c1b1356$var$createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController) {
    var stopAnimation = null;
    var timingStyle = interKeys.reduce((res, key)=>$08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread({}, res), {}, {
            [key]: [
                from[key],
                to[key]
            ]
        }), {});
    var beginTime;
    var timingUpdate = (now)=>{
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $35360cba28ad52dc$export$d6051a0f7a227332)((key, val)=>$08e31cfc0c1b1356$export$58f0f39f63f3cf42(...val, easing(t)), timingStyle);
        // get union set and add compatible prefix
        render($08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) stopAnimation = timeoutController.setTimeout(timingUpdate);
        else {
            var finalStyle = (0, $35360cba28ad52dc$export$d6051a0f7a227332)((key, val)=>$08e31cfc0c1b1356$export$58f0f39f63f3cf42(...val, easing(1)), timingStyle);
            render($08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(timingUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation2;
            (_stopAnimation2 = stopAnimation) === null || _stopAnimation2 === void 0 || _stopAnimation2();
        };
    };
}
var // configure update function
// eslint-disable-next-line import/no-default-export
$08e31cfc0c1b1356$export$2e2bcd8739ae039 = (from, to, easing, duration, render, timeoutController)=>{
    var interKeys = (0, $35360cba28ad52dc$export$59e29973723da0b3)(from, to);
    if (easing == null) // no animation, just set to final state
    return ()=>{
        render($08e31cfc0c1b1356$var$_objectSpread($08e31cfc0c1b1356$var$_objectSpread({}, from), to));
        return ()=>{};
    };
    return easing.isStepper === true ? $08e31cfc0c1b1356$var$createStepperUpdate(from, to, easing, interKeys, render, timeoutController) : $08e31cfc0c1b1356$var$createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController);
};


var $61b459ed014587d6$export$73dea3ad38069b0e = 1e-4;
var $61b459ed014587d6$var$cubicBezierFactor = (c1, c2)=>[
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
var $61b459ed014587d6$var$evaluatePolynomial = (params, t)=>params.map((param, i)=>param * t ** i).reduce((pre, curr)=>pre + curr);
var $61b459ed014587d6$var$cubicBezier = (c1, c2)=>(t)=>{
        var params = $61b459ed014587d6$var$cubicBezierFactor(c1, c2);
        return $61b459ed014587d6$var$evaluatePolynomial(params, t);
    };
var $61b459ed014587d6$var$derivativeCubicBezier = (c1, c2)=>(t)=>{
        var params = $61b459ed014587d6$var$cubicBezierFactor(c1, c2);
        var newParams = [
            ...params.map((param, i)=>param * i).slice(1),
            0
        ];
        return $61b459ed014587d6$var$evaluatePolynomial(newParams, t);
    };
var $61b459ed014587d6$var$getBezierCoordinates = function getBezierCoordinates() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            return [
                0.0,
                0.0,
                1.0,
                1.0
            ];
        case 'ease':
            return [
                0.25,
                0.1,
                0.25,
                1.0
            ];
        case 'ease-in':
            return [
                0.42,
                0.0,
                1.0,
                1.0
            ];
        case 'ease-out':
            return [
                0.42,
                0.0,
                0.58,
                1.0
            ];
        case 'ease-in-out':
            return [
                0.0,
                0.0,
                0.58,
                1.0
            ];
        default:
            var _easing$;
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && ((_easing$ = easing[1]) === null || _easing$ === void 0 ? void 0 : _easing$.split(')')[0].split(',').length) === 4) {
                var coords = easing[1].split(')')[0].split(',').map((x)=>parseFloat(x));
                return [
                    coords[0],
                    coords[1],
                    coords[2],
                    coords[3]
                ];
            }
    }
    if (args.length === 4) return args;
    // Fallback for invalid inputs. The previous implementation was buggy and would lead to NaN.
    // Returning linear easing is a safe default.
    return [
        0.0,
        0.0,
        1.0,
        1.0
    ];
};
var $61b459ed014587d6$var$createBezierEasing = (x1, y1, x2, y2)=>{
    var curveX = $61b459ed014587d6$var$cubicBezier(x1, x2);
    var curveY = $61b459ed014587d6$var$cubicBezier(y1, y2);
    var derCurveX = $61b459ed014587d6$var$derivativeCubicBezier(x1, x2);
    var rangeValue = (value)=>{
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = (_t)=>{
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $61b459ed014587d6$export$73dea3ad38069b0e || derVal < $61b459ed014587d6$export$73dea3ad38069b0e) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $61b459ed014587d6$export$56c51296f72f0592 = function configBezier() {
    return $61b459ed014587d6$var$createBezierEasing(...$61b459ed014587d6$var$getBezierCoordinates(...arguments));
};
var $61b459ed014587d6$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var { stiff: stiff = 100, damping: damping = 8, dt: dt = 17 } = config;
    var stepper = (currX, destX, currV)=>{
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $61b459ed014587d6$export$73dea3ad38069b0e && Math.abs(newV) < $61b459ed014587d6$export$73dea3ad38069b0e) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $61b459ed014587d6$export$e3e04925801e5434 = (easing)=>{
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $61b459ed014587d6$export$56c51296f72f0592(easing);
        case 'spring':
            return $61b459ed014587d6$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $61b459ed014587d6$export$56c51296f72f0592(easing);
    }
    if (typeof easing === 'function') return easing;
    return null;
};



var $aivMx = parcelRequire("aivMx");
/**
 * Represents a single item in the ReactSmoothQueue.
 * The item can be:
 * - A number representing a delay in milliseconds.
 * - An object representing a style change
 * - A StartAnimationFunction that starts eased transition and calls different render
 *      because of course in Recharts we have to have three ways to do everything
 * - An arbitrary function to be executed
 */ function $c5172bad0c713494$export$26646f0bb02941d1(timeoutController) {
    var currStyle;
    var handleChange = ()=>null;
    var shouldStop = false;
    var cancelTimeout = null;
    var setStyle = (_style)=>{
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var [curr, ...restStyles] = styles;
            if (typeof curr === 'number') {
                cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles));
            return;
        }
        if (typeof _style === 'string') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: ()=>{
            shouldStop = true;
        },
        start: (style)=>{
            shouldStop = false;
            if (cancelTimeout) {
                cancelTimeout();
                cancelTimeout = null;
            }
            setStyle(style);
        },
        subscribe: (_handleChange)=>{
            handleChange = _handleChange;
            return ()=>{
                handleChange = ()=>null;
            };
        },
        getTimeoutController: ()=>timeoutController
    };
}


/**
 * Callback type for the timeout function.
 * Receives current time in milliseconds as an argument.
 */ /**
 * A function that, when called, cancels the timeout.
 */ class $fa3457cfa80e0497$export$fa255b8f41b568c2 {
    setTimeout(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var startTime = performance.now();
        var requestId = null;
        var executeCallback = (now)=>{
            if (now - startTime >= delay) callback(now);
            else if (typeof requestAnimationFrame === 'function') requestId = requestAnimationFrame(executeCallback);
        };
        requestId = requestAnimationFrame(executeCallback);
        return ()=>{
            if (requestId != null) cancelAnimationFrame(requestId);
        };
    }
}


function $a40ed1193f27de99$export$a649b7dd21ebb400() {
    return (0, $c5172bad0c713494$export$26646f0bb02941d1)(new (0, $fa3457cfa80e0497$export$fa255b8f41b568c2)());
}


var $ba46eade8a9c9fcb$export$ec4cae1386f040b6 = /*#__PURE__*/ (0, $aivMx.createContext)((0, $a40ed1193f27de99$export$a649b7dd21ebb400));
function $ba46eade8a9c9fcb$export$996cb06187bf3507(animationId, animationManagerFromProps) {
    var contextAnimationManager = (0, $aivMx.useContext)($ba46eade8a9c9fcb$export$ec4cae1386f040b6);
    return (0, $aivMx.useMemo)(()=>animationManagerFromProps !== null && animationManagerFromProps !== void 0 ? animationManagerFromProps : contextAnimationManager(animationId), [
        animationId,
        animationManagerFromProps,
        contextAnimationManager
    ]);
}



var $6e14365e65dd4f13$var$defaultJavascriptAnimateProps = {
    begin: 0,
    duration: 1000,
    easing: 'ease',
    isActive: true,
    canBegin: true,
    onAnimationEnd: ()=>{},
    onAnimationStart: ()=>{}
};
var $6e14365e65dd4f13$var$from = {
    t: 0
};
var $6e14365e65dd4f13$var$to = {
    t: 1
};
function $6e14365e65dd4f13$export$5d41821894c47c52(outsideProps) {
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $6e14365e65dd4f13$var$defaultJavascriptAnimateProps);
    var { isActive: isActiveProp, canBegin: canBegin, duration: duration, easing: easing, begin: begin, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart, children: children } = props;
    var isActive = isActiveProp === 'auto' ? !(0, $a898dc03dc17f75a$export$98f03c5d19621d70).isSsr : isActiveProp;
    var animationManager = (0, $ba46eade8a9c9fcb$export$996cb06187bf3507)(props.animationId, props.animationManager);
    var [style, setStyle] = (0, $aivMx.useState)(isActive ? $6e14365e65dd4f13$var$from : $6e14365e65dd4f13$var$to);
    var stopJSAnimation = (0, $aivMx.useRef)(null);
    (0, $aivMx.useEffect)(()=>{
        if (!isActive) setStyle($6e14365e65dd4f13$var$to);
    }, [
        isActive
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!isActive || !canBegin) return 0, $9d9ad0197f7e4c2b$export$8793edee2d425525;
        var startAnimation = (0, $08e31cfc0c1b1356$export$2e2bcd8739ae039)($6e14365e65dd4f13$var$from, $6e14365e65dd4f13$var$to, (0, $61b459ed014587d6$export$e3e04925801e5434)(easing), duration, setStyle, animationManager.getTimeoutController());
        var onAnimationActive = ()=>{
            stopJSAnimation.current = startAnimation();
        };
        animationManager.start([
            onAnimationStart,
            begin,
            onAnimationActive,
            duration,
            onAnimationEnd
        ]);
        return ()=>{
            animationManager.stop();
            if (stopJSAnimation.current) stopJSAnimation.current();
            onAnimationEnd();
        };
    }, [
        isActive,
        canBegin,
        duration,
        easing,
        begin,
        onAnimationStart,
        onAnimationEnd,
        animationManager
    ]);
    return children(style.t);
}




var $aivMx = parcelRequire("aivMx");

function $85b2a51d25cd2e70$export$e1042b2944b80b7f(input) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'animation-';
    var animationId = (0, $aivMx.useRef)((0, $9d9ad0197f7e4c2b$export$8b15d37bc3f197d4)(prefix));
    var prevProps = (0, $aivMx.useRef)(input);
    if (prevProps.current !== input) {
        animationId.current = (0, $9d9ad0197f7e4c2b$export$8b15d37bc3f197d4)(prefix);
        prevProps.current = input;
    }
    return animationId.current;
}




var $ef5048504f25e0b5$var$_excluded = [
    "radius"
], $ef5048504f25e0b5$var$_excluded2 = [
    "radius"
];
function $ef5048504f25e0b5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef5048504f25e0b5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef5048504f25e0b5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ef5048504f25e0b5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef5048504f25e0b5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ef5048504f25e0b5$var$_defineProperty(e, r, t) {
    return (r = $ef5048504f25e0b5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ef5048504f25e0b5$var$_toPropertyKey(t) {
    var i = $ef5048504f25e0b5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ef5048504f25e0b5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ef5048504f25e0b5$var$_extends() {
    return $ef5048504f25e0b5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ef5048504f25e0b5$var$_extends.apply(null, arguments);
}
function $ef5048504f25e0b5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ef5048504f25e0b5$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ef5048504f25e0b5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ef5048504f25e0b5$var$getRectanglePath = (x, y, width, height, radius)=>{
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $ef5048504f25e0b5$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $ef5048504f25e0b5$export$4617fb02663045ef = (rectangleProps)=>{
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(rectangleProps, $ef5048504f25e0b5$var$defaultProps);
    var pathRef = (0, $aivMx.useRef)(null);
    var [totalLength, setTotalLength] = (0, $aivMx.useState)(-1);
    (0, $aivMx.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    var { x: x, y: y, width: width, height: height, radius: radius, className: className } = props;
    var { animationEasing: animationEasing, animationDuration: animationDuration, animationBegin: animationBegin, isAnimationActive: isAnimationActive, isUpdateAnimationActive: isUpdateAnimationActive } = props;
    var prevWidthRef = (0, $aivMx.useRef)(width);
    var prevHeightRef = (0, $aivMx.useRef)(height);
    var prevXRef = (0, $aivMx.useRef)(x);
    var prevYRef = (0, $aivMx.useRef)(y);
    var animationIdInput = (0, $aivMx.useMemo)(()=>({
            x: x,
            y: y,
            width: width,
            height: height,
            radius: radius
        }), [
        x,
        y,
        width,
        height,
        radius
    ]);
    var animationId = (0, $85b2a51d25cd2e70$export$e1042b2944b80b7f)(animationIdInput, 'rectangle-');
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) {
        var _svgPropertiesAndEven = (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(props), { radius: _ } = _svgPropertiesAndEven, otherPathProps = $ef5048504f25e0b5$var$_objectWithoutProperties(_svgPropertiesAndEven, $ef5048504f25e0b5$var$_excluded);
        return /*#__PURE__*/ $aivMx.createElement("path", $ef5048504f25e0b5$var$_extends({}, otherPathProps, {
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $ef5048504f25e0b5$var$getRectanglePath(x, y, width, height, radius)
        }));
    }
    var prevWidth = prevWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px 0px");
    var transition = (0, $35360cba28ad52dc$export$1594c78389ee3429)([
        'strokeDasharray'
    ], animationDuration, typeof animationEasing === 'string' ? animationEasing : $ef5048504f25e0b5$var$defaultProps.animationEasing);
    return /*#__PURE__*/ $aivMx.createElement((0, $6e14365e65dd4f13$export$5d41821894c47c52), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currWidth = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevWidth, width, t);
        var currHeight = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevHeight, height, t);
        var currX = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevX, x, t);
        var currY = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevY, y, t);
        if (pathRef.current) {
            prevWidthRef.current = currWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle;
        if (!isAnimationActive) animationStyle = {
            strokeDasharray: to
        };
        else if (t > 0) animationStyle = {
            transition: transition,
            strokeDasharray: to
        };
        else animationStyle = {
            strokeDasharray: from
        };
        var _svgPropertiesAndEven2 = (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(props), { radius: _ } = _svgPropertiesAndEven2, otherPathProps = $ef5048504f25e0b5$var$_objectWithoutProperties(_svgPropertiesAndEven2, $ef5048504f25e0b5$var$_excluded2);
        return /*#__PURE__*/ $aivMx.createElement("path", $ef5048504f25e0b5$var$_extends({}, otherPathProps, {
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $ef5048504f25e0b5$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef,
            style: $ef5048504f25e0b5$var$_objectSpread($ef5048504f25e0b5$var$_objectSpread({}, animationStyle), props.style)
        }));
    });
};



var $aivMx = parcelRequire("aivMx");







function $651341ac3c97456a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $651341ac3c97456a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $651341ac3c97456a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $651341ac3c97456a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $651341ac3c97456a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $651341ac3c97456a$var$_defineProperty(e, r, t) {
    return (r = $651341ac3c97456a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $651341ac3c97456a$var$_toPropertyKey(t) {
    var i = $651341ac3c97456a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $651341ac3c97456a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $651341ac3c97456a$var$_extends() {
    return $651341ac3c97456a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $651341ac3c97456a$var$_extends.apply(null, arguments);
}
var $651341ac3c97456a$var$getTrapezoidPath = (x, y, upperWidth, lowerWidth, height)=>{
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $651341ac3c97456a$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $651341ac3c97456a$export$d1ed33dc592f5337 = (outsideProps)=>{
    var trapezoidProps = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $651341ac3c97456a$var$defaultProps);
    var { x: x, y: y, upperWidth: upperWidth, lowerWidth: lowerWidth, height: height, className: className } = trapezoidProps;
    var { animationEasing: animationEasing, animationDuration: animationDuration, animationBegin: animationBegin, isUpdateAnimationActive: isUpdateAnimationActive } = trapezoidProps;
    var pathRef = (0, $aivMx.useRef)(null);
    var [totalLength, setTotalLength] = (0, $aivMx.useState)(-1);
    var prevUpperWidthRef = (0, $aivMx.useRef)(upperWidth);
    var prevLowerWidthRef = (0, $aivMx.useRef)(lowerWidth);
    var prevHeightRef = (0, $aivMx.useRef)(height);
    var prevXRef = (0, $aivMx.useRef)(x);
    var prevYRef = (0, $aivMx.useRef)(y);
    var animationId = (0, $85b2a51d25cd2e70$export$e1042b2944b80b7f)(outsideProps, 'trapezoid-');
    (0, $aivMx.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ $aivMx.createElement("g", null, /*#__PURE__*/ $aivMx.createElement("path", $651341ac3c97456a$var$_extends({}, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(trapezoidProps), {
        className: layerClass,
        d: $651341ac3c97456a$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    var prevUpperWidth = prevUpperWidthRef.current;
    var prevLowerWidth = prevLowerWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px 0px");
    var transition = (0, $35360cba28ad52dc$export$1594c78389ee3429)([
        'strokeDasharray'
    ], animationDuration, animationEasing);
    return /*#__PURE__*/ $aivMx.createElement((0, $6e14365e65dd4f13$export$5d41821894c47c52), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currUpperWidth = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevUpperWidth, upperWidth, t);
        var currLowerWidth = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevLowerWidth, lowerWidth, t);
        var currHeight = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevHeight, height, t);
        var currX = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevX, x, t);
        var currY = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prevY, y, t);
        if (pathRef.current) {
            prevUpperWidthRef.current = currUpperWidth;
            prevLowerWidthRef.current = currLowerWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle = t > 0 ? {
            transition: transition,
            strokeDasharray: to
        } : {
            strokeDasharray: from
        };
        return /*#__PURE__*/ $aivMx.createElement("path", $651341ac3c97456a$var$_extends({}, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(trapezoidProps), {
            className: layerClass,
            d: $651341ac3c97456a$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef,
            style: $651341ac3c97456a$var$_objectSpread($651341ac3c97456a$var$_objectSpread({}, animationStyle), trapezoidProps.style)
        }));
    });
};



var $aivMx = parcelRequire("aivMx");





function $fc5569a992bb3703$var$_extends() {
    return $fc5569a992bb3703$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fc5569a992bb3703$var$_extends.apply(null, arguments);
}
var $fc5569a992bb3703$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $fc5569a992bb3703$var$getTangentCircle = (_ref)=>{
    var { cx: cx, cy: cy, radius: radius, angle: angle, sign: sign, isExternal: isExternal, cornerRadius: cornerRadius, cornerIsExternal: cornerIsExternal } = _ref;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $e8905a15bef036aa$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $e8905a15bef036aa$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $fc5569a992bb3703$var$getSectorPath = (_ref2)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle } = _ref2;
    var angle = $fc5569a992bb3703$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $fc5569a992bb3703$var$getSectorWithCorner = (_ref3)=>{
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, forceCornerRadius: forceCornerRadius, cornerIsExternal: cornerIsExternal, startAngle: startAngle, endAngle: endAngle } = _ref3;
    var sign = (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(endAngle - startAngle);
    var { circleTangency: soct, lineTangency: solt, theta: sot } = $fc5569a992bb3703$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    });
    var { circleTangency: eoct, lineTangency: eolt, theta: eot } = $fc5569a992bb3703$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    });
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $fc5569a992bb3703$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var { circleTangency: sict, lineTangency: silt, theta: sit } = $fc5569a992bb3703$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        });
        var { circleTangency: eict, lineTangency: eilt, theta: eit } = $fc5569a992bb3703$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        });
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
/**
 * SVG cx, cy are `string | number | undefined`, but internally we use `number` so let's
 * override the types here.
 */ var $fc5569a992bb3703$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $fc5569a992bb3703$export$e98c2c7eb2b14f45 = (sectorProps)=>{
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(sectorProps, $fc5569a992bb3703$var$defaultProps);
    var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, cornerRadius: cornerRadius, forceCornerRadius: forceCornerRadius, cornerIsExternal: cornerIsExternal, startAngle: startAngle, endAngle: endAngle, className: className } = props;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $fc5569a992bb3703$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $fc5569a992bb3703$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ $aivMx.createElement("path", $fc5569a992bb3703$var$_extends({}, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(props), {
        className: layerClass,
        d: path
    }));
};




var $aivMx = parcelRequire("aivMx");




var $7dd0b7ccca1861b3$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $7dd0b7ccca1861b3$var$_extends() {
    return $7dd0b7ccca1861b3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7dd0b7ccca1861b3$var$_extends.apply(null, arguments);
}
function $7dd0b7ccca1861b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7dd0b7ccca1861b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7dd0b7ccca1861b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7dd0b7ccca1861b3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7dd0b7ccca1861b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7dd0b7ccca1861b3$var$_defineProperty(e, r, t) {
    return (r = $7dd0b7ccca1861b3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7dd0b7ccca1861b3$var$_toPropertyKey(t) {
    var i = $7dd0b7ccca1861b3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7dd0b7ccca1861b3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7dd0b7ccca1861b3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7dd0b7ccca1861b3$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7dd0b7ccca1861b3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7dd0b7ccca1861b3$var$symbolFactories = {
    symbolCircle: $37e225aae6e0868f$exports.symbolCircle,
    symbolCross: $37e225aae6e0868f$exports.symbolCross,
    symbolDiamond: $37e225aae6e0868f$exports.symbolDiamond,
    symbolSquare: $37e225aae6e0868f$exports.symbolSquare,
    symbolStar: $37e225aae6e0868f$exports.symbolStar,
    symbolTriangle: $37e225aae6e0868f$exports.symbolTriangle,
    symbolWye: $37e225aae6e0868f$exports.symbolWye
};
var $7dd0b7ccca1861b3$var$RADIAN = Math.PI / 180;
var $7dd0b7ccca1861b3$var$getSymbolFactory = (type)=>{
    var name = "symbol".concat((0, $9d9ad0197f7e4c2b$export$3061f22cd819074d)(type));
    return $7dd0b7ccca1861b3$var$symbolFactories[name] || (0, $37e225aae6e0868f$exports.symbolCircle);
};
var $7dd0b7ccca1861b3$var$calculateAreaSize = (size, sizeType, type)=>{
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $7dd0b7ccca1861b3$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.tan(angle) ** 2);
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $7dd0b7ccca1861b3$var$registerSymbol = (key, factory)=>{
    $7dd0b7ccca1861b3$var$symbolFactories["symbol".concat((0, $9d9ad0197f7e4c2b$export$3061f22cd819074d)(key))] = factory;
};
var $7dd0b7ccca1861b3$export$fa456266707bf4e4 = (_ref)=>{
    var { type: type = 'circle', size: size = 64, sizeType: sizeType = 'area' } = _ref, rest = $7dd0b7ccca1861b3$var$_objectWithoutProperties(_ref, $7dd0b7ccca1861b3$var$_excluded);
    var props = $7dd0b7ccca1861b3$var$_objectSpread($7dd0b7ccca1861b3$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    var realType = 'circle';
    if (typeof type === 'string') /*
     * Our type guard is not as strong as it could be (i.e. non-existent),
     * and so despite the typescript type saying that `type` is a `SymbolType`,
     * we can get numbers or really anything, so let's have a runtime check here to fix the exception.
     *
     * https://github.com/recharts/recharts/issues/6197
     */ realType = type;
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = ()=>{
        var symbolFactory = $7dd0b7ccca1861b3$var$getSymbolFactory(realType);
        var symbol = (0, $37e225aae6e0868f$exports.symbol)().type(symbolFactory).size($7dd0b7ccca1861b3$var$calculateAreaSize(size, sizeType, realType));
        var s = symbol();
        if (s === null) return undefined;
        return s;
    };
    var { className: className, cx: cx, cy: cy } = props;
    var filteredProps = (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(props);
    if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(cx) && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(cy) && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(size)) return /*#__PURE__*/ $aivMx.createElement("path", $7dd0b7ccca1861b3$var$_extends({}, filteredProps, {
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$7dd0b7ccca1861b3$export$fa456266707bf4e4.registerSymbol = $7dd0b7ccca1861b3$var$registerSymbol;



var $aivMx = parcelRequire("aivMx");






function $f4997a3a0c463bed$var$_extends() {
    return $f4997a3a0c463bed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f4997a3a0c463bed$var$_extends.apply(null, arguments);
}
function $f4997a3a0c463bed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4997a3a0c463bed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4997a3a0c463bed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f4997a3a0c463bed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4997a3a0c463bed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f4997a3a0c463bed$var$_defineProperty(e, r, t) {
    return (r = $f4997a3a0c463bed$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f4997a3a0c463bed$var$_toPropertyKey(t) {
    var i = $f4997a3a0c463bed$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f4997a3a0c463bed$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f4997a3a0c463bed$var$CURVE_FACTORIES = {
    curveBasisClosed: $37e225aae6e0868f$exports.curveBasisClosed,
    curveBasisOpen: $37e225aae6e0868f$exports.curveBasisOpen,
    curveBasis: $37e225aae6e0868f$exports.curveBasis,
    curveBumpX: $37e225aae6e0868f$exports.curveBumpX,
    curveBumpY: $37e225aae6e0868f$exports.curveBumpY,
    curveLinearClosed: $37e225aae6e0868f$exports.curveLinearClosed,
    curveLinear: $37e225aae6e0868f$exports.curveLinear,
    curveMonotoneX: $37e225aae6e0868f$exports.curveMonotoneX,
    curveMonotoneY: $37e225aae6e0868f$exports.curveMonotoneY,
    curveNatural: $37e225aae6e0868f$exports.curveNatural,
    curveStep: $37e225aae6e0868f$exports.curveStep,
    curveStepAfter: $37e225aae6e0868f$exports.curveStepAfter,
    curveStepBefore: $37e225aae6e0868f$exports.curveStepBefore
};
var $f4997a3a0c463bed$var$defined = (p)=>(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(p.x) && (0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(p.y);
var $f4997a3a0c463bed$var$areaDefined = (d)=>d.base != null && $f4997a3a0c463bed$var$defined(d.base) && $f4997a3a0c463bed$var$defined(d);
var $f4997a3a0c463bed$var$getX = (p)=>p.x;
var $f4997a3a0c463bed$var$getY = (p)=>p.y;
var $f4997a3a0c463bed$var$getCurveFactory = (type, layout)=>{
    if (typeof type === 'function') return type;
    var name = "curve".concat((0, $9d9ad0197f7e4c2b$export$3061f22cd819074d)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $f4997a3a0c463bed$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $f4997a3a0c463bed$var$CURVE_FACTORIES[name] || (0, $37e225aae6e0868f$exports.curveLinear);
};
var $f4997a3a0c463bed$export$2aa3fd96c49a84a8 = (_ref)=>{
    var { type: type = 'linear', points: points = [], baseLine: baseLine, layout: layout, connectNulls: connectNulls = false } = _ref;
    var curveFactory = $f4997a3a0c463bed$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter($f4997a3a0c463bed$var$defined) : points;
    var lineFunction;
    // When dealing with an area chart (where `baseLine` is an array),
    // we need to pair points with their corresponding `baseLine` points first.
    // This is to ensure that we filter points and their baseline counterparts together,
    // preventing errors from mismatched array lengths and ensuring `defined` checks both.
    if (Array.isArray(baseLine)) {
        var areaPoints = points.map((entry, index)=>$f4997a3a0c463bed$var$_objectSpread($f4997a3a0c463bed$var$_objectSpread({}, entry), {}, {
                base: baseLine[index]
            }));
        if (layout === 'vertical') lineFunction = (0, $37e225aae6e0868f$exports.area)().y($f4997a3a0c463bed$var$getY).x1($f4997a3a0c463bed$var$getX).x0((d)=>d.base.x);
        else lineFunction = (0, $37e225aae6e0868f$exports.area)().x($f4997a3a0c463bed$var$getX).y1($f4997a3a0c463bed$var$getY).y0((d)=>d.base.y);
        /*
     * What happens here is that the `.defined()` call will make it so that this function can accept
     * nullable points, and internally it will filter them out and skip when generating the path.
     * So on the input it accepts NullableCoordinate, but it never calls getX/getY on null points because of the defined() filter.
     *
     * The d3 type definition has only one generic so it doesn't allow to describe this properly.
     * However. d3 types are mutable, but we can pretend that they are not and we can pretend
     * that calling defined() returns a new function with a different generic type.
     */ var _nullableLineFunction = lineFunction.defined($f4997a3a0c463bed$var$areaDefined).curve(curveFactory);
        var finalPoints = connectNulls ? areaPoints.filter($f4997a3a0c463bed$var$areaDefined) : areaPoints;
        return _nullableLineFunction(finalPoints);
    }
    if (layout === 'vertical' && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $37e225aae6e0868f$exports.area)().y($f4997a3a0c463bed$var$getY).x1($f4997a3a0c463bed$var$getX).x0(baseLine);
    else if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $37e225aae6e0868f$exports.area)().x($f4997a3a0c463bed$var$getX).y1($f4997a3a0c463bed$var$getY).y0(baseLine);
    else lineFunction = (0, $37e225aae6e0868f$exports.line)().x($f4997a3a0c463bed$var$getX).y($f4997a3a0c463bed$var$getY);
    var nullableLineFunction = lineFunction.defined($f4997a3a0c463bed$var$defined).curve(curveFactory);
    return nullableLineFunction(formatPoints);
};
var $f4997a3a0c463bed$export$b0e83c3ef8d2db1 = (props)=>{
    var { className: className, points: points, path: path, pathRef: pathRef } = props;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $f4997a3a0c463bed$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ $aivMx.createElement("path", $f4997a3a0c463bed$var$_extends({}, (0, $bf74bd062767a6f3$export$8b56257912140094)(props), (0, $1ea0ac8e1739d80a$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-curve', className),
        d: realPath === null ? undefined : realPath,
        ref: pathRef
    }));
};


var $333e6f5e0fe541db$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName"
];
function $333e6f5e0fe541db$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $333e6f5e0fe541db$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $333e6f5e0fe541db$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $333e6f5e0fe541db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $333e6f5e0fe541db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $333e6f5e0fe541db$var$ownKeys(Object(t), !0).forEach(function(r) {
            $333e6f5e0fe541db$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $333e6f5e0fe541db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $333e6f5e0fe541db$var$_defineProperty(e, r, t) {
    return (r = $333e6f5e0fe541db$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $333e6f5e0fe541db$var$_toPropertyKey(t) {
    var i = $333e6f5e0fe541db$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $333e6f5e0fe541db$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a React element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $333e6f5e0fe541db$var$defaultPropTransformer(option, props) {
    return $333e6f5e0fe541db$var$_objectSpread($333e6f5e0fe541db$var$_objectSpread({}, props), option);
}
function $333e6f5e0fe541db$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $333e6f5e0fe541db$var$ShapeSelector(_ref) {
    var { shapeType: shapeType, elementProps: elementProps } = _ref;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ $aivMx.createElement((0, $ef5048504f25e0b5$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ $aivMx.createElement((0, $651341ac3c97456a$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ $aivMx.createElement((0, $fc5569a992bb3703$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($333e6f5e0fe541db$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ $aivMx.createElement((0, $7dd0b7ccca1861b3$export$fa456266707bf4e4), elementProps);
            break;
        case 'curve':
            return /*#__PURE__*/ $aivMx.createElement((0, $f4997a3a0c463bed$export$b0e83c3ef8d2db1), elementProps);
        default:
            return null;
    }
}
function $333e6f5e0fe541db$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(option)) return option.props;
    return option;
}
function $333e6f5e0fe541db$export$6428a7f2611ef1fa(_ref2) {
    var { option: option, shapeType: shapeType, propTransformer: propTransformer = $333e6f5e0fe541db$var$defaultPropTransformer, activeClassName: activeClassName = 'recharts-active-shape' } = _ref2, props = $333e6f5e0fe541db$var$_objectWithoutProperties(_ref2, $333e6f5e0fe541db$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(option)) // @ts-expect-error we can't know the type of cloned element props
    shape = /*#__PURE__*/ (0, $aivMx.cloneElement)(option, $333e6f5e0fe541db$var$_objectSpread($333e6f5e0fe541db$var$_objectSpread({}, props), $333e6f5e0fe541db$export$33c4f706a443da24(option)));
    else if (typeof option === 'function') shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($5b8df110085d1594$exports)))(option) && typeof option !== 'boolean') {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ $aivMx.createElement($333e6f5e0fe541db$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ $aivMx.createElement($333e6f5e0fe541db$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (props.isActive) return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}



var $144e54756b5729a1$var$_excluded = [
    "x",
    "y"
];
function $144e54756b5729a1$var$_extends() {
    return $144e54756b5729a1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $144e54756b5729a1$var$_extends.apply(null, arguments);
}
function $144e54756b5729a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $144e54756b5729a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $144e54756b5729a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $144e54756b5729a1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $144e54756b5729a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $144e54756b5729a1$var$_defineProperty(e, r, t) {
    return (r = $144e54756b5729a1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $144e54756b5729a1$var$_toPropertyKey(t) {
    var i = $144e54756b5729a1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $144e54756b5729a1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $144e54756b5729a1$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $144e54756b5729a1$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $144e54756b5729a1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $144e54756b5729a1$var$typeguardBarRectangleProps(_ref, props) {
    var { x: xProp, y: yProp } = _ref, option = $144e54756b5729a1$var$_objectWithoutProperties(_ref, $144e54756b5729a1$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $144e54756b5729a1$var$_objectSpread($144e54756b5729a1$var$_objectSpread($144e54756b5729a1$var$_objectSpread($144e54756b5729a1$var$_objectSpread($144e54756b5729a1$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $144e54756b5729a1$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ $aivMx.createElement((0, $333e6f5e0fe541db$export$6428a7f2611ef1fa), $144e54756b5729a1$var$_extends({
        shapeType: "rectangle",
        propTransformer: $144e54756b5729a1$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $144e54756b5729a1$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (value, index)=>{
        if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(minPointSize)) return minPointSize;
        var isValueNumberOrNil = (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(value) || (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, $d23b6a4945e6cbc3$export$2e2bcd8739ae039)(false, "minPointSize callback function received a value with type of ".concat(typeof value, ". Currently only numbers or null/undefined are supported."));
        return defaultValue;
    };
};




var $56Xh3 = parcelRequire("56Xh3");
var $135692a8e4adb0cb$var$__defProp = Object.defineProperty;
var $135692a8e4adb0cb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $135692a8e4adb0cb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $135692a8e4adb0cb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $135692a8e4adb0cb$var$__defNormalProp = (obj, key, value)=>key in obj ? $135692a8e4adb0cb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $135692a8e4adb0cb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($135692a8e4adb0cb$var$__hasOwnProp.call(b, prop)) $135692a8e4adb0cb$var$__defNormalProp(a, prop, b[prop]);
    if ($135692a8e4adb0cb$var$__getOwnPropSymbols) {
        for (var prop of $135692a8e4adb0cb$var$__getOwnPropSymbols(b))if ($135692a8e4adb0cb$var$__propIsEnum.call(b, prop)) $135692a8e4adb0cb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $135692a8e4adb0cb$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $135692a8e4adb0cb$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $135692a8e4adb0cb$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $135692a8e4adb0cb$var$errors = [];
function $135692a8e4adb0cb$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $135692a8e4adb0cb$var$getPrototypeOf = Object.getPrototypeOf;
function $135692a8e4adb0cb$export$541ac630993a4c84(value) {
    return !!value && !!value[$135692a8e4adb0cb$var$DRAFT_STATE];
}
function $135692a8e4adb0cb$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $135692a8e4adb0cb$var$isPlainObject(value) || Array.isArray(value) || !!value[$135692a8e4adb0cb$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$135692a8e4adb0cb$export$6ee2082928bcb0ee]) || $135692a8e4adb0cb$var$isMap(value) || $135692a8e4adb0cb$var$isSet(value);
}
var $135692a8e4adb0cb$var$objectCtorString = Object.prototype.constructor.toString();
var $135692a8e4adb0cb$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $135692a8e4adb0cb$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null || proto === Object.prototype) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    if (typeof Ctor !== "function") return false;
    let ctorString = $135692a8e4adb0cb$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $135692a8e4adb0cb$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $135692a8e4adb0cb$var$objectCtorString;
}
function $135692a8e4adb0cb$export$22e8af3f75a010e3(value) {
    if (!$135692a8e4adb0cb$export$541ac630993a4c84(value)) $135692a8e4adb0cb$var$die(15, value);
    return value[$135692a8e4adb0cb$var$DRAFT_STATE].base_;
}
function $135692a8e4adb0cb$var$each(obj, iter, strict = true) {
    if ($135692a8e4adb0cb$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : Object.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $135692a8e4adb0cb$var$getArchtype(thing) {
    const state = thing[$135692a8e4adb0cb$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $135692a8e4adb0cb$var$isMap(thing) ? 2 /* Map */  : $135692a8e4adb0cb$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $135692a8e4adb0cb$var$has(thing, prop) {
    return $135692a8e4adb0cb$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $135692a8e4adb0cb$var$get(thing, prop) {
    return $135692a8e4adb0cb$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $135692a8e4adb0cb$var$set(thing, propOrOldValue, value) {
    const t = $135692a8e4adb0cb$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $135692a8e4adb0cb$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $135692a8e4adb0cb$var$isMap(target) {
    return target instanceof Map;
}
function $135692a8e4adb0cb$var$isSet(target) {
    return target instanceof Set;
}
function $135692a8e4adb0cb$var$latest(state) {
    return state.copy_ || state.base_;
}
function $135692a8e4adb0cb$var$shallowCopy(base, strict) {
    if ($135692a8e4adb0cb$var$isMap(base)) return new Map(base);
    if ($135692a8e4adb0cb$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $135692a8e4adb0cb$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$135692a8e4adb0cb$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($135692a8e4adb0cb$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $135692a8e4adb0cb$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $135692a8e4adb0cb$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $135692a8e4adb0cb$export$792f3d81ea979f55(obj, deep = false) {
    if ($135692a8e4adb0cb$var$isFrozen(obj) || $135692a8e4adb0cb$export$541ac630993a4c84(obj) || !$135692a8e4adb0cb$export$16e3aed3edb85946(obj)) return obj;
    if ($135692a8e4adb0cb$var$getArchtype(obj) > 1) Object.defineProperties(obj, {
        set: $135692a8e4adb0cb$var$dontMutateMethodOverride,
        add: $135692a8e4adb0cb$var$dontMutateMethodOverride,
        clear: $135692a8e4adb0cb$var$dontMutateMethodOverride,
        delete: $135692a8e4adb0cb$var$dontMutateMethodOverride
    });
    Object.freeze(obj);
    if (deep) Object.values(obj).forEach((value)=>$135692a8e4adb0cb$export$792f3d81ea979f55(value, true));
    return obj;
}
function $135692a8e4adb0cb$var$dontMutateFrozenCollections() {
    $135692a8e4adb0cb$var$die(2);
}
var $135692a8e4adb0cb$var$dontMutateMethodOverride = {
    value: $135692a8e4adb0cb$var$dontMutateFrozenCollections
};
function $135692a8e4adb0cb$var$isFrozen(obj) {
    if (obj === null || typeof obj !== "object") return true;
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $135692a8e4adb0cb$var$plugins = {};
function $135692a8e4adb0cb$var$getPlugin(pluginKey) {
    const plugin = $135692a8e4adb0cb$var$plugins[pluginKey];
    if (!plugin) $135692a8e4adb0cb$var$die(0, pluginKey);
    return plugin;
}
function $135692a8e4adb0cb$var$loadPlugin(pluginKey, implementation) {
    if (!$135692a8e4adb0cb$var$plugins[pluginKey]) $135692a8e4adb0cb$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $135692a8e4adb0cb$var$currentScope;
function $135692a8e4adb0cb$var$getCurrentScope() {
    return $135692a8e4adb0cb$var$currentScope;
}
function $135692a8e4adb0cb$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $135692a8e4adb0cb$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $135692a8e4adb0cb$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $135692a8e4adb0cb$var$revokeScope(scope) {
    $135692a8e4adb0cb$var$leaveScope(scope);
    scope.drafts_.forEach($135692a8e4adb0cb$var$revokeDraft);
    scope.drafts_ = null;
}
function $135692a8e4adb0cb$var$leaveScope(scope) {
    if (scope === $135692a8e4adb0cb$var$currentScope) $135692a8e4adb0cb$var$currentScope = scope.parent_;
}
function $135692a8e4adb0cb$var$enterScope(immer2) {
    return $135692a8e4adb0cb$var$currentScope = $135692a8e4adb0cb$var$createScope($135692a8e4adb0cb$var$currentScope, immer2);
}
function $135692a8e4adb0cb$var$revokeDraft(draft) {
    const state = draft[$135692a8e4adb0cb$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $135692a8e4adb0cb$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$135692a8e4adb0cb$var$DRAFT_STATE].modified_) {
            $135692a8e4adb0cb$var$revokeScope(scope);
            $135692a8e4adb0cb$var$die(4);
        }
        if ($135692a8e4adb0cb$export$16e3aed3edb85946(result)) {
            result = $135692a8e4adb0cb$var$finalize(scope, result);
            if (!scope.parent_) $135692a8e4adb0cb$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $135692a8e4adb0cb$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$135692a8e4adb0cb$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $135692a8e4adb0cb$var$finalize(scope, baseDraft, []);
    $135692a8e4adb0cb$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $135692a8e4adb0cb$export$45b790e32b2810ee ? result : void 0;
}
function $135692a8e4adb0cb$var$finalize(rootScope, value, path) {
    if ($135692a8e4adb0cb$var$isFrozen(value)) return value;
    const useStrictIteration = rootScope.immer_.shouldUseStrictIteration();
    const state = value[$135692a8e4adb0cb$var$DRAFT_STATE];
    if (!state) {
        $135692a8e4adb0cb$var$each(value, (key, childValue)=>$135692a8e4adb0cb$var$finalizeProperty(rootScope, state, value, key, childValue, path), useStrictIteration);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $135692a8e4adb0cb$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $135692a8e4adb0cb$var$each(resultEach, (key, childValue)=>$135692a8e4adb0cb$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2), useStrictIteration);
        $135692a8e4adb0cb$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $135692a8e4adb0cb$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $135692a8e4adb0cb$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (childValue == null) return;
    if (typeof childValue !== "object" && !targetIsSet) return;
    const childIsFrozen = $135692a8e4adb0cb$var$isFrozen(childValue);
    if (childIsFrozen && !targetIsSet) return;
    if ($135692a8e4adb0cb$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$135692a8e4adb0cb$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $135692a8e4adb0cb$var$finalize(rootScope, childValue, path);
        $135692a8e4adb0cb$var$set(targetObject, prop, res);
        if ($135692a8e4adb0cb$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($135692a8e4adb0cb$export$16e3aed3edb85946(childValue) && !childIsFrozen) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        if (parentState && parentState.base_ && parentState.base_[prop] === childValue && childIsFrozen) return;
        $135692a8e4adb0cb$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && ($135692a8e4adb0cb$var$isMap(targetObject) ? targetObject.has(prop) : Object.prototype.propertyIsEnumerable.call(targetObject, prop))) $135692a8e4adb0cb$var$maybeFreeze(rootScope, childValue);
    }
}
function $135692a8e4adb0cb$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $135692a8e4adb0cb$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $135692a8e4adb0cb$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $135692a8e4adb0cb$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $135692a8e4adb0cb$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $135692a8e4adb0cb$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $135692a8e4adb0cb$var$objectTraps = {
    get (state, prop) {
        if (prop === $135692a8e4adb0cb$var$DRAFT_STATE) return state;
        const source = $135692a8e4adb0cb$var$latest(state);
        if (!$135692a8e4adb0cb$var$has(source, prop)) return $135692a8e4adb0cb$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$135692a8e4adb0cb$export$16e3aed3edb85946(value)) return value;
        if (value === $135692a8e4adb0cb$var$peek(state.base_, prop)) {
            $135692a8e4adb0cb$var$prepareCopy(state);
            return state.copy_[prop] = $135692a8e4adb0cb$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $135692a8e4adb0cb$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($135692a8e4adb0cb$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $135692a8e4adb0cb$var$getDescriptorFromProto($135692a8e4adb0cb$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $135692a8e4adb0cb$var$peek($135692a8e4adb0cb$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$135692a8e4adb0cb$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($135692a8e4adb0cb$var$is(value, current2) && (value !== void 0 || $135692a8e4adb0cb$var$has(state.base_, prop))) return true;
            $135692a8e4adb0cb$var$prepareCopy(state);
            $135692a8e4adb0cb$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($135692a8e4adb0cb$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $135692a8e4adb0cb$var$prepareCopy(state);
            $135692a8e4adb0cb$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $135692a8e4adb0cb$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $135692a8e4adb0cb$var$die(11);
    },
    getPrototypeOf (state) {
        return $135692a8e4adb0cb$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $135692a8e4adb0cb$var$die(12);
    }
};
var $135692a8e4adb0cb$var$arrayTraps = {};
$135692a8e4adb0cb$var$each($135692a8e4adb0cb$var$objectTraps, (key, fn)=>{
    $135692a8e4adb0cb$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$135692a8e4adb0cb$var$arrayTraps.deleteProperty = function(state, prop) {
    return $135692a8e4adb0cb$var$arrayTraps.set.call(this, state, prop, void 0);
};
$135692a8e4adb0cb$var$arrayTraps.set = function(state, prop, value) {
    return $135692a8e4adb0cb$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $135692a8e4adb0cb$var$peek(draft, prop) {
    const state = draft[$135692a8e4adb0cb$var$DRAFT_STATE];
    const source = state ? $135692a8e4adb0cb$var$latest(state) : draft;
    return source[prop];
}
function $135692a8e4adb0cb$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $135692a8e4adb0cb$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $135692a8e4adb0cb$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $135692a8e4adb0cb$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $135692a8e4adb0cb$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $135692a8e4adb0cb$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $135692a8e4adb0cb$var$markChanged(state.parent_);
    }
}
function $135692a8e4adb0cb$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $135692a8e4adb0cb$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $135692a8e4adb0cb$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = true;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $135692a8e4adb0cb$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $135692a8e4adb0cb$var$die(7);
            let result;
            if ($135692a8e4adb0cb$export$16e3aed3edb85946(base)) {
                const scope = $135692a8e4adb0cb$var$enterScope(this);
                const proxy = $135692a8e4adb0cb$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $135692a8e4adb0cb$var$revokeScope(scope);
                    else $135692a8e4adb0cb$var$leaveScope(scope);
                }
                $135692a8e4adb0cb$var$usePatchesInScope(scope, patchListener);
                return $135692a8e4adb0cb$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $135692a8e4adb0cb$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $135692a8e4adb0cb$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $135692a8e4adb0cb$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $135692a8e4adb0cb$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (typeof (config == null ? void 0 : config.useStrictIteration) === "boolean") this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$135692a8e4adb0cb$export$16e3aed3edb85946(base)) $135692a8e4adb0cb$var$die(8);
        if ($135692a8e4adb0cb$export$541ac630993a4c84(base)) base = $135692a8e4adb0cb$export$97aac956da55dae9(base);
        const scope = $135692a8e4adb0cb$var$enterScope(this);
        const proxy = $135692a8e4adb0cb$var$createProxy(base, void 0);
        proxy[$135692a8e4adb0cb$var$DRAFT_STATE].isManual_ = true;
        $135692a8e4adb0cb$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$135692a8e4adb0cb$var$DRAFT_STATE];
        if (!state || !state.isManual_) $135692a8e4adb0cb$var$die(9);
        const { scope_: scope } = state;
        $135692a8e4adb0cb$var$usePatchesInScope(scope, patchListener);
        return $135692a8e4adb0cb$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $135692a8e4adb0cb$var$getPlugin("Patches").applyPatches_;
        if ($135692a8e4adb0cb$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $135692a8e4adb0cb$var$createProxy(value, parent) {
    const draft = $135692a8e4adb0cb$var$isMap(value) ? $135692a8e4adb0cb$var$getPlugin("MapSet").proxyMap_(value, parent) : $135692a8e4adb0cb$var$isSet(value) ? $135692a8e4adb0cb$var$getPlugin("MapSet").proxySet_(value, parent) : $135692a8e4adb0cb$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $135692a8e4adb0cb$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $135692a8e4adb0cb$export$97aac956da55dae9(value) {
    if (!$135692a8e4adb0cb$export$541ac630993a4c84(value)) $135692a8e4adb0cb$var$die(10, value);
    return $135692a8e4adb0cb$var$currentImpl(value);
}
function $135692a8e4adb0cb$var$currentImpl(value) {
    if (!$135692a8e4adb0cb$export$16e3aed3edb85946(value) || $135692a8e4adb0cb$var$isFrozen(value)) return value;
    const state = value[$135692a8e4adb0cb$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $135692a8e4adb0cb$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $135692a8e4adb0cb$var$shallowCopy(value, true);
    $135692a8e4adb0cb$var$each(copy, (key, childValue)=>{
        $135692a8e4adb0cb$var$set(copy, key, $135692a8e4adb0cb$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $135692a8e4adb0cb$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $135692a8e4adb0cb$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $135692a8e4adb0cb$var$get(base_, key);
            const value = $135692a8e4adb0cb$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $135692a8e4adb0cb$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $135692a8e4adb0cb$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $135692a8e4adb0cb$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $135692a8e4adb0cb$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $135692a8e4adb0cb$var$die(errorOffset + 3);
                base = $135692a8e4adb0cb$var$get(base, p);
                if (typeof base !== "object") $135692a8e4adb0cb$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $135692a8e4adb0cb$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $135692a8e4adb0cb$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $135692a8e4adb0cb$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$135692a8e4adb0cb$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($135692a8e4adb0cb$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($135692a8e4adb0cb$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($135692a8e4adb0cb$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($135692a8e4adb0cb$var$has(obj, $135692a8e4adb0cb$export$6ee2082928bcb0ee)) cloned[$135692a8e4adb0cb$export$6ee2082928bcb0ee] = obj[$135692a8e4adb0cb$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($135692a8e4adb0cb$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $135692a8e4adb0cb$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $135692a8e4adb0cb$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$135692a8e4adb0cb$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $135692a8e4adb0cb$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $135692a8e4adb0cb$var$latest(this[$135692a8e4adb0cb$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $135692a8e4adb0cb$var$latest(this[$135692a8e4adb0cb$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$135692a8e4adb0cb$var$latest(state).has(key) || $135692a8e4adb0cb$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $135692a8e4adb0cb$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $135692a8e4adb0cb$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($135692a8e4adb0cb$var$latest(state).size) {
                prepareMapCopy(state);
                $135692a8e4adb0cb$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $135692a8e4adb0cb$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            $135692a8e4adb0cb$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $135692a8e4adb0cb$var$latest(state).get(key);
            if (state.finalized_ || !$135692a8e4adb0cb$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $135692a8e4adb0cb$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $135692a8e4adb0cb$var$latest(this[$135692a8e4adb0cb$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($135692a8e4adb0cb$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$135692a8e4adb0cb$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $135692a8e4adb0cb$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $135692a8e4adb0cb$var$latest(this[$135692a8e4adb0cb$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $135692a8e4adb0cb$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $135692a8e4adb0cb$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($135692a8e4adb0cb$var$latest(state).size) {
                prepareSetCopy(state);
                $135692a8e4adb0cb$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$135692a8e4adb0cb$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($135692a8e4adb0cb$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($135692a8e4adb0cb$export$16e3aed3edb85946(value)) {
                    const draft = $135692a8e4adb0cb$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $135692a8e4adb0cb$var$die(3, JSON.stringify($135692a8e4adb0cb$var$latest(state)));
    }
    $135692a8e4adb0cb$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $135692a8e4adb0cb$var$immer = new $135692a8e4adb0cb$export$aaadc6ff0f822719();
var $135692a8e4adb0cb$export$b46cabe22e78bc00 = $135692a8e4adb0cb$var$immer.produce;
var $135692a8e4adb0cb$export$4da66d41c9492c78 = /* @__PURE__ */ $135692a8e4adb0cb$var$immer.produceWithPatches.bind($135692a8e4adb0cb$var$immer);
var $135692a8e4adb0cb$export$573f26f60825c493 = /* @__PURE__ */ $135692a8e4adb0cb$var$immer.setAutoFreeze.bind($135692a8e4adb0cb$var$immer);
var $135692a8e4adb0cb$export$333ce65961cbe047 = /* @__PURE__ */ $135692a8e4adb0cb$var$immer.setUseStrictShallowCopy.bind($135692a8e4adb0cb$var$immer);
var $135692a8e4adb0cb$export$1045b3be3904c489 = /* @__PURE__ */ $135692a8e4adb0cb$var$immer.setUseStrictIteration.bind($135692a8e4adb0cb$var$immer);
var $135692a8e4adb0cb$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $135692a8e4adb0cb$var$immer.applyPatches.bind($135692a8e4adb0cb$var$immer);
var $135692a8e4adb0cb$export$3c3214997190395f = /* @__PURE__ */ $135692a8e4adb0cb$var$immer.createDraft.bind($135692a8e4adb0cb$var$immer);
var $135692a8e4adb0cb$export$c60f5e69c521b528 = /* @__PURE__ */ $135692a8e4adb0cb$var$immer.finishDraft.bind($135692a8e4adb0cb$var$immer);
function $135692a8e4adb0cb$export$c05b21e3257751e5(value) {
    return value;
}
function $135692a8e4adb0cb$export$20f911b3f8cf0b74(value) {
    return value;
}


var $c54e506cc16ecb3e$export$66f2ad380b6acece = {
    active: false,
    index: null,
    dataKey: undefined,
    coordinate: undefined
};
var $c54e506cc16ecb3e$export$d4c72bab9d6cc13a = {
    itemInteraction: {
        click: $c54e506cc16ecb3e$export$66f2ad380b6acece,
        hover: $c54e506cc16ecb3e$export$66f2ad380b6acece
    },
    axisInteraction: {
        click: $c54e506cc16ecb3e$export$66f2ad380b6acece,
        hover: $c54e506cc16ecb3e$export$66f2ad380b6acece
    },
    keyboardInteraction: $c54e506cc16ecb3e$export$66f2ad380b6acece,
    syncInteraction: {
        active: false,
        index: null,
        dataKey: undefined,
        label: undefined,
        coordinate: undefined,
        sourceViewBox: undefined
    },
    tooltipItemPayloads: [],
    settings: {
        shared: undefined,
        trigger: 'hover',
        axisId: 0,
        active: false,
        defaultIndex: undefined
    }
};
var $c54e506cc16ecb3e$var$tooltipSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'tooltip',
    initialState: $c54e506cc16ecb3e$export$d4c72bab9d6cc13a,
    reducers: {
        addTooltipEntrySettings: {
            reducer (state, action) {
                state.tooltipItemPayloads.push((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        replaceTooltipEntrySettings: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $56Xh3.current)(state).tooltipItemPayloads.indexOf((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(prev));
                if (index > -1) state.tooltipItemPayloads[index] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        removeTooltipEntrySettings: {
            reducer (state, action) {
                var index = (0, $56Xh3.current)(state).tooltipItemPayloads.indexOf((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.tooltipItemPayloads.splice(index, 1);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        setTooltipSettingsState (state, action) {
            state.settings = action.payload;
        },
        setActiveMouseOverItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.keyboardInteraction.active = false;
            state.itemInteraction.hover.active = true;
            state.itemInteraction.hover.index = action.payload.activeIndex;
            state.itemInteraction.hover.dataKey = action.payload.activeDataKey;
            state.itemInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        mouseLeaveChart (state) {
            /*
       * Clear only the active flags. Why?
       * 1. Keep Coordinate to preserve animation - next time the Tooltip appears, we want to render it from
       * the last place where it was when it disappeared.
       * 2. We want to keep all the properties anyway just in case the tooltip has `active=true` prop
       * and continues being visible even after the mouse has left the chart.
       */ state.itemInteraction.hover.active = false;
            state.axisInteraction.hover.active = false;
        },
        mouseLeaveItem (state) {
            state.itemInteraction.hover.active = false;
        },
        setActiveClickItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.itemInteraction.click.active = true;
            state.keyboardInteraction.active = false;
            state.itemInteraction.click.index = action.payload.activeIndex;
            state.itemInteraction.click.dataKey = action.payload.activeDataKey;
            state.itemInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setMouseOverAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.axisInteraction.hover.active = true;
            state.keyboardInteraction.active = false;
            state.axisInteraction.hover.index = action.payload.activeIndex;
            state.axisInteraction.hover.dataKey = action.payload.activeDataKey;
            state.axisInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        setMouseClickAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.keyboardInteraction.active = false;
            state.axisInteraction.click.active = true;
            state.axisInteraction.click.index = action.payload.activeIndex;
            state.axisInteraction.click.dataKey = action.payload.activeDataKey;
            state.axisInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setSyncInteraction (state, action) {
            state.syncInteraction = action.payload;
        },
        setKeyboardInteraction (state, action) {
            state.keyboardInteraction.active = action.payload.active;
            state.keyboardInteraction.index = action.payload.activeIndex;
            state.keyboardInteraction.coordinate = action.payload.activeCoordinate;
            state.keyboardInteraction.dataKey = action.payload.activeDataKey;
        }
    }
});
var { addTooltipEntrySettings: $c54e506cc16ecb3e$export$2eaa1babb4725485, replaceTooltipEntrySettings: $c54e506cc16ecb3e$export$7333cdb61d5073d3, removeTooltipEntrySettings: $c54e506cc16ecb3e$export$29793cde90169929, setTooltipSettingsState: $c54e506cc16ecb3e$export$8d517a53c4528750, setActiveMouseOverItemIndex: $c54e506cc16ecb3e$export$c78abbb2450f6b44, mouseLeaveItem: $c54e506cc16ecb3e$export$68742311289b8f85, mouseLeaveChart: $c54e506cc16ecb3e$export$73879bed3f2eef71, setActiveClickItemIndex: $c54e506cc16ecb3e$export$99be2464250d8cae, setMouseOverAxisIndex: $c54e506cc16ecb3e$export$a7277636863fc703, setMouseClickAxisIndex: $c54e506cc16ecb3e$export$d2b1af5c3a560528, setSyncInteraction: $c54e506cc16ecb3e$export$f2efc99b98e50938, setKeyboardInteraction: $c54e506cc16ecb3e$export$820c94985c9eba3f } = $c54e506cc16ecb3e$var$tooltipSlice.actions;
var $c54e506cc16ecb3e$export$cadd4678b967dba6 = $c54e506cc16ecb3e$var$tooltipSlice.reducer;


var $43b9d3dd582657fd$export$6162f642d41f88ea = (onMouseEnterFromProps, dataKey)=>{
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseEnterFromProps === null || onMouseEnterFromProps === void 0 || onMouseEnterFromProps(data, index, event);
            dispatch((0, $c54e506cc16ecb3e$export$c78abbb2450f6b44)({
                activeIndex: String(index),
                activeDataKey: dataKey,
                activeCoordinate: data.tooltipPosition
            }));
        };
};
var $43b9d3dd582657fd$export$27cbf444bf0be2d0 = (onMouseLeaveFromProps)=>{
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseLeaveFromProps === null || onMouseLeaveFromProps === void 0 || onMouseLeaveFromProps(data, index, event);
            dispatch((0, $c54e506cc16ecb3e$export$68742311289b8f85)());
        };
};
var $43b9d3dd582657fd$export$c9154937ad8393fc = (onMouseClickFromProps, dataKey)=>{
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    return (data, index)=>(event)=>{
            onMouseClickFromProps === null || onMouseClickFromProps === void 0 || onMouseClickFromProps(data, index, event);
            dispatch((0, $c54e506cc16ecb3e$export$99be2464250d8cae)({
                activeIndex: String(index),
                activeDataKey: dataKey,
                activeCoordinate: data.tooltipPosition
            }));
        };
};



var $aivMx = parcelRequire("aivMx");



function $8a16f0191d982cde$export$7fa09c17ce18f3e8(_ref) {
    var { tooltipEntrySettings: tooltipEntrySettings } = _ref;
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var prevSettingsRef = (0, $aivMx.useRef)(null);
    (0, $aivMx.useLayoutEffect)(()=>{
        if (isPanorama) // Panorama graphical items should never contribute to Tooltip payload.
        return;
        if (prevSettingsRef.current === null) dispatch((0, $c54e506cc16ecb3e$export$2eaa1babb4725485)(tooltipEntrySettings));
        else if (prevSettingsRef.current !== tooltipEntrySettings) dispatch((0, $c54e506cc16ecb3e$export$7333cdb61d5073d3)({
            prev: prevSettingsRef.current,
            next: tooltipEntrySettings
        }));
        prevSettingsRef.current = tooltipEntrySettings;
    }, [
        tooltipEntrySettings,
        dispatch,
        isPanorama
    ]);
    (0, $aivMx.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $c54e506cc16ecb3e$export$29793cde90169929)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}



var $aivMx = parcelRequire("aivMx");

/**
 * ErrorBars have lot more settings but all the others are scoped to the component itself.
 * Only some of them required to be reported to the global store because XAxis and YAxis need to know
 * if the error bar is contributing to extending the axis domain.
 */ var $f6ac4049b670471f$var$initialState = {};
var $f6ac4049b670471f$var$errorBarSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'errorBars',
    initialState: $f6ac4049b670471f$var$initialState,
    reducers: {
        addErrorBar: (state, action)=>{
            var { itemId: itemId, errorBar: errorBar } = action.payload;
            if (!state[itemId]) state[itemId] = [];
            state[itemId].push(errorBar);
        },
        replaceErrorBar: (state, action)=>{
            var { itemId: itemId, prev: prev, next: next } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].map((e)=>e.dataKey === prev.dataKey && e.direction === prev.direction ? next : e);
        },
        removeErrorBar: (state, action)=>{
            var { itemId: itemId, errorBar: errorBar } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].filter((e)=>e.dataKey !== errorBar.dataKey || e.direction !== errorBar.direction);
        }
    }
});
var { addErrorBar: $f6ac4049b670471f$export$155912f95c88abac, replaceErrorBar: $f6ac4049b670471f$export$f1ebd3b9f70a9f5f, removeErrorBar: $f6ac4049b670471f$export$b0d2fb6a7d9d3b45 } = $f6ac4049b670471f$var$errorBarSlice.actions;
var $f6ac4049b670471f$export$6dda85fa3c67ca19 = $f6ac4049b670471f$var$errorBarSlice.reducer;




var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");

var $612c8483d8ea9851$var$_ref;
var $612c8483d8ea9851$export$bf86633db292cdb4 = ()=>{
    var [id] = $aivMx.useState(()=>(0, $9d9ad0197f7e4c2b$export$8b15d37bc3f197d4)('uid-'));
    return id;
};
var $612c8483d8ea9851$export$f680877a34711e37 = ($612c8483d8ea9851$var$_ref = $aivMx['useId'.toString()]) !== null && $612c8483d8ea9851$var$_ref !== void 0 ? $612c8483d8ea9851$var$_ref : $612c8483d8ea9851$export$bf86633db292cdb4;


function $7561c9dab6180cbd$export$c485849f2e393253(prefix, customId) {
    /*
   * We have to call this hook here even if we don't use the result because
   * rules of hooks demand that hooks are never called conditionally.
   */ var generatedId = (0, $612c8483d8ea9851$export$f680877a34711e37)();
    // If a custom ID is provided, it always takes precedence.
    if (customId) return customId;
    // Apply the prefix if one was provided.
    return prefix ? "".concat(prefix, "-").concat(generatedId) : generatedId;
} /**
 * The useUniqueId hook returns a unique ID that is either reused from external props or generated internally.
 * Either way the ID is now guaranteed to be present so no more nulls or undefined.
 */ 


var $5cc9e31d9b078aed$var$GraphicalItemIdContext = /*#__PURE__*/ (0, $aivMx.createContext)(undefined);
var $5cc9e31d9b078aed$export$8c2f307ff93f02ba = (_ref)=>{
    var { id: id, type: type, children: children } = _ref;
    var resolvedId = (0, $7561c9dab6180cbd$export$c485849f2e393253)("recharts-".concat(type), id);
    return /*#__PURE__*/ $aivMx.createElement($5cc9e31d9b078aed$var$GraphicalItemIdContext.Provider, {
        value: resolvedId
    }, children(resolvedId));
};
function $5cc9e31d9b078aed$export$e24f341c4ff41691() {
    return (0, $aivMx.useContext)($5cc9e31d9b078aed$var$GraphicalItemIdContext);
}


var $969a432a307941ac$var$_excluded = [
    "children"
];
function $969a432a307941ac$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $969a432a307941ac$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $969a432a307941ac$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $969a432a307941ac$var$initialContextState = {
    data: [],
    xAxisId: 'xAxis-0',
    yAxisId: 'yAxis-0',
    dataPointFormatter: ()=>({
            x: 0,
            y: 0,
            value: 0
        }),
    errorBarOffset: 0
};
var $969a432a307941ac$var$ErrorBarContext = /*#__PURE__*/ (0, $aivMx.createContext)($969a432a307941ac$var$initialContextState);
function $969a432a307941ac$export$fcd6ba6fb4bc66e7(props) {
    var { children: children } = props, rest = $969a432a307941ac$var$_objectWithoutProperties(props, $969a432a307941ac$var$_excluded);
    return /*#__PURE__*/ $aivMx.createElement($969a432a307941ac$var$ErrorBarContext.Provider, {
        value: rest
    }, children);
}
var $969a432a307941ac$export$ce29452bff119c97 = ()=>(0, $aivMx.useContext)($969a432a307941ac$var$ErrorBarContext);
function $969a432a307941ac$export$18dc5be7c8cb3008(props) {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var graphicalItemId = (0, $5cc9e31d9b078aed$export$e24f341c4ff41691)();
    var prevPropsRef = (0, $aivMx.useRef)(null);
    (0, $aivMx.useEffect)(()=>{
        if (graphicalItemId == null) // ErrorBar outside a graphical item context does not do anything.
        return;
        if (prevPropsRef.current === null) dispatch((0, $f6ac4049b670471f$export$155912f95c88abac)({
            itemId: graphicalItemId,
            errorBar: props
        }));
        else if (prevPropsRef.current !== props) dispatch((0, $f6ac4049b670471f$export$f1ebd3b9f70a9f5f)({
            itemId: graphicalItemId,
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        graphicalItemId,
        props
    ]);
    (0, $aivMx.useEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current != null && graphicalItemId != null) {
                dispatch((0, $f6ac4049b670471f$export$b0d2fb6a7d9d3b45)({
                    itemId: graphicalItemId,
                    errorBar: prevPropsRef.current
                }));
                prevPropsRef.current = null;
            }
        };
    }, [
        dispatch,
        graphicalItemId
    ]);
    return null;
}



var $aivMx = parcelRequire("aivMx");


var $11eb522a191bff78$exports = {};

$11eb522a191bff78$exports = (parcelRequire("ifW0z")).range;


var $8c7575a8880d9a3f$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$8c7575a8880d9a3f$exports = (parcelRequire("b1EZC"));





var $695f2ef1b702f419$export$519edd692222520 = (state)=>state.chartData;
var $695f2ef1b702f419$export$3b10e41b7db2c36 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $695f2ef1b702f419$export$519edd692222520
], (dataState)=>{
    var dataEndIndex = dataState.chartData != null ? dataState.chartData.length - 1 : 0;
    return {
        chartData: dataState.chartData,
        computedData: dataState.computedData,
        dataEndIndex: dataEndIndex,
        dataStartIndex: 0
    };
});
var $695f2ef1b702f419$export$4953b85e13393616 = (state, _unused1, _unused2, isPanorama)=>{
    if (isPanorama) return $695f2ef1b702f419$export$3b10e41b7db2c36(state);
    return $695f2ef1b702f419$export$519edd692222520(state);
};





function $cbad8497179b0866$export$ba29b24e2a92eb58(v) {
    if (Array.isArray(v) && v.length === 2) {
        var [min, max] = v;
        if ((0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(min) && (0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(max)) return true;
    }
    return false;
}
function $cbad8497179b0866$export$15a9d37c57dafeb9(providedDomain, boundaryDomain, allowDataOverflow) {
    if (allowDataOverflow) // If the data are allowed to overflow - we're fine with whatever user provided
    return providedDomain;
    /*
   * If the data are not allowed to overflow - we need to extend the domain.
   * Means that effectively the user is allowed to make the domain larger
   * but not smaller.
   */ return [
        Math.min(providedDomain[0], boundaryDomain[0]),
        Math.max(providedDomain[1], boundaryDomain[1])
    ];
}
function $cbad8497179b0866$export$fcbf88d4627b24df(userDomain, allowDataOverflow) {
    if (!allowDataOverflow) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function') // The user function expects the data to be provided as an argument
    return undefined;
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if ((0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        if ((0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($cbad8497179b0866$export$ba29b24e2a92eb58(candidate)) return candidate;
    }
    return undefined;
}
function $cbad8497179b0866$export$3f87aa7a53437a70(userDomain, dataDomain, allowDataOverflow) {
    if (!allowDataOverflow && dataDomain == null) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function' && dataDomain != null) try {
        var result = userDomain(dataDomain, allowDataOverflow);
        if ($cbad8497179b0866$export$ba29b24e2a92eb58(result)) return $cbad8497179b0866$export$15a9d37c57dafeb9(result, dataDomain, allowDataOverflow);
    } catch (_unused) {
    /* ignore the exception and compute domain from data later */ }
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if (providedMin === 'auto') {
            if (dataDomain != null) finalMin = Math.min(...dataDomain);
        } else if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') try {
            if (dataDomain != null) finalMin = providedMin(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0]);
        } catch (_unused2) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMin === 'string' && (0, $09206e1485e62bdb$export$75a7b23ff266dfa1).test(providedMin)) {
            var match = (0, $09206e1485e62bdb$export$75a7b23ff266dfa1).exec(providedMin);
            if (match == null || dataDomain == null) finalMin = undefined;
            else {
                var value = +match[1];
                finalMin = dataDomain[0] - value;
            }
        } else finalMin = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0];
        if (providedMax === 'auto') {
            if (dataDomain != null) finalMax = Math.max(...dataDomain);
        } else if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') try {
            if (dataDomain != null) finalMax = providedMax(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1]);
        } catch (_unused3) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMax === 'string' && (0, $09206e1485e62bdb$export$19c111ec8ad6c644).test(providedMax)) {
            var _match = (0, $09206e1485e62bdb$export$19c111ec8ad6c644).exec(providedMax);
            if (_match == null || dataDomain == null) finalMax = undefined;
            else {
                var _value = +_match[1];
                finalMax = dataDomain[1] + _value;
            }
        } else finalMax = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1];
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($cbad8497179b0866$export$ba29b24e2a92eb58(candidate)) {
            if (dataDomain == null) return candidate;
            return $cbad8497179b0866$export$15a9d37c57dafeb9(candidate, dataDomain, allowDataOverflow);
        }
    }
    return undefined;
}




/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var $f12808bdd0b96d4b$exports = {};
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $f12808bdd0b96d4b$exports) $f12808bdd0b96d4b$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($f12808bdd0b96d4b$exports);


var $3034610033979fd9$var$identity = (i)=>i;
var $3034610033979fd9$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $3034610033979fd9$var$isPlaceHolder = (val)=>val === $3034610033979fd9$export$ca73b6d700d0505;
var $3034610033979fd9$var$curry0 = (fn)=>function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $3034610033979fd9$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn(...arguments);
    };
var $3034610033979fd9$var$curryN = (n, fn)=>{
    if (n === 1) return fn;
    return $3034610033979fd9$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter((arg)=>arg !== $3034610033979fd9$export$ca73b6d700d0505).length;
        if (argsLength >= n) return fn(...args);
        return $3034610033979fd9$var$curryN(n - argsLength, $3034610033979fd9$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map((arg)=>$3034610033979fd9$var$isPlaceHolder(arg) ? restArgs.shift() : arg);
            return fn(...newArgs, ...restArgs);
        }));
    });
};
var $3034610033979fd9$export$c3095a23b368d1f2 = (fn)=>$3034610033979fd9$var$curryN(fn.length, fn);
var $3034610033979fd9$export$d02631cccf789723 = (begin, end)=>{
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $3034610033979fd9$export$871de8747c9eaa88 = $3034610033979fd9$export$c3095a23b368d1f2((fn, arr)=>{
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map((key)=>arr[key]).map(fn);
});
var $3034610033979fd9$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $3034610033979fd9$var$identity;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce((res, fn)=>fn(res), firstFn(...arguments));
    };
};
var $3034610033979fd9$export$66c1ae025e96b4bc = (arr)=>{
    if (Array.isArray(arr)) return arr.reverse();
    // can be string
    return arr.split('').reverse().join('');
};


/**
 * @fileOverview Some common arithmetic methods
 * @author xile611
 * @date 2015-09-17
 */ 
/**
 * Get the digit count of a number.
 * If the absolute value is in the interval [0.1, 1), the result is 0.
 * If the absolute value is in the interval [0.01, 0.1), the digit count is -1.
 * If the absolute value is in the interval [0.001, 0.01), the digit count is -2.
 *
 * @param  {Number} value The number
 * @return {Integer}      Digit count
 */ function $ec4ab438b4958c6d$export$c21fa0a8c666ce01(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * Get the data in the interval [start, end) with a fixed step.
 * Also handles JS calculation precision issues.
 *
 * @param  {Decimal} start Start point
 * @param  {Decimal} end   End point, not included
 * @param  {Decimal} step  Step size
 * @return {Array}         Array of numbers
 */ function $ec4ab438b4958c6d$export$85207d4610782ccb(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(start);
    var i = 0;
    var result = [];
    // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}


var $132078bfcf1d5ec9$export$9fcf9e98b0fc6c13 = (_ref)=>{
    var [min, max] = _ref;
    var [validMin, validMax] = [
        min,
        max
    ];
    // exchange
    if (min > max) [validMin, validMax] = [
        max,
        min
    ];
    return [
        validMin,
        validMax
    ];
};
var $132078bfcf1d5ec9$export$bda2c289544cdcde = (roughStep, allowDecimals, correctionFactor)=>{
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(0);
    var digitCount = (0, $ec4ab438b4958c6d$export$c21fa0a8c666ce01)(roughStep.toNumber());
    // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue);
    // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(formatStep.toNumber()) : new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(Math.ceil(formatStep.toNumber()));
};
var $132078bfcf1d5ec9$export$8913aec4ff751b4d = (value, tickCount, allowDecimals)=>{
    var step = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(1);
    // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(10).pow((0, $ec4ab438b4958c6d$export$c21fa0a8c666ce01)(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $3034610033979fd9$export$f672e0b6f7222cd7)((0, $3034610033979fd9$export$871de8747c9eaa88)((n)=>middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(n - middleIndex).mul(step)).toNumber()), (0, $3034610033979fd9$export$d02631cccf789723));
    return fn(0, tickCount);
};
/**
 * Calculate the step
 *
 * @param  min              The minimum value of an interval
 * @param  max              The maximum value of an interval
 * @param  tickCount        The count of ticks
 * @param  allowDecimals    Allow the ticks to be decimals or not
 * @param  correctionFactor A correction factor
 * @return The step, minimum value of ticks, maximum value of ticks
 */ var $132078bfcf1d5ec9$export$ca78fcd978995194 = function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(0)
    };
    // The step which is easy to understand between two ticks
    var step = $132078bfcf1d5ec9$export$bda2c289544cdcde(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor);
    // A medial value of ticks
    var middle;
    // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(min).add(max).div(2);
        // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $132078bfcf1d5ec9$export$ca78fcd978995194(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(upCount).mul(step))
    };
};
var $132078bfcf1d5ec9$export$b84e75ccbfe6a612 = function getNiceTickValues(_ref2) {
    var [min, max] = _ref2;
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var [cormin, cormax] = $132078bfcf1d5ec9$export$9fcf9e98b0fc6c13([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin,
            ...(0, $3034610033979fd9$export$d02631cccf789723)(0, tickCount - 1).map(()=>Infinity)
        ] : [
            ...(0, $3034610033979fd9$export$d02631cccf789723)(0, tickCount - 1).map(()=>-Infinity),
            cormax
        ];
        return min > max ? (0, $3034610033979fd9$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $132078bfcf1d5ec9$export$8913aec4ff751b4d(cormin, tickCount, allowDecimals);
    // Get the step between two ticks
    var { step: step, tickMin: tickMin, tickMax: tickMax } = $132078bfcf1d5ec9$export$ca78fcd978995194(cormin, cormax, count, allowDecimals, 0);
    var values = (0, $ec4ab438b4958c6d$export$85207d4610782ccb)(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $3034610033979fd9$export$66c1ae025e96b4bc)(values) : values;
};
var $132078bfcf1d5ec9$export$e9d28da780436e98 = function getTickValuesFixedDomain(_ref3, tickCount) {
    var [min, max] = _ref3;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var [cormin, cormax] = $132078bfcf1d5ec9$export$9fcf9e98b0fc6c13([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $132078bfcf1d5ec9$export$bda2c289544cdcde(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [
        ...(0, $ec4ab438b4958c6d$export$85207d4610782ccb)(new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($f12808bdd0b96d4b$exports)))(cormax), step),
        cormax
    ];
    if (allowDecimals === false) /*
     * allowDecimals is false means that we want to have integer ticks.
     * The step is guaranteed to be an integer in the code above which is great start
     * but when the first step is not an integer, it will start stepping from a decimal value anyway.
     * So we need to round all the values to integers after the fact.
     */ values = values.map((value)=>Math.round(value));
    return min > max ? (0, $3034610033979fd9$export$66c1ae025e96b4bc)(values) : values;
};






var $3eaa7bc41ed64724$export$db43f3089e0ec1e9 = (state)=>state.rootProps.maxBarSize;
var $3eaa7bc41ed64724$export$9b8e3d53e72fb7a8 = (state)=>state.rootProps.barGap;
var $3eaa7bc41ed64724$export$a73f9d39b015942a = (state)=>state.rootProps.barCategoryGap;
var $3eaa7bc41ed64724$export$be00206a4a82272f = (state)=>state.rootProps.barSize;
var $3eaa7bc41ed64724$export$73aff39176364def = (state)=>state.rootProps.stackOffset;
var $3eaa7bc41ed64724$export$ec830dc49707c6da = (state)=>state.rootProps.reverseStackOrder;
var $3eaa7bc41ed64724$export$3247769c9dbde559 = (state)=>state.options.chartName;
var $3eaa7bc41ed64724$export$d3b88e5c88540018 = (state)=>state.rootProps.syncId;
var $3eaa7bc41ed64724$export$f3cbf53653105e96 = (state)=>state.rootProps.syncMethod;
var $3eaa7bc41ed64724$export$b89defd58e84e980 = (state)=>state.options.eventEmitter;
var $3eaa7bc41ed64724$export$a1ad1f48be8d5def = (state)=>state.rootProps.baseValue;



var $7e3e3c6e6d8d9066$export$8a7d579879340d98 = (_state, axisType)=>axisType;


var $f78caf308607cee1$export$6a2efa106dc9c8f6 = (_state, _axisType, axisId)=>axisId;




/**
 * Returns identifier for stack series which is one individual graphical item in the stack.
 * @param graphicalItem - The graphical item representing the series in the stack.
 * @return The identifier for the series in the stack
 */ function $4d697308b8e82e01$export$58b095b87bc46727(graphicalItem) {
    return graphicalItem === null || graphicalItem === void 0 ? void 0 : graphicalItem.id;
}




function $7729821c902de9dd$export$ae6c77e7720cddf9(stackedGraphicalItems, _ref, tooltipAxisSettings) {
    var { chartData: chartData = [] } = _ref;
    var { allowDuplicatedCategory: allowDuplicatedCategory, dataKey: tooltipDataKey } = tooltipAxisSettings;
    // A map of tooltip data keys to the stacked data points
    var knownItemsByDataKey = new Map();
    stackedGraphicalItems.forEach((item)=>{
        var _item$data;
        // If there is no data on the individual item then we use the root chart data
        var resolvedData = (_item$data = item.data) !== null && _item$data !== void 0 ? _item$data : chartData;
        if (resolvedData == null || resolvedData.length === 0) // if that doesn't work then we skip this item
        return;
        var stackIdentifier = (0, $4d697308b8e82e01$export$58b095b87bc46727)(item);
        resolvedData.forEach((entry, index)=>{
            var tooltipValue = tooltipDataKey == null || allowDuplicatedCategory ? index : String((0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, tooltipDataKey, null));
            var numericValue = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, item.dataKey, 0);
            var curr;
            if (knownItemsByDataKey.has(tooltipValue)) curr = knownItemsByDataKey.get(tooltipValue);
            else curr = {};
            Object.assign(curr, {
                [stackIdentifier]: numericValue
            });
            knownItemsByDataKey.set(tooltipValue, curr);
        });
    });
    return Array.from(knownItemsByDataKey.values());
}


/**
 * Some graphical items allow data stacking. The stacks are optional,
 * so all props here are optional too.
 */ /**
 * Some graphical items allow data stacking.
 * This interface is used to represent the items that are stacked
 * because the user has provided the stackId and dataKey properties.
 */ function $1bc52e873b283c40$export$2335dd91cc88053e(graphicalItem) {
    return graphicalItem.stackId != null && graphicalItem.dataKey != null;
}


var $70a71c8202bf4e60$export$45c01007b107f1a6 = (a, b)=>{
    if (a === b) return true;
    if (a == null || b == null) return false;
    return a[0] === b[0] && a[1] === b[1];
};




var $52d2aaf4f719b99e$export$898d3dfd98fb482 = (state)=>{
    var layout = (0, $2d4a23e6670568d2$export$8426b6d9af801dee)(state);
    if (layout === 'horizontal') return 'xAxis';
    if (layout === 'vertical') return 'yAxis';
    if (layout === 'centric') return 'angleAxis';
    return 'radiusAxis';
};


var $5c148cab1b5c3b61$export$eeffdb10daff095d = (state)=>state.tooltip.settings.axisId;


function $40ff607ce3fff820$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40ff607ce3fff820$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40ff607ce3fff820$var$ownKeys(Object(t), !0).forEach(function(r) {
            $40ff607ce3fff820$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40ff607ce3fff820$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $40ff607ce3fff820$var$_defineProperty(e, r, t) {
    return (r = $40ff607ce3fff820$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $40ff607ce3fff820$var$_toPropertyKey(t) {
    var i = $40ff607ce3fff820$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $40ff607ce3fff820$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $40ff607ce3fff820$export$a012a4dce80491c2 = [
    0,
    'auto'
];
var $40ff607ce3fff820$export$21aec091b6ac8422 = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: undefined,
    height: 30,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'bottom',
    padding: {
        left: 0,
        right: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'category',
    unit: undefined
};
var $40ff607ce3fff820$export$8079b33b4a6a2ac5 = (state, axisId)=>{
    return state.cartesianAxis.xAxis[axisId];
};
var $40ff607ce3fff820$export$d6895d8ddb4cee5 = (state, axisId)=>{
    var axis = $40ff607ce3fff820$export$8079b33b4a6a2ac5(state, axisId);
    if (axis == null) return $40ff607ce3fff820$export$21aec091b6ac8422;
    return axis;
};
var $40ff607ce3fff820$export$397148de2ecdec3c = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: $40ff607ce3fff820$export$a012a4dce80491c2,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'left',
    padding: {
        top: 0,
        bottom: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined,
    width: (0, $61c6522d82a73e91$export$fb6ee82c8ee2faf8)
};
var $40ff607ce3fff820$export$d0970661da76c14c = (state, axisId)=>{
    return state.cartesianAxis.yAxis[axisId];
};
var $40ff607ce3fff820$export$1f472705a332f1c9 = (state, axisId)=>{
    var axis = $40ff607ce3fff820$export$d0970661da76c14c(state, axisId);
    if (axis == null) return $40ff607ce3fff820$export$397148de2ecdec3c;
    return axis;
};
var $40ff607ce3fff820$export$73a439a535d82503 = {
    domain: [
        0,
        'auto'
    ],
    includeHidden: false,
    reversed: false,
    allowDataOverflow: false,
    allowDuplicatedCategory: false,
    dataKey: undefined,
    id: 0,
    name: '',
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number',
    unit: ''
};
var $40ff607ce3fff820$export$26eadf639b453d0f = (state, axisId)=>{
    var axis = state.cartesianAxis.zAxis[axisId];
    if (axis == null) return $40ff607ce3fff820$export$73a439a535d82503;
    return axis;
};
var $40ff607ce3fff820$export$fc14c3706e09c50c = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $40ff607ce3fff820$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $40ff607ce3fff820$export$1f472705a332f1c9(state, axisId);
        case 'zAxis':
            return $40ff607ce3fff820$export$26eadf639b453d0f(state, axisId);
        case 'angleAxis':
            return (0, $84d209255304466f$export$2d9ff7eb66def0da)(state, axisId);
        case 'radiusAxis':
            return (0, $84d209255304466f$export$74b0499accddabe1)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $40ff607ce3fff820$var$selectCartesianAxisSettings = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $40ff607ce3fff820$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $40ff607ce3fff820$export$1f472705a332f1c9(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $40ff607ce3fff820$export$3635e5ebe47f85a9 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $40ff607ce3fff820$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $40ff607ce3fff820$export$1f472705a332f1c9(state, axisId);
        case 'angleAxis':
            return (0, $84d209255304466f$export$2d9ff7eb66def0da)(state, axisId);
        case 'radiusAxis':
            return (0, $84d209255304466f$export$74b0499accddabe1)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $40ff607ce3fff820$export$1c7798b82c8010cd = (state)=>state.graphicalItems.cartesianItems.some((item)=>item.type === 'bar') || state.graphicalItems.polarItems.some((item)=>item.type === 'radialBar');
function $40ff607ce3fff820$export$a3923f321c6572c3(axisType, axisId) {
    return (item)=>{
        switch(axisType){
            case 'xAxis':
                // This is sensitive to the data type, as 0 !== '0'. I wonder if we should be more flexible. How does 2.x branch behave? TODO write test for that
                return 'xAxisId' in item && item.xAxisId === axisId;
            case 'yAxis':
                return 'yAxisId' in item && item.yAxisId === axisId;
            case 'zAxis':
                return 'zAxisId' in item && item.zAxisId === axisId;
            case 'angleAxis':
                return 'angleAxisId' in item && item.angleAxisId === axisId;
            case 'radiusAxis':
                return 'radiusAxisId' in item && item.radiusAxisId === axisId;
            default:
                return false;
        }
    };
}
var $40ff607ce3fff820$export$f67c737adf41a3af = (state)=>state.graphicalItems.cartesianItems;
var $40ff607ce3fff820$var$selectAxisPredicate = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98),
    (0, $f78caf308607cee1$export$6a2efa106dc9c8f6)
], $40ff607ce3fff820$export$a3923f321c6572c3);
var $40ff607ce3fff820$export$ad35679ce4582010 = (graphicalItems, axisSettings, axisPredicate)=>graphicalItems.filter(axisPredicate).filter((item)=>{
        if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.includeHidden) === true) return true;
        return !item.hide;
    });
var $40ff607ce3fff820$export$533d13f911334c9d = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$f67c737adf41a3af,
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    $40ff607ce3fff820$var$selectAxisPredicate
], $40ff607ce3fff820$export$ad35679ce4582010, {
    memoizeOptions: {
        resultEqualityCheck: (0, $d44733464ce55990$export$dcc34c4213e7f4c)
    }
});
var $40ff607ce3fff820$export$58ad06f71246a0da = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$533d13f911334c9d
], (cartesianItems)=>{
    return cartesianItems.filter((item)=>item.type === 'area' || item.type === 'bar').filter((0, $1bc52e873b283c40$export$2335dd91cc88053e));
});
var $40ff607ce3fff820$export$a61da86823382adc = (cartesianItems)=>cartesianItems.filter((item)=>!('stackId' in item) || item.stackId === undefined);
var $40ff607ce3fff820$var$selectCartesianItemsSettingsExceptStacked = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$533d13f911334c9d
], $40ff607ce3fff820$export$a61da86823382adc);
var $40ff607ce3fff820$export$d945cee965d266f0 = (cartesianItems)=>cartesianItems.map((item)=>item.data).filter(Boolean).flat(1);
var $40ff607ce3fff820$export$f2151bebfd9ae457 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$533d13f911334c9d
], $40ff607ce3fff820$export$d945cee965d266f0, {
    memoizeOptions: {
        resultEqualityCheck: (0, $d44733464ce55990$export$dcc34c4213e7f4c)
    }
});
var $40ff607ce3fff820$export$c2c6d012cffe2c75 = (graphicalItemsData, _ref)=>{
    var { chartData: chartData = [], dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    if (graphicalItemsData.length > 0) /*
     * There is no slicing when data is defined on graphical items. Why?
     * Because Brush ignores data defined on graphical items,
     * and does not render.
     * So Brush will never show up in a Scatter chart for example.
     * This is something we will need to fix.
     *
     * Now, when the root chart data is not defined, the dataEndIndex is 0,
     * which means the itemsData will be sliced to an empty array anyway.
     * But that's an implementation detail, and we can fix that too.
     *
     * Also, in absence of Axis dataKey, we use the dataKey from each item, respectively.
     * This is the usual pattern for numerical axis, that is the one where bars go up:
     * users don't specify any dataKey by default and expect the axis to "just match the data".
     */ return graphicalItemsData;
    return chartData.slice(dataStartIndex, dataEndIndex + 1);
};
var $40ff607ce3fff820$export$6099ba314905f0c4 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$f2151bebfd9ae457,
    (0, $695f2ef1b702f419$export$4953b85e13393616)
], $40ff607ce3fff820$export$c2c6d012cffe2c75);
var $40ff607ce3fff820$export$3051da2013ba9cfe = (data, axisSettings, items)=>{
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, $09206e1485e62bdb$export$f97fc4a450f29a)(item, axisSettings.dataKey)
        }));
    if (items.length > 0) return items.map((item)=>item.dataKey).flatMap((dataKey)=>data.map((entry)=>({
                value: (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey)
            })));
    return data.map((entry)=>({
            value: entry
        }));
};
var $40ff607ce3fff820$export$9cea618b690f07b7 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$6099ba314905f0c4,
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    $40ff607ce3fff820$export$533d13f911334c9d
], $40ff607ce3fff820$export$3051da2013ba9cfe);
function $40ff607ce3fff820$export$8b0eb5a8c39b724f(axisType, errorBar) {
    switch(axisType){
        case 'xAxis':
            return errorBar.direction === 'x';
        case 'yAxis':
            return errorBar.direction === 'y';
        default:
            return false;
    }
}
function $40ff607ce3fff820$export$f0a6d058b28316d9(value) {
    if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(value) && Number.isFinite(value)) return [
        value,
        value
    ];
    if (Array.isArray(value)) {
        var minError = Math.min(...value);
        var maxError = Math.max(...value);
        if (!(0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(minError) && !(0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(maxError) && Number.isFinite(minError) && Number.isFinite(maxError)) return [
            minError,
            maxError
        ];
    }
    return undefined;
}
function $40ff607ce3fff820$var$makeNumber(val) {
    if ((0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(val) || val instanceof Date) {
        var n = Number(val);
        if ((0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(n)) return n;
    }
    return undefined;
}
function $40ff607ce3fff820$var$makeDomain(val) {
    if (Array.isArray(val)) {
        var attempt = [
            $40ff607ce3fff820$var$makeNumber(val[0]),
            $40ff607ce3fff820$var$makeNumber(val[1])
        ];
        if ((0, $cbad8497179b0866$export$ba29b24e2a92eb58)(attempt)) return attempt;
        return undefined;
    }
    var n = $40ff607ce3fff820$var$makeNumber(val);
    if (n == null) return undefined;
    return [
        n,
        n
    ];
}
function $40ff607ce3fff820$var$onlyAllowNumbers(data) {
    return data.map($40ff607ce3fff820$var$makeNumber).filter((0, $9d9ad0197f7e4c2b$export$7e515ab5fbd92bef));
}
function $40ff607ce3fff820$export$25971beae035f58a(entry, appliedValue, relevantErrorBars) {
    if (!relevantErrorBars || typeof appliedValue !== 'number' || (0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(appliedValue)) return [];
    if (!relevantErrorBars.length) return [];
    return $40ff607ce3fff820$var$onlyAllowNumbers(relevantErrorBars.flatMap((eb)=>{
        var errorValue = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, eb.dataKey);
        var lowBound, highBound;
        if (Array.isArray(errorValue)) [lowBound, highBound] = errorValue;
        else lowBound = highBound = errorValue;
        if (!(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(lowBound) || !(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(highBound)) return undefined;
        return [
            appliedValue - lowBound,
            appliedValue + highBound
        ];
    }));
}
var $40ff607ce3fff820$export$27d9004292294cd7 = (state)=>{
    var axisType = (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)(state);
    var axisId = (0, $5c148cab1b5c3b61$export$eeffdb10daff095d)(state);
    return $40ff607ce3fff820$export$3635e5ebe47f85a9(state, axisType, axisId);
};
var $40ff607ce3fff820$export$bf8397fefbaa3617 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$27d9004292294cd7
], (axis)=>axis === null || axis === void 0 ? void 0 : axis.dataKey);
var $40ff607ce3fff820$export$b329ef9482661e60 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$58ad06f71246a0da,
    (0, $695f2ef1b702f419$export$4953b85e13393616),
    $40ff607ce3fff820$export$27d9004292294cd7
], (0, $7729821c902de9dd$export$ae6c77e7720cddf9));
var $40ff607ce3fff820$export$9312914d13496409 = (displayedData, items, stackOffsetType, reverseStackOrder)=>{
    var initialItemsGroups = {};
    var itemsGroup = items.reduce((acc, item)=>{
        if (item.stackId == null) return acc;
        if (acc[item.stackId] == null) acc[item.stackId] = [];
        acc[item.stackId].push(item);
        return acc;
    }, initialItemsGroups);
    return Object.fromEntries(Object.entries(itemsGroup).map((_ref2)=>{
        var [stackId, graphicalItems] = _ref2;
        var orderedGraphicalItems = reverseStackOrder ? [
            ...graphicalItems
        ].reverse() : graphicalItems;
        var dataKeys = orderedGraphicalItems.map((0, $4d697308b8e82e01$export$58b095b87bc46727));
        return [
            stackId,
            {
                // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
                stackedData: (0, $09206e1485e62bdb$export$c2170542cfc0177c)(displayedData, dataKeys, stackOffsetType),
                graphicalItems: orderedGraphicalItems
            }
        ];
    }));
};
var $40ff607ce3fff820$export$af2278e5e47fc440 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$b329ef9482661e60,
    $40ff607ce3fff820$export$58ad06f71246a0da,
    (0, $3eaa7bc41ed64724$export$73aff39176364def),
    (0, $3eaa7bc41ed64724$export$ec830dc49707c6da)
], $40ff607ce3fff820$export$9312914d13496409);
var $40ff607ce3fff820$export$3286b8ea6ff06720 = (stackGroups, _ref3, axisType, domainFromUserPreference)=>{
    var { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref3;
    if (domainFromUserPreference != null) // User has specified a domain, so we respect that and we can skip computing anything else
    return undefined;
    if (axisType === 'zAxis') // ZAxis ignores stacks
    return undefined;
    var domainOfStackGroups = (0, $09206e1485e62bdb$export$26522b779eb5497c)(stackGroups, dataStartIndex, dataEndIndex);
    if (domainOfStackGroups != null && domainOfStackGroups[0] === 0 && domainOfStackGroups[1] === 0) return undefined;
    return domainOfStackGroups;
};
var $40ff607ce3fff820$var$selectAllowsDataOverflow = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c
], (axisSettings)=>axisSettings.allowDataOverflow);
var $40ff607ce3fff820$export$2e6262b6c952ab02 = (axisSettings)=>{
    var _axisSettings$domain;
    if (axisSettings == null || !('domain' in axisSettings)) return $40ff607ce3fff820$export$a012a4dce80491c2;
    if (axisSettings.domain != null) return axisSettings.domain;
    if (axisSettings.ticks != null) {
        if (axisSettings.type === 'number') {
            var allValues = $40ff607ce3fff820$var$onlyAllowNumbers(axisSettings.ticks);
            return [
                Math.min(...allValues),
                Math.max(...allValues)
            ];
        }
        if (axisSettings.type === 'category') return axisSettings.ticks.map(String);
    }
    return (_axisSettings$domain = axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.domain) !== null && _axisSettings$domain !== void 0 ? _axisSettings$domain : $40ff607ce3fff820$export$a012a4dce80491c2;
};
var $40ff607ce3fff820$export$5d46410c3f089eb2 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c
], $40ff607ce3fff820$export$2e6262b6c952ab02);
var $40ff607ce3fff820$export$c21dc69ecce61f8a = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$5d46410c3f089eb2,
    $40ff607ce3fff820$var$selectAllowsDataOverflow
], (0, $cbad8497179b0866$export$fcbf88d4627b24df));
var $40ff607ce3fff820$export$969bc8d84122c036 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$af2278e5e47fc440,
    (0, $695f2ef1b702f419$export$519edd692222520),
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98),
    $40ff607ce3fff820$export$c21dc69ecce61f8a
], $40ff607ce3fff820$export$3286b8ea6ff06720, {
    memoizeOptions: {
        resultEqualityCheck: (0, $70a71c8202bf4e60$export$45c01007b107f1a6)
    }
});
var $40ff607ce3fff820$export$9429ab4550237b6d = (state)=>state.errorBars;
var $40ff607ce3fff820$var$combineRelevantErrorBarSettings = (cartesianItemsSettings, allErrorBarSettings, axisType)=>{
    return cartesianItemsSettings.flatMap((item)=>{
        return allErrorBarSettings[item.id];
    }).filter(Boolean).filter((e)=>{
        return $40ff607ce3fff820$export$8b0eb5a8c39b724f(axisType, e);
    });
};
var $40ff607ce3fff820$export$9c8185c6eda0fb0d = function mergeDomains() {
    for(var _len = arguments.length, domains = new Array(_len), _key = 0; _key < _len; _key++)domains[_key] = arguments[_key];
    var allDomains = domains.filter(Boolean);
    if (allDomains.length === 0) return undefined;
    var allValues = allDomains.flat();
    var min = Math.min(...allValues);
    var max = Math.max(...allValues);
    return [
        min,
        max
    ];
};
var $40ff607ce3fff820$export$df56c8e9a3e45e65 = (data, axisSettings, items, errorBars, axisType)=>{
    var lowerEnd, upperEnd;
    if (items.length > 0) data.forEach((entry)=>{
        items.forEach((item)=>{
            var _errorBars$item$id, _axisSettings$dataKey;
            var relevantErrorBars = (_errorBars$item$id = errorBars[item.id]) === null || _errorBars$item$id === void 0 ? void 0 : _errorBars$item$id.filter((errorBar)=>$40ff607ce3fff820$export$8b0eb5a8c39b724f(axisType, errorBar));
            var valueByDataKey = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            var errorDomain = $40ff607ce3fff820$export$25971beae035f58a(entry, valueByDataKey, relevantErrorBars);
            if (errorDomain.length >= 2) {
                var localLower = Math.min(...errorDomain);
                var localUpper = Math.max(...errorDomain);
                if (lowerEnd == null || localLower < lowerEnd) lowerEnd = localLower;
                if (upperEnd == null || localUpper > upperEnd) upperEnd = localUpper;
            }
            var dataValueDomain = $40ff607ce3fff820$var$makeDomain(valueByDataKey);
            if (dataValueDomain != null) {
                lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
                upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
            }
        });
    });
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) data.forEach((item)=>{
        var dataValueDomain = $40ff607ce3fff820$var$makeDomain((0, $09206e1485e62bdb$export$f97fc4a450f29a)(item, axisSettings.dataKey));
        if (dataValueDomain != null) {
            lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
            upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
        }
    });
    if ((0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(lowerEnd) && (0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(upperEnd)) return [
        lowerEnd,
        upperEnd
    ];
    return undefined;
};
var $40ff607ce3fff820$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$6099ba314905f0c4,
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    $40ff607ce3fff820$var$selectCartesianItemsSettingsExceptStacked,
    $40ff607ce3fff820$export$9429ab4550237b6d,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$df56c8e9a3e45e65, {
    memoizeOptions: {
        resultEqualityCheck: (0, $70a71c8202bf4e60$export$45c01007b107f1a6)
    }
});
function $40ff607ce3fff820$var$onlyAllowNumbersAndStringsAndDates(item) {
    var { value: value } = item;
    if ((0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(value) || value instanceof Date) return value;
    return undefined;
}
var $40ff607ce3fff820$var$computeDomainOfTypeCategory = (allDataSquished, axisSettings, isCategorical)=>{
    var categoricalDomain = allDataSquished.map($40ff607ce3fff820$var$onlyAllowNumbersAndStringsAndDates).filter((v)=>v != null);
    if (isCategorical && (axisSettings.dataKey == null || axisSettings.allowDuplicatedCategory && (0, $9d9ad0197f7e4c2b$export$732baf6a98f122)(categoricalDomain))) /*
     * 1. In an absence of dataKey, Recharts will use array indexes as its categorical domain
     * 2. When category axis has duplicated text, serial numbers are used to generate scale
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($11eb522a191bff78$exports)))(0, allDataSquished.length);
    if (axisSettings.allowDuplicatedCategory) return categoricalDomain;
    return Array.from(new Set(categoricalDomain));
};
var $40ff607ce3fff820$export$71580de5ed38161a = (state)=>state.referenceElements.dots;
var $40ff607ce3fff820$export$2829d12117d2002f = (elements, axisType, axisId)=>{
    return elements.filter((el)=>el.ifOverflow === 'extendDomain').filter((el)=>{
        if (axisType === 'xAxis') return el.xAxisId === axisId;
        return el.yAxisId === axisId;
    });
};
var $40ff607ce3fff820$export$dc267b7b9026caca = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$71580de5ed38161a,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98),
    (0, $f78caf308607cee1$export$6a2efa106dc9c8f6)
], $40ff607ce3fff820$export$2829d12117d2002f);
var $40ff607ce3fff820$export$c7e152cb7f10c1a6 = (state)=>state.referenceElements.areas;
var $40ff607ce3fff820$export$699de899b7bc81a9 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$c7e152cb7f10c1a6,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98),
    (0, $f78caf308607cee1$export$6a2efa106dc9c8f6)
], $40ff607ce3fff820$export$2829d12117d2002f);
var $40ff607ce3fff820$export$8fe2a49ce63c5348 = (state)=>state.referenceElements.lines;
var $40ff607ce3fff820$export$29b80feb73eec2b3 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$8fe2a49ce63c5348,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98),
    (0, $f78caf308607cee1$export$6a2efa106dc9c8f6)
], $40ff607ce3fff820$export$2829d12117d2002f);
var $40ff607ce3fff820$export$5da0b79fd816ec4b = (dots, axisType)=>{
    var allCoords = $40ff607ce3fff820$var$onlyAllowNumbers(dots.map((dot)=>axisType === 'xAxis' ? dot.x : dot.y));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $40ff607ce3fff820$var$selectReferenceDotsDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)($40ff607ce3fff820$export$dc267b7b9026caca, (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98), $40ff607ce3fff820$export$5da0b79fd816ec4b);
var $40ff607ce3fff820$export$7b27918cf5e1fc19 = (areas, axisType)=>{
    var allCoords = $40ff607ce3fff820$var$onlyAllowNumbers(areas.flatMap((area)=>[
            axisType === 'xAxis' ? area.x1 : area.y1,
            axisType === 'xAxis' ? area.x2 : area.y2
        ]));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $40ff607ce3fff820$var$selectReferenceAreasDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$699de899b7bc81a9,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$7b27918cf5e1fc19);
function $40ff607ce3fff820$var$extractXCoordinates(line) {
    var _line$segment;
    if (line.x != null) return $40ff607ce3fff820$var$onlyAllowNumbers([
        line.x
    ]);
    var segmentCoordinates = (_line$segment = line.segment) === null || _line$segment === void 0 ? void 0 : _line$segment.map((s)=>s.x);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $40ff607ce3fff820$var$onlyAllowNumbers(segmentCoordinates);
}
function $40ff607ce3fff820$var$extractYCoordinates(line) {
    var _line$segment2;
    if (line.y != null) return $40ff607ce3fff820$var$onlyAllowNumbers([
        line.y
    ]);
    var segmentCoordinates = (_line$segment2 = line.segment) === null || _line$segment2 === void 0 ? void 0 : _line$segment2.map((s)=>s.y);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $40ff607ce3fff820$var$onlyAllowNumbers(segmentCoordinates);
}
var $40ff607ce3fff820$export$f1d17aebd11953eb = (lines, axisType)=>{
    var allCoords = lines.flatMap((line)=>axisType === 'xAxis' ? $40ff607ce3fff820$var$extractXCoordinates(line) : $40ff607ce3fff820$var$extractYCoordinates(line));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $40ff607ce3fff820$var$selectReferenceLinesDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$29b80feb73eec2b3,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$f1d17aebd11953eb);
var $40ff607ce3fff820$var$selectReferenceElementsDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)($40ff607ce3fff820$var$selectReferenceDotsDomain, $40ff607ce3fff820$var$selectReferenceLinesDomain, $40ff607ce3fff820$var$selectReferenceAreasDomain, (dotsDomain, linesDomain, areasDomain)=>{
    return $40ff607ce3fff820$export$9c8185c6eda0fb0d(dotsDomain, areasDomain, linesDomain);
});
var $40ff607ce3fff820$export$b9eca0fd568f66a4 = (axisSettings, domainDefinition, domainFromUserPreference, domainOfStackGroups, dataAndErrorBarsDomain, referenceElementsDomain, layout, axisType)=>{
    if (domainFromUserPreference != null) // We're done! No need to compute anything else.
    return domainFromUserPreference;
    var shouldIncludeDomainOfStackGroups = layout === 'vertical' && axisType === 'xAxis' || layout === 'horizontal' && axisType === 'yAxis';
    var mergedDomains = shouldIncludeDomainOfStackGroups ? $40ff607ce3fff820$export$9c8185c6eda0fb0d(domainOfStackGroups, referenceElementsDomain, dataAndErrorBarsDomain) : $40ff607ce3fff820$export$9c8185c6eda0fb0d(referenceElementsDomain, dataAndErrorBarsDomain);
    return (0, $cbad8497179b0866$export$3f87aa7a53437a70)(domainDefinition, mergedDomains, axisSettings.allowDataOverflow);
};
var $40ff607ce3fff820$export$2a64502fccb4dfa6 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    $40ff607ce3fff820$export$5d46410c3f089eb2,
    $40ff607ce3fff820$export$c21dc69ecce61f8a,
    $40ff607ce3fff820$export$969bc8d84122c036,
    $40ff607ce3fff820$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $40ff607ce3fff820$var$selectReferenceElementsDomain,
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$b9eca0fd568f66a4, {
    memoizeOptions: {
        resultEqualityCheck: (0, $70a71c8202bf4e60$export$45c01007b107f1a6)
    }
});
/**
 * Expand by design maps everything between 0 and 1,
 * there is nothing to compute.
 * See https://d3js.org/d3-shape/stack#stack-offsets
 */ var $40ff607ce3fff820$var$expandDomain = [
    0,
    1
];
var $40ff607ce3fff820$export$70e6ef68424edf74 = (axisSettings, layout, displayedData, allAppliedValues, stackOffsetType, axisType, numericalDomain)=>{
    if ((axisSettings == null || displayedData == null || displayedData.length === 0) && numericalDomain === undefined) return undefined;
    var { dataKey: dataKey, type: type } = axisSettings;
    var isCategorical = (0, $09206e1485e62bdb$export$9fc1baaa6c6368b)(layout, axisType);
    if (isCategorical && dataKey == null) {
        var _displayedData$length;
        return (0, (/*@__PURE__*/$parcel$interopDefault($11eb522a191bff78$exports)))(0, (_displayedData$length = displayedData === null || displayedData === void 0 ? void 0 : displayedData.length) !== null && _displayedData$length !== void 0 ? _displayedData$length : 0);
    }
    if (type === 'category') return $40ff607ce3fff820$var$computeDomainOfTypeCategory(allAppliedValues, axisSettings, isCategorical);
    if (stackOffsetType === 'expand') return $40ff607ce3fff820$var$expandDomain;
    return numericalDomain;
};
var $40ff607ce3fff820$export$4fc5ecb5227dd744 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $40ff607ce3fff820$export$6099ba314905f0c4,
    $40ff607ce3fff820$export$9cea618b690f07b7,
    (0, $3eaa7bc41ed64724$export$73aff39176364def),
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98),
    $40ff607ce3fff820$export$2a64502fccb4dfa6
], $40ff607ce3fff820$export$70e6ef68424edf74);
var $40ff607ce3fff820$export$bebec32544750591 = (axisConfig, layout, hasBar, chartType, axisType)=>{
    if (axisConfig == null) return undefined;
    var { scale: scale, type: type } = axisConfig;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return 'band';
        if (layout === 'radial' && axisType === 'angleAxis') return 'linear';
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return 'point';
        if (type === 'category') return 'band';
        return 'linear';
    }
    if (typeof scale === 'string') {
        var name = "scale".concat((0, $9d9ad0197f7e4c2b$export$3061f22cd819074d)(scale));
        return name in $8c7575a8880d9a3f$exports ? name : 'point';
    }
    return undefined;
};
var $40ff607ce3fff820$export$a1a58ca78bb13ce7 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $40ff607ce3fff820$export$1c7798b82c8010cd,
    (0, $3eaa7bc41ed64724$export$3247769c9dbde559),
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$bebec32544750591);
function $40ff607ce3fff820$var$getD3ScaleFromType(realScaleType) {
    if (realScaleType == null) return undefined;
    if (realScaleType in $8c7575a8880d9a3f$exports) // @ts-expect-error we should do better type verification here
    return $8c7575a8880d9a3f$exports[realScaleType]();
    var name = "scale".concat((0, $9d9ad0197f7e4c2b$export$3061f22cd819074d)(realScaleType));
    if (name in $8c7575a8880d9a3f$exports) // @ts-expect-error we should do better type verification here
    return $8c7575a8880d9a3f$exports[name]();
    return undefined;
}
function $40ff607ce3fff820$export$e2fe61793fcf6495(axis, realScaleType, axisDomain, axisRange) {
    if (axisDomain == null || axisRange == null) return undefined;
    if (typeof axis.scale === 'function') // @ts-expect-error we're going to assume here that if axis.scale is a function then it is a d3Scale function
    return axis.scale.copy().domain(axisDomain).range(axisRange);
    var d3ScaleFunction = $40ff607ce3fff820$var$getD3ScaleFromType(realScaleType);
    if (d3ScaleFunction == null) return undefined;
    var scale = d3ScaleFunction.domain(axisDomain).range(axisRange);
    // I don't like this function because it mutates the scale. We should come up with a way to compute the domain up front.
    (0, $09206e1485e62bdb$export$9d80152e23bae434)(scale);
    return scale;
}
var $40ff607ce3fff820$export$aa1ef6c8f610e48c = (axisDomain, axisSettings, realScaleType)=>{
    var domainDefinition = $40ff607ce3fff820$export$2e6262b6c952ab02(axisSettings);
    if (realScaleType !== 'auto' && realScaleType !== 'linear') return undefined;
    if (axisSettings != null && axisSettings.tickCount && Array.isArray(domainDefinition) && (domainDefinition[0] === 'auto' || domainDefinition[1] === 'auto') && (0, $cbad8497179b0866$export$ba29b24e2a92eb58)(axisDomain)) return (0, $132078bfcf1d5ec9$export$b84e75ccbfe6a612)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals);
    if (axisSettings != null && axisSettings.tickCount && axisSettings.type === 'number' && (0, $cbad8497179b0866$export$ba29b24e2a92eb58)(axisDomain)) return (0, $132078bfcf1d5ec9$export$e9d28da780436e98)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals);
    return undefined;
};
var $40ff607ce3fff820$export$2efb9b5d95659d33 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$4fc5ecb5227dd744,
    $40ff607ce3fff820$export$3635e5ebe47f85a9,
    $40ff607ce3fff820$export$a1a58ca78bb13ce7
], $40ff607ce3fff820$export$aa1ef6c8f610e48c);
var $40ff607ce3fff820$export$3a4530026b1860ff = (axisSettings, domain, niceTicks, axisType)=>{
    if (/*
   * Angle axis for some reason uses nice ticks when rendering axis tick labels,
   * but doesn't use nice ticks for extending domain like all the other axes do.
   * Not really sure why? Is there a good reason,
   * or is it just because someone added support for nice ticks to the other axes and forgot this one?
   */ axisType !== 'angleAxis' && (axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.type) === 'number' && (0, $cbad8497179b0866$export$ba29b24e2a92eb58)(domain) && Array.isArray(niceTicks) && niceTicks.length > 0) {
        var minFromDomain = domain[0];
        var minFromTicks = niceTicks[0];
        var maxFromDomain = domain[1];
        var maxFromTicks = niceTicks[niceTicks.length - 1];
        return [
            Math.min(minFromDomain, minFromTicks),
            Math.max(maxFromDomain, maxFromTicks)
        ];
    }
    return domain;
};
var $40ff607ce3fff820$export$af7761c6ea30fae4 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    $40ff607ce3fff820$export$4fc5ecb5227dd744,
    $40ff607ce3fff820$export$2efb9b5d95659d33,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$3a4530026b1860ff);
var $40ff607ce3fff820$export$a1013ea99dfe6af9 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)($40ff607ce3fff820$export$9cea618b690f07b7, $40ff607ce3fff820$export$fc14c3706e09c50c, (allDataSquished, axisSettings)=>{
    if (!axisSettings || axisSettings.type !== 'number') return undefined;
    var smallestDistanceBetweenValues = Infinity;
    var sortedValues = Array.from($40ff607ce3fff820$var$onlyAllowNumbers(allDataSquished.map((d)=>d.value))).sort((a, b)=>a - b);
    if (sortedValues.length < 2) return Infinity;
    var diff = sortedValues[sortedValues.length - 1] - sortedValues[0];
    if (diff === 0) return Infinity;
    // Only do n - 1 distance calculations because there's only n - 1 distances between n values.
    for(var i = 0; i < sortedValues.length - 1; i++){
        var distance = sortedValues[i + 1] - sortedValues[i];
        smallestDistanceBetweenValues = Math.min(smallestDistanceBetweenValues, distance);
    }
    return smallestDistanceBetweenValues / diff;
});
var $40ff607ce3fff820$var$selectCalculatedPadding = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)($40ff607ce3fff820$export$a1013ea99dfe6af9, (0, $2d4a23e6670568d2$export$8426b6d9af801dee), (0, $3eaa7bc41ed64724$export$a73f9d39b015942a), (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b), (_1, _2, _3, padding)=>padding, (smallestDistanceInPercent, layout, barCategoryGap, offset, padding)=>{
    if (!(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(smallestDistanceInPercent)) return 0;
    var rangeWidth = layout === 'vertical' ? offset.height : offset.width;
    if (padding === 'gap') return smallestDistanceInPercent * rangeWidth / 2;
    if (padding === 'no-gap') {
        var gap = (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(barCategoryGap, smallestDistanceInPercent * rangeWidth);
        var halfBand = smallestDistanceInPercent * rangeWidth / 2;
        return halfBand - gap - (halfBand - gap) / rangeWidth * gap;
    }
    return 0;
});
var $40ff607ce3fff820$export$29cb35c3432eef0e = (state, axisId)=>{
    var xAxisSettings = $40ff607ce3fff820$export$d6895d8ddb4cee5(state, axisId);
    if (xAxisSettings == null || typeof xAxisSettings.padding !== 'string') return 0;
    return $40ff607ce3fff820$var$selectCalculatedPadding(state, 'xAxis', axisId, xAxisSettings.padding);
};
var $40ff607ce3fff820$export$689bf02345b2d857 = (state, axisId)=>{
    var yAxisSettings = $40ff607ce3fff820$export$1f472705a332f1c9(state, axisId);
    if (yAxisSettings == null || typeof yAxisSettings.padding !== 'string') return 0;
    return $40ff607ce3fff820$var$selectCalculatedPadding(state, 'yAxis', axisId, yAxisSettings.padding);
};
var $40ff607ce3fff820$var$selectXAxisPadding = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)($40ff607ce3fff820$export$d6895d8ddb4cee5, $40ff607ce3fff820$export$29cb35c3432eef0e, (xAxisSettings, calculated)=>{
    var _padding$left, _padding$right;
    if (xAxisSettings == null) return {
        left: 0,
        right: 0
    };
    var { padding: padding } = xAxisSettings;
    if (typeof padding === 'string') return {
        left: calculated,
        right: calculated
    };
    return {
        left: ((_padding$left = padding.left) !== null && _padding$left !== void 0 ? _padding$left : 0) + calculated,
        right: ((_padding$right = padding.right) !== null && _padding$right !== void 0 ? _padding$right : 0) + calculated
    };
});
var $40ff607ce3fff820$var$selectYAxisPadding = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)($40ff607ce3fff820$export$1f472705a332f1c9, $40ff607ce3fff820$export$689bf02345b2d857, (yAxisSettings, calculated)=>{
    var _padding$top, _padding$bottom;
    if (yAxisSettings == null) return {
        top: 0,
        bottom: 0
    };
    var { padding: padding } = yAxisSettings;
    if (typeof padding === 'string') return {
        top: calculated,
        bottom: calculated
    };
    return {
        top: ((_padding$top = padding.top) !== null && _padding$top !== void 0 ? _padding$top : 0) + calculated,
        bottom: ((_padding$bottom = padding.bottom) !== null && _padding$bottom !== void 0 ? _padding$bottom : 0) + calculated
    };
});
var $40ff607ce3fff820$export$f90f75eaf1068eb1 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    $40ff607ce3fff820$var$selectXAxisPadding,
    (0, $157aebf66ae7c2b8$export$3b81e97eae001823),
    (0, $157aebf66ae7c2b8$export$5ba94b496f8dc52e),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, padding, brushDimensions, _ref4, isPanorama)=>{
    var { padding: brushPadding } = _ref4;
    if (isPanorama) return [
        brushPadding.left,
        brushDimensions.width - brushPadding.right
    ];
    return [
        offset.left + padding.left,
        offset.left + offset.width - padding.right
    ];
});
var $40ff607ce3fff820$export$90c620fc44f45640 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $40ff607ce3fff820$var$selectYAxisPadding,
    (0, $157aebf66ae7c2b8$export$3b81e97eae001823),
    (0, $157aebf66ae7c2b8$export$5ba94b496f8dc52e),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, layout, padding, brushDimensions, _ref5, isPanorama)=>{
    var { padding: brushPadding } = _ref5;
    if (isPanorama) return [
        brushDimensions.height - brushPadding.bottom,
        brushPadding.top
    ];
    if (layout === 'horizontal') return [
        offset.top + offset.height - padding.bottom,
        offset.top + padding.top
    ];
    return [
        offset.top + padding.top,
        offset.top + offset.height - padding.bottom
    ];
});
var $40ff607ce3fff820$export$3506ed461810cc8f = (state, axisType, axisId, isPanorama)=>{
    var _selectZAxisSettings;
    switch(axisType){
        case 'xAxis':
            return $40ff607ce3fff820$export$f90f75eaf1068eb1(state, axisId, isPanorama);
        case 'yAxis':
            return $40ff607ce3fff820$export$90c620fc44f45640(state, axisId, isPanorama);
        case 'zAxis':
            return (_selectZAxisSettings = $40ff607ce3fff820$export$26eadf639b453d0f(state, axisId)) === null || _selectZAxisSettings === void 0 ? void 0 : _selectZAxisSettings.range;
        case 'angleAxis':
            return (0, $84d209255304466f$export$d00c8e94622c940)(state);
        case 'radiusAxis':
            return (0, $84d209255304466f$export$e13d847e4d4f833f)(state, axisId);
        default:
            return undefined;
    }
};
var $40ff607ce3fff820$export$d6d5faff23feedea = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    $40ff607ce3fff820$export$3506ed461810cc8f
], (0, $d20f3aee8b703dd2$export$3f7e30291950e694));
var $40ff607ce3fff820$export$22e8e5f8924724ea = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    $40ff607ce3fff820$export$a1a58ca78bb13ce7,
    $40ff607ce3fff820$export$af7761c6ea30fae4,
    $40ff607ce3fff820$export$d6d5faff23feedea
], $40ff607ce3fff820$export$e2fe61793fcf6495);
var $40ff607ce3fff820$export$565b9812b1d7c04f = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$533d13f911334c9d,
    $40ff607ce3fff820$export$9429ab4550237b6d,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$var$combineRelevantErrorBarSettings);
function $40ff607ce3fff820$var$compareIds(a, b) {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
}
var $40ff607ce3fff820$var$pickAxisOrientation = (_state, orientation)=>orientation;
var $40ff607ce3fff820$var$pickMirror = (_state, _orientation, mirror)=>mirror;
var $40ff607ce3fff820$var$selectAllXAxesWithOffsetType = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((0, $ca40ce91d5de9c53$export$bd320344232f30af), $40ff607ce3fff820$var$pickAxisOrientation, $40ff607ce3fff820$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($40ff607ce3fff820$var$compareIds));
var $40ff607ce3fff820$var$selectAllYAxesWithOffsetType = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((0, $ca40ce91d5de9c53$export$e22adabb0128cf25), $40ff607ce3fff820$var$pickAxisOrientation, $40ff607ce3fff820$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($40ff607ce3fff820$var$compareIds));
var $40ff607ce3fff820$var$getXAxisSize = (offset, axisSettings)=>{
    return {
        width: offset.width,
        height: axisSettings.height
    };
};
var $40ff607ce3fff820$var$getYAxisSize = (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $61c6522d82a73e91$export$fb6ee82c8ee2faf8);
    return {
        width: width,
        height: offset.height
    };
};
var $40ff607ce3fff820$export$50d4085c87c19b12 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((0, $680da228e16ed19c$export$1e34c8efb0bc9b3b), $40ff607ce3fff820$export$d6895d8ddb4cee5, $40ff607ce3fff820$var$getXAxisSize);
var $40ff607ce3fff820$var$combineXAxisPositionStartingPoint = (offset, orientation, chartHeight)=>{
    switch(orientation){
        case 'top':
            return offset.top;
        case 'bottom':
            return chartHeight - offset.bottom;
        default:
            return 0;
    }
};
var $40ff607ce3fff820$var$combineYAxisPositionStartingPoint = (offset, orientation, chartWidth)=>{
    switch(orientation){
        case 'left':
            return offset.left;
        case 'right':
            return chartWidth - offset.right;
        default:
            return 0;
    }
};
var $40ff607ce3fff820$export$6cb04966ad155e81 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((0, $122c64eee523dc50$export$5856a7d94c109505), (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b), $40ff607ce3fff820$var$selectAllXAxesWithOffsetType, $40ff607ce3fff820$var$pickAxisOrientation, $40ff607ce3fff820$var$pickMirror, (chartHeight, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $40ff607ce3fff820$var$getXAxisSize(offset, axis);
        if (position == null) position = $40ff607ce3fff820$var$combineXAxisPositionStartingPoint(offset, orientation, chartHeight);
        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.height;
        position += (needSpace ? -1 : 1) * axisSize.height;
    });
    return steps;
});
var $40ff607ce3fff820$export$edba808018e1c207 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((0, $122c64eee523dc50$export$771ef0ac044f724d), (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b), $40ff607ce3fff820$var$selectAllYAxesWithOffsetType, $40ff607ce3fff820$var$pickAxisOrientation, $40ff607ce3fff820$var$pickMirror, (chartWidth, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $40ff607ce3fff820$var$getYAxisSize(offset, axis);
        if (position == null) position = $40ff607ce3fff820$var$combineYAxisPositionStartingPoint(offset, orientation, chartWidth);
        var needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.width;
        position += (needSpace ? -1 : 1) * axisSize.width;
    });
    return steps;
});
var $40ff607ce3fff820$var$selectXAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $40ff607ce3fff820$export$d6895d8ddb4cee5(state, axisId);
    if (axisSettings == null) return undefined;
    return $40ff607ce3fff820$export$6cb04966ad155e81(state, axisSettings.orientation, axisSettings.mirror);
};
var $40ff607ce3fff820$export$92fdc590d2371053 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    $40ff607ce3fff820$export$d6895d8ddb4cee5,
    $40ff607ce3fff820$var$selectXAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: offset.left,
        y: 0
    };
    return {
        x: offset.left,
        y: stepOfThisAxis
    };
});
var $40ff607ce3fff820$var$selectYAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $40ff607ce3fff820$export$1f472705a332f1c9(state, axisId);
    if (axisSettings == null) return undefined;
    return $40ff607ce3fff820$export$edba808018e1c207(state, axisSettings.orientation, axisSettings.mirror);
};
var $40ff607ce3fff820$export$e67a320452ebcaef = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    $40ff607ce3fff820$export$1f472705a332f1c9,
    $40ff607ce3fff820$var$selectYAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: 0,
        y: offset.top
    };
    return {
        x: stepOfThisAxis,
        y: offset.top
    };
});
var $40ff607ce3fff820$export$249bec756af8ac39 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((0, $680da228e16ed19c$export$1e34c8efb0bc9b3b), $40ff607ce3fff820$export$1f472705a332f1c9, (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $61c6522d82a73e91$export$fb6ee82c8ee2faf8);
    return {
        width: width,
        height: offset.height
    };
});
var $40ff607ce3fff820$export$6d6e642aa7a0ae10 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $40ff607ce3fff820$export$50d4085c87c19b12(state, axisId).width;
        case 'yAxis':
            return $40ff607ce3fff820$export$249bec756af8ac39(state, axisId).height;
        default:
            return undefined;
    }
};
var $40ff607ce3fff820$export$bb1ebf56a37bd899 = (chartLayout, appliedValues, axis, axisType)=>{
    if (axis == null) return undefined;
    var { allowDuplicatedCategory: allowDuplicatedCategory, type: type, dataKey: dataKey } = axis;
    var isCategorical = (0, $09206e1485e62bdb$export$9fc1baaa6c6368b)(chartLayout, axisType);
    var allData = appliedValues.map((av)=>av.value);
    if (dataKey && isCategorical && type === 'category' && allowDuplicatedCategory && (0, $9d9ad0197f7e4c2b$export$732baf6a98f122)(allData)) return allData;
    return undefined;
};
var $40ff607ce3fff820$export$4fc6aadcd9e9157c = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $40ff607ce3fff820$export$9cea618b690f07b7,
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$bb1ebf56a37bd899);
var $40ff607ce3fff820$export$911ef47868c9ab07 = (layout, appliedValues, axis, axisType)=>{
    if (axis == null || axis.dataKey == null) return undefined;
    var { type: type, scale: scale } = axis;
    var isCategorical = (0, $09206e1485e62bdb$export$9fc1baaa6c6368b)(layout, axisType);
    if (isCategorical && (type === 'number' || scale !== 'auto')) return appliedValues.map((d)=>d.value);
    return undefined;
};
var $40ff607ce3fff820$export$a6a79e7a5412631c = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $40ff607ce3fff820$export$9cea618b690f07b7,
    $40ff607ce3fff820$export$3635e5ebe47f85a9,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$911ef47868c9ab07);
var $40ff607ce3fff820$export$45cd57660792dd31 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $40ff607ce3fff820$var$selectCartesianAxisSettings,
    $40ff607ce3fff820$export$a1a58ca78bb13ce7,
    $40ff607ce3fff820$export$22e8e5f8924724ea,
    $40ff607ce3fff820$export$4fc6aadcd9e9157c,
    $40ff607ce3fff820$export$a6a79e7a5412631c,
    $40ff607ce3fff820$export$3506ed461810cc8f,
    $40ff607ce3fff820$export$2efb9b5d95659d33,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], (layout, axis, realScaleType, scale, duplicateDomain, categoricalDomain, axisRange, niceTicks, axisType)=>{
    if (axis == null) return undefined;
    var isCategorical = (0, $09206e1485e62bdb$export$9fc1baaa6c6368b)(layout, axisType);
    return {
        angle: axis.angle,
        interval: axis.interval,
        minTickGap: axis.minTickGap,
        orientation: axis.orientation,
        tick: axis.tick,
        tickCount: axis.tickCount,
        tickFormatter: axis.tickFormatter,
        ticks: axis.ticks,
        type: axis.type,
        unit: axis.unit,
        axisType: axisType,
        categoricalDomain: categoricalDomain,
        duplicateDomain: duplicateDomain,
        isCategorical: isCategorical,
        niceTicks: niceTicks,
        range: axisRange,
        realScaleType: realScaleType,
        scale: scale
    };
});
var $40ff607ce3fff820$export$d033262fd214bffb = (layout, axis, realScaleType, scale, niceTicks, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null) return undefined;
    var isCategorical = (0, $09206e1485e62bdb$export$9fc1baaa6c6368b)(layout, axisType);
    var { type: type, ticks: ticks, tickCount: tickCount } = axis;
    // This is testing for `scaleBand` but for band axis the type is reported as `band` so this looks like a dead code with a workaround elsewhere?
    var offsetForBand = realScaleType === 'scaleBand' && typeof scale.bandwidth === 'function' ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && axisRange != null && axisRange.length >= 2 ? (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    var ticksOrNiceTicks = ticks || niceTicks;
    if (ticksOrNiceTicks) {
        var result = ticksOrNiceTicks.map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                index: index,
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter((row)=>(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(row.coordinate));
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        })).filter((row)=>(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(row.coordinate));
    if (scale.ticks) return scale.ticks(tickCount)// @ts-expect-error why does the offset go here? The type does not require it
    .map((entry)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        }));
};
var $40ff607ce3fff820$export$f0d85e8287c47657 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $40ff607ce3fff820$export$3635e5ebe47f85a9,
    $40ff607ce3fff820$export$a1a58ca78bb13ce7,
    $40ff607ce3fff820$export$22e8e5f8924724ea,
    $40ff607ce3fff820$export$2efb9b5d95659d33,
    $40ff607ce3fff820$export$3506ed461810cc8f,
    $40ff607ce3fff820$export$4fc6aadcd9e9157c,
    $40ff607ce3fff820$export$a6a79e7a5412631c,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$d033262fd214bffb);
var $40ff607ce3fff820$export$453d0e9212f0369b = (layout, axis, scale, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null || axisRange == null || axisRange[0] === axisRange[1]) return undefined;
    var isCategorical = (0, $09206e1485e62bdb$export$9fc1baaa6c6368b)(layout, axisType);
    var { tickCount: tickCount } = axis;
    var offset = 0;
    offset = axisType === 'angleAxis' && (axisRange === null || axisRange === void 0 ? void 0 : axisRange.length) >= 2 ? (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        }));
    if (scale.ticks) return scale.ticks(tickCount)// @ts-expect-error why does the offset go here? The type does not require it
    .map((entry)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        }));
};
var $40ff607ce3fff820$export$b894cb5d8586b43d = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $40ff607ce3fff820$export$3635e5ebe47f85a9,
    $40ff607ce3fff820$export$22e8e5f8924724ea,
    $40ff607ce3fff820$export$3506ed461810cc8f,
    $40ff607ce3fff820$export$4fc6aadcd9e9157c,
    $40ff607ce3fff820$export$a6a79e7a5412631c,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], $40ff607ce3fff820$export$453d0e9212f0369b);
var $40ff607ce3fff820$export$db36c2f3bfe5c9d7 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)($40ff607ce3fff820$export$fc14c3706e09c50c, $40ff607ce3fff820$export$22e8e5f8924724ea, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $40ff607ce3fff820$var$_objectSpread($40ff607ce3fff820$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $40ff607ce3fff820$var$selectZAxisScale = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $40ff607ce3fff820$export$fc14c3706e09c50c,
    $40ff607ce3fff820$export$a1a58ca78bb13ce7,
    $40ff607ce3fff820$export$4fc5ecb5227dd744,
    $40ff607ce3fff820$export$d6d5faff23feedea
], $40ff607ce3fff820$export$e2fe61793fcf6495);
var $40ff607ce3fff820$export$4dab5213d1420bb3 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((state, _axisType, axisId)=>$40ff607ce3fff820$export$26eadf639b453d0f(state, axisId), $40ff607ce3fff820$var$selectZAxisScale, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $40ff607ce3fff820$var$_objectSpread($40ff607ce3fff820$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $40ff607ce3fff820$export$430d623a94added7 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $ca40ce91d5de9c53$export$bd320344232f30af),
    (0, $ca40ce91d5de9c53$export$e22adabb0128cf25)
], (layout, allXAxes, allYAxes)=>{
    switch(layout){
        case 'horizontal':
            return allXAxes.some((axis)=>axis.reversed) ? 'right-to-left' : 'left-to-right';
        case 'vertical':
            return allYAxes.some((axis)=>axis.reversed) ? 'bottom-to-top' : 'top-to-bottom';
        // TODO: make this better. For now, right arrow triggers "forward", left arrow "back"
        // however, the tooltip moves an unintuitive direction because of how the indices are rendered
        case 'centric':
        case 'radial':
            return 'left-to-right';
        default:
            return undefined;
    }
});




function $9b2a3f99ebd40cd8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b2a3f99ebd40cd8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b2a3f99ebd40cd8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9b2a3f99ebd40cd8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b2a3f99ebd40cd8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9b2a3f99ebd40cd8$var$_defineProperty(e, r, t) {
    return (r = $9b2a3f99ebd40cd8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9b2a3f99ebd40cd8$var$_toPropertyKey(t) {
    var i = $9b2a3f99ebd40cd8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9b2a3f99ebd40cd8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9b2a3f99ebd40cd8$export$e43f7367e579f53d = 0;
/**
 * Properties shared in X, Y, and Z axes
 */ /**
 * These are the external props, visible for users as they set them using our public API.
 * There is all sorts of internal computed things based on these, but they will come through selectors.
 *
 * Properties shared between X and Y axes
 */ /**
 * Z axis is special because it's never displayed. It controls the size of Scatter dots,
 * but it never displays ticks anywhere.
 */ var $9b2a3f99ebd40cd8$var$initialState = {
    xAxis: {},
    yAxis: {},
    zAxis: {}
};
/**
 * This is the slice where each individual Axis element pushes its own configuration.
 * Prefer to use this one instead of axisSlice.
 */ var $9b2a3f99ebd40cd8$var$cartesianAxisSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'cartesianAxis',
    initialState: $9b2a3f99ebd40cd8$var$initialState,
    reducers: {
        addXAxis: {
            reducer (state, action) {
                state.xAxis[action.payload.id] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        replaceXAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.xAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.xAxis[prev.id];
                    state.xAxis[next.id] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        removeXAxis: {
            reducer (state, action) {
                delete state.xAxis[action.payload.id];
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        addYAxis: {
            reducer (state, action) {
                state.yAxis[action.payload.id] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        replaceYAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.yAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.yAxis[prev.id];
                    state.yAxis[next.id] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        removeYAxis: {
            reducer (state, action) {
                delete state.yAxis[action.payload.id];
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        addZAxis: {
            reducer (state, action) {
                state.zAxis[action.payload.id] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        replaceZAxis: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                if (state.zAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.zAxis[prev.id];
                    state.zAxis[next.id] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(next);
                }
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        removeZAxis: {
            reducer (state, action) {
                delete state.zAxis[action.payload.id];
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        updateYAxisWidth (state, action) {
            var { id: id, width: width } = action.payload;
            var axis = state.yAxis[id];
            if (axis) {
                var history = axis.widthHistory || [];
                // An oscillation is detected when the new width is the same as the width before the last one.
                // This is a simple A -> B -> A pattern. If the next width is B, and the difference is less than 1 pixel, we ignore it.
                if (history.length === 3 && history[0] === history[2] && width === history[1] && width !== axis.width && Math.abs(width - history[0]) <= 1) return;
                var newHistory = [
                    ...history,
                    width
                ].slice(-3);
                state.yAxis[id] = $9b2a3f99ebd40cd8$var$_objectSpread($9b2a3f99ebd40cd8$var$_objectSpread({}, state.yAxis[id]), {}, {
                    width: width,
                    widthHistory: newHistory
                });
            }
        }
    }
});
var { addXAxis: $9b2a3f99ebd40cd8$export$add6226ad7812fc8, replaceXAxis: $9b2a3f99ebd40cd8$export$40aac341c282a543, removeXAxis: $9b2a3f99ebd40cd8$export$f408189458c6a79b, addYAxis: $9b2a3f99ebd40cd8$export$4ed10a19d7febea1, replaceYAxis: $9b2a3f99ebd40cd8$export$58b7fa4a7d4572f6, removeYAxis: $9b2a3f99ebd40cd8$export$79db5e9bd25f14c4, addZAxis: $9b2a3f99ebd40cd8$export$1c8a1319a1571880, replaceZAxis: $9b2a3f99ebd40cd8$export$ad147e7505520476, removeZAxis: $9b2a3f99ebd40cd8$export$d823f07ec1da7041, updateYAxisWidth: $9b2a3f99ebd40cd8$export$6e42dbbf4e5a5faa } = $9b2a3f99ebd40cd8$var$cartesianAxisSlice.actions;
var $9b2a3f99ebd40cd8$export$c8ae79f5f6ae07c6 = $9b2a3f99ebd40cd8$var$cartesianAxisSlice.reducer;














var $c4309ff5980e62d8$export$877d2dd8db5f51fd = (state)=>state.options.defaultTooltipEventType;
var $c4309ff5980e62d8$export$7f95a7e594fa7911 = (state)=>state.options.validateTooltipEventTypes;
function $c4309ff5980e62d8$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes) {
    if (shared == null) return defaultTooltipEventType;
    var eventType = shared ? 'axis' : 'item';
    if (validateTooltipEventTypes == null) return defaultTooltipEventType;
    return validateTooltipEventTypes.includes(eventType) ? eventType : defaultTooltipEventType;
}
function $c4309ff5980e62d8$export$53af65c2db668fac(state, shared) {
    var defaultTooltipEventType = $c4309ff5980e62d8$export$877d2dd8db5f51fd(state);
    var validateTooltipEventTypes = $c4309ff5980e62d8$export$7f95a7e594fa7911(state);
    return $c4309ff5980e62d8$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes);
}
function $c4309ff5980e62d8$export$7ac1fe18a92be318(shared) {
    return (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>$c4309ff5980e62d8$export$53af65c2db668fac(state, shared));
}



var $e1872c677ee761c0$export$3213c4688ceb4c80 = (tooltipTicks, activeIndex)=>{
    var _tooltipTicks$n;
    var n = Number(activeIndex);
    if ((0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(n) || activeIndex == null) return undefined;
    return n >= 0 ? tooltipTicks === null || tooltipTicks === void 0 || (_tooltipTicks$n = tooltipTicks[n]) === null || _tooltipTicks$n === void 0 ? void 0 : _tooltipTicks$n.value : undefined;
};


var $e27ab2d37e85c093$export$26d1e95fb7dea02 = (state)=>state.tooltip.settings;



function $9eb1abdae9a7bbd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9eb1abdae9a7bbd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9eb1abdae9a7bbd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9eb1abdae9a7bbd1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9eb1abdae9a7bbd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9eb1abdae9a7bbd1$var$_defineProperty(e, r, t) {
    return (r = $9eb1abdae9a7bbd1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9eb1abdae9a7bbd1$var$_toPropertyKey(t) {
    var i = $9eb1abdae9a7bbd1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9eb1abdae9a7bbd1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9eb1abdae9a7bbd1$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger) {
    if (tooltipEventType === 'axis') {
        if (trigger === 'click') return tooltipState.axisInteraction.click;
        return tooltipState.axisInteraction.hover;
    }
    if (trigger === 'click') return tooltipState.itemInteraction.click;
    return tooltipState.itemInteraction.hover;
}
function $9eb1abdae9a7bbd1$var$hasBeenActivePreviously(tooltipInteractionState) {
    return tooltipInteractionState.index != null;
}
var $9eb1abdae9a7bbd1$export$d759c39cacfacf6a = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    if (tooltipEventType == null) return 0, $c54e506cc16ecb3e$export$66f2ad380b6acece;
    var appropriateMouseInteraction = $9eb1abdae9a7bbd1$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger);
    if (appropriateMouseInteraction == null) return 0, $c54e506cc16ecb3e$export$66f2ad380b6acece;
    if (appropriateMouseInteraction.active) return appropriateMouseInteraction;
    if (tooltipState.keyboardInteraction.active) return tooltipState.keyboardInteraction;
    if (tooltipState.syncInteraction.active && tooltipState.syncInteraction.index != null) return tooltipState.syncInteraction;
    var activeFromProps = tooltipState.settings.active === true;
    if ($9eb1abdae9a7bbd1$var$hasBeenActivePreviously(appropriateMouseInteraction)) {
        if (activeFromProps) return $9eb1abdae9a7bbd1$var$_objectSpread($9eb1abdae9a7bbd1$var$_objectSpread({}, appropriateMouseInteraction), {}, {
            active: true
        });
    } else if (defaultIndex != null) return {
        active: true,
        coordinate: undefined,
        dataKey: undefined,
        index: defaultIndex
    };
    return $9eb1abdae9a7bbd1$var$_objectSpread($9eb1abdae9a7bbd1$var$_objectSpread({}, (0, $c54e506cc16ecb3e$export$66f2ad380b6acece)), {}, {
        coordinate: appropriateMouseInteraction.coordinate
    });
};





function $22214ebf87c016df$var$toFiniteNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (value instanceof Date) {
        var numericValue = value.valueOf();
        return Number.isFinite(numericValue) ? numericValue : undefined;
    }
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
function $22214ebf87c016df$var$isValueWithinNumberDomain(value, domain) {
    var numericValue = $22214ebf87c016df$var$toFiniteNumber(value);
    var lowerBound = domain[0];
    var upperBound = domain[1];
    if (numericValue === undefined) return false;
    var min = Math.min(lowerBound, upperBound);
    var max = Math.max(lowerBound, upperBound);
    return numericValue >= min && numericValue <= max;
}
function $22214ebf87c016df$var$isValueWithinDomain(entry, axisDataKey, domain) {
    if (domain == null || axisDataKey == null) return true;
    var value = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, axisDataKey);
    if (value == null) return true;
    if (!(0, $cbad8497179b0866$export$ba29b24e2a92eb58)(domain)) return true;
    return $22214ebf87c016df$var$isValueWithinNumberDomain(value, domain);
}
var $22214ebf87c016df$export$32df4b03a0962e46 = (tooltipInteraction, chartData, axisDataKey, domain)=>{
    var desiredIndex = tooltipInteraction === null || tooltipInteraction === void 0 ? void 0 : tooltipInteraction.index;
    if (desiredIndex == null) return null;
    var indexAsNumber = Number(desiredIndex);
    if (!(0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(indexAsNumber)) // this is for charts like Sankey and Treemap that do not support numerical indexes. We need a proper solution for this before we can start supporting keyboard events on these charts.
    return desiredIndex;
    /*
   * Zero is a trivial limit for single-dimensional charts like Line and Area,
   * but this also needs a support for multidimensional charts like Sankey and Treemap! TODO
   */ var lowerLimit = 0;
    var upperLimit = Infinity;
    if (chartData.length > 0) upperLimit = chartData.length - 1;
    // now let's clamp the desiredIndex between the limits
    var clampedIndex = Math.max(lowerLimit, Math.min(indexAsNumber, upperLimit));
    var entry = chartData[clampedIndex];
    if (entry == null) return String(clampedIndex);
    if (!$22214ebf87c016df$var$isValueWithinDomain(entry, axisDataKey, domain)) return null;
    return String(clampedIndex);
};


var $71f8d538d48a32e2$export$c2cbc37a7546bbd0 = (width, height, layout, offset, tooltipTicks, defaultIndex, tooltipConfigurations, tooltipPayloadSearcher)=>{
    if (defaultIndex == null || tooltipPayloadSearcher == null) return undefined;
    // With defaultIndex alone, we don't have enough information to decide _which_ of the multiple tooltips to display. So we choose the first one.
    var firstConfiguration = tooltipConfigurations[0];
    // @ts-expect-error we need to rethink the tooltipPayloadSearcher type
    var maybePosition = firstConfiguration == null ? undefined : tooltipPayloadSearcher(firstConfiguration.positions, defaultIndex);
    if (maybePosition != null) return maybePosition;
    var tick = tooltipTicks === null || tooltipTicks === void 0 ? void 0 : tooltipTicks[Number(defaultIndex)];
    if (!tick) return undefined;
    switch(layout){
        case 'horizontal':
            return {
                x: tick.coordinate,
                y: (offset.top + height) / 2
            };
        default:
            // This logic is not super sound - it conflates vertical, radial, centric layouts into just one. TODO improve!
            return {
                x: (offset.left + width) / 2,
                y: tick.coordinate
            };
    }
};




var $b035ad89395e7942$export$45044aaa79c0cddb = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    // if tooltip reacts to axis interaction, then we display all items at the same time.
    if (tooltipEventType === 'axis') return tooltipState.tooltipItemPayloads;
    /*
   * By now we already know that tooltipEventType is 'item', so we can only search in itemInteractions.
   * item means that only the hovered or clicked item will be present in the tooltip.
   */ if (tooltipState.tooltipItemPayloads.length === 0) // No point filtering if the payload is empty
    return [];
    var filterByDataKey;
    if (trigger === 'hover') filterByDataKey = tooltipState.itemInteraction.hover.dataKey;
    else filterByDataKey = tooltipState.itemInteraction.click.dataKey;
    if (filterByDataKey == null && defaultIndex != null) /*
     * So when we use `defaultIndex` - we don't have a dataKey to filter by because user did not hover over anything yet.
     * In that case let's display the first item in the tooltip; after all, this is `item` interaction case,
     * so we should display only one item at a time instead of all.
     */ return [
        tooltipState.tooltipItemPayloads[0]
    ];
    return tooltipState.tooltipItemPayloads.filter((tpc)=>{
        var _tpc$settings;
        return ((_tpc$settings = tpc.settings) === null || _tpc$settings === void 0 ? void 0 : _tpc$settings.dataKey) === filterByDataKey;
    });
};


var $983b6625e071621a$export$6ae1ee94e6fa88a7 = (state)=>state.options.tooltipPayloadSearcher;


var $a3236ed45f976f57$export$703b585bc92b5bae = (state)=>state.tooltip;





function $0c87694423bc4b01$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c87694423bc4b01$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c87694423bc4b01$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0c87694423bc4b01$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c87694423bc4b01$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c87694423bc4b01$var$_defineProperty(e, r, t) {
    return (r = $0c87694423bc4b01$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0c87694423bc4b01$var$_toPropertyKey(t) {
    var i = $0c87694423bc4b01$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0c87694423bc4b01$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0c87694423bc4b01$var$selectFinalData(dataDefinedOnItem, dataDefinedOnChart) {
    /*
   * If a payload has data specified directly from the graphical item, prefer that.
   * Otherwise, fill in data from the chart level, using the same index.
   */ if (dataDefinedOnItem != null) return dataDefinedOnItem;
    return dataDefinedOnChart;
}
var $0c87694423bc4b01$export$e50d50655fe0e7ab = (tooltipPayloadConfigurations, activeIndex, chartDataState, tooltipAxisDataKey, activeLabel, tooltipPayloadSearcher, tooltipEventType)=>{
    if (activeIndex == null || tooltipPayloadSearcher == null) return undefined;
    var { chartData: chartData, computedData: computedData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = chartDataState;
    var init = [];
    return tooltipPayloadConfigurations.reduce((agg, _ref)=>{
        var _settings$dataKey;
        var { dataDefinedOnItem: dataDefinedOnItem, settings: settings } = _ref;
        var finalData = $0c87694423bc4b01$var$selectFinalData(dataDefinedOnItem, chartData);
        var sliced = Array.isArray(finalData) ? (0, $bd2b31f7ff5e821d$export$238176e5211cdc1a)(finalData, dataStartIndex, dataEndIndex) : finalData;
        var finalDataKey = (_settings$dataKey = settings === null || settings === void 0 ? void 0 : settings.dataKey) !== null && _settings$dataKey !== void 0 ? _settings$dataKey : tooltipAxisDataKey;
        // BaseAxisProps does not support nameKey but it could!
        var finalNameKey = settings === null || settings === void 0 ? void 0 : settings.nameKey; // ?? tooltipAxis?.nameKey;
        var tooltipPayload;
        if (tooltipAxisDataKey && Array.isArray(sliced) && /*
     * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
     * as tooltip payloads and findEntryInArray is not prepared to handle that.
     * Sad but also ScatterChart only allows 'item' tooltipEventType
     * and also this is only a problem if there are multiple Scatters and each has its own data array
     * so let's fix that some other time.
     */ !Array.isArray(sliced[0]) && /*
     * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
     * because thanks to allowDuplicatedCategory=false, the order of elements in the array
     * no longer matches the order of elements in the original data
     * and so we need to search by the active dataKey + label rather than by index.
     *
     * The same happens if multiple graphical items are present in the chart
     * and each of them has its own data array. Those arrays get concatenated
     * and again the tooltip index no longer matches the original data.
     *
     * On the other hand the tooltipEventType 'item' should always search by index
     * because we get the index from interacting over the individual elements
     * which is always accurate, irrespective of the allowDuplicatedCategory setting.
     */ tooltipEventType === 'axis') tooltipPayload = (0, $9d9ad0197f7e4c2b$export$66950d3869f5cc67)(sliced, tooltipAxisDataKey, activeLabel);
        else /*
       * This is a problem because it assumes that the index is pointing to the displayed data
       * which it isn't because the index is pointing to the tooltip ticks array.
       * The above approach (with findEntryInArray) is the correct one, but it only works
       * if the axis dataKey is defined explicitly, and if the data is an array of objects.
       */ tooltipPayload = tooltipPayloadSearcher(sliced, activeIndex, computedData, finalNameKey);
        if (Array.isArray(tooltipPayload)) tooltipPayload.forEach((item)=>{
            var newSettings = $0c87694423bc4b01$var$_objectSpread($0c87694423bc4b01$var$_objectSpread({}, settings), {}, {
                name: item.name,
                unit: item.unit,
                // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
                color: undefined,
                // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
                fill: undefined
            });
            agg.push((0, $09206e1485e62bdb$export$3c1b390368bb3561)({
                tooltipEntrySettings: newSettings,
                dataKey: item.dataKey,
                payload: item.payload,
                // @ts-expect-error getValueByDataKey does not validate the output type
                value: (0, $09206e1485e62bdb$export$f97fc4a450f29a)(item.payload, item.dataKey),
                name: item.name
            }));
        });
        else {
            var _getValueByDataKey;
            // I am not quite sure why these two branches (Array vs Array of Arrays) have to behave differently - I imagine we should unify these. 3.x breaking change?
            agg.push((0, $09206e1485e62bdb$export$3c1b390368bb3561)({
                tooltipEntrySettings: settings,
                dataKey: finalDataKey,
                payload: tooltipPayload,
                // @ts-expect-error getValueByDataKey does not validate the output type
                value: (0, $09206e1485e62bdb$export$f97fc4a450f29a)(tooltipPayload, finalDataKey),
                // @ts-expect-error getValueByDataKey does not validate the output type
                name: (_getValueByDataKey = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(tooltipPayload, finalNameKey)) !== null && _getValueByDataKey !== void 0 ? _getValueByDataKey : settings === null || settings === void 0 ? void 0 : settings.name
            }));
        }
        return agg;
    }, init);
};









var $1fec9e0b4d773a24$export$221021c57c593b2 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $40ff607ce3fff820$export$1c7798b82c8010cd),
    (0, $3eaa7bc41ed64724$export$3247769c9dbde559),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$bebec32544750591));
var $1fec9e0b4d773a24$export$4751149f4d54cbbf = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (state)=>state.graphicalItems.cartesianItems,
    (state)=>state.graphicalItems.polarItems
], (cartesianItems, polarItems)=>[
        ...cartesianItems,
        ...polarItems
    ]);
var $1fec9e0b4d773a24$var$selectTooltipAxisPredicate = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482),
    (0, $5c148cab1b5c3b61$export$eeffdb10daff095d)
], (0, $40ff607ce3fff820$export$a3923f321c6572c3));
var $1fec9e0b4d773a24$export$645965005f643e6f = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$4751149f4d54cbbf,
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$var$selectTooltipAxisPredicate
], (0, $40ff607ce3fff820$export$ad35679ce4582010), {
    memoizeOptions: {
        resultEqualityCheck: (0, $d44733464ce55990$export$dcc34c4213e7f4c)
    }
});
var $1fec9e0b4d773a24$var$selectAllStackedGraphicalItemsSettings = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $1bc52e873b283c40$export$2335dd91cc88053e)));
var $1fec9e0b4d773a24$export$b3f948fbed0299f1 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$645965005f643e6f
], (0, $40ff607ce3fff820$export$d945cee965d266f0), {
    memoizeOptions: {
        resultEqualityCheck: (0, $d44733464ce55990$export$dcc34c4213e7f4c)
    }
});
var $1fec9e0b4d773a24$export$5a8beccc8250d20e = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$b3f948fbed0299f1,
    (0, $695f2ef1b702f419$export$519edd692222520)
], (0, $40ff607ce3fff820$export$c2c6d012cffe2c75));
var $1fec9e0b4d773a24$var$selectTooltipStackedData = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectAllStackedGraphicalItemsSettings,
    (0, $695f2ef1b702f419$export$519edd692222520),
    (0, $40ff607ce3fff820$export$27d9004292294cd7)
], (0, $7729821c902de9dd$export$ae6c77e7720cddf9));
var $1fec9e0b4d773a24$var$selectAllTooltipAppliedValues = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$5a8beccc8250d20e,
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$export$645965005f643e6f
], (0, $40ff607ce3fff820$export$3051da2013ba9cfe));
var $1fec9e0b4d773a24$var$selectTooltipAxisDomainDefinition = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$27d9004292294cd7)
], (0, $40ff607ce3fff820$export$2e6262b6c952ab02));
var $1fec9e0b4d773a24$var$selectTooltipDataOverflow = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$27d9004292294cd7)
], (axisSettings)=>axisSettings.allowDataOverflow);
var $1fec9e0b4d773a24$var$selectTooltipDomainFromUserPreferences = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipAxisDomainDefinition,
    $1fec9e0b4d773a24$var$selectTooltipDataOverflow
], (0, $cbad8497179b0866$export$fcbf88d4627b24df));
var $1fec9e0b4d773a24$var$selectAllStackedGraphicalItems = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $1bc52e873b283c40$export$2335dd91cc88053e)));
var $1fec9e0b4d773a24$var$selectTooltipStackGroups = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipStackedData,
    $1fec9e0b4d773a24$var$selectAllStackedGraphicalItems,
    (0, $3eaa7bc41ed64724$export$73aff39176364def),
    (0, $3eaa7bc41ed64724$export$ec830dc49707c6da)
], (0, $40ff607ce3fff820$export$9312914d13496409));
var $1fec9e0b4d773a24$var$selectTooltipDomainOfStackGroups = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipStackGroups,
    (0, $695f2ef1b702f419$export$519edd692222520),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482),
    $1fec9e0b4d773a24$var$selectTooltipDomainFromUserPreferences
], (0, $40ff607ce3fff820$export$3286b8ea6ff06720));
var $1fec9e0b4d773a24$var$selectTooltipItemsSettingsExceptStacked = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$645965005f643e6f
], (0, $40ff607ce3fff820$export$a61da86823382adc));
var $1fec9e0b4d773a24$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$5a8beccc8250d20e,
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$var$selectTooltipItemsSettingsExceptStacked,
    (0, $40ff607ce3fff820$export$9429ab4550237b6d),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$df56c8e9a3e45e65), {
    memoizeOptions: {
        resultEqualityCheck: (0, $70a71c8202bf4e60$export$45c01007b107f1a6)
    }
});
var $1fec9e0b4d773a24$var$selectReferenceDotsByTooltipAxis = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$71580de5ed38161a),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482),
    (0, $5c148cab1b5c3b61$export$eeffdb10daff095d)
], (0, $40ff607ce3fff820$export$2829d12117d2002f));
var $1fec9e0b4d773a24$var$selectTooltipReferenceDotsDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectReferenceDotsByTooltipAxis,
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$5da0b79fd816ec4b));
var $1fec9e0b4d773a24$var$selectReferenceAreasByTooltipAxis = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$c7e152cb7f10c1a6),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482),
    (0, $5c148cab1b5c3b61$export$eeffdb10daff095d)
], (0, $40ff607ce3fff820$export$2829d12117d2002f));
var $1fec9e0b4d773a24$var$selectTooltipReferenceAreasDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectReferenceAreasByTooltipAxis,
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$7b27918cf5e1fc19));
var $1fec9e0b4d773a24$var$selectReferenceLinesByTooltipAxis = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$8fe2a49ce63c5348),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482),
    (0, $5c148cab1b5c3b61$export$eeffdb10daff095d)
], (0, $40ff607ce3fff820$export$2829d12117d2002f));
var $1fec9e0b4d773a24$var$selectTooltipReferenceLinesDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectReferenceLinesByTooltipAxis,
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$f1d17aebd11953eb));
var $1fec9e0b4d773a24$var$selectTooltipReferenceElementsDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipReferenceDotsDomain,
    $1fec9e0b4d773a24$var$selectTooltipReferenceLinesDomain,
    $1fec9e0b4d773a24$var$selectTooltipReferenceAreasDomain
], (0, $40ff607ce3fff820$export$9c8185c6eda0fb0d));
var $1fec9e0b4d773a24$var$selectTooltipNumericalDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$var$selectTooltipAxisDomainDefinition,
    $1fec9e0b4d773a24$var$selectTooltipDomainFromUserPreferences,
    $1fec9e0b4d773a24$var$selectTooltipDomainOfStackGroups,
    $1fec9e0b4d773a24$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $1fec9e0b4d773a24$var$selectTooltipReferenceElementsDomain,
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$b9eca0fd568f66a4));
var $1fec9e0b4d773a24$export$76f7a1975f60ccf1 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $1fec9e0b4d773a24$export$5a8beccc8250d20e,
    $1fec9e0b4d773a24$var$selectAllTooltipAppliedValues,
    (0, $3eaa7bc41ed64724$export$73aff39176364def),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482),
    $1fec9e0b4d773a24$var$selectTooltipNumericalDomain
], (0, $40ff607ce3fff820$export$70e6ef68424edf74));
var $1fec9e0b4d773a24$var$selectTooltipNiceTicks = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$76f7a1975f60ccf1,
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$export$221021c57c593b2
], (0, $40ff607ce3fff820$export$aa1ef6c8f610e48c));
var $1fec9e0b4d773a24$export$90be38154e4228b2 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$export$76f7a1975f60ccf1,
    $1fec9e0b4d773a24$var$selectTooltipNiceTicks,
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$3a4530026b1860ff));
var $1fec9e0b4d773a24$var$selectTooltipAxisRange = (state)=>{
    var axisType = (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)(state);
    var axisId = (0, $5c148cab1b5c3b61$export$eeffdb10daff095d)(state);
    var isPanorama = false; // Tooltip never displays in panorama so this is safe to assume
    return (0, $40ff607ce3fff820$export$3506ed461810cc8f)(state, axisType, axisId, isPanorama);
};
var $1fec9e0b4d773a24$export$cf4d6dfce3a76af3 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$var$selectTooltipAxisRange
], (0, $d20f3aee8b703dd2$export$3f7e30291950e694));
var $1fec9e0b4d773a24$export$cdeccbbdd343ae59 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$export$221021c57c593b2,
    $1fec9e0b4d773a24$export$90be38154e4228b2,
    $1fec9e0b4d773a24$export$cf4d6dfce3a76af3
], (0, $40ff607ce3fff820$export$e2fe61793fcf6495));
var $1fec9e0b4d773a24$var$selectTooltipDuplicateDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $1fec9e0b4d773a24$var$selectAllTooltipAppliedValues,
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$bb1ebf56a37bd899));
var $1fec9e0b4d773a24$export$f7665d13a99c934c = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $1fec9e0b4d773a24$var$selectAllTooltipAppliedValues,
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], (0, $40ff607ce3fff820$export$911ef47868c9ab07));
var $1fec9e0b4d773a24$var$combineTicksOfTooltipAxis = (layout, axis, realScaleType, scale, range, duplicateDomain, categoricalDomain, axisType)=>{
    if (!axis) return undefined;
    var { type: type } = axis;
    var isCategorical = (0, $09206e1485e62bdb$export$9fc1baaa6c6368b)(layout, axisType);
    if (!scale) return undefined;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range != null && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        }));
};
var $1fec9e0b4d773a24$export$ffe0e60f8c88c05a = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $40ff607ce3fff820$export$27d9004292294cd7),
    $1fec9e0b4d773a24$export$221021c57c593b2,
    $1fec9e0b4d773a24$export$cdeccbbdd343ae59,
    $1fec9e0b4d773a24$var$selectTooltipAxisRange,
    $1fec9e0b4d773a24$var$selectTooltipDuplicateDomain,
    $1fec9e0b4d773a24$export$f7665d13a99c934c,
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482)
], $1fec9e0b4d773a24$var$combineTicksOfTooltipAxis);
var $1fec9e0b4d773a24$var$selectTooltipEventType = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $c4309ff5980e62d8$export$877d2dd8db5f51fd),
    (0, $c4309ff5980e62d8$export$7f95a7e594fa7911),
    (0, $e27ab2d37e85c093$export$26d1e95fb7dea02)
], (defaultTooltipEventType, validateTooltipEventType, settings)=>(0, $c4309ff5980e62d8$export$d419a1f58b445a8f)(settings.shared, defaultTooltipEventType, validateTooltipEventType));
var $1fec9e0b4d773a24$var$selectTooltipTrigger = (state)=>state.tooltip.settings.trigger;
var $1fec9e0b4d773a24$var$selectDefaultIndex = (state)=>state.tooltip.settings.defaultIndex;
var $1fec9e0b4d773a24$var$selectTooltipInteractionState = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $a3236ed45f976f57$export$703b585bc92b5bae),
    $1fec9e0b4d773a24$var$selectTooltipEventType,
    $1fec9e0b4d773a24$var$selectTooltipTrigger,
    $1fec9e0b4d773a24$var$selectDefaultIndex
], (0, $9eb1abdae9a7bbd1$export$d759c39cacfacf6a));
var $1fec9e0b4d773a24$export$8b2762260f5891c9 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipInteractionState,
    $1fec9e0b4d773a24$export$5a8beccc8250d20e,
    (0, $40ff607ce3fff820$export$bf8397fefbaa3617),
    $1fec9e0b4d773a24$export$76f7a1975f60ccf1
], (0, $22214ebf87c016df$export$32df4b03a0962e46));
var $1fec9e0b4d773a24$export$400c35cc3b9a0487 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$ffe0e60f8c88c05a,
    $1fec9e0b4d773a24$export$8b2762260f5891c9
], (0, $e1872c677ee761c0$export$3213c4688ceb4c80));
var $1fec9e0b4d773a24$export$999f7a7ced063fab = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.dataKey;
});
var $1fec9e0b4d773a24$var$selectTooltipPayloadConfigurations = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $a3236ed45f976f57$export$703b585bc92b5bae),
    $1fec9e0b4d773a24$var$selectTooltipEventType,
    $1fec9e0b4d773a24$var$selectTooltipTrigger,
    $1fec9e0b4d773a24$var$selectDefaultIndex
], (0, $b035ad89395e7942$export$45044aaa79c0cddb));
var $1fec9e0b4d773a24$var$selectTooltipCoordinateForDefaultIndex = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $122c64eee523dc50$export$771ef0ac044f724d),
    (0, $122c64eee523dc50$export$5856a7d94c109505),
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    $1fec9e0b4d773a24$export$ffe0e60f8c88c05a,
    $1fec9e0b4d773a24$var$selectDefaultIndex,
    $1fec9e0b4d773a24$var$selectTooltipPayloadConfigurations,
    (0, $983b6625e071621a$export$6ae1ee94e6fa88a7)
], (0, $71f8d538d48a32e2$export$c2cbc37a7546bbd0));
var $1fec9e0b4d773a24$export$90c565a5b196e427 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipInteractionState,
    $1fec9e0b4d773a24$var$selectTooltipCoordinateForDefaultIndex
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    if (tooltipInteractionState !== null && tooltipInteractionState !== void 0 && tooltipInteractionState.coordinate) return tooltipInteractionState.coordinate;
    return defaultIndexCoordinate;
});
var $1fec9e0b4d773a24$export$c8884ed37796034a = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipInteractionState
], (tooltipInteractionState)=>tooltipInteractionState.active);
var $1fec9e0b4d773a24$export$a2bb5be6e87cbb86 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$var$selectTooltipPayloadConfigurations,
    $1fec9e0b4d773a24$export$8b2762260f5891c9,
    (0, $695f2ef1b702f419$export$519edd692222520),
    (0, $40ff607ce3fff820$export$bf8397fefbaa3617),
    $1fec9e0b4d773a24$export$400c35cc3b9a0487,
    (0, $983b6625e071621a$export$6ae1ee94e6fa88a7),
    $1fec9e0b4d773a24$var$selectTooltipEventType
], (0, $0c87694423bc4b01$export$e50d50655fe0e7ab));
var $1fec9e0b4d773a24$export$1a5b9bd341ad5f0e = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1fec9e0b4d773a24$export$a2bb5be6e87cbb86
], (payload)=>{
    if (payload == null) return undefined;
    var dataPoints = payload.map((p)=>p.payload).filter((p)=>p != null);
    return Array.from(new Set(dataPoints));
});




var $022361fa16087a62$export$623d7e312118b313 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b)
], (offsetInternal)=>{
    return {
        top: offsetInternal.top,
        bottom: offsetInternal.bottom,
        left: offsetInternal.left,
        right: offsetInternal.right
    };
});





var $cfa7f939aca371e2$export$8a921ed356911d9a = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $022361fa16087a62$export$623d7e312118b313),
    (0, $122c64eee523dc50$export$771ef0ac044f724d),
    (0, $122c64eee523dc50$export$5856a7d94c109505)
], (offset, chartWidth, chartHeight)=>{
    if (!offset || chartWidth == null || chartHeight == null) return undefined;
    return {
        x: offset.left,
        y: offset.top,
        width: Math.max(0, chartWidth - offset.left - offset.right),
        height: Math.max(0, chartHeight - offset.top - offset.bottom)
    };
});


var $c058c547db329017$export$5acf30f46eb8262f = (xAxisId)=>{
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    return (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama));
};
var $c058c547db329017$export$db526816f6980005 = (yAxisId)=>{
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    return (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama));
};
var $c058c547db329017$export$44023ffa3b5a8134 = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$400c35cc3b9a0487));
};
var $c058c547db329017$export$99e5207fa7e69f17 = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)((0, $022361fa16087a62$export$623d7e312118b313));
};
var $c058c547db329017$export$f1ef8efc9ef6fe0c = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)((0, $cfa7f939aca371e2$export$8a921ed356911d9a));
};
var $c058c547db329017$export$a5935a9f8709ac28 = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$1a5b9bd341ad5f0e));
};
var $c058c547db329017$export$fef606eda509da71 = function useXAxisDomain() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $9b2a3f99ebd40cd8$export$e43f7367e579f53d);
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    return (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$4fc5ecb5227dd744)(state, 'xAxis', xAxisId, isPanorama));
};
var $c058c547db329017$export$530156bda5a6e0b8 = function useYAxisDomain() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $9b2a3f99ebd40cd8$export$e43f7367e579f53d);
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    return (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$4fc5ecb5227dd744)(state, 'yAxis', yAxisId, isPanorama));
};


function $737883764e493ab4$export$79e142f66441c204(xAxisId, yAxisId) {
    var _xAxis$allowDataOverf, _yAxis$allowDataOverf;
    var xAxis = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$d6895d8ddb4cee5)(state, xAxisId));
    var yAxis = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$1f472705a332f1c9)(state, yAxisId));
    var needClipX = (_xAxis$allowDataOverf = xAxis === null || xAxis === void 0 ? void 0 : xAxis.allowDataOverflow) !== null && _xAxis$allowDataOverf !== void 0 ? _xAxis$allowDataOverf : (0, $40ff607ce3fff820$export$21aec091b6ac8422).allowDataOverflow;
    var needClipY = (_yAxis$allowDataOverf = yAxis === null || yAxis === void 0 ? void 0 : yAxis.allowDataOverflow) !== null && _yAxis$allowDataOverf !== void 0 ? _yAxis$allowDataOverf : (0, $40ff607ce3fff820$export$397148de2ecdec3c).allowDataOverflow;
    var needClip = needClipX || needClipY;
    return {
        needClip: needClip,
        needClipX: needClipX,
        needClipY: needClipY
    };
}
function $737883764e493ab4$export$d65f7a7dd82fbb63(_ref) {
    var { xAxisId: xAxisId, yAxisId: yAxisId, clipPathId: clipPathId } = _ref;
    var plotArea = (0, $c058c547db329017$export$f1ef8efc9ef6fe0c)();
    var { needClipX: needClipX, needClipY: needClipY, needClip: needClip } = $737883764e493ab4$export$79e142f66441c204(xAxisId, yAxisId);
    if (!needClip || !plotArea) return null;
    var { x: x, y: y, width: width, height: height } = plotArea;
    return /*#__PURE__*/ $aivMx.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
    }, /*#__PURE__*/ $aivMx.createElement("rect", {
        x: needClipX ? x : x - width / 2,
        y: needClipY ? y : y - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
    }));
}















function $649bf62937953d6b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $649bf62937953d6b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $649bf62937953d6b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $649bf62937953d6b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $649bf62937953d6b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $649bf62937953d6b$var$_defineProperty(e, r, t) {
    return (r = $649bf62937953d6b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $649bf62937953d6b$var$_toPropertyKey(t) {
    var i = $649bf62937953d6b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $649bf62937953d6b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $649bf62937953d6b$var$pickXAxisId = (_state, xAxisId)=>xAxisId;
var $649bf62937953d6b$var$pickYAxisId = (_state, _xAxisId, yAxisId)=>yAxisId;
var $649bf62937953d6b$var$pickIsPanorama = (_state, _xAxisId, _yAxisId, isPanorama)=>isPanorama;
var $649bf62937953d6b$var$pickBarId = (_state, _xAxisId, _yAxisId, _isPanorama, id)=>id;
var $649bf62937953d6b$var$selectSynchronisedBarSettings = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$f67c737adf41a3af),
    $649bf62937953d6b$var$pickBarId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'bar').find((item)=>item.id === id));
var $649bf62937953d6b$export$50baca3091205310 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $649bf62937953d6b$var$selectSynchronisedBarSettings
], (barSettings)=>barSettings === null || barSettings === void 0 ? void 0 : barSettings.maxBarSize);
var $649bf62937953d6b$var$pickCells = (_state, _xAxisId, _yAxisId, _isPanorama, _id, cells)=>cells;
var $649bf62937953d6b$var$getBarSize = (globalSize, totalSize, selfSize)=>{
    var barSize = selfSize !== null && selfSize !== void 0 ? selfSize : globalSize;
    if ((0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(barSize)) return undefined;
    return (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(barSize, totalSize, 0);
};
var $649bf62937953d6b$export$bf2e7c2f01f3feee = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $40ff607ce3fff820$export$f67c737adf41a3af),
    $649bf62937953d6b$var$pickXAxisId,
    $649bf62937953d6b$var$pickYAxisId,
    $649bf62937953d6b$var$pickIsPanorama
], (layout, allItems, xAxisId, yAxisId, isPanorama)=>allItems.filter((i)=>{
        if (layout === 'horizontal') return i.xAxisId === xAxisId;
        return i.yAxisId === yAxisId;
    }).filter((i)=>i.isPanorama === isPanorama).filter((i)=>i.hide === false).filter((i)=>i.type === 'bar'));
var $649bf62937953d6b$var$selectBarStackGroups = (state, xAxisId, yAxisId, isPanorama)=>{
    var layout = (0, $2d4a23e6670568d2$export$8426b6d9af801dee)(state);
    if (layout === 'horizontal') return (0, $40ff607ce3fff820$export$af2278e5e47fc440)(state, 'yAxis', yAxisId, isPanorama);
    return (0, $40ff607ce3fff820$export$af2278e5e47fc440)(state, 'xAxis', xAxisId, isPanorama);
};
var $649bf62937953d6b$export$d463f1583eab6c4c = (state, xAxisId, yAxisId)=>{
    var layout = (0, $2d4a23e6670568d2$export$8426b6d9af801dee)(state);
    if (layout === 'horizontal') return (0, $40ff607ce3fff820$export$6d6e642aa7a0ae10)(state, 'xAxis', xAxisId);
    return (0, $40ff607ce3fff820$export$6d6e642aa7a0ae10)(state, 'yAxis', yAxisId);
};
var $649bf62937953d6b$export$fa5aca2cbc42e692 = (allBars, globalSize, totalSize)=>{
    var initialValue = {};
    var stackedBars = allBars.filter((0, $1bc52e873b283c40$export$2335dd91cc88053e));
    var unstackedBars = allBars.filter((b)=>b.stackId == null);
    var groupByStack = stackedBars.reduce((acc, bar)=>{
        if (!acc[bar.stackId]) acc[bar.stackId] = [];
        acc[bar.stackId].push(bar);
        return acc;
    }, initialValue);
    var stackedSizeList = Object.entries(groupByStack).map((_ref)=>{
        var [stackId, bars] = _ref;
        var dataKeys = bars.map((b)=>b.dataKey);
        var barSize = $649bf62937953d6b$var$getBarSize(globalSize, totalSize, bars[0].barSize);
        return {
            stackId: stackId,
            dataKeys: dataKeys,
            barSize: barSize
        };
    });
    var unstackedSizeList = unstackedBars.map((b)=>{
        var dataKeys = [
            b.dataKey
        ].filter((dk)=>dk != null);
        var barSize = $649bf62937953d6b$var$getBarSize(globalSize, totalSize, b.barSize);
        return {
            stackId: undefined,
            dataKeys: dataKeys,
            barSize: barSize
        };
    });
    return [
        ...stackedSizeList,
        ...unstackedSizeList
    ];
};
var $649bf62937953d6b$export$2ef868bbad239fe0 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $649bf62937953d6b$export$bf2e7c2f01f3feee,
    (0, $3eaa7bc41ed64724$export$be00206a4a82272f),
    $649bf62937953d6b$export$d463f1583eab6c4c
], $649bf62937953d6b$export$fa5aca2cbc42e692);
var $649bf62937953d6b$export$32ce49801f050c73 = (state, xAxisId, yAxisId, isPanorama, id)=>{
    var _ref2, _getBandSizeOfAxis;
    var barSettings = $649bf62937953d6b$var$selectSynchronisedBarSettings(state, xAxisId, yAxisId, isPanorama, id);
    if (barSettings == null) return undefined;
    var layout = (0, $2d4a23e6670568d2$export$8426b6d9af801dee)(state);
    var globalMaxBarSize = (0, $3eaa7bc41ed64724$export$db43f3089e0ec1e9)(state);
    var { maxBarSize: childMaxBarSize } = barSettings;
    var maxBarSize = (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
    var axis, ticks;
    if (layout === 'horizontal') {
        axis = (0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
        ticks = (0, $40ff607ce3fff820$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
    } else {
        axis = (0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
        ticks = (0, $40ff607ce3fff820$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
    }
    return (_ref2 = (_getBandSizeOfAxis = (0, $09206e1485e62bdb$export$212ec45c42fe68a7)(axis, ticks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref2 !== void 0 ? _ref2 : 0;
};
var $649bf62937953d6b$export$bc27c715442861c7 = (state, xAxisId, yAxisId, isPanorama)=>{
    var layout = (0, $2d4a23e6670568d2$export$8426b6d9af801dee)(state);
    var axis, ticks;
    if (layout === 'horizontal') {
        axis = (0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
        ticks = (0, $40ff607ce3fff820$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
    } else {
        axis = (0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
        ticks = (0, $40ff607ce3fff820$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
    }
    return (0, $09206e1485e62bdb$export$212ec45c42fe68a7)(axis, ticks);
};
function $649bf62937953d6b$var$getBarPositions(barGap, barCategoryGap, bandSize, sizeList, maxBarSize) {
    var len = sizeList.length;
    if (len < 1) return undefined;
    var realBarGap = (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether is barSize set by user
    // Okay but why does it check only for the first element? What if the first element is set but others are not?
    if ((0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(sizeList[0].barSize)) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce((res, entry)=>res + (entry.barSize || 0), 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce((res, entry)=>{
            var _entry$barSize;
            var newPosition = {
                stackId: entry.stackId,
                dataKeys: entry.dataKeys,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    size: useFull ? fullBarSize : (_entry$barSize = entry.barSize) !== null && _entry$barSize !== void 0 ? _entry$barSize : 0
                }
            };
            var newRes = [
                ...res,
                newPosition
            ];
            prev = newRes[newRes.length - 1].position;
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = (0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(maxBarSize) ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce((res, entry, i)=>[
                ...res,
                {
                    stackId: entry.stackId,
                    dataKeys: entry.dataKeys,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ], initialValue);
    }
    return result;
}
var $649bf62937953d6b$export$5068ec6da13c95bb = (sizeList, globalMaxBarSize, barGap, barCategoryGap, barBandSize, bandSize, childMaxBarSize)=>{
    var maxBarSize = (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
    var allBarPositions = $649bf62937953d6b$var$getBarPositions(barGap, barCategoryGap, barBandSize !== bandSize ? barBandSize : bandSize, sizeList, maxBarSize);
    if (barBandSize !== bandSize && allBarPositions != null) allBarPositions = allBarPositions.map((pos)=>$649bf62937953d6b$var$_objectSpread($649bf62937953d6b$var$_objectSpread({}, pos), {}, {
            position: $649bf62937953d6b$var$_objectSpread($649bf62937953d6b$var$_objectSpread({}, pos.position), {}, {
                offset: pos.position.offset - barBandSize / 2
            })
        }));
    return allBarPositions;
};
var $649bf62937953d6b$export$d5f086f9524dc338 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $649bf62937953d6b$export$2ef868bbad239fe0,
    (0, $3eaa7bc41ed64724$export$db43f3089e0ec1e9),
    (0, $3eaa7bc41ed64724$export$9b8e3d53e72fb7a8),
    (0, $3eaa7bc41ed64724$export$a73f9d39b015942a),
    $649bf62937953d6b$export$32ce49801f050c73,
    $649bf62937953d6b$export$bc27c715442861c7,
    $649bf62937953d6b$export$50baca3091205310
], $649bf62937953d6b$export$5068ec6da13c95bb);
var $649bf62937953d6b$var$selectXAxisWithScale = (state, xAxisId, _yAxisId, isPanorama)=>(0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
var $649bf62937953d6b$var$selectYAxisWithScale = (state, _xAxisId, yAxisId, isPanorama)=>(0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
var $649bf62937953d6b$var$selectXAxisTicks = (state, xAxisId, _yAxisId, isPanorama)=>(0, $40ff607ce3fff820$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
var $649bf62937953d6b$var$selectYAxisTicks = (state, _xAxisId, yAxisId, isPanorama)=>(0, $40ff607ce3fff820$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
var $649bf62937953d6b$export$713ac88b203ac3be = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $649bf62937953d6b$export$d5f086f9524dc338,
    $649bf62937953d6b$var$selectSynchronisedBarSettings
], (allBarPositions, barSettings)=>{
    if (allBarPositions == null || barSettings == null) return undefined;
    var position = allBarPositions.find((p)=>p.stackId === barSettings.stackId && barSettings.dataKey != null && p.dataKeys.includes(barSettings.dataKey));
    if (position == null) return undefined;
    return position.position;
});
var $649bf62937953d6b$export$66625d959aa66f0f = (stackGroups, barSettings)=>{
    var stackSeriesIdentifier = (0, $4d697308b8e82e01$export$58b095b87bc46727)(barSettings);
    if (!stackGroups || stackSeriesIdentifier == null || barSettings == null) return undefined;
    var { stackId: stackId } = barSettings;
    if (stackId == null) return undefined;
    var stackGroup = stackGroups[stackId];
    if (!stackGroup) return undefined;
    var { stackedData: stackedData } = stackGroup;
    if (!stackedData) return undefined;
    return stackedData.find((sd)=>sd.key === stackSeriesIdentifier);
};
var $649bf62937953d6b$var$selectStackedDataOfItem = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $649bf62937953d6b$var$selectBarStackGroups,
    $649bf62937953d6b$var$selectSynchronisedBarSettings
], $649bf62937953d6b$export$66625d959aa66f0f);
var $649bf62937953d6b$export$bb89ca2d15dbced9 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    (0, $680da228e16ed19c$export$32c8e778bac69ce4),
    $649bf62937953d6b$var$selectXAxisWithScale,
    $649bf62937953d6b$var$selectYAxisWithScale,
    $649bf62937953d6b$var$selectXAxisTicks,
    $649bf62937953d6b$var$selectYAxisTicks,
    $649bf62937953d6b$export$713ac88b203ac3be,
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $695f2ef1b702f419$export$4953b85e13393616),
    $649bf62937953d6b$export$bc27c715442861c7,
    $649bf62937953d6b$var$selectStackedDataOfItem,
    $649bf62937953d6b$var$selectSynchronisedBarSettings,
    $649bf62937953d6b$var$pickCells
], (offset, axisViewBox, xAxis, yAxis, xAxisTicks, yAxisTicks, pos, layout, _ref3, bandSize, stackedData, barSettings, cells)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref3;
    if (barSettings == null || pos == null || axisViewBox == null || layout !== 'horizontal' && layout !== 'vertical' || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || bandSize == null) return undefined;
    var { data: data } = barSettings;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $6418e49322eed664$export$3b2ba7a38b022e)({
        layout: layout,
        barSettings: barSettings,
        pos: pos,
        parentViewBox: axisViewBox,
        bandSize: bandSize,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        stackedData: stackedData,
        displayedData: displayedData,
        offset: offset,
        cells: cells,
        dataStartIndex: dataStartIndex
    });
});






var $aivMx = parcelRequire("aivMx");




var $56Xh3 = parcelRequire("56Xh3");

/**
 * The properties inside this state update independently of each other and quite often.
 * When selecting, never select the whole state because you are going to get
 * unnecessary re-renders. Select only the properties you need.
 *
 * This is why this state type is not exported - don't use it directly.
 */ var $2dd5d2946f23160b$var$initialState = {
    settings: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'middle',
        itemSorter: 'value'
    },
    size: {
        width: 0,
        height: 0
    },
    payload: []
};
var $2dd5d2946f23160b$var$legendSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'legend',
    initialState: $2dd5d2946f23160b$var$initialState,
    reducers: {
        setLegendSize (state, action) {
            state.size.width = action.payload.width;
            state.size.height = action.payload.height;
        },
        setLegendSettings (state, action) {
            state.settings.align = action.payload.align;
            state.settings.layout = action.payload.layout;
            state.settings.verticalAlign = action.payload.verticalAlign;
            state.settings.itemSorter = action.payload.itemSorter;
        },
        addLegendPayload: {
            reducer (state, action) {
                state.payload.push((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        replaceLegendPayload: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $56Xh3.current)(state).payload.indexOf((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(prev));
                if (index > -1) state.payload[index] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        removeLegendPayload: {
            reducer (state, action) {
                var index = (0, $56Xh3.current)(state).payload.indexOf((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.payload.splice(index, 1);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        }
    }
});
var { setLegendSize: $2dd5d2946f23160b$export$f9ba9ab9b90c340e, setLegendSettings: $2dd5d2946f23160b$export$a1a647a9c0dcc839, addLegendPayload: $2dd5d2946f23160b$export$236fd33b6ffe3f4b, replaceLegendPayload: $2dd5d2946f23160b$export$379d42d798953c3d, removeLegendPayload: $2dd5d2946f23160b$export$337e5f2bb3b9e128 } = $2dd5d2946f23160b$var$legendSlice.actions;
var $2dd5d2946f23160b$export$8d8dfb8d5acf8179 = $2dd5d2946f23160b$var$legendSlice.reducer;


function $39eb3bad114e2a47$export$34b61b169492c008(_ref) {
    var { legendPayload: legendPayload } = _ref;
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var prevPayloadRef = (0, $aivMx.useRef)(null);
    (0, $aivMx.useLayoutEffect)(()=>{
        if (isPanorama) return;
        if (prevPayloadRef.current === null) dispatch((0, $2dd5d2946f23160b$export$236fd33b6ffe3f4b)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $2dd5d2946f23160b$export$379d42d798953c3d)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        isPanorama,
        legendPayload
    ]);
    (0, $aivMx.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $2dd5d2946f23160b$export$337e5f2bb3b9e128)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function $39eb3bad114e2a47$export$eb937fedea4aab3a(_ref2) {
    var { legendPayload: legendPayload } = _ref2;
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var layout = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $2d4a23e6670568d2$export$8426b6d9af801dee));
    var prevPayloadRef = (0, $aivMx.useRef)(null);
    (0, $aivMx.useLayoutEffect)(()=>{
        if (layout !== 'centric' && layout !== 'radial') return;
        if (prevPayloadRef.current === null) dispatch((0, $2dd5d2946f23160b$export$236fd33b6ffe3f4b)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $2dd5d2946f23160b$export$379d42d798953c3d)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        layout,
        legendPayload
    ]);
    (0, $aivMx.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $2dd5d2946f23160b$export$337e5f2bb3b9e128)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}






var $aivMx = parcelRequire("aivMx");


var $56Xh3 = parcelRequire("56Xh3");

/**
 * Unique ID of the graphical item.
 * This is used to identify the graphical item in the state and in the React tree.
 * This is required for every graphical item - it's either provided by the user or generated automatically.
 */ var $f2fc97b2a40d4484$var$initialState = {
    cartesianItems: [],
    polarItems: []
};
var $f2fc97b2a40d4484$var$graphicalItemsSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'graphicalItems',
    initialState: $f2fc97b2a40d4484$var$initialState,
    reducers: {
        addCartesianGraphicalItem: {
            reducer (state, action) {
                state.cartesianItems.push((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        replaceCartesianGraphicalItem: {
            reducer (state, action) {
                var { prev: prev, next: next } = action.payload;
                var index = (0, $56Xh3.current)(state).cartesianItems.indexOf((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(prev));
                if (index > -1) state.cartesianItems[index] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(next);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        removeCartesianGraphicalItem: {
            reducer (state, action) {
                var index = (0, $56Xh3.current)(state).cartesianItems.indexOf((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.cartesianItems.splice(index, 1);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        addPolarGraphicalItem: {
            reducer (state, action) {
                state.polarItems.push((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        },
        removePolarGraphicalItem: {
            reducer (state, action) {
                var index = (0, $56Xh3.current)(state).polarItems.indexOf((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
                if (index > -1) state.polarItems.splice(index, 1);
            },
            prepare: (0, $d60c7aefffed8a78$export$39fcd5145ec5e4e2)()
        }
    }
});
var { addCartesianGraphicalItem: $f2fc97b2a40d4484$export$3f947cc833f5129c, replaceCartesianGraphicalItem: $f2fc97b2a40d4484$export$5e4d82f2e2775795, removeCartesianGraphicalItem: $f2fc97b2a40d4484$export$cc47a48755a91e1a, addPolarGraphicalItem: $f2fc97b2a40d4484$export$468d47d44d0e088f, removePolarGraphicalItem: $f2fc97b2a40d4484$export$77442a5b47e92750 } = $f2fc97b2a40d4484$var$graphicalItemsSlice.actions;
var $f2fc97b2a40d4484$export$183eecd5cb7dbb38 = $f2fc97b2a40d4484$var$graphicalItemsSlice.reducer;


var $9b9188165a8d5ee0$var$SetCartesianGraphicalItemImpl = (props)=>{
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var prevPropsRef = (0, $aivMx.useRef)(null);
    (0, $aivMx.useLayoutEffect)(()=>{
        if (prevPropsRef.current === null) dispatch((0, $f2fc97b2a40d4484$export$3f947cc833f5129c)(props));
        else if (prevPropsRef.current !== props) dispatch((0, $f2fc97b2a40d4484$export$5e4d82f2e2775795)({
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        props
    ]);
    (0, $aivMx.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current) {
                dispatch((0, $f2fc97b2a40d4484$export$cc47a48755a91e1a)(prevPropsRef.current));
                /*
         * Here we have to reset the ref to null because in StrictMode, the effect will run twice,
         * but it will keep the same ref value from the first render.
         *
         * In browser, React will clear the ref after the first effect cleanup,
         * so that wouldn't be an issue.
         *
         * In StrictMode, however, the ref is kept,
         * and in the hook above the code checks for `prevPropsRef.current === null`
         * which would be false so it would not dispatch the `addCartesianGraphicalItem` action again.
         *
         * https://github.com/recharts/recharts/issues/6022
         */ prevPropsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
};
var $9b9188165a8d5ee0$export$b600bf9c1966a9c2 = /*#__PURE__*/ (0, $aivMx.memo)($9b9188165a8d5ee0$var$SetCartesianGraphicalItemImpl);
function $9b9188165a8d5ee0$export$8d7124402ca6b71c(props) {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useLayoutEffect)(()=>{
        dispatch((0, $f2fc97b2a40d4484$export$468d47d44d0e088f)(props));
        return ()=>{
            dispatch((0, $f2fc97b2a40d4484$export$77442a5b47e92750)(props));
        };
    }, [
        dispatch,
        props
    ]);
    return null;
}







function $1a5565785c86a091$export$384f306fbc0d3ce9(input, defaultZIndex) {
    if (input && typeof input === 'object' && 'zIndex' in input && typeof input.zIndex === 'number' && (0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(input.zIndex)) return input.zIndex;
    return defaultZIndex;
}



var $7fd62a4f2791f570$var$propsToShallowCompare = new Set([
    'axisLine',
    'tickLine',
    'activeBar',
    'activeDot',
    'activeLabel',
    'activeShape',
    'allowEscapeViewBox',
    'background',
    'cursor',
    'dot',
    'label',
    'line',
    'margin',
    'padding',
    'position',
    'shape',
    'style',
    'tick',
    'wrapperStyle'
]);
/**
 * When comparing two values, returns true if they are the same value or
 * are both NaN.
 *
 * If we used just a simple triple equals, we would get false negatives for two NaNs
 * which could cause extra re-renders so let's have this instead.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Equality_comparisons_and_sameness#same-value-zero_equality
 *
 * @param x first value to compare
 * @param y second value to compare
 * return true if the same, false if different
 */ function $7fd62a4f2791f570$var$sameValueZero(x, y) {
    if (x == null && y == null) /*
     * treat null and undefined as equal. Internally in Recharts we make no difference between these two
     * so there is no need to re-render.
     */ return true;
    if (typeof x === 'number' && typeof y === 'number') // x and y are equal (this is true for -0 and 0) or they are both NaN
    // eslint-disable-next-line no-self-compare
    return x === y || x !== x && y !== y;
    return x === y;
}
function $7fd62a4f2791f570$export$b8f09df787c278d9(prevProps, nextProps) {
    var allKeys = new Set([
        ...Object.keys(prevProps),
        ...Object.keys(nextProps)
    ]);
    for (var key of allKeys){
        /*
     * If a key is on a special allowlist, go one level deeper
     * and do a shallow comparison of the values.
     */ if ($7fd62a4f2791f570$var$propsToShallowCompare.has(key)) {
            if (prevProps[key] == null && nextProps[key] == null) continue;
            if (!(0, $b1dd956634aa1b08$export$2e2bcd8739ae039)(prevProps[key], nextProps[key])) return false;
        /*
       * Otherwise do a simple same-value comparison (with NaN support).
       */ } else if (!$7fd62a4f2791f570$var$sameValueZero(prevProps[key], nextProps[key])) return false;
    }
    return true;
}


var $6418e49322eed664$var$_excluded = [
    "onMouseEnter",
    "onMouseLeave",
    "onClick"
], $6418e49322eed664$var$_excluded2 = [
    "value",
    "background",
    "tooltipPosition"
], $6418e49322eed664$var$_excluded3 = [
    "id"
], $6418e49322eed664$var$_excluded4 = [
    "onMouseEnter",
    "onClick",
    "onMouseLeave"
];
function $6418e49322eed664$var$_extends() {
    return $6418e49322eed664$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6418e49322eed664$var$_extends.apply(null, arguments);
}
function $6418e49322eed664$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6418e49322eed664$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6418e49322eed664$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6418e49322eed664$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6418e49322eed664$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6418e49322eed664$var$_defineProperty(e, r, t) {
    return (r = $6418e49322eed664$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6418e49322eed664$var$_toPropertyKey(t) {
    var i = $6418e49322eed664$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6418e49322eed664$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6418e49322eed664$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6418e49322eed664$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $6418e49322eed664$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6418e49322eed664$var$computeLegendPayloadFromBarData = (props)=>{
    var { dataKey: dataKey, name: name, fill: fill, legendType: legendType, hide: hide } = props;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: fill,
            value: (0, $09206e1485e62bdb$export$d3207de44081d2b3)(name, dataKey),
            payload: props
        }
    ];
};
var $6418e49322eed664$var$SetBarTooltipEntrySettings = /*#__PURE__*/ $aivMx.memo((_ref)=>{
    var { dataKey: dataKey, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, unit: unit, tooltipType: tooltipType } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: undefined,
        positions: undefined,
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $09206e1485e62bdb$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: fill,
            unit: unit
        }
    };
    return /*#__PURE__*/ $aivMx.createElement((0, $8a16f0191d982cde$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
function $6418e49322eed664$var$BarBackground(props) {
    var activeIndex = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$8b2762260f5891c9));
    var { data: data, dataKey: dataKey, background: backgroundFromProps, allOtherBarProps: allOtherBarProps } = props;
    var { onMouseEnter: onMouseEnterFromProps, onMouseLeave: onMouseLeaveFromProps, onClick: onItemClickFromProps } = allOtherBarProps, restOfAllOtherProps = $6418e49322eed664$var$_objectWithoutProperties(allOtherBarProps, $6418e49322eed664$var$_excluded);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onMouseEnterFromContext = (0, $43b9d3dd582657fd$export$6162f642d41f88ea)(onMouseEnterFromProps, dataKey);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onMouseLeaveFromContext = (0, $43b9d3dd582657fd$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onClickFromContext = (0, $43b9d3dd582657fd$export$c9154937ad8393fc)(onItemClickFromProps, dataKey);
    if (!backgroundFromProps || data == null) return null;
    var backgroundProps = (0, $bf74bd062767a6f3$export$6d5921c09aa671a9)(backgroundFromProps);
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: (0, $1a5565785c86a091$export$384f306fbc0d3ce9)(backgroundFromProps, (0, $5ad557dd967fc64c$export$96df16b28aa32702).barBackground)
    }, data.map((entry, i)=>{
        var { value: value, background: backgroundFromDataEntry, tooltipPosition: tooltipPosition } = entry, rest = $6418e49322eed664$var$_objectWithoutProperties(entry, $6418e49322eed664$var$_excluded2);
        if (!backgroundFromDataEntry) return null;
        // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
        var onMouseEnter = onMouseEnterFromContext(entry, i);
        // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
        var onMouseLeave = onMouseLeaveFromContext(entry, i);
        // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
        var onClick = onClickFromContext(entry, i);
        var barRectangleProps = $6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread({
            option: backgroundFromProps,
            isActive: String(i) === activeIndex
        }, rest), {}, {
            // @ts-expect-error backgroundProps is contributing unknown props
            fill: '#eee'
        }, backgroundFromDataEntry), backgroundProps), (0, $1ea0ac8e1739d80a$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i)), {}, {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            dataKey: dataKey,
            index: i,
            className: 'recharts-bar-background-rectangle'
        });
        return /*#__PURE__*/ $aivMx.createElement((0, $144e54756b5729a1$export$f19074a6842f9217), $6418e49322eed664$var$_extends({
            key: "background-bar-".concat(i)
        }, barRectangleProps));
    }));
}
function $6418e49322eed664$var$BarLabelListProvider(_ref2) {
    var { showLabels: showLabels, children: children, rects: rects } = _ref2;
    var labelListEntries = rects === null || rects === void 0 ? void 0 : rects.map((entry)=>{
        var viewBox = {
            x: entry.x,
            y: entry.y,
            width: entry.width,
            lowerWidth: entry.width,
            upperWidth: entry.width,
            height: entry.height
        };
        return $6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread({}, viewBox), {}, {
            value: entry.value,
            payload: entry.payload,
            parentViewBox: entry.parentViewBox,
            viewBox: viewBox,
            fill: entry.fill
        });
    });
    return /*#__PURE__*/ $aivMx.createElement((0, $bdc309bb5887af46$export$64e384eac5db53f7), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $6418e49322eed664$var$BarRectangleWithActiveState(props) {
    var { shape: shape, activeBar: activeBar, baseProps: baseProps, entry: entry, index: index, dataKey: dataKey } = props;
    var activeIndex = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$8b2762260f5891c9));
    var activeDataKey = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$999f7a7ced063fab));
    /*
   * Bars support stacking, meaning that there can be multiple bars at the same x value.
   * With Tooltip shared=false we only want to highlight the currently active Bar, not all.
   *
   * Also, if the tooltip is shared, we want to highlight all bars at the same x value
   * regardless of the dataKey.
   *
   * With shared Tooltip, the activeDataKey is undefined.
   */ var isActive = activeBar && String(index) === activeIndex && (activeDataKey == null || dataKey === activeDataKey);
    var option = isActive ? activeBar : shape;
    if (isActive) return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).activeBar
    }, /*#__PURE__*/ $aivMx.createElement((0, $144e54756b5729a1$export$f19074a6842f9217), $6418e49322eed664$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: isActive,
        option: option,
        index: index,
        dataKey: dataKey
    })));
    return /*#__PURE__*/ $aivMx.createElement((0, $144e54756b5729a1$export$f19074a6842f9217), $6418e49322eed664$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: isActive,
        option: option,
        index: index,
        dataKey: dataKey
    }));
}
function $6418e49322eed664$var$BarRectangleNeverActive(props) {
    var { shape: shape, baseProps: baseProps, entry: entry, index: index, dataKey: dataKey } = props;
    return /*#__PURE__*/ $aivMx.createElement((0, $144e54756b5729a1$export$f19074a6842f9217), $6418e49322eed664$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: false,
        option: shape,
        index: index,
        dataKey: dataKey
    }));
}
function $6418e49322eed664$var$BarRectangles(_ref3) {
    var _svgPropertiesNoEvent;
    var { data: data, props: props } = _ref3;
    var _ref4 = (_svgPropertiesNoEvent = (0, $bf74bd062767a6f3$export$8b56257912140094)(props)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, { id: id } = _ref4, baseProps = $6418e49322eed664$var$_objectWithoutProperties(_ref4, $6418e49322eed664$var$_excluded3);
    var { shape: shape, dataKey: dataKey, activeBar: activeBar } = props;
    var { onMouseEnter: onMouseEnterFromProps, onClick: onItemClickFromProps, onMouseLeave: onMouseLeaveFromProps } = props, restOfAllOtherProps = $6418e49322eed664$var$_objectWithoutProperties(props, $6418e49322eed664$var$_excluded4);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onMouseEnterFromContext = (0, $43b9d3dd582657fd$export$6162f642d41f88ea)(onMouseEnterFromProps, dataKey);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onMouseLeaveFromContext = (0, $43b9d3dd582657fd$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    // @ts-expect-error bar mouse events are not compatible with recharts mouse events
    var onClickFromContext = (0, $43b9d3dd582657fd$export$c9154937ad8393fc)(onItemClickFromProps, dataKey);
    if (!data) return null;
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, data.map((entry, i)=>{
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), $6418e49322eed664$var$_extends({
            key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i),
            className: "recharts-bar-rectangle"
        }, (0, $1ea0ac8e1739d80a$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i), {
            // @ts-expect-error BarRectangleItem type definition says it's missing properties, but I can see them present in debugger!
            onMouseEnter: onMouseEnterFromContext(entry, i),
            onMouseLeave: onMouseLeaveFromContext(entry, i),
            onClick: onClickFromContext(entry, i)
        }), activeBar ? /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$BarRectangleWithActiveState, {
            shape: shape,
            activeBar: activeBar,
            baseProps: baseProps,
            entry: entry,
            index: i,
            dataKey: dataKey
        }) : /*#__PURE__*/ /*
     * If the `activeBar` prop is falsy, then let's call the variant without hooks.
     * Using the `selectActiveTooltipIndex` selector is usually fast
     * but in charts with large-ish amount of data even the few nanoseconds add up to a noticeable jank.
     * If the activeBar is false then we don't need to know which index is active - because we won't use it anyway.
     * So let's just skip the hooks altogether. That way, React can skip rendering the component,
     * and can skip the tree reconciliation for its children too.
     * Because we can't call hooks conditionally, we need to have a separate component for that.
     */ $aivMx.createElement($6418e49322eed664$var$BarRectangleNeverActive, {
            shape: shape,
            baseProps: baseProps,
            entry: entry,
            index: i,
            dataKey: dataKey
        }));
    }));
}
function $6418e49322eed664$var$RectanglesWithAnimation(_ref5) {
    var { props: props, previousRectanglesRef: previousRectanglesRef } = _ref5;
    var { data: data, layout: layout, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart } = props;
    var prevData = previousRectanglesRef.current;
    var animationId = (0, $85b2a51d25cd2e70$export$e1042b2944b80b7f)(props, 'recharts-bar-');
    var [isAnimating, setIsAnimating] = (0, $aivMx.useState)(false);
    var showLabels = !isAnimating;
    var handleAnimationEnd = (0, $aivMx.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $aivMx.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    return /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$BarLabelListProvider, {
        showLabels: showLabels,
        rects: data
    }, /*#__PURE__*/ $aivMx.createElement((0, $6e14365e65dd4f13$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: handleAnimationEnd,
        onAnimationStart: handleAnimationStart,
        key: animationId
    }, (t)=>{
        var stepData = t === 1 ? data : data === null || data === void 0 ? void 0 : data.map((entry, index)=>{
            var prev = prevData && prevData[index];
            if (prev) return $6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread({}, entry), {}, {
                x: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                y: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.y, entry.y, t),
                width: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.width, entry.width, t),
                height: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.height, entry.height, t)
            });
            if (layout === 'horizontal') {
                var height = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(0, entry.height, t);
                var y = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(entry.stackedBarStart, entry.y, t);
                return $6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread({}, entry), {}, {
                    y: y,
                    height: height
                });
            }
            var w = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(0, entry.width, t);
            var x = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(entry.stackedBarStart, entry.x, t);
            return $6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread({}, entry), {}, {
                width: w,
                x: x
            });
        });
        if (t > 0) // eslint-disable-next-line no-param-reassign
        previousRectanglesRef.current = stepData !== null && stepData !== void 0 ? stepData : null;
        if (stepData == null) return null;
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), null, /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$BarRectangles, {
            props: props,
            data: stepData
        }));
    }), /*#__PURE__*/ $aivMx.createElement((0, $bdc309bb5887af46$export$9a402bc8de2b410e), {
        label: props.label
    }), props.children);
}
function $6418e49322eed664$var$RenderRectangles(props) {
    var previousRectanglesRef = (0, $aivMx.useRef)(null);
    return /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$RectanglesWithAnimation, {
        previousRectanglesRef: previousRectanglesRef,
        props: props
    });
}
var $6418e49322eed664$var$defaultMinPointSize = 0;
var $6418e49322eed664$var$errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    /**
   * if the value coming from `selectBarRectangles` is an array then this is a stacked bar chart.
   * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
   * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
    return {
        x: dataPoint.x,
        y: dataPoint.y,
        value: value,
        // @ts-expect-error getValueByDataKey does not validate the output type
        errorVal: (0, $09206e1485e62bdb$export$f97fc4a450f29a)(dataPoint, dataKey)
    };
};
class $6418e49322eed664$var$BarWithState extends (0, $aivMx.PureComponent) {
    render() {
        var { hide: hide, data: data, dataKey: dataKey, className: className, xAxisId: xAxisId, yAxisId: yAxisId, needClip: needClip, background: background, id: id } = this.props;
        if (hide || data == null) return null;
        var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-bar', className);
        var clipPathId = id;
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
            className: layerClass,
            id: id
        }, needClip && /*#__PURE__*/ $aivMx.createElement("defs", null, /*#__PURE__*/ $aivMx.createElement((0, $737883764e493ab4$export$d65f7a7dd82fbb63), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        })), /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
            className: "recharts-bar-rectangles",
            clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined
        }, /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$BarBackground, {
            data: data,
            dataKey: dataKey,
            background: background,
            allOtherBarProps: this.props
        }), /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$RenderRectangles, this.props)));
    }
}
var $6418e49322eed664$export$ae0fe71c3c345c68 = {
    activeBar: false,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease',
    background: false,
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'rect',
    minPointSize: $6418e49322eed664$var$defaultMinPointSize,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).bar
};
function $6418e49322eed664$var$BarImpl(props) {
    var { xAxisId: xAxisId, yAxisId: yAxisId, hide: hide, legendType: legendType, minPointSize: minPointSize, activeBar: activeBar, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, isAnimationActive: isAnimationActive } = props;
    var { needClip: needClip } = (0, $737883764e493ab4$export$79e142f66441c204)(xAxisId, yAxisId);
    var layout = (0, $2d4a23e6670568d2$export$970c79ecc7081cc)();
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var cells = (0, $a703e7e67d5286d1$export$fdd5e64c0e8495bb)(props.children, (0, $66258e37252e74df$export$f6f0c3fe4ec306ea));
    var rects = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $649bf62937953d6b$export$bb89ca2d15dbced9)(state, xAxisId, yAxisId, isPanorama, props.id, cells));
    if (layout !== 'vertical' && layout !== 'horizontal') return null;
    var errorBarOffset;
    var firstDataPoint = rects === null || rects === void 0 ? void 0 : rects[0];
    if (firstDataPoint == null || firstDataPoint.height == null || firstDataPoint.width == null) errorBarOffset = 0;
    else errorBarOffset = layout === 'vertical' ? firstDataPoint.height / 2 : firstDataPoint.width / 2;
    return /*#__PURE__*/ $aivMx.createElement((0, $969a432a307941ac$export$fcd6ba6fb4bc66e7), {
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        data: rects,
        dataPointFormatter: $6418e49322eed664$var$errorBarDataPointFormatter,
        errorBarOffset: errorBarOffset
    }, /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$BarWithState, $6418e49322eed664$var$_extends({}, props, {
        layout: layout,
        needClip: needClip,
        data: rects,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        hide: hide,
        legendType: legendType,
        minPointSize: minPointSize,
        activeBar: activeBar,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive
    })));
}
function $6418e49322eed664$export$3b2ba7a38b022e(_ref6) {
    var { layout: layout, barSettings: { dataKey: dataKey, minPointSize: minPointSizeProp }, pos: pos, bandSize: bandSize, xAxis: xAxis, yAxis: yAxis, xAxisTicks: xAxisTicks, yAxisTicks: yAxisTicks, stackedData: stackedData, displayedData: displayedData, offset: offset, cells: cells, parentViewBox: parentViewBox, dataStartIndex: dataStartIndex } = _ref6;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    // @ts-expect-error this assumes that the domain is always numeric, but doesn't check for it
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $09206e1485e62bdb$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var stackedBarStart = numericAxis.scale(baseValue);
    return displayedData.map((entry, index)=>{
        var value, x, y, width, height, background;
        if (stackedData) // Use dataStartIndex to access the correct element in the full stackedData array
        value = (0, $09206e1485e62bdb$export$c7ec0fa96d0c462e)(stackedData[index + dataStartIndex], stackedDomain);
        else {
            value = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $144e54756b5729a1$export$c20d73790de171f0)(minPointSizeProp, $6418e49322eed664$var$defaultMinPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref7;
            var [baseValueScale, currentValueScale] = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ];
            x = (0, $09206e1485e62bdb$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref7 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref7 !== void 0 ? _ref7 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = (0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: offset.top,
                width: width,
                height: offset.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var [_baseValueScale, _currentValueScale] = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ];
            x = _baseValueScale;
            y = (0, $09206e1485e62bdb$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: offset.left,
                y: y,
                width: offset.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        if (x == null || y == null || width == null || height == null) return null;
        var barRectangleItem = $6418e49322eed664$var$_objectSpread($6418e49322eed664$var$_objectSpread({}, entry), {}, {
            stackedBarStart: stackedBarStart,
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background,
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            },
            parentViewBox: parentViewBox
        }, cells && cells[index] && cells[index].props);
        return barRectangleItem;
    }).filter(Boolean);
}
function $6418e49322eed664$var$BarFn(outsideProps) {
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $6418e49322eed664$export$ae0fe71c3c345c68);
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    // Report all props to Redux store first, before calling any hooks, to avoid circular dependencies.
    return /*#__PURE__*/ $aivMx.createElement((0, $5cc9e31d9b078aed$export$8c2f307ff93f02ba), {
        id: props.id,
        type: "bar"
    }, (id)=>/*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement((0, $39eb3bad114e2a47$export$34b61b169492c008), {
            legendPayload: $6418e49322eed664$var$computeLegendPayloadFromBarData(props)
        }), /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$SetBarTooltipEntrySettings, {
            dataKey: props.dataKey,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            tooltipType: props.tooltipType
        }), /*#__PURE__*/ $aivMx.createElement((0, $9b9188165a8d5ee0$export$b600bf9c1966a9c2), {
            type: "bar",
            id: id,
            data: undefined,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            stackId: (0, $09206e1485e62bdb$export$f0871da41ca7fc82)(props.stackId),
            hide: props.hide,
            barSize: props.barSize,
            minPointSize: props.minPointSize,
            maxBarSize: props.maxBarSize,
            isPanorama: isPanorama
        }), /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
            zIndex: props.zIndex
        }, /*#__PURE__*/ $aivMx.createElement($6418e49322eed664$var$BarImpl, $6418e49322eed664$var$_extends({}, props, {
            id: id
        })))));
}
var $6418e49322eed664$export$bbc6c6369b38e3d1 = /*#__PURE__*/ $aivMx.memo($6418e49322eed664$var$BarFn, (0, $7fd62a4f2791f570$export$b8f09df787c278d9));
$6418e49322eed664$export$bbc6c6369b38e3d1.displayName = 'Bar';


var $aivMx = parcelRequire("aivMx");


function $9a03b151feb18982$export$3d996ff386c7802d(data, strIndex) {
    if (!strIndex) return undefined;
    var numIndex = Number.parseInt(strIndex, 10);
    if ((0, $9d9ad0197f7e4c2b$export$e426a261f3212d7d)(numIndex)) return undefined;
    return data === null || data === void 0 ? void 0 : data[numIndex];
}
var $9a03b151feb18982$var$initialState = {
    chartName: '',
    tooltipPayloadSearcher: undefined,
    eventEmitter: undefined,
    defaultTooltipEventType: 'axis'
};
var $9a03b151feb18982$var$optionsSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'options',
    initialState: $9a03b151feb18982$var$initialState,
    reducers: {
        createEventEmitter: (state)=>{
            if (state.eventEmitter == null) state.eventEmitter = Symbol('rechartsEventEmitter');
        }
    }
});
var $9a03b151feb18982$export$81a3ba457dd82bec = $9a03b151feb18982$var$optionsSlice.reducer;
var { createEventEmitter: $9a03b151feb18982$export$abfecd6a8e6070c1 } = $9a03b151feb18982$var$optionsSlice.actions;



var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");





var $a3ac5576ba06edce$export$7285b50bc333b067 = {
    chartData: undefined,
    computedData: undefined,
    dataStartIndex: 0,
    dataEndIndex: 0
};
var $a3ac5576ba06edce$var$chartDataSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'chartData',
    initialState: $a3ac5576ba06edce$export$7285b50bc333b067,
    reducers: {
        setChartData (state, action) {
            state.chartData = action.payload;
            if (action.payload == null) {
                state.dataStartIndex = 0;
                state.dataEndIndex = 0;
                return;
            }
            if (action.payload.length > 0 && state.dataEndIndex !== action.payload.length - 1) state.dataEndIndex = action.payload.length - 1;
        },
        setComputedData (state, action) {
            state.computedData = action.payload;
        },
        setDataStartEndIndexes (state, action) {
            var { startIndex: startIndex, endIndex: endIndex } = action.payload;
            if (startIndex != null) state.dataStartIndex = startIndex;
            if (endIndex != null) state.dataEndIndex = endIndex;
        }
    }
});
var { setChartData: $a3ac5576ba06edce$export$624c47d88733f253, setDataStartEndIndexes: $a3ac5576ba06edce$export$427d605cc4e3bbdd, setComputedData: $a3ac5576ba06edce$export$9b2e7f4962514250 } = $a3ac5576ba06edce$var$chartDataSlice.actions;
var $a3ac5576ba06edce$export$52973ca5fce0a5d5 = $a3ac5576ba06edce$var$chartDataSlice.reducer;






























function $9d6f2373a9d0ba42$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d6f2373a9d0ba42$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d6f2373a9d0ba42$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9d6f2373a9d0ba42$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d6f2373a9d0ba42$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9d6f2373a9d0ba42$var$_defineProperty(e, r, t) {
    return (r = $9d6f2373a9d0ba42$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9d6f2373a9d0ba42$var$_toPropertyKey(t) {
    var i = $9d6f2373a9d0ba42$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9d6f2373a9d0ba42$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9d6f2373a9d0ba42$export$cfad5721ad1fe55 = (layout, tooltipTicks, activeIndex, pointer)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: pointer.chartY
        };
        if (layout === 'vertical') return {
            x: pointer.chartX,
            y: entry.coordinate
        };
    }
    return {
        x: 0,
        y: 0
    };
};
var $9d6f2373a9d0ba42$export$6bc723868198544 = (layout, tooltipTicks, activeIndex, rangeObj)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var { radius: _radius } = rangeObj;
            return $9d6f2373a9d0ba42$var$_objectSpread($9d6f2373a9d0ba42$var$_objectSpread($9d6f2373a9d0ba42$var$_objectSpread({}, rangeObj), (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var { angle: angle } = rangeObj;
        return $9d6f2373a9d0ba42$var$_objectSpread($9d6f2373a9d0ba42$var$_objectSpread($9d6f2373a9d0ba42$var$_objectSpread({}, rangeObj), (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return {
        angle: 0,
        clockWise: false,
        cx: 0,
        cy: 0,
        endAngle: 0,
        innerRadius: 0,
        outerRadius: 0,
        radius: 0,
        startAngle: 0,
        x: 0,
        y: 0
    };
};
function $9d6f2373a9d0ba42$export$215f974420919247(pointer, offset) {
    var { chartX: x, chartY: y } = pointer;
    return x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
}
var $9d6f2373a9d0ba42$export$3071d39cc844078e = (coordinate, ticks, unsortedTicks, axisType, range)=>{
    var _ticks$length;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or fewer ticks or if there is no coordinate then the active tick is at index 0
    if (len <= 1 || coordinate == null) return 0;
    if (axisType === 'angleAxis' && range != null && Math.abs(Math.abs(range[1] - range[0]) - 360) <= 1e-6) // ticks are distributed in a circle
    for(var i = 0; i < len; i++){
        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
        var cur = unsortedTicks[i].coordinate;
        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
        var sameDirectionCoord = void 0;
        if ((0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(cur - before) !== (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(after - cur)) {
            var diffInterval = [];
            if ((0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(after - cur) === (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(range[1] - range[0])) {
                sameDirectionCoord = after;
                var curInRange = cur + range[1] - range[0];
                diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
            } else {
                sameDirectionCoord = before;
                var afterInRange = after + range[1] - range[0];
                diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
            }
            var sameInterval = [
                Math.min(cur, (sameDirectionCoord + cur) / 2),
                Math.max(cur, (sameDirectionCoord + cur) / 2)
            ];
            if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                ({ index: index } = unsortedTicks[i]);
                break;
            }
        } else {
            var minValue = Math.min(before, after);
            var maxValue = Math.max(before, after);
            if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                ({ index: index } = unsortedTicks[i]);
                break;
            }
        }
    }
    else if (ticks) {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            ({ index: index } = ticks[_i]);
            break;
        }
    }
    return index;
};



var $0d9ada87ae089576$export$ed30b3372172c46c = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$3247769c9dbde559));
};
var $0d9ada87ae089576$var$pickTooltipEventType = (_state, tooltipEventType)=>tooltipEventType;
var $0d9ada87ae089576$var$pickTrigger = (_state, _tooltipEventType, trigger)=>trigger;
var $0d9ada87ae089576$var$pickDefaultIndex = (_state, _tooltipEventType, _trigger, defaultIndex)=>defaultIndex;
var $0d9ada87ae089576$export$e133bec3c93a9247 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)((0, $1fec9e0b4d773a24$export$ffe0e60f8c88c05a), (ticks)=>(0, (/*@__PURE__*/$parcel$interopDefault($63d55c965c0eca64$exports)))(ticks, (o)=>o.coordinate));
var $0d9ada87ae089576$export$1288ff5c64c4ac42 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $a3236ed45f976f57$export$703b585bc92b5bae),
    $0d9ada87ae089576$var$pickTooltipEventType,
    $0d9ada87ae089576$var$pickTrigger,
    $0d9ada87ae089576$var$pickDefaultIndex
], (0, $9eb1abdae9a7bbd1$export$d759c39cacfacf6a));
var $0d9ada87ae089576$export$95fb15d7bb7a8a94 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $0d9ada87ae089576$export$1288ff5c64c4ac42,
    (0, $1fec9e0b4d773a24$export$5a8beccc8250d20e),
    (0, $40ff607ce3fff820$export$bf8397fefbaa3617),
    (0, $1fec9e0b4d773a24$export$76f7a1975f60ccf1)
], (0, $22214ebf87c016df$export$32df4b03a0962e46));
var $0d9ada87ae089576$export$faa2b8b92235e5bd = (state, tooltipEventType, trigger)=>{
    if (tooltipEventType == null) return undefined;
    var tooltipState = (0, $a3236ed45f976f57$export$703b585bc92b5bae)(state);
    if (tooltipEventType === 'axis') {
        if (trigger === 'hover') return tooltipState.axisInteraction.hover.dataKey;
        return tooltipState.axisInteraction.click.dataKey;
    }
    if (trigger === 'hover') return tooltipState.itemInteraction.hover.dataKey;
    return tooltipState.itemInteraction.click.dataKey;
};
var $0d9ada87ae089576$export$8ff07a725463bd5 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $a3236ed45f976f57$export$703b585bc92b5bae),
    $0d9ada87ae089576$var$pickTooltipEventType,
    $0d9ada87ae089576$var$pickTrigger,
    $0d9ada87ae089576$var$pickDefaultIndex
], (0, $b035ad89395e7942$export$45044aaa79c0cddb));
var $0d9ada87ae089576$export$7dbe424d18defe7d = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $122c64eee523dc50$export$771ef0ac044f724d),
    (0, $122c64eee523dc50$export$5856a7d94c109505),
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    (0, $1fec9e0b4d773a24$export$ffe0e60f8c88c05a),
    $0d9ada87ae089576$var$pickDefaultIndex,
    $0d9ada87ae089576$export$8ff07a725463bd5,
    (0, $983b6625e071621a$export$6ae1ee94e6fa88a7)
], (0, $71f8d538d48a32e2$export$c2cbc37a7546bbd0));
var $0d9ada87ae089576$export$392a0083df9bfd7c = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $0d9ada87ae089576$export$1288ff5c64c4ac42,
    $0d9ada87ae089576$export$7dbe424d18defe7d
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState.coordinate) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : defaultIndexCoordinate;
});
var $0d9ada87ae089576$export$400c35cc3b9a0487 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $1fec9e0b4d773a24$export$ffe0e60f8c88c05a),
    $0d9ada87ae089576$export$95fb15d7bb7a8a94
], (0, $e1872c677ee761c0$export$3213c4688ceb4c80));
var $0d9ada87ae089576$export$529676bfdba08611 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $0d9ada87ae089576$export$8ff07a725463bd5,
    $0d9ada87ae089576$export$95fb15d7bb7a8a94,
    (0, $695f2ef1b702f419$export$519edd692222520),
    (0, $40ff607ce3fff820$export$bf8397fefbaa3617),
    $0d9ada87ae089576$export$400c35cc3b9a0487,
    (0, $983b6625e071621a$export$6ae1ee94e6fa88a7),
    $0d9ada87ae089576$var$pickTooltipEventType
], (0, $0c87694423bc4b01$export$e50d50655fe0e7ab));
var $0d9ada87ae089576$export$c8884ed37796034a = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $0d9ada87ae089576$export$1288ff5c64c4ac42,
    $0d9ada87ae089576$export$95fb15d7bb7a8a94
], (tooltipInteractionState, activeIndex)=>{
    return {
        isActive: tooltipInteractionState.active && activeIndex != null,
        activeIndex: activeIndex
    };
});
var $0d9ada87ae089576$var$combineActiveCartesianProps = (chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (!(0, $9d6f2373a9d0ba42$export$215f974420919247)(chartEvent, offset)) return undefined;
    var pos = (0, $09206e1485e62bdb$export$f29fac779ccd75bc)(chartEvent, layout);
    var activeIndex = (0, $9d6f2373a9d0ba42$export$3071d39cc844078e)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $9d6f2373a9d0ba42$export$cfad5721ad1fe55)(layout, tooltipTicks, activeIndex, chartEvent);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $0d9ada87ae089576$var$combineActivePolarProps = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks || !polarViewBox) return undefined;
    var rangeObj = (0, $e8905a15bef036aa$export$e85a2bf8cd31c504)(chartEvent, polarViewBox);
    if (!rangeObj) return undefined;
    var pos = (0, $09206e1485e62bdb$export$fb2b0f76aa25d837)(rangeObj, layout);
    var activeIndex = (0, $9d6f2373a9d0ba42$export$3071d39cc844078e)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $9d6f2373a9d0ba42$export$6bc723868198544)(layout, tooltipTicks, activeIndex, rangeObj);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $0d9ada87ae089576$export$e1c9f959fffb37b4 = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !layout || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (layout === 'horizontal' || layout === 'vertical') return $0d9ada87ae089576$var$combineActiveCartesianProps(chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset);
    return $0d9ada87ae089576$var$combineActivePolarProps(chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks);
};




var $24bcd1e3ff5f7e51$var$pickChartPointer = (_state, chartPointer)=>chartPointer;
var $24bcd1e3ff5f7e51$export$2cfb761a54690867 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $24bcd1e3ff5f7e51$var$pickChartPointer,
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $84d209255304466f$export$57f4101c1e20bd95),
    (0, $52d2aaf4f719b99e$export$898d3dfd98fb482),
    (0, $1fec9e0b4d773a24$export$cf4d6dfce3a76af3),
    (0, $1fec9e0b4d773a24$export$ffe0e60f8c88c05a),
    (0, $0d9ada87ae089576$export$e133bec3c93a9247),
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b)
], (0, $0d9ada87ae089576$export$e1c9f959fffb37b4));



/**
 * Computes the chart coordinates from the mouse event.
 *
 * The coordinates are relative to the top-left corner of the chart,
 * where the top-left corner of the chart is (0, 0).
 * Moving right, the x-coordinate increases, and moving down, the y-coordinate increases.
 *
 * The coordinates are rounded to the nearest integer and are including a CSS transform scale.
 * So a chart that's scaled will return the same coordinates as a chart that's not scaled.
 *
 * @param event The mouse event from React event handlers
 * @return chartPointer The chart coordinates relative to the top-left corner of the chart
 */ var $fc863bec97d53848$export$96f447b11b1279d1 = (event)=>{
    var rect = event.currentTarget.getBoundingClientRect();
    var scaleX = rect.width / event.currentTarget.offsetWidth;
    var scaleY = rect.height / event.currentTarget.offsetHeight;
    return {
        /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */ chartX: Math.round((event.clientX - rect.left) / scaleX),
        chartY: Math.round((event.clientY - rect.top) / scaleY)
    };
};


var $d687c2e98a898d0b$export$f06e14b484aecafc = (0, $d60c7aefffed8a78$export$309c7a02b0b0bc62)('mouseClick');
var $d687c2e98a898d0b$export$fb3df626ae9864a = (0, $d60c7aefffed8a78$export$1228acebbbcb485b)();
// TODO: there's a bug here when you click the chart the activeIndex resets to zero
$d687c2e98a898d0b$export$fb3df626ae9864a.startListening({
    actionCreator: $d687c2e98a898d0b$export$f06e14b484aecafc,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        var activeProps = (0, $24bcd1e3ff5f7e51$export$2cfb761a54690867)(listenerApi.getState(), (0, $fc863bec97d53848$export$96f447b11b1279d1)(mousePointer));
        if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $c54e506cc16ecb3e$export$d2b1af5c3a560528)({
            activeIndex: activeProps.activeIndex,
            activeDataKey: undefined,
            activeCoordinate: activeProps.activeCoordinate
        }));
    }
});
var $d687c2e98a898d0b$export$f9de213dbfb2e32c = (0, $d60c7aefffed8a78$export$309c7a02b0b0bc62)('mouseMove');
var $d687c2e98a898d0b$export$b7e1b38eb227944a = (0, $d60c7aefffed8a78$export$1228acebbbcb485b)();
/*
 * This single rafId is safe because:
 * 1. Each chart has its own Redux store instance with its own middleware
 * 2. mouseMoveAction only fires from one DOM element (the chart wrapper)
 * 3. Rapid mousemove events from the same element SHOULD debounce - we only care about the latest position
 * This is different from externalEventsMiddleware which handles multiple event types
 * (click, mouseenter, mouseleave, etc.) that should NOT cancel each other.
 */ var $d687c2e98a898d0b$var$rafId = null;
$d687c2e98a898d0b$export$b7e1b38eb227944a.startListening({
    actionCreator: $d687c2e98a898d0b$export$f9de213dbfb2e32c,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        // Cancel any pending animation frame
        if ($d687c2e98a898d0b$var$rafId !== null) cancelAnimationFrame($d687c2e98a898d0b$var$rafId);
        var chartPointer = (0, $fc863bec97d53848$export$96f447b11b1279d1)(mousePointer);
        // Schedule the dispatch for the next animation frame
        $d687c2e98a898d0b$var$rafId = requestAnimationFrame(()=>{
            var state = listenerApi.getState();
            var tooltipEventType = (0, $c4309ff5980e62d8$export$53af65c2db668fac)(state, state.tooltip.settings.shared);
            // this functionality only applies to charts that have axes
            if (tooltipEventType === 'axis') {
                var activeProps = (0, $24bcd1e3ff5f7e51$export$2cfb761a54690867)(state, chartPointer);
                if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $c54e506cc16ecb3e$export$a7277636863fc703)({
                    activeIndex: activeProps.activeIndex,
                    activeDataKey: undefined,
                    activeCoordinate: activeProps.activeCoordinate
                }));
                else // this is needed to clear tooltip state when the mouse moves out of the inRange (svg - offset) function, but not yet out of the svg
                listenerApi.dispatch((0, $c54e506cc16ecb3e$export$73879bed3f2eef71)());
            }
            $d687c2e98a898d0b$var$rafId = null;
        });
    }
});


function $cf6acf337b947da4$export$b5f053baf756345f(key, value) {
    if (value instanceof HTMLElement) return "HTMLElement <".concat(value.tagName, " class=\"").concat(value.className, "\">");
    if (value === window) return 'global.window';
    if (key === 'children' && typeof value === 'object' && value !== null) return '<<CHILDREN>>';
    return value;
}





var $56Xh3 = parcelRequire("56Xh3");

var $8c92f32b81d13cf7$var$initialState = {
    dots: [],
    areas: [],
    lines: []
};
var $8c92f32b81d13cf7$export$cbde679baaad2c79 = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'referenceElements',
    initialState: $8c92f32b81d13cf7$var$initialState,
    reducers: {
        addDot: (state, action)=>{
            state.dots.push(action.payload);
        },
        removeDot: (state, action)=>{
            var index = (0, $56Xh3.current)(state).dots.findIndex((dot)=>dot === action.payload);
            if (index !== -1) state.dots.splice(index, 1);
        },
        addArea: (state, action)=>{
            state.areas.push(action.payload);
        },
        removeArea: (state, action)=>{
            var index = (0, $56Xh3.current)(state).areas.findIndex((area)=>area === action.payload);
            if (index !== -1) state.areas.splice(index, 1);
        },
        addLine: (state, action)=>{
            state.lines.push((0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload));
        },
        removeLine: (state, action)=>{
            var index = (0, $56Xh3.current)(state).lines.findIndex((line)=>line === action.payload);
            if (index !== -1) state.lines.splice(index, 1);
        }
    }
});
var { addDot: $8c92f32b81d13cf7$export$9be8ef3add1f8c1e, removeDot: $8c92f32b81d13cf7$export$57ff7495ce685163, addArea: $8c92f32b81d13cf7$export$d604a18565cfc1b3, removeArea: $8c92f32b81d13cf7$export$a8da2ad4123475fe, addLine: $8c92f32b81d13cf7$export$a9ce8e8146745e3e, removeLine: $8c92f32b81d13cf7$export$fd7919a5491769ec } = $8c92f32b81d13cf7$export$cbde679baaad2c79.actions;
var $8c92f32b81d13cf7$export$f30a87c263d1acf8 = $8c92f32b81d13cf7$export$cbde679baaad2c79.reducer;



/**
 * From all Brush properties, only height has a default value and will always be defined.
 * Other properties are nullable and will be computed from offsets and margins if they are not set.
 */ var $cb503c4830834a15$var$initialState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
var $cb503c4830834a15$export$d64e835ef4b0c23a = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'brush',
    initialState: $cb503c4830834a15$var$initialState,
    reducers: {
        setBrushSettings (_state, action) {
            if (action.payload == null) return $cb503c4830834a15$var$initialState;
            return action.payload;
        }
    }
});
var { setBrushSettings: $cb503c4830834a15$export$1860ec7d971c6a5b } = $cb503c4830834a15$export$d64e835ef4b0c23a.actions;
var $cb503c4830834a15$export$b8c9ca32ee9dbf92 = $cb503c4830834a15$export$d64e835ef4b0c23a.reducer;




var $4d3acae5bcb76a5d$export$d4c72bab9d6cc13a = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    barSize: undefined,
    className: undefined,
    maxBarSize: undefined,
    stackOffset: 'none',
    syncId: undefined,
    syncMethod: 'index',
    baseValue: undefined,
    reverseStackOrder: false
};
var $4d3acae5bcb76a5d$var$rootPropsSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'rootProps',
    initialState: $4d3acae5bcb76a5d$export$d4c72bab9d6cc13a,
    reducers: {
        updateOptions: (state, action)=>{
            var _action$payload$barGa;
            state.accessibilityLayer = action.payload.accessibilityLayer;
            state.barCategoryGap = action.payload.barCategoryGap;
            state.barGap = (_action$payload$barGa = action.payload.barGap) !== null && _action$payload$barGa !== void 0 ? _action$payload$barGa : $4d3acae5bcb76a5d$export$d4c72bab9d6cc13a.barGap;
            state.barSize = action.payload.barSize;
            state.maxBarSize = action.payload.maxBarSize;
            state.stackOffset = action.payload.stackOffset;
            state.syncId = action.payload.syncId;
            state.syncMethod = action.payload.syncMethod;
            state.className = action.payload.className;
            state.baseValue = action.payload.baseValue;
            state.reverseStackOrder = action.payload.reverseStackOrder;
        }
    }
});
var $4d3acae5bcb76a5d$export$291d6468e221147e = $4d3acae5bcb76a5d$var$rootPropsSlice.reducer;
var { updateOptions: $4d3acae5bcb76a5d$export$c6fe4049d20353ac } = $4d3acae5bcb76a5d$var$rootPropsSlice.actions;




var $807caecc90755f76$var$initialState = {
    radiusAxis: {},
    angleAxis: {}
};
var $807caecc90755f76$var$polarAxisSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'polarAxis',
    initialState: $807caecc90755f76$var$initialState,
    reducers: {
        addRadiusAxis (state, action) {
            state.radiusAxis[action.payload.id] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload);
        },
        removeRadiusAxis (state, action) {
            delete state.radiusAxis[action.payload.id];
        },
        addAngleAxis (state, action) {
            state.angleAxis[action.payload.id] = (0, $135692a8e4adb0cb$export$c05b21e3257751e5)(action.payload);
        },
        removeAngleAxis (state, action) {
            delete state.angleAxis[action.payload.id];
        }
    }
});
var { addRadiusAxis: $807caecc90755f76$export$3555d359361c9fe3, removeRadiusAxis: $807caecc90755f76$export$104b2ce9f0baf86f, addAngleAxis: $807caecc90755f76$export$bf871b0db8674238, removeAngleAxis: $807caecc90755f76$export$d540ed209cfbb147 } = $807caecc90755f76$var$polarAxisSlice.actions;
var $807caecc90755f76$export$97e65520f1278b5 = $807caecc90755f76$var$polarAxisSlice.reducer;



var $9bd6c091a21f244d$var$polarOptionsSlice = (0, $d60c7aefffed8a78$export$4d8d9bd83c24ae8b)({
    name: 'polarOptions',
    initialState: null,
    reducers: {
        updatePolarOptions: (_state, action)=>{
            return action.payload;
        }
    }
});
var { updatePolarOptions: $9bd6c091a21f244d$export$5dfe4dcb848af93f } = $9bd6c091a21f244d$var$polarOptionsSlice.actions;
var $9bd6c091a21f244d$export$8d4054f1936f7f4d = $9bd6c091a21f244d$var$polarOptionsSlice.reducer;








var $4db11ad80426f119$export$4839538efb7414c = (0, $d60c7aefffed8a78$export$309c7a02b0b0bc62)('keyDown');
var $4db11ad80426f119$export$d95192eee5865567 = (0, $d60c7aefffed8a78$export$309c7a02b0b0bc62)('focus');
var $4db11ad80426f119$export$b4d762ee62ea3f99 = (0, $d60c7aefffed8a78$export$1228acebbbcb485b)();
$4db11ad80426f119$export$b4d762ee62ea3f99.startListening({
    actionCreator: $4db11ad80426f119$export$4839538efb7414c,
    effect: (action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction: keyboardInteraction } = state.tooltip;
        var key = action.payload;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Enter') return;
        // TODO this is lacking index for charts that do not support numeric indexes
        var resolvedIndex = (0, $22214ebf87c016df$export$32df4b03a0962e46)(keyboardInteraction, (0, $1fec9e0b4d773a24$export$5a8beccc8250d20e)(state), (0, $40ff607ce3fff820$export$bf8397fefbaa3617)(state), (0, $1fec9e0b4d773a24$export$76f7a1975f60ccf1)(state));
        var currentIndex = resolvedIndex == null ? -1 : Number(resolvedIndex);
        if (!Number.isFinite(currentIndex) || currentIndex < 0) return;
        var tooltipTicks = (0, $1fec9e0b4d773a24$export$ffe0e60f8c88c05a)(state);
        if (key === 'Enter') {
            var _coordinate = (0, $0d9ada87ae089576$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(keyboardInteraction.index));
            listenerApi.dispatch((0, $c54e506cc16ecb3e$export$820c94985c9eba3f)({
                active: !keyboardInteraction.active,
                activeIndex: keyboardInteraction.index,
                activeDataKey: keyboardInteraction.dataKey,
                activeCoordinate: _coordinate
            }));
            return;
        }
        var direction = (0, $40ff607ce3fff820$export$430d623a94added7)(state);
        var directionMultiplier = direction === 'left-to-right' ? 1 : -1;
        var movement = key === 'ArrowRight' ? 1 : -1;
        var nextIndex = currentIndex + movement * directionMultiplier;
        if (tooltipTicks == null || nextIndex >= tooltipTicks.length || nextIndex < 0) return;
        var coordinate = (0, $0d9ada87ae089576$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(nextIndex));
        listenerApi.dispatch((0, $c54e506cc16ecb3e$export$820c94985c9eba3f)({
            active: true,
            activeIndex: nextIndex.toString(),
            activeDataKey: undefined,
            activeCoordinate: coordinate
        }));
    }
});
$4db11ad80426f119$export$b4d762ee62ea3f99.startListening({
    actionCreator: $4db11ad80426f119$export$d95192eee5865567,
    effect: (_action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction: keyboardInteraction } = state.tooltip;
        if (keyboardInteraction.active) return;
        if (keyboardInteraction.index == null) {
            var nextIndex = '0';
            var coordinate = (0, $0d9ada87ae089576$export$7dbe424d18defe7d)(state, 'axis', 'hover', String(nextIndex));
            listenerApi.dispatch((0, $c54e506cc16ecb3e$export$820c94985c9eba3f)({
                activeDataKey: undefined,
                active: true,
                activeIndex: nextIndex,
                activeCoordinate: coordinate
            }));
        }
    }
});




var $cc02abb7d35aa02f$export$1d0268b9f89859f0 = (0, $d60c7aefffed8a78$export$309c7a02b0b0bc62)('externalEvent');
var $cc02abb7d35aa02f$export$3c5d447f046d0ec3 = (0, $d60c7aefffed8a78$export$1228acebbbcb485b)();
/*
 * We need a Map keyed by event type because this middleware handles MULTIPLE different event types
 * (click, mouseenter, mouseleave, mousedown, mouseup, contextmenu, dblclick, touchstart, touchmove, touchend)
 * from the same DOM element. Different event types should NOT cancel each other's animation frames.
 * For example, a click event and a mousemove event can happen in quick succession and both should be processed.
 * This is different from mouseMoveMiddleware which only handles one event type and uses a single rafId.
 */ var $cc02abb7d35aa02f$var$rafIdMap = new Map();
$cc02abb7d35aa02f$export$3c5d447f046d0ec3.startListening({
    actionCreator: $cc02abb7d35aa02f$export$1d0268b9f89859f0,
    effect: (action, listenerApi)=>{
        var { handler: handler, reactEvent: reactEvent } = action.payload;
        if (handler == null) return;
        reactEvent.persist();
        var eventType = reactEvent.type;
        // Cancel any pending animation frame for this event type
        var existingRafId = $cc02abb7d35aa02f$var$rafIdMap.get(eventType);
        if (existingRafId !== undefined) cancelAnimationFrame(existingRafId);
        var rafId = requestAnimationFrame(()=>{
            try {
                /*
         * Here it is important that we get the latest state inside the animation frame callback,
         * not from the outer scope, because there may have been other actions dispatched
         * between the time the event was fired and the animation frame callback is executed.
         * One of those actions is the one that actually sets the active tooltip state!
         */ var state = listenerApi.getState();
                var nextState = {
                    activeCoordinate: (0, $1fec9e0b4d773a24$export$90c565a5b196e427)(state),
                    activeDataKey: (0, $1fec9e0b4d773a24$export$999f7a7ced063fab)(state),
                    activeIndex: (0, $1fec9e0b4d773a24$export$8b2762260f5891c9)(state),
                    activeLabel: (0, $1fec9e0b4d773a24$export$400c35cc3b9a0487)(state),
                    activeTooltipIndex: (0, $1fec9e0b4d773a24$export$8b2762260f5891c9)(state),
                    isTooltipActive: (0, $1fec9e0b4d773a24$export$c8884ed37796034a)(state)
                };
                handler(nextState, reactEvent);
            } finally{
                $cc02abb7d35aa02f$var$rafIdMap.delete(eventType);
            }
        });
        $cc02abb7d35aa02f$var$rafIdMap.set(eventType, rafId);
    }
});











var $f3caeaa400d3a499$var$selectAllTooltipPayloadConfiguration = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $a3236ed45f976f57$export$703b585bc92b5bae)
], (tooltipState)=>tooltipState.tooltipItemPayloads);
var $f3caeaa400d3a499$export$4e32c9da1f3ea7ce = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $f3caeaa400d3a499$var$selectAllTooltipPayloadConfiguration,
    (0, $983b6625e071621a$export$6ae1ee94e6fa88a7),
    (_state, tooltipIndex, _dataKey)=>tooltipIndex,
    (_state, _tooltipIndex, dataKey)=>dataKey
], (allTooltipConfigurations, tooltipPayloadSearcher, tooltipIndex, dataKey)=>{
    var mostRelevantTooltipConfiguration = allTooltipConfigurations.find((tooltipConfiguration)=>{
        return tooltipConfiguration.settings.dataKey === dataKey;
    });
    if (mostRelevantTooltipConfiguration == null) return undefined;
    var { positions: positions } = mostRelevantTooltipConfiguration;
    if (positions == null) return undefined;
    // @ts-expect-error tooltipPayloadSearcher is not typed well
    var maybePosition = tooltipPayloadSearcher(positions, tooltipIndex);
    return maybePosition;
});


var $5464e0730956a384$export$ba46b5fda0e2985f = (0, $d60c7aefffed8a78$export$309c7a02b0b0bc62)('touchMove');
var $5464e0730956a384$export$923ceddc5a79736a = (0, $d60c7aefffed8a78$export$1228acebbbcb485b)();
$5464e0730956a384$export$923ceddc5a79736a.startListening({
    actionCreator: $5464e0730956a384$export$ba46b5fda0e2985f,
    effect: (action, listenerApi)=>{
        var touchEvent = action.payload;
        if (touchEvent.touches == null || touchEvent.touches.length === 0) return;
        var state = listenerApi.getState();
        var tooltipEventType = (0, $c4309ff5980e62d8$export$53af65c2db668fac)(state, state.tooltip.settings.shared);
        if (tooltipEventType === 'axis') {
            var activeProps = (0, $24bcd1e3ff5f7e51$export$2cfb761a54690867)(state, (0, $fc863bec97d53848$export$96f447b11b1279d1)({
                clientX: touchEvent.touches[0].clientX,
                clientY: touchEvent.touches[0].clientY,
                currentTarget: touchEvent.currentTarget
            }));
            if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $c54e506cc16ecb3e$export$a7277636863fc703)({
                activeIndex: activeProps.activeIndex,
                activeDataKey: undefined,
                activeCoordinate: activeProps.activeCoordinate
            }));
        } else if (tooltipEventType === 'item') {
            var _target$getAttribute;
            var touch = touchEvent.touches[0];
            if (document.elementFromPoint == null) return;
            var target = document.elementFromPoint(touch.clientX, touch.clientY);
            if (!target || !target.getAttribute) return;
            var itemIndex = target.getAttribute((0, $61c6522d82a73e91$export$c0f3d78d63b3e065));
            var dataKey = (_target$getAttribute = target.getAttribute((0, $61c6522d82a73e91$export$38427ae88f231d57))) !== null && _target$getAttribute !== void 0 ? _target$getAttribute : undefined;
            var coordinate = (0, $f3caeaa400d3a499$export$4e32c9da1f3ea7ce)(listenerApi.getState(), itemIndex, dataKey);
            listenerApi.dispatch((0, $c54e506cc16ecb3e$export$c78abbb2450f6b44)({
                activeDataKey: dataKey,
                activeIndex: itemIndex,
                activeCoordinate: coordinate
            }));
        }
    }
});





var $faebed037bc31eb2$var$rootReducer = (0, $b4bc487a38c3f200$export$66e4520cdb265d18)({
    brush: (0, $cb503c4830834a15$export$b8c9ca32ee9dbf92),
    cartesianAxis: (0, $9b2a3f99ebd40cd8$export$c8ae79f5f6ae07c6),
    chartData: (0, $a3ac5576ba06edce$export$52973ca5fce0a5d5),
    errorBars: (0, $f6ac4049b670471f$export$6dda85fa3c67ca19),
    graphicalItems: (0, $f2fc97b2a40d4484$export$183eecd5cb7dbb38),
    layout: (0, $909e1e5d36056665$export$701395c4acfabc85),
    legend: (0, $2dd5d2946f23160b$export$8d8dfb8d5acf8179),
    options: (0, $9a03b151feb18982$export$81a3ba457dd82bec),
    polarAxis: (0, $807caecc90755f76$export$97e65520f1278b5),
    polarOptions: (0, $9bd6c091a21f244d$export$8d4054f1936f7f4d),
    referenceElements: (0, $8c92f32b81d13cf7$export$f30a87c263d1acf8),
    rootProps: (0, $4d3acae5bcb76a5d$export$291d6468e221147e),
    tooltip: (0, $c54e506cc16ecb3e$export$cadd4678b967dba6),
    zIndex: (0, $f208877c1770a0d1$export$a34096cdea3a022a)
});
var $faebed037bc31eb2$export$a4383593d58e8efa = function createRechartsStore(preloadedState) {
    var chartName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Chart';
    return (0, $d60c7aefffed8a78$export$7d8a5b498da695ac)({
        reducer: $faebed037bc31eb2$var$rootReducer,
        // redux-toolkit v1 types are unhappy with the preloadedState type. Remove the `as any` when bumping to v2
        preloadedState: preloadedState,
        // @ts-expect-error redux-toolkit v1 types are unhappy with the middleware array. Remove this comment when bumping to v2
        middleware: (getDefaultMiddleware)=>{
            var _process$env$NODE_ENV;
            return getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: ![
                    'commonjs',
                    'es6',
                    'production'
                ].includes((_process$env$NODE_ENV = "es6", _process$env$NODE_ENV !== void 0) ? _process$env$NODE_ENV : '')
            }).concat([
                (0, $d687c2e98a898d0b$export$fb3df626ae9864a).middleware,
                (0, $d687c2e98a898d0b$export$b7e1b38eb227944a).middleware,
                (0, $4db11ad80426f119$export$b4d762ee62ea3f99).middleware,
                (0, $cc02abb7d35aa02f$export$3c5d447f046d0ec3).middleware,
                (0, $5464e0730956a384$export$923ceddc5a79736a).middleware
            ]);
        },
        /*
     * I can't find out how to satisfy typescript here.
     * We return `EnhancerArray<[StoreEnhancer<{}, {}>, StoreEnhancer]>` from this function,
     * but the types say we should return `EnhancerArray<StoreEnhancer<{}, {}>`.
     * Looks like it's badly inferred generics, but it won't allow me to provide the correct type manually either.
     * So let's just ignore the error for now.
     */ // @ts-expect-error mismatched generics
        enhancers: (getDefaultEnhancers)=>{
            var enhancers = getDefaultEnhancers;
            if (typeof getDefaultEnhancers === 'function') /*
         * In RTK v2 this is always a function, but in v1 it is an array.
         * Because we have @types/redux-toolkit v1 as a dependency, typescript is going to flag this as an error.
         * We support both RTK v1 and v2, so we need to do this check.
         * https://redux-toolkit.js.org/usage/migrating-rtk-2#configurestoreenhancers-must-be-a-callback
         */ // @ts-expect-error RTK v2 behaviour on RTK v1 types
            enhancers = getDefaultEnhancers();
            return enhancers.concat((0, $d60c7aefffed8a78$export$676277d7dca0f396)({
                type: 'raf'
            }));
        },
        devTools: (0, $a898dc03dc17f75a$export$98f03c5d19621d70).devToolsEnabled && {
            serialize: {
                replacer: (0, $cf6acf337b947da4$export$b5f053baf756345f)
            },
            name: "recharts-".concat(chartName)
        }
    });
};




function $d9644cbb81cad403$export$debe87639f2707f9(_ref) {
    var { preloadedState: preloadedState, children: children, reduxStoreName: reduxStoreName } = _ref;
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    /*
   * Why the ref? Redux official documentation recommends to use store as a singleton,
   * and reuse that everywhere: https://redux-toolkit.js.org/api/configureStore#basic-example
   *
   * Which is correct! Except that is considering deploying Redux in an app.
   * Recharts as a library supports multiple charts on the same page.
   * And each of these charts needs its own store independent of others!
   *
   * The alternative is to have everything in the store keyed by the chart id.
   * Which would make working with everything a little bit more painful because we need the chart id everywhere.
   */ var storeRef = (0, $aivMx.useRef)(null);
    /*
   * Panorama means that this chart is not its own chart, it's only a "preview"
   * being rendered as a child of Brush.
   * In such case, it should not have a store on its own - it should implicitly inherit
   * whatever data is in the "parent" or "root" chart.
   * Which here is represented by not having a Provider at all. All selectors will use the root store by default.
   */ if (isPanorama) return children;
    if (storeRef.current == null) storeRef.current = (0, $faebed037bc31eb2$export$a4383593d58e8efa)(preloadedState, reduxStoreName);
    // @ts-expect-error React-Redux types demand that the context internal value is not null, but we have that as default.
    var nonNullContext = (0, $748f70810790c017$export$876ef70bc88b13cb);
    return /*#__PURE__*/ $aivMx.createElement((0, $7a57c545a1f92740$export$2e2bcd8739ae039), {
        context: nonNullContext,
        store: storeRef.current
    }, children);
}



var $aivMx = parcelRequire("aivMx");



var $d94c6d6afa2971cf$export$2100a1dedbca0238 = (props)=>{
    var { chartData: chartData } = props;
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    (0, $aivMx.useEffect)(()=>{
        if (isPanorama) // Panorama mode reuses data from the main chart, so we must not overwrite it here.
        return ()=>{
        // there is nothing to clean up
        };
        dispatch((0, $a3ac5576ba06edce$export$624c47d88733f253)(chartData));
        return ()=>{
            dispatch((0, $a3ac5576ba06edce$export$624c47d88733f253)(undefined));
        };
    }, [
        chartData,
        dispatch,
        isPanorama
    ]);
    return null;
};
var $d94c6d6afa2971cf$export$91a155b0e28498ba = (props)=>{
    var { computedData: computedData } = props;
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useEffect)(()=>{
        dispatch((0, $a3ac5576ba06edce$export$9b2e7f4962514250)(computedData));
        return ()=>{
            dispatch((0, $a3ac5576ba06edce$export$624c47d88733f253)(undefined));
        };
    }, [
        computedData,
        dispatch
    ]);
    return null;
};
var $d94c6d6afa2971cf$var$selectChartData = (state)=>state.chartData.chartData;
var $d94c6d6afa2971cf$export$551a2a6f7431b8ad = ()=>(0, $7729c221c7142965$export$a7347740d65f620b)($d94c6d6afa2971cf$var$selectChartData);
var $d94c6d6afa2971cf$var$selectDataIndex = (state)=>{
    var { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = state.chartData;
    return {
        startIndex: dataStartIndex,
        endIndex: dataEndIndex
    };
};
var $d94c6d6afa2971cf$export$824568c74ea1faec = ()=>{
    return (0, $7729c221c7142965$export$a7347740d65f620b)($d94c6d6afa2971cf$var$selectDataIndex);
};



var $aivMx = parcelRequire("aivMx");




/**
 * "Main" props are props that are only accepted on the main chart,
 * as opposed to the small panorama chart inside a Brush.
 */ function $cda7a91bff70ffe1$var$ReportMainChartPropsImpl(_ref) {
    var { layout: layout, margin: margin } = _ref;
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    /*
   * useEffect here is required to avoid the "Cannot update a component while rendering a different component" error.
   * https://github.com/facebook/react/issues/18178
   *
   * Reported in https://github.com/recharts/recharts/issues/5514
   */ (0, $aivMx.useEffect)(()=>{
        if (!isPanorama) {
            dispatch((0, $909e1e5d36056665$export$e8437af1f2483b8e)(layout));
            dispatch((0, $909e1e5d36056665$export$3f8f25b83912855f)(margin));
        }
    }, [
        dispatch,
        isPanorama,
        layout,
        margin
    ]);
    return null;
}
var $cda7a91bff70ffe1$export$6faeaad6e02c2e9d = /*#__PURE__*/ (0, $aivMx.memo)($cda7a91bff70ffe1$var$ReportMainChartPropsImpl, (0, $7fd62a4f2791f570$export$b8f09df787c278d9));



var $aivMx = parcelRequire("aivMx");


function $e07526bda954b171$export$6fabfb9ba230d12b(props) {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useEffect)(()=>{
        dispatch((0, $4d3acae5bcb76a5d$export$c6fe4049d20353ac)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}



var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");


var $08040eca3d3c0c30$export$276788f18f24cad3 = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>state.rootProps.accessibilityLayer)) !== null && _useAppSelector !== void 0 ? _useAppSelector : true;
};




var $aivMx = parcelRequire("aivMx");


var $fa0afac1492c9749$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $fa0afac1492c9749$var$_extends() {
    return $fa0afac1492c9749$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fa0afac1492c9749$var$_extends.apply(null, arguments);
}
function $fa0afac1492c9749$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $fa0afac1492c9749$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $fa0afac1492c9749$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $fa0afac1492c9749$export$7b92b459e668cb21 = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var { children: children, width: width, height: height, viewBox: viewBox, className: className, style: style, title: title, desc: desc } = props, others = $fa0afac1492c9749$var$_objectWithoutProperties(props, $fa0afac1492c9749$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-surface', className);
    return /*#__PURE__*/ $aivMx.createElement("svg", $fa0afac1492c9749$var$_extends({}, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(others), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
        ref: ref
    }), /*#__PURE__*/ $aivMx.createElement("title", null, title), /*#__PURE__*/ $aivMx.createElement("desc", null, desc), children);
});






var $aivMx = parcelRequire("aivMx");




function $0eb5286524cccf83$var$ZIndexSvgPortal(_ref) {
    var { zIndex: zIndex, isPanorama: isPanorama } = _ref;
    var prefix = isPanorama ? "recharts-zindex-panorama-" : "recharts-zindex-";
    var portalId = (0, $7561c9dab6180cbd$export$c485849f2e393253)("".concat(prefix).concat(zIndex));
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useLayoutEffect)(()=>{
        dispatch((0, $f208877c1770a0d1$export$7243b907ccc71fa6)({
            zIndex: zIndex,
            elementId: portalId,
            isPanorama: isPanorama
        }));
        return ()=>{
            dispatch((0, $f208877c1770a0d1$export$c3d01e849b2b6f99)({
                zIndex: zIndex,
                isPanorama: isPanorama
            }));
        };
    }, [
        dispatch,
        zIndex,
        portalId,
        isPanorama
    ]);
    return /*#__PURE__*/ $aivMx.createElement("g", {
        id: portalId
    });
}
function $0eb5286524cccf83$export$7a76624f8e4da531(_ref2) {
    var { children: children, isPanorama: isPanorama } = _ref2;
    var allRegisteredZIndexes = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $f32f74c67887f2ee$export$7967bffce127e19c));
    if (!allRegisteredZIndexes || allRegisteredZIndexes.length === 0) return children;
    var allNegativeZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex < 0);
    // We exclude zero on purpose - that is the default layer, and it doesn't need a portal.
    var allPositiveZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex > 0);
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, allNegativeZIndexes.map((zIndex)=>/*#__PURE__*/ $aivMx.createElement($0eb5286524cccf83$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })), children, allPositiveZIndexes.map((zIndex)=>/*#__PURE__*/ $aivMx.createElement($0eb5286524cccf83$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })));
}


var $1a561f7aa634198a$var$_excluded = [
    "children"
];
function $1a561f7aa634198a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1a561f7aa634198a$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $1a561f7aa634198a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $1a561f7aa634198a$var$_extends() {
    return $1a561f7aa634198a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1a561f7aa634198a$var$_extends.apply(null, arguments);
}
var $1a561f7aa634198a$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%',
    /*
   * display: block is necessary here because the default for an SVG is display: inline,
   * which in some browsers (Chrome) adds a little bit of extra space above and below the SVG
   * to make space for the descender of letters like "g" and "y". This throws off the height calculation
   * and causes the container to grow indefinitely on each render with responsive=true.
   * Display: block removes that extra space.
   *
   * Interestingly, Firefox does not have this problem, but it doesn't hurt to add the style anyway.
   */ display: 'block'
};
var $1a561f7aa634198a$var$MainChartSurface = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var width = (0, $2d4a23e6670568d2$export$8854f7ece606854b)();
    var height = (0, $2d4a23e6670568d2$export$369ae257969c6f9f)();
    var hasAccessibilityLayer = (0, $08040eca3d3c0c30$export$276788f18f24cad3)();
    if (!(0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(width) || !(0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(height)) return null;
    var { children: children, otherAttributes: otherAttributes, title: title, desc: desc } = props;
    var tabIndex, role;
    if (otherAttributes != null) {
        if (typeof otherAttributes.tabIndex === 'number') tabIndex = otherAttributes.tabIndex;
        else tabIndex = hasAccessibilityLayer ? 0 : undefined;
        if (typeof otherAttributes.role === 'string') role = otherAttributes.role;
        else role = hasAccessibilityLayer ? 'application' : undefined;
    }
    return /*#__PURE__*/ $aivMx.createElement((0, $fa0afac1492c9749$export$7b92b459e668cb21), $1a561f7aa634198a$var$_extends({}, otherAttributes, {
        title: title,
        desc: desc,
        role: role,
        tabIndex: tabIndex,
        width: width,
        height: height,
        style: $1a561f7aa634198a$var$FULL_WIDTH_AND_HEIGHT,
        ref: ref
    }), children);
});
var $1a561f7aa634198a$var$BrushPanoramaSurface = (_ref)=>{
    var { children: children } = _ref;
    var brushDimensions = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $157aebf66ae7c2b8$export$3b81e97eae001823));
    if (!brushDimensions) return null;
    var { width: width, height: height, y: y, x: x } = brushDimensions;
    return /*#__PURE__*/ $aivMx.createElement((0, $fa0afac1492c9749$export$7b92b459e668cb21), {
        width: width,
        height: height,
        x: x,
        y: y
    }, children);
};
var $1a561f7aa634198a$export$b6c051d2e0bcd3e9 = /*#__PURE__*/ (0, $aivMx.forwardRef)((_ref2, ref)=>{
    var { children: children } = _ref2, rest = $1a561f7aa634198a$var$_objectWithoutProperties(_ref2, $1a561f7aa634198a$var$_excluded);
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    if (isPanorama) return /*#__PURE__*/ $aivMx.createElement($1a561f7aa634198a$var$BrushPanoramaSurface, null, /*#__PURE__*/ $aivMx.createElement((0, $0eb5286524cccf83$export$7a76624f8e4da531), {
        isPanorama: true
    }, children));
    return /*#__PURE__*/ $aivMx.createElement($1a561f7aa634198a$var$MainChartSurface, $1a561f7aa634198a$var$_extends({
        ref: ref
    }, rest), /*#__PURE__*/ $aivMx.createElement((0, $0eb5286524cccf83$export$7a76624f8e4da531), {
        isPanorama: false
    }, children));
});



var $aivMx = parcelRequire("aivMx");





var $aivMx = parcelRequire("aivMx");


var $1f98468c9cab3179$exports = {};
'use strict';
var $1f98468c9cab3179$var$has = Object.prototype.hasOwnProperty, $1f98468c9cab3179$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $1f98468c9cab3179$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $1f98468c9cab3179$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $1f98468c9cab3179$var$Events().__proto__) $1f98468c9cab3179$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $1f98468c9cab3179$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $1f98468c9cab3179$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $1f98468c9cab3179$var$EE(fn, context || emitter, once), evt = $1f98468c9cab3179$var$prefix ? $1f98468c9cab3179$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $1f98468c9cab3179$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $1f98468c9cab3179$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $1f98468c9cab3179$var$EventEmitter() {
    this._events = new $1f98468c9cab3179$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $1f98468c9cab3179$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($1f98468c9cab3179$var$has.call(events, name)) names.push($1f98468c9cab3179$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $1f98468c9cab3179$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $1f98468c9cab3179$var$prefix ? $1f98468c9cab3179$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $1f98468c9cab3179$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $1f98468c9cab3179$var$prefix ? $1f98468c9cab3179$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $1f98468c9cab3179$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $1f98468c9cab3179$var$prefix ? $1f98468c9cab3179$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1f98468c9cab3179$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $1f98468c9cab3179$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1f98468c9cab3179$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $1f98468c9cab3179$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1f98468c9cab3179$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $1f98468c9cab3179$var$prefix ? $1f98468c9cab3179$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $1f98468c9cab3179$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $1f98468c9cab3179$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $1f98468c9cab3179$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1f98468c9cab3179$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $1f98468c9cab3179$var$prefix ? $1f98468c9cab3179$var$prefix + event : event;
        if (this._events[evt]) $1f98468c9cab3179$var$clearEvent(this, evt);
    } else {
        this._events = new $1f98468c9cab3179$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$1f98468c9cab3179$var$EventEmitter.prototype.off = $1f98468c9cab3179$var$EventEmitter.prototype.removeListener;
$1f98468c9cab3179$var$EventEmitter.prototype.addListener = $1f98468c9cab3179$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$1f98468c9cab3179$var$EventEmitter.prefixed = $1f98468c9cab3179$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$1f98468c9cab3179$var$EventEmitter.EventEmitter = $1f98468c9cab3179$var$EventEmitter;
$1f98468c9cab3179$exports = $1f98468c9cab3179$var$EventEmitter;


var $948ceed3993e4d53$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($1f98468c9cab3179$exports)))();
var $948ceed3993e4d53$export$e2631176295fd79b = 'recharts.syncEvent.tooltip';
var $948ceed3993e4d53$export$5069141294af4ee8 = 'recharts.syncEvent.brush';






function $fa5755e568b72f1c$export$54e3aed0d8d4a717(state) {
    return state.tooltip.syncInteraction;
}





var $0bebaaa81de07330$var$_excluded = [
    "x",
    "y"
];
function $0bebaaa81de07330$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0bebaaa81de07330$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0bebaaa81de07330$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0bebaaa81de07330$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0bebaaa81de07330$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0bebaaa81de07330$var$_defineProperty(e, r, t) {
    return (r = $0bebaaa81de07330$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0bebaaa81de07330$var$_toPropertyKey(t) {
    var i = $0bebaaa81de07330$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0bebaaa81de07330$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0bebaaa81de07330$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0bebaaa81de07330$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0bebaaa81de07330$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0bebaaa81de07330$var$useTooltipSyncEventsListener() {
    var mySyncId = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$d3b88e5c88540018));
    var myEventEmitter = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$b89defd58e84e980));
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var syncMethod = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$f3cbf53653105e96));
    var tooltipTicks = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$ffe0e60f8c88c05a));
    var layout = (0, $2d4a23e6670568d2$export$970c79ecc7081cc)();
    var viewBox = (0, $2d4a23e6670568d2$export$76b29bb074e0c45a)();
    var className = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>state.rootProps.className);
    (0, $aivMx.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $9d9ad0197f7e4c2b$export$8793edee2d425525;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId !== incomingSyncId) // This event is not for this chart
            return;
            if (syncMethod === 'index') {
                var _action$payload;
                if (viewBox && action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.coordinate && action.payload.sourceViewBox) {
                    var _action$payload$coord = action.payload.coordinate, { x: _x, y: _y } = _action$payload$coord, otherCoordinateProps = $0bebaaa81de07330$var$_objectWithoutProperties(_action$payload$coord, $0bebaaa81de07330$var$_excluded);
                    var { x: sourceX, y: sourceY, width: sourceWidth, height: sourceHeight } = action.payload.sourceViewBox;
                    var scaledCoordinate = $0bebaaa81de07330$var$_objectSpread($0bebaaa81de07330$var$_objectSpread({}, otherCoordinateProps), {}, {
                        x: viewBox.x + (sourceWidth ? (_x - sourceX) / sourceWidth : 0) * viewBox.width,
                        y: viewBox.y + (sourceHeight ? (_y - sourceY) / sourceHeight : 0) * viewBox.height
                    });
                    dispatch($0bebaaa81de07330$var$_objectSpread($0bebaaa81de07330$var$_objectSpread({}, action), {}, {
                        payload: $0bebaaa81de07330$var$_objectSpread($0bebaaa81de07330$var$_objectSpread({}, action.payload), {}, {
                            coordinate: scaledCoordinate
                        })
                    }));
                } else dispatch(action);
                return;
            }
            if (tooltipTicks == null) // for the other two sync methods, we need the ticks to be available
            return;
            var activeTick;
            if (typeof syncMethod === 'function') {
                /*
         * This is what the data shape in 2.x CategoricalChartState used to look like.
         * In 3.x we store things differently but let's try to keep the old shape for compatibility.
         */ var syncMethodParam = {
                    activeTooltipIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    isTooltipActive: action.payload.active,
                    activeIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    activeLabel: action.payload.label,
                    activeDataKey: action.payload.dataKey,
                    activeCoordinate: action.payload.coordinate
                };
                // Call a callback function. If there is an application specific algorithm
                var activeTooltipIndex = syncMethod(tooltipTicks, syncMethodParam);
                activeTick = tooltipTicks[activeTooltipIndex];
            } else if (syncMethod === 'value') // labels are always strings, tick.value might be a string or a number, depending on axis type
            activeTick = tooltipTicks.find((tick)=>String(tick.value) === action.payload.label);
            var { coordinate: coordinate } = action.payload;
            if (activeTick == null || action.payload.active === false || coordinate == null || viewBox == null) {
                dispatch((0, $c54e506cc16ecb3e$export$f2efc99b98e50938)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: undefined
                }));
                return;
            }
            var { x: x, y: y } = coordinate;
            var validateChartX = Math.min(x, viewBox.x + viewBox.width);
            var validateChartY = Math.min(y, viewBox.y + viewBox.height);
            var activeCoordinate = {
                x: layout === 'horizontal' ? activeTick.coordinate : validateChartX,
                y: layout === 'horizontal' ? validateChartY : activeTick.coordinate
            };
            var syncAction = (0, $c54e506cc16ecb3e$export$f2efc99b98e50938)({
                active: action.payload.active,
                coordinate: activeCoordinate,
                dataKey: action.payload.dataKey,
                index: String(activeTick.index),
                label: action.payload.label,
                sourceViewBox: action.payload.sourceViewBox
            });
            dispatch(syncAction);
        };
        (0, $948ceed3993e4d53$export$9bcdfe5f29bb33).on((0, $948ceed3993e4d53$export$e2631176295fd79b), listener);
        return ()=>{
            (0, $948ceed3993e4d53$export$9bcdfe5f29bb33).off((0, $948ceed3993e4d53$export$e2631176295fd79b), listener);
        };
    }, [
        className,
        dispatch,
        myEventEmitter,
        mySyncId,
        syncMethod,
        tooltipTicks,
        layout,
        viewBox
    ]);
}
function $0bebaaa81de07330$var$useBrushSyncEventsListener() {
    var mySyncId = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$d3b88e5c88540018));
    var myEventEmitter = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$b89defd58e84e980));
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $9d9ad0197f7e4c2b$export$8793edee2d425525;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId === incomingSyncId) dispatch((0, $a3ac5576ba06edce$export$427d605cc4e3bbdd)(action));
        };
        (0, $948ceed3993e4d53$export$9bcdfe5f29bb33).on((0, $948ceed3993e4d53$export$5069141294af4ee8), listener);
        return ()=>{
            (0, $948ceed3993e4d53$export$9bcdfe5f29bb33).off((0, $948ceed3993e4d53$export$5069141294af4ee8), listener);
        };
    }, [
        dispatch,
        myEventEmitter,
        mySyncId
    ]);
}
function $0bebaaa81de07330$export$3a6efefeed76accf() {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useEffect)(()=>{
        dispatch((0, $9a03b151feb18982$export$abfecd6a8e6070c1)());
    }, [
        dispatch
    ]);
    $0bebaaa81de07330$var$useTooltipSyncEventsListener();
    $0bebaaa81de07330$var$useBrushSyncEventsListener();
}
function $0bebaaa81de07330$export$21f8394fb189b529(tooltipEventType, trigger, activeCoordinate, activeLabel, activeIndex, isTooltipActive) {
    var activeDataKey = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $0d9ada87ae089576$export$faa2b8b92235e5bd)(state, tooltipEventType, trigger));
    var eventEmitterSymbol = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$b89defd58e84e980));
    var syncId = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$d3b88e5c88540018));
    var syncMethod = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$f3cbf53653105e96));
    var tooltipState = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $fa5755e568b72f1c$export$54e3aed0d8d4a717));
    var isReceivingSynchronisation = tooltipState === null || tooltipState === void 0 ? void 0 : tooltipState.active;
    var viewBox = (0, $2d4a23e6670568d2$export$76b29bb074e0c45a)();
    (0, $aivMx.useEffect)(()=>{
        if (isReceivingSynchronisation) /*
       * This chart currently has active tooltip, synchronised from another chart.
       * Let's not send any outgoing synchronisation events while that's happening
       * to avoid infinite loops.
       */ return;
        if (syncId == null) /*
       * syncId is not set, means that this chart is not synchronised with any other chart,
       * means we don't need to send synchronisation events
       */ return;
        if (eventEmitterSymbol == null) /*
       * When using Recharts internal hooks and selectors outside charts context,
       * these properties will be undefined. Let's return silently instead of throwing an error.
       */ return;
        var syncAction = (0, $c54e506cc16ecb3e$export$f2efc99b98e50938)({
            active: isTooltipActive,
            coordinate: activeCoordinate,
            dataKey: activeDataKey,
            index: activeIndex,
            label: typeof activeLabel === 'number' ? String(activeLabel) : activeLabel,
            sourceViewBox: viewBox
        });
        (0, $948ceed3993e4d53$export$9bcdfe5f29bb33).emit((0, $948ceed3993e4d53$export$e2631176295fd79b), syncId, syncAction, eventEmitterSymbol);
    }, [
        isReceivingSynchronisation,
        activeCoordinate,
        activeDataKey,
        activeIndex,
        activeLabel,
        eventEmitterSymbol,
        syncId,
        syncMethod,
        isTooltipActive,
        viewBox
    ]);
}
function $0bebaaa81de07330$export$d3c93a99675de51f() {
    var syncId = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$d3b88e5c88540018));
    var eventEmitterSymbol = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $3eaa7bc41ed64724$export$b89defd58e84e980));
    var brushStartIndex = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>state.chartData.dataStartIndex);
    var brushEndIndex = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>state.chartData.dataEndIndex);
    (0, $aivMx.useEffect)(()=>{
        if (syncId == null || brushStartIndex == null || brushEndIndex == null || eventEmitterSymbol == null) return;
        var syncAction = {
            startIndex: brushStartIndex,
            endIndex: brushEndIndex
        };
        (0, $948ceed3993e4d53$export$9bcdfe5f29bb33).emit((0, $948ceed3993e4d53$export$5069141294af4ee8), syncId, syncAction, eventEmitterSymbol);
    }, [
        brushEndIndex,
        brushStartIndex,
        eventEmitterSymbol,
        syncId
    ]);
}




var $aivMx = parcelRequire("aivMx");




function $770c42e4598659d3$export$20f53c2c914d2da0() {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var [ref, setRef] = (0, $aivMx.useState)(null);
    var scale = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $122c64eee523dc50$export$317b55dda5fb5617));
    (0, $aivMx.useEffect)(()=>{
        if (ref == null) return;
        var rect = ref.getBoundingClientRect();
        var newScale = rect.width / ref.offsetWidth;
        if ((0, $c7c0820fc649c04a$export$f8a8fc612ced9bb0)(newScale) && newScale !== scale) dispatch((0, $909e1e5d36056665$export$4dc523f7f9b3edd6)(newScale));
    }, [
        ref,
        dispatch,
        scale
    ]);
    return setRef;
}





var $aivMx = parcelRequire("aivMx");
var $433c73e78ad72698$export$cf22c67346dd99a4 = /*#__PURE__*/ (0, $aivMx.createContext)(null);
var $433c73e78ad72698$export$2842d70d9d62127a = ()=>(0, $aivMx.useContext)($433c73e78ad72698$export$cf22c67346dd99a4);



var $aivMx = parcelRequire("aivMx");
var $15f21314b6c368a8$export$63a23315bebc1b2 = /*#__PURE__*/ (0, $aivMx.createContext)(null);
var $15f21314b6c368a8$export$36ebc0838785d4af = ()=>(0, $aivMx.useContext)($15f21314b6c368a8$export$63a23315bebc1b2);





function $3cbb05076134baa7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cbb05076134baa7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cbb05076134baa7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3cbb05076134baa7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cbb05076134baa7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3cbb05076134baa7$var$_defineProperty(e, r, t) {
    return (r = $3cbb05076134baa7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3cbb05076134baa7$var$_toPropertyKey(t) {
    var i = $3cbb05076134baa7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3cbb05076134baa7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3cbb05076134baa7$var$_extends() {
    return $3cbb05076134baa7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3cbb05076134baa7$var$_extends.apply(null, arguments);
}
var $3cbb05076134baa7$var$EventSynchronizer = ()=>{
    (0, $0bebaaa81de07330$export$3a6efefeed76accf)();
    return null;
};
function $3cbb05076134baa7$var$getNumberOrZero(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) return parsed;
    }
    return 0;
}
var $3cbb05076134baa7$var$ResponsiveDiv = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var _props$style, _props$style2;
    var observerRef = (0, $aivMx.useRef)(null);
    var [sizes, setSizes] = (0, $aivMx.useState)({
        containerWidth: $3cbb05076134baa7$var$getNumberOrZero((_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.width),
        containerHeight: $3cbb05076134baa7$var$getNumberOrZero((_props$style2 = props.style) === null || _props$style2 === void 0 ? void 0 : _props$style2.height)
    });
    var setContainerSize = (0, $aivMx.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $aivMx.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null && typeof ResizeObserver !== 'undefined') {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
            var callback = (entries)=>{
                var { width: width, height: height } = entries[0].contentRect;
                setContainerSize(width, height);
            };
            var observer = new ResizeObserver(callback);
            observer.observe(node);
            observerRef.current = observer;
        }
    }, [
        ref,
        setContainerSize
    ]);
    (0, $aivMx.useEffect)(()=>{
        return ()=>{
            var observer = observerRef.current;
            if (observer != null) observer.disconnect();
        };
    }, [
        setContainerSize
    ]);
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement((0, $2d4a23e6670568d2$export$80ea82e77fb424e1), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $aivMx.createElement("div", $3cbb05076134baa7$var$_extends({
        ref: innerRef
    }, props)));
});
var $3cbb05076134baa7$var$ReadSizeOnceDiv = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    var [sizes, setSizes] = (0, $aivMx.useState)({
        containerWidth: $3cbb05076134baa7$var$getNumberOrZero(width),
        containerHeight: $3cbb05076134baa7$var$getNumberOrZero(height)
    });
    var setContainerSize = (0, $aivMx.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $aivMx.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null) {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
        }
    }, [
        ref,
        setContainerSize
    ]);
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement((0, $2d4a23e6670568d2$export$80ea82e77fb424e1), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $aivMx.createElement("div", $3cbb05076134baa7$var$_extends({
        ref: innerRef
    }, props)));
});
var $3cbb05076134baa7$var$StaticDiv = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement((0, $2d4a23e6670568d2$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $aivMx.createElement("div", $3cbb05076134baa7$var$_extends({
        ref: ref
    }, props)));
});
var $3cbb05076134baa7$var$NonResponsiveDiv = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var { width: width, height: height } = props;
    if ((0, $9d9ad0197f7e4c2b$export$e50269385c77c348)(width) || (0, $9d9ad0197f7e4c2b$export$e50269385c77c348)(height)) return /*#__PURE__*/ $aivMx.createElement($3cbb05076134baa7$var$ReadSizeOnceDiv, $3cbb05076134baa7$var$_extends({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ $aivMx.createElement($3cbb05076134baa7$var$StaticDiv, $3cbb05076134baa7$var$_extends({}, props, {
        ref: ref
    }));
});
function $3cbb05076134baa7$var$getWrapperDivComponent(responsive) {
    return responsive === true ? $3cbb05076134baa7$var$ResponsiveDiv : $3cbb05076134baa7$var$NonResponsiveDiv;
}
var $3cbb05076134baa7$export$81bb7974a33f88b = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var { children: children, className: className, height: heightFromProps, onClick: onClick, onContextMenu: onContextMenu, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, style: style, width: widthFromProps, responsive: responsive, dispatchTouchEvents: dispatchTouchEvents = true } = props;
    var containerRef = (0, $aivMx.useRef)(null);
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var [tooltipPortal, setTooltipPortal] = (0, $aivMx.useState)(null);
    var [legendPortal, setLegendPortal] = (0, $aivMx.useState)(null);
    var setScaleRef = (0, $770c42e4598659d3$export$20f53c2c914d2da0)();
    var responsiveContainerCalculations = (0, $9acfa7cb966ff3a4$export$4ec9972d4f677af6)();
    var width = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.width) > 0 ? responsiveContainerCalculations.width : widthFromProps;
    var height = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.height) > 0 ? responsiveContainerCalculations.height : heightFromProps;
    var innerRef = (0, $aivMx.useCallback)((node)=>{
        setScaleRef(node);
        if (typeof ref === 'function') ref(node);
        setTooltipPortal(node);
        setLegendPortal(node);
        if (node != null) containerRef.current = node;
    }, [
        setScaleRef,
        ref,
        setTooltipPortal,
        setLegendPortal
    ]);
    var myOnClick = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $d687c2e98a898d0b$export$f06e14b484aecafc)(e));
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onClick
    ]);
    var myOnMouseEnter = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $d687c2e98a898d0b$export$f9de213dbfb2e32c)(e));
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onMouseEnter,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseEnter
    ]);
    var myOnMouseLeave = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $c54e506cc16ecb3e$export$73879bed3f2eef71)());
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onMouseLeave,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseLeave
    ]);
    var myOnMouseMove = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $d687c2e98a898d0b$export$f9de213dbfb2e32c)(e));
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onMouseMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseMove
    ]);
    var onFocus = (0, $aivMx.useCallback)(()=>{
        dispatch((0, $4db11ad80426f119$export$d95192eee5865567)());
    }, [
        dispatch
    ]);
    var onKeyDown = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $4db11ad80426f119$export$4839538efb7414c)(e.key));
    }, [
        dispatch
    ]);
    var myOnContextMenu = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onContextMenu,
            reactEvent: e
        }));
    }, [
        dispatch,
        onContextMenu
    ]);
    var myOnDoubleClick = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onDoubleClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onDoubleClick
    ]);
    var myOnMouseDown = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onMouseDown,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseDown
    ]);
    var myOnMouseUp = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onMouseUp,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseUp
    ]);
    var myOnTouchStart = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onTouchStart,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchStart
    ]);
    /*
   * onTouchMove is special because it behaves different from mouse events.
   * Mouse events have 'enter' + 'leave' combo that notify us when the mouse is over
   * a certain element. Touch events don't have that; touch only gives us
   * start (finger down), end (finger up) and move (finger moving).
   * So we need to figure out which element the user is touching
   * ourselves. Fortunately, there's a convenient method for that:
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementFromPoint
   */ var myOnTouchMove = (0, $aivMx.useCallback)((e)=>{
        if (dispatchTouchEvents) dispatch((0, $5464e0730956a384$export$ba46b5fda0e2985f)(e));
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onTouchMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        dispatchTouchEvents,
        onTouchMove
    ]);
    var myOnTouchEnd = (0, $aivMx.useCallback)((e)=>{
        dispatch((0, $cc02abb7d35aa02f$export$1d0268b9f89859f0)({
            handler: onTouchEnd,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchEnd
    ]);
    var WrapperDiv = $3cbb05076134baa7$var$getWrapperDivComponent(responsive);
    return /*#__PURE__*/ $aivMx.createElement((0, $433c73e78ad72698$export$cf22c67346dd99a4).Provider, {
        value: tooltipPortal
    }, /*#__PURE__*/ $aivMx.createElement((0, $15f21314b6c368a8$export$63a23315bebc1b2).Provider, {
        value: legendPortal
    }, /*#__PURE__*/ $aivMx.createElement(WrapperDiv, {
        width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width,
        height: height !== null && height !== void 0 ? height : style === null || style === void 0 ? void 0 : style.height,
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-wrapper', className),
        style: $3cbb05076134baa7$var$_objectSpread({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
        }, style),
        onClick: myOnClick,
        onContextMenu: myOnContextMenu,
        onDoubleClick: myOnDoubleClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: myOnMouseDown,
        onMouseEnter: myOnMouseEnter,
        onMouseLeave: myOnMouseLeave,
        onMouseMove: myOnMouseMove,
        onMouseUp: myOnMouseUp,
        onTouchEnd: myOnTouchEnd,
        onTouchMove: myOnTouchMove,
        onTouchStart: myOnTouchStart,
        ref: innerRef
    }, /*#__PURE__*/ $aivMx.createElement($3cbb05076134baa7$var$EventSynchronizer, null), children)));
});



var $aivMx = parcelRequire("aivMx");


var $57cfbdcff0aa6fcb$var$ClipPathIdContext = /*#__PURE__*/ (0, $aivMx.createContext)(undefined);
var $57cfbdcff0aa6fcb$export$8b42b9b49a38ca72 = (_ref)=>{
    var { children: children } = _ref;
    var [clipPathId] = (0, $aivMx.useState)("".concat((0, $9d9ad0197f7e4c2b$export$8b15d37bc3f197d4)('recharts'), "-clip"));
    var plotArea = (0, $c058c547db329017$export$f1ef8efc9ef6fe0c)();
    if (plotArea == null) return null;
    var { x: x, y: y, width: width, height: height } = plotArea;
    return /*#__PURE__*/ $aivMx.createElement($57cfbdcff0aa6fcb$var$ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ $aivMx.createElement("defs", null, /*#__PURE__*/ $aivMx.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $aivMx.createElement("rect", {
        x: x,
        y: y,
        height: height,
        width: width
    }))), children);
};
var $57cfbdcff0aa6fcb$export$71e825c43eae6ca6 = ()=>{
    return (0, $aivMx.useContext)($57cfbdcff0aa6fcb$var$ClipPathIdContext);
};




var $bf8fc15659d6b7b6$var$_excluded = [
    "width",
    "height",
    "responsive",
    "children",
    "className",
    "style",
    "compact",
    "title",
    "desc"
];
function $bf8fc15659d6b7b6$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bf8fc15659d6b7b6$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bf8fc15659d6b7b6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $bf8fc15659d6b7b6$export$d49e03133b3316a9 = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var { width: width, height: height, responsive: responsive, children: children, className: className, style: style, compact: compact, title: title, desc: desc } = props, others = $bf8fc15659d6b7b6$var$_objectWithoutProperties(props, $bf8fc15659d6b7b6$var$_excluded);
    var attrs = (0, $bf74bd062767a6f3$export$8b56257912140094)(others);
    /*
   * The "compact" mode is used as the panorama within Brush.
   * However because `compact` is a public prop, let's assume that it can render outside of Brush too.
   */ if (compact) return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement((0, $2d4a23e6670568d2$export$80ea82e77fb424e1), {
        width: width,
        height: height
    }), /*#__PURE__*/ $aivMx.createElement((0, $1a561f7aa634198a$export$b6c051d2e0bcd3e9), {
        otherAttributes: attrs,
        title: title,
        desc: desc
    }, children));
    return /*#__PURE__*/ $aivMx.createElement((0, $3cbb05076134baa7$export$81bb7974a33f88b), {
        className: className,
        style: style,
        width: width,
        height: height,
        responsive: responsive !== null && responsive !== void 0 ? responsive : false,
        onClick: props.onClick,
        onMouseLeave: props.onMouseLeave,
        onMouseEnter: props.onMouseEnter,
        onMouseMove: props.onMouseMove,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        onContextMenu: props.onContextMenu,
        onDoubleClick: props.onDoubleClick,
        onTouchStart: props.onTouchStart,
        onTouchMove: props.onTouchMove,
        onTouchEnd: props.onTouchEnd
    }, /*#__PURE__*/ $aivMx.createElement((0, $1a561f7aa634198a$export$b6c051d2e0bcd3e9), {
        otherAttributes: attrs,
        title: title,
        desc: desc,
        ref: ref
    }, /*#__PURE__*/ $aivMx.createElement((0, $57cfbdcff0aa6fcb$export$8b42b9b49a38ca72), null, children)));
});



function $12db2a0a1d5c03ed$var$_extends() {
    return $12db2a0a1d5c03ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $12db2a0a1d5c03ed$var$_extends.apply(null, arguments);
}
var $12db2a0a1d5c03ed$var$defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
var $12db2a0a1d5c03ed$var$defaultProps = {
    accessibilityLayer: true,
    layout: 'horizontal',
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: $12db2a0a1d5c03ed$var$defaultMargin,
    reverseStackOrder: false,
    syncMethod: 'index',
    responsive: false
};
var $12db2a0a1d5c03ed$export$855bb85b2910abc9 = /*#__PURE__*/ (0, $aivMx.forwardRef)(function CartesianChart(props, ref) {
    var _categoricalChartProp;
    var rootChartProps = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(props.categoricalChartProps, $12db2a0a1d5c03ed$var$defaultProps);
    var { chartName: chartName, defaultTooltipEventType: defaultTooltipEventType, validateTooltipEventTypes: validateTooltipEventTypes, tooltipPayloadSearcher: tooltipPayloadSearcher, categoricalChartProps: categoricalChartProps } = props;
    var options = {
        chartName: chartName,
        defaultTooltipEventType: defaultTooltipEventType,
        validateTooltipEventTypes: validateTooltipEventTypes,
        tooltipPayloadSearcher: tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ $aivMx.createElement((0, $d9644cbb81cad403$export$debe87639f2707f9), {
        preloadedState: {
            options: options
        },
        reduxStoreName: (_categoricalChartProp = categoricalChartProps.id) !== null && _categoricalChartProp !== void 0 ? _categoricalChartProp : chartName
    }, /*#__PURE__*/ $aivMx.createElement((0, $d94c6d6afa2971cf$export$2100a1dedbca0238), {
        chartData: categoricalChartProps.data
    }), /*#__PURE__*/ $aivMx.createElement((0, $cda7a91bff70ffe1$export$6faeaad6e02c2e9d), {
        layout: rootChartProps.layout,
        margin: rootChartProps.margin
    }), /*#__PURE__*/ $aivMx.createElement((0, $e07526bda954b171$export$6fabfb9ba230d12b), {
        baseValue: rootChartProps.baseValue,
        accessibilityLayer: rootChartProps.accessibilityLayer,
        barCategoryGap: rootChartProps.barCategoryGap,
        maxBarSize: rootChartProps.maxBarSize,
        stackOffset: rootChartProps.stackOffset,
        barGap: rootChartProps.barGap,
        barSize: rootChartProps.barSize,
        syncId: rootChartProps.syncId,
        syncMethod: rootChartProps.syncMethod,
        className: rootChartProps.className,
        reverseStackOrder: rootChartProps.reverseStackOrder
    }), /*#__PURE__*/ $aivMx.createElement((0, $bf8fc15659d6b7b6$export$d49e03133b3316a9), $12db2a0a1d5c03ed$var$_extends({}, rootChartProps, {
        ref: ref
    })));
});


var $6aece67ee1275fdb$var$allowedTooltipTypes = [
    'axis',
    'item'
];
var $6aece67ee1275fdb$export$94aefc399ef206a9 = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $aivMx.createElement((0, $12db2a0a1d5c03ed$export$855bb85b2910abc9), {
        chartName: "BarChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $6aece67ee1275fdb$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $9a03b151feb18982$export$3d996ff386c7802d),
        categoricalChartProps: props,
        ref: ref
    });
});


var $aivMx = parcelRequire("aivMx");






function $aec65e585a7cff12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aec65e585a7cff12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aec65e585a7cff12$var$ownKeys(Object(t), !0).forEach(function(r) {
            $aec65e585a7cff12$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aec65e585a7cff12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $aec65e585a7cff12$var$_defineProperty(e, r, t) {
    return (r = $aec65e585a7cff12$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $aec65e585a7cff12$var$_toPropertyKey(t) {
    var i = $aec65e585a7cff12$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $aec65e585a7cff12$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $aec65e585a7cff12$export$c7964a5b9439ae62 = (_ref, _ref2)=>{
    var { x: x1, y: y1 } = _ref;
    var { x: x2, y: y2 } = _ref2;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $aec65e585a7cff12$export$6df2062b9e15eec0 = (_ref3)=>{
    var { x1: x1, y1: y1, x2: x2, y2: y2 } = _ref3;
    return $aec65e585a7cff12$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
class $aec65e585a7cff12$export$dae1ac4449a69ee8 {
    static create(obj) {
        return new $aec65e585a7cff12$export$dae1ac4449a69ee8(obj);
    }
    constructor(scale){
        this.scale = scale;
    }
    get domain() {
        return this.scale.domain;
    }
    get range() {
        return this.scale.range;
    }
    get rangeMin() {
        return this.range()[0];
    }
    get rangeMax() {
        return this.range()[1];
    }
    get bandwidth() {
        return this.scale.bandwidth;
    }
    apply(value) {
        var { bandAware: bandAware, position: position } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (value === undefined) return undefined;
        if (position) switch(position){
            case 'start':
                return this.scale(value);
            case 'middle':
                var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                return this.scale(value) + offset;
            case 'end':
                var _offset = this.bandwidth ? this.bandwidth() : 0;
                return this.scale(value) + _offset;
            default:
                return this.scale(value);
        }
        if (bandAware) {
            var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(value) + _offset2;
        }
        return this.scale(value);
    }
    isInRange(value) {
        var range = this.range();
        var first = range[0];
        var last = range[range.length - 1];
        return first <= last ? value >= first && value <= last : value >= last && value <= first;
    }
}
$aec65e585a7cff12$var$_defineProperty($aec65e585a7cff12$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $aec65e585a7cff12$export$db77ae668c18269f = (options)=>{
    var scales = Object.keys(options).reduce((res, key)=>$aec65e585a7cff12$var$_objectSpread($aec65e585a7cff12$var$_objectSpread({}, res), {}, {
            [key]: $aec65e585a7cff12$export$dae1ac4449a69ee8.create(options[key])
        }), {});
    return $aec65e585a7cff12$var$_objectSpread($aec65e585a7cff12$var$_objectSpread({}, scales), {}, {
        apply (coord) {
            var { bandAware: bandAware, position: position } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return Object.fromEntries(Object.entries(coord).map((_ref4)=>{
                var [label, value] = _ref4;
                return [
                    label,
                    scales[label].apply(value, {
                        bandAware: bandAware,
                        position: position
                    })
                ];
            }));
        },
        isInRange (coord) {
            return Object.keys(coord).every((label)=>scales[label].isInRange(coord[label]));
        }
    });
};
function $aec65e585a7cff12$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $aec65e585a7cff12$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref5) {
    var { width: width, height: height } = _ref5;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $aec65e585a7cff12$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * For n equal to 1, the input array is returned as is.
 * For n greater than the length of the array, an array containing the first element
 * and every nTh element after that (if any) is returned.
 *
 * @param array An input array.
 * @param n A number specifying which elements to take.
 * @returns The result array of the same type as the input array.
 */ function $f3d895b633f7570a$export$41514b9f058a6886(array, n) {
    if (n < 1) return [];
    if (n === 1) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n)result.push(array[i]);
    return result;
}


function $aa9d14bb938eacb9$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $aec65e585a7cff12$export$3ee78d51cffc2b68)(size, angle);
}
function $aa9d14bb938eacb9$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var { x: x, y: y, width: width, height: height } = viewBox;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $aa9d14bb938eacb9$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $aa9d14bb938eacb9$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $f3d895b633f7570a$export$41514b9f058a6886)(ticks, interval + 1);
}




function $14b95d78ed688bf7$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    var result = (ticks || []).slice();
    var { start: initialStart, end: end } = boundaries;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluated all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $f3d895b633f7570a$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $aa9d14bb938eacb9$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $9522609de51c9b8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9522609de51c9b8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9522609de51c9b8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9522609de51c9b8e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9522609de51c9b8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9522609de51c9b8e$var$_defineProperty(e, r, t) {
    return (r = $9522609de51c9b8e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9522609de51c9b8e$var$_toPropertyKey(t) {
    var i = $9522609de51c9b8e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9522609de51c9b8e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9522609de51c9b8e$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var { start: start } = boundaries;
    var { end: end } = boundaries;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $9522609de51c9b8e$var$_objectSpread($9522609de51c9b8e$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $9522609de51c9b8e$var$_objectSpread($9522609de51c9b8e$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $aa9d14bb938eacb9$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
                result[i] = $9522609de51c9b8e$var$_objectSpread($9522609de51c9b8e$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $9522609de51c9b8e$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    // This method is mutating the array so clone is indeed necessary here
    var result = (ticks || []).slice();
    var len = result.length;
    var { start: start, end: end } = boundaries;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $9522609de51c9b8e$var$_objectSpread($9522609de51c9b8e$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        if (tail.tickCoord != null) {
            var isTailShow = (0, $aa9d14bb938eacb9$export$795910f5f15a9633)(sign, tail.tickCoord, ()=>tailSize, start, end);
            if (isTailShow) {
                end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
                result[len - 1] = $9522609de51c9b8e$var$_objectSpread($9522609de51c9b8e$var$_objectSpread({}, tail), {}, {
                    isShow: true
                });
            }
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $9522609de51c9b8e$var$_objectSpread($9522609de51c9b8e$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $9522609de51c9b8e$var$_objectSpread($9522609de51c9b8e$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $aa9d14bb938eacb9$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
                result[i] = $9522609de51c9b8e$var$_objectSpread($9522609de51c9b8e$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $9522609de51c9b8e$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var { tick: tick, ticks: ticks, viewBox: viewBox, minTickGap: minTickGap, orientation: orientation, interval: interval, tickFormatter: tickFormatter, unit: unit, angle: angle } = props;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(interval) || (0, $a898dc03dc17f75a$export$98f03c5d19621d70).isSsr) {
        var _getNumberIntervalTic;
        return (_getNumberIntervalTic = (0, $aa9d14bb938eacb9$export$beeebbe3ff1b306b)(ticks, (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(interval) ? interval : 0)) !== null && _getNumberIntervalTic !== void 0 ? _getNumberIntervalTic : [];
    }
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $3cfe37fe7cebaf4e$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = (content, index)=>{
        var value = typeof tickFormatter === 'function' ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $aa9d14bb938eacb9$export$a1966f4ad955c82b)((0, $3cfe37fe7cebaf4e$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $3cfe37fe7cebaf4e$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $aa9d14bb938eacb9$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $14b95d78ed688bf7$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $9522609de51c9b8e$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $9522609de51c9b8e$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter((entry)=>entry.isShow);
}



var $aivMx = parcelRequire("aivMx");









/**
 * Calculates the width of the Y-axis based on the tick labels and the axis label.
 * @param params - The parameters object.
 * @param [params.ticks] - An array-like object of tick elements, each with a `getBoundingClientRect` method.
 * @param [params.label] - The axis label element, with a `getBoundingClientRect` method.
 * @param [params.labelGapWithTick=5] - The gap between the label and the tick.
 * @param [params.tickSize=0] - The length of the tick line.
 * @param [params.tickMargin=0] - The margin between the tick line and the tick text.
 * @returns The calculated width of the Y-axis.
 */ var $3c916a6098324428$export$b70f70a4fdbed242 = (_ref)=>{
    var { ticks: ticks, label: label, labelGapWithTick: labelGapWithTick = 5, tickSize: // Default gap between label and tick
    tickSize = 0, tickMargin: tickMargin = 0 } = _ref;
    // find the max width of the tick labels
    var maxTickWidth = 0;
    if (ticks) {
        Array.from(ticks).forEach((tickNode)=>{
            if (tickNode) {
                var bbox = tickNode.getBoundingClientRect();
                if (bbox.width > maxTickWidth) maxTickWidth = bbox.width;
            }
        });
        // calculate width of the axis label
        var labelWidth = label ? label.getBoundingClientRect().width : 0;
        var tickWidth = tickSize + tickMargin;
        // calculate the updated width of the y-axis
        var updatedYAxisWidth = maxTickWidth + tickWidth + labelWidth + (label ? labelGapWithTick : 0);
        return Math.round(updatedYAxisWidth);
    }
    return 0;
};





var $5c8c13823a5e3ea8$var$_excluded = [
    "axisLine",
    "width",
    "height",
    "className",
    "hide",
    "ticks",
    "axisType"
];
function $5c8c13823a5e3ea8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $5c8c13823a5e3ea8$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $5c8c13823a5e3ea8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $5c8c13823a5e3ea8$var$_extends() {
    return $5c8c13823a5e3ea8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5c8c13823a5e3ea8$var$_extends.apply(null, arguments);
}
function $5c8c13823a5e3ea8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c8c13823a5e3ea8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c8c13823a5e3ea8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5c8c13823a5e3ea8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c8c13823a5e3ea8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5c8c13823a5e3ea8$var$_defineProperty(e, r, t) {
    return (r = $5c8c13823a5e3ea8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5c8c13823a5e3ea8$var$_toPropertyKey(t) {
    var i = $5c8c13823a5e3ea8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5c8c13823a5e3ea8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5c8c13823a5e3ea8$export$179c35154a9748c0 = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd',
    zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).axis
};
/*
 * `viewBox` and `scale` are SVG attributes.
 * Recharts however - unfortunately - has its own attributes named `viewBox` and `scale`
 * that are completely different data shape and different purpose.
 */ function $5c8c13823a5e3ea8$var$AxisLine(axisLineProps) {
    var { x: x, y: y, width: width, height: height, orientation: orientation, mirror: mirror, axisLine: axisLine, otherSvgProps: otherSvgProps } = axisLineProps;
    if (!axisLine) return null;
    var props = $5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread({}, otherSvgProps), (0, $bf74bd062767a6f3$export$8b56257912140094)(axisLine)), {}, {
        fill: 'none'
    });
    if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
        props = $5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: y + needHeight * height,
            x2: x + width,
            y2: y + needHeight * height
        });
    } else {
        var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
        props = $5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread({}, props), {}, {
            x1: x + needWidth * width,
            y1: y,
            x2: x + needWidth * width,
            y2: y + height
        });
    }
    return /*#__PURE__*/ $aivMx.createElement("line", $5c8c13823a5e3ea8$var$_extends({}, props, {
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($a7b626aae7e6649e$exports)))(axisLine, 'className'))
    }));
}
/**
 * Calculate the coordinates of endpoints in ticks.
 * @param data The data of a simple tick.
 * @param x The x-coordinate of the axis.
 * @param y The y-coordinate of the axis.
 * @param width The width of the axis.
 * @param height The height of the axis.
 * @param orientation The orientation of the axis.
 * @param tickSize The length of the tick line.
 * @param mirror If true, the ticks are mirrored.
 * @param tickMargin The margin between the tick line and the tick text.
 * @returns An object with `line` and `tick` coordinates.
 * `line` is the coordinates for the tick line, and `tick` is the coordinate for the tick text.
 */ function $5c8c13823a5e3ea8$var$getTickLineCoord(data, x, y, width, height, orientation, tickSize, mirror, tickMargin) {
    var x1, x2, y1, y2, tx, ty;
    var sign = mirror ? -1 : 1;
    var finalTickSize = data.tickSize || tickSize;
    var tickCoord = (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
    switch(orientation){
        case 'top':
            x1 = x2 = data.coordinate;
            y2 = y + +!mirror * height;
            y1 = y2 - sign * finalTickSize;
            ty = y1 - sign * tickMargin;
            tx = tickCoord;
            break;
        case 'left':
            y1 = y2 = data.coordinate;
            x2 = x + +!mirror * width;
            x1 = x2 - sign * finalTickSize;
            tx = x1 - sign * tickMargin;
            ty = tickCoord;
            break;
        case 'right':
            y1 = y2 = data.coordinate;
            x2 = x + +mirror * width;
            x1 = x2 + sign * finalTickSize;
            tx = x1 + sign * tickMargin;
            ty = tickCoord;
            break;
        default:
            x1 = x2 = data.coordinate;
            y2 = y + +mirror * height;
            y1 = y2 + sign * finalTickSize;
            ty = y1 + sign * tickMargin;
            tx = tickCoord;
            break;
    }
    return {
        line: {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        },
        tick: {
            x: tx,
            y: ty
        }
    };
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The text anchor of the tick.
 */ function $5c8c13823a5e3ea8$var$getTickTextAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
            return mirror ? 'start' : 'end';
        case 'right':
            return mirror ? 'end' : 'start';
        default:
            return 'middle';
    }
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The vertical text anchor of the tick.
 */ function $5c8c13823a5e3ea8$var$getTickVerticalAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
        case 'right':
            return 'middle';
        case 'top':
            return mirror ? 'start' : 'end';
        default:
            return mirror ? 'end' : 'start';
    }
}
function $5c8c13823a5e3ea8$var$TickItem(props) {
    var { option: option, tickProps: tickProps, value: value } = props;
    var tickItem;
    var combinedClassName = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)(tickProps.className, 'recharts-cartesian-axis-tick-value');
    if (/*#__PURE__*/ $aivMx.isValidElement(option)) // @ts-expect-error element cloning is not typed
    tickItem = /*#__PURE__*/ $aivMx.cloneElement(option, $5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else if (typeof option === 'function') tickItem = option($5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else {
        var className = 'recharts-cartesian-axis-tick-value';
        if (typeof option !== 'boolean') className = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)(className, option === null || option === void 0 ? void 0 : option.className);
        tickItem = /*#__PURE__*/ $aivMx.createElement((0, $79fae2d735abd531$export$5f1af8db9871e1d6), $5c8c13823a5e3ea8$var$_extends({}, tickProps, {
            className: className
        }), value);
    }
    return tickItem;
}
var $5c8c13823a5e3ea8$var$Ticks = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var { ticks: ticks = [], tick: tick, tickLine: tickLine, stroke: stroke, tickFormatter: tickFormatter, unit: unit, padding: padding, tickTextProps: tickTextProps, orientation: orientation, mirror: mirror, x: x, y: y, width: width, height: height, tickSize: tickSize, tickMargin: tickMargin, fontSize: fontSize, letterSpacing: letterSpacing, getTicksConfig: getTicksConfig, events: events, axisType: axisType } = props;
    // @ts-expect-error some properties are optional in props but required in getTicks
    var finalTicks = (0, $9522609de51c9b8e$export$3d27d42b1034de5c)($5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread({}, getTicksConfig), {}, {
        ticks: ticks
    }), fontSize, letterSpacing);
    var textAnchor = $5c8c13823a5e3ea8$var$getTickTextAnchor(orientation, mirror);
    var verticalAnchor = $5c8c13823a5e3ea8$var$getTickVerticalAnchor(orientation, mirror);
    var axisProps = (0, $bf74bd062767a6f3$export$8b56257912140094)(getTicksConfig);
    var customTickProps = (0, $bf74bd062767a6f3$export$6d5921c09aa671a9)(tick);
    var tickLinePropsObject = {};
    if (typeof tickLine === 'object') tickLinePropsObject = tickLine;
    var tickLineProps = $5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread({}, axisProps), {}, {
        fill: 'none'
    }, tickLinePropsObject);
    var tickLineCoords = finalTicks.map((entry)=>$5c8c13823a5e3ea8$var$_objectSpread({
            entry: entry
        }, $5c8c13823a5e3ea8$var$getTickLineCoord(entry, x, y, width, height, orientation, tickSize, mirror, tickMargin)));
    var tickLines = tickLineCoords.map((_ref)=>{
        var { entry: entry, line: lineCoord } = _ref;
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, tickLine && /*#__PURE__*/ $aivMx.createElement("line", $5c8c13823a5e3ea8$var$_extends({}, tickLineProps, lineCoord, {
            className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($a7b626aae7e6649e$exports)))(tickLine, 'className'))
        })));
    });
    var tickLabels = tickLineCoords.map((_ref2, i)=>{
        var { entry: entry, tick: tickCoord } = _ref2;
        var tickProps = $5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread($5c8c13823a5e3ea8$var$_objectSpread({
            textAnchor: // @ts-expect-error textAnchor from axisProps is typed as `string` but Text wants type `TextAnchor`
            textAnchor,
            verticalAnchor: verticalAnchor
        }, axisProps), {}, {
            // @ts-expect-error customTickProps is contributing unknown props
            stroke: 'none',
            // @ts-expect-error customTickProps is contributing unknown props
            fill: stroke
        }, customTickProps), tickCoord), {}, {
            index: i,
            payload: entry,
            visibleTicksCount: finalTicks.length,
            tickFormatter: tickFormatter,
            padding: padding
        }, tickTextProps);
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), $5c8c13823a5e3ea8$var$_extends({
            className: "recharts-cartesian-axis-tick-label",
            key: "tick-label-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, (0, $1ea0ac8e1739d80a$export$ca62be0d67a3158c)(events, entry, i)), tick && /*#__PURE__*/ $aivMx.createElement($5c8c13823a5e3ea8$var$TickItem, {
            option: tick,
            tickProps: tickProps,
            value: "".concat(typeof tickFormatter === 'function' ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')
        }));
    });
    return /*#__PURE__*/ $aivMx.createElement("g", {
        className: "recharts-cartesian-axis-ticks recharts-".concat(axisType, "-ticks")
    }, tickLabels.length > 0 && /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).label
    }, /*#__PURE__*/ $aivMx.createElement("g", {
        className: "recharts-cartesian-axis-tick-labels recharts-".concat(axisType, "-tick-labels"),
        ref: ref
    }, tickLabels)), tickLines.length > 0 && /*#__PURE__*/ $aivMx.createElement("g", {
        className: "recharts-cartesian-axis-tick-lines recharts-".concat(axisType, "-tick-lines")
    }, tickLines));
});
var $5c8c13823a5e3ea8$var$CartesianAxisComponent = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var { axisLine: axisLine, width: width, height: height, className: className, hide: hide, ticks: ticks, axisType: axisType } = props, rest = $5c8c13823a5e3ea8$var$_objectWithoutProperties(props, $5c8c13823a5e3ea8$var$_excluded);
    var [fontSize, setFontSize] = (0, $aivMx.useState)('');
    var [letterSpacing, setLetterSpacing] = (0, $aivMx.useState)('');
    var tickRefs = (0, $aivMx.useRef)(null);
    (0, $aivMx.useImperativeHandle)(ref, ()=>({
            getCalculatedWidth: ()=>{
                var _props$labelRef;
                return (0, $3c916a6098324428$export$b70f70a4fdbed242)({
                    ticks: tickRefs.current,
                    label: (_props$labelRef = props.labelRef) === null || _props$labelRef === void 0 ? void 0 : _props$labelRef.current,
                    labelGapWithTick: 5,
                    tickSize: props.tickSize,
                    tickMargin: props.tickMargin
                });
            }
        }));
    var layerRef = (0, $aivMx.useCallback)((el)=>{
        if (el) {
            var tickNodes = el.getElementsByClassName('recharts-cartesian-axis-tick-value');
            tickRefs.current = tickNodes;
            var tick = tickNodes[0];
            if (tick) {
                var computedStyle = window.getComputedStyle(tick);
                var calculatedFontSize = computedStyle.fontSize;
                var calculatedLetterSpacing = computedStyle.letterSpacing;
                if (calculatedFontSize !== fontSize || calculatedLetterSpacing !== letterSpacing) {
                    setFontSize(calculatedFontSize);
                    setLetterSpacing(calculatedLetterSpacing);
                }
            }
        }
    }, [
        fontSize,
        letterSpacing
    ]);
    if (hide) return null;
    /*
   * This is different condition from what validateWidthHeight is doing;
   * the CartesianAxis does allow width or height to be undefined.
   */ if (width != null && width <= 0 || height != null && height <= 0) return null;
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-cartesian-axis', className)
    }, /*#__PURE__*/ $aivMx.createElement($5c8c13823a5e3ea8$var$AxisLine, {
        x: props.x,
        y: props.y,
        width: width,
        height: height,
        orientation: props.orientation,
        mirror: props.mirror,
        axisLine: axisLine,
        otherSvgProps: (0, $bf74bd062767a6f3$export$8b56257912140094)(props)
    }), /*#__PURE__*/ $aivMx.createElement($5c8c13823a5e3ea8$var$Ticks, {
        ref: layerRef,
        axisType: axisType,
        events: rest,
        fontSize: fontSize,
        getTicksConfig: props,
        height: props.height,
        letterSpacing: letterSpacing,
        mirror: props.mirror,
        orientation: props.orientation,
        padding: props.padding,
        stroke: props.stroke,
        tick: props.tick,
        tickFormatter: props.tickFormatter,
        tickLine: props.tickLine,
        tickMargin: props.tickMargin,
        tickSize: props.tickSize,
        tickTextProps: props.tickTextProps,
        ticks: ticks,
        unit: props.unit,
        width: props.width,
        x: props.x,
        y: props.y
    }), /*#__PURE__*/ $aivMx.createElement((0, $23f34369f47c7824$export$3b4df77eaec10b03), {
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height,
        lowerWidth: props.width,
        upperWidth: props.width
    }, /*#__PURE__*/ $aivMx.createElement((0, $23f34369f47c7824$export$3c82c3a3704539d8), {
        label: props.label,
        labelRef: props.labelRef
    }), props.children)));
});
var $5c8c13823a5e3ea8$export$bdd99f2cdf352bae = /*#__PURE__*/ $aivMx.forwardRef((outsideProps, ref)=>{
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $5c8c13823a5e3ea8$export$179c35154a9748c0);
    return /*#__PURE__*/ $aivMx.createElement($5c8c13823a5e3ea8$var$CartesianAxisComponent, $5c8c13823a5e3ea8$var$_extends({}, props, {
        ref: ref
    }));
});
$5c8c13823a5e3ea8$export$bdd99f2cdf352bae.displayName = 'CartesianAxis';











var $4c34854e9934dcaa$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $4c34854e9934dcaa$var$_excluded2 = [
    "offset"
], $4c34854e9934dcaa$var$_excluded3 = [
    "xAxisId",
    "yAxisId"
], $4c34854e9934dcaa$var$_excluded4 = [
    "xAxisId",
    "yAxisId"
];
function $4c34854e9934dcaa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c34854e9934dcaa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c34854e9934dcaa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4c34854e9934dcaa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c34854e9934dcaa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4c34854e9934dcaa$var$_defineProperty(e, r, t) {
    return (r = $4c34854e9934dcaa$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c34854e9934dcaa$var$_toPropertyKey(t) {
    var i = $4c34854e9934dcaa$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c34854e9934dcaa$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4c34854e9934dcaa$var$_extends() {
    return $4c34854e9934dcaa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4c34854e9934dcaa$var$_extends.apply(null, arguments);
}
function $4c34854e9934dcaa$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4c34854e9934dcaa$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4c34854e9934dcaa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * The <CartesianGrid horizontal
 */ var $4c34854e9934dcaa$var$Background = (props)=>{
    var { fill: fill } = props;
    if (!fill || fill === 'none') return null;
    var { fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, ry: ry } = props;
    return /*#__PURE__*/ $aivMx.createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $4c34854e9934dcaa$var$LineItem(_ref) {
    var { option: option, lineItemProps: lineItemProps } = _ref;
    var lineItem;
    if (/*#__PURE__*/ $aivMx.isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ $aivMx.cloneElement(option, lineItemProps);
    else if (typeof option === 'function') lineItem = option(lineItemProps);
    else {
        var _svgPropertiesNoEvent;
        var { x1: x1, y1: y1, x2: x2, y2: y2, key: key } = lineItemProps, others = $4c34854e9934dcaa$var$_objectWithoutProperties(lineItemProps, $4c34854e9934dcaa$var$_excluded);
        var _ref2 = (_svgPropertiesNoEvent = (0, $bf74bd062767a6f3$export$8b56257912140094)(others)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, { offset: __ } = _ref2, restOfFilteredProps = $4c34854e9934dcaa$var$_objectWithoutProperties(_ref2, $4c34854e9934dcaa$var$_excluded2);
        lineItem = /*#__PURE__*/ $aivMx.createElement("line", $4c34854e9934dcaa$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $4c34854e9934dcaa$var$HorizontalGridLines(props) {
    var { x: x, width: width, horizontal: horizontal = true, horizontalPoints: horizontalPoints } = props;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var { xAxisId: xAxisId, yAxisId: yAxisId } = props, otherLineItemProps = $4c34854e9934dcaa$var$_objectWithoutProperties(props, $4c34854e9934dcaa$var$_excluded3);
    var items = horizontalPoints.map((entry, i)=>{
        var lineItemProps = $4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $aivMx.createElement($4c34854e9934dcaa$var$LineItem, {
            key: "line-".concat(i),
            option: horizontal,
            lineItemProps: lineItemProps
        });
    });
    return /*#__PURE__*/ $aivMx.createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $4c34854e9934dcaa$var$VerticalGridLines(props) {
    var { y: y, height: height, vertical: vertical = true, verticalPoints: verticalPoints } = props;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var { xAxisId: xAxisId, yAxisId: yAxisId } = props, otherLineItemProps = $4c34854e9934dcaa$var$_objectWithoutProperties(props, $4c34854e9934dcaa$var$_excluded4);
    var items = verticalPoints.map((entry, i)=>{
        var lineItemProps = $4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $aivMx.createElement($4c34854e9934dcaa$var$LineItem, {
            option: vertical,
            lineItemProps: lineItemProps,
            key: "line-".concat(i)
        });
    });
    return /*#__PURE__*/ $aivMx.createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $4c34854e9934dcaa$var$HorizontalStripes(props) {
    var { horizontalFill: horizontalFill, fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, horizontalPoints: horizontalPoints, horizontal: horizontal = true } = props;
    if (!horizontal || !horizontalFill || !horizontalFill.length || horizontalPoints == null) return null;
    var roundedSortedHorizontalPoints = horizontalPoints.map((e)=>Math.round(e + y - y)).sort((a, b)=>a - b);
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map((entry, i)=>{
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ $aivMx.createElement("rect", {
            key: "react-".concat(i),
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $aivMx.createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $4c34854e9934dcaa$var$VerticalStripes(props) {
    var { vertical: vertical = true, verticalFill: verticalFill, fillOpacity: fillOpacity, x: x, y: y, width: width, height: height, verticalPoints: verticalPoints } = props;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map((e)=>Math.round(e + x - x)).sort((a, b)=>a - b);
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map((entry, i)=>{
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ $aivMx.createElement("rect", {
            key: "react-".concat(i),
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $aivMx.createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $4c34854e9934dcaa$var$defaultVerticalCoordinatesGenerator = (_ref3, syncWithTicks)=>{
    var { xAxis: xAxis, width: width, height: height, offset: offset } = _ref3;
    return (0, $09206e1485e62bdb$export$846dc5ac5fecff74)((0, $9522609de51c9b8e$export$3d27d42b1034de5c)($4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread({}, (0, $5c8c13823a5e3ea8$export$179c35154a9748c0)), xAxis), {}, {
        ticks: (0, $09206e1485e62bdb$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $4c34854e9934dcaa$var$defaultHorizontalCoordinatesGenerator = (_ref4, syncWithTicks)=>{
    var { yAxis: yAxis, width: width, height: height, offset: offset } = _ref4;
    return (0, $09206e1485e62bdb$export$846dc5ac5fecff74)((0, $9522609de51c9b8e$export$3d27d42b1034de5c)($4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread({}, (0, $5c8c13823a5e3ea8$export$179c35154a9748c0)), yAxis), {}, {
        ticks: (0, $09206e1485e62bdb$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $4c34854e9934dcaa$export$58f1dfa394f98e54 = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: [],
    xAxisId: 0,
    yAxisId: 0,
    syncWithTicks: false,
    zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).grid
};
function $4c34854e9934dcaa$export$6440e27b9f186856(props) {
    var chartWidth = (0, $2d4a23e6670568d2$export$8854f7ece606854b)();
    var chartHeight = (0, $2d4a23e6670568d2$export$369ae257969c6f9f)();
    var offset = (0, $2d4a23e6670568d2$export$10605f61bef2858a)();
    var propsIncludingDefaults = $4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread({}, (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(props, $4c34854e9934dcaa$export$58f1dfa394f98e54)), {}, {
        x: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var { xAxisId: xAxisId, yAxisId: yAxisId, x: x, y: y, width: width, height: height, syncWithTicks: syncWithTicks, horizontalValues: horizontalValues, verticalValues: verticalValues } = propsIncludingDefaults;
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var xAxis = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$45cd57660792dd31)(state, 'xAxis', xAxisId, isPanorama));
    var yAxis = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$45cd57660792dd31)(state, 'yAxis', yAxisId, isPanorama));
    if (!(0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(width) || !(0, $c7c0820fc649c04a$export$5374bb854d0e41c8)(height) || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(x) || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(y)) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $4c34854e9934dcaa$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $4c34854e9934dcaa$var$defaultHorizontalCoordinatesGenerator;
    var { horizontalPoints: horizontalPoints, verticalPoints: verticalPoints } = propsIncludingDefaults;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && typeof horizontalCoordinatesGenerator === 'function') {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $0b9d7895420683f6$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(typeof generatorResult, "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && typeof verticalCoordinatesGenerator === 'function') {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $4c34854e9934dcaa$var$_objectSpread($4c34854e9934dcaa$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $0b9d7895420683f6$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(typeof _generatorResult, "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: propsIncludingDefaults.zIndex
    }, /*#__PURE__*/ $aivMx.createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ $aivMx.createElement($4c34854e9934dcaa$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ $aivMx.createElement($4c34854e9934dcaa$var$HorizontalStripes, $4c34854e9934dcaa$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ $aivMx.createElement($4c34854e9934dcaa$var$VerticalStripes, $4c34854e9934dcaa$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })), /*#__PURE__*/ $aivMx.createElement($4c34854e9934dcaa$var$HorizontalGridLines, $4c34854e9934dcaa$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ $aivMx.createElement($4c34854e9934dcaa$var$VerticalGridLines, $4c34854e9934dcaa$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    }))));
}
$4c34854e9934dcaa$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $aivMx = parcelRequire("aivMx");
var $cf64ee5d4289032b$exports = {};

$cf64ee5d4289032b$exports = (parcelRequire("b40KW")).omit;












var $aivMx = parcelRequire("aivMx");

function $1ee59f1c1a598bde$var$_extends() {
    return $1ee59f1c1a598bde$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1ee59f1c1a598bde$var$_extends.apply(null, arguments);
}
function $1ee59f1c1a598bde$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ee59f1c1a598bde$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ee59f1c1a598bde$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1ee59f1c1a598bde$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ee59f1c1a598bde$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1ee59f1c1a598bde$var$_defineProperty(e, r, t) {
    return (r = $1ee59f1c1a598bde$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1ee59f1c1a598bde$var$_toPropertyKey(t) {
    var i = $1ee59f1c1a598bde$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1ee59f1c1a598bde$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1ee59f1c1a598bde$export$332d7bd484c543f0(option, props) {
    var xValue = "".concat(props.x || option.x);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(props.y || option.y);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat((props === null || props === void 0 ? void 0 : props.height) || (option === null || option === void 0 ? void 0 : option.height));
    var height = parseInt(heightValue, 10);
    return $1ee59f1c1a598bde$var$_objectSpread($1ee59f1c1a598bde$var$_objectSpread($1ee59f1c1a598bde$var$_objectSpread({}, props), (0, $333e6f5e0fe541db$export$33c4f706a443da24)(option)), {}, {
        height: height,
        x: x,
        y: y
    });
}
function $1ee59f1c1a598bde$export$80e1cf105b9e876a(props) {
    return /*#__PURE__*/ $aivMx.createElement((0, $333e6f5e0fe541db$export$6428a7f2611ef1fa), $1ee59f1c1a598bde$var$_extends({
        shapeType: "trapezoid",
        propTransformer: $1ee59f1c1a598bde$export$332d7bd484c543f0
    }, props));
}








function $2fc561df7974ffb1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2fc561df7974ffb1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2fc561df7974ffb1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2fc561df7974ffb1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2fc561df7974ffb1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2fc561df7974ffb1$var$_defineProperty(e, r, t) {
    return (r = $2fc561df7974ffb1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2fc561df7974ffb1$var$_toPropertyKey(t) {
    var i = $2fc561df7974ffb1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2fc561df7974ffb1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2fc561df7974ffb1$var$pickFunnelSettings = (_state, funnelSettings)=>funnelSettings;
var $2fc561df7974ffb1$export$b3c86f0c96313f81 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b),
    $2fc561df7974ffb1$var$pickFunnelSettings,
    (0, $695f2ef1b702f419$export$3b10e41b7db2c36)
], (offset, _ref, _ref2)=>{
    var { data: data, dataKey: dataKey, nameKey: nameKey, tooltipType: tooltipType, lastShapeType: lastShapeType, reversed: reversed, customWidth: customWidth, cells: cells, presentationProps: presentationProps } = _ref;
    var { chartData: chartData } = _ref2;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else if (chartData != null && chartData.length > 0) displayedData = chartData;
    if (displayedData && displayedData.length) displayedData = displayedData.map((entry, index)=>$2fc561df7974ffb1$var$_objectSpread($2fc561df7974ffb1$var$_objectSpread($2fc561df7974ffb1$var$_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props));
    else if (cells && cells.length) displayedData = cells.map((cell)=>$2fc561df7974ffb1$var$_objectSpread($2fc561df7974ffb1$var$_objectSpread({}, presentationProps), cell.props));
    else return [];
    return (0, $8bbf77ab6cef1b16$export$89c97daba8cb5a5a)({
        dataKey: dataKey,
        nameKey: nameKey,
        displayedData: displayedData,
        tooltipType: tooltipType,
        lastShapeType: lastShapeType,
        reversed: reversed,
        offset: offset,
        customWidth: customWidth
    });
});









var $8bbf77ab6cef1b16$var$_excluded = [
    "onMouseEnter",
    "onClick",
    "onMouseLeave",
    "shape",
    "activeShape"
], $8bbf77ab6cef1b16$var$_excluded2 = [
    "stroke",
    "fill",
    "legendType",
    "hide",
    "isAnimationActive",
    "animationBegin",
    "animationDuration",
    "animationEasing",
    "nameKey",
    "lastShapeType"
];
function $8bbf77ab6cef1b16$var$_extends() {
    return $8bbf77ab6cef1b16$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8bbf77ab6cef1b16$var$_extends.apply(null, arguments);
}
function $8bbf77ab6cef1b16$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $8bbf77ab6cef1b16$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $8bbf77ab6cef1b16$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $8bbf77ab6cef1b16$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bbf77ab6cef1b16$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bbf77ab6cef1b16$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8bbf77ab6cef1b16$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bbf77ab6cef1b16$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8bbf77ab6cef1b16$var$_defineProperty(e, r, t) {
    return (r = $8bbf77ab6cef1b16$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8bbf77ab6cef1b16$var$_toPropertyKey(t) {
    var i = $8bbf77ab6cef1b16$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8bbf77ab6cef1b16$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ /**
 * External props, intended for end users to fill in
 */ var $8bbf77ab6cef1b16$var$SetFunnelTooltipEntrySettings = /*#__PURE__*/ $aivMx.memo((_ref)=>{
    var { dataKey: dataKey, nameKey: nameKey, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, tooltipType: tooltipType, data: data, trapezoids: trapezoids } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: data,
        positions: trapezoids.map((_ref2)=>{
            var { tooltipPosition: tooltipPosition } = _ref2;
            return tooltipPosition;
        }),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            name: name,
            nameKey: nameKey,
            hide: hide,
            type: tooltipType,
            color: fill,
            unit: '' // Funnel does not have unit, why?
        }
    };
    return /*#__PURE__*/ $aivMx.createElement((0, $8a16f0191d982cde$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
function $8bbf77ab6cef1b16$var$FunnelLabelListProvider(_ref3) {
    var { showLabels: showLabels, trapezoids: trapezoids, children: children } = _ref3;
    var labelListEntries = (0, $aivMx.useMemo)(()=>{
        if (!showLabels) return undefined;
        return trapezoids === null || trapezoids === void 0 ? void 0 : trapezoids.map((entry)=>{
            var viewBox = entry.labelViewBox;
            return $8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread({}, viewBox), {}, {
                value: entry.name,
                payload: entry.payload,
                parentViewBox: entry.parentViewBox,
                viewBox: viewBox,
                fill: entry.fill
            });
        });
    }, [
        showLabels,
        trapezoids
    ]);
    return /*#__PURE__*/ $aivMx.createElement((0, $bdc309bb5887af46$export$64e384eac5db53f7), {
        value: labelListEntries
    }, children);
}
function $8bbf77ab6cef1b16$var$FunnelTrapezoids(props) {
    var { trapezoids: trapezoids, allOtherFunnelProps: allOtherFunnelProps } = props;
    var activeItemIndex = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $0d9ada87ae089576$export$95fb15d7bb7a8a94)(state, 'item', state.tooltip.settings.trigger, undefined));
    var { onMouseEnter: onMouseEnterFromProps, onClick: onItemClickFromProps, onMouseLeave: onMouseLeaveFromProps, shape: shape, activeShape: activeShape } = allOtherFunnelProps, restOfAllOtherProps = $8bbf77ab6cef1b16$var$_objectWithoutProperties(allOtherFunnelProps, $8bbf77ab6cef1b16$var$_excluded);
    var onMouseEnterFromContext = (0, $43b9d3dd582657fd$export$6162f642d41f88ea)(onMouseEnterFromProps, allOtherFunnelProps.dataKey);
    var onMouseLeaveFromContext = (0, $43b9d3dd582657fd$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    var onClickFromContext = (0, $43b9d3dd582657fd$export$c9154937ad8393fc)(onItemClickFromProps, allOtherFunnelProps.dataKey);
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, trapezoids.map((entry, i)=>{
        var isActiveIndex = Boolean(activeShape) && activeItemIndex === String(i);
        var trapezoidOptions = isActiveIndex ? activeShape : shape;
        var trapezoidProps = $8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread({}, entry), {}, {
            option: trapezoidOptions,
            isActive: isActiveIndex,
            stroke: entry.stroke
        });
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), $8bbf77ab6cef1b16$var$_extends({
            key: "trapezoid-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.name, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value),
            className: "recharts-funnel-trapezoid"
        }, (0, $1ea0ac8e1739d80a$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i), {
            // @ts-expect-error the types need a bit of attention
            onMouseEnter: onMouseEnterFromContext(entry, i),
            onMouseLeave: onMouseLeaveFromContext(entry, i),
            onClick: onClickFromContext(entry, i)
        }), /*#__PURE__*/ $aivMx.createElement((0, $1ee59f1c1a598bde$export$80e1cf105b9e876a), trapezoidProps));
    }));
}
function $8bbf77ab6cef1b16$var$TrapezoidsWithAnimation(_ref4) {
    var { previousTrapezoidsRef: previousTrapezoidsRef, props: props } = _ref4;
    var { trapezoids: trapezoids, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart } = props;
    var prevTrapezoids = previousTrapezoidsRef.current;
    var [isAnimating, setIsAnimating] = (0, $aivMx.useState)(false);
    var showLabels = !isAnimating;
    var animationId = (0, $85b2a51d25cd2e70$export$e1042b2944b80b7f)(trapezoids, 'recharts-funnel-');
    var handleAnimationEnd = (0, $aivMx.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $aivMx.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    return /*#__PURE__*/ $aivMx.createElement($8bbf77ab6cef1b16$var$FunnelLabelListProvider, {
        showLabels: showLabels,
        trapezoids: trapezoids
    }, /*#__PURE__*/ $aivMx.createElement((0, $6e14365e65dd4f13$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        key: animationId,
        onAnimationStart: handleAnimationStart,
        onAnimationEnd: handleAnimationEnd
    }, (t)=>{
        var stepData = t === 1 ? trapezoids : trapezoids.map((entry, index)=>{
            var prev = prevTrapezoids && prevTrapezoids[index];
            if (prev) return $8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread({}, entry), {}, {
                x: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                y: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.y, entry.y, t),
                upperWidth: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.upperWidth, entry.upperWidth, t),
                lowerWidth: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.lowerWidth, entry.lowerWidth, t),
                height: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.height, entry.height, t)
            });
            return $8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread({}, entry), {}, {
                x: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(entry.x + entry.upperWidth / 2, entry.x, t),
                y: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(entry.y + entry.height / 2, entry.y, t),
                upperWidth: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(0, entry.upperWidth, t),
                lowerWidth: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(0, entry.lowerWidth, t),
                height: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(0, entry.height, t)
            });
        });
        if (t > 0) // eslint-disable-next-line no-param-reassign
        previousTrapezoidsRef.current = stepData;
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), null, /*#__PURE__*/ $aivMx.createElement($8bbf77ab6cef1b16$var$FunnelTrapezoids, {
            trapezoids: stepData,
            allOtherFunnelProps: props
        }));
    }), /*#__PURE__*/ $aivMx.createElement((0, $bdc309bb5887af46$export$9a402bc8de2b410e), {
        label: props.label
    }), props.children);
}
function $8bbf77ab6cef1b16$var$RenderTrapezoids(props) {
    var previousTrapezoidsRef = (0, $aivMx.useRef)(undefined);
    return /*#__PURE__*/ $aivMx.createElement($8bbf77ab6cef1b16$var$TrapezoidsWithAnimation, {
        props: props,
        previousTrapezoidsRef: previousTrapezoidsRef
    });
}
var $8bbf77ab6cef1b16$var$getRealWidthHeight = (customWidth, offset)=>{
    var { width: width, height: height, left: left, top: top } = offset;
    var realWidth = (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(customWidth, width, width);
    return {
        realWidth: realWidth,
        realHeight: height,
        offsetX: left,
        offsetY: top
    };
};
class $8bbf77ab6cef1b16$export$86b0922eacba8b94 extends (0, $aivMx.PureComponent) {
    render() {
        var { className: className } = this.props;
        var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-trapezoids', className);
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
            className: layerClass
        }, /*#__PURE__*/ $aivMx.createElement($8bbf77ab6cef1b16$var$RenderTrapezoids, this.props));
    }
}
var $8bbf77ab6cef1b16$var$defaultFunnelProps = {
    stroke: '#fff',
    fill: '#808080',
    legendType: 'rect',
    hide: false,
    isAnimationActive: !(0, $a898dc03dc17f75a$export$98f03c5d19621d70).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    nameKey: 'name',
    lastShapeType: 'triangle'
};
function $8bbf77ab6cef1b16$var$FunnelImpl(props) {
    var plotArea = (0, $c058c547db329017$export$f1ef8efc9ef6fe0c)();
    var _resolveDefaultProps = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(props, $8bbf77ab6cef1b16$var$defaultFunnelProps), { stroke: stroke, fill: fill, legendType: legendType, hide: hide, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, nameKey: nameKey, lastShapeType: lastShapeType } = _resolveDefaultProps, everythingElse = $8bbf77ab6cef1b16$var$_objectWithoutProperties(_resolveDefaultProps, $8bbf77ab6cef1b16$var$_excluded2);
    var presentationProps = (0, $bf74bd062767a6f3$export$8b56257912140094)(props);
    var cells = (0, $a703e7e67d5286d1$export$fdd5e64c0e8495bb)(props.children, (0, $66258e37252e74df$export$f6f0c3fe4ec306ea));
    var funnelSettings = (0, $aivMx.useMemo)(()=>({
            dataKey: props.dataKey,
            nameKey: nameKey,
            data: props.data,
            tooltipType: props.tooltipType,
            lastShapeType: lastShapeType,
            reversed: props.reversed,
            customWidth: props.width,
            cells: cells,
            presentationProps: presentationProps
        }), [
        props.dataKey,
        nameKey,
        props.data,
        props.tooltipType,
        lastShapeType,
        props.reversed,
        props.width,
        cells,
        presentationProps
    ]);
    var trapezoids = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $2fc561df7974ffb1$export$b3c86f0c96313f81)(state, funnelSettings));
    if (hide || !trapezoids || !trapezoids.length || !plotArea) return null;
    var { height: height, width: width } = plotArea;
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement($8bbf77ab6cef1b16$var$SetFunnelTooltipEntrySettings, {
        dataKey: props.dataKey,
        nameKey: props.nameKey,
        stroke: props.stroke,
        strokeWidth: props.strokeWidth,
        fill: props.fill,
        name: props.name,
        hide: props.hide,
        tooltipType: props.tooltipType,
        data: props.data,
        trapezoids: trapezoids
    }), /*#__PURE__*/ $aivMx.createElement($8bbf77ab6cef1b16$export$86b0922eacba8b94, $8bbf77ab6cef1b16$var$_extends({}, everythingElse, {
        stroke: stroke,
        fill: fill,
        nameKey: nameKey,
        lastShapeType: lastShapeType,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        hide: hide,
        legendType: legendType,
        height: height,
        width: width,
        trapezoids: trapezoids
    })));
}
function $8bbf77ab6cef1b16$export$89c97daba8cb5a5a(_ref5) {
    var { dataKey: dataKey, nameKey: nameKey, displayedData: displayedData, tooltipType: tooltipType, lastShapeType: lastShapeType, reversed: reversed, offset: offset, customWidth: customWidth } = _ref5;
    var { realHeight: realHeight, realWidth: realWidth, offsetX: offsetX, offsetY: offsetY } = $8bbf77ab6cef1b16$var$getRealWidthHeight(customWidth, offset);
    var maxValue = Math.max.apply(null, displayedData.map((entry)=>(0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey, 0)));
    var len = displayedData.length;
    var rowHeight = realHeight / len;
    var parentViewBox = {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
    var trapezoids = displayedData.map((entry, i)=>{
        // @ts-expect-error getValueByDataKey does not validate the output type
        var rawVal = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey, 0);
        var name = String((0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, nameKey, i));
        var val = rawVal;
        var nextVal;
        if (i !== len - 1) {
            nextVal = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(displayedData[i + 1], dataKey, 0);
            if (nextVal instanceof Array) [val, nextVal] = nextVal;
        } else if (rawVal instanceof Array && rawVal.length === 2) [val, nextVal] = rawVal;
        else if (lastShapeType === 'rectangle') nextVal = val;
        else nextVal = 0;
        // @ts-expect-error this is a problem if we have ranged values because `val` can be an array
        var x = (maxValue - val) * realWidth / (2 * maxValue) + offsetX;
        var y = rowHeight * i + offsetY;
        // @ts-expect-error getValueByDataKey does not validate the output type
        var upperWidth = val / maxValue * realWidth;
        var lowerWidth = nextVal / maxValue * realWidth;
        var tooltipPayload = [
            {
                name: name,
                value: val,
                payload: entry,
                dataKey: dataKey,
                type: tooltipType
            }
        ];
        var tooltipPosition = {
            x: x + upperWidth / 2,
            y: y + rowHeight / 2
        };
        var trapezoidViewBox = {
            x: x,
            y: y,
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            width: Math.max(upperWidth, lowerWidth),
            height: rowHeight
        };
        return $8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread({}, trapezoidViewBox), {}, {
            name: name,
            val: val,
            tooltipPayload: tooltipPayload,
            tooltipPosition: tooltipPosition
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cf64ee5d4289032b$exports)))(entry, [
            'width'
        ])), {}, {
            payload: entry,
            parentViewBox: parentViewBox,
            labelViewBox: trapezoidViewBox
        });
    });
    if (reversed) trapezoids = trapezoids.map((entry, index)=>{
        var reversedViewBox = {
            x: entry.x - (entry.lowerWidth - entry.upperWidth) / 2,
            y: entry.y - index * rowHeight + (len - 1 - index) * rowHeight,
            upperWidth: entry.lowerWidth,
            lowerWidth: entry.upperWidth,
            width: Math.max(entry.lowerWidth, entry.upperWidth),
            height: rowHeight
        };
        return $8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread({}, entry), reversedViewBox), {}, {
            tooltipPosition: $8bbf77ab6cef1b16$var$_objectSpread($8bbf77ab6cef1b16$var$_objectSpread({}, entry.tooltipPosition), {}, {
                y: entry.y - index * rowHeight + (len - 1 - index) * rowHeight + rowHeight / 2
            }),
            labelViewBox: reversedViewBox
        });
    });
    return trapezoids;
}
class $8bbf77ab6cef1b16$export$30b1585f3948a0cc extends (0, $aivMx.PureComponent) {
    render() {
        return /*#__PURE__*/ $aivMx.createElement($8bbf77ab6cef1b16$var$FunnelImpl, this.props);
    }
}
$8bbf77ab6cef1b16$var$_defineProperty($8bbf77ab6cef1b16$export$30b1585f3948a0cc, "displayName", 'Funnel');
$8bbf77ab6cef1b16$var$_defineProperty($8bbf77ab6cef1b16$export$30b1585f3948a0cc, "defaultProps", $8bbf77ab6cef1b16$var$defaultFunnelProps);


var $aivMx = parcelRequire("aivMx");


var $5a963b20a3ae6224$var$allowedTooltipTypes = [
    'item'
];
var $5a963b20a3ae6224$export$254956f9f205304 = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $aivMx.createElement((0, $12db2a0a1d5c03ed$export$855bb85b2910abc9), {
        chartName: "FunnelChart",
        defaultTooltipEventType: "item",
        validateTooltipEventTypes: $5a963b20a3ae6224$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $9a03b151feb18982$export$3d996ff386c7802d),
        categoricalChartProps: props,
        ref: ref
    });
});


var $aivMx = parcelRequire("aivMx");



var $aivMx = parcelRequire("aivMx");





function $887ff77ea346c624$var$_extends() {
    return $887ff77ea346c624$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $887ff77ea346c624$var$_extends.apply(null, arguments);
}
function $887ff77ea346c624$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $887ff77ea346c624$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $887ff77ea346c624$var$ownKeys(Object(t), !0).forEach(function(r) {
            $887ff77ea346c624$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $887ff77ea346c624$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $887ff77ea346c624$var$_defineProperty(e, r, t) {
    return (r = $887ff77ea346c624$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $887ff77ea346c624$var$_toPropertyKey(t) {
    var i = $887ff77ea346c624$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $887ff77ea346c624$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $887ff77ea346c624$var$SIZE = 32;
var $887ff77ea346c624$var$defaultLegendContentDefaultProps = {
    align: 'center',
    iconSize: 14,
    inactiveColor: '#ccc',
    layout: 'horizontal',
    verticalAlign: 'middle'
};
function $887ff77ea346c624$var$Icon(_ref) {
    var { data: data, iconType: iconType, inactiveColor: inactiveColor } = _ref;
    var halfSize = $887ff77ea346c624$var$SIZE / 2;
    var sixthSize = $887ff77ea346c624$var$SIZE / 6;
    var thirdSize = $887ff77ea346c624$var$SIZE / 3;
    var color = data.inactive ? inactiveColor : data.color;
    var preferredIcon = iconType !== null && iconType !== void 0 ? iconType : data.type;
    if (preferredIcon === 'none') return null;
    if (preferredIcon === 'plainline') {
        var _data$payload;
        return /*#__PURE__*/ $aivMx.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: color,
            strokeDasharray: (_data$payload = data.payload) === null || _data$payload === void 0 ? void 0 : _data$payload.strokeDasharray,
            x1: 0,
            y1: halfSize,
            x2: $887ff77ea346c624$var$SIZE,
            y2: halfSize,
            className: "recharts-legend-icon"
        });
    }
    if (preferredIcon === 'line') return /*#__PURE__*/ $aivMx.createElement("path", {
        strokeWidth: 4,
        fill: "none",
        stroke: color,
        d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($887ff77ea346c624$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
        className: "recharts-legend-icon"
    });
    if (preferredIcon === 'rect') return /*#__PURE__*/ $aivMx.createElement("path", {
        stroke: "none",
        fill: color,
        d: "M0,".concat($887ff77ea346c624$var$SIZE / 8, "h").concat($887ff77ea346c624$var$SIZE, "v").concat($887ff77ea346c624$var$SIZE * 3 / 4, "h").concat(-$887ff77ea346c624$var$SIZE, "z"),
        className: "recharts-legend-icon"
    });
    if (/*#__PURE__*/ $aivMx.isValidElement(data.legendIcon)) {
        var iconProps = $887ff77ea346c624$var$_objectSpread({}, data);
        delete iconProps.legendIcon;
        return /*#__PURE__*/ $aivMx.cloneElement(data.legendIcon, iconProps);
    }
    return /*#__PURE__*/ $aivMx.createElement((0, $7dd0b7ccca1861b3$export$fa456266707bf4e4), {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: $887ff77ea346c624$var$SIZE,
        sizeType: "diameter",
        type: preferredIcon
    });
}
function $887ff77ea346c624$var$Items(props) {
    var { payload: payload, iconSize: iconSize, layout: layout, formatter: formatter, inactiveColor: inactiveColor, iconType: iconType } = props;
    var viewBox = {
        x: 0,
        y: 0,
        width: $887ff77ea346c624$var$SIZE,
        height: $887ff77ea346c624$var$SIZE
    };
    var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
    };
    var svgStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 4
    };
    return payload.map((entry, i)=>{
        var finalFormatter = entry.formatter || formatter;
        var className = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)({
            'recharts-legend-item': true,
            ["legend-item-".concat(i)]: true,
            inactive: entry.inactive
        });
        if (entry.type === 'none') return null;
        var color = entry.inactive ? inactiveColor : entry.color;
        var finalValue = finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value;
        return /*#__PURE__*/ $aivMx.createElement("li", $887ff77ea346c624$var$_extends({
            className: className,
            style: itemStyle,
            key: "legend-item-".concat(i)
        }, (0, $1ea0ac8e1739d80a$export$ca62be0d67a3158c)(props, entry, i)), /*#__PURE__*/ $aivMx.createElement((0, $fa0afac1492c9749$export$7b92b459e668cb21), {
            width: iconSize,
            height: iconSize,
            viewBox: viewBox,
            style: svgStyle,
            "aria-label": "".concat(finalValue, " legend icon")
        }, /*#__PURE__*/ $aivMx.createElement($887ff77ea346c624$var$Icon, {
            data: entry,
            iconType: iconType,
            inactiveColor: inactiveColor
        })), /*#__PURE__*/ $aivMx.createElement("span", {
            className: "recharts-legend-item-text",
            style: {
                color: color
            }
        }, finalValue));
    });
}
var $887ff77ea346c624$export$99f8d96ed0cededa = (outsideProps)=>{
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $887ff77ea346c624$var$defaultLegendContentDefaultProps);
    var { payload: payload, layout: layout, align: align } = props;
    if (!payload || !payload.length) return null;
    var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
    };
    return /*#__PURE__*/ $aivMx.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
    }, /*#__PURE__*/ $aivMx.createElement($887ff77ea346c624$var$Items, $887ff77ea346c624$var$_extends({}, props, {
        payload: payload
    })));
};



var $684d4362450daea5$exports = {};

$684d4362450daea5$exports = (parcelRequire("lwPuX")).uniqBy;


function $6207a5a19aec9083$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($684d4362450daea5$exports)))(payload, defaultUniqBy);
    if (typeof option === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($684d4362450daea5$exports)))(payload, option);
    return payload;
}




function $9cf85cf45fda579c$export$5e7711dbef7c() {
    return (0, $7729c221c7142965$export$a7347740d65f620b)((0, $94d84d1c93d9fa29$export$9a6de64b691a7304));
}



var $aivMx = parcelRequire("aivMx");
var $789fe1100772c0d2$var$EPS = 1;
function $789fe1100772c0d2$export$35f58fcda6094144() {
    var extraDependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var [lastBoundingBox, setLastBoundingBox] = (0, $aivMx.useState)({
        height: 0,
        left: 0,
        top: 0,
        width: 0
    });
    var updateBoundingBox = (0, $aivMx.useCallback)((node)=>{
        if (node != null) {
            var rect = node.getBoundingClientRect();
            var box = {
                height: rect.height,
                left: rect.left,
                top: rect.top,
                width: rect.width
            };
            if (Math.abs(box.height - lastBoundingBox.height) > $789fe1100772c0d2$var$EPS || Math.abs(box.left - lastBoundingBox.left) > $789fe1100772c0d2$var$EPS || Math.abs(box.top - lastBoundingBox.top) > $789fe1100772c0d2$var$EPS || Math.abs(box.width - lastBoundingBox.width) > $789fe1100772c0d2$var$EPS) setLastBoundingBox({
                height: box.height,
                left: box.left,
                top: box.top,
                width: box.width
            });
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lastBoundingBox.width,
        lastBoundingBox.height,
        lastBoundingBox.top,
        lastBoundingBox.left,
        ...extraDependencies
    ]);
    return [
        lastBoundingBox,
        updateBoundingBox
    ];
}






var $e116a714fccbb193$var$_excluded = [
    "contextPayload"
];
function $e116a714fccbb193$var$_extends() {
    return $e116a714fccbb193$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e116a714fccbb193$var$_extends.apply(null, arguments);
}
function $e116a714fccbb193$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e116a714fccbb193$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e116a714fccbb193$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e116a714fccbb193$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e116a714fccbb193$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e116a714fccbb193$var$_defineProperty(e, r, t) {
    return (r = $e116a714fccbb193$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e116a714fccbb193$var$_toPropertyKey(t) {
    var i = $e116a714fccbb193$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e116a714fccbb193$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e116a714fccbb193$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e116a714fccbb193$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e116a714fccbb193$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $e116a714fccbb193$var$defaultUniqBy(entry) {
    return entry.value;
}
function $e116a714fccbb193$var$LegendContent(props) {
    var { contextPayload: contextPayload } = props, otherProps = $e116a714fccbb193$var$_objectWithoutProperties(props, $e116a714fccbb193$var$_excluded);
    var finalPayload = (0, $6207a5a19aec9083$export$b67e33c2fb1535fa)(contextPayload, props.payloadUniqBy, $e116a714fccbb193$var$defaultUniqBy);
    var contentProps = $e116a714fccbb193$var$_objectSpread($e116a714fccbb193$var$_objectSpread({}, otherProps), {}, {
        payload: finalPayload
    });
    if (/*#__PURE__*/ $aivMx.isValidElement(props.content)) return /*#__PURE__*/ $aivMx.cloneElement(props.content, contentProps);
    if (typeof props.content === 'function') return /*#__PURE__*/ $aivMx.createElement(props.content, contentProps);
    return /*#__PURE__*/ $aivMx.createElement((0, $887ff77ea346c624$export$99f8d96ed0cededa), contentProps);
}
function $e116a714fccbb193$var$getDefaultPosition(style, props, margin, chartWidth, chartHeight, box) {
    var { layout: layout, align: align, verticalAlign: verticalAlign } = props;
    var hPos, vPos;
    if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') hPos = {
            left: ((chartWidth || 0) - box.width) / 2
        };
        else hPos = align === 'right' ? {
            right: margin && margin.right || 0
        } : {
            left: margin && margin.left || 0
        };
    }
    if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') vPos = {
            top: ((chartHeight || 0) - box.height) / 2
        };
        else vPos = verticalAlign === 'bottom' ? {
            bottom: margin && margin.bottom || 0
        } : {
            top: margin && margin.top || 0
        };
    }
    return $e116a714fccbb193$var$_objectSpread($e116a714fccbb193$var$_objectSpread({}, hPos), vPos);
}
function $e116a714fccbb193$var$LegendSettingsDispatcher(props) {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useEffect)(()=>{
        dispatch((0, $2dd5d2946f23160b$export$a1a647a9c0dcc839)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}
function $e116a714fccbb193$var$LegendSizeDispatcher(props) {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useEffect)(()=>{
        dispatch((0, $2dd5d2946f23160b$export$f9ba9ab9b90c340e)(props));
        return ()=>{
            dispatch((0, $2dd5d2946f23160b$export$f9ba9ab9b90c340e)({
                width: 0,
                height: 0
            }));
        };
    }, [
        dispatch,
        props
    ]);
    return null;
}
function $e116a714fccbb193$var$getWidthOrHeight(layout, height, width, maxWidth) {
    if (layout === 'vertical' && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(height)) return {
        height: height
    };
    if (layout === 'horizontal') return {
        width: width || maxWidth
    };
    return null;
}
var $e116a714fccbb193$var$legendDefaultProps = {
    align: 'center',
    iconSize: 14,
    itemSorter: 'value',
    layout: 'horizontal',
    verticalAlign: 'bottom'
};
function $e116a714fccbb193$export$ed247974535929c7(outsideProps) {
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $e116a714fccbb193$var$legendDefaultProps);
    var contextPayload = (0, $9cf85cf45fda579c$export$5e7711dbef7c)();
    var legendPortalFromContext = (0, $15f21314b6c368a8$export$36ebc0838785d4af)();
    var margin = (0, $2d4a23e6670568d2$export$58ac794108fd8ca)();
    var { width: widthFromProps, height: heightFromProps, wrapperStyle: wrapperStyle, portal: portalFromProps } = props;
    // The contextPayload is not used directly inside the hook, but we need the onBBoxUpdate call
    // when the payload changes, therefore it's here as a dependency.
    var [lastBoundingBox, updateBoundingBox] = (0, $789fe1100772c0d2$export$35f58fcda6094144)([
        contextPayload
    ]);
    var chartWidth = (0, $2d4a23e6670568d2$export$8854f7ece606854b)();
    var chartHeight = (0, $2d4a23e6670568d2$export$369ae257969c6f9f)();
    if (chartWidth == null || chartHeight == null) return null;
    var maxWidth = chartWidth - ((margin === null || margin === void 0 ? void 0 : margin.left) || 0) - ((margin === null || margin === void 0 ? void 0 : margin.right) || 0);
    var widthOrHeight = $e116a714fccbb193$var$getWidthOrHeight(props.layout, heightFromProps, widthFromProps, maxWidth);
    // if the user supplies their own portal, only use their defined wrapper styles
    var outerStyle = portalFromProps ? wrapperStyle : $e116a714fccbb193$var$_objectSpread($e116a714fccbb193$var$_objectSpread({
        position: 'absolute',
        width: (widthOrHeight === null || widthOrHeight === void 0 ? void 0 : widthOrHeight.width) || widthFromProps || 'auto',
        height: (widthOrHeight === null || widthOrHeight === void 0 ? void 0 : widthOrHeight.height) || heightFromProps || 'auto'
    }, $e116a714fccbb193$var$getDefaultPosition(wrapperStyle, props, margin, chartWidth, chartHeight, lastBoundingBox)), wrapperStyle);
    var legendPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : legendPortalFromContext;
    if (legendPortal == null || contextPayload == null) return null;
    var legendElement = /*#__PURE__*/ $aivMx.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: updateBoundingBox
    }, /*#__PURE__*/ $aivMx.createElement($e116a714fccbb193$var$LegendSettingsDispatcher, {
        layout: props.layout,
        align: props.align,
        verticalAlign: props.verticalAlign,
        itemSorter: props.itemSorter
    }), !portalFromProps && /*#__PURE__*/ $aivMx.createElement($e116a714fccbb193$var$LegendSizeDispatcher, {
        width: lastBoundingBox.width,
        height: lastBoundingBox.height
    }), /*#__PURE__*/ $aivMx.createElement($e116a714fccbb193$var$LegendContent, $e116a714fccbb193$var$_extends({}, props, widthOrHeight, {
        margin: margin,
        chartWidth: chartWidth,
        chartHeight: chartHeight,
        contextPayload: contextPayload
    })));
    return /*#__PURE__*/ (0, $9f97ad3b314012cb$exports.createPortal)(legendElement, legendPortal);
}
$e116a714fccbb193$export$ed247974535929c7.displayName = 'Legend';


var $aivMx = parcelRequire("aivMx");




var $aivMx = parcelRequire("aivMx");


var $aivMx = parcelRequire("aivMx");




function $9680b2630412950d$var$_extends() {
    return $9680b2630412950d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9680b2630412950d$var$_extends.apply(null, arguments);
}
var $9680b2630412950d$export$d046b3c4a416f60d = (props)=>{
    var { cx: cx, cy: cy, r: r, className: className } = props;
    var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-dot', className);
    if ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(cx) && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(cy) && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(r)) return /*#__PURE__*/ $aivMx.createElement("circle", $9680b2630412950d$var$_extends({}, (0, $bf74bd062767a6f3$export$8b56257912140094)(props), (0, $1ea0ac8e1739d80a$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};







var $dba03b80662ade21$var$_excluded = [
    "points"
];
function $dba03b80662ade21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dba03b80662ade21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dba03b80662ade21$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dba03b80662ade21$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dba03b80662ade21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dba03b80662ade21$var$_defineProperty(e, r, t) {
    return (r = $dba03b80662ade21$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $dba03b80662ade21$var$_toPropertyKey(t) {
    var i = $dba03b80662ade21$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $dba03b80662ade21$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dba03b80662ade21$var$_extends() {
    return $dba03b80662ade21$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dba03b80662ade21$var$_extends.apply(null, arguments);
}
function $dba03b80662ade21$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $dba03b80662ade21$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $dba03b80662ade21$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $dba03b80662ade21$var$DotItem(_ref) {
    var { option: option, dotProps: dotProps, className: className } = _ref;
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(option)) // @ts-expect-error we can't type check element cloning properly
    return /*#__PURE__*/ (0, $aivMx.cloneElement)(option, dotProps);
    if (typeof option === 'function') return option(dotProps);
    var finalClassName = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)(className, typeof option !== 'boolean' ? option.className : '');
    var _ref2 = dotProps !== null && dotProps !== void 0 ? dotProps : {}, { points: points } = _ref2, props = $dba03b80662ade21$var$_objectWithoutProperties(_ref2, $dba03b80662ade21$var$_excluded);
    return /*#__PURE__*/ $aivMx.createElement((0, $9680b2630412950d$export$d046b3c4a416f60d), $dba03b80662ade21$var$_extends({}, props, {
        className: finalClassName
    }));
}
function $dba03b80662ade21$var$shouldRenderDots(points, dot) {
    if (points == null) return false;
    if (dot) return true;
    return points.length === 1;
}
function $dba03b80662ade21$export$8da50d3722682be0(_ref3) {
    var { points: points, dot: dot, className: className, dotClassName: dotClassName, dataKey: dataKey, baseProps: baseProps, needClip: needClip, clipPathId: clipPathId, zIndex: zIndex = (0, $5ad557dd967fc64c$export$96df16b28aa32702).scatter } = _ref3;
    if (!$dba03b80662ade21$var$shouldRenderDots(points, dot)) return null;
    var clipDot = (0, $a703e7e67d5286d1$export$28c0c718114c1a2e)(dot);
    var customDotProps = (0, $61a9c4d36b40070f$export$87ef3d7bc7cd0706)(dot);
    var dots = points.map((entry, i)=>{
        var _entry$x, _entry$y;
        var dotProps = $dba03b80662ade21$var$_objectSpread($dba03b80662ade21$var$_objectSpread($dba03b80662ade21$var$_objectSpread({
            r: 3
        }, baseProps), customDotProps), {}, {
            index: i,
            cx: (_entry$x = entry.x) !== null && _entry$x !== void 0 ? _entry$x : undefined,
            cy: (_entry$y = entry.y) !== null && _entry$y !== void 0 ? _entry$y : undefined,
            dataKey: dataKey,
            value: entry.value,
            payload: entry.payload,
            points: points
        });
        return /*#__PURE__*/ $aivMx.createElement($dba03b80662ade21$var$DotItem, {
            key: "dot-".concat(i),
            option: dot,
            dotProps: dotProps,
            className: dotClassName
        });
    });
    var layerProps = {};
    if (needClip && clipPathId != null) layerProps.clipPath = "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")");
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: zIndex
    }, /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), $dba03b80662ade21$var$_extends({
        className: className
    }, layerProps), dots));
}






var $aivMx = parcelRequire("aivMx");










function $74d88ee93e981b64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $74d88ee93e981b64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $74d88ee93e981b64$var$ownKeys(Object(t), !0).forEach(function(r) {
            $74d88ee93e981b64$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $74d88ee93e981b64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $74d88ee93e981b64$var$_defineProperty(e, r, t) {
    return (r = $74d88ee93e981b64$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $74d88ee93e981b64$var$_toPropertyKey(t) {
    var i = $74d88ee93e981b64$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $74d88ee93e981b64$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $74d88ee93e981b64$var$ActivePoint = (_ref)=>{
    var { point: point, childIndex: childIndex, mainColor: mainColor, activeDot: activeDot, dataKey: dataKey, clipPath: clipPath } = _ref;
    if (activeDot === false || point.x == null || point.y == null) return null;
    var dotPropsTyped = {
        index: childIndex,
        dataKey: dataKey,
        cx: point.x,
        cy: point.y,
        r: 4,
        fill: mainColor !== null && mainColor !== void 0 ? mainColor : 'none',
        strokeWidth: 2,
        stroke: '#fff',
        payload: point.payload,
        value: point.value
    };
    // @ts-expect-error svgPropertiesNoEventsFromUnknown(activeDot) is contributing unknown props
    var dotProps = $74d88ee93e981b64$var$_objectSpread($74d88ee93e981b64$var$_objectSpread($74d88ee93e981b64$var$_objectSpread({}, dotPropsTyped), (0, $bf74bd062767a6f3$export$6d5921c09aa671a9)(activeDot)), (0, $1ea0ac8e1739d80a$export$7c4c290a4a9c1b1e)(activeDot));
    var dot;
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(activeDot)) // @ts-expect-error we're improperly typing events
    dot = /*#__PURE__*/ (0, $aivMx.cloneElement)(activeDot, dotProps);
    else if (typeof activeDot === 'function') dot = activeDot(dotProps);
    else dot = /*#__PURE__*/ $aivMx.createElement((0, $9680b2630412950d$export$d046b3c4a416f60d), dotProps);
    return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
        className: "recharts-active-dot",
        clipPath: clipPath
    }, dot);
};
function $74d88ee93e981b64$export$dd2d3dc8acd956aa(_ref2) {
    var { points: points, mainColor: mainColor, activeDot: activeDot, itemDataKey: itemDataKey, clipPath: clipPath, zIndex: zIndex = (0, $5ad557dd967fc64c$export$96df16b28aa32702).activeDot } = _ref2;
    var activeTooltipIndex = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$8b2762260f5891c9));
    var activeDataPoints = (0, $c058c547db329017$export$a5935a9f8709ac28)();
    if (points == null || activeDataPoints == null) return null;
    var activePoint = points.find((p)=>activeDataPoints.includes(p.payload));
    if ((0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(activePoint)) return null;
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: zIndex
    }, /*#__PURE__*/ $aivMx.createElement($74d88ee93e981b64$var$ActivePoint, {
        point: activePoint,
        childIndex: Number(activeTooltipIndex),
        mainColor: mainColor,
        dataKey: itemDataKey,
        activeDot: activeDot,
        clipPath: clipPath
    }));
}













var $4c32a7a1b3ca0a53$var$selectXAxisWithScale = (state, xAxisId, _yAxisId, isPanorama)=>(0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'xAxis', xAxisId, isPanorama);
var $4c32a7a1b3ca0a53$var$selectXAxisTicks = (state, xAxisId, _yAxisId, isPanorama)=>(0, $40ff607ce3fff820$export$b894cb5d8586b43d)(state, 'xAxis', xAxisId, isPanorama);
var $4c32a7a1b3ca0a53$var$selectYAxisWithScale = (state, _xAxisId, yAxisId, isPanorama)=>(0, $40ff607ce3fff820$export$db36c2f3bfe5c9d7)(state, 'yAxis', yAxisId, isPanorama);
var $4c32a7a1b3ca0a53$var$selectYAxisTicks = (state, _xAxisId, yAxisId, isPanorama)=>(0, $40ff607ce3fff820$export$b894cb5d8586b43d)(state, 'yAxis', yAxisId, isPanorama);
var $4c32a7a1b3ca0a53$var$selectBandSize = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $4c32a7a1b3ca0a53$var$selectXAxisWithScale,
    $4c32a7a1b3ca0a53$var$selectYAxisWithScale,
    $4c32a7a1b3ca0a53$var$selectXAxisTicks,
    $4c32a7a1b3ca0a53$var$selectYAxisTicks
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks)=>{
    if ((0, $09206e1485e62bdb$export$9fc1baaa6c6368b)(layout, 'xAxis')) return (0, $09206e1485e62bdb$export$212ec45c42fe68a7)(xAxis, xAxisTicks, false);
    return (0, $09206e1485e62bdb$export$212ec45c42fe68a7)(yAxis, yAxisTicks, false);
});
var $4c32a7a1b3ca0a53$var$pickLineId = (_state, _xAxisId, _yAxisId, _isPanorama, id)=>id;
function $4c32a7a1b3ca0a53$var$isLineSettings(item) {
    return item.type === 'line';
}
/*
 * There is a race condition problem because we read some data from props and some from the state.
 * The state is updated through a dispatch and is one render behind,
 * and so we have this weird one tick render where the displayedData in one selector have the old dataKey
 * but the new dataKey in another selector.
 *
 * So here instead of reading the dataKey from the props, we always read it from the state.
 */ var $4c32a7a1b3ca0a53$var$selectSynchronisedLineSettings = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$f67c737adf41a3af),
    $4c32a7a1b3ca0a53$var$pickLineId
], (graphicalItems, id)=>graphicalItems.filter($4c32a7a1b3ca0a53$var$isLineSettings).find((x)=>x.id === id));
var $4c32a7a1b3ca0a53$export$3eaebea0f6c183c0 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $4c32a7a1b3ca0a53$var$selectXAxisWithScale,
    $4c32a7a1b3ca0a53$var$selectYAxisWithScale,
    $4c32a7a1b3ca0a53$var$selectXAxisTicks,
    $4c32a7a1b3ca0a53$var$selectYAxisTicks,
    $4c32a7a1b3ca0a53$var$selectSynchronisedLineSettings,
    $4c32a7a1b3ca0a53$var$selectBandSize,
    (0, $695f2ef1b702f419$export$4953b85e13393616)
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks, lineSettings, bandSize, _ref)=>{
    var { chartData: chartData, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex } = _ref;
    if (lineSettings == null || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || xAxisTicks.length === 0 || yAxisTicks.length === 0 || bandSize == null || layout !== 'horizontal' && layout !== 'vertical') return undefined;
    var { dataKey: dataKey, data: data } = lineSettings;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $c85dc270154f0923$export$bfbd9a993cf94d79)({
        layout: layout,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        dataKey: dataKey,
        bandSize: bandSize,
        displayedData: displayedData
    });
});













function $3bdde01e4823ed96$export$af45be059e20a9dd(dot) {
    var props = (0, $bf74bd062767a6f3$export$6d5921c09aa671a9)(dot);
    var defaultR = 3;
    var defaultStrokeWidth = 2;
    if (props != null) {
        var { r: r, strokeWidth: strokeWidth } = props;
        var realR = Number(r);
        var realStrokeWidth = Number(strokeWidth);
        if (Number.isNaN(realR) || realR < 0) realR = defaultR;
        if (Number.isNaN(realStrokeWidth) || realStrokeWidth < 0) realStrokeWidth = defaultStrokeWidth;
        return {
            r: realR,
            strokeWidth: realStrokeWidth
        };
    }
    return {
        r: defaultR,
        strokeWidth: defaultStrokeWidth
    };
}






var $c85dc270154f0923$var$_excluded = [
    "id"
], $c85dc270154f0923$var$_excluded2 = [
    "type",
    "layout",
    "connectNulls",
    "needClip",
    "shape"
], $c85dc270154f0923$var$_excluded3 = [
    "activeDot",
    "animateNewValues",
    "animationBegin",
    "animationDuration",
    "animationEasing",
    "connectNulls",
    "dot",
    "hide",
    "isAnimationActive",
    "label",
    "legendType",
    "xAxisId",
    "yAxisId",
    "id"
];
function $c85dc270154f0923$var$_extends() {
    return $c85dc270154f0923$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c85dc270154f0923$var$_extends.apply(null, arguments);
}
function $c85dc270154f0923$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c85dc270154f0923$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c85dc270154f0923$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c85dc270154f0923$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c85dc270154f0923$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c85dc270154f0923$var$_defineProperty(e, r, t) {
    return (r = $c85dc270154f0923$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c85dc270154f0923$var$_toPropertyKey(t) {
    var i = $c85dc270154f0923$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c85dc270154f0923$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c85dc270154f0923$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c85dc270154f0923$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c85dc270154f0923$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ /**
 * External props, intended for end users to fill in
 */ /**
 * Because of naming conflict, we are forced to ignore certain (valid) SVG attributes.
 */ var $c85dc270154f0923$var$computeLegendPayloadFromAreaData = (props)=>{
    var { dataKey: dataKey, name: name, stroke: stroke, legendType: legendType, hide: hide } = props;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: stroke,
            value: (0, $09206e1485e62bdb$export$d3207de44081d2b3)(name, dataKey),
            payload: props
        }
    ];
};
var $c85dc270154f0923$var$SetLineTooltipEntrySettings = /*#__PURE__*/ $aivMx.memo((_ref)=>{
    var { dataKey: dataKey, data: data, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, unit: unit, tooltipType: tooltipType } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: data,
        positions: undefined,
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $09206e1485e62bdb$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: stroke,
            unit: unit
        }
    };
    return /*#__PURE__*/ $aivMx.createElement((0, $8a16f0191d982cde$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
var $c85dc270154f0923$var$generateSimpleStrokeDasharray = (totalLength, length)=>{
    return "".concat(length, "px ").concat(totalLength - length, "px");
};
function $c85dc270154f0923$var$repeat(lines, count) {
    var linesUnit = lines.length % 2 !== 0 ? [
        ...lines,
        0
    ] : lines;
    var result = [];
    for(var i = 0; i < count; ++i)result = [
        ...result,
        ...linesUnit
    ];
    return result;
}
var $c85dc270154f0923$var$getStrokeDasharray = (length, totalLength, lines)=>{
    var lineLength = lines.reduce((pre, next)=>pre + next);
    // if lineLength is 0 return the default when no strokeDasharray is provided
    if (!lineLength) return $c85dc270154f0923$var$generateSimpleStrokeDasharray(totalLength, length);
    var count = Math.floor(length / lineLength);
    var remainLength = length % lineLength;
    var restLength = totalLength - length;
    var remainLines = [];
    for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
        remainLines = [
            ...lines.slice(0, i),
            remainLength - sum
        ];
        break;
    }
    var emptyLines = remainLines.length % 2 === 0 ? [
        0,
        restLength
    ] : [
        restLength
    ];
    return [
        ...$c85dc270154f0923$var$repeat(lines, count),
        ...remainLines,
        ...emptyLines
    ].map((line)=>"".concat(line, "px")).join(', ');
};
function $c85dc270154f0923$var$LineDotsWrapper(_ref2) {
    var { clipPathId: clipPathId, points: points, props: props } = _ref2;
    var { dot: dot, dataKey: dataKey, needClip: needClip } = props;
    /*
   * Exclude ID from the props passed to the Dots component
   * because then the ID would be applied to multiple dots, and it would no longer be unique.
   */ var { id: id } = props, propsWithoutId = $c85dc270154f0923$var$_objectWithoutProperties(props, $c85dc270154f0923$var$_excluded);
    var lineProps = (0, $bf74bd062767a6f3$export$8b56257912140094)(propsWithoutId);
    return /*#__PURE__*/ $aivMx.createElement((0, $dba03b80662ade21$export$8da50d3722682be0), {
        points: points,
        dot: dot,
        className: "recharts-line-dots",
        dotClassName: "recharts-line-dot",
        dataKey: dataKey,
        baseProps: lineProps,
        needClip: needClip,
        clipPathId: clipPathId
    });
}
function $c85dc270154f0923$var$LineLabelListProvider(_ref3) {
    var { showLabels: showLabels, children: children, points: points } = _ref3;
    var labelListEntries = (0, $aivMx.useMemo)(()=>{
        return points === null || points === void 0 ? void 0 : points.map((point)=>{
            var _point$x, _point$y;
            var viewBox = {
                x: (_point$x = point.x) !== null && _point$x !== void 0 ? _point$x : 0,
                y: (_point$y = point.y) !== null && _point$y !== void 0 ? _point$y : 0,
                width: 0,
                lowerWidth: 0,
                upperWidth: 0,
                height: 0
            };
            return $c85dc270154f0923$var$_objectSpread($c85dc270154f0923$var$_objectSpread({}, viewBox), {}, {
                value: point.value,
                payload: point.payload,
                viewBox: viewBox,
                /*
         * Line is not passing parentViewBox to the LabelList so the labels can escape - looks like a bug, should we pass parentViewBox?
         * Or should this just be the root chart viewBox?
         */ parentViewBox: undefined,
                fill: undefined
            });
        });
    }, [
        points
    ]);
    return /*#__PURE__*/ $aivMx.createElement((0, $bdc309bb5887af46$export$64e384eac5db53f7), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $c85dc270154f0923$var$StaticCurve(_ref4) {
    var { clipPathId: clipPathId, pathRef: pathRef, points: points, strokeDasharray: strokeDasharray, props: props } = _ref4;
    var { type: type, layout: layout, connectNulls: connectNulls, needClip: needClip, shape: shape } = props, others = $c85dc270154f0923$var$_objectWithoutProperties(props, $c85dc270154f0923$var$_excluded2);
    var curveProps = $c85dc270154f0923$var$_objectSpread($c85dc270154f0923$var$_objectSpread({}, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(others)), {}, {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined,
        points: points,
        type: type,
        layout: layout,
        connectNulls: connectNulls,
        strokeDasharray: strokeDasharray !== null && strokeDasharray !== void 0 ? strokeDasharray : props.strokeDasharray
    });
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, (points === null || points === void 0 ? void 0 : points.length) > 1 && /*#__PURE__*/ $aivMx.createElement((0, $333e6f5e0fe541db$export$6428a7f2611ef1fa), $c85dc270154f0923$var$_extends({
        shapeType: "curve",
        option: shape
    }, curveProps, {
        pathRef: pathRef
    })), /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$LineDotsWrapper, {
        points: points,
        clipPathId: clipPathId,
        props: props
    }));
}
function $c85dc270154f0923$var$getTotalLength(mainCurve) {
    try {
        return mainCurve && mainCurve.getTotalLength && mainCurve.getTotalLength() || 0;
    } catch (_unused) {
        return 0;
    }
}
function $c85dc270154f0923$var$CurveWithAnimation(_ref5) {
    var { clipPathId: clipPathId, props: props, pathRef: pathRef, previousPointsRef: previousPointsRef, longestAnimatedLengthRef: longestAnimatedLengthRef } = _ref5;
    var { points: points, strokeDasharray: strokeDasharray, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, animateNewValues: animateNewValues, width: width, height: height, onAnimationEnd: onAnimationEnd, onAnimationStart: onAnimationStart } = props;
    var prevPoints = previousPointsRef.current;
    var animationId = (0, $85b2a51d25cd2e70$export$e1042b2944b80b7f)(points, 'recharts-line-');
    var animationIdRef = (0, $aivMx.useRef)(animationId);
    var [isAnimating, setIsAnimating] = (0, $aivMx.useState)(false);
    var showLabels = !isAnimating;
    var handleAnimationEnd = (0, $aivMx.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $aivMx.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    var totalLength = $c85dc270154f0923$var$getTotalLength(pathRef.current);
    /*
   * Here we want to detect if the length animation has been interrupted.
   * For that we keep a reference to the furthest length that has been animated.
   *
   * And then, to keep things smooth, we add to it the current length that is being animated right now.
   *
   * If we did Math.max then it makes the length animation "pause" but we want to keep it smooth
   * so in case we have some "leftover" length from the previous animation we add it to the current length.
   *
   * This is not perfect because the animation changes speed due to easing. The default easing is 'ease' which is not linear
   * and makes it stand out. But it's good enough I suppose.
   * If we want to fix it then we need to keep track of multiple animations and their easing and timings.
   *
   * If you want to see this in action, try to change the dataKey of the line chart while the initial animation is running.
   * The Line begins with zero length and slowly grows to the full length. While this growth is in progress,
   * change the dataKey and the Line will continue growing from where it has grown so far.
   *
   * This is for the case when new animation triggers. When that happens we get new points, everything re-renders,
   * and we get fresh new state in this component and use the ref stored above.
   *
   * In case when we get render without new animation - for example when opacity changes, or color changes,
   * then the animationId remains the same, and we do not update the starting point.
   * See https://github.com/recharts/recharts/issues/6044
   */ var startingPointRef = (0, $aivMx.useRef)(0);
    if (animationIdRef.current !== animationId) {
        startingPointRef.current = longestAnimatedLengthRef.current;
        animationIdRef.current = animationId;
    }
    var startingPoint = startingPointRef.current;
    return /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$LineLabelListProvider, {
        points: points,
        showLabels: showLabels
    }, props.children, /*#__PURE__*/ $aivMx.createElement((0, $6e14365e65dd4f13$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: handleAnimationEnd,
        onAnimationStart: handleAnimationStart,
        key: animationId
    }, (t)=>{
        var lengthInterpolated = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(startingPoint, totalLength + startingPoint, t);
        var curLength = Math.min(lengthInterpolated, totalLength);
        var currentStrokeDasharray;
        if (isAnimationActive) {
            if (strokeDasharray) {
                var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map((num)=>parseFloat(num));
                currentStrokeDasharray = $c85dc270154f0923$var$getStrokeDasharray(curLength, totalLength, lines);
            } else currentStrokeDasharray = $c85dc270154f0923$var$generateSimpleStrokeDasharray(totalLength, curLength);
        } else currentStrokeDasharray = strokeDasharray == null ? undefined : String(strokeDasharray);
        /*
     * Here it is important to wait a little bit with updating the previousPointsRef
     * before the animation has a time to initialize.
     * If we set the previous pointsRef immediately, we set it before the Legend height it calculated
     * and before pathRef is set.
     * If that happens, the Line will re-render again after Legend had reported its height
     * which will start a new animation with the previous points as the starting point
     * which gives the effect of the Line animating slightly upwards (where the animation distance equals the Legend height).
     * Waiting for t > 0 is indirect but good enough to ensure that the Legend height is calculated and animation works properly.
     *
     * Total length similarly is calculated from the pathRef. We should not update the previousPointsRef
     * before the pathRef is set, otherwise we will have a wrong total length.
     */ if (t > 0 && totalLength > 0) {
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = points;
            /*
       * totalLength is set from a ref and is not updated in the first tick of the animation.
       * It defaults to zero which is exactly what we want here because we want to grow from zero,
       * however the same happens when the data change.
       *
       * In that case we want to remember the previous length and continue from there, and only animate the shape.
       *
       * Therefore the totalLength > 0 check.
       *
       * The Animate is about to fire handleAnimationStart which will update the state
       * and cause a re-render and read a new proper totalLength which will be used in the next tick
       * and update the longestAnimatedLengthRef.
       *
       * Why Math.max? Sometimes the curve goes through a smaller length than previously recorded.
       * If we just set it to curLength, then the next animation would start from a smaller length
       * which looks weird. So we keep the longest length ever reached and then animate from there.
       */ // eslint-disable-next-line no-param-reassign
            longestAnimatedLengthRef.current = Math.max(longestAnimatedLengthRef.current, curLength);
        }
        if (prevPoints) {
            var prevPointsDiffFactor = prevPoints.length / points.length;
            var stepData = t === 1 ? points : points.map((entry, index)=>{
                var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                if (prevPoints[prevPointIndex]) {
                    var prev = prevPoints[prevPointIndex];
                    return $c85dc270154f0923$var$_objectSpread($c85dc270154f0923$var$_objectSpread({}, entry), {}, {
                        x: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.x, entry.x, t),
                        y: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.y, entry.y, t)
                    });
                }
                // magic number of faking previous x and y location
                if (animateNewValues) return $c85dc270154f0923$var$_objectSpread($c85dc270154f0923$var$_objectSpread({}, entry), {}, {
                    x: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(width * 2, entry.x, t),
                    y: (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(height / 2, entry.y, t)
                });
                return $c85dc270154f0923$var$_objectSpread($c85dc270154f0923$var$_objectSpread({}, entry), {}, {
                    x: entry.x,
                    y: entry.y
                });
            });
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = stepData;
            return /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$StaticCurve, {
                props: props,
                points: stepData,
                clipPathId: clipPathId,
                pathRef: pathRef,
                strokeDasharray: currentStrokeDasharray
            });
        }
        return /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$StaticCurve, {
            props: props,
            points: points,
            clipPathId: clipPathId,
            pathRef: pathRef,
            strokeDasharray: currentStrokeDasharray
        });
    }), /*#__PURE__*/ $aivMx.createElement((0, $bdc309bb5887af46$export$9a402bc8de2b410e), {
        label: props.label
    }));
}
function $c85dc270154f0923$var$RenderCurve(_ref6) {
    var { clipPathId: clipPathId, props: props } = _ref6;
    var previousPointsRef = (0, $aivMx.useRef)(null);
    var longestAnimatedLengthRef = (0, $aivMx.useRef)(0);
    var pathRef = (0, $aivMx.useRef)(null);
    return /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$CurveWithAnimation, {
        props: props,
        clipPathId: clipPathId,
        previousPointsRef: previousPointsRef,
        longestAnimatedLengthRef: longestAnimatedLengthRef,
        pathRef: pathRef
    });
}
var $c85dc270154f0923$var$errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    var _dataPoint$x, _dataPoint$y;
    return {
        x: (_dataPoint$x = dataPoint.x) !== null && _dataPoint$x !== void 0 ? _dataPoint$x : undefined,
        y: (_dataPoint$y = dataPoint.y) !== null && _dataPoint$y !== void 0 ? _dataPoint$y : undefined,
        value: dataPoint.value,
        // @ts-expect-error getValueByDataKey does not validate the output type
        errorVal: (0, $09206e1485e62bdb$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
    };
};
// eslint-disable-next-line react/prefer-stateless-function
class $c85dc270154f0923$var$LineWithState extends (0, $aivMx.Component) {
    render() {
        var { hide: hide, dot: dot, points: points, className: className, xAxisId: xAxisId, yAxisId: yAxisId, top: top, left: left, width: width, height: height, id: id, needClip: needClip, zIndex: zIndex } = this.props;
        if (hide) return null;
        var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-line', className);
        var clipPathId = id;
        var { r: r, strokeWidth: strokeWidth } = (0, $3bdde01e4823ed96$export$af45be059e20a9dd)(dot);
        var clipDot = (0, $a703e7e67d5286d1$export$28c0c718114c1a2e)(dot);
        var dotSize = r * 2 + strokeWidth;
        var activePointsClipPath = needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : undefined;
        return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
            zIndex: zIndex
        }, /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
            className: layerClass
        }, needClip && /*#__PURE__*/ $aivMx.createElement("defs", null, /*#__PURE__*/ $aivMx.createElement((0, $737883764e493ab4$export$d65f7a7dd82fbb63), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        }), !clipDot && /*#__PURE__*/ $aivMx.createElement("clipPath", {
            id: "clipPath-dots-".concat(clipPathId)
        }, /*#__PURE__*/ $aivMx.createElement("rect", {
            x: left - dotSize / 2,
            y: top - dotSize / 2,
            width: width + dotSize,
            height: height + dotSize
        }))), /*#__PURE__*/ $aivMx.createElement((0, $969a432a307941ac$export$fcd6ba6fb4bc66e7), {
            xAxisId: xAxisId,
            yAxisId: yAxisId,
            data: points,
            dataPointFormatter: $c85dc270154f0923$var$errorBarDataPointFormatter,
            errorBarOffset: 0
        }, /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$RenderCurve, {
            props: this.props,
            clipPathId: clipPathId
        }))), /*#__PURE__*/ $aivMx.createElement((0, $74d88ee93e981b64$export$dd2d3dc8acd956aa), {
            activeDot: this.props.activeDot,
            points: points,
            mainColor: this.props.stroke,
            itemDataKey: this.props.dataKey,
            clipPath: activePointsClipPath
        }));
    }
}
var $c85dc270154f0923$export$ab40e5efc5c9973f = {
    activeDot: true,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    connectNulls: false,
    dot: true,
    fill: '#fff',
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).line,
    type: 'linear'
};
function $c85dc270154f0923$var$LineImpl(props) {
    var _resolveDefaultProps = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(props, $c85dc270154f0923$export$ab40e5efc5c9973f), { activeDot: activeDot, animateNewValues: animateNewValues, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, connectNulls: connectNulls, dot: dot, hide: hide, isAnimationActive: isAnimationActive, label: label, legendType: legendType, xAxisId: xAxisId, yAxisId: yAxisId, id: id } = _resolveDefaultProps, everythingElse = $c85dc270154f0923$var$_objectWithoutProperties(_resolveDefaultProps, $c85dc270154f0923$var$_excluded3);
    var { needClip: needClip } = (0, $737883764e493ab4$export$79e142f66441c204)(xAxisId, yAxisId);
    var plotArea = (0, $c058c547db329017$export$f1ef8efc9ef6fe0c)();
    var layout = (0, $2d4a23e6670568d2$export$970c79ecc7081cc)();
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var points = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $4c32a7a1b3ca0a53$export$3eaebea0f6c183c0)(state, xAxisId, yAxisId, isPanorama, id));
    if (layout !== 'horizontal' && layout !== 'vertical' || points == null || plotArea == null) // Cannot render Line in an unsupported layout
    return null;
    var { height: height, width: width, x: left, y: top } = plotArea;
    return /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$LineWithState, $c85dc270154f0923$var$_extends({}, everythingElse, {
        id: id,
        connectNulls: connectNulls,
        dot: dot,
        activeDot: activeDot,
        animateNewValues: animateNewValues,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        hide: hide,
        label: label,
        legendType: legendType,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        points: points,
        layout: layout,
        height: height,
        width: width,
        left: left,
        top: top,
        needClip: needClip
    }));
}
function $c85dc270154f0923$export$bfbd9a993cf94d79(_ref7) {
    var { layout: layout, xAxis: xAxis, yAxis: yAxis, xAxisTicks: xAxisTicks, yAxisTicks: yAxisTicks, dataKey: dataKey, bandSize: bandSize, displayedData: displayedData } = _ref7;
    return displayedData.map((entry, index)=>{
        // @ts-expect-error getValueByDataKey does not validate the output type
        var value = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') {
            var _x = (0, $09206e1485e62bdb$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            });
            var _y = (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(value) ? null : yAxis.scale(value);
            return {
                x: _x,
                y: _y,
                value: value,
                payload: entry
            };
        }
        var x = (0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(value) ? null : xAxis.scale(value);
        var y = (0, $09206e1485e62bdb$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: bandSize,
            entry: entry,
            index: index
        });
        if (x == null || y == null) return null;
        return {
            x: x,
            y: y,
            value: value,
            payload: entry
        };
    }).filter(Boolean);
}
function $c85dc270154f0923$var$LineFn(outsideProps) {
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $c85dc270154f0923$export$ab40e5efc5c9973f);
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    return /*#__PURE__*/ $aivMx.createElement((0, $5cc9e31d9b078aed$export$8c2f307ff93f02ba), {
        id: props.id,
        type: "line"
    }, (id)=>/*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement((0, $39eb3bad114e2a47$export$34b61b169492c008), {
            legendPayload: $c85dc270154f0923$var$computeLegendPayloadFromAreaData(props)
        }), /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$SetLineTooltipEntrySettings, {
            dataKey: props.dataKey,
            data: props.data,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            tooltipType: props.tooltipType
        }), /*#__PURE__*/ $aivMx.createElement((0, $9b9188165a8d5ee0$export$b600bf9c1966a9c2), {
            type: "line",
            id: id,
            data: props.data,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            hide: props.hide,
            isPanorama: isPanorama
        }), /*#__PURE__*/ $aivMx.createElement($c85dc270154f0923$var$LineImpl, $c85dc270154f0923$var$_extends({}, props, {
            id: id
        }))));
}
var $c85dc270154f0923$export$17d680238e50603e = /*#__PURE__*/ $aivMx.memo($c85dc270154f0923$var$LineFn, (0, $7fd62a4f2791f570$export$b8f09df787c278d9));
$c85dc270154f0923$export$17d680238e50603e.displayName = 'Line';


var $aivMx = parcelRequire("aivMx");


var $7d2d1ef636456ec6$var$allowedTooltipTypes = [
    'axis'
];
var $7d2d1ef636456ec6$export$54d0e8420ac838ac = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $aivMx.createElement((0, $12db2a0a1d5c03ed$export$855bb85b2910abc9), {
        chartName: "LineChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $7d2d1ef636456ec6$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $9a03b151feb18982$export$3d996ff386c7802d),
        categoricalChartProps: props,
        ref: ref
    });
});


var $aivMx = parcelRequire("aivMx");















var $6c16212a212d4a37$export$1d9b78e3a3685311 = (state)=>state.graphicalItems.polarItems;
var $6c16212a212d4a37$var$selectAxisPredicate = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98),
    (0, $f78caf308607cee1$export$6a2efa106dc9c8f6)
], (0, $40ff607ce3fff820$export$a3923f321c6572c3));
var $6c16212a212d4a37$export$cf006504ac494d1 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $6c16212a212d4a37$export$1d9b78e3a3685311,
    (0, $40ff607ce3fff820$export$fc14c3706e09c50c),
    $6c16212a212d4a37$var$selectAxisPredicate
], (0, $40ff607ce3fff820$export$ad35679ce4582010));
var $6c16212a212d4a37$var$selectPolarGraphicalItemsData = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $6c16212a212d4a37$export$cf006504ac494d1
], (0, $40ff607ce3fff820$export$d945cee965d266f0));
var $6c16212a212d4a37$export$2a78a128a7055193 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $6c16212a212d4a37$var$selectPolarGraphicalItemsData,
    (0, $695f2ef1b702f419$export$3b10e41b7db2c36)
], (0, $40ff607ce3fff820$export$c2c6d012cffe2c75));
var $6c16212a212d4a37$export$9adf998427b6c073 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $6c16212a212d4a37$export$2a78a128a7055193,
    (0, $40ff607ce3fff820$export$fc14c3706e09c50c),
    $6c16212a212d4a37$export$cf006504ac494d1
], (0, $40ff607ce3fff820$export$3051da2013ba9cfe));
var $6c16212a212d4a37$export$a41fa0a103b05ea = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $6c16212a212d4a37$export$2a78a128a7055193,
    (0, $40ff607ce3fff820$export$fc14c3706e09c50c),
    $6c16212a212d4a37$export$cf006504ac494d1
], (data, axisSettings, items)=>{
    if (items.length > 0) return data.flatMap((entry)=>{
        return items.flatMap((item)=>{
            var _axisSettings$dataKey;
            var valueByDataKey = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            return {
                value: valueByDataKey,
                errorDomain: [] // polar charts do not have error bars
            };
        });
    }).filter(Boolean);
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, $09206e1485e62bdb$export$f97fc4a450f29a)(item, axisSettings.dataKey),
            errorDomain: []
        }));
    return data.map((entry)=>({
            value: entry,
            errorDomain: []
        }));
});
var $6c16212a212d4a37$var$unsupportedInPolarChart = ()=>undefined;
var $6c16212a212d4a37$var$selectDomainOfAllPolarAppliedNumericalValues = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $6c16212a212d4a37$export$2a78a128a7055193,
    (0, $40ff607ce3fff820$export$fc14c3706e09c50c),
    $6c16212a212d4a37$export$cf006504ac494d1,
    (0, $40ff607ce3fff820$export$9429ab4550237b6d),
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], (0, $40ff607ce3fff820$export$df56c8e9a3e45e65));
var $6c16212a212d4a37$var$selectPolarNumericalDomain = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$fc14c3706e09c50c),
    (0, $40ff607ce3fff820$export$5d46410c3f089eb2),
    (0, $40ff607ce3fff820$export$c21dc69ecce61f8a),
    $6c16212a212d4a37$var$unsupportedInPolarChart,
    $6c16212a212d4a37$var$selectDomainOfAllPolarAppliedNumericalValues,
    $6c16212a212d4a37$var$unsupportedInPolarChart,
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], (0, $40ff607ce3fff820$export$b9eca0fd568f66a4));
var $6c16212a212d4a37$export$853e8eb91c358168 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$fc14c3706e09c50c),
    (0, $2d4a23e6670568d2$export$8426b6d9af801dee),
    $6c16212a212d4a37$export$2a78a128a7055193,
    $6c16212a212d4a37$export$9adf998427b6c073,
    (0, $3eaa7bc41ed64724$export$73aff39176364def),
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98),
    $6c16212a212d4a37$var$selectPolarNumericalDomain
], (0, $40ff607ce3fff820$export$70e6ef68424edf74));
var $6c16212a212d4a37$export$e2d1beea1ea428fd = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $6c16212a212d4a37$export$853e8eb91c358168,
    (0, $40ff607ce3fff820$export$fc14c3706e09c50c),
    (0, $40ff607ce3fff820$export$a1a58ca78bb13ce7)
], (0, $40ff607ce3fff820$export$aa1ef6c8f610e48c));
var $6c16212a212d4a37$export$5dd396e660cc1d86 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $40ff607ce3fff820$export$fc14c3706e09c50c),
    $6c16212a212d4a37$export$853e8eb91c358168,
    $6c16212a212d4a37$export$e2d1beea1ea428fd,
    (0, $7e3e3c6e6d8d9066$export$8a7d579879340d98)
], (0, $40ff607ce3fff820$export$3a4530026b1860ff));


function $1387e3f5faddb23b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1387e3f5faddb23b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1387e3f5faddb23b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1387e3f5faddb23b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1387e3f5faddb23b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1387e3f5faddb23b$var$_defineProperty(e, r, t) {
    return (r = $1387e3f5faddb23b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1387e3f5faddb23b$var$_toPropertyKey(t) {
    var i = $1387e3f5faddb23b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1387e3f5faddb23b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1387e3f5faddb23b$var$pickId = (_state, id)=>id;
var $1387e3f5faddb23b$var$selectSynchronisedPieSettings = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $6c16212a212d4a37$export$1d9b78e3a3685311),
    $1387e3f5faddb23b$var$pickId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'pie').find((item)=>item.id === id));
// Keep stable reference to an empty array to prevent re-renders
var $1387e3f5faddb23b$var$emptyArray = [];
var $1387e3f5faddb23b$var$pickCells = (_state, _id, cells)=>{
    if ((cells === null || cells === void 0 ? void 0 : cells.length) === 0) return $1387e3f5faddb23b$var$emptyArray;
    return cells;
};
var $1387e3f5faddb23b$export$6099ba314905f0c4 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    (0, $695f2ef1b702f419$export$3b10e41b7db2c36),
    $1387e3f5faddb23b$var$selectSynchronisedPieSettings,
    $1387e3f5faddb23b$var$pickCells
], (_ref, pieSettings, cells)=>{
    var { chartData: chartData } = _ref;
    if (pieSettings == null) return undefined;
    var displayedData;
    if ((pieSettings === null || pieSettings === void 0 ? void 0 : pieSettings.data) != null && pieSettings.data.length > 0) displayedData = pieSettings.data;
    else displayedData = chartData;
    if ((!displayedData || !displayedData.length) && cells != null) displayedData = cells.map((cell)=>$1387e3f5faddb23b$var$_objectSpread($1387e3f5faddb23b$var$_objectSpread({}, pieSettings.presentationProps), cell.props));
    if (displayedData == null) return undefined;
    return displayedData;
});
var $1387e3f5faddb23b$export$3b28bf469d4906d8 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1387e3f5faddb23b$export$6099ba314905f0c4,
    $1387e3f5faddb23b$var$selectSynchronisedPieSettings,
    $1387e3f5faddb23b$var$pickCells
], (displayedData, pieSettings, cells)=>{
    if (displayedData == null || pieSettings == null) return undefined;
    return displayedData.map((entry, i)=>{
        var _cells$i;
        var name = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, pieSettings.nameKey, pieSettings.name);
        var color;
        if (cells !== null && cells !== void 0 && (_cells$i = cells[i]) !== null && _cells$i !== void 0 && (_cells$i = _cells$i.props) !== null && _cells$i !== void 0 && _cells$i.fill) color = cells[i].props.fill;
        else if (typeof entry === 'object' && entry != null && 'fill' in entry) color = entry.fill;
        else color = pieSettings.fill;
        return {
            value: (0, $09206e1485e62bdb$export$d3207de44081d2b3)(name, pieSettings.dataKey),
            color: color,
            // @ts-expect-error we need a better typing for our data inputs
            payload: entry,
            type: pieSettings.legendType
        };
    });
});
var $1387e3f5faddb23b$export$c6af8a90408f4a64 = (0, $ff7643c45c712aa2$export$595d22ed68ca2841)([
    $1387e3f5faddb23b$export$6099ba314905f0c4,
    $1387e3f5faddb23b$var$selectSynchronisedPieSettings,
    $1387e3f5faddb23b$var$pickCells,
    (0, $680da228e16ed19c$export$1e34c8efb0bc9b3b)
], (displayedData, pieSettings, cells, offset)=>{
    if (pieSettings == null || displayedData == null) return undefined;
    return (0, $966dda21f47144a9$export$c404972144c91fdf)({
        offset: offset,
        pieSettings: pieSettings,
        displayedData: displayedData,
        cells: cells
    });
});




























var $966dda21f47144a9$var$_excluded = [
    "key"
], $966dda21f47144a9$var$_excluded2 = [
    "onMouseEnter",
    "onClick",
    "onMouseLeave"
], $966dda21f47144a9$var$_excluded3 = [
    "id"
], $966dda21f47144a9$var$_excluded4 = [
    "id"
];
function $966dda21f47144a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $966dda21f47144a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $966dda21f47144a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $966dda21f47144a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $966dda21f47144a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $966dda21f47144a9$var$_defineProperty(e, r, t) {
    return (r = $966dda21f47144a9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $966dda21f47144a9$var$_toPropertyKey(t) {
    var i = $966dda21f47144a9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $966dda21f47144a9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $966dda21f47144a9$var$_extends() {
    return $966dda21f47144a9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $966dda21f47144a9$var$_extends.apply(null, arguments);
}
function $966dda21f47144a9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $966dda21f47144a9$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $966dda21f47144a9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * The `label` prop in Pie accepts a variety of alternatives.
 */ /**
 * We spread the data object into the sector data item,
 * so we can't really know what is going to be inside.
 *
 * This type represents our best effort, but it all depends on the input data
 * and what is inside of it.
 *
 * https://github.com/recharts/recharts/issues/6380
 * https://github.com/recharts/recharts/discussions/6375
 */ /**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ function $966dda21f47144a9$var$SetPiePayloadLegend(props) {
    var cells = (0, $aivMx.useMemo)(()=>(0, $a703e7e67d5286d1$export$fdd5e64c0e8495bb)(props.children, (0, $66258e37252e74df$export$f6f0c3fe4ec306ea)), [
        props.children
    ]);
    var legendPayload = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $1387e3f5faddb23b$export$3b28bf469d4906d8)(state, props.id, cells));
    if (legendPayload == null) return null;
    return /*#__PURE__*/ $aivMx.createElement((0, $39eb3bad114e2a47$export$eb937fedea4aab3a), {
        legendPayload: legendPayload
    });
}
var $966dda21f47144a9$var$SetPieTooltipEntrySettings = /*#__PURE__*/ $aivMx.memo((_ref)=>{
    var { dataKey: dataKey, nameKey: nameKey, sectors: sectors, stroke: stroke, strokeWidth: strokeWidth, fill: fill, name: name, hide: hide, tooltipType: tooltipType } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: sectors.map((p)=>p.tooltipPayload),
        positions: sectors.map((p)=>p.tooltipPosition),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: nameKey,
            name: (0, $09206e1485e62bdb$export$d3207de44081d2b3)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: fill,
            unit: '' // why doesn't Pie support unit?
        }
    };
    return /*#__PURE__*/ $aivMx.createElement((0, $8a16f0191d982cde$export$7fa09c17ce18f3e8), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
var $966dda21f47144a9$var$getTextAnchor = (x, cx)=>{
    if (x > cx) return 'start';
    if (x < cx) return 'end';
    return 'middle';
};
var $966dda21f47144a9$var$getOuterRadius = (dataPoint, outerRadius, maxPieRadius)=>{
    if (typeof outerRadius === 'function') return (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(outerRadius(dataPoint), maxPieRadius, maxPieRadius * 0.8);
    return (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(outerRadius, maxPieRadius, maxPieRadius * 0.8);
};
var $966dda21f47144a9$var$parseCoordinateOfPie = (pieSettings, offset, dataPoint)=>{
    var { top: top, left: left, width: width, height: height } = offset;
    var maxPieRadius = (0, $e8905a15bef036aa$export$ad5c48602371adfa)(width, height);
    var cx = left + (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(pieSettings.cx, width, width / 2);
    var cy = top + (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(pieSettings.cy, height, height / 2);
    var innerRadius = (0, $9d9ad0197f7e4c2b$export$476354dbf49bdff6)(pieSettings.innerRadius, maxPieRadius, 0);
    var outerRadius = $966dda21f47144a9$var$getOuterRadius(dataPoint, pieSettings.outerRadius, maxPieRadius);
    var maxRadius = pieSettings.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
};
var $966dda21f47144a9$var$parseDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
function $966dda21f47144a9$var$getClassNamePropertyIfExists(u) {
    if (u && typeof u === 'object' && 'className' in u && typeof u.className === 'string') return u.className;
    return '';
}
var $966dda21f47144a9$var$renderLabelLineItem = (option, props)=>{
    if (/*#__PURE__*/ $aivMx.isValidElement(option)) // @ts-expect-error we can't know if the type of props matches the element
    return /*#__PURE__*/ $aivMx.cloneElement(option, props);
    if (typeof option === 'function') return option(props);
    var className = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
    // React doesn't like it when we spread a key property onto an element
    var { key: key } = props, otherProps = $966dda21f47144a9$var$_objectWithoutProperties(props, $966dda21f47144a9$var$_excluded);
    return /*#__PURE__*/ $aivMx.createElement((0, $f4997a3a0c463bed$export$b0e83c3ef8d2db1), $966dda21f47144a9$var$_extends({}, otherProps, {
        type: "linear",
        className: className
    }));
};
var $966dda21f47144a9$var$renderLabelItem = (option, props, value)=>{
    if (/*#__PURE__*/ $aivMx.isValidElement(option)) // @ts-expect-error element cloning is not typed
    return /*#__PURE__*/ $aivMx.cloneElement(option, props);
    var label = value;
    if (typeof option === 'function') {
        label = option(props);
        if (/*#__PURE__*/ $aivMx.isValidElement(label)) return label;
    }
    var className = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-pie-label-text', $966dda21f47144a9$var$getClassNamePropertyIfExists(option));
    return /*#__PURE__*/ $aivMx.createElement((0, $79fae2d735abd531$export$5f1af8db9871e1d6), $966dda21f47144a9$var$_extends({}, props, {
        alignmentBaseline: "middle",
        className: className
    }), label);
};
function $966dda21f47144a9$var$PieLabels(_ref2) {
    var { sectors: sectors, props: props, showLabels: showLabels } = _ref2;
    var { label: label, labelLine: labelLine, dataKey: dataKey } = props;
    if (!showLabels || !label || !sectors) return null;
    var pieProps = (0, $bf74bd062767a6f3$export$8b56257912140094)(props);
    var customLabelProps = (0, $bf74bd062767a6f3$export$6d5921c09aa671a9)(label);
    var customLabelLineProps = (0, $bf74bd062767a6f3$export$6d5921c09aa671a9)(labelLine);
    var offsetRadius = typeof label === 'object' && 'offsetRadius' in label && typeof label.offsetRadius === 'number' && label.offsetRadius || 20;
    var labels = sectors.map((entry, i)=>{
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
        var labelProps = $966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread({}, pieProps), entry), {}, {
            // @ts-expect-error customLabelProps is contributing unknown props
            stroke: 'none'
        }, customLabelProps), {}, {
            index: i,
            textAnchor: $966dda21f47144a9$var$getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);
        var lineProps = $966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread({}, pieProps), entry), {}, {
            // @ts-expect-error customLabelLineProps is contributing unknown props
            fill: 'none',
            // @ts-expect-error customLabelLineProps is contributing unknown props
            stroke: entry.fill
        }, customLabelLineProps), {}, {
            index: i,
            points: [
                (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                endPoint
            ],
            key: 'line'
        });
        return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
            zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).label,
            key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
        }, /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), null, labelLine && $966dda21f47144a9$var$renderLabelLineItem(labelLine, lineProps), $966dda21f47144a9$var$renderLabelItem(label, labelProps, (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey))));
    });
    return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
        className: "recharts-pie-labels"
    }, labels);
}
function $966dda21f47144a9$var$PieLabelList(_ref3) {
    var { sectors: sectors, props: props, showLabels: showLabels } = _ref3;
    var { label: label } = props;
    if (typeof label === 'object' && label != null && 'position' in label) return /*#__PURE__*/ $aivMx.createElement((0, $bdc309bb5887af46$export$9a402bc8de2b410e), {
        label: label
    });
    return /*#__PURE__*/ $aivMx.createElement($966dda21f47144a9$var$PieLabels, {
        sectors: sectors,
        props: props,
        showLabels: showLabels
    });
}
function $966dda21f47144a9$var$PieSectors(props) {
    var { sectors: sectors, activeShape: activeShape, inactiveShape: inactiveShapeProp, allOtherPieProps: allOtherPieProps, shape: shape } = props;
    var activeIndex = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$8b2762260f5891c9));
    var { onMouseEnter: onMouseEnterFromProps, onClick: onItemClickFromProps, onMouseLeave: onMouseLeaveFromProps } = allOtherPieProps, restOfAllOtherProps = $966dda21f47144a9$var$_objectWithoutProperties(allOtherPieProps, $966dda21f47144a9$var$_excluded2);
    var onMouseEnterFromContext = (0, $43b9d3dd582657fd$export$6162f642d41f88ea)(onMouseEnterFromProps, allOtherPieProps.dataKey);
    var onMouseLeaveFromContext = (0, $43b9d3dd582657fd$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    var onClickFromContext = (0, $43b9d3dd582657fd$export$c9154937ad8393fc)(onItemClickFromProps, allOtherPieProps.dataKey);
    if (sectors == null || sectors.length === 0) return null;
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, sectors.map((entry, i)=>{
        if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
        var isActive = String(i) === activeIndex;
        var inactiveShape = activeIndex ? inactiveShapeProp : null;
        var sectorOptions = activeShape && isActive ? activeShape : inactiveShape;
        var sectorProps = $966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread({}, entry), {}, {
            stroke: entry.stroke,
            tabIndex: -1,
            [(0, $61c6522d82a73e91$export$c0f3d78d63b3e065)]: i,
            [(0, $61c6522d82a73e91$export$38427ae88f231d57)]: allOtherPieProps.dataKey
        });
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), $966dda21f47144a9$var$_extends({
            key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i),
            tabIndex: -1,
            className: "recharts-pie-sector"
        }, (0, $1ea0ac8e1739d80a$export$ca62be0d67a3158c)(restOfAllOtherProps, entry, i), {
            // @ts-expect-error the types need a bit of attention
            onMouseEnter: onMouseEnterFromContext(entry, i),
            onMouseLeave: onMouseLeaveFromContext(entry, i),
            onClick: onClickFromContext(entry, i)
        }), /*#__PURE__*/ $aivMx.createElement((0, $333e6f5e0fe541db$export$6428a7f2611ef1fa), $966dda21f47144a9$var$_extends({
            option: shape !== null && shape !== void 0 ? shape : sectorOptions,
            shapeType: "sector",
            isActive: isActive
        }, sectorProps)));
    }));
}
function $966dda21f47144a9$export$c404972144c91fdf(_ref4) {
    var _pieSettings$paddingA;
    var { pieSettings: pieSettings, displayedData: displayedData, cells: cells, offset: offset } = _ref4;
    var { cornerRadius: cornerRadius, startAngle: startAngle, endAngle: endAngle, dataKey: dataKey, nameKey: nameKey, tooltipType: tooltipType } = pieSettings;
    var minAngle = Math.abs(pieSettings.minAngle);
    var deltaAngle = $966dda21f47144a9$var$parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var paddingAngle = displayedData.length <= 1 ? 0 : (_pieSettings$paddingA = pieSettings.paddingAngle) !== null && _pieSettings$paddingA !== void 0 ? _pieSettings$paddingA : 0;
    var notZeroItemCount = displayedData.filter((entry)=>(0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey, 0) !== 0).length;
    var totalPaddingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPaddingAngle;
    var sum = displayedData.reduce((result, entry)=>{
        var val = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey, 0);
        return result + ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = displayedData.map((entry, i)=>{
            // @ts-expect-error getValueByDataKey does not validate the output type
            var val = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, dataKey, 0);
            // @ts-expect-error getValueByDataKey does not validate the output type
            var name = (0, $09206e1485e62bdb$export$f97fc4a450f29a)(entry, nameKey, i);
            var coordinate = $966dda21f47144a9$var$parseCoordinateOfPie(pieSettings, offset, entry);
            var percent = ((0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(val) ? val : 0) / sum;
            var tempStartAngle;
            var entryWithCellInfo = $966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread({}, entry), cells && cells[i] && cells[i].props);
            if (i) tempStartAngle = prev.endAngle + (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entryWithCellInfo,
                    dataKey: dataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = $966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread({}, pieSettings.presentationProps), {}, {
                percent: percent,
                cornerRadius: typeof cornerRadius === 'string' ? parseFloat(cornerRadius) : cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entryWithCellInfo), coordinate), {}, {
                value: val,
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entryWithCellInfo,
                paddingAngle: (0, $9d9ad0197f7e4c2b$export$9d334328eb75e624)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return sectors;
}
function $966dda21f47144a9$var$PieLabelListProvider(_ref5) {
    var { showLabels: showLabels, sectors: sectors, children: children } = _ref5;
    var labelListEntries = (0, $aivMx.useMemo)(()=>{
        if (!showLabels || !sectors) return [];
        return sectors.map((entry)=>({
                value: entry.value,
                payload: entry.payload,
                clockWise: false,
                parentViewBox: undefined,
                viewBox: {
                    cx: entry.cx,
                    cy: entry.cy,
                    innerRadius: entry.innerRadius,
                    outerRadius: entry.outerRadius,
                    startAngle: entry.startAngle,
                    endAngle: entry.endAngle,
                    clockWise: false
                },
                fill: entry.fill
            }));
    }, [
        sectors,
        showLabels
    ]);
    return /*#__PURE__*/ $aivMx.createElement((0, $bdc309bb5887af46$export$38a852d7976af0fe), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $966dda21f47144a9$var$SectorsWithAnimation(_ref6) {
    var { props: props, previousSectorsRef: previousSectorsRef } = _ref6;
    var { sectors: sectors, isAnimationActive: isAnimationActive, animationBegin: animationBegin, animationDuration: animationDuration, animationEasing: animationEasing, activeShape: activeShape, inactiveShape: inactiveShape, onAnimationStart: onAnimationStart, onAnimationEnd: onAnimationEnd } = props;
    var animationId = (0, $85b2a51d25cd2e70$export$e1042b2944b80b7f)(props, 'recharts-pie-');
    var prevSectors = previousSectorsRef.current;
    var [isAnimating, setIsAnimating] = (0, $aivMx.useState)(false);
    var handleAnimationEnd = (0, $aivMx.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, $aivMx.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    return /*#__PURE__*/ $aivMx.createElement($966dda21f47144a9$var$PieLabelListProvider, {
        showLabels: !isAnimating,
        sectors: sectors
    }, /*#__PURE__*/ $aivMx.createElement((0, $6e14365e65dd4f13$export$5d41821894c47c52), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationStart: handleAnimationStart,
        onAnimationEnd: handleAnimationEnd,
        key: animationId
    }, (t)=>{
        var stepData = [];
        var first = sectors && sectors[0];
        var curAngle = first === null || first === void 0 ? void 0 : first.startAngle;
        sectors === null || sectors === void 0 || sectors.forEach((entry, index)=>{
            var prev = prevSectors && prevSectors[index];
            var paddingAngle = index > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($a7b626aae7e6649e$exports)))(entry, 'paddingAngle', 0) : 0;
            if (prev) {
                var angle = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle, t);
                var latest = $966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread({}, entry), {}, {
                    startAngle: curAngle + paddingAngle,
                    endAngle: curAngle + angle + paddingAngle
                });
                stepData.push(latest);
                curAngle = latest.endAngle;
            } else {
                var { endAngle: endAngle, startAngle: startAngle } = entry;
                var deltaAngle = (0, $9d9ad0197f7e4c2b$export$89e29e4ab65e70a9)(0, endAngle - startAngle, t);
                var _latest = $966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread({}, entry), {}, {
                    startAngle: curAngle + paddingAngle,
                    endAngle: curAngle + deltaAngle + paddingAngle
                });
                stepData.push(_latest);
                curAngle = _latest.endAngle;
            }
        });
        // eslint-disable-next-line no-param-reassign
        previousSectorsRef.current = stepData;
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), null, /*#__PURE__*/ $aivMx.createElement($966dda21f47144a9$var$PieSectors, {
            sectors: stepData,
            activeShape: activeShape,
            inactiveShape: inactiveShape,
            allOtherPieProps: props,
            shape: props.shape
        }));
    }), /*#__PURE__*/ $aivMx.createElement($966dda21f47144a9$var$PieLabelList, {
        showLabels: !isAnimating,
        sectors: sectors,
        props: props
    }), props.children);
}
var $966dda21f47144a9$var$defaultPieProps = {
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    cx: '50%',
    cy: '50%',
    dataKey: 'value',
    endAngle: 360,
    fill: '#808080',
    hide: false,
    innerRadius: 0,
    isAnimationActive: !(0, $a898dc03dc17f75a$export$98f03c5d19621d70).isSsr,
    labelLine: true,
    legendType: 'rect',
    minAngle: 0,
    nameKey: 'name',
    outerRadius: '80%',
    paddingAngle: 0,
    rootTabIndex: 0,
    startAngle: 0,
    stroke: '#fff',
    zIndex: (0, $5ad557dd967fc64c$export$96df16b28aa32702).area
};
function $966dda21f47144a9$var$PieImpl(props) {
    var { id: id } = props, propsWithoutId = $966dda21f47144a9$var$_objectWithoutProperties(props, $966dda21f47144a9$var$_excluded3);
    var { hide: hide, className: className, rootTabIndex: rootTabIndex } = props;
    var cells = (0, $aivMx.useMemo)(()=>(0, $a703e7e67d5286d1$export$fdd5e64c0e8495bb)(props.children, (0, $66258e37252e74df$export$f6f0c3fe4ec306ea)), [
        props.children
    ]);
    var sectors = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $1387e3f5faddb23b$export$c6af8a90408f4a64)(state, id, cells));
    var previousSectorsRef = (0, $aivMx.useRef)(null);
    var layerClass = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-pie', className);
    if (hide || sectors == null) {
        previousSectorsRef.current = null;
        return /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
            tabIndex: rootTabIndex,
            className: layerClass
        });
    }
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $aivMx.createElement($966dda21f47144a9$var$SetPieTooltipEntrySettings, {
        dataKey: props.dataKey,
        nameKey: props.nameKey,
        sectors: sectors,
        stroke: props.stroke,
        strokeWidth: props.strokeWidth,
        fill: props.fill,
        name: props.name,
        hide: props.hide,
        tooltipType: props.tooltipType
    }), /*#__PURE__*/ $aivMx.createElement((0, $d3f671dc6f3ee601$export$936d0764594b6eb3), {
        tabIndex: rootTabIndex,
        className: layerClass
    }, /*#__PURE__*/ $aivMx.createElement($966dda21f47144a9$var$SectorsWithAnimation, {
        props: $966dda21f47144a9$var$_objectSpread($966dda21f47144a9$var$_objectSpread({}, propsWithoutId), {}, {
            sectors: sectors
        }),
        previousSectorsRef: previousSectorsRef
    })));
}
function $966dda21f47144a9$export$2ae8800cf67c848c(outsideProps) {
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $966dda21f47144a9$var$defaultPieProps);
    var { id: externalId } = props, propsWithoutId = $966dda21f47144a9$var$_objectWithoutProperties(props, $966dda21f47144a9$var$_excluded4);
    var presentationProps = (0, $bf74bd062767a6f3$export$8b56257912140094)(propsWithoutId);
    return /*#__PURE__*/ $aivMx.createElement((0, $5cc9e31d9b078aed$export$8c2f307ff93f02ba), {
        id: externalId,
        type: "pie"
    }, (id)=>/*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement((0, $9b9188165a8d5ee0$export$8d7124402ca6b71c), {
            type: "pie",
            id: id,
            data: propsWithoutId.data,
            dataKey: propsWithoutId.dataKey,
            hide: propsWithoutId.hide,
            angleAxisId: 0,
            radiusAxisId: 0,
            name: propsWithoutId.name,
            nameKey: propsWithoutId.nameKey,
            tooltipType: propsWithoutId.tooltipType,
            legendType: propsWithoutId.legendType,
            fill: propsWithoutId.fill,
            cx: propsWithoutId.cx,
            cy: propsWithoutId.cy,
            startAngle: propsWithoutId.startAngle,
            endAngle: propsWithoutId.endAngle,
            paddingAngle: propsWithoutId.paddingAngle,
            minAngle: propsWithoutId.minAngle,
            innerRadius: propsWithoutId.innerRadius,
            outerRadius: propsWithoutId.outerRadius,
            cornerRadius: propsWithoutId.cornerRadius,
            presentationProps: presentationProps,
            maxRadius: props.maxRadius
        }), /*#__PURE__*/ $aivMx.createElement($966dda21f47144a9$var$SetPiePayloadLegend, $966dda21f47144a9$var$_extends({}, propsWithoutId, {
            id: id
        })), /*#__PURE__*/ $aivMx.createElement($966dda21f47144a9$var$PieImpl, $966dda21f47144a9$var$_extends({}, propsWithoutId, {
            id: id
        }))));
}
$966dda21f47144a9$export$2ae8800cf67c848c.displayName = 'Pie';


var $aivMx = parcelRequire("aivMx");


var $aivMx = parcelRequire("aivMx");





var $aivMx = parcelRequire("aivMx");


function $0a3a8c429ee9d7b1$export$babaff6c249d1f4b(props) {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    (0, $aivMx.useEffect)(()=>{
        dispatch((0, $9bd6c091a21f244d$export$5dfe4dcb848af93f)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}




var $b95984adad758d86$var$_excluded = [
    "layout"
];
function $b95984adad758d86$var$_extends() {
    return $b95984adad758d86$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b95984adad758d86$var$_extends.apply(null, arguments);
}
function $b95984adad758d86$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b95984adad758d86$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b95984adad758d86$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b95984adad758d86$var$defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
/**
 * These default props are the same for all PolarChart components.
 */ var $b95984adad758d86$var$defaultProps = {
    accessibilityLayer: true,
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: $b95984adad758d86$var$defaultMargin,
    reverseStackOrder: false,
    syncMethod: 'index',
    layout: 'radial',
    responsive: false
};
var $b95984adad758d86$export$8de722e497513838 = /*#__PURE__*/ (0, $aivMx.forwardRef)(function PolarChart(props, ref) {
    var _polarChartProps$id;
    var polarChartProps = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(props.categoricalChartProps, $b95984adad758d86$var$defaultProps);
    var { layout: layout } = polarChartProps, otherCategoricalProps = $b95984adad758d86$var$_objectWithoutProperties(polarChartProps, $b95984adad758d86$var$_excluded);
    var { chartName: chartName, defaultTooltipEventType: defaultTooltipEventType, validateTooltipEventTypes: validateTooltipEventTypes, tooltipPayloadSearcher: tooltipPayloadSearcher } = props;
    var options = {
        chartName: chartName,
        defaultTooltipEventType: defaultTooltipEventType,
        validateTooltipEventTypes: validateTooltipEventTypes,
        tooltipPayloadSearcher: tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ $aivMx.createElement((0, $d9644cbb81cad403$export$debe87639f2707f9), {
        preloadedState: {
            options: options
        },
        reduxStoreName: (_polarChartProps$id = polarChartProps.id) !== null && _polarChartProps$id !== void 0 ? _polarChartProps$id : chartName
    }, /*#__PURE__*/ $aivMx.createElement((0, $d94c6d6afa2971cf$export$2100a1dedbca0238), {
        chartData: polarChartProps.data
    }), /*#__PURE__*/ $aivMx.createElement((0, $cda7a91bff70ffe1$export$6faeaad6e02c2e9d), {
        layout: layout,
        margin: polarChartProps.margin
    }), /*#__PURE__*/ $aivMx.createElement((0, $e07526bda954b171$export$6fabfb9ba230d12b), {
        baseValue: undefined,
        accessibilityLayer: polarChartProps.accessibilityLayer,
        barCategoryGap: polarChartProps.barCategoryGap,
        maxBarSize: polarChartProps.maxBarSize,
        stackOffset: polarChartProps.stackOffset,
        barGap: polarChartProps.barGap,
        barSize: polarChartProps.barSize,
        syncId: polarChartProps.syncId,
        syncMethod: polarChartProps.syncMethod,
        className: polarChartProps.className,
        reverseStackOrder: polarChartProps.reverseStackOrder
    }), /*#__PURE__*/ $aivMx.createElement((0, $0a3a8c429ee9d7b1$export$babaff6c249d1f4b), {
        cx: polarChartProps.cx,
        cy: polarChartProps.cy,
        startAngle: polarChartProps.startAngle,
        endAngle: polarChartProps.endAngle,
        innerRadius: polarChartProps.innerRadius,
        outerRadius: polarChartProps.outerRadius
    }), /*#__PURE__*/ $aivMx.createElement((0, $bf8fc15659d6b7b6$export$d49e03133b3316a9), $b95984adad758d86$var$_extends({}, otherCategoricalProps, {
        ref: ref
    })));
});



var $a2a03cff1c144ec9$var$allowedTooltipTypes = [
    'item'
];
var $a2a03cff1c144ec9$var$defaultProps = {
    layout: 'centric',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
};
var $a2a03cff1c144ec9$export$b99d3348f709c998 = /*#__PURE__*/ (0, $aivMx.forwardRef)((props, ref)=>{
    var propsWithDefaults = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(props, $a2a03cff1c144ec9$var$defaultProps);
    return /*#__PURE__*/ $aivMx.createElement((0, $b95984adad758d86$export$8de722e497513838), {
        chartName: "PieChart",
        defaultTooltipEventType: "item",
        validateTooltipEventTypes: $a2a03cff1c144ec9$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $9a03b151feb18982$export$3d996ff386c7802d),
        categoricalChartProps: propsWithDefaults,
        ref: ref
    });
});


var $aivMx = parcelRequire("aivMx");


var $aivMx = parcelRequire("aivMx");



function $fb179dab27c636af$var$_extends() {
    return $fb179dab27c636af$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fb179dab27c636af$var$_extends.apply(null, arguments);
}
function $fb179dab27c636af$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb179dab27c636af$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb179dab27c636af$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fb179dab27c636af$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb179dab27c636af$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fb179dab27c636af$var$_defineProperty(e, r, t) {
    return (r = $fb179dab27c636af$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fb179dab27c636af$var$_toPropertyKey(t) {
    var i = $fb179dab27c636af$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fb179dab27c636af$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fb179dab27c636af$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(value[0]) && (0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $fb179dab27c636af$export$6fe33945eebf9ac8 = (props)=>{
    var { separator: separator = ' : ', contentStyle: contentStyle = {}, itemStyle: itemStyle = {}, labelStyle: labelStyle = {}, payload: payload, formatter: formatter, itemSorter: itemSorter, wrapperClassName: wrapperClassName, labelClassName: labelClassName, label: label, labelFormatter: labelFormatter, accessibilityLayer: accessibilityLayer = false } = props;
    var renderContent = ()=>{
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($63d55c965c0eca64$exports)))(payload, itemSorter) : payload).map((entry, i)=>{
                if (entry.type === 'none') return null;
                var finalFormatter = entry.formatter || formatter || $fb179dab27c636af$var$defaultFormatter;
                var { value: value, name: name } = entry;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) [finalValue, finalName] = formatted;
                    else if (formatted != null) finalValue = formatted;
                    else return null;
                }
                var finalItemStyle = $fb179dab27c636af$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                return /*#__PURE__*/ $aivMx.createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ $aivMx.createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $9d9ad0197f7e4c2b$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ $aivMx.createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ $aivMx.createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ $aivMx.createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || ''));
            });
            return /*#__PURE__*/ $aivMx.createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $fb179dab27c636af$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $fb179dab27c636af$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, $9d9ad0197f7e4c2b$export$b931b78cbb3caf86)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ $aivMx.createElement("div", $fb179dab27c636af$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ $aivMx.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ $aivMx.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $aivMx = parcelRequire("aivMx");


var $2cef97f3aa7c17b9$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $2cef97f3aa7c17b9$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $2cef97f3aa7c17b9$export$46aee7ef09f78756(_ref) {
    var { coordinate: coordinate, translateX: translateX, translateY: translateY } = _ref;
    return (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)($2cef97f3aa7c17b9$var$CSS_CLASS_PREFIX, {
        ["".concat($2cef97f3aa7c17b9$var$CSS_CLASS_PREFIX, "-right")]: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(translateX) && coordinate && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x,
        ["".concat($2cef97f3aa7c17b9$var$CSS_CLASS_PREFIX, "-left")]: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(translateX) && coordinate && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x,
        ["".concat($2cef97f3aa7c17b9$var$CSS_CLASS_PREFIX, "-bottom")]: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(translateY) && coordinate && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y,
        ["".concat($2cef97f3aa7c17b9$var$CSS_CLASS_PREFIX, "-top")]: (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(translateY) && coordinate && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y
    });
}
function $2cef97f3aa7c17b9$export$4cccba03fe0eccc6(_ref2) {
    var { allowEscapeViewBox: allowEscapeViewBox, coordinate: coordinate, key: key, offsetTopLeft: offsetTopLeft, position: position, reverseDirection: reverseDirection, tooltipDimension: tooltipDimension, viewBox: viewBox, viewBoxDimension: viewBoxDimension } = _ref2;
    if (position && (0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - (offsetTopLeft > 0 ? offsetTopLeft : 0);
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    var viewBoxKey = viewBox[key];
    if (viewBoxKey == null) return 0;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBoxKey;
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBoxKey);
        return Math.max(negative, viewBoxKey);
    }
    if (viewBoxDimension == null) return 0;
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBoxKey + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBoxKey);
    return Math.max(positive, viewBoxKey);
}
function $2cef97f3aa7c17b9$export$4fe0982879780f9b(_ref3) {
    var { translateX: translateX, translateY: translateY, useTranslate3d: useTranslate3d } = _ref3;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $2cef97f3aa7c17b9$export$25e3b0ae21503056(_ref4) {
    var { allowEscapeViewBox: allowEscapeViewBox, coordinate: coordinate, offsetTopLeft: offsetTopLeft, position: position, reverseDirection: reverseDirection, tooltipBox: tooltipBox, useTranslate3d: useTranslate3d, viewBox: viewBox } = _ref4;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $2cef97f3aa7c17b9$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $2cef97f3aa7c17b9$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $2cef97f3aa7c17b9$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $2cef97f3aa7c17b9$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $2cef97f3aa7c17b9$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $48343d2a5adaa4cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48343d2a5adaa4cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48343d2a5adaa4cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $48343d2a5adaa4cf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48343d2a5adaa4cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $48343d2a5adaa4cf$var$_defineProperty(e, r, t) {
    return (r = $48343d2a5adaa4cf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $48343d2a5adaa4cf$var$_toPropertyKey(t) {
    var i = $48343d2a5adaa4cf$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $48343d2a5adaa4cf$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $48343d2a5adaa4cf$export$9e6cee7b86551b9c extends (0, $aivMx.PureComponent) {
    constructor(){
        super(...arguments);
        $48343d2a5adaa4cf$var$_defineProperty(this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        $48343d2a5adaa4cf$var$_defineProperty(this, "handleKeyDown", (event)=>{
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
    componentDidUpdate() {
        var _this$props$coordinat5, _this$props$coordinat6;
        if (!this.state.dismissed) return;
        if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
    }
    render() {
        var { active: active, allowEscapeViewBox: allowEscapeViewBox, animationDuration: animationDuration, animationEasing: animationEasing, children: children, coordinate: coordinate, hasPayload: hasPayload, isAnimationActive: isAnimationActive, offset: offset, position: position, reverseDirection: reverseDirection, useTranslate3d: useTranslate3d, viewBox: viewBox, wrapperStyle: wrapperStyle, lastBoundingBox: lastBoundingBox, innerRef: innerRef, hasPortalFromProps: hasPortalFromProps } = this.props;
        var { cssClasses: cssClasses, cssProperties: cssProperties } = (0, $2cef97f3aa7c17b9$export$25e3b0ae21503056)({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            offsetTopLeft: offset,
            position: position,
            reverseDirection: reverseDirection,
            tooltipBox: {
                height: lastBoundingBox.height,
                width: lastBoundingBox.width
            },
            useTranslate3d: useTranslate3d,
            viewBox: viewBox
        });
        // do not use absolute styles if the user has passed a custom portal prop
        var positionStyles = hasPortalFromProps ? {} : $48343d2a5adaa4cf$var$_objectSpread($48343d2a5adaa4cf$var$_objectSpread({
            transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
        }, cssProperties), {}, {
            pointerEvents: 'none',
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
            position: 'absolute',
            top: 0,
            left: 0
        });
        var outerStyle = $48343d2a5adaa4cf$var$_objectSpread($48343d2a5adaa4cf$var$_objectSpread({}, positionStyles), {}, {
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden'
        }, wrapperStyle);
        return(/*#__PURE__*/ // This element allow listening to the `Escape` key. See https://github.com/recharts/recharts/pull/2925
        $aivMx.createElement("div", {
            // @ts-expect-error typescript library does not recognize xmlns attribute, but it's required for an HTML chunk inside SVG.
            xmlns: "http://www.w3.org/1999/xhtml",
            tabIndex: -1,
            className: cssClasses,
            style: outerStyle,
            ref: innerRef
        }, children));
    }
}








var $aivMx = parcelRequire("aivMx");




var $aivMx = parcelRequire("aivMx");



var $4789f72ff4033c64$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $4789f72ff4033c64$var$_extends() {
    return $4789f72ff4033c64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4789f72ff4033c64$var$_extends.apply(null, arguments);
}
function $4789f72ff4033c64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4789f72ff4033c64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4789f72ff4033c64$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4789f72ff4033c64$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4789f72ff4033c64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4789f72ff4033c64$var$_defineProperty(e, r, t) {
    return (r = $4789f72ff4033c64$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4789f72ff4033c64$var$_toPropertyKey(t) {
    var i = $4789f72ff4033c64$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4789f72ff4033c64$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4789f72ff4033c64$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4789f72ff4033c64$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4789f72ff4033c64$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4789f72ff4033c64$var$getPath = (x, y, width, height, top, left)=>{
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $4789f72ff4033c64$export$3c877bb842c36952 = (_ref)=>{
    var { x: x = 0, y: y = 0, top: top = 0, left: left = 0, width: width = 0, height: height = 0, className: className } = _ref, rest = $4789f72ff4033c64$var$_objectWithoutProperties(_ref, $4789f72ff4033c64$var$_excluded);
    var props = $4789f72ff4033c64$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(x) || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(y) || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(width) || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(height) || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(top) || !(0, $9d9ad0197f7e4c2b$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ $aivMx.createElement("path", $4789f72ff4033c64$var$_extends({}, (0, $61a9c4d36b40070f$export$67f8fc03e57e2747)(props), {
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-cross', className),
        d: $4789f72ff4033c64$var$getPath(x, y, width, height, top, left)
    }));
};


function $d348aafac40f4395$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $29c5032d4efe527a$export$ad661ef85a042a4f(activeCoordinate) {
    var { cx: cx, cy: cy, radius: radius, startAngle: startAngle, endAngle: endAngle } = activeCoordinate;
    var startPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}






function $bd0c42b34e069e51$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    if (layout === 'horizontal') return [
        {
            x: activeCoordinate.x,
            y: offset.top
        },
        {
            x: activeCoordinate.x,
            y: offset.top + offset.height
        }
    ];
    if (layout === 'vertical') return [
        {
            x: offset.left,
            y: activeCoordinate.y
        },
        {
            x: offset.left + offset.width,
            y: activeCoordinate.y
        }
    ];
    if ((0, $1ea0ac8e1739d80a$export$b8cdb4ab1d25db49)(activeCoordinate)) {
        if (layout === 'centric') {
            var { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, angle: angle } = activeCoordinate;
            var innerPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $e8905a15bef036aa$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            return [
                {
                    x: innerPoint.x,
                    y: innerPoint.y
                },
                {
                    x: outerPoint.x,
                    y: outerPoint.y
                }
            ];
        }
        return (0, $29c5032d4efe527a$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return undefined;
}







function $9484f025bfc08725$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9484f025bfc08725$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9484f025bfc08725$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9484f025bfc08725$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9484f025bfc08725$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9484f025bfc08725$var$_defineProperty(e, r, t) {
    return (r = $9484f025bfc08725$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $9484f025bfc08725$var$_toPropertyKey(t) {
    var i = $9484f025bfc08725$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $9484f025bfc08725$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9484f025bfc08725$export$952de9be87065336 = ()=>(0, $7729c221c7142965$export$a7347740d65f620b)((0, $40ff607ce3fff820$export$27d9004292294cd7));
var $9484f025bfc08725$export$fd17f57c33e9d17e = ()=>{
    var tooltipAxis = $9484f025bfc08725$export$952de9be87065336();
    var tooltipTicks = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$ffe0e60f8c88c05a));
    var tooltipAxisScale = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $1fec9e0b4d773a24$export$cdeccbbdd343ae59));
    if (!tooltipAxis || !tooltipAxisScale) return (0, $09206e1485e62bdb$export$212ec45c42fe68a7)(undefined, tooltipTicks);
    return (0, $09206e1485e62bdb$export$212ec45c42fe68a7)($9484f025bfc08725$var$_objectSpread($9484f025bfc08725$var$_objectSpread({}, tooltipAxis), {}, {
        scale: tooltipAxisScale
    }), tooltipTicks);
};






function $cf3a12f488877c01$var$_extends() {
    return $cf3a12f488877c01$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cf3a12f488877c01$var$_extends.apply(null, arguments);
}
function $cf3a12f488877c01$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf3a12f488877c01$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf3a12f488877c01$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cf3a12f488877c01$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf3a12f488877c01$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cf3a12f488877c01$var$_defineProperty(e, r, t) {
    return (r = $cf3a12f488877c01$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cf3a12f488877c01$var$_toPropertyKey(t) {
    var i = $cf3a12f488877c01$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cf3a12f488877c01$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * If set false, no cursor will be drawn when tooltip is active.
 * If set an object, the option is the configuration of cursor.
 * If set a React element, the option is the custom react element of drawing cursor
 */ function $cf3a12f488877c01$var$RenderCursor(_ref) {
    var { cursor: cursor, cursorComp: cursorComp, cursorProps: cursorProps } = _ref;
    if (/*#__PURE__*/ (0, $aivMx.isValidElement)(cursor)) return /*#__PURE__*/ (0, $aivMx.cloneElement)(cursor, cursorProps);
    return /*#__PURE__*/ (0, $aivMx.createElement)(cursorComp, cursorProps);
}
function $cf3a12f488877c01$export$3ea3a57cbaeb6b4e(props) {
    var _props$zIndex;
    var { coordinate: coordinate, payload: payload, index: index, offset: offset, tooltipAxisBandSize: tooltipAxisBandSize, layout: layout, cursor: cursor, tooltipEventType: tooltipEventType, chartName: chartName } = props;
    // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
    var activeCoordinate = coordinate;
    var activePayload = payload;
    var activeTooltipIndex = index;
    if (!cursor || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps, cursorComp, preferredZIndex;
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $4789f72ff4033c64$export$3c877bb842c36952);
        preferredZIndex = (0, $5ad557dd967fc64c$export$96df16b28aa32702).cursorLine;
    } else if (chartName === 'BarChart') {
        restProps = (0, $d348aafac40f4395$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $ef5048504f25e0b5$export$4617fb02663045ef);
        preferredZIndex = (0, $5ad557dd967fc64c$export$96df16b28aa32702).cursorRectangle;
    } else if (layout === 'radial' && (0, $1ea0ac8e1739d80a$export$b8cdb4ab1d25db49)(activeCoordinate)) {
        var { cx: cx, cy: cy, radius: radius, startAngle: startAngle, endAngle: endAngle } = (0, $29c5032d4efe527a$export$ad661ef85a042a4f)(activeCoordinate);
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $fc5569a992bb3703$export$e98c2c7eb2b14f45);
        preferredZIndex = (0, $5ad557dd967fc64c$export$96df16b28aa32702).cursorLine;
    } else {
        restProps = {
            points: (0, $bd0c42b34e069e51$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $f4997a3a0c463bed$export$b0e83c3ef8d2db1);
        preferredZIndex = (0, $5ad557dd967fc64c$export$96df16b28aa32702).cursorLine;
    }
    var extraClassName = typeof cursor === 'object' && 'className' in cursor ? cursor.className : undefined;
    var cursorProps = $cf3a12f488877c01$var$_objectSpread($cf3a12f488877c01$var$_objectSpread($cf3a12f488877c01$var$_objectSpread($cf3a12f488877c01$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $bf74bd062767a6f3$export$6d5921c09aa671a9)(cursor)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)('recharts-tooltip-cursor', extraClassName)
    });
    return /*#__PURE__*/ $aivMx.createElement((0, $e548635fa476b495$export$b37befaf92aba9f1), {
        zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : preferredZIndex
    }, /*#__PURE__*/ $aivMx.createElement($cf3a12f488877c01$var$RenderCursor, {
        cursor: cursor,
        cursorComp: cursorComp,
        cursorProps: cursorProps
    }));
}
function $cf3a12f488877c01$export$b6a79797ad180576(props) {
    var tooltipAxisBandSize = (0, $9484f025bfc08725$export$fd17f57c33e9d17e)();
    var offset = (0, $2d4a23e6670568d2$export$10605f61bef2858a)();
    var layout = (0, $2d4a23e6670568d2$export$970c79ecc7081cc)();
    var chartName = (0, $0d9ada87ae089576$export$ed30b3372172c46c)();
    if (tooltipAxisBandSize == null || offset == null || layout == null || chartName == null) return null;
    return /*#__PURE__*/ $aivMx.createElement($cf3a12f488877c01$export$3ea3a57cbaeb6b4e, $cf3a12f488877c01$var$_extends({}, props, {
        offset: offset,
        layout: layout,
        tooltipAxisBandSize: tooltipAxisBandSize,
        chartName: chartName
    }));
}









function $ebc06b7521ee0e46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ebc06b7521ee0e46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ebc06b7521ee0e46$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ebc06b7521ee0e46$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ebc06b7521ee0e46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ebc06b7521ee0e46$var$_defineProperty(e, r, t) {
    return (r = $ebc06b7521ee0e46$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ebc06b7521ee0e46$var$_toPropertyKey(t) {
    var i = $ebc06b7521ee0e46$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ebc06b7521ee0e46$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ebc06b7521ee0e46$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $ebc06b7521ee0e46$var$renderContent(content, props) {
    if (/*#__PURE__*/ $aivMx.isValidElement(content)) return /*#__PURE__*/ $aivMx.cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ $aivMx.createElement(content, props);
    return /*#__PURE__*/ $aivMx.createElement((0, $fb179dab27c636af$export$6fe33945eebf9ac8), props);
}
var $ebc06b7521ee0e46$var$emptyPayload = [];
var $ebc06b7521ee0e46$var$defaultTooltipProps = {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    axisId: 0,
    contentStyle: {},
    cursor: true,
    filterNull: true,
    isAnimationActive: !(0, $a898dc03dc17f75a$export$98f03c5d19621d70).isSsr,
    itemSorter: 'name',
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    wrapperStyle: {}
};
function $ebc06b7521ee0e46$export$28c660c63b792dea(outsideProps) {
    var _useAppSelector, _ref;
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $ebc06b7521ee0e46$var$defaultTooltipProps);
    var { active: activeFromProps, allowEscapeViewBox: allowEscapeViewBox, animationDuration: animationDuration, animationEasing: animationEasing, content: content, filterNull: filterNull, isAnimationActive: isAnimationActive, offset: offset, payloadUniqBy: payloadUniqBy, position: position, reverseDirection: reverseDirection, useTranslate3d: useTranslate3d, wrapperStyle: wrapperStyle, cursor: cursor, shared: shared, trigger: trigger, defaultIndex: defaultIndex, portal: portalFromProps, axisId: axisId } = props;
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var defaultIndexAsString = typeof defaultIndex === 'number' ? String(defaultIndex) : defaultIndex;
    (0, $aivMx.useEffect)(()=>{
        dispatch((0, $c54e506cc16ecb3e$export$8d517a53c4528750)({
            shared: shared,
            trigger: trigger,
            axisId: axisId,
            active: activeFromProps,
            defaultIndex: defaultIndexAsString
        }));
    }, [
        dispatch,
        shared,
        trigger,
        axisId,
        activeFromProps,
        defaultIndexAsString
    ]);
    var viewBox = (0, $2d4a23e6670568d2$export$76b29bb074e0c45a)();
    var accessibilityLayer = (0, $08040eca3d3c0c30$export$276788f18f24cad3)();
    var tooltipEventType = (0, $c4309ff5980e62d8$export$7ac1fe18a92be318)(shared);
    var { activeIndex: activeIndex, isActive: isActive } = (_useAppSelector = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $0d9ada87ae089576$export$c8884ed37796034a)(state, tooltipEventType, trigger, defaultIndexAsString))) !== null && _useAppSelector !== void 0 ? _useAppSelector : {};
    var payloadFromRedux = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $0d9ada87ae089576$export$529676bfdba08611)(state, tooltipEventType, trigger, defaultIndexAsString));
    var labelFromRedux = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $0d9ada87ae089576$export$400c35cc3b9a0487)(state, tooltipEventType, trigger, defaultIndexAsString));
    var coordinate = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $0d9ada87ae089576$export$392a0083df9bfd7c)(state, tooltipEventType, trigger, defaultIndexAsString));
    var payload = payloadFromRedux;
    var tooltipPortalFromContext = (0, $433c73e78ad72698$export$2842d70d9d62127a)();
    /*
   * The user can set `active=true` on the Tooltip in which case the Tooltip will stay always active,
   * or `active=false` in which case the Tooltip never shows.
   *
   * If the `active` prop is not defined then it will show and hide based on mouse or keyboard activity.
   */ var finalIsActive = (_ref = activeFromProps !== null && activeFromProps !== void 0 ? activeFromProps : isActive) !== null && _ref !== void 0 ? _ref : false;
    var [lastBoundingBox, updateBoundingBox] = (0, $789fe1100772c0d2$export$35f58fcda6094144)([
        payload,
        finalIsActive
    ]);
    var finalLabel = tooltipEventType === 'axis' ? labelFromRedux : undefined;
    (0, $0bebaaa81de07330$export$21f8394fb189b529)(tooltipEventType, trigger, coordinate, finalLabel, activeIndex, finalIsActive);
    var tooltipPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : tooltipPortalFromContext;
    if (tooltipPortal == null || viewBox == null || tooltipEventType == null) return null;
    var finalPayload = payload !== null && payload !== void 0 ? payload : $ebc06b7521ee0e46$var$emptyPayload;
    if (!finalIsActive) finalPayload = $ebc06b7521ee0e46$var$emptyPayload;
    if (filterNull && finalPayload.length) finalPayload = (0, $6207a5a19aec9083$export$b67e33c2fb1535fa)(finalPayload.filter((entry)=>entry.value != null && (entry.hide !== true || props.includeHidden)), payloadUniqBy, $ebc06b7521ee0e46$var$defaultUniqBy);
    var hasPayload = finalPayload.length > 0;
    var tooltipElement = /*#__PURE__*/ $aivMx.createElement((0, $48343d2a5adaa4cf$export$9e6cee7b86551b9c), {
        allowEscapeViewBox: allowEscapeViewBox,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        active: finalIsActive,
        coordinate: coordinate,
        hasPayload: hasPayload,
        offset: offset,
        position: position,
        reverseDirection: reverseDirection,
        useTranslate3d: useTranslate3d,
        viewBox: viewBox,
        wrapperStyle: wrapperStyle,
        lastBoundingBox: lastBoundingBox,
        innerRef: updateBoundingBox,
        hasPortalFromProps: Boolean(portalFromProps)
    }, $ebc06b7521ee0e46$var$renderContent(content, $ebc06b7521ee0e46$var$_objectSpread($ebc06b7521ee0e46$var$_objectSpread({}, props), {}, {
        payload: finalPayload,
        label: finalLabel,
        active: finalIsActive,
        activeIndex: activeIndex,
        coordinate: coordinate,
        accessibilityLayer: accessibilityLayer
    })));
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ (0, $9f97ad3b314012cb$exports.createPortal)(tooltipElement, tooltipPortal), finalIsActive && /*#__PURE__*/ $aivMx.createElement((0, $cf3a12f488877c01$export$b6a79797ad180576), {
        cursor: cursor,
        tooltipEventType: tooltipEventType,
        coordinate: coordinate,
        payload: finalPayload,
        index: activeIndex
    }));
}


var $aivMx = parcelRequire("aivMx");









var $56b8e0b6636ee8c8$var$_excluded = [
    "domain",
    "range"
], $56b8e0b6636ee8c8$var$_excluded2 = [
    "domain",
    "range"
];
function $56b8e0b6636ee8c8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $56b8e0b6636ee8c8$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $56b8e0b6636ee8c8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $56b8e0b6636ee8c8$var$shortArraysAreEqual(arr1, arr2) {
    if (arr1 === arr2) return true;
    if (Array.isArray(arr1) && arr1.length === 2 && Array.isArray(arr2) && arr2.length === 2) return arr1[0] === arr2[0] && arr1[1] === arr2[1];
    return false;
}
function $56b8e0b6636ee8c8$export$a803260e379f3736(prevProps, nextProps) {
    if (prevProps === nextProps) return true;
    var { domain: prevDomain, range: prevRange } = prevProps, prevRest = $56b8e0b6636ee8c8$var$_objectWithoutProperties(prevProps, $56b8e0b6636ee8c8$var$_excluded);
    var { domain: nextDomain, range: nextRange } = nextProps, nextRest = $56b8e0b6636ee8c8$var$_objectWithoutProperties(nextProps, $56b8e0b6636ee8c8$var$_excluded2);
    if (!$56b8e0b6636ee8c8$var$shortArraysAreEqual(prevDomain, nextDomain)) return false;
    if (!$56b8e0b6636ee8c8$var$shortArraysAreEqual(prevRange, nextRange)) return false;
    return (0, $7fd62a4f2791f570$export$b8f09df787c278d9)(prevRest, nextRest);
}


var $b6d97c3070c142d1$var$_excluded = [
    "dangerouslySetInnerHTML",
    "ticks"
], $b6d97c3070c142d1$var$_excluded2 = [
    "id"
];
function $b6d97c3070c142d1$var$_extends() {
    return $b6d97c3070c142d1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b6d97c3070c142d1$var$_extends.apply(null, arguments);
}
function $b6d97c3070c142d1$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b6d97c3070c142d1$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b6d97c3070c142d1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $b6d97c3070c142d1$var$SetXAxisSettings(settings) {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var prevSettingsRef = (0, $aivMx.useRef)(null);
    (0, $aivMx.useLayoutEffect)(()=>{
        if (prevSettingsRef.current === null) dispatch((0, $9b2a3f99ebd40cd8$export$add6226ad7812fc8)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $9b2a3f99ebd40cd8$export$40aac341c282a543)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $aivMx.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $9b2a3f99ebd40cd8$export$f408189458c6a79b)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var $b6d97c3070c142d1$var$XAxisImpl = (props)=>{
    var { xAxisId: xAxisId, className: className } = props;
    var viewBox = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $680da228e16ed19c$export$32c8e778bac69ce4));
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var axisType = 'xAxis';
    var scale = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$22e8e5f8924724ea)(state, axisType, xAxisId, isPanorama));
    var cartesianTickItems = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$f0d85e8287c47657)(state, axisType, xAxisId, isPanorama));
    var axisSize = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$50d4085c87c19b12)(state, xAxisId));
    var position = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$92fdc590d2371053)(state, xAxisId));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$8079b33b4a6a2ac5)(state, xAxisId));
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML: dangerouslySetInnerHTML, ticks: ticks } = props, allOtherProps = $b6d97c3070c142d1$var$_objectWithoutProperties(props, $b6d97c3070c142d1$var$_excluded);
    var { id: id } = synchronizedSettings, restSynchronizedSettings = $b6d97c3070c142d1$var$_objectWithoutProperties(synchronizedSettings, $b6d97c3070c142d1$var$_excluded2);
    return /*#__PURE__*/ $aivMx.createElement((0, $5c8c13823a5e3ea8$export$bdd99f2cdf352bae), $b6d97c3070c142d1$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        scale: scale,
        x: position.x,
        y: position.y,
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType
    }));
};
var $b6d97c3070c142d1$export$bf921d6fd02045a0 = {
    allowDataOverflow: (0, $40ff607ce3fff820$export$21aec091b6ac8422).allowDataOverflow,
    allowDecimals: (0, $40ff607ce3fff820$export$21aec091b6ac8422).allowDecimals,
    allowDuplicatedCategory: (0, $40ff607ce3fff820$export$21aec091b6ac8422).allowDuplicatedCategory,
    angle: (0, $40ff607ce3fff820$export$21aec091b6ac8422).angle,
    axisLine: (0, $5c8c13823a5e3ea8$export$179c35154a9748c0).axisLine,
    height: (0, $40ff607ce3fff820$export$21aec091b6ac8422).height,
    hide: false,
    includeHidden: (0, $40ff607ce3fff820$export$21aec091b6ac8422).includeHidden,
    interval: (0, $40ff607ce3fff820$export$21aec091b6ac8422).interval,
    minTickGap: (0, $40ff607ce3fff820$export$21aec091b6ac8422).minTickGap,
    mirror: (0, $40ff607ce3fff820$export$21aec091b6ac8422).mirror,
    orientation: (0, $40ff607ce3fff820$export$21aec091b6ac8422).orientation,
    padding: (0, $40ff607ce3fff820$export$21aec091b6ac8422).padding,
    reversed: (0, $40ff607ce3fff820$export$21aec091b6ac8422).reversed,
    scale: (0, $40ff607ce3fff820$export$21aec091b6ac8422).scale,
    tick: (0, $40ff607ce3fff820$export$21aec091b6ac8422).tick,
    tickCount: (0, $40ff607ce3fff820$export$21aec091b6ac8422).tickCount,
    tickLine: (0, $5c8c13823a5e3ea8$export$179c35154a9748c0).tickLine,
    tickSize: (0, $5c8c13823a5e3ea8$export$179c35154a9748c0).tickSize,
    type: (0, $40ff607ce3fff820$export$21aec091b6ac8422).type,
    xAxisId: 0
};
var $b6d97c3070c142d1$var$XAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $b6d97c3070c142d1$export$bf921d6fd02045a0);
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement($b6d97c3070c142d1$var$SetXAxisSettings, {
        allowDataOverflow: props.allowDataOverflow,
        allowDecimals: props.allowDecimals,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        angle: props.angle,
        dataKey: props.dataKey,
        domain: props.domain,
        height: props.height,
        hide: props.hide,
        id: props.xAxisId,
        includeHidden: props.includeHidden,
        interval: props.interval,
        minTickGap: props.minTickGap,
        mirror: props.mirror,
        name: props.name,
        orientation: props.orientation,
        padding: props.padding,
        reversed: props.reversed,
        scale: props.scale,
        tick: props.tick,
        tickCount: props.tickCount,
        tickFormatter: props.tickFormatter,
        ticks: props.ticks,
        type: props.type,
        unit: props.unit
    }), /*#__PURE__*/ $aivMx.createElement($b6d97c3070c142d1$var$XAxisImpl, props));
};
var $b6d97c3070c142d1$export$ea77231de273b52d = /*#__PURE__*/ $aivMx.memo($b6d97c3070c142d1$var$XAxisSettingsDispatcher, (0, $56b8e0b6636ee8c8$export$a803260e379f3736));
$b6d97c3070c142d1$export$ea77231de273b52d.displayName = 'XAxis';


var $aivMx = parcelRequire("aivMx");










var $ea6b60bd0638bcb3$var$_excluded = [
    "dangerouslySetInnerHTML",
    "ticks"
], $ea6b60bd0638bcb3$var$_excluded2 = [
    "id"
];
function $ea6b60bd0638bcb3$var$_extends() {
    return $ea6b60bd0638bcb3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ea6b60bd0638bcb3$var$_extends.apply(null, arguments);
}
function $ea6b60bd0638bcb3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ea6b60bd0638bcb3$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ea6b60bd0638bcb3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $ea6b60bd0638bcb3$var$SetYAxisSettings(settings) {
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var prevSettingsRef = (0, $aivMx.useRef)(null);
    (0, $aivMx.useLayoutEffect)(()=>{
        if (prevSettingsRef.current === null) dispatch((0, $9b2a3f99ebd40cd8$export$4ed10a19d7febea1)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $9b2a3f99ebd40cd8$export$58b7fa4a7d4572f6)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $aivMx.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $9b2a3f99ebd40cd8$export$79db5e9bd25f14c4)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var $ea6b60bd0638bcb3$var$YAxisImpl = (props)=>{
    var { yAxisId: yAxisId, className: className, width: width, label: label } = props;
    var cartesianAxisRef = (0, $aivMx.useRef)(null);
    var labelRef = (0, $aivMx.useRef)(null);
    var viewBox = (0, $7729c221c7142965$export$a7347740d65f620b)((0, $680da228e16ed19c$export$32c8e778bac69ce4));
    var isPanorama = (0, $1c9217aa5a5c378b$export$4b0c59f8845ba920)();
    var dispatch = (0, $7729c221c7142965$export$f51d452c10d5b956)();
    var axisType = 'yAxis';
    var scale = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$22e8e5f8924724ea)(state, axisType, yAxisId, isPanorama));
    var axisSize = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$249bec756af8ac39)(state, yAxisId));
    var position = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$e67a320452ebcaef)(state, yAxisId));
    var cartesianTickItems = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$f0d85e8287c47657)(state, axisType, yAxisId, isPanorama));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $7729c221c7142965$export$a7347740d65f620b)((state)=>(0, $40ff607ce3fff820$export$d0970661da76c14c)(state, yAxisId));
    (0, $aivMx.useLayoutEffect)(()=>{
        // No dynamic width calculation is done when width !== 'auto'
        // or when a function/react element is used for label
        if (width !== 'auto' || !axisSize || (0, $23f34369f47c7824$export$96a48941c06f377f)(label) || /*#__PURE__*/ (0, $aivMx.isValidElement)(label) || synchronizedSettings == null) return;
        var axisComponent = cartesianAxisRef.current;
        if (!axisComponent) return;
        var updatedYAxisWidth = axisComponent.getCalculatedWidth();
        // if the width has changed, dispatch an action to update the width
        if (Math.round(axisSize.width) !== Math.round(updatedYAxisWidth)) dispatch((0, $9b2a3f99ebd40cd8$export$6e42dbbf4e5a5faa)({
            id: yAxisId,
            width: updatedYAxisWidth
        }));
    }, [
        // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
        // The ref will be populated by then.
        // To re-run this effect when ticks change, we can depend on the ticks array from the store.
        cartesianTickItems,
        axisSize,
        dispatch,
        label,
        yAxisId,
        width,
        synchronizedSettings
    ]);
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML: dangerouslySetInnerHTML, ticks: ticks } = props, allOtherProps = $ea6b60bd0638bcb3$var$_objectWithoutProperties(props, $ea6b60bd0638bcb3$var$_excluded);
    var { id: id } = synchronizedSettings, restSynchronizedSettings = $ea6b60bd0638bcb3$var$_objectWithoutProperties(synchronizedSettings, $ea6b60bd0638bcb3$var$_excluded2);
    return /*#__PURE__*/ $aivMx.createElement((0, $5c8c13823a5e3ea8$export$bdd99f2cdf352bae), $ea6b60bd0638bcb3$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        ref: cartesianAxisRef,
        labelRef: labelRef,
        scale: scale,
        x: position.x,
        y: position.y,
        tickTextProps: width === 'auto' ? {
            width: undefined
        } : {
            width: width
        },
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $d545b40f7ad07d5d$export$4f5d2d50c9deca37)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType
    }));
};
var $ea6b60bd0638bcb3$export$299ffbfed5267dce = {
    allowDataOverflow: (0, $40ff607ce3fff820$export$397148de2ecdec3c).allowDataOverflow,
    allowDecimals: (0, $40ff607ce3fff820$export$397148de2ecdec3c).allowDecimals,
    allowDuplicatedCategory: (0, $40ff607ce3fff820$export$397148de2ecdec3c).allowDuplicatedCategory,
    angle: (0, $40ff607ce3fff820$export$397148de2ecdec3c).angle,
    axisLine: (0, $5c8c13823a5e3ea8$export$179c35154a9748c0).axisLine,
    hide: false,
    includeHidden: (0, $40ff607ce3fff820$export$397148de2ecdec3c).includeHidden,
    interval: (0, $40ff607ce3fff820$export$397148de2ecdec3c).interval,
    minTickGap: (0, $40ff607ce3fff820$export$397148de2ecdec3c).minTickGap,
    mirror: (0, $40ff607ce3fff820$export$397148de2ecdec3c).mirror,
    orientation: (0, $40ff607ce3fff820$export$397148de2ecdec3c).orientation,
    padding: (0, $40ff607ce3fff820$export$397148de2ecdec3c).padding,
    reversed: (0, $40ff607ce3fff820$export$397148de2ecdec3c).reversed,
    scale: (0, $40ff607ce3fff820$export$397148de2ecdec3c).scale,
    tick: (0, $40ff607ce3fff820$export$397148de2ecdec3c).tick,
    tickCount: (0, $40ff607ce3fff820$export$397148de2ecdec3c).tickCount,
    tickLine: (0, $5c8c13823a5e3ea8$export$179c35154a9748c0).tickLine,
    tickSize: (0, $5c8c13823a5e3ea8$export$179c35154a9748c0).tickSize,
    type: (0, $40ff607ce3fff820$export$397148de2ecdec3c).type,
    width: (0, $40ff607ce3fff820$export$397148de2ecdec3c).width,
    yAxisId: 0
};
var $ea6b60bd0638bcb3$var$YAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $2f9fe6ad083d623b$export$45004cc70a390ee8)(outsideProps, $ea6b60bd0638bcb3$export$299ffbfed5267dce);
    return /*#__PURE__*/ $aivMx.createElement($aivMx.Fragment, null, /*#__PURE__*/ $aivMx.createElement($ea6b60bd0638bcb3$var$SetYAxisSettings, {
        interval: props.interval,
        id: props.yAxisId,
        scale: props.scale,
        type: props.type,
        domain: props.domain,
        allowDataOverflow: props.allowDataOverflow,
        dataKey: props.dataKey,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        allowDecimals: props.allowDecimals,
        tickCount: props.tickCount,
        padding: props.padding,
        includeHidden: props.includeHidden,
        reversed: props.reversed,
        ticks: props.ticks,
        width: props.width,
        orientation: props.orientation,
        mirror: props.mirror,
        hide: props.hide,
        unit: props.unit,
        name: props.name,
        angle: props.angle,
        minTickGap: props.minTickGap,
        tick: props.tick,
        tickFormatter: props.tickFormatter
    }), /*#__PURE__*/ $aivMx.createElement($ea6b60bd0638bcb3$var$YAxisImpl, props));
};
var $ea6b60bd0638bcb3$export$f96c4024c52de8f4 = /*#__PURE__*/ $aivMx.memo($ea6b60bd0638bcb3$var$YAxisSettingsDispatcher, (0, $56b8e0b6636ee8c8$export$a803260e379f3736));
$ea6b60bd0638bcb3$export$f96c4024c52de8f4.displayName = 'YAxis';



const $9d6fdbdfbe2f342e$var$getStrokeStyle = (stroke)=>{
    if (!stroke) return {};
    const style = {};
    if (stroke.color) style.stroke = stroke.color;
    if (stroke.width) style.strokeWidth = stroke.width;
    if (stroke.style === 'dashed' && stroke.dash && stroke.gap) style.strokeDasharray = `${stroke.dash} ${stroke.gap}`;
    return style;
};
const $9d6fdbdfbe2f342e$var$getBackgroundColor = (background)=>{
    if (!Array.isArray(background) || background.length === 0) return undefined;
    const colorBg = background.find((bg)=>bg.type === 'color');
    return colorBg?.value;
};
/**
 * The row key a series or an axis is bound to, as a key of the ROW OBJECT.
 *
 * The protocol writes a chart binding as `{{this.<key>}}` (TNBEWEB-1797, and what the
 * editor's chart panel emits) — `this.` naming the row the chart iterates. The rows
 * themselves arrive from `settings.data` keyed WITHOUT that prefix (`{month, sales, spend}`),
 * so handing recharts the raw inner text asks it for `row['this.sales']`, which is undefined
 * for every row: the grid, the axis lines and the legend still draw (none of them reads a
 * row), and the series and the x tick labels come out empty. That is the whole symptom — a
 * chart frame with nothing in it on a published page.
 *
 * Stripping here rather than at the extraction helper: `extractValueInsideCurlyBraces` is
 * shared with callers that want the path verbatim. A binding written without the prefix
 * (`{{sales}}`) is already a row key and passes through untouched.
 */ const $9d6fdbdfbe2f342e$var$rowKeyOf = (data)=>{
    const inner = (0, $7b0e169a5380005e$export$19c69f429b13dbe1)(data || '');
    return inner.startsWith('this.') ? inner.slice(5) : inner;
};
const $9d6fdbdfbe2f342e$var$ChartRenderer = ({ chartItems: chartItems, settingsData: settingsData, localVariables: localVariables, width: width = '100%', height: height = '100%' })=>{
    const realData = (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(settingsData);
    const chartData = Array.isArray(realData) ? realData : [];
    // Normalize width and height for ResponsiveContainer
    const containerWidth = typeof width === 'number' ? width : width;
    const containerHeight = typeof height === 'number' ? height : height;
    const chartConfig = (0, $aivMx.useMemo)(()=>{
        const config = {
            type: 'line',
            series: [],
            xAxis: null,
            yAxis: null,
            grid: null,
            tooltip: false,
            legend: false
        };
        chartItems.forEach((item)=>{
            switch(item.component){
                case 'chart-line':
                    config.type = 'line';
                    config.series.push({
                        type: 'line',
                        id: item.id,
                        dataKey: $9d6fdbdfbe2f342e$var$rowKeyOf(item.data),
                        name: item.label,
                        ...$9d6fdbdfbe2f342e$var$getStrokeStyle(item.style?.stroke),
                        strokeType: item.style?.type || 'monotone',
                        animationDuration: item.style?.animation?.duration || 0,
                        animationEasing: item.style?.animation?.easing,
                        dot: item.items?.find((subItem)=>subItem.component === 'chart-dot')
                    });
                    break;
                case 'chart-bar':
                    config.type = 'bar';
                    config.series.push({
                        type: 'bar',
                        id: item.id,
                        dataKey: $9d6fdbdfbe2f342e$var$rowKeyOf(item.data),
                        name: item.label,
                        fill: $9d6fdbdfbe2f342e$var$getBackgroundColor(item.style?.background) || '#8884d8',
                        animationDuration: item.style?.animation?.duration || 0
                    });
                    break;
                case 'chart-pie':
                    config.type = 'pie';
                    config.series.push({
                        type: 'pie',
                        id: item.id,
                        dataKey: $9d6fdbdfbe2f342e$var$rowKeyOf(item.data),
                        nameKey: item.style?.nameKey,
                        fill: $9d6fdbdfbe2f342e$var$getBackgroundColor(item.style?.background) || '#8884d8',
                        innerRadius: item.style?.innerRadius,
                        outerRadius: item.style?.outerRadius,
                        animationDuration: item.style?.animation?.duration || 0
                    });
                    break;
                case 'chart-funnel':
                    config.type = 'funnel';
                    config.series.push({
                        type: 'funnel',
                        id: item.id,
                        dataKey: $9d6fdbdfbe2f342e$var$rowKeyOf(item.data),
                        fill: $9d6fdbdfbe2f342e$var$getBackgroundColor(item.style?.background) || '#8884d8',
                        animationDuration: item.style?.animation?.duration || 0
                    });
                    break;
                case 'chart-axis':
                    if (item.axis === 'x') config.xAxis = {
                        dataKey: $9d6fdbdfbe2f342e$var$rowKeyOf(item.data),
                        ...$9d6fdbdfbe2f342e$var$getStrokeStyle(item.style?.stroke),
                        domain: item.style?.domain,
                        type: item.style?.type
                    };
                    else if (item.axis === 'y') config.yAxis = {
                        ...$9d6fdbdfbe2f342e$var$getStrokeStyle(item.style?.stroke),
                        domain: item.style?.domain,
                        type: item.style?.type
                    };
                    break;
                case 'chart-grid':
                    config.grid = {
                        ...$9d6fdbdfbe2f342e$var$getStrokeStyle(item.style?.stroke)
                    };
                    break;
                case 'chart-tooltip':
                    config.tooltip = true;
                    break;
                case 'chart-legend':
                    config.legend = true;
                    break;
                default:
                    break;
            }
        });
        return config;
    }, [
        chartItems
    ]);
    if (!chartData.length) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#999',
            fontSize: '14px'
        },
        children: "No data available"
    });
    const renderDot = (dotConfig)=>{
        if (!dotConfig) return undefined;
        const DotComponent = (props)=>{
            const { cx: cx, cy: cy } = props;
            const dotStyle = dotConfig.style || {};
            const dotWidth = parseFloat(dotStyle.width) || 8;
            const dotColor = $9d6fdbdfbe2f342e$var$getBackgroundColor(dotStyle.background) || '#8884d8';
            const borderRadius = dotStyle.border?.radius || '0%';
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("circle", {
                cx: cx,
                cy: cy,
                r: dotWidth / 2,
                fill: dotColor,
                style: {
                    borderRadius: borderRadius
                }
            });
        };
        DotComponent.displayName = 'DotComponent';
        return DotComponent;
    };
    const renderChart = ()=>{
        switch(chartConfig.type){
            case 'line':
                return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $9acfa7cb966ff3a4$export$e60a4704009a0009), {
                    width: containerWidth,
                    height: containerHeight,
                    children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)((0, $7d2d1ef636456ec6$export$54d0e8420ac838ac), {
                        data: chartData,
                        children: [
                            chartConfig.grid && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $4c34854e9934dcaa$export$6440e27b9f186856), {
                                ...chartConfig.grid
                            }),
                            chartConfig.xAxis && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $b6d97c3070c142d1$export$ea77231de273b52d), {
                                ...chartConfig.xAxis,
                                domain: chartConfig.xAxis.domain,
                                type: chartConfig.xAxis.type
                            }),
                            chartConfig.yAxis && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $ea6b60bd0638bcb3$export$f96c4024c52de8f4), {
                                ...chartConfig.yAxis,
                                domain: chartConfig.yAxis.domain,
                                type: chartConfig.yAxis.type
                            }),
                            chartConfig.tooltip && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $ebc06b7521ee0e46$export$28c660c63b792dea), {}),
                            chartConfig.legend && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $e116a714fccbb193$export$ed247974535929c7), {}),
                            chartConfig.series.map((series)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $c85dc270154f0923$export$17d680238e50603e), {
                                    type: series.strokeType,
                                    dataKey: series.dataKey,
                                    name: series.name,
                                    stroke: series.stroke,
                                    strokeWidth: series.strokeWidth,
                                    strokeDasharray: series.strokeDasharray,
                                    animationDuration: series.animationDuration,
                                    animationEasing: series.animationEasing,
                                    dot: renderDot(series.dot)
                                }, series.id))
                        ]
                    })
                });
            case 'bar':
                return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $9acfa7cb966ff3a4$export$e60a4704009a0009), {
                    width: containerWidth,
                    height: containerHeight,
                    children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)((0, $6aece67ee1275fdb$export$94aefc399ef206a9), {
                        data: chartData,
                        children: [
                            chartConfig.grid && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $4c34854e9934dcaa$export$6440e27b9f186856), {
                                ...chartConfig.grid
                            }),
                            chartConfig.xAxis && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $b6d97c3070c142d1$export$ea77231de273b52d), {
                                ...chartConfig.xAxis,
                                domain: chartConfig.xAxis.domain,
                                type: chartConfig.xAxis.type
                            }),
                            chartConfig.yAxis && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $ea6b60bd0638bcb3$export$f96c4024c52de8f4), {
                                ...chartConfig.yAxis,
                                domain: chartConfig.yAxis.domain,
                                type: chartConfig.yAxis.type
                            }),
                            chartConfig.tooltip && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $ebc06b7521ee0e46$export$28c660c63b792dea), {}),
                            chartConfig.legend && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $e116a714fccbb193$export$ed247974535929c7), {}),
                            chartConfig.series.map((series)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $6418e49322eed664$export$bbc6c6369b38e3d1), {
                                    dataKey: series.dataKey,
                                    name: series.name,
                                    fill: series.fill,
                                    animationDuration: series.animationDuration
                                }, series.id))
                        ]
                    })
                });
            case 'pie':
                return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $9acfa7cb966ff3a4$export$e60a4704009a0009), {
                    width: containerWidth,
                    height: containerHeight,
                    children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)((0, $a2a03cff1c144ec9$export$b99d3348f709c998), {
                        children: [
                            chartConfig.tooltip && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $ebc06b7521ee0e46$export$28c660c63b792dea), {}),
                            chartConfig.legend && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $e116a714fccbb193$export$ed247974535929c7), {}),
                            chartConfig.series.map((series)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $966dda21f47144a9$export$2ae8800cf67c848c), {
                                    data: chartData,
                                    dataKey: series.dataKey,
                                    nameKey: series.nameKey || 'name',
                                    cx: "50%",
                                    cy: "50%",
                                    innerRadius: series.innerRadius,
                                    outerRadius: series.outerRadius || 80,
                                    fill: series.fill,
                                    animationDuration: series.animationDuration,
                                    label: true,
                                    children: chartData?.map((entry, index)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $66258e37252e74df$export$f6f0c3fe4ec306ea), {
                                            fill: series.fill
                                        }, `cell-${index}`))
                                }, series.id))
                        ]
                    })
                });
            case 'funnel':
                return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $9acfa7cb966ff3a4$export$e60a4704009a0009), {
                    width: containerWidth,
                    height: containerHeight,
                    children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)((0, $5a963b20a3ae6224$export$254956f9f205304), {
                        children: [
                            chartConfig.tooltip && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $ebc06b7521ee0e46$export$28c660c63b792dea), {}),
                            chartConfig.legend && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $e116a714fccbb193$export$ed247974535929c7), {}),
                            chartConfig.series.map((series)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8bbf77ab6cef1b16$export$30b1585f3948a0cc), {
                                    data: chartData,
                                    dataKey: series.dataKey,
                                    fill: series.fill,
                                    animationDuration: series.animationDuration
                                }, series.id))
                        ]
                    })
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $02de83db299f7983$exports.Fragment), {
        children: renderChart()
    });
};
var $9d6fdbdfbe2f342e$export$2e2bcd8739ae039 = $9d6fdbdfbe2f342e$var$ChartRenderer;


const $530c81466a75d6ee$var$StyledChartContainer = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  z-index: 1;
  cursor: pointer;
  position: relative;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
const $530c81466a75d6ee$var$Chart = ({ id: id, style: stDraft, events: eventsDraft, pageSettings: pageSettings, dataLake: dataLake, active_state: activeStateDraft, parentIndex: parentIndex, styleChunks: styleChunks, skeleton: renderSkeleton2, parentLoading: parentLoading, parentStyle: parentStyle, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache, settings: settings, 'chart-items': items })=>{
    const { ref: ref } = settings || {};
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const containerRef = (0, $aivMx.useRef)(null);
    const { style: styleDraft, events: events, active_state: active_state, ref: realRef } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        ref: ref,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        ref: undefined,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'switcher') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading
    ]);
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    // First useMemo to merge active state styles with base style
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, containerRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Second useMemo to merge styles with chunks based on parentIndex
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const { on_change: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates } = events || {};
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleClick = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        e.preventDefault();
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = clickUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = clickUpdates.filter((update)=>update && 'function' in update);
            applyVariablesFirst(clickUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            applyVariablesFirst(hoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const styleUpdates = launchUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') ;
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && containerRef.current && !containerRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    if (renderSceleton && style) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
        style: style,
        baseScreenResolution: baseScreenResolution,
        skipStates: active_state === 'disabled' || active_state === 'loading'
    });
    // Calculate dimensions from style
    const chartWidth = style?.width || '100%';
    const chartHeight = style?.height || '100%';
    // Get chart data from settings
    const chartDataSource = settings?.data;
    const ChartEl = $530c81466a75d6ee$var$StyledChartContainer;
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(ChartEl, {
        ref: containerRef,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": "chart",
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)('disableFocus', style.class),
        onClick: handleClick,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        children: items && items.length > 0 && /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $9d6fdbdfbe2f342e$export$2e2bcd8739ae039), {
            chartItems: items,
            settingsData: chartDataSource,
            localVariables: dataLake?.data
        })
    });
};
var $530c81466a75d6ee$export$2e2bcd8739ae039 = $530c81466a75d6ee$var$Chart;


var $4659927e2b435a01$export$2e2bcd8739ae039 = (0, $530c81466a75d6ee$export$2e2bcd8739ae039);


// Utility functions for tree node detection and traversal
const $023c85c367f3a865$export$447718b10fc2fae = (targetId, items, visited = new Set())=>{
    if (!targetId || !items || !Array.isArray(items)) return false;
    for (const item of items){
        // Prevent infinite loops in case of circular references
        const itemId = item.id || item.settings?.ref;
        if (!itemId || visited.has(itemId)) continue;
        visited.add(itemId);
        // Check if this item matches the target
        if (itemId === targetId || item.settings?.ref && item.settings.ref === targetId) return true;
        // Recursively check nested children
        if (item.items && $023c85c367f3a865$export$447718b10fc2fae(targetId, item.items, visited)) return true;
    }
    return false;
};




var $aivMx = parcelRequire("aivMx");


var $751e048dd35ac525$exports = {};

$parcel$export($751e048dd35ac525$exports, "version", function () { return $751e048dd35ac525$export$83d89fbfd8236492; }, function (v) { return $751e048dd35ac525$export$83d89fbfd8236492 = v; });
$parcel$export($751e048dd35ac525$exports, "renderToString", function () { return $751e048dd35ac525$export$80e7718417253a51; }, function (v) { return $751e048dd35ac525$export$80e7718417253a51 = v; });
$parcel$export($751e048dd35ac525$exports, "renderToStaticMarkup", function () { return $751e048dd35ac525$export$eb3a06aef9e6ee51; }, function (v) { return $751e048dd35ac525$export$eb3a06aef9e6ee51 = v; });
$parcel$export($751e048dd35ac525$exports, "renderToNodeStream", function () { return $751e048dd35ac525$export$307591e98609eddd; }, function (v) { return $751e048dd35ac525$export$307591e98609eddd = v; });
$parcel$export($751e048dd35ac525$exports, "renderToStaticNodeStream", function () { return $751e048dd35ac525$export$b23711c915539651; }, function (v) { return $751e048dd35ac525$export$b23711c915539651 = v; });
$parcel$export($751e048dd35ac525$exports, "renderToReadableStream", function () { return $751e048dd35ac525$export$7020a3240b287705; }, function (v) { return $751e048dd35ac525$export$7020a3240b287705 = v; });
var $751e048dd35ac525$export$83d89fbfd8236492;
var $751e048dd35ac525$export$80e7718417253a51;
var $751e048dd35ac525$export$eb3a06aef9e6ee51;
var $751e048dd35ac525$export$307591e98609eddd;
var $751e048dd35ac525$export$b23711c915539651;
var $751e048dd35ac525$export$7020a3240b287705;
'use strict';
var $751e048dd35ac525$var$l, $751e048dd35ac525$var$s;

$751e048dd35ac525$var$l = (parcelRequire("anY5p"));

$751e048dd35ac525$var$s = (parcelRequire("3c06z"));
$751e048dd35ac525$export$83d89fbfd8236492 = $751e048dd35ac525$var$l.version;
$751e048dd35ac525$export$80e7718417253a51 = $751e048dd35ac525$var$l.renderToString;
$751e048dd35ac525$export$eb3a06aef9e6ee51 = $751e048dd35ac525$var$l.renderToStaticMarkup;
$751e048dd35ac525$export$307591e98609eddd = $751e048dd35ac525$var$l.renderToNodeStream;
$751e048dd35ac525$export$b23711c915539651 = $751e048dd35ac525$var$l.renderToStaticNodeStream;
$751e048dd35ac525$export$7020a3240b287705 = $751e048dd35ac525$var$s.renderToReadableStream;



var $94WEq = parcelRequire("94WEq");
var $d73df6074dc4c114$exports = {};
/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */ (function(global, factory) {
    $d73df6074dc4c114$exports = factory();
})($d73df6074dc4c114$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.2.5';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});



const $8e9edb93102a6e47$var$measureWidth = (text, textStyles)=>{
    const span = document.createElement('span');
    span.style.visibility = 'hidden';
    span.style.whiteSpace = 'nowrap';
    span.textContent = text;
    if (textStyles) Object.entries(textStyles).forEach(([property, value])=>{
        // Using type assertion to handle the dynamic property assignment
        span.style[property] = value;
    });
    document.body.appendChild(span);
    const width = span.offsetWidth;
    document.body.removeChild(span);
    return width;
};
class $8e9edb93102a6e47$export$699bb9da27ec3a7f {
    processText(text, parentWidth, textOverflowEllipsis, textStyles) {
        const tokens = text.split(/(\s+|\n)/);
        parentWidth = textOverflowEllipsis && parentWidth === 0 ? 1000 : parentWidth;
        const fullText = tokens.join('').trim();
        if (textOverflowEllipsis) {
            if ($8e9edb93102a6e47$var$measureWidth(fullText, textStyles) > parentWidth) {
                let start = 0;
                let end = fullText.length;
                while(start < end){
                    const mid = Math.floor((start + end + 1) / 2);
                    const testText = fullText.substring(0, mid) + '...';
                    if ($8e9edb93102a6e47$var$measureWidth(testText, textStyles) <= parentWidth) start = mid;
                    else end = mid - 1;
                }
                return `<span class="shimmer-text">${fullText.substring(0, start)}...</span>`;
            }
            return `<span class="shimmer-text">${fullText}</span>`;
        }
        let result = '';
        let currentLine = '';
        tokens.forEach((token, i)=>{
            if (textOverflowEllipsis && currentLine && $8e9edb93102a6e47$var$measureWidth(currentLine + token, textStyles) > parentWidth) {
                result += `<span class="shimmer-text">${currentLine.trim()}</span>${i < tokens.length - 1 ? '<br/>' : ''}`;
                currentLine = token;
            } else if (token === "\n\xa0" || token === "\n\xa0\n" || token === "\n\xa0\n " || token === " \n\xa0\n" || token === " \n\xa0\n ") {
                result += `<span class="shimmer-text">${currentLine.trim()}</span><br/><br/>`;
                currentLine = '';
                return result;
            } else currentLine = currentLine ? currentLine + token : token;
        });
        if (currentLine) result += `<span class="shimmer-text">${currentLine.trim()}</span>`;
        return result;
    }
}
class $8e9edb93102a6e47$export$1402bc849cfa4a81 {
    processText(htmlString, parentWidth, textOverflowEllipsis, textStyles) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        function wrapTextNodes(node) {
            if (node.nodeType === Node.TEXT_NODE && node.nodeValue && node.nodeValue.trim() !== '') {
                const textContent = node.nodeValue.split(/(\s+|\n)/).flatMap((token)=>{
                    // Skip if token is whitespace or already short
                    if (/^\s*$/.test(token) || token.length < 10) return token;
                    return token.split(/(-(?=\d{2}\.\d{2}\.\d{4})|(?<=\d{2}\.\d{2}\.\d{4})-|(?<=\w{3,})-(?=\w{3,}))/).filter((part)=>part !== '');
                });
                const span = document.createElement('span');
                span.style.visibility = 'hidden';
                span.style.whiteSpace = 'nowrap';
                if (textStyles) Object.entries(textStyles).forEach(([property, value])=>{
                    // Using type assertion to handle the dynamic property assignment
                    span.style[property] = value;
                });
                document.body.appendChild(span);
                let currentText = '';
                let wrappedText = '';
                const spans = [];
                textContent.forEach((token, index)=>{
                    if (token === '\n') {
                        if (currentText.trim()) spans.push(`<span class="shimmer-text">${currentText.trim()}</span>`);
                        spans.push('<br/>');
                        currentText = '';
                    } else if (token === '\n ' || token === '\n \n' || token === '\n \n ' || token === ' \n \n' || token === ' \n \n ') {
                        if (currentText.trim()) spans.push(`<span class="shimmer-text">${currentText.trim()}</span>`);
                        spans.push('<br/><br/>');
                        currentText = '';
                    } else {
                        const testText = currentText ? `${currentText}${token}` : token;
                        span.textContent = testText;
                        if (span.offsetWidth > parentWidth - 1 && currentText.trim()) {
                            spans.push(`<span class="shimmer-text">${currentText.trim()}</span>`);
                            spans.push('<br/>');
                            currentText = token.trim();
                        } else currentText = testText;
                    }
                    // Handle the last token
                    if (index === textContent.length - 1 && currentText.trim()) spans.push(`<span class="shimmer-text">${currentText.trim()}</span>`);
                });
                wrappedText = spans.join('');
                document.body.removeChild(span);
                // Only replace the node if we have actual content to wrap
                if (wrappedText && spans.some((span)=>span.includes('shimmer-text'))) {
                    const wrapperSpan = document.createElement('span');
                    wrapperSpan.innerHTML = wrappedText;
                    node.replaceWith(wrapperSpan);
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) // Convert NodeList to array to prevent issues with live updates
            Array.from(node.childNodes).forEach(wrapTextNodes);
        }
        // Convert NodeList to array to prevent issues with live updates
        Array.from(doc.body.childNodes).forEach((node)=>wrapTextNodes(node));
        return doc.body.innerHTML;
    }
}


function $fd8923e6d4b4f897$var$checkNode(node) {
    // Skip empty text nodes
    if (node.nodeType === Node.TEXT_NODE && !node.nodeValue?.trim()) return true;
    // If node has more than 1 meaningful child, it's not a single branch
    const meaningfulChildren = Array.from(node.childNodes).filter((child)=>!(child.nodeType === Node.TEXT_NODE && !child.nodeValue?.trim()));
    if (meaningfulChildren.length > 1) return false;
    // If no children, we're at a leaf node
    if (meaningfulChildren.length === 0) return true;
    // Recurse on single child
    return $fd8923e6d4b4f897$var$checkNode(meaningfulChildren[0]);
}
const $fd8923e6d4b4f897$var$isSimpleTextRenderer = (isSimpleStructure, parentOverflow, textOverflowEllipsis, nestedTable, textStyle)=>{
    if (nestedTable && parentOverflow === 'hidden') return false;
    if (isSimpleStructure && parentOverflow !== 'visible' || textOverflowEllipsis || nestedTable) return true;
    return false;
};
const $fd8923e6d4b4f897$export$163ca17ab7c8b5d9 = (htmlString, textStyle, parentWidth, parentOverflow, textOverflowEllipsis, nestedTable)=>{
    const parser = new DOMParser();
    const cleaned = cleanInlineTags(htmlString);
    const doc = parser.parseFromString(cleaned, 'text/html');
    const isSimpleStructure = $fd8923e6d4b4f897$var$checkNode(doc.body);
    const processor = $fd8923e6d4b4f897$var$isSimpleTextRenderer(isSimpleStructure, parentOverflow, textOverflowEllipsis, nestedTable, textStyle) ? new (0, $8e9edb93102a6e47$export$699bb9da27ec3a7f)() : new (0, $8e9edb93102a6e47$export$1402bc849cfa4a81)();
    function wrapTextNodes(node, currentParentWidth) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue?.trim()) {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = processor.processText(node.nodeValue, currentParentWidth, textOverflowEllipsis, textStyle);
            node.parentNode?.replaceChild(wrapper.firstChild, node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            // Adjust parentWidth if node is an li element
            let newParentWidth = currentParentWidth;
            if (node.nodeName === 'LI') newParentWidth -= 40;
            Array.from(node.childNodes).forEach((childNode)=>wrapTextNodes(childNode, newParentWidth));
        }
    }
    function cleanInlineTags(htmlString) {
        const inlineTags = [
            'custom-timer',
            'a',
            'abbr',
            'acronym',
            'b',
            'bdo',
            'big',
            'cite',
            'dfn',
            'em',
            'i',
            'kbd',
            'label',
            'q',
            'samp',
            'small',
            'span',
            'strong',
            'sub',
            'sup',
            'tt',
            'var'
        ];
        const inlineTagsPattern = new RegExp(`</?(${inlineTags.join('|')})[^>]*>`, 'gi');
        return htmlString.replace(inlineTagsPattern, '');
    }
    doc.body.childNodes.forEach((node)=>wrapTextNodes(node, parentWidth));
    return doc.body.innerHTML;
};












var $aivMx = parcelRequire("aivMx");

var $aivMx = parcelRequire("aivMx");
function $8e498fab81f77515$var$r() {
    return $8e498fab81f77515$var$r = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, $8e498fab81f77515$var$r.apply(this, arguments);
}
var $8e498fab81f77515$var$n, $8e498fab81f77515$var$t = [
    "children",
    "options"
], $8e498fab81f77515$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($8e498fab81f77515$var$n || ($8e498fab81f77515$var$n = {}));
var $8e498fab81f77515$var$a = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(e, r) {
    return e[r.toLowerCase()] = r, e;
}, {
    class: "className",
    for: "htmlFor"
}), $8e498fab81f77515$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $8e498fab81f77515$var$l = [
    "style",
    "script"
], $8e498fab81f77515$var$c = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $8e498fab81f77515$var$u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $8e498fab81f77515$var$s = /mailto:/i, $8e498fab81f77515$var$f = /\n{2,}$/, $8e498fab81f77515$var$d = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $8e498fab81f77515$var$p = /^ *> ?/gm, $8e498fab81f77515$var$h = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $8e498fab81f77515$var$m = /^ {2,}\n/, $8e498fab81f77515$var$g = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $8e498fab81f77515$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $8e498fab81f77515$var$v = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $8e498fab81f77515$var$k = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $8e498fab81f77515$var$x = /^(?:\n *)*\n/, $8e498fab81f77515$var$b = /\r\n?/g, $8e498fab81f77515$var$C = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $8e498fab81f77515$var$S = /^\[\^([^\]]+)]/, $8e498fab81f77515$var$w = /\f/g, $8e498fab81f77515$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $8e498fab81f77515$var$z = /^\s*?\[(x|\s)\]/, $8e498fab81f77515$var$L = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $8e498fab81f77515$var$A = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $8e498fab81f77515$var$O = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $8e498fab81f77515$var$T = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $8e498fab81f77515$var$B = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $8e498fab81f77515$var$$ = /^<!--[\s\S]*?(?:-->)/, $8e498fab81f77515$var$M = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $8e498fab81f77515$var$R = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $8e498fab81f77515$var$I = /^\{.*\}$/, $8e498fab81f77515$var$D = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $8e498fab81f77515$var$U = /^<([^ >]+@[^ >]+)>/, $8e498fab81f77515$var$N = /^<([^ >]+:\/[^ >]+)>/, $8e498fab81f77515$var$j = /-([a-z])?/gi, $8e498fab81f77515$var$H = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $8e498fab81f77515$var$P = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $8e498fab81f77515$var$_ = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $8e498fab81f77515$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $8e498fab81f77515$var$W = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $8e498fab81f77515$var$G = /\t/g, $8e498fab81f77515$var$Z = /(^ *\||\| *$)/g, $8e498fab81f77515$var$q = /^ *:-+: *$/, $8e498fab81f77515$var$Q = /^ *:-+ *$/, $8e498fab81f77515$var$V = /^ *-+: *$/, $8e498fab81f77515$var$X = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $8e498fab81f77515$var$J = new RegExp("^([*_])\\1" + $8e498fab81f77515$var$X + "\\1\\1(?!\\1)"), $8e498fab81f77515$var$K = new RegExp("^([*_])" + $8e498fab81f77515$var$X + "\\1(?!\\1)"), $8e498fab81f77515$var$Y = new RegExp("^(==)" + $8e498fab81f77515$var$X + "\\1"), $8e498fab81f77515$var$ee = new RegExp("^(~~)" + $8e498fab81f77515$var$X + "\\1"), $8e498fab81f77515$var$re = /^\\([^0-9A-Za-z\s])/, $8e498fab81f77515$var$ne = /\\([^0-9A-Za-z\s])/g, $8e498fab81f77515$var$te = /^([\s\S](?:(?!  |[0-9]\.)[^=*_~\-\n<`\\\[!])*)/, $8e498fab81f77515$var$ie = /^\n+/, $8e498fab81f77515$var$ae = /^([ \t]*)/, $8e498fab81f77515$var$oe = /\\([^\\])/g, $8e498fab81f77515$var$le = /(?:^|\n)( *)$/, $8e498fab81f77515$var$ce = "(?:\\d+\\.)", $8e498fab81f77515$var$ue = "(?:[*+-])";
function $8e498fab81f77515$var$se(e) {
    return "( *)(" + (1 === e ? $8e498fab81f77515$var$ce : $8e498fab81f77515$var$ue) + ") +";
}
var $8e498fab81f77515$var$fe = $8e498fab81f77515$var$se(1), $8e498fab81f77515$var$de = $8e498fab81f77515$var$se(2);
function $8e498fab81f77515$var$pe(e) {
    return new RegExp("^" + (1 === e ? $8e498fab81f77515$var$fe : $8e498fab81f77515$var$de));
}
var $8e498fab81f77515$var$he = $8e498fab81f77515$var$pe(1), $8e498fab81f77515$var$me = $8e498fab81f77515$var$pe(2);
function $8e498fab81f77515$var$ge(e) {
    return new RegExp("^" + (1 === e ? $8e498fab81f77515$var$fe : $8e498fab81f77515$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $8e498fab81f77515$var$ce : $8e498fab81f77515$var$ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $8e498fab81f77515$var$ye = $8e498fab81f77515$var$ge(1), $8e498fab81f77515$var$ve = $8e498fab81f77515$var$ge(2);
function $8e498fab81f77515$var$ke(e) {
    var r = 1 === e ? $8e498fab81f77515$var$ce : $8e498fab81f77515$var$ue;
    return new RegExp("^( *)(" + r + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + r + " (?!" + r + " ))\\n*|\\s*\\n*$)");
}
var $8e498fab81f77515$var$xe = $8e498fab81f77515$var$ke(1), $8e498fab81f77515$var$be = $8e498fab81f77515$var$ke(2);
function $8e498fab81f77515$var$Ce(e, r) {
    var n = 1 === r, t = n ? $8e498fab81f77515$var$xe : $8e498fab81f77515$var$be, a = n ? $8e498fab81f77515$var$ye : $8e498fab81f77515$var$ve, o = n ? $8e498fab81f77515$var$he : $8e498fab81f77515$var$me;
    return {
        match: $8e498fab81f77515$var$Me(function(e, r) {
            var n = $8e498fab81f77515$var$le.exec(r.prevCapture);
            return n && (r.list || !r.inline && !r.simple) ? t.exec(e = n[1] + e) : null;
        }),
        order: 1,
        parse: function(e, r, t) {
            var i = n ? +e[2] : void 0, l = e[0].replace($8e498fab81f77515$var$f, "\n").match(a), c = !1;
            return {
                items: l.map(function(e, n) {
                    var i = o.exec(e)[0].length, a = new RegExp("^ {1," + i + "}", "gm"), u = e.replace(a, "").replace(o, ""), s = n === l.length - 1, f = -1 !== u.indexOf("\n\n") || s && c;
                    c = f;
                    var d, p = t.inline, h = t.list;
                    t.list = !0, f ? (t.inline = !1, d = $8e498fab81f77515$var$Le(u) + "\n\n") : (t.inline = !0, d = $8e498fab81f77515$var$Le(u));
                    var m = r(d, t);
                    return t.inline = p, t.list = h, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: function(r, n, t) {
            return e(r.ordered ? "ol" : "ul", {
                key: t.key,
                start: r.type === $8e498fab81f77515$export$e0aa44767d8750d5.orderedList ? r.start : void 0
            }, r.items.map(function(r, i) {
                return e("li", {
                    key: i
                }, n(r, t));
            }));
        }
    };
}
var $8e498fab81f77515$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $8e498fab81f77515$var$we = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $8e498fab81f77515$var$Ee = [
    $8e498fab81f77515$var$d,
    $8e498fab81f77515$var$y,
    $8e498fab81f77515$var$v,
    $8e498fab81f77515$var$L,
    $8e498fab81f77515$var$O,
    $8e498fab81f77515$var$A,
    $8e498fab81f77515$var$H,
    $8e498fab81f77515$var$xe,
    $8e498fab81f77515$var$be
], $8e498fab81f77515$var$ze = [].concat($8e498fab81f77515$var$Ee, [
    /^[^\n]+(?:  \n|\n{2,})/,
    $8e498fab81f77515$var$T,
    $8e498fab81f77515$var$$,
    $8e498fab81f77515$var$R
]);
function $8e498fab81f77515$var$Le(e) {
    for(var r = e.length; r > 0 && e[r - 1] <= " ";)r--;
    return e.slice(0, r);
}
function $8e498fab81f77515$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $8e498fab81f77515$var$Oe(e) {
    return $8e498fab81f77515$var$V.test(e) ? "right" : $8e498fab81f77515$var$q.test(e) ? "center" : $8e498fab81f77515$var$Q.test(e) ? "left" : null;
}
function $8e498fab81f77515$var$Te(e, r, n, t) {
    var i = n.inTable;
    n.inTable = !0;
    var a = [
        []
    ], o = "";
    function l() {
        if (o) {
            var e = a[a.length - 1];
            e.push.apply(e, r(o, n)), o = "";
        }
    }
    return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach(function(e, r, n) {
        "|" === e.trim() && (l(), t) ? 0 !== r && r !== n.length - 1 && a.push([]) : o += e;
    }), l(), n.inTable = i, a;
}
function $8e498fab81f77515$var$Be(e, r, n) {
    n.inline = !0;
    var t = e[2] ? e[2].replace($8e498fab81f77515$var$Z, "").split("|").map($8e498fab81f77515$var$Oe) : [], a = e[3] ? function(e, r, n) {
        return e.trim().split("\n").map(function(e) {
            return $8e498fab81f77515$var$Te(e, r, n, !0);
        });
    }(e[3], r, n) : [], o = $8e498fab81f77515$var$Te(e[1], r, n, !!a.length);
    return n.inline = !1, a.length ? {
        align: t,
        cells: a,
        header: o,
        type: $8e498fab81f77515$export$e0aa44767d8750d5.table
    } : {
        children: o,
        type: $8e498fab81f77515$export$e0aa44767d8750d5.paragraph
    };
}
function $8e498fab81f77515$var$$e(e, r) {
    return null == e.align[r] ? {} : {
        textAlign: e.align[r]
    };
}
function $8e498fab81f77515$var$Me(e) {
    return e.inline = 1, e;
}
function $8e498fab81f77515$var$Re(e) {
    return $8e498fab81f77515$var$Me(function(r, n) {
        return n.inline ? e.exec(r) : null;
    });
}
function $8e498fab81f77515$var$Ie(e) {
    return $8e498fab81f77515$var$Me(function(r, n) {
        return n.inline || n.simple ? e.exec(r) : null;
    });
}
function $8e498fab81f77515$var$De(e) {
    return function(r, n) {
        return n.inline || n.simple ? null : e.exec(r);
    };
}
function $8e498fab81f77515$var$Ue(e) {
    return $8e498fab81f77515$var$Me(function(r) {
        return e.exec(r);
    });
}
function $8e498fab81f77515$var$Ne(e, r) {
    if (r.inline || r.simple) return null;
    var n = "";
    e.split("\n").every(function(e) {
        return e += "\n", !$8e498fab81f77515$var$Ee.some(function(r) {
            return r.test(e);
        }) && (n += e, !!e.trim());
    });
    var t = $8e498fab81f77515$var$Le(n);
    return "" == t ? null : [
        n,
        ,
        t
    ];
}
var $8e498fab81f77515$var$je = /(javascript|vbscript|data(?!:image)):/i;
function $8e498fab81f77515$export$3e2338ea76b578c9(e) {
    try {
        var r = decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "");
        if ($8e498fab81f77515$var$je.test(r)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $8e498fab81f77515$var$Pe(e) {
    return e.replace($8e498fab81f77515$var$oe, "$1");
}
function $8e498fab81f77515$var$_e(e, r, n) {
    var t = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    var a = e(r, n);
    return n.inline = t, n.simple = i, a;
}
function $8e498fab81f77515$var$Fe(e, r, n) {
    var t = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    var a = e(r, n);
    return n.inline = t, n.simple = i, a;
}
function $8e498fab81f77515$var$We(e, r, n) {
    var t = n.inline || !1;
    n.inline = !1;
    var i = e(r, n);
    return n.inline = t, i;
}
var $8e498fab81f77515$var$Ge = function(e, r, n) {
    return {
        children: $8e498fab81f77515$var$_e(r, e[2], n)
    };
};
function $8e498fab81f77515$var$Ze() {
    return {};
}
function $8e498fab81f77515$var$qe() {
    return null;
}
function $8e498fab81f77515$var$Qe() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $8e498fab81f77515$var$Ve(e, r, n) {
    for(var t = e, i = r.split("."); i.length && void 0 !== (t = t[i[0]]);)i.shift();
    return t || n;
}
function $8e498fab81f77515$var$Xe(e, r) {
    var n = $8e498fab81f77515$var$Ve(r, e);
    return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $8e498fab81f77515$var$Ve(r, e + ".component", e) : e;
}
function $8e498fab81f77515$export$69f434acfbdb0b32(n, t) {
    var f;
    function Z(e, n) {
        var i, a = $8e498fab81f77515$var$Ve(t.overrides, e + ".props", {});
        return (i = t).createElement.apply(i, [
            $8e498fab81f77515$var$Xe(e, t.overrides),
            $8e498fab81f77515$var$r({}, n, a, {
                className: $8e498fab81f77515$var$Qe(null == n ? void 0 : n.className, a.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function q(e) {
        e = e.replace($8e498fab81f77515$var$E, "");
        var r = !1;
        t.forceInline ? r = !0 : t.forceBlock || (r = !1 === $8e498fab81f77515$var$W.test(e));
        for(var n = ue(ce(r ? e : $8e498fab81f77515$var$Le(e).replace($8e498fab81f77515$var$ie, "") + "\n\n", {
            inline: r
        })); "string" == typeof n[n.length - 1] && !n[n.length - 1].trim();)n.pop();
        if (null === t.wrapper) return n;
        var i, a = t.wrapper || (r ? "span" : "div");
        if (n.length > 1 || t.forceWrapper) i = n;
        else {
            if (1 === n.length) return "string" == typeof (i = n[0]) ? Z("span", {
                key: "outer"
            }, i) : i;
            i = null;
        }
        return t.createElement(a, {
            key: "outer"
        }, i);
    }
    function Q(e, r) {
        var n = r.match($8e498fab81f77515$var$u);
        return n ? n.reduce(function(r, n) {
            var i = n.indexOf("=");
            if (-1 !== i) {
                var o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($8e498fab81f77515$var$M) && (e = e.replace($8e498fab81f77515$var$j, function(e, r) {
                        return r.toUpperCase();
                    })), e;
                })(n.slice(0, i)).trim(), l = function(e) {
                    var r = e[0];
                    return ('"' === r || "'" === r) && e.length >= 2 && e[e.length - 1] === r ? e.slice(1, -1) : e;
                }(n.slice(i + 1).trim()), u = $8e498fab81f77515$var$a[o] || o;
                if ("ref" === u) return r;
                var s = r[u] = function(e, r, n, t) {
                    return "style" === r ? (function(e) {
                        var r = [], n = "", t = !1, i = !1, a = "";
                        if (!e) return r;
                        for(var o = 0; o < e.length; o++){
                            var l = e[o];
                            if ('"' !== l && "'" !== l || t || (i ? l === a && (i = !1, a = "") : (i = !0, a = l)), "(" === l && n.endsWith("url") ? t = !0 : ")" === l && t && (t = !1), ";" !== l || i || t) n += l;
                            else {
                                var c = n.trim();
                                if (c) {
                                    var u = c.indexOf(":");
                                    if (u > 0) {
                                        var s = c.slice(0, u).trim(), f = c.slice(u + 1).trim();
                                        r.push([
                                            s,
                                            f
                                        ]);
                                    }
                                }
                                n = "";
                            }
                        }
                        var d = n.trim();
                        if (d) {
                            var p = d.indexOf(":");
                            if (p > 0) {
                                var h = d.slice(0, p).trim(), m = d.slice(p + 1).trim();
                                r.push([
                                    h,
                                    m
                                ]);
                            }
                        }
                        return r;
                    })(n).reduce(function(r, n) {
                        var i = n[0], a = n[1];
                        return r[i.replace(/(-[a-z])/g, function(e) {
                            return e[1].toUpperCase();
                        })] = t(a, e, i), r;
                    }, {}) : -1 !== $8e498fab81f77515$var$c.indexOf(r) ? t(n, e, r) : (n.match($8e498fab81f77515$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(e, o, l, t.sanitizer);
                "string" == typeof s && ($8e498fab81f77515$var$T.test(s) || $8e498fab81f77515$var$R.test(s)) && (r[u] = q(s.trim()));
            } else "style" !== n && (r[$8e498fab81f77515$var$a[n] || n] = !0);
            return r;
        }, {}) : null;
    }
    void 0 === n && (n = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.sanitizer = t.sanitizer || $8e498fab81f77515$export$3e2338ea76b578c9, t.slugify = t.slugify || $8e498fab81f77515$export$c383cdd2a518017a, t.namedCodesToUnicode = t.namedCodesToUnicode ? $8e498fab81f77515$var$r({}, $8e498fab81f77515$var$o, t.namedCodesToUnicode) : $8e498fab81f77515$var$o, t.createElement = t.createElement || $aivMx.createElement;
    var V = [], X = {}, oe = ((f = {})[$8e498fab81f77515$export$e0aa44767d8750d5.blockQuote] = {
        match: $8e498fab81f77515$var$De($8e498fab81f77515$var$d),
        order: 1,
        parse: function(e, r, n) {
            var t = e[0].replace($8e498fab81f77515$var$p, "").match($8e498fab81f77515$var$h);
            return {
                alert: t[1],
                children: r(t[2], n)
            };
        },
        render: function(e, r, n) {
            var a = {
                key: n.key
            };
            return e.alert && (a.className = "markdown-alert-" + t.slugify(e.alert.toLowerCase(), $8e498fab81f77515$export$c383cdd2a518017a), e.children.unshift({
                attrs: {},
                children: [
                    {
                        type: $8e498fab81f77515$export$e0aa44767d8750d5.text,
                        text: e.alert
                    }
                ],
                noInnerParse: !0,
                type: $8e498fab81f77515$export$e0aa44767d8750d5.htmlBlock,
                tag: "header"
            })), Z("blockquote", a, r(e.children, n));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.breakLine] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$m),
        order: 1,
        parse: $8e498fab81f77515$var$Ze,
        render: function(e, r, n) {
            return Z("br", {
                key: n.key
            });
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.breakThematic] = {
        match: $8e498fab81f77515$var$De($8e498fab81f77515$var$g),
        order: 1,
        parse: $8e498fab81f77515$var$Ze,
        render: function(e, r, n) {
            return Z("hr", {
                key: n.key
            });
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.codeBlock] = {
        match: $8e498fab81f77515$var$De($8e498fab81f77515$var$v),
        order: 0,
        parse: function(e) {
            return {
                lang: void 0,
                text: $8e498fab81f77515$var$Le(e[0].replace(/^ {4}/gm, "")).replace($8e498fab81f77515$var$ne, "$1")
            };
        },
        render: function(e, n, t) {
            return Z("pre", {
                key: t.key
            }, Z("code", $8e498fab81f77515$var$r({}, e.attrs, {
                className: e.lang ? "lang-" + e.lang : ""
            }), e.text));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.codeFenced] = {
        match: $8e498fab81f77515$var$De($8e498fab81f77515$var$y),
        order: 0,
        parse: function(e) {
            return {
                attrs: Q("code", e[3] || ""),
                lang: e[2] || void 0,
                text: e[4],
                type: $8e498fab81f77515$export$e0aa44767d8750d5.codeBlock
            };
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.codeInline] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$k),
        order: 3,
        parse: function(e) {
            return {
                text: e[2].replace($8e498fab81f77515$var$ne, "$1")
            };
        },
        render: function(e, r, n) {
            return Z("code", {
                key: n.key
            }, e.text);
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.footnote] = {
        match: $8e498fab81f77515$var$De($8e498fab81f77515$var$C),
        order: 0,
        parse: function(e) {
            return V.push({
                footnote: e[2],
                identifier: e[1]
            }), {};
        },
        render: $8e498fab81f77515$var$qe
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.footnoteReference] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$S),
        order: 1,
        parse: function(e) {
            return {
                target: "#" + t.slugify(e[1], $8e498fab81f77515$export$c383cdd2a518017a),
                text: e[1]
            };
        },
        render: function(e, r, n) {
            return Z("a", {
                key: n.key,
                href: t.sanitizer(e.target, "a", "href")
            }, Z("sup", {
                key: n.key
            }, e.text));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.gfmTask] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$z),
        order: 1,
        parse: function(e) {
            return {
                completed: "x" === e[1].toLowerCase()
            };
        },
        render: function(e, r, n) {
            return Z("input", {
                checked: e.completed,
                key: n.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.heading] = {
        match: $8e498fab81f77515$var$De(t.enforceAtxHeadings ? $8e498fab81f77515$var$A : $8e498fab81f77515$var$L),
        order: 1,
        parse: function(e, r, n) {
            return {
                children: $8e498fab81f77515$var$_e(r, e[2], n),
                id: t.slugify(e[2], $8e498fab81f77515$export$c383cdd2a518017a),
                level: e[1].length
            };
        },
        render: function(e, r, n) {
            return Z("h" + e.level, {
                id: e.id,
                key: n.key
            }, r(e.children, n));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.headingSetext] = {
        match: $8e498fab81f77515$var$De($8e498fab81f77515$var$O),
        order: 0,
        parse: function(e, r, n) {
            return {
                children: $8e498fab81f77515$var$_e(r, e[1], n),
                level: "=" === e[2] ? 1 : 2,
                type: $8e498fab81f77515$export$e0aa44767d8750d5.heading
            };
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.htmlBlock] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$T),
        order: 1,
        parse: function(e, r, n) {
            var t, i = e[3].match($8e498fab81f77515$var$ae), a = new RegExp("^" + i[1], "gm"), o = e[3].replace(a, ""), c = (t = o, $8e498fab81f77515$var$ze.some(function(e) {
                return e.test(t);
            }) ? $8e498fab81f77515$var$We : $8e498fab81f77515$var$_e), u = e[1].toLowerCase(), s = -1 !== $8e498fab81f77515$var$l.indexOf(u), f = (s ? u : e[1]).trim(), d = {
                attrs: Q(f, e[2]),
                noInnerParse: s,
                tag: f
            };
            return n.inAnchor = n.inAnchor || "a" === u, s ? d.text = e[3] : d.children = c(r, o, n), n.inAnchor = !1, d;
        },
        render: function(e, n, t) {
            return Z(e.tag, $8e498fab81f77515$var$r({
                key: t.key
            }, e.attrs), e.text || (e.children ? n(e.children, t) : ""));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.htmlSelfClosing] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$R),
        order: 1,
        parse: function(e) {
            var r = e[1].trim();
            return {
                attrs: Q(r, e[2] || ""),
                tag: r
            };
        },
        render: function(e, n, t) {
            return Z(e.tag, $8e498fab81f77515$var$r({}, e.attrs, {
                key: t.key
            }));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.htmlComment] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$$),
        order: 1,
        parse: function() {
            return {};
        },
        render: $8e498fab81f77515$var$qe
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.image] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$we),
        order: 1,
        parse: function(e) {
            return {
                alt: e[1],
                target: $8e498fab81f77515$var$Pe(e[2]),
                title: e[3]
            };
        },
        render: function(e, r, n) {
            return Z("img", {
                key: n.key,
                alt: e.alt || void 0,
                title: e.title || void 0,
                src: t.sanitizer(e.target, "img", "src")
            });
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.link] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$Se),
        order: 3,
        parse: function(e, r, n) {
            return {
                children: $8e498fab81f77515$var$Fe(r, e[1], n),
                target: $8e498fab81f77515$var$Pe(e[2]),
                title: e[3]
            };
        },
        render: function(e, r, n) {
            return Z("a", {
                key: n.key,
                href: t.sanitizer(e.target, "a", "href"),
                title: e.title
            }, r(e.children, n));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.linkAngleBraceStyleDetector] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$N),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: $8e498fab81f77515$export$e0aa44767d8750d5.text
                    }
                ],
                target: e[1],
                type: $8e498fab81f77515$export$e0aa44767d8750d5.link
            };
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.linkBareUrlDetector] = {
        match: $8e498fab81f77515$var$Me(function(e, r) {
            return r.inAnchor || t.disableAutoLink ? null : $8e498fab81f77515$var$Re($8e498fab81f77515$var$D)(e, r);
        }),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: $8e498fab81f77515$export$e0aa44767d8750d5.text
                    }
                ],
                target: e[1],
                title: void 0,
                type: $8e498fab81f77515$export$e0aa44767d8750d5.link
            };
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.linkMailtoDetector] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$U),
        order: 0,
        parse: function(e) {
            var r = e[1], n = e[1];
            return $8e498fab81f77515$var$s.test(n) || (n = "mailto:" + n), {
                children: [
                    {
                        text: r.replace("mailto:", ""),
                        type: $8e498fab81f77515$export$e0aa44767d8750d5.text
                    }
                ],
                target: n,
                type: $8e498fab81f77515$export$e0aa44767d8750d5.link
            };
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.orderedList] = $8e498fab81f77515$var$Ce(Z, 1), f[$8e498fab81f77515$export$e0aa44767d8750d5.unorderedList] = $8e498fab81f77515$var$Ce(Z, 2), f[$8e498fab81f77515$export$e0aa44767d8750d5.newlineCoalescer] = {
        match: $8e498fab81f77515$var$De($8e498fab81f77515$var$x),
        order: 3,
        parse: $8e498fab81f77515$var$Ze,
        render: function() {
            return "\n";
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.paragraph] = {
        match: $8e498fab81f77515$var$Me($8e498fab81f77515$var$Ne),
        order: 3,
        parse: $8e498fab81f77515$var$Ge,
        render: function(e, r, n) {
            return Z("p", {
                key: n.key
            }, r(e.children, n));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.ref] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$P),
        order: 0,
        parse: function(e) {
            return X[e[1]] = {
                target: e[2],
                title: e[4]
            }, {};
        },
        render: $8e498fab81f77515$var$qe
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.refImage] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$_),
        order: 0,
        parse: function(e) {
            return {
                alt: e[1] || void 0,
                ref: e[2]
            };
        },
        render: function(e, r, n) {
            return X[e.ref] ? Z("img", {
                key: n.key,
                alt: e.alt,
                src: t.sanitizer(X[e.ref].target, "img", "src"),
                title: X[e.ref].title
            }) : null;
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.refLink] = {
        match: $8e498fab81f77515$var$Re($8e498fab81f77515$var$F),
        order: 0,
        parse: function(e, r, n) {
            return {
                children: r(e[1], n),
                fallbackChildren: e[0],
                ref: e[2]
            };
        },
        render: function(e, r, n) {
            return X[e.ref] ? Z("a", {
                key: n.key,
                href: t.sanitizer(X[e.ref].target, "a", "href"),
                title: X[e.ref].title
            }, r(e.children, n)) : Z("span", {
                key: n.key
            }, e.fallbackChildren);
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.table] = {
        match: $8e498fab81f77515$var$De($8e498fab81f77515$var$H),
        order: 1,
        parse: $8e498fab81f77515$var$Be,
        render: function(e, r, n) {
            var t = e;
            return Z("table", {
                key: n.key
            }, Z("thead", null, Z("tr", null, t.header.map(function(e, i) {
                return Z("th", {
                    key: i,
                    style: $8e498fab81f77515$var$$e(t, i)
                }, r(e, n));
            }))), Z("tbody", null, t.cells.map(function(e, i) {
                return Z("tr", {
                    key: i
                }, e.map(function(e, i) {
                    return Z("td", {
                        key: i,
                        style: $8e498fab81f77515$var$$e(t, i)
                    }, r(e, n));
                }));
            })));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.text] = {
        match: $8e498fab81f77515$var$Ue($8e498fab81f77515$var$te),
        order: 4,
        parse: function(e) {
            return {
                text: e[0].replace($8e498fab81f77515$var$B, function(e, r) {
                    return t.namedCodesToUnicode[r] ? t.namedCodesToUnicode[r] : e;
                })
            };
        },
        render: function(e) {
            return e.text;
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.textBolded] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$J),
        order: 2,
        parse: function(e, r, n) {
            return {
                children: r(e[2], n)
            };
        },
        render: function(e, r, n) {
            return Z("strong", {
                key: n.key
            }, r(e.children, n));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.textEmphasized] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$K),
        order: 3,
        parse: function(e, r, n) {
            return {
                children: r(e[2], n)
            };
        },
        render: function(e, r, n) {
            return Z("em", {
                key: n.key
            }, r(e.children, n));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.textEscaped] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$re),
        order: 1,
        parse: function(e) {
            return {
                text: e[1],
                type: $8e498fab81f77515$export$e0aa44767d8750d5.text
            };
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.textMarked] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$Y),
        order: 3,
        parse: $8e498fab81f77515$var$Ge,
        render: function(e, r, n) {
            return Z("mark", {
                key: n.key
            }, r(e.children, n));
        }
    }, f[$8e498fab81f77515$export$e0aa44767d8750d5.textStrikethroughed] = {
        match: $8e498fab81f77515$var$Ie($8e498fab81f77515$var$ee),
        order: 3,
        parse: $8e498fab81f77515$var$Ge,
        render: function(e, r, n) {
            return Z("del", {
                key: n.key
            }, r(e.children, n));
        }
    }, f);
    !0 === t.disableParsingRawHTML && (delete oe[$8e498fab81f77515$export$e0aa44767d8750d5.htmlBlock], delete oe[$8e498fab81f77515$export$e0aa44767d8750d5.htmlSelfClosing]);
    var le, ce = function(e) {
        var r = Object.keys(e);
        function n(t, i) {
            var a, o, l = [], c = "", u = "";
            for(i.prevCapture = i.prevCapture || ""; t;)for(var s = 0; s < r.length;)if (a = e[c = r[s]], !i.inline || a.match.inline) {
                var f = a.match(t, i);
                if (f) {
                    i.prevCapture += u = f[0], t = t.substring(u.length), null == (o = a.parse(f, n, i)).type && (o.type = c), l.push(o);
                    break;
                }
                s++;
            } else s++;
            return i.prevCapture = "", l;
        }
        return r.sort(function(r, n) {
            var t = e[r].order, i = e[n].order;
            return t !== i ? t - i : r < n ? -1 : 1;
        }), function(e, r) {
            return n(function(e) {
                return e.replace($8e498fab81f77515$var$b, "\n").replace($8e498fab81f77515$var$w, "").replace($8e498fab81f77515$var$G, "    ");
            }(e), r);
        };
    }(oe), ue = (le = function(e, r) {
        return function(n, t, i) {
            var a = e[n.type].render;
            return r ? r(function() {
                return a(n, t, i);
            }, n, t, i) : a(n, t, i);
        };
    }(oe, t.renderRule), function e(r, n) {
        if (void 0 === n && (n = {}), Array.isArray(r)) {
            for(var t = n.key, i = [], a = !1, o = 0; o < r.length; o++){
                n.key = o;
                var l = e(r[o], n), c = "string" == typeof l;
                c && a ? i[i.length - 1] += l : null !== l && i.push(l), a = c;
            }
            return n.key = t, i;
        }
        return le(r, e, n);
    }), se = q(n);
    return V.length ? Z("div", null, se, Z("footer", {
        key: "footer"
    }, V.map(function(e) {
        return Z("div", {
            id: t.slugify(e.identifier, $8e498fab81f77515$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ue(ce(e.footnote, {
            inline: !0
        })));
    }))) : se;
}
function $8e498fab81f77515$export$2e2bcd8739ae039(r) {
    var n = r.children, i = void 0 === n ? "" : n, a = r.options, o = function(e, r) {
        if (null == e) return {};
        var n, t, i = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)r.indexOf(n = a[t]) >= 0 || (i[n] = e[n]);
        return i;
    }(r, $8e498fab81f77515$var$t);
    return $aivMx.cloneElement($8e498fab81f77515$export$69f434acfbdb0b32(i, a), o);
}


// TNBEWEB-1945 — rich-text normalisation for the screen-editor Text node.
//
// The editor authors HTML (format menu + hand-typed tags) and stores it on the
// node's `value`. This module is the runtime half of that contract and MUST
// stay in sync with the editor's `components/HtmlContent/sanitize.ts`:
// same allowlist, same literal-tag decoding, same whitespace encoding — so the
// canvas, the preview iframe and the published screen render identically.

const $8ae552e76398dc96$export$3ceeeb9b90ab1e35 = [
    'strong',
    'em',
    'b',
    'i',
    'u',
    's',
    'mark',
    'small',
    'sup',
    'sub',
    'pre',
    'dfn',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'q',
    'blockquote',
    'cite',
    'code',
    'samp',
    'kbd',
    'var',
    'time',
    'a',
    'hr',
    'br',
    'ul',
    'ol',
    'li',
    'abbr',
    'ins',
    'del',
    'details',
    'summary',
    'span'
];
const $8ae552e76398dc96$var$ALLOWED_ATTR = [
    'href',
    'target',
    'rel',
    'datetime',
    'title',
    'open',
    'style'
];
// `style` survives only for safe character properties — `url(...)` /
// `background-image` are an XSS and data-exfiltration vector. DOMPurify has no
// per-property style filter, so the declaration list is re-parsed by hand.
const $8ae552e76398dc96$var$SAFE_STYLE_PROPS = new Set([
    'color',
    'background-color',
    'font-weight',
    'font-style',
    'text-decoration',
    'text-decoration-line',
    'font-size',
    'font-family',
    'letter-spacing'
]);
const $8ae552e76398dc96$var$VALUE_HAS_FORBIDDEN = /url\s*\(|expression\s*\(|image-set\s*\(/i;
(0, (/*@__PURE__*/$parcel$interopDefault($d73df6074dc4c114$exports))).addHook('afterSanitizeAttributes', (node)=>{
    if (!(node instanceof HTMLElement)) return;
    const styleAttr = node.getAttribute('style');
    if (!styleAttr) return;
    const safe = styleAttr.split(';').map((decl)=>{
        const idx = decl.indexOf(':');
        if (idx === -1) return null;
        const prop = decl.slice(0, idx).trim().toLowerCase();
        const value = decl.slice(idx + 1).trim();
        if (!$8ae552e76398dc96$var$SAFE_STYLE_PROPS.has(prop) || !value || $8ae552e76398dc96$var$VALUE_HAS_FORBIDDEN.test(value)) return null;
        return `${prop}: ${value}`;
    }).filter(Boolean).join('; ');
    if (safe) node.setAttribute('style', safe);
    else node.removeAttribute('style');
});
// Authored links must be usable in the preview iframe and in the published
// screen. Two things stopped them working: a href typed without a scheme
// ("google.com") resolves against the app origin, and an in-place navigation
// inside the preview iframe just replaces the preview. Normalise the scheme and
// send every link to a new tab. Done in a sanitizer hook rather than in JSX
// because the ellipsis path renders the content to a STRING
// (ReactDOMServer.renderToString) — React event handlers do not survive that,
// plain attributes do.
const $8ae552e76398dc96$var$HAS_SCHEME_RE = /^([a-z][a-z0-9+.-]*:|\/\/|\/|#|\?)/i;
(0, (/*@__PURE__*/$parcel$interopDefault($d73df6074dc4c114$exports))).addHook('afterSanitizeAttributes', (node)=>{
    if (!(node instanceof HTMLElement) || node.tagName !== 'A') return;
    const href = node.getAttribute('href');
    if (!href) return;
    const trimmed = href.trim();
    if (trimmed && !$8ae552e76398dc96$var$HAS_SCHEME_RE.test(trimmed)) node.setAttribute('href', `https://${trimmed}`);
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
});
const $8ae552e76398dc96$var$ALLOWED_TAG_SET = new Set($8ae552e76398dc96$export$3ceeeb9b90ab1e35);
// The editor's contentEditable escapes everything the user types, so markup
// written by hand arrives as `&lt;b&gt;bold&lt;/b&gt;` and would render as literal
// text. Decode it — but only for allowlisted tags, so `&lt;script&gt;` and any
// prose containing `<` stays inert.
const $8ae552e76398dc96$var$LITERAL_TAG_RE = /&lt;(\/?)([a-zA-Z][a-zA-Z0-9]*)([^<>]*?)&gt;/g;
const $8ae552e76398dc96$export$365a88267285f210 = (input)=>input.replace($8ae552e76398dc96$var$LITERAL_TAG_RE, (match, slash, tag, attrs)=>{
        if (!$8ae552e76398dc96$var$ALLOWED_TAG_SET.has(tag.toLowerCase())) return match;
        const decodedAttrs = attrs.replace(/&quot;|&#34;/g, '"').replace(/&#39;|&apos;/g, "'").replace(/&amp;/g, '&');
        return `<${slash}${tag}${decodedAttrs}>`;
    });
// HTML collapses whitespace runs and ignores newlines, so the indentation and
// blank lines the author typed vanished at render time. Encode them as markup
// (nbsp + <br>) instead of forcing `white-space: pre-wrap`, which would fight
// the node's own `nowrap` in ellipsis mode.
const $8ae552e76398dc96$var$NBSP = '\u00a0';
// Tags that start a new visual line — only after one of these (or a newline) is
// a run of spaces indentation rather than an ordinary word gap.
const $8ae552e76398dc96$var$LINE_BREAKING_TAG_RE = /^<\/?(br|hr|p|div|li|ul|ol|h[1-6]|blockquote|pre|details|summary)\b/i;
const $8ae552e76398dc96$export$13fe85b4d830a2be = (input)=>{
    let atLineStart = true;
    return input// Odd indices are the tags themselves — never rewrite inside a tag or the
    // attribute values get corrupted.
    .split(/(<[^>]*>)/).map((token, i)=>{
        if (i % 2 === 1) {
            if ($8ae552e76398dc96$var$LINE_BREAKING_TAG_RE.test(token)) atLineStart = true;
            return token;
        }
        if (!token) return token;
        const out = token.split(/\r\n|\r|\n/).map((line, lineIndex)=>{
            const indented = line.replace(/\t/g, $8ae552e76398dc96$var$NBSP.repeat(4));
            // A space right after an INLINE tag (`</b> c`) is a word gap, not
            // indentation — turning it into a nbsp would glue the words together.
            const isLineStart = lineIndex > 0 || atLineStart;
            return (isLineStart ? indented.replace(/^ +/, (spaces)=>$8ae552e76398dc96$var$NBSP.repeat(spaces.length)) : indented).replace(/ {2,}/g, (spaces)=>`${$8ae552e76398dc96$var$NBSP.repeat(spaces.length - 1)} `);
        }).join('<br>');
        atLineStart = /[\r\n]$/.test(token);
        return out;
    }).join('');
};
const $8ae552e76398dc96$export$7ce3da561e086fc9 = (input)=>(0, (/*@__PURE__*/$parcel$interopDefault($d73df6074dc4c114$exports))).sanitize($8ae552e76398dc96$export$13fe85b4d830a2be($8ae552e76398dc96$export$365a88267285f210(input)), {
        ALLOWED_TAGS: $8ae552e76398dc96$export$3ceeeb9b90ab1e35,
        ALLOWED_ATTR: $8ae552e76398dc96$var$ALLOWED_ATTR
    });
var $8ae552e76398dc96$export$2e2bcd8739ae039 = $8ae552e76398dc96$export$7ce3da561e086fc9;


var $c4270f87ee1c564b$export$7bcc4193ad80bf91;
$c4270f87ee1c564b$export$7bcc4193ad80bf91 = `SVWb7a_richText`;


const $5b62e0f9ddeec46b$var$HTML_TAG_RE = /<[a-zA-Z][^>]*>/;
const $5b62e0f9ddeec46b$var$hasHtml = (text)=>$5b62e0f9ddeec46b$var$HTML_TAG_RE.test(text);
const $5b62e0f9ddeec46b$var$MarkdownContent = ({ text: text, transparent: transparent = false, renderCallback: renderCallback })=>{
    if (!text) return null;
    const stringifiedText = typeof text === 'object' ? JSON.stringify(text) : String(text);
    // Replace multiple consecutive newlines with a single newline followed by the corresponding number of non-breaking spaces
    // Replace all types of newline characters with <br /> tags
    const formatTextOutsideListItems = (text)=>{
        const blocks = text.split(/(\n-.*?\n\n)/s); // Split text into blocks by list item start and end
        return blocks.map((block)=>{
            // Check if the block starts with a list item
            if (/^\n-/.test(block)) return block; // Return the block as is if it starts with a list item
            return block.replace(/\n{2,}/g, (match)=>{
                const newlineCount = match.length; // Count the number of newlines in the match
                const nbspCount = newlineCount - 1; // Number of nbsp needed (newlines - 1)
                let replacement = '\n'; // Start with one newline
                for(let i = 0; i < nbspCount; i += 1)replacement += '&nbsp;\n'; // Add nbsp + newline for each extra newline
                return replacement;
            });
        }).join(''); // Join the blocks back together
    };
    const hasUnresolvedTokens = /\{\{.+?\}\}/.test(stringifiedText);
    const formattedText = stringifiedText;
    const handleLinkClick = (e)=>{
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        if (href) window.open(href, '_blank');
    };
    const CustomLink = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("a", {
            ...props,
            onClick: handleLinkClick
        });
    const CustomListItem = (props)=>{
        const { children: children } = props;
        const modifiedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).Children.map(children, (child)=>{
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).isValidElement(child) && child.type === 'a') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aivMx))).cloneElement(child, {
                onClick: handleLinkClick
            });
            return child;
        });
        return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("li", {
            ...props,
            children: modifiedChildren
        });
    };
    const containerStyle = {
        opacity: 1
    };
    // useEffect(() => {
    //   if (renderCallback) {
    //     renderCallback();
    //   }
    // }
    // , [renderCallback]);
    if (hasUnresolvedTokens) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
        children: formattedText
    });
    // TNBEWEB-1945 — content authored in the screen editor's Text node. Tags the
    // author typed by hand arrive escaped, so decode them BEFORE deciding which
    // branch renders: `&lt;b&gt;bold&lt;/b&gt;` is HTML the user meant, not prose.
    // Markdown stays the branch for content with no tags at all, so nothing that
    // relies on it regresses.
    const decodedText = (0, $8ae552e76398dc96$export$365a88267285f210)(formattedText);
    if ($5b62e0f9ddeec46b$var$hasHtml(decodedText)) return(// Links navigate through the `target="_blank"` the sanitizer adds — no
    // React handler here, because the ellipsis path renders this to a string
    // and would drop one. The node's own click actions are suppressed for
    // links in Text.tsx's handleClick.
    /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
        className: $c4270f87ee1c564b$export$7bcc4193ad80bf91,
        dangerouslySetInnerHTML: {
            __html: (0, $8ae552e76398dc96$export$7ce3da561e086fc9)(decodedText)
        }
    }));
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e498fab81f77515$export$2e2bcd8739ae039), {
        options: {
            overrides: {
                a: {
                    component: CustomLink
                },
                li: {
                    component: CustomListItem
                }
            }
        },
        children: formattedText
    });
};
var $5b62e0f9ddeec46b$export$2e2bcd8739ae039 = $5b62e0f9ddeec46b$var$MarkdownContent;


var $54f9738ec67d5626$export$2e2bcd8739ae039 = (0, $5b62e0f9ddeec46b$export$2e2bcd8739ae039);


var $42c5baa8fd68a26d$export$a244188ab7675ec7;
$42c5baa8fd68a26d$export$a244188ab7675ec7 = `TOPzwa_fix_overflow`;


const $ca01b6cc23909411$var$StyledInlineText = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div.attrs(({ as: as })=>({
        as: as
    }))`
  z-index: 1;
  position: relative;
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}

  ${({ $shape: $shape })=>$shape?.font?.text_overflow === 'ellipsis' && (0, $6e03950c2a9b6039$export$dbf350e5966cf602)`
      /* Apply to all nested elements */
      * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `}
`;
const $ca01b6cc23909411$var$InlineText = ({ id: id, value: value, style: stDraft, events: eventsDraft, dataLake: dataLake, pageSettings: pageSettings, active_state: activeStateDraft, nestedTable: nestedTable, parentIndex: parentIndex, styleChunks: styleChunks, skeleton: renderSkeleton2, parentRef: parentRef, settings: settings, parentLoading: parentLoading, parentStyle: parentStyle, enableLocalShimmer: enableLocalShimmer, valueOriginal: valueOriginal, cache: cache })=>{
    const { ref: ref } = settings || {};
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const containerRef = (0, $aivMx.useRef)(null);
    const { tag: tag = 'div' } = settings || {};
    const [containerProperties, setContainerProperties] = (0, $aivMx.useState)({
        width: 0,
        overflow: undefined
    });
    const { style: styleDraft, events: events, active_state: active_state, ref: realRef } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        ref: ref,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        ref: undefined,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    };
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'text') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? !!(cache || typeof valueOriginal === 'string' && /{{.*}}/.test(valueOriginal)) : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        valueOriginal,
        parentLoading,
        cache
    ]);
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, containerRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    const style = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const { on_click: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    const handleClick = (e)=>{
        if (active_state === 'disabled' || active_state === 'loading') {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        // A click on an authored link (TNBEWEB-1945) belongs to the link — let it
        // navigate and do NOT also run the node's click actions. Checked here rather
        // than only in MarkdownContent because the ellipsis path renders the content
        // to a string, which drops that component's React handlers.
        if (e.target?.closest?.('a[href]')) return;
        if (clickUpdates) {
            const styleUpdates = clickUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = clickUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = clickUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = clickUpdates.filter((update)=>update && 'action' in update);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            applyVariablesFirst(clickUpdates);
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            applyVariablesFirst(hoverUpdates);
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length && active_state !== 'disabled' && active_state !== 'loading') handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            applyVariablesFirst(unhoverUpdates);
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== style?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = style?.visibility; // Set the flag to true
            const styleUpdates = launchUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') ;
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            applyVariablesFirst(launchUpdates);
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        style?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (style?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && containerRef.current && !containerRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex));
                    // Handle action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id,
                            onSuccess: onSuccessUpdates,
                            onError: onErrorUpdates
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        style?.visibility
    ]);
    // FE-4974: `value` comes off the screen untyped — the API stores `"value": 12345` — and
    // `?.` doesn't save a number from `.match`. Only a string can carry a `{{this.*}}` token.
    const val = dataLake?.data && typeof value === 'string' && value.match(/{{this\..*}}/) ? value.replace(/{{(this\.[^}]+)}}/g, (_, path)=>{
        const result = (0, $7b0e169a5380005e$export$a87687c5ea189578)(dataLake.data, path);
        return result ?? '';
    }) : value;
    const updateContainerWidth = ()=>{
        if (parentRef?.current && parentRef?.current?.offsetWidth) {
            const styles = window.getComputedStyle(parentRef?.current);
            const paddingLeft = parseFloat(styles.paddingLeft);
            const paddingRight = parseFloat(styles.paddingRight);
            const overflow = styles.overflow || styles.overflowX;
            const totalWidth = parentRef?.current.offsetWidth;
            const available = totalWidth - (paddingLeft + paddingRight);
            setContainerProperties({
                width: available,
                overflow: overflow
            });
            return available;
        }
    };
    (0, $aivMx.useEffect)(()=>{
        if (!val) return;
        updateContainerWidth();
    }, [
        parentRef?.current,
        val
    ]);
    const textOverflowEllipsis = style?.font?.text_overflow === 'ellipsis';
    const TextEl = $ca01b6cc23909411$var$StyledInlineText;
    const renderMarkdown = /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $54f9738ec67d5626$export$2e2bcd8739ae039), {
        text: val
    });
    const tryParse = (htmlString)=>{
        try {
            const sanitizedHtml = (0, (/*@__PURE__*/$parcel$interopDefault($d73df6074dc4c114$exports))).sanitize(htmlString);
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: sanitizedHtml
                }
            });
        } catch (error) {
            console.error('Error parsing HTML string:', error);
            return null;
        }
    };
    if (renderSceleton) {
        const htmlString = (0, (/*@__PURE__*/$parcel$interopDefault($751e048dd35ac525$exports))).renderToString(renderMarkdown);
        const generatedStyle = (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)({
            font: style?.font
        });
        const wrappedHtmlString = (0, $fd8923e6d4b4f897$export$163ca17ab7c8b5d9)(htmlString, generatedStyle, containerProperties.width, containerProperties.overflow, textOverflowEllipsis, nestedTable);
        const WrappedMarkdownContent = ()=>wrappedHtmlString ? tryParse(wrappedHtmlString) : null;
        return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(TextEl, {
            as: tag,
            ref: containerRef,
            "data-id": realRef || id,
            id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
            $shape: style,
            $baseScreenResolution: baseScreenResolution,
            $skipStates: active_state === 'disabled' || active_state === 'loading',
            $parentDisplay: parentStyle?.display,
            $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
            "data-component": "text",
            className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style?.class, $42c5baa8fd68a26d$export$a244188ab7675ec7),
            onClick: handleClick,
            onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
            onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(WrappedMarkdownContent, {})
        });
    }
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(TextEl, {
        ref: containerRef,
        as: tag,
        "data-id": realRef || id,
        id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        $shape: style,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": "text",
        // FE-4974: a text created through the API may carry no `style` at all.
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style?.class),
        onClick: handleClick,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $54f9738ec67d5626$export$2e2bcd8739ae039), {
            text: val
        })
    });
};
var $ca01b6cc23909411$export$2e2bcd8739ae039 = $ca01b6cc23909411$var$InlineText;


var $d009549dd9adb801$export$2e2bcd8739ae039 = (0, $ca01b6cc23909411$export$2e2bcd8739ae039);



parcelRequire("aivMx");



// Every `component` the platform knows: the ones this renderer draws, plus `button` and
// `divider`, which only the editor draws and which render as nothing here. Mirrors
// `isUnknownComponent` in the editor (fractal-fe `UnknownComponentChunk`).
const $29a699900545c598$var$KNOWN_COMPONENTS = new Set([
    'screen',
    'container',
    'table',
    'text',
    'input',
    'select',
    'checkbox',
    'radio',
    'switcher',
    'chart',
    'image',
    'separator',
    'button',
    'divider'
]);
const $29a699900545c598$export$45ed19580260ae3a = (component)=>typeof component !== 'string' || !$29a699900545c598$var$KNOWN_COMPONENTS.has(component);
const $29a699900545c598$var$StyledNode = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, undefined, undefined, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
// The editor's placeholder, which is the mobile canvas's (`paintPlaceholder`).
const $29a699900545c598$var$Placeholder = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 4px 8px;
  border: 1px dashed #b0b0b8;
  border-radius: 8px;
  background: rgba(176, 176, 184, 0.1);
`;
const $29a699900545c598$var$Label = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).span`
  overflow: hidden;
  color: #b0b0b8;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
// FE-4974: the API accepts any `component` string, and a type nothing here can draw rendered
// as nothing at all. It is drawn as the placeholder the editor shows, in the node's own box
// (its size and placement). Nothing the node holds is rendered: its children and value mean
// nothing without the component that would lay them out.
const $29a699900545c598$var$UnknownComponent = ({ id: id, component: component, style: style, parentStyle: parentStyle })=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($29a699900545c598$var$StyledNode, {
        id: id,
        "data-id": id,
        "data-component": "unknown",
        $shape: style,
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        className: (0, $7b0e169a5380005e$export$189053d41e721fcb)(style?.class),
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($29a699900545c598$var$Placeholder, {
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)($29a699900545c598$var$Label, {
                children: typeof component === 'string' && component ? `Unknown component: ${component}` : 'Unknown component'
            })
        })
    });
var $29a699900545c598$export$2e2bcd8739ae039 = $29a699900545c598$var$UnknownComponent;


var $4049ca43de2ab8ae$export$2e2bcd8739ae039 = (0, $29a699900545c598$export$2e2bcd8739ae039);











var $aivMx = parcelRequire("aivMx");
const $0aedb54c46f4bebe$var$useScrollToTopOnLocationChange = (ref, hash)=>{
    const prevHashRef = (0, $aivMx.useRef)(hash);
    (0, $aivMx.useEffect)(()=>{
        // Only trigger if hash changed and is not the initial render
        if (hash !== prevHashRef.current && ref.current && !(typeof hash === 'string' && hash.startsWith('skip-'))) {
            const element = ref.current;
            element.scrollTop = 0;
        }
        // Update the previous hash value
        prevHashRef.current = hash;
    }, [
        hash,
        ref
    ]);
};
var $0aedb54c46f4bebe$export$2e2bcd8739ae039 = $0aedb54c46f4bebe$var$useScrollToTopOnLocationChange;


// constants.ts
const $2b42b3a2aa0ebb61$export$c5399bfb4d939924 = 12; // col size related to parent width
const $2b42b3a2aa0ebb61$export$a176cc2ca3635d69 = 16; // row size related to parent height


const $d4ac9f041de1a90a$var$componentMapping = {
    checkbox: (0, $2c90db8687e433b8$export$2e2bcd8739ae039),
    image: (0, $aa8f0f735a0f79aa$export$2e2bcd8739ae039),
    input: (0, $7ea0c43ec9b05f7e$export$2e2bcd8739ae039),
    radio: (0, $b35bf230db392315$export$2e2bcd8739ae039),
    select: (0, $bb9696960a8827ef$export$2e2bcd8739ae039),
    separator: (0, $3492f55331d0a86f$export$2e2bcd8739ae039),
    switcher: (0, $f7a8d8148b95e31e$export$2e2bcd8739ae039),
    chart: (0, $4659927e2b435a01$export$2e2bcd8739ae039),
    text: (0, $d009549dd9adb801$export$2e2bcd8739ae039)
};
const $d4ac9f041de1a90a$var$StyledContainer = (0, $6e03950c2a9b6039$export$2e2bcd8739ae039).div`
  ${(props)=>(0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(props.$shape, props.$baseScreenResolution, props.$skipStates, props.$parentDisplay, undefined, props.$parentFlexDirection)}
`;
// Utility function to generate CSS classes with hover styles for targeted elements
const $d4ac9f041de1a90a$var$generateHoverClass = (elementId, hoverUpdates, items)=>{
    if (!hoverUpdates?.length) return '';
    const hoverStyleUpdates = hoverUpdates?.filter((update)=>update && 'style' in update) || [];
    // Only handle style updates that target specific child elements (have object_id and target a child)
    const targetedStyleUpdates = hoverStyleUpdates.filter((update)=>update.object_id && update.object_id !== elementId);
    if (!targetedStyleUpdates.length) return '';
    const className = `hover-class-${elementId.replace(/[^a-zA-Z0-9-_]/g, '-')}`;
    // const mainElementSelector = `#${elementId.replace(/[^a-zA-Z0-9-_]/g, '\\\\$&')}`;
    // Generate CSS for hover state
    let css = '';
    if (targetedStyleUpdates.length) targetedStyleUpdates.forEach((update)=>{
        const { style: updateStyle, object_id: targetId } = update;
        // Use generateComponentStyles to properly convert style object to CSS
        const generatedStyles = (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)({
            display: updateStyle?.visibility === 'visible' ? 'flex' : undefined,
            ...updateStyle
        }, undefined, true);
        if (generatedStyles && typeof generatedStyles === 'object') {
            const cssProperties = Object.entries(generatedStyles).filter(([key, value])=>value !== null && value !== undefined).map(([key, value])=>`    ${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value};`).join('\n');
            if (cssProperties) {
                // Target specific child element with data-id, nested inside main element hover
                const targetSelector = `[data-id="${targetId.replace(/"/g, '\\"')}"]`;
                // TNBEWEB-1980: gate the CSS hover behind @media (hover: hover) so a finger
                // tap on a touch device doesn't trigger (and stick) the child hover styling,
                // bypassing the JS pointerType gate.
                css += `
  @media (hover: hover) {
    .${className}:hover ${targetSelector} {
${cssProperties}
    }
  }`;
            }
        }
    });
    // Inject CSS into document head
    const styleId = `hover-style-${elementId.replace(/[^a-zA-Z0-9-_]/g, '-')}`;
    const existingStyle = document.getElementById(styleId);
    if (existingStyle) existingStyle.textContent = css;
    else {
        const styleElement = document.createElement('style');
        styleElement.id = styleId;
        styleElement.textContent = css;
        document.head.appendChild(styleElement);
    }
    return className;
};
const $d4ac9f041de1a90a$var$GridContainerComponent = (obj)=>{
    const { id: id, items: items, style: stDraft, component: component, events: eventsDraft, dataLake: dataLake, parentIndex: parentIndex, pageSettings: pageSettings, styleChunks: styleChunks, active_state: activeStateDraft, nestedTable: nestedTable, skeleton: renderSkeleton2, parentLoading: parentLoading, parentStyle: parentStyle, topLayerNode: topLayerNode, hash: hash, enableLocalShimmer: enableLocalShimmer, cache: cache, settings: settings } = obj || {};
    const { ref: ref } = settings || {};
    const launchExecutedRef = (0, $aivMx.useRef)(null);
    const containerRef = (0, $aivMx.useRef)(null);
    const { style: styleDraft, events: events, active_state: active_state, ref: realRef } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
        ref: ref,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    }, dataLake.data) : {
        ref: undefined,
        style: stDraft,
        events: eventsDraft,
        active_state: activeStateDraft
    };
    // Merge active state styles with base style
    const mergeStylesWithChunks = (0, $aivMx.useCallback)((style, chunks, index)=>{
        const { indexes: indexes, refs: refs } = chunks || {};
        let mergedStyle = style;
        // Apply index-based styles first
        if (indexes && indexes[id] && indexes[id][index] && typeof index === 'number') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, indexes[id][index]);
        // Apply ref-based updates at the end
        if (refs && realRef) {
            const refUpdate = refs[realRef];
            if (refUpdate?.type && refUpdate.type === 'container') mergedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, mergedStyle, refUpdate?.update);
        }
        return mergedStyle;
    }, [
        id,
        realRef
    ]);
    const renderSceleton = (0, $aivMx.useMemo)(()=>{
        if (enableLocalShimmer) {
            if (cache === false) return false;
            return active_state === 'loading' || parentLoading ? cache : false;
        }
        return renderSkeleton2;
    }, [
        renderSkeleton2,
        active_state,
        enableLocalShimmer,
        parentLoading
    ]);
    // First useMemo to merge active state styles with base style
    const { effectiveState: effectiveState, entranceAnimation: entranceAnimation } = (0, $a2763a0b9b623ad0$export$a46b8a0c83328bf7)(styleDraft, active_state, containerRef);
    const mergedStyleWithState = (0, $aivMx.useMemo)(()=>{
        let mergedStyle = styleDraft;
        if (effectiveState && styleDraft?.states?.[effectiveState]) mergedStyle = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, styleDraft, styleDraft.states[effectiveState]);
        // Handle states in breakpoints
        if (styleDraft?.breakpoints) mergedStyle.breakpoints = Object.entries(styleDraft.breakpoints).reduce((acc, [breakpoint, breakpointStyle])=>{
            const typedBreakpointStyle = breakpointStyle;
            if (typedBreakpointStyle?.states?.[effectiveState]) acc[breakpoint] = (0, $e284844083433a8c$export$3186d74a8b5f5ee8)({}, typedBreakpointStyle, typedBreakpointStyle.states[effectiveState]);
            else acc[breakpoint] = typedBreakpointStyle;
            return acc;
        }, {});
        if (entranceAnimation) mergedStyle = {
            ...mergedStyle,
            animation: entranceAnimation
        };
        return mergedStyle;
    }, [
        styleDraft,
        effectiveState,
        entranceAnimation
    ]);
    // Use the custom hook
    (0, $0aedb54c46f4bebe$export$2e2bcd8739ae039)(containerRef, hash);
    // Second useMemo to merge styles with chunks based on parentIndex
    const st = (0, $aivMx.useMemo)(()=>mergeStylesWithChunks(mergedStyleWithState, styleChunks, parentIndex), [
        mergedStyleWithState,
        styleChunks,
        parentIndex
    ]);
    const { row: stickyRows } = dataLake?.settings?.pin || {};
    const isSticky = parentIndex < stickyRows;
    const { on_click: clickUpdates, on_launch: launchUpdates, on_hover: hoverUpdates, on_unhover: unhoverUpdates, on_outclick: outclickUpdates, on_success: onSuccessUpdates, on_error: onErrorUpdates } = events || {};
    const { cols: colCount, rows: rowCount } = st || {};
    const baseScreenResolution = pageSettings?.baseScreenResolution ? (0, $7b0e169a5380005e$export$e58d7eefdadeb732)(pageSettings?.baseScreenResolution) : undefined;
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const timeoutsRef = (0, $aivMx.useRef)([]);
    // TNBEWEB-1990: tracks whether JS-applied hover styles are currently active, so a
    // tab focus/visibility loss (e.g. on_click opens a link in a new tab) can revert them.
    const isHoveredRef = (0, $aivMx.useRef)(false);
    // TNBEWEB-1992: shared handler scope (adds data.* / _c.* / _config.* / this.* on top of the
    // legacy $get/$set); `thisRow`/`rowPath` come from the repeatable row context (undefined otherwise).
    const internalFns = (0, $c6acd105f1cc0a20$export$48102551e27885f5)({
        store: store,
        thisRow: dataLake?.data,
        rowPath: dataLake?.rowPath,
        owner: {
            id: id,
            parentIndex: parentIndex,
            row: dataLake?.data,
            activeState: active_state
        }
    });
    // Variables are assigned before every other chunk in the event (first in the
    // stack). Resolve them synchronously so the style/action/function chunks that
    // follow already see the new values. `{{this.*}}` resolves against this
    // component's own data.
    const applyVariablesFirst = (updates)=>{
        const variableUpdates = (updates || []).filter((u)=>(0, $7674591fd5554b85$export$a7714fd308578054)(u));
        if (!variableUpdates.length) return;
        const state = store.getState();
        const data = (0, $7674591fd5554b85$export$4c40aaaedfbf949d)(variableUpdates, {
            variables: (0, $79fc67ed759ae65b$export$e3ab06c283dfbb87)(state),
            localVariables: (0, $79fc67ed759ae65b$export$78b26e3ba532c6ce)(state),
            thisContext: dataLake?.data,
            formValues: state.page?.formValues
        });
        if (data && Object.keys(data).length) dispatch((0, $8eba69c5466928d3$export$7b322c1959eae1de)({
            data: data
        }));
    };
    const handleActionChunk = (actionUpdates, filterLoadingState, onSuccessEvts, onErrorEvts)=>{
        actionUpdates.forEach((update)=>{
            dispatch((0, $8eba69c5466928d3$export$2c41626496d118d)({
                actionUpdate: update,
                componentId: id,
                onSuccess: onSuccessEvts,
                onError: onErrorEvts
            }, filterLoadingState));
        });
    };
    const handleClick = (e)=>{
        e.preventDefault();
        // for container click block requests but keep all other
        if (active_state === 'disabled' || active_state === 'loading') {
            e.stopPropagation();
            return;
        }
        if (clickUpdates) {
            e.stopPropagation();
            const styleUpdates = clickUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = clickUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = clickUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = clickUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(clickUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) {
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    handleActionChunk(actionUpdates, filterLoadingState, onSuccessUpdates, onErrorUpdates);
                }
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const filterLoadingState = styleUpdates?.filter((update)=>update?.active_state === 'loading');
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'command') dispatch((0, $8eba69c5466928d3$export$ea176eb1668c7b4b)({
                        location: {
                            pathname: value
                        },
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        delay: delay,
                        silent: silent,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }, filterLoadingState));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    // Recursive function to check if a target node is a child of the current container
    const isTargetNodeChild = (0, $aivMx.useCallback)((targetId)=>(0, $023c85c367f3a865$export$447718b10fc2fae)(targetId, items), [
        items
    ]);
    const handleHover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply hover
        if (hoverUpdates) {
            isHoveredRef.current = true; // TNBEWEB-1990: JS hover styles are being applied
            const styleUpdates = hoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = hoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = hoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = hoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(hoverUpdates);
            // Only dispatch style updates that are NOT handled by CSS hover classes
            // (i.e., updates that don't target specific child elements or target the container itself)
            const styleUpdatesForDispatch = styleUpdates.filter((update)=>{
                // Exclude if object_id matches {{...}} or contains {{...}} pattern
                if (/\{\{.*\}\}/.test(update.object_id)) return true;
                // If no object_id, it targets the container itself
                if (!update.object_id) return true;
                // If object_id matches current container, include it
                if (update.object_id === (realRef || id)) return true;
                // If object_id targets a child node, exclude it (let CSS handle it)
                if (isTargetNodeChild(update.object_id)) return false;
                // Otherwise, include it (might target parent or sibling)
                return true;
            });
            const runEffects = ()=>{
                if (styleUpdatesForDispatch.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdatesForDispatch, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    // TNBEWEB-1990: pointer-event-free unhover core, callable both from the
    // onPointerLeave handler and from the tab focus/visibility fallback below.
    const applyUnhover = (e)=>{
        isHoveredRef.current = false;
        if (unhoverUpdates) {
            const styleUpdates = unhoverUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = unhoverUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = unhoverUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = unhoverUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(unhoverUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length && active_state !== 'disabled' && active_state !== 'loading') requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                        value: value,
                        silent: silent,
                        delay: delay,
                        componentId: id,
                        onSuccess: onSuccessUpdates,
                        onError: onErrorUpdates
                    }));
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects, e);
        }
    };
    const handleUnhover = (e)=>{
        if (e.pointerType === 'touch') return; // TNBEWEB-1980: finger tap — don't apply unhover
        applyUnhover(e);
    };
    // TNBEWEB-1990: when an on_click opens a link in a new tab, the new tab steals
    // focus BEFORE the pointer leaves the element, so the browser never fires
    // pointerleave → handleUnhover never runs → JS hover styles stay stuck (red).
    // Revert them when the tab loses focus / becomes hidden while still hovered.
    (0, $aivMx.useEffect)(()=>{
        if (!unhoverUpdates?.length) return undefined;
        const resetHoverIfActive = ()=>{
            if (isHoveredRef.current) applyUnhover();
        };
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === 'hidden') resetHoverIfActive();
        };
        window.addEventListener('blur', resetHoverIfActive);
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            window.removeEventListener('blur', resetHoverIfActive);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        unhoverUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (launchExecutedRef.current !== st?.visibility && launchUpdates && launchUpdates.length) {
            launchExecutedRef.current = st?.visibility; // Set the flag to true
            const styleUpdates = launchUpdates.filter((update)=>update && 'style' in update);
            const requestUpdates = launchUpdates.filter((update)=>update && 'request' in update);
            const functionUpdates = launchUpdates.filter((update)=>update && 'function' in update);
            const actionUpdates = launchUpdates.filter((update)=>update && 'action' in update);
            applyVariablesFirst(launchUpdates);
            const runEffects = ()=>{
                if (styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(styleUpdates, parentIndex, dataLake?.data));
                if (actionUpdates.length) handleActionChunk(actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                if (requestUpdates.length) requestUpdates.forEach((update)=>{
                    const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                    const { delay: delay } = config || {};
                    if (update?.request && method === 'action') ;
                    else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                });
            };
            (0, $7b0e169a5380005e$export$4526859d798b35)(functionUpdates, internalFns, runEffects);
        }
        return ()=>{
            timeoutsRef?.current?.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        launchUpdates,
        st?.visibility
    ]);
    // Memoize the filtered updates to avoid recalculating on every click
    const filteredUpdates = (0, $aivMx.useMemo)(()=>{
        if (!outclickUpdates) return null;
        return {
            styleUpdates: outclickUpdates.filter((update)=>update && 'style' in update),
            requestUpdates: outclickUpdates.filter((update)=>update && 'request' in update),
            functionUpdates: outclickUpdates.filter((update)=>update && 'function' in update),
            actionUpdates: outclickUpdates.filter((update)=>update && 'action' in update)
        };
    }, [
        outclickUpdates
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!outclickUpdates?.length) return undefined;
        if (st?.visibility === 'hidden') return undefined;
        const handleUnclick = (e)=>{
            if (active_state === 'disabled' || active_state === 'loading') return;
            if (outclickUpdates?.length && containerRef.current && !containerRef.current.contains(e.target) && !(0, $7b0e169a5380005e$export$59feb59f25215061)(e.target) && filteredUpdates) {
                const runEffects = ()=>{
                    // Apply style updates
                    if (filteredUpdates.styleUpdates.length) dispatch((0, $8eba69c5466928d3$export$fe25ce1cfff10000)(filteredUpdates.styleUpdates, parentIndex, dataLake?.data));
                    // Handle action updates
                    if (filteredUpdates.actionUpdates.length) handleActionChunk(filteredUpdates.actionUpdates, undefined, onSuccessUpdates, onErrorUpdates);
                    // Process request updates
                    if (filteredUpdates.requestUpdates.length) filteredUpdates.requestUpdates.forEach((update)=>{
                        const { method: method, value: value, silent: silent, config: config } = update?.request || {};
                        const { delay: delay } = config || {};
                        if (update?.request && method === 'action') dispatch((0, $8eba69c5466928d3$export$decff28e578bd5f9)({
                            value: value,
                            silent: silent,
                            delay: delay,
                            componentId: id
                        }));
                        else if (update?.request && method === 'open-url') (0, $7b0e169a5380005e$export$b5ac3c35b6e379b6)(value, delay, silent, (0, $4931f7746d84676b$export$55abd4691b317664));
                    });
                };
                applyVariablesFirst(outclickUpdates);
                (0, $7b0e169a5380005e$export$4526859d798b35)(filteredUpdates.functionUpdates, internalFns, runEffects);
            }
        };
        document.addEventListener('mousedown', handleUnclick, true);
        return ()=>{
            document.removeEventListener('mousedown', handleUnclick, true);
        };
    }, [
        parentIndex,
        active_state,
        id,
        stDraft?.states?.loading,
        outclickUpdates?.length,
        st?.visibility
    ]);
    // Generate hover class name when component loads or id changes
    const hoverClassName = (0, $aivMx.useMemo)(()=>$d4ac9f041de1a90a$var$generateHoverClass(realRef || id, hoverUpdates), [
        id,
        realRef,
        hoverUpdates
    ]);
    // Cleanup hover styles when component unmounts
    (0, $aivMx.useEffect)(()=>{
        if (!id) return undefined;
        const currentId = id;
        return ()=>{
            // Check if any other elements with the same data-id still exist in the DOM
            const elementsWithSameId = document.querySelectorAll(`[data-id="${currentId}"]`);
            // Only remove the hover styles if no other elements with this id exist
            if (elementsWithSameId?.length === 0) {
                const styleId = `hover-style-${currentId.replace(/[^a-zA-Z0-9-_]/g, '-')}`;
                const existingStyle = document.getElementById(styleId);
                if (existingStyle) existingStyle.remove();
            }
        };
    }, [
        id
    ]);
    // State transitions (:hover / :active / active_state) animate via the CSS
    // `transition` emitted in generateComponentStyles. No framer-motion entrance.
    const ContainerEl = $d4ac9f041de1a90a$var$StyledContainer;
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)(ContainerEl, {
        ref: containerRef,
        id: `${realRef || id}${nestedTable && typeof parentIndex === 'number' && !realRef ? `::${parentIndex}` : ''}`,
        style: {
            gridTemplateColumns: `repeat(${colCount || (0, $2b42b3a2aa0ebb61$export$c5399bfb4d939924)}, 1fr)`,
            gridTemplateRows: rowCount ? `repeat(${rowCount}, 1fr)` : undefined,
            gridAutoRows: rowCount ? undefined : `${0, $2b42b3a2aa0ebb61$export$a176cc2ca3635d69}px`,
            position: isSticky ? 'sticky' : undefined,
            maxWidth: topLayerNode ? '100vw' : undefined,
            top: isSticky ? 0 : undefined,
            zIndex: isSticky ? `${99999999 - parentIndex}` : undefined,
            visibility: renderSceleton && st ? 'hidden' : undefined
        },
        "data-id": realRef || id,
        $shape: st,
        $baseScreenResolution: baseScreenResolution,
        $skipStates: active_state === 'disabled' || active_state === 'loading',
        $parentDisplay: parentStyle?.display,
        $parentFlexDirection: typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined,
        "data-component": component,
        onClick: handleClick,
        onPointerEnter: hoverUpdates?.length ? handleHover : undefined,
        onPointerLeave: unhoverUpdates?.length ? handleUnhover : undefined,
        className: hoverClassName,
        children: [
            items && items.map((item, index)=>{
                const Component = $d4ac9f041de1a90a$var$componentMapping[item.component];
                const commonProps = {
                    dataLake: (0, $7b0e169a5380005e$export$e9c29559b77b0f7b)(item, obj, dataLake, index, pageSettings?.variables, parentIndex),
                    parentIndex: parentIndex,
                    pageSettings: pageSettings,
                    styleChunks: styleChunks,
                    nestedTable: nestedTable,
                    parentStyle: st,
                    parentLoading: active_state === 'loading' || parentLoading,
                    enableLocalShimmer: enableLocalShimmer
                };
                if (item.component === 'container' && item.type === 'table-body-row' && item.dynamic) {
                    const replaced = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(commonProps?.dataLake?.settings?.source, pageSettings?.variables);
                    const parseSourceIfExist = (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(replaced);
                    return Array.isArray(parseSourceIfExist) ? parseSourceIfExist?.map((sourceItem, sourceIndex)=>{
                        const dynamicProps = {
                            dataLake: (0, $7b0e169a5380005e$export$e9c29559b77b0f7b)(item, obj, dataLake, sourceIndex, pageSettings?.variables, parentIndex),
                            parentIndex: sourceIndex,
                            styleChunks: styleChunks,
                            nestedTable: true,
                            parentLoading: active_state === 'loading' || parentLoading,
                            enableLocalShimmer: enableLocalShimmer
                        };
                        // The guard above pins item.component === 'container', and componentMapping
                        // has no 'container' (or 'table') key — so Component is always undefined here
                        // and this row is always a ContainerTemplate. If that guard is ever widened,
                        // reinstate the per-component branching.
                        return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $35731daef6037f8e$export$2e2bcd8739ae039), {
                            ...item,
                            ...dynamicProps,
                            hash: hash
                        }, `${item.id}::${sourceIndex}`);
                    }) : null;
                }
                if (Component) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(Component, {
                    ...item,
                    ...commonProps,
                    parentRef: containerRef
                }, item.id);
                if (item.component === 'container') return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $35731daef6037f8e$export$2e2bcd8739ae039), {
                    ...item,
                    ...commonProps,
                    hash: hash
                }, item.id);
                if (item.component === 'table') return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $35731daef6037f8e$export$2e2bcd8739ae039), {
                    ...item,
                    ...commonProps,
                    hash: hash
                }, item.id);
                if ((0, $29a699900545c598$export$45ed19580260ae3a)(item.component)) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $4049ca43de2ab8ae$export$2e2bcd8739ae039), {
                    id: item.id,
                    component: item.component,
                    style: item.style,
                    parentStyle: st
                }, item.id);
                return null;
            }),
            renderSceleton && st ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $71fb680e8403c8dd$export$2e2bcd8739ae039), {
                style: {
                    ...st,
                    display: st.display === 'grid' ? 'flex' : st.display
                },
                baseScreenResolution: baseScreenResolution,
                skipStates: active_state === 'disabled' || active_state === 'loading',
                nested: true
            }) : null
        ]
    });
};
var $d4ac9f041de1a90a$export$2e2bcd8739ae039 = $d4ac9f041de1a90a$var$GridContainerComponent;


var $0380290541115933$export$2e2bcd8739ae039 = (0, $d4ac9f041de1a90a$export$2e2bcd8739ae039);


const $1ef00bcfc91a959e$var$ContainerTemplate = (obj)=>{
    const { style: stDraft, events: eventsDraft, active_state: activeStateDraft, parentLoading: parentLoading, dataLake: dataLake, pageSettings: pageSettings, settings: settings, styleChunks: styleChunks, enableLocalShimmer: enableLocalShimmer, hash: hash } = obj || {};
    const { repeatable: repeatable } = settings || {};
    const { source: source } = repeatable || {};
    if (!source) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $0380290541115933$export$2e2bcd8739ae039), {
        ...obj
    });
    if (source) {
        const { active_state: active_state } = dataLake?.data ? (0, $7b0e169a5380005e$export$485c71a5d8ecbaad)({
            style: stDraft,
            events: eventsDraft,
            active_state: activeStateDraft
        }, dataLake.data) : {
            active_state: activeStateDraft
        };
        const replaced = dataLake?.data && typeof source === 'string' && /^{{this\..*}}$/.test(source) ? (0, $7b0e169a5380005e$export$ebda49d0e9aa0c89)(dataLake.data, source.slice(7, -2)) // Remove '{{this.' and '}}'
         : (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(source, pageSettings?.variables);
        const parseSourceIfExist = (0, $7b0e169a5380005e$export$8c51936ffbb22bee)(replaced);
        // TNBEWEB-1992: the variable this repeatable is bound to, so a `this.*` write inside a
        // row can target variableData.<srcVar>.<index>. Only a simple top-level `{{var}}` source
        // gets write-back this ticket; a nested `{{this.*}}` source renders a read-only `this`.
        const isThisSource = typeof source === 'string' && /^{{this\..*}}$/.test(source);
        const srcMatch = !isThisSource && typeof source === 'string' ? source.match(/^\s*\{\{\s*([\w.-]+)\s*\}\}\s*$/) : null;
        const srcVar = srcMatch ? srcMatch[1] : undefined;
        if (Array.isArray(parseSourceIfExist)) return parseSourceIfExist.map((sourceItem, sourceIndex)=>{
            const dynamicProps = {
                dataLake: {
                    data: parseSourceIfExist[sourceIndex],
                    rowPath: srcVar ? `${srcVar}.${sourceIndex}` : undefined
                },
                parentIndex: sourceIndex,
                styleChunks: styleChunks,
                nestedTable: true,
                parentLoading: active_state === 'loading' || parentLoading,
                enableLocalShimmer: enableLocalShimmer
            };
            return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $0380290541115933$export$2e2bcd8739ae039), {
                ...obj,
                ...dynamicProps,
                hash: hash
            }, `${obj.id}::${sourceIndex}`);
        });
    }
};
var $1ef00bcfc91a959e$export$2e2bcd8739ae039 = $1ef00bcfc91a959e$var$ContainerTemplate;


var $35731daef6037f8e$export$2e2bcd8739ae039 = (0, $1ef00bcfc91a959e$export$2e2bcd8739ae039);














var $aivMx = parcelRequire("aivMx");

const $7a42c25e248b6d5e$var$useTrackRouteChangeHook = (hash)=>{
    const prevHashRef = (0, $aivMx.useRef)(hash);
    const location = (0, $8e7337eeed3043b3$export$45d76561a5302f2b)();
    (0, $aivMx.useEffect)(()=>{
        // Only trigger if hash changed and is not the initial render
        if (hash !== prevHashRef.current) {
            const event = new CustomEvent('internalRouteChanged', {
                detail: {
                    location: location
                }
            });
            window.dispatchEvent(event);
        }
        // Update the previous hash value
        prevHashRef.current = hash;
    }, [
        hash
    ]);
};
var $7a42c25e248b6d5e$export$2e2bcd8739ae039 = $7a42c25e248b6d5e$var$useTrackRouteChangeHook;




// utils/prefetchHelper.ts
const $fe90f07def2730ef$var$fetchedImageUrls = new Set();
const $fe90f07def2730ef$export$4358cc9d407dbd2f = (pp)=>{
    const imageUrls = new Set();
    const traverseScheme = (node)=>{
        if (Array.isArray(node)) node.forEach(traverseScheme);
        else if (typeof node === 'object' && node !== null) {
            // Check for image URLs in the background property
            if (node.style) extractImageUrls(node.style);
            // Traverse child nodes
            Object.values(node).forEach(traverseScheme);
        }
    };
    const extractImageUrls = (style)=>{
        if (style.background) style.background.forEach((bg)=>{
            // Skip unresolved template tokens ({{this.icon}} in repeatable row
            // templates, {{_l.*}} locals): they only resolve per-row at render
            // time — preloading the literal string fires a bogus GET against the
            // page origin (/%7B%7Bthis.icon%7D%7D → 404).
            if (bg.type === 'image' && bg.value && !String(bg.value).includes('{{')) imageUrls.add(bg.value);
        });
        // Check nested properties (states, events, breakpoints)
        if (style.states) Object.values(style.states).forEach(extractImageUrls);
        if (style.events) Object.values(style.events).forEach((event)=>{
            if (Array.isArray(event)) event.forEach((e)=>{
                if (e.style) extractImageUrls(e.style);
            });
        });
        if (style.breakpoints) Object.values(style.breakpoints).forEach(extractImageUrls);
    };
    traverseScheme(pp);
    // Filter out already fetched URLs
    const newImageUrls = Array.from(imageUrls).filter((url)=>!$fe90f07def2730ef$var$fetchedImageUrls.has(url));
    // Add new URLs to the fetched set
    newImageUrls.forEach((url)=>$fe90f07def2730ef$var$fetchedImageUrls.add(url));
    // Send unique new image URLs to the Web Worker
    // worker.postMessage(newImageUrls);
    return newImageUrls;
};


const $73d63d58f0308e04$var$preloadedUrls = new Set();
const $73d63d58f0308e04$export$6b05b21262ec0515 = (imageUrls)=>{
    imageUrls.forEach((url)=>{
        if ($73d63d58f0308e04$var$preloadedUrls.has(url)) return;
        const img = new Image();
        img.src = url;
        img.onload = ()=>{
            $73d63d58f0308e04$var$preloadedUrls.add(url);
        };
        img.onerror = ()=>{
            console.warn(`Failed to prefetch: ${url}`);
        };
    });
};



/* eslint-disable @typescript-eslint/no-explicit-any */ 
/**
 * TNBEWEB-2019 — the ONE default root-flex object for a web screen.
 *
 * The root level of a screen is laid out by different code in the editor (the
 * synthetic `__flex_root__` wrapper on the canvas) and here (`.pageWrap`). When
 * `settings.style` carries a COMPLETE `flex` object both sides agree, because
 * they map `direction`/`justify_content`/`align_items` through equivalent style
 * helpers. They only diverged when `flex` was ABSENT and each side fell back to
 * something different: the canvas took the browser defaults (`row` /
 * `flex-start` / `stretch`) while `.pageWrap` hardcoded `justify-content:
 * center`, so the same screen sat left on the canvas and centered under the
 * published link. That `center` is gone; this object replaces it.
 *
 * The values are the ones the editor's Screen settings → Layout panel already
 * displays for an untouched screen, so what the panel claims is what renders.
 *
 * ⚠️ Mirrored in `fractal-fe/src/features/tabs/utils/rootFlexDefaults.ts`. The
 * two repos cannot share code, so ANY change here must land in both — a
 * divergence silently reintroduces exactly the bug this module exists to close.
 */ const $da4c484b96726071$export$143d8d27f975e1ca = {
    direction: 'row',
    justify_content: 'flex-start',
    // NOT the browser's `stretch`: with `stretch` a root section that declares no
    // height is measured against whatever box encloses it — the design frame in
    // the editor, the browser window here — so the same screen rendered at a
    // different height on every window size (`.pageWrap` is `100dvh`).
    // `flex-start` makes the section shrink-wrap its content in both places,
    // which is the only height the canvas and the browser can agree on.
    align_items: 'flex-start',
    gap: 0,
    wrap: 'nowrap'
};
function $da4c484b96726071$export$286d9699fdb22746(flex) {
    if (!flex || typeof flex !== 'object') return {
        ...$da4c484b96726071$export$143d8d27f975e1ca
    };
    const declared = Object.keys(flex).reduce((acc, key)=>{
        const value = flex[key];
        if (value !== undefined && value !== null) acc[key] = value;
        return acc;
    }, {});
    return {
        ...$da4c484b96726071$export$143d8d27f975e1ca,
        ...declared
    };
}
const $da4c484b96726071$export$800cb6392e38fe4f = (flex)=>{
    const { direction: direction } = $da4c484b96726071$export$286d9699fdb22746(flex);
    return direction === 'column' || direction === 'column-reverse';
};



/**
 * How a screen's ROOT level is laid out — the one answer both the published page
 * (`routes/page`) and the editor's view-mode frame (`routes/internalFrame`) render.
 *
 * The frame used to keep its own copy: a hardcoded `display: grid` wrapper built from
 * `settings.cols/rows` that never read `settings.style.display`. A flex screen (every
 * screen the editor creates) therefore rendered as a 1×1 grid in view mode — the first
 * root section took the single `1fr` row and every following one fell into an implicit
 * row below the frame, so two side-by-side cubes on the canvas showed up as ONE in view
 * mode while the published page laid them out in a row.
 */ const $f26dbe87306bf208$var$FLEX_ROOT_ID = '__flex_root__';
const $f26dbe87306bf208$var$isFlexRootNode = (node)=>!!node && node.id === $f26dbe87306bf208$var$FLEX_ROOT_ID;
const $f26dbe87306bf208$var$pickSoleFlexRoot = (x)=>{
    if (Array.isArray(x) && x.length === 1 && $f26dbe87306bf208$var$isFlexRootNode(x[0])) return x[0];
    if (x && !Array.isArray(x) && $f26dbe87306bf208$var$isFlexRootNode(x)) return x;
    return null;
};
function $f26dbe87306bf208$export$e304d3af97550acf(page, settings) {
    // Back-compat: legacy screens persisted the editor's __flex_root__ wrapper as a
    // top-level section. Unwrap it here so the runtime tree matches the new clean format.
    // Loop unwraps arbitrarily-deep chains caused by multiple saves before the save-side strip.
    // Keep the outermost wrapper so its style (if flex) can drive the top-level layout.
    const legacyFlexRoot = $f26dbe87306bf208$var$pickSoleFlexRoot(page);
    let unwrapped = legacyFlexRoot?.items ?? page;
    let nested = $f26dbe87306bf208$var$pickSoleFlexRoot(unwrapped);
    while(nested){
        unwrapped = nested.items ?? unwrapped;
        nested = $f26dbe87306bf208$var$pickSoleFlexRoot(unwrapped);
    }
    // Strip layout-mode fields (display, flex) from settings.style before applying to the
    // outer .page wrapper — those are canvas layout properties, not page background styles.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { display: _sd, flex: _sf, ...pageBackgroundStyle } = settings?.style || {};
    // Top-level layout mode. Prefer settings.style; fall back to the legacy flex_root's style
    // so old backend payloads keep rendering correctly.
    const layoutStyle = legacyFlexRoot?.style || settings?.style || {};
    const isFlexLayout = layoutStyle?.display === 'flex';
    // TNBEWEB-2019: resolve the root flex object ONCE, defaults filled in, and use
    // that one value for both the wrapper style and the children's `parentStyle`.
    // A screen whose Layout was never touched has no `flex` at all; leaving the
    // gap open let `.pageWrap`'s old `justify-content: center` decide the root
    // alignment here while the editor's canvas used the browser default, which is
    // the mismatch this ticket is about. Fields the screen DOES declare still win
    // — a legacy `__flex_root__` wrapper style keeps overriding every one of them.
    const rootFlex = isFlexLayout ? (0, $da4c484b96726071$export$286d9699fdb22746)(layoutStyle?.flex) : null;
    const flexWrapStyle = isFlexLayout ? (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)({
        display: 'flex',
        flex: rootFlex
    }) : null;
    const wrapStyle = isFlexLayout ? flexWrapStyle || {
        display: 'flex'
    } : {
        display: 'grid',
        gridTemplateColumns: `repeat(${settings?.cols || (0, $2b42b3a2aa0ebb61$export$c5399bfb4d939924)}, 1fr)`,
        gridAutoRows: settings?.rows ? undefined : `${0, $2b42b3a2aa0ebb61$export$a176cc2ca3635d69}px`,
        gridTemplateRows: settings?.rows ? `repeat(${settings?.rows}, 1fr)` : undefined
    };
    // Synthetic parentStyle for the top-level container. .pageWrap is the actual flex/grid
    // parent in the DOM, but Container only reads parent layout from a `parentStyle` prop —
    // without this, `width/height: 'fill'` on a root container resolves to undefined and the
    // container collapses to 0×0, hiding any fill.
    // `rootFlex`, not the raw `layoutStyle.flex` — this is what resolves a child's
    // `width/height: 'fill'` (main axis → flex-grow, cross axis → 100%), so it has
    // to see the same direction the wrapper is actually laid out with.
    const topLayerParentStyle = isFlexLayout ? {
        display: 'flex',
        flex: rootFlex
    } : {
        display: 'grid'
    };
    return {
        items: unwrapped,
        pageBackgroundStyle: pageBackgroundStyle,
        wrapStyle: wrapStyle,
        isColumnRoot: isFlexLayout && (0, $da4c484b96726071$export$800cb6392e38fe4f)(rootFlex),
        topLayerParentStyle: topLayerParentStyle
    };
}



function $9988b5a80f290978$export$2e2bcd8739ae039(jsonString) {
    try {
        const data = JSON.parse(jsonString);
        return {
            success: true,
            data: data
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
}



const $a1fc314d6e34ac94$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$a1fc314d6e34ac94$export$c169aefb7330cccb["open"] = "0";
$a1fc314d6e34ac94$export$c169aefb7330cccb["close"] = "1";
$a1fc314d6e34ac94$export$c169aefb7330cccb["ping"] = "2";
$a1fc314d6e34ac94$export$c169aefb7330cccb["pong"] = "3";
$a1fc314d6e34ac94$export$c169aefb7330cccb["message"] = "4";
$a1fc314d6e34ac94$export$c169aefb7330cccb["upgrade"] = "5";
$a1fc314d6e34ac94$export$c169aefb7330cccb["noop"] = "6";
const $a1fc314d6e34ac94$export$47791e8004edd485 = Object.create(null);
Object.keys($a1fc314d6e34ac94$export$c169aefb7330cccb).forEach((key)=>{
    $a1fc314d6e34ac94$export$47791e8004edd485[$a1fc314d6e34ac94$export$c169aefb7330cccb[key]] = key;
});
const $a1fc314d6e34ac94$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $6f99c7ccf8da7f3e$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $6f99c7ccf8da7f3e$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $6f99c7ccf8da7f3e$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $6f99c7ccf8da7f3e$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($6f99c7ccf8da7f3e$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $6f99c7ccf8da7f3e$var$encodeBlobAsBase64(data, callback);
    } else if ($6f99c7ccf8da7f3e$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $6f99c7ccf8da7f3e$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $6f99c7ccf8da7f3e$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $a1fc314d6e34ac94$export$c169aefb7330cccb)[type] + (data || ""));
};
const $6f99c7ccf8da7f3e$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $6f99c7ccf8da7f3e$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $6f99c7ccf8da7f3e$var$TEXT_ENCODER;
function $6f99c7ccf8da7f3e$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($6f99c7ccf8da7f3e$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($6f99c7ccf8da7f3e$var$toArray).then(callback);
    else if ($6f99c7ccf8da7f3e$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $6f99c7ccf8da7f3e$var$isView(packet.data))) return callback($6f99c7ccf8da7f3e$var$toArray(packet.data));
    $6f99c7ccf8da7f3e$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$6f99c7ccf8da7f3e$var$TEXT_ENCODER) $6f99c7ccf8da7f3e$var$TEXT_ENCODER = new TextEncoder();
        callback($6f99c7ccf8da7f3e$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $d7bc315985e6f656$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $d7bc315985e6f656$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $d7bc315985e6f656$var$chars.length; i++)$d7bc315985e6f656$var$lookup[$d7bc315985e6f656$var$chars.charCodeAt(i)] = i;
const $d7bc315985e6f656$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $d7bc315985e6f656$var$chars[bytes[i] >> 2];
        base64 += $d7bc315985e6f656$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $d7bc315985e6f656$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $d7bc315985e6f656$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $d7bc315985e6f656$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $d7bc315985e6f656$var$lookup[base64.charCodeAt(i)];
        encoded2 = $d7bc315985e6f656$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $d7bc315985e6f656$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $d7bc315985e6f656$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $5b849b38c0cfea23$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $5b849b38c0cfea23$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $5b849b38c0cfea23$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $5b849b38c0cfea23$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $a1fc314d6e34ac94$export$47791e8004edd485)[type];
    if (!packetType) return 0, $a1fc314d6e34ac94$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $a1fc314d6e34ac94$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $a1fc314d6e34ac94$export$47791e8004edd485)[type]
    };
};
const $5b849b38c0cfea23$var$decodeBase64Packet = (data, binaryType)=>{
    if ($5b849b38c0cfea23$var$withNativeArrayBuffer) {
        const decoded = (0, $d7bc315985e6f656$export$2f872c0f2117be69)(data);
        return $5b849b38c0cfea23$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $5b849b38c0cfea23$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $c8a38bcb71b20bd4$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $c8a38bcb71b20bd4$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $6f99c7ccf8da7f3e$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($c8a38bcb71b20bd4$var$SEPARATOR));
        });
    });
};
const $c8a38bcb71b20bd4$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($c8a38bcb71b20bd4$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $5b849b38c0cfea23$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $c8a38bcb71b20bd4$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $6f99c7ccf8da7f3e$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $c8a38bcb71b20bd4$var$TEXT_DECODER;
function $c8a38bcb71b20bd4$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $c8a38bcb71b20bd4$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $c8a38bcb71b20bd4$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$c8a38bcb71b20bd4$var$TEXT_DECODER) $c8a38bcb71b20bd4$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($c8a38bcb71b20bd4$var$totalLength(chunks) < 1) break;
                    const header = $c8a38bcb71b20bd4$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($c8a38bcb71b20bd4$var$totalLength(chunks) < 2) break;
                    const headerArray = $c8a38bcb71b20bd4$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($c8a38bcb71b20bd4$var$totalLength(chunks) < 8) break;
                    const headerArray = $c8a38bcb71b20bd4$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $a1fc314d6e34ac94$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($c8a38bcb71b20bd4$var$totalLength(chunks) < expectedLength) break;
                    const data = $c8a38bcb71b20bd4$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $5b849b38c0cfea23$export$4647901878f33f31)(isBinary ? data : $c8a38bcb71b20bd4$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $a1fc314d6e34ac94$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $c8a38bcb71b20bd4$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $bd7e26f198897caa$export$4293555f241ae35a(obj) {
    if (obj) return $bd7e26f198897caa$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $bd7e26f198897caa$var$mixin(obj) {
    for(var key in $bd7e26f198897caa$export$4293555f241ae35a.prototype)obj[key] = $bd7e26f198897caa$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.on = $bd7e26f198897caa$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.off = $bd7e26f198897caa$export$4293555f241ae35a.prototype.removeListener = $bd7e26f198897caa$export$4293555f241ae35a.prototype.removeAllListeners = $bd7e26f198897caa$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$bd7e26f198897caa$export$4293555f241ae35a.prototype.emitReserved = $bd7e26f198897caa$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $bd7e26f198897caa$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $296c7d23957f3d69$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $296c7d23957f3d69$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $296c7d23957f3d69$export$790dcbc41e2d75d5 = "arraybuffer";
function $296c7d23957f3d69$export$19413efcf2fac759() {}


function $e34120c3d721494a$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $e34120c3d721494a$var$NATIVE_SET_TIMEOUT = (0, $296c7d23957f3d69$export$394f9358f6231289).setTimeout;
const $e34120c3d721494a$var$NATIVE_CLEAR_TIMEOUT = (0, $296c7d23957f3d69$export$394f9358f6231289).clearTimeout;
function $e34120c3d721494a$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $e34120c3d721494a$var$NATIVE_SET_TIMEOUT.bind((0, $296c7d23957f3d69$export$394f9358f6231289));
        obj.clearTimeoutFn = $e34120c3d721494a$var$NATIVE_CLEAR_TIMEOUT.bind((0, $296c7d23957f3d69$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $296c7d23957f3d69$export$394f9358f6231289).setTimeout.bind((0, $296c7d23957f3d69$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $296c7d23957f3d69$export$394f9358f6231289).clearTimeout.bind((0, $296c7d23957f3d69$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $e34120c3d721494a$var$BASE64_OVERHEAD = 1.33;
function $e34120c3d721494a$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $e34120c3d721494a$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $e34120c3d721494a$var$BASE64_OVERHEAD);
}
function $e34120c3d721494a$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $e34120c3d721494a$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $671ed638d6347e9b$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $671ed638d6347e9b$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $e667b4e5712dd5df$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $e667b4e5712dd5df$export$86495b081fef8e52 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $e34120c3d721494a$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $e667b4e5712dd5df$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $5b849b38c0cfea23$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $671ed638d6347e9b$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $4c9fe808dbd2b179$export$265ee5eefd4c309b extends (0, $e667b4e5712dd5df$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $c8a38bcb71b20bd4$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $c8a38bcb71b20bd4$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e34120c3d721494a$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $d9c1762a5ddb3730$var$value = false;
try {
    $d9c1762a5ddb3730$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $d9c1762a5ddb3730$export$5235bbd4a1ef06e = $d9c1762a5ddb3730$var$value;


function $cbaeca2c76030d87$var$empty() {}
class $cbaeca2c76030d87$export$c959f2344155d309 extends (0, $4c9fe808dbd2b179$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $cbaeca2c76030d87$export$7fa6c5b6f8193917 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $e34120c3d721494a$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $e34120c3d721494a$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $cbaeca2c76030d87$export$7fa6c5b6f8193917.requestsCount++;
            $cbaeca2c76030d87$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $cbaeca2c76030d87$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $cbaeca2c76030d87$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$cbaeca2c76030d87$export$7fa6c5b6f8193917.requestsCount = 0;
$cbaeca2c76030d87$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $cbaeca2c76030d87$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $296c7d23957f3d69$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $cbaeca2c76030d87$var$unloadHandler, false);
    }
}
function $cbaeca2c76030d87$var$unloadHandler() {
    for(let i in $cbaeca2c76030d87$export$7fa6c5b6f8193917.requests)if ($cbaeca2c76030d87$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $cbaeca2c76030d87$export$7fa6c5b6f8193917.requests[i].abort();
}
const $cbaeca2c76030d87$var$hasXHR2 = function() {
    const xhr = $cbaeca2c76030d87$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $cbaeca2c76030d87$export$a2d42eb087c10497 extends $cbaeca2c76030d87$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $cbaeca2c76030d87$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $cbaeca2c76030d87$export$7fa6c5b6f8193917($cbaeca2c76030d87$var$newRequest, this.uri(), opts);
    }
}
function $cbaeca2c76030d87$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $d9c1762a5ddb3730$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $296c7d23957f3d69$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $da85c64c883daff7$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $da85c64c883daff7$export$570bf71d2367e261 extends (0, $e667b4e5712dd5df$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $da85c64c883daff7$var$isReactNative ? {} : (0, $e34120c3d721494a$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $6f99c7ccf8da7f3e$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $296c7d23957f3d69$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e34120c3d721494a$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $da85c64c883daff7$var$WebSocketCtor = (0, $296c7d23957f3d69$export$394f9358f6231289).WebSocket || (0, $296c7d23957f3d69$export$394f9358f6231289).MozWebSocket;
class $da85c64c883daff7$export$911baa0677ac404c extends $da85c64c883daff7$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$da85c64c883daff7$var$isReactNative ? protocols ? new $da85c64c883daff7$var$WebSocketCtor(uri, protocols) : new $da85c64c883daff7$var$WebSocketCtor(uri) : new $da85c64c883daff7$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $d801797666dc235e$export$961c930859384407 extends (0, $e667b4e5712dd5df$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $c8a38bcb71b20bd4$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $c8a38bcb71b20bd4$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $296c7d23957f3d69$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $0cb269c4f7ff6eee$export$46dec00755c1153b = {
    websocket: (0, $da85c64c883daff7$export$911baa0677ac404c),
    webtransport: (0, $d801797666dc235e$export$961c930859384407),
    polling: (0, $cbaeca2c76030d87$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $22f7aeedd2aef9bc$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $22f7aeedd2aef9bc$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $22f7aeedd2aef9bc$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $22f7aeedd2aef9bc$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$22f7aeedd2aef9bc$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $22f7aeedd2aef9bc$var$pathNames(uri, uri['path']);
    uri.queryKey = $22f7aeedd2aef9bc$var$queryKey(uri, uri['query']);
    return uri;
}
function $22f7aeedd2aef9bc$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $22f7aeedd2aef9bc$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $9ebc607289cc7033$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS = [];
if ($9ebc607289cc7033$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $9ebc607289cc7033$export$3874118029a0ee0d extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $296c7d23957f3d69$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $22f7aeedd2aef9bc$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $22f7aeedd2aef9bc$export$98e6a39c04603d36)(opts.host).host;
        (0, $e34120c3d721494a$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $671ed638d6347e9b$export$2f872c0f2117be69)(this.opts.query);
        if ($9ebc607289cc7033$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $296c7d23957f3d69$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $c8a38bcb71b20bd4$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $e34120c3d721494a$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $296c7d23957f3d69$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($9ebc607289cc7033$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $9ebc607289cc7033$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$9ebc607289cc7033$export$3874118029a0ee0d.protocol = (0, $c8a38bcb71b20bd4$export$a51d6b395ff4c65a);
class $9ebc607289cc7033$export$cc521fcb1004e85c extends $9ebc607289cc7033$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $9ebc607289cc7033$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $9ebc607289cc7033$export$4798917dbf149b79 extends $9ebc607289cc7033$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $0cb269c4f7ff6eee$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $e79e3bad237bb244$export$1e7deca84b429035 extends (0, $4c9fe808dbd2b179$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $700d97bd566e2b49$export$a51d6b395ff4c65a = (0, $9ebc607289cc7033$export$4798917dbf149b79).protocol;


function $7d769e07affedf95$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $22f7aeedd2aef9bc$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $13da305dc812d504$exports = {};

$parcel$export($13da305dc812d504$exports, "protocol", function () { return $13da305dc812d504$export$a51d6b395ff4c65a; });
$parcel$export($13da305dc812d504$exports, "PacketType", function () { return $13da305dc812d504$export$84d4095e16c6fc19; });
$parcel$export($13da305dc812d504$exports, "Encoder", function () { return $13da305dc812d504$export$a50aceb0e02a00aa; });
$parcel$export($13da305dc812d504$exports, "Decoder", function () { return $13da305dc812d504$export$f9de6ca0bc043724; });

const $7fa6351679be186c$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $7fa6351679be186c$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $7fa6351679be186c$var$toString = Object.prototype.toString;
const $7fa6351679be186c$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $7fa6351679be186c$var$toString.call(Blob) === "[object BlobConstructor]";
const $7fa6351679be186c$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $7fa6351679be186c$var$toString.call(File) === "[object FileConstructor]";
function $7fa6351679be186c$export$37488ff1135b1696(obj) {
    return $7fa6351679be186c$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $7fa6351679be186c$var$isView(obj)) || $7fa6351679be186c$var$withNativeBlob && obj instanceof Blob || $7fa6351679be186c$var$withNativeFile && obj instanceof File;
}
function $7fa6351679be186c$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($7fa6351679be186c$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($7fa6351679be186c$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $7fa6351679be186c$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $7fa6351679be186c$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $703f86ca7e069862$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $703f86ca7e069862$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $703f86ca7e069862$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $7fa6351679be186c$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $703f86ca7e069862$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $703f86ca7e069862$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $703f86ca7e069862$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $703f86ca7e069862$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $703f86ca7e069862$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $703f86ca7e069862$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $703f86ca7e069862$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $13da305dc812d504$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $13da305dc812d504$export$a51d6b395ff4c65a = 5;
var $13da305dc812d504$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($13da305dc812d504$export$84d4095e16c6fc19 || ($13da305dc812d504$export$84d4095e16c6fc19 = {}));
class $13da305dc812d504$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $13da305dc812d504$export$84d4095e16c6fc19.EVENT || obj.type === $13da305dc812d504$export$84d4095e16c6fc19.ACK) {
            if ((0, $7fa6351679be186c$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $13da305dc812d504$export$84d4095e16c6fc19.EVENT ? $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT : $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $703f86ca7e069862$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $13da305dc812d504$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $13da305dc812d504$export$f9de6ca0bc043724 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $13da305dc812d504$export$84d4095e16c6fc19.EVENT : $13da305dc812d504$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $13da305dc812d504$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $7fa6351679be186c$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($13da305dc812d504$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($13da305dc812d504$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $13da305dc812d504$export$84d4095e16c6fc19.CONNECT:
                return $13da305dc812d504$var$isObject(payload);
            case $13da305dc812d504$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $13da305dc812d504$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $13da305dc812d504$var$isObject(payload);
            case $13da305dc812d504$export$84d4095e16c6fc19.EVENT:
            case $13da305dc812d504$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $13da305dc812d504$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $13da305dc812d504$export$84d4095e16c6fc19.ACK:
            case $13da305dc812d504$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $13da305dc812d504$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $703f86ca7e069862$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}


function $28bdc64516b067d7$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $ddd773b6996dfbad$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $ddd773b6996dfbad$export$4798917dbf149b79 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $28bdc64516b067d7$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $28bdc64516b067d7$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $28bdc64516b067d7$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $28bdc64516b067d7$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($ddd773b6996dfbad$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $13da305dc812d504$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $13da305dc812d504$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).EVENT:
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).ACK:
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $13da305dc812d504$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $13da305dc812d504$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $13da305dc812d504$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $ee0df5f01f97328c$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $ee0df5f01f97328c$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $01e6adc4d3f15cb7$export$d0d38e7dec7a1a61 extends (0, $bd7e26f198897caa$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $e34120c3d721494a$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $ee0df5f01f97328c$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $13da305dc812d504$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $9ebc607289cc7033$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $28bdc64516b067d7$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $28bdc64516b067d7$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $296c7d23957f3d69$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $ddd773b6996dfbad$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $47722129af947523$var$cache = {};
function $47722129af947523$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $7d769e07affedf95$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $47722129af947523$var$cache[id] && path in $47722129af947523$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $01e6adc4d3f15cb7$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$47722129af947523$var$cache[id]) $47722129af947523$var$cache[id] = new (0, $01e6adc4d3f15cb7$export$d0d38e7dec7a1a61)(source, opts);
        io = $47722129af947523$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($47722129af947523$export$841407ceb083bd74, {
    Manager: $01e6adc4d3f15cb7$export$d0d38e7dec7a1a61,
    Socket: $ddd773b6996dfbad$export$4798917dbf149b79,
    io: $47722129af947523$export$841407ceb083bd74,
    connect: $47722129af947523$export$841407ceb083bd74
});


class $d68136b81b98fb26$export$bfafe629242f30bd {
    config;
    connected = false;
    constructor(config){
        this.config = config;
    }
}


class $8a43e1ca9f6baf85$export$690b26a1db3936c8 extends (0, $d68136b81b98fb26$export$bfafe629242f30bd) {
    socket = null;
    manualDisconnect = false;
    constructor(config){
        super(config);
    }
    getWebSocketUrl() {
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        return `${protocol}//${window.location.host}/ws`;
    }
    connect() {
        if (this.socket) {
            console.warn('Socket.io already connected');
            return;
        }
        this.socket = (0, $47722129af947523$export$841407ceb083bd74)(this.getWebSocketUrl(), {
            path: '/ws',
            transports: [
                'websocket'
            ],
            reconnection: !this.manualDisconnect
        });
        this.socket.on('connect', ()=>{
            this.connected = true;
            this.manualDisconnect = false;
            // Authorize after connection
            this.socket?.emit('authorize', {
                groupIdentifier: this.config.deviceId,
                sessionIdentifier: this.config.sessionId,
                isAdmin: false
            });
            if (this.config.onConnect) this.config.onConnect();
        });
        this.socket.on('disconnect', (reason)=>{
            this.connected = false;
            if (this.config.onDisconnect) this.config.onDisconnect(reason);
        });
        this.socket.on('connect_error', (error)=>{
            console.error('Socket.io Error:', error);
            if (this.config.onError) this.config.onError(error);
        });
        this.socket.on('pageUpdate', (message)=>{
            if (message.requireAck && message.messageId) this.sendAck(message.messageId);
            this.config.onPageUpdate(message);
        });
    }
    disconnect() {
        this.manualDisconnect = true;
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            this.connected = false;
        }
    }
    isConnected() {
        return this.connected && this.socket !== null;
    }
    sendAck(messageId) {
        if (this.socket) this.socket.emit('ack', {
            messageId: messageId
        });
    }
    setManualDisconnect(value) {
        this.manualDisconnect = value;
        // Update socket.io reconnection setting if socket exists
        if (this.socket) this.socket.io.opts.reconnection = !value;
    }
}



class $2d86fab84a17eaa0$export$41f65dc68f806385 extends (0, $d68136b81b98fb26$export$bfafe629242f30bd) {
    socket = null;
    reconnectTimeout = null;
    reconnectAttempts = 0;
    maxReconnectAttempts = 5;
    reconnectDelay = 3000;
    manualDisconnect = false;
    constructor(config){
        super(config);
    }
    getWebSocketUrl() {
        // if (this.config.publicUrl) {
        //   try {
        //     const parsedUrl = new URL(this.config.publicUrl);
        //     const protocol = parsedUrl.protocol === 'https:' ? 'wss:' : 'ws:';
        //     const pathPrefix = parsedUrl.pathname.replace(/\/+$/, '');
        //     return `${protocol}//${parsedUrl.host}${pathPrefix}/_ws?device_id=${this.config.deviceId}&session_id=${this.config.sessionId}`;
        //   } catch (e) {
        //     console.error('Failed to parse publicUrl, falling back to window.location:', e);
        //   }
        // }
        const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
        return `${protocol}//${window.location.host}/_ws?device_id=${this.config.deviceId}&session_id=${this.config.sessionId}`;
    }
    connect() {
        if (this.socket) {
            console.warn('Native WebSocket already connected');
            return;
        }
        try {
            this.socket = new WebSocket(this.getWebSocketUrl());
            this.socket.onopen = ()=>{
                this.connected = true;
                this.reconnectAttempts = 0;
                this.manualDisconnect = false;
                // Send authorization message
                // this.sendMessage({
                //   type: 'authorize',
                //   data: {
                //     deviceIdentifier: this.config.deviceId,
                //     sessionIdentifier: this.config.sessionId,
                //   },
                // });
                if (this.config.onConnect) this.config.onConnect();
            };
            this.socket.onclose = (event)=>{
                this.connected = false;
                if (this.config.onDisconnect) this.config.onDisconnect(event.reason);
                // Attempt to reconnect only if not manually disconnected
                if (!this.manualDisconnect) this.attemptReconnect();
            };
            this.socket.onerror = (event)=>{
                console.error('Native WebSocket Error:', event);
                if (this.config.onError) this.config.onError(new Error('WebSocket connection error'));
            };
            this.socket.onmessage = (event)=>{
                try {
                    const message = JSON.parse(event.data);
                    // Handle acknowledgment if required
                    if (message.requireAck && message.messageId) this.sendAck(message.messageId);
                    // Dispatch to the handler
                    if (message.type === 'pageUpdate') this.config.onPageUpdate(message);
                } catch (error) {
                    console.error('Failed to parse WebSocket message:', error);
                }
            };
        } catch (error) {
            console.error('Failed to create WebSocket connection:', error);
            if (this.config.onError && error instanceof Error) this.config.onError(error);
        }
    }
    attemptReconnect() {
        if (this.reconnectAttempts >= this.maxReconnectAttempts) {
            console.error('Max reconnection attempts reached');
            return;
        }
        this.reconnectTimeout = setTimeout(()=>{
            this.reconnectAttempts++;
            this.socket = null;
            this.connect();
        }, this.reconnectDelay);
    }
    disconnect() {
        this.manualDisconnect = true;
        if (this.reconnectTimeout) {
            clearTimeout(this.reconnectTimeout);
            this.reconnectTimeout = null;
        }
        if (this.socket) {
            this.socket.close();
            this.socket = null;
            this.connected = false;
        }
    }
    isConnected() {
        return this.connected && this.socket !== null && this.socket.readyState === WebSocket.OPEN;
    }
    sendAck(messageId) {
        this.sendMessage({
            type: 'ack',
            data: {
                messageId: messageId
            }
        });
    }
    sendMessage(message) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) this.socket.send(JSON.stringify(message));
        else console.warn('WebSocket is not connected. Cannot send message.');
    }
    setManualDisconnect(value) {
        this.manualDisconnect = value;
    }
}


class $1dd250e5f5465e68$export$67be75336dea7fb5 {
    /**
   * Create a WebSocket provider based on the specified type
   * @param type - The type of WebSocket provider ('socket.io' or 'native')
   * @param config - Configuration for the WebSocket connection
   * @returns An instance of the appropriate WebSocket provider
   */ static createProvider(type, config) {
        switch(type){
            case 'socket.io':
                return new (0, $8a43e1ca9f6baf85$export$690b26a1db3936c8)(config);
            case 'native':
                return new (0, $2d86fab84a17eaa0$export$41f65dc68f806385)(config);
            default:
                throw new Error(`Unknown WebSocket provider type: ${type}`);
        }
    }
    /**
   * Automatically determine which provider to use based on environment or configuration
   * Can be extended with more sophisticated logic
   */ static createAutoProvider(config) {
        // You can add logic here to determine which provider to use
        // For example, check environment variables, feature flags, etc.
        const providerType = this.getProviderType();
        return this.createProvider(providerType, config);
    }
    static getProviderType() {
        // Check environment variable or configuration
        // For now, return a default or check localStorage/sessionStorage
        const storedType = localStorage.getItem('ws_provider_type');
        if (storedType === 'native' || storedType === 'socket.io') return storedType;
        // Default to socket.io for backward compatibility
        return 'socket.io';
    }
    /**
   * Set the preferred WebSocket provider type
   */ static setProviderType(type) {
        localStorage.setItem('ws_provider_type', type);
    }
}









var $4c78f829eb748ae3$export$523fb3936f49e028;
var $4c78f829eb748ae3$export$fe63ae40556ad5d2;
var $4c78f829eb748ae3$export$46579a180cb70caa;
$4c78f829eb748ae3$export$523fb3936f49e028 = `epB7vq_page`;
$4c78f829eb748ae3$export$fe63ae40556ad5d2 = `epB7vq_pageWrap`;
$4c78f829eb748ae3$export$46579a180cb70caa = `epB7vq_pageWrapColumn`;




// FE-4577 — see the note in `store/page/sagas.ts`: cached bodies must not carry
// the design system, which the trust boundary now merges into every payload.
const $a4d47c1a2433f072$var$setLocalCache = (key, body)=>(0, $c9e12427d7d919f3$export$8a8216c44337cd5)(key, (0, $0338670cd4d1a0d1$export$fc94ef871805e581)(body));
const $a4d47c1a2433f072$var$styleElementId = 'custom-css-header-kdlshHhgjhgf';
const $a4d47c1a2433f072$var$componentMapping = {
    checkbox: (0, $2c90db8687e433b8$export$2e2bcd8739ae039),
    image: (0, $aa8f0f735a0f79aa$export$2e2bcd8739ae039),
    input: (0, $7ea0c43ec9b05f7e$export$2e2bcd8739ae039),
    radio: (0, $b35bf230db392315$export$2e2bcd8739ae039),
    select: (0, $bb9696960a8827ef$export$2e2bcd8739ae039),
    separator: (0, $3492f55331d0a86f$export$2e2bcd8739ae039),
    switcher: (0, $f7a8d8148b95e31e$export$2e2bcd8739ae039),
    chart: (0, $4659927e2b435a01$export$2e2bcd8739ae039),
    text: (0, $d009549dd9adb801$export$2e2bcd8739ae039)
};
const $a4d47c1a2433f072$var$Page = ()=>{
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const store = (0, $864b0261b61c7c4a$export$6ccbb43953eebf8)();
    const [fontsLoaded, setFontsLoaded] = (0, $aivMx.useState)(false);
    const [customFontLoaded, setCustomFontLoaded] = (0, $aivMx.useState)(false);
    const [lastFrameEvent, setLastFrameEvent] = (0, $aivMx.useState)(null);
    // Guards the one-shot frame handshake — see the receiveMessage handler below.
    const frameSchemaAppliedRef = (0, $aivMx.useRef)(false);
    const socketRef = (0, $aivMx.useRef)(null);
    const pageWrapRef = (0, $aivMx.useRef)(null);
    const config = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((state)=>state.config);
    const page = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((state)=>state.page);
    const { data: data } = config || {};
    const { features: features } = data || {};
    const { editor: editorUrl } = data?.urls || {};
    // Detected once — true when the iframe loads with ?frame=true query param
    const isFrameMode = new URLSearchParams(window.location.search).has('frame');
    const isProcesses = features?.processes || false;
    const { data: pageData2, settings: settings, variableData: variableData, session_data: session_data, styleChunks: styleChunks, screenId: screenId } = page || {};
    const { deviceId: deviceId, sessionId: sessionId, hash: hash, localShimmer: localShimmer } = session_data || {};
    // Get global variables from localStorage and assign to 'c' key
    const globalVariables = (0, $7d814282d5d3c114$export$1c9005e29d943d56)();
    // mergeVariableBags (not a plain merge): keeps the resolved `settings.variables`
    // objects from being clobbered by the unresolved `"{{parameters.X}}"` strings
    // that arrive in `variableData`, so dynamic content (table `source`, docs lists)
    // renders on first paint instead of only after an UPDATE_VARIABLE_SUCCESS.
    const mergedVariables = (0, $7b0e169a5380005e$export$fdb973e72befebb1)(settings?.variables || {}, variableData || {}, globalVariables || {});
    const pageData = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(pageData2, mergedVariables);
    const newSettings = {
        ...settings,
        variables: mergedVariables
    };
    const { page: ppRaw } = pageData || {};
    // Root layout (legacy `__flex_root__` unwrap, flex/grid wrapper, top-level `parentStyle`)
    // — shared with the editor's view-mode frame so the two can't drift. See `rootLayout.ts`.
    const { items: pp, pageBackgroundStyle: pageBackgroundStyle, wrapStyle: wrapStyle, isColumnRoot: isColumnRoot, topLayerParentStyle: topLayerParentStyle } = (0, $f26dbe87306bf208$export$e304d3af97550acf)(ppRaw, settings);
    (0, $7a42c25e248b6d5e$export$2e2bcd8739ae039)(hash);
    // FE-4866: `.pageWrap` is what scrolls on a published page (the document doesn't), and
    // Page is never remounted between screens — so without this its offset survives every
    // navigation. Same hash contract as the containers: the sagas send a fresh hash once per
    // navigation and `skip-` for everything else.
    (0, $0aedb54c46f4bebe$export$2e2bcd8739ae039)(pageWrapRef, hash);
    // Frame mode: notify parent that iframe is ready to receive the initial schema.
    // Fires on mount (sends to '*' as fallback) and again once editorUrl is resolved from config.
    (0, $aivMx.useEffect)(()=>{
        if (!isFrameMode || !window.parent) return;
        window.parent.postMessage({
            type: 'iframeReady'
        }, editorUrl || '*');
    }, [
        isFrameMode,
        editorUrl
    ]);
    // Frame mode: receive the initial schema from the parent editor via postMessage.
    // After this first handshake, all subsequent navigation works through the normal saga/API flow.
    (0, $aivMx.useEffect)(()=>{
        if (!isFrameMode) return;
        const receiveMessage = (event)=>{
            const isAllowed = editorUrl ? event.origin === editorUrl : event.source === window.parent;
            if (!isAllowed || !event.source) return;
            const result = (0, $9988b5a80f290978$export$2e2bcd8739ae039)(event.data);
            const sourceWindow = event.source;
            if (result.success && result?.data?.page) {
                // Apply the posted schema ONCE per document. The parent answers every
                // `iframeReady`, and we announce twice (on mount, then again once `editorUrl`
                // resolves from the async config fetch) — so the schema arrives twice. Because
                // PAGE_SUCCESS resets `variableData` wholesale, a re-apply throws away whatever
                // the screen's `on_launch` handlers already wrote, and those handlers don't
                // re-run (Container latches `launchExecutedRef`): the preview would render
                // correctly and then break a moment later. Both posts carry the same schema,
                // so ignoring the later one loses nothing.
                if (frameSchemaAppliedRef.current) {
                    event.source.postMessage('Parsed JSON', event.origin);
                    return;
                }
                frameSchemaAppliedRef.current = true;
                const incoming = result.data;
                (0, $3668382e27becba6$export$99153244860c0d0e)({
                    companyShortname: incoming.company_shortname,
                    projectShortname: incoming.project_shortname
                });
                setLastFrameEvent(event);
                dispatch((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                    // Same reason as `settings` below: the posted schema never passed through
                    // parseOldFormat/parseNewFormat, so the protocol migration has to run here.
                    // It is what turns the legacy camelCase `activeState` into the `active_state`
                    // components read — without it NO node state is applied in view mode, so a
                    // constructed component (Calendar / Select / Table / Choice) shows only its
                    // base look: placeholder hidden, dropdown never opening.
                    data: (0, $7b0e169a5380005e$export$2fd5a075072ce09d)(incoming.page),
                    // The editor posts its own working config, which never passed through
                    // parseOldFormat/parseNewFormat — normalize it so view mode boots with the same
                    // settings shape (parsed `variables` bag, registered custom resolutions) the API
                    // path produces. Without this the screen renders with NO variables.
                    settings: (0, $7b0e169a5380005e$export$969b2a989f0d9d7f)(incoming.settings),
                    session_data: (0, $7b0e169a5380005e$export$7e97e2c09f211669)({
                        deviceId: (0, $7cdaba13c8ba20d3$export$2e2bcd8739ae039).getOrCreateDeviceId(),
                        sessionId: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId(),
                        ...incoming.session_data || {}
                    }),
                    variableData: incoming.variableData,
                    screenId: incoming.screenId
                }));
                sourceWindow.postMessage('Parsed JSON', event.origin);
            } else sourceWindow.postMessage('Failed to parse JSON', event.origin);
        };
        window.addEventListener('message', receiveMessage);
        return ()=>window.removeEventListener('message', receiveMessage);
    }, [
        isFrameMode,
        editorUrl,
        dispatch
    ]);
    // Frame mode: report rendered height back to the parent so it can resize the iframe.
    (0, $aivMx.useEffect)(()=>{
        if (!isFrameMode || !lastFrameEvent || !pp) return;
        const timer = setTimeout(()=>{
            const elementId = '6201:298088';
            const element = document.getElementById(elementId);
            if (element) {
                const sourceWindow = lastFrameEvent.source;
                sourceWindow.postMessage({
                    newHeight: element.scrollHeight
                }, lastFrameEvent.origin);
            }
        }, 1000);
        return ()=>clearTimeout(timer);
    }, [
        isFrameMode,
        pp,
        lastFrameEvent
    ]);
    // Frame mode: bridge the "A" hotkey to the parent editor. Keydowns inside the iframe
    // don't bubble to the parent window, so we forward a toggle-preview message instead of
    // trying to handle the click here. Passive listener — never preventDefault/stopPropagation.
    (0, $aivMx.useEffect)(()=>{
        if (!isFrameMode || !window.parent) return;
        const handleKeydown = (event)=>{
            if (event.keyCode !== 65) return;
            if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
            const el = document.activeElement;
            const tag = el?.tagName?.toUpperCase();
            if (tag === 'INPUT' || tag === 'TEXTAREA' || el?.isContentEditable) return;
            window.parent.postMessage({
                type: 'toggle-preview'
            }, editorUrl || '*');
        };
        window.addEventListener('keydown', handleKeydown);
        return ()=>window.removeEventListener('keydown', handleKeydown);
    }, [
        isFrameMode,
        editorUrl
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { basic: basic, variables: variables } = data || {};
        // The theme is injected on its own. This used to read
        // `if (basic && variables && classes)` around a builder that turned a global
        // `classes` blob into CSS rules — so whenever that blob was absent the
        // <style> element was never created at all, and every `$token -> var(--token)`
        // reference in every component silently resolved to nothing.
        //
        // Style classes are branch-scoped resources now (`/api/v1/classes`); the blob
        // is gone, and the theme no longer depends on it.
        if (!basic || !variables) return;
        let styleElement = document.getElementById($a4d47c1a2433f072$var$styleElementId);
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = $a4d47c1a2433f072$var$styleElementId;
            document.head.insertBefore(styleElement, document.head.firstChild);
        }
        styleElement.innerText = `${variables}\n${basic}`;
    }, [
        data
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (settings?.script) (0, $7b0e169a5380005e$export$1ab2cd8b58d4bd64)(settings?.script);
    }, [
        settings?.script
    ]);
    (0, $aivMx.useEffect)(()=>{
        settings?.fonts;
        if (settings?.fonts) (0, $7b0e169a5380005e$export$dda81216098e0f9d)(settings?.fonts).then(()=>{
            setTimeout(()=>{
            // setFontsLoaded(true);
            }, 0);
        }).catch((error)=>{
            console.error('Font loading failed:', error);
        // setFontsLoaded(true); 
        // Fallback to show content even if fonts fail to load
        });
    }, [
        settings?.fonts
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (settings?.page) {
            const { title: title, description: description, icon: icon, theme_color: themeColor } = settings.page;
            if (title) document.title = title;
            if (description) {
                let metaDescription = document.querySelector("meta[name='description']");
                if (!metaDescription) {
                    metaDescription = document.createElement('meta');
                    metaDescription.name = 'description';
                    metaDescription.content = description;
                    document.getElementsByTagName('head')[0].appendChild(metaDescription);
                }
            }
            if (icon) {
                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                link.href = icon;
            }
            // TNBEWEB-1424: drive the mobile status bar color from the screen's
            // `settings.page.theme_color`. Create-and-update so live `pageUpdate`
            // changes take effect; remove the tag when the color is cleared.
            let themeMeta = document.querySelector("meta[name='theme-color']");
            if (themeColor) {
                if (!themeMeta) {
                    themeMeta = document.createElement('meta');
                    themeMeta.name = 'theme-color';
                    document.getElementsByTagName('head')[0].appendChild(themeMeta);
                }
                themeMeta.content = themeColor;
            } else if (themeMeta) themeMeta.remove();
        }
    }, [
        settings
    ]);
    const handlePageUpdate = (0, $aivMx.useCallback)((message)=>{
        if (message.type === 'pageUpdate' && message.data) {
            // FE-4938 — the provider keeps the callback it was given at connect time,
            // so a `page` captured from render is the page as it was THEN, and each
            // frame would be merged into it and discard the previous frame (and any
            // variable written since). Read the store as it is when the frame lands.
            const livePage = store.getState().page;
            const { settings: liveSettings, session_data: liveSessionData } = livePage || {};
            const { data: dataDraft } = message.data || {};
            // FE-4577 — a socket frame is a DELIVERY like any other: it carries its
            // mark in `session_data.fds` (there are no headers on this transport) and
            // may carry the classes an inserted node needs. This path used to call the
            // parsers directly, bypassing the trust boundary, so it saw neither the
            // stored design system nor the mark.
            const data = (0, $7d394fadd9d1d259$export$ef119f2182a928e)(dataDraft || message.data || {}, {
                ingest: true
            });
            const { page: pp, settings: settingsNew, variableData: variableData, screenId: screenId } = data.sections ? (0, $7b0e169a5380005e$export$d214ae9ea462ad72)(data) : (0, $7b0e169a5380005e$export$305e871e4887c1d)(data);
            // Handle new update mode scheme for WebSocket updates
            let finalPageData = pp;
            let finalVariableData = variableData;
            let shouldUpdateCache = false;
            if (data.mode === 'update') {
                const currentPageData = livePage?.data?.page;
                const currentVariableData = livePage?.variableData;
                const { page: updatedPage, variableData: updatedVariableData, shouldUpdateCache: cacheFlag } = (0, $7b0e169a5380005e$export$7fb9c25935e012b)(currentPageData, data, currentVariableData);
                finalPageData = updatedPage;
                finalVariableData = updatedVariableData;
                shouldUpdateCache = cacheFlag;
            }
            if (settingsNew?.command) {
                const allVariables = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, liveSettings?.variables || {}, livePage?.variableData || {}, finalVariableData || {}, (0, $7d814282d5d3c114$export$1c9005e29d943d56)() || {});
                const resolvedCommand = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(settingsNew.command, allVariables);
                const newCommand = resolvedCommand.replace(/^\//, '').replace(/\/$/, '');
                const currentPath = window.location.pathname.replace(/^\//, '').replace(/\/$/, '') + window.location.search;
                if (!/\{\{[^}]+\}\}/.test(newCommand) && newCommand !== currentPath) {
                    if (window.location.pathname + window.location.search !== `/${newCommand}`) window.history.pushState(null, '', `/${newCommand}`);
                }
            }
            dispatch((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                data: finalPageData,
                settings: {
                    ...liveSettings,
                    ...settingsNew
                },
                session_data: {
                    ...liveSessionData,
                    hash: `skip-s-${(0, $70c7bcd05bb92b18$export$2e2bcd8739ae039)()}`
                },
                variableData: finalVariableData,
                screenId: screenId
            }));
            if (message.data?.requestData && message.data?.requestData.component_id && message.data?.requestData.screen_id) {
                const { command: command, action: action, component_id: componentId, screen_id: screenId } = message.data?.requestData;
                const cacheKey = (0, $7b0e169a5380005e$export$2083ef81b7b5b44)({
                    command: command,
                    action: action,
                    component_id: componentId,
                    screen_id: screenId
                });
                const { status: status, transformed: transformed } = (0, $7b0e169a5380005e$export$b40f43cc69224c6e)(data?.screen?.sections);
                // Handle caching based on mode and settings
                if (data.mode === 'update') // For update mode, save the final transformed data
                {
                    if (shouldUpdateCache) $a4d47c1a2433f072$var$setLocalCache(cacheKey, {
                        ...data,
                        screen: {
                            ...data.screen,
                            sections: finalPageData
                        },
                        variable_data: finalVariableData
                    });
                } else if (status && transformed) $a4d47c1a2433f072$var$setLocalCache(cacheKey, {
                    ...data,
                    screen: {
                        ...data.screen,
                        sections: transformed
                    },
                    variable_data: variableData
                });
            }
        }
    }, [
        dispatch,
        store
    ]);
    const connectWebSocket = (0, $aivMx.useCallback)(()=>{
        if (!deviceId || !sessionId || socketRef.current) return;
        const provider = isProcesses ? 'native' : 'socket.io';
        // Create WebSocket provider using factory
        // You can change 'socket.io' to 'native' to use the Golang WebSocket service
        const wsProvider = (0, $1dd250e5f5465e68$export$67be75336dea7fb5).createProvider(provider, {
            deviceId: deviceId,
            sessionId: sessionId,
            publicUrl: config?.data?.public_url,
            onPageUpdate: handlePageUpdate,
            onError: (error)=>{
                console.error('WebSocket Error:', error);
            }
        });
        wsProvider.connect();
        socketRef.current = wsProvider;
        return ()=>{
            if (socketRef.current) socketRef.current.disconnect();
        };
    }, [
        deviceId,
        sessionId,
        handlePageUpdate
    ]);
    (0, $aivMx.useEffect)(()=>{
        if (!isProcesses && deviceId && sessionId) connectWebSocket();
        else if (settings?.live_updates && deviceId && sessionId) {
            // Close old connection before establishing new one
            if (socketRef.current) // skip as it's already connected
            return;
            // Connect new WebSocket
            connectWebSocket();
        } else if (!settings?.live_updates && socketRef.current && deviceId && sessionId) {
            socketRef.current.setManualDisconnect(true); // Notify provider this is a manual disconnect
            socketRef.current.disconnect();
            socketRef.current = null;
        }
    }, [
        settings?.live_updates,
        deviceId,
        sessionId,
        connectWebSocket
    ]);
    // useEffect(() => {
    //   if (document.fonts.check('1em Inter')) {
    //     setCustomFontLoaded(true);
    //   } else {
    //     document.fonts.ready.then(() => {
    //       if (document.fonts.check('1em Inter')) {
    //         setCustomFontLoaded(true);
    //       }
    //     });
    //   }
    // }, []);
    (0, $aivMx.useEffect)(()=>{
        if (!pp) return;
        const url = (0, $fe90f07def2730ef$export$4358cc9d407dbd2f)(pp);
        (0, $73d63d58f0308e04$export$6b05b21262ec0515)(url);
    }, [
        pp
    ]);
    // if (!fontsLoaded || !customFontLoaded) {
    //   return <div style={{ color: 'transparent', fontFamily: 'Inter', fontWeight: 600 }}>Loading <span style={{ color: 'transparent', fontFamily: 'Inter', fontWeight: 400 }}>...</span></div>;
    // }
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        className: $4c78f829eb748ae3$export$523fb3936f49e028,
        style: (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(pageBackgroundStyle),
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
            ref: pageWrapRef,
            className: isColumnRoot ? `${$4c78f829eb748ae3$export$fe63ae40556ad5d2} ${$4c78f829eb748ae3$export$46579a180cb70caa}` : $4c78f829eb748ae3$export$fe63ae40556ad5d2,
            style: wrapStyle,
            children: [
                typeof pp === 'object' && Object.keys(pp) && !Array.isArray(pp) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $35731daef6037f8e$export$2e2bcd8739ae039), {
                    ...pp,
                    pageSettings: newSettings,
                    styleChunks: styleChunks,
                    topLayerNode: true,
                    parentStyle: topLayerParentStyle,
                    hash: hash,
                    enableLocalShimmer: localShimmer
                }) : null,
                Array.isArray(pp) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $02de83db299f7983$exports.Fragment), {
                    children: pp.map((item)=>{
                        const Component = $a4d47c1a2433f072$var$componentMapping[item.component];
                        if (Component) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(Component, {
                            ...item,
                            pageSettings: newSettings,
                            styleChunks: styleChunks,
                            topLayerNode: true,
                            parentStyle: topLayerParentStyle,
                            enableLocalShimmer: localShimmer
                        }, item.id);
                        if (item.component === 'container' || item.component === 'table') return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $35731daef6037f8e$export$2e2bcd8739ae039), {
                            ...item,
                            pageSettings: newSettings,
                            styleChunks: styleChunks,
                            topLayerNode: true,
                            parentStyle: topLayerParentStyle,
                            hash: hash,
                            enableLocalShimmer: localShimmer
                        }, item.id);
                        if ((0, $29a699900545c598$export$45ed19580260ae3a)(item.component)) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $4049ca43de2ab8ae$export$2e2bcd8739ae039), {
                            id: item.id,
                            component: item.component,
                            style: item.style,
                            parentStyle: topLayerParentStyle
                        }, item.id);
                        return null;
                    })
                }) : null
            ]
        })
    });
};
var $a4d47c1a2433f072$export$2e2bcd8739ae039 = $a4d47c1a2433f072$var$Page;



parcelRequire("aivMx");

parcelRequire("aivMx");
const $dde6212574de0fc3$var$SvgImg404 = (props)=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 720,
        height: 363,
        fill: "none",
        viewBox: "0 0 720 363",
        ...props,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("path", {
            d: "M385.293 205.372c0-14.962-2.173-26.529-6.518-34.691q-6.519-12.244-18.53-12.244-12.016 0-18.275 12.244c-4.178 8.162-6.263 19.729-6.263 34.691 0 14.967 2.085 26.573 6.263 34.819 4.173 8.251 10.264 12.372 18.275 12.372 8.007 0 14.185-4.121 18.53-12.372q6.518-12.369 6.518-34.819m43.707 0c0 13.097-1.705 24.743-5.112 34.947q-5.117 15.305-14.186 25.636-9.074 10.331-21.725 15.689C379.543 285.214 370.38 287 360.5 287c-10.057 0-19.297-1.786-27.732-5.356-8.434-3.572-15.68-8.801-21.725-15.689q-9.075-10.331-14.058-25.636c-3.322-10.204-4.985-21.85-4.985-34.947q.001-19.64 4.985-34.819c3.323-10.115 8.007-18.621 14.058-25.509 6.045-6.887 13.291-12.116 21.725-15.687S350.443 124 360.5 124c9.88 0 19.043 1.786 27.477 5.357q12.651 5.357 21.725 15.687c6.046 6.888 10.775 15.394 14.186 25.509q5.111 15.18 5.112 34.819M517.634 168.642h-.766l-33.937 47.981h34.703zm-13.013-40.069q4.843-1.529 11.1-2.551c4.166-.678 7.95-1.022 11.355-1.022q5.865 0 11.355 1.149 5.483 1.147 9.824 3.829 4.337 2.678 6.89 7.273c1.698 3.062 2.552 6.891 2.552 11.484v67.888h22.71c1.021 1.874 2.042 4.338 3.061 7.401q1.533 4.594 1.532 9.698 0 9.703-4.339 13.782-4.34 4.084-10.972 4.084h-11.992v30.115q-2.81.507-8.421 1.405-5.616.89-10.717.892-5.616-.001-9.952-.511-4.343-.512-7.273-2.424-2.934-1.913-4.466-5.487-1.53-3.572-1.531-9.698v-14.292h-64.048q-5.87-3.062-10.078-9.062-4.21-5.993-4.211-14.674-.002-4.844 1.276-10.719 1.275-5.866 4.338-10.208zM216.634 168.642h-.766l-33.937 47.981h34.703zm-13.013-40.069q4.844-1.529 11.1-2.551c4.166-.678 7.95-1.022 11.355-1.022q5.865 0 11.355 1.149 5.483 1.147 9.824 3.829 4.338 2.678 6.89 7.273c1.698 3.062 2.552 6.891 2.552 11.484v67.888h22.71c1.021 1.874 2.042 4.338 3.061 7.401q1.532 4.594 1.532 9.698 0 9.703-4.339 13.782-4.34 4.084-10.972 4.084h-11.992v30.115q-2.81.507-8.421 1.405-5.616.89-10.717.892-5.616-.001-9.952-.511-4.343-.512-7.273-2.424-2.934-1.913-4.466-5.487-1.53-3.572-1.531-9.698v-14.292h-64.048q-5.87-3.062-10.078-9.062-4.21-5.993-4.211-14.674-.002-4.844 1.276-10.719 1.275-5.866 4.338-10.208zM123.577 345.391q0-2.883 1.802-4.747 1.8-1.863 4.978-1.864 3.177.001 4.978 1.864 1.802 1.864 1.802 4.747t-1.802 4.745q-1.801 1.863-4.978 1.864-3.178 0-4.978-1.864-1.802-1.862-1.802-4.745m2.331-9.212q-1.2-.632-2.259-2.285-1.06-1.651-1.059-3.902-.001-2.179 1.165-3.269t3.423-1.653l5.51-1.335q3.53-.916 3.531-3.376 0-1.335-1.307-2.32t-4.485-.985q-2.895 0-5.437.738-2.542.74-4.096 1.723a8.8 8.8 0 0 1-2.048-2.214q-.847-1.3-.846-3.13 0-1.828 1.059-3.199t2.93-2.251q1.87-.878 4.449-1.3 2.576-.421 5.684-.421 8.333 0 12.605 3.691 4.273 3.692 4.273 9.668 0 11.25-15.959 14.414zM7.916 252.601q0-4.1 2.557-6.751 2.556-2.65 7.065-2.651 4.51.001 7.067 2.651 2.557 2.652 2.557 6.751t-2.557 6.748q-2.557 2.65-7.067 2.651-4.509-.001-7.065-2.651t-2.557-6.748m3.308-13.102q-1.703-.9-3.206-3.249-1.504-2.349-1.504-5.551-.001-3.099 1.654-4.649 1.653-1.55 4.86-2.35l7.82-1.9q5.01-1.3 5.011-4.8-.001-1.9-1.855-3.301-1.855-1.398-6.365-1.4-4.11 0-7.717 1.05-3.609 1.051-5.814 2.45A12.5 12.5 0 0 1 1.2 212.65Q-.001 210.801 0 208.199q0-2.599 1.503-4.55t4.16-3.201q2.653-1.248 6.314-1.85 3.656-.598 8.067-.598 11.827 0 17.891 5.249Q44 208.499 44 217q0 16-22.652 20.5zM469.176 63.132q0-4.74 2.963-7.806c1.976-2.04 4.704-3.065 8.19-3.065q5.226.002 8.191 3.065 2.964 3.066 2.963 7.806t-2.963 7.803q-2.965 3.064-8.191 3.065-5.228-.001-8.19-3.065-2.963-3.063-2.963-7.803m3.834-15.148q-1.975-1.041-3.716-3.758-1.744-2.716-1.743-6.417-.002-3.584 1.917-5.376 1.915-1.792 5.632-2.718l9.064-2.196q5.808-1.504 5.809-5.55-.001-2.197-2.15-3.817-2.15-1.617-7.378-1.618-4.763 0-8.945 1.213-4.183 1.215-6.739 2.833a14.4 14.4 0 0 1-3.369-3.641q-1.394-2.137-1.392-5.147 0-3.004 1.742-5.26 1.74-2.255 4.821-3.701 3.076-1.444 7.319-2.14 4.237-.69 9.351-.691 13.709 0 20.737 6.07Q511 12.14 511 21.967q0 18.5-26.256 23.704zM77.694 131.901q0-6.149 3.777-10.126c2.519-2.648 5.995-3.977 10.438-3.977 4.441 0 7.92 1.329 10.44 3.977q3.777 3.977 3.777 10.126 0 6.15-3.777 10.122-3.78 3.976-10.44 3.977-6.663-.001-10.438-3.977-3.776-3.973-3.777-10.122m4.887-19.652q-2.516-1.35-4.736-4.875-2.223-3.522-2.222-8.325-.001-4.648 2.444-6.974 2.44-2.325 7.178-3.526l11.553-2.848c4.932-1.301 7.403-3.702 7.403-7.201q-.001-2.85-2.74-4.951-2.74-2.099-9.403-2.1-6.073.001-11.401 1.574-5.33 1.577-8.589 3.676c-1.68-1.3-3.107-2.873-4.294-4.724Q65.998 69.2 66 65.298q0-3.899 2.22-6.824 2.219-2.925 6.145-4.802 3.92-1.874 9.328-2.774Q89.093 50 95.61 50q17.471 0 26.43 7.874 8.96 7.875 8.959 20.625 0 24-33.463 30.75zM282.038 69.979q0-2.627 1.627-4.325 1.626-1.698 4.496-1.699 2.87.001 4.497 1.699t1.627 4.325q0 2.626-1.627 4.323T288.161 76q-2.87 0-4.496-1.698t-1.627-4.324m2.105-8.394q-1.084-.576-2.041-2.081t-.957-3.556q0-1.985 1.053-2.979 1.052-.992 3.092-1.505l4.977-1.217q3.188-.832 3.189-3.075 0-1.216-1.181-2.115-1.18-.895-4.05-.897-2.616 0-4.911.673-2.296.673-3.7 1.57a8 8 0 0 1-1.85-2.018Q277 43.201 277 41.533q0-1.665.956-2.914.957-1.25 2.647-2.05 1.69-.801 4.018-1.186 2.327-.383 5.134-.383 7.527 0 11.386 3.363 3.86 3.363 3.859 8.809 0 10.25-14.415 13.133zM634.837 121.922q0-3.522 2.208-5.801 2.207-2.277 6.102-2.278 3.894.001 6.103 2.278 2.208 2.279 2.208 5.801t-2.208 5.8q-2.208 2.277-6.103 2.278t-6.102-2.278q-2.208-2.277-2.208-5.8m2.857-11.259q-1.472-.773-2.769-2.792-1.3-2.019-1.299-4.77 0-2.663 1.428-3.996 1.428-1.331 4.197-2.02l6.754-1.631q4.327-1.119 4.328-4.126 0-1.632-1.602-2.837-1.602-1.202-5.497-1.203-3.55.001-6.665.902-3.117.905-5.021 2.106a10.7 10.7 0 0 1-2.511-2.706Q627.999 86 628 83.764q0-2.233 1.298-3.91 1.297-1.675 3.592-2.75 2.292-1.074 5.453-1.59 3.158-.514 6.968-.514 10.215 0 15.451 4.511Q666 84.023 666 91.328q0 13.75-19.563 17.617zM666.694 290.901q.001-6.149 3.777-10.126c2.519-2.648 5.995-3.977 10.438-3.977 4.441 0 7.921 1.329 10.44 3.977q3.777 3.977 3.777 10.126 0 6.15-3.777 10.122-3.779 3.976-10.44 3.977c-4.443 0-7.919-1.327-10.438-3.977q-3.775-3.973-3.777-10.122m4.887-19.652q-2.516-1.35-4.736-4.875-2.222-3.522-2.222-8.325-.001-4.648 2.444-6.974 2.441-2.325 7.178-3.526l11.553-2.848c4.932-1.301 7.403-3.702 7.403-7.201q-.001-2.85-2.74-4.951-2.74-2.099-9.403-2.1-6.072.001-11.401 1.574-5.33 1.577-8.589 3.676c-1.68-1.299-3.107-2.873-4.294-4.724q-1.776-2.773-1.774-6.677 0-3.899 2.22-6.824 2.219-2.925 6.145-4.802 3.92-1.874 9.328-2.774 5.4-.898 11.918-.898 17.471 0 26.43 7.874 8.96 7.875 8.959 20.626 0 24-33.463 30.749zM590.217 356.832q0-2.69 1.686-4.431 1.684-1.738 4.656-1.739 2.972.001 4.658 1.739 1.685 1.74 1.685 4.431t-1.685 4.428q-1.686 1.74-4.658 1.74t-4.656-1.74q-1.685-1.738-1.686-4.428m2.181-8.598q-1.123-.59-2.113-2.133-.993-1.54-.992-3.642 0-2.033 1.091-3.051 1.09-1.017 3.202-1.543l5.155-1.246q3.302-.854 3.303-3.15-.001-1.247-1.223-2.166t-4.195-.919q-2.71 0-5.087.689-2.378.69-3.832 1.608a8.2 8.2 0 0 1-1.916-2.067q-.792-1.213-.791-2.921 0-1.706.99-2.986.99-1.279 2.742-2.1 1.748-.82 4.162-1.214 2.409-.393 5.317-.393 7.795 0 11.792 3.445 3.997 3.446 3.997 9.024 0 10.5-14.93 13.453z",
            className: "fill"
        })
    });
var $dde6212574de0fc3$export$2e2bcd8739ae039 = $dde6212574de0fc3$var$SvgImg404;


var $c826ef794bd667d6$export$a33e918cb4258370;
var $c826ef794bd667d6$export$7fb0516b0ed6bd2;
var $c826ef794bd667d6$export$121a36a7c59b25d9;
$c826ef794bd667d6$export$a33e918cb4258370 = `YHTgIW_notFound`;
$c826ef794bd667d6$export$7fb0516b0ed6bd2 = `YHTgIW_notFoundBtn`;
$c826ef794bd667d6$export$121a36a7c59b25d9 = `YHTgIW_notFoundCenter`;


const $279d3b4c8110a250$var$NotFound = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        className: $c826ef794bd667d6$export$a33e918cb4258370,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
            className: $c826ef794bd667d6$export$121a36a7c59b25d9,
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $dde6212574de0fc3$export$2e2bcd8739ae039), {})
        })
    });
var $279d3b4c8110a250$export$2e2bcd8739ae039 = $279d3b4c8110a250$var$NotFound;


/* eslint-disable react/jsx-props-no-spreading */ 

var $aivMx = parcelRequire("aivMx");


















var $d6aa166daaaad1e4$export$a2b3dd87d3e471be;
var $d6aa166daaaad1e4$export$e8c9778bf415dd08;
var $d6aa166daaaad1e4$export$3ffe842fbbf0db09;
var $d6aa166daaaad1e4$export$2adb16ac204af30e;
var $d6aa166daaaad1e4$export$73920f18ca706874;
var $d6aa166daaaad1e4$export$523fb3936f49e028;
$d6aa166daaaad1e4$export$a2b3dd87d3e471be = `TIdUyG_centerButton`;
$d6aa166daaaad1e4$export$e8c9778bf415dd08 = `TIdUyG_divider`;
$d6aa166daaaad1e4$export$3ffe842fbbf0db09 = `TIdUyG_frameLayout`;
$d6aa166daaaad1e4$export$2adb16ac204af30e = `TIdUyG_full`;
$d6aa166daaaad1e4$export$73920f18ca706874 = `TIdUyG_hidden`;
$d6aa166daaaad1e4$export$523fb3936f49e028 = `TIdUyG_page`;




const $92fc1304e46d7bde$var$styleElementId = 'custom-css-header-kdlshHhgjhgf';
const $92fc1304e46d7bde$var$componentMapping = {
    checkbox: (0, $2c90db8687e433b8$export$2e2bcd8739ae039),
    image: (0, $aa8f0f735a0f79aa$export$2e2bcd8739ae039),
    input: (0, $7ea0c43ec9b05f7e$export$2e2bcd8739ae039),
    radio: (0, $b35bf230db392315$export$2e2bcd8739ae039),
    select: (0, $bb9696960a8827ef$export$2e2bcd8739ae039),
    separator: (0, $3492f55331d0a86f$export$2e2bcd8739ae039),
    switcher: (0, $f7a8d8148b95e31e$export$2e2bcd8739ae039),
    chart: (0, $4659927e2b435a01$export$2e2bcd8739ae039),
    text: (0, $d009549dd9adb801$export$2e2bcd8739ae039)
};
const $92fc1304e46d7bde$var$InternalFrame = ()=>{
    const [styleApplied, setStyleApplied] = (0, $aivMx.useState)(false);
    const config = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((state)=>state.config);
    const page = (0, $f40d1f3d995cccef$export$2105062e25df4afe)((state)=>state.page);
    const { data: data } = config || {};
    const { editor: editorUrl } = data?.urls || {};
    const { data: pageData2, settings: settings, variableData: variableData, styleChunks: styleChunks } = page || {};
    // The SAME bag the page route builds, and for the same reason — see the twin in
    // routes/page/index.tsx.
    //
    // This used to substitute against `settings.variables` alone, which is the author's
    // static screen bag and nothing else. Every constructed component (Select, Checkbox,
    // Radio, Switcher, Table, Calendar) keeps its whole runtime model in `data._<instanceId>`,
    // written by its generated `on_launch` through `$setVariable` — so it lands in
    // `variableData`, never in `settings.variables`. Leaving `variableData` out of the bag
    // meant every `{{_select_1.…}}` / `{{_table_1.…}}` binding stayed unresolved for ever:
    // the repeatables got no rows and rendered their template row once with a literal
    // `{{this.label}}`, the table drew no rows at all, and nothing responded to a click.
    // The components were fine — view mode was reading them through the wrong bag, which is
    // why the very same screen worked when published and not here.
    //
    // `mergeVariableBags` rather than a plain merge, and `globalVariables` included, so this
    // resolves identically to the published page instead of merely resolving.
    const globalVariables = (0, $7d814282d5d3c114$export$1c9005e29d943d56)();
    const mergedVariables = (0, $7b0e169a5380005e$export$fdb973e72befebb1)(settings?.variables || {}, variableData || {}, globalVariables || {});
    const pageData = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(pageData2, mergedVariables);
    // Handed down as `pageSettings`, because that is the bag a repeatable resolves its
    // `source` against (ContainerTemplate reads `pageSettings.variables`) — substituting the
    // tree alone would leave every repeatable empty.
    const newSettings = {
        ...settings,
        variables: mergedVariables
    };
    const { page: ppRaw } = pageData || {};
    // The root is laid out exactly as the published page lays it out — flex or grid from
    // `settings.style`. This frame used to hardcode a `settings.cols × settings.rows` grid,
    // so a flex screen (1×1) showed only its first root section. See `rootLayout.ts`.
    const { items: pp, pageBackgroundStyle: pageBackgroundStyle, wrapStyle: wrapStyle, isColumnRoot: isColumnRoot, topLayerParentStyle: topLayerParentStyle } = (0, $f26dbe87306bf208$export$e304d3af97550acf)(ppRaw, settings);
    const dispatch = (0, $d023060d48542f4c$export$8ad76b76a4c905f8)();
    const [output, setOutput] = (0, $aivMx.useState)(null);
    const [eventCopy, setLastEventCopy] = (0, $aivMx.useState)(null);
    // Guards the one-shot frame handshake — see the receiveMessageFromParent handler below.
    const frameSchemaAppliedRef = (0, $aivMx.useRef)(false);
    const dispatchContentUpdateEvent = (height)=>{
        if (eventCopy) {
            const sourceWindow = eventCopy.source;
            sourceWindow.postMessage({
                newHeight: height
            }, eventCopy.origin);
        }
    };
    // Corrected syntax for the type guard function
    const expectedOrigin = editorUrl;
    (0, $aivMx.useEffect)(()=>{
        setTimeout(()=>{
            // const bodyScrollHeight = document.body.scrollHeight;
            const elementId = '6201:298088';
            const element = document.getElementById(elementId);
            if (element) {
                const { scrollHeight: scrollHeight } = element;
                dispatchContentUpdateEvent(scrollHeight); // Trigger the event
            }
        }, 1000);
    }, [
        output
    ]);
    (0, $aivMx.useEffect)(()=>{
        const receiveMessageFromParent = (event)=>{
            // Accept messages from expectedOrigin, or from window.parent when origin is not yet configured
            const isAllowed = expectedOrigin ? event.origin === expectedOrigin : event.source === window.parent;
            if (isAllowed) {
                if (event.source) {
                    const result = (0, $9988b5a80f290978$export$2e2bcd8739ae039)(event.data);
                    const sourceWindow = event.source;
                    if (result.success && result?.data?.page) {
                        const responseMessage = 'Parsed JSON';
                        // One-shot, same as the page frame handshake: we announce `iframeReady`
                        // twice (mount, then again once `expectedOrigin` resolves from the async
                        // config), the parent answers both, and a re-applied PAGE_SUCCESS resets
                        // `variableData` — discarding what the screen's on_launch handlers wrote.
                        if (frameSchemaAppliedRef.current) {
                            sourceWindow.postMessage(responseMessage, event.origin);
                            return;
                        }
                        frameSchemaAppliedRef.current = true;
                        setLastEventCopy(event);
                        setOutput(result?.data?.page);
                        dispatch((0, $8eba69c5466928d3$export$98eb18032ef4d6ea)({
                            // Same reason as `settings` below: the posted schema never went through
                            // parseOldFormat/parseNewFormat, so the protocol migration runs here — it is
                            // what turns the legacy camelCase `activeState` into the `active_state`
                            // components read. Without it no node state is applied at all.
                            data: (0, $7b0e169a5380005e$export$2fd5a075072ce09d)(result.data.page),
                            // Same normalization as the page frame handshake — the editor posts its own
                            // working config (stringified `variables`, camelCase resolutions), which never
                            // went through parseOldFormat/parseNewFormat. See normalizeScreenSettings.
                            settings: (0, $7b0e169a5380005e$export$969b2a989f0d9d7f)(result.data.settings),
                            session_data: (0, $7b0e169a5380005e$export$7e97e2c09f211669)(result.data.session_data || {}),
                            variableData: result.data.variableData,
                            screenId: result.data.screenId
                        }));
                        sourceWindow.postMessage(responseMessage, event.origin);
                    } else {
                        const responseMessage = 'Failed to parse JSON';
                        sourceWindow.postMessage(responseMessage, event.origin);
                    }
                }
            }
        };
        // Attach the receiveMessageFromParent function to the message event
        window.addEventListener('message', receiveMessageFromParent);
        // Cleanup the event listener on component unmount
        return ()=>{
            window.removeEventListener('message', receiveMessageFromParent);
        };
    }, [
        expectedOrigin
    ]);
    (0, $aivMx.useEffect)(()=>{
        const { basic: basic, variables: variables } = data || {};
        // The theme is injected on its own. This used to read
        // `if (basic && variables && classes)` around a builder that turned a global
        // `classes` blob into CSS rules — so whenever that blob was absent the
        // <style> element was never created at all, and every `$token -> var(--token)`
        // reference in every component silently resolved to nothing.
        //
        // Style classes are branch-scoped resources now (`/api/v1/classes`); the blob
        // is gone, and the theme no longer depends on it.
        if (!basic || !variables) return;
        let styleElement = document.getElementById($92fc1304e46d7bde$var$styleElementId);
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = $92fc1304e46d7bde$var$styleElementId;
            document.head.insertBefore(styleElement, document.head.firstChild);
        }
        styleElement.innerText = `${variables}\n${basic}`;
    }, [
        data
    ]);
    (0, $aivMx.useEffect)(()=>{
        // Notify parent window that iframe is ready to receive messages.
        // Use expectedOrigin when available; fall back to '*' so the signal is
        // always delivered even before config is loaded.
        if (window.parent) window.parent.postMessage({
            type: 'iframeReady'
        }, expectedOrigin || '*');
    }, [
        expectedOrigin
    ]);
    // FE-4798: bridge the editor's mode switcher. Keydowns inside this frame never
    // reach the parent window, so with focus in the rendered screen ⌥Tab / Ctrl+`
    // — and the modifier release that commits the pick — would be lost. Forwarded
    // as messages; the editor replays them (Iframe.tsx). Only the opening chord is
    // prevented here (Tab would move focus inside the frame); Esc / Enter / arrows
    // are forwarded as they are, and only while a modifier is held.
    (0, $aivMx.useEffect)(()=>{
        if (!window.parent || window.parent === window) return undefined;
        const forward = (phase, event)=>{
            window.parent.postMessage({
                type: 'mode-switcher-key',
                phase: phase,
                key: event.key,
                code: event.code,
                altKey: event.altKey,
                ctrlKey: event.ctrlKey,
                shiftKey: event.shiftKey,
                metaKey: event.metaKey
            }, expectedOrigin || '*');
        };
        const isChord = (event)=>!event.metaKey && (event.code === 'Tab' && event.altKey && !event.ctrlKey || event.code === 'Backquote' && event.ctrlKey && !event.altKey);
        const handleKeydown = (event)=>{
            if (isChord(event)) {
                // Typing into a rendered field keeps the browser default, as in the editor.
                const el = document.activeElement;
                const tag = el?.tagName?.toUpperCase();
                if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el?.isContentEditable) return;
                event.preventDefault();
                forward('down', event);
                return;
            }
            if ((event.altKey || event.ctrlKey) && [
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown'
            ].includes(event.code)) forward('down', event);
        };
        const handleKeyup = (event)=>{
            if (event.key === 'Alt' || event.key === 'Control') forward('up', event);
        };
        window.addEventListener('keydown', handleKeydown);
        window.addEventListener('keyup', handleKeyup);
        return ()=>{
            window.removeEventListener('keydown', handleKeydown);
            window.removeEventListener('keyup', handleKeyup);
        };
    }, [
        expectedOrigin
    ]);
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                className: $d6aa166daaaad1e4$export$3ffe842fbbf0db09,
                children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                    style: {
                        boxSizing: 'border-box'
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4aeabe14c1618d30$exports)))({
                        [$d6aa166daaaad1e4$export$2adb16ac204af30e]: true
                    }),
                    children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                        style: {
                            overflow: 'auto',
                            height: '100%'
                        },
                        children: pp ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                            className: $d6aa166daaaad1e4$export$523fb3936f49e028,
                            style: (0, $e0d24bf85c947bed$export$2e2bcd8739ae039)(pageBackgroundStyle),
                            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)("div", {
                                className: isColumnRoot ? `${$4c78f829eb748ae3$export$fe63ae40556ad5d2} ${$4c78f829eb748ae3$export$46579a180cb70caa}` : $4c78f829eb748ae3$export$fe63ae40556ad5d2,
                                style: wrapStyle,
                                children: [
                                    typeof pp === 'object' && Object.keys(pp) && !Array.isArray(pp) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $0380290541115933$export$2e2bcd8739ae039), {
                                        ...pp,
                                        pageSettings: newSettings,
                                        styleChunks: styleChunks,
                                        topLayerNode: true,
                                        parentStyle: topLayerParentStyle
                                    }) : null,
                                    Array.isArray(pp) ? /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $02de83db299f7983$exports.Fragment), {
                                        children: pp.map((item)=>{
                                            const Component = $92fc1304e46d7bde$var$componentMapping[item.component];
                                            if (Component) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)(Component, {
                                                ...item,
                                                pageSettings: newSettings,
                                                styleChunks: styleChunks,
                                                topLayerNode: true,
                                                parentStyle: topLayerParentStyle
                                            }, item.id);
                                            if (item.component === 'container' || item.component === 'table') return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $0380290541115933$export$2e2bcd8739ae039), {
                                                ...item,
                                                pageSettings: newSettings,
                                                styleChunks: styleChunks,
                                                topLayerNode: true,
                                                parentStyle: topLayerParentStyle
                                            }, item.id);
                                            if ((0, $29a699900545c598$export$45ed19580260ae3a)(item.component)) return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $4049ca43de2ab8ae$export$2e2bcd8739ae039), {
                                                id: item.id,
                                                component: item.component,
                                                style: item.style,
                                                parentStyle: topLayerParentStyle
                                            }, item.id);
                                            return null;
                                        })
                                    }) : null
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
                            children: "No valid data"
                        })
                    })
                })
            })
        })
    });
};
var $92fc1304e46d7bde$export$2e2bcd8739ae039 = $92fc1304e46d7bde$var$InternalFrame;


const $24743a343556581e$var$Routes = ()=>/*#__PURE__*/ (0, $02de83db299f7983$exports.jsxs)((0, $8e7337eeed3043b3$export$b5d5cf8927ab7262), {
        children: [
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e7337eeed3043b3$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/not_found",
                component: (0, $279d3b4c8110a250$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e7337eeed3043b3$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/frame/internal",
                component: (0, $92fc1304e46d7bde$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $8e7337eeed3043b3$export$e7b0ac011bb776c6), {
                exact: true,
                component: (0, $a4d47c1a2433f072$export$2e2bcd8739ae039)
            })
        ]
    });
var $24743a343556581e$export$2e2bcd8739ae039 = $24743a343556581e$var$Routes;



parcelRequire("aivMx");
const $741fbedaf13cc59d$var$Theme = ({ children: children })=>{
    const brand = 'tnbe';
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)("div", {
        "data-testid": "theme",
        className: `theme-${brand} theme`,
        children: children
    });
};
var $741fbedaf13cc59d$export$2e2bcd8739ae039 = $741fbedaf13cc59d$var$Theme;


const $ae9ae0bb313ac8bf$var$Main = (props)=>{
    const { store: store, history: history } = props;
    return /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $7a57c545a1f92740$export$2e2bcd8739ae039), {
        store: store,
        children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $2a1fdbb8d383931f$export$2e2bcd8739ae039), {
            history: history,
            children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $741fbedaf13cc59d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $24743a343556581e$export$2e2bcd8739ae039), {})
            })
        })
    });
};
var $ae9ae0bb313ac8bf$export$2e2bcd8739ae039 = $ae9ae0bb313ac8bf$var$Main;


/**
 * Utility to parse and validate window.__APP_DATA__ for server-side rendered initial data
 */ 

const $e3de6a84c2a74985$export$bea8e38bce6d3960 = ()=>{
    return typeof window !== 'undefined' && typeof window.__APP_DATA__ !== 'undefined' && window.__APP_DATA__ !== null;
};
const $e3de6a84c2a74985$export$f2a9a04d9e72202c = ()=>{
    if (!$e3de6a84c2a74985$export$bea8e38bce6d3960()) return null;
    try {
        // tnbe-web-be 0.22.x serves a FLAT envelope (no `data` wrapper, `screen`
        // holds the screen object, `config` renamed to `session_data`). Normalize
        // into the canonical shape FIRST so the validation below — and every
        // consumer downstream — only ever sees one shape.
        const appData = (0, $7d394fadd9d1d259$export$b9a006cb2241c14)(window.__APP_DATA__);
        // Validate required fields
        if (!appData || !appData.screen || !appData.data) {
            console.warn('Invalid __APP_DATA__: missing required fields');
            return null;
        }
        return appData;
    } catch (error) {
        console.error('Failed to parse __APP_DATA__:', error);
        return null;
    }
};
const $e3de6a84c2a74985$export$d0f80fe8b00983ae = (appData)=>{
    const data = appData?.data;
    const screen = data?.screen;
    // Guard FIRST: a process/actions payload (or an envelope we could not
    // normalize) carries no screen, and everything below dereferences it.
    if (!screen) return null;
    // Unescape the script content if present (it's escaped during save as <\\/script>)
    const unescapedScript = screen?.settings?.script ? screen.settings.script.replace(/<\\\/script>/gi, '</script>') : screen?.settings?.script;
    // Normalize resolution fields: backend sends snake_case
    // (base_screen_resolution, custom_resolutions) but components read camelCase.
    // Register custom resolution widths so breakpoints keyed by custom ids resolve.
    const customResolutions = screen?.settings?.custom_resolutions ?? screen?.settings?.customResolutions;
    (0, $7b0e169a5380005e$export$ed72da891243b781)(customResolutions);
    const enhancedSettings = {
        ...screen?.settings,
        script: unescapedScript,
        live_updates: data.live_updates || false,
        baseScreenResolution: screen?.settings?.base_screen_resolution ?? screen?.settings?.baseScreenResolution,
        customResolutions: customResolutions
    };
    return {
        screenId: appData.screen,
        data: screen.sections || [],
        settings: enhancedSettings,
        variableData: data.variable_data || {},
        mode: data.mode
    };
};
const $e3de6a84c2a74985$export$c8caa3e08495366c = (appData)=>{
    const { data: data } = appData;
    if (!data.config) return null;
    return {
        data: data.config
    };
};
const $e3de6a84c2a74985$export$c5e685ac15b5cd75 = ()=>{
    if (typeof document !== 'undefined') {
        const initScript = document.getElementById('init');
        if (initScript && initScript.parentNode) initScript.parentNode.removeChild(initScript);
    }
};
const $e3de6a84c2a74985$export$955d0697eb4d7e60 = ()=>{
    if (typeof window !== 'undefined') delete window.__APP_DATA__;
};











const $3d60a1b70f95f5d4$var$retryWithHeaders = async ()=>{
    const deviceId = (0, $7cdaba13c8ba20d3$export$2e2bcd8739ae039).getOrCreateDeviceId();
    const sessionId = (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId();
    const response = await fetch(window.location.href, {
        headers: {
            'Fie': 'true',
            'Fc': 'web',
            'Fdi': deviceId,
            'Fsi': sessionId,
            // FE-4577 — this is the FIRST request the renderer makes itself. The SSR
            // shell that preceded it could carry no claim (a browser navigation sends
            // no custom headers), so the negotiation begins here.
            'Fds': await (0, $e916c0573570ec65$export$ac2a76745b8c23c3)()
        }
    });
    if (!response.ok) throw new Error(`Retry failed: ${response.status} ${response.statusText}`);
    // Extract relevant response headers for future usage
    const responseHeaders = {
        endpoint_id: response.headers.get('Fseid'),
        endpoint_type: response.headers.get('Fset'),
        task_ref: response.headers.get('Fref'),
        process_id: response.headers.get('Fspid')
    };
    const wrapResult = (data)=>{
        // The retry can come back as the flat 0.22.x envelope, as the legacy
        // `{ code, data }` one, or as an init-script blob — normalize before the
        // caller (index.tsx) reads `data.mode` / `data.screen` off it.
        // Same-origin (`window.location.href`), so the response header is readable
        // here; `session_data.fds` still takes precedence inside the boundary.
        const normalized = (0, $7d394fadd9d1d259$export$b9a006cb2241c14)(data, {
            fdsHeader: response.headers.get('Fds')
        });
        if (!normalized) return null;
        return {
            data: normalized,
            headers: responseHeaders
        };
    };
    const contentType = response.headers.get('content-type')?.toLowerCase() ?? '';
    // Most retries return JSON directly; parse it first when possible.
    if (contentType.includes('application/json')) return wrapResult(await response.json());
    const html = await response.text();
    const trimmed = html.trim();
    // Some backends return JSON with an unexpected content-type.
    if (trimmed) try {
        return wrapResult(JSON.parse(trimmed));
    } catch  {
    // Continue with HTML init-script parsing fallback.
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const initScript = doc.getElementById('init');
    if (initScript?.textContent) {
        const match = initScript.textContent.match(/window\.__APP_DATA__\s*=\s*([\s\S]*);?\s*$/);
        if (match?.[1]) return wrapResult(JSON.parse(match[1].replace(/;\s*$/, '')));
    }
    return null;
};
var $3d60a1b70f95f5d4$export$2e2bcd8739ae039 = $3d60a1b70f95f5d4$var$retryWithHeaders;








/**
 * Extracts the pathname from a URL
 * @param url - Full URL (e.g., https://demo.gom.com/okauy/)
 * @returns Pathname if it's more than just '/', otherwise empty string
 * @example extractPathFromUrl('https://demo.gom.com/okauy/') => '/okauy/'
 * @example extractPathFromUrl('https://demo.gom.com/') => ''
 */ const $f0076a935b238615$var$extractPathFromUrl = (url)=>{
    try {
        const parsedUrl = new URL(url);
        const { pathname: pathname } = parsedUrl;
        // Only return pathname if it's more than just '/'
        return pathname && pathname !== '/' ? pathname : '';
    } catch (e) {
        console.error('Failed to parse URL:', e);
        return '';
    }
};
const $f0076a935b238615$var$hasScreenData = (appData)=>appData?.data?.mode === 'show' && !!appData?.data?.screen;
const $f0076a935b238615$var$buildConfigState = (appData)=>{
    const configData = (0, $e3de6a84c2a74985$export$c8caa3e08495366c)(appData);
    if (!configData) return undefined;
    const publicUrlPath = appData.data.config?.public_url ? $f0076a935b238615$var$extractPathFromUrl(appData.data.config.public_url) : undefined;
    if (appData.data.config?.style) (0, $7b0e169a5380005e$export$ff76c51b0f744e0a)(appData.data.config.style);
    return {
        ...configData,
        initializedFromInitScript: true,
        publicUrl: publicUrlPath || undefined
    };
};
const $f0076a935b238615$var$buildPageState = (appData)=>{
    const transformedData = (0, $e3de6a84c2a74985$export$d0f80fe8b00983ae)(appData);
    if (!transformedData) return undefined;
    const { page: page, settings: settings, variableData: variableData } = appData.data.screen ? {
        // FE-4451 — this branch takes the screen STRAIGHT off the bootstrap payload
        // and never reaches parseNewFormat, so it has to assemble template
        // references itself. Missing it renders every placed template as an empty
        // container on first paint, and only a later navigation (which does go
        // through parseNewFormat) would appear to fix it.
        //
        // …and for the same reason it has to run the protocol migration itself.
        // `migrateSchemeNode` is what turns the legacy camelCase `activeState` into
        // the `active_state` every component actually reads (also `svgString`,
        // `scriptUrl`, `settings.afterSymbols`). Without it a published page keeps
        // the legacy key, `active_state` is undefined on every node, and NO node
        // state is ever applied — while `value` bindings, which need no migration,
        // resolve normally. That asymmetry is the whole bug: a constructed
        // component (Calendar / Select / Table / Choice) drives its entire
        // appearance through `activeState` bindings, so on a published screen its
        // placeholder stays hidden and its dropdown never opens, even though its
        // `on_launch` ran and wrote the instance correctly.
        //
        // Ordering matches parseNewFormat: assemble templates and classes FIRST, so
        // a template body — which arrives straight from the map and has never passed
        // through a screen parse — gets migrated too.
        page: (0, $7b0e169a5380005e$export$2fd5a075072ce09d)((0, $45287d3e48b5815e$export$8a8430000842166d)((0, $16d445f6645d8a76$export$f75350e774e076c0)(appData.data.screen.sections, appData.data.templates), appData.data.classes)),
        // FE-4733 — and, for the same reason, lay the template layer under the
        // screen's variables itself; parseNewFormat does it on every other path.
        settings: (0, $16d445f6645d8a76$export$e7a25978043fb98a)(transformedData.settings, appData.data.screen.sections, appData.data.templates),
        variableData: {
            ...appData.data?.variable_data,
            ...appData.data?.parameters
        }
    } : (0, $7b0e169a5380005e$export$305e871e4887c1d)(appData.data);
    return {
        screenId: appData.screen,
        loading: false,
        data: {
            page: page
        },
        settings: settings || {},
        variableData: (0, $7b0e169a5380005e$export$8c1182ab03da08ba)(variableData, settings?.variables),
        formValues: {},
        styleChunks: {
            refs: {},
            indexes: {}
        },
        session_data: {
            type: 'initial',
            localShimmer: false,
            deviceId: (0, $7cdaba13c8ba20d3$export$2e2bcd8739ae039).getOrCreateDeviceId(),
            sessionId: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId()
        }
    };
};
(async ()=>{
    // FE-4577 — settle the design-system store before anything normalizes a
    // payload or reaches the network. Never rejects; resolves 'ready' or
    // 'degraded'. Correctness does not depend on this ordering (an unhydrated
    // mirror sends `h=none`, so the response carries everything anyway) — it
    // simply avoids one wasted full delivery per session.
    //
    // Frame mode is excluded: there the schema arrives by postMessage from the
    // editor as an unsaved working copy, which must never be persisted as the
    // branch's authoritative design system.
    await (0, $e916c0573570ec65$export$9279e804159fafce)({
        enabled: !(0, $3668382e27becba6$export$3fa83f310820eeee)()
    });
    // Cached screens store their sections ALREADY token-substituted, so they hold
    // whichever theme was live when they were written. Registered here rather than
    // called from the store so that module keeps no dependency on the screen cache.
    (0, $e916c0573570ec65$export$f55c2c7b57013ae0)(()=>{
        (0, $c9e12427d7d919f3$export$42ffd38884aecdac)();
    });
    let initialState;
    let retryHeaders;
    if ((0, $e3de6a84c2a74985$export$bea8e38bce6d3960)()) try {
        // Normalized once here too: `hasScreenData` / `buildConfigState` read the
        // raw blob directly when `parseInitialData` bails, so both paths must see
        // the canonical envelope.
        const rawAppData = (0, $7d394fadd9d1d259$export$b9a006cb2241c14)(window.__APP_DATA__);
        let appData = (0, $e3de6a84c2a74985$export$f2a9a04d9e72202c)();
        // If APP_DATA doesn't have mode=show + screen, retry with headers
        if (!$f0076a935b238615$var$hasScreenData(appData || rawAppData)) {
            // Extract config from initial APP_DATA so it's not lost
            if (rawAppData?.data?.config) {
                const configState = $f0076a935b238615$var$buildConfigState(rawAppData);
                if (configState) initialState = {
                    config: configState
                };
            }
            try {
                const retryResult = await (0, $3d60a1b70f95f5d4$export$2e2bcd8739ae039)();
                if (retryResult) {
                    appData = retryResult.data;
                    retryHeaders = retryResult.headers;
                }
            } catch (retryError) {
                console.error('Retry with headers failed:', retryError);
            }
        }
        if (appData) {
            // Refine <html lang> from the (possibly retried) response's
            // `localization` before buildPageState — a process/actions response
            // (screen: null) drops through transformInitialDataToPageState's
            // `if (!screen) return null`, so the language would otherwise be lost
            // on cold boot even though `data.localization` is present.
            (0, $7b0e169a5380005e$export$ab76a6159e74f74b)(appData?.data?.localization);
            const pageState = $f0076a935b238615$var$buildPageState(appData);
            if (pageState) {
                initialState = {
                    ...initialState,
                    page: pageState
                };
                // Handle settings.command URL update
                if (pageState.settings?.command) {
                    const allVariables = (0, (/*@__PURE__*/$parcel$interopDefault($94WEq)))({}, pageState.settings?.variables || {}, pageState.variableData || {});
                    const resolvedCommand = (0, $7b0e169a5380005e$export$9a7eef5d73136d1e)(pageState.settings.command, allVariables);
                    const newCommand = resolvedCommand.replace(/^\//, '').replace(/\/$/, '');
                    const currentPath = window.location.pathname.replace(/^\//, '').replace(/\/$/, '') + window.location.search;
                    if (!/\{\{[^}]+\}\}/.test(newCommand) && newCommand !== currentPath) {
                        if (window.location.pathname + window.location.search !== `/${newCommand}`) window.history.pushState(null, '', `/${newCommand}`);
                    }
                }
                // Stamp the current history entry with the request context so a
                // later back/forward onto it replays the same GET instead of
                // firing a contextless /get call. Mirrors what retryWithHeaders
                // does on cold boot.
                // NOTE: Fds is deliberately NOT stamped here. This snapshot is frozen
                // into `history.state` and replayed on back/forward, by which time a
                // design-system claim is stale. `executeNavigationRequest` — the only
                // consumer of these headers — derives it at fire time, next to Fsc.
                const initialHeaders = {
                    Accept: 'application/json',
                    Fc: 'web',
                    Fie: 'true',
                    Fsi: (0, $2857511e8f5d961e$export$2e2bcd8739ae039).getOrCreateSessionId(),
                    Fdi: (0, $7cdaba13c8ba20d3$export$2e2bcd8739ae039).getOrCreateDeviceId()
                };
                const ep = retryHeaders || appData?.data?.config || {};
                if (ep.endpoint_id) initialHeaders.Fseid = String(ep.endpoint_id);
                if (ep.endpoint_type) initialHeaders.Fset = String(ep.endpoint_type);
                if (ep.task_ref) initialHeaders.Fref = String(ep.task_ref);
                if (ep.process_id) initialHeaders.Fspid = String(ep.process_id);
                const initialSnapshot = {
                    kind: 'action',
                    url: window.location.pathname + window.location.search,
                    method: 'GET',
                    headers: initialHeaders
                };
                (0, $9c0f2890202f6fcd$export$d287140c80e4b48d)(initialSnapshot);
            }
            const configState = $f0076a935b238615$var$buildConfigState(appData);
            if (configState) initialState = {
                ...initialState,
                config: configState
            };
        }
        (0, $e3de6a84c2a74985$export$c5e685ac15b5cd75)();
        (0, $e3de6a84c2a74985$export$955d0697eb4d7e60)();
    } catch (error) {
        console.error('Failed to initialize with initial data:', error);
    }
    const store = (0, $4931f7746d84676b$export$2e2bcd8739ae039)(initialState);
    // Dispatch response headers from retryWithHeaders into the same Redux storage
    // as handleActionRequest does via updateEndpointParams
    if (retryHeaders) {
        const { endpoint_id: endpoint_id, endpoint_type: endpoint_type, task_ref: task_ref, process_id: process_id } = retryHeaders;
        if (endpoint_id || endpoint_type || task_ref || process_id) {
            const params = {};
            if (endpoint_id) params.endpoint_id = endpoint_id;
            if (endpoint_type) params.endpoint_type = endpoint_type;
            if (task_ref) params.task_ref = task_ref;
            if (process_id) params.process_id = process_id;
            store.dispatch((0, $2907166a90fe0a09$export$1899915054cedfe4)(params));
        }
    }
    const root = (0, $86dae81a7d15f03f$export$882461b6382ed46c)(document.getElementById('root'));
    root.render(/*#__PURE__*/ (0, $02de83db299f7983$exports.jsx)((0, $ae9ae0bb313ac8bf$export$2e2bcd8739ae039), {
        store: store,
        history: (0, $4931f7746d84676b$export$55abd4691b317664)
    }));
})();


//# sourceMappingURL=bundle.aed12f4f.js.map
